/* eslint-disable */
/*! pdfmake v0.2.4, @license MIT, @link http://pdfmake.org */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 9282:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(4155);
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(2136),
    _require$codes = _require.codes,
    ERR_AMBIGUOUS_ARGUMENT = _require$codes.ERR_AMBIGUOUS_ARGUMENT,
    ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
    ERR_INVALID_ARG_VALUE = _require$codes.ERR_INVALID_ARG_VALUE,
    ERR_INVALID_RETURN_VALUE = _require$codes.ERR_INVALID_RETURN_VALUE,
    ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS;

var AssertionError = __webpack_require__(5961);

var _require2 = __webpack_require__(9539),
    inspect = _require2.inspect;

var _require$types = (__webpack_require__(9539).types),
    isPromise = _require$types.isPromise,
    isRegExp = _require$types.isRegExp;

var objectAssign = Object.assign ? Object.assign : (__webpack_require__(8091).assign);
var objectIs = Object.is ? Object.is : __webpack_require__(609);
var errorCache = new Map();
var isDeepEqual;
var isDeepStrictEqual;
var parseExpressionAt;
var findNodeAround;
var decoder;

function lazyLoadComparison() {
  var comparison = __webpack_require__(9158);

  isDeepEqual = comparison.isDeepEqual;
  isDeepStrictEqual = comparison.isDeepStrictEqual;
} // Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex


var escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var meta = (/* unused pure expression or super */ null && (["\\u0000", "\\u0001", "\\u0002", "\\u0003", "\\u0004", "\\u0005", "\\u0006", "\\u0007", '\\b', '', '', "\\u000b", '\\f', '', "\\u000e", "\\u000f", "\\u0010", "\\u0011", "\\u0012", "\\u0013", "\\u0014", "\\u0015", "\\u0016", "\\u0017", "\\u0018", "\\u0019", "\\u001a", "\\u001b", "\\u001c", "\\u001d", "\\u001e", "\\u001f"]));

var escapeFn = function escapeFn(str) {
  return meta[str.charCodeAt(0)];
};

var warned = false; // The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;
var NO_EXCEPTION_SENTINEL = {}; // All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function innerFail(obj) {
  if (obj.message instanceof Error) throw obj.message;
  throw new AssertionError(obj);
}

function fail(actual, expected, message, operator, stackStartFn) {
  var argsLen = arguments.length;
  var internalMessage;

  if (argsLen === 0) {
    internalMessage = 'Failed';
  } else if (argsLen === 1) {
    message = actual;
    actual = undefined;
  } else {
    if (warned === false) {
      warned = true;
      var warn = process.emitWarning ? process.emitWarning : console.warn.bind(console);
      warn('assert.fail() with more than one argument is deprecated. ' + 'Please use assert.strictEqual() instead or only pass a message.', 'DeprecationWarning', 'DEP0094');
    }

    if (argsLen === 2) operator = '!=';
  }

  if (message instanceof Error) throw message;
  var errArgs = {
    actual: actual,
    expected: expected,
    operator: operator === undefined ? 'fail' : operator,
    stackStartFn: stackStartFn || fail
  };

  if (message !== undefined) {
    errArgs.message = message;
  }

  var err = new AssertionError(errArgs);

  if (internalMessage) {
    err.message = internalMessage;
    err.generatedMessage = true;
  }

  throw err;
}

assert.fail = fail; // The AssertionError is defined in internal/error.

assert.AssertionError = AssertionError;

function innerOk(fn, argLen, value, message) {
  if (!value) {
    var generatedMessage = false;

    if (argLen === 0) {
      generatedMessage = true;
      message = 'No value argument passed to `assert.ok()`';
    } else if (message instanceof Error) {
      throw message;
    }

    var err = new AssertionError({
      actual: value,
      expected: true,
      message: message,
      operator: '==',
      stackStartFn: fn
    });
    err.generatedMessage = generatedMessage;
    throw err;
  }
} // Pure assertion tests whether a value is truthy, as determined
// by !!value.


function ok() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  innerOk.apply(void 0, [ok, args.length].concat(args));
}

assert.ok = ok; // The equality assertion tests shallow, coercive equality with ==.

/* eslint-disable no-restricted-properties */

assert.equal = function equal(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  } // eslint-disable-next-line eqeqeq


  if (actual != expected) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: '==',
      stackStartFn: equal
    });
  }
}; // The non-equality assertion tests for whether two objects are not
// equal with !=.


assert.notEqual = function notEqual(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  } // eslint-disable-next-line eqeqeq


  if (actual == expected) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: '!=',
      stackStartFn: notEqual
    });
  }
}; // The equivalence assertion tests a deep equality relation.


assert.deepEqual = function deepEqual(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  }

  if (isDeepEqual === undefined) lazyLoadComparison();

  if (!isDeepEqual(actual, expected)) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: 'deepEqual',
      stackStartFn: deepEqual
    });
  }
}; // The non-equivalence assertion tests for any deep inequality.


assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (arguments.length < 2) {
    throw new ERR_MISSING_ARGS('actual', 'expected');
  }

  if (isDeepEqual === undefined) lazyLoadComparison();

  if (isDeepEqual(actual, expected)) {
    innerFail({
      actual: actual,
      expected: expected,
      message: message,
      operator: 'notDeepEqual',
      stackStartFn: notDeepEqual
    });
  }
};
        /* eslint-enable */

        assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
          if (arguments.length < 2) {
            throw new ERR_MISSING_ARGS('actual', 'expected');
          }

          if (isDeepEqual === undefined) lazyLoadComparison();

          if (!isDeepStrictEqual(actual, expected)) {
            innerFail({
              actual,
              expected,
              message,
              operator: 'deepStrictEqual',
              stackStartFn: deepStrictEqual,
            });
          }
        };

        assert.notDeepStrictEqual = notDeepStrictEqual;

        function notDeepStrictEqual(actual, expected, message) {
          if (arguments.length < 2) {
            throw new ERR_MISSING_ARGS('actual', 'expected');
          }

          if (isDeepEqual === undefined) lazyLoadComparison();

          if (isDeepStrictEqual(actual, expected)) {
            innerFail({
              actual,
              expected,
              message,
              operator: 'notDeepStrictEqual',
              stackStartFn: notDeepStrictEqual,
            });
          }
        }

        assert.strictEqual = function strictEqual(actual, expected, message) {
          if (arguments.length < 2) {
            throw new ERR_MISSING_ARGS('actual', 'expected');
          }

          if (!objectIs(actual, expected)) {
            innerFail({
              actual,
              expected,
              message,
              operator: 'strictEqual',
              stackStartFn: strictEqual,
            });
          }
        };

        assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
          if (arguments.length < 2) {
            throw new ERR_MISSING_ARGS('actual', 'expected');
          }

          if (objectIs(actual, expected)) {
            innerFail({
              actual,
              expected,
              message,
              operator: 'notStrictEqual',
              stackStartFn: notStrictEqual,
            });
          }
        };

        const Comparison = function Comparison(obj, keys, actual) {
          const _this = this;

          _classCallCheck(this, Comparison);

          keys.forEach((key) => {
            if (key in obj) {
              if (actual !== undefined && typeof actual[key] === 'string' && isRegExp(obj[key]) && obj[key].test(actual[key])) {
                _this[key] = actual[key];
              } else {
                _this[key] = obj[key];
              }
            }
          });
        };

        function compareExceptionKey(actual, expected, key, message, keys, fn) {
          if (!(key in actual) || !isDeepStrictEqual(actual[key], expected[key])) {
            if (!message) {
              // Create placeholder objects to create a nice output.
              const a = new Comparison(actual, keys);
              const b = new Comparison(expected, keys, actual);
              const err = new AssertionError({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn,
              });
              err.actual = actual;
              err.expected = expected;
              err.operator = fn.name;
              throw err;
            }

            innerFail({
              actual,
              expected,
              message,
              operator: fn.name,
              stackStartFn: fn,
            });
          }
        }

        function expectedException(actual, expected, msg, fn) {
          if (typeof expected !== 'function') {
            if (isRegExp(expected)) return expected.test(actual); // assert.doesNotThrow does not accept objects.

            if (arguments.length === 2) {
              throw new ERR_INVALID_ARG_TYPE('expected', ['Function', 'RegExp'], expected);
            } // Handle primitives properly.

            if (_typeof(actual) !== 'object' || actual === null) {
              const err = new AssertionError({
                actual,
                expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn,
              });
              err.operator = fn.name;
              throw err;
            }

            const keys = Object.keys(expected); // Special handle errors to make sure the name and the message are compared
            // as well.

            if (expected instanceof Error) {
              keys.push('name', 'message');
            } else if (keys.length === 0) {
              throw new ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
            }

            if (isDeepEqual === undefined) lazyLoadComparison();
            keys.forEach((key) => {
              if (typeof actual[key] === 'string' && isRegExp(expected[key]) && expected[key].test(actual[key])) {
                return;
              }

              compareExceptionKey(actual, expected, key, msg, keys, fn);
            });
            return true;
          } // Guard instanceof against arrow functions as they don't have a prototype.

          if (expected.prototype !== undefined && actual instanceof expected) {
            return true;
          }

          if (Error.isPrototypeOf(expected)) {
            return false;
          }

          return expected.call({}, actual) === true;
        }

        function getActual(fn) {
          if (typeof fn !== 'function') {
            throw new ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
          }

          try {
            fn();
          } catch (e) {
            return e;
          }

          return NO_EXCEPTION_SENTINEL;
        }

        function checkIsPromise(obj) {
          // Accept native ES6 promises and promises that are implemented in a similar
          // way. Do not accept thenables that use a function as `obj` and that have no
          // `catch` handler.
          // TODO: thenables are checked up until they have the correct methods,
          // but according to documentation, the `then` method should receive
          // the `fulfill` and `reject` arguments as well or it may be never resolved.
          return isPromise(obj) || obj !== null && _typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
        }

        function waitForActual(promiseFn) {
          return Promise.resolve().then(() => {
            let resultPromise;

            if (typeof promiseFn === 'function') {
              // Return a rejected promise if `promiseFn` throws synchronously.
              resultPromise = promiseFn(); // Fail in case no promise is returned.

              if (!checkIsPromise(resultPromise)) {
                throw new ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
              }
            } else if (checkIsPromise(promiseFn)) {
              resultPromise = promiseFn;
            } else {
              throw new ERR_INVALID_ARG_TYPE('promiseFn', ['Function', 'Promise'], promiseFn);
            }

            return Promise.resolve().then(() => resultPromise).then(() => NO_EXCEPTION_SENTINEL).catch((e) => e);
          });
        }

        function expectsError(stackStartFn, actual, error, message) {
          if (typeof error === 'string') {
            if (arguments.length === 4) {
              throw new ERR_INVALID_ARG_TYPE('error', ['Object', 'Error', 'Function', 'RegExp'], error);
            }

            if (_typeof(actual) === 'object' && actual !== null) {
              if (actual.message === error) {
                throw new ERR_AMBIGUOUS_ARGUMENT('error/message', 'The error message "'.concat(actual.message, '" is identical to the message.'));
              }
            } else if (actual === error) {
              throw new ERR_AMBIGUOUS_ARGUMENT('error/message', 'The error "'.concat(actual, '" is identical to the message.'));
            }

            message = error;
            error = undefined;
          } else if (error != null && _typeof(error) !== 'object' && typeof error !== 'function') {
            throw new ERR_INVALID_ARG_TYPE('error', ['Object', 'Error', 'Function', 'RegExp'], error);
          }

          if (actual === NO_EXCEPTION_SENTINEL) {
            let details = '';

            if (error && error.name) {
              details += ' ('.concat(error.name, ')');
            }

            details += message ? ': '.concat(message) : '.';
            const fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
            innerFail({
              actual: undefined,
              expected: error,
              operator: stackStartFn.name,
              message: 'Missing expected '.concat(fnType).concat(details),
              stackStartFn,
            });
          }

          if (error && !expectedException(actual, error, message, stackStartFn)) {
            throw actual;
          }
        }

        function expectsNoError(stackStartFn, actual, error, message) {
          if (actual === NO_EXCEPTION_SENTINEL) return;

          if (typeof error === 'string') {
            message = error;
            error = undefined;
          }

          if (!error || expectedException(actual, error)) {
            const details = message ? ': '.concat(message) : '.';
            const fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
            innerFail({
              actual,
              expected: error,
              operator: stackStartFn.name,
              message: 'Got unwanted '.concat(fnType).concat(details, '\n') + 'Actual message: "'.concat(actual && actual.message, '"'),
              stackStartFn,
            });
          }

          throw actual;
        }

        assert.throws = function throws(promiseFn) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          expectsError.apply(void 0, [throws, getActual(promiseFn)].concat(args));
        };

        assert.rejects = function rejects(promiseFn) {
          for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
            args[_key3 - 1] = arguments[_key3];
          }

          return waitForActual(promiseFn).then((result) => expectsError.apply(void 0, [rejects, result].concat(args)));
        };

        assert.doesNotThrow = function doesNotThrow(fn) {
          for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
            args[_key4 - 1] = arguments[_key4];
          }

          expectsNoError.apply(void 0, [doesNotThrow, getActual(fn)].concat(args));
        };

        assert.doesNotReject = function doesNotReject(fn) {
          for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
            args[_key5 - 1] = arguments[_key5];
          }

          return waitForActual(fn).then((result) => expectsNoError.apply(void 0, [doesNotReject, result].concat(args)));
        };

        assert.ifError = function ifError(err) {
          if (err !== null && err !== undefined) {
            let message = 'ifError got unwanted exception: ';

            if (_typeof(err) === 'object' && typeof err.message === 'string') {
              if (err.message.length === 0 && err.constructor) {
                message += err.constructor.name;
              } else {
                message += err.message;
              }
            } else {
              message += inspect(err);
            }

            const newErr = new AssertionError({
              actual: err,
              expected: null,
              operator: 'ifError',
              message,
              stackStartFn: ifError,
            }); // Make sure we actually have a stack trace!

            const origStack = err.stack;

            if (typeof origStack === 'string') {
              // This will remove any duplicated frames from the error frames taken
              // from within `ifError` and add the original error frames to the newly
              // created ones.
              const tmp2 = origStack.split('\n');
              tmp2.shift(); // Filter all frames existing in err.stack.

              let tmp1 = newErr.stack.split('\n');

              for (let i = 0; i < tmp2.length; i++) {
                // Find the first occurrence of the frame.
                const pos = tmp1.indexOf(tmp2[i]);

                if (pos !== -1) {
                  // Only keep new frames.
                  tmp1 = tmp1.slice(0, pos);
                  break;
                }
              }

              newErr.stack = ''.concat(tmp1.join('\n'), '\n').concat(tmp2.join('\n'));
            }

            throw newErr;
          }
        }; // Expose a strict only variant of assert

        function strict() {
          for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            args[_key6] = arguments[_key6];
          }

          innerOk.apply(void 0, [strict, args.length].concat(args));
        }

        assert.strict = objectAssign(strict, assert, {
          equal: assert.strictEqual,
          deepEqual: assert.deepStrictEqual,
          notEqual: assert.notStrictEqual,
          notDeepEqual: assert.notDeepStrictEqual,
        });
        assert.strict.strict = assert.strict;
        /***/ }),

      /***/ 5961:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* provided dependency */ const process = __webpack_require__(4155);
        // Currently in sync with Node.js lib/internal/assert/assertion_error.js
        // https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

        function _objectSpread(target) { for (let i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; let ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter((sym) => Object.getOwnPropertyDescriptor(source, sym).enumerable)); } ownKeys.forEach((key) => { _defineProperty(target, key, source[key]); }); } return target; }

        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value, enumerable: true, configurable: true, writable: true,
            });
          } else { obj[key] = value; } return obj;
        }

        function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

        function _defineProperties(target, props) { for (let i = 0; i < props.length; i++) { const descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

        function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === 'object' || typeof call === 'function')) { return call; } return _assertThisInitialized(self); }

        function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

        function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function'); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

        function _wrapNativeSuper(Class) {
          const _cache = typeof Map === 'function' ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) {
            if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== 'function') { throw new TypeError('Super expression must either be null or a function'); } if (typeof _cache !== 'undefined') { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, {
              constructor: {
                value: Wrapper, enumerable: false, writable: true, configurable: true,
              },
            }); return _setPrototypeOf(Wrapper, Class);
          }; return _wrapNativeSuper(Class);
        }

        function isNativeReflectConstruct() { if (typeof Reflect === 'undefined' || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === 'function') return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], () => {})); return true; } catch (e) { return false; } }

        function _construct(Parent, args, Class) { if (isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { const a = [null]; a.push.apply(a, args); const Constructor = Function.bind.apply(Parent, a); const instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

        function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf('[native code]') !== -1; }

        function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

        function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

        function _typeof(obj) { if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj; }; } return _typeof(obj); }

        const _require = __webpack_require__(9539);
        const { inspect } = _require;

        const _require2 = __webpack_require__(2136);
        const { ERR_INVALID_ARG_TYPE } = _require2.codes; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith

        function endsWith(str, search, this_len) {
          if (this_len === undefined || this_len > str.length) {
            this_len = str.length;
          }

          return str.substring(this_len - search.length, this_len) === search;
        } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat

        function repeat(str, count) {
          count = Math.floor(count);
          if (str.length == 0 || count == 0) return '';
          const maxCount = str.length * count;
          count = Math.floor(Math.log(count) / Math.log(2));

          while (count) {
            str += str;
            count--;
          }

          str += str.substring(0, maxCount - str.length);
          return str;
        }

        let blue = '';
        let green = '';
        let red = '';
        let white = '';
        const kReadableOperator = {
          deepStrictEqual: 'Expected values to be strictly deep-equal:',
          strictEqual: 'Expected values to be strictly equal:',
          strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
          deepEqual: 'Expected values to be loosely deep-equal:',
          equal: 'Expected values to be loosely equal:',
          notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
          notStrictEqual: 'Expected "actual" to be strictly unequal to:',
          notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
          notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
          notEqual: 'Expected "actual" to be loosely unequal to:',
          notIdentical: 'Values identical but not reference-equal:',
        }; // Comparing short primitives should just show === / !== instead of using the
        // diff.

        const kMaxShortLength = 10;

        function copyError(source) {
          const keys = Object.keys(source);
          const target = Object.create(Object.getPrototypeOf(source));
          keys.forEach((key) => {
            target[key] = source[key];
          });
          Object.defineProperty(target, 'message', {
            value: source.message,
          });
          return target;
        }

        function inspectValue(val) {
          // The util.inspect default values could be changed. This makes sure the
          // error messages contain the necessary information nevertheless.
          return inspect(val, {
            compact: false,
            customInspect: false,
            depth: 1000,
            maxArrayLength: Infinity,
            // Assert compares only enumerable properties (with a few exceptions).
            showHidden: false,
            // Having a long line as error is better than wrapping the line for
            // comparison for now.
            // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
            // have meta information about the inspected properties (i.e., know where
            // in what line the property starts and ends).
            breakLength: Infinity,
            // Assert does not detect proxies currently.
            showProxy: false,
            sorted: true,
            // Inspect getters as we also check them when comparing entries.
            getters: true,
          });
        }

        function createErrDiff(actual, expected, operator) {
          let other = '';
          let res = '';
          let lastPos = 0;
          let end = '';
          let skipped = false;
          const actualInspected = inspectValue(actual);
          const actualLines = actualInspected.split('\n');
          const expectedLines = inspectValue(expected).split('\n');
          let i = 0;
          let indicator = ''; // In case both values are objects explicitly mark them as not reference equal
          // for the `strictEqual` operator.

          if (operator === 'strictEqual' && _typeof(actual) === 'object' && _typeof(expected) === 'object' && actual !== null && expected !== null) {
            operator = 'strictEqualObject';
          } // If "actual" and "expected" fit on a single line and they are not strictly
          // equal, check further special handling.

          if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
            const inputLength = actualLines[0].length + expectedLines[0].length; // If the character length of "actual" and "expected" together is less than
            // kMaxShortLength and if neither is an object and at least one of them is
            // not `zero`, use the strict equal comparison to visualize the output.

            if (inputLength <= kMaxShortLength) {
              if ((_typeof(actual) !== 'object' || actual === null) && (_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) {
                // -0 === +0
                return ''.concat(kReadableOperator[operator], '\n\n') + ''.concat(actualLines[0], ' !== ').concat(expectedLines[0], '\n');
              }
            } else if (operator !== 'strictEqualObject') {
              // If the stderr is a tty and the input length is lower than the current
              // columns per line, add a mismatch indicator below the output. If it is
              // not a tty, use a default value of 80 characters.
              const maxLength = process.stderr && process.stderr.isTTY ? process.stderr.columns : 80;

              if (inputLength < maxLength) {
                while (actualLines[0][i] === expectedLines[0][i]) {
                  i++;
                } // Ignore the first characters.

                if (i > 2) {
                  // Add position indicator for the first mismatch in case it is a
                  // single line and the input length is less than the column length.
                  indicator = '\n  '.concat(repeat(' ', i), '^');
                  i = 0;
                }
              }
            }
          } // Remove all ending lines that match (this optimizes the output for
          // readability by reducing the number of total changed lines).

          let a = actualLines[actualLines.length - 1];
          let b = expectedLines[expectedLines.length - 1];

          while (a === b) {
            if (i++ < 2) {
              end = '\n  '.concat(a).concat(end);
            } else {
              other = a;
            }

            actualLines.pop();
            expectedLines.pop();
            if (actualLines.length === 0 || expectedLines.length === 0) break;
            a = actualLines[actualLines.length - 1];
            b = expectedLines[expectedLines.length - 1];
          }

          const maxLines = Math.max(actualLines.length, expectedLines.length); // Strict equal with identical objects that are not identical by reference.
          // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })

          if (maxLines === 0) {
            // We have to get the result again. The lines were all removed before.
            const _actualLines = actualInspected.split('\n'); // Only remove lines in case it makes sense to collapse those.
            // TODO: Accept env to always show the full error.

            if (_actualLines.length > 30) {
              _actualLines[26] = ''.concat(blue, '...').concat(white);

              while (_actualLines.length > 27) {
                _actualLines.pop();
              }
            }

            return ''.concat(kReadableOperator.notIdentical, '\n\n').concat(_actualLines.join('\n'), '\n');
          }

          if (i > 3) {
            end = '\n'.concat(blue, '...').concat(white).concat(end);
            skipped = true;
          }

          if (other !== '') {
            end = '\n  '.concat(other).concat(end);
            other = '';
          }

          let printedLines = 0;
          const msg = kReadableOperator[operator] + '\n'.concat(green, '+ actual').concat(white, ' ').concat(red, '- expected').concat(white);
          const skippedMsg = ' '.concat(blue, '...').concat(white, ' Lines skipped');

          for (i = 0; i < maxLines; i++) {
            // Only extra expected lines exist
            const cur = i - lastPos;

            if (actualLines.length < i + 1) {
              // If the last diverging line is more than one line above and the
              // current line is at least line three, add some of the former lines and
              // also add dots to indicate skipped entries.
              if (cur > 1 && i > 2) {
                if (cur > 4) {
                  res += '\n'.concat(blue, '...').concat(white);
                  skipped = true;
                } else if (cur > 3) {
                  res += '\n  '.concat(expectedLines[i - 2]);
                  printedLines++;
                }

                res += '\n  '.concat(expectedLines[i - 1]);
                printedLines++;
              } // Mark the current line as the last diverging one.

              lastPos = i; // Add the expected line to the cache.

              other += '\n'.concat(red, '-').concat(white, ' ').concat(expectedLines[i]);
              printedLines++; // Only extra actual lines exist
            } else if (expectedLines.length < i + 1) {
              // If the last diverging line is more than one line above and the
              // current line is at least line three, add some of the former lines and
              // also add dots to indicate skipped entries.
              if (cur > 1 && i > 2) {
                if (cur > 4) {
                  res += '\n'.concat(blue, '...').concat(white);
                  skipped = true;
                } else if (cur > 3) {
                  res += '\n  '.concat(actualLines[i - 2]);
                  printedLines++;
                }

                res += '\n  '.concat(actualLines[i - 1]);
                printedLines++;
              } // Mark the current line as the last diverging one.

              lastPos = i; // Add the actual line to the result.

              res += '\n'.concat(green, '+').concat(white, ' ').concat(actualLines[i]);
              printedLines++; // Lines diverge
            } else {
              const expectedLine = expectedLines[i];
              let actualLine = actualLines[i]; // If the lines diverge, specifically check for lines that only diverge by
              // a trailing comma. In that case it is actually identical and we should
              // mark it as such.

              let divergingLines = actualLine !== expectedLine && (!endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine); // If the expected line has a trailing comma but is otherwise identical,
              // add a comma at the end of the actual line. Otherwise the output could
              // look weird as in:
              //
              //   [
              //     1         // No comma at the end!
              // +   2
              //   ]
              //

              if (divergingLines && endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
              }

              if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                  if (cur > 4) {
                    res += '\n'.concat(blue, '...').concat(white);
                    skipped = true;
                  } else if (cur > 3) {
                    res += '\n  '.concat(actualLines[i - 2]);
                    printedLines++;
                  }

                  res += '\n  '.concat(actualLines[i - 1]);
                  printedLines++;
                } // Mark the current line as the last diverging one.

                lastPos = i; // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.

                res += '\n'.concat(green, '+').concat(white, ' ').concat(actualLine);
                other += '\n'.concat(red, '-').concat(white, ' ').concat(expectedLine);
                printedLines += 2; // Lines are identical
              } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = ''; // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.

                if (cur === 1 || i === 0) {
                  res += '\n  '.concat(actualLine);
                  printedLines++;
                }
              }
            } // Inspected object to big (Show ~20 rows max)

            if (printedLines > 20 && i < maxLines - 2) {
              return ''.concat(msg).concat(skippedMsg, '\n').concat(res, '\n').concat(blue, '...')
                .concat(white)
                .concat(other, '\n') + ''.concat(blue, '...').concat(white);
            }
          }

          return ''.concat(msg).concat(skipped ? skippedMsg : '', '\n').concat(res).concat(other)
            .concat(end)
            .concat(indicator);
        }

        const AssertionError =
/* #__PURE__ */
(function (_Error) {
  _inherits(AssertionError, _Error);

  function AssertionError(options) {
    let _this;

    _classCallCheck(this, AssertionError);

    if (_typeof(options) !== 'object' || options === null) {
      throw new ERR_INVALID_ARG_TYPE('options', 'Object', options);
    }

    const { message } = options;
    const { operator } = options;
    const { stackStartFn } = options;
    let { actual } = options;
    let { expected } = options;
    const limit = Error.stackTraceLimit;
    Error.stackTraceLimit = 0;

    if (message != null) {
      _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, String(message)));
    } else {
      if (process.stderr && process.stderr.isTTY) {
        // Reset on each call to make sure we handle dynamically set environment
        // variables correct.
        if (process.stderr && process.stderr.getColorDepth && process.stderr.getColorDepth() !== 1) {
          blue = '\x1B[34m';
          green = '\x1B[32m';
          white = '\x1B[39m';
          red = '\x1B[31m';
        } else {
          blue = '';
          green = '';
          white = '';
          red = '';
        }
      } // Prevent the error stack from being visible by duplicating the error
      // in a very close way to the original in case both sides are actually
      // instances of Error.

      if (_typeof(actual) === 'object' && actual !== null && _typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
        actual = copyError(actual);
        expected = copyError(expected);
      }

      if (operator === 'deepStrictEqual' || operator === 'strictEqual') {
        _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, createErrDiff(actual, expected, operator)));
      } else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
        // In case the objects are equal but the operator requires unequal, show
        // the first object and say A equals B
        let base = kReadableOperator[operator];
        const res = inspectValue(actual).split('\n'); // In case "actual" is an object, it should not be reference equal.

        if (operator === 'notStrictEqual' && _typeof(actual) === 'object' && actual !== null) {
          base = kReadableOperator.notStrictEqualObject;
        } // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.

        if (res.length > 30) {
          res[26] = ''.concat(blue, '...').concat(white);

          while (res.length > 27) {
            res.pop();
          }
        } // Only print a single input.

        if (res.length === 1) {
          _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, ''.concat(base, ' ').concat(res[0])));
        } else {
          _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, ''.concat(base, '\n\n').concat(res.join('\n'), '\n')));
        }
      } else {
        let _res = inspectValue(actual);

        let other = '';
        const knownOperators = kReadableOperator[operator];

        if (operator === 'notDeepEqual' || operator === 'notEqual') {
          _res = ''.concat(kReadableOperator[operator], '\n\n').concat(_res);

          if (_res.length > 1024) {
            _res = ''.concat(_res.slice(0, 1021), '...');
          }
        } else {
          other = ''.concat(inspectValue(expected));

          if (_res.length > 512) {
            _res = ''.concat(_res.slice(0, 509), '...');
          }

          if (other.length > 512) {
            other = ''.concat(other.slice(0, 509), '...');
          }

          if (operator === 'deepEqual' || operator === 'equal') {
            _res = ''.concat(knownOperators, '\n\n').concat(_res, '\n\nshould equal\n\n');
          } else {
            other = ' '.concat(operator, ' ').concat(other);
          }
        }

        _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, ''.concat(_res).concat(other)));
      }
    }

    Error.stackTraceLimit = limit;
    _this.generatedMessage = !message;
    Object.defineProperty(_assertThisInitialized(_this), 'name', {
      value: 'AssertionError [ERR_ASSERTION]',
      enumerable: false,
      writable: true,
      configurable: true,
    });
    _this.code = 'ERR_ASSERTION';
    _this.actual = actual;
    _this.expected = expected;
    _this.operator = operator;

    if (Error.captureStackTrace) {
      // eslint-disable-next-line no-restricted-syntax
      Error.captureStackTrace(_assertThisInitialized(_this), stackStartFn);
    } // Create error message including the error code in the name.

    _this.stack; // Reset the name.

    _this.name = 'AssertionError';
    return _possibleConstructorReturn(_this);
  }

  _createClass(AssertionError, [{
    key: 'toString',
    value: function toString() {
      return ''.concat(this.name, ' [').concat(this.code, ']: ').concat(this.message);
    },
  }, {
    key: inspect.custom,
    value: function value(recurseTimes, ctx) {
      // This limits the `actual` and `expected` property default inspection to
      // the minimum depth. Otherwise those values would be too verbose compared
      // to the actual error message which contains a combined view of these two
      // input values.
      return inspect(this, _objectSpread({}, ctx, {
        customInspect: false,
        depth: 0,
      }));
    },
  }]);

  return AssertionError;
}(_wrapNativeSuper(Error)));

        module.exports = AssertionError;
        /***/ }),

      /***/ 2136:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        // Currently in sync with Node.js lib/internal/errors.js
        // https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f

        /* eslint node-core/documented-errors: "error" */

        /* eslint node-core/alphabetize-errors: "error" */

        /* eslint node-core/prefer-util-format-errors: "error" */
        // The whole point behind this internal module is to allow Node.js to no
        // longer be forced to treat every error message change as a semver-major
        // change. The NodeError classes here all expose a `code` property whose
        // value statically and permanently identifies the error. While the error
        // message may change, the code should not.

        function _typeof(obj) { if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj; }; } return _typeof(obj); }

        function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

        function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === 'object' || typeof call === 'function')) { return call; } return _assertThisInitialized(self); }

        function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

        function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

        function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function'); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

        function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

        const codes = {}; // Lazy loaded

        let assert;
        let util;

        function createErrorType(code, message, Base) {
          if (!Base) {
            Base = Error;
          }

          function getMessage(arg1, arg2, arg3) {
            if (typeof message === 'string') {
              return message;
            }
            return message(arg1, arg2, arg3);
          }

          const NodeError =
  /* #__PURE__ */
  (function (_Base) {
    _inherits(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      let _this;

      _classCallCheck(this, NodeError);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(NodeError).call(this, getMessage(arg1, arg2, arg3)));
      _this.code = code;
      return _this;
    }

    return NodeError;
  }(Base));

          codes[code] = NodeError;
        } // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js

        function oneOf(expected, thing) {
          if (Array.isArray(expected)) {
            const len = expected.length;
            expected = expected.map((i) => String(i));

            if (len > 2) {
              return 'one of '.concat(thing, ' ').concat(expected.slice(0, len - 1).join(', '), ', or ') + expected[len - 1];
            } if (len === 2) {
              return 'one of '.concat(thing, ' ').concat(expected[0], ' or ').concat(expected[1]);
            }
            return 'of '.concat(thing, ' ').concat(expected[0]);
          }
          return 'of '.concat(thing, ' ').concat(String(expected));
        } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith

        function startsWith(str, search, pos) {
          return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
        } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith

        function endsWith(str, search, this_len) {
          if (this_len === undefined || this_len > str.length) {
            this_len = str.length;
          }

          return str.substring(this_len - search.length, this_len) === search;
        } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes

        function includes(str, search, start) {
          if (typeof start !== 'number') {
            start = 0;
          }

          if (start + search.length > str.length) {
            return false;
          }
          return str.indexOf(search, start) !== -1;
        }

        createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);
        createErrorType('ERR_INVALID_ARG_TYPE', (name, expected, actual) => {
          if (assert === undefined) assert = __webpack_require__(9282);
          assert(typeof name === 'string', "'name' must be a string"); // determiner: 'must be' or 'must not be'

          let determiner;

          if (typeof expected === 'string' && startsWith(expected, 'not ')) {
            determiner = 'must not be';
            expected = expected.replace(/^not /, '');
          } else {
            determiner = 'must be';
          }

          let msg;

          if (endsWith(name, ' argument')) {
            // For cases like 'first argument'
            msg = 'The '.concat(name, ' ').concat(determiner, ' ').concat(oneOf(expected, 'type'));
          } else {
            const type = includes(name, '.') ? 'property' : 'argument';
            msg = 'The "'.concat(name, '" ').concat(type, ' ').concat(determiner, ' ').concat(oneOf(expected, 'type'));
          } // TODO(BridgeAR): Improve the output by showing `null` and similar.

          msg += '. Received type '.concat(_typeof(actual));
          return msg;
        }, TypeError);
        createErrorType('ERR_INVALID_ARG_VALUE', function (name, value) {
          const reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
          if (util === undefined) util = __webpack_require__(9539);
          let inspected = util.inspect(value);

          if (inspected.length > 128) {
            inspected = ''.concat(inspected.slice(0, 128), '...');
          }

          return "The argument '".concat(name, "' ").concat(reason, '. Received ').concat(inspected);
        }, TypeError, RangeError);
        createErrorType('ERR_INVALID_RETURN_VALUE', (input, name, value) => {
          let type;

          if (value && value.constructor && value.constructor.name) {
            type = 'instance of '.concat(value.constructor.name);
          } else {
            type = 'type '.concat(_typeof(value));
          }

          return 'Expected '.concat(input, ' to be returned from the "').concat(name, '"') + ' function but got '.concat(type, '.');
        }, TypeError);
        createErrorType('ERR_MISSING_ARGS', function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (assert === undefined) assert = __webpack_require__(9282);
          assert(args.length > 0, 'At least one arg needs to be specified');
          let msg = 'The ';
          const len = args.length;
          args = args.map((a) => '"'.concat(a, '"'));

          switch (len) {
            case 1:
              msg += ''.concat(args[0], ' argument');
              break;

            case 2:
              msg += ''.concat(args[0], ' and ').concat(args[1], ' arguments');
              break;

            default:
              msg += args.slice(0, len - 1).join(', ');
              msg += ', and '.concat(args[len - 1], ' arguments');
              break;
          }

          return ''.concat(msg, ' must be specified');
        }, TypeError);
        module.exports.codes = codes;
        /***/ }),

      /***/ 9158:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        // Currently in sync with Node.js lib/internal/util/comparisons.js
        // https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9

        function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

        function _nonIterableRest() { throw new TypeError('Invalid attempt to destructure non-iterable instance'); }

        function _iterableToArrayLimit(arr, i) { const _arr = []; let _n = true; let _d = false; let _e; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i.return != null) _i.return(); } finally { if (_d) throw _e; } } return _arr; }

        function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

        function _typeof(obj) { if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj; }; } return _typeof(obj); }

        const regexFlagsSupported = /a/g.flags !== undefined;

        const arrayFromSet = function arrayFromSet(set) {
          const array = [];
          set.forEach((value) => array.push(value));
          return array;
        };

        const arrayFromMap = function arrayFromMap(map) {
          const array = [];
          map.forEach((value, key) => array.push([key, value]));
          return array;
        };

        const objectIs = Object.is ? Object.is : __webpack_require__(609);
        const objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function () {
          return [];
        };
        const numberIsNaN = Number.isNaN ? Number.isNaN : __webpack_require__(360);

        function uncurryThis(f) {
          return f.call.bind(f);
        }

        const hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);
        const propertyIsEnumerable = uncurryThis(Object.prototype.propertyIsEnumerable);
        const objectToString = uncurryThis(Object.prototype.toString);

        const _require$types = (__webpack_require__(9539).types);
        const { isAnyArrayBuffer } = _require$types;
        const { isArrayBufferView } = _require$types;
        const { isDate } = _require$types;
        const { isMap } = _require$types;
        const { isRegExp } = _require$types;
        const { isSet } = _require$types;
        const { isNativeError } = _require$types;
        const { isBoxedPrimitive } = _require$types;
        const { isNumberObject } = _require$types;
        const { isStringObject } = _require$types;
        const { isBooleanObject } = _require$types;
        const { isBigIntObject } = _require$types;
        const { isSymbolObject } = _require$types;
        const { isFloat32Array } = _require$types;
        const { isFloat64Array } = _require$types;

        function isNonIndex(key) {
          if (key.length === 0 || key.length > 10) return true;

          for (let i = 0; i < key.length; i++) {
            const code = key.charCodeAt(i);
            if (code < 48 || code > 57) return true;
          } // The maximum size for an array is 2 ** 32 -1.

          return key.length === 10 && key >= Math.pow(2, 32);
        }

        function getOwnNonIndexProperties(value) {
          return Object.keys(value).filter(isNonIndex).concat(objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
        } // Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
        // original notice:

        /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */

        function compare(a, b) {
          if (a === b) {
            return 0;
          }

          let x = a.length;
          let y = b.length;

          for (let i = 0, len = Math.min(x, y); i < len; ++i) {
            if (a[i] !== b[i]) {
              x = a[i];
              y = b[i];
              break;
            }
          }

          if (x < y) {
            return -1;
          }

          if (y < x) {
            return 1;
          }

          return 0;
        }

        const ONLY_ENUMERABLE = undefined;
        const kStrict = true;
        const kLoose = false;
        const kNoIterator = 0;
        const kIsArray = 1;
        const kIsSet = 2;
        const kIsMap = 3; // Check if they have the same source and flags

        function areSimilarRegExps(a, b) {
          return regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
        }

        function areSimilarFloatArrays(a, b) {
          if (a.byteLength !== b.byteLength) {
            return false;
          }

          for (let offset = 0; offset < a.byteLength; offset++) {
            if (a[offset] !== b[offset]) {
              return false;
            }
          }

          return true;
        }

        function areSimilarTypedArrays(a, b) {
          if (a.byteLength !== b.byteLength) {
            return false;
          }

          return compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
        }

        function areEqualArrayBuffers(buf1, buf2) {
          return buf1.byteLength === buf2.byteLength && compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
        }

        function isEqualBoxedPrimitive(val1, val2) {
          if (isNumberObject(val1)) {
            return isNumberObject(val2) && objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
          }

          if (isStringObject(val1)) {
            return isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
          }

          if (isBooleanObject(val1)) {
            return isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
          }

          if (isBigIntObject(val1)) {
            return isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
          }

          return isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
        } // Notes: Type tags are historical [[Class]] properties that can be set by
        // FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
        // and retrieved using Object.prototype.toString.call(obj) in JS
        // See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
        // for a list of tags pre-defined in the spec.
        // There are some unspecified tags in the wild too (e.g. typed array tags).
        // Since tags can be altered, they only serve fast failures
        //
        // Typed arrays and buffers are checked by comparing the content in their
        // underlying ArrayBuffer. This optimization requires that it's
        // reasonable to interpret their underlying memory in the same way,
        // which is checked by comparing their type tags.
        // (e.g. a Uint8Array and a Uint16Array with the same memory content
        // could still be different because they will be interpreted differently).
        //
        // For strict comparison, objects should have
        // a) The same built-in type tags
        // b) The same prototypes.

        function innerDeepEqual(val1, val2, strict, memos) {
          // All identical values are equivalent, as determined by ===.
          if (val1 === val2) {
            if (val1 !== 0) return true;
            return strict ? objectIs(val1, val2) : true;
          } // Check more closely if val1 and val2 are equal.

          if (strict) {
            if (_typeof(val1) !== 'object') {
              return typeof val1 === 'number' && numberIsNaN(val1) && numberIsNaN(val2);
            }

            if (_typeof(val2) !== 'object' || val1 === null || val2 === null) {
              return false;
            }

            if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) {
              return false;
            }
          } else {
            if (val1 === null || _typeof(val1) !== 'object') {
              if (val2 === null || _typeof(val2) !== 'object') {
                // eslint-disable-next-line eqeqeq
                return val1 == val2;
              }

              return false;
            }

            if (val2 === null || _typeof(val2) !== 'object') {
              return false;
            }
          }

          const val1Tag = objectToString(val1);
          const val2Tag = objectToString(val2);

          if (val1Tag !== val2Tag) {
            return false;
          }

          if (Array.isArray(val1)) {
            // Check for sparse arrays and general fast path
            if (val1.length !== val2.length) {
              return false;
            }

            const keys1 = getOwnNonIndexProperties(val1, ONLY_ENUMERABLE);
            const keys2 = getOwnNonIndexProperties(val2, ONLY_ENUMERABLE);

            if (keys1.length !== keys2.length) {
              return false;
            }

            return keyCheck(val1, val2, strict, memos, kIsArray, keys1);
          } // [browserify] This triggers on certain types in IE (Map/Set) so we don't
          // wan't to early return out of the rest of the checks. However we can check
          // if the second value is one of these values and the first isn't.

          if (val1Tag === '[object Object]') {
            // return keyCheck(val1, val2, strict, memos, kNoIterator);
            if (!isMap(val1) && isMap(val2) || !isSet(val1) && isSet(val2)) {
              return false;
            }
          }

          if (isDate(val1)) {
            if (!isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) {
              return false;
            }
          } else if (isRegExp(val1)) {
            if (!isRegExp(val2) || !areSimilarRegExps(val1, val2)) {
              return false;
            }
          } else if (isNativeError(val1) || val1 instanceof Error) {
            // Do not compare the stack as it might differ even though the error itself
            // is otherwise identical.
            if (val1.message !== val2.message || val1.name !== val2.name) {
              return false;
            }
          } else if (isArrayBufferView(val1)) {
            if (!strict && (isFloat32Array(val1) || isFloat64Array(val1))) {
              if (!areSimilarFloatArrays(val1, val2)) {
                return false;
              }
            } else if (!areSimilarTypedArrays(val1, val2)) {
              return false;
            } // Buffer.compare returns true, so val1.length === val2.length. If they both
            // only contain numeric keys, we don't need to exam further than checking
            // the symbols.

            const _keys = getOwnNonIndexProperties(val1, ONLY_ENUMERABLE);

            const _keys2 = getOwnNonIndexProperties(val2, ONLY_ENUMERABLE);

            if (_keys.length !== _keys2.length) {
              return false;
            }

            return keyCheck(val1, val2, strict, memos, kNoIterator, _keys);
          } else if (isSet(val1)) {
            if (!isSet(val2) || val1.size !== val2.size) {
              return false;
            }

            return keyCheck(val1, val2, strict, memos, kIsSet);
          } else if (isMap(val1)) {
            if (!isMap(val2) || val1.size !== val2.size) {
              return false;
            }

            return keyCheck(val1, val2, strict, memos, kIsMap);
          } else if (isAnyArrayBuffer(val1)) {
            if (!areEqualArrayBuffers(val1, val2)) {
              return false;
            }
          } else if (isBoxedPrimitive(val1) && !isEqualBoxedPrimitive(val1, val2)) {
            return false;
          }

          return keyCheck(val1, val2, strict, memos, kNoIterator);
        }

        function getEnumerables(val, keys) {
          return keys.filter((k) => propertyIsEnumerable(val, k));
        }

        function keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
          // For all remaining Object pairs, including Array, objects and Maps,
          // equivalence is determined by having:
          // a) The same number of owned enumerable properties
          // b) The same set of keys/indexes (although not necessarily the same order)
          // c) Equivalent values for every corresponding key/index
          // d) For Sets and Maps, equal contents
          // Note: this accounts for both named and indexed properties on Arrays.
          if (arguments.length === 5) {
            aKeys = Object.keys(val1);
            const bKeys = Object.keys(val2); // The pair must have the same number of owned properties.

            if (aKeys.length !== bKeys.length) {
              return false;
            }
          } // Cheap key test

          let i = 0;

          for (; i < aKeys.length; i++) {
            if (!hasOwnProperty(val2, aKeys[i])) {
              return false;
            }
          }

          if (strict && arguments.length === 5) {
            const symbolKeysA = objectGetOwnPropertySymbols(val1);

            if (symbolKeysA.length !== 0) {
              let count = 0;

              for (i = 0; i < symbolKeysA.length; i++) {
                const key = symbolKeysA[i];

                if (propertyIsEnumerable(val1, key)) {
                  if (!propertyIsEnumerable(val2, key)) {
                    return false;
                  }

                  aKeys.push(key);
                  count++;
                } else if (propertyIsEnumerable(val2, key)) {
                  return false;
                }
              }

              const symbolKeysB = objectGetOwnPropertySymbols(val2);

              if (symbolKeysA.length !== symbolKeysB.length && getEnumerables(val2, symbolKeysB).length !== count) {
                return false;
              }
            } else {
              const _symbolKeysB = objectGetOwnPropertySymbols(val2);

              if (_symbolKeysB.length !== 0 && getEnumerables(val2, _symbolKeysB).length !== 0) {
                return false;
              }
            }
          }

          if (aKeys.length === 0 && (iterationType === kNoIterator || iterationType === kIsArray && val1.length === 0 || val1.size === 0)) {
            return true;
          } // Use memos to handle cycles.

          if (memos === undefined) {
            memos = {
              val1: new Map(),
              val2: new Map(),
              position: 0,
            };
          } else {
            // We prevent up to two map.has(x) calls by directly retrieving the value
            // and checking for undefined. The map can only contain numbers, so it is
            // safe to check for undefined only.
            const val2MemoA = memos.val1.get(val1);

            if (val2MemoA !== undefined) {
              const val2MemoB = memos.val2.get(val2);

              if (val2MemoB !== undefined) {
                return val2MemoA === val2MemoB;
              }
            }

            memos.position++;
          }

          memos.val1.set(val1, memos.position);
          memos.val2.set(val2, memos.position);
          const areEq = objEquiv(val1, val2, strict, aKeys, memos, iterationType);
          memos.val1.delete(val1);
          memos.val2.delete(val2);
          return areEq;
        }

        function setHasEqualElement(set, val1, strict, memo) {
          // Go looking.
          const setValues = arrayFromSet(set);

          for (let i = 0; i < setValues.length; i++) {
            const val2 = setValues[i];

            if (innerDeepEqual(val1, val2, strict, memo)) {
              // Remove the matching element to make sure we do not check that again.
              set.delete(val2);
              return true;
            }
          }

          return false;
        } // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
        // Sadly it is not possible to detect corresponding values properly in case the
        // type is a string, number, bigint or boolean. The reason is that those values
        // can match lots of different string values (e.g., 1n == '+00001').

        function findLooseMatchingPrimitives(prim) {
          switch (_typeof(prim)) {
            case 'undefined':
              return null;

            case 'object':
              // Only pass in null as object!
              return undefined;

            case 'symbol':
              return false;

            case 'string':
              prim = +prim;
              // Loose equal entries exist only if the string is possible to convert to
              // a regular number and not NaN.
              // Fall through

            case 'number':
              if (numberIsNaN(prim)) {
                return false;
              }
          }

          return true;
        }

        function setMightHaveLoosePrim(a, b, prim) {
          const altValue = findLooseMatchingPrimitives(prim);
          if (altValue != null) return altValue;
          return b.has(altValue) && !a.has(altValue);
        }

        function mapMightHaveLoosePrim(a, b, prim, item, memo) {
          const altValue = findLooseMatchingPrimitives(prim);

          if (altValue != null) {
            return altValue;
          }

          const curB = b.get(altValue);

          if (curB === undefined && !b.has(altValue) || !innerDeepEqual(item, curB, false, memo)) {
            return false;
          }

          return !a.has(altValue) && innerDeepEqual(item, curB, false, memo);
        }

        function setEquiv(a, b, strict, memo) {
          // This is a lazily initiated Set of entries which have to be compared
          // pairwise.
          let set = null;
          const aValues = arrayFromSet(a);

          for (let i = 0; i < aValues.length; i++) {
            const val = aValues[i]; // Note: Checking for the objects first improves the performance for object
            // heavy sets but it is a minor slow down for primitives. As they are fast
            // to check this improves the worst case scenario instead.

            if (_typeof(val) === 'object' && val !== null) {
              if (set === null) {
                set = new Set();
              } // If the specified value doesn't exist in the second set its an not null
              // object (or non strict only: a not matching primitive) we'll need to go
              // hunting for something thats deep-(strict-)equal to it. To make this
              // O(n log n) complexity we have to copy these values in a new set first.

              set.add(val);
            } else if (!b.has(val)) {
              if (strict) return false; // Fast path to detect missing string, symbol, undefined and null values.

              if (!setMightHaveLoosePrim(a, b, val)) {
                return false;
              }

              if (set === null) {
                set = new Set();
              }

              set.add(val);
            }
          }

          if (set !== null) {
            const bValues = arrayFromSet(b);

            for (let _i = 0; _i < bValues.length; _i++) {
              const _val = bValues[_i]; // We have to check if a primitive value is already
              // matching and only if it's not, go hunting for it.

              if (_typeof(_val) === 'object' && _val !== null) {
                if (!setHasEqualElement(set, _val, strict, memo)) return false;
              } else if (!strict && !a.has(_val) && !setHasEqualElement(set, _val, strict, memo)) {
                return false;
              }
            }

            return set.size === 0;
          }

          return true;
        }

        function mapHasEqualEntry(set, map, key1, item1, strict, memo) {
          // To be able to handle cases like:
          //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
          // ... we need to consider *all* matching keys, not just the first we find.
          const setValues = arrayFromSet(set);

          for (let i = 0; i < setValues.length; i++) {
            const key2 = setValues[i];

            if (innerDeepEqual(key1, key2, strict, memo) && innerDeepEqual(item1, map.get(key2), strict, memo)) {
              set.delete(key2);
              return true;
            }
          }

          return false;
        }

        function mapEquiv(a, b, strict, memo) {
          let set = null;
          const aEntries = arrayFromMap(a);

          for (let i = 0; i < aEntries.length; i++) {
            const _aEntries$i = _slicedToArray(aEntries[i], 2);
            var key = _aEntries$i[0];
            const item1 = _aEntries$i[1];

            if (_typeof(key) === 'object' && key !== null) {
              if (set === null) {
                set = new Set();
              }

              set.add(key);
            } else {
              // By directly retrieving the value we prevent another b.has(key) check in
              // almost all possible cases.
              const item2 = b.get(key);

              if (item2 === undefined && !b.has(key) || !innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false; // Fast path to detect missing string, symbol, undefined and null
                // keys.

                if (!mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;

                if (set === null) {
                  set = new Set();
                }

                set.add(key);
              }
            }
          }

          if (set !== null) {
            const bEntries = arrayFromMap(b);

            for (let _i2 = 0; _i2 < bEntries.length; _i2++) {
              const _bEntries$_i = _slicedToArray(bEntries[_i2], 2);
              var key = _bEntries$_i[0];
              const item = _bEntries$_i[1];

              if (_typeof(key) === 'object' && key !== null) {
                if (!mapHasEqualEntry(set, a, key, item, strict, memo)) return false;
              } else if (!strict && (!a.has(key) || !innerDeepEqual(a.get(key), item, false, memo)) && !mapHasEqualEntry(set, a, key, item, false, memo)) {
                return false;
              }
            }

            return set.size === 0;
          }

          return true;
        }

        function objEquiv(a, b, strict, keys, memos, iterationType) {
          // Sets and maps don't have their entries accessible via normal object
          // properties.
          let i = 0;

          if (iterationType === kIsSet) {
            if (!setEquiv(a, b, strict, memos)) {
              return false;
            }
          } else if (iterationType === kIsMap) {
            if (!mapEquiv(a, b, strict, memos)) {
              return false;
            }
          } else if (iterationType === kIsArray) {
            for (; i < a.length; i++) {
              if (hasOwnProperty(a, i)) {
                if (!hasOwnProperty(b, i) || !innerDeepEqual(a[i], b[i], strict, memos)) {
                  return false;
                }
              } else if (hasOwnProperty(b, i)) {
                return false;
              } else {
                // Array is sparse.
                const keysA = Object.keys(a);

                for (; i < keysA.length; i++) {
                  const key = keysA[i];

                  if (!hasOwnProperty(b, key) || !innerDeepEqual(a[key], b[key], strict, memos)) {
                    return false;
                  }
                }

                if (keysA.length !== Object.keys(b).length) {
                  return false;
                }

                return true;
              }
            }
          } // The pair must have equivalent values for every corresponding key.
          // Possibly expensive deep test:

          for (i = 0; i < keys.length; i++) {
            const _key = keys[i];

            if (!innerDeepEqual(a[_key], b[_key], strict, memos)) {
              return false;
            }
          }

          return true;
        }

        function isDeepEqual(val1, val2) {
          return innerDeepEqual(val1, val2, kLoose);
        }

        function isDeepStrictEqual(val1, val2) {
          return innerDeepEqual(val1, val2, kStrict);
        }

        module.exports = {
          isDeepEqual,
          isDeepStrictEqual,
        };
        /***/ }),

      /***/ 2055:
      /***/ (function (__unused_webpack_module, exports) {
        // The following break classes are handled by the pair table
        exports.OP = 0; // Opening punctuation

        exports.CL = 1; // Closing punctuation

        exports.CP = 2; // Closing parenthesis

        exports.QU = 3; // Ambiguous quotation

        exports.GL = 4; // Glue

        exports.NS = 5; // Non-starters

        exports.EX = 6; // Exclamation/Interrogation

        exports.SY = 7; // Symbols allowing break after

        exports.IS = 8; // Infix separator

        exports.PR = 9; // Prefix

        exports.PO = 10; // Postfix

        exports.NU = 11; // Numeric

        exports.AL = 12; // Alphabetic

        exports.HL = 13; // Hebrew Letter

        exports.ID = 14; // Ideographic

        exports.IN = 15; // Inseparable characters

        exports.HY = 16; // Hyphen

        exports.BA = 17; // Break after

        exports.BB = 18; // Break before

        exports.B2 = 19; // Break on either side (but not pair)

        exports.ZW = 20; // Zero-width space

        exports.CM = 21; // Combining marks

        exports.WJ = 22; // Word joiner

        exports.H2 = 23; // Hangul LV

        exports.H3 = 24; // Hangul LVT

        exports.JL = 25; // Hangul L Jamo

        exports.JV = 26; // Hangul V Jamo

        exports.JT = 27; // Hangul T Jamo

        exports.RI = 28; // Regional Indicator

        exports.EB = 29; // Emoji Base

        exports.EM = 30; // Emoji Modifier

        exports.ZWJ = 31; // Zero Width Joiner

        exports.CB = 32; // Contingent break
        // The following break classes are not handled by the pair table

        exports.AI = 33; // Ambiguous (Alphabetic or Ideograph)

        exports.BK = 34; // Break (mandatory)

        exports.CJ = 35; // Conditional Japanese Starter

        exports.CR = 36; // Carriage return

        exports.LF = 37; // Line feed

        exports.NL = 38; // Next line

        exports.SA = 39; // South-East Asian

        exports.SG = 40; // Surrogates

        exports.SP = 41; // Space

        exports.XX = 42; // Unknown
        /***/ }),

      /***/ 8383:
      /***/ (function (__unused_webpack_module, exports) {
        let CI_BRK; let CP_BRK; let DI_BRK; let IN_BRK; let
          PR_BRK;
        exports.DI_BRK = DI_BRK = 0; // Direct break opportunity

        exports.IN_BRK = IN_BRK = 1; // Indirect break opportunity

        exports.CI_BRK = CI_BRK = 2; // Indirect break opportunity for combining marks

        exports.CP_BRK = CP_BRK = 3; // Prohibited break for combining marks

        exports.PR_BRK = PR_BRK = 4; // Prohibited break
        // Based on example pair table from https://www.unicode.org/reports/tr14/tr14-37.html#Table2
        // - ZWJ special processing for LB8a of Revision 41
        // - CB manually added as per Rule LB20
        // - CL, CP, NS, SY, IS, PR, PO, HY, BA, B2 and RI manually adjusted as per LB22 of Revision 45

        exports.pairTable = [// OP   , CL    , CP    , QU    , GL    , NS    , EX    , SY    , IS    , PR    , PO    , NU    , AL    , HL    , ID    , IN    , HY    , BA    , BB    , B2    , ZW    , CM    , WJ    , H2    , H3    , JL    , JV    , JT    , RI    , EB    , EM    , ZWJ   , CB
          [PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, CP_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK], // OP
          [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], // CL
          [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], // CP
          [PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK], // QU
          [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK], // GL
          [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], // NS
          [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], // EX
          [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], // SY
          [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], // IS
          [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK], // PR
          [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], // PO
          [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], // NU
          [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], // AL
          [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], // HL
          [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], // ID
          [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], // IN
          [DI_BRK, PR_BRK, PR_BRK, IN_BRK, DI_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], // HY
          [DI_BRK, PR_BRK, PR_BRK, IN_BRK, DI_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], // BA
          [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK], // BB
          [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, PR_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], // B2
          [DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], // ZW
          [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], // CM
          [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK], // WJ
          [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], // H2
          [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], // H3
          [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], // JL
          [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], // JV
          [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], // JT
          [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], // RI
          [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK], // EB
          [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], // EM
          [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], // ZWJ
          [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, DI_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], // CB
        ];
        /***/ }),

      /***/ 5106:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        __webpack_require__(9601);

        exports.EncodeStream = __webpack_require__(9126);
        exports.DecodeStream = __webpack_require__(3030);
        exports.Array = __webpack_require__(1988);
        exports.LazyArray = __webpack_require__(6768);
        exports.Bitfield = __webpack_require__(3425);
        exports.Boolean = __webpack_require__(9024);
        exports.Buffer = __webpack_require__(5250);
        exports.Enum = __webpack_require__(3100);
        exports.Optional = __webpack_require__(9541);
        exports.Reserved = __webpack_require__(7468);
        exports.String = __webpack_require__(1466);
        exports.Struct = __webpack_require__(1219);
        exports.VersionedStruct = __webpack_require__(3585);

        const utils = __webpack_require__(6610);

        const NumberT = __webpack_require__(6462);

        const Pointer = __webpack_require__(8011);

        Object.assign(exports, utils, NumberT, Pointer);
        /***/ }),

      /***/ 1988:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        __webpack_require__(7042);

        __webpack_require__(1539);

        __webpack_require__(8309);

        __webpack_require__(1038);

        __webpack_require__(8783);

        __webpack_require__(4916);

        __webpack_require__(2526);

        __webpack_require__(1817);

        __webpack_require__(2165);

        __webpack_require__(6992);

        __webpack_require__(3948);

        function _createForOfIteratorHelperLoose(o, allowArrayLike) { let it = typeof Symbol !== 'undefined' && o[Symbol.iterator] || o['@@iterator']; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === 'number') { if (it) o = it; let i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError('Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'); }

        function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === 'string') return _arrayLikeToArray(o, minLen); let n = Object.prototype.toString.call(o).slice(8, -1); if (n === 'Object' && o.constructor) n = o.constructor.name; if (n === 'Map' || n === 'Set') return Array.from(o); if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

        function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

        const _require = __webpack_require__(6462);
        const NumberT = _require.Number;

        const utils = __webpack_require__(6610);

        const ArrayT = /* #__PURE__ */(function () {
          function ArrayT(type, length, lengthType) {
            if (lengthType === void 0) {
              lengthType = 'count';
            }

            this.type = type;
            this.length = length;
            this.lengthType = lengthType;
          }

          const _proto = ArrayT.prototype;

          _proto.decode = function decode(stream, parent) {
            let length;
            const { pos } = stream;
            const res = [];
            let ctx = parent;

            if (this.length != null) {
              length = utils.resolveLength(this.length, stream, parent);
            }

            if (this.length instanceof NumberT) {
              // define hidden properties
              Object.defineProperties(res, {
                parent: {
                  value: parent,
                },
                _startOffset: {
                  value: pos,
                },
                _currentOffset: {
                  value: 0,
                  writable: true,
                },
                _length: {
                  value: length,
                },
              });
              ctx = res;
            }

            if (length == null || this.lengthType === 'bytes') {
              const target = length != null ? stream.pos + length : (parent != null ? parent._length : undefined) ? parent._startOffset + parent._length : stream.length;

              while (stream.pos < target) {
                res.push(this.type.decode(stream, ctx));
              }
            } else {
              for (let i = 0, end = length; i < end; i++) {
                res.push(this.type.decode(stream, ctx));
              }
            }

            return res;
          };

          _proto.size = function size(array, ctx) {
            if (!array) {
              return this.type.size(null, ctx) * utils.resolveLength(this.length, null, ctx);
            }

            let size = 0;

            if (this.length instanceof NumberT) {
              size += this.length.size();
              ctx = {
                parent: ctx,
              };
            }

            for (var _iterator = _createForOfIteratorHelperLoose(array), _step; !(_step = _iterator()).done;) {
              const item = _step.value;
              size += this.type.size(item, ctx);
            }

            return size;
          };

          _proto.encode = function encode(stream, array, parent) {
            let ctx = parent;

            if (this.length instanceof NumberT) {
              ctx = {
                pointers: [],
                startOffset: stream.pos,
                parent,
              };
              ctx.pointerOffset = stream.pos + this.size(array, ctx);
              this.length.encode(stream, array.length);
            }

            for (var _iterator2 = _createForOfIteratorHelperLoose(array), _step2; !(_step2 = _iterator2()).done;) {
              const item = _step2.value;
              this.type.encode(stream, item, ctx);
            }

            if (this.length instanceof NumberT) {
              let i = 0;

              while (i < ctx.pointers.length) {
                const ptr = ctx.pointers[i++];
                ptr.type.encode(stream, ptr.val);
              }
            }
          };

          return ArrayT;
        }());

        module.exports = ArrayT;
        /***/ }),

      /***/ 3425:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        __webpack_require__(2087);

        const Bitfield = /* #__PURE__ */(function () {
          function Bitfield(type, flags) {
            if (flags === void 0) {
              flags = [];
            }

            this.type = type;
            this.flags = flags;
          }

          const _proto = Bitfield.prototype;

          _proto.decode = function decode(stream) {
            const val = this.type.decode(stream);
            const res = {};

            for (let i = 0; i < this.flags.length; i++) {
              const flag = this.flags[i];

              if (flag != null) {
                res[flag] = !!(val & 1 << i);
              }
            }

            return res;
          };

          _proto.size = function size() {
            return this.type.size();
          };

          _proto.encode = function encode(stream, keys) {
            let val = 0;

            for (let i = 0; i < this.flags.length; i++) {
              const flag = this.flags[i];

              if (flag != null) {
                if (keys[flag]) {
                  val |= 1 << i;
                }
              }
            }

            return this.type.encode(stream, val);
          };

          return Bitfield;
        }());

        module.exports = Bitfield;
        /***/ }),

      /***/ 9024:
      /***/ (function (module) {
        const BooleanT = /* #__PURE__ */(function () {
          function BooleanT(type) {
            this.type = type;
          }

          const _proto = BooleanT.prototype;

          _proto.decode = function decode(stream, parent) {
            return !!this.type.decode(stream, parent);
          };

          _proto.size = function size(val, parent) {
            return this.type.size(val, parent);
          };

          _proto.encode = function encode(stream, val, parent) {
            return this.type.encode(stream, +val, parent);
          };

          return BooleanT;
        }());

        module.exports = BooleanT;
        /***/ }),

      /***/ 5250:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const utils = __webpack_require__(6610);

        const _require = __webpack_require__(6462);
        const NumberT = _require.Number;

        const BufferT = /* #__PURE__ */(function () {
          function BufferT(length) {
            this.length = length;
          }

          const _proto = BufferT.prototype;

          _proto.decode = function decode(stream, parent) {
            const length = utils.resolveLength(this.length, stream, parent);
            return stream.readBuffer(length);
          };

          _proto.size = function size(val, parent) {
            if (!val) {
              return utils.resolveLength(this.length, null, parent);
            }

            return val.length;
          };

          _proto.encode = function encode(stream, buf, parent) {
            if (this.length instanceof NumberT) {
              this.length.encode(stream, buf.length);
            }

            return stream.writeBuffer(buf);
          };

          return BufferT;
        }());

        module.exports = BufferT;
        /***/ }),

      /***/ 3030:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* provided dependency */ const { Buffer } = __webpack_require__(8823);

        __webpack_require__(1539);

        __webpack_require__(9714);

        __webpack_require__(7042);

        __webpack_require__(4916);

        __webpack_require__(5306);

        let iconv;

        try {
          iconv = __webpack_require__(4914);
        } catch (error) {}

        const DecodeStream = /* #__PURE__ */(function () {
          function DecodeStream(buffer) {
            this.buffer = buffer;
            this.pos = 0;
            this.length = this.buffer.length;
          }

          const _proto = DecodeStream.prototype;

          _proto.readString = function readString(length, encoding) {
            if (encoding === void 0) {
              encoding = 'ascii';
            }

            switch (encoding) {
              case 'utf16le':
              case 'ucs2':
              case 'utf8':
              case 'ascii':
                return this.buffer.toString(encoding, this.pos, this.pos += length);

              case 'utf16be':
                var buf = Buffer.from(this.readBuffer(length)); // swap the bytes

                for (let i = 0, end = buf.length - 1; i < end; i += 2) {
                  const byte = buf[i];
                  buf[i] = buf[i + 1];
                  buf[i + 1] = byte;
                }

                return buf.toString('utf16le');

              default:
                buf = this.readBuffer(length);

                if (iconv) {
                  try {
                    return iconv.decode(buf, encoding);
                  } catch (error1) {}
                }

                return buf;
            }
          };

          _proto.readBuffer = function readBuffer(length) {
            return this.buffer.slice(this.pos, this.pos += length);
          };

          _proto.readUInt24BE = function readUInt24BE() {
            return (this.readUInt16BE() << 8) + this.readUInt8();
          };

          _proto.readUInt24LE = function readUInt24LE() {
            return this.readUInt16LE() + (this.readUInt8() << 16);
          };

          _proto.readInt24BE = function readInt24BE() {
            return (this.readInt16BE() << 8) + this.readUInt8();
          };

          _proto.readInt24LE = function readInt24LE() {
            return this.readUInt16LE() + (this.readInt8() << 16);
          };

          return DecodeStream;
        }());

        DecodeStream.TYPES = {
          UInt8: 1,
          UInt16: 2,
          UInt24: 3,
          UInt32: 4,
          Int8: 1,
          Int16: 2,
          Int24: 3,
          Int32: 4,
          Float: 4,
          Double: 8,
        };

        const _loop = function _loop(key) {
          if (key.slice(0, 4) === 'read') {
            const bytes = DecodeStream.TYPES[key.replace(/read|[BL]E/g, '')];

            DecodeStream.prototype[key] = function () {
              const ret = this.buffer[key](this.pos);
              this.pos += bytes;
              return ret;
            };
          }
        };

        for (const key in Buffer.prototype) {
          _loop(key);
        }

        module.exports = DecodeStream;
        /***/ }),

      /***/ 9126:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* provided dependency */ const { Buffer } = __webpack_require__(8823);

        __webpack_require__(7042);

        __webpack_require__(3290);

        __webpack_require__(4916);

        __webpack_require__(5306);

        function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

        function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

        let iconv;

        const stream = __webpack_require__(2830);

        const DecodeStream = __webpack_require__(3030);

        try {
          iconv = __webpack_require__(4914);
        } catch (error) {}

        const EncodeStream = /* #__PURE__ */(function (_stream$Readable) {
          _inheritsLoose(EncodeStream, _stream$Readable);

          function EncodeStream(bufferSize) {
            let _this;

            if (bufferSize === void 0) {
              bufferSize = 65536;
            }

            _this = _stream$Readable.apply(this, arguments) || this;
            _this.buffer = Buffer.alloc(bufferSize);
            _this.bufferOffset = 0;
            _this.pos = 0;
            return _this;
          } // do nothing, required by node

          const _proto = EncodeStream.prototype;

          _proto._read = function _read() {};

          _proto.ensure = function ensure(bytes) {
            if (this.bufferOffset + bytes > this.buffer.length) {
              return this.flush();
            }
          };

          _proto.flush = function flush() {
            if (this.bufferOffset > 0) {
              this.push(Buffer.from(this.buffer.slice(0, this.bufferOffset)));
              return this.bufferOffset = 0;
            }
          };

          _proto.writeBuffer = function writeBuffer(buffer) {
            this.flush();
            this.push(buffer);
            return this.pos += buffer.length;
          };

          _proto.writeString = function writeString(string, encoding) {
            if (encoding === void 0) {
              encoding = 'ascii';
            }

            switch (encoding) {
              case 'utf16le':
              case 'ucs2':
              case 'utf8':
              case 'ascii':
                return this.writeBuffer(Buffer.from(string, encoding));

              case 'utf16be':
                var buf = Buffer.from(string, 'utf16le'); // swap the bytes

                for (let i = 0, end = buf.length - 1; i < end; i += 2) {
                  const byte = buf[i];
                  buf[i] = buf[i + 1];
                  buf[i + 1] = byte;
                }

                return this.writeBuffer(buf);

              default:
                if (iconv) {
                  return this.writeBuffer(iconv.encode(string, encoding));
                }
                throw new Error('Install iconv-lite to enable additional string encodings.');
            }
          };

          _proto.writeUInt24BE = function writeUInt24BE(val) {
            this.ensure(3);
            this.buffer[this.bufferOffset++] = val >>> 16 & 0xff;
            this.buffer[this.bufferOffset++] = val >>> 8 & 0xff;
            this.buffer[this.bufferOffset++] = val & 0xff;
            return this.pos += 3;
          };

          _proto.writeUInt24LE = function writeUInt24LE(val) {
            this.ensure(3);
            this.buffer[this.bufferOffset++] = val & 0xff;
            this.buffer[this.bufferOffset++] = val >>> 8 & 0xff;
            this.buffer[this.bufferOffset++] = val >>> 16 & 0xff;
            return this.pos += 3;
          };

          _proto.writeInt24BE = function writeInt24BE(val) {
            if (val >= 0) {
              return this.writeUInt24BE(val);
            }
            return this.writeUInt24BE(val + 0xffffff + 1);
          };

          _proto.writeInt24LE = function writeInt24LE(val) {
            if (val >= 0) {
              return this.writeUInt24LE(val);
            }
            return this.writeUInt24LE(val + 0xffffff + 1);
          };

          _proto.fill = function fill(val, length) {
            if (length < this.buffer.length) {
              this.ensure(length);
              this.buffer.fill(val, this.bufferOffset, this.bufferOffset + length);
              this.bufferOffset += length;
              return this.pos += length;
            }
            const buf = Buffer.alloc(length);
            buf.fill(val);
            return this.writeBuffer(buf);
          };

          _proto.end = function end() {
            this.flush();
            return this.push(null);
          };

          return EncodeStream;
        }(stream.Readable));

        const _loop = function _loop(key) {
          if (key.slice(0, 5) === 'write') {
            const bytes = +DecodeStream.TYPES[key.replace(/write|[BL]E/g, '')];

            EncodeStream.prototype[key] = function (value) {
              this.ensure(bytes);
              this.buffer[key](value, this.bufferOffset);
              this.bufferOffset += bytes;
              return this.pos += bytes;
            };
          }
        };

        for (const key in Buffer.prototype) {
          _loop(key);
        }

        module.exports = EncodeStream;
        /***/ }),

      /***/ 3100:
      /***/ (function (module) {
        const Enum = /* #__PURE__ */(function () {
          function Enum(type, options) {
            if (options === void 0) {
              options = [];
            }

            this.type = type;
            this.options = options;
          }

          const _proto = Enum.prototype;

          _proto.decode = function decode(stream) {
            const index = this.type.decode(stream);
            return this.options[index] || index;
          };

          _proto.size = function size() {
            return this.type.size();
          };

          _proto.encode = function encode(stream, val) {
            const index = this.options.indexOf(val);

            if (index === -1) {
              throw new Error(`Unknown option in enum: ${val}`);
            }

            return this.type.encode(stream, index);
          };

          return Enum;
        }());

        module.exports = Enum;
        /***/ }),

      /***/ 6768:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        __webpack_require__(1539);

        __webpack_require__(8674);

        function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

        function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

        const ArrayT = __webpack_require__(1988);

        const _require = __webpack_require__(6462);
        const NumberT = _require.Number;

        const utils = __webpack_require__(6610);

        const _require2 = __webpack_require__(9539);
        const _inspect = _require2.inspect;

        const LazyArrayT = /* #__PURE__ */(function (_ArrayT) {
          _inheritsLoose(LazyArrayT, _ArrayT);

          function LazyArrayT() {
            return _ArrayT.apply(this, arguments) || this;
          }

          const _proto = LazyArrayT.prototype;

          _proto.decode = function decode(stream, parent) {
            const { pos } = stream;
            const length = utils.resolveLength(this.length, stream, parent);

            if (this.length instanceof NumberT) {
              parent = {
                parent,
                _startOffset: pos,
                _currentOffset: 0,
                _length: length,
              };
            }

            const res = new LazyArray(this.type, length, stream, parent);
            stream.pos += length * this.type.size(null, parent);
            return res;
          };

          _proto.size = function size(val, ctx) {
            if (val instanceof LazyArray) {
              val = val.toArray();
            }

            return _ArrayT.prototype.size.call(this, val, ctx);
          };

          _proto.encode = function encode(stream, val, ctx) {
            if (val instanceof LazyArray) {
              val = val.toArray();
            }

            return _ArrayT.prototype.encode.call(this, stream, val, ctx);
          };

          return LazyArrayT;
        }(ArrayT));

        var LazyArray = /* #__PURE__ */(function () {
          function LazyArray(type, length, stream, ctx) {
            this.type = type;
            this.length = length;
            this.stream = stream;
            this.ctx = ctx;
            this.base = this.stream.pos;
            this.items = [];
          }

          const _proto2 = LazyArray.prototype;

          _proto2.get = function get(index) {
            if (index < 0 || index >= this.length) {
              return undefined;
            }

            if (this.items[index] == null) {
              const { pos } = this.stream;
              this.stream.pos = this.base + this.type.size(null, this.ctx) * index;
              this.items[index] = this.type.decode(this.stream, this.ctx);
              this.stream.pos = pos;
            }

            return this.items[index];
          };

          _proto2.toArray = function toArray() {
            const result = [];

            for (let i = 0, end = this.length; i < end; i++) {
              result.push(this.get(i));
            }

            return result;
          };

          _proto2.inspect = function inspect() {
            return _inspect(this.toArray());
          };

          return LazyArray;
        }());

        module.exports = LazyArrayT;
        /***/ }),

      /***/ 6462:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

        function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

        const DecodeStream = __webpack_require__(3030);

        const NumberT = /* #__PURE__ */(function () {
          function NumberT(type, endian) {
            if (endian === void 0) {
              endian = 'BE';
            }

            this.type = type;
            this.endian = endian;
            this.fn = this.type;

            if (this.type[this.type.length - 1] !== '8') {
              this.fn += this.endian;
            }
          }

          const _proto = NumberT.prototype;

          _proto.size = function size() {
            return DecodeStream.TYPES[this.type];
          };

          _proto.decode = function decode(stream) {
            return stream[`read${this.fn}`]();
          };

          _proto.encode = function encode(stream, val) {
            return stream[`write${this.fn}`](val);
          };

          return NumberT;
        }());

        exports.Number = NumberT;
        exports.uint8 = new NumberT('UInt8');
        exports.uint16be = exports.uint16 = new NumberT('UInt16', 'BE');
        exports.uint16le = new NumberT('UInt16', 'LE');
        exports.uint24be = exports.uint24 = new NumberT('UInt24', 'BE');
        exports.uint24le = new NumberT('UInt24', 'LE');
        exports.uint32be = exports.uint32 = new NumberT('UInt32', 'BE');
        exports.uint32le = new NumberT('UInt32', 'LE');
        exports.int8 = new NumberT('Int8');
        exports.int16be = exports.int16 = new NumberT('Int16', 'BE');
        exports.int16le = new NumberT('Int16', 'LE');
        exports.int24be = exports.int24 = new NumberT('Int24', 'BE');
        exports.int24le = new NumberT('Int24', 'LE');
        exports.int32be = exports.int32 = new NumberT('Int32', 'BE');
        exports.int32le = new NumberT('Int32', 'LE');
        exports.floatbe = exports.float = new NumberT('Float', 'BE');
        exports.floatle = new NumberT('Float', 'LE');
        exports.doublebe = exports.double = new NumberT('Double', 'BE');
        exports.doublele = new NumberT('Double', 'LE');

        const Fixed = /* #__PURE__ */(function (_NumberT) {
          _inheritsLoose(Fixed, _NumberT);

          function Fixed(size, endian, fracBits) {
            let _this;

            if (fracBits === void 0) {
              fracBits = size >> 1;
            }

            _this = _NumberT.call(this, `Int${size}`, endian) || this;
            _this._point = 1 << fracBits;
            return _this;
          }

          const _proto2 = Fixed.prototype;

          _proto2.decode = function decode(stream) {
            return _NumberT.prototype.decode.call(this, stream) / this._point;
          };

          _proto2.encode = function encode(stream, val) {
            return _NumberT.prototype.encode.call(this, stream, val * this._point | 0);
          };

          return Fixed;
        }(NumberT));

        exports.Fixed = Fixed;
        exports.fixed16be = exports.fixed16 = new Fixed(16, 'BE');
        exports.fixed16le = new Fixed(16, 'LE');
        exports.fixed32be = exports.fixed32 = new Fixed(32, 'BE');
        exports.fixed32le = new Fixed(32, 'LE');
        /***/ }),

      /***/ 9541:
      /***/ (function (module) {
        const Optional = /* #__PURE__ */(function () {
          function Optional(type, condition) {
            if (condition === void 0) {
              condition = true;
            }

            this.type = type;
            this.condition = condition;
          }

          const _proto = Optional.prototype;

          _proto.decode = function decode(stream, parent) {
            let { condition } = this;

            if (typeof condition === 'function') {
              condition = condition.call(parent, parent);
            }

            if (condition) {
              return this.type.decode(stream, parent);
            }
          };

          _proto.size = function size(val, parent) {
            let { condition } = this;

            if (typeof condition === 'function') {
              condition = condition.call(parent, parent);
            }

            if (condition) {
              return this.type.size(val, parent);
            }
            return 0;
          };

          _proto.encode = function encode(stream, val, parent) {
            let { condition } = this;

            if (typeof condition === 'function') {
              condition = condition.call(parent, parent);
            }

            if (condition) {
              return this.type.encode(stream, val, parent);
            }
          };

          return Optional;
        }());

        module.exports = Optional;
        /***/ }),

      /***/ 8011:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        const utils = __webpack_require__(6610);

        const Pointer = /* #__PURE__ */(function () {
          function Pointer(offsetType, type, options) {
            if (options === void 0) {
              options = {};
            }

            this.offsetType = offsetType;
            this.type = type;
            this.options = options;

            if (this.type === 'void') {
              this.type = null;
            }

            if (this.options.type == null) {
              this.options.type = 'local';
            }

            if (this.options.allowNull == null) {
              this.options.allowNull = true;
            }

            if (this.options.nullValue == null) {
              this.options.nullValue = 0;
            }

            if (this.options.lazy == null) {
              this.options.lazy = false;
            }

            if (this.options.relativeTo) {
              if (typeof this.options.relativeTo !== 'function') {
                throw new Error('relativeTo option must be a function');
              }

              this.relativeToGetter = options.relativeTo;
            }
          }

          const _proto = Pointer.prototype;

          _proto.decode = function decode(stream, ctx) {
            const _this = this;

            const offset = this.offsetType.decode(stream, ctx); // handle NULL pointers

            if (offset === this.options.nullValue && this.options.allowNull) {
              return null;
            }

            let relative;

            switch (this.options.type) {
              case 'local':
                relative = ctx._startOffset;
                break;

              case 'immediate':
                relative = stream.pos - this.offsetType.size();
                break;

              case 'parent':
                relative = ctx.parent._startOffset;
                break;

              default:
                var c = ctx;

                while (c.parent) {
                  c = c.parent;
                }

                relative = c._startOffset || 0;
            }

            if (this.options.relativeTo) {
              relative += this.relativeToGetter(ctx);
            }

            const ptr = offset + relative;

            if (this.type != null) {
              let val = null;

              const decodeValue = function decodeValue() {
                if (val != null) {
                  return val;
                }

                const { pos } = stream;
                stream.pos = ptr;
                val = _this.type.decode(stream, ctx);
                stream.pos = pos;
                return val;
              }; // If this is a lazy pointer, define a getter to decode only when needed.
              // This obviously only works when the pointer is contained by a Struct.

              if (this.options.lazy) {
                return new utils.PropertyDescriptor({
                  get: decodeValue,
                });
              }

              return decodeValue();
            }
            return ptr;
          };

          _proto.size = function size(val, ctx) {
            const parent = ctx;

            switch (this.options.type) {
              case 'local':
              case 'immediate':
                break;

              case 'parent':
                ctx = ctx.parent;
                break;

              default:
                // global
                while (ctx.parent) {
                  ctx = ctx.parent;
                }
            }

            let { type } = this;

            if (type == null) {
              if (!(val instanceof VoidPointer)) {
                throw new Error('Must be a VoidPointer');
              }

              const _val = val;
              type = _val.type;
              val = val.value;
            }

            if (val && ctx) {
              ctx.pointerSize += type.size(val, parent);
            }

            return this.offsetType.size();
          };

          _proto.encode = function encode(stream, val, ctx) {
            let relative;
            const parent = ctx;

            if (val == null) {
              this.offsetType.encode(stream, this.options.nullValue);
              return;
            }

            switch (this.options.type) {
              case 'local':
                relative = ctx.startOffset;
                break;

              case 'immediate':
                relative = stream.pos + this.offsetType.size(val, parent);
                break;

              case 'parent':
                ctx = ctx.parent;
                relative = ctx.startOffset;
                break;

              default:
                // global
                relative = 0;

                while (ctx.parent) {
                  ctx = ctx.parent;
                }
            }

            if (this.options.relativeTo) {
              relative += this.relativeToGetter(parent.val);
            }

            this.offsetType.encode(stream, ctx.pointerOffset - relative);
            let { type } = this;

            if (type == null) {
              if (!(val instanceof VoidPointer)) {
                throw new Error('Must be a VoidPointer');
              }

              const _val2 = val;
              type = _val2.type;
              val = val.value;
            }

            ctx.pointers.push({
              type,
              val,
              parent,
            });
            return ctx.pointerOffset += type.size(val, parent);
          };

          return Pointer;
        }()); // A pointer whose type is determined at decode time

        var VoidPointer = function VoidPointer(type, value) {
          this.type = type;
          this.value = value;
        };

        exports.Pointer = Pointer;
        exports.VoidPointer = VoidPointer;
        /***/ }),

      /***/ 7468:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        __webpack_require__(3290);

        const utils = __webpack_require__(6610);

        const Reserved = /* #__PURE__ */(function () {
          function Reserved(type, count) {
            if (count === void 0) {
              count = 1;
            }

            this.type = type;
            this.count = count;
          }

          const _proto = Reserved.prototype;

          _proto.decode = function decode(stream, parent) {
            stream.pos += this.size(null, parent);
            return undefined;
          };

          _proto.size = function size(data, parent) {
            const count = utils.resolveLength(this.count, null, parent);
            return this.type.size() * count;
          };

          _proto.encode = function encode(stream, val, parent) {
            return stream.fill(0, this.size(val, parent));
          };

          return Reserved;
        }());

        module.exports = Reserved;
        /***/ }),

      /***/ 1466:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* provided dependency */ const { Buffer } = __webpack_require__(8823);

        const _require = __webpack_require__(6462);
        const NumberT = _require.Number;

        const utils = __webpack_require__(6610);

        const StringT = /* #__PURE__ */(function () {
          function StringT(length, encoding) {
            if (encoding === void 0) {
              encoding = 'ascii';
            }

            this.length = length;
            this.encoding = encoding;
          }

          const _proto = StringT.prototype;

          _proto.decode = function decode(stream, parent) {
            let length; let
              pos;

            if (this.length != null) {
              length = utils.resolveLength(this.length, stream, parent);
            } else {
              let buffer;
              buffer = stream.buffer;
              length = stream.length;
              pos = stream.pos;

              while (pos < length && buffer[pos] !== 0x00) {
                ++pos;
              }

              length = pos - stream.pos;
            }

            let { encoding } = this;

            if (typeof encoding === 'function') {
              encoding = encoding.call(parent, parent) || 'ascii';
            }

            const string = stream.readString(length, encoding);

            if (this.length == null && stream.pos < stream.length) {
              stream.pos++;
            }

            return string;
          };

          _proto.size = function size(val, parent) {
            // Use the defined value if no value was given
            if (!val) {
              return utils.resolveLength(this.length, null, parent);
            }

            let { encoding } = this;

            if (typeof encoding === 'function') {
              encoding = encoding.call(parent != null ? parent.val : undefined, parent != null ? parent.val : undefined) || 'ascii';
            }

            if (encoding === 'utf16be') {
              encoding = 'utf16le';
            }

            let size = Buffer.byteLength(val, encoding);

            if (this.length instanceof NumberT) {
              size += this.length.size();
            }

            if (this.length == null) {
              size++;
            }

            return size;
          };

          _proto.encode = function encode(stream, val, parent) {
            let { encoding } = this;

            if (typeof encoding === 'function') {
              encoding = encoding.call(parent != null ? parent.val : undefined, parent != null ? parent.val : undefined) || 'ascii';
            }

            if (this.length instanceof NumberT) {
              this.length.encode(stream, Buffer.byteLength(val, encoding));
            }

            stream.writeString(val, encoding);

            if (this.length == null) {
              return stream.writeUInt8(0x00);
            }
          };

          return StringT;
        }());

        module.exports = StringT;
        /***/ }),

      /***/ 1219:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const utils = __webpack_require__(6610);

        const Struct = /* #__PURE__ */(function () {
          function Struct(fields) {
            if (fields === void 0) {
              fields = {};
            }

            this.fields = fields;
          }

          const _proto = Struct.prototype;

          _proto.decode = function decode(stream, parent, length) {
            if (length === void 0) {
              length = 0;
            }

            const res = this._setup(stream, parent, length);

            this._parseFields(stream, res, this.fields);

            if (this.process != null) {
              this.process.call(res, stream);
            }

            return res;
          };

          _proto._setup = function _setup(stream, parent, length) {
            const res = {}; // define hidden properties

            Object.defineProperties(res, {
              parent: {
                value: parent,
              },
              _startOffset: {
                value: stream.pos,
              },
              _currentOffset: {
                value: 0,
                writable: true,
              },
              _length: {
                value: length,
              },
            });
            return res;
          };

          _proto._parseFields = function _parseFields(stream, res, fields) {
            for (const key in fields) {
              var val;
              const type = fields[key];

              if (typeof type === 'function') {
                val = type.call(res, res);
              } else {
                val = type.decode(stream, res);
              }

              if (val !== undefined) {
                if (val instanceof utils.PropertyDescriptor) {
                  Object.defineProperty(res, key, val);
                } else {
                  res[key] = val;
                }
              }

              res._currentOffset = stream.pos - res._startOffset;
            }
          };

          _proto.size = function size(val, parent, includePointers) {
            if (val == null) {
              val = {};
            }

            if (includePointers == null) {
              includePointers = true;
            }

            const ctx = {
              parent,
              val,
              pointerSize: 0,
            };
            let size = 0;

            for (const key in this.fields) {
              const type = this.fields[key];

              if (type.size != null) {
                size += type.size(val[key], ctx);
              }
            }

            if (includePointers) {
              size += ctx.pointerSize;
            }

            return size;
          };

          _proto.encode = function encode(stream, val, parent) {
            let type;

            if (this.preEncode != null) {
              this.preEncode.call(val, stream);
            }

            const ctx = {
              pointers: [],
              startOffset: stream.pos,
              parent,
              val,
              pointerSize: 0,
            };
            ctx.pointerOffset = stream.pos + this.size(val, ctx, false);

            for (const key in this.fields) {
              type = this.fields[key];

              if (type.encode != null) {
                type.encode(stream, val[key], ctx);
              }
            }

            let i = 0;

            while (i < ctx.pointers.length) {
              const ptr = ctx.pointers[i++];
              ptr.type.encode(stream, ptr.val, ptr.parent);
            }
          };

          return Struct;
        }());

        module.exports = Struct;
        /***/ }),

      /***/ 3585:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        __webpack_require__(1539);

        __webpack_require__(4916);

        __webpack_require__(3123);

        function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

        function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

        const Struct = __webpack_require__(1219);

        const getPath = function getPath(object, pathArray) {
          return pathArray.reduce((prevObj, key) => prevObj && prevObj[key], object);
        };

        const VersionedStruct = /* #__PURE__ */(function (_Struct) {
          _inheritsLoose(VersionedStruct, _Struct);

          function VersionedStruct(type, versions) {
            let _this;

            if (versions === void 0) {
              versions = {};
            }

            _this = _Struct.call(this) || this;
            _this.type = type;
            _this.versions = versions;

            if (typeof type === 'string') {
              _this.versionPath = type.split('.');
            }

            return _this;
          }

          const _proto = VersionedStruct.prototype;

          _proto.decode = function decode(stream, parent, length) {
            if (length === void 0) {
              length = 0;
            }

            const res = this._setup(stream, parent, length);

            if (typeof this.type === 'string') {
              res.version = getPath(parent, this.versionPath);
            } else {
              res.version = this.type.decode(stream);
            }

            if (this.versions.header) {
              this._parseFields(stream, res, this.versions.header);
            }

            const fields = this.versions[res.version];

            if (fields == null) {
              throw new Error(`Unknown version ${res.version}`);
            }

            if (fields instanceof VersionedStruct) {
              return fields.decode(stream, parent);
            }

            this._parseFields(stream, res, fields);

            if (this.process != null) {
              this.process.call(res, stream);
            }

            return res;
          };

          _proto.size = function size(val, parent, includePointers) {
            if (includePointers === void 0) {
              includePointers = true;
            }

            let key; let
              type;

            if (!val) {
              throw new Error('Not a fixed size');
            }

            const ctx = {
              parent,
              val,
              pointerSize: 0,
            };
            let size = 0;

            if (typeof this.type !== 'string') {
              size += this.type.size(val.version, ctx);
            }

            if (this.versions.header) {
              for (key in this.versions.header) {
                type = this.versions.header[key];

                if (type.size != null) {
                  size += type.size(val[key], ctx);
                }
              }
            }

            const fields = this.versions[val.version];

            if (fields == null) {
              throw new Error(`Unknown version ${val.version}`);
            }

            for (key in fields) {
              type = fields[key];

              if (type.size != null) {
                size += type.size(val[key], ctx);
              }
            }

            if (includePointers) {
              size += ctx.pointerSize;
            }

            return size;
          };

          _proto.encode = function encode(stream, val, parent) {
            let key; let
              type;

            if (this.preEncode != null) {
              this.preEncode.call(val, stream);
            }

            const ctx = {
              pointers: [],
              startOffset: stream.pos,
              parent,
              val,
              pointerSize: 0,
            };
            ctx.pointerOffset = stream.pos + this.size(val, ctx, false);

            if (typeof this.type !== 'string') {
              this.type.encode(stream, val.version);
            }

            if (this.versions.header) {
              for (key in this.versions.header) {
                type = this.versions.header[key];

                if (type.encode != null) {
                  type.encode(stream, val[key], ctx);
                }
              }
            }

            const fields = this.versions[val.version];

            for (key in fields) {
              type = fields[key];

              if (type.encode != null) {
                type.encode(stream, val[key], ctx);
              }
            }

            let i = 0;

            while (i < ctx.pointers.length) {
              const ptr = ctx.pointers[i++];
              ptr.type.encode(stream, ptr.val, ptr.parent);
            }
          };

          return VersionedStruct;
        }(Struct));

        module.exports = VersionedStruct;
        /***/ }),

      /***/ 6610:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        const _require = __webpack_require__(6462);
        const NumberT = _require.Number;

        exports.resolveLength = function (length, stream, parent) {
          let res;

          if (typeof length === 'number') {
            res = length;
          } else if (typeof length === 'function') {
            res = length.call(parent, parent);
          } else if (parent && typeof length === 'string') {
            res = parent[length];
          } else if (stream && length instanceof NumberT) {
            res = length.decode(stream);
          }

          if (isNaN(res)) {
            throw new Error('Not a fixed size');
          }

          return res;
        };

        const PropertyDescriptor = function PropertyDescriptor(opts) {
          if (opts === void 0) {
            opts = {};
          }

          this.enumerable = true;
          this.configurable = true;

          for (const key in opts) {
            const val = opts[key];
            this[key] = val;
          }
        };

        exports.PropertyDescriptor = PropertyDescriptor;
        /***/ }),

      /***/ 8823:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

        /* eslint-disable no-proto */

        __webpack_require__(2526);

        __webpack_require__(1817);

        __webpack_require__(1539);

        __webpack_require__(6992);

        __webpack_require__(2472);

        __webpack_require__(2990);

        __webpack_require__(8927);

        __webpack_require__(3105);

        __webpack_require__(5035);

        __webpack_require__(4345);

        __webpack_require__(7174);

        __webpack_require__(2846);

        __webpack_require__(4731);

        __webpack_require__(7209);

        __webpack_require__(6319);

        __webpack_require__(8867);

        __webpack_require__(7789);

        __webpack_require__(3739);

        __webpack_require__(9368);

        __webpack_require__(4483);

        __webpack_require__(2056);

        __webpack_require__(3462);

        __webpack_require__(678);

        __webpack_require__(7462);

        __webpack_require__(3824);

        __webpack_require__(5021);

        __webpack_require__(2974);

        __webpack_require__(5016);

        __webpack_require__(7803);

        __webpack_require__(6649);

        __webpack_require__(6078);

        __webpack_require__(3290);

        __webpack_require__(7042);

        __webpack_require__(2222);

        __webpack_require__(9714);

        __webpack_require__(3210);

        __webpack_require__(4916);

        __webpack_require__(5306);

        __webpack_require__(6699);

        __webpack_require__(2023);

        __webpack_require__(9653);

        __webpack_require__(3753);

        __webpack_require__(545);

        __webpack_require__(8309);

        __webpack_require__(3161);

        __webpack_require__(3123);

        function _defineProperties(target, props) { for (let i = 0; i < props.length; i++) { const descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

        function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

        function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

        function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

        const base64 = __webpack_require__(9742);

        const ieee754 = __webpack_require__(645);

        const customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
          ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
          : null;
        exports.Buffer = Buffer;
        exports.SlowBuffer = SlowBuffer;
        exports.INSPECT_MAX_BYTES = 50;
        const K_MAX_LENGTH = 0x7fffffff;
        exports.kMaxLength = K_MAX_LENGTH;
        /**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */

        Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();

        if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') {
          console.error('This browser lacks typed array (Uint8Array) support which is required by ' + '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.');
        }

        function typedArraySupport() {
          // Can typed array instances can be augmented?
          try {
            const arr = new Uint8Array(1);
            const proto = {
              foo: function foo() {
                return 42;
              },
            };
            Object.setPrototypeOf(proto, Uint8Array.prototype);
            Object.setPrototypeOf(arr, proto);
            return arr.foo() === 42;
          } catch (e) {
            return false;
          }
        }

        Object.defineProperty(Buffer.prototype, 'parent', {
          enumerable: true,
          get: function get() {
            if (!Buffer.isBuffer(this)) return undefined;
            return this.buffer;
          },
        });
        Object.defineProperty(Buffer.prototype, 'offset', {
          enumerable: true,
          get: function get() {
            if (!Buffer.isBuffer(this)) return undefined;
            return this.byteOffset;
          },
        });

        function createBuffer(length) {
          if (length > K_MAX_LENGTH) {
            throw new RangeError(`The value "${length}" is invalid for option "size"`);
          } // Return an augmented `Uint8Array` instance

          const buf = new Uint8Array(length);
          Object.setPrototypeOf(buf, Buffer.prototype);
          return buf;
        }
        /**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

        function Buffer(arg, encodingOrOffset, length) {
          // Common case.
          if (typeof arg === 'number') {
            if (typeof encodingOrOffset === 'string') {
              throw new TypeError('The "string" argument must be of type string. Received type number');
            }

            return allocUnsafe(arg);
          }

          return from(arg, encodingOrOffset, length);
        }

        Buffer.poolSize = 8192; // not used by this implementation

        function from(value, encodingOrOffset, length) {
          if (typeof value === 'string') {
            return fromString(value, encodingOrOffset);
          }

          if (ArrayBuffer.isView(value)) {
            return fromArrayView(value);
          }

          if (value == null) {
            throw new TypeError(`${'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' + 'or Array-like Object. Received type '}${typeof value}`);
          }

          if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
            return fromArrayBuffer(value, encodingOrOffset, length);
          }

          if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) {
            return fromArrayBuffer(value, encodingOrOffset, length);
          }

          if (typeof value === 'number') {
            throw new TypeError('The "value" argument must not be of type number. Received type number');
          }

          const valueOf = value.valueOf && value.valueOf();

          if (valueOf != null && valueOf !== value) {
            return Buffer.from(valueOf, encodingOrOffset, length);
          }

          const b = fromObject(value);
          if (b) return b;

          if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') {
            return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
          }

          throw new TypeError(`${'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' + 'or Array-like Object. Received type '}${typeof value}`);
        }
        /**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 * */

        Buffer.from = function (value, encodingOrOffset, length) {
          return from(value, encodingOrOffset, length);
        }; // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
        // https://github.com/feross/buffer/pull/148

        Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
        Object.setPrototypeOf(Buffer, Uint8Array);

        function assertSize(size) {
          if (typeof size !== 'number') {
            throw new TypeError('"size" argument must be of type number');
          } else if (size < 0) {
            throw new RangeError(`The value "${size}" is invalid for option "size"`);
          }
        }

        function alloc(size, fill, encoding) {
          assertSize(size);

          if (size <= 0) {
            return createBuffer(size);
          }

          if (fill !== undefined) {
            // Only pay attention to encoding if it's a string. This
            // prevents accidentally sending in a number that would
            // be interpreted as a start offset.
            return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
          }

          return createBuffer(size);
        }
        /**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 * */

        Buffer.alloc = function (size, fill, encoding) {
          return alloc(size, fill, encoding);
        };

        function allocUnsafe(size) {
          assertSize(size);
          return createBuffer(size < 0 ? 0 : checked(size) | 0);
        }
        /**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */

        Buffer.allocUnsafe = function (size) {
          return allocUnsafe(size);
        };
        /**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */

        Buffer.allocUnsafeSlow = function (size) {
          return allocUnsafe(size);
        };

        function fromString(string, encoding) {
          if (typeof encoding !== 'string' || encoding === '') {
            encoding = 'utf8';
          }

          if (!Buffer.isEncoding(encoding)) {
            throw new TypeError(`Unknown encoding: ${encoding}`);
          }

          const length = byteLength(string, encoding) | 0;
          let buf = createBuffer(length);
          const actual = buf.write(string, encoding);

          if (actual !== length) {
            // Writing a hex string, for example, that contains invalid characters will
            // cause everything after the first invalid character to be ignored. (e.g.
            // 'abxxcd' will be treated as 'ab')
            buf = buf.slice(0, actual);
          }

          return buf;
        }

        function fromArrayLike(array) {
          const length = array.length < 0 ? 0 : checked(array.length) | 0;
          const buf = createBuffer(length);

          for (let i = 0; i < length; i += 1) {
            buf[i] = array[i] & 255;
          }

          return buf;
        }

        function fromArrayView(arrayView) {
          if (isInstance(arrayView, Uint8Array)) {
            const copy = new Uint8Array(arrayView);
            return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
          }

          return fromArrayLike(arrayView);
        }

        function fromArrayBuffer(array, byteOffset, length) {
          if (byteOffset < 0 || array.byteLength < byteOffset) {
            throw new RangeError('"offset" is outside of buffer bounds');
          }

          if (array.byteLength < byteOffset + (length || 0)) {
            throw new RangeError('"length" is outside of buffer bounds');
          }

          let buf;

          if (byteOffset === undefined && length === undefined) {
            buf = new Uint8Array(array);
          } else if (length === undefined) {
            buf = new Uint8Array(array, byteOffset);
          } else {
            buf = new Uint8Array(array, byteOffset, length);
          } // Return an augmented `Uint8Array` instance

          Object.setPrototypeOf(buf, Buffer.prototype);
          return buf;
        }

        function fromObject(obj) {
          if (Buffer.isBuffer(obj)) {
            const len = checked(obj.length) | 0;
            const buf = createBuffer(len);

            if (buf.length === 0) {
              return buf;
            }

            obj.copy(buf, 0, 0, len);
            return buf;
          }

          if (obj.length !== undefined) {
            if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
              return createBuffer(0);
            }

            return fromArrayLike(obj);
          }

          if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
            return fromArrayLike(obj.data);
          }
        }

        function checked(length) {
          // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
          // length is NaN (which is otherwise coerced to zero.)
          if (length >= K_MAX_LENGTH) {
            throw new RangeError(`${'Attempt to allocate Buffer larger than maximum ' + 'size: 0x'}${K_MAX_LENGTH.toString(16)} bytes`);
          }

          return length | 0;
        }

        function SlowBuffer(length) {
          if (+length != length) {
            // eslint-disable-line eqeqeq
            length = 0;
          }

          return Buffer.alloc(+length);
        }

        Buffer.isBuffer = function isBuffer(b) {
          return b != null && b._isBuffer === true && b !== Buffer.prototype; // so Buffer.isBuffer(Buffer.prototype) will be false
        };

        Buffer.compare = function compare(a, b) {
          if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
          if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);

          if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
            throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
          }

          if (a === b) return 0;
          let x = a.length;
          let y = b.length;

          for (let i = 0, len = Math.min(x, y); i < len; ++i) {
            if (a[i] !== b[i]) {
              x = a[i];
              y = b[i];
              break;
            }
          }

          if (x < y) return -1;
          if (y < x) return 1;
          return 0;
        };

        Buffer.isEncoding = function isEncoding(encoding) {
          switch (String(encoding).toLowerCase()) {
            case 'hex':
            case 'utf8':
            case 'utf-8':
            case 'ascii':
            case 'latin1':
            case 'binary':
            case 'base64':
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
              return true;

            default:
              return false;
          }
        };

        Buffer.concat = function concat(list, length) {
          if (!Array.isArray(list)) {
            throw new TypeError('"list" argument must be an Array of Buffers');
          }

          if (list.length === 0) {
            return Buffer.alloc(0);
          }

          let i;

          if (length === undefined) {
            length = 0;

            for (i = 0; i < list.length; ++i) {
              length += list[i].length;
            }
          }

          const buffer = Buffer.allocUnsafe(length);
          let pos = 0;

          for (i = 0; i < list.length; ++i) {
            let buf = list[i];

            if (isInstance(buf, Uint8Array)) {
              if (pos + buf.length > buffer.length) {
                if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                buf.copy(buffer, pos);
              } else {
                Uint8Array.prototype.set.call(buffer, buf, pos);
              }
            } else if (!Buffer.isBuffer(buf)) {
              throw new TypeError('"list" argument must be an Array of Buffers');
            } else {
              buf.copy(buffer, pos);
            }

            pos += buf.length;
          }

          return buffer;
        };

        function byteLength(string, encoding) {
          if (Buffer.isBuffer(string)) {
            return string.length;
          }

          if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
            return string.byteLength;
          }

          if (typeof string !== 'string') {
            throw new TypeError(`${'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' + 'Received type '}${typeof string}`);
          }

          const len = string.length;
          const mustMatch = arguments.length > 2 && arguments[2] === true;
          if (!mustMatch && len === 0) return 0; // Use a for loop to avoid recursion

          let loweredCase = false;

          for (;;) {
            switch (encoding) {
              case 'ascii':
              case 'latin1':
              case 'binary':
                return len;

              case 'utf8':
              case 'utf-8':
                return utf8ToBytes(string).length;

              case 'ucs2':
              case 'ucs-2':
              case 'utf16le':
              case 'utf-16le':
                return len * 2;

              case 'hex':
                return len >>> 1;

              case 'base64':
                return base64ToBytes(string).length;

              default:
                if (loweredCase) {
                  return mustMatch ? -1 : utf8ToBytes(string).length; // assume utf8
                }

                encoding = (`${encoding}`).toLowerCase();
                loweredCase = true;
            }
          }
        }

        Buffer.byteLength = byteLength;

        function slowToString(encoding, start, end) {
          let loweredCase = false; // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
          // property of a typed array.
          // This behaves neither like String nor Uint8Array in that we set start/end
          // to their upper/lower bounds if the value passed is out of range.
          // undefined is handled specially as per ECMA-262 6th Edition,
          // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.

          if (start === undefined || start < 0) {
            start = 0;
          } // Return early if start > this.length. Done here to prevent potential uint32
          // coercion fail below.

          if (start > this.length) {
            return '';
          }

          if (end === undefined || end > this.length) {
            end = this.length;
          }

          if (end <= 0) {
            return '';
          } // Force coercion to uint32. This will also coerce falsey/NaN values to 0.

          end >>>= 0;
          start >>>= 0;

          if (end <= start) {
            return '';
          }

          if (!encoding) encoding = 'utf8';

          while (true) {
            switch (encoding) {
              case 'hex':
                return hexSlice(this, start, end);

              case 'utf8':
              case 'utf-8':
                return utf8Slice(this, start, end);

              case 'ascii':
                return asciiSlice(this, start, end);

              case 'latin1':
              case 'binary':
                return latin1Slice(this, start, end);

              case 'base64':
                return base64Slice(this, start, end);

              case 'ucs2':
              case 'ucs-2':
              case 'utf16le':
              case 'utf-16le':
                return utf16leSlice(this, start, end);

              default:
                if (loweredCase) throw new TypeError(`Unknown encoding: ${encoding}`);
                encoding = (`${encoding}`).toLowerCase();
                loweredCase = true;
            }
          }
        } // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
        // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
        // reliably in a browserify context because there could be multiple different
        // copies of the 'buffer' package in use. This method works even for Buffer
        // instances that were created from another copy of the `buffer` package.
        // See: https://github.com/feross/buffer/issues/154

        Buffer.prototype._isBuffer = true;

        function swap(b, n, m) {
          const i = b[n];
          b[n] = b[m];
          b[m] = i;
        }

        Buffer.prototype.swap16 = function swap16() {
          const len = this.length;

          if (len % 2 !== 0) {
            throw new RangeError('Buffer size must be a multiple of 16-bits');
          }

          for (let i = 0; i < len; i += 2) {
            swap(this, i, i + 1);
          }

          return this;
        };

        Buffer.prototype.swap32 = function swap32() {
          const len = this.length;

          if (len % 4 !== 0) {
            throw new RangeError('Buffer size must be a multiple of 32-bits');
          }

          for (let i = 0; i < len; i += 4) {
            swap(this, i, i + 3);
            swap(this, i + 1, i + 2);
          }

          return this;
        };

        Buffer.prototype.swap64 = function swap64() {
          const len = this.length;

          if (len % 8 !== 0) {
            throw new RangeError('Buffer size must be a multiple of 64-bits');
          }

          for (let i = 0; i < len; i += 8) {
            swap(this, i, i + 7);
            swap(this, i + 1, i + 6);
            swap(this, i + 2, i + 5);
            swap(this, i + 3, i + 4);
          }

          return this;
        };

        Buffer.prototype.toString = function toString() {
          const { length } = this;
          if (length === 0) return '';
          if (arguments.length === 0) return utf8Slice(this, 0, length);
          return slowToString.apply(this, arguments);
        };

        Buffer.prototype.toLocaleString = Buffer.prototype.toString;

        Buffer.prototype.equals = function equals(b) {
          if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
          if (this === b) return true;
          return Buffer.compare(this, b) === 0;
        };

        Buffer.prototype.inspect = function inspect() {
          let str = '';
          const max = exports.INSPECT_MAX_BYTES;
          str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
          if (this.length > max) str += ' ... ';
          return `<Buffer ${str}>`;
        };

        if (customInspectSymbol) {
          Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
        }

        Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
          if (isInstance(target, Uint8Array)) {
            target = Buffer.from(target, target.offset, target.byteLength);
          }

          if (!Buffer.isBuffer(target)) {
            throw new TypeError(`${'The "target" argument must be one of type Buffer or Uint8Array. ' + 'Received type '}${typeof target}`);
          }

          if (start === undefined) {
            start = 0;
          }

          if (end === undefined) {
            end = target ? target.length : 0;
          }

          if (thisStart === undefined) {
            thisStart = 0;
          }

          if (thisEnd === undefined) {
            thisEnd = this.length;
          }

          if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
            throw new RangeError('out of range index');
          }

          if (thisStart >= thisEnd && start >= end) {
            return 0;
          }

          if (thisStart >= thisEnd) {
            return -1;
          }

          if (start >= end) {
            return 1;
          }

          start >>>= 0;
          end >>>= 0;
          thisStart >>>= 0;
          thisEnd >>>= 0;
          if (this === target) return 0;
          let x = thisEnd - thisStart;
          let y = end - start;
          const len = Math.min(x, y);
          const thisCopy = this.slice(thisStart, thisEnd);
          const targetCopy = target.slice(start, end);

          for (let i = 0; i < len; ++i) {
            if (thisCopy[i] !== targetCopy[i]) {
              x = thisCopy[i];
              y = targetCopy[i];
              break;
            }
          }

          if (x < y) return -1;
          if (y < x) return 1;
          return 0;
        }; // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
        // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
        //
        // Arguments:
        // - buffer - a Buffer to search
        // - val - a string, Buffer, or number
        // - byteOffset - an index into `buffer`; will be clamped to an int32
        // - encoding - an optional encoding, relevant is val is a string
        // - dir - true for indexOf, false for lastIndexOf

        function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
          // Empty buffer means no match
          if (buffer.length === 0) return -1; // Normalize byteOffset

          if (typeof byteOffset === 'string') {
            encoding = byteOffset;
            byteOffset = 0;
          } else if (byteOffset > 0x7fffffff) {
            byteOffset = 0x7fffffff;
          } else if (byteOffset < -0x80000000) {
            byteOffset = -0x80000000;
          }

          byteOffset = +byteOffset; // Coerce to Number.

          if (numberIsNaN(byteOffset)) {
            // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
            byteOffset = dir ? 0 : buffer.length - 1;
          } // Normalize byteOffset: negative offsets start from the end of the buffer

          if (byteOffset < 0) byteOffset = buffer.length + byteOffset;

          if (byteOffset >= buffer.length) {
            if (dir) return -1; byteOffset = buffer.length - 1;
          } else if (byteOffset < 0) {
            if (dir) byteOffset = 0; else return -1;
          } // Normalize val

          if (typeof val === 'string') {
            val = Buffer.from(val, encoding);
          } // Finally, search either indexOf (if dir is true) or lastIndexOf

          if (Buffer.isBuffer(val)) {
            // Special case: looking for empty string/buffer always fails
            if (val.length === 0) {
              return -1;
            }

            return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
          } if (typeof val === 'number') {
            val &= 0xFF; // Search for a byte value [0-255]

            if (typeof Uint8Array.prototype.indexOf === 'function') {
              if (dir) {
                return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
              }
              return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
            }

            return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
          }

          throw new TypeError('val must be string, number or Buffer');
        }

        function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
          let indexSize = 1;
          let arrLength = arr.length;
          let valLength = val.length;

          if (encoding !== undefined) {
            encoding = String(encoding).toLowerCase();

            if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
              if (arr.length < 2 || val.length < 2) {
                return -1;
              }

              indexSize = 2;
              arrLength /= 2;
              valLength /= 2;
              byteOffset /= 2;
            }
          }

          function read(buf, i) {
            if (indexSize === 1) {
              return buf[i];
            }
            return buf.readUInt16BE(i * indexSize);
          }

          let i;

          if (dir) {
            let foundIndex = -1;

            for (i = byteOffset; i < arrLength; i++) {
              if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                if (foundIndex === -1) foundIndex = i;
                if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
              } else {
                if (foundIndex !== -1) i -= i - foundIndex;
                foundIndex = -1;
              }
            }
          } else {
            if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;

            for (i = byteOffset; i >= 0; i--) {
              let found = true;

              for (let j = 0; j < valLength; j++) {
                if (read(arr, i + j) !== read(val, j)) {
                  found = false;
                  break;
                }
              }

              if (found) return i;
            }
          }

          return -1;
        }

        Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
          return this.indexOf(val, byteOffset, encoding) !== -1;
        };

        Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
          return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
        };

        Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
          return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
        };

        function hexWrite(buf, string, offset, length) {
          offset = Number(offset) || 0;
          const remaining = buf.length - offset;

          if (!length) {
            length = remaining;
          } else {
            length = Number(length);

            if (length > remaining) {
              length = remaining;
            }
          }

          const strLen = string.length;

          if (length > strLen / 2) {
            length = strLen / 2;
          }

          let i;

          for (i = 0; i < length; ++i) {
            const parsed = parseInt(string.substr(i * 2, 2), 16);
            if (numberIsNaN(parsed)) return i;
            buf[offset + i] = parsed;
          }

          return i;
        }

        function utf8Write(buf, string, offset, length) {
          return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
        }

        function asciiWrite(buf, string, offset, length) {
          return blitBuffer(asciiToBytes(string), buf, offset, length);
        }

        function base64Write(buf, string, offset, length) {
          return blitBuffer(base64ToBytes(string), buf, offset, length);
        }

        function ucs2Write(buf, string, offset, length) {
          return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
        }

        Buffer.prototype.write = function write(string, offset, length, encoding) {
          // Buffer#write(string)
          if (offset === undefined) {
            encoding = 'utf8';
            length = this.length;
            offset = 0; // Buffer#write(string, encoding)
          } else if (length === undefined && typeof offset === 'string') {
            encoding = offset;
            length = this.length;
            offset = 0; // Buffer#write(string, offset[, length][, encoding])
          } else if (isFinite(offset)) {
            offset >>>= 0;

            if (isFinite(length)) {
              length >>>= 0;
              if (encoding === undefined) encoding = 'utf8';
            } else {
              encoding = length;
              length = undefined;
            }
          } else {
            throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
          }

          const remaining = this.length - offset;
          if (length === undefined || length > remaining) length = remaining;

          if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
            throw new RangeError('Attempt to write outside buffer bounds');
          }

          if (!encoding) encoding = 'utf8';
          let loweredCase = false;

          for (;;) {
            switch (encoding) {
              case 'hex':
                return hexWrite(this, string, offset, length);

              case 'utf8':
              case 'utf-8':
                return utf8Write(this, string, offset, length);

              case 'ascii':
              case 'latin1':
              case 'binary':
                return asciiWrite(this, string, offset, length);

              case 'base64':
                // Warning: maxLength not taken into account in base64Write
                return base64Write(this, string, offset, length);

              case 'ucs2':
              case 'ucs-2':
              case 'utf16le':
              case 'utf-16le':
                return ucs2Write(this, string, offset, length);

              default:
                if (loweredCase) throw new TypeError(`Unknown encoding: ${encoding}`);
                encoding = (`${encoding}`).toLowerCase();
                loweredCase = true;
            }
          }
        };

        Buffer.prototype.toJSON = function toJSON() {
          return {
            type: 'Buffer',
            data: Array.prototype.slice.call(this._arr || this, 0),
          };
        };

        function base64Slice(buf, start, end) {
          if (start === 0 && end === buf.length) {
            return base64.fromByteArray(buf);
          }
          return base64.fromByteArray(buf.slice(start, end));
        }

        function utf8Slice(buf, start, end) {
          end = Math.min(buf.length, end);
          const res = [];
          let i = start;

          while (i < end) {
            const firstByte = buf[i];
            let codePoint = null;
            let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;

            if (i + bytesPerSequence <= end) {
              let secondByte = void 0;
              let thirdByte = void 0;
              let fourthByte = void 0;
              let tempCodePoint = void 0;

              switch (bytesPerSequence) {
                case 1:
                  if (firstByte < 0x80) {
                    codePoint = firstByte;
                  }

                  break;

                case 2:
                  secondByte = buf[i + 1];

                  if ((secondByte & 0xC0) === 0x80) {
                    tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;

                    if (tempCodePoint > 0x7F) {
                      codePoint = tempCodePoint;
                    }
                  }

                  break;

                case 3:
                  secondByte = buf[i + 1];
                  thirdByte = buf[i + 2];

                  if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                    tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;

                    if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
                      codePoint = tempCodePoint;
                    }
                  }

                  break;

                case 4:
                  secondByte = buf[i + 1];
                  thirdByte = buf[i + 2];
                  fourthByte = buf[i + 3];

                  if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                    tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;

                    if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
                      codePoint = tempCodePoint;
                    }
                  }
              }
            }

            if (codePoint === null) {
              // we did not generate a valid codePoint so insert a
              // replacement char (U+FFFD) and advance only 1 byte
              codePoint = 0xFFFD;
              bytesPerSequence = 1;
            } else if (codePoint > 0xFFFF) {
              // encode to utf16 (surrogate pair dance)
              codePoint -= 0x10000;
              res.push(codePoint >>> 10 & 0x3FF | 0xD800);
              codePoint = 0xDC00 | codePoint & 0x3FF;
            }

            res.push(codePoint);
            i += bytesPerSequence;
          }

          return decodeCodePointsArray(res);
        } // Based on http://stackoverflow.com/a/22747272/680742, the browser with
        // the lowest limit is Chrome, with 0x10000 args.
        // We go 1 magnitude less, for safety

        const MAX_ARGUMENTS_LENGTH = 0x1000;

        function decodeCodePointsArray(codePoints) {
          const len = codePoints.length;

          if (len <= MAX_ARGUMENTS_LENGTH) {
            return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
          } // Decode in chunks to avoid "call stack size exceeded".

          let res = '';
          let i = 0;

          while (i < len) {
            res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
          }

          return res;
        }

        function asciiSlice(buf, start, end) {
          let ret = '';
          end = Math.min(buf.length, end);

          for (let i = start; i < end; ++i) {
            ret += String.fromCharCode(buf[i] & 0x7F);
          }

          return ret;
        }

        function latin1Slice(buf, start, end) {
          let ret = '';
          end = Math.min(buf.length, end);

          for (let i = start; i < end; ++i) {
            ret += String.fromCharCode(buf[i]);
          }

          return ret;
        }

        function hexSlice(buf, start, end) {
          const len = buf.length;
          if (!start || start < 0) start = 0;
          if (!end || end < 0 || end > len) end = len;
          let out = '';

          for (let i = start; i < end; ++i) {
            out += hexSliceLookupTable[buf[i]];
          }

          return out;
        }

        function utf16leSlice(buf, start, end) {
          const bytes = buf.slice(start, end);
          let res = ''; // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)

          for (let i = 0; i < bytes.length - 1; i += 2) {
            res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
          }

          return res;
        }

        Buffer.prototype.slice = function slice(start, end) {
          const len = this.length;
          start = ~~start;
          end = end === undefined ? len : ~~end;

          if (start < 0) {
            start += len;
            if (start < 0) start = 0;
          } else if (start > len) {
            start = len;
          }

          if (end < 0) {
            end += len;
            if (end < 0) end = 0;
          } else if (end > len) {
            end = len;
          }

          if (end < start) end = start;
          const newBuf = this.subarray(start, end); // Return an augmented `Uint8Array` instance

          Object.setPrototypeOf(newBuf, Buffer.prototype);
          return newBuf;
        };
        /*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */

        function checkOffset(offset, ext, length) {
          if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
          if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
        }

        Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
          offset >>>= 0;
          byteLength >>>= 0;
          if (!noAssert) checkOffset(offset, byteLength, this.length);
          let val = this[offset];
          let mul = 1;
          let i = 0;

          while (++i < byteLength && (mul *= 0x100)) {
            val += this[offset + i] * mul;
          }

          return val;
        };

        Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
          offset >>>= 0;
          byteLength >>>= 0;

          if (!noAssert) {
            checkOffset(offset, byteLength, this.length);
          }

          let val = this[offset + --byteLength];
          let mul = 1;

          while (byteLength > 0 && (mul *= 0x100)) {
            val += this[offset + --byteLength] * mul;
          }

          return val;
        };

        Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
          offset >>>= 0;
          if (!noAssert) checkOffset(offset, 1, this.length);
          return this[offset];
        };

        Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
          offset >>>= 0;
          if (!noAssert) checkOffset(offset, 2, this.length);
          return this[offset] | this[offset + 1] << 8;
        };

        Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
          offset >>>= 0;
          if (!noAssert) checkOffset(offset, 2, this.length);
          return this[offset] << 8 | this[offset + 1];
        };

        Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
          offset >>>= 0;
          if (!noAssert) checkOffset(offset, 4, this.length);
          return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
        };

        Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
          offset >>>= 0;
          if (!noAssert) checkOffset(offset, 4, this.length);
          return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
        };

        Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
          offset >>>= 0;
          validateNumber(offset, 'offset');
          const first = this[offset];
          const last = this[offset + 7];

          if (first === undefined || last === undefined) {
            boundsError(offset, this.length - 8);
          }

          const lo = first + this[++offset] * Math.pow(2, 8) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
          const hi = this[++offset] + this[++offset] * Math.pow(2, 8) + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
          return BigInt(lo) + (BigInt(hi) << BigInt(32));
        });
        Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
          offset >>>= 0;
          validateNumber(offset, 'offset');
          const first = this[offset];
          const last = this[offset + 7];

          if (first === undefined || last === undefined) {
            boundsError(offset, this.length - 8);
          }

          const hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + this[++offset];
          const lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + last;
          return (BigInt(hi) << BigInt(32)) + BigInt(lo);
        });

        Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
          offset >>>= 0;
          byteLength >>>= 0;
          if (!noAssert) checkOffset(offset, byteLength, this.length);
          let val = this[offset];
          let mul = 1;
          let i = 0;

          while (++i < byteLength && (mul *= 0x100)) {
            val += this[offset + i] * mul;
          }

          mul *= 0x80;
          if (val >= mul) val -= Math.pow(2, 8 * byteLength);
          return val;
        };

        Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
          offset >>>= 0;
          byteLength >>>= 0;
          if (!noAssert) checkOffset(offset, byteLength, this.length);
          let i = byteLength;
          let mul = 1;
          let val = this[offset + --i];

          while (i > 0 && (mul *= 0x100)) {
            val += this[offset + --i] * mul;
          }

          mul *= 0x80;
          if (val >= mul) val -= Math.pow(2, 8 * byteLength);
          return val;
        };

        Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
          offset >>>= 0;
          if (!noAssert) checkOffset(offset, 1, this.length);
          if (!(this[offset] & 0x80)) return this[offset];
          return (0xff - this[offset] + 1) * -1;
        };

        Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
          offset >>>= 0;
          if (!noAssert) checkOffset(offset, 2, this.length);
          const val = this[offset] | this[offset + 1] << 8;
          return val & 0x8000 ? val | 0xFFFF0000 : val;
        };

        Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
          offset >>>= 0;
          if (!noAssert) checkOffset(offset, 2, this.length);
          const val = this[offset + 1] | this[offset] << 8;
          return val & 0x8000 ? val | 0xFFFF0000 : val;
        };

        Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
          offset >>>= 0;
          if (!noAssert) checkOffset(offset, 4, this.length);
          return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
        };

        Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
          offset >>>= 0;
          if (!noAssert) checkOffset(offset, 4, this.length);
          return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
        };

        Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
          offset >>>= 0;
          validateNumber(offset, 'offset');
          const first = this[offset];
          const last = this[offset + 7];

          if (first === undefined || last === undefined) {
            boundsError(offset, this.length - 8);
          }

          const val = this[offset + 4] + this[offset + 5] * Math.pow(2, 8) + this[offset + 6] * Math.pow(2, 16) + (last << 24); // Overflow

          return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * Math.pow(2, 8) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
        });
        Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
          offset >>>= 0;
          validateNumber(offset, 'offset');
          const first = this[offset];
          const last = this[offset + 7];

          if (first === undefined || last === undefined) {
            boundsError(offset, this.length - 8);
          }

          const val = (first << 24) // Overflow
  + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + this[++offset];
          return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + last);
        });

        Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
          offset >>>= 0;
          if (!noAssert) checkOffset(offset, 4, this.length);
          return ieee754.read(this, offset, true, 23, 4);
        };

        Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
          offset >>>= 0;
          if (!noAssert) checkOffset(offset, 4, this.length);
          return ieee754.read(this, offset, false, 23, 4);
        };

        Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
          offset >>>= 0;
          if (!noAssert) checkOffset(offset, 8, this.length);
          return ieee754.read(this, offset, true, 52, 8);
        };

        Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
          offset >>>= 0;
          if (!noAssert) checkOffset(offset, 8, this.length);
          return ieee754.read(this, offset, false, 52, 8);
        };

        function checkInt(buf, value, offset, ext, max, min) {
          if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
          if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
          if (offset + ext > buf.length) throw new RangeError('Index out of range');
        }

        Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
          value = +value;
          offset >>>= 0;
          byteLength >>>= 0;

          if (!noAssert) {
            const maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
          }

          let mul = 1;
          let i = 0;
          this[offset] = value & 0xFF;

          while (++i < byteLength && (mul *= 0x100)) {
            this[offset + i] = value / mul & 0xFF;
          }

          return offset + byteLength;
        };

        Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
          value = +value;
          offset >>>= 0;
          byteLength >>>= 0;

          if (!noAssert) {
            const maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
          }

          let i = byteLength - 1;
          let mul = 1;
          this[offset + i] = value & 0xFF;

          while (--i >= 0 && (mul *= 0x100)) {
            this[offset + i] = value / mul & 0xFF;
          }

          return offset + byteLength;
        };

        Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
          value = +value;
          offset >>>= 0;
          if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
          this[offset] = value & 0xff;
          return offset + 1;
        };

        Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
          value = +value;
          offset >>>= 0;
          if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
          this[offset] = value & 0xff;
          this[offset + 1] = value >>> 8;
          return offset + 2;
        };

        Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
          value = +value;
          offset >>>= 0;
          if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
          this[offset] = value >>> 8;
          this[offset + 1] = value & 0xff;
          return offset + 2;
        };

        Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
          value = +value;
          offset >>>= 0;
          if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
          this[offset + 3] = value >>> 24;
          this[offset + 2] = value >>> 16;
          this[offset + 1] = value >>> 8;
          this[offset] = value & 0xff;
          return offset + 4;
        };

        Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
          value = +value;
          offset >>>= 0;
          if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
          this[offset] = value >>> 24;
          this[offset + 1] = value >>> 16;
          this[offset + 2] = value >>> 8;
          this[offset + 3] = value & 0xff;
          return offset + 4;
        };

        function wrtBigUInt64LE(buf, value, offset, min, max) {
          checkIntBI(value, min, max, buf, offset, 7);
          let lo = Number(value & BigInt(0xffffffff));
          buf[offset++] = lo;
          lo >>= 8;
          buf[offset++] = lo;
          lo >>= 8;
          buf[offset++] = lo;
          lo >>= 8;
          buf[offset++] = lo;
          let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
          buf[offset++] = hi;
          hi >>= 8;
          buf[offset++] = hi;
          hi >>= 8;
          buf[offset++] = hi;
          hi >>= 8;
          buf[offset++] = hi;
          return offset;
        }

        function wrtBigUInt64BE(buf, value, offset, min, max) {
          checkIntBI(value, min, max, buf, offset, 7);
          let lo = Number(value & BigInt(0xffffffff));
          buf[offset + 7] = lo;
          lo >>= 8;
          buf[offset + 6] = lo;
          lo >>= 8;
          buf[offset + 5] = lo;
          lo >>= 8;
          buf[offset + 4] = lo;
          let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
          buf[offset + 3] = hi;
          hi >>= 8;
          buf[offset + 2] = hi;
          hi >>= 8;
          buf[offset + 1] = hi;
          hi >>= 8;
          buf[offset] = hi;
          return offset + 8;
        }

        Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset) {
          if (offset === void 0) {
            offset = 0;
          }

          return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
        });
        Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset) {
          if (offset === void 0) {
            offset = 0;
          }

          return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
        });

        Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
          value = +value;
          offset >>>= 0;

          if (!noAssert) {
            const limit = Math.pow(2, 8 * byteLength - 1);
            checkInt(this, value, offset, byteLength, limit - 1, -limit);
          }

          let i = 0;
          let mul = 1;
          let sub = 0;
          this[offset] = value & 0xFF;

          while (++i < byteLength && (mul *= 0x100)) {
            if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
              sub = 1;
            }

            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
          }

          return offset + byteLength;
        };

        Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
          value = +value;
          offset >>>= 0;

          if (!noAssert) {
            const limit = Math.pow(2, 8 * byteLength - 1);
            checkInt(this, value, offset, byteLength, limit - 1, -limit);
          }

          let i = byteLength - 1;
          let mul = 1;
          let sub = 0;
          this[offset + i] = value & 0xFF;

          while (--i >= 0 && (mul *= 0x100)) {
            if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
              sub = 1;
            }

            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
          }

          return offset + byteLength;
        };

        Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
          value = +value;
          offset >>>= 0;
          if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
          if (value < 0) value = 0xff + value + 1;
          this[offset] = value & 0xff;
          return offset + 1;
        };

        Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
          value = +value;
          offset >>>= 0;
          if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
          this[offset] = value & 0xff;
          this[offset + 1] = value >>> 8;
          return offset + 2;
        };

        Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
          value = +value;
          offset >>>= 0;
          if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
          this[offset] = value >>> 8;
          this[offset + 1] = value & 0xff;
          return offset + 2;
        };

        Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
          value = +value;
          offset >>>= 0;
          if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
          this[offset] = value & 0xff;
          this[offset + 1] = value >>> 8;
          this[offset + 2] = value >>> 16;
          this[offset + 3] = value >>> 24;
          return offset + 4;
        };

        Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
          value = +value;
          offset >>>= 0;
          if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
          if (value < 0) value = 0xffffffff + value + 1;
          this[offset] = value >>> 24;
          this[offset + 1] = value >>> 16;
          this[offset + 2] = value >>> 8;
          this[offset + 3] = value & 0xff;
          return offset + 4;
        };

        Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset) {
          if (offset === void 0) {
            offset = 0;
          }

          return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
        });
        Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset) {
          if (offset === void 0) {
            offset = 0;
          }

          return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
        });

        function checkIEEE754(buf, value, offset, ext, max, min) {
          if (offset + ext > buf.length) throw new RangeError('Index out of range');
          if (offset < 0) throw new RangeError('Index out of range');
        }

        function writeFloat(buf, value, offset, littleEndian, noAssert) {
          value = +value;
          offset >>>= 0;

          if (!noAssert) {
            checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
          }

          ieee754.write(buf, value, offset, littleEndian, 23, 4);
          return offset + 4;
        }

        Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
          return writeFloat(this, value, offset, true, noAssert);
        };

        Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
          return writeFloat(this, value, offset, false, noAssert);
        };

        function writeDouble(buf, value, offset, littleEndian, noAssert) {
          value = +value;
          offset >>>= 0;

          if (!noAssert) {
            checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
          }

          ieee754.write(buf, value, offset, littleEndian, 52, 8);
          return offset + 8;
        }

        Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
          return writeDouble(this, value, offset, true, noAssert);
        };

        Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
          return writeDouble(this, value, offset, false, noAssert);
        }; // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)

        Buffer.prototype.copy = function copy(target, targetStart, start, end) {
          if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
          if (!start) start = 0;
          if (!end && end !== 0) end = this.length;
          if (targetStart >= target.length) targetStart = target.length;
          if (!targetStart) targetStart = 0;
          if (end > 0 && end < start) end = start; // Copy 0 bytes; we're done

          if (end === start) return 0;
          if (target.length === 0 || this.length === 0) return 0; // Fatal error conditions

          if (targetStart < 0) {
            throw new RangeError('targetStart out of bounds');
          }

          if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
          if (end < 0) throw new RangeError('sourceEnd out of bounds'); // Are we oob?

          if (end > this.length) end = this.length;

          if (target.length - targetStart < end - start) {
            end = target.length - targetStart + start;
          }

          const len = end - start;

          if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
            // Use built-in when available, missing from IE11
            this.copyWithin(targetStart, start, end);
          } else {
            Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
          }

          return len;
        }; // Usage:
        //    buffer.fill(number[, offset[, end]])
        //    buffer.fill(buffer[, offset[, end]])
        //    buffer.fill(string[, offset[, end]][, encoding])

        Buffer.prototype.fill = function fill(val, start, end, encoding) {
          // Handle string cases:
          if (typeof val === 'string') {
            if (typeof start === 'string') {
              encoding = start;
              start = 0;
              end = this.length;
            } else if (typeof end === 'string') {
              encoding = end;
              end = this.length;
            }

            if (encoding !== undefined && typeof encoding !== 'string') {
              throw new TypeError('encoding must be a string');
            }

            if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
              throw new TypeError(`Unknown encoding: ${encoding}`);
            }

            if (val.length === 1) {
              const code = val.charCodeAt(0);

              if (encoding === 'utf8' && code < 128 || encoding === 'latin1') {
                // Fast path: If `val` fits into a single byte, use that numeric value.
                val = code;
              }
            }
          } else if (typeof val === 'number') {
            val &= 255;
          } else if (typeof val === 'boolean') {
            val = Number(val);
          } // Invalid ranges are not set to a default, so can range check early.

          if (start < 0 || this.length < start || this.length < end) {
            throw new RangeError('Out of range index');
          }

          if (end <= start) {
            return this;
          }

          start >>>= 0;
          end = end === undefined ? this.length : end >>> 0;
          if (!val) val = 0;
          let i;

          if (typeof val === 'number') {
            for (i = start; i < end; ++i) {
              this[i] = val;
            }
          } else {
            const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
            const len = bytes.length;

            if (len === 0) {
              throw new TypeError(`The value "${val}" is invalid for argument "value"`);
            }

            for (i = 0; i < end - start; ++i) {
              this[i + start] = bytes[i % len];
            }
          }

          return this;
        }; // CUSTOM ERRORS
        // =============
        // Simplified versions from Node, changed for Buffer-only usage

        const errors = {};

        function E(sym, getMessage, Base) {
          errors[sym] = /* #__PURE__ */(function (_Base) {
            _inheritsLoose(NodeError, _Base);

            function NodeError() {
              let _this;

              _this = _Base.call(this) || this;
              Object.defineProperty(_assertThisInitialized(_this), 'message', {
                value: getMessage.apply(_assertThisInitialized(_this), arguments),
                writable: true,
                configurable: true,
              }); // Add the error code to the name to include it in the stack trace.

              _this.name = `${_this.name} [${sym}]`; // Access the stack to generate the error message including the error code
              // from the name.

              _this.stack; // eslint-disable-line no-unused-expressions
              // Reset the name to the actual name.

              delete _this.name;
              return _this;
            }

            const _proto = NodeError.prototype;

            _proto.toString = function toString() {
              return `${this.name} [${sym}]: ${this.message}`;
            };

            _createClass(NodeError, [{
              key: 'code',
              get: function get() {
                return sym;
              },
              set: function set(value) {
                Object.defineProperty(this, 'code', {
                  configurable: true,
                  enumerable: true,
                  value,
                  writable: true,
                });
              },
            }]);

            return NodeError;
          }(Base));
        }

        E('ERR_BUFFER_OUT_OF_BOUNDS', (name) => {
          if (name) {
            return `${name} is outside of buffer bounds`;
          }

          return 'Attempt to access memory outside buffer bounds';
        }, RangeError);
        E('ERR_INVALID_ARG_TYPE', (name, actual) => `The "${name}" argument must be of type number. Received type ${typeof actual}`, TypeError);
        E('ERR_OUT_OF_RANGE', (str, range, input) => {
          let msg = `The value of "${str}" is out of range.`;
          let received = input;

          if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) {
            received = addNumericalSeparator(String(input));
          } else if (typeof input === 'bigint') {
            received = String(input);

            if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) {
              received = addNumericalSeparator(received);
            }

            received += 'n';
          }

          msg += ` It must be ${range}. Received ${received}`;
          return msg;
        }, RangeError);

        function addNumericalSeparator(val) {
          let res = '';
          let i = val.length;
          const start = val[0] === '-' ? 1 : 0;

          for (; i >= start + 4; i -= 3) {
            res = `_${val.slice(i - 3, i)}${res}`;
          }

          return `${val.slice(0, i)}${res}`;
        } // CHECK FUNCTIONS
        // ===============

        function checkBounds(buf, offset, byteLength) {
          validateNumber(offset, 'offset');

          if (buf[offset] === undefined || buf[offset + byteLength] === undefined) {
            boundsError(offset, buf.length - (byteLength + 1));
          }
        }

        function checkIntBI(value, min, max, buf, offset, byteLength) {
          if (value > max || value < min) {
            const n = typeof min === 'bigint' ? 'n' : '';
            let range;

            if (byteLength > 3) {
              if (min === 0 || min === BigInt(0)) {
                range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
              } else {
                range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
              }
            } else {
              range = `>= ${min}${n} and <= ${max}${n}`;
            }

            throw new errors.ERR_OUT_OF_RANGE('value', range, value);
          }

          checkBounds(buf, offset, byteLength);
        }

        function validateNumber(value, name) {
          if (typeof value !== 'number') {
            throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
          }
        }

        function boundsError(value, length, type) {
          if (Math.floor(value) !== value) {
            validateNumber(value, type);
            throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
          }

          if (length < 0) {
            throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
          }

          throw new errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
        } // HELPER FUNCTIONS
        // ================

        const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;

        function base64clean(str) {
          // Node takes equal signs as end of the Base64 encoding
          str = str.split('=')[0]; // Node strips out invalid characters like \n and \t from the string, base64-js does not

          str = str.trim().replace(INVALID_BASE64_RE, ''); // Node converts strings with length < 2 to ''

          if (str.length < 2) return ''; // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not

          while (str.length % 4 !== 0) {
            str = `${str}=`;
          }

          return str;
        }

        function utf8ToBytes(string, units) {
          units = units || Infinity;
          let codePoint;
          const { length } = string;
          let leadSurrogate = null;
          const bytes = [];

          for (let i = 0; i < length; ++i) {
            codePoint = string.charCodeAt(i); // is surrogate component

            if (codePoint > 0xD7FF && codePoint < 0xE000) {
              // last char was a lead
              if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                  // unexpected trail
                  if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                  continue;
                } else if (i + 1 === length) {
                  // unpaired lead
                  if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                  continue;
                } // valid lead

                leadSurrogate = codePoint;
                continue;
              } // 2 leads in a row

              if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
              } // valid surrogate pair

              codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
            } else if (leadSurrogate) {
              // valid bmp char, but last char was a lead
              if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            }

            leadSurrogate = null; // encode utf8

            if (codePoint < 0x80) {
              if ((units -= 1) < 0) break;
              bytes.push(codePoint);
            } else if (codePoint < 0x800) {
              if ((units -= 2) < 0) break;
              bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
            } else if (codePoint < 0x10000) {
              if ((units -= 3) < 0) break;
              bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
            } else if (codePoint < 0x110000) {
              if ((units -= 4) < 0) break;
              bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
            } else {
              throw new Error('Invalid code point');
            }
          }

          return bytes;
        }

        function asciiToBytes(str) {
          const byteArray = [];

          for (let i = 0; i < str.length; ++i) {
            // Node's code seems to be doing this and not & 0x7F..
            byteArray.push(str.charCodeAt(i) & 0xFF);
          }

          return byteArray;
        }

        function utf16leToBytes(str, units) {
          let c; let hi; let
            lo;
          const byteArray = [];

          for (let i = 0; i < str.length; ++i) {
            if ((units -= 2) < 0) break;
            c = str.charCodeAt(i);
            hi = c >> 8;
            lo = c % 256;
            byteArray.push(lo);
            byteArray.push(hi);
          }

          return byteArray;
        }

        function base64ToBytes(str) {
          return base64.toByteArray(base64clean(str));
        }

        function blitBuffer(src, dst, offset, length) {
          let i;

          for (i = 0; i < length; ++i) {
            if (i + offset >= dst.length || i >= src.length) break;
            dst[i + offset] = src[i];
          }

          return i;
        } // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
        // the `instanceof` check but they should be treated as of that type.
        // See: https://github.com/feross/buffer/issues/166

        function isInstance(obj, type) {
          return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
        }

        function numberIsNaN(obj) {
          // For IE11 support
          return obj !== obj; // eslint-disable-line no-self-compare
        } // Create lookup table for `toString('hex')`
        // See: https://github.com/feross/buffer/issues/219

        var hexSliceLookupTable = (function () {
          const alphabet = '0123456789abcdef';
          const table = new Array(256);

          for (let i = 0; i < 16; ++i) {
            const i16 = i * 16;

            for (let j = 0; j < 16; ++j) {
              table[i16 + j] = alphabet[i] + alphabet[j];
            }
          }

          return table;
        }()); // Return not function with Error if BigInt not supported

        function defineBigIntMethod(fn) {
          return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn;
        }

        function BufferBigIntNotDefined() {
          throw new Error('BigInt not supported');
        }
        /***/ }),

      /***/ 477:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        __webpack_require__(7803);

        __webpack_require__(1539);

        // eslint-disable-next-line es/no-typed-arrays -- safe
        module.exports = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined';
        /***/ }),

      /***/ 2094:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const NATIVE_ARRAY_BUFFER = __webpack_require__(477);

        const DESCRIPTORS = __webpack_require__(9781);

        const global = __webpack_require__(7854);

        const isCallable = __webpack_require__(614);

        const isObject = __webpack_require__(111);

        const hasOwn = __webpack_require__(2597);

        const classof = __webpack_require__(648);

        const tryToString = __webpack_require__(6330);

        const createNonEnumerableProperty = __webpack_require__(8880);

        const redefine = __webpack_require__(1320);

        const defineProperty = (__webpack_require__(3070).f);

        const isPrototypeOf = __webpack_require__(7976);

        const getPrototypeOf = __webpack_require__(9518);

        const setPrototypeOf = __webpack_require__(7674);

        const wellKnownSymbol = __webpack_require__(5112);

        const uid = __webpack_require__(9711);

        const { Int8Array } = global;
        const Int8ArrayPrototype = Int8Array && Int8Array.prototype;
        const { Uint8ClampedArray } = global;
        const Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
        let TypedArray = Int8Array && getPrototypeOf(Int8Array);
        let TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
        const ObjectPrototype = Object.prototype;
        const { TypeError } = global;
        const TO_STRING_TAG = wellKnownSymbol('toStringTag');
        const TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
        const TYPED_ARRAY_CONSTRUCTOR = uid('TYPED_ARRAY_CONSTRUCTOR'); // Fixing native typed arrays in Opera Presto crashes the browser, see #595

        let NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(global.opera) !== 'Opera';
        let TYPED_ARRAY_TAG_REQIRED = false;
        let NAME; let Constructor; let
          Prototype;
        const TypedArrayConstructorsList = {
          Int8Array: 1,
          Uint8Array: 1,
          Uint8ClampedArray: 1,
          Int16Array: 2,
          Uint16Array: 2,
          Int32Array: 4,
          Uint32Array: 4,
          Float32Array: 4,
          Float64Array: 8,
        };
        const BigIntArrayConstructorsList = {
          BigInt64Array: 8,
          BigUint64Array: 8,
        };

        const isView = function isView(it) {
          if (!isObject(it)) return false;
          const klass = classof(it);
          return klass === 'DataView' || hasOwn(TypedArrayConstructorsList, klass) || hasOwn(BigIntArrayConstructorsList, klass);
        };

        const isTypedArray = function isTypedArray(it) {
          if (!isObject(it)) return false;
          const klass = classof(it);
          return hasOwn(TypedArrayConstructorsList, klass) || hasOwn(BigIntArrayConstructorsList, klass);
        };

        const aTypedArray = function aTypedArray(it) {
          if (isTypedArray(it)) return it;
          throw TypeError('Target is not a typed array');
        };

        const aTypedArrayConstructor = function aTypedArrayConstructor(C) {
          if (isCallable(C) && (!setPrototypeOf || isPrototypeOf(TypedArray, C))) return C;
          throw TypeError(`${tryToString(C)} is not a typed array constructor`);
        };

        const exportTypedArrayMethod = function exportTypedArrayMethod(KEY, property, forced) {
          if (!DESCRIPTORS) return;
          if (forced) {
            for (const ARRAY in TypedArrayConstructorsList) {
              const TypedArrayConstructor = global[ARRAY];
              if (TypedArrayConstructor && hasOwn(TypedArrayConstructor.prototype, KEY)) {
                try {
                  delete TypedArrayConstructor.prototype[KEY];
                } catch (error) {
                  /* empty */
                }
              }
            }
          }

          if (!TypedArrayPrototype[KEY] || forced) {
            redefine(TypedArrayPrototype, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property);
          }
        };

        const exportTypedArrayStaticMethod = function exportTypedArrayStaticMethod(KEY, property, forced) {
          let ARRAY; let
            TypedArrayConstructor;
          if (!DESCRIPTORS) return;

          if (setPrototypeOf) {
            if (forced) {
              for (ARRAY in TypedArrayConstructorsList) {
                TypedArrayConstructor = global[ARRAY];
                if (TypedArrayConstructor && hasOwn(TypedArrayConstructor, KEY)) {
                  try {
                    delete TypedArrayConstructor[KEY];
                  } catch (error) {
                    /* empty */
                  }
                }
              }
            }

            if (!TypedArray[KEY] || forced) {
              // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
              try {
                return redefine(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
              } catch (error) {
                /* empty */
              }
            } else return;
          }

          for (ARRAY in TypedArrayConstructorsList) {
            TypedArrayConstructor = global[ARRAY];

            if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
              redefine(TypedArrayConstructor, KEY, property);
            }
          }
        };

        for (NAME in TypedArrayConstructorsList) {
          Constructor = global[NAME];
          Prototype = Constructor && Constructor.prototype;
          if (Prototype) createNonEnumerableProperty(Prototype, TYPED_ARRAY_CONSTRUCTOR, Constructor); else NATIVE_ARRAY_BUFFER_VIEWS = false;
        }

        for (NAME in BigIntArrayConstructorsList) {
          Constructor = global[NAME];
          Prototype = Constructor && Constructor.prototype;
          if (Prototype) createNonEnumerableProperty(Prototype, TYPED_ARRAY_CONSTRUCTOR, Constructor);
        } // WebKit bug - typed arrays constructors prototype is Object.prototype

        if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
          // eslint-disable-next-line no-shadow -- safe
          TypedArray = function TypedArray() {
            throw TypeError('Incorrect invocation');
          };

          if (NATIVE_ARRAY_BUFFER_VIEWS) {
            for (NAME in TypedArrayConstructorsList) {
              if (global[NAME]) setPrototypeOf(global[NAME], TypedArray);
            }
          }
        }

        if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
          TypedArrayPrototype = TypedArray.prototype;
          if (NATIVE_ARRAY_BUFFER_VIEWS) {
            for (NAME in TypedArrayConstructorsList) {
              if (global[NAME]) setPrototypeOf(global[NAME].prototype, TypedArrayPrototype);
            }
          }
        } // WebKit bug - one more object in Uint8ClampedArray prototype chain

        if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
          setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
        }

        if (DESCRIPTORS && !hasOwn(TypedArrayPrototype, TO_STRING_TAG)) {
          TYPED_ARRAY_TAG_REQIRED = true;
          defineProperty(TypedArrayPrototype, TO_STRING_TAG, {
            get: function get() {
              return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
            },
          });

          for (NAME in TypedArrayConstructorsList) {
            if (global[NAME]) {
              createNonEnumerableProperty(global[NAME], TYPED_ARRAY_TAG, NAME);
            }
          }
        }

        module.exports = {
          NATIVE_ARRAY_BUFFER_VIEWS,
          TYPED_ARRAY_CONSTRUCTOR,
          TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQIRED && TYPED_ARRAY_TAG,
          aTypedArray,
          aTypedArrayConstructor,
          exportTypedArrayMethod,
          exportTypedArrayStaticMethod,
          isView,
          isTypedArray,
          TypedArray,
          TypedArrayPrototype,
        };
        /***/ }),

      /***/ 2091:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        __webpack_require__(8309);

        const global = __webpack_require__(7854);

        const uncurryThis = __webpack_require__(1702);

        const DESCRIPTORS = __webpack_require__(9781);

        const NATIVE_ARRAY_BUFFER = __webpack_require__(477);

        const FunctionName = __webpack_require__(6530);

        const createNonEnumerableProperty = __webpack_require__(8880);

        const redefineAll = __webpack_require__(2248);

        const fails = __webpack_require__(7293);

        const anInstance = __webpack_require__(5787);

        const toIntegerOrInfinity = __webpack_require__(9303);

        const toLength = __webpack_require__(7466);

        const toIndex = __webpack_require__(7067);

        const IEEE754 = __webpack_require__(1179);

        const getPrototypeOf = __webpack_require__(9518);

        const setPrototypeOf = __webpack_require__(7674);

        const getOwnPropertyNames = (__webpack_require__(8006).f);

        const defineProperty = (__webpack_require__(3070).f);

        const arrayFill = __webpack_require__(1285);

        const arraySlice = __webpack_require__(206);

        const setToStringTag = __webpack_require__(8003);

        const InternalStateModule = __webpack_require__(9909);

        const PROPER_FUNCTION_NAME = FunctionName.PROPER;
        const CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
        const getInternalState = InternalStateModule.get;
        const setInternalState = InternalStateModule.set;
        const ARRAY_BUFFER = 'ArrayBuffer';
        const DATA_VIEW = 'DataView';
        const PROTOTYPE = 'prototype';
        const WRONG_LENGTH = 'Wrong length';
        const WRONG_INDEX = 'Wrong index';
        const NativeArrayBuffer = global[ARRAY_BUFFER];
        let $ArrayBuffer = NativeArrayBuffer;
        let ArrayBufferPrototype = $ArrayBuffer && $ArrayBuffer[PROTOTYPE];
        let $DataView = global[DATA_VIEW];
        let DataViewPrototype = $DataView && $DataView[PROTOTYPE];
        const ObjectPrototype = Object.prototype;
        const { Array } = global;
        const { RangeError } = global;
        const fill = uncurryThis(arrayFill);
        const reverse = uncurryThis([].reverse);
        const packIEEE754 = IEEE754.pack;
        const unpackIEEE754 = IEEE754.unpack;

        const packInt8 = function packInt8(number) {
          return [number & 0xFF];
        };

        const packInt16 = function packInt16(number) {
          return [number & 0xFF, number >> 8 & 0xFF];
        };

        const packInt32 = function packInt32(number) {
          return [number & 0xFF, number >> 8 & 0xFF, number >> 16 & 0xFF, number >> 24 & 0xFF];
        };

        const unpackInt32 = function unpackInt32(buffer) {
          return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
        };

        const packFloat32 = function packFloat32(number) {
          return packIEEE754(number, 23, 4);
        };

        const packFloat64 = function packFloat64(number) {
          return packIEEE754(number, 52, 8);
        };

        const addGetter = function addGetter(Constructor, key) {
          defineProperty(Constructor[PROTOTYPE], key, {
            get: function get() {
              return getInternalState(this)[key];
            },
          });
        };

        const get = function get(view, count, index, isLittleEndian) {
          const intIndex = toIndex(index);
          const store = getInternalState(view);
          if (intIndex + count > store.byteLength) throw RangeError(WRONG_INDEX);
          const { bytes } = getInternalState(store.buffer);
          const start = intIndex + store.byteOffset;
          const pack = arraySlice(bytes, start, start + count);
          return isLittleEndian ? pack : reverse(pack);
        };

        const set = function set(view, count, index, conversion, value, isLittleEndian) {
          const intIndex = toIndex(index);
          const store = getInternalState(view);
          if (intIndex + count > store.byteLength) throw RangeError(WRONG_INDEX);
          const { bytes } = getInternalState(store.buffer);
          const start = intIndex + store.byteOffset;
          const pack = conversion(+value);

          for (let i = 0; i < count; i++) {
            bytes[start + i] = pack[isLittleEndian ? i : count - i - 1];
          }
        };

        if (!NATIVE_ARRAY_BUFFER) {
          $ArrayBuffer = function ArrayBuffer(length) {
            anInstance(this, ArrayBufferPrototype);
            const byteLength = toIndex(length);
            setInternalState(this, {
              bytes: fill(Array(byteLength), 0),
              byteLength,
            });
            if (!DESCRIPTORS) this.byteLength = byteLength;
          };

          ArrayBufferPrototype = $ArrayBuffer[PROTOTYPE];

          $DataView = function DataView(buffer, byteOffset, byteLength) {
            anInstance(this, DataViewPrototype);
            anInstance(buffer, ArrayBufferPrototype);
            const bufferLength = getInternalState(buffer).byteLength;
            const offset = toIntegerOrInfinity(byteOffset);
            if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset');
            byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
            if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
            setInternalState(this, {
              buffer,
              byteLength,
              byteOffset: offset,
            });

            if (!DESCRIPTORS) {
              this.buffer = buffer;
              this.byteLength = byteLength;
              this.byteOffset = offset;
            }
          };

          DataViewPrototype = $DataView[PROTOTYPE];

          if (DESCRIPTORS) {
            addGetter($ArrayBuffer, 'byteLength');
            addGetter($DataView, 'buffer');
            addGetter($DataView, 'byteLength');
            addGetter($DataView, 'byteOffset');
          }

          redefineAll(DataViewPrototype, {
            getInt8: function getInt8(byteOffset) {
              return get(this, 1, byteOffset)[0] << 24 >> 24;
            },
            getUint8: function getUint8(byteOffset) {
              return get(this, 1, byteOffset)[0];
            },
            getInt16: function getInt16(byteOffset,
              /* , littleEndian */
            ) {
              const bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
              return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
            },
            getUint16: function getUint16(byteOffset,
              /* , littleEndian */
            ) {
              const bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
              return bytes[1] << 8 | bytes[0];
            },
            getInt32: function getInt32(byteOffset,
              /* , littleEndian */
            ) {
              return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined));
            },
            getUint32: function getUint32(byteOffset,
              /* , littleEndian */
            ) {
              return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined)) >>> 0;
            },
            getFloat32: function getFloat32(byteOffset,
              /* , littleEndian */
            ) {
              return unpackIEEE754(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 23);
            },
            getFloat64: function getFloat64(byteOffset,
              /* , littleEndian */
            ) {
              return unpackIEEE754(get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 52);
            },
            setInt8: function setInt8(byteOffset, value) {
              set(this, 1, byteOffset, packInt8, value);
            },
            setUint8: function setUint8(byteOffset, value) {
              set(this, 1, byteOffset, packInt8, value);
            },
            setInt16: function setInt16(byteOffset, value,
              /* , littleEndian */
            ) {
              set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
            },
            setUint16: function setUint16(byteOffset, value,
              /* , littleEndian */
            ) {
              set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
            },
            setInt32: function setInt32(byteOffset, value,
              /* , littleEndian */
            ) {
              set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
            },
            setUint32: function setUint32(byteOffset, value,
              /* , littleEndian */
            ) {
              set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
            },
            setFloat32: function setFloat32(byteOffset, value,
              /* , littleEndian */
            ) {
              set(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : undefined);
            },
            setFloat64: function setFloat64(byteOffset, value,
              /* , littleEndian */
            ) {
              set(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : undefined);
            },
          });
        } else {
          const INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME && NativeArrayBuffer.name !== ARRAY_BUFFER;
          /* eslint-disable no-new -- required for testing */

          if (!fails(() => {
            NativeArrayBuffer(1);
          }) || !fails(() => {
            new NativeArrayBuffer(-1);
          }) || fails(() => {
            new NativeArrayBuffer();
            new NativeArrayBuffer(1.5);
            new NativeArrayBuffer(NaN);
            return INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
          })) {
            /* eslint-enable no-new -- required for testing */
            $ArrayBuffer = function ArrayBuffer(length) {
              anInstance(this, ArrayBufferPrototype);
              return new NativeArrayBuffer(toIndex(length));
            };

            $ArrayBuffer[PROTOTYPE] = ArrayBufferPrototype;

            for (var keys = getOwnPropertyNames(NativeArrayBuffer), j = 0, key; keys.length > j;) {
              if (!((key = keys[j++]) in $ArrayBuffer)) {
                createNonEnumerableProperty($ArrayBuffer, key, NativeArrayBuffer[key]);
              }
            }

            ArrayBufferPrototype.constructor = $ArrayBuffer;
          } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) {
            createNonEnumerableProperty(NativeArrayBuffer, 'name', ARRAY_BUFFER);
          } // WebKit bug - the same parent prototype for typed arrays and data view

          if (setPrototypeOf && getPrototypeOf(DataViewPrototype) !== ObjectPrototype) {
            setPrototypeOf(DataViewPrototype, ObjectPrototype);
          } // iOS Safari 7.x bug

          const testView = new $DataView(new $ArrayBuffer(2));
          const $setInt8 = uncurryThis(DataViewPrototype.setInt8);
          testView.setInt8(0, 2147483648);
          testView.setInt8(1, 2147483649);
          if (testView.getInt8(0) || !testView.getInt8(1)) {
            redefineAll(DataViewPrototype, {
              setInt8: function setInt8(byteOffset, value) {
                $setInt8(this, byteOffset, value << 24 >> 24);
              },
              setUint8: function setUint8(byteOffset, value) {
                $setInt8(this, byteOffset, value << 24 >> 24);
              },
            }, {
              unsafe: true,
            });
          }
        }

        setToStringTag($ArrayBuffer, ARRAY_BUFFER);
        setToStringTag($DataView, DATA_VIEW);
        module.exports = {
          ArrayBuffer: $ArrayBuffer,
          DataView: $DataView,
        };
        /***/ }),

      /***/ 7803:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);

        const global = __webpack_require__(7854);

        const arrayBufferModule = __webpack_require__(2091);

        const setSpecies = __webpack_require__(6340);

        const ARRAY_BUFFER = 'ArrayBuffer';
        const ArrayBuffer = arrayBufferModule[ARRAY_BUFFER];
        const NativeArrayBuffer = global[ARRAY_BUFFER]; // `ArrayBuffer` constructor
        // https://tc39.es/ecma262/#sec-arraybuffer-constructor

        $({
          global: true,
          forced: NativeArrayBuffer !== ArrayBuffer,
        }, {
          ArrayBuffer,
        });
        setSpecies(ARRAY_BUFFER);
        /***/ }),

      /***/ 194:
      /***/ (function (module, exports, __webpack_require__) {
        (function (root, factory, undef) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757), __webpack_require__(7508), __webpack_require__(3440), __webpack_require__(3839), __webpack_require__(1582));
          } else {}
        }(void 0, (CryptoJS) => {
          (function () {
            // Shortcuts
            const C = CryptoJS;
            const C_lib = C.lib;
            const { BlockCipher } = C_lib;
            const C_algo = C.algo; // Lookup tables

            const SBOX = [];
            const INV_SBOX = [];
            const SUB_MIX_0 = [];
            const SUB_MIX_1 = [];
            const SUB_MIX_2 = [];
            const SUB_MIX_3 = [];
            const INV_SUB_MIX_0 = [];
            const INV_SUB_MIX_1 = [];
            const INV_SUB_MIX_2 = [];
            const INV_SUB_MIX_3 = []; // Compute lookup tables

            (function () {
              // Compute double table
              const d = [];

              for (var i = 0; i < 256; i++) {
                if (i < 128) {
                  d[i] = i << 1;
                } else {
                  d[i] = i << 1 ^ 0x11b;
                }
              } // Walk GF(2^8)

              let x = 0;
              let xi = 0;

              for (var i = 0; i < 256; i++) {
                // Compute sbox
                let sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
                sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
                SBOX[x] = sx;
                INV_SBOX[sx] = x; // Compute multiplication

                const x2 = d[x];
                const x4 = d[x2];
                const x8 = d[x4]; // Compute sub bytes, mix columns tables

                var t = d[sx] * 0x101 ^ sx * 0x1010100;
                SUB_MIX_0[x] = t << 24 | t >>> 8;
                SUB_MIX_1[x] = t << 16 | t >>> 16;
                SUB_MIX_2[x] = t << 8 | t >>> 24;
                SUB_MIX_3[x] = t; // Compute inv sub bytes, inv mix columns tables

                var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
                INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
                INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
                INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
                INV_SUB_MIX_3[sx] = t; // Compute next counter

                if (!x) {
                  x = xi = 1;
                } else {
                  x = x2 ^ d[d[d[x8 ^ x2]]];
                  xi ^= d[d[xi]];
                }
              }
            }()); // Precomputed Rcon lookup

            const RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
            /**
     * AES block cipher algorithm.
     */

            const AES = C_algo.AES = BlockCipher.extend({
              _doReset: function _doReset() {
                var t; // Skip reset of nRounds has been set before and key did not change

                if (this._nRounds && this._keyPriorReset === this._key) {
                  return;
                } // Shortcuts

                const key = this._keyPriorReset = this._key;
                const keyWords = key.words;
                const keySize = key.sigBytes / 4; // Compute number of rounds

                const nRounds = this._nRounds = keySize + 6; // Compute number of key schedule rows

                const ksRows = (nRounds + 1) * 4; // Compute key schedule

                const keySchedule = this._keySchedule = [];

                for (var ksRow = 0; ksRow < ksRows; ksRow++) {
                  if (ksRow < keySize) {
                    keySchedule[ksRow] = keyWords[ksRow];
                  } else {
                    t = keySchedule[ksRow - 1];

                    if (!(ksRow % keySize)) {
                      // Rot word
                      t = t << 8 | t >>> 24; // Sub word

                      t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff]; // Mix Rcon

                      t ^= RCON[ksRow / keySize | 0] << 24;
                    } else if (keySize > 6 && ksRow % keySize == 4) {
                      // Sub word
                      t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                    }

                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                  }
                } // Compute inv key schedule

                const invKeySchedule = this._invKeySchedule = [];

                for (let invKsRow = 0; invKsRow < ksRows; invKsRow++) {
                  var ksRow = ksRows - invKsRow;

                  if (invKsRow % 4) {
                    var t = keySchedule[ksRow];
                  } else {
                    var t = keySchedule[ksRow - 4];
                  }

                  if (invKsRow < 4 || ksRow <= 4) {
                    invKeySchedule[invKsRow] = t;
                  } else {
                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
                  }
                }
              },
              encryptBlock: function encryptBlock(M, offset) {
                this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
              },
              decryptBlock: function decryptBlock(M, offset) {
                // Swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;

                this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX); // Inv swap 2nd and 4th rows

                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
              },
              _doCryptBlock: function _doCryptBlock(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
                // Shortcut
                const nRounds = this._nRounds; // Get input, add round key

                let s0 = M[offset] ^ keySchedule[0];
                let s1 = M[offset + 1] ^ keySchedule[1];
                let s2 = M[offset + 2] ^ keySchedule[2];
                let s3 = M[offset + 3] ^ keySchedule[3]; // Key schedule row counter

                let ksRow = 4; // Rounds

                for (let round = 1; round < nRounds; round++) {
                  // Shift rows, sub bytes, mix columns, add round key
                  var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
                  var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
                  var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
                  var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++]; // Update state

                  s0 = t0;
                  s1 = t1;
                  s2 = t2;
                  s3 = t3;
                } // Shift rows, sub bytes, add round key

                var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
                var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
                var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
                var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]; // Set output

                M[offset] = t0;
                M[offset + 1] = t1;
                M[offset + 2] = t2;
                M[offset + 3] = t3;
              },
              keySize: 256 / 32,
            });
            /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
     */

            C.AES = BlockCipher._createHelper(AES);
          }());

          return CryptoJS.AES;
        }));
        /***/ }),

      /***/ 1582:
      /***/ (function (module, exports, __webpack_require__) {
        __webpack_require__(7042);

        __webpack_require__(2222);

        __webpack_require__(1539);

        __webpack_require__(9714);

        __webpack_require__(561);

        (function (root, factory, undef) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757), __webpack_require__(3839));
          } else {}
        }(void 0, (CryptoJS) => {
          /**
   * Cipher core components.
   */
          CryptoJS.lib.Cipher || (function (undefined) {
            // Shortcuts
            const C = CryptoJS;
            const C_lib = C.lib;
            const { Base } = C_lib;
            const { WordArray } = C_lib;
            const { BufferedBlockAlgorithm } = C_lib;
            const C_enc = C.enc;
            const { Utf8 } = C_enc;
            const { Base64 } = C_enc;
            const C_algo = C.algo;
            const { EvpKDF } = C_algo;
            /**
     * Abstract base cipher template.
     *
     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
     */

            const Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
              /**
       * Configuration options.
       *
       * @property {WordArray} iv The IV to use for this operation.
       */
              cfg: Base.extend(),

              /**
       * Creates this cipher in encryption mode.
       *
       * @param {WordArray} key The key.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @return {Cipher} A cipher instance.
       *
       * @static
       *
       * @example
       *
       *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
       */
              createEncryptor: function createEncryptor(key, cfg) {
                return this.create(this._ENC_XFORM_MODE, key, cfg);
              },

              /**
       * Creates this cipher in decryption mode.
       *
       * @param {WordArray} key The key.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @return {Cipher} A cipher instance.
       *
       * @static
       *
       * @example
       *
       *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
       */
              createDecryptor: function createDecryptor(key, cfg) {
                return this.create(this._DEC_XFORM_MODE, key, cfg);
              },

              /**
       * Initializes a newly created cipher.
       *
       * @param {number} xformMode Either the encryption or decryption transormation mode constant.
       * @param {WordArray} key The key.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @example
       *
       *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
       */
              init: function init(xformMode, key, cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg); // Store transform mode and key

                this._xformMode = xformMode;
                this._key = key; // Set initial values

                this.reset();
              },

              /**
       * Resets this cipher to its initial state.
       *
       * @example
       *
       *     cipher.reset();
       */
              reset: function reset() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this); // Perform concrete-cipher logic

                this._doReset();
              },

              /**
       * Adds data to be encrypted or decrypted.
       *
       * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
       *
       * @return {WordArray} The data after processing.
       *
       * @example
       *
       *     var encrypted = cipher.process('data');
       *     var encrypted = cipher.process(wordArray);
       */
              process: function process(dataUpdate) {
                // Append
                this._append(dataUpdate); // Process available blocks

                return this._process();
              },

              /**
       * Finalizes the encryption or decryption process.
       * Note that the finalize operation is effectively a destructive, read-once operation.
       *
       * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
       *
       * @return {WordArray} The data after final processing.
       *
       * @example
       *
       *     var encrypted = cipher.finalize();
       *     var encrypted = cipher.finalize('data');
       *     var encrypted = cipher.finalize(wordArray);
       */
              finalize: function finalize(dataUpdate) {
                // Final data update
                if (dataUpdate) {
                  this._append(dataUpdate);
                } // Perform concrete-cipher logic

                const finalProcessedData = this._doFinalize();

                return finalProcessedData;
              },
              keySize: 128 / 32,
              ivSize: 128 / 32,
              _ENC_XFORM_MODE: 1,
              _DEC_XFORM_MODE: 2,

              /**
       * Creates shortcut functions to a cipher's object interface.
       *
       * @param {Cipher} cipher The cipher to create a helper for.
       *
       * @return {Object} An object with encrypt and decrypt shortcut functions.
       *
       * @static
       *
       * @example
       *
       *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
       */
              _createHelper: (function () {
                function selectCipherStrategy(key) {
                  if (typeof key === 'string') {
                    return PasswordBasedCipher;
                  }
                  return SerializableCipher;
                }

                return function (cipher) {
                  return {
                    encrypt: function encrypt(message, key, cfg) {
                      return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                    },
                    decrypt: function decrypt(ciphertext, key, cfg) {
                      return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                    },
                  };
                };
              }()),
            });
            /**
     * Abstract base stream cipher template.
     *
     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
     */

            const StreamCipher = C_lib.StreamCipher = Cipher.extend({
              _doFinalize: function _doFinalize() {
                // Process partial blocks
                const finalProcessedBlocks = this._process(!!'flush');

                return finalProcessedBlocks;
              },
              blockSize: 1,
            });
            /**
     * Mode namespace.
     */

            const C_mode = C.mode = {};
            /**
     * Abstract base block cipher mode template.
     */

            const BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
              /**
       * Creates this mode for encryption.
       *
       * @param {Cipher} cipher A block cipher instance.
       * @param {Array} iv The IV words.
       *
       * @static
       *
       * @example
       *
       *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
       */
              createEncryptor: function createEncryptor(cipher, iv) {
                return this.Encryptor.create(cipher, iv);
              },

              /**
       * Creates this mode for decryption.
       *
       * @param {Cipher} cipher A block cipher instance.
       * @param {Array} iv The IV words.
       *
       * @static
       *
       * @example
       *
       *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
       */
              createDecryptor: function createDecryptor(cipher, iv) {
                return this.Decryptor.create(cipher, iv);
              },

              /**
       * Initializes a newly created mode.
       *
       * @param {Cipher} cipher A block cipher instance.
       * @param {Array} iv The IV words.
       *
       * @example
       *
       *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
       */
              init: function init(cipher, iv) {
                this._cipher = cipher;
                this._iv = iv;
              },
            });
            /**
     * Cipher Block Chaining mode.
     */

            const CBC = C_mode.CBC = (function () {
              /**
       * Abstract base CBC mode.
       */
              const CBC = BlockCipherMode.extend();
              /**
       * CBC encryptor.
       */

              CBC.Encryptor = CBC.extend({
                /**
         * Processes the data block at offset.
         *
         * @param {Array} words The data words to operate on.
         * @param {number} offset The offset where the block starts.
         *
         * @example
         *
         *     mode.processBlock(data.words, offset);
         */
                processBlock: function processBlock(words, offset) {
                  // Shortcuts
                  const cipher = this._cipher;
                  const { blockSize } = cipher; // XOR and encrypt

                  xorBlock.call(this, words, offset, blockSize);
                  cipher.encryptBlock(words, offset); // Remember this block to use with next block

                  this._prevBlock = words.slice(offset, offset + blockSize);
                },
              });
              /**
       * CBC decryptor.
       */

              CBC.Decryptor = CBC.extend({
                /**
         * Processes the data block at offset.
         *
         * @param {Array} words The data words to operate on.
         * @param {number} offset The offset where the block starts.
         *
         * @example
         *
         *     mode.processBlock(data.words, offset);
         */
                processBlock: function processBlock(words, offset) {
                  // Shortcuts
                  const cipher = this._cipher;
                  const { blockSize } = cipher; // Remember this block to use with next block

                  const thisBlock = words.slice(offset, offset + blockSize); // Decrypt and XOR

                  cipher.decryptBlock(words, offset);
                  xorBlock.call(this, words, offset, blockSize); // This block becomes the previous block

                  this._prevBlock = thisBlock;
                },
              });

              function xorBlock(words, offset, blockSize) {
                let block; // Shortcut

                const iv = this._iv; // Choose mixing block

                if (iv) {
                  block = iv; // Remove IV for subsequent blocks

                  this._iv = undefined;
                } else {
                  block = this._prevBlock;
                } // XOR blocks

                for (let i = 0; i < blockSize; i++) {
                  words[offset + i] ^= block[i];
                }
              }

              return CBC;
            }());
            /**
     * Padding namespace.
     */

            const C_pad = C.pad = {};
            /**
     * PKCS #5/7 padding strategy.
     */

            const Pkcs7 = C_pad.Pkcs7 = {
              /**
       * Pads data using the algorithm defined in PKCS #5/7.
       *
       * @param {WordArray} data The data to pad.
       * @param {number} blockSize The multiple that the data should be padded to.
       *
       * @static
       *
       * @example
       *
       *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
       */
              pad: function pad(data, blockSize) {
                // Shortcut
                const blockSizeBytes = blockSize * 4; // Count padding bytes

                const nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes; // Create padding word

                const paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes; // Create padding

                const paddingWords = [];

                for (let i = 0; i < nPaddingBytes; i += 4) {
                  paddingWords.push(paddingWord);
                }

                const padding = WordArray.create(paddingWords, nPaddingBytes); // Add padding

                data.concat(padding);
              },

              /**
       * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
       *
       * @param {WordArray} data The data to unpad.
       *
       * @static
       *
       * @example
       *
       *     CryptoJS.pad.Pkcs7.unpad(wordArray);
       */
              unpad: function unpad(data) {
                // Get number of padding bytes from last byte
                const nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff; // Remove padding

                data.sigBytes -= nPaddingBytes;
              },
            };
            /**
     * Abstract base block cipher template.
     *
     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
     */

            const BlockCipher = C_lib.BlockCipher = Cipher.extend({
              /**
       * Configuration options.
       *
       * @property {Mode} mode The block mode to use. Default: CBC
       * @property {Padding} padding The padding strategy to use. Default: Pkcs7
       */
              cfg: Cipher.cfg.extend({
                mode: CBC,
                padding: Pkcs7,
              }),
              reset: function reset() {
                let modeCreator; // Reset cipher

                Cipher.reset.call(this); // Shortcuts

                const { cfg } = this;
                const { iv } = cfg;
                const { mode } = cfg; // Reset block mode

                if (this._xformMode == this._ENC_XFORM_MODE) {
                  modeCreator = mode.createEncryptor;
                } else
                /* if (this._xformMode == this._DEC_XFORM_MODE) */
                {
                  modeCreator = mode.createDecryptor; // Keep at least one block in the buffer for unpadding

                  this._minBufferSize = 1;
                }

                if (this._mode && this._mode.__creator == modeCreator) {
                  this._mode.init(this, iv && iv.words);
                } else {
                  this._mode = modeCreator.call(mode, this, iv && iv.words);
                  this._mode.__creator = modeCreator;
                }
              },
              _doProcessBlock: function _doProcessBlock(words, offset) {
                this._mode.processBlock(words, offset);
              },
              _doFinalize: function _doFinalize() {
                let finalProcessedBlocks; // Shortcut

                const { padding } = this.cfg; // Finalize

                if (this._xformMode == this._ENC_XFORM_MODE) {
                  // Pad data
                  padding.pad(this._data, this.blockSize); // Process final blocks

                  finalProcessedBlocks = this._process(!!'flush');
                } else
                /* if (this._xformMode == this._DEC_XFORM_MODE) */
                {
                  // Process final blocks
                  finalProcessedBlocks = this._process(!!'flush'); // Unpad data

                  padding.unpad(finalProcessedBlocks);
                }

                return finalProcessedBlocks;
              },
              blockSize: 128 / 32,
            });
            /**
     * A collection of cipher parameters.
     *
     * @property {WordArray} ciphertext The raw ciphertext.
     * @property {WordArray} key The key to this ciphertext.
     * @property {WordArray} iv The IV used in the ciphering operation.
     * @property {WordArray} salt The salt used with a key derivation function.
     * @property {Cipher} algorithm The cipher algorithm.
     * @property {Mode} mode The block mode used in the ciphering operation.
     * @property {Padding} padding The padding scheme used in the ciphering operation.
     * @property {number} blockSize The block size of the cipher.
     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
     */

            const CipherParams = C_lib.CipherParams = Base.extend({
              /**
       * Initializes a newly created cipher params object.
       *
       * @param {Object} cipherParams An object with any of the possible cipher parameters.
       *
       * @example
       *
       *     var cipherParams = CryptoJS.lib.CipherParams.create({
       *         ciphertext: ciphertextWordArray,
       *         key: keyWordArray,
       *         iv: ivWordArray,
       *         salt: saltWordArray,
       *         algorithm: CryptoJS.algo.AES,
       *         mode: CryptoJS.mode.CBC,
       *         padding: CryptoJS.pad.PKCS7,
       *         blockSize: 4,
       *         formatter: CryptoJS.format.OpenSSL
       *     });
       */
              init: function init(cipherParams) {
                this.mixIn(cipherParams);
              },

              /**
       * Converts this cipher params object to a string.
       *
       * @param {Format} formatter (Optional) The formatting strategy to use.
       *
       * @return {string} The stringified cipher params.
       *
       * @throws Error If neither the formatter nor the default formatter is set.
       *
       * @example
       *
       *     var string = cipherParams + '';
       *     var string = cipherParams.toString();
       *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
       */
              toString: function toString(formatter) {
                return (formatter || this.formatter).stringify(this);
              },
            });
            /**
     * Format namespace.
     */

            const C_format = C.format = {};
            /**
     * OpenSSL formatting strategy.
     */

            const OpenSSLFormatter = C_format.OpenSSL = {
              /**
       * Converts a cipher params object to an OpenSSL-compatible string.
       *
       * @param {CipherParams} cipherParams The cipher params object.
       *
       * @return {string} The OpenSSL-compatible string.
       *
       * @static
       *
       * @example
       *
       *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
       */
              stringify: function stringify(cipherParams) {
                let wordArray; // Shortcuts

                const { ciphertext } = cipherParams;
                const { salt } = cipherParams; // Format

                if (salt) {
                  wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
                } else {
                  wordArray = ciphertext;
                }

                return wordArray.toString(Base64);
              },

              /**
       * Converts an OpenSSL-compatible string to a cipher params object.
       *
       * @param {string} openSSLStr The OpenSSL-compatible string.
       *
       * @return {CipherParams} The cipher params object.
       *
       * @static
       *
       * @example
       *
       *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
       */
              parse: function parse(openSSLStr) {
                let salt; // Parse base64

                const ciphertext = Base64.parse(openSSLStr); // Shortcut

                const ciphertextWords = ciphertext.words; // Test for salt

                if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
                  // Extract salt
                  salt = WordArray.create(ciphertextWords.slice(2, 4)); // Remove salt from ciphertext

                  ciphertextWords.splice(0, 4);
                  ciphertext.sigBytes -= 16;
                }

                return CipherParams.create({
                  ciphertext,
                  salt,
                });
              },
            };
            /**
     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
     */

            var SerializableCipher = C_lib.SerializableCipher = Base.extend({
              /**
       * Configuration options.
       *
       * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
       */
              cfg: Base.extend({
                format: OpenSSLFormatter,
              }),

              /**
       * Encrypts a message.
       *
       * @param {Cipher} cipher The cipher algorithm to use.
       * @param {WordArray|string} message The message to encrypt.
       * @param {WordArray} key The key.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @return {CipherParams} A cipher params object.
       *
       * @static
       *
       * @example
       *
       *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
       *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
       *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
       */
              encrypt: function encrypt(cipher, message, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg); // Encrypt

                const encryptor = cipher.createEncryptor(key, cfg);
                const ciphertext = encryptor.finalize(message); // Shortcut

                const cipherCfg = encryptor.cfg; // Create and return serializable cipher params

                return CipherParams.create({
                  ciphertext,
                  key,
                  iv: cipherCfg.iv,
                  algorithm: cipher,
                  mode: cipherCfg.mode,
                  padding: cipherCfg.padding,
                  blockSize: cipher.blockSize,
                  formatter: cfg.format,
                });
              },

              /**
       * Decrypts serialized ciphertext.
       *
       * @param {Cipher} cipher The cipher algorithm to use.
       * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
       * @param {WordArray} key The key.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @return {WordArray} The plaintext.
       *
       * @static
       *
       * @example
       *
       *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
       *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
       */
              decrypt: function decrypt(cipher, ciphertext, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg); // Convert string to CipherParams

                ciphertext = this._parse(ciphertext, cfg.format); // Decrypt

                const plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
                return plaintext;
              },

              /**
       * Converts serialized ciphertext to CipherParams,
       * else assumed CipherParams already and returns ciphertext unchanged.
       *
       * @param {CipherParams|string} ciphertext The ciphertext.
       * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
       *
       * @return {CipherParams} The unserialized ciphertext.
       *
       * @static
       *
       * @example
       *
       *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
       */
              _parse: function _parse(ciphertext, format) {
                if (typeof ciphertext === 'string') {
                  return format.parse(ciphertext, this);
                }
                return ciphertext;
              },
            });
            /**
     * Key derivation function namespace.
     */

            const C_kdf = C.kdf = {};
            /**
     * OpenSSL key derivation function.
     */

            const OpenSSLKdf = C_kdf.OpenSSL = {
              /**
       * Derives a key and IV from a password.
       *
       * @param {string} password The password to derive from.
       * @param {number} keySize The size in words of the key to generate.
       * @param {number} ivSize The size in words of the IV to generate.
       * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
       *
       * @return {CipherParams} A cipher params object with the key, IV, and salt.
       *
       * @static
       *
       * @example
       *
       *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
       *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
       */
              execute: function execute(password, keySize, ivSize, salt) {
                // Generate random salt
                if (!salt) {
                  salt = WordArray.random(64 / 8);
                } // Derive key and IV

                const key = EvpKDF.create({
                  keySize: keySize + ivSize,
                }).compute(password, salt); // Separate key and IV

                const iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
                key.sigBytes = keySize * 4; // Return params

                return CipherParams.create({
                  key,
                  iv,
                  salt,
                });
              },
            };
            /**
     * A serializable cipher wrapper that derives the key from a password,
     * and returns ciphertext as a serializable cipher params object.
     */

            var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
              /**
       * Configuration options.
       *
       * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
       */
              cfg: SerializableCipher.cfg.extend({
                kdf: OpenSSLKdf,
              }),

              /**
       * Encrypts a message using a password.
       *
       * @param {Cipher} cipher The cipher algorithm to use.
       * @param {WordArray|string} message The message to encrypt.
       * @param {string} password The password.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @return {CipherParams} A cipher params object.
       *
       * @static
       *
       * @example
       *
       *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
       *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
       */
              encrypt: function encrypt(cipher, message, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg); // Derive key and other params

                const derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize); // Add IV to config

                cfg.iv = derivedParams.iv; // Encrypt

                const ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg); // Mix in derived params

                ciphertext.mixIn(derivedParams);
                return ciphertext;
              },

              /**
       * Decrypts serialized ciphertext using a password.
       *
       * @param {Cipher} cipher The cipher algorithm to use.
       * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
       * @param {string} password The password.
       * @param {Object} cfg (Optional) The configuration options to use for this operation.
       *
       * @return {WordArray} The plaintext.
       *
       * @static
       *
       * @example
       *
       *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
       *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
       */
              decrypt: function decrypt(cipher, ciphertext, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg); // Convert string to CipherParams

                ciphertext = this._parse(ciphertext, cfg.format); // Derive key and other params

                const derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt); // Add IV to config

                cfg.iv = derivedParams.iv; // Decrypt

                const plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
                return plaintext;
              },
            });
          }());
        }));
        /***/ }),

      /***/ 757:
      /***/ (function (module, exports, __webpack_require__) {
        __webpack_require__(5743);

        __webpack_require__(6992);

        __webpack_require__(1539);

        __webpack_require__(9135);

        __webpack_require__(2990);

        __webpack_require__(8927);

        __webpack_require__(3105);

        __webpack_require__(5035);

        __webpack_require__(4345);

        __webpack_require__(7174);

        __webpack_require__(2846);

        __webpack_require__(4731);

        __webpack_require__(7209);

        __webpack_require__(6319);

        __webpack_require__(8867);

        __webpack_require__(7789);

        __webpack_require__(3739);

        __webpack_require__(9368);

        __webpack_require__(4483);

        __webpack_require__(2056);

        __webpack_require__(3462);

        __webpack_require__(678);

        __webpack_require__(7462);

        __webpack_require__(3824);

        __webpack_require__(5021);

        __webpack_require__(2974);

        __webpack_require__(5016);

        __webpack_require__(9714);

        __webpack_require__(7042);

        __webpack_require__(9600);

        __webpack_require__(2222);

        __webpack_require__(561);

        (function (root, factory) {
          if (true) {
            // CommonJS
            module.exports = exports = factory();
          } else {}
        }(void 0, () => {
          /* globals window, global, require */

          /**
   * CryptoJS core components.
   */
          var CryptoJS = CryptoJS || (function (Math, undefined) {
            let crypto; // Native crypto from window (Browser)

            if (typeof window !== 'undefined' && window.crypto) {
              crypto = window.crypto;
            } // Native crypto in web worker (Browser)

            if (typeof self !== 'undefined' && self.crypto) {
              crypto = self.crypto;
            } // Native crypto from worker

            if (typeof globalThis !== 'undefined' && globalThis.crypto) {
              crypto = globalThis.crypto;
            } // Native (experimental IE 11) crypto from window (Browser)

            if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
              crypto = window.msCrypto;
            } // Native crypto from global (NodeJS)

            if (!crypto && typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.crypto) {
              crypto = __webpack_require__.g.crypto;
            } // Native crypto import via require (NodeJS)

            if (!crypto && 'function' === 'function') {
              try {
                crypto = __webpack_require__(2480);
              } catch (err) {}
            }
            /*
     * Cryptographically secure pseudorandom number generator
     *
     * As Math.random() is cryptographically not safe to use
     */

            const cryptoSecureRandomInt = function cryptoSecureRandomInt() {
              if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === 'function') {
                  try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                  } catch (err) {}
                } // Use randomBytes method (NodeJS)

                if (typeof crypto.randomBytes === 'function') {
                  try {
                    return crypto.randomBytes(4).readInt32LE();
                  } catch (err) {}
                }
              }

              throw new Error('Native crypto module could not be used to get secure random number.');
            };
            /*
     * Local polyfill of Object.create
      */

            const create = Object.create || (function () {
              function F() {}

              return function (obj) {
                let subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
              };
            }());
            /**
     * CryptoJS namespace.
     */

            const C = {};
            /**
     * Library namespace.
     */

            const C_lib = C.lib = {};
            /**
     * Base object for prototypal inheritance.
     */

            const Base = C_lib.Base = (function () {
              return {
                /**
         * Creates a new object that inherits from this object.
         *
         * @param {Object} overrides Properties to copy into the new object.
         *
         * @return {Object} The new object.
         *
         * @static
         *
         * @example
         *
         *     var MyType = CryptoJS.lib.Base.extend({
         *         field: 'value',
         *
         *         method: function () {
         *         }
         *     });
         */
                extend: function extend(overrides) {
                  // Spawn
                  const subtype = create(this); // Augment

                  if (overrides) {
                    subtype.mixIn(overrides);
                  } // Create default initializer

                  if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
                    subtype.init = function () {
                      subtype.$super.init.apply(this, arguments);
                    };
                  } // Initializer's prototype is the subtype object

                  subtype.init.prototype = subtype; // Reference supertype

                  subtype.$super = this;
                  return subtype;
                },

                /**
         * Extends this object and runs the init method.
         * Arguments to create() will be passed to init().
         *
         * @return {Object} The new object.
         *
         * @static
         *
         * @example
         *
         *     var instance = MyType.create();
         */
                create: function create() {
                  const instance = this.extend();
                  instance.init.apply(instance, arguments);
                  return instance;
                },

                /**
         * Initializes a newly created object.
         * Override this method to add some logic when your objects are created.
         *
         * @example
         *
         *     var MyType = CryptoJS.lib.Base.extend({
         *         init: function () {
         *             // ...
         *         }
         *     });
         */
                init: function init() {},

                /**
         * Copies properties into this object.
         *
         * @param {Object} properties The properties to mix in.
         *
         * @example
         *
         *     MyType.mixIn({
         *         field: 'value'
         *     });
         */
                mixIn: function mixIn(properties) {
                  for (const propertyName in properties) {
                    if (properties.hasOwnProperty(propertyName)) {
                      this[propertyName] = properties[propertyName];
                    }
                  } // IE won't copy toString using the loop above

                  if (properties.hasOwnProperty('toString')) {
                    this.toString = properties.toString;
                  }
                },

                /**
         * Creates a copy of this object.
         *
         * @return {Object} The clone.
         *
         * @example
         *
         *     var clone = instance.clone();
         */
                clone: function clone() {
                  return this.init.prototype.extend(this);
                },
              };
            }());
            /**
     * An array of 32-bit words.
     *
     * @property {Array} words The array of 32-bit words.
     * @property {number} sigBytes The number of significant bytes in this word array.
     */

            var WordArray = C_lib.WordArray = Base.extend({
              /**
       * Initializes a newly created word array.
       *
       * @param {Array} words (Optional) An array of 32-bit words.
       * @param {number} sigBytes (Optional) The number of significant bytes in the words.
       *
       * @example
       *
       *     var wordArray = CryptoJS.lib.WordArray.create();
       *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
       *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
       */
              init: function init(words, sigBytes) {
                words = this.words = words || [];

                if (sigBytes != undefined) {
                  this.sigBytes = sigBytes;
                } else {
                  this.sigBytes = words.length * 4;
                }
              },

              /**
       * Converts this word array to a string.
       *
       * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
       *
       * @return {string} The stringified word array.
       *
       * @example
       *
       *     var string = wordArray + '';
       *     var string = wordArray.toString();
       *     var string = wordArray.toString(CryptoJS.enc.Utf8);
       */
              toString: function toString(encoder) {
                return (encoder || Hex).stringify(this);
              },

              /**
       * Concatenates a word array to this word array.
       *
       * @param {WordArray} wordArray The word array to append.
       *
       * @return {WordArray} This word array.
       *
       * @example
       *
       *     wordArray1.concat(wordArray2);
       */
              concat: function concat(wordArray) {
                // Shortcuts
                const thisWords = this.words;
                const thatWords = wordArray.words;
                const thisSigBytes = this.sigBytes;
                const thatSigBytes = wordArray.sigBytes; // Clamp excess bits

                this.clamp(); // Concat

                if (thisSigBytes % 4) {
                  // Copy one byte at a time
                  for (let i = 0; i < thatSigBytes; i++) {
                    const thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                  }
                } else {
                  // Copy one word at a time
                  for (let j = 0; j < thatSigBytes; j += 4) {
                    thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                  }
                }

                this.sigBytes += thatSigBytes; // Chainable

                return this;
              },

              /**
       * Removes insignificant bits.
       *
       * @example
       *
       *     wordArray.clamp();
       */
              clamp: function clamp() {
                // Shortcuts
                const { words } = this;
                const { sigBytes } = this; // Clamp

                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math.ceil(sigBytes / 4);
              },

              /**
       * Creates a copy of this word array.
       *
       * @return {WordArray} The clone.
       *
       * @example
       *
       *     var clone = wordArray.clone();
       */
              clone: function clone() {
                const clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
              },

              /**
       * Creates a word array filled with random bytes.
       *
       * @param {number} nBytes The number of random bytes to generate.
       *
       * @return {WordArray} The random word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.lib.WordArray.random(16);
       */
              random: function random(nBytes) {
                const words = [];

                for (let i = 0; i < nBytes; i += 4) {
                  words.push(cryptoSecureRandomInt());
                }

                return new WordArray.init(words, nBytes);
              },
            });
            /**
     * Encoder namespace.
     */

            const C_enc = C.enc = {};
            /**
     * Hex encoding strategy.
     */

            var Hex = C_enc.Hex = {
              /**
       * Converts a word array to a hex string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @return {string} The hex string.
       *
       * @static
       *
       * @example
       *
       *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
       */
              stringify: function stringify(wordArray) {
                // Shortcuts
                const { words } = wordArray;
                const { sigBytes } = wordArray; // Convert

                const hexChars = [];

                for (let i = 0; i < sigBytes; i++) {
                  const bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                  hexChars.push((bite >>> 4).toString(16));
                  hexChars.push((bite & 0x0f).toString(16));
                }

                return hexChars.join('');
              },

              /**
       * Converts a hex string to a word array.
       *
       * @param {string} hexStr The hex string.
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
       */
              parse: function parse(hexStr) {
                // Shortcut
                const hexStrLength = hexStr.length; // Convert

                const words = [];

                for (let i = 0; i < hexStrLength; i += 2) {
                  words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                }

                return new WordArray.init(words, hexStrLength / 2);
              },
            };
            /**
     * Latin1 encoding strategy.
     */

            const Latin1 = C_enc.Latin1 = {
              /**
       * Converts a word array to a Latin1 string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @return {string} The Latin1 string.
       *
       * @static
       *
       * @example
       *
       *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
       */
              stringify: function stringify(wordArray) {
                // Shortcuts
                const { words } = wordArray;
                const { sigBytes } = wordArray; // Convert

                const latin1Chars = [];

                for (let i = 0; i < sigBytes; i++) {
                  const bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                  latin1Chars.push(String.fromCharCode(bite));
                }

                return latin1Chars.join('');
              },

              /**
       * Converts a Latin1 string to a word array.
       *
       * @param {string} latin1Str The Latin1 string.
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
       */
              parse: function parse(latin1Str) {
                // Shortcut
                const latin1StrLength = latin1Str.length; // Convert

                const words = [];

                for (let i = 0; i < latin1StrLength; i++) {
                  words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                }

                return new WordArray.init(words, latin1StrLength);
              },
            };
            /**
     * UTF-8 encoding strategy.
     */

            const Utf8 = C_enc.Utf8 = {
              /**
       * Converts a word array to a UTF-8 string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @return {string} The UTF-8 string.
       *
       * @static
       *
       * @example
       *
       *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
       */
              stringify: function stringify(wordArray) {
                try {
                  return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                  throw new Error('Malformed UTF-8 data');
                }
              },

              /**
       * Converts a UTF-8 string to a word array.
       *
       * @param {string} utf8Str The UTF-8 string.
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
       */
              parse: function parse(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
              },
            };
            /**
     * Abstract buffered block algorithm template.
     *
     * The property blockSize must be implemented in a concrete subtype.
     *
     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
     */

            const BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
              /**
       * Resets this block algorithm's data buffer to its initial state.
       *
       * @example
       *
       *     bufferedBlockAlgorithm.reset();
       */
              reset: function reset() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
              },

              /**
       * Adds new data to this block algorithm's buffer.
       *
       * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
       *
       * @example
       *
       *     bufferedBlockAlgorithm._append('data');
       *     bufferedBlockAlgorithm._append(wordArray);
       */
              _append: function _append(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data === 'string') {
                  data = Utf8.parse(data);
                } // Append

                this._data.concat(data);

                this._nDataBytes += data.sigBytes;
              },

              /**
       * Processes available data blocks.
       *
       * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
       *
       * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
       *
       * @return {WordArray} The processed data.
       *
       * @example
       *
       *     var processedData = bufferedBlockAlgorithm._process();
       *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
       */
              _process: function _process(doFlush) {
                let processedWords; // Shortcuts

                const data = this._data;
                const dataWords = data.words;
                const dataSigBytes = data.sigBytes;
                const { blockSize } = this;
                const blockSizeBytes = blockSize * 4; // Count blocks ready

                let nBlocksReady = dataSigBytes / blockSizeBytes;

                if (doFlush) {
                  // Round up to include partial blocks
                  nBlocksReady = Math.ceil(nBlocksReady);
                } else {
                  // Round down to include only full blocks,
                  // less the number of blocks that must remain in the buffer
                  nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
                } // Count words ready

                const nWordsReady = nBlocksReady * blockSize; // Count bytes ready

                const nBytesReady = Math.min(nWordsReady * 4, dataSigBytes); // Process blocks

                if (nWordsReady) {
                  for (let offset = 0; offset < nWordsReady; offset += blockSize) {
                    // Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                  } // Remove processed words

                  processedWords = dataWords.splice(0, nWordsReady);
                  data.sigBytes -= nBytesReady;
                } // Return processed words

                return new WordArray.init(processedWords, nBytesReady);
              },

              /**
       * Creates a copy of this object.
       *
       * @return {Object} The clone.
       *
       * @example
       *
       *     var clone = bufferedBlockAlgorithm.clone();
       */
              clone: function clone() {
                const clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
              },
              _minBufferSize: 0,
            });
            /**
     * Abstract hasher template.
     *
     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
     */

            const Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
              /**
       * Configuration options.
       */
              cfg: Base.extend(),

              /**
       * Initializes a newly created hasher.
       *
       * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
       *
       * @example
       *
       *     var hasher = CryptoJS.algo.SHA256.create();
       */
              init: function init(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg); // Set initial values

                this.reset();
              },

              /**
       * Resets this hasher to its initial state.
       *
       * @example
       *
       *     hasher.reset();
       */
              reset: function reset() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this); // Perform concrete-hasher logic

                this._doReset();
              },

              /**
       * Updates this hasher with a message.
       *
       * @param {WordArray|string} messageUpdate The message to append.
       *
       * @return {Hasher} This hasher.
       *
       * @example
       *
       *     hasher.update('message');
       *     hasher.update(wordArray);
       */
              update: function update(messageUpdate) {
                // Append
                this._append(messageUpdate); // Update the hash

                this._process(); // Chainable

                return this;
              },

              /**
       * Finalizes the hash computation.
       * Note that the finalize operation is effectively a destructive, read-once operation.
       *
       * @param {WordArray|string} messageUpdate (Optional) A final message update.
       *
       * @return {WordArray} The hash.
       *
       * @example
       *
       *     var hash = hasher.finalize();
       *     var hash = hasher.finalize('message');
       *     var hash = hasher.finalize(wordArray);
       */
              finalize: function finalize(messageUpdate) {
                // Final message update
                if (messageUpdate) {
                  this._append(messageUpdate);
                } // Perform concrete-hasher logic

                const hash = this._doFinalize();

                return hash;
              },
              blockSize: 512 / 32,

              /**
       * Creates a shortcut function to a hasher's object interface.
       *
       * @param {Hasher} hasher The hasher to create a helper for.
       *
       * @return {Function} The shortcut function.
       *
       * @static
       *
       * @example
       *
       *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
       */
              _createHelper: function _createHelper(hasher) {
                return function (message, cfg) {
                  return new hasher.init(cfg).finalize(message);
                };
              },

              /**
       * Creates a shortcut function to the HMAC's object interface.
       *
       * @param {Hasher} hasher The hasher to use in this HMAC helper.
       *
       * @return {Function} The shortcut function.
       *
       * @static
       *
       * @example
       *
       *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
       */
              _createHmacHelper: function _createHmacHelper(hasher) {
                return function (message, key) {
                  return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
              },
            });
            /**
     * Algorithm namespace.
     */

            var C_algo = C.algo = {};
            return C;
          }(Math));

          return CryptoJS;
        }));
        /***/ }),

      /***/ 7508:
      /***/ (function (module, exports, __webpack_require__) {
        __webpack_require__(9600);

        (function (root, factory) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757));
          } else {}
        }(void 0, (CryptoJS) => {
          (function () {
            // Shortcuts
            const C = CryptoJS;
            const C_lib = C.lib;
            const { WordArray } = C_lib;
            const C_enc = C.enc;
            /**
     * Base64 encoding strategy.
     */

            const Base64 = C_enc.Base64 = {
              /**
       * Converts a word array to a Base64 string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @return {string} The Base64 string.
       *
       * @static
       *
       * @example
       *
       *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
       */
              stringify: function stringify(wordArray) {
                // Shortcuts
                const { words } = wordArray;
                const { sigBytes } = wordArray;
                const map = this._map; // Clamp excess bits

                wordArray.clamp(); // Convert

                const base64Chars = [];

                for (let i = 0; i < sigBytes; i += 3) {
                  const byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                  const byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                  const byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                  const triplet = byte1 << 16 | byte2 << 8 | byte3;

                  for (let j = 0; j < 4 && i + j * 0.75 < sigBytes; j++) {
                    base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                  }
                } // Add padding

                const paddingChar = map.charAt(64);

                if (paddingChar) {
                  while (base64Chars.length % 4) {
                    base64Chars.push(paddingChar);
                  }
                }

                return base64Chars.join('');
              },

              /**
       * Converts a Base64 string to a word array.
       *
       * @param {string} base64Str The Base64 string.
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
       */
              parse: function parse(base64Str) {
                // Shortcuts
                let base64StrLength = base64Str.length;
                const map = this._map;
                let reverseMap = this._reverseMap;

                if (!reverseMap) {
                  reverseMap = this._reverseMap = [];

                  for (let j = 0; j < map.length; j++) {
                    reverseMap[map.charCodeAt(j)] = j;
                  }
                } // Ignore padding

                const paddingChar = map.charAt(64);

                if (paddingChar) {
                  const paddingIndex = base64Str.indexOf(paddingChar);

                  if (paddingIndex !== -1) {
                    base64StrLength = paddingIndex;
                  }
                } // Convert

                return parseLoop(base64Str, base64StrLength, reverseMap);
              },
              _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
            };

            function parseLoop(base64Str, base64StrLength, reverseMap) {
              const words = [];
              let nBytes = 0;

              for (let i = 0; i < base64StrLength; i++) {
                if (i % 4) {
                  const bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                  const bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                  const bitsCombined = bits1 | bits2;
                  words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                  nBytes++;
                }
              }

              return WordArray.create(words, nBytes);
            }
          }());

          return CryptoJS.enc.Base64;
        }));
        /***/ }),

      /***/ 7590:
      /***/ (function (module, exports, __webpack_require__) {
        __webpack_require__(9600);

        (function (root, factory) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757));
          } else {}
        }(void 0, (CryptoJS) => {
          (function () {
            // Shortcuts
            const C = CryptoJS;
            const C_lib = C.lib;
            const { WordArray } = C_lib;
            const C_enc = C.enc;
            /**
     * Base64url encoding strategy.
     */

            const Base64url = C_enc.Base64url = {
              /**
       * Converts a word array to a Base64url string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @param {boolean} urlSafe Whether to use url safe
       *
       * @return {string} The Base64url string.
       *
       * @static
       *
       * @example
       *
       *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
       */
              stringify: function stringify(wordArray, urlSafe) {
                if (urlSafe === void 0) {
                  urlSafe = true;
                }

                // Shortcuts
                const { words } = wordArray;
                const { sigBytes } = wordArray;
                const map = urlSafe ? this._safe_map : this._map; // Clamp excess bits

                wordArray.clamp(); // Convert

                const base64Chars = [];

                for (let i = 0; i < sigBytes; i += 3) {
                  const byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                  const byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                  const byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                  const triplet = byte1 << 16 | byte2 << 8 | byte3;

                  for (let j = 0; j < 4 && i + j * 0.75 < sigBytes; j++) {
                    base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                  }
                } // Add padding

                const paddingChar = map.charAt(64);

                if (paddingChar) {
                  while (base64Chars.length % 4) {
                    base64Chars.push(paddingChar);
                  }
                }

                return base64Chars.join('');
              },

              /**
       * Converts a Base64url string to a word array.
       *
       * @param {string} base64Str The Base64url string.
       *
       * @param {boolean} urlSafe Whether to use url safe
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
       */
              parse: function parse(base64Str, urlSafe) {
                if (urlSafe === void 0) {
                  urlSafe = true;
                }

                // Shortcuts
                let base64StrLength = base64Str.length;
                const map = urlSafe ? this._safe_map : this._map;
                let reverseMap = this._reverseMap;

                if (!reverseMap) {
                  reverseMap = this._reverseMap = [];

                  for (let j = 0; j < map.length; j++) {
                    reverseMap[map.charCodeAt(j)] = j;
                  }
                } // Ignore padding

                const paddingChar = map.charAt(64);

                if (paddingChar) {
                  const paddingIndex = base64Str.indexOf(paddingChar);

                  if (paddingIndex !== -1) {
                    base64StrLength = paddingIndex;
                  }
                } // Convert

                return parseLoop(base64Str, base64StrLength, reverseMap);
              },
              _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
              _safe_map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_',
            };

            function parseLoop(base64Str, base64StrLength, reverseMap) {
              const words = [];
              let nBytes = 0;

              for (let i = 0; i < base64StrLength; i++) {
                if (i % 4) {
                  const bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                  const bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                  const bitsCombined = bits1 | bits2;
                  words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                  nBytes++;
                }
              }

              return WordArray.create(words, nBytes);
            }
          }());

          return CryptoJS.enc.Base64url;
        }));
        /***/ }),

      /***/ 4978:
      /***/ (function (module, exports, __webpack_require__) {
        __webpack_require__(9600);

        (function (root, factory) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757));
          } else {}
        }(void 0, (CryptoJS) => {
          (function () {
            // Shortcuts
            const C = CryptoJS;
            const C_lib = C.lib;
            const { WordArray } = C_lib;
            const C_enc = C.enc;
            /**
     * UTF-16 BE encoding strategy.
     */

            const Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
              /**
       * Converts a word array to a UTF-16 BE string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @return {string} The UTF-16 BE string.
       *
       * @static
       *
       * @example
       *
       *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
       */
              stringify: function stringify(wordArray) {
                // Shortcuts
                const { words } = wordArray;
                const { sigBytes } = wordArray; // Convert

                const utf16Chars = [];

                for (let i = 0; i < sigBytes; i += 2) {
                  const codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff;
                  utf16Chars.push(String.fromCharCode(codePoint));
                }

                return utf16Chars.join('');
              },

              /**
       * Converts a UTF-16 BE string to a word array.
       *
       * @param {string} utf16Str The UTF-16 BE string.
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
       */
              parse: function parse(utf16Str) {
                // Shortcut
                const utf16StrLength = utf16Str.length; // Convert

                const words = [];

                for (let i = 0; i < utf16StrLength; i++) {
                  words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
                }

                return WordArray.create(words, utf16StrLength * 2);
              },
            };
            /**
     * UTF-16 LE encoding strategy.
     */

            C_enc.Utf16LE = {
              /**
       * Converts a word array to a UTF-16 LE string.
       *
       * @param {WordArray} wordArray The word array.
       *
       * @return {string} The UTF-16 LE string.
       *
       * @static
       *
       * @example
       *
       *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
       */
              stringify: function stringify(wordArray) {
                // Shortcuts
                const { words } = wordArray;
                const { sigBytes } = wordArray; // Convert

                const utf16Chars = [];

                for (let i = 0; i < sigBytes; i += 2) {
                  const codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff);
                  utf16Chars.push(String.fromCharCode(codePoint));
                }

                return utf16Chars.join('');
              },

              /**
       * Converts a UTF-16 LE string to a word array.
       *
       * @param {string} utf16Str The UTF-16 LE string.
       *
       * @return {WordArray} The word array.
       *
       * @static
       *
       * @example
       *
       *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
       */
              parse: function parse(utf16Str) {
                // Shortcut
                const utf16StrLength = utf16Str.length; // Convert

                const words = [];

                for (let i = 0; i < utf16StrLength; i++) {
                  words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
                }

                return WordArray.create(words, utf16StrLength * 2);
              },
            };

            function swapEndian(word) {
              return word << 8 & 0xff00ff00 | word >>> 8 & 0x00ff00ff;
            }
          }());

          return CryptoJS.enc.Utf16;
        }));
        /***/ }),

      /***/ 3839:
      /***/ (function (module, exports, __webpack_require__) {
        __webpack_require__(2222);

        (function (root, factory, undef) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757), __webpack_require__(9865), __webpack_require__(6727));
          } else {}
        }(void 0, (CryptoJS) => {
          (function () {
            // Shortcuts
            const C = CryptoJS;
            const C_lib = C.lib;
            const { Base } = C_lib;
            const { WordArray } = C_lib;
            const C_algo = C.algo;
            const { MD5 } = C_algo;
            /**
     * This key derivation function is meant to conform with EVP_BytesToKey.
     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
     */

            const EvpKDF = C_algo.EvpKDF = Base.extend({
              /**
       * Configuration options.
       *
       * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
       * @property {Hasher} hasher The hash algorithm to use. Default: MD5
       * @property {number} iterations The number of iterations to perform. Default: 1
       */
              cfg: Base.extend({
                keySize: 128 / 32,
                hasher: MD5,
                iterations: 1,
              }),

              /**
       * Initializes a newly created key derivation function.
       *
       * @param {Object} cfg (Optional) The configuration options to use for the derivation.
       *
       * @example
       *
       *     var kdf = CryptoJS.algo.EvpKDF.create();
       *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
       *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
       */
              init: function init(cfg) {
                this.cfg = this.cfg.extend(cfg);
              },

              /**
       * Derives a key from a password.
       *
       * @param {WordArray|string} password The password.
       * @param {WordArray|string} salt A salt.
       *
       * @return {WordArray} The derived key.
       *
       * @example
       *
       *     var key = kdf.compute(password, salt);
       */
              compute: function compute(password, salt) {
                let block; // Shortcut

                const { cfg } = this; // Init hasher

                const hasher = cfg.hasher.create(); // Initial values

                const derivedKey = WordArray.create(); // Shortcuts

                const derivedKeyWords = derivedKey.words;
                const { keySize } = cfg;
                const { iterations } = cfg; // Generate key

                while (derivedKeyWords.length < keySize) {
                  if (block) {
                    hasher.update(block);
                  }

                  block = hasher.update(password).finalize(salt);
                  hasher.reset(); // Iterations

                  for (let i = 1; i < iterations; i++) {
                    block = hasher.finalize(block);
                    hasher.reset();
                  }

                  derivedKey.concat(block);
                }

                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
              },
            });
            /**
     * Derives a key from a password.
     *
     * @param {WordArray|string} password The password.
     * @param {WordArray|string} salt A salt.
     * @param {Object} cfg (Optional) The configuration options to use for this computation.
     *
     * @return {WordArray} The derived key.
     *
     * @static
     *
     * @example
     *
     *     var key = CryptoJS.EvpKDF(password, salt);
     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
     */

            C.EvpKDF = function (password, salt, cfg) {
              return EvpKDF.create(cfg).compute(password, salt);
            };
          }());

          return CryptoJS.EvpKDF;
        }));
        /***/ }),

      /***/ 8942:
      /***/ (function (module, exports, __webpack_require__) {
        __webpack_require__(1539);

        __webpack_require__(9714);

        (function (root, factory, undef) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757), __webpack_require__(1582));
          } else {}
        }(void 0, (CryptoJS) => {
          (function (undefined) {
            // Shortcuts
            const C = CryptoJS;
            const C_lib = C.lib;
            const { CipherParams } = C_lib;
            const C_enc = C.enc;
            const { Hex } = C_enc;
            const C_format = C.format;
            const HexFormatter = C_format.Hex = {
              /**
       * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
       *
       * @param {CipherParams} cipherParams The cipher params object.
       *
       * @return {string} The hexadecimally encoded string.
       *
       * @static
       *
       * @example
       *
       *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
       */
              stringify: function stringify(cipherParams) {
                return cipherParams.ciphertext.toString(Hex);
              },

              /**
       * Converts a hexadecimally encoded ciphertext string to a cipher params object.
       *
       * @param {string} input The hexadecimally encoded string.
       *
       * @return {CipherParams} The cipher params object.
       *
       * @static
       *
       * @example
       *
       *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
       */
              parse: function parse(input) {
                const ciphertext = Hex.parse(input);
                return CipherParams.create({
                  ciphertext,
                });
              },
            };
          }());

          return CryptoJS.format.Hex;
        }));
        /***/ }),

      /***/ 6727:
      /***/ (function (module, exports, __webpack_require__) {
        __webpack_require__(2222);

        (function (root, factory) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757));
          } else {}
        }(void 0, (CryptoJS) => {
          (function () {
            // Shortcuts
            const C = CryptoJS;
            const C_lib = C.lib;
            const { Base } = C_lib;
            const C_enc = C.enc;
            const { Utf8 } = C_enc;
            const C_algo = C.algo;
            /**
     * HMAC algorithm.
     */

            const HMAC = C_algo.HMAC = Base.extend({
              /**
       * Initializes a newly created HMAC.
       *
       * @param {Hasher} hasher The hash algorithm to use.
       * @param {WordArray|string} key The secret key.
       *
       * @example
       *
       *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
       */
              init: function init(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init(); // Convert string to WordArray, else assume WordArray already

                if (typeof key === 'string') {
                  key = Utf8.parse(key);
                } // Shortcuts

                const hasherBlockSize = hasher.blockSize;
                const hasherBlockSizeBytes = hasherBlockSize * 4; // Allow arbitrary length keys

                if (key.sigBytes > hasherBlockSizeBytes) {
                  key = hasher.finalize(key);
                } // Clamp excess bits

                key.clamp(); // Clone key for inner and outer pads

                const oKey = this._oKey = key.clone();
                const iKey = this._iKey = key.clone(); // Shortcuts

                const oKeyWords = oKey.words;
                const iKeyWords = iKey.words; // XOR keys with pad constants

                for (let i = 0; i < hasherBlockSize; i++) {
                  oKeyWords[i] ^= 0x5c5c5c5c;
                  iKeyWords[i] ^= 0x36363636;
                }

                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes; // Set initial values

                this.reset();
              },

              /**
       * Resets this HMAC to its initial state.
       *
       * @example
       *
       *     hmacHasher.reset();
       */
              reset: function reset() {
                // Shortcut
                const hasher = this._hasher; // Reset

                hasher.reset();
                hasher.update(this._iKey);
              },

              /**
       * Updates this HMAC with a message.
       *
       * @param {WordArray|string} messageUpdate The message to append.
       *
       * @return {HMAC} This HMAC instance.
       *
       * @example
       *
       *     hmacHasher.update('message');
       *     hmacHasher.update(wordArray);
       */
              update: function update(messageUpdate) {
                this._hasher.update(messageUpdate); // Chainable

                return this;
              },

              /**
       * Finalizes the HMAC computation.
       * Note that the finalize operation is effectively a destructive, read-once operation.
       *
       * @param {WordArray|string} messageUpdate (Optional) A final message update.
       *
       * @return {WordArray} The HMAC.
       *
       * @example
       *
       *     var hmac = hmacHasher.finalize();
       *     var hmac = hmacHasher.finalize('message');
       *     var hmac = hmacHasher.finalize(wordArray);
       */
              finalize: function finalize(messageUpdate) {
                // Shortcut
                const hasher = this._hasher; // Compute HMAC

                const innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                const hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
              },
            });
          }());
        }));
        /***/ }),

      /***/ 5153:
      /***/ (function (module, exports, __webpack_require__) {
        (function (root, factory, undef) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757), __webpack_require__(2601), __webpack_require__(1947), __webpack_require__(4978), __webpack_require__(7508), __webpack_require__(7590), __webpack_require__(3440), __webpack_require__(9865), __webpack_require__(8921), __webpack_require__(6876), __webpack_require__(7991), __webpack_require__(8122), __webpack_require__(8342), __webpack_require__(8714), __webpack_require__(6727), __webpack_require__(3486), __webpack_require__(3839), __webpack_require__(1582), __webpack_require__(702), __webpack_require__(2362), __webpack_require__(4412), __webpack_require__(5720), __webpack_require__(3518), __webpack_require__(6362), __webpack_require__(4431), __webpack_require__(8800), __webpack_require__(3992), __webpack_require__(649), __webpack_require__(8942), __webpack_require__(194), __webpack_require__(8437), __webpack_require__(4640), __webpack_require__(5323), __webpack_require__(4363));
          } else {}
        }(void 0, (CryptoJS) => CryptoJS));
        /***/ }),

      /***/ 1947:
      /***/ (function (module, exports, __webpack_require__) {
        __webpack_require__(7803);

        __webpack_require__(1539);

        __webpack_require__(6992);

        __webpack_require__(2472);

        __webpack_require__(2990);

        __webpack_require__(8927);

        __webpack_require__(3105);

        __webpack_require__(5035);

        __webpack_require__(4345);

        __webpack_require__(7174);

        __webpack_require__(2846);

        __webpack_require__(4731);

        __webpack_require__(7209);

        __webpack_require__(6319);

        __webpack_require__(8867);

        __webpack_require__(7789);

        __webpack_require__(3739);

        __webpack_require__(9368);

        __webpack_require__(4483);

        __webpack_require__(2056);

        __webpack_require__(3462);

        __webpack_require__(678);

        __webpack_require__(7462);

        __webpack_require__(3824);

        __webpack_require__(5021);

        __webpack_require__(2974);

        __webpack_require__(5016);

        __webpack_require__(7145);

        __webpack_require__(9743);

        __webpack_require__(5109);

        __webpack_require__(8255);

        __webpack_require__(5125);

        __webpack_require__(9135);

        __webpack_require__(4197);

        __webpack_require__(6495);

        (function (root, factory) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757));
          } else {}
        }(void 0, (CryptoJS) => {
          (function () {
            // Check if typed arrays are supported
            if (typeof ArrayBuffer !== 'function') {
              return;
            } // Shortcuts

            const C = CryptoJS;
            const C_lib = C.lib;
            const { WordArray } = C_lib; // Reference original init

            const superInit = WordArray.init; // Augment WordArray.init to handle typed arrays

            const subInit = WordArray.init = function (typedArray) {
              // Convert buffers to uint8
              if (typedArray instanceof ArrayBuffer) {
                typedArray = new Uint8Array(typedArray);
              } // Convert other array views to uint8

              if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== 'undefined' && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) {
                typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
              } // Handle Uint8Array

              if (typedArray instanceof Uint8Array) {
                // Shortcut
                const typedArrayByteLength = typedArray.byteLength; // Extract bytes

                const words = [];

                for (let i = 0; i < typedArrayByteLength; i++) {
                  words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                } // Initialize this word array

                superInit.call(this, words, typedArrayByteLength);
              } else {
                // Else call normal init
                superInit.apply(this, arguments);
              }
            };

            subInit.prototype = WordArray;
          }());

          return CryptoJS.lib.WordArray;
        }));
        /***/ }),

      /***/ 3440:
      /***/ (function (module, exports, __webpack_require__) {
        (function (root, factory) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757));
          } else {}
        }(void 0, (CryptoJS) => {
          (function (Math) {
            // Shortcuts
            const C = CryptoJS;
            const C_lib = C.lib;
            const { WordArray } = C_lib;
            const { Hasher } = C_lib;
            const C_algo = C.algo; // Constants table

            const T = []; // Compute constants

            (function () {
              for (let i = 0; i < 64; i++) {
                T[i] = Math.abs(Math.sin(i + 1)) * 0x100000000 | 0;
              }
            }());
            /**
     * MD5 hash algorithm.
     */

            const MD5 = C_algo.MD5 = Hasher.extend({
              _doReset: function _doReset() {
                this._hash = new WordArray.init([0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476]);
              },
              _doProcessBlock: function _doProcessBlock(M, offset) {
                // Swap endian
                for (let i = 0; i < 16; i++) {
                  // Shortcuts
                  const offset_i = offset + i;
                  const M_offset_i = M[offset_i];
                  M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                } // Shortcuts

                const H = this._hash.words;
                const M_offset_0 = M[offset + 0];
                const M_offset_1 = M[offset + 1];
                const M_offset_2 = M[offset + 2];
                const M_offset_3 = M[offset + 3];
                const M_offset_4 = M[offset + 4];
                const M_offset_5 = M[offset + 5];
                const M_offset_6 = M[offset + 6];
                const M_offset_7 = M[offset + 7];
                const M_offset_8 = M[offset + 8];
                const M_offset_9 = M[offset + 9];
                const M_offset_10 = M[offset + 10];
                const M_offset_11 = M[offset + 11];
                const M_offset_12 = M[offset + 12];
                const M_offset_13 = M[offset + 13];
                const M_offset_14 = M[offset + 14];
                const M_offset_15 = M[offset + 15]; // Working varialbes

                let a = H[0];
                let b = H[1];
                let c = H[2];
                let d = H[3]; // Computation

                a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                a = II(a, b, c, d, M_offset_0, 6, T[48]);
                d = II(d, a, b, c, M_offset_7, 10, T[49]);
                c = II(c, d, a, b, M_offset_14, 15, T[50]);
                b = II(b, c, d, a, M_offset_5, 21, T[51]);
                a = II(a, b, c, d, M_offset_12, 6, T[52]);
                d = II(d, a, b, c, M_offset_3, 10, T[53]);
                c = II(c, d, a, b, M_offset_10, 15, T[54]);
                b = II(b, c, d, a, M_offset_1, 21, T[55]);
                a = II(a, b, c, d, M_offset_8, 6, T[56]);
                d = II(d, a, b, c, M_offset_15, 10, T[57]);
                c = II(c, d, a, b, M_offset_6, 15, T[58]);
                b = II(b, c, d, a, M_offset_13, 21, T[59]);
                a = II(a, b, c, d, M_offset_4, 6, T[60]);
                d = II(d, a, b, c, M_offset_11, 10, T[61]);
                c = II(c, d, a, b, M_offset_2, 15, T[62]);
                b = II(b, c, d, a, M_offset_9, 21, T[63]); // Intermediate hash value

                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
              },
              _doFinalize: function _doFinalize() {
                // Shortcuts
                const data = this._data;
                const dataWords = data.words;
                const nBitsTotal = this._nDataBytes * 8;
                const nBitsLeft = data.sigBytes * 8; // Add padding

                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                const nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
                const nBitsTotalL = nBitsTotal;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4; // Hash final blocks

                this._process(); // Shortcuts

                const hash = this._hash;
                const H = hash.words; // Swap endian

                for (let i = 0; i < 4; i++) {
                  // Shortcut
                  const H_i = H[i];
                  H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                } // Return final computed hash

                return hash;
              },
              clone: function clone() {
                const clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
              },
            });

            function FF(a, b, c, d, x, s, t) {
              const n = a + (b & c | ~b & d) + x + t;
              return (n << s | n >>> 32 - s) + b;
            }

            function GG(a, b, c, d, x, s, t) {
              const n = a + (b & d | c & ~d) + x + t;
              return (n << s | n >>> 32 - s) + b;
            }

            function HH(a, b, c, d, x, s, t) {
              const n = a + (b ^ c ^ d) + x + t;
              return (n << s | n >>> 32 - s) + b;
            }

            function II(a, b, c, d, x, s, t) {
              const n = a + (c ^ (b | ~d)) + x + t;
              return (n << s | n >>> 32 - s) + b;
            }
            /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.MD5('message');
     *     var hash = CryptoJS.MD5(wordArray);
     */

            C.MD5 = Hasher._createHelper(MD5);
            /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacMD5(message, key);
     */

            C.HmacMD5 = Hasher._createHmacHelper(MD5);
          }(Math));

          return CryptoJS.MD5;
        }));
        /***/ }),

      /***/ 702:
      /***/ (function (module, exports, __webpack_require__) {
        __webpack_require__(7042);

        (function (root, factory, undef) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757), __webpack_require__(1582));
          } else {}
        }(void 0, (CryptoJS) => {
          /**
   * Cipher Feedback block mode.
   */
          CryptoJS.mode.CFB = (function () {
            const CFB = CryptoJS.lib.BlockCipherMode.extend();
            CFB.Encryptor = CFB.extend({
              processBlock: function processBlock(words, offset) {
                // Shortcuts
                const cipher = this._cipher;
                const { blockSize } = cipher;
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher); // Remember this block to use with next block

                this._prevBlock = words.slice(offset, offset + blockSize);
              },
            });
            CFB.Decryptor = CFB.extend({
              processBlock: function processBlock(words, offset) {
                // Shortcuts
                const cipher = this._cipher;
                const { blockSize } = cipher; // Remember this block to use with next block

                const thisBlock = words.slice(offset, offset + blockSize);
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher); // This block becomes the previous block

                this._prevBlock = thisBlock;
              },
            });

            function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
              let keystream; // Shortcut

              const iv = this._iv; // Generate keystream

              if (iv) {
                keystream = iv.slice(0); // Remove IV for subsequent blocks

                this._iv = undefined;
              } else {
                keystream = this._prevBlock;
              }

              cipher.encryptBlock(keystream, 0); // Encrypt

              for (let i = 0; i < blockSize; i++) {
                words[offset + i] ^= keystream[i];
              }
            }

            return CFB;
          }());

          return CryptoJS.mode.CFB;
        }));
        /***/ }),

      /***/ 4412:
      /***/ (function (module, exports, __webpack_require__) {
        __webpack_require__(7042);

        (function (root, factory, undef) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757), __webpack_require__(1582));
          } else {}
        }(void 0, (CryptoJS) => {
          /** @preserve
   * Counter block mode compatible with  Dr Brian Gladman fileenc.c
   * derived from CryptoJS.mode.CTR
   * Jan Hruby jhruby.web@gmail.com
   */
          CryptoJS.mode.CTRGladman = (function () {
            const CTRGladman = CryptoJS.lib.BlockCipherMode.extend();

            function incWord(word) {
              if ((word >> 24 & 0xff) === 0xff) {
                // overflow
                let b1 = word >> 16 & 0xff;
                let b2 = word >> 8 & 0xff;
                let b3 = word & 0xff;

                if (b1 === 0xff) // overflow b1
                {
                  b1 = 0;

                  if (b2 === 0xff) {
                    b2 = 0;

                    if (b3 === 0xff) {
                      b3 = 0;
                    } else {
                      ++b3;
                    }
                  } else {
                    ++b2;
                  }
                } else {
                  ++b1;
                }

                word = 0;
                word += b1 << 16;
                word += b2 << 8;
                word += b3;
              } else {
                word += 0x01 << 24;
              }

              return word;
            }

            function incCounter(counter) {
              if ((counter[0] = incWord(counter[0])) === 0) {
                // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
                counter[1] = incWord(counter[1]);
              }

              return counter;
            }

            const Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
              processBlock: function processBlock(words, offset) {
                // Shortcuts
                const cipher = this._cipher;
                const { blockSize } = cipher;
                const iv = this._iv;
                let counter = this._counter; // Generate keystream

                if (iv) {
                  counter = this._counter = iv.slice(0); // Remove IV for subsequent blocks

                  this._iv = undefined;
                }

                incCounter(counter);
                const keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0); // Encrypt

                for (let i = 0; i < blockSize; i++) {
                  words[offset + i] ^= keystream[i];
                }
              },
            });
            CTRGladman.Decryptor = Encryptor;
            return CTRGladman;
          }());

          return CryptoJS.mode.CTRGladman;
        }));
        /***/ }),

      /***/ 2362:
      /***/ (function (module, exports, __webpack_require__) {
        __webpack_require__(7042);

        (function (root, factory, undef) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757), __webpack_require__(1582));
          } else {}
        }(void 0, (CryptoJS) => {
          /**
   * Counter block mode.
   */
          CryptoJS.mode.CTR = (function () {
            const CTR = CryptoJS.lib.BlockCipherMode.extend();
            const Encryptor = CTR.Encryptor = CTR.extend({
              processBlock: function processBlock(words, offset) {
                // Shortcuts
                const cipher = this._cipher;
                const { blockSize } = cipher;
                const iv = this._iv;
                let counter = this._counter; // Generate keystream

                if (iv) {
                  counter = this._counter = iv.slice(0); // Remove IV for subsequent blocks

                  this._iv = undefined;
                }

                const keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0); // Increment counter

                counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0; // Encrypt

                for (let i = 0; i < blockSize; i++) {
                  words[offset + i] ^= keystream[i];
                }
              },
            });
            CTR.Decryptor = Encryptor;
            return CTR;
          }());

          return CryptoJS.mode.CTR;
        }));
        /***/ }),

      /***/ 3518:
      /***/ (function (module, exports, __webpack_require__) {
        (function (root, factory, undef) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757), __webpack_require__(1582));
          } else {}
        }(void 0, (CryptoJS) => {
          /**
   * Electronic Codebook block mode.
   */
          CryptoJS.mode.ECB = (function () {
            const ECB = CryptoJS.lib.BlockCipherMode.extend();
            ECB.Encryptor = ECB.extend({
              processBlock: function processBlock(words, offset) {
                this._cipher.encryptBlock(words, offset);
              },
            });
            ECB.Decryptor = ECB.extend({
              processBlock: function processBlock(words, offset) {
                this._cipher.decryptBlock(words, offset);
              },
            });
            return ECB;
          }());

          return CryptoJS.mode.ECB;
        }));
        /***/ }),

      /***/ 5720:
      /***/ (function (module, exports, __webpack_require__) {
        __webpack_require__(7042);

        (function (root, factory, undef) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757), __webpack_require__(1582));
          } else {}
        }(void 0, (CryptoJS) => {
          /**
   * Output Feedback block mode.
   */
          CryptoJS.mode.OFB = (function () {
            const OFB = CryptoJS.lib.BlockCipherMode.extend();
            const Encryptor = OFB.Encryptor = OFB.extend({
              processBlock: function processBlock(words, offset) {
                // Shortcuts
                const cipher = this._cipher;
                const { blockSize } = cipher;
                const iv = this._iv;
                let keystream = this._keystream; // Generate keystream

                if (iv) {
                  keystream = this._keystream = iv.slice(0); // Remove IV for subsequent blocks

                  this._iv = undefined;
                }

                cipher.encryptBlock(keystream, 0); // Encrypt

                for (let i = 0; i < blockSize; i++) {
                  words[offset + i] ^= keystream[i];
                }
              },
            });
            OFB.Decryptor = Encryptor;
            return OFB;
          }());

          return CryptoJS.mode.OFB;
        }));
        /***/ }),

      /***/ 6362:
      /***/ (function (module, exports, __webpack_require__) {
        (function (root, factory, undef) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757), __webpack_require__(1582));
          } else {}
        }(void 0, (CryptoJS) => {
          /**
   * ANSI X.923 padding strategy.
   */
          CryptoJS.pad.AnsiX923 = {
            pad: function pad(data, blockSize) {
              // Shortcuts
              const dataSigBytes = data.sigBytes;
              const blockSizeBytes = blockSize * 4; // Count padding bytes

              const nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes; // Compute last byte position

              const lastBytePos = dataSigBytes + nPaddingBytes - 1; // Pad

              data.clamp();
              data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
              data.sigBytes += nPaddingBytes;
            },
            unpad: function unpad(data) {
              // Get number of padding bytes from last byte
              const nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff; // Remove padding

              data.sigBytes -= nPaddingBytes;
            },
          };
          return CryptoJS.pad.Ansix923;
        }));
        /***/ }),

      /***/ 4431:
      /***/ (function (module, exports, __webpack_require__) {
        __webpack_require__(2222);

        (function (root, factory, undef) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757), __webpack_require__(1582));
          } else {}
        }(void 0, (CryptoJS) => {
          /**
   * ISO 10126 padding strategy.
   */
          CryptoJS.pad.Iso10126 = {
            pad: function pad(data, blockSize) {
              // Shortcut
              const blockSizeBytes = blockSize * 4; // Count padding bytes

              const nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes; // Pad

              data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
            },
            unpad: function unpad(data) {
              // Get number of padding bytes from last byte
              const nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff; // Remove padding

              data.sigBytes -= nPaddingBytes;
            },
          };
          return CryptoJS.pad.Iso10126;
        }));
        /***/ }),

      /***/ 8800:
      /***/ (function (module, exports, __webpack_require__) {
        __webpack_require__(2222);

        (function (root, factory, undef) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757), __webpack_require__(1582));
          } else {}
        }(void 0, (CryptoJS) => {
          /**
   * ISO/IEC 9797-1 Padding Method 2.
   */
          CryptoJS.pad.Iso97971 = {
            pad: function pad(data, blockSize) {
              // Add 0x80 byte
              data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1)); // Zero pad the rest

              CryptoJS.pad.ZeroPadding.pad(data, blockSize);
            },
            unpad: function unpad(data) {
              // Remove zero padding
              CryptoJS.pad.ZeroPadding.unpad(data); // Remove one more byte -- the 0x80 byte

              data.sigBytes--;
            },
          };
          return CryptoJS.pad.Iso97971;
        }));
        /***/ }),

      /***/ 649:
      /***/ (function (module, exports, __webpack_require__) {
        (function (root, factory, undef) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757), __webpack_require__(1582));
          } else {}
        }(void 0, (CryptoJS) => {
          /**
   * A noop padding strategy.
   */
          CryptoJS.pad.NoPadding = {
            pad: function pad() {},
            unpad: function unpad() {},
          };
          return CryptoJS.pad.NoPadding;
        }));
        /***/ }),

      /***/ 3992:
      /***/ (function (module, exports, __webpack_require__) {
        (function (root, factory, undef) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757), __webpack_require__(1582));
          } else {}
        }(void 0, (CryptoJS) => {
          /**
   * Zero padding strategy.
   */
          CryptoJS.pad.ZeroPadding = {
            pad: function pad(data, blockSize) {
              // Shortcut
              const blockSizeBytes = blockSize * 4; // Pad

              data.clamp();
              data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
            },
            unpad: function unpad(data) {
              // Shortcut
              const dataWords = data.words; // Unpad

              var i = data.sigBytes - 1;

              for (var i = data.sigBytes - 1; i >= 0; i--) {
                if (dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff) {
                  data.sigBytes = i + 1;
                  break;
                }
              }
            },
          };
          return CryptoJS.pad.ZeroPadding;
        }));
        /***/ }),

      /***/ 3486:
      /***/ (function (module, exports, __webpack_require__) {
        __webpack_require__(2222);

        (function (root, factory, undef) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757), __webpack_require__(9865), __webpack_require__(6727));
          } else {}
        }(void 0, (CryptoJS) => {
          (function () {
            // Shortcuts
            const C = CryptoJS;
            const C_lib = C.lib;
            const { Base } = C_lib;
            const { WordArray } = C_lib;
            const C_algo = C.algo;
            const { SHA1 } = C_algo;
            const { HMAC } = C_algo;
            /**
     * Password-Based Key Derivation Function 2 algorithm.
     */

            const PBKDF2 = C_algo.PBKDF2 = Base.extend({
              /**
       * Configuration options.
       *
       * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
       * @property {Hasher} hasher The hasher to use. Default: SHA1
       * @property {number} iterations The number of iterations to perform. Default: 1
       */
              cfg: Base.extend({
                keySize: 128 / 32,
                hasher: SHA1,
                iterations: 1,
              }),

              /**
       * Initializes a newly created key derivation function.
       *
       * @param {Object} cfg (Optional) The configuration options to use for the derivation.
       *
       * @example
       *
       *     var kdf = CryptoJS.algo.PBKDF2.create();
       *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
       *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
       */
              init: function init(cfg) {
                this.cfg = this.cfg.extend(cfg);
              },

              /**
       * Computes the Password-Based Key Derivation Function 2.
       *
       * @param {WordArray|string} password The password.
       * @param {WordArray|string} salt A salt.
       *
       * @return {WordArray} The derived key.
       *
       * @example
       *
       *     var key = kdf.compute(password, salt);
       */
              compute: function compute(password, salt) {
                // Shortcut
                const { cfg } = this; // Init HMAC

                const hmac = HMAC.create(cfg.hasher, password); // Initial values

                const derivedKey = WordArray.create();
                const blockIndex = WordArray.create([0x00000001]); // Shortcuts

                const derivedKeyWords = derivedKey.words;
                const blockIndexWords = blockIndex.words;
                const { keySize } = cfg;
                const { iterations } = cfg; // Generate key

                while (derivedKeyWords.length < keySize) {
                  const block = hmac.update(salt).finalize(blockIndex);
                  hmac.reset(); // Shortcuts

                  const blockWords = block.words;
                  const blockWordsLength = blockWords.length; // Iterations

                  let intermediate = block;

                  for (let i = 1; i < iterations; i++) {
                    intermediate = hmac.finalize(intermediate);
                    hmac.reset(); // Shortcut

                    const intermediateWords = intermediate.words; // XOR intermediate with block

                    for (let j = 0; j < blockWordsLength; j++) {
                      blockWords[j] ^= intermediateWords[j];
                    }
                  }

                  derivedKey.concat(block);
                  blockIndexWords[0]++;
                }

                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
              },
            });
            /**
     * Computes the Password-Based Key Derivation Function 2.
     *
     * @param {WordArray|string} password The password.
     * @param {WordArray|string} salt A salt.
     * @param {Object} cfg (Optional) The configuration options to use for this computation.
     *
     * @return {WordArray} The derived key.
     *
     * @static
     *
     * @example
     *
     *     var key = CryptoJS.PBKDF2(password, salt);
     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
     */

            C.PBKDF2 = function (password, salt, cfg) {
              return PBKDF2.create(cfg).compute(password, salt);
            };
          }());

          return CryptoJS.PBKDF2;
        }));
        /***/ }),

      /***/ 4363:
      /***/ (function (module, exports, __webpack_require__) {
        (function (root, factory, undef) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757), __webpack_require__(7508), __webpack_require__(3440), __webpack_require__(3839), __webpack_require__(1582));
          } else {}
        }(void 0, (CryptoJS) => {
          (function () {
            // Shortcuts
            const C = CryptoJS;
            const C_lib = C.lib;
            const { StreamCipher } = C_lib;
            const C_algo = C.algo; // Reusable objects

            const S = [];
            const C_ = [];
            const G = [];
            /**
     * Rabbit stream cipher algorithm.
     *
     * This is a legacy version that neglected to convert the key to little-endian.
     * This error doesn't affect the cipher's security,
     * but it does affect its compatibility with other implementations.
     */

            const RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
              _doReset: function _doReset() {
                // Shortcuts
                const K = this._key.words;
                const { iv } = this.cfg; // Generate initial state values

                const X = this._X = [K[0], K[3] << 16 | K[2] >>> 16, K[1], K[0] << 16 | K[3] >>> 16, K[2], K[1] << 16 | K[0] >>> 16, K[3], K[2] << 16 | K[1] >>> 16]; // Generate initial counter values

                const C = this._C = [K[2] << 16 | K[2] >>> 16, K[0] & 0xffff0000 | K[1] & 0x0000ffff, K[3] << 16 | K[3] >>> 16, K[1] & 0xffff0000 | K[2] & 0x0000ffff, K[0] << 16 | K[0] >>> 16, K[2] & 0xffff0000 | K[3] & 0x0000ffff, K[1] << 16 | K[1] >>> 16, K[3] & 0xffff0000 | K[0] & 0x0000ffff]; // Carry bit

                this._b = 0; // Iterate the system four times

                for (var i = 0; i < 4; i++) {
                  nextState.call(this);
                } // Modify the counters

                for (var i = 0; i < 8; i++) {
                  C[i] ^= X[i + 4 & 7];
                } // IV setup

                if (iv) {
                  // Shortcuts
                  const IV = iv.words;
                  const IV_0 = IV[0];
                  const IV_1 = IV[1]; // Generate four subvectors

                  const i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                  const i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                  const i1 = i0 >>> 16 | i2 & 0xffff0000;
                  const i3 = i2 << 16 | i0 & 0x0000ffff; // Modify counter values

                  C[0] ^= i0;
                  C[1] ^= i1;
                  C[2] ^= i2;
                  C[3] ^= i3;
                  C[4] ^= i0;
                  C[5] ^= i1;
                  C[6] ^= i2;
                  C[7] ^= i3; // Iterate the system four times

                  for (var i = 0; i < 4; i++) {
                    nextState.call(this);
                  }
                }
              },
              _doProcessBlock: function _doProcessBlock(M, offset) {
                // Shortcut
                const X = this._X; // Iterate the system

                nextState.call(this); // Generate four keystream words

                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;

                for (let i = 0; i < 4; i++) {
                  // Swap endian
                  S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00; // Encrypt

                  M[offset + i] ^= S[i];
                }
              },
              blockSize: 128 / 32,
              ivSize: 64 / 32,
            });

            function nextState() {
              // Shortcuts
              const X = this._X;
              const C = this._C; // Save old counter values

              for (var i = 0; i < 8; i++) {
                C_[i] = C[i];
              } // Calculate new counter values

              C[0] = C[0] + 0x4d34d34d + this._b | 0;
              C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
              C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
              C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
              C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
              C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
              C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
              C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
              this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0; // Calculate the g-values

              for (var i = 0; i < 8; i++) {
                const gx = X[i] + C[i]; // Construct high and low argument for squaring

                const ga = gx & 0xffff;
                const gb = gx >>> 16; // Calculate high and low result of squaring

                const gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                const gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0); // High XOR low

                G[i] = gh ^ gl;
              } // Calculate new state values

              X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
              X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
              X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
              X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
              X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
              X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
              X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
              X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
            }
            /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
     */

            C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
          }());

          return CryptoJS.RabbitLegacy;
        }));
        /***/ }),

      /***/ 5323:
      /***/ (function (module, exports, __webpack_require__) {
        (function (root, factory, undef) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757), __webpack_require__(7508), __webpack_require__(3440), __webpack_require__(3839), __webpack_require__(1582));
          } else {}
        }(void 0, (CryptoJS) => {
          (function () {
            // Shortcuts
            const C = CryptoJS;
            const C_lib = C.lib;
            const { StreamCipher } = C_lib;
            const C_algo = C.algo; // Reusable objects

            const S = [];
            const C_ = [];
            const G = [];
            /**
     * Rabbit stream cipher algorithm
     */

            const Rabbit = C_algo.Rabbit = StreamCipher.extend({
              _doReset: function _doReset() {
                // Shortcuts
                const K = this._key.words;
                const { iv } = this.cfg; // Swap endian

                for (var i = 0; i < 4; i++) {
                  K[i] = (K[i] << 8 | K[i] >>> 24) & 0x00ff00ff | (K[i] << 24 | K[i] >>> 8) & 0xff00ff00;
                } // Generate initial state values

                const X = this._X = [K[0], K[3] << 16 | K[2] >>> 16, K[1], K[0] << 16 | K[3] >>> 16, K[2], K[1] << 16 | K[0] >>> 16, K[3], K[2] << 16 | K[1] >>> 16]; // Generate initial counter values

                const C = this._C = [K[2] << 16 | K[2] >>> 16, K[0] & 0xffff0000 | K[1] & 0x0000ffff, K[3] << 16 | K[3] >>> 16, K[1] & 0xffff0000 | K[2] & 0x0000ffff, K[0] << 16 | K[0] >>> 16, K[2] & 0xffff0000 | K[3] & 0x0000ffff, K[1] << 16 | K[1] >>> 16, K[3] & 0xffff0000 | K[0] & 0x0000ffff]; // Carry bit

                this._b = 0; // Iterate the system four times

                for (var i = 0; i < 4; i++) {
                  nextState.call(this);
                } // Modify the counters

                for (var i = 0; i < 8; i++) {
                  C[i] ^= X[i + 4 & 7];
                } // IV setup

                if (iv) {
                  // Shortcuts
                  const IV = iv.words;
                  const IV_0 = IV[0];
                  const IV_1 = IV[1]; // Generate four subvectors

                  const i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                  const i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                  const i1 = i0 >>> 16 | i2 & 0xffff0000;
                  const i3 = i2 << 16 | i0 & 0x0000ffff; // Modify counter values

                  C[0] ^= i0;
                  C[1] ^= i1;
                  C[2] ^= i2;
                  C[3] ^= i3;
                  C[4] ^= i0;
                  C[5] ^= i1;
                  C[6] ^= i2;
                  C[7] ^= i3; // Iterate the system four times

                  for (var i = 0; i < 4; i++) {
                    nextState.call(this);
                  }
                }
              },
              _doProcessBlock: function _doProcessBlock(M, offset) {
                // Shortcut
                const X = this._X; // Iterate the system

                nextState.call(this); // Generate four keystream words

                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;

                for (let i = 0; i < 4; i++) {
                  // Swap endian
                  S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00; // Encrypt

                  M[offset + i] ^= S[i];
                }
              },
              blockSize: 128 / 32,
              ivSize: 64 / 32,
            });

            function nextState() {
              // Shortcuts
              const X = this._X;
              const C = this._C; // Save old counter values

              for (var i = 0; i < 8; i++) {
                C_[i] = C[i];
              } // Calculate new counter values

              C[0] = C[0] + 0x4d34d34d + this._b | 0;
              C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
              C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
              C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
              C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
              C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
              C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
              C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
              this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0; // Calculate the g-values

              for (var i = 0; i < 8; i++) {
                const gx = X[i] + C[i]; // Construct high and low argument for squaring

                const ga = gx & 0xffff;
                const gb = gx >>> 16; // Calculate high and low result of squaring

                const gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                const gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0); // High XOR low

                G[i] = gh ^ gl;
              } // Calculate new state values

              X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
              X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
              X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
              X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
              X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
              X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
              X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
              X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
            }
            /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
     */

            C.Rabbit = StreamCipher._createHelper(Rabbit);
          }());

          return CryptoJS.Rabbit;
        }));
        /***/ }),

      /***/ 4640:
      /***/ (function (module, exports, __webpack_require__) {
        __webpack_require__(1539);

        __webpack_require__(8674);

        (function (root, factory, undef) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757), __webpack_require__(7508), __webpack_require__(3440), __webpack_require__(3839), __webpack_require__(1582));
          } else {}
        }(void 0, (CryptoJS) => {
          (function () {
            // Shortcuts
            const C = CryptoJS;
            const C_lib = C.lib;
            const { StreamCipher } = C_lib;
            const C_algo = C.algo;
            /**
     * RC4 stream cipher algorithm.
     */

            const RC4 = C_algo.RC4 = StreamCipher.extend({
              _doReset: function _doReset() {
                // Shortcuts
                const key = this._key;
                const keyWords = key.words;
                const keySigBytes = key.sigBytes; // Init sbox

                const S = this._S = [];

                for (var i = 0; i < 256; i++) {
                  S[i] = i;
                } // Key setup

                for (var i = 0, j = 0; i < 256; i++) {
                  const keyByteIndex = i % keySigBytes;
                  const keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;
                  j = (j + S[i] + keyByte) % 256; // Swap

                  const t = S[i];
                  S[i] = S[j];
                  S[j] = t;
                } // Counters

                this._i = this._j = 0;
              },
              _doProcessBlock: function _doProcessBlock(M, offset) {
                M[offset] ^= generateKeystreamWord.call(this);
              },
              keySize: 256 / 32,
              ivSize: 0,
            });

            function generateKeystreamWord() {
              // Shortcuts
              const S = this._S;
              let i = this._i;
              let j = this._j; // Generate keystream word

              let keystreamWord = 0;

              for (let n = 0; n < 4; n++) {
                i = (i + 1) % 256;
                j = (j + S[i]) % 256; // Swap

                const t = S[i];
                S[i] = S[j];
                S[j] = t;
                keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
              } // Update counters

              this._i = i;
              this._j = j;
              return keystreamWord;
            }
            /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
     */

            C.RC4 = StreamCipher._createHelper(RC4);
            /**
     * Modified RC4 stream cipher algorithm.
     */

            const RC4Drop = C_algo.RC4Drop = RC4.extend({
              /**
       * Configuration options.
       *
       * @property {number} drop The number of keystream words to drop. Default 192
       */
              cfg: RC4.cfg.extend({
                drop: 192,
              }),
              _doReset: function _doReset() {
                RC4._doReset.call(this); // Drop

                for (let i = this.cfg.drop; i > 0; i--) {
                  generateKeystreamWord.call(this);
                }
              },
            });
            /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
     */

            C.RC4Drop = StreamCipher._createHelper(RC4Drop);
          }());

          return CryptoJS.RC4;
        }));
        /***/ }),

      /***/ 8714:
      /***/ (function (module, exports, __webpack_require__) {
        (function (root, factory) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757));
          } else {}
        }(void 0, (CryptoJS) => {
          /** @preserve
  (c) 2012 by Cédric Mesnil. All rights reserved.
  	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
  	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
      - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
  	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */
          (function (Math) {
            // Shortcuts
            const C = CryptoJS;
            const C_lib = C.lib;
            const { WordArray } = C_lib;
            const { Hasher } = C_lib;
            const C_algo = C.algo; // Constants table

            const _zl = WordArray.create([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13]);

            const _zr = WordArray.create([5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11]);

            const _sl = WordArray.create([11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6]);

            const _sr = WordArray.create([8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11]);

            const _hl = WordArray.create([0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);

            const _hr = WordArray.create([0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);
            /**
     * RIPEMD160 hash algorithm.
     */

            const RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
              _doReset: function _doReset() {
                this._hash = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
              },
              _doProcessBlock: function _doProcessBlock(M, offset) {
                // Swap endian
                for (var i = 0; i < 16; i++) {
                  // Shortcuts
                  const offset_i = offset + i;
                  const M_offset_i = M[offset_i]; // Swap

                  M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                } // Shortcut

                const H = this._hash.words;
                const hl = _hl.words;
                const hr = _hr.words;
                const zl = _zl.words;
                const zr = _zr.words;
                const sl = _sl.words;
                const sr = _sr.words; // Working variables

                let al; let bl; let cl; let dl; let
                  el;
                let ar; let br; let cr; let dr; let
                  er;
                ar = al = H[0];
                br = bl = H[1];
                cr = cl = H[2];
                dr = dl = H[3];
                er = el = H[4]; // Computation

                let t;

                for (var i = 0; i < 80; i += 1) {
                  t = al + M[offset + zl[i]] | 0;

                  if (i < 16) {
                    t += f1(bl, cl, dl) + hl[0];
                  } else if (i < 32) {
                    t += f2(bl, cl, dl) + hl[1];
                  } else if (i < 48) {
                    t += f3(bl, cl, dl) + hl[2];
                  } else if (i < 64) {
                    t += f4(bl, cl, dl) + hl[3];
                  } else {
                    // if (i<80) {
                    t += f5(bl, cl, dl) + hl[4];
                  }

                  t |= 0;
                  t = rotl(t, sl[i]);
                  t = t + el | 0;
                  al = el;
                  el = dl;
                  dl = rotl(cl, 10);
                  cl = bl;
                  bl = t;
                  t = ar + M[offset + zr[i]] | 0;

                  if (i < 16) {
                    t += f5(br, cr, dr) + hr[0];
                  } else if (i < 32) {
                    t += f4(br, cr, dr) + hr[1];
                  } else if (i < 48) {
                    t += f3(br, cr, dr) + hr[2];
                  } else if (i < 64) {
                    t += f2(br, cr, dr) + hr[3];
                  } else {
                    // if (i<80) {
                    t += f1(br, cr, dr) + hr[4];
                  }

                  t |= 0;
                  t = rotl(t, sr[i]);
                  t = t + er | 0;
                  ar = er;
                  er = dr;
                  dr = rotl(cr, 10);
                  cr = br;
                  br = t;
                } // Intermediate hash value

                t = H[1] + cl + dr | 0;
                H[1] = H[2] + dl + er | 0;
                H[2] = H[3] + el + ar | 0;
                H[3] = H[4] + al + br | 0;
                H[4] = H[0] + bl + cr | 0;
                H[0] = t;
              },
              _doFinalize: function _doFinalize() {
                // Shortcuts
                const data = this._data;
                const dataWords = data.words;
                const nBitsTotal = this._nDataBytes * 8;
                const nBitsLeft = data.sigBytes * 8; // Add padding

                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4; // Hash final blocks

                this._process(); // Shortcuts

                const hash = this._hash;
                const H = hash.words; // Swap endian

                for (let i = 0; i < 5; i++) {
                  // Shortcut
                  const H_i = H[i]; // Swap

                  H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                } // Return final computed hash

                return hash;
              },
              clone: function clone() {
                const clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
              },
            });

            function f1(x, y, z) {
              return x ^ y ^ z;
            }

            function f2(x, y, z) {
              return x & y | ~x & z;
            }

            function f3(x, y, z) {
              return (x | ~y) ^ z;
            }

            function f4(x, y, z) {
              return x & z | y & ~z;
            }

            function f5(x, y, z) {
              return x ^ (y | ~z);
            }

            function rotl(x, n) {
              return x << n | x >>> 32 - n;
            }
            /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.RIPEMD160('message');
     *     var hash = CryptoJS.RIPEMD160(wordArray);
     */

            C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
            /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
     */

            C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
          }(Math));

          return CryptoJS.RIPEMD160;
        }));
        /***/ }),

      /***/ 9865:
      /***/ (function (module, exports, __webpack_require__) {
        (function (root, factory) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757));
          } else {}
        }(void 0, (CryptoJS) => {
          (function () {
            // Shortcuts
            const C = CryptoJS;
            const C_lib = C.lib;
            const { WordArray } = C_lib;
            const { Hasher } = C_lib;
            const C_algo = C.algo; // Reusable object

            const W = [];
            /**
     * SHA-1 hash algorithm.
     */

            const SHA1 = C_algo.SHA1 = Hasher.extend({
              _doReset: function _doReset() {
                this._hash = new WordArray.init([0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0]);
              },
              _doProcessBlock: function _doProcessBlock(M, offset) {
                // Shortcut
                const H = this._hash.words; // Working variables

                let a = H[0];
                let b = H[1];
                let c = H[2];
                let d = H[3];
                let e = H[4]; // Computation

                for (let i = 0; i < 80; i++) {
                  if (i < 16) {
                    W[i] = M[offset + i] | 0;
                  } else {
                    const n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                    W[i] = n << 1 | n >>> 31;
                  }

                  let t = (a << 5 | a >>> 27) + e + W[i];

                  if (i < 20) {
                    t += (b & c | ~b & d) + 0x5a827999;
                  } else if (i < 40) {
                    t += (b ^ c ^ d) + 0x6ed9eba1;
                  } else if (i < 60) {
                    t += (b & c | b & d | c & d) - 0x70e44324;
                  } else
                  /* if (i < 80) */
                  {
                    t += (b ^ c ^ d) - 0x359d3e2a;
                  }

                  e = d;
                  d = c;
                  c = b << 30 | b >>> 2;
                  b = a;
                  a = t;
                } // Intermediate hash value

                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
              },
              _doFinalize: function _doFinalize() {
                // Shortcuts
                const data = this._data;
                const dataWords = data.words;
                const nBitsTotal = this._nDataBytes * 8;
                const nBitsLeft = data.sigBytes * 8; // Add padding

                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4; // Hash final blocks

                this._process(); // Return final computed hash

                return this._hash;
              },
              clone: function clone() {
                const clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
              },
            });
            /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA1('message');
     *     var hash = CryptoJS.SHA1(wordArray);
     */

            C.SHA1 = Hasher._createHelper(SHA1);
            /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA1(message, key);
     */

            C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
          }());

          return CryptoJS.SHA1;
        }));
        /***/ }),

      /***/ 6876:
      /***/ (function (module, exports, __webpack_require__) {
        (function (root, factory, undef) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757), __webpack_require__(8921));
          } else {}
        }(void 0, (CryptoJS) => {
          (function () {
            // Shortcuts
            const C = CryptoJS;
            const C_lib = C.lib;
            const { WordArray } = C_lib;
            const C_algo = C.algo;
            const { SHA256 } = C_algo;
            /**
     * SHA-224 hash algorithm.
     */

            const SHA224 = C_algo.SHA224 = SHA256.extend({
              _doReset: function _doReset() {
                this._hash = new WordArray.init([0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939, 0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4]);
              },
              _doFinalize: function _doFinalize() {
                const hash = SHA256._doFinalize.call(this);

                hash.sigBytes -= 4;
                return hash;
              },
            });
            /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA224('message');
     *     var hash = CryptoJS.SHA224(wordArray);
     */

            C.SHA224 = SHA256._createHelper(SHA224);
            /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA224(message, key);
     */

            C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
          }());

          return CryptoJS.SHA224;
        }));
        /***/ }),

      /***/ 8921:
      /***/ (function (module, exports, __webpack_require__) {
        __webpack_require__(7042);

        (function (root, factory) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757));
          } else {}
        }(void 0, (CryptoJS) => {
          (function (Math) {
            // Shortcuts
            const C = CryptoJS;
            const C_lib = C.lib;
            const { WordArray } = C_lib;
            const { Hasher } = C_lib;
            const C_algo = C.algo; // Initialization and round constants tables

            const H = [];
            const K = []; // Compute constants

            (function () {
              function isPrime(n) {
                const sqrtN = Math.sqrt(n);

                for (let factor = 2; factor <= sqrtN; factor++) {
                  if (!(n % factor)) {
                    return false;
                  }
                }

                return true;
              }

              function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
              }

              let n = 2;
              let nPrime = 0;

              while (nPrime < 64) {
                if (isPrime(n)) {
                  if (nPrime < 8) {
                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
                  }

                  K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));
                  nPrime++;
                }

                n++;
              }
            }()); // Reusable object

            const W = [];
            /**
     * SHA-256 hash algorithm.
     */

            const SHA256 = C_algo.SHA256 = Hasher.extend({
              _doReset: function _doReset() {
                this._hash = new WordArray.init(H.slice(0));
              },
              _doProcessBlock: function _doProcessBlock(M, offset) {
                // Shortcut
                const H = this._hash.words; // Working variables

                let a = H[0];
                let b = H[1];
                let c = H[2];
                let d = H[3];
                let e = H[4];
                let f = H[5];
                let g = H[6];
                let h = H[7]; // Computation

                for (let i = 0; i < 64; i++) {
                  if (i < 16) {
                    W[i] = M[offset + i] | 0;
                  } else {
                    const gamma0x = W[i - 15];
                    const gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                    const gamma1x = W[i - 2];
                    const gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                  }

                  const ch = e & f ^ ~e & g;
                  const maj = a & b ^ a & c ^ b & c;
                  const sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                  const sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                  const t1 = h + sigma1 + ch + K[i] + W[i];
                  const t2 = sigma0 + maj;
                  h = g;
                  g = f;
                  f = e;
                  e = d + t1 | 0;
                  d = c;
                  c = b;
                  b = a;
                  a = t1 + t2 | 0;
                } // Intermediate hash value

                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
              },
              _doFinalize: function _doFinalize() {
                // Shortcuts
                const data = this._data;
                const dataWords = data.words;
                const nBitsTotal = this._nDataBytes * 8;
                const nBitsLeft = data.sigBytes * 8; // Add padding

                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4; // Hash final blocks

                this._process(); // Return final computed hash

                return this._hash;
              },
              clone: function clone() {
                const clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
              },
            });
            /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA256('message');
     *     var hash = CryptoJS.SHA256(wordArray);
     */

            C.SHA256 = Hasher._createHelper(SHA256);
            /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA256(message, key);
     */

            C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
          }(Math));

          return CryptoJS.SHA256;
        }));
        /***/ }),

      /***/ 8342:
      /***/ (function (module, exports, __webpack_require__) {
        __webpack_require__(7042);

        (function (root, factory, undef) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757), __webpack_require__(2601));
          } else {}
        }(void 0, (CryptoJS) => {
          (function (Math) {
            // Shortcuts
            const C = CryptoJS;
            const C_lib = C.lib;
            const { WordArray } = C_lib;
            const { Hasher } = C_lib;
            const C_x64 = C.x64;
            const X64Word = C_x64.Word;
            const C_algo = C.algo; // Constants tables

            const RHO_OFFSETS = [];
            const PI_INDEXES = [];
            const ROUND_CONSTANTS = []; // Compute Constants

            (function () {
              // Compute rho offset constants
              var x = 1;
              var y = 0;

              for (let t = 0; t < 24; t++) {
                RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
                const newX = y % 5;
                const newY = (2 * x + 3 * y) % 5;
                x = newX;
                y = newY;
              } // Compute pi index constants

              for (var x = 0; x < 5; x++) {
                for (var y = 0; y < 5; y++) {
                  PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
                }
              } // Compute round constants

              let LFSR = 0x01;

              for (let i = 0; i < 24; i++) {
                let roundConstantMsw = 0;
                let roundConstantLsw = 0;

                for (let j = 0; j < 7; j++) {
                  if (LFSR & 0x01) {
                    const bitPosition = (1 << j) - 1;

                    if (bitPosition < 32) {
                      roundConstantLsw ^= 1 << bitPosition;
                    } else
                    /* if (bitPosition >= 32) */
                    {
                      roundConstantMsw ^= 1 << bitPosition - 32;
                    }
                  } // Compute next LFSR

                  if (LFSR & 0x80) {
                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
                    LFSR = LFSR << 1 ^ 0x71;
                  } else {
                    LFSR <<= 1;
                  }
                }

                ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
              }
            }()); // Reusable objects for temporary values

            const T = [];

            (function () {
              for (let i = 0; i < 25; i++) {
                T[i] = X64Word.create();
              }
            }());
            /**
     * SHA-3 hash algorithm.
     */

            const SHA3 = C_algo.SHA3 = Hasher.extend({
              /**
       * Configuration options.
       *
       * @property {number} outputLength
       *   The desired number of bits in the output hash.
       *   Only values permitted are: 224, 256, 384, 512.
       *   Default: 512
       */
              cfg: Hasher.cfg.extend({
                outputLength: 512,
              }),
              _doReset: function _doReset() {
                const state = this._state = [];

                for (let i = 0; i < 25; i++) {
                  state[i] = new X64Word.init();
                }

                this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
              },
              _doProcessBlock: function _doProcessBlock(M, offset) {
                // Shortcuts
                const state = this._state;
                const nBlockSizeLanes = this.blockSize / 2; // Absorb

                for (let i = 0; i < nBlockSizeLanes; i++) {
                  // Shortcuts
                  let M2i = M[offset + 2 * i];
                  let M2i1 = M[offset + 2 * i + 1]; // Swap endian

                  M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
                  M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00; // Absorb message into state

                  var lane = state[i];
                  lane.high ^= M2i1;
                  lane.low ^= M2i;
                } // Rounds

                for (let round = 0; round < 24; round++) {
                  // Theta
                  for (var x = 0; x < 5; x++) {
                    // Mix column lanes
                    var tMsw = 0;
                    var tLsw = 0;

                    for (var y = 0; y < 5; y++) {
                      var lane = state[x + 5 * y];
                      tMsw ^= lane.high;
                      tLsw ^= lane.low;
                    } // Temporary values

                    const Tx = T[x];
                    Tx.high = tMsw;
                    Tx.low = tLsw;
                  }

                  for (var x = 0; x < 5; x++) {
                    // Shortcuts
                    const Tx4 = T[(x + 4) % 5];
                    const Tx1 = T[(x + 1) % 5];
                    const Tx1Msw = Tx1.high;
                    const Tx1Lsw = Tx1.low; // Mix surrounding columns

                    var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
                    var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);

                    for (var y = 0; y < 5; y++) {
                      var lane = state[x + 5 * y];
                      lane.high ^= tMsw;
                      lane.low ^= tLsw;
                    }
                  } // Rho Pi

                  for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
                    var tMsw;
                    var tLsw; // Shortcuts

                    var lane = state[laneIndex];
                    const laneMsw = lane.high;
                    const laneLsw = lane.low;
                    const rhoOffset = RHO_OFFSETS[laneIndex]; // Rotate lanes

                    if (rhoOffset < 32) {
                      tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
                      tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
                    } else
                    /* if (rhoOffset >= 32) */
                    {
                      tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
                      tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
                    } // Transpose lanes

                    const TPiLane = T[PI_INDEXES[laneIndex]];
                    TPiLane.high = tMsw;
                    TPiLane.low = tLsw;
                  } // Rho pi at x = y = 0

                  const T0 = T[0];
                  const state0 = state[0];
                  T0.high = state0.high;
                  T0.low = state0.low; // Chi

                  for (var x = 0; x < 5; x++) {
                    for (var y = 0; y < 5; y++) {
                      // Shortcuts
                      var laneIndex = x + 5 * y;
                      var lane = state[laneIndex];
                      const TLane = T[laneIndex];
                      const Tx1Lane = T[(x + 1) % 5 + 5 * y];
                      const Tx2Lane = T[(x + 2) % 5 + 5 * y]; // Mix rows

                      lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
                      lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
                    }
                  } // Iota

                  var lane = state[0];
                  const roundConstant = ROUND_CONSTANTS[round];
                  lane.high ^= roundConstant.high;
                  lane.low ^= roundConstant.low;
                }
              },
              _doFinalize: function _doFinalize() {
                // Shortcuts
                const data = this._data;
                const dataWords = data.words;
                const nBitsTotal = this._nDataBytes * 8;
                const nBitsLeft = data.sigBytes * 8;
                const blockSizeBits = this.blockSize * 32; // Add padding

                dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
                dataWords[(Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
                data.sigBytes = dataWords.length * 4; // Hash final blocks

                this._process(); // Shortcuts

                const state = this._state;
                const outputLengthBytes = this.cfg.outputLength / 8;
                const outputLengthLanes = outputLengthBytes / 8; // Squeeze

                const hashWords = [];

                for (let i = 0; i < outputLengthLanes; i++) {
                  // Shortcuts
                  const lane = state[i];
                  let laneMsw = lane.high;
                  let laneLsw = lane.low; // Swap endian

                  laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
                  laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00; // Squeeze state to retrieve hash

                  hashWords.push(laneLsw);
                  hashWords.push(laneMsw);
                } // Return final computed hash

                return new WordArray.init(hashWords, outputLengthBytes);
              },
              clone: function clone() {
                const clone = Hasher.clone.call(this);

                const state = clone._state = this._state.slice(0);

                for (let i = 0; i < 25; i++) {
                  state[i] = state[i].clone();
                }

                return clone;
              },
            });
            /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA3('message');
     *     var hash = CryptoJS.SHA3(wordArray);
     */

            C.SHA3 = Hasher._createHelper(SHA3);
            /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA3(message, key);
     */

            C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
          }(Math));

          return CryptoJS.SHA3;
        }));
        /***/ }),

      /***/ 8122:
      /***/ (function (module, exports, __webpack_require__) {
        (function (root, factory, undef) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757), __webpack_require__(2601), __webpack_require__(7991));
          } else {}
        }(void 0, (CryptoJS) => {
          (function () {
            // Shortcuts
            const C = CryptoJS;
            const C_x64 = C.x64;
            const X64Word = C_x64.Word;
            const X64WordArray = C_x64.WordArray;
            const C_algo = C.algo;
            const { SHA512 } = C_algo;
            /**
     * SHA-384 hash algorithm.
     */

            const SHA384 = C_algo.SHA384 = SHA512.extend({
              _doReset: function _doReset() {
                this._hash = new X64WordArray.init([new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507), new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939), new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511), new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)]);
              },
              _doFinalize: function _doFinalize() {
                const hash = SHA512._doFinalize.call(this);

                hash.sigBytes -= 16;
                return hash;
              },
            });
            /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA384('message');
     *     var hash = CryptoJS.SHA384(wordArray);
     */

            C.SHA384 = SHA512._createHelper(SHA384);
            /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA384(message, key);
     */

            C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
          }());

          return CryptoJS.SHA384;
        }));
        /***/ }),

      /***/ 7991:
      /***/ (function (module, exports, __webpack_require__) {
        (function (root, factory, undef) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757), __webpack_require__(2601));
          } else {}
        }(void 0, (CryptoJS) => {
          (function () {
            // Shortcuts
            const C = CryptoJS;
            const C_lib = C.lib;
            const { Hasher } = C_lib;
            const C_x64 = C.x64;
            const X64Word = C_x64.Word;
            const X64WordArray = C_x64.WordArray;
            const C_algo = C.algo;

            function X64Word_create() {
              return X64Word.create.apply(X64Word, arguments);
            } // Constants

            const K = [X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd), X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc), X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019), X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118), X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe), X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2), X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1), X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694), X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3), X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65), X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483), X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5), X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210), X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4), X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725), X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70), X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926), X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df), X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8), X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b), X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001), X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30), X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910), X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8), X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53), X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8), X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb), X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3), X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60), X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec), X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9), X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b), X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207), X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178), X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6), X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b), X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493), X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c), X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a), X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)]; // Reusable objects

            const W = [];

            (function () {
              for (let i = 0; i < 80; i++) {
                W[i] = X64Word_create();
              }
            }());
            /**
     * SHA-512 hash algorithm.
     */

            const SHA512 = C_algo.SHA512 = Hasher.extend({
              _doReset: function _doReset() {
                this._hash = new X64WordArray.init([new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b), new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1), new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f), new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)]);
              },
              _doProcessBlock: function _doProcessBlock(M, offset) {
                // Shortcuts
                const H = this._hash.words;
                const H0 = H[0];
                const H1 = H[1];
                const H2 = H[2];
                const H3 = H[3];
                const H4 = H[4];
                const H5 = H[5];
                const H6 = H[6];
                const H7 = H[7];
                const H0h = H0.high;
                let H0l = H0.low;
                const H1h = H1.high;
                let H1l = H1.low;
                const H2h = H2.high;
                let H2l = H2.low;
                const H3h = H3.high;
                let H3l = H3.low;
                const H4h = H4.high;
                let H4l = H4.low;
                const H5h = H5.high;
                let H5l = H5.low;
                const H6h = H6.high;
                let H6l = H6.low;
                const H7h = H7.high;
                let H7l = H7.low; // Working variables

                let ah = H0h;
                let al = H0l;
                let bh = H1h;
                let bl = H1l;
                let ch = H2h;
                let cl = H2l;
                let dh = H3h;
                let dl = H3l;
                let eh = H4h;
                let el = H4l;
                let fh = H5h;
                let fl = H5l;
                let gh = H6h;
                let gl = H6l;
                let hh = H7h;
                let hl = H7l; // Rounds

                for (let i = 0; i < 80; i++) {
                  var Wil;
                  var Wih; // Shortcut

                  const Wi = W[i]; // Extend message

                  if (i < 16) {
                    Wih = Wi.high = M[offset + i * 2] | 0;
                    Wil = Wi.low = M[offset + i * 2 + 1] | 0;
                  } else {
                    // Gamma0
                    const gamma0x = W[i - 15];
                    const gamma0xh = gamma0x.high;
                    const gamma0xl = gamma0x.low;
                    const gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
                    const gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25); // Gamma1

                    const gamma1x = W[i - 2];
                    const gamma1xh = gamma1x.high;
                    const gamma1xl = gamma1x.low;
                    const gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
                    const gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26); // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]

                    const Wi7 = W[i - 7];
                    const Wi7h = Wi7.high;
                    const Wi7l = Wi7.low;
                    const Wi16 = W[i - 16];
                    const Wi16h = Wi16.high;
                    const Wi16l = Wi16.low;
                    Wil = gamma0l + Wi7l;
                    Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
                    Wil += gamma1l;
                    Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
                    Wil += Wi16l;
                    Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
                    Wi.high = Wih;
                    Wi.low = Wil;
                  }

                  const chh = eh & fh ^ ~eh & gh;
                  const chl = el & fl ^ ~el & gl;
                  const majh = ah & bh ^ ah & ch ^ bh & ch;
                  const majl = al & bl ^ al & cl ^ bl & cl;
                  const sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
                  const sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
                  const sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
                  const sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9); // t1 = h + sigma1 + ch + K[i] + W[i]

                  const Ki = K[i];
                  const Kih = Ki.high;
                  const Kil = Ki.low;
                  var t1l = hl + sigma1l;
                  var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
                  var t1l = t1l + chl;
                  var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
                  var t1l = t1l + Kil;
                  var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
                  var t1l = t1l + Wil;
                  var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0); // t2 = sigma0 + maj

                  const t2l = sigma0l + majl;
                  const t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0); // Update working variables

                  hh = gh;
                  hl = gl;
                  gh = fh;
                  gl = fl;
                  fh = eh;
                  fl = el;
                  el = dl + t1l | 0;
                  eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
                  dh = ch;
                  dl = cl;
                  ch = bh;
                  cl = bl;
                  bh = ah;
                  bl = al;
                  al = t1l + t2l | 0;
                  ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
                } // Intermediate hash value

                H0l = H0.low = H0l + al;
                H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
                H1l = H1.low = H1l + bl;
                H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
                H2l = H2.low = H2l + cl;
                H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
                H3l = H3.low = H3l + dl;
                H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
                H4l = H4.low = H4l + el;
                H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
                H5l = H5.low = H5l + fl;
                H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
                H6l = H6.low = H6l + gl;
                H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
                H7l = H7.low = H7l + hl;
                H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
              },
              _doFinalize: function _doFinalize() {
                // Shortcuts
                const data = this._data;
                const dataWords = data.words;
                const nBitsTotal = this._nDataBytes * 8;
                const nBitsLeft = data.sigBytes * 8; // Add padding

                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
                data.sigBytes = dataWords.length * 4; // Hash final blocks

                this._process(); // Convert hash to 32-bit word array before returning

                const hash = this._hash.toX32(); // Return final computed hash

                return hash;
              },
              clone: function clone() {
                const clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
              },
              blockSize: 1024 / 32,
            });
            /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA512('message');
     *     var hash = CryptoJS.SHA512(wordArray);
     */

            C.SHA512 = Hasher._createHelper(SHA512);
            /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA512(message, key);
     */

            C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
          }());

          return CryptoJS.SHA512;
        }));
        /***/ }),

      /***/ 8437:
      /***/ (function (module, exports, __webpack_require__) {
        __webpack_require__(7042);

        (function (root, factory, undef) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757), __webpack_require__(7508), __webpack_require__(3440), __webpack_require__(3839), __webpack_require__(1582));
          } else {}
        }(void 0, (CryptoJS) => {
          (function () {
            // Shortcuts
            const C = CryptoJS;
            const C_lib = C.lib;
            const { WordArray } = C_lib;
            const { BlockCipher } = C_lib;
            const C_algo = C.algo; // Permuted Choice 1 constants

            const PC1 = [57, 49, 41, 33, 25, 17, 9, 1, 58, 50, 42, 34, 26, 18, 10, 2, 59, 51, 43, 35, 27, 19, 11, 3, 60, 52, 44, 36, 63, 55, 47, 39, 31, 23, 15, 7, 62, 54, 46, 38, 30, 22, 14, 6, 61, 53, 45, 37, 29, 21, 13, 5, 28, 20, 12, 4]; // Permuted Choice 2 constants

            const PC2 = [14, 17, 11, 24, 1, 5, 3, 28, 15, 6, 21, 10, 23, 19, 12, 4, 26, 8, 16, 7, 27, 20, 13, 2, 41, 52, 31, 37, 47, 55, 30, 40, 51, 45, 33, 48, 44, 49, 39, 56, 34, 53, 46, 42, 50, 36, 29, 32]; // Cumulative bit shift constants

            const BIT_SHIFTS = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28]; // SBOXes and round permutation constants

            const SBOX_P = [{
              0x0: 0x808200,
              0x10000000: 0x8000,
              0x20000000: 0x808002,
              0x30000000: 0x2,
              0x40000000: 0x200,
              0x50000000: 0x808202,
              0x60000000: 0x800202,
              0x70000000: 0x800000,
              0x80000000: 0x202,
              0x90000000: 0x800200,
              0xa0000000: 0x8200,
              0xb0000000: 0x808000,
              0xc0000000: 0x8002,
              0xd0000000: 0x800002,
              0xe0000000: 0x0,
              0xf0000000: 0x8202,
              0x8000000: 0x0,
              0x18000000: 0x808202,
              0x28000000: 0x8202,
              0x38000000: 0x8000,
              0x48000000: 0x808200,
              0x58000000: 0x200,
              0x68000000: 0x808002,
              0x78000000: 0x2,
              0x88000000: 0x800200,
              0x98000000: 0x8200,
              0xa8000000: 0x808000,
              0xb8000000: 0x800202,
              0xc8000000: 0x800002,
              0xd8000000: 0x8002,
              0xe8000000: 0x202,
              0xf8000000: 0x800000,
              0x1: 0x8000,
              0x10000001: 0x2,
              0x20000001: 0x808200,
              0x30000001: 0x800000,
              0x40000001: 0x808002,
              0x50000001: 0x8200,
              0x60000001: 0x200,
              0x70000001: 0x800202,
              0x80000001: 0x808202,
              0x90000001: 0x808000,
              0xa0000001: 0x800002,
              0xb0000001: 0x8202,
              0xc0000001: 0x202,
              0xd0000001: 0x800200,
              0xe0000001: 0x8002,
              0xf0000001: 0x0,
              0x8000001: 0x808202,
              0x18000001: 0x808000,
              0x28000001: 0x800000,
              0x38000001: 0x200,
              0x48000001: 0x8000,
              0x58000001: 0x800002,
              0x68000001: 0x2,
              0x78000001: 0x8202,
              0x88000001: 0x8002,
              0x98000001: 0x800202,
              0xa8000001: 0x202,
              0xb8000001: 0x808200,
              0xc8000001: 0x800200,
              0xd8000001: 0x0,
              0xe8000001: 0x8200,
              0xf8000001: 0x808002,
            }, {
              0x0: 0x40084010,
              0x1000000: 0x4000,
              0x2000000: 0x80000,
              0x3000000: 0x40080010,
              0x4000000: 0x40000010,
              0x5000000: 0x40084000,
              0x6000000: 0x40004000,
              0x7000000: 0x10,
              0x8000000: 0x84000,
              0x9000000: 0x40004010,
              0xa000000: 0x40000000,
              0xb000000: 0x84010,
              0xc000000: 0x80010,
              0xd000000: 0x0,
              0xe000000: 0x4010,
              0xf000000: 0x40080000,
              0x800000: 0x40004000,
              0x1800000: 0x84010,
              0x2800000: 0x10,
              0x3800000: 0x40004010,
              0x4800000: 0x40084010,
              0x5800000: 0x40000000,
              0x6800000: 0x80000,
              0x7800000: 0x40080010,
              0x8800000: 0x80010,
              0x9800000: 0x0,
              0xa800000: 0x4000,
              0xb800000: 0x40080000,
              0xc800000: 0x40000010,
              0xd800000: 0x84000,
              0xe800000: 0x40084000,
              0xf800000: 0x4010,
              0x10000000: 0x0,
              0x11000000: 0x40080010,
              0x12000000: 0x40004010,
              0x13000000: 0x40084000,
              0x14000000: 0x40080000,
              0x15000000: 0x10,
              0x16000000: 0x84010,
              0x17000000: 0x4000,
              0x18000000: 0x4010,
              0x19000000: 0x80000,
              0x1a000000: 0x80010,
              0x1b000000: 0x40000010,
              0x1c000000: 0x84000,
              0x1d000000: 0x40004000,
              0x1e000000: 0x40000000,
              0x1f000000: 0x40084010,
              0x10800000: 0x84010,
              0x11800000: 0x80000,
              0x12800000: 0x40080000,
              0x13800000: 0x4000,
              0x14800000: 0x40004000,
              0x15800000: 0x40084010,
              0x16800000: 0x10,
              0x17800000: 0x40000000,
              0x18800000: 0x40084000,
              0x19800000: 0x40000010,
              0x1a800000: 0x40004010,
              0x1b800000: 0x80010,
              0x1c800000: 0x0,
              0x1d800000: 0x4010,
              0x1e800000: 0x40080010,
              0x1f800000: 0x84000,
            }, {
              0x0: 0x104,
              0x100000: 0x0,
              0x200000: 0x4000100,
              0x300000: 0x10104,
              0x400000: 0x10004,
              0x500000: 0x4000004,
              0x600000: 0x4010104,
              0x700000: 0x4010000,
              0x800000: 0x4000000,
              0x900000: 0x4010100,
              0xa00000: 0x10100,
              0xb00000: 0x4010004,
              0xc00000: 0x4000104,
              0xd00000: 0x10000,
              0xe00000: 0x4,
              0xf00000: 0x100,
              0x80000: 0x4010100,
              0x180000: 0x4010004,
              0x280000: 0x0,
              0x380000: 0x4000100,
              0x480000: 0x4000004,
              0x580000: 0x10000,
              0x680000: 0x10004,
              0x780000: 0x104,
              0x880000: 0x4,
              0x980000: 0x100,
              0xa80000: 0x4010000,
              0xb80000: 0x10104,
              0xc80000: 0x10100,
              0xd80000: 0x4000104,
              0xe80000: 0x4010104,
              0xf80000: 0x4000000,
              0x1000000: 0x4010100,
              0x1100000: 0x10004,
              0x1200000: 0x10000,
              0x1300000: 0x4000100,
              0x1400000: 0x100,
              0x1500000: 0x4010104,
              0x1600000: 0x4000004,
              0x1700000: 0x0,
              0x1800000: 0x4000104,
              0x1900000: 0x4000000,
              0x1a00000: 0x4,
              0x1b00000: 0x10100,
              0x1c00000: 0x4010000,
              0x1d00000: 0x104,
              0x1e00000: 0x10104,
              0x1f00000: 0x4010004,
              0x1080000: 0x4000000,
              0x1180000: 0x104,
              0x1280000: 0x4010100,
              0x1380000: 0x0,
              0x1480000: 0x10004,
              0x1580000: 0x4000100,
              0x1680000: 0x100,
              0x1780000: 0x4010004,
              0x1880000: 0x10000,
              0x1980000: 0x4010104,
              0x1a80000: 0x10104,
              0x1b80000: 0x4000004,
              0x1c80000: 0x4000104,
              0x1d80000: 0x4010000,
              0x1e80000: 0x4,
              0x1f80000: 0x10100,
            }, {
              0x0: 0x80401000,
              0x10000: 0x80001040,
              0x20000: 0x401040,
              0x30000: 0x80400000,
              0x40000: 0x0,
              0x50000: 0x401000,
              0x60000: 0x80000040,
              0x70000: 0x400040,
              0x80000: 0x80000000,
              0x90000: 0x400000,
              0xa0000: 0x40,
              0xb0000: 0x80001000,
              0xc0000: 0x80400040,
              0xd0000: 0x1040,
              0xe0000: 0x1000,
              0xf0000: 0x80401040,
              0x8000: 0x80001040,
              0x18000: 0x40,
              0x28000: 0x80400040,
              0x38000: 0x80001000,
              0x48000: 0x401000,
              0x58000: 0x80401040,
              0x68000: 0x0,
              0x78000: 0x80400000,
              0x88000: 0x1000,
              0x98000: 0x80401000,
              0xa8000: 0x400000,
              0xb8000: 0x1040,
              0xc8000: 0x80000000,
              0xd8000: 0x400040,
              0xe8000: 0x401040,
              0xf8000: 0x80000040,
              0x100000: 0x400040,
              0x110000: 0x401000,
              0x120000: 0x80000040,
              0x130000: 0x0,
              0x140000: 0x1040,
              0x150000: 0x80400040,
              0x160000: 0x80401000,
              0x170000: 0x80001040,
              0x180000: 0x80401040,
              0x190000: 0x80000000,
              0x1a0000: 0x80400000,
              0x1b0000: 0x401040,
              0x1c0000: 0x80001000,
              0x1d0000: 0x400000,
              0x1e0000: 0x40,
              0x1f0000: 0x1000,
              0x108000: 0x80400000,
              0x118000: 0x80401040,
              0x128000: 0x0,
              0x138000: 0x401000,
              0x148000: 0x400040,
              0x158000: 0x80000000,
              0x168000: 0x80001040,
              0x178000: 0x40,
              0x188000: 0x80000040,
              0x198000: 0x1000,
              0x1a8000: 0x80001000,
              0x1b8000: 0x80400040,
              0x1c8000: 0x1040,
              0x1d8000: 0x80401000,
              0x1e8000: 0x400000,
              0x1f8000: 0x401040,
            }, {
              0x0: 0x80,
              0x1000: 0x1040000,
              0x2000: 0x40000,
              0x3000: 0x20000000,
              0x4000: 0x20040080,
              0x5000: 0x1000080,
              0x6000: 0x21000080,
              0x7000: 0x40080,
              0x8000: 0x1000000,
              0x9000: 0x20040000,
              0xa000: 0x20000080,
              0xb000: 0x21040080,
              0xc000: 0x21040000,
              0xd000: 0x0,
              0xe000: 0x1040080,
              0xf000: 0x21000000,
              0x800: 0x1040080,
              0x1800: 0x21000080,
              0x2800: 0x80,
              0x3800: 0x1040000,
              0x4800: 0x40000,
              0x5800: 0x20040080,
              0x6800: 0x21040000,
              0x7800: 0x20000000,
              0x8800: 0x20040000,
              0x9800: 0x0,
              0xa800: 0x21040080,
              0xb800: 0x1000080,
              0xc800: 0x20000080,
              0xd800: 0x21000000,
              0xe800: 0x1000000,
              0xf800: 0x40080,
              0x10000: 0x40000,
              0x11000: 0x80,
              0x12000: 0x20000000,
              0x13000: 0x21000080,
              0x14000: 0x1000080,
              0x15000: 0x21040000,
              0x16000: 0x20040080,
              0x17000: 0x1000000,
              0x18000: 0x21040080,
              0x19000: 0x21000000,
              0x1a000: 0x1040000,
              0x1b000: 0x20040000,
              0x1c000: 0x40080,
              0x1d000: 0x20000080,
              0x1e000: 0x0,
              0x1f000: 0x1040080,
              0x10800: 0x21000080,
              0x11800: 0x1000000,
              0x12800: 0x1040000,
              0x13800: 0x20040080,
              0x14800: 0x20000000,
              0x15800: 0x1040080,
              0x16800: 0x80,
              0x17800: 0x21040000,
              0x18800: 0x40080,
              0x19800: 0x21040080,
              0x1a800: 0x0,
              0x1b800: 0x21000000,
              0x1c800: 0x1000080,
              0x1d800: 0x40000,
              0x1e800: 0x20040000,
              0x1f800: 0x20000080,
            }, {
              0x0: 0x10000008,
              0x100: 0x2000,
              0x200: 0x10200000,
              0x300: 0x10202008,
              0x400: 0x10002000,
              0x500: 0x200000,
              0x600: 0x200008,
              0x700: 0x10000000,
              0x800: 0x0,
              0x900: 0x10002008,
              0xa00: 0x202000,
              0xb00: 0x8,
              0xc00: 0x10200008,
              0xd00: 0x202008,
              0xe00: 0x2008,
              0xf00: 0x10202000,
              0x80: 0x10200000,
              0x180: 0x10202008,
              0x280: 0x8,
              0x380: 0x200000,
              0x480: 0x202008,
              0x580: 0x10000008,
              0x680: 0x10002000,
              0x780: 0x2008,
              0x880: 0x200008,
              0x980: 0x2000,
              0xa80: 0x10002008,
              0xb80: 0x10200008,
              0xc80: 0x0,
              0xd80: 0x10202000,
              0xe80: 0x202000,
              0xf80: 0x10000000,
              0x1000: 0x10002000,
              0x1100: 0x10200008,
              0x1200: 0x10202008,
              0x1300: 0x2008,
              0x1400: 0x200000,
              0x1500: 0x10000000,
              0x1600: 0x10000008,
              0x1700: 0x202000,
              0x1800: 0x202008,
              0x1900: 0x0,
              0x1a00: 0x8,
              0x1b00: 0x10200000,
              0x1c00: 0x2000,
              0x1d00: 0x10002008,
              0x1e00: 0x10202000,
              0x1f00: 0x200008,
              0x1080: 0x8,
              0x1180: 0x202000,
              0x1280: 0x200000,
              0x1380: 0x10000008,
              0x1480: 0x10002000,
              0x1580: 0x2008,
              0x1680: 0x10202008,
              0x1780: 0x10200000,
              0x1880: 0x10202000,
              0x1980: 0x10200008,
              0x1a80: 0x2000,
              0x1b80: 0x202008,
              0x1c80: 0x200008,
              0x1d80: 0x0,
              0x1e80: 0x10000000,
              0x1f80: 0x10002008,
            }, {
              0x0: 0x100000,
              0x10: 0x2000401,
              0x20: 0x400,
              0x30: 0x100401,
              0x40: 0x2100401,
              0x50: 0x0,
              0x60: 0x1,
              0x70: 0x2100001,
              0x80: 0x2000400,
              0x90: 0x100001,
              0xa0: 0x2000001,
              0xb0: 0x2100400,
              0xc0: 0x2100000,
              0xd0: 0x401,
              0xe0: 0x100400,
              0xf0: 0x2000000,
              0x8: 0x2100001,
              0x18: 0x0,
              0x28: 0x2000401,
              0x38: 0x2100400,
              0x48: 0x100000,
              0x58: 0x2000001,
              0x68: 0x2000000,
              0x78: 0x401,
              0x88: 0x100401,
              0x98: 0x2000400,
              0xa8: 0x2100000,
              0xb8: 0x100001,
              0xc8: 0x400,
              0xd8: 0x2100401,
              0xe8: 0x1,
              0xf8: 0x100400,
              0x100: 0x2000000,
              0x110: 0x100000,
              0x120: 0x2000401,
              0x130: 0x2100001,
              0x140: 0x100001,
              0x150: 0x2000400,
              0x160: 0x2100400,
              0x170: 0x100401,
              0x180: 0x401,
              0x190: 0x2100401,
              0x1a0: 0x100400,
              0x1b0: 0x1,
              0x1c0: 0x0,
              0x1d0: 0x2100000,
              0x1e0: 0x2000001,
              0x1f0: 0x400,
              0x108: 0x100400,
              0x118: 0x2000401,
              0x128: 0x2100001,
              0x138: 0x1,
              0x148: 0x2000000,
              0x158: 0x100000,
              0x168: 0x401,
              0x178: 0x2100400,
              0x188: 0x2000001,
              0x198: 0x2100000,
              0x1a8: 0x0,
              0x1b8: 0x2100401,
              0x1c8: 0x100401,
              0x1d8: 0x400,
              0x1e8: 0x2000400,
              0x1f8: 0x100001,
            }, {
              0x0: 0x8000820,
              0x1: 0x20000,
              0x2: 0x8000000,
              0x3: 0x20,
              0x4: 0x20020,
              0x5: 0x8020820,
              0x6: 0x8020800,
              0x7: 0x800,
              0x8: 0x8020000,
              0x9: 0x8000800,
              0xa: 0x20800,
              0xb: 0x8020020,
              0xc: 0x820,
              0xd: 0x0,
              0xe: 0x8000020,
              0xf: 0x20820,
              0x80000000: 0x800,
              0x80000001: 0x8020820,
              0x80000002: 0x8000820,
              0x80000003: 0x8000000,
              0x80000004: 0x8020000,
              0x80000005: 0x20800,
              0x80000006: 0x20820,
              0x80000007: 0x20,
              0x80000008: 0x8000020,
              0x80000009: 0x820,
              0x8000000a: 0x20020,
              0x8000000b: 0x8020800,
              0x8000000c: 0x0,
              0x8000000d: 0x8020020,
              0x8000000e: 0x8000800,
              0x8000000f: 0x20000,
              0x10: 0x20820,
              0x11: 0x8020800,
              0x12: 0x20,
              0x13: 0x800,
              0x14: 0x8000800,
              0x15: 0x8000020,
              0x16: 0x8020020,
              0x17: 0x20000,
              0x18: 0x0,
              0x19: 0x20020,
              0x1a: 0x8020000,
              0x1b: 0x8000820,
              0x1c: 0x8020820,
              0x1d: 0x20800,
              0x1e: 0x820,
              0x1f: 0x8000000,
              0x80000010: 0x20000,
              0x80000011: 0x800,
              0x80000012: 0x8020020,
              0x80000013: 0x20820,
              0x80000014: 0x20,
              0x80000015: 0x8020000,
              0x80000016: 0x8000000,
              0x80000017: 0x8000820,
              0x80000018: 0x8020820,
              0x80000019: 0x8000020,
              0x8000001a: 0x8000800,
              0x8000001b: 0x0,
              0x8000001c: 0x20800,
              0x8000001d: 0x820,
              0x8000001e: 0x20020,
              0x8000001f: 0x8020800,
            }]; // Masks that select the SBOX input

            const SBOX_MASK = [0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000, 0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f];
            /**
     * DES block cipher algorithm.
     */

            const DES = C_algo.DES = BlockCipher.extend({
              _doReset: function _doReset() {
                // Shortcuts
                const key = this._key;
                const keyWords = key.words; // Select 56 bits according to PC1

                const keyBits = [];

                for (var i = 0; i < 56; i++) {
                  const keyBitPos = PC1[i] - 1;
                  keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
                } // Assemble 16 subkeys

                const subKeys = this._subKeys = [];

                for (let nSubKey = 0; nSubKey < 16; nSubKey++) {
                  // Create subkey
                  const subKey = subKeys[nSubKey] = []; // Shortcut

                  const bitShift = BIT_SHIFTS[nSubKey]; // Select 48 bits according to PC2

                  for (var i = 0; i < 24; i++) {
                    // Select from the left 28 key bits
                    subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6; // Select from the right 28 key bits

                    subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
                  } // Since each subkey is applied to an expanded 32-bit input,
                  // the subkey can be broken into 8 values scaled to 32-bits,
                  // which allows the key to be used without expansion

                  subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;

                  for (var i = 1; i < 7; i++) {
                    subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
                  }

                  subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
                } // Compute inverse subkeys

                const invSubKeys = this._invSubKeys = [];

                for (var i = 0; i < 16; i++) {
                  invSubKeys[i] = subKeys[15 - i];
                }
              },
              encryptBlock: function encryptBlock(M, offset) {
                this._doCryptBlock(M, offset, this._subKeys);
              },
              decryptBlock: function decryptBlock(M, offset) {
                this._doCryptBlock(M, offset, this._invSubKeys);
              },
              _doCryptBlock: function _doCryptBlock(M, offset, subKeys) {
                // Get input
                this._lBlock = M[offset];
                this._rBlock = M[offset + 1]; // Initial permutation

                exchangeLR.call(this, 4, 0x0f0f0f0f);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeLR.call(this, 1, 0x55555555); // Rounds

                for (let round = 0; round < 16; round++) {
                  // Shortcuts
                  const subKey = subKeys[round];
                  const lBlock = this._lBlock;
                  const rBlock = this._rBlock; // Feistel function

                  let f = 0;

                  for (let i = 0; i < 8; i++) {
                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
                  }

                  this._lBlock = rBlock;
                  this._rBlock = lBlock ^ f;
                } // Undo swap from last round

                const t = this._lBlock;
                this._lBlock = this._rBlock;
                this._rBlock = t; // Final permutation

                exchangeLR.call(this, 1, 0x55555555);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeLR.call(this, 4, 0x0f0f0f0f); // Set output

                M[offset] = this._lBlock;
                M[offset + 1] = this._rBlock;
              },
              keySize: 64 / 32,
              ivSize: 64 / 32,
              blockSize: 64 / 32,
            }); // Swap bits across the left and right words

            function exchangeLR(offset, mask) {
              const t = (this._lBlock >>> offset ^ this._rBlock) & mask;
              this._rBlock ^= t;
              this._lBlock ^= t << offset;
            }

            function exchangeRL(offset, mask) {
              const t = (this._rBlock >>> offset ^ this._lBlock) & mask;
              this._lBlock ^= t;
              this._rBlock ^= t << offset;
            }
            /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
     */

            C.DES = BlockCipher._createHelper(DES);
            /**
     * Triple-DES block cipher algorithm.
     */

            const TripleDES = C_algo.TripleDES = BlockCipher.extend({
              _doReset: function _doReset() {
                // Shortcuts
                const key = this._key;
                const keyWords = key.words; // Make sure the key length is valid (64, 128 or >= 192 bit)

                if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) {
                  throw new Error('Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.');
                } // Extend the key according to the keying options defined in 3DES standard

                const key1 = keyWords.slice(0, 2);
                const key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
                const key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6); // Create DES instances

                this._des1 = DES.createEncryptor(WordArray.create(key1));
                this._des2 = DES.createEncryptor(WordArray.create(key2));
                this._des3 = DES.createEncryptor(WordArray.create(key3));
              },
              encryptBlock: function encryptBlock(M, offset) {
                this._des1.encryptBlock(M, offset);

                this._des2.decryptBlock(M, offset);

                this._des3.encryptBlock(M, offset);
              },
              decryptBlock: function decryptBlock(M, offset) {
                this._des3.decryptBlock(M, offset);

                this._des2.encryptBlock(M, offset);

                this._des1.decryptBlock(M, offset);
              },
              keySize: 192 / 32,
              ivSize: 64 / 32,
              blockSize: 64 / 32,
            });
            /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
     */

            C.TripleDES = BlockCipher._createHelper(TripleDES);
          }());

          return CryptoJS.TripleDES;
        }));
        /***/ }),

      /***/ 2601:
      /***/ (function (module, exports, __webpack_require__) {
        __webpack_require__(7042);

        (function (root, factory) {
          if (true) {
            // CommonJS
            module.exports = exports = factory(__webpack_require__(757));
          } else {}
        }(void 0, (CryptoJS) => {
          (function (undefined) {
            // Shortcuts
            const C = CryptoJS;
            const C_lib = C.lib;
            const { Base } = C_lib;
            const X32WordArray = C_lib.WordArray;
            /**
     * x64 namespace.
     */

            const C_x64 = C.x64 = {};
            /**
     * A 64-bit word.
     */

            const X64Word = C_x64.Word = Base.extend({
              /**
       * Initializes a newly created 64-bit word.
       *
       * @param {number} high The high 32 bits.
       * @param {number} low The low 32 bits.
       *
       * @example
       *
       *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
       */
              init: function init(high, low) {
                this.high = high;
                this.low = low;
              },
              /**
       * Bitwise NOTs this word.
       *
       * @return {X64Word} A new x64-Word object after negating.
       *
       * @example
       *
       *     var negated = x64Word.not();
       */
              // not: function () {
              // var high = ~this.high;
              // var low = ~this.low;
              // return X64Word.create(high, low);
              // },

              /**
       * Bitwise ANDs this word with the passed word.
       *
       * @param {X64Word} word The x64-Word to AND with this word.
       *
       * @return {X64Word} A new x64-Word object after ANDing.
       *
       * @example
       *
       *     var anded = x64Word.and(anotherX64Word);
       */
              // and: function (word) {
              // var high = this.high & word.high;
              // var low = this.low & word.low;
              // return X64Word.create(high, low);
              // },

              /**
       * Bitwise ORs this word with the passed word.
       *
       * @param {X64Word} word The x64-Word to OR with this word.
       *
       * @return {X64Word} A new x64-Word object after ORing.
       *
       * @example
       *
       *     var ored = x64Word.or(anotherX64Word);
       */
              // or: function (word) {
              // var high = this.high | word.high;
              // var low = this.low | word.low;
              // return X64Word.create(high, low);
              // },

              /**
       * Bitwise XORs this word with the passed word.
       *
       * @param {X64Word} word The x64-Word to XOR with this word.
       *
       * @return {X64Word} A new x64-Word object after XORing.
       *
       * @example
       *
       *     var xored = x64Word.xor(anotherX64Word);
       */
              // xor: function (word) {
              // var high = this.high ^ word.high;
              // var low = this.low ^ word.low;
              // return X64Word.create(high, low);
              // },

              /**
       * Shifts this word n bits to the left.
       *
       * @param {number} n The number of bits to shift.
       *
       * @return {X64Word} A new x64-Word object after shifting.
       *
       * @example
       *
       *     var shifted = x64Word.shiftL(25);
       */
              // shiftL: function (n) {
              // if (n < 32) {
              // var high = (this.high << n) | (this.low >>> (32 - n));
              // var low = this.low << n;
              // } else {
              // var high = this.low << (n - 32);
              // var low = 0;
              // }
              // return X64Word.create(high, low);
              // },

              /**
       * Shifts this word n bits to the right.
       *
       * @param {number} n The number of bits to shift.
       *
       * @return {X64Word} A new x64-Word object after shifting.
       *
       * @example
       *
       *     var shifted = x64Word.shiftR(7);
       */
              // shiftR: function (n) {
              // if (n < 32) {
              // var low = (this.low >>> n) | (this.high << (32 - n));
              // var high = this.high >>> n;
              // } else {
              // var low = this.high >>> (n - 32);
              // var high = 0;
              // }
              // return X64Word.create(high, low);
              // },

              /**
       * Rotates this word n bits to the left.
       *
       * @param {number} n The number of bits to rotate.
       *
       * @return {X64Word} A new x64-Word object after rotating.
       *
       * @example
       *
       *     var rotated = x64Word.rotL(25);
       */
              // rotL: function (n) {
              // return this.shiftL(n).or(this.shiftR(64 - n));
              // },

              /**
       * Rotates this word n bits to the right.
       *
       * @param {number} n The number of bits to rotate.
       *
       * @return {X64Word} A new x64-Word object after rotating.
       *
       * @example
       *
       *     var rotated = x64Word.rotR(7);
       */
              // rotR: function (n) {
              // return this.shiftR(n).or(this.shiftL(64 - n));
              // },

              /**
       * Adds this word with the passed word.
       *
       * @param {X64Word} word The x64-Word to add with this word.
       *
       * @return {X64Word} A new x64-Word object after adding.
       *
       * @example
       *
       *     var added = x64Word.add(anotherX64Word);
       */
              // add: function (word) {
              // var low = (this.low + word.low) | 0;
              // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
              // var high = (this.high + word.high + carry) | 0;
              // return X64Word.create(high, low);
              // }

            });
            /**
     * An array of 64-bit words.
     *
     * @property {Array} words The array of CryptoJS.x64.Word objects.
     * @property {number} sigBytes The number of significant bytes in this word array.
     */

            const X64WordArray = C_x64.WordArray = Base.extend({
              /**
       * Initializes a newly created word array.
       *
       * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
       * @param {number} sigBytes (Optional) The number of significant bytes in the words.
       *
       * @example
       *
       *     var wordArray = CryptoJS.x64.WordArray.create();
       *
       *     var wordArray = CryptoJS.x64.WordArray.create([
       *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
       *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
       *     ]);
       *
       *     var wordArray = CryptoJS.x64.WordArray.create([
       *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
       *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
       *     ], 10);
       */
              init: function init(words, sigBytes) {
                words = this.words = words || [];

                if (sigBytes != undefined) {
                  this.sigBytes = sigBytes;
                } else {
                  this.sigBytes = words.length * 8;
                }
              },

              /**
       * Converts this 64-bit word array to a 32-bit word array.
       *
       * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
       *
       * @example
       *
       *     var x32WordArray = x64WordArray.toX32();
       */
              toX32: function toX32() {
                // Shortcuts
                const x64Words = this.words;
                const x64WordsLength = x64Words.length; // Convert

                const x32Words = [];

                for (let i = 0; i < x64WordsLength; i++) {
                  const x64Word = x64Words[i];
                  x32Words.push(x64Word.high);
                  x32Words.push(x64Word.low);
                }

                return X32WordArray.create(x32Words, this.sigBytes);
              },

              /**
       * Creates a copy of this word array.
       *
       * @return {X64WordArray} The clone.
       *
       * @example
       *
       *     var clone = x64WordArray.clone();
       */
              clone: function clone() {
                const clone = Base.clone.call(this); // Clone "words" array

                const words = clone.words = this.words.slice(0); // Clone each X64Word object

                const wordsLength = words.length;

                for (let i = 0; i < wordsLength; i++) {
                  words[i] = words[i].clone();
                }

                return clone;
              },
            });
          }());

          return CryptoJS;
        }));
        /***/ }),

      /***/ 9811:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        __webpack_require__(8309);

        __webpack_require__(1038);

        __webpack_require__(5666);

        __webpack_require__(4916);

        __webpack_require__(4723);

        __webpack_require__(2165);

        __webpack_require__(6992);

        __webpack_require__(1539);

        __webpack_require__(8783);

        __webpack_require__(3948);

        __webpack_require__(2526);

        __webpack_require__(1817);

        __webpack_require__(7042);

        function _createForOfIteratorHelperLoose(o, allowArrayLike) { let it = typeof Symbol !== 'undefined' && o[Symbol.iterator] || o['@@iterator']; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === 'number') { if (it) o = it; let i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError('Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'); }

        function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === 'string') return _arrayLikeToArray(o, minLen); let n = Object.prototype.toString.call(o).slice(8, -1); if (n === 'Object' && o.constructor) n = o.constructor.name; if (n === 'Map' || n === 'Set') return Array.from(o); if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

        function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

        const INITIAL_STATE = 1;
        const FAIL_STATE = 0;
        /**
 * A StateMachine represents a deterministic finite automaton.
 * It can perform matches over a sequence of values, similar to a regular expression.
 */

        const StateMachine = /* #__PURE__ */(function () {
          function StateMachine(dfa) {
            this.stateTable = dfa.stateTable;
            this.accepting = dfa.accepting;
            this.tags = dfa.tags;
          }
          /**
   * Returns an iterable object that yields pattern matches over the input sequence.
   * Matches are of the form [startIndex, endIndex, tags].
   */

          const _proto = StateMachine.prototype;

          _proto.match = function match(str) {
            let _ref;

            const self = this;
            return _ref = {}, _ref[Symbol.iterator] = /* #__PURE__ */regeneratorRuntime.mark(function _callee() {
              let state; let startRun; let lastAccepting; let lastState; let p; let
                c;
              return regeneratorRuntime.wrap((_context) => {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      state = INITIAL_STATE;
                      startRun = null;
                      lastAccepting = null;
                      lastState = null;
                      p = 0;

                    case 5:
                      if (!(p < str.length)) {
                        _context.next = 21;
                        break;
                      }

                      c = str[p];
                      lastState = state;
                      state = self.stateTable[state][c];

                      if (!(state === FAIL_STATE)) {
                        _context.next = 15;
                        break;
                      }

                      if (!(startRun != null && lastAccepting != null && lastAccepting >= startRun)) {
                        _context.next = 13;
                        break;
                      }

                      _context.next = 13;
                      return [startRun, lastAccepting, self.tags[lastState]];

                    case 13:
                      // reset the state as if we started over from the initial state
                      state = self.stateTable[INITIAL_STATE][c];
                      startRun = null;

                    case 15:
                      // start a run if not in the failure state
                      if (state !== FAIL_STATE && startRun == null) {
                        startRun = p;
                      } // if accepting, mark the potential match end

                      if (self.accepting[state]) {
                        lastAccepting = p;
                      } // reset the state to the initial state if we get into the failure state

                      if (state === FAIL_STATE) {
                        state = INITIAL_STATE;
                      }

                    case 18:
                      p++;
                      _context.next = 5;
                      break;

                    case 21:
                      if (!(startRun != null && lastAccepting != null && lastAccepting >= startRun)) {
                        _context.next = 24;
                        break;
                      }

                      _context.next = 24;
                      return [startRun, lastAccepting, self.tags[state]];

                    case 24:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee);
            }), _ref;
          }
          /**
   * For each match over the input sequence, action functions matching
   * the tag definitions in the input pattern are called with the startIndex,
   * endIndex, and sub-match sequence.
   */
          ;

          _proto.apply = function apply(str, actions) {
            for (var _iterator = _createForOfIteratorHelperLoose(this.match(str)), _step; !(_step = _iterator()).done;) {
              const _step$value = _step.value;
              const start = _step$value[0];
              const end = _step$value[1];
              const tags = _step$value[2];

              for (var _iterator2 = _createForOfIteratorHelperLoose(tags), _step2; !(_step2 = _iterator2()).done;) {
                const tag = _step2.value;

                if (typeof actions[tag] === 'function') {
                  actions[tag](start, end, str.slice(start, end + 1));
                }
              }
            }
          };

          return StateMachine;
        }());

        module.exports = StateMachine;
        /***/ }),

      /***/ 8478:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* provided dependency */ const { Buffer } = __webpack_require__(8823);

        __webpack_require__(7042);

        __webpack_require__(6699);

        /*
 * MIT LICENSE
 * Copyright (c) 2011 Devon Govett
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
 * software and associated documentation files (the "Software"), to deal in the Software
 * without restriction, including without limitation the rights to use, copy, modify, merge,
 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons
 * to whom the Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all copies or
 * substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING
 * BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
        const fs = __webpack_require__(3857);

        const zlib = __webpack_require__(2635);

        module.exports = /* #__PURE__ */(function () {
          PNG.decode = function decode(path, fn) {
            return fs.readFile(path, (err, file) => {
              const png = new PNG(file);
              return png.decode((pixels) => fn(pixels));
            });
          };

          PNG.load = function load(path) {
            const file = fs.readFileSync(path);
            return new PNG(file);
          };

          function PNG(data) {
            let i;
            this.data = data;
            this.pos = 8; // Skip the default header

            this.palette = [];
            this.imgData = [];
            this.transparency = {};
            this.text = {};

            while (true) {
              const chunkSize = this.readUInt32();
              let section = '';

              for (i = 0; i < 4; i++) {
                section += String.fromCharCode(this.data[this.pos++]);
              }

              switch (section) {
                case 'IHDR':
                  // we can grab  interesting values from here (like width, height, etc)
                  this.width = this.readUInt32();
                  this.height = this.readUInt32();
                  this.bits = this.data[this.pos++];
                  this.colorType = this.data[this.pos++];
                  this.compressionMethod = this.data[this.pos++];
                  this.filterMethod = this.data[this.pos++];
                  this.interlaceMethod = this.data[this.pos++];
                  break;

                case 'PLTE':
                  this.palette = this.read(chunkSize);
                  break;

                case 'IDAT':
                  for (i = 0; i < chunkSize; i++) {
                    this.imgData.push(this.data[this.pos++]);
                  }

                  break;

                case 'tRNS':
                  // This chunk can only occur once and it must occur after the
                  // PLTE chunk and before the IDAT chunk.
                  this.transparency = {};

                  switch (this.colorType) {
                    case 3:
                      // Indexed color, RGB. Each byte in this chunk is an alpha for
                      // the palette index in the PLTE ("palette") chunk up until the
                      // last non-opaque entry. Set up an array, stretching over all
                      // palette entries which will be 0 (opaque) or 1 (transparent).
                      this.transparency.indexed = this.read(chunkSize);
                      var short = 255 - this.transparency.indexed.length;

                      if (short > 0) {
                        for (i = 0; i < short; i++) {
                          this.transparency.indexed.push(255);
                        }
                      }

                      break;

                    case 0:
                      // Greyscale. Corresponding to entries in the PLTE chunk.
                      // Grey is two bytes, range 0 .. (2 ^ bit-depth) - 1
                      this.transparency.grayscale = this.read(chunkSize)[0];
                      break;

                    case 2:
                      // True color with proper alpha channel.
                      this.transparency.rgb = this.read(chunkSize);
                      break;
                  }

                  break;

                case 'tEXt':
                  var text = this.read(chunkSize);
                  var index = text.indexOf(0);
                  var key = String.fromCharCode.apply(String, text.slice(0, index));
                  this.text[key] = String.fromCharCode.apply(String, text.slice(index + 1));
                  break;

                case 'IEND':
                  // we've got everything we need!
                  switch (this.colorType) {
                    case 0:
                    case 3:
                    case 4:
                      this.colors = 1;
                      break;

                    case 2:
                    case 6:
                      this.colors = 3;
                      break;
                  }

                  this.hasAlphaChannel = [4, 6].includes(this.colorType);
                  var colors = this.colors + (this.hasAlphaChannel ? 1 : 0);
                  this.pixelBitlength = this.bits * colors;

                  switch (this.colors) {
                    case 1:
                      this.colorSpace = 'DeviceGray';
                      break;

                    case 3:
                      this.colorSpace = 'DeviceRGB';
                      break;
                  }

                  this.imgData = new Buffer(this.imgData);
                  return;
                  break;

                default:
                  // unknown (or unimportant) section, skip it
                  this.pos += chunkSize;
              }

              this.pos += 4; // Skip the CRC

              if (this.pos > this.data.length) {
                throw new Error('Incomplete or corrupt PNG file');
              }
            }
          }

          const _proto = PNG.prototype;

          _proto.read = function read(bytes) {
            const result = new Array(bytes);

            for (let i = 0; i < bytes; i++) {
              result[i] = this.data[this.pos++];
            }

            return result;
          };

          _proto.readUInt32 = function readUInt32() {
            const b1 = this.data[this.pos++] << 24;
            const b2 = this.data[this.pos++] << 16;
            const b3 = this.data[this.pos++] << 8;
            const b4 = this.data[this.pos++];
            return b1 | b2 | b3 | b4;
          };

          _proto.readUInt16 = function readUInt16() {
            const b1 = this.data[this.pos++] << 8;
            const b2 = this.data[this.pos++];
            return b1 | b2;
          };

          _proto.decodePixels = function decodePixels(fn) {
            const _this = this;

            return zlib.inflate(this.imgData, (err, data) => {
              if (err) {
                throw err;
              }

              const { width } = _this;
              const { height } = _this;
              const pixelBytes = _this.pixelBitlength / 8;
              const pixels = new Buffer(width * height * pixelBytes);
              const { length } = data;
              let pos = 0;

              function pass(x0, y0, dx, dy, singlePass) {
                if (singlePass === void 0) {
                  singlePass = false;
                }

                const w = Math.ceil((width - x0) / dx);
                const h = Math.ceil((height - y0) / dy);
                const scanlineLength = pixelBytes * w;
                const buffer = singlePass ? pixels : new Buffer(scanlineLength * h);
                let row = 0;
                let c = 0;

                while (row < h && pos < length) {
                  var byte; var col; var i; var left; var
                    upper;

                  switch (data[pos++]) {
                    case 0:
                      // None
                      for (i = 0; i < scanlineLength; i++) {
                        buffer[c++] = data[pos++];
                      }

                      break;

                    case 1:
                      // Sub
                      for (i = 0; i < scanlineLength; i++) {
                        byte = data[pos++];
                        left = i < pixelBytes ? 0 : buffer[c - pixelBytes];
                        buffer[c++] = (byte + left) % 256;
                      }

                      break;

                    case 2:
                      // Up
                      for (i = 0; i < scanlineLength; i++) {
                        byte = data[pos++];
                        col = (i - i % pixelBytes) / pixelBytes;
                        upper = row && buffer[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];
                        buffer[c++] = (upper + byte) % 256;
                      }

                      break;

                    case 3:
                      // Average
                      for (i = 0; i < scanlineLength; i++) {
                        byte = data[pos++];
                        col = (i - i % pixelBytes) / pixelBytes;
                        left = i < pixelBytes ? 0 : buffer[c - pixelBytes];
                        upper = row && buffer[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];
                        buffer[c++] = (byte + Math.floor((left + upper) / 2)) % 256;
                      }

                      break;

                    case 4:
                      // Paeth
                      for (i = 0; i < scanlineLength; i++) {
                        var paeth; var
                          upperLeft;
                        byte = data[pos++];
                        col = (i - i % pixelBytes) / pixelBytes;
                        left = i < pixelBytes ? 0 : buffer[c - pixelBytes];

                        if (row === 0) {
                          upper = upperLeft = 0;
                        } else {
                          upper = buffer[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];
                          upperLeft = col && buffer[(row - 1) * scanlineLength + (col - 1) * pixelBytes + i % pixelBytes];
                        }

                        const p = left + upper - upperLeft;
                        const pa = Math.abs(p - left);
                        const pb = Math.abs(p - upper);
                        const pc = Math.abs(p - upperLeft);

                        if (pa <= pb && pa <= pc) {
                          paeth = left;
                        } else if (pb <= pc) {
                          paeth = upper;
                        } else {
                          paeth = upperLeft;
                        }

                        buffer[c++] = (byte + paeth) % 256;
                      }

                      break;

                    default:
                      throw new Error(`Invalid filter algorithm: ${data[pos - 1]}`);
                  }

                  if (!singlePass) {
                    let pixelsPos = ((y0 + row * dy) * width + x0) * pixelBytes;
                    let bufferPos = row * scanlineLength;

                    for (i = 0; i < w; i++) {
                      for (let j = 0; j < pixelBytes; j++) {
                        pixels[pixelsPos++] = buffer[bufferPos++];
                      }

                      pixelsPos += (dx - 1) * pixelBytes;
                    }
                  }

                  row++;
                }
              }

              if (_this.interlaceMethod === 1) {
                /*
          1 6 4 6 2 6 4 6
          7 7 7 7 7 7 7 7
          5 6 5 6 5 6 5 6
          7 7 7 7 7 7 7 7
          3 6 4 6 3 6 4 6
          7 7 7 7 7 7 7 7
          5 6 5 6 5 6 5 6
          7 7 7 7 7 7 7 7
        */
                pass(0, 0, 8, 8); // 1

                pass(4, 0, 8, 8); // 2

                pass(0, 4, 4, 8); // 3

                pass(2, 0, 4, 4); // 4

                pass(0, 2, 2, 4); // 5

                pass(1, 0, 2, 2); // 6

                pass(0, 1, 1, 2); // 7
              } else {
                pass(0, 0, 1, 1, true);
              }

              return fn(pixels);
            });
          };

          _proto.decodePalette = function decodePalette() {
            const { palette } = this;
            const { length } = palette;
            const transparency = this.transparency.indexed || [];
            const ret = new Buffer(transparency.length + length);
            let pos = 0;
            let c = 0;

            for (let i = 0; i < length; i += 3) {
              var left;
              ret[pos++] = palette[i];
              ret[pos++] = palette[i + 1];
              ret[pos++] = palette[i + 2];
              ret[pos++] = (left = transparency[c++]) != null ? left : 255;
            }

            return ret;
          };

          _proto.copyToImageData = function copyToImageData(imageData, pixels) {
            let j; let
              k;
            let { colors } = this;
            let palette = null;
            let alpha = this.hasAlphaChannel;

            if (this.palette.length) {
              palette = this._decodedPalette || (this._decodedPalette = this.decodePalette());
              colors = 4;
              alpha = true;
            }

            const data = imageData.data || imageData;
            const { length } = data;
            const input = palette || pixels;
            let i = j = 0;

            if (colors === 1) {
              while (i < length) {
                k = palette ? pixels[i / 4] * 4 : j;
                const v = input[k++];
                data[i++] = v;
                data[i++] = v;
                data[i++] = v;
                data[i++] = alpha ? input[k++] : 255;
                j = k;
              }
            } else {
              while (i < length) {
                k = palette ? pixels[i / 4] * 4 : j;
                data[i++] = input[k++];
                data[i++] = input[k++];
                data[i++] = input[k++];
                data[i++] = alpha ? input[k++] : 255;
                j = k;
              }
            }
          };

          _proto.decode = function decode(fn) {
            const _this2 = this;

            const ret = new Buffer(this.width * this.height * 4);
            return this.decodePixels((pixels) => {
              _this2.copyToImageData(ret, pixels);

              return fn(ret);
            });
          };

          return PNG;
        }());
        /***/ }),

      /***/ 1750:
      /***/ (function (module, exports, __webpack_require__) {
        __webpack_require__(3290);

        /* eslint-disable node/no-deprecated-api */
        const buffer = __webpack_require__(8823);

        const { Buffer } = buffer; // alternative to using Object.keys for old browsers

        function copyProps(src, dst) {
          for (const key in src) {
            dst[key] = src[key];
          }
        }

        if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
          module.exports = buffer;
        } else {
          // Copy properties from require('buffer')
          copyProps(buffer, exports);
          exports.Buffer = SafeBuffer;
        }

        function SafeBuffer(arg, encodingOrOffset, length) {
          return Buffer(arg, encodingOrOffset, length);
        } // Copy static methods from Buffer

        copyProps(Buffer, SafeBuffer);

        SafeBuffer.from = function (arg, encodingOrOffset, length) {
          if (typeof arg === 'number') {
            throw new TypeError('Argument must not be a number');
          }

          return Buffer(arg, encodingOrOffset, length);
        };

        SafeBuffer.alloc = function (size, fill, encoding) {
          if (typeof size !== 'number') {
            throw new TypeError('Argument must be a number');
          }

          const buf = Buffer(size);

          if (fill !== undefined) {
            if (typeof encoding === 'string') {
              buf.fill(fill, encoding);
            } else {
              buf.fill(fill);
            }
          } else {
            buf.fill(0);
          }

          return buf;
        };

        SafeBuffer.allocUnsafe = function (size) {
          if (typeof size !== 'number') {
            throw new TypeError('Argument must be a number');
          }

          return Buffer(size);
        };

        SafeBuffer.allocUnsafeSlow = function (size) {
          if (typeof size !== 'number') {
            throw new TypeError('Argument must be a number');
          }

          return buffer.SlowBuffer(size);
        };
        /***/ }),

      /***/ 7103:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* provided dependency */ const process = __webpack_require__(4155);
        /* eslint-disable node/no-deprecated-api */

        __webpack_require__(8145);

        __webpack_require__(6992);

        __webpack_require__(1539);

        __webpack_require__(2472);

        __webpack_require__(2990);

        __webpack_require__(8927);

        __webpack_require__(3105);

        __webpack_require__(5035);

        __webpack_require__(4345);

        __webpack_require__(7174);

        __webpack_require__(2846);

        __webpack_require__(4731);

        __webpack_require__(7209);

        __webpack_require__(6319);

        __webpack_require__(8867);

        __webpack_require__(7789);

        __webpack_require__(3739);

        __webpack_require__(9368);

        __webpack_require__(4483);

        __webpack_require__(2056);

        __webpack_require__(3462);

        __webpack_require__(678);

        __webpack_require__(7462);

        __webpack_require__(3824);

        __webpack_require__(5021);

        __webpack_require__(2974);

        __webpack_require__(5016);

        __webpack_require__(3290);

        const buffer = __webpack_require__(8823);

        const { Buffer } = buffer;
        const safer = {};
        let key;

        for (key in buffer) {
          if (!buffer.hasOwnProperty(key)) continue;
          if (key === 'SlowBuffer' || key === 'Buffer') continue;
          safer[key] = buffer[key];
        }

        const Safer = safer.Buffer = {};

        for (key in Buffer) {
          if (!Buffer.hasOwnProperty(key)) continue;
          if (key === 'allocUnsafe' || key === 'allocUnsafeSlow') continue;
          Safer[key] = Buffer[key];
        }

        safer.Buffer.prototype = Buffer.prototype;

        if (!Safer.from || Safer.from === Uint8Array.from) {
          Safer.from = function (value, encodingOrOffset, length) {
            if (typeof value === 'number') {
              throw new TypeError(`The "value" argument must not be of type number. Received type ${typeof value}`);
            }

            if (value && typeof value.length === 'undefined') {
              throw new TypeError(`The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ${typeof value}`);
            }

            return Buffer(value, encodingOrOffset, length);
          };
        }

        if (!Safer.alloc) {
          Safer.alloc = function (size, fill, encoding) {
            if (typeof size !== 'number') {
              throw new TypeError(`The "size" argument must be of type number. Received type ${typeof size}`);
            }

            if (size < 0 || size >= 2 * (1 << 30)) {
              throw new RangeError(`The value "${size}" is invalid for option "size"`);
            }

            const buf = Buffer(size);

            if (!fill || fill.length === 0) {
              buf.fill(0);
            } else if (typeof encoding === 'string') {
              buf.fill(fill, encoding);
            } else {
              buf.fill(fill);
            }

            return buf;
          };
        }

        if (!safer.kStringMaxLength) {
          try {
            safer.kStringMaxLength = process.binding('buffer').kStringMaxLength;
          } catch (e) { // we can't determine kStringMaxLength in environments where process.binding
            // is unsupported, so let's not set it
          }
        }

        if (!safer.constants) {
          safer.constants = {
            MAX_LENGTH: safer.kMaxLength,
          };

          if (safer.kStringMaxLength) {
            safer.constants.MAX_STRING_LENGTH = safer.kStringMaxLength;
          }
        }

        module.exports = safer;
        /***/ }),

      /***/ 3361:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        __webpack_require__(7941);

        __webpack_require__(2526);

        __webpack_require__(7327);

        __webpack_require__(1539);

        __webpack_require__(5003);

        __webpack_require__(4747);

        __webpack_require__(9337);

        __webpack_require__(7042);

        function ownKeys(object, enumerableOnly) {
          const keys = Object.keys(object);

          if (Object.getOwnPropertySymbols) {
            let symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) {
              symbols = symbols.filter((sym) => Object.getOwnPropertyDescriptor(object, sym).enumerable);
            }
            keys.push.apply(keys, symbols);
          }

          return keys;
        }

        function _objectSpread(target) {
          for (let i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};

            if (i % 2) {
              ownKeys(Object(source), true).forEach((key) => {
                _defineProperty(target, key, source[key]);
              });
            } else if (Object.getOwnPropertyDescriptors) {
              Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            } else {
              ownKeys(Object(source)).forEach((key) => {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
              });
            }
          }

          return target;
        }

        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value,
              enumerable: true,
              configurable: true,
              writable: true,
            });
          } else {
            obj[key] = value;
          }

          return obj;
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function _defineProperties(target, props) {
          for (let i = 0; i < props.length; i++) {
            const descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          return Constructor;
        }

        const _require = __webpack_require__(8823);
        const { Buffer } = _require;

        const _require2 = __webpack_require__(9862);
        const { inspect } = _require2;

        const custom = inspect && inspect.custom || 'inspect';

        function copyBuffer(src, target, offset) {
          Buffer.prototype.copy.call(src, target, offset);
        }

        module.exports = /* #__PURE__ */(function () {
          function BufferList() {
            _classCallCheck(this, BufferList);

            this.head = null;
            this.tail = null;
            this.length = 0;
          }

          _createClass(BufferList, [{
            key: 'push',
            value: function push(v) {
              const entry = {
                data: v,
                next: null,
              };
              if (this.length > 0) this.tail.next = entry; else this.head = entry;
              this.tail = entry;
              ++this.length;
            },
          }, {
            key: 'unshift',
            value: function unshift(v) {
              const entry = {
                data: v,
                next: this.head,
              };
              if (this.length === 0) this.tail = entry;
              this.head = entry;
              ++this.length;
            },
          }, {
            key: 'shift',
            value: function shift() {
              if (this.length === 0) return;
              const ret = this.head.data;
              if (this.length === 1) this.head = this.tail = null; else this.head = this.head.next;
              --this.length;
              return ret;
            },
          }, {
            key: 'clear',
            value: function clear() {
              this.head = this.tail = null;
              this.length = 0;
            },
          }, {
            key: 'join',
            value: function join(s) {
              if (this.length === 0) return '';
              let p = this.head;
              let ret = `${p.data}`;

              while (p = p.next) {
                ret += s + p.data;
              }

              return ret;
            },
          }, {
            key: 'concat',
            value: function concat(n) {
              if (this.length === 0) return Buffer.alloc(0);
              const ret = Buffer.allocUnsafe(n >>> 0);
              let p = this.head;
              let i = 0;

              while (p) {
                copyBuffer(p.data, ret, i);
                i += p.data.length;
                p = p.next;
              }

              return ret;
            }, // Consumes a specified amount of bytes or characters from the buffered data.

          }, {
            key: 'consume',
            value: function consume(n, hasStrings) {
              let ret;

              if (n < this.head.data.length) {
                // `slice` is the same for buffers and strings.
                ret = this.head.data.slice(0, n);
                this.head.data = this.head.data.slice(n);
              } else if (n === this.head.data.length) {
                // First chunk is a perfect match.
                ret = this.shift();
              } else {
                // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
              }

              return ret;
            },
          }, {
            key: 'first',
            value: function first() {
              return this.head.data;
            }, // Consumes a specified amount of characters from the buffered data.

          }, {
            key: '_getString',
            value: function _getString(n) {
              let p = this.head;
              let c = 1;
              let ret = p.data;
              n -= ret.length;

              while (p = p.next) {
                const str = p.data;
                const nb = n > str.length ? str.length : n;
                if (nb === str.length) ret += str; else ret += str.slice(0, n);
                n -= nb;

                if (n === 0) {
                  if (nb === str.length) {
                    ++c;
                    if (p.next) this.head = p.next; else this.head = this.tail = null;
                  } else {
                    this.head = p;
                    p.data = str.slice(nb);
                  }

                  break;
                }

                ++c;
              }

              this.length -= c;
              return ret;
            }, // Consumes a specified amount of bytes from the buffered data.

          }, {
            key: '_getBuffer',
            value: function _getBuffer(n) {
              const ret = Buffer.allocUnsafe(n);
              let p = this.head;
              let c = 1;
              p.data.copy(ret);
              n -= p.data.length;

              while (p = p.next) {
                const buf = p.data;
                const nb = n > buf.length ? buf.length : n;
                buf.copy(ret, ret.length - n, 0, nb);
                n -= nb;

                if (n === 0) {
                  if (nb === buf.length) {
                    ++c;
                    if (p.next) this.head = p.next; else this.head = this.tail = null;
                  } else {
                    this.head = p;
                    p.data = buf.slice(nb);
                  }

                  break;
                }

                ++c;
              }

              this.length -= c;
              return ret;
            }, // Make sure the linked list only shows the minimal necessary information.

          }, {
            key: custom,
            value: function value(_, options) {
              return inspect(this, _objectSpread({}, options, {
                // Only inspect one level.
                depth: 0,
                // It should not recurse.
                customInspect: false,
              }));
            },
          }]);

          return BufferList;
        }());
        /***/ }),

      /***/ 4872:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        const __dirname = '/';
        /* provided dependency */ const { Buffer } = __webpack_require__(8823);

        Object.defineProperty(exports, '__esModule', ({
          value: true,
        }));
        exports.default = void 0;

        __webpack_require__(7941);

        __webpack_require__(2526);

        __webpack_require__(7327);

        __webpack_require__(1539);

        __webpack_require__(5003);

        __webpack_require__(4747);

        __webpack_require__(9337);

        __webpack_require__(489);

        __webpack_require__(2419);

        __webpack_require__(1817);

        __webpack_require__(2165);

        __webpack_require__(6992);

        __webpack_require__(8783);

        __webpack_require__(3948);

        __webpack_require__(1038);

        __webpack_require__(7042);

        __webpack_require__(8309);

        __webpack_require__(4916);

        __webpack_require__(2707);

        __webpack_require__(2222);

        __webpack_require__(9600);

        __webpack_require__(9714);

        __webpack_require__(5306);

        __webpack_require__(1249);

        __webpack_require__(9841);

        __webpack_require__(4953);

        __webpack_require__(6977);

        __webpack_require__(6699);

        __webpack_require__(5192);

        __webpack_require__(9653);

        __webpack_require__(3123);

        __webpack_require__(4723);

        __webpack_require__(8734);

        __webpack_require__(2472);

        __webpack_require__(2990);

        __webpack_require__(8927);

        __webpack_require__(3105);

        __webpack_require__(5035);

        __webpack_require__(4345);

        __webpack_require__(7174);

        __webpack_require__(2846);

        __webpack_require__(4731);

        __webpack_require__(7209);

        __webpack_require__(6319);

        __webpack_require__(8867);

        __webpack_require__(7789);

        __webpack_require__(3739);

        __webpack_require__(9368);

        __webpack_require__(4483);

        __webpack_require__(2056);

        __webpack_require__(3462);

        __webpack_require__(678);

        __webpack_require__(7462);

        __webpack_require__(3824);

        __webpack_require__(5021);

        __webpack_require__(2974);

        __webpack_require__(5016);

        __webpack_require__(7803);

        __webpack_require__(3290);

        __webpack_require__(9601);

        __webpack_require__(3210);

        __webpack_require__(9254);

        __webpack_require__(7397);

        const _stream = _interopRequireDefault(__webpack_require__(2830));

        const _zlib = _interopRequireDefault(__webpack_require__(2635));

        const _cryptoJs = _interopRequireDefault(__webpack_require__(5153));

        const _fontkit = _interopRequireDefault(__webpack_require__(1917));

        const _events = __webpack_require__(7187);

        const _linebreak = _interopRequireDefault(__webpack_require__(7337));

        const _pngJs = _interopRequireDefault(__webpack_require__(8478));

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        const fs = __webpack_require__(3857);

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function _defineProperties(target, props) {
          for (let i = 0; i < props.length; i++) {
            const descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          return Constructor;
        }

        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value,
              enumerable: true,
              configurable: true,
              writable: true,
            });
          } else {
            obj[key] = value;
          }

          return obj;
        }

        function ownKeys(object, enumerableOnly) {
          const keys = Object.keys(object);

          if (Object.getOwnPropertySymbols) {
            let symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) {
              symbols = symbols.filter((sym) => Object.getOwnPropertyDescriptor(object, sym).enumerable);
            }
            keys.push.apply(keys, symbols);
          }

          return keys;
        }

        function _objectSpread2(target) {
          for (let i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};

            if (i % 2) {
              ownKeys(Object(source), true).forEach((key) => {
                _defineProperty(target, key, source[key]);
              });
            } else if (Object.getOwnPropertyDescriptors) {
              Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            } else {
              ownKeys(Object(source)).forEach((key) => {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
              });
            }
          }

          return target;
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== 'function' && superClass !== null) {
            throw new TypeError('Super expression must either be null or a function');
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              writable: true,
              configurable: true,
            },
          });
          if (superClass) _setPrototypeOf(subClass, superClass);
        }

        function _getPrototypeOf(o) {
          _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
          };
          return _getPrototypeOf(o);
        }

        function _setPrototypeOf(o, p) {
          _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
          };

          return _setPrototypeOf(o, p);
        }

        function _isNativeReflectConstruct() {
          if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
          if (Reflect.construct.sham) return false;
          if (typeof Proxy === 'function') return true;

          try {
            Date.prototype.toString.call(Reflect.construct(Date, [], () => {}));
            return true;
          } catch (e) {
            return false;
          }
        }

        function _assertThisInitialized(self) {
          if (self === void 0) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return self;
        }

        function _possibleConstructorReturn(self, call) {
          if (call && (typeof call === 'object' || typeof call === 'function')) {
            return call;
          }

          return _assertThisInitialized(self);
        }

        function _createSuper(Derived) {
          const hasNativeReflectConstruct = _isNativeReflectConstruct();

          return function _createSuperInternal() {
            const Super = _getPrototypeOf(Derived);
            let result;

            if (hasNativeReflectConstruct) {
              const NewTarget = _getPrototypeOf(this).constructor;

              result = Reflect.construct(Super, arguments, NewTarget);
            } else {
              result = Super.apply(this, arguments);
            }

            return _possibleConstructorReturn(this, result);
          };
        }

        function _slicedToArray(arr, i) {
          return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
        }

        function _toConsumableArray(arr) {
          return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
        }

        function _arrayWithoutHoles(arr) {
          if (Array.isArray(arr)) return _arrayLikeToArray(arr);
        }

        function _arrayWithHoles(arr) {
          if (Array.isArray(arr)) return arr;
        }

        function _iterableToArray(iter) {
          if (typeof Symbol !== 'undefined' && Symbol.iterator in Object(iter)) return Array.from(iter);
        }

        function _iterableToArrayLimit(arr, i) {
          if (typeof Symbol === 'undefined' || !(Symbol.iterator in Object(arr))) return;
          const _arr = [];
          let _n = true;
          let _d = false;
          let _e;

          try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);

              if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;
            _e = err;
          } finally {
            try {
              if (!_n && _i.return != null) _i.return();
            } finally {
              if (_d) throw _e;
            }
          }

          return _arr;
        }

        function _unsupportedIterableToArray(o, minLen) {
          if (!o) return;
          if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
          let n = Object.prototype.toString.call(o).slice(8, -1);
          if (n === 'Object' && o.constructor) n = o.constructor.name;
          if (n === 'Map' || n === 'Set') return Array.from(o);
          if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
        }

        function _arrayLikeToArray(arr, len) {
          if (len == null || len > arr.length) len = arr.length;

          for (var i = 0, arr2 = new Array(len); i < len; i++) {
            arr2[i] = arr[i];
          }

          return arr2;
        }

        function _nonIterableSpread() {
          throw new TypeError('Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
        }

        function _nonIterableRest() {
          throw new TypeError('Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
        }

        function _createForOfIteratorHelper(o, allowArrayLike) {
          let it;

          if (typeof Symbol === 'undefined' || o[Symbol.iterator] == null) {
            if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === 'number') {
              if (it) o = it;
              let i = 0;

              const F = function F() {};

              return {
                s: F,
                n: function n() {
                  if (i >= o.length) {
                    return {
                      done: true,
                    };
                  }
                  return {
                    done: false,
                    value: o[i++],
                  };
                },
                e: function e(_e2) {
                  throw _e2;
                },
                f: F,
              };
            }

            throw new TypeError('Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
          }

          let normalCompletion = true;
          let didErr = false;
          let err;
          return {
            s: function s() {
              it = o[Symbol.iterator]();
            },
            n: function n() {
              const step = it.next();
              normalCompletion = step.done;
              return step;
            },
            e: function e(_e3) {
              didErr = true;
              err = _e3;
            },
            f: function f() {
              try {
                if (!normalCompletion && it.return != null) it.return();
              } finally {
                if (didErr) throw err;
              }
            },
          };
        }
        /*
PDFAbstractReference - abstract class for PDF reference
*/

        const PDFAbstractReference = /* #__PURE__ */(function () {
          function PDFAbstractReference() {
            _classCallCheck(this, PDFAbstractReference);
          }

          _createClass(PDFAbstractReference, [{
            key: 'toString',
            value: function toString() {
              throw new Error('Must be implemented by subclasses');
            },
          }]);

          return PDFAbstractReference;
        }());

        const PDFTree = /* #__PURE__ */(function () {
          function PDFTree() {
            const options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            _classCallCheck(this, PDFTree);

            this._items = {}; // disable /Limits output for this tree

            this.limits = typeof options.limits === 'boolean' ? options.limits : true;
          }

          _createClass(PDFTree, [{
            key: 'add',
            value: function add(key, val) {
              return this._items[key] = val;
            },
          }, {
            key: 'get',
            value: function get(key) {
              return this._items[key];
            },
          }, {
            key: 'toString',
            value: function toString() {
              const _this = this; // Needs to be sorted by key

              const sortedKeys = Object.keys(this._items).sort((a, b) => _this._compareKeys(a, b));
              const out = ['<<'];

              if (this.limits && sortedKeys.length > 1) {
                const first = sortedKeys[0];
                const last = sortedKeys[sortedKeys.length - 1];
                out.push('  /Limits '.concat(PDFObject.convert([this._dataForKey(first), this._dataForKey(last)])));
              }

              out.push('  /'.concat(this._keysName(), ' ['));

              const _iterator = _createForOfIteratorHelper(sortedKeys);
              let _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  const key = _step.value;
                  out.push('    '.concat(PDFObject.convert(this._dataForKey(key)), ' ').concat(PDFObject.convert(this._items[key])));
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              out.push(']');
              out.push('>>');
              return out.join('\n');
            },
          }, {
            key: '_compareKeys',
            value: function _compareKeys()
            /* a, b */
            {
              throw new Error('Must be implemented by subclasses');
            },
          }, {
            key: '_keysName',
            value: function _keysName() {
              throw new Error('Must be implemented by subclasses');
            },
          }, {
            key: '_dataForKey',
            value: function _dataForKey()
            /* k */
            {
              throw new Error('Must be implemented by subclasses');
            },
          }]);

          return PDFTree;
        }());

        const pad = function pad(str, length) {
          return (Array(length + 1).join('0') + str).slice(-length);
        };

        const escapableRe = /[\n\r\t\b\f()\\]/g;
        const escapable = {
          '\n': '\\n',
          '\r': '\\r',
          '\t': '\\t',
          '\b': '\\b',
          '\f': '\\f',
          '\\': '\\\\',
          '(': '\\(',
          ')': '\\)',
        }; // Convert little endian UTF-16 to big endian

        const swapBytes = function swapBytes(buff) {
          const l = buff.length;

          if (l & 0x01) {
            throw new Error('Buffer length must be even');
          } else {
            for (let i = 0, end = l - 1; i < end; i += 2) {
              const a = buff[i];
              buff[i] = buff[i + 1];
              buff[i + 1] = a;
            }
          }

          return buff;
        };

        var PDFObject = /* #__PURE__ */(function () {
          function PDFObject() {
            _classCallCheck(this, PDFObject);
          }

          _createClass(PDFObject, null, [{
            key: 'convert',
            value: function convert(object) {
              const encryptFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null; // String literals are converted to the PDF name type

              if (typeof object === 'string') {
                return '/'.concat(object); // String objects are converted to PDF strings (UTF-16)
              } if (object instanceof String) {
                let string = object; // Detect if this is a unicode string

                let isUnicode = false;

                for (let i = 0, end = string.length; i < end; i++) {
                  if (string.charCodeAt(i) > 0x7f) {
                    isUnicode = true;
                    break;
                  }
                } // If so, encode it as big endian UTF-16

                let stringBuffer;

                if (isUnicode) {
                  stringBuffer = swapBytes(Buffer.from('\uFEFF'.concat(string), 'utf16le'));
                } else {
                  stringBuffer = Buffer.from(string.valueOf(), 'ascii');
                } // Encrypt the string when necessary

                if (encryptFn) {
                  string = encryptFn(stringBuffer).toString('binary');
                } else {
                  string = stringBuffer.toString('binary');
                } // Escape characters as required by the spec

                string = string.replace(escapableRe, (c) => escapable[c]);
                return '('.concat(string, ')'); // Buffers are converted to PDF hex strings
              } if (Buffer.isBuffer(object)) {
                return '<'.concat(object.toString('hex'), '>');
              } if (object instanceof PDFAbstractReference || object instanceof PDFTree) {
                return object.toString();
              } if (object instanceof Date) {
                let _string = `${'D:'.concat(pad(object.getUTCFullYear(), 4)) + pad(object.getUTCMonth() + 1, 2) + pad(object.getUTCDate(), 2) + pad(object.getUTCHours(), 2) + pad(object.getUTCMinutes(), 2) + pad(object.getUTCSeconds(), 2)}Z`; // Encrypt the string when necessary

                if (encryptFn) {
                  _string = encryptFn(Buffer.from(_string, 'ascii')).toString('binary'); // Escape characters as required by the spec

                  _string = _string.replace(escapableRe, (c) => escapable[c]);
                }

                return '('.concat(_string, ')');
              } if (Array.isArray(object)) {
                const items = object.map((e) => PDFObject.convert(e, encryptFn)).join(' ');
                return '['.concat(items, ']');
              } if ({}.toString.call(object) === '[object Object]') {
                const out = ['<<'];

                for (const key in object) {
                  const val = object[key];
                  out.push('/'.concat(key, ' ').concat(PDFObject.convert(val, encryptFn)));
                }

                out.push('>>');
                return out.join('\n');
              } if (typeof object === 'number') {
                return PDFObject.number(object);
              }
              return ''.concat(object);
            },
          }, {
            key: 'number',
            value: function number(n) {
              if (n > -1e21 && n < 1e21) {
                return Math.round(n * 1e6) / 1e6;
              }

              throw new Error('unsupported number: '.concat(n));
            },
          }]);

          return PDFObject;
        }());

        const PDFReference = /* #__PURE__ */(function (_PDFAbstractReference) {
          _inherits(PDFReference, _PDFAbstractReference);

          const _super = _createSuper(PDFReference);

          function PDFReference(document, id) {
            let _this;

            const data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            _classCallCheck(this, PDFReference);

            _this = _super.call(this);
            _this.document = document;
            _this.id = id;
            _this.data = data;
            _this.gen = 0;
            _this.compress = _this.document.compress && !_this.data.Filter;
            _this.uncompressedLength = 0;
            _this.buffer = [];
            return _this;
          }

          _createClass(PDFReference, [{
            key: 'write',
            value: function write(chunk) {
              if (!Buffer.isBuffer(chunk)) {
                chunk = Buffer.from(`${chunk}\n`, 'binary');
              }

              this.uncompressedLength += chunk.length;

              if (this.data.Length == null) {
                this.data.Length = 0;
              }

              this.buffer.push(chunk);
              this.data.Length += chunk.length;

              if (this.compress) {
                return this.data.Filter = 'FlateDecode';
              }
            },
          }, {
            key: 'end',
            value: function end(chunk) {
              if (chunk) {
                this.write(chunk);
              }

              return this.finalize();
            },
          }, {
            key: 'finalize',
            value: function finalize() {
              this.offset = this.document._offset;
              const encryptFn = this.document._security ? this.document._security.getEncryptFn(this.id, this.gen) : null;

              if (this.buffer.length) {
                this.buffer = Buffer.concat(this.buffer);

                if (this.compress) {
                  this.buffer = _zlib.default.deflateSync(this.buffer);
                }

                if (encryptFn) {
                  this.buffer = encryptFn(this.buffer);
                }

                this.data.Length = this.buffer.length;
              }

              this.document._write(''.concat(this.id, ' ').concat(this.gen, ' obj'));

              this.document._write(PDFObject.convert(this.data, encryptFn));

              if (this.buffer.length) {
                this.document._write('stream');

                this.document._write(this.buffer);

                this.buffer = []; // free up memory

                this.document._write('\nendstream');
              }

              this.document._write('endobj');

              this.document._refEnd(this);
            },
          }, {
            key: 'toString',
            value: function toString() {
              return ''.concat(this.id, ' ').concat(this.gen, ' R');
            },
          }]);

          return PDFReference;
        }(PDFAbstractReference));
        /*
PDFPage - represents a single page in the PDF document
By Devon Govett
*/

        const DEFAULT_MARGINS = {
          top: 72,
          left: 72,
          bottom: 72,
          right: 72,
        };
        const SIZES = {
          '4A0': [4767.87, 6740.79],
          '2A0': [3370.39, 4767.87],
          A0: [2383.94, 3370.39],
          A1: [1683.78, 2383.94],
          A2: [1190.55, 1683.78],
          A3: [841.89, 1190.55],
          A4: [595.28, 841.89],
          A5: [419.53, 595.28],
          A6: [297.64, 419.53],
          A7: [209.76, 297.64],
          A8: [147.4, 209.76],
          A9: [104.88, 147.4],
          A10: [73.7, 104.88],
          B0: [2834.65, 4008.19],
          B1: [2004.09, 2834.65],
          B2: [1417.32, 2004.09],
          B3: [1000.63, 1417.32],
          B4: [708.66, 1000.63],
          B5: [498.9, 708.66],
          B6: [354.33, 498.9],
          B7: [249.45, 354.33],
          B8: [175.75, 249.45],
          B9: [124.72, 175.75],
          B10: [87.87, 124.72],
          C0: [2599.37, 3676.54],
          C1: [1836.85, 2599.37],
          C2: [1298.27, 1836.85],
          C3: [918.43, 1298.27],
          C4: [649.13, 918.43],
          C5: [459.21, 649.13],
          C6: [323.15, 459.21],
          C7: [229.61, 323.15],
          C8: [161.57, 229.61],
          C9: [113.39, 161.57],
          C10: [79.37, 113.39],
          RA0: [2437.8, 3458.27],
          RA1: [1729.13, 2437.8],
          RA2: [1218.9, 1729.13],
          RA3: [864.57, 1218.9],
          RA4: [609.45, 864.57],
          SRA0: [2551.18, 3628.35],
          SRA1: [1814.17, 2551.18],
          SRA2: [1275.59, 1814.17],
          SRA3: [907.09, 1275.59],
          SRA4: [637.8, 907.09],
          EXECUTIVE: [521.86, 756.0],
          FOLIO: [612.0, 936.0],
          LEGAL: [612.0, 1008.0],
          LETTER: [612.0, 792.0],
          TABLOID: [792.0, 1224.0],
        };

        const PDFPage = /* #__PURE__ */(function () {
          function PDFPage(document) {
            const options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            _classCallCheck(this, PDFPage);

            this.document = document;
            this.size = options.size || 'letter';
            this.layout = options.layout || 'portrait'; // process margins

            if (typeof options.margin === 'number') {
              this.margins = {
                top: options.margin,
                left: options.margin,
                bottom: options.margin,
                right: options.margin,
              }; // default to 1 inch margins
            } else {
              this.margins = options.margins || DEFAULT_MARGINS;
            } // calculate page dimensions

            const dimensions = Array.isArray(this.size) ? this.size : SIZES[this.size.toUpperCase()];
            this.width = dimensions[this.layout === 'portrait' ? 0 : 1];
            this.height = dimensions[this.layout === 'portrait' ? 1 : 0];
            this.content = this.document.ref(); // Initialize the Font, XObject, and ExtGState dictionaries

            this.resources = this.document.ref({
              ProcSet: ['PDF', 'Text', 'ImageB', 'ImageC', 'ImageI'],
            }); // The page dictionary

            this.dictionary = this.document.ref({
              Type: 'Page',
              Parent: this.document._root.data.Pages,
              MediaBox: [0, 0, this.width, this.height],
              Contents: this.content,
              Resources: this.resources,
            });
            this.markings = [];
          } // Lazily create these objects

          _createClass(PDFPage, [{
            key: 'maxY',
            value: function maxY() {
              return this.height - this.margins.bottom;
            },
          }, {
            key: 'write',
            value: function write(chunk) {
              return this.content.write(chunk);
            },
          }, {
            key: 'end',
            value: function end() {
              this.dictionary.end();
              this.resources.end();
              return this.content.end();
            },
          }, {
            key: 'fonts',
            get: function get() {
              const { data } = this.resources;
              return data.Font != null ? data.Font : data.Font = {};
            },
          }, {
            key: 'xobjects',
            get: function get() {
              const { data } = this.resources;
              return data.XObject != null ? data.XObject : data.XObject = {};
            },
          }, {
            key: 'ext_gstates',
            get: function get() {
              const { data } = this.resources;
              return data.ExtGState != null ? data.ExtGState : data.ExtGState = {};
            },
          }, {
            key: 'patterns',
            get: function get() {
              const { data } = this.resources;
              return data.Pattern != null ? data.Pattern : data.Pattern = {};
            },
          }, {
            key: 'colorSpaces',
            get: function get() {
              const { data } = this.resources;
              return data.ColorSpace || (data.ColorSpace = {});
            },
          }, {
            key: 'annotations',
            get: function get() {
              const { data } = this.dictionary;
              return data.Annots != null ? data.Annots : data.Annots = [];
            },
          }, {
            key: 'structParentTreeKey',
            get: function get() {
              const { data } = this.dictionary;
              return data.StructParents != null ? data.StructParents : data.StructParents = this.document.createStructParentTreeNextKey();
            },
          }]);

          return PDFPage;
        }());

        const PDFNameTree = /* #__PURE__ */(function (_PDFTree) {
          _inherits(PDFNameTree, _PDFTree);

          const _super = _createSuper(PDFNameTree);

          function PDFNameTree() {
            _classCallCheck(this, PDFNameTree);

            return _super.apply(this, arguments);
          }

          _createClass(PDFNameTree, [{
            key: '_compareKeys',
            value: function _compareKeys(a, b) {
              return a.localeCompare(b);
            },
          }, {
            key: '_keysName',
            value: function _keysName() {
              return 'Names';
            },
          }, {
            key: '_dataForKey',
            value: function _dataForKey(k) {
              return new String(k);
            },
          }]);

          return PDFNameTree;
        }(PDFTree));
        /**
 * Check if value is in a range group.
 * @param {number} value
 * @param {number[]} rangeGroup
 * @returns {boolean}
 */

        function inRange(value, rangeGroup) {
          if (value < rangeGroup[0]) return false;
          let startRange = 0;
          let endRange = rangeGroup.length / 2;

          while (startRange <= endRange) {
            const middleRange = Math.floor((startRange + endRange) / 2); // actual array index

            const arrayIndex = middleRange * 2; // Check if value is in range pointed by actual index

            if (value >= rangeGroup[arrayIndex] && value <= rangeGroup[arrayIndex + 1]) {
              return true;
            }

            if (value > rangeGroup[arrayIndex + 1]) {
              // Search Right Side Of Array
              startRange = middleRange + 1;
            } else {
              // Search Left Side Of Array
              endRange = middleRange - 1;
            }
          }

          return false;
        }
        /**
 * A.1 Unassigned code points in Unicode 3.2
 * @link https://tools.ietf.org/html/rfc3454#appendix-A.1
 */

        const unassigned_code_points = [0x0221, 0x0221, 0x0234, 0x024f, 0x02ae, 0x02af, 0x02ef, 0x02ff, 0x0350, 0x035f, 0x0370, 0x0373, 0x0376, 0x0379, 0x037b, 0x037d, 0x037f, 0x0383, 0x038b, 0x038b, 0x038d, 0x038d, 0x03a2, 0x03a2, 0x03cf, 0x03cf, 0x03f7, 0x03ff, 0x0487, 0x0487, 0x04cf, 0x04cf, 0x04f6, 0x04f7, 0x04fa, 0x04ff, 0x0510, 0x0530, 0x0557, 0x0558, 0x0560, 0x0560, 0x0588, 0x0588, 0x058b, 0x0590, 0x05a2, 0x05a2, 0x05ba, 0x05ba, 0x05c5, 0x05cf, 0x05eb, 0x05ef, 0x05f5, 0x060b, 0x060d, 0x061a, 0x061c, 0x061e, 0x0620, 0x0620, 0x063b, 0x063f, 0x0656, 0x065f, 0x06ee, 0x06ef, 0x06ff, 0x06ff, 0x070e, 0x070e, 0x072d, 0x072f, 0x074b, 0x077f, 0x07b2, 0x0900, 0x0904, 0x0904, 0x093a, 0x093b, 0x094e, 0x094f, 0x0955, 0x0957, 0x0971, 0x0980, 0x0984, 0x0984, 0x098d, 0x098e, 0x0991, 0x0992, 0x09a9, 0x09a9, 0x09b1, 0x09b1, 0x09b3, 0x09b5, 0x09ba, 0x09bb, 0x09bd, 0x09bd, 0x09c5, 0x09c6, 0x09c9, 0x09ca, 0x09ce, 0x09d6, 0x09d8, 0x09db, 0x09de, 0x09de, 0x09e4, 0x09e5, 0x09fb, 0x0a01, 0x0a03, 0x0a04, 0x0a0b, 0x0a0e, 0x0a11, 0x0a12, 0x0a29, 0x0a29, 0x0a31, 0x0a31, 0x0a34, 0x0a34, 0x0a37, 0x0a37, 0x0a3a, 0x0a3b, 0x0a3d, 0x0a3d, 0x0a43, 0x0a46, 0x0a49, 0x0a4a, 0x0a4e, 0x0a58, 0x0a5d, 0x0a5d, 0x0a5f, 0x0a65, 0x0a75, 0x0a80, 0x0a84, 0x0a84, 0x0a8c, 0x0a8c, 0x0a8e, 0x0a8e, 0x0a92, 0x0a92, 0x0aa9, 0x0aa9, 0x0ab1, 0x0ab1, 0x0ab4, 0x0ab4, 0x0aba, 0x0abb, 0x0ac6, 0x0ac6, 0x0aca, 0x0aca, 0x0ace, 0x0acf, 0x0ad1, 0x0adf, 0x0ae1, 0x0ae5, 0x0af0, 0x0b00, 0x0b04, 0x0b04, 0x0b0d, 0x0b0e, 0x0b11, 0x0b12, 0x0b29, 0x0b29, 0x0b31, 0x0b31, 0x0b34, 0x0b35, 0x0b3a, 0x0b3b, 0x0b44, 0x0b46, 0x0b49, 0x0b4a, 0x0b4e, 0x0b55, 0x0b58, 0x0b5b, 0x0b5e, 0x0b5e, 0x0b62, 0x0b65, 0x0b71, 0x0b81, 0x0b84, 0x0b84, 0x0b8b, 0x0b8d, 0x0b91, 0x0b91, 0x0b96, 0x0b98, 0x0b9b, 0x0b9b, 0x0b9d, 0x0b9d, 0x0ba0, 0x0ba2, 0x0ba5, 0x0ba7, 0x0bab, 0x0bad, 0x0bb6, 0x0bb6, 0x0bba, 0x0bbd, 0x0bc3, 0x0bc5, 0x0bc9, 0x0bc9, 0x0bce, 0x0bd6, 0x0bd8, 0x0be6, 0x0bf3, 0x0c00, 0x0c04, 0x0c04, 0x0c0d, 0x0c0d, 0x0c11, 0x0c11, 0x0c29, 0x0c29, 0x0c34, 0x0c34, 0x0c3a, 0x0c3d, 0x0c45, 0x0c45, 0x0c49, 0x0c49, 0x0c4e, 0x0c54, 0x0c57, 0x0c5f, 0x0c62, 0x0c65, 0x0c70, 0x0c81, 0x0c84, 0x0c84, 0x0c8d, 0x0c8d, 0x0c91, 0x0c91, 0x0ca9, 0x0ca9, 0x0cb4, 0x0cb4, 0x0cba, 0x0cbd, 0x0cc5, 0x0cc5, 0x0cc9, 0x0cc9, 0x0cce, 0x0cd4, 0x0cd7, 0x0cdd, 0x0cdf, 0x0cdf, 0x0ce2, 0x0ce5, 0x0cf0, 0x0d01, 0x0d04, 0x0d04, 0x0d0d, 0x0d0d, 0x0d11, 0x0d11, 0x0d29, 0x0d29, 0x0d3a, 0x0d3d, 0x0d44, 0x0d45, 0x0d49, 0x0d49, 0x0d4e, 0x0d56, 0x0d58, 0x0d5f, 0x0d62, 0x0d65, 0x0d70, 0x0d81, 0x0d84, 0x0d84, 0x0d97, 0x0d99, 0x0db2, 0x0db2, 0x0dbc, 0x0dbc, 0x0dbe, 0x0dbf, 0x0dc7, 0x0dc9, 0x0dcb, 0x0dce, 0x0dd5, 0x0dd5, 0x0dd7, 0x0dd7, 0x0de0, 0x0df1, 0x0df5, 0x0e00, 0x0e3b, 0x0e3e, 0x0e5c, 0x0e80, 0x0e83, 0x0e83, 0x0e85, 0x0e86, 0x0e89, 0x0e89, 0x0e8b, 0x0e8c, 0x0e8e, 0x0e93, 0x0e98, 0x0e98, 0x0ea0, 0x0ea0, 0x0ea4, 0x0ea4, 0x0ea6, 0x0ea6, 0x0ea8, 0x0ea9, 0x0eac, 0x0eac, 0x0eba, 0x0eba, 0x0ebe, 0x0ebf, 0x0ec5, 0x0ec5, 0x0ec7, 0x0ec7, 0x0ece, 0x0ecf, 0x0eda, 0x0edb, 0x0ede, 0x0eff, 0x0f48, 0x0f48, 0x0f6b, 0x0f70, 0x0f8c, 0x0f8f, 0x0f98, 0x0f98, 0x0fbd, 0x0fbd, 0x0fcd, 0x0fce, 0x0fd0, 0x0fff, 0x1022, 0x1022, 0x1028, 0x1028, 0x102b, 0x102b, 0x1033, 0x1035, 0x103a, 0x103f, 0x105a, 0x109f, 0x10c6, 0x10cf, 0x10f9, 0x10fa, 0x10fc, 0x10ff, 0x115a, 0x115e, 0x11a3, 0x11a7, 0x11fa, 0x11ff, 0x1207, 0x1207, 0x1247, 0x1247, 0x1249, 0x1249, 0x124e, 0x124f, 0x1257, 0x1257, 0x1259, 0x1259, 0x125e, 0x125f, 0x1287, 0x1287, 0x1289, 0x1289, 0x128e, 0x128f, 0x12af, 0x12af, 0x12b1, 0x12b1, 0x12b6, 0x12b7, 0x12bf, 0x12bf, 0x12c1, 0x12c1, 0x12c6, 0x12c7, 0x12cf, 0x12cf, 0x12d7, 0x12d7, 0x12ef, 0x12ef, 0x130f, 0x130f, 0x1311, 0x1311, 0x1316, 0x1317, 0x131f, 0x131f, 0x1347, 0x1347, 0x135b, 0x1360, 0x137d, 0x139f, 0x13f5, 0x1400, 0x1677, 0x167f, 0x169d, 0x169f, 0x16f1, 0x16ff, 0x170d, 0x170d, 0x1715, 0x171f, 0x1737, 0x173f, 0x1754, 0x175f, 0x176d, 0x176d, 0x1771, 0x1771, 0x1774, 0x177f, 0x17dd, 0x17df, 0x17ea, 0x17ff, 0x180f, 0x180f, 0x181a, 0x181f, 0x1878, 0x187f, 0x18aa, 0x1dff, 0x1e9c, 0x1e9f, 0x1efa, 0x1eff, 0x1f16, 0x1f17, 0x1f1e, 0x1f1f, 0x1f46, 0x1f47, 0x1f4e, 0x1f4f, 0x1f58, 0x1f58, 0x1f5a, 0x1f5a, 0x1f5c, 0x1f5c, 0x1f5e, 0x1f5e, 0x1f7e, 0x1f7f, 0x1fb5, 0x1fb5, 0x1fc5, 0x1fc5, 0x1fd4, 0x1fd5, 0x1fdc, 0x1fdc, 0x1ff0, 0x1ff1, 0x1ff5, 0x1ff5, 0x1fff, 0x1fff, 0x2053, 0x2056, 0x2058, 0x205e, 0x2064, 0x2069, 0x2072, 0x2073, 0x208f, 0x209f, 0x20b2, 0x20cf, 0x20eb, 0x20ff, 0x213b, 0x213c, 0x214c, 0x2152, 0x2184, 0x218f, 0x23cf, 0x23ff, 0x2427, 0x243f, 0x244b, 0x245f, 0x24ff, 0x24ff, 0x2614, 0x2615, 0x2618, 0x2618, 0x267e, 0x267f, 0x268a, 0x2700, 0x2705, 0x2705, 0x270a, 0x270b, 0x2728, 0x2728, 0x274c, 0x274c, 0x274e, 0x274e, 0x2753, 0x2755, 0x2757, 0x2757, 0x275f, 0x2760, 0x2795, 0x2797, 0x27b0, 0x27b0, 0x27bf, 0x27cf, 0x27ec, 0x27ef, 0x2b00, 0x2e7f, 0x2e9a, 0x2e9a, 0x2ef4, 0x2eff, 0x2fd6, 0x2fef, 0x2ffc, 0x2fff, 0x3040, 0x3040, 0x3097, 0x3098, 0x3100, 0x3104, 0x312d, 0x3130, 0x318f, 0x318f, 0x31b8, 0x31ef, 0x321d, 0x321f, 0x3244, 0x3250, 0x327c, 0x327e, 0x32cc, 0x32cf, 0x32ff, 0x32ff, 0x3377, 0x337a, 0x33de, 0x33df, 0x33ff, 0x33ff, 0x4db6, 0x4dff, 0x9fa6, 0x9fff, 0xa48d, 0xa48f, 0xa4c7, 0xabff, 0xd7a4, 0xd7ff, 0xfa2e, 0xfa2f, 0xfa6b, 0xfaff, 0xfb07, 0xfb12, 0xfb18, 0xfb1c, 0xfb37, 0xfb37, 0xfb3d, 0xfb3d, 0xfb3f, 0xfb3f, 0xfb42, 0xfb42, 0xfb45, 0xfb45, 0xfbb2, 0xfbd2, 0xfd40, 0xfd4f, 0xfd90, 0xfd91, 0xfdc8, 0xfdcf, 0xfdfd, 0xfdff, 0xfe10, 0xfe1f, 0xfe24, 0xfe2f, 0xfe47, 0xfe48, 0xfe53, 0xfe53, 0xfe67, 0xfe67, 0xfe6c, 0xfe6f, 0xfe75, 0xfe75, 0xfefd, 0xfefe, 0xff00, 0xff00, 0xffbf, 0xffc1, 0xffc8, 0xffc9, 0xffd0, 0xffd1, 0xffd8, 0xffd9, 0xffdd, 0xffdf, 0xffe7, 0xffe7, 0xffef, 0xfff8, 0x10000, 0x102ff, 0x1031f, 0x1031f, 0x10324, 0x1032f, 0x1034b, 0x103ff, 0x10426, 0x10427, 0x1044e, 0x1cfff, 0x1d0f6, 0x1d0ff, 0x1d127, 0x1d129, 0x1d1de, 0x1d3ff, 0x1d455, 0x1d455, 0x1d49d, 0x1d49d, 0x1d4a0, 0x1d4a1, 0x1d4a3, 0x1d4a4, 0x1d4a7, 0x1d4a8, 0x1d4ad, 0x1d4ad, 0x1d4ba, 0x1d4ba, 0x1d4bc, 0x1d4bc, 0x1d4c1, 0x1d4c1, 0x1d4c4, 0x1d4c4, 0x1d506, 0x1d506, 0x1d50b, 0x1d50c, 0x1d515, 0x1d515, 0x1d51d, 0x1d51d, 0x1d53a, 0x1d53a, 0x1d53f, 0x1d53f, 0x1d545, 0x1d545, 0x1d547, 0x1d549, 0x1d551, 0x1d551, 0x1d6a4, 0x1d6a7, 0x1d7ca, 0x1d7cd, 0x1d800, 0x1fffd, 0x2a6d7, 0x2f7ff, 0x2fa1e, 0x2fffd, 0x30000, 0x3fffd, 0x40000, 0x4fffd, 0x50000, 0x5fffd, 0x60000, 0x6fffd, 0x70000, 0x7fffd, 0x80000, 0x8fffd, 0x90000, 0x9fffd, 0xa0000, 0xafffd, 0xb0000, 0xbfffd, 0xc0000, 0xcfffd, 0xd0000, 0xdfffd, 0xe0000, 0xe0000, 0xe0002, 0xe001f, 0xe0080, 0xefffd]; // prettier-ignore-end

        const isUnassignedCodePoint = function isUnassignedCodePoint(character) {
          return inRange(character, unassigned_code_points);
        }; // prettier-ignore-start

        /**
 * B.1 Commonly mapped to nothing
 * @link https://tools.ietf.org/html/rfc3454#appendix-B.1
 */

        const commonly_mapped_to_nothing = [0x00ad, 0x00ad, 0x034f, 0x034f, 0x1806, 0x1806, 0x180b, 0x180b, 0x180c, 0x180c, 0x180d, 0x180d, 0x200b, 0x200b, 0x200c, 0x200c, 0x200d, 0x200d, 0x2060, 0x2060, 0xfe00, 0xfe00, 0xfe01, 0xfe01, 0xfe02, 0xfe02, 0xfe03, 0xfe03, 0xfe04, 0xfe04, 0xfe05, 0xfe05, 0xfe06, 0xfe06, 0xfe07, 0xfe07, 0xfe08, 0xfe08, 0xfe09, 0xfe09, 0xfe0a, 0xfe0a, 0xfe0b, 0xfe0b, 0xfe0c, 0xfe0c, 0xfe0d, 0xfe0d, 0xfe0e, 0xfe0e, 0xfe0f, 0xfe0f, 0xfeff, 0xfeff]; // prettier-ignore-end

        const isCommonlyMappedToNothing = function isCommonlyMappedToNothing(character) {
          return inRange(character, commonly_mapped_to_nothing);
        }; // prettier-ignore-start

        /**
 * C.1.2 Non-ASCII space characters
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.1.2
 */

        const non_ASCII_space_characters = [0x00a0, 0x00a0,
          /* NO-BREAK SPACE */
          0x1680, 0x1680,
          /* OGHAM SPACE MARK */
          0x2000, 0x2000,
          /* EN QUAD */
          0x2001, 0x2001,
          /* EM QUAD */
          0x2002, 0x2002,
          /* EN SPACE */
          0x2003, 0x2003,
          /* EM SPACE */
          0x2004, 0x2004,
          /* THREE-PER-EM SPACE */
          0x2005, 0x2005,
          /* FOUR-PER-EM SPACE */
          0x2006, 0x2006,
          /* SIX-PER-EM SPACE */
          0x2007, 0x2007,
          /* FIGURE SPACE */
          0x2008, 0x2008,
          /* PUNCTUATION SPACE */
          0x2009, 0x2009,
          /* THIN SPACE */
          0x200a, 0x200a,
          /* HAIR SPACE */
          0x200b, 0x200b,
          /* ZERO WIDTH SPACE */
          0x202f, 0x202f,
          /* NARROW NO-BREAK SPACE */
          0x205f, 0x205f,
          /* MEDIUM MATHEMATICAL SPACE */
          0x3000, 0x3000,
          /* IDEOGRAPHIC SPACE */
        ]; // prettier-ignore-end

        const isNonASCIISpaceCharacter = function isNonASCIISpaceCharacter(character) {
          return inRange(character, non_ASCII_space_characters);
        }; // prettier-ignore-start

        const non_ASCII_controls_characters = [
          /**
 * C.2.2 Non-ASCII control characters
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.2.2
 */
          0x0080, 0x009f,
          /* [CONTROL CHARACTERS] */
          0x06dd, 0x06dd,
          /* ARABIC END OF AYAH */
          0x070f, 0x070f,
          /* SYRIAC ABBREVIATION MARK */
          0x180e, 0x180e,
          /* MONGOLIAN VOWEL SEPARATOR */
          0x200c, 0x200c,
          /* ZERO WIDTH NON-JOINER */
          0x200d, 0x200d,
          /* ZERO WIDTH JOINER */
          0x2028, 0x2028,
          /* LINE SEPARATOR */
          0x2029, 0x2029,
          /* PARAGRAPH SEPARATOR */
          0x2060, 0x2060,
          /* WORD JOINER */
          0x2061, 0x2061,
          /* FUNCTION APPLICATION */
          0x2062, 0x2062,
          /* INVISIBLE TIMES */
          0x2063, 0x2063,
          /* INVISIBLE SEPARATOR */
          0x206a, 0x206f,
          /* [CONTROL CHARACTERS] */
          0xfeff, 0xfeff,
          /* ZERO WIDTH NO-BREAK SPACE */
          0xfff9, 0xfffc,
          /* [CONTROL CHARACTERS] */
          0x1d173, 0x1d17a,
          /* [MUSICAL CONTROL CHARACTERS] */
        ];
        const non_character_codepoints = [
          /**
 * C.4 Non-character code points
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.4
 */
          0xfdd0, 0xfdef,
          /* [NONCHARACTER CODE POINTS] */
          0xfffe, 0xffff,
          /* [NONCHARACTER CODE POINTS] */
          0x1fffe, 0x1ffff,
          /* [NONCHARACTER CODE POINTS] */
          0x2fffe, 0x2ffff,
          /* [NONCHARACTER CODE POINTS] */
          0x3fffe, 0x3ffff,
          /* [NONCHARACTER CODE POINTS] */
          0x4fffe, 0x4ffff,
          /* [NONCHARACTER CODE POINTS] */
          0x5fffe, 0x5ffff,
          /* [NONCHARACTER CODE POINTS] */
          0x6fffe, 0x6ffff,
          /* [NONCHARACTER CODE POINTS] */
          0x7fffe, 0x7ffff,
          /* [NONCHARACTER CODE POINTS] */
          0x8fffe, 0x8ffff,
          /* [NONCHARACTER CODE POINTS] */
          0x9fffe, 0x9ffff,
          /* [NONCHARACTER CODE POINTS] */
          0xafffe, 0xaffff,
          /* [NONCHARACTER CODE POINTS] */
          0xbfffe, 0xbffff,
          /* [NONCHARACTER CODE POINTS] */
          0xcfffe, 0xcffff,
          /* [NONCHARACTER CODE POINTS] */
          0xdfffe, 0xdffff,
          /* [NONCHARACTER CODE POINTS] */
          0xefffe, 0xeffff,
          /* [NONCHARACTER CODE POINTS] */
          0x10fffe, 0x10ffff,
          /* [NONCHARACTER CODE POINTS] */
        ];
        /**
 * 2.3.  Prohibited Output
 */

        const prohibited_characters = [
          /**
 * C.2.1 ASCII control characters
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.2.1
 */
          0, 0x001f,
          /* [CONTROL CHARACTERS] */
          0x007f, 0x007f, /* DELETE */

          /**
 * C.8 Change display properties or are deprecated
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.8
 */
          0x0340, 0x0340,
          /* COMBINING GRAVE TONE MARK */
          0x0341, 0x0341,
          /* COMBINING ACUTE TONE MARK */
          0x200e, 0x200e,
          /* LEFT-TO-RIGHT MARK */
          0x200f, 0x200f,
          /* RIGHT-TO-LEFT MARK */
          0x202a, 0x202a,
          /* LEFT-TO-RIGHT EMBEDDING */
          0x202b, 0x202b,
          /* RIGHT-TO-LEFT EMBEDDING */
          0x202c, 0x202c,
          /* POP DIRECTIONAL FORMATTING */
          0x202d, 0x202d,
          /* LEFT-TO-RIGHT OVERRIDE */
          0x202e, 0x202e,
          /* RIGHT-TO-LEFT OVERRIDE */
          0x206a, 0x206a,
          /* INHIBIT SYMMETRIC SWAPPING */
          0x206b, 0x206b,
          /* ACTIVATE SYMMETRIC SWAPPING */
          0x206c, 0x206c,
          /* INHIBIT ARABIC FORM SHAPING */
          0x206d, 0x206d,
          /* ACTIVATE ARABIC FORM SHAPING */
          0x206e, 0x206e,
          /* NATIONAL DIGIT SHAPES */
          0x206f, 0x206f, /* NOMINAL DIGIT SHAPES */

          /**
 * C.7 Inappropriate for canonical representation
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.7
 */
          0x2ff0, 0x2ffb, /* [IDEOGRAPHIC DESCRIPTION CHARACTERS] */

          /**
 * C.5 Surrogate codes
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.5
 */
          0xd800, 0xdfff,
          /**
 * C.3 Private use
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.3
 */
          0xe000, 0xf8ff, /* [PRIVATE USE, PLANE 0] */

          /**
 * C.6 Inappropriate for plain text
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.6
 */
          0xfff9, 0xfff9,
          /* INTERLINEAR ANNOTATION ANCHOR */
          0xfffa, 0xfffa,
          /* INTERLINEAR ANNOTATION SEPARATOR */
          0xfffb, 0xfffb,
          /* INTERLINEAR ANNOTATION TERMINATOR */
          0xfffc, 0xfffc,
          /* OBJECT REPLACEMENT CHARACTER */
          0xfffd, 0xfffd, /* REPLACEMENT CHARACTER */

          /**
 * C.9 Tagging characters
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.9
 */
          0xe0001, 0xe0001,
          /* LANGUAGE TAG */
          0xe0020, 0xe007f, /* [TAGGING CHARACTERS] */

          /**
 * C.3 Private use
 * @link https://tools.ietf.org/html/rfc3454#appendix-C.3
 */
          0xf0000, 0xffffd,
          /* [PRIVATE USE, PLANE 15] */
          0x100000, 0x10fffd,
          /* [PRIVATE USE, PLANE 16] */
        ]; // prettier-ignore-end

        const isProhibitedCharacter = function isProhibitedCharacter(character) {
          return inRange(character, non_ASCII_space_characters) || inRange(character, prohibited_characters) || inRange(character, non_ASCII_controls_characters) || inRange(character, non_character_codepoints);
        }; // prettier-ignore-start

        /**
 * D.1 Characters with bidirectional property "R" or "AL"
 * @link https://tools.ietf.org/html/rfc3454#appendix-D.1
 */

        const bidirectional_r_al = [0x05be, 0x05be, 0x05c0, 0x05c0, 0x05c3, 0x05c3, 0x05d0, 0x05ea, 0x05f0, 0x05f4, 0x061b, 0x061b, 0x061f, 0x061f, 0x0621, 0x063a, 0x0640, 0x064a, 0x066d, 0x066f, 0x0671, 0x06d5, 0x06dd, 0x06dd, 0x06e5, 0x06e6, 0x06fa, 0x06fe, 0x0700, 0x070d, 0x0710, 0x0710, 0x0712, 0x072c, 0x0780, 0x07a5, 0x07b1, 0x07b1, 0x200f, 0x200f, 0xfb1d, 0xfb1d, 0xfb1f, 0xfb28, 0xfb2a, 0xfb36, 0xfb38, 0xfb3c, 0xfb3e, 0xfb3e, 0xfb40, 0xfb41, 0xfb43, 0xfb44, 0xfb46, 0xfbb1, 0xfbd3, 0xfd3d, 0xfd50, 0xfd8f, 0xfd92, 0xfdc7, 0xfdf0, 0xfdfc, 0xfe70, 0xfe74, 0xfe76, 0xfefc]; // prettier-ignore-end

        const isBidirectionalRAL = function isBidirectionalRAL(character) {
          return inRange(character, bidirectional_r_al);
        }; // prettier-ignore-start

        /**
 * D.2 Characters with bidirectional property "L"
 * @link https://tools.ietf.org/html/rfc3454#appendix-D.2
 */

        const bidirectional_l = [0x0041, 0x005a, 0x0061, 0x007a, 0x00aa, 0x00aa, 0x00b5, 0x00b5, 0x00ba, 0x00ba, 0x00c0, 0x00d6, 0x00d8, 0x00f6, 0x00f8, 0x0220, 0x0222, 0x0233, 0x0250, 0x02ad, 0x02b0, 0x02b8, 0x02bb, 0x02c1, 0x02d0, 0x02d1, 0x02e0, 0x02e4, 0x02ee, 0x02ee, 0x037a, 0x037a, 0x0386, 0x0386, 0x0388, 0x038a, 0x038c, 0x038c, 0x038e, 0x03a1, 0x03a3, 0x03ce, 0x03d0, 0x03f5, 0x0400, 0x0482, 0x048a, 0x04ce, 0x04d0, 0x04f5, 0x04f8, 0x04f9, 0x0500, 0x050f, 0x0531, 0x0556, 0x0559, 0x055f, 0x0561, 0x0587, 0x0589, 0x0589, 0x0903, 0x0903, 0x0905, 0x0939, 0x093d, 0x0940, 0x0949, 0x094c, 0x0950, 0x0950, 0x0958, 0x0961, 0x0964, 0x0970, 0x0982, 0x0983, 0x0985, 0x098c, 0x098f, 0x0990, 0x0993, 0x09a8, 0x09aa, 0x09b0, 0x09b2, 0x09b2, 0x09b6, 0x09b9, 0x09be, 0x09c0, 0x09c7, 0x09c8, 0x09cb, 0x09cc, 0x09d7, 0x09d7, 0x09dc, 0x09dd, 0x09df, 0x09e1, 0x09e6, 0x09f1, 0x09f4, 0x09fa, 0x0a05, 0x0a0a, 0x0a0f, 0x0a10, 0x0a13, 0x0a28, 0x0a2a, 0x0a30, 0x0a32, 0x0a33, 0x0a35, 0x0a36, 0x0a38, 0x0a39, 0x0a3e, 0x0a40, 0x0a59, 0x0a5c, 0x0a5e, 0x0a5e, 0x0a66, 0x0a6f, 0x0a72, 0x0a74, 0x0a83, 0x0a83, 0x0a85, 0x0a8b, 0x0a8d, 0x0a8d, 0x0a8f, 0x0a91, 0x0a93, 0x0aa8, 0x0aaa, 0x0ab0, 0x0ab2, 0x0ab3, 0x0ab5, 0x0ab9, 0x0abd, 0x0ac0, 0x0ac9, 0x0ac9, 0x0acb, 0x0acc, 0x0ad0, 0x0ad0, 0x0ae0, 0x0ae0, 0x0ae6, 0x0aef, 0x0b02, 0x0b03, 0x0b05, 0x0b0c, 0x0b0f, 0x0b10, 0x0b13, 0x0b28, 0x0b2a, 0x0b30, 0x0b32, 0x0b33, 0x0b36, 0x0b39, 0x0b3d, 0x0b3e, 0x0b40, 0x0b40, 0x0b47, 0x0b48, 0x0b4b, 0x0b4c, 0x0b57, 0x0b57, 0x0b5c, 0x0b5d, 0x0b5f, 0x0b61, 0x0b66, 0x0b70, 0x0b83, 0x0b83, 0x0b85, 0x0b8a, 0x0b8e, 0x0b90, 0x0b92, 0x0b95, 0x0b99, 0x0b9a, 0x0b9c, 0x0b9c, 0x0b9e, 0x0b9f, 0x0ba3, 0x0ba4, 0x0ba8, 0x0baa, 0x0bae, 0x0bb5, 0x0bb7, 0x0bb9, 0x0bbe, 0x0bbf, 0x0bc1, 0x0bc2, 0x0bc6, 0x0bc8, 0x0bca, 0x0bcc, 0x0bd7, 0x0bd7, 0x0be7, 0x0bf2, 0x0c01, 0x0c03, 0x0c05, 0x0c0c, 0x0c0e, 0x0c10, 0x0c12, 0x0c28, 0x0c2a, 0x0c33, 0x0c35, 0x0c39, 0x0c41, 0x0c44, 0x0c60, 0x0c61, 0x0c66, 0x0c6f, 0x0c82, 0x0c83, 0x0c85, 0x0c8c, 0x0c8e, 0x0c90, 0x0c92, 0x0ca8, 0x0caa, 0x0cb3, 0x0cb5, 0x0cb9, 0x0cbe, 0x0cbe, 0x0cc0, 0x0cc4, 0x0cc7, 0x0cc8, 0x0cca, 0x0ccb, 0x0cd5, 0x0cd6, 0x0cde, 0x0cde, 0x0ce0, 0x0ce1, 0x0ce6, 0x0cef, 0x0d02, 0x0d03, 0x0d05, 0x0d0c, 0x0d0e, 0x0d10, 0x0d12, 0x0d28, 0x0d2a, 0x0d39, 0x0d3e, 0x0d40, 0x0d46, 0x0d48, 0x0d4a, 0x0d4c, 0x0d57, 0x0d57, 0x0d60, 0x0d61, 0x0d66, 0x0d6f, 0x0d82, 0x0d83, 0x0d85, 0x0d96, 0x0d9a, 0x0db1, 0x0db3, 0x0dbb, 0x0dbd, 0x0dbd, 0x0dc0, 0x0dc6, 0x0dcf, 0x0dd1, 0x0dd8, 0x0ddf, 0x0df2, 0x0df4, 0x0e01, 0x0e30, 0x0e32, 0x0e33, 0x0e40, 0x0e46, 0x0e4f, 0x0e5b, 0x0e81, 0x0e82, 0x0e84, 0x0e84, 0x0e87, 0x0e88, 0x0e8a, 0x0e8a, 0x0e8d, 0x0e8d, 0x0e94, 0x0e97, 0x0e99, 0x0e9f, 0x0ea1, 0x0ea3, 0x0ea5, 0x0ea5, 0x0ea7, 0x0ea7, 0x0eaa, 0x0eab, 0x0ead, 0x0eb0, 0x0eb2, 0x0eb3, 0x0ebd, 0x0ebd, 0x0ec0, 0x0ec4, 0x0ec6, 0x0ec6, 0x0ed0, 0x0ed9, 0x0edc, 0x0edd, 0x0f00, 0x0f17, 0x0f1a, 0x0f34, 0x0f36, 0x0f36, 0x0f38, 0x0f38, 0x0f3e, 0x0f47, 0x0f49, 0x0f6a, 0x0f7f, 0x0f7f, 0x0f85, 0x0f85, 0x0f88, 0x0f8b, 0x0fbe, 0x0fc5, 0x0fc7, 0x0fcc, 0x0fcf, 0x0fcf, 0x1000, 0x1021, 0x1023, 0x1027, 0x1029, 0x102a, 0x102c, 0x102c, 0x1031, 0x1031, 0x1038, 0x1038, 0x1040, 0x1057, 0x10a0, 0x10c5, 0x10d0, 0x10f8, 0x10fb, 0x10fb, 0x1100, 0x1159, 0x115f, 0x11a2, 0x11a8, 0x11f9, 0x1200, 0x1206, 0x1208, 0x1246, 0x1248, 0x1248, 0x124a, 0x124d, 0x1250, 0x1256, 0x1258, 0x1258, 0x125a, 0x125d, 0x1260, 0x1286, 0x1288, 0x1288, 0x128a, 0x128d, 0x1290, 0x12ae, 0x12b0, 0x12b0, 0x12b2, 0x12b5, 0x12b8, 0x12be, 0x12c0, 0x12c0, 0x12c2, 0x12c5, 0x12c8, 0x12ce, 0x12d0, 0x12d6, 0x12d8, 0x12ee, 0x12f0, 0x130e, 0x1310, 0x1310, 0x1312, 0x1315, 0x1318, 0x131e, 0x1320, 0x1346, 0x1348, 0x135a, 0x1361, 0x137c, 0x13a0, 0x13f4, 0x1401, 0x1676, 0x1681, 0x169a, 0x16a0, 0x16f0, 0x1700, 0x170c, 0x170e, 0x1711, 0x1720, 0x1731, 0x1735, 0x1736, 0x1740, 0x1751, 0x1760, 0x176c, 0x176e, 0x1770, 0x1780, 0x17b6, 0x17be, 0x17c5, 0x17c7, 0x17c8, 0x17d4, 0x17da, 0x17dc, 0x17dc, 0x17e0, 0x17e9, 0x1810, 0x1819, 0x1820, 0x1877, 0x1880, 0x18a8, 0x1e00, 0x1e9b, 0x1ea0, 0x1ef9, 0x1f00, 0x1f15, 0x1f18, 0x1f1d, 0x1f20, 0x1f45, 0x1f48, 0x1f4d, 0x1f50, 0x1f57, 0x1f59, 0x1f59, 0x1f5b, 0x1f5b, 0x1f5d, 0x1f5d, 0x1f5f, 0x1f7d, 0x1f80, 0x1fb4, 0x1fb6, 0x1fbc, 0x1fbe, 0x1fbe, 0x1fc2, 0x1fc4, 0x1fc6, 0x1fcc, 0x1fd0, 0x1fd3, 0x1fd6, 0x1fdb, 0x1fe0, 0x1fec, 0x1ff2, 0x1ff4, 0x1ff6, 0x1ffc, 0x200e, 0x200e, 0x2071, 0x2071, 0x207f, 0x207f, 0x2102, 0x2102, 0x2107, 0x2107, 0x210a, 0x2113, 0x2115, 0x2115, 0x2119, 0x211d, 0x2124, 0x2124, 0x2126, 0x2126, 0x2128, 0x2128, 0x212a, 0x212d, 0x212f, 0x2131, 0x2133, 0x2139, 0x213d, 0x213f, 0x2145, 0x2149, 0x2160, 0x2183, 0x2336, 0x237a, 0x2395, 0x2395, 0x249c, 0x24e9, 0x3005, 0x3007, 0x3021, 0x3029, 0x3031, 0x3035, 0x3038, 0x303c, 0x3041, 0x3096, 0x309d, 0x309f, 0x30a1, 0x30fa, 0x30fc, 0x30ff, 0x3105, 0x312c, 0x3131, 0x318e, 0x3190, 0x31b7, 0x31f0, 0x321c, 0x3220, 0x3243, 0x3260, 0x327b, 0x327f, 0x32b0, 0x32c0, 0x32cb, 0x32d0, 0x32fe, 0x3300, 0x3376, 0x337b, 0x33dd, 0x33e0, 0x33fe, 0x3400, 0x4db5, 0x4e00, 0x9fa5, 0xa000, 0xa48c, 0xac00, 0xd7a3, 0xd800, 0xfa2d, 0xfa30, 0xfa6a, 0xfb00, 0xfb06, 0xfb13, 0xfb17, 0xff21, 0xff3a, 0xff41, 0xff5a, 0xff66, 0xffbe, 0xffc2, 0xffc7, 0xffca, 0xffcf, 0xffd2, 0xffd7, 0xffda, 0xffdc, 0x10300, 0x1031e, 0x10320, 0x10323, 0x10330, 0x1034a, 0x10400, 0x10425, 0x10428, 0x1044d, 0x1d000, 0x1d0f5, 0x1d100, 0x1d126, 0x1d12a, 0x1d166, 0x1d16a, 0x1d172, 0x1d183, 0x1d184, 0x1d18c, 0x1d1a9, 0x1d1ae, 0x1d1dd, 0x1d400, 0x1d454, 0x1d456, 0x1d49c, 0x1d49e, 0x1d49f, 0x1d4a2, 0x1d4a2, 0x1d4a5, 0x1d4a6, 0x1d4a9, 0x1d4ac, 0x1d4ae, 0x1d4b9, 0x1d4bb, 0x1d4bb, 0x1d4bd, 0x1d4c0, 0x1d4c2, 0x1d4c3, 0x1d4c5, 0x1d505, 0x1d507, 0x1d50a, 0x1d50d, 0x1d514, 0x1d516, 0x1d51c, 0x1d51e, 0x1d539, 0x1d53b, 0x1d53e, 0x1d540, 0x1d544, 0x1d546, 0x1d546, 0x1d54a, 0x1d550, 0x1d552, 0x1d6a3, 0x1d6a8, 0x1d7c9, 0x20000, 0x2a6d6, 0x2f800, 0x2fa1d, 0xf0000, 0xffffd, 0x100000, 0x10fffd]; // prettier-ignore-end

        const isBidirectionalL = function isBidirectionalL(character) {
          return inRange(character, bidirectional_l);
        };
        /**
 * non-ASCII space characters [StringPrep, C.1.2] that can be
 * mapped to SPACE (U+0020)
 */

        const mapping2space = isNonASCIISpaceCharacter;
        /**
 * the "commonly mapped to nothing" characters [StringPrep, B.1]
 * that can be mapped to nothing.
 */

        const mapping2nothing = isCommonlyMappedToNothing; // utils

        const getCodePoint = function getCodePoint(character) {
          return character.codePointAt(0);
        };

        const first = function first(x) {
          return x[0];
        };

        const last = function last(x) {
          return x[x.length - 1];
        };
        /**
 * Convert provided string into an array of Unicode Code Points.
 * Based on https://stackoverflow.com/a/21409165/1556249
 * and https://www.npmjs.com/package/code-point-at.
 * @param {string} input
 * @returns {number[]}
 */

        function toCodePoints(input) {
          const codepoints = [];
          const size = input.length;

          for (let i = 0; i < size; i += 1) {
            const before = input.charCodeAt(i);

            if (before >= 0xd800 && before <= 0xdbff && size > i + 1) {
              const next = input.charCodeAt(i + 1);

              if (next >= 0xdc00 && next <= 0xdfff) {
                codepoints.push((before - 0xd800) * 0x400 + next - 0xdc00 + 0x10000);
                i += 1;
                continue;
              }
            }

            codepoints.push(before);
          }

          return codepoints;
        }
        /**
 * SASLprep.
 * @param {string} input
 * @param {Object} opts
 * @param {boolean} opts.allowUnassigned
 * @returns {string}
 */

        function saslprep(input) {
          const opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          if (typeof input !== 'string') {
            throw new TypeError('Expected string.');
          }

          if (input.length === 0) {
            return '';
          } // 1. Map

          const mapped_input = toCodePoints(input) // 1.1 mapping to space
            .map((character) => (mapping2space(character) ? 0x20 : character)) // 1.2 mapping to nothing
            .filter((character) => !mapping2nothing(character)); // 2. Normalize

          const normalized_input = String.fromCodePoint.apply(null, mapped_input).normalize('NFKC');
          const normalized_map = toCodePoints(normalized_input); // 3. Prohibit

          const hasProhibited = normalized_map.some(isProhibitedCharacter);

          if (hasProhibited) {
            throw new Error('Prohibited character, see https://tools.ietf.org/html/rfc4013#section-2.3');
          } // Unassigned Code Points

          if (opts.allowUnassigned !== true) {
            const hasUnassigned = normalized_map.some(isUnassignedCodePoint);

            if (hasUnassigned) {
              throw new Error('Unassigned code point, see https://tools.ietf.org/html/rfc4013#section-2.5');
            }
          } // 4. check bidi

          const hasBidiRAL = normalized_map.some(isBidirectionalRAL);
          const hasBidiL = normalized_map.some(isBidirectionalL); // 4.1 If a string contains any RandALCat character, the string MUST NOT
          // contain any LCat character.

          if (hasBidiRAL && hasBidiL) {
            throw new Error('String must not contain RandALCat and LCat at the same time,' + ' see https://tools.ietf.org/html/rfc3454#section-6');
          }
          /**
   * 4.2 If a string contains any RandALCat character, a RandALCat
   * character MUST be the first character of the string, and a
   * RandALCat character MUST be the last character of the string.
   */

          const isFirstBidiRAL = isBidirectionalRAL(getCodePoint(first(normalized_input)));
          const isLastBidiRAL = isBidirectionalRAL(getCodePoint(last(normalized_input)));

          if (hasBidiRAL && !(isFirstBidiRAL && isLastBidiRAL)) {
            throw new Error('Bidirectional RandALCat character must be the first and the last' + ' character of the string, see https://tools.ietf.org/html/rfc3454#section-6');
          }

          return normalized_input;
        }

        const PDFSecurity = /* #__PURE__ */(function () {
          _createClass(PDFSecurity, null, [{
            key: 'generateFileID',
            value: function generateFileID() {
              const info = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              let infoStr = ''.concat(info.CreationDate.getTime(), '\n');

              for (const key in info) {
                // eslint-disable-next-line no-prototype-builtins
                if (!info.hasOwnProperty(key)) {
                  continue;
                }

                infoStr += ''.concat(key, ': ').concat(info[key].valueOf(), '\n');
              }

              return wordArrayToBuffer(_cryptoJs.default.MD5(infoStr));
            },
          }, {
            key: 'generateRandomWordArray',
            value: function generateRandomWordArray(bytes) {
              return _cryptoJs.default.lib.WordArray.random(bytes);
            },
          }, {
            key: 'create',
            value: function create(document) {
              const options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

              if (!options.ownerPassword && !options.userPassword) {
                return null;
              }

              return new PDFSecurity(document, options);
            },
          }]);

          function PDFSecurity(document) {
            const options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            _classCallCheck(this, PDFSecurity);

            if (!options.ownerPassword && !options.userPassword) {
              throw new Error('None of owner password and user password is defined.');
            }

            this.document = document;

            this._setupEncryption(options);
          }

          _createClass(PDFSecurity, [{
            key: '_setupEncryption',
            value: function _setupEncryption(options) {
              switch (options.pdfVersion) {
                case '1.4':
                case '1.5':
                  this.version = 2;
                  break;

                case '1.6':
                case '1.7':
                  this.version = 4;
                  break;

                case '1.7ext3':
                  this.version = 5;
                  break;

                default:
                  this.version = 1;
                  break;
              }

              const encDict = {
                Filter: 'Standard',
              };

              switch (this.version) {
                case 1:
                case 2:
                case 4:
                  this._setupEncryptionV1V2V4(this.version, encDict, options);

                  break;

                case 5:
                  this._setupEncryptionV5(encDict, options);

                  break;
              }

              this.dictionary = this.document.ref(encDict);
            },
          }, {
            key: '_setupEncryptionV1V2V4',
            value: function _setupEncryptionV1V2V4(v, encDict, options) {
              let r; let
                permissions;

              switch (v) {
                case 1:
                  r = 2;
                  this.keyBits = 40;
                  permissions = getPermissionsR2(options.permissions);
                  break;

                case 2:
                  r = 3;
                  this.keyBits = 128;
                  permissions = getPermissionsR3(options.permissions);
                  break;

                case 4:
                  r = 4;
                  this.keyBits = 128;
                  permissions = getPermissionsR3(options.permissions);
                  break;
              }

              const paddedUserPassword = processPasswordR2R3R4(options.userPassword);
              const paddedOwnerPassword = options.ownerPassword ? processPasswordR2R3R4(options.ownerPassword) : paddedUserPassword;
              const ownerPasswordEntry = getOwnerPasswordR2R3R4(r, this.keyBits, paddedUserPassword, paddedOwnerPassword);
              this.encryptionKey = getEncryptionKeyR2R3R4(r, this.keyBits, this.document._id, paddedUserPassword, ownerPasswordEntry, permissions);
              let userPasswordEntry;

              if (r === 2) {
                userPasswordEntry = getUserPasswordR2(this.encryptionKey);
              } else {
                userPasswordEntry = getUserPasswordR3R4(this.document._id, this.encryptionKey);
              }

              encDict.V = v;

              if (v >= 2) {
                encDict.Length = this.keyBits;
              }

              if (v === 4) {
                encDict.CF = {
                  StdCF: {
                    AuthEvent: 'DocOpen',
                    CFM: 'AESV2',
                    Length: this.keyBits / 8,
                  },
                };
                encDict.StmF = 'StdCF';
                encDict.StrF = 'StdCF';
              }

              encDict.R = r;
              encDict.O = wordArrayToBuffer(ownerPasswordEntry);
              encDict.U = wordArrayToBuffer(userPasswordEntry);
              encDict.P = permissions;
            },
          }, {
            key: '_setupEncryptionV5',
            value: function _setupEncryptionV5(encDict, options) {
              this.keyBits = 256;
              const permissions = getPermissionsR3(options.permissions);
              const processedUserPassword = processPasswordR5(options.userPassword);
              const processedOwnerPassword = options.ownerPassword ? processPasswordR5(options.ownerPassword) : processedUserPassword;
              this.encryptionKey = getEncryptionKeyR5(PDFSecurity.generateRandomWordArray);
              const userPasswordEntry = getUserPasswordR5(processedUserPassword, PDFSecurity.generateRandomWordArray);

              const userKeySalt = _cryptoJs.default.lib.WordArray.create(userPasswordEntry.words.slice(10, 12), 8);

              const userEncryptionKeyEntry = getUserEncryptionKeyR5(processedUserPassword, userKeySalt, this.encryptionKey);
              const ownerPasswordEntry = getOwnerPasswordR5(processedOwnerPassword, userPasswordEntry, PDFSecurity.generateRandomWordArray);

              const ownerKeySalt = _cryptoJs.default.lib.WordArray.create(ownerPasswordEntry.words.slice(10, 12), 8);

              const ownerEncryptionKeyEntry = getOwnerEncryptionKeyR5(processedOwnerPassword, ownerKeySalt, userPasswordEntry, this.encryptionKey);
              const permsEntry = getEncryptedPermissionsR5(permissions, this.encryptionKey, PDFSecurity.generateRandomWordArray);
              encDict.V = 5;
              encDict.Length = this.keyBits;
              encDict.CF = {
                StdCF: {
                  AuthEvent: 'DocOpen',
                  CFM: 'AESV3',
                  Length: this.keyBits / 8,
                },
              };
              encDict.StmF = 'StdCF';
              encDict.StrF = 'StdCF';
              encDict.R = 5;
              encDict.O = wordArrayToBuffer(ownerPasswordEntry);
              encDict.OE = wordArrayToBuffer(ownerEncryptionKeyEntry);
              encDict.U = wordArrayToBuffer(userPasswordEntry);
              encDict.UE = wordArrayToBuffer(userEncryptionKeyEntry);
              encDict.P = permissions;
              encDict.Perms = wordArrayToBuffer(permsEntry);
            },
          }, {
            key: 'getEncryptFn',
            value: function getEncryptFn(obj, gen) {
              let digest;

              if (this.version < 5) {
                digest = this.encryptionKey.clone().concat(_cryptoJs.default.lib.WordArray.create([(obj & 0xff) << 24 | (obj & 0xff00) << 8 | obj >> 8 & 0xff00 | gen & 0xff, (gen & 0xff00) << 16], 5));
              }

              if (this.version === 1 || this.version === 2) {
                const _key = _cryptoJs.default.MD5(digest);

                _key.sigBytes = Math.min(16, this.keyBits / 8 + 5);
                return function (buffer) {
                  return wordArrayToBuffer(_cryptoJs.default.RC4.encrypt(_cryptoJs.default.lib.WordArray.create(buffer), _key).ciphertext);
                };
              }

              let key;

              if (this.version === 4) {
                key = _cryptoJs.default.MD5(digest.concat(_cryptoJs.default.lib.WordArray.create([0x73416c54], 4)));
              } else {
                key = this.encryptionKey;
              }

              const iv = PDFSecurity.generateRandomWordArray(16);
              const options = {
                mode: _cryptoJs.default.mode.CBC,
                padding: _cryptoJs.default.pad.Pkcs7,
                iv,
              };
              return function (buffer) {
                return wordArrayToBuffer(iv.clone().concat(_cryptoJs.default.AES.encrypt(_cryptoJs.default.lib.WordArray.create(buffer), key, options).ciphertext));
              };
            },
          }, {
            key: 'end',
            value: function end() {
              this.dictionary.end();
            },
          }]);

          return PDFSecurity;
        }());

        function getPermissionsR2() {
          const permissionObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          let permissions = 0xffffffc0 >> 0;

          if (permissionObject.printing) {
            permissions |= 4;
          }

          if (permissionObject.modifying) {
            permissions |= 8;
          }

          if (permissionObject.copying) {
            permissions |= 16;
          }

          if (permissionObject.annotating) {
            permissions |= 32;
          }

          return permissions;
        }

        function getPermissionsR3() {
          const permissionObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          let permissions = 0xfffff0c0 >> 0;

          if (permissionObject.printing === 'lowResolution') {
            permissions |= 4;
          }

          if (permissionObject.printing === 'highResolution') {
            permissions |= 2052;
          }

          if (permissionObject.modifying) {
            permissions |= 8;
          }

          if (permissionObject.copying) {
            permissions |= 16;
          }

          if (permissionObject.annotating) {
            permissions |= 32;
          }

          if (permissionObject.fillingForms) {
            permissions |= 256;
          }

          if (permissionObject.contentAccessibility) {
            permissions |= 512;
          }

          if (permissionObject.documentAssembly) {
            permissions |= 1024;
          }

          return permissions;
        }

        function getUserPasswordR2(encryptionKey) {
          return _cryptoJs.default.RC4.encrypt(processPasswordR2R3R4(), encryptionKey).ciphertext;
        }

        function getUserPasswordR3R4(documentId, encryptionKey) {
          const key = encryptionKey.clone();

          let cipher = _cryptoJs.default.MD5(processPasswordR2R3R4().concat(_cryptoJs.default.lib.WordArray.create(documentId)));

          for (let i = 0; i < 20; i++) {
            const xorRound = Math.ceil(key.sigBytes / 4);

            for (let j = 0; j < xorRound; j++) {
              key.words[j] = encryptionKey.words[j] ^ (i | i << 8 | i << 16 | i << 24);
            }

            cipher = _cryptoJs.default.RC4.encrypt(cipher, key).ciphertext;
          }

          return cipher.concat(_cryptoJs.default.lib.WordArray.create(null, 16));
        }

        function getOwnerPasswordR2R3R4(r, keyBits, paddedUserPassword, paddedOwnerPassword) {
          let digest = paddedOwnerPassword;
          let round = r >= 3 ? 51 : 1;

          for (let i = 0; i < round; i++) {
            digest = _cryptoJs.default.MD5(digest);
          }

          const key = digest.clone();
          key.sigBytes = keyBits / 8;
          let cipher = paddedUserPassword;
          round = r >= 3 ? 20 : 1;

          for (let _i = 0; _i < round; _i++) {
            const xorRound = Math.ceil(key.sigBytes / 4);

            for (let j = 0; j < xorRound; j++) {
              key.words[j] = digest.words[j] ^ (_i | _i << 8 | _i << 16 | _i << 24);
            }

            cipher = _cryptoJs.default.RC4.encrypt(cipher, key).ciphertext;
          }

          return cipher;
        }

        function getEncryptionKeyR2R3R4(r, keyBits, documentId, paddedUserPassword, ownerPasswordEntry, permissions) {
          let key = paddedUserPassword.clone().concat(ownerPasswordEntry).concat(_cryptoJs.default.lib.WordArray.create([lsbFirstWord(permissions)], 4)).concat(_cryptoJs.default.lib.WordArray.create(documentId));
          const round = r >= 3 ? 51 : 1;

          for (let i = 0; i < round; i++) {
            key = _cryptoJs.default.MD5(key);
            key.sigBytes = keyBits / 8;
          }

          return key;
        }

        function getUserPasswordR5(processedUserPassword, generateRandomWordArray) {
          const validationSalt = generateRandomWordArray(8);
          const keySalt = generateRandomWordArray(8);
          return _cryptoJs.default.SHA256(processedUserPassword.clone().concat(validationSalt)).concat(validationSalt).concat(keySalt);
        }

        function getUserEncryptionKeyR5(processedUserPassword, userKeySalt, encryptionKey) {
          const key = _cryptoJs.default.SHA256(processedUserPassword.clone().concat(userKeySalt));

          const options = {
            mode: _cryptoJs.default.mode.CBC,
            padding: _cryptoJs.default.pad.NoPadding,
            iv: _cryptoJs.default.lib.WordArray.create(null, 16),
          };
          return _cryptoJs.default.AES.encrypt(encryptionKey, key, options).ciphertext;
        }

        function getOwnerPasswordR5(processedOwnerPassword, userPasswordEntry, generateRandomWordArray) {
          const validationSalt = generateRandomWordArray(8);
          const keySalt = generateRandomWordArray(8);
          return _cryptoJs.default.SHA256(processedOwnerPassword.clone().concat(validationSalt).concat(userPasswordEntry)).concat(validationSalt).concat(keySalt);
        }

        function getOwnerEncryptionKeyR5(processedOwnerPassword, ownerKeySalt, userPasswordEntry, encryptionKey) {
          const key = _cryptoJs.default.SHA256(processedOwnerPassword.clone().concat(ownerKeySalt).concat(userPasswordEntry));

          const options = {
            mode: _cryptoJs.default.mode.CBC,
            padding: _cryptoJs.default.pad.NoPadding,
            iv: _cryptoJs.default.lib.WordArray.create(null, 16),
          };
          return _cryptoJs.default.AES.encrypt(encryptionKey, key, options).ciphertext;
        }

        function getEncryptionKeyR5(generateRandomWordArray) {
          return generateRandomWordArray(32);
        }

        function getEncryptedPermissionsR5(permissions, encryptionKey, generateRandomWordArray) {
          const cipher = _cryptoJs.default.lib.WordArray.create([lsbFirstWord(permissions), 0xffffffff, 0x54616462], 12).concat(generateRandomWordArray(4));

          const options = {
            mode: _cryptoJs.default.mode.ECB,
            padding: _cryptoJs.default.pad.NoPadding,
          };
          return _cryptoJs.default.AES.encrypt(cipher, encryptionKey, options).ciphertext;
        }

        function processPasswordR2R3R4() {
          const password = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
          const out = Buffer.alloc(32);
          const { length } = password;
          let index = 0;

          while (index < length && index < 32) {
            const code = password.charCodeAt(index);

            if (code > 0xff) {
              throw new Error('Password contains one or more invalid characters.');
            }

            out[index] = code;
            index++;
          }

          while (index < 32) {
            out[index] = PASSWORD_PADDING[index - length];
            index++;
          }

          return _cryptoJs.default.lib.WordArray.create(out);
        }

        function processPasswordR5() {
          let password = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
          password = unescape(encodeURIComponent(saslprep(password)));
          const length = Math.min(127, password.length);
          const out = Buffer.alloc(length);

          for (let i = 0; i < length; i++) {
            out[i] = password.charCodeAt(i);
          }

          return _cryptoJs.default.lib.WordArray.create(out);
        }

        function lsbFirstWord(data) {
          return (data & 0xff) << 24 | (data & 0xff00) << 8 | data >> 8 & 0xff00 | data >> 24 & 0xff;
        }

        function wordArrayToBuffer(wordArray) {
          const byteArray = [];

          for (let i = 0; i < wordArray.sigBytes; i++) {
            byteArray.push(wordArray.words[Math.floor(i / 4)] >> 8 * (3 - i % 4) & 0xff);
          }

          return Buffer.from(byteArray);
        }

        var PASSWORD_PADDING = [0x28, 0xbf, 0x4e, 0x5e, 0x4e, 0x75, 0x8a, 0x41, 0x64, 0x00, 0x4e, 0x56, 0xff, 0xfa, 0x01, 0x08, 0x2e, 0x2e, 0x00, 0xb6, 0xd0, 0x68, 0x3e, 0x80, 0x2f, 0x0c, 0xa9, 0xfe, 0x64, 0x53, 0x69, 0x7a];
        const { number } = PDFObject;

        const PDFGradient = /* #__PURE__ */(function () {
          function PDFGradient(doc) {
            _classCallCheck(this, PDFGradient);

            this.doc = doc;
            this.stops = [];
            this.embedded = false;
            this.transform = [1, 0, 0, 1, 0, 0];
          }

          _createClass(PDFGradient, [{
            key: 'stop',
            value: function stop(pos, color, opacity) {
              if (opacity == null) {
                opacity = 1;
              }

              color = this.doc._normalizeColor(color);

              if (this.stops.length === 0) {
                if (color.length === 3) {
                  this._colorSpace = 'DeviceRGB';
                } else if (color.length === 4) {
                  this._colorSpace = 'DeviceCMYK';
                } else if (color.length === 1) {
                  this._colorSpace = 'DeviceGray';
                } else {
                  throw new Error('Unknown color space');
                }
              } else if (this._colorSpace === 'DeviceRGB' && color.length !== 3 || this._colorSpace === 'DeviceCMYK' && color.length !== 4 || this._colorSpace === 'DeviceGray' && color.length !== 1) {
                throw new Error('All gradient stops must use the same color space');
              }

              opacity = Math.max(0, Math.min(1, opacity));
              this.stops.push([pos, color, opacity]);
              return this;
            },
          }, {
            key: 'setTransform',
            value: function setTransform(m11, m12, m21, m22, dx, dy) {
              this.transform = [m11, m12, m21, m22, dx, dy];
              return this;
            },
          }, {
            key: 'embed',
            value: function embed(m) {
              let fn;
              const stopsLength = this.stops.length;

              if (stopsLength === 0) {
                return;
              }

              this.embedded = true;
              this.matrix = m; // if the last stop comes before 100%, add a copy at 100%

              const last = this.stops[stopsLength - 1];

              if (last[0] < 1) {
                this.stops.push([1, last[1], last[2]]);
              }

              const bounds = [];
              const encode = [];
              const stops = [];

              for (let i = 0; i < stopsLength - 1; i++) {
                encode.push(0, 1);

                if (i + 2 !== stopsLength) {
                  bounds.push(this.stops[i + 1][0]);
                }

                fn = this.doc.ref({
                  FunctionType: 2,
                  Domain: [0, 1],
                  C0: this.stops[i + 0][1],
                  C1: this.stops[i + 1][1],
                  N: 1,
                });
                stops.push(fn);
                fn.end();
              } // if there are only two stops, we don't need a stitching function

              if (stopsLength === 1) {
                fn = stops[0];
              } else {
                fn = this.doc.ref({
                  FunctionType: 3,
                  // stitching function
                  Domain: [0, 1],
                  Functions: stops,
                  Bounds: bounds,
                  Encode: encode,
                });
                fn.end();
              }

              this.id = 'Sh'.concat(++this.doc._gradCount);
              const shader = this.shader(fn);
              shader.end();
              const pattern = this.doc.ref({
                Type: 'Pattern',
                PatternType: 2,
                Shading: shader,
                Matrix: this.matrix.map(number),
              });
              pattern.end();

              if (this.stops.some((stop) => stop[2] < 1)) {
                let grad = this.opacityGradient();
                grad._colorSpace = 'DeviceGray';

                const _iterator = _createForOfIteratorHelper(this.stops);
                let _step;

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    const stop = _step.value;
                    grad.stop(stop[0], [stop[2]]);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                grad = grad.embed(this.matrix);
                const pageBBox = [0, 0, this.doc.page.width, this.doc.page.height];
                const form = this.doc.ref({
                  Type: 'XObject',
                  Subtype: 'Form',
                  FormType: 1,
                  BBox: pageBBox,
                  Group: {
                    Type: 'Group',
                    S: 'Transparency',
                    CS: 'DeviceGray',
                  },
                  Resources: {
                    ProcSet: ['PDF', 'Text', 'ImageB', 'ImageC', 'ImageI'],
                    Pattern: {
                      Sh1: grad,
                    },
                  },
                });
                form.write('/Pattern cs /Sh1 scn');
                form.end(''.concat(pageBBox.join(' '), ' re f'));
                const gstate = this.doc.ref({
                  Type: 'ExtGState',
                  SMask: {
                    Type: 'Mask',
                    S: 'Luminosity',
                    G: form,
                  },
                });
                gstate.end();
                const opacityPattern = this.doc.ref({
                  Type: 'Pattern',
                  PatternType: 1,
                  PaintType: 1,
                  TilingType: 2,
                  BBox: pageBBox,
                  XStep: pageBBox[2],
                  YStep: pageBBox[3],
                  Resources: {
                    ProcSet: ['PDF', 'Text', 'ImageB', 'ImageC', 'ImageI'],
                    Pattern: {
                      Sh1: pattern,
                    },
                    ExtGState: {
                      Gs1: gstate,
                    },
                  },
                });
                opacityPattern.write('/Gs1 gs /Pattern cs /Sh1 scn');
                opacityPattern.end(''.concat(pageBBox.join(' '), ' re f'));
                this.doc.page.patterns[this.id] = opacityPattern;
              } else {
                this.doc.page.patterns[this.id] = pattern;
              }

              return pattern;
            },
          }, {
            key: 'apply',
            value: function apply(stroke) {
              // apply gradient transform to existing document ctm
              const _this$doc$_ctm = _slicedToArray(this.doc._ctm, 6);
              const m0 = _this$doc$_ctm[0];
              const m1 = _this$doc$_ctm[1];
              const m2 = _this$doc$_ctm[2];
              const m3 = _this$doc$_ctm[3];
              const m4 = _this$doc$_ctm[4];
              const m5 = _this$doc$_ctm[5];

              const _this$transform = _slicedToArray(this.transform, 6);
              const m11 = _this$transform[0];
              const m12 = _this$transform[1];
              const m21 = _this$transform[2];
              const m22 = _this$transform[3];
              const dx = _this$transform[4];
              const dy = _this$transform[5];

              const m = [m0 * m11 + m2 * m12, m1 * m11 + m3 * m12, m0 * m21 + m2 * m22, m1 * m21 + m3 * m22, m0 * dx + m2 * dy + m4, m1 * dx + m3 * dy + m5];

              if (!this.embedded || m.join(' ') !== this.matrix.join(' ')) {
                this.embed(m);
              }

              this.doc._setColorSpace('Pattern', stroke);

              const op = stroke ? 'SCN' : 'scn';
              return this.doc.addContent('/'.concat(this.id, ' ').concat(op));
            },
          }]);

          return PDFGradient;
        }());

        const PDFLinearGradient = /* #__PURE__ */(function (_PDFGradient) {
          _inherits(PDFLinearGradient, _PDFGradient);

          const _super = _createSuper(PDFLinearGradient);

          function PDFLinearGradient(doc, x1, y1, x2, y2) {
            let _this;

            _classCallCheck(this, PDFLinearGradient);

            _this = _super.call(this, doc);
            _this.x1 = x1;
            _this.y1 = y1;
            _this.x2 = x2;
            _this.y2 = y2;
            return _this;
          }

          _createClass(PDFLinearGradient, [{
            key: 'shader',
            value: function shader(fn) {
              return this.doc.ref({
                ShadingType: 2,
                ColorSpace: this._colorSpace,
                Coords: [this.x1, this.y1, this.x2, this.y2],
                Function: fn,
                Extend: [true, true],
              });
            },
          }, {
            key: 'opacityGradient',
            value: function opacityGradient() {
              return new PDFLinearGradient(this.doc, this.x1, this.y1, this.x2, this.y2);
            },
          }]);

          return PDFLinearGradient;
        }(PDFGradient));

        const PDFRadialGradient = /* #__PURE__ */(function (_PDFGradient2) {
          _inherits(PDFRadialGradient, _PDFGradient2);

          const _super2 = _createSuper(PDFRadialGradient);

          function PDFRadialGradient(doc, x1, y1, r1, x2, y2, r2) {
            let _this2;

            _classCallCheck(this, PDFRadialGradient);

            _this2 = _super2.call(this, doc);
            _this2.doc = doc;
            _this2.x1 = x1;
            _this2.y1 = y1;
            _this2.r1 = r1;
            _this2.x2 = x2;
            _this2.y2 = y2;
            _this2.r2 = r2;
            return _this2;
          }

          _createClass(PDFRadialGradient, [{
            key: 'shader',
            value: function shader(fn) {
              return this.doc.ref({
                ShadingType: 3,
                ColorSpace: this._colorSpace,
                Coords: [this.x1, this.y1, this.r1, this.x2, this.y2, this.r2],
                Function: fn,
                Extend: [true, true],
              });
            },
          }, {
            key: 'opacityGradient',
            value: function opacityGradient() {
              return new PDFRadialGradient(this.doc, this.x1, this.y1, this.r1, this.x2, this.y2, this.r2);
            },
          }]);

          return PDFRadialGradient;
        }(PDFGradient));

        const Gradient = {
          PDFGradient,
          PDFLinearGradient,
          PDFRadialGradient,
        };
        /*
PDF tiling pattern support. Uncolored only.
 */

        const underlyingColorSpaces = ['DeviceCMYK', 'DeviceRGB'];

        const PDFTilingPattern = /* #__PURE__ */(function () {
          function PDFTilingPattern(doc, bBox, xStep, yStep, stream) {
            _classCallCheck(this, PDFTilingPattern);

            this.doc = doc;
            this.bBox = bBox;
            this.xStep = xStep;
            this.yStep = yStep;
            this.stream = stream;
          }

          _createClass(PDFTilingPattern, [{
            key: 'createPattern',
            value: function createPattern() {
              // no resources needed for our current usage
              // required entry
              const resources = this.doc.ref();
              resources.end(); // apply default transform matrix (flipped in the default doc._ctm)
              // see document.js & gradient.js

              const _this$doc$_ctm = _slicedToArray(this.doc._ctm, 6);
              const m0 = _this$doc$_ctm[0];
              const m1 = _this$doc$_ctm[1];
              const m2 = _this$doc$_ctm[2];
              const m3 = _this$doc$_ctm[3];
              const m4 = _this$doc$_ctm[4];
              const m5 = _this$doc$_ctm[5];

              const m11 = 1;
              const m12 = 0;
              const m21 = 0;
              const m22 = 1;
              const dx = 0;
              const dy = 0;
              const m = [m0 * m11 + m2 * m12, m1 * m11 + m3 * m12, m0 * m21 + m2 * m22, m1 * m21 + m3 * m22, m0 * dx + m2 * dy + m4, m1 * dx + m3 * dy + m5];
              const pattern = this.doc.ref({
                Type: 'Pattern',
                PatternType: 1,
                // tiling
                PaintType: 2,
                // 1-colored, 2-uncolored
                TilingType: 2,
                // 2-no distortion
                BBox: this.bBox,
                XStep: this.xStep,
                YStep: this.yStep,
                Matrix: m.map((v) => +v.toFixed(5)),
                Resources: resources,
              });
              pattern.end(this.stream);
              return pattern;
            },
          }, {
            key: 'embedPatternColorSpaces',
            value: function embedPatternColorSpaces() {
              const _this = this; // map each pattern to an underlying color space
              // and embed on each page

              underlyingColorSpaces.forEach((csName) => {
                const csId = _this.getPatternColorSpaceId(csName);

                if (_this.doc.page.colorSpaces[csId]) return;

                const cs = _this.doc.ref(['Pattern', csName]);

                cs.end();
                _this.doc.page.colorSpaces[csId] = cs;
              });
            },
          }, {
            key: 'getPatternColorSpaceId',
            value: function getPatternColorSpaceId(underlyingColorspace) {
              return 'CsP'.concat(underlyingColorspace);
            },
          }, {
            key: 'embed',
            value: function embed() {
              if (!this.id) {
                this.doc._patternCount = this.doc._patternCount + 1;
                this.id = `P${this.doc._patternCount}`;
                this.pattern = this.createPattern();
              } // patterns are embedded in each page

              if (!this.doc.page.patterns[this.id]) {
                this.doc.page.patterns[this.id] = this.pattern;
              }
            },
          }, {
            key: 'apply',
            value: function apply(stroke, patternColor) {
              // do any embedding/creating that might be needed
              this.embedPatternColorSpaces();
              this.embed();

              const normalizedColor = this.doc._normalizeColor(patternColor);

              if (!normalizedColor) throw Error('invalid pattern color. (value: '.concat(patternColor, ')')); // select one of the pattern color spaces

              const csId = this.getPatternColorSpaceId(this.doc._getColorSpace(normalizedColor));

              this.doc._setColorSpace(csId, stroke); // stroke/fill using the pattern and color (in the above underlying color space)

              const op = stroke ? 'SCN' : 'scn';
              return this.doc.addContent(''.concat(normalizedColor.join(' '), ' /').concat(this.id, ' ').concat(op));
            },
          }]);

          return PDFTilingPattern;
        }());

        const pattern = {
          PDFTilingPattern,
        };
        const PDFGradient$1 = Gradient.PDFGradient;
        const PDFLinearGradient$1 = Gradient.PDFLinearGradient;
        const PDFRadialGradient$1 = Gradient.PDFRadialGradient;
        const PDFTilingPattern$1 = pattern.PDFTilingPattern;
        const ColorMixin = {
          initColor: function initColor() {
            // The opacity dictionaries
            this._opacityRegistry = {};
            this._opacityCount = 0;
            this._patternCount = 0;
            return this._gradCount = 0;
          },
          _normalizeColor: function _normalizeColor(color) {
            if (typeof color === 'string') {
              if (color.charAt(0) === '#') {
                if (color.length === 4) {
                  color = color.replace(/#([0-9A-F])([0-9A-F])([0-9A-F])/i, '#$1$1$2$2$3$3');
                }

                const hex = parseInt(color.slice(1), 16);
                color = [hex >> 16, hex >> 8 & 0xff, hex & 0xff];
              } else if (namedColors[color]) {
                color = namedColors[color];
              }
            }

            if (Array.isArray(color)) {
              // RGB
              if (color.length === 3) {
                color = color.map((part) => part / 255); // CMYK
              } else if (color.length === 4) {
                color = color.map((part) => part / 100);
              }

              return color;
            }

            return null;
          },
          _setColor: function _setColor(color, stroke) {
            if (color instanceof PDFGradient$1) {
              color.apply(stroke);
              return true; // see if tiling pattern, decode & apply it it
            } if (Array.isArray(color) && color[0] instanceof PDFTilingPattern$1) {
              color[0].apply(stroke, color[1]);
              return true;
            } // any other case should be a normal color and not a pattern

            return this._setColorCore(color, stroke);
          },
          _setColorCore: function _setColorCore(color, stroke) {
            color = this._normalizeColor(color);

            if (!color) {
              return false;
            }

            const op = stroke ? 'SCN' : 'scn';

            const space = this._getColorSpace(color);

            this._setColorSpace(space, stroke);

            color = color.join(' ');
            this.addContent(''.concat(color, ' ').concat(op));
            return true;
          },
          _setColorSpace: function _setColorSpace(space, stroke) {
            const op = stroke ? 'CS' : 'cs';
            return this.addContent('/'.concat(space, ' ').concat(op));
          },
          _getColorSpace: function _getColorSpace(color) {
            return color.length === 4 ? 'DeviceCMYK' : 'DeviceRGB';
          },
          fillColor: function fillColor(color, opacity) {
            const set = this._setColor(color, false);

            if (set) {
              this.fillOpacity(opacity);
            } // save this for text wrapper, which needs to reset
            // the fill color on new pages

            this._fillColor = [color, opacity];
            return this;
          },
          strokeColor: function strokeColor(color, opacity) {
            const set = this._setColor(color, true);

            if (set) {
              this.strokeOpacity(opacity);
            }

            return this;
          },
          opacity: function opacity(_opacity) {
            this._doOpacity(_opacity, _opacity);

            return this;
          },
          fillOpacity: function fillOpacity(opacity) {
            this._doOpacity(opacity, null);

            return this;
          },
          strokeOpacity: function strokeOpacity(opacity) {
            this._doOpacity(null, opacity);

            return this;
          },
          _doOpacity: function _doOpacity(fillOpacity, strokeOpacity) {
            let dictionary; let
              name;

            if (fillOpacity == null && strokeOpacity == null) {
              return;
            }

            if (fillOpacity != null) {
              fillOpacity = Math.max(0, Math.min(1, fillOpacity));
            }

            if (strokeOpacity != null) {
              strokeOpacity = Math.max(0, Math.min(1, strokeOpacity));
            }

            const key = ''.concat(fillOpacity, '_').concat(strokeOpacity);

            if (this._opacityRegistry[key]) {
              const _this$_opacityRegistr = _slicedToArray(this._opacityRegistry[key], 2);

              dictionary = _this$_opacityRegistr[0];
              name = _this$_opacityRegistr[1];
            } else {
              dictionary = {
                Type: 'ExtGState',
              };

              if (fillOpacity != null) {
                dictionary.ca = fillOpacity;
              }

              if (strokeOpacity != null) {
                dictionary.CA = strokeOpacity;
              }

              dictionary = this.ref(dictionary);
              dictionary.end();
              const id = ++this._opacityCount;
              name = 'Gs'.concat(id);
              this._opacityRegistry[key] = [dictionary, name];
            }

            this.page.ext_gstates[name] = dictionary;
            return this.addContent('/'.concat(name, ' gs'));
          },
          linearGradient: function linearGradient(x1, y1, x2, y2) {
            return new PDFLinearGradient$1(this, x1, y1, x2, y2);
          },
          radialGradient: function radialGradient(x1, y1, r1, x2, y2, r2) {
            return new PDFRadialGradient$1(this, x1, y1, r1, x2, y2, r2);
          },
          pattern: function pattern(bbox, xStep, yStep, stream) {
            return new PDFTilingPattern$1(this, bbox, xStep, yStep, stream);
          },
        };
        var namedColors = {
          aliceblue: [240, 248, 255],
          antiquewhite: [250, 235, 215],
          aqua: [0, 255, 255],
          aquamarine: [127, 255, 212],
          azure: [240, 255, 255],
          beige: [245, 245, 220],
          bisque: [255, 228, 196],
          black: [0, 0, 0],
          blanchedalmond: [255, 235, 205],
          blue: [0, 0, 255],
          blueviolet: [138, 43, 226],
          brown: [165, 42, 42],
          burlywood: [222, 184, 135],
          cadetblue: [95, 158, 160],
          chartreuse: [127, 255, 0],
          chocolate: [210, 105, 30],
          coral: [255, 127, 80],
          cornflowerblue: [100, 149, 237],
          cornsilk: [255, 248, 220],
          crimson: [220, 20, 60],
          cyan: [0, 255, 255],
          darkblue: [0, 0, 139],
          darkcyan: [0, 139, 139],
          darkgoldenrod: [184, 134, 11],
          darkgray: [169, 169, 169],
          darkgreen: [0, 100, 0],
          darkgrey: [169, 169, 169],
          darkkhaki: [189, 183, 107],
          darkmagenta: [139, 0, 139],
          darkolivegreen: [85, 107, 47],
          darkorange: [255, 140, 0],
          darkorchid: [153, 50, 204],
          darkred: [139, 0, 0],
          darksalmon: [233, 150, 122],
          darkseagreen: [143, 188, 143],
          darkslateblue: [72, 61, 139],
          darkslategray: [47, 79, 79],
          darkslategrey: [47, 79, 79],
          darkturquoise: [0, 206, 209],
          darkviolet: [148, 0, 211],
          deeppink: [255, 20, 147],
          deepskyblue: [0, 191, 255],
          dimgray: [105, 105, 105],
          dimgrey: [105, 105, 105],
          dodgerblue: [30, 144, 255],
          firebrick: [178, 34, 34],
          floralwhite: [255, 250, 240],
          forestgreen: [34, 139, 34],
          fuchsia: [255, 0, 255],
          gainsboro: [220, 220, 220],
          ghostwhite: [248, 248, 255],
          gold: [255, 215, 0],
          goldenrod: [218, 165, 32],
          gray: [128, 128, 128],
          grey: [128, 128, 128],
          green: [0, 128, 0],
          greenyellow: [173, 255, 47],
          honeydew: [240, 255, 240],
          hotpink: [255, 105, 180],
          indianred: [205, 92, 92],
          indigo: [75, 0, 130],
          ivory: [255, 255, 240],
          khaki: [240, 230, 140],
          lavender: [230, 230, 250],
          lavenderblush: [255, 240, 245],
          lawngreen: [124, 252, 0],
          lemonchiffon: [255, 250, 205],
          lightblue: [173, 216, 230],
          lightcoral: [240, 128, 128],
          lightcyan: [224, 255, 255],
          lightgoldenrodyellow: [250, 250, 210],
          lightgray: [211, 211, 211],
          lightgreen: [144, 238, 144],
          lightgrey: [211, 211, 211],
          lightpink: [255, 182, 193],
          lightsalmon: [255, 160, 122],
          lightseagreen: [32, 178, 170],
          lightskyblue: [135, 206, 250],
          lightslategray: [119, 136, 153],
          lightslategrey: [119, 136, 153],
          lightsteelblue: [176, 196, 222],
          lightyellow: [255, 255, 224],
          lime: [0, 255, 0],
          limegreen: [50, 205, 50],
          linen: [250, 240, 230],
          magenta: [255, 0, 255],
          maroon: [128, 0, 0],
          mediumaquamarine: [102, 205, 170],
          mediumblue: [0, 0, 205],
          mediumorchid: [186, 85, 211],
          mediumpurple: [147, 112, 219],
          mediumseagreen: [60, 179, 113],
          mediumslateblue: [123, 104, 238],
          mediumspringgreen: [0, 250, 154],
          mediumturquoise: [72, 209, 204],
          mediumvioletred: [199, 21, 133],
          midnightblue: [25, 25, 112],
          mintcream: [245, 255, 250],
          mistyrose: [255, 228, 225],
          moccasin: [255, 228, 181],
          navajowhite: [255, 222, 173],
          navy: [0, 0, 128],
          oldlace: [253, 245, 230],
          olive: [128, 128, 0],
          olivedrab: [107, 142, 35],
          orange: [255, 165, 0],
          orangered: [255, 69, 0],
          orchid: [218, 112, 214],
          palegoldenrod: [238, 232, 170],
          palegreen: [152, 251, 152],
          paleturquoise: [175, 238, 238],
          palevioletred: [219, 112, 147],
          papayawhip: [255, 239, 213],
          peachpuff: [255, 218, 185],
          peru: [205, 133, 63],
          pink: [255, 192, 203],
          plum: [221, 160, 221],
          powderblue: [176, 224, 230],
          purple: [128, 0, 128],
          red: [255, 0, 0],
          rosybrown: [188, 143, 143],
          royalblue: [65, 105, 225],
          saddlebrown: [139, 69, 19],
          salmon: [250, 128, 114],
          sandybrown: [244, 164, 96],
          seagreen: [46, 139, 87],
          seashell: [255, 245, 238],
          sienna: [160, 82, 45],
          silver: [192, 192, 192],
          skyblue: [135, 206, 235],
          slateblue: [106, 90, 205],
          slategray: [112, 128, 144],
          slategrey: [112, 128, 144],
          snow: [255, 250, 250],
          springgreen: [0, 255, 127],
          steelblue: [70, 130, 180],
          tan: [210, 180, 140],
          teal: [0, 128, 128],
          thistle: [216, 191, 216],
          tomato: [255, 99, 71],
          turquoise: [64, 224, 208],
          violet: [238, 130, 238],
          wheat: [245, 222, 179],
          white: [255, 255, 255],
          whitesmoke: [245, 245, 245],
          yellow: [255, 255, 0],
          yellowgreen: [154, 205, 50],
        };
        let cx; let cy; let px; let py; let sx; let
          sy;
        cx = cy = px = py = sx = sy = 0;
        const parameters = {
          A: 7,
          a: 7,
          C: 6,
          c: 6,
          H: 1,
          h: 1,
          L: 2,
          l: 2,
          M: 2,
          m: 2,
          Q: 4,
          q: 4,
          S: 4,
          s: 4,
          T: 2,
          t: 2,
          V: 1,
          v: 1,
          Z: 0,
          z: 0,
        };

        const parse = function parse(path) {
          let cmd;
          const ret = [];
          let args = [];
          let curArg = '';
          let foundDecimal = false;
          let params = 0;

          const _iterator = _createForOfIteratorHelper(path);
          let _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              const c = _step.value;

              if (parameters[c] != null) {
                params = parameters[c];

                if (cmd) {
                  // save existing command
                  if (curArg.length > 0) {
                    args[args.length] = +curArg;
                  }

                  ret[ret.length] = {
                    cmd,
                    args,
                  };
                  args = [];
                  curArg = '';
                  foundDecimal = false;
                }

                cmd = c;
              } else if ([' ', ','].includes(c) || c === '-' && curArg.length > 0 && curArg[curArg.length - 1] !== 'e' || c === '.' && foundDecimal) {
                if (curArg.length === 0) {
                  continue;
                }

                if (args.length === params) {
                  // handle reused commands
                  ret[ret.length] = {
                    cmd,
                    args,
                  };
                  args = [+curArg]; // handle assumed commands

                  if (cmd === 'M') {
                    cmd = 'L';
                  }

                  if (cmd === 'm') {
                    cmd = 'l';
                  }
                } else {
                  args[args.length] = +curArg;
                }

                foundDecimal = c === '.'; // fix for negative numbers or repeated decimals with no delimeter between commands

                curArg = ['-', '.'].includes(c) ? c : '';
              } else {
                curArg += c;

                if (c === '.') {
                  foundDecimal = true;
                }
              }
            } // add the last command
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          if (curArg.length > 0) {
            if (args.length === params) {
              // handle reused commands
              ret[ret.length] = {
                cmd,
                args,
              };
              args = [+curArg]; // handle assumed commands

              if (cmd === 'M') {
                cmd = 'L';
              }

              if (cmd === 'm') {
                cmd = 'l';
              }
            } else {
              args[args.length] = +curArg;
            }
          }

          ret[ret.length] = {
            cmd,
            args,
          };
          return ret;
        };

        const _apply = function apply(commands, doc) {
          // current point, control point, and subpath starting point
          cx = cy = px = py = sx = sy = 0; // run the commands

          for (let i = 0; i < commands.length; i++) {
            const c = commands[i];

            if (typeof runners[c.cmd] === 'function') {
              runners[c.cmd](doc, c.args);
            }
          }
        };

        var runners = {
          M: function M(doc, a) {
            cx = a[0];
            cy = a[1];
            px = py = null;
            sx = cx;
            sy = cy;
            return doc.moveTo(cx, cy);
          },
          m: function m(doc, a) {
            cx += a[0];
            cy += a[1];
            px = py = null;
            sx = cx;
            sy = cy;
            return doc.moveTo(cx, cy);
          },
          C: function C(doc, a) {
            cx = a[4];
            cy = a[5];
            px = a[2];
            py = a[3];
            return doc.bezierCurveTo.apply(doc, _toConsumableArray(a));
          },
          c: function c(doc, a) {
            doc.bezierCurveTo(a[0] + cx, a[1] + cy, a[2] + cx, a[3] + cy, a[4] + cx, a[5] + cy);
            px = cx + a[2];
            py = cy + a[3];
            cx += a[4];
            return cy += a[5];
          },
          S: function S(doc, a) {
            if (px === null) {
              px = cx;
              py = cy;
            }

            doc.bezierCurveTo(cx - (px - cx), cy - (py - cy), a[0], a[1], a[2], a[3]);
            px = a[0];
            py = a[1];
            cx = a[2];
            return cy = a[3];
          },
          s: function s(doc, a) {
            if (px === null) {
              px = cx;
              py = cy;
            }

            doc.bezierCurveTo(cx - (px - cx), cy - (py - cy), cx + a[0], cy + a[1], cx + a[2], cy + a[3]);
            px = cx + a[0];
            py = cy + a[1];
            cx += a[2];
            return cy += a[3];
          },
          Q: function Q(doc, a) {
            px = a[0];
            py = a[1];
            cx = a[2];
            cy = a[3];
            return doc.quadraticCurveTo(a[0], a[1], cx, cy);
          },
          q: function q(doc, a) {
            doc.quadraticCurveTo(a[0] + cx, a[1] + cy, a[2] + cx, a[3] + cy);
            px = cx + a[0];
            py = cy + a[1];
            cx += a[2];
            return cy += a[3];
          },
          T: function T(doc, a) {
            if (px === null) {
              px = cx;
              py = cy;
            } else {
              px = cx - (px - cx);
              py = cy - (py - cy);
            }

            doc.quadraticCurveTo(px, py, a[0], a[1]);
            px = cx - (px - cx);
            py = cy - (py - cy);
            cx = a[0];
            return cy = a[1];
          },
          t: function t(doc, a) {
            if (px === null) {
              px = cx;
              py = cy;
            } else {
              px = cx - (px - cx);
              py = cy - (py - cy);
            }

            doc.quadraticCurveTo(px, py, cx + a[0], cy + a[1]);
            cx += a[0];
            return cy += a[1];
          },
          A: function A(doc, a) {
            solveArc(doc, cx, cy, a);
            cx = a[5];
            return cy = a[6];
          },
          a: function a(doc, _a) {
            _a[5] += cx;
            _a[6] += cy;
            solveArc(doc, cx, cy, _a);
            cx = _a[5];
            return cy = _a[6];
          },
          L: function L(doc, a) {
            cx = a[0];
            cy = a[1];
            px = py = null;
            return doc.lineTo(cx, cy);
          },
          l: function l(doc, a) {
            cx += a[0];
            cy += a[1];
            px = py = null;
            return doc.lineTo(cx, cy);
          },
          H: function H(doc, a) {
            cx = a[0];
            px = py = null;
            return doc.lineTo(cx, cy);
          },
          h: function h(doc, a) {
            cx += a[0];
            px = py = null;
            return doc.lineTo(cx, cy);
          },
          V: function V(doc, a) {
            cy = a[0];
            px = py = null;
            return doc.lineTo(cx, cy);
          },
          v: function v(doc, a) {
            cy += a[0];
            px = py = null;
            return doc.lineTo(cx, cy);
          },
          Z: function Z(doc) {
            doc.closePath();
            cx = sx;
            return cy = sy;
          },
          z: function z(doc) {
            doc.closePath();
            cx = sx;
            return cy = sy;
          },
        };

        var solveArc = function solveArc(doc, x, y, coords) {
          const _coords = _slicedToArray(coords, 7);
          const rx = _coords[0];
          const ry = _coords[1];
          const rot = _coords[2];
          const large = _coords[3];
          const sweep = _coords[4];
          const ex = _coords[5];
          const ey = _coords[6];

          const segs = arcToSegments(ex, ey, rx, ry, large, sweep, rot, x, y);

          const _iterator2 = _createForOfIteratorHelper(segs);
          let _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              const seg = _step2.value;
              const bez = segmentToBezier.apply(void 0, _toConsumableArray(seg));
              doc.bezierCurveTo.apply(doc, _toConsumableArray(bez));
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }; // from Inkscape svgtopdf, thanks!

        var arcToSegments = function arcToSegments(x, y, rx, ry, large, sweep, rotateX, ox, oy) {
          const th = rotateX * (Math.PI / 180);
          const sin_th = Math.sin(th);
          const cos_th = Math.cos(th);
          rx = Math.abs(rx);
          ry = Math.abs(ry);
          px = cos_th * (ox - x) * 0.5 + sin_th * (oy - y) * 0.5;
          py = cos_th * (oy - y) * 0.5 - sin_th * (ox - x) * 0.5;
          let pl = px * px / (rx * rx) + py * py / (ry * ry);

          if (pl > 1) {
            pl = Math.sqrt(pl);
            rx *= pl;
            ry *= pl;
          }

          const a00 = cos_th / rx;
          const a01 = sin_th / rx;
          const a10 = -sin_th / ry;
          const a11 = cos_th / ry;
          const x0 = a00 * ox + a01 * oy;
          const y0 = a10 * ox + a11 * oy;
          const x1 = a00 * x + a01 * y;
          const y1 = a10 * x + a11 * y;
          const d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
          let sfactor_sq = 1 / d - 0.25;

          if (sfactor_sq < 0) {
            sfactor_sq = 0;
          }

          let sfactor = Math.sqrt(sfactor_sq);

          if (sweep === large) {
            sfactor = -sfactor;
          }

          const xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
          const yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
          const th0 = Math.atan2(y0 - yc, x0 - xc);
          const th1 = Math.atan2(y1 - yc, x1 - xc);
          let th_arc = th1 - th0;

          if (th_arc < 0 && sweep === 1) {
            th_arc += 2 * Math.PI;
          } else if (th_arc > 0 && sweep === 0) {
            th_arc -= 2 * Math.PI;
          }

          const segments = Math.ceil(Math.abs(th_arc / (Math.PI * 0.5 + 0.001)));
          const result = [];

          for (let i = 0; i < segments; i++) {
            const th2 = th0 + i * th_arc / segments;
            const th3 = th0 + (i + 1) * th_arc / segments;
            result[i] = [xc, yc, th2, th3, rx, ry, sin_th, cos_th];
          }

          return result;
        };

        var segmentToBezier = function segmentToBezier(cx, cy, th0, th1, rx, ry, sin_th, cos_th) {
          const a00 = cos_th * rx;
          const a01 = -sin_th * ry;
          const a10 = sin_th * rx;
          const a11 = cos_th * ry;
          const th_half = 0.5 * (th1 - th0);
          const t = 8 / 3 * Math.sin(th_half * 0.5) * Math.sin(th_half * 0.5) / Math.sin(th_half);
          const x1 = cx + Math.cos(th0) - t * Math.sin(th0);
          const y1 = cy + Math.sin(th0) + t * Math.cos(th0);
          const x3 = cx + Math.cos(th1);
          const y3 = cy + Math.sin(th1);
          const x2 = x3 + t * Math.sin(th1);
          const y2 = y3 - t * Math.cos(th1);
          return [a00 * x1 + a01 * y1, a10 * x1 + a11 * y1, a00 * x2 + a01 * y2, a10 * x2 + a11 * y2, a00 * x3 + a01 * y3, a10 * x3 + a11 * y3];
        };

        const SVGPath = /* #__PURE__ */(function () {
          function SVGPath() {
            _classCallCheck(this, SVGPath);
          }

          _createClass(SVGPath, null, [{
            key: 'apply',
            value: function apply(doc, path) {
              const commands = parse(path);

              _apply(commands, doc);
            },
          }]);

          return SVGPath;
        }());

        const number$1 = PDFObject.number; // This constant is used to approximate a symmetrical arc using a cubic
        // Bezier curve.

        const KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
        const VectorMixin = {
          initVector: function initVector() {
            this._ctm = [1, 0, 0, 1, 0, 0]; // current transformation matrix

            return this._ctmStack = [];
          },
          save: function save() {
            this._ctmStack.push(this._ctm.slice()); // TODO: save/restore colorspace and styles so not setting it unnessesarily all the time?

            return this.addContent('q');
          },
          restore: function restore() {
            this._ctm = this._ctmStack.pop() || [1, 0, 0, 1, 0, 0];
            return this.addContent('Q');
          },
          closePath: function closePath() {
            return this.addContent('h');
          },
          lineWidth: function lineWidth(w) {
            return this.addContent(''.concat(number$1(w), ' w'));
          },
          _CAP_STYLES: {
            BUTT: 0,
            ROUND: 1,
            SQUARE: 2,
          },
          lineCap: function lineCap(c) {
            if (typeof c === 'string') {
              c = this._CAP_STYLES[c.toUpperCase()];
            }

            return this.addContent(''.concat(c, ' J'));
          },
          _JOIN_STYLES: {
            MITER: 0,
            ROUND: 1,
            BEVEL: 2,
          },
          lineJoin: function lineJoin(j) {
            if (typeof j === 'string') {
              j = this._JOIN_STYLES[j.toUpperCase()];
            }

            return this.addContent(''.concat(j, ' j'));
          },
          miterLimit: function miterLimit(m) {
            return this.addContent(''.concat(number$1(m), ' M'));
          },
          dash: function dash(length) {
            const options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            const originalLength = length;

            if (!Array.isArray(length)) {
              length = [length, options.space || length];
            }

            const valid = length.every((x) => Number.isFinite(x) && x > 0);

            if (!valid) {
              throw new Error('dash('.concat(JSON.stringify(originalLength), ', ').concat(JSON.stringify(options), ') invalid, lengths must be numeric and greater than zero'));
            }

            length = length.map(number$1).join(' ');
            return this.addContent('['.concat(length, '] ').concat(number$1(options.phase || 0), ' d'));
          },
          undash: function undash() {
            return this.addContent('[] 0 d');
          },
          moveTo: function moveTo(x, y) {
            return this.addContent(''.concat(number$1(x), ' ').concat(number$1(y), ' m'));
          },
          lineTo: function lineTo(x, y) {
            return this.addContent(''.concat(number$1(x), ' ').concat(number$1(y), ' l'));
          },
          bezierCurveTo: function bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y) {
            return this.addContent(''.concat(number$1(cp1x), ' ').concat(number$1(cp1y), ' ').concat(number$1(cp2x), ' ').concat(number$1(cp2y), ' ')
              .concat(number$1(x), ' ')
              .concat(number$1(y), ' c'));
          },
          quadraticCurveTo: function quadraticCurveTo(cpx, cpy, x, y) {
            return this.addContent(''.concat(number$1(cpx), ' ').concat(number$1(cpy), ' ').concat(number$1(x), ' ').concat(number$1(y), ' v'));
          },
          rect: function rect(x, y, w, h) {
            return this.addContent(''.concat(number$1(x), ' ').concat(number$1(y), ' ').concat(number$1(w), ' ').concat(number$1(h), ' re'));
          },
          roundedRect: function roundedRect(x, y, w, h, r) {
            if (r == null) {
              r = 0;
            }

            r = Math.min(r, 0.5 * w, 0.5 * h); // amount to inset control points from corners (see `ellipse`)

            const c = r * (1.0 - KAPPA);
            this.moveTo(x + r, y);
            this.lineTo(x + w - r, y);
            this.bezierCurveTo(x + w - c, y, x + w, y + c, x + w, y + r);
            this.lineTo(x + w, y + h - r);
            this.bezierCurveTo(x + w, y + h - c, x + w - c, y + h, x + w - r, y + h);
            this.lineTo(x + r, y + h);
            this.bezierCurveTo(x + c, y + h, x, y + h - c, x, y + h - r);
            this.lineTo(x, y + r);
            this.bezierCurveTo(x, y + c, x + c, y, x + r, y);
            return this.closePath();
          },
          ellipse: function ellipse(x, y, r1, r2) {
            // based on http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas/2173084#2173084
            if (r2 == null) {
              r2 = r1;
            }

            x -= r1;
            y -= r2;
            const ox = r1 * KAPPA;
            const oy = r2 * KAPPA;
            const xe = x + r1 * 2;
            const ye = y + r2 * 2;
            const xm = x + r1;
            const ym = y + r2;
            this.moveTo(x, ym);
            this.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
            this.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
            this.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
            this.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
            return this.closePath();
          },
          circle: function circle(x, y, radius) {
            return this.ellipse(x, y, radius);
          },
          arc: function arc(x, y, radius, startAngle, endAngle, anticlockwise) {
            if (anticlockwise == null) {
              anticlockwise = false;
            }

            const TWO_PI = 2.0 * Math.PI;
            const HALF_PI = 0.5 * Math.PI;
            let deltaAng = endAngle - startAngle;

            if (Math.abs(deltaAng) > TWO_PI) {
              // draw only full circle if more than that is specified
              deltaAng = TWO_PI;
            } else if (deltaAng !== 0 && anticlockwise !== deltaAng < 0) {
              // necessary to flip direction of rendering
              const dir = anticlockwise ? -1 : 1;
              deltaAng = dir * TWO_PI + deltaAng;
            }

            const numSegs = Math.ceil(Math.abs(deltaAng) / HALF_PI);
            const segAng = deltaAng / numSegs;
            const handleLen = segAng / HALF_PI * KAPPA * radius;
            let curAng = startAngle; // component distances between anchor point and control point

            let deltaCx = -Math.sin(curAng) * handleLen;
            let deltaCy = Math.cos(curAng) * handleLen; // anchor point

            let ax = x + Math.cos(curAng) * radius;
            let ay = y + Math.sin(curAng) * radius; // calculate and render segments

            this.moveTo(ax, ay);

            for (let segIdx = 0; segIdx < numSegs; segIdx++) {
              // starting control point
              const cp1x = ax + deltaCx;
              const cp1y = ay + deltaCy; // step angle

              curAng += segAng; // next anchor point

              ax = x + Math.cos(curAng) * radius;
              ay = y + Math.sin(curAng) * radius; // next control point delta

              deltaCx = -Math.sin(curAng) * handleLen;
              deltaCy = Math.cos(curAng) * handleLen; // ending control point

              const cp2x = ax - deltaCx;
              const cp2y = ay - deltaCy; // render segment

              this.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, ax, ay);
            }

            return this;
          },
          polygon: function polygon() {
            for (var _len = arguments.length, points = new Array(_len), _key = 0; _key < _len; _key++) {
              points[_key] = arguments[_key];
            }

            this.moveTo.apply(this, _toConsumableArray(points.shift() || []));

            for (let _i = 0, _points = points; _i < _points.length; _i++) {
              const point = _points[_i];
              this.lineTo.apply(this, _toConsumableArray(point || []));
            }

            return this.closePath();
          },
          path: function path(_path) {
            SVGPath.apply(this, _path);
            return this;
          },
          _windingRule: function _windingRule(rule) {
            if (/even-?odd/.test(rule)) {
              return '*';
            }

            return '';
          },
          fill: function fill(color, rule) {
            if (/(even-?odd)|(non-?zero)/.test(color)) {
              rule = color;
              color = null;
            }

            if (color) {
              this.fillColor(color);
            }

            return this.addContent('f'.concat(this._windingRule(rule)));
          },
          stroke: function stroke(color) {
            if (color) {
              this.strokeColor(color);
            }

            return this.addContent('S');
          },
          fillAndStroke: function fillAndStroke(fillColor, strokeColor, rule) {
            if (strokeColor == null) {
              strokeColor = fillColor;
            }

            const isFillRule = /(even-?odd)|(non-?zero)/;

            if (isFillRule.test(fillColor)) {
              rule = fillColor;
              fillColor = null;
            }

            if (isFillRule.test(strokeColor)) {
              rule = strokeColor;
              strokeColor = fillColor;
            }

            if (fillColor) {
              this.fillColor(fillColor);
              this.strokeColor(strokeColor);
            }

            return this.addContent('B'.concat(this._windingRule(rule)));
          },
          clip: function clip(rule) {
            return this.addContent('W'.concat(this._windingRule(rule), ' n'));
          },
          transform: function transform(m11, m12, m21, m22, dx, dy) {
            // keep track of the current transformation matrix
            const m = this._ctm;

            const _m = _slicedToArray(m, 6);
            const m0 = _m[0];
            const m1 = _m[1];
            const m2 = _m[2];
            const m3 = _m[3];
            const m4 = _m[4];
            const m5 = _m[5];

            m[0] = m0 * m11 + m2 * m12;
            m[1] = m1 * m11 + m3 * m12;
            m[2] = m0 * m21 + m2 * m22;
            m[3] = m1 * m21 + m3 * m22;
            m[4] = m0 * dx + m2 * dy + m4;
            m[5] = m1 * dx + m3 * dy + m5;
            const values = [m11, m12, m21, m22, dx, dy].map((v) => number$1(v)).join(' ');
            return this.addContent(''.concat(values, ' cm'));
          },
          translate: function translate(x, y) {
            return this.transform(1, 0, 0, 1, x, y);
          },
          rotate: function rotate(angle) {
            const options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let y;
            const rad = angle * Math.PI / 180;
            const cos = Math.cos(rad);
            const sin = Math.sin(rad);
            let x = y = 0;

            if (options.origin != null) {
              const _options$origin = _slicedToArray(options.origin, 2);

              x = _options$origin[0];
              y = _options$origin[1];
              const x1 = x * cos - y * sin;
              const y1 = x * sin + y * cos;
              x -= x1;
              y -= y1;
            }

            return this.transform(cos, sin, -sin, cos, x, y);
          },
          scale: function scale(xFactor, yFactor) {
            let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            let y;

            if (yFactor == null) {
              yFactor = xFactor;
            }

            if (typeof yFactor === 'object') {
              options = yFactor;
              yFactor = xFactor;
            }

            let x = y = 0;

            if (options.origin != null) {
              const _options$origin2 = _slicedToArray(options.origin, 2);

              x = _options$origin2[0];
              y = _options$origin2[1];
              x -= xFactor * x;
              y -= yFactor * y;
            }

            return this.transform(xFactor, 0, 0, yFactor, x, y);
          },
        };
        const WIN_ANSI_MAP = {
          402: 131,
          8211: 150,
          8212: 151,
          8216: 145,
          8217: 146,
          8218: 130,
          8220: 147,
          8221: 148,
          8222: 132,
          8224: 134,
          8225: 135,
          8226: 149,
          8230: 133,
          8364: 128,
          8240: 137,
          8249: 139,
          8250: 155,
          710: 136,
          8482: 153,
          338: 140,
          339: 156,
          732: 152,
          352: 138,
          353: 154,
          376: 159,
          381: 142,
          382: 158,
        };
        const characters = '.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n  \nspace         exclam         quotedbl       numbersign\ndollar        percent        ampersand      quotesingle\nparenleft     parenright     asterisk       plus\ncomma         hyphen         period         slash\nzero          one            two            three\nfour          five           six            seven\neight         nine           colon          semicolon\nless          equal          greater        question\n  \nat            A              B              C\nD             E              F              G\nH             I              J              K\nL             M              N              O\nP             Q              R              S\nT             U              V              W\nX             Y              Z              bracketleft\nbackslash     bracketright   asciicircum    underscore\n  \ngrave         a              b              c\nd             e              f              g\nh             i              j              k\nl             m              n              o\np             q              r              s\nt             u              v              w\nx             y              z              braceleft\nbar           braceright     asciitilde     .notdef\n  \nEuro          .notdef        quotesinglbase florin\nquotedblbase  ellipsis       dagger         daggerdbl\ncircumflex    perthousand    Scaron         guilsinglleft\nOE            .notdef        Zcaron         .notdef\n.notdef       quoteleft      quoteright     quotedblleft\nquotedblright bullet         endash         emdash\ntilde         trademark      scaron         guilsinglright\noe            .notdef        zcaron         ydieresis\n  \nspace         exclamdown     cent           sterling\ncurrency      yen            brokenbar      section\ndieresis      copyright      ordfeminine    guillemotleft\nlogicalnot    hyphen         registered     macron\ndegree        plusminus      twosuperior    threesuperior\nacute         mu             paragraph      periodcentered\ncedilla       onesuperior    ordmasculine   guillemotright\nonequarter    onehalf        threequarters  questiondown\n  \nAgrave        Aacute         Acircumflex    Atilde\nAdieresis     Aring          AE             Ccedilla\nEgrave        Eacute         Ecircumflex    Edieresis\nIgrave        Iacute         Icircumflex    Idieresis\nEth           Ntilde         Ograve         Oacute\nOcircumflex   Otilde         Odieresis      multiply\nOslash        Ugrave         Uacute         Ucircumflex\nUdieresis     Yacute         Thorn          germandbls\n  \nagrave        aacute         acircumflex    atilde\nadieresis     aring          ae             ccedilla\negrave        eacute         ecircumflex    edieresis\nigrave        iacute         icircumflex    idieresis\neth           ntilde         ograve         oacute\nocircumflex   otilde         odieresis      divide\noslash        ugrave         uacute         ucircumflex\nudieresis     yacute         thorn          ydieresis'.split(/\s+/);

        const AFMFont = /* #__PURE__ */(function () {
          _createClass(AFMFont, null, [{
            key: 'open',
            value: function open(filename) {
              return new AFMFont(fs.readFileSync(filename, 'utf8'));
            },
          }]);

          function AFMFont(contents) {
            _classCallCheck(this, AFMFont);

            this.contents = contents;
            this.attributes = {};
            this.glyphWidths = {};
            this.boundingBoxes = {};
            this.kernPairs = {};
            this.parse(); // todo: remove charWidths since appears to not be used

            this.charWidths = new Array(256);

            for (let char = 0; char <= 255; char++) {
              this.charWidths[char] = this.glyphWidths[characters[char]];
            }

            this.bbox = this.attributes.FontBBox.split(/\s+/).map((e) => +e);
            this.ascender = +(this.attributes.Ascender || 0);
            this.descender = +(this.attributes.Descender || 0);
            this.xHeight = +(this.attributes.XHeight || 0);
            this.capHeight = +(this.attributes.CapHeight || 0);
            this.lineGap = this.bbox[3] - this.bbox[1] - (this.ascender - this.descender);
          }

          _createClass(AFMFont, [{
            key: 'parse',
            value: function parse() {
              let section = '';

              const _iterator = _createForOfIteratorHelper(this.contents.split('\n'));
              let _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  const line = _step.value;
                  var match;
                  var a;

                  if (match = line.match(/^Start(\w+)/)) {
                    section = match[1];
                    continue;
                  } else if (match = line.match(/^End(\w+)/)) {
                    section = '';
                    continue;
                  }

                  switch (section) {
                    case 'FontMetrics':
                      match = line.match(/(^\w+)\s+(.*)/);
                      var key = match[1];
                      var value = match[2];

                      if (a = this.attributes[key]) {
                        if (!Array.isArray(a)) {
                          a = this.attributes[key] = [a];
                        }

                        a.push(value);
                      } else {
                        this.attributes[key] = value;
                      }

                      break;

                    case 'CharMetrics':
                      if (!/^CH?\s/.test(line)) {
                        continue;
                      }

                      var name = line.match(/\bN\s+(\.?\w+)\s*;/)[1];
                      this.glyphWidths[name] = +line.match(/\bWX\s+(\d+)\s*;/)[1];
                      break;

                    case 'KernPairs':
                      match = line.match(/^KPX\s+(\.?\w+)\s+(\.?\w+)\s+(-?\d+)/);

                      if (match) {
                        this.kernPairs[`${match[1]}\0${match[2]}`] = parseInt(match[3]);
                      }

                      break;
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            },
          }, {
            key: 'encodeText',
            value: function encodeText(text) {
              const res = [];

              for (let i = 0, len = text.length; i < len; i++) {
                let char = text.charCodeAt(i);
                char = WIN_ANSI_MAP[char] || char;
                res.push(char.toString(16));
              }

              return res;
            },
          }, {
            key: 'glyphsForString',
            value: function glyphsForString(string) {
              const glyphs = [];

              for (let i = 0, len = string.length; i < len; i++) {
                const charCode = string.charCodeAt(i);
                glyphs.push(this.characterToGlyph(charCode));
              }

              return glyphs;
            },
          }, {
            key: 'characterToGlyph',
            value: function characterToGlyph(character) {
              return characters[WIN_ANSI_MAP[character] || character] || '.notdef';
            },
          }, {
            key: 'widthOfGlyph',
            value: function widthOfGlyph(glyph) {
              return this.glyphWidths[glyph] || 0;
            },
          }, {
            key: 'getKernPair',
            value: function getKernPair(left, right) {
              return this.kernPairs[`${left}\0${right}`] || 0;
            },
          }, {
            key: 'advancesForGlyphs',
            value: function advancesForGlyphs(glyphs) {
              const advances = [];

              for (let index = 0; index < glyphs.length; index++) {
                const left = glyphs[index];
                const right = glyphs[index + 1];
                advances.push(this.widthOfGlyph(left) + this.getKernPair(left, right));
              }

              return advances;
            },
          }]);

          return AFMFont;
        }());

        const PDFFont = /* #__PURE__ */(function () {
          function PDFFont() {
            _classCallCheck(this, PDFFont);
          }

          _createClass(PDFFont, [{
            key: 'encode',
            value: function encode() {
              throw new Error('Must be implemented by subclasses');
            },
          }, {
            key: 'widthOfString',
            value: function widthOfString() {
              throw new Error('Must be implemented by subclasses');
            },
          }, {
            key: 'ref',
            value: function ref() {
              return this.dictionary != null ? this.dictionary : this.dictionary = this.document.ref();
            },
          }, {
            key: 'finalize',
            value: function finalize() {
              if (this.embedded || this.dictionary == null) {
                return;
              }

              this.embed();
              return this.embedded = true;
            },
          }, {
            key: 'embed',
            value: function embed() {
              throw new Error('Must be implemented by subclasses');
            },
          }, {
            key: 'lineHeight',
            value: function lineHeight(size, includeGap) {
              if (includeGap == null) {
                includeGap = false;
              }

              const gap = includeGap ? this.lineGap : 0;
              return (this.ascender + gap - this.descender) / 1000 * size;
            },
          }]);

          return PDFFont;
        }());

        const STANDARD_FONTS = {
          Courier: function Courier() {
            return fs.readFileSync(`${__dirname}/data/Courier.afm`, 'utf8');
          },
          'Courier-Bold': function CourierBold() {
            return fs.readFileSync(`${__dirname}/data/Courier-Bold.afm`, 'utf8');
          },
          'Courier-Oblique': function CourierOblique() {
            return fs.readFileSync(`${__dirname}/data/Courier-Oblique.afm`, 'utf8');
          },
          'Courier-BoldOblique': function CourierBoldOblique() {
            return fs.readFileSync(`${__dirname}/data/Courier-BoldOblique.afm`, 'utf8');
          },
          Helvetica: function Helvetica() {
            return fs.readFileSync(`${__dirname}/data/Helvetica.afm`, 'utf8');
          },
          'Helvetica-Bold': function HelveticaBold() {
            return fs.readFileSync(`${__dirname}/data/Helvetica-Bold.afm`, 'utf8');
          },
          'Helvetica-Oblique': function HelveticaOblique() {
            return fs.readFileSync(`${__dirname}/data/Helvetica-Oblique.afm`, 'utf8');
          },
          'Helvetica-BoldOblique': function HelveticaBoldOblique() {
            return fs.readFileSync(`${__dirname}/data/Helvetica-BoldOblique.afm`, 'utf8');
          },
          'Times-Roman': function TimesRoman() {
            return fs.readFileSync(`${__dirname}/data/Times-Roman.afm`, 'utf8');
          },
          'Times-Bold': function TimesBold() {
            return fs.readFileSync(`${__dirname}/data/Times-Bold.afm`, 'utf8');
          },
          'Times-Italic': function TimesItalic() {
            return fs.readFileSync(`${__dirname}/data/Times-Italic.afm`, 'utf8');
          },
          'Times-BoldItalic': function TimesBoldItalic() {
            return fs.readFileSync(`${__dirname}/data/Times-BoldItalic.afm`, 'utf8');
          },
          Symbol: function Symbol() {
            return fs.readFileSync(`${__dirname}/data/Symbol.afm`, 'utf8');
          },
          ZapfDingbats: function ZapfDingbats() {
            return fs.readFileSync(`${__dirname}/data/ZapfDingbats.afm`, 'utf8');
          },
        };

        const StandardFont = /* #__PURE__ */(function (_PDFFont) {
          _inherits(StandardFont, _PDFFont);

          const _super = _createSuper(StandardFont);

          function StandardFont(document, name, id) {
            let _this;

            _classCallCheck(this, StandardFont);

            _this = _super.call(this);
            _this.document = document;
            _this.name = name;
            _this.id = id;
            _this.font = new AFMFont(STANDARD_FONTS[_this.name]());
            const _this$font = _this.font;
            _this.ascender = _this$font.ascender;
            _this.descender = _this$font.descender;
            _this.bbox = _this$font.bbox;
            _this.lineGap = _this$font.lineGap;
            _this.xHeight = _this$font.xHeight;
            _this.capHeight = _this$font.capHeight;
            return _this;
          }

          _createClass(StandardFont, [{
            key: 'embed',
            value: function embed() {
              this.dictionary.data = {
                Type: 'Font',
                BaseFont: this.name,
                Subtype: 'Type1',
                Encoding: 'WinAnsiEncoding',
              };
              return this.dictionary.end();
            },
          }, {
            key: 'encode',
            value: function encode(text) {
              const encoded = this.font.encodeText(text);
              const glyphs = this.font.glyphsForString(''.concat(text));
              const advances = this.font.advancesForGlyphs(glyphs);
              const positions = [];

              for (let i = 0; i < glyphs.length; i++) {
                const glyph = glyphs[i];
                positions.push({
                  xAdvance: advances[i],
                  yAdvance: 0,
                  xOffset: 0,
                  yOffset: 0,
                  advanceWidth: this.font.widthOfGlyph(glyph),
                });
              }

              return [encoded, positions];
            },
          }, {
            key: 'widthOfString',
            value: function widthOfString(string, size) {
              const glyphs = this.font.glyphsForString(''.concat(string));
              const advances = this.font.advancesForGlyphs(glyphs);
              let width = 0;

              const _iterator = _createForOfIteratorHelper(advances);
              let _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  const advance = _step.value;
                  width += advance;
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              const scale = size / 1000;
              return width * scale;
            },
          }], [{
            key: 'isStandardFont',
            value: function isStandardFont(name) {
              return name in STANDARD_FONTS;
            },
          }]);

          return StandardFont;
        }(PDFFont));

        const toHex = function toHex(num) {
          return '0000'.concat(num.toString(16)).slice(-4);
        };

        const EmbeddedFont = /* #__PURE__ */(function (_PDFFont) {
          _inherits(EmbeddedFont, _PDFFont);

          const _super = _createSuper(EmbeddedFont);

          function EmbeddedFont(document, font, id) {
            let _this;

            _classCallCheck(this, EmbeddedFont);

            _this = _super.call(this);
            _this.document = document;
            _this.font = font;
            _this.id = id;
            _this.subset = _this.font.createSubset();
            _this.unicode = [[0]];
            _this.widths = [_this.font.getGlyph(0).advanceWidth];
            _this.name = _this.font.postscriptName;
            _this.scale = 1000 / _this.font.unitsPerEm;
            _this.ascender = _this.font.ascent * _this.scale;
            _this.descender = _this.font.descent * _this.scale;
            _this.xHeight = _this.font.xHeight * _this.scale;
            _this.capHeight = _this.font.capHeight * _this.scale;
            _this.lineGap = _this.font.lineGap * _this.scale;
            _this.bbox = _this.font.bbox;

            if (document.options.fontLayoutCache !== false) {
              _this.layoutCache = Object.create(null);
            }

            return _this;
          }

          _createClass(EmbeddedFont, [{
            key: 'layoutRun',
            value: function layoutRun(text, features) {
              const run = this.font.layout(text, features); // Normalize position values

              for (let i = 0; i < run.positions.length; i++) {
                const position = run.positions[i];

                for (const key in position) {
                  position[key] *= this.scale;
                }

                position.advanceWidth = run.glyphs[i].advanceWidth * this.scale;
              }

              return run;
            },
          }, {
            key: 'layoutCached',
            value: function layoutCached(text) {
              if (!this.layoutCache) {
                return this.layoutRun(text);
              }

              let cached;

              if (cached = this.layoutCache[text]) {
                return cached;
              }

              const run = this.layoutRun(text);
              this.layoutCache[text] = run;
              return run;
            },
          }, {
            key: 'layout',
            value: function layout(text, features, onlyWidth) {
              // Skip the cache if any user defined features are applied
              if (features) {
                return this.layoutRun(text, features);
              }

              let glyphs = onlyWidth ? null : [];
              let positions = onlyWidth ? null : [];
              let advanceWidth = 0; // Split the string by words to increase cache efficiency.
              // For this purpose, spaces and tabs are a good enough delimeter.

              let last = 0;
              let index = 0;

              while (index <= text.length) {
                var needle;

                if (index === text.length && last < index || (needle = text.charAt(index), [' ', '\t'].includes(needle))) {
                  const run = this.layoutCached(text.slice(last, ++index));

                  if (!onlyWidth) {
                    glyphs = glyphs.concat(run.glyphs);
                    positions = positions.concat(run.positions);
                  }

                  advanceWidth += run.advanceWidth;
                  last = index;
                } else {
                  index++;
                }
              }

              return {
                glyphs,
                positions,
                advanceWidth,
              };
            },
          }, {
            key: 'encode',
            value: function encode(text, features) {
              const _this$layout = this.layout(text, features);
              const { glyphs } = _this$layout;
              const { positions } = _this$layout;

              const res = [];

              for (let i = 0; i < glyphs.length; i++) {
                const glyph = glyphs[i];
                const gid = this.subset.includeGlyph(glyph.id);
                res.push('0000'.concat(gid.toString(16)).slice(-4));

                if (this.widths[gid] == null) {
                  this.widths[gid] = glyph.advanceWidth * this.scale;
                }

                if (this.unicode[gid] == null) {
                  this.unicode[gid] = glyph.codePoints;
                }
              }

              return [res, positions];
            },
          }, {
            key: 'widthOfString',
            value: function widthOfString(string, size, features) {
              const width = this.layout(string, features, true).advanceWidth;
              const scale = size / 1000;
              return width * scale;
            },
          }, {
            key: 'embed',
            value: function embed() {
              const _this2 = this;

              const isCFF = this.subset.cff != null;
              const fontFile = this.document.ref();

              if (isCFF) {
                fontFile.data.Subtype = 'CIDFontType0C';
              }

              this.subset.encodeStream().on('data', (data) => fontFile.write(data)).on('end', () => fontFile.end());
              const familyClass = ((this.font['OS/2'] != null ? this.font['OS/2'].sFamilyClass : undefined) || 0) >> 8;
              let flags = 0;

              if (this.font.post.isFixedPitch) {
                flags |= 1 << 0;
              }

              if (familyClass >= 1 && familyClass <= 7) {
                flags |= 1 << 1;
              }

              flags |= 1 << 2; // assume the font uses non-latin characters

              if (familyClass === 10) {
                flags |= 1 << 3;
              }

              if (this.font.head.macStyle.italic) {
                flags |= 1 << 6;
              } // generate a tag (6 uppercase letters. 17 is the char code offset from '0' to 'A'. 73 will map to 'Z')

              const tag = [1, 2, 3, 4, 5, 6].map((i) => String.fromCharCode((_this2.id.charCodeAt(i) || 73) + 17)).join('');
              const name = `${tag}+${this.font.postscriptName}`;
              const { bbox } = this.font;
              const descriptor = this.document.ref({
                Type: 'FontDescriptor',
                FontName: name,
                Flags: flags,
                FontBBox: [bbox.minX * this.scale, bbox.minY * this.scale, bbox.maxX * this.scale, bbox.maxY * this.scale],
                ItalicAngle: this.font.italicAngle,
                Ascent: this.ascender,
                Descent: this.descender,
                CapHeight: (this.font.capHeight || this.font.ascent) * this.scale,
                XHeight: (this.font.xHeight || 0) * this.scale,
                StemV: 0,
              }); // not sure how to calculate this

              if (isCFF) {
                descriptor.data.FontFile3 = fontFile;
              } else {
                descriptor.data.FontFile2 = fontFile;
              }

              descriptor.end();
              const descendantFontData = {
                Type: 'Font',
                Subtype: 'CIDFontType0',
                BaseFont: name,
                CIDSystemInfo: {
                  Registry: new String('Adobe'),
                  Ordering: new String('Identity'),
                  Supplement: 0,
                },
                FontDescriptor: descriptor,
                W: [0, this.widths],
              };

              if (!isCFF) {
                descendantFontData.Subtype = 'CIDFontType2';
                descendantFontData.CIDToGIDMap = 'Identity';
              }

              const descendantFont = this.document.ref(descendantFontData);
              descendantFont.end();
              this.dictionary.data = {
                Type: 'Font',
                Subtype: 'Type0',
                BaseFont: name,
                Encoding: 'Identity-H',
                DescendantFonts: [descendantFont],
                ToUnicode: this.toUnicodeCmap(),
              };
              return this.dictionary.end();
            }, // Maps the glyph ids encoded in the PDF back to unicode strings
            // Because of ligature substitutions and the like, there may be one or more
            // unicode characters represented by each glyph.

          }, {
            key: 'toUnicodeCmap',
            value: function toUnicodeCmap() {
              const cmap = this.document.ref();
              const entries = [];

              const _iterator = _createForOfIteratorHelper(this.unicode);
              let _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  const codePoints = _step.value;
                  const encoded = []; // encode codePoints to utf16

                  const _iterator2 = _createForOfIteratorHelper(codePoints);
                  var _step2;

                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      let { value } = _step2;

                      if (value > 0xffff) {
                        value -= 0x10000;
                        encoded.push(toHex(value >>> 10 & 0x3ff | 0xd800));
                        value = 0xdc00 | value & 0x3ff;
                      }

                      encoded.push(toHex(value));
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }

                  entries.push('<'.concat(encoded.join(' '), '>'));
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              cmap.end('/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange\n1 beginbfrange\n<0000> <'.concat(toHex(entries.length - 1), '> [').concat(entries.join(' '), ']\nendbfrange\nendcmap\nCMapName currentdict /CMap defineresource pop\nend\nend'));
              return cmap;
            },
          }]);

          return EmbeddedFont;
        }(PDFFont));

        const PDFFontFactory = /* #__PURE__ */(function () {
          function PDFFontFactory() {
            _classCallCheck(this, PDFFontFactory);
          }

          _createClass(PDFFontFactory, null, [{
            key: 'open',
            value: function open(document, src, family, id) {
              let font;

              if (typeof src === 'string') {
                if (StandardFont.isStandardFont(src)) {
                  return new StandardFont(document, src, id);
                }

                src = fs.readFileSync(src);
              }

              if (Buffer.isBuffer(src)) {
                font = _fontkit.default.create(src, family);
              } else if (src instanceof Uint8Array) {
                font = _fontkit.default.create(Buffer.from(src), family);
              } else if (src instanceof ArrayBuffer) {
                font = _fontkit.default.create(Buffer.from(new Uint8Array(src)), family);
              }

              if (font == null) {
                throw new Error('Not a supported font format or standard PDF font.');
              }

              return new EmbeddedFont(document, font, id);
            },
          }]);

          return PDFFontFactory;
        }());

        const FontsMixin = {
          initFonts: function initFonts() {
            const defaultFont = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Helvetica'; // Lookup table for embedded fonts

            this._fontFamilies = {};
            this._fontCount = 0; // Font state

            this._fontSize = 12;
            this._font = null;
            this._registeredFonts = {}; // Set the default font

            if (defaultFont) {
              this.font(defaultFont);
            }
          },
          font: function font(src, family, size) {
            let cacheKey; let
              font;

            if (typeof family === 'number') {
              size = family;
              family = null;
            } // check registered fonts if src is a string

            if (typeof src === 'string' && this._registeredFonts[src]) {
              cacheKey = src;
              const _this$_registeredFont = this._registeredFonts[src];
              src = _this$_registeredFont.src;
              family = _this$_registeredFont.family;
            } else {
              cacheKey = family || src;

              if (typeof cacheKey !== 'string') {
                cacheKey = null;
              }
            }

            if (size != null) {
              this.fontSize(size);
            } // fast path: check if the font is already in the PDF

            if (font = this._fontFamilies[cacheKey]) {
              this._font = font;
              return this;
            } // load the font

            const id = 'F'.concat(++this._fontCount);
            this._font = PDFFontFactory.open(this, src, family, id); // check for existing font familes with the same name already in the PDF
            // useful if the font was passed as a buffer

            if (font = this._fontFamilies[this._font.name]) {
              this._font = font;
              return this;
            } // save the font for reuse later

            if (cacheKey) {
              this._fontFamilies[cacheKey] = this._font;
            }

            if (this._font.name) {
              this._fontFamilies[this._font.name] = this._font;
            }

            return this;
          },
          fontSize: function fontSize(_fontSize) {
            this._fontSize = _fontSize;
            return this;
          },
          currentLineHeight: function currentLineHeight(includeGap) {
            if (includeGap == null) {
              includeGap = false;
            }

            return this._font.lineHeight(this._fontSize, includeGap);
          },
          registerFont: function registerFont(name, src, family) {
            this._registeredFonts[name] = {
              src,
              family,
            };
            return this;
          },
        };

        const LineWrapper = /* #__PURE__ */(function (_EventEmitter) {
          _inherits(LineWrapper, _EventEmitter);

          const _super = _createSuper(LineWrapper);

          function LineWrapper(document, options) {
            let _this;

            _classCallCheck(this, LineWrapper);

            _this = _super.call(this);
            _this.document = document;
            _this.indent = options.indent || 0;
            _this.characterSpacing = options.characterSpacing || 0;
            _this.wordSpacing = options.wordSpacing === 0;
            _this.columns = options.columns || 1;
            _this.columnGap = options.columnGap != null ? options.columnGap : 18; // 1/4 inch

            _this.lineWidth = (options.width - _this.columnGap * (_this.columns - 1)) / _this.columns;
            _this.spaceLeft = _this.lineWidth;
            _this.startX = _this.document.x;
            _this.startY = _this.document.y;
            _this.column = 1;
            _this.ellipsis = options.ellipsis;
            _this.continuedX = 0;
            _this.features = options.features; // calculate the maximum Y position the text can appear at

            if (options.height != null) {
              _this.height = options.height;
              _this.maxY = _this.startY + options.height;
            } else {
              _this.maxY = _this.document.page.maxY();
            } // handle paragraph indents

            _this.on('firstLine', (options) => {
              // if this is the first line of the text segment, and
              // we're continuing where we left off, indent that much
              // otherwise use the user specified indent option
              const indent = _this.continuedX || _this.indent;
              _this.document.x += indent;
              _this.lineWidth -= indent;
              return _this.once('line', () => {
                _this.document.x -= indent;
                _this.lineWidth += indent;

                if (options.continued && !_this.continuedX) {
                  _this.continuedX = _this.indent;
                }

                if (!options.continued) {
                  return _this.continuedX = 0;
                }
              });
            }); // handle left aligning last lines of paragraphs

            _this.on('lastLine', (options) => {
              const { align } = options;

              if (align === 'justify') {
                options.align = 'left';
              }

              _this.lastLine = true;
              return _this.once('line', () => {
                _this.document.y += options.paragraphGap || 0;
                options.align = align;
                return _this.lastLine = false;
              });
            });

            return _this;
          }

          _createClass(LineWrapper, [{
            key: 'wordWidth',
            value: function wordWidth(word) {
              return this.document.widthOfString(word, this) + this.characterSpacing + this.wordSpacing;
            },
          }, {
            key: 'eachWord',
            value: function eachWord(text, fn) {
              // setup a unicode line breaker
              let bk;
              const breaker = new _linebreak.default(text);
              let last = null;
              const wordWidths = Object.create(null);

              while (bk = breaker.nextBreak()) {
                var shouldContinue;
                let word = text.slice((last != null ? last.position : undefined) || 0, bk.position);
                let w = wordWidths[word] != null ? wordWidths[word] : wordWidths[word] = this.wordWidth(word); // if the word is longer than the whole line, chop it up
                // TODO: break by grapheme clusters, not JS string characters

                if (w > this.lineWidth + this.continuedX) {
                  // make some fake break objects
                  let lbk = last;
                  const fbk = {};

                  while (word.length) {
                    // fit as much of the word as possible into the space we have
                    var l; var
                      mightGrow;

                    if (w > this.spaceLeft) {
                      // start our check at the end of our available space - this method is faster than a loop of each character and it resolves
                      // an issue with long loops when processing massive words, such as a huge number of spaces
                      l = Math.ceil(this.spaceLeft / (w / word.length));
                      w = this.wordWidth(word.slice(0, l));
                      mightGrow = w <= this.spaceLeft && l < word.length;
                    } else {
                      l = word.length;
                    }

                    let mustShrink = w > this.spaceLeft && l > 0; // shrink or grow word as necessary after our near-guess above

                    while (mustShrink || mightGrow) {
                      if (mustShrink) {
                        w = this.wordWidth(word.slice(0, --l));
                        mustShrink = w > this.spaceLeft && l > 0;
                      } else {
                        w = this.wordWidth(word.slice(0, ++l));
                        mustShrink = w > this.spaceLeft && l > 0;
                        mightGrow = w <= this.spaceLeft && l < word.length;
                      }
                    } // check for the edge case where a single character cannot fit into a line.

                    if (l === 0 && this.spaceLeft === this.lineWidth) {
                      l = 1;
                    } // send a required break unless this is the last piece and a linebreak is not specified

                    fbk.required = bk.required || l < word.length;
                    shouldContinue = fn(word.slice(0, l), w, fbk, lbk);
                    lbk = {
                      required: false,
                    }; // get the remaining piece of the word

                    word = word.slice(l);
                    w = this.wordWidth(word);

                    if (shouldContinue === false) {
                      break;
                    }
                  }
                } else {
                  // otherwise just emit the break as it was given to us
                  shouldContinue = fn(word, w, bk, last);
                }

                if (shouldContinue === false) {
                  break;
                }

                last = bk;
              }
            },
          }, {
            key: 'wrap',
            value: function wrap(text, options) {
              const _this2 = this; // override options from previous continued fragments

              if (options.indent != null) {
                this.indent = options.indent;
              }

              if (options.characterSpacing != null) {
                this.characterSpacing = options.characterSpacing;
              }

              if (options.wordSpacing != null) {
                this.wordSpacing = options.wordSpacing;
              }

              if (options.ellipsis != null) {
                this.ellipsis = options.ellipsis;
              } // make sure we're actually on the page
              // and that the first line of is never by
              // itself at the bottom of a page (orphans)

              const nextY = this.document.y + this.document.currentLineHeight(true);

              if (this.document.y > this.maxY || nextY > this.maxY) {
                this.nextSection();
              }

              let buffer = '';
              let textWidth = 0;
              let wc = 0;
              let lc = 0;
              let { y } = this.document; // used to reset Y pos if options.continued (below)

              const emitLine = function emitLine() {
                options.textWidth = textWidth + _this2.wordSpacing * (wc - 1);
                options.wordCount = wc;
                options.lineWidth = _this2.lineWidth;
                y = _this2.document.y;

                _this2.emit('line', buffer, options, _this2);

                return lc++;
              };

              this.emit('sectionStart', options, this);
              this.eachWord(text, (word, w, bk, last) => {
                if (last == null || last.required) {
                  _this2.emit('firstLine', options, _this2);

                  _this2.spaceLeft = _this2.lineWidth;
                }

                if (w <= _this2.spaceLeft) {
                  buffer += word;
                  textWidth += w;
                  wc++;
                }

                if (bk.required || w > _this2.spaceLeft) {
                  // if the user specified a max height and an ellipsis, and is about to pass the
                  // max height and max columns after the next line, append the ellipsis
                  const lh = _this2.document.currentLineHeight(true);

                  if (_this2.height != null && _this2.ellipsis && _this2.document.y + lh * 2 > _this2.maxY && _this2.column >= _this2.columns) {
                    if (_this2.ellipsis === true) {
                      _this2.ellipsis = '…';
                    } // map default ellipsis character

                    buffer = buffer.replace(/\s+$/, '');
                    textWidth = _this2.wordWidth(buffer + _this2.ellipsis); // remove characters from the buffer until the ellipsis fits
                    // to avoid infinite loop need to stop while-loop if buffer is empty string

                    while (buffer && textWidth > _this2.lineWidth) {
                      buffer = buffer.slice(0, -1).replace(/\s+$/, '');
                      textWidth = _this2.wordWidth(buffer + _this2.ellipsis);
                    } // need to add ellipsis only if there is enough space for it

                    if (textWidth <= _this2.lineWidth) {
                      buffer += _this2.ellipsis;
                    }

                    textWidth = _this2.wordWidth(buffer);
                  }

                  if (bk.required) {
                    if (w > _this2.spaceLeft) {
                      emitLine();
                      buffer = word;
                      textWidth = w;
                      wc = 1;
                    }

                    _this2.emit('lastLine', options, _this2);
                  }

                  emitLine(); // if we've reached the edge of the page,
                  // continue on a new page or column

                  if (_this2.document.y + lh > _this2.maxY) {
                    const shouldContinue = _this2.nextSection(); // stop if we reached the maximum height

                    if (!shouldContinue) {
                      wc = 0;
                      buffer = '';
                      return false;
                    }
                  } // reset the space left and buffer

                  if (bk.required) {
                    _this2.spaceLeft = _this2.lineWidth;
                    buffer = '';
                    textWidth = 0;
                    return wc = 0;
                  }
                  // reset the space left and buffer
                  _this2.spaceLeft = _this2.lineWidth - w;
                  buffer = word;
                  textWidth = w;
                  return wc = 1;
                }
                return _this2.spaceLeft -= w;
              });

              if (wc > 0) {
                this.emit('lastLine', options, this);
                emitLine();
              }

              this.emit('sectionEnd', options, this); // if the wrap is set to be continued, save the X position
              // to start the first line of the next segment at, and reset
              // the y position

              if (options.continued === true) {
                if (lc > 1) {
                  this.continuedX = 0;
                }

                this.continuedX += options.textWidth || 0;
                return this.document.y = y;
              }
              return this.document.x = this.startX;
            },
          }, {
            key: 'nextSection',
            value: function nextSection(options) {
              this.emit('sectionEnd', options, this);

              if (++this.column > this.columns) {
                // if a max height was specified by the user, we're done.
                // otherwise, the default is to make a new page at the bottom.
                if (this.height != null) {
                  return false;
                }

                this.document.continueOnNewPage();
                this.column = 1;
                this.startY = this.document.page.margins.top;
                this.maxY = this.document.page.maxY();
                this.document.x = this.startX;

                if (this.document._fillColor) {
                  let _this$document;

                  (_this$document = this.document).fillColor.apply(_this$document, _toConsumableArray(this.document._fillColor));
                }

                this.emit('pageBreak', options, this);
              } else {
                this.document.x += this.lineWidth + this.columnGap;
                this.document.y = this.startY;
                this.emit('columnBreak', options, this);
              }

              this.emit('sectionStart', options, this);
              return true;
            },
          }]);

          return LineWrapper;
        }(_events.EventEmitter));

        const number$2 = PDFObject.number;
        const TextMixin = {
          initText: function initText() {
            this._line = this._line.bind(this); // Current coordinates

            this.x = 0;
            this.y = 0;
            return this._lineGap = 0;
          },
          lineGap: function lineGap(_lineGap) {
            this._lineGap = _lineGap;
            return this;
          },
          moveDown: function moveDown(lines) {
            if (lines == null) {
              lines = 1;
            }

            this.y += this.currentLineHeight(true) * lines + this._lineGap;
            return this;
          },
          moveUp: function moveUp(lines) {
            if (lines == null) {
              lines = 1;
            }

            this.y -= this.currentLineHeight(true) * lines + this._lineGap;
            return this;
          },
          _text: function _text(text, x, y, options, lineCallback) {
            const _this = this;

            options = this._initOptions(x, y, options); // Convert text to a string

            text = text == null ? '' : ''.concat(text); // if the wordSpacing option is specified, remove multiple consecutive spaces

            if (options.wordSpacing) {
              text = text.replace(/\s{2,}/g, ' ');
            }

            const addStructure = function addStructure() {
              if (options.structParent) {
                options.structParent.add(_this.struct(options.structType || 'P', [_this.markStructureContent(options.structType || 'P')]));
              }
            }; // word wrapping

            if (options.width) {
              let wrapper = this._wrapper;

              if (!wrapper) {
                wrapper = new LineWrapper(this, options);
                wrapper.on('line', lineCallback);
                wrapper.on('firstLine', addStructure);
              }

              this._wrapper = options.continued ? wrapper : null;
              this._textOptions = options.continued ? options : null;
              wrapper.wrap(text, options); // render paragraphs as single lines
            } else {
              const _iterator = _createForOfIteratorHelper(text.split('\n'));
              let _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  const line = _step.value;
                  addStructure();
                  lineCallback(line, options);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            }

            return this;
          },
          text: function text(_text2, x, y, options) {
            return this._text(_text2, x, y, options, this._line);
          },
          widthOfString: function widthOfString(string) {
            const options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return this._font.widthOfString(string, this._fontSize, options.features) + (options.characterSpacing || 0) * (string.length - 1);
          },
          heightOfString: function heightOfString(text, options) {
            const _this2 = this;

            const { x } = this;
            const { y } = this;
            options = this._initOptions(options);
            options.height = Infinity; // don't break pages

            const lineGap = options.lineGap || this._lineGap || 0;

            this._text(text, this.x, this.y, options, () => _this2.y += _this2.currentLineHeight(true) + lineGap);

            const height = this.y - y;
            this.x = x;
            this.y = y;
            return height;
          },
          list: function list(_list, x, y, options, wrapper) {
            const _this3 = this;

            options = this._initOptions(x, y, options);
            const listType = options.listType || 'bullet';
            const unit = Math.round(this._font.ascender / 1000 * this._fontSize);
            const midLine = unit / 2;
            const r = options.bulletRadius || unit / 3;
            const indent = options.textIndent || (listType === 'bullet' ? r * 5 : unit * 2);
            const itemIndent = options.bulletIndent || (listType === 'bullet' ? r * 8 : unit * 2);
            let level = 1;
            const items = [];
            const levels = [];
            const numbers = [];

            const flatten = function flatten(list) {
              let n = 1;

              for (let _i = 0; _i < list.length; _i++) {
                const item = list[_i];

                if (Array.isArray(item)) {
                  level++;
                  flatten(item);
                  level--;
                } else {
                  items.push(item);
                  levels.push(level);

                  if (listType !== 'bullet') {
                    numbers.push(n++);
                  }
                }
              }
            };

            flatten(_list);

            const label = function label(n) {
              switch (listType) {
                case 'numbered':
                  return ''.concat(n, '.');

                case 'lettered':
                  var letter = String.fromCharCode((n - 1) % 26 + 65);
                  var times = Math.floor((n - 1) / 26 + 1);
                  var text = Array(times + 1).join(letter);
                  return ''.concat(text, '.');
              }
            };

            wrapper = new LineWrapper(this, options);
            wrapper.on('line', this._line);
            level = 1;
            let i = 0;
            wrapper.on('firstLine', () => {
              let item; let itemType; let labelType; let
                bodyType;

              if (options.structParent) {
                if (options.structTypes) {
                  const _options$structTypes = _slicedToArray(options.structTypes, 3);

                  itemType = _options$structTypes[0];
                  labelType = _options$structTypes[1];
                  bodyType = _options$structTypes[2];
                } else {
                  itemType = 'LI';
                  labelType = 'Lbl';
                  bodyType = 'LBody';
                }
              }

              if (itemType) {
                item = _this3.struct(itemType);
                options.structParent.add(item);
              } else if (options.structParent) {
                item = options.structParent;
              }

              let l;

              if ((l = levels[i++]) !== level) {
                const diff = itemIndent * (l - level);
                _this3.x += diff;
                wrapper.lineWidth -= diff;
                level = l;
              }

              if (item && (labelType || bodyType)) {
                item.add(_this3.struct(labelType || bodyType, [_this3.markStructureContent(labelType || bodyType)]));
              }

              switch (listType) {
                case 'bullet':
                  _this3.circle(_this3.x - indent + r, _this3.y + midLine, r);

                  _this3.fill();

                  break;

                case 'numbered':
                case 'lettered':
                  var text = label(numbers[i - 1]);

                  _this3._fragment(text, _this3.x - indent, _this3.y, options);

                  break;
              }

              if (item && labelType && bodyType) {
                item.add(_this3.struct(bodyType, [_this3.markStructureContent(bodyType)]));
              }

              if (item && item !== options.structParent) {
                item.end();
              }
            });
            wrapper.on('sectionStart', () => {
              const pos = indent + itemIndent * (level - 1);
              _this3.x += pos;
              return wrapper.lineWidth -= pos;
            });
            wrapper.on('sectionEnd', () => {
              const pos = indent + itemIndent * (level - 1);
              _this3.x -= pos;
              return wrapper.lineWidth += pos;
            });
            wrapper.wrap(items.join('\n'), options);
            return this;
          },
          _initOptions: function _initOptions() {
            let x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            const y = arguments.length > 1 ? arguments[1] : undefined;
            let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            if (typeof x === 'object') {
              options = x;
              x = null;
            } // clone options object

            const result = { ...options }; // extend options with previous values for continued text

            if (this._textOptions) {
              for (const key in this._textOptions) {
                const val = this._textOptions[key];

                if (key !== 'continued') {
                  if (result[key] === undefined) {
                    result[key] = val;
                  }
                }
              }
            } // Update the current position

            if (x != null) {
              this.x = x;
            }

            if (y != null) {
              this.y = y;
            } // wrap to margins if no x or y position passed

            if (result.lineBreak !== false) {
              if (result.width == null) {
                result.width = this.page.width - this.x - this.page.margins.right;
              }

              result.width = Math.max(result.width, 0);
            }

            if (!result.columns) {
              result.columns = 0;
            }

            if (result.columnGap == null) {
              result.columnGap = 18;
            } // 1/4 inch

            return result;
          },
          _line: function _line(text) {
            const options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            const wrapper = arguments.length > 2 ? arguments[2] : undefined;

            this._fragment(text, this.x, this.y, options);

            const lineGap = options.lineGap || this._lineGap || 0;

            if (!wrapper) {
              return this.x += this.widthOfString(text);
            }
            return this.y += this.currentLineHeight(true) + lineGap;
          },
          _fragment: function _fragment(text, x, y, options) {
            const _this4 = this;

            let dy; let encoded; let i; let positions; let textWidth; let
              words;
            text = ''.concat(text).replace(/\n/g, '');

            if (text.length === 0) {
              return;
            } // handle options

            const align = options.align || 'left';
            let wordSpacing = options.wordSpacing || 0;
            const characterSpacing = options.characterSpacing || 0; // text alignments

            if (options.width) {
              switch (align) {
                case 'right':
                  textWidth = this.widthOfString(text.replace(/\s+$/, ''), options);
                  x += options.lineWidth - textWidth;
                  break;

                case 'center':
                  x += options.lineWidth / 2 - options.textWidth / 2;
                  break;

                case 'justify':
                  // calculate the word spacing value
                  words = text.trim().split(/\s+/);
                  textWidth = this.widthOfString(text.replace(/\s+/g, ''), options);
                  var spaceWidth = this.widthOfString(' ') + characterSpacing;
                  wordSpacing = Math.max(0, (options.lineWidth - textWidth) / Math.max(1, words.length - 1) - spaceWidth);
                  break;
              }
            } // text baseline alignments based on http://wiki.apache.org/xmlgraphics-fop/LineLayout/AlignmentHandling

            if (typeof options.baseline === 'number') {
              dy = -options.baseline;
            } else {
              switch (options.baseline) {
                case 'svg-middle':
                  dy = 0.5 * this._font.xHeight;
                  break;

                case 'middle':
                case 'svg-central':
                  dy = 0.5 * (this._font.descender + this._font.ascender);
                  break;

                case 'bottom':
                case 'ideographic':
                  dy = this._font.descender;
                  break;

                case 'alphabetic':
                  dy = 0;
                  break;

                case 'mathematical':
                  dy = 0.5 * this._font.ascender;
                  break;

                case 'hanging':
                  dy = 0.8 * this._font.ascender;
                  break;

                case 'top':
                  dy = this._font.ascender;
                  break;

                default:
                  dy = this._font.ascender;
              }

              dy = dy / 1000 * this._fontSize;
            } // calculate the actual rendered width of the string after word and character spacing

            const renderedWidth = options.textWidth + wordSpacing * (options.wordCount - 1) + characterSpacing * (text.length - 1); // create link annotations if the link option is given

            if (options.link != null) {
              this.link(x, y, renderedWidth, this.currentLineHeight(), options.link);
            }

            if (options.goTo != null) {
              this.goTo(x, y, renderedWidth, this.currentLineHeight(), options.goTo);
            }

            if (options.destination != null) {
              this.addNamedDestination(options.destination, 'XYZ', x, y, null);
            } // create underline

            if (options.underline) {
              this.save();

              if (!options.stroke) {
                this.strokeColor.apply(this, _toConsumableArray(this._fillColor || []));
              }

              const lineWidth = this._fontSize < 10 ? 0.5 : Math.floor(this._fontSize / 10);
              this.lineWidth(lineWidth);
              const lineY = y + this.currentLineHeight() - lineWidth;
              this.moveTo(x, lineY);
              this.lineTo(x + renderedWidth, lineY);
              this.stroke();
              this.restore();
            } // create strikethrough line

            if (options.strike) {
              this.save();

              if (!options.stroke) {
                this.strokeColor.apply(this, _toConsumableArray(this._fillColor || []));
              }

              const _lineWidth = this._fontSize < 10 ? 0.5 : Math.floor(this._fontSize / 10);

              this.lineWidth(_lineWidth);

              const _lineY = y + this.currentLineHeight() / 2;

              this.moveTo(x, _lineY);
              this.lineTo(x + renderedWidth, _lineY);
              this.stroke();
              this.restore();
            }

            this.save(); // oblique (angle in degrees or boolean)

            if (options.oblique) {
              let skew;

              if (typeof options.oblique === 'number') {
                skew = -Math.tan(options.oblique * Math.PI / 180);
              } else {
                skew = -0.25;
              }

              this.transform(1, 0, 0, 1, x, y);
              this.transform(1, 0, skew, 1, -skew * dy, 0);
              this.transform(1, 0, 0, 1, -x, -y);
            } // flip coordinate system

            this.transform(1, 0, 0, -1, 0, this.page.height);
            y = this.page.height - y - dy; // add current font to page if necessary

            if (this.page.fonts[this._font.id] == null) {
              this.page.fonts[this._font.id] = this._font.ref();
            } // begin the text object

            this.addContent('BT'); // text position

            this.addContent('1 0 0 1 '.concat(number$2(x), ' ').concat(number$2(y), ' Tm')); // font and font size

            this.addContent('/'.concat(this._font.id, ' ').concat(number$2(this._fontSize), ' Tf')); // rendering mode

            const mode = options.fill && options.stroke ? 2 : options.stroke ? 1 : 0;

            if (mode) {
              this.addContent(''.concat(mode, ' Tr'));
            } // Character spacing

            if (characterSpacing) {
              this.addContent(''.concat(number$2(characterSpacing), ' Tc'));
            } // Add the actual text
            // If we have a word spacing value, we need to encode each word separately
            // since the normal Tw operator only works on character code 32, which isn't
            // used for embedded fonts.

            if (wordSpacing) {
              words = text.trim().split(/\s+/);
              wordSpacing += this.widthOfString(' ') + characterSpacing;
              wordSpacing *= 1000 / this._fontSize;
              encoded = [];
              positions = [];

              const _iterator2 = _createForOfIteratorHelper(words);
              let _step2;

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  const word = _step2.value;

                  const _this$_font$encode = this._font.encode(word, options.features);
                  const _this$_font$encode2 = _slicedToArray(_this$_font$encode, 2);
                  const encodedWord = _this$_font$encode2[0];
                  const positionsWord = _this$_font$encode2[1];

                  encoded = encoded.concat(encodedWord);
                  positions = positions.concat(positionsWord); // add the word spacing to the end of the word
                  // clone object because of cache

                  const space = {};
                  const object = positions[positions.length - 1];

                  for (const key in object) {
                    const val = object[key];
                    space[key] = val;
                  }

                  space.xAdvance += wordSpacing;
                  positions[positions.length - 1] = space;
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            } else {
              const _this$_font$encode3 = this._font.encode(text, options.features);

              const _this$_font$encode4 = _slicedToArray(_this$_font$encode3, 2);

              encoded = _this$_font$encode4[0];
              positions = _this$_font$encode4[1];
            }

            const scale = this._fontSize / 1000;
            const commands = [];
            let last = 0;
            let hadOffset = false; // Adds a segment of text to the TJ command buffer

            const addSegment = function addSegment(cur) {
              if (last < cur) {
                const hex = encoded.slice(last, cur).join('');
                const advance = positions[cur - 1].xAdvance - positions[cur - 1].advanceWidth;
                commands.push('<'.concat(hex, '> ').concat(number$2(-advance)));
              }

              return last = cur;
            }; // Flushes the current TJ commands to the output stream

            const flush = function flush(i) {
              addSegment(i);

              if (commands.length > 0) {
                _this4.addContent('['.concat(commands.join(' '), '] TJ'));

                return commands.length = 0;
              }
            };

            for (i = 0; i < positions.length; i++) {
              // If we have an x or y offset, we have to break out of the current TJ command
              // so we can move the text position.
              const pos = positions[i];

              if (pos.xOffset || pos.yOffset) {
                // Flush the current buffer
                flush(i); // Move the text position and flush just the current character

                this.addContent('1 0 0 1 '.concat(number$2(x + pos.xOffset * scale), ' ').concat(number$2(y + pos.yOffset * scale), ' Tm'));
                flush(i + 1);
                hadOffset = true;
              } else {
                // If the last character had an offset, reset the text position
                if (hadOffset) {
                  this.addContent('1 0 0 1 '.concat(number$2(x), ' ').concat(number$2(y), ' Tm'));
                  hadOffset = false;
                } // Group segments that don't have any advance adjustments

                if (pos.xAdvance - pos.advanceWidth !== 0) {
                  addSegment(i + 1);
                }
              }

              x += pos.xAdvance * scale;
            } // Flush any remaining commands

            flush(i); // end the text object

            this.addContent('ET'); // restore flipped coordinate system

            return this.restore();
          },
        };
        const MARKERS = [0xffc0, 0xffc1, 0xffc2, 0xffc3, 0xffc5, 0xffc6, 0xffc7, 0xffc8, 0xffc9, 0xffca, 0xffcb, 0xffcc, 0xffcd, 0xffce, 0xffcf];
        const COLOR_SPACE_MAP = {
          1: 'DeviceGray',
          3: 'DeviceRGB',
          4: 'DeviceCMYK',
        };

        const JPEG = /* #__PURE__ */(function () {
          function JPEG(data, label) {
            _classCallCheck(this, JPEG);

            let marker;
            this.data = data;
            this.label = label;

            if (this.data.readUInt16BE(0) !== 0xffd8) {
              throw 'SOI not found in JPEG';
            }

            let pos = 2;

            while (pos < this.data.length) {
              marker = this.data.readUInt16BE(pos);
              pos += 2;

              if (MARKERS.includes(marker)) {
                break;
              }

              pos += this.data.readUInt16BE(pos);
            }

            if (!MARKERS.includes(marker)) {
              throw 'Invalid JPEG.';
            }

            pos += 2;
            this.bits = this.data[pos++];
            this.height = this.data.readUInt16BE(pos);
            pos += 2;
            this.width = this.data.readUInt16BE(pos);
            pos += 2;
            const channels = this.data[pos++];
            this.colorSpace = COLOR_SPACE_MAP[channels];
            this.obj = null;
          }

          _createClass(JPEG, [{
            key: 'embed',
            value: function embed(document) {
              if (this.obj) {
                return;
              }

              this.obj = document.ref({
                Type: 'XObject',
                Subtype: 'Image',
                BitsPerComponent: this.bits,
                Width: this.width,
                Height: this.height,
                ColorSpace: this.colorSpace,
                Filter: 'DCTDecode',
              }); // add extra decode params for CMYK images. By swapping the
              // min and max values from the default, we invert the colors. See
              // section 4.8.4 of the spec.

              if (this.colorSpace === 'DeviceCMYK') {
                this.obj.data.Decode = [1.0, 0.0, 1.0, 0.0, 1.0, 0.0, 1.0, 0.0];
              }

              this.obj.end(this.data); // free memory

              return this.data = null;
            },
          }]);

          return JPEG;
        }());

        const PNGImage = /* #__PURE__ */(function () {
          function PNGImage(data, label) {
            _classCallCheck(this, PNGImage);

            this.label = label;
            this.image = new _pngJs.default(data);
            this.width = this.image.width;
            this.height = this.image.height;
            this.imgData = this.image.imgData;
            this.obj = null;
          }

          _createClass(PNGImage, [{
            key: 'embed',
            value: function embed(document) {
              let dataDecoded = false;
              this.document = document;

              if (this.obj) {
                return;
              }

              const { hasAlphaChannel } = this.image;
              const isInterlaced = this.image.interlaceMethod === 1;
              this.obj = this.document.ref({
                Type: 'XObject',
                Subtype: 'Image',
                BitsPerComponent: hasAlphaChannel ? 8 : this.image.bits,
                Width: this.width,
                Height: this.height,
                Filter: 'FlateDecode',
              });

              if (!hasAlphaChannel) {
                const params = this.document.ref({
                  Predictor: isInterlaced ? 1 : 15,
                  Colors: this.image.colors,
                  BitsPerComponent: this.image.bits,
                  Columns: this.width,
                });
                this.obj.data.DecodeParms = params;
                params.end();
              }

              if (this.image.palette.length === 0) {
                this.obj.data.ColorSpace = this.image.colorSpace;
              } else {
                // embed the color palette in the PDF as an object stream
                const palette = this.document.ref();
                palette.end(Buffer.from(this.image.palette)); // build the color space array for the image

                this.obj.data.ColorSpace = ['Indexed', 'DeviceRGB', this.image.palette.length / 3 - 1, palette];
              } // For PNG color types 0, 2 and 3, the transparency data is stored in
              // a dedicated PNG chunk.

              if (this.image.transparency.grayscale != null) {
                // Use Color Key Masking (spec section 4.8.5)
                // An array with N elements, where N is two times the number of color components.
                const val = this.image.transparency.grayscale;
                this.obj.data.Mask = [val, val];
              } else if (this.image.transparency.rgb) {
                // Use Color Key Masking (spec section 4.8.5)
                // An array with N elements, where N is two times the number of color components.
                const { rgb } = this.image.transparency;
                const mask = [];

                const _iterator = _createForOfIteratorHelper(rgb);
                let _step;

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    const x = _step.value;
                    mask.push(x, x);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                this.obj.data.Mask = mask;
              } else if (this.image.transparency.indexed) {
                // Create a transparency SMask for the image based on the data
                // in the PLTE and tRNS sections. See below for details on SMasks.
                dataDecoded = true;
                return this.loadIndexedAlphaChannel();
              } else if (hasAlphaChannel) {
                // For PNG color types 4 and 6, the transparency data is stored as a alpha
                // channel mixed in with the main image data. Separate this data out into an
                // SMask object and store it separately in the PDF.
                dataDecoded = true;
                return this.splitAlphaChannel();
              }

              if (isInterlaced && !dataDecoded) {
                return this.decodeData();
              }

              this.finalize();
            },
          }, {
            key: 'finalize',
            value: function finalize() {
              if (this.alphaChannel) {
                const sMask = this.document.ref({
                  Type: 'XObject',
                  Subtype: 'Image',
                  Height: this.height,
                  Width: this.width,
                  BitsPerComponent: 8,
                  Filter: 'FlateDecode',
                  ColorSpace: 'DeviceGray',
                  Decode: [0, 1],
                });
                sMask.end(this.alphaChannel);
                this.obj.data.SMask = sMask;
              } // add the actual image data

              this.obj.end(this.imgData); // free memory

              this.image = null;
              return this.imgData = null;
            },
          }, {
            key: 'splitAlphaChannel',
            value: function splitAlphaChannel() {
              const _this = this;

              return this.image.decodePixels((pixels) => {
                let a; let
                  p;
                const colorCount = _this.image.colors;
                const pixelCount = _this.width * _this.height;
                const imgData = Buffer.alloc(pixelCount * colorCount);
                const alphaChannel = Buffer.alloc(pixelCount);
                let i = p = a = 0;
                const len = pixels.length; // For 16bit images copy only most significant byte (MSB) - PNG data is always stored in network byte order (MSB first)

                const skipByteCount = _this.image.bits === 16 ? 1 : 0;

                while (i < len) {
                  for (let colorIndex = 0; colorIndex < colorCount; colorIndex++) {
                    imgData[p++] = pixels[i++];
                    i += skipByteCount;
                  }

                  alphaChannel[a++] = pixels[i++];
                  i += skipByteCount;
                }

                _this.imgData = _zlib.default.deflateSync(imgData);
                _this.alphaChannel = _zlib.default.deflateSync(alphaChannel);
                return _this.finalize();
              });
            },
          }, {
            key: 'loadIndexedAlphaChannel',
            value: function loadIndexedAlphaChannel() {
              const _this2 = this;

              const transparency = this.image.transparency.indexed;
              return this.image.decodePixels((pixels) => {
                const alphaChannel = Buffer.alloc(_this2.width * _this2.height);
                let i = 0;

                for (let j = 0, end = pixels.length; j < end; j++) {
                  alphaChannel[i++] = transparency[pixels[j]];
                }

                _this2.alphaChannel = _zlib.default.deflateSync(alphaChannel);
                return _this2.finalize();
              });
            },
          }, {
            key: 'decodeData',
            value: function decodeData() {
              const _this3 = this;

              this.image.decodePixels((pixels) => {
                _this3.imgData = _zlib.default.deflateSync(pixels);

                _this3.finalize();
              });
            },
          }]);

          return PNGImage;
        }());

        const PDFImage = /* #__PURE__ */(function () {
          function PDFImage() {
            _classCallCheck(this, PDFImage);
          }

          _createClass(PDFImage, null, [{
            key: 'open',
            value: function open(src, label) {
              let data;

              if (Buffer.isBuffer(src)) {
                data = src;
              } else if (src instanceof ArrayBuffer) {
                data = Buffer.from(new Uint8Array(src));
              } else {
                let match;

                if (match = /^data:.+;base64,(.*)$/.exec(src)) {
                  data = Buffer.from(match[1], 'base64');
                } else {
                  data = fs.readFileSync(src);

                  if (!data) {
                    return;
                  }
                }
              }

              if (data[0] === 0xff && data[1] === 0xd8) {
                return new JPEG(data, label);
              } if (data[0] === 0x89 && data.toString('ascii', 1, 4) === 'PNG') {
                return new PNGImage(data, label);
              }
              throw new Error('Unknown image format.');
            },
          }]);

          return PDFImage;
        }());

        const ImagesMixin = {
          initImages: function initImages() {
            this._imageRegistry = {};
            return this._imageCount = 0;
          },
          image: function image(src, x, y) {
            let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            let bh; let bp; let bw; let image; let ip; let left; let
              left1;

            if (typeof x === 'object') {
              options = x;
              x = null;
            }

            x = (left = x != null ? x : options.x) != null ? left : this.x;
            y = (left1 = y != null ? y : options.y) != null ? left1 : this.y;

            if (typeof src === 'string') {
              image = this._imageRegistry[src];
            }

            if (!image) {
              if (src.width && src.height) {
                image = src;
              } else {
                image = this.openImage(src);
              }
            }

            if (!image.obj) {
              image.embed(this);
            }

            if (this.page.xobjects[image.label] == null) {
              this.page.xobjects[image.label] = image.obj;
            }

            let w = options.width || image.width;
            let h = options.height || image.height;

            if (options.width && !options.height) {
              const wp = w / image.width;
              w = image.width * wp;
              h = image.height * wp;
            } else if (options.height && !options.width) {
              const hp = h / image.height;
              w = image.width * hp;
              h = image.height * hp;
            } else if (options.scale) {
              w = image.width * options.scale;
              h = image.height * options.scale;
            } else if (options.fit) {
              const _options$fit = _slicedToArray(options.fit, 2);

              bw = _options$fit[0];
              bh = _options$fit[1];
              bp = bw / bh;
              ip = image.width / image.height;

              if (ip > bp) {
                w = bw;
                h = bw / ip;
              } else {
                h = bh;
                w = bh * ip;
              }
            } else if (options.cover) {
              const _options$cover = _slicedToArray(options.cover, 2);

              bw = _options$cover[0];
              bh = _options$cover[1];
              bp = bw / bh;
              ip = image.width / image.height;

              if (ip > bp) {
                h = bh;
                w = bh * ip;
              } else {
                w = bw;
                h = bw / ip;
              }
            }

            if (options.fit || options.cover) {
              if (options.align === 'center') {
                x = x + bw / 2 - w / 2;
              } else if (options.align === 'right') {
                x = x + bw - w;
              }

              if (options.valign === 'center') {
                y = y + bh / 2 - h / 2;
              } else if (options.valign === 'bottom') {
                y = y + bh - h;
              }
            } // create link annotations if the link option is given

            if (options.link != null) {
              this.link(x, y, w, h, options.link);
            }

            if (options.goTo != null) {
              this.goTo(x, y, w, h, options.goTo);
            }

            if (options.destination != null) {
              this.addNamedDestination(options.destination, 'XYZ', x, y, null);
            } // Set the current y position to below the image if it is in the document flow

            if (this.y === y) {
              this.y += h;
            }

            this.save();
            this.transform(w, 0, 0, -h, x, y + h);
            this.addContent('/'.concat(image.label, ' Do'));
            this.restore();
            return this;
          },
          openImage: function openImage(src) {
            let image;

            if (typeof src === 'string') {
              image = this._imageRegistry[src];
            }

            if (!image) {
              image = PDFImage.open(src, 'I'.concat(++this._imageCount));

              if (typeof src === 'string') {
                this._imageRegistry[src] = image;
              }
            }

            return image;
          },
        };
        const AnnotationsMixin = {
          annotate: function annotate(x, y, w, h, options) {
            options.Type = 'Annot';
            options.Rect = this._convertRect(x, y, w, h);
            options.Border = [0, 0, 0];

            if (options.Subtype === 'Link' && typeof options.F === 'undefined') {
              options.F = 1 << 2; // Print Annotation Flag
            }

            if (options.Subtype !== 'Link') {
              if (options.C == null) {
                options.C = this._normalizeColor(options.color || [0, 0, 0]);
              }
            } // convert colors

            delete options.color;

            if (typeof options.Dest === 'string') {
              options.Dest = new String(options.Dest);
            } // Capitalize keys

            for (const key in options) {
              const val = options[key];
              options[key[0].toUpperCase() + key.slice(1)] = val;
            }

            const ref = this.ref(options);
            this.page.annotations.push(ref);
            ref.end();
            return this;
          },
          note: function note(x, y, w, h, contents) {
            const options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
            options.Subtype = 'Text';
            options.Contents = new String(contents);
            options.Name = 'Comment';

            if (options.color == null) {
              options.color = [243, 223, 92];
            }

            return this.annotate(x, y, w, h, options);
          },
          goTo: function goTo(x, y, w, h, name) {
            const options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
            options.Subtype = 'Link';
            options.A = this.ref({
              S: 'GoTo',
              D: new String(name),
            });
            options.A.end();
            return this.annotate(x, y, w, h, options);
          },
          link: function link(x, y, w, h, url) {
            const options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
            options.Subtype = 'Link';

            if (typeof url === 'number') {
              // Link to a page in the document (the page must already exist)
              const pages = this._root.data.Pages.data;

              if (url >= 0 && url < pages.Kids.length) {
                options.A = this.ref({
                  S: 'GoTo',
                  D: [pages.Kids[url], 'XYZ', null, null, null],
                });
                options.A.end();
              } else {
                throw new Error('The document has no page '.concat(url));
              }
            } else {
              // Link to an external url
              options.A = this.ref({
                S: 'URI',
                URI: new String(url),
              });
              options.A.end();
            }

            return this.annotate(x, y, w, h, options);
          },
          _markup: function _markup(x, y, w, h) {
            const options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

            const _this$_convertRect = this._convertRect(x, y, w, h);
            const _this$_convertRect2 = _slicedToArray(_this$_convertRect, 4);
            const x1 = _this$_convertRect2[0];
            const y1 = _this$_convertRect2[1];
            const x2 = _this$_convertRect2[2];
            const y2 = _this$_convertRect2[3];

            options.QuadPoints = [x1, y2, x2, y2, x1, y1, x2, y1];
            options.Contents = new String();
            return this.annotate(x, y, w, h, options);
          },
          highlight: function highlight(x, y, w, h) {
            const options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
            options.Subtype = 'Highlight';

            if (options.color == null) {
              options.color = [241, 238, 148];
            }

            return this._markup(x, y, w, h, options);
          },
          underline: function underline(x, y, w, h) {
            const options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
            options.Subtype = 'Underline';
            return this._markup(x, y, w, h, options);
          },
          strike: function strike(x, y, w, h) {
            const options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
            options.Subtype = 'StrikeOut';
            return this._markup(x, y, w, h, options);
          },
          lineAnnotation: function lineAnnotation(x1, y1, x2, y2) {
            const options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
            options.Subtype = 'Line';
            options.Contents = new String();
            options.L = [x1, this.page.height - y1, x2, this.page.height - y2];
            return this.annotate(x1, y1, x2, y2, options);
          },
          rectAnnotation: function rectAnnotation(x, y, w, h) {
            const options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
            options.Subtype = 'Square';
            options.Contents = new String();
            return this.annotate(x, y, w, h, options);
          },
          ellipseAnnotation: function ellipseAnnotation(x, y, w, h) {
            const options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
            options.Subtype = 'Circle';
            options.Contents = new String();
            return this.annotate(x, y, w, h, options);
          },
          textAnnotation: function textAnnotation(x, y, w, h, text) {
            const options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
            options.Subtype = 'FreeText';
            options.Contents = new String(text);
            options.DA = new String();
            return this.annotate(x, y, w, h, options);
          },
          fileAnnotation: function fileAnnotation(x, y, w, h) {
            const file = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
            const options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {}; // create hidden file

            const filespec = this.file(file.src, { hidden: true, ...file });
            options.Subtype = 'FileAttachment';
            options.FS = filespec; // add description from filespec unless description (Contents) has already been set

            if (options.Contents) {
              options.Contents = new String(options.Contents);
            } else if (filespec.data.Desc) {
              options.Contents = filespec.data.Desc;
            }

            return this.annotate(x, y, w, h, options);
          },
          _convertRect: function _convertRect(x1, y1, w, h) {
            // flip y1 and y2
            let y2 = y1;
            y1 += h; // make x2

            let x2 = x1 + w; // apply current transformation matrix to points

            const _this$_ctm = _slicedToArray(this._ctm, 6);
            const m0 = _this$_ctm[0];
            const m1 = _this$_ctm[1];
            const m2 = _this$_ctm[2];
            const m3 = _this$_ctm[3];
            const m4 = _this$_ctm[4];
            const m5 = _this$_ctm[5];

            x1 = m0 * x1 + m2 * y1 + m4;
            y1 = m1 * x1 + m3 * y1 + m5;
            x2 = m0 * x2 + m2 * y2 + m4;
            y2 = m1 * x2 + m3 * y2 + m5;
            return [x1, y1, x2, y2];
          },
        };

        const PDFOutline = /* #__PURE__ */(function () {
          function PDFOutline(document, parent, title, dest) {
            const options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
              expanded: false,
            };

            _classCallCheck(this, PDFOutline);

            this.document = document;
            this.options = options;
            this.outlineData = {};

            if (dest !== null) {
              this.outlineData.Dest = [dest.dictionary, 'Fit'];
            }

            if (parent !== null) {
              this.outlineData.Parent = parent;
            }

            if (title !== null) {
              this.outlineData.Title = new String(title);
            }

            this.dictionary = this.document.ref(this.outlineData);
            this.children = [];
          }

          _createClass(PDFOutline, [{
            key: 'addItem',
            value: function addItem(title) {
              const options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                expanded: false,
              };
              const result = new PDFOutline(this.document, this.dictionary, title, this.document.page, options);
              this.children.push(result);
              return result;
            },
          }, {
            key: 'endOutline',
            value: function endOutline() {
              if (this.children.length > 0) {
                if (this.options.expanded) {
                  this.outlineData.Count = this.children.length;
                }

                const first = this.children[0];
                const last = this.children[this.children.length - 1];
                this.outlineData.First = first.dictionary;
                this.outlineData.Last = last.dictionary;

                for (let i = 0, len = this.children.length; i < len; i++) {
                  const child = this.children[i];

                  if (i > 0) {
                    child.outlineData.Prev = this.children[i - 1].dictionary;
                  }

                  if (i < this.children.length - 1) {
                    child.outlineData.Next = this.children[i + 1].dictionary;
                  }

                  child.endOutline();
                }
              }

              return this.dictionary.end();
            },
          }]);

          return PDFOutline;
        }());

        const OutlineMixin = {
          initOutline: function initOutline() {
            return this.outline = new PDFOutline(this, null, null, null);
          },
          endOutline: function endOutline() {
            this.outline.endOutline();

            if (this.outline.children.length > 0) {
              this._root.data.Outlines = this.outline.dictionary;
              return this._root.data.PageMode = 'UseOutlines';
            }
          },
        };
        /*
PDFStructureContent - a reference to a marked structure content
By Ben Schmidt
*/

        const PDFStructureContent = /* #__PURE__ */(function () {
          function PDFStructureContent(pageRef, mcid) {
            _classCallCheck(this, PDFStructureContent);

            this.refs = [{
              pageRef,
              mcid,
            }];
          }

          _createClass(PDFStructureContent, [{
            key: 'push',
            value: function push(structContent) {
              const _this = this;

              structContent.refs.forEach((ref) => _this.refs.push(ref));
            },
          }]);

          return PDFStructureContent;
        }());

        const PDFStructureElement = /* #__PURE__ */(function () {
          function PDFStructureElement(document, type) {
            const _this = this;

            let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            let children = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

            _classCallCheck(this, PDFStructureElement);

            this.document = document;
            this._attached = false;
            this._ended = false;
            this._flushed = false;
            this.dictionary = document.ref({
              // Type: "StructElem",
              S: type,
            });
            const { data } = this.dictionary;

            if (Array.isArray(options) || this._isValidChild(options)) {
              children = options;
              options = {};
            }

            if (typeof options.title !== 'undefined') {
              data.T = new String(options.title);
            }

            if (typeof options.lang !== 'undefined') {
              data.Lang = new String(options.lang);
            }

            if (typeof options.alt !== 'undefined') {
              data.Alt = new String(options.alt);
            }

            if (typeof options.expanded !== 'undefined') {
              data.E = new String(options.expanded);
            }

            if (typeof options.actual !== 'undefined') {
              data.ActualText = new String(options.actual);
            }

            this._children = [];

            if (children) {
              if (!Array.isArray(children)) {
                children = [children];
              }

              children.forEach((child) => _this.add(child));
              this.end();
            }
          }

          _createClass(PDFStructureElement, [{
            key: 'add',
            value: function add(child) {
              if (this._ended) {
                throw new Error('Cannot add child to already-ended structure element');
              }

              if (!this._isValidChild(child)) {
                throw new Error('Invalid structure element child');
              }

              if (child instanceof PDFStructureElement) {
                child.setParent(this.dictionary);

                if (this._attached) {
                  child.setAttached();
                }
              }

              if (child instanceof PDFStructureContent) {
                this._addContentToParentTree(child);
              }

              if (typeof child === 'function' && this._attached) {
                // _contentForClosure() adds the content to the parent tree
                child = this._contentForClosure(child);
              }

              this._children.push(child);

              return this;
            },
          }, {
            key: '_addContentToParentTree',
            value: function _addContentToParentTree(content) {
              const _this2 = this;

              content.refs.forEach((_ref) => {
                const { pageRef } = _ref;
                const { mcid } = _ref;

                const pageStructParents = _this2.document.getStructParentTree().get(pageRef.data.StructParents);

                pageStructParents[mcid] = _this2.dictionary;
              });
            },
          }, {
            key: 'setParent',
            value: function setParent(parentRef) {
              if (this.dictionary.data.P) {
                throw new Error('Structure element added to more than one parent');
              }

              this.dictionary.data.P = parentRef;

              this._flush();
            },
          }, {
            key: 'setAttached',
            value: function setAttached() {
              const _this3 = this;

              if (this._attached) {
                return;
              }

              this._children.forEach((child, index) => {
                if (child instanceof PDFStructureElement) {
                  child.setAttached();
                }

                if (typeof child === 'function') {
                  _this3._children[index] = _this3._contentForClosure(child);
                }
              });

              this._attached = true;

              this._flush();
            },
          }, {
            key: 'end',
            value: function end() {
              if (this._ended) {
                return;
              }

              this._children.filter((child) => child instanceof PDFStructureElement).forEach((child) => child.end());

              this._ended = true;

              this._flush();
            },
          }, {
            key: '_isValidChild',
            value: function _isValidChild(child) {
              return child instanceof PDFStructureElement || child instanceof PDFStructureContent || typeof child === 'function';
            },
          }, {
            key: '_contentForClosure',
            value: function _contentForClosure(closure) {
              const content = this.document.markStructureContent(this.dictionary.data.S);
              closure();
              this.document.endMarkedContent();

              this._addContentToParentTree(content);

              return content;
            },
          }, {
            key: '_isFlushable',
            value: function _isFlushable() {
              if (!this.dictionary.data.P || !this._ended) {
                return false;
              }

              return this._children.every((child) => {
                if (typeof child === 'function') {
                  return false;
                }

                if (child instanceof PDFStructureElement) {
                  return child._isFlushable();
                }

                return true;
              });
            },
          }, {
            key: '_flush',
            value: function _flush() {
              const _this4 = this;

              if (this._flushed || !this._isFlushable()) {
                return;
              }

              this.dictionary.data.K = [];

              this._children.forEach((child) => _this4._flushChild(child));

              this.dictionary.end(); // free memory used by children; the dictionary itself may still be
              // referenced by a parent structure element or root, but we can
              // at least trim the tree here

              this._children = [];
              this.dictionary.data.K = null;
              this._flushed = true;
            },
          }, {
            key: '_flushChild',
            value: function _flushChild(child) {
              const _this5 = this;

              if (child instanceof PDFStructureElement) {
                this.dictionary.data.K.push(child.dictionary);
              }

              if (child instanceof PDFStructureContent) {
                child.refs.forEach((_ref2) => {
                  const { pageRef } = _ref2;
                  const { mcid } = _ref2;

                  if (!_this5.dictionary.data.Pg) {
                    _this5.dictionary.data.Pg = pageRef;
                  }

                  if (_this5.dictionary.data.Pg === pageRef) {
                    _this5.dictionary.data.K.push(mcid);
                  } else {
                    _this5.dictionary.data.K.push({
                      Type: 'MCR',
                      Pg: pageRef,
                      MCID: mcid,
                    });
                  }
                });
              }
            },
          }]);

          return PDFStructureElement;
        }());

        const PDFNumberTree = /* #__PURE__ */(function (_PDFTree) {
          _inherits(PDFNumberTree, _PDFTree);

          const _super = _createSuper(PDFNumberTree);

          function PDFNumberTree() {
            _classCallCheck(this, PDFNumberTree);

            return _super.apply(this, arguments);
          }

          _createClass(PDFNumberTree, [{
            key: '_compareKeys',
            value: function _compareKeys(a, b) {
              return parseInt(a) - parseInt(b);
            },
          }, {
            key: '_keysName',
            value: function _keysName() {
              return 'Nums';
            },
          }, {
            key: '_dataForKey',
            value: function _dataForKey(k) {
              return parseInt(k);
            },
          }]);

          return PDFNumberTree;
        }(PDFTree));

        const MarkingsMixin = {
          initMarkings: function initMarkings(options) {
            this.structChildren = [];

            if (options.tagged) {
              this.getMarkInfoDictionary().data.Marked = true;
              this.getStructTreeRoot();
            }
          },
          markContent: function markContent(tag) {
            const options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            if (tag === 'Artifact' || options && options.mcid) {
              let toClose = 0;
              this.page.markings.forEach((marking) => {
                if (toClose || marking.structContent || marking.tag === 'Artifact') {
                  toClose++;
                }
              });

              while (toClose--) {
                this.endMarkedContent();
              }
            }

            if (!options) {
              this.page.markings.push({
                tag,
              });
              this.addContent('/'.concat(tag, ' BMC'));
              return this;
            }

            this.page.markings.push({
              tag,
              options,
            });
            const dictionary = {};

            if (typeof options.mcid !== 'undefined') {
              dictionary.MCID = options.mcid;
            }

            if (tag === 'Artifact') {
              if (typeof options.type === 'string') {
                dictionary.Type = options.type;
              }

              if (Array.isArray(options.bbox)) {
                dictionary.BBox = [options.bbox[0], this.page.height - options.bbox[3], options.bbox[2], this.page.height - options.bbox[1]];
              }

              if (Array.isArray(options.attached) && options.attached.every((val) => typeof val === 'string')) {
                dictionary.Attached = options.attached;
              }
            }

            if (tag === 'Span') {
              if (options.lang) {
                dictionary.Lang = new String(options.lang);
              }

              if (options.alt) {
                dictionary.Alt = new String(options.alt);
              }

              if (options.expanded) {
                dictionary.E = new String(options.expanded);
              }

              if (options.actual) {
                dictionary.ActualText = new String(options.actual);
              }
            }

            this.addContent('/'.concat(tag, ' ').concat(PDFObject.convert(dictionary), ' BDC'));
            return this;
          },
          markStructureContent: function markStructureContent(tag) {
            const options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            const pageStructParents = this.getStructParentTree().get(this.page.structParentTreeKey);
            const mcid = pageStructParents.length;
            pageStructParents.push(null);
            this.markContent(tag, _objectSpread2(_objectSpread2({}, options), {}, {
              mcid,
            }));
            const structContent = new PDFStructureContent(this.page.dictionary, mcid);
            this.page.markings.slice(-1)[0].structContent = structContent;
            return structContent;
          },
          endMarkedContent: function endMarkedContent() {
            this.page.markings.pop();
            this.addContent('EMC');
            return this;
          },
          struct: function struct(type) {
            const options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            const children = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            return new PDFStructureElement(this, type, options, children);
          },
          addStructure: function addStructure(structElem) {
            const structTreeRoot = this.getStructTreeRoot();
            structElem.setParent(structTreeRoot);
            structElem.setAttached();
            this.structChildren.push(structElem);

            if (!structTreeRoot.data.K) {
              structTreeRoot.data.K = [];
            }

            structTreeRoot.data.K.push(structElem.dictionary);
            return this;
          },
          initPageMarkings: function initPageMarkings(pageMarkings) {
            const _this = this;

            pageMarkings.forEach((marking) => {
              if (marking.structContent) {
                const { structContent } = marking;

                const newStructContent = _this.markStructureContent(marking.tag, marking.options);

                structContent.push(newStructContent);
                _this.page.markings.slice(-1)[0].structContent = structContent;
              } else {
                _this.markContent(marking.tag, marking.options);
              }
            });
          },
          endPageMarkings: function endPageMarkings(page) {
            const pageMarkings = page.markings;
            pageMarkings.forEach(() => page.write('EMC'));
            page.markings = [];
            return pageMarkings;
          },
          getMarkInfoDictionary: function getMarkInfoDictionary() {
            if (!this._root.data.MarkInfo) {
              this._root.data.MarkInfo = this.ref({});
            }

            return this._root.data.MarkInfo;
          },
          getStructTreeRoot: function getStructTreeRoot() {
            if (!this._root.data.StructTreeRoot) {
              this._root.data.StructTreeRoot = this.ref({
                Type: 'StructTreeRoot',
                ParentTree: new PDFNumberTree(),
                ParentTreeNextKey: 0,
              });
            }

            return this._root.data.StructTreeRoot;
          },
          getStructParentTree: function getStructParentTree() {
            return this.getStructTreeRoot().data.ParentTree;
          },
          createStructParentTreeNextKey: function createStructParentTreeNextKey() {
            // initialise the MarkInfo dictionary
            this.getMarkInfoDictionary();
            const structTreeRoot = this.getStructTreeRoot();
            const key = structTreeRoot.data.ParentTreeNextKey++;
            structTreeRoot.data.ParentTree.add(key, []);
            return key;
          },
          endMarkings: function endMarkings() {
            const structTreeRoot = this._root.data.StructTreeRoot;

            if (structTreeRoot) {
              structTreeRoot.end();
              this.structChildren.forEach((structElem) => structElem.end());
            }

            if (this._root.data.MarkInfo) {
              this._root.data.MarkInfo.end();
            }
          },
        };
        const FIELD_FLAGS = {
          readOnly: 1,
          required: 2,
          noExport: 4,
          multiline: 0x1000,
          password: 0x2000,
          toggleToOffButton: 0x4000,
          radioButton: 0x8000,
          pushButton: 0x10000,
          combo: 0x20000,
          edit: 0x40000,
          sort: 0x80000,
          multiSelect: 0x200000,
          noSpell: 0x400000,
        };
        const FIELD_JUSTIFY = {
          left: 0,
          center: 1,
          right: 2,
        };
        const VALUE_MAP = {
          value: 'V',
          defaultValue: 'DV',
        };
        const FORMAT_SPECIAL = {
          zip: '0',
          zipPlus4: '1',
          zip4: '1',
          phone: '2',
          ssn: '3',
        };
        const FORMAT_DEFAULT = {
          number: {
            nDec: 0,
            sepComma: false,
            negStyle: 'MinusBlack',
            currency: '',
            currencyPrepend: true,
          },
          percent: {
            nDec: 0,
            sepComma: false,
          },
        };
        const AcroFormMixin = {
          /**
   * Must call if adding AcroForms to a document. Must also call font() before
   * this method to set the default font.
   */
          initForm: function initForm() {
            if (!this._font) {
              throw new Error('Must set a font before calling initForm method');
            }

            this._acroform = {
              fonts: {},
              defaultFont: this._font.name,
            };
            this._acroform.fonts[this._font.id] = this._font.ref();
            const data = {
              Fields: [],
              NeedAppearances: true,
              DA: new String('/'.concat(this._font.id, ' 0 Tf 0 g')),
              DR: {
                Font: {},
              },
            };
            data.DR.Font[this._font.id] = this._font.ref();
            const AcroForm = this.ref(data);
            this._root.data.AcroForm = AcroForm;
            return this;
          },

          /**
   * Called automatically by document.js
   */
          endAcroForm: function endAcroForm() {
            const _this = this;

            if (this._root.data.AcroForm) {
              if (!Object.keys(this._acroform.fonts).length && !this._acroform.defaultFont) {
                throw new Error('No fonts specified for PDF form');
              }

              const fontDict = this._root.data.AcroForm.data.DR.Font;
              Object.keys(this._acroform.fonts).forEach((name) => {
                fontDict[name] = _this._acroform.fonts[name];
              });

              this._root.data.AcroForm.data.Fields.forEach((fieldRef) => {
                _this._endChild(fieldRef);
              });

              this._root.data.AcroForm.end();
            }

            return this;
          },
          _endChild: function _endChild(ref) {
            const _this2 = this;

            if (Array.isArray(ref.data.Kids)) {
              ref.data.Kids.forEach((childRef) => {
                _this2._endChild(childRef);
              });
              ref.end();
            }

            return this;
          },

          /**
   * Creates and adds a form field to the document. Form fields are intermediate
   * nodes in a PDF form that are used to specify form name heirarchy and form
   * value defaults.
   * @param {string} name - field name (T attribute in field dictionary)
   * @param {object} options  - other attributes to include in field dictionary
   */
          formField: function formField(name) {
            const options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            const fieldDict = this._fieldDict(name, null, options);

            const fieldRef = this.ref(fieldDict);

            this._addToParent(fieldRef);

            return fieldRef;
          },

          /**
   * Creates and adds a Form Annotation to the document. Form annotations are
   * called Widget annotations internally within a PDF file.
   * @param {string} name - form field name (T attribute of widget annotation
   * dictionary)
   * @param {number} x
   * @param {number} y
   * @param {number} w
   * @param {number} h
   * @param {object} options
   */
          formAnnotation: function formAnnotation(name, type, x, y, w, h) {
            const options = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

            const fieldDict = this._fieldDict(name, type, options);

            fieldDict.Subtype = 'Widget';

            if (fieldDict.F === undefined) {
              fieldDict.F = 4; // print the annotation
            } // Add Field annot to page, and get it's ref

            this.annotate(x, y, w, h, fieldDict);
            const annotRef = this.page.annotations[this.page.annotations.length - 1];
            return this._addToParent(annotRef);
          },
          formText: function formText(name, x, y, w, h) {
            const options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
            return this.formAnnotation(name, 'text', x, y, w, h, options);
          },
          formPushButton: function formPushButton(name, x, y, w, h) {
            const options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
            return this.formAnnotation(name, 'pushButton', x, y, w, h, options);
          },
          formCombo: function formCombo(name, x, y, w, h) {
            const options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
            return this.formAnnotation(name, 'combo', x, y, w, h, options);
          },
          formList: function formList(name, x, y, w, h) {
            const options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
            return this.formAnnotation(name, 'list', x, y, w, h, options);
          },
          formRadioButton: function formRadioButton(name, x, y, w, h) {
            const options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
            return this.formAnnotation(name, 'radioButton', x, y, w, h, options);
          },
          formCheckbox: function formCheckbox(name, x, y, w, h) {
            const options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
            return this.formAnnotation(name, 'checkbox', x, y, w, h, options);
          },
          _addToParent: function _addToParent(fieldRef) {
            const parent = fieldRef.data.Parent;

            if (parent) {
              if (!parent.data.Kids) {
                parent.data.Kids = [];
              }

              parent.data.Kids.push(fieldRef);
            } else {
              this._root.data.AcroForm.data.Fields.push(fieldRef);
            }

            return this;
          },
          _fieldDict: function _fieldDict(name, type) {
            const options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            if (!this._acroform) {
              throw new Error('Call document.initForms() method before adding form elements to document');
            }

            let opts = { ...options };

            if (type !== null) {
              opts = this._resolveType(type, options);
            }

            opts = this._resolveFlags(opts);
            opts = this._resolveJustify(opts);
            opts = this._resolveFont(opts);
            opts = this._resolveStrings(opts);
            opts = this._resolveColors(opts);
            opts = this._resolveFormat(opts);
            opts.T = new String(name);

            if (opts.parent) {
              opts.Parent = opts.parent;
              delete opts.parent;
            }

            return opts;
          },
          _resolveType: function _resolveType(type, opts) {
            if (type === 'text') {
              opts.FT = 'Tx';
            } else if (type === 'pushButton') {
              opts.FT = 'Btn';
              opts.pushButton = true;
            } else if (type === 'radioButton') {
              opts.FT = 'Btn';
              opts.radioButton = true;
            } else if (type === 'checkbox') {
              opts.FT = 'Btn';
            } else if (type === 'combo') {
              opts.FT = 'Ch';
              opts.combo = true;
            } else if (type === 'list') {
              opts.FT = 'Ch';
            } else {
              throw new Error("Invalid form annotation type '".concat(type, "'"));
            }

            return opts;
          },
          _resolveFormat: function _resolveFormat(opts) {
            const f = opts.format;

            if (f && f.type) {
              let fnKeystroke;
              let fnFormat;
              let params = '';

              if (FORMAT_SPECIAL[f.type] !== undefined) {
                fnKeystroke = 'AFSpecial_Keystroke';
                fnFormat = 'AFSpecial_Format';
                params = FORMAT_SPECIAL[f.type];
              } else {
                const format = f.type.charAt(0).toUpperCase() + f.type.slice(1);
                fnKeystroke = 'AF'.concat(format, '_Keystroke');
                fnFormat = 'AF'.concat(format, '_Format');

                if (f.type === 'date') {
                  fnKeystroke += 'Ex';
                  params = String(f.param);
                } else if (f.type === 'time') {
                  params = String(f.param);
                } else if (f.type === 'number') {
                  const p = { ...FORMAT_DEFAULT.number, ...f };
                  params = String([String(p.nDec), p.sepComma ? '0' : '1', `"${p.negStyle}"`, 'null', `"${p.currency}"`, String(p.currencyPrepend)].join(','));
                } else if (f.type === 'percent') {
                  const _p = { ...FORMAT_DEFAULT.percent, ...f };

                  params = String([String(_p.nDec), _p.sepComma ? '0' : '1'].join(','));
                }
              }

              opts.AA = opts.AA ? opts.AA : {};
              opts.AA.K = {
                S: 'JavaScript',
                JS: new String(''.concat(fnKeystroke, '(').concat(params, ');')),
              };
              opts.AA.F = {
                S: 'JavaScript',
                JS: new String(''.concat(fnFormat, '(').concat(params, ');')),
              };
            }

            delete opts.format;
            return opts;
          },
          _resolveColors: function _resolveColors(opts) {
            let color = this._normalizeColor(opts.backgroundColor);

            if (color) {
              if (!opts.MK) {
                opts.MK = {};
              }

              opts.MK.BG = color;
            }

            color = this._normalizeColor(opts.borderColor);

            if (color) {
              if (!opts.MK) {
                opts.MK = {};
              }

              opts.MK.BC = color;
            }

            delete opts.backgroundColor;
            delete opts.borderColor;
            return opts;
          },
          _resolveFlags: function _resolveFlags(options) {
            let result = 0;
            Object.keys(options).forEach((key) => {
              if (FIELD_FLAGS[key]) {
                result |= FIELD_FLAGS[key];
                delete options[key];
              }
            });

            if (result !== 0) {
              options.Ff = options.Ff ? options.Ff : 0;
              options.Ff |= result;
            }

            return options;
          },
          _resolveJustify: function _resolveJustify(options) {
            let result = 0;

            if (options.align !== undefined) {
              if (typeof FIELD_JUSTIFY[options.align] === 'number') {
                result = FIELD_JUSTIFY[options.align];
              }

              delete options.align;
            }

            if (result !== 0) {
              options.Q = result; // default
            }

            return options;
          },
          _resolveFont: function _resolveFont(options) {
            // add current font to document-level AcroForm dict if necessary
            if (this._acroform.fonts[this._font.id] === null) {
              this._acroform.fonts[this._font.id] = this._font.ref();
            } // add current font to field's resource dict (RD) if not the default acroform font

            if (this._acroform.defaultFont !== this._font.name) {
              options.DR = {
                Font: {},
              }; // Get the fontSize option. If not set use auto sizing

              const fontSize = options.fontSize || 0;
              options.DR.Font[this._font.id] = this._font.ref();
              options.DA = new String('/'.concat(this._font.id, ' ').concat(fontSize, ' Tf 0 g'));
            }

            return options;
          },
          _resolveStrings: function _resolveStrings(options) {
            const select = [];

            function appendChoices(a) {
              if (Array.isArray(a)) {
                for (let idx = 0; idx < a.length; idx++) {
                  if (typeof a[idx] === 'string') {
                    select.push(new String(a[idx]));
                  } else {
                    select.push(a[idx]);
                  }
                }
              }
            }

            appendChoices(options.Opt);

            if (options.select) {
              appendChoices(options.select);
              delete options.select;
            }

            if (select.length) {
              options.Opt = select;
            }

            Object.keys(VALUE_MAP).forEach((key) => {
              if (options[key] !== undefined) {
                options[VALUE_MAP[key]] = options[key];
                delete options[key];
              }
            });
            ['V', 'DV'].forEach((key) => {
              if (typeof options[key] === 'string') {
                options[key] = new String(options[key]);
              }
            });

            if (options.MK && options.MK.CA) {
              options.MK.CA = new String(options.MK.CA);
            }

            if (options.label) {
              options.MK = options.MK ? options.MK : {};
              options.MK.CA = new String(options.label);
              delete options.label;
            }

            return options;
          },
        };
        const AttachmentsMixin = {
          /**
   * Embed contents of `src` in PDF
   * @param {Buffer | ArrayBuffer | string} src input Buffer, ArrayBuffer, base64 encoded string or path to file
   * @param {object} options
   *  * options.name: filename to be shown in PDF, will use `src` if none set
   *  * options.type: filetype to be shown in PDF
   *  * options.description: description to be shown in PDF
   *  * options.hidden: if true, do not add attachment to EmbeddedFiles dictionary. Useful for file attachment annotations
   *  * options.creationDate: override creation date
   *  * options.modifiedDate: override modified date
   * @returns filespec reference
   */
          file: function file(src) {
            const options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            options.name = options.name || src;
            const refBody = {
              Type: 'EmbeddedFile',
              Params: {},
            };
            let data;

            if (!src) {
              throw new Error('No src specified');
            }

            if (Buffer.isBuffer(src)) {
              data = src;
            } else if (src instanceof ArrayBuffer) {
              data = Buffer.from(new Uint8Array(src));
            } else {
              let match;

              if (match = /^data:(.*);base64,(.*)$/.exec(src)) {
                if (match[1]) {
                  refBody.Subtype = match[1].replace('/', '#2F');
                }

                data = Buffer.from(match[2], 'base64');
              } else {
                data = fs.readFileSync(src);

                if (!data) {
                  throw new Error('Could not read contents of file at filepath '.concat(src));
                } // update CreationDate and ModDate

                const _fs$statSync = fs.statSync(src);
                const { birthtime } = _fs$statSync;
                const { ctime } = _fs$statSync;

                refBody.Params.CreationDate = birthtime;
                refBody.Params.ModDate = ctime;
              }
            } // override creation date and modified date

            if (options.creationDate instanceof Date) {
              refBody.Params.CreationDate = options.creationDate;
            }

            if (options.modifiedDate instanceof Date) {
              refBody.Params.ModDate = options.modifiedDate;
            } // add optional subtype

            if (options.type) {
              refBody.Subtype = options.type.replace('/', '#2F');
            } // add checksum and size information

            const checksum = _cryptoJs.default.MD5(_cryptoJs.default.lib.WordArray.create(new Uint8Array(data)));

            refBody.Params.CheckSum = new String(checksum);
            refBody.Params.Size = data.byteLength; // save some space when embedding the same file again
            // if a file with the same name and metadata exists, reuse its reference

            let ref;
            if (!this._fileRegistry) this._fileRegistry = {};
            const file = this._fileRegistry[options.name];

            if (file && isEqual(refBody, file)) {
              ref = file.ref;
            } else {
              ref = this.ref(refBody);
              ref.end(data);
              this._fileRegistry[options.name] = _objectSpread2(_objectSpread2({}, refBody), {}, {
                ref,
              });
            } // add filespec for embedded file

            const fileSpecBody = {
              Type: 'Filespec',
              F: new String(options.name),
              EF: {
                F: ref,
              },
              UF: new String(options.name),
            };

            if (options.description) {
              fileSpecBody.Desc = new String(options.description);
            }

            const filespec = this.ref(fileSpecBody);
            filespec.end();

            if (!options.hidden) {
              this.addNamedEmbeddedFile(options.name, filespec);
            }

            return filespec;
          },
        };
        /** check two embedded file metadata objects for equality */

        function isEqual(a, b) {
          return a.Subtype === b.Subtype && a.Params.CheckSum.toString() === b.Params.CheckSum.toString() && a.Params.Size === b.Params.Size && a.Params.CreationDate === b.Params.CreationDate && a.Params.ModDate === b.Params.ModDate;
        }

        const PDFDocument = /* #__PURE__ */(function (_stream$Readable) {
          _inherits(PDFDocument, _stream$Readable);

          const _super = _createSuper(PDFDocument);

          function PDFDocument() {
            let _this;

            const options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            _classCallCheck(this, PDFDocument);

            _this = _super.call(this, options);
            _this.options = options; // PDF version

            switch (options.pdfVersion) {
              case '1.4':
                _this.version = 1.4;
                break;

              case '1.5':
                _this.version = 1.5;
                break;

              case '1.6':
                _this.version = 1.6;
                break;

              case '1.7':
              case '1.7ext3':
                _this.version = 1.7;
                break;

              default:
                _this.version = 1.3;
                break;
            } // Whether streams should be compressed

            _this.compress = _this.options.compress != null ? _this.options.compress : true;
            _this._pageBuffer = [];
            _this._pageBufferStart = 0; // The PDF object store

            _this._offsets = [];
            _this._waiting = 0;
            _this._ended = false;
            _this._offset = 0;

            const Pages = _this.ref({
              Type: 'Pages',
              Count: 0,
              Kids: [],
            });

            const Names = _this.ref({
              Dests: new PDFNameTree(),
            });

            _this._root = _this.ref({
              Type: 'Catalog',
              Pages,
              Names,
            });

            if (_this.options.lang) {
              _this._root.data.Lang = new String(_this.options.lang);
            } // The current page

            _this.page = null; // Initialize mixins

            _this.initColor();

            _this.initVector();

            _this.initFonts(options.font);

            _this.initText();

            _this.initImages();

            _this.initOutline();

            _this.initMarkings(options); // Initialize the metadata

            _this.info = {
              Producer: 'PDFKit',
              Creator: 'PDFKit',
              CreationDate: new Date(),
            };

            if (_this.options.info) {
              for (const key in _this.options.info) {
                const val = _this.options.info[key];
                _this.info[key] = val;
              }
            }

            if (_this.options.displayTitle) {
              _this._root.data.ViewerPreferences = _this.ref({
                DisplayDocTitle: true,
              });
            } // Generate file ID

            _this._id = PDFSecurity.generateFileID(_this.info); // Initialize security settings

            _this._security = PDFSecurity.create(_assertThisInitialized(_this), options); // Write the header
            // PDF version

            _this._write('%PDF-'.concat(_this.version)); // 4 binary chars, as recommended by the spec

            _this._write('%\xFF\xFF\xFF\xFF'); // Add the first page

            if (_this.options.autoFirstPage !== false) {
              _this.addPage();
            }

            return _this;
          }

          _createClass(PDFDocument, [{
            key: 'addPage',
            value: function addPage(options) {
              if (options == null) {
                options = this.options;
              } // end the current page if needed

              if (!this.options.bufferPages) {
                this.flushPages();
              } // create a page object

              this.page = new PDFPage(this, options);

              this._pageBuffer.push(this.page); // add the page to the object store

              const pages = this._root.data.Pages.data;
              pages.Kids.push(this.page.dictionary);
              pages.Count++; // reset x and y coordinates

              this.x = this.page.margins.left;
              this.y = this.page.margins.top; // flip PDF coordinate system so that the origin is in
              // the top left rather than the bottom left

              this._ctm = [1, 0, 0, 1, 0, 0];
              this.transform(1, 0, 0, -1, 0, this.page.height);
              this.emit('pageAdded');
              return this;
            },
          }, {
            key: 'continueOnNewPage',
            value: function continueOnNewPage(options) {
              const pageMarkings = this.endPageMarkings(this.page);
              this.addPage(options);
              this.initPageMarkings(pageMarkings);
              return this;
            },
          }, {
            key: 'bufferedPageRange',
            value: function bufferedPageRange() {
              return {
                start: this._pageBufferStart,
                count: this._pageBuffer.length,
              };
            },
          }, {
            key: 'switchToPage',
            value: function switchToPage(n) {
              let page;

              if (!(page = this._pageBuffer[n - this._pageBufferStart])) {
                throw new Error('switchToPage('.concat(n, ') out of bounds, current buffer covers pages ').concat(this._pageBufferStart, ' to ').concat(this._pageBufferStart + this._pageBuffer.length - 1));
              }

              return this.page = page;
            },
          }, {
            key: 'flushPages',
            value: function flushPages() {
              // this local variable exists so we're future-proof against
              // reentrant calls to flushPages.
              const pages = this._pageBuffer;
              this._pageBuffer = [];
              this._pageBufferStart += pages.length;

              const _iterator = _createForOfIteratorHelper(pages);
              let _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  const page = _step.value;
                  this.endPageMarkings(page);
                  page.end();
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            },
          }, {
            key: 'addNamedDestination',
            value: function addNamedDestination(name) {
              for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
              }

              if (args.length === 0) {
                args = ['XYZ', null, null, null];
              }

              if (args[0] === 'XYZ' && args[2] !== null) {
                args[2] = this.page.height - args[2];
              }

              args.unshift(this.page.dictionary);

              this._root.data.Names.data.Dests.add(name, args);
            },
          }, {
            key: 'addNamedEmbeddedFile',
            value: function addNamedEmbeddedFile(name, ref) {
              if (!this._root.data.Names.data.EmbeddedFiles) {
                // disabling /Limits for this tree fixes attachments not showing in Adobe Reader
                this._root.data.Names.data.EmbeddedFiles = new PDFNameTree({
                  limits: false,
                });
              } // add filespec to EmbeddedFiles

              this._root.data.Names.data.EmbeddedFiles.add(name, ref);
            },
          }, {
            key: 'addNamedJavaScript',
            value: function addNamedJavaScript(name, js) {
              if (!this._root.data.Names.data.JavaScript) {
                this._root.data.Names.data.JavaScript = new PDFNameTree();
              }

              const data = {
                JS: new String(js),
                S: 'JavaScript',
              };

              this._root.data.Names.data.JavaScript.add(name, data);
            },
          }, {
            key: 'ref',
            value: function ref(data) {
              const ref = new PDFReference(this, this._offsets.length + 1, data);

              this._offsets.push(null); // placeholder for this object's offset once it is finalized

              this._waiting++;
              return ref;
            },
          }, {
            key: '_read',
            value: function _read() {}, // do nothing, but this method is required by node

          }, {
            key: '_write',
            value: function _write(data) {
              if (!Buffer.isBuffer(data)) {
                data = Buffer.from(`${data}\n`, 'binary');
              }

              this.push(data);
              return this._offset += data.length;
            },
          }, {
            key: 'addContent',
            value: function addContent(data) {
              this.page.write(data);
              return this;
            },
          }, {
            key: '_refEnd',
            value: function _refEnd(ref) {
              this._offsets[ref.id - 1] = ref.offset;

              if (--this._waiting === 0 && this._ended) {
                this._finalize();

                return this._ended = false;
              }
            },
          }, {
            key: 'write',
            value: function write(filename, fn) {
              // print a deprecation warning with a stacktrace
              const err = new Error('PDFDocument#write is deprecated, and will be removed in a future version of PDFKit. Please pipe the document into a Node stream.');
              console.warn(err.stack);
              this.pipe(fs.createWriteStream(filename));
              this.end();
              return this.once('end', fn);
            },
          }, {
            key: 'end',
            value: function end() {
              this.flushPages();
              this._info = this.ref();

              for (const key in this.info) {
                let val = this.info[key];

                if (typeof val === 'string') {
                  val = new String(val);
                }

                const entry = this.ref(val);
                entry.end();
                this._info.data[key] = entry;
              }

              this._info.end();

              for (const name in this._fontFamilies) {
                const font = this._fontFamilies[name];
                font.finalize();
              }

              this.endOutline();
              this.endMarkings();

              this._root.end();

              this._root.data.Pages.end();

              this._root.data.Names.end();

              this.endAcroForm();

              if (this._root.data.ViewerPreferences) {
                this._root.data.ViewerPreferences.end();
              }

              if (this._security) {
                this._security.end();
              }

              if (this._waiting === 0) {
                return this._finalize();
              }
              return this._ended = true;
            },
          }, {
            key: '_finalize',
            value: function _finalize() {
              // generate xref
              const xRefOffset = this._offset;

              this._write('xref');

              this._write('0 '.concat(this._offsets.length + 1));

              this._write('0000000000 65535 f ');

              const _iterator2 = _createForOfIteratorHelper(this._offsets);
              let _step2;

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  let offset = _step2.value;
                  offset = '0000000000'.concat(offset).slice(-10);

                  this._write(`${offset} 00000 n `);
                } // trailer
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }

              const trailer = {
                Size: this._offsets.length + 1,
                Root: this._root,
                Info: this._info,
                ID: [this._id, this._id],
              };

              if (this._security) {
                trailer.Encrypt = this._security.dictionary;
              }

              this._write('trailer');

              this._write(PDFObject.convert(trailer));

              this._write('startxref');

              this._write(''.concat(xRefOffset));

              this._write('%%EOF'); // end the stream

              return this.push(null);
            },
          }, {
            key: 'toString',
            value: function toString() {
              return '[object PDFDocument]';
            },
          }]);

          return PDFDocument;
        }(_stream.default.Readable));

        const mixin = function mixin(methods) {
          Object.assign(PDFDocument.prototype, methods);
        };

        mixin(ColorMixin);
        mixin(VectorMixin);
        mixin(FontsMixin);
        mixin(TextMixin);
        mixin(ImagesMixin);
        mixin(AnnotationsMixin);
        mixin(OutlineMixin);
        mixin(MarkingsMixin);
        mixin(AcroFormMixin);
        mixin(AttachmentsMixin);
        PDFDocument.LineWrapper = LineWrapper;
        const _default = PDFDocument;
        exports.default = _default;
        /***/ }),

      /***/ 9160:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        Object.defineProperty(exports, '__esModule', ({
          value: true,
        }));
        exports.default = void 0;

        __webpack_require__(4256);

        const _unicodeTrie = _interopRequireDefault(__webpack_require__(4781));

        const _base64Js = _interopRequireDefault(__webpack_require__(9742));

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

        const categories = ['Cc', 'Zs', 'Po', 'Sc', 'Ps', 'Pe', 'Sm', 'Pd', 'Nd', 'Lu', 'Sk', 'Pc', 'Ll', 'So', 'Lo', 'Pi', 'Cf', 'No', 'Pf', 'Lt', 'Lm', 'Mn', 'Me', 'Mc', 'Nl', 'Zl', 'Zp', 'Cs', 'Co'];
        const combiningClasses = ['Not_Reordered', 'Above', 'Above_Right', 'Below', 'Attached_Above_Right', 'Attached_Below', 'Overlay', 'Iota_Subscript', 'Double_Below', 'Double_Above', 'Below_Right', 'Above_Left', 'CCC10', 'CCC11', 'CCC12', 'CCC13', 'CCC14', 'CCC15', 'CCC16', 'CCC17', 'CCC18', 'CCC19', 'CCC20', 'CCC21', 'CCC22', 'CCC23', 'CCC24', 'CCC25', 'CCC30', 'CCC31', 'CCC32', 'CCC27', 'CCC28', 'CCC29', 'CCC33', 'CCC34', 'CCC35', 'CCC36', 'Nukta', 'Virama', 'CCC84', 'CCC91', 'CCC103', 'CCC107', 'CCC118', 'CCC122', 'CCC129', 'CCC130', 'CCC132', 'Attached_Above', 'Below_Left', 'Left', 'Kana_Voicing', 'CCC26', 'Right'];
        const scripts = ['Common', 'Latin', 'Bopomofo', 'Inherited', 'Greek', 'Coptic', 'Cyrillic', 'Armenian', 'Hebrew', 'Arabic', 'Syriac', 'Thaana', 'Nko', 'Samaritan', 'Mandaic', 'Devanagari', 'Bengali', 'Gurmukhi', 'Gujarati', 'Oriya', 'Tamil', 'Telugu', 'Kannada', 'Malayalam', 'Sinhala', 'Thai', 'Lao', 'Tibetan', 'Myanmar', 'Georgian', 'Hangul', 'Ethiopic', 'Cherokee', 'Canadian_Aboriginal', 'Ogham', 'Runic', 'Tagalog', 'Hanunoo', 'Buhid', 'Tagbanwa', 'Khmer', 'Mongolian', 'Limbu', 'Tai_Le', 'New_Tai_Lue', 'Buginese', 'Tai_Tham', 'Balinese', 'Sundanese', 'Batak', 'Lepcha', 'Ol_Chiki', 'Braille', 'Glagolitic', 'Tifinagh', 'Han', 'Hiragana', 'Katakana', 'Yi', 'Lisu', 'Vai', 'Bamum', 'Syloti_Nagri', 'Phags_Pa', 'Saurashtra', 'Kayah_Li', 'Rejang', 'Javanese', 'Cham', 'Tai_Viet', 'Meetei_Mayek', 'null', 'Linear_B', 'Lycian', 'Carian', 'Old_Italic', 'Gothic', 'Old_Permic', 'Ugaritic', 'Old_Persian', 'Deseret', 'Shavian', 'Osmanya', 'Osage', 'Elbasan', 'Caucasian_Albanian', 'Linear_A', 'Cypriot', 'Imperial_Aramaic', 'Palmyrene', 'Nabataean', 'Hatran', 'Phoenician', 'Lydian', 'Meroitic_Hieroglyphs', 'Meroitic_Cursive', 'Kharoshthi', 'Old_South_Arabian', 'Old_North_Arabian', 'Manichaean', 'Avestan', 'Inscriptional_Parthian', 'Inscriptional_Pahlavi', 'Psalter_Pahlavi', 'Old_Turkic', 'Old_Hungarian', 'Hanifi_Rohingya', 'Old_Sogdian', 'Sogdian', 'Elymaic', 'Brahmi', 'Kaithi', 'Sora_Sompeng', 'Chakma', 'Mahajani', 'Sharada', 'Khojki', 'Multani', 'Khudawadi', 'Grantha', 'Newa', 'Tirhuta', 'Siddham', 'Modi', 'Takri', 'Ahom', 'Dogra', 'Warang_Citi', 'Nandinagari', 'Zanabazar_Square', 'Soyombo', 'Pau_Cin_Hau', 'Bhaiksuki', 'Marchen', 'Masaram_Gondi', 'Gunjala_Gondi', 'Makasar', 'Cuneiform', 'Egyptian_Hieroglyphs', 'Anatolian_Hieroglyphs', 'Mro', 'Bassa_Vah', 'Pahawh_Hmong', 'Medefaidrin', 'Miao', 'Tangut', 'Nushu', 'Duployan', 'SignWriting', 'Nyiakeng_Puachue_Hmong', 'Wancho', 'Mende_Kikakui', 'Adlam'];
        const eaw = ['N', 'Na', 'A', 'W', 'H', 'F'];
        const data = {
          categories,
          combiningClasses,
          scripts,
          eaw,
        };
        const data$1 = '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';
        const trieData = {
          data: data$1,
        };

        const log2 = Math.log2 || function (n) {
          return Math.log(n) / Math.LN2;
        };

        const bits = function bits(n) {
          return log2(n) + 1 | 0;
        };

        const buildUnicodeProperties = function buildUnicodeProperties(data, trie) {
          // compute the number of bits stored for each field
          const CATEGORY_BITS = bits(data.categories.length - 1);
          const COMBINING_BITS = bits(data.combiningClasses.length - 1);
          const SCRIPT_BITS = bits(data.scripts.length - 1);
          const EAW_BITS = bits(data.eaw.length - 1);
          const NUMBER_BITS = 10; // compute shift and mask values for each field

          const CATEGORY_SHIFT = COMBINING_BITS + SCRIPT_BITS + EAW_BITS + NUMBER_BITS;
          const COMBINING_SHIFT = SCRIPT_BITS + EAW_BITS + NUMBER_BITS;
          const SCRIPT_SHIFT = EAW_BITS + NUMBER_BITS;
          const EAW_SHIFT = NUMBER_BITS;
          const CATEGORY_MASK = (1 << CATEGORY_BITS) - 1;
          const COMBINING_MASK = (1 << COMBINING_BITS) - 1;
          const SCRIPT_MASK = (1 << SCRIPT_BITS) - 1;
          const EAW_MASK = (1 << EAW_BITS) - 1;
          const NUMBER_MASK = (1 << NUMBER_BITS) - 1;

          const getCategory = function getCategory(codePoint) {
            const val = trie.get(codePoint);
            return data.categories[val >> CATEGORY_SHIFT & CATEGORY_MASK];
          };

          const getCombiningClass = function getCombiningClass(codePoint) {
            const val = trie.get(codePoint);
            return data.combiningClasses[val >> COMBINING_SHIFT & COMBINING_MASK];
          };

          const getScript = function getScript(codePoint) {
            const val = trie.get(codePoint);
            return data.scripts[val >> SCRIPT_SHIFT & SCRIPT_MASK];
          };

          const getEastAsianWidth = function getEastAsianWidth(codePoint) {
            const val = trie.get(codePoint);
            return data.eaw[val >> EAW_SHIFT & EAW_MASK];
          };

          const getNumericValue = function getNumericValue(codePoint) {
            let val = trie.get(codePoint);
            const num = val & NUMBER_MASK;

            if (num === 0) {
              return null;
            } if (num <= 50) {
              return num - 1;
            } if (num < 0x1e0) {
              const numerator = (num >> 4) - 12;
              const denominator = (num & 0xf) + 1;
              return numerator / denominator;
            } if (num < 0x300) {
              val = (num >> 5) - 14;
              let exp = (num & 0x1f) + 2;

              while (exp > 0) {
                val *= 10;
                exp--;
              }

              return val;
            }
            val = (num >> 2) - 0xbf;

            let _exp = (num & 3) + 1;

            while (_exp > 0) {
              val *= 60;
              _exp--;
            }

            return val;
          };

          const isAlphabetic = function isAlphabetic(codePoint) {
            const category = getCategory(codePoint);
            return category === 'Lu' || category === 'Ll' || category === 'Lt' || category === 'Lm' || category === 'Lo' || category === 'Nl';
          };

          const isDigit = function isDigit(codePoint) {
            return getCategory(codePoint) === 'Nd';
          };

          const isPunctuation = function isPunctuation(codePoint) {
            const category = getCategory(codePoint);
            return category === 'Pc' || category === 'Pd' || category === 'Pe' || category === 'Pf' || category === 'Pi' || category === 'Po' || category === 'Ps';
          };

          const isLowerCase = function isLowerCase(codePoint) {
            return getCategory(codePoint) === 'Ll';
          };

          const isUpperCase = function isUpperCase(codePoint) {
            return getCategory(codePoint) === 'Lu';
          };

          const isTitleCase = function isTitleCase(codePoint) {
            return getCategory(codePoint) === 'Lt';
          };

          const isWhiteSpace = function isWhiteSpace(codePoint) {
            const category = getCategory(codePoint);
            return category === 'Zs' || category === 'Zl' || category === 'Zp';
          };

          const isBaseForm = function isBaseForm(codePoint) {
            const category = getCategory(codePoint);
            return category === 'Nd' || category === 'No' || category === 'Nl' || category === 'Lu' || category === 'Ll' || category === 'Lt' || category === 'Lm' || category === 'Lo' || category === 'Me' || category === 'Mc';
          };

          const isMark = function isMark(codePoint) {
            const category = getCategory(codePoint);
            return category === 'Mn' || category === 'Me' || category === 'Mc';
          };

          return {
            getCategory,
            getCombiningClass,
            getScript,
            getEastAsianWidth,
            getNumericValue,
            isAlphabetic,
            isDigit,
            isPunctuation,
            isLowerCase,
            isUpperCase,
            isTitleCase,
            isWhiteSpace,
            isBaseForm,
            isMark,
          };
        };

        const trie = new _unicodeTrie.default(_base64Js.default.toByteArray(trieData.data));
        const unicodeProperties = buildUnicodeProperties(data, trie);
        const _default = unicodeProperties;
        exports.default = _default;
        /***/ }),

      /***/ 4781:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        __webpack_require__(7042);

        __webpack_require__(6992);

        __webpack_require__(1539);

        __webpack_require__(2472);

        __webpack_require__(2990);

        __webpack_require__(8927);

        __webpack_require__(3105);

        __webpack_require__(5035);

        __webpack_require__(4345);

        __webpack_require__(7174);

        __webpack_require__(2846);

        __webpack_require__(4731);

        __webpack_require__(7209);

        __webpack_require__(6319);

        __webpack_require__(8867);

        __webpack_require__(7789);

        __webpack_require__(3739);

        __webpack_require__(9368);

        __webpack_require__(4483);

        __webpack_require__(2056);

        __webpack_require__(3462);

        __webpack_require__(678);

        __webpack_require__(7462);

        __webpack_require__(3824);

        __webpack_require__(5021);

        __webpack_require__(2974);

        __webpack_require__(5016);

        __webpack_require__(9135);

        const inflate = __webpack_require__(311);

        const _require = __webpack_require__(1753);
        const { swap32LE } = _require; // Shift size for getting the index-1 table offset.

        const SHIFT_1 = 6 + 5; // Shift size for getting the index-2 table offset.

        const SHIFT_2 = 5; // Difference between the two shift sizes,
        // for getting an index-1 offset from an index-2 offset. 6=11-5

        const SHIFT_1_2 = SHIFT_1 - SHIFT_2; // Number of index-1 entries for the BMP. 32=0x20
        // This part of the index-1 table is omitted from the serialized form.

        const OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> SHIFT_1; // Number of entries in an index-2 block. 64=0x40

        const INDEX_2_BLOCK_LENGTH = 1 << SHIFT_1_2; // Mask for getting the lower bits for the in-index-2-block offset. */

        const INDEX_2_MASK = INDEX_2_BLOCK_LENGTH - 1; // Shift size for shifting left the index array values.
        // Increases possible data size with 16-bit index values at the cost
        // of compactability.
        // This requires data blocks to be aligned by DATA_GRANULARITY.

        const INDEX_SHIFT = 2; // Number of entries in a data block. 32=0x20

        const DATA_BLOCK_LENGTH = 1 << SHIFT_2; // Mask for getting the lower bits for the in-data-block offset.

        const DATA_MASK = DATA_BLOCK_LENGTH - 1; // The part of the index-2 table for U+D800..U+DBFF stores values for
        // lead surrogate code _units_ not code _points_.
        // Values for lead surrogate code _points_ are indexed with this portion of the table.
        // Length=32=0x20=0x400>>SHIFT_2. (There are 1024=0x400 lead surrogates.)

        const LSCP_INDEX_2_OFFSET = 0x10000 >> SHIFT_2;
        const LSCP_INDEX_2_LENGTH = 0x400 >> SHIFT_2; // Count the lengths of both BMP pieces. 2080=0x820

        const INDEX_2_BMP_LENGTH = LSCP_INDEX_2_OFFSET + LSCP_INDEX_2_LENGTH; // The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
        // Length 32=0x20 for lead bytes C0..DF, regardless of SHIFT_2.

        const UTF8_2B_INDEX_2_OFFSET = INDEX_2_BMP_LENGTH;
        const UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; // U+0800 is the first code point after 2-byte UTF-8
        // The index-1 table, only used for supplementary code points, at offset 2112=0x840.
        // Variable length, for code points up to highStart, where the last single-value range starts.
        // Maximum length 512=0x200=0x100000>>SHIFT_1.
        // (For 0x100000 supplementary code points U+10000..U+10ffff.)
        //
        // The part of the index-2 table for supplementary code points starts
        // after this index-1 table.
        //
        // Both the index-1 table and the following part of the index-2 table
        // are omitted completely if there is only BMP data.

        const INDEX_1_OFFSET = UTF8_2B_INDEX_2_OFFSET + UTF8_2B_INDEX_2_LENGTH; // The alignment size of a data block. Also the granularity for compaction.

        const DATA_GRANULARITY = 1 << INDEX_SHIFT;

        const UnicodeTrie = /* #__PURE__ */(function () {
          function UnicodeTrie(data) {
            const isBuffer = typeof data.readUInt32BE === 'function' && typeof data.slice === 'function';

            if (isBuffer || data instanceof Uint8Array) {
              // read binary format
              let uncompressedLength;

              if (isBuffer) {
                this.highStart = data.readUInt32LE(0);
                this.errorValue = data.readUInt32LE(4);
                uncompressedLength = data.readUInt32LE(8);
                data = data.slice(12);
              } else {
                const view = new DataView(data.buffer);
                this.highStart = view.getUint32(0, true);
                this.errorValue = view.getUint32(4, true);
                uncompressedLength = view.getUint32(8, true);
                data = data.subarray(12);
              } // double inflate the actual trie data

              data = inflate(data, new Uint8Array(uncompressedLength));
              data = inflate(data, new Uint8Array(uncompressedLength)); // swap bytes from little-endian

              swap32LE(data);
              this.data = new Uint32Array(data.buffer);
            } else {
              // pre-parsed data
              const _data = data;
              this.data = _data.data;
              this.highStart = _data.highStart;
              this.errorValue = _data.errorValue;
            }
          }

          const _proto = UnicodeTrie.prototype;

          _proto.get = function get(codePoint) {
            let index;

            if (codePoint < 0 || codePoint > 0x10ffff) {
              return this.errorValue;
            }

            if (codePoint < 0xd800 || codePoint > 0xdbff && codePoint <= 0xffff) {
              // Ordinary BMP code point, excluding leading surrogates.
              // BMP uses a single level lookup.  BMP index starts at offset 0 in the index.
              // data is stored in the index array itself.
              index = (this.data[codePoint >> SHIFT_2] << INDEX_SHIFT) + (codePoint & DATA_MASK);
              return this.data[index];
            }

            if (codePoint <= 0xffff) {
              // Lead Surrogate Code Point.  A Separate index section is stored for
              // lead surrogate code units and code points.
              //   The main index has the code unit data.
              //   For this function, we need the code point data.
              index = (this.data[LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> SHIFT_2)] << INDEX_SHIFT) + (codePoint & DATA_MASK);
              return this.data[index];
            }

            if (codePoint < this.highStart) {
              // Supplemental code point, use two-level lookup.
              index = this.data[INDEX_1_OFFSET - OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> SHIFT_1)];
              index = this.data[index + (codePoint >> SHIFT_2 & INDEX_2_MASK)];
              index = (index << INDEX_SHIFT) + (codePoint & DATA_MASK);
              return this.data[index];
            }

            return this.data[this.data.length - DATA_GRANULARITY];
          };

          return UnicodeTrie;
        }());

        module.exports = UnicodeTrie;
        /***/ }),

      /***/ 1753:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        __webpack_require__(6992);

        __webpack_require__(1539);

        __webpack_require__(2472);

        __webpack_require__(2990);

        __webpack_require__(8927);

        __webpack_require__(3105);

        __webpack_require__(5035);

        __webpack_require__(4345);

        __webpack_require__(7174);

        __webpack_require__(2846);

        __webpack_require__(4731);

        __webpack_require__(7209);

        __webpack_require__(6319);

        __webpack_require__(8867);

        __webpack_require__(7789);

        __webpack_require__(3739);

        __webpack_require__(9368);

        __webpack_require__(4483);

        __webpack_require__(2056);

        __webpack_require__(3462);

        __webpack_require__(678);

        __webpack_require__(7462);

        __webpack_require__(3824);

        __webpack_require__(5021);

        __webpack_require__(2974);

        __webpack_require__(5016);

        __webpack_require__(9135);

        const isBigEndian = new Uint8Array(new Uint32Array([0x12345678]).buffer)[0] === 0x12;

        const swap = function swap(b, n, m) {
          const i = b[n];
          b[n] = b[m];
          b[m] = i;
        };

        const swap32 = function swap32(array) {
          const len = array.length;

          for (let i = 0; i < len; i += 4) {
            swap(array, i, i + 3);
            swap(array, i + 1, i + 2);
          }
        };

        const swap32LE = function swap32LE(array) {
          if (isBigEndian) {
            swap32(array);
          }
        };

        module.exports = {
          swap32LE,
        };
        /***/ }),

      /***/ 8071:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const SVGtoPDF = __webpack_require__(8519);

        module.exports = SVGtoPDF;
        /***/ }),

      /***/ 8519:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* module decorator */ module = __webpack_require__.nmd(module);

        __webpack_require__(8309);

        __webpack_require__(7941);

        __webpack_require__(3210);

        __webpack_require__(4916);

        __webpack_require__(4723);

        __webpack_require__(3123);

        __webpack_require__(3728);

        __webpack_require__(5306);

        __webpack_require__(7042);

        __webpack_require__(9653);

        __webpack_require__(2222);

        __webpack_require__(6992);

        __webpack_require__(1539);

        __webpack_require__(3948);

        __webpack_require__(9254);

        __webpack_require__(3290);

        const SVGtoPDF = function SVGtoPDF(doc, svg, x, y, options) {
          const NamedColors = {
            aliceblue: [240, 248, 255],
            antiquewhite: [250, 235, 215],
            aqua: [0, 255, 255],
            aquamarine: [127, 255, 212],
            azure: [240, 255, 255],
            beige: [245, 245, 220],
            bisque: [255, 228, 196],
            black: [0, 0, 0],
            blanchedalmond: [255, 235, 205],
            blue: [0, 0, 255],
            blueviolet: [138, 43, 226],
            brown: [165, 42, 42],
            burlywood: [222, 184, 135],
            cadetblue: [95, 158, 160],
            chartreuse: [127, 255, 0],
            chocolate: [210, 105, 30],
            coral: [255, 127, 80],
            cornflowerblue: [100, 149, 237],
            cornsilk: [255, 248, 220],
            crimson: [220, 20, 60],
            cyan: [0, 255, 255],
            darkblue: [0, 0, 139],
            darkcyan: [0, 139, 139],
            darkgoldenrod: [184, 134, 11],
            darkgray: [169, 169, 169],
            darkgrey: [169, 169, 169],
            darkgreen: [0, 100, 0],
            darkkhaki: [189, 183, 107],
            darkmagenta: [139, 0, 139],
            darkolivegreen: [85, 107, 47],
            darkorange: [255, 140, 0],
            darkorchid: [153, 50, 204],
            darkred: [139, 0, 0],
            darksalmon: [233, 150, 122],
            darkseagreen: [143, 188, 143],
            darkslateblue: [72, 61, 139],
            darkslategray: [47, 79, 79],
            darkslategrey: [47, 79, 79],
            darkturquoise: [0, 206, 209],
            darkviolet: [148, 0, 211],
            deeppink: [255, 20, 147],
            deepskyblue: [0, 191, 255],
            dimgray: [105, 105, 105],
            dimgrey: [105, 105, 105],
            dodgerblue: [30, 144, 255],
            firebrick: [178, 34, 34],
            floralwhite: [255, 250, 240],
            forestgreen: [34, 139, 34],
            fuchsia: [255, 0, 255],
            gainsboro: [220, 220, 220],
            ghostwhite: [248, 248, 255],
            gold: [255, 215, 0],
            goldenrod: [218, 165, 32],
            gray: [128, 128, 128],
            grey: [128, 128, 128],
            green: [0, 128, 0],
            greenyellow: [173, 255, 47],
            honeydew: [240, 255, 240],
            hotpink: [255, 105, 180],
            indianred: [205, 92, 92],
            indigo: [75, 0, 130],
            ivory: [255, 255, 240],
            khaki: [240, 230, 140],
            lavender: [230, 230, 250],
            lavenderblush: [255, 240, 245],
            lawngreen: [124, 252, 0],
            lemonchiffon: [255, 250, 205],
            lightblue: [173, 216, 230],
            lightcoral: [240, 128, 128],
            lightcyan: [224, 255, 255],
            lightgoldenrodyellow: [250, 250, 210],
            lightgray: [211, 211, 211],
            lightgrey: [211, 211, 211],
            lightgreen: [144, 238, 144],
            lightpink: [255, 182, 193],
            lightsalmon: [255, 160, 122],
            lightseagreen: [32, 178, 170],
            lightskyblue: [135, 206, 250],
            lightslategray: [119, 136, 153],
            lightslategrey: [119, 136, 153],
            lightsteelblue: [176, 196, 222],
            lightyellow: [255, 255, 224],
            lime: [0, 255, 0],
            limegreen: [50, 205, 50],
            linen: [250, 240, 230],
            magenta: [255, 0, 255],
            maroon: [128, 0, 0],
            mediumaquamarine: [102, 205, 170],
            mediumblue: [0, 0, 205],
            mediumorchid: [186, 85, 211],
            mediumpurple: [147, 112, 219],
            mediumseagreen: [60, 179, 113],
            mediumslateblue: [123, 104, 238],
            mediumspringgreen: [0, 250, 154],
            mediumturquoise: [72, 209, 204],
            mediumvioletred: [199, 21, 133],
            midnightblue: [25, 25, 112],
            mintcream: [245, 255, 250],
            mistyrose: [255, 228, 225],
            moccasin: [255, 228, 181],
            navajowhite: [255, 222, 173],
            navy: [0, 0, 128],
            oldlace: [253, 245, 230],
            olive: [128, 128, 0],
            olivedrab: [107, 142, 35],
            orange: [255, 165, 0],
            orangered: [255, 69, 0],
            orchid: [218, 112, 214],
            palegoldenrod: [238, 232, 170],
            palegreen: [152, 251, 152],
            paleturquoise: [175, 238, 238],
            palevioletred: [219, 112, 147],
            papayawhip: [255, 239, 213],
            peachpuff: [255, 218, 185],
            peru: [205, 133, 63],
            pink: [255, 192, 203],
            plum: [221, 160, 221],
            powderblue: [176, 224, 230],
            purple: [128, 0, 128],
            rebeccapurple: [102, 51, 153],
            red: [255, 0, 0],
            rosybrown: [188, 143, 143],
            royalblue: [65, 105, 225],
            saddlebrown: [139, 69, 19],
            salmon: [250, 128, 114],
            sandybrown: [244, 164, 96],
            seagreen: [46, 139, 87],
            seashell: [255, 245, 238],
            sienna: [160, 82, 45],
            silver: [192, 192, 192],
            skyblue: [135, 206, 235],
            slateblue: [106, 90, 205],
            slategray: [112, 128, 144],
            slategrey: [112, 128, 144],
            snow: [255, 250, 250],
            springgreen: [0, 255, 127],
            steelblue: [70, 130, 180],
            tan: [210, 180, 140],
            teal: [0, 128, 128],
            thistle: [216, 191, 216],
            tomato: [255, 99, 71],
            turquoise: [64, 224, 208],
            violet: [238, 130, 238],
            wheat: [245, 222, 179],
            white: [255, 255, 255],
            whitesmoke: [245, 245, 245],
            yellow: [255, 255, 0],
          };
          const DefaultColors = {
            black: [NamedColors.black, 1],
            white: [NamedColors.white, 1],
            transparent: [NamedColors.black, 0],
          };
          const Entities = {
            quot: 34,
            amp: 38,
            lt: 60,
            gt: 62,
            apos: 39,
            OElig: 338,
            oelig: 339,
            Scaron: 352,
            scaron: 353,
            Yuml: 376,
            circ: 710,
            tilde: 732,
            ensp: 8194,
            emsp: 8195,
            thinsp: 8201,
            zwnj: 8204,
            zwj: 8205,
            lrm: 8206,
            rlm: 8207,
            ndash: 8211,
            mdash: 8212,
            lsquo: 8216,
            rsquo: 8217,
            sbquo: 8218,
            ldquo: 8220,
            rdquo: 8221,
            bdquo: 8222,
            dagger: 8224,
            Dagger: 8225,
            permil: 8240,
            lsaquo: 8249,
            rsaquo: 8250,
            euro: 8364,
            nbsp: 160,
            iexcl: 161,
            cent: 162,
            pound: 163,
            curren: 164,
            yen: 165,
            brvbar: 166,
            sect: 167,
            uml: 168,
            copy: 169,
            ordf: 170,
            laquo: 171,
            not: 172,
            shy: 173,
            reg: 174,
            macr: 175,
            deg: 176,
            plusmn: 177,
            sup2: 178,
            sup3: 179,
            acute: 180,
            micro: 181,
            para: 182,
            middot: 183,
            cedil: 184,
            sup1: 185,
            ordm: 186,
            raquo: 187,
            frac14: 188,
            frac12: 189,
            frac34: 190,
            iquest: 191,
            Agrave: 192,
            Aacute: 193,
            Acirc: 194,
            Atilde: 195,
            Auml: 196,
            Aring: 197,
            AElig: 198,
            Ccedil: 199,
            Egrave: 200,
            Eacute: 201,
            Ecirc: 202,
            Euml: 203,
            Igrave: 204,
            Iacute: 205,
            Icirc: 206,
            Iuml: 207,
            ETH: 208,
            Ntilde: 209,
            Ograve: 210,
            Oacute: 211,
            Ocirc: 212,
            Otilde: 213,
            Ouml: 214,
            times: 215,
            Oslash: 216,
            Ugrave: 217,
            Uacute: 218,
            Ucirc: 219,
            Uuml: 220,
            Yacute: 221,
            THORN: 222,
            szlig: 223,
            agrave: 224,
            aacute: 225,
            acirc: 226,
            atilde: 227,
            auml: 228,
            aring: 229,
            aelig: 230,
            ccedil: 231,
            egrave: 232,
            eacute: 233,
            ecirc: 234,
            euml: 235,
            igrave: 236,
            iacute: 237,
            icirc: 238,
            iuml: 239,
            eth: 240,
            ntilde: 241,
            ograve: 242,
            oacute: 243,
            ocirc: 244,
            otilde: 245,
            ouml: 246,
            divide: 247,
            oslash: 248,
            ugrave: 249,
            uacute: 250,
            ucirc: 251,
            uuml: 252,
            yacute: 253,
            thorn: 254,
            yuml: 255,
            fnof: 402,
            Alpha: 913,
            Beta: 914,
            Gamma: 915,
            Delta: 916,
            Epsilon: 917,
            Zeta: 918,
            Eta: 919,
            Theta: 920,
            Iota: 921,
            Kappa: 922,
            Lambda: 923,
            Mu: 924,
            Nu: 925,
            Xi: 926,
            Omicron: 927,
            Pi: 928,
            Rho: 929,
            Sigma: 931,
            Tau: 932,
            Upsilon: 933,
            Phi: 934,
            Chi: 935,
            Psi: 936,
            Omega: 937,
            alpha: 945,
            beta: 946,
            gamma: 947,
            delta: 948,
            epsilon: 949,
            zeta: 950,
            eta: 951,
            theta: 952,
            iota: 953,
            kappa: 954,
            lambda: 955,
            mu: 956,
            nu: 957,
            xi: 958,
            omicron: 959,
            pi: 960,
            rho: 961,
            sigmaf: 962,
            sigma: 963,
            tau: 964,
            upsilon: 965,
            phi: 966,
            chi: 967,
            psi: 968,
            omega: 969,
            thetasym: 977,
            upsih: 978,
            piv: 982,
            bull: 8226,
            hellip: 8230,
            prime: 8242,
            Prime: 8243,
            oline: 8254,
            frasl: 8260,
            weierp: 8472,
            image: 8465,
            real: 8476,
            trade: 8482,
            alefsym: 8501,
            larr: 8592,
            uarr: 8593,
            rarr: 8594,
            darr: 8595,
            harr: 8596,
            crarr: 8629,
            lArr: 8656,
            uArr: 8657,
            rArr: 8658,
            dArr: 8659,
            hArr: 8660,
            forall: 8704,
            part: 8706,
            exist: 8707,
            empty: 8709,
            nabla: 8711,
            isin: 8712,
            notin: 8713,
            ni: 8715,
            prod: 8719,
            sum: 8721,
            minus: 8722,
            lowast: 8727,
            radic: 8730,
            prop: 8733,
            infin: 8734,
            ang: 8736,
            and: 8743,
            or: 8744,
            cap: 8745,
            cup: 8746,
            int: 8747,
            there4: 8756,
            sim: 8764,
            cong: 8773,
            asymp: 8776,
            ne: 8800,
            equiv: 8801,
            le: 8804,
            ge: 8805,
            sub: 8834,
            sup: 8835,
            nsub: 8836,
            sube: 8838,
            supe: 8839,
            oplus: 8853,
            otimes: 8855,
            perp: 8869,
            sdot: 8901,
            lceil: 8968,
            rceil: 8969,
            lfloor: 8970,
            rfloor: 8971,
            lang: 9001,
            rang: 9002,
            loz: 9674,
            spades: 9824,
            clubs: 9827,
            hearts: 9829,
            diams: 9830,
          };
          const PathArguments = {
            A: 7,
            a: 7,
            C: 6,
            c: 6,
            H: 1,
            h: 1,
            L: 2,
            l: 2,
            M: 2,
            m: 2,
            Q: 4,
            q: 4,
            S: 4,
            s: 4,
            T: 2,
            t: 2,
            V: 1,
            v: 1,
            Z: 0,
            z: 0,
          };
          const PathFlags = {
            A3: true,
            A4: true,
            a3: true,
            a4: true,
          };
          const Properties = {
            color: {
              inherit: true,
              initial: undefined,
            },
            visibility: {
              inherit: true,
              initial: 'visible',
              values: {
                hidden: 'hidden',
                collapse: 'hidden',
                visible: 'visible',
              },
            },
            fill: {
              inherit: true,
              initial: DefaultColors.black,
            },
            stroke: {
              inherit: true,
              initial: 'none',
            },
            'stop-color': {
              inherit: false,
              initial: DefaultColors.black,
            },
            'fill-opacity': {
              inherit: true,
              initial: 1,
            },
            'stroke-opacity': {
              inherit: true,
              initial: 1,
            },
            'stop-opacity': {
              inherit: false,
              initial: 1,
            },
            'fill-rule': {
              inherit: true,
              initial: 'nonzero',
              values: {
                nonzero: 'nonzero',
                evenodd: 'evenodd',
              },
            },
            'clip-rule': {
              inherit: true,
              initial: 'nonzero',
              values: {
                nonzero: 'nonzero',
                evenodd: 'evenodd',
              },
            },
            'stroke-width': {
              inherit: true,
              initial: 1,
            },
            'stroke-dasharray': {
              inherit: true,
              initial: [],
            },
            'stroke-dashoffset': {
              inherit: true,
              initial: 0,
            },
            'stroke-miterlimit': {
              inherit: true,
              initial: 4,
            },
            'stroke-linejoin': {
              inherit: true,
              initial: 'miter',
              values: {
                miter: 'miter',
                round: 'round',
                bevel: 'bevel',
              },
            },
            'stroke-linecap': {
              inherit: true,
              initial: 'butt',
              values: {
                butt: 'butt',
                round: 'round',
                square: 'square',
              },
            },
            'font-size': {
              inherit: true,
              initial: 16,
              values: {
                'xx-small': 9,
                'x-small': 10,
                small: 13,
                medium: 16,
                large: 18,
                'x-large': 24,
                'xx-large': 32,
              },
            },
            'font-family': {
              inherit: true,
              initial: 'sans-serif',
            },
            'font-weight': {
              inherit: true,
              initial: 'normal',
              values: {
                600: 'bold',
                700: 'bold',
                800: 'bold',
                900: 'bold',
                bold: 'bold',
                bolder: 'bold',
                500: 'normal',
                400: 'normal',
                300: 'normal',
                200: 'normal',
                100: 'normal',
                normal: 'normal',
                lighter: 'normal',
              },
            },
            'font-style': {
              inherit: true,
              initial: 'normal',
              values: {
                italic: 'italic',
                oblique: 'italic',
                normal: 'normal',
              },
            },
            'text-anchor': {
              inherit: true,
              initial: 'start',
              values: {
                start: 'start',
                middle: 'middle',
                end: 'end',
              },
            },
            direction: {
              inherit: true,
              initial: 'ltr',
              values: {
                ltr: 'ltr',
                rtl: 'rtl',
              },
            },
            'dominant-baseline': {
              inherit: true,
              initial: 'baseline',
              values: {
                auto: 'baseline',
                baseline: 'baseline',
                'before-edge': 'before-edge',
                'text-before-edge': 'before-edge',
                middle: 'middle',
                central: 'central',
                'after-edge': 'after-edge',
                'text-after-edge': 'after-edge',
                ideographic: 'ideographic',
                alphabetic: 'alphabetic',
                hanging: 'hanging',
                mathematical: 'mathematical',
              },
            },
            'alignment-baseline': {
              inherit: false,
              initial: undefined,
              values: {
                auto: 'baseline',
                baseline: 'baseline',
                'before-edge': 'before-edge',
                'text-before-edge': 'before-edge',
                middle: 'middle',
                central: 'central',
                'after-edge': 'after-edge',
                'text-after-edge': 'after-edge',
                ideographic: 'ideographic',
                alphabetic: 'alphabetic',
                hanging: 'hanging',
                mathematical: 'mathematical',
              },
            },
            'baseline-shift': {
              inherit: true,
              initial: 'baseline',
              values: {
                baseline: 'baseline',
                sub: 'sub',
                super: 'super',
              },
            },
            'word-spacing': {
              inherit: true,
              initial: 0,
              values: {
                normal: 0,
              },
            },
            'letter-spacing': {
              inherit: true,
              initial: 0,
              values: {
                normal: 0,
              },
            },
            'text-decoration': {
              inherit: false,
              initial: 'none',
              values: {
                none: 'none',
                underline: 'underline',
                overline: 'overline',
                'line-through': 'line-through',
              },
            },
            'xml:space': {
              inherit: true,
              initial: 'default',
              css: 'white-space',
              values: {
                preserve: 'preserve',
                default: 'default',
                pre: 'preserve',
                'pre-line': 'preserve',
                'pre-wrap': 'preserve',
                nowrap: 'default',
              },
            },
            'marker-start': {
              inherit: true,
              initial: 'none',
            },
            'marker-mid': {
              inherit: true,
              initial: 'none',
            },
            'marker-end': {
              inherit: true,
              initial: 'none',
            },
            opacity: {
              inherit: false,
              initial: 1,
            },
            transform: {
              inherit: false,
              initial: [1, 0, 0, 1, 0, 0],
            },
            display: {
              inherit: false,
              initial: 'inline',
              values: {
                none: 'none',
                inline: 'inline',
                block: 'inline',
              },
            },
            'clip-path': {
              inherit: false,
              initial: 'none',
            },
            mask: {
              inherit: false,
              initial: 'none',
            },
            overflow: {
              inherit: false,
              initial: 'hidden',
              values: {
                hidden: 'hidden',
                scroll: 'hidden',
                visible: 'visible',
              },
            },
          };

          function docBeginGroup(bbox) {
            const group = new function PDFGroup() {}();
            group.name = `G${doc._groupCount = (doc._groupCount || 0) + 1}`;
            group.resources = doc.ref();
            group.xobj = doc.ref({
              Type: 'XObject',
              Subtype: 'Form',
              FormType: 1,
              BBox: bbox,
              Group: {
                S: 'Transparency',
                CS: 'DeviceRGB',
                I: true,
                K: false,
              },
              Resources: group.resources,
            });
            group.xobj.write('');
            group.savedMatrix = doc._ctm;
            group.savedPage = doc.page;
            groupStack.push(group);
            doc._ctm = [1, 0, 0, 1, 0, 0];
            doc.page = {
              width: doc.page.width,
              height: doc.page.height,
              write: function write(data) {
                group.xobj.write(data);
              },
              fonts: {},
              xobjects: {},
              ext_gstates: {},
              patterns: {},
            };
            return group;
          }

          function docEndGroup(group) {
            if (group !== groupStack.pop()) {
              throw 'Group not matching';
            }

            if (Object.keys(doc.page.fonts).length) {
              group.resources.data.Font = doc.page.fonts;
            }

            if (Object.keys(doc.page.xobjects).length) {
              group.resources.data.XObject = doc.page.xobjects;
            }

            if (Object.keys(doc.page.ext_gstates).length) {
              group.resources.data.ExtGState = doc.page.ext_gstates;
            }

            if (Object.keys(doc.page.patterns).length) {
              group.resources.data.Pattern = doc.page.patterns;
            }

            group.resources.end();
            group.xobj.end();
            doc._ctm = group.savedMatrix;
            doc.page = group.savedPage;
          }

          function docInsertGroup(group) {
            doc.page.xobjects[group.name] = group.xobj;
            doc.addContent(`/${group.name} Do`);
          }

          function docApplyMask(group, clip) {
            const name = `M${doc._maskCount = (doc._maskCount || 0) + 1}`;
            const gstate = doc.ref({
              Type: 'ExtGState',
              CA: 1,
              ca: 1,
              BM: 'Normal',
              SMask: {
                S: 'Luminosity',
                G: group.xobj,
                BC: clip ? [0, 0, 0] : [1, 1, 1],
              },
            });
            gstate.end();
            doc.page.ext_gstates[name] = gstate;
            doc.addContent(`/${name} gs`);
          }

          function docCreatePattern(group, dx, dy, matrix) {
            const pattern = new function PDFPattern() {}();
            pattern.group = group;
            pattern.dx = dx;
            pattern.dy = dy;
            pattern.matrix = matrix || [1, 0, 0, 1, 0, 0];
            return pattern;
          }

          function docUsePattern(pattern, stroke) {
            const name = `P${doc._patternCount = (doc._patternCount || 0) + 1}`;
            const ref = doc.ref({
              Type: 'Pattern',
              PatternType: 1,
              PaintType: 1,
              TilingType: 2,
              BBox: [0, 0, pattern.dx, pattern.dy],
              XStep: pattern.dx,
              YStep: pattern.dy,
              Matrix: multiplyMatrix(doc._ctm, pattern.matrix),
              Resources: {
                ProcSet: ['PDF', 'Text', 'ImageB', 'ImageC', 'ImageI'],
                XObject: (function () {
                  const temp = {};
                  temp[pattern.group.name] = pattern.group.xobj;
                  return temp;
                }()),
              },
            });
            ref.write(`/${pattern.group.name} Do`);
            ref.end();
            doc.page.patterns[name] = ref;

            if (stroke) {
              doc.addContent('/Pattern CS');
              doc.addContent(`/${name} SCN`);
            } else {
              doc.addContent('/Pattern cs');
              doc.addContent(`/${name} scn`);
            }
          }

          function docBeginText(font, size) {
            if (!doc.page.fonts[font.id]) {
              doc.page.fonts[font.id] = font.ref();
            }

            doc.addContent('BT').addContent(`/${font.id} ${size} Tf`);
          }

          function docSetTextMatrix(a, b, c, d, e, f) {
            doc.addContent(`${validateNumber(a)} ${validateNumber(b)} ${validateNumber(-c)} ${validateNumber(-d)} ${validateNumber(e)} ${validateNumber(f)} Tm`);
          }

          function docSetTextMode(fill, stroke) {
            const mode = fill && stroke ? 2 : stroke ? 1 : fill ? 0 : 3;
            doc.addContent(`${mode} Tr`);
          }

          function docWriteGlyph(glyph) {
            doc.addContent(`<${glyph}> Tj`);
          }

          function docEndText() {
            doc.addContent('ET');
          }

          function docFillColor(color) {
            if (color[0].constructor.name === 'PDFPattern') {
              doc.fillOpacity(color[1]);
              docUsePattern(color[0], false);
            } else {
              doc.fillColor(color[0], color[1]);
            }
          }

          function docStrokeColor(color) {
            if (color[0].constructor.name === 'PDFPattern') {
              doc.strokeOpacity(color[1]);
              docUsePattern(color[0], true);
            } else {
              doc.strokeColor(color[0], color[1]);
            }
          }

          function docInsertLink(x, y, w, h, url) {
            const ref = doc.ref({
              Type: 'Annot',
              Subtype: 'Link',
              Rect: [x, y, w, h],
              Border: [0, 0, 0],
              A: {
                S: 'URI',
                URI: new String(url),
              },
            });
            ref.end();
            links.push(ref);
          }

          function parseXml(xml) {
            const SvgNode = function SvgNode(tag, type, value, error) {
              this.error = error;
              this.nodeName = tag;
              this.nodeValue = value;
              this.nodeType = type;
              this.attributes = Object.create(null);
              this.childNodes = [];
              this.parentNode = null;
              this.id = '';
              this.textContent = '';
              this.classList = [];
            };

            SvgNode.prototype.getAttribute = function (attr) {
              return this.attributes[attr] != null ? this.attributes[attr] : null;
            };

            SvgNode.prototype.getElementById = function (id) {
              let result = null;

              (function recursive(node) {
                if (result) {
                  return;
                }

                if (node.nodeType === 1) {
                  if (node.id === id) {
                    result = node;
                  }

                  for (let i = 0; i < node.childNodes.length; i++) {
                    recursive(node.childNodes[i]);
                  }
                }
              }(this));

              return result;
            };

            SvgNode.prototype.getElementsByTagName = function (tag) {
              const result = [];

              (function recursive(node) {
                if (node.nodeType === 1) {
                  if (node.nodeName === tag) {
                    result.push(node);
                  }

                  for (let i = 0; i < node.childNodes.length; i++) {
                    recursive(node.childNodes[i]);
                  }
                }
              }(this));

              return result;
            };

            const parser = new StringParser(xml.trim());
            let result;
            let child;
            let error = false;

            const recursive = function recursive() {
              let temp; let
                child;

              if (temp = parser.match(/^<([\w:.-]+)\s*/, true)) {
                // Opening tag
                const node = new SvgNode(temp[1], 1, null, error);

                while (temp = parser.match(/^([\w:.-]+)(?:\s*=\s*"([^"]*)"|\s*=\s*'([^']*)')?\s*/, true)) {
                  // Attribute
                  const attr = temp[1];
                  const value = decodeEntities(temp[2] || temp[3] || '');

                  if (!node.attributes[attr]) {
                    node.attributes[attr] = value;

                    if (attr === 'id') {
                      node.id = value;
                    }

                    if (attr === 'class') {
                      node.classList = value.split(' ');
                    }
                  } else {
                    warningCallback(`parseXml: duplicate attribute "${attr}"`);
                    error = true;
                  }
                }

                if (parser.match(/^>/)) {
                  // End of opening tag
                  while (child = recursive()) {
                    node.childNodes.push(child);
                    child.parentNode = node;
                    node.textContent += child.nodeType === 3 || child.nodeType === 4 ? child.nodeValue : child.textContent;
                  }

                  if (temp = parser.match(/^<\/([\w:.-]+)\s*>/, true)) {
                    // Closing tag
                    if (temp[1] === node.nodeName) {
                      return node;
                    }
                    warningCallback(`parseXml: tag not matching, opening "${node.nodeName}" & closing "${temp[1]}"`);
                    error = true;
                    return node;
                  }
                  warningCallback(`parseXml: tag not matching, opening "${node.nodeName}" & not closing`);
                  error = true;
                  return node;
                } if (parser.match(/^\/>/)) {
                  // Self-closing tag
                  return node;
                }
                warningCallback(`parseXml: tag could not be parsed "${node.nodeName}"`);
                error = true;
              } else if (temp = parser.match(/^<!--[\s\S]*?-->/)) {
                // Comment
                return new SvgNode(null, 8, temp, error);
              } else if (temp = parser.match(/^<\?[\s\S]*?\?>/)) {
                // Processing instructions
                return new SvgNode(null, 7, temp, error);
              } else if (temp = parser.match(/^<!DOCTYPE\s*([\s\S]*?)>/)) {
                // Doctype
                return new SvgNode(null, 10, temp, error);
              } else if (temp = parser.match(/^<!\[CDATA\[([\s\S]*?)\]\]>/, true)) {
                // Cdata node
                return new SvgNode('#cdata-section', 4, temp[1], error);
              } else if (temp = parser.match(/^([^<]+)/, true)) {
                // Text node
                return new SvgNode('#text', 3, decodeEntities(temp[1]), error);
              }
            };

            while (child = recursive()) {
              if (child.nodeType === 1 && !result) {
                result = child;
              } else if (child.nodeType === 1 || child.nodeType === 3 && child.nodeValue.trim() !== '') {
                warningCallback('parseXml: data after document end has been discarded');
              }
            }

            if (parser.matchAll()) {
              warningCallback('parseXml: parsing error');
            }

            return result;
          }

          function decodeEntities(str) {
            return str.replace(/&(?:#([0-9]+)|#[xX]([0-9A-Fa-f]+)|([0-9A-Za-z]+));/g, (mt, m0, m1, m2) => {
              if (m0) {
                return String.fromCharCode(parseInt(m0, 10));
              } if (m1) {
                return String.fromCharCode(parseInt(m1, 16));
              } if (m2 && Entities[m2]) {
                return String.fromCharCode(Entities[m2]);
              }
              return mt;
            });
          }

          function parseColor(raw) {
            let temp; let
              result;
            raw = (raw || '').trim();

            if (temp = NamedColors[raw]) {
              result = [temp.slice(), 1];
            } else if (temp = raw.match(/^rgba\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9.]+)\s*\)$/i)) {
              temp[1] = parseInt(temp[1]);
              temp[2] = parseInt(temp[2]);
              temp[3] = parseInt(temp[3]);
              temp[4] = parseFloat(temp[4]);

              if (temp[1] < 256 && temp[2] < 256 && temp[3] < 256 && temp[4] <= 1) {
                result = [temp.slice(1, 4), temp[4]];
              }
            } else if (temp = raw.match(/^rgb\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)$/i)) {
              temp[1] = parseInt(temp[1]);
              temp[2] = parseInt(temp[2]);
              temp[3] = parseInt(temp[3]);

              if (temp[1] < 256 && temp[2] < 256 && temp[3] < 256) {
                result = [temp.slice(1, 4), 1];
              }
            } else if (temp = raw.match(/^rgb\(\s*([0-9.]+)%\s*,\s*([0-9.]+)%\s*,\s*([0-9.]+)%\s*\)$/i)) {
              temp[1] = 2.55 * parseFloat(temp[1]);
              temp[2] = 2.55 * parseFloat(temp[2]);
              temp[3] = 2.55 * parseFloat(temp[3]);

              if (temp[1] < 256 && temp[2] < 256 && temp[3] < 256) {
                result = [temp.slice(1, 4), 1];
              }
            } else if (temp = raw.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i)) {
              result = [[parseInt(temp[1], 16), parseInt(temp[2], 16), parseInt(temp[3], 16)], 1];
            } else if (temp = raw.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i)) {
              result = [[0x11 * parseInt(temp[1], 16), 0x11 * parseInt(temp[2], 16), 0x11 * parseInt(temp[3], 16)], 1];
            }

            return colorCallback ? colorCallback(result, raw) : result;
          }

          function opacityToColor(color, opacity, isMask) {
            const newColor = color[0].slice();
            const newOpacity = color[1] * opacity;

            if (isMask) {
              for (let i = 0; i < color.length; i++) {
                newColor[i] *= newOpacity;
              }

              return [newColor, 1];
            }
            return [newColor, newOpacity];
          }

          function multiplyMatrix() {
            function multiply(a, b) {
              return [a[0] * b[0] + a[2] * b[1], a[1] * b[0] + a[3] * b[1], a[0] * b[2] + a[2] * b[3], a[1] * b[2] + a[3] * b[3], a[0] * b[4] + a[2] * b[5] + a[4], a[1] * b[4] + a[3] * b[5] + a[5]];
            }

            let result = arguments[0];

            for (let i = 1; i < arguments.length; i++) {
              result = multiply(result, arguments[i]);
            }

            return result;
          }

          function transformPoint(p, m) {
            return [m[0] * p[0] + m[2] * p[1] + m[4], m[1] * p[0] + m[3] * p[1] + m[5]];
          }

          function getGlobalMatrix() {
            let ctm = doc._ctm;

            for (let i = groupStack.length - 1; i >= 0; i--) {
              ctm = multiplyMatrix(groupStack[i].savedMatrix, ctm);
            }

            return ctm;
          }

          function getPageBBox() {
            return new SvgShape().M(0, 0).L(doc.page.width, 0).L(doc.page.width, doc.page.height)
              .L(0, doc.page.height)
              .transform(inverseMatrix(getGlobalMatrix()))
              .getBoundingBox();
          }

          function inverseMatrix(m) {
            const dt = m[0] * m[3] - m[1] * m[2];
            return [m[3] / dt, -m[1] / dt, -m[2] / dt, m[0] / dt, (m[2] * m[5] - m[3] * m[4]) / dt, (m[1] * m[4] - m[0] * m[5]) / dt];
          }

          function validateMatrix(m) {
            const m0 = validateNumber(m[0]);
            const m1 = validateNumber(m[1]);
            const m2 = validateNumber(m[2]);
            const m3 = validateNumber(m[3]);
            const m4 = validateNumber(m[4]);
            const m5 = validateNumber(m[5]);

            if (isNotEqual(m0 * m3 - m1 * m2, 0)) {
              return [m0, m1, m2, m3, m4, m5];
            }
          }

          function solveEquation(curve) {
            const a = curve[2] || 0;
            const b = curve[1] || 0;
            const c = curve[0] || 0;

            if (isEqual(a, 0) && isEqual(b, 0)) {
              return [];
            } if (isEqual(a, 0)) {
              return [-c / b];
            }
            const d = b * b - 4 * a * c;

            if (isNotEqual(d, 0) && d > 0) {
              return [(-b + Math.sqrt(d)) / (2 * a), (-b - Math.sqrt(d)) / (2 * a)];
            } if (isEqual(d, 0)) {
              return [-b / (2 * a)];
            }
            return [];
          }

          function getCurveValue(t, curve) {
            return (curve[0] || 0) + (curve[1] || 0) * t + (curve[2] || 0) * t * t + (curve[3] || 0) * t * t * t;
          }

          function isEqual(number, ref) {
            return Math.abs(number - ref) < 1e-10;
          }

          function isNotEqual(number, ref) {
            return Math.abs(number - ref) >= 1e-10;
          }

          function validateNumber(n) {
            return n > -1e21 && n < 1e21 ? Math.round(n * 1e6) / 1e6 : 0;
          }

          function isArrayLike(v) {
            return typeof v === 'object' && v !== null && typeof v.length === 'number';
          }

          function parseTranform(v) {
            const parser = new StringParser((v || '').trim());
            let result = [1, 0, 0, 1, 0, 0];
            let temp;

            while (temp = parser.match(/^([A-Za-z]+)\s*[(]([^(]+)[)]/, true)) {
              const func = temp[1];
              const nums = [];
              const parser2 = new StringParser(temp[2].trim());
              let temp2 = void 0;

              while (temp2 = parser2.matchNumber()) {
                nums.push(Number(temp2));
                parser2.matchSeparator();
              }

              if (func === 'matrix' && nums.length === 6) {
                result = multiplyMatrix(result, [nums[0], nums[1], nums[2], nums[3], nums[4], nums[5]]);
              } else if (func === 'translate' && nums.length === 2) {
                result = multiplyMatrix(result, [1, 0, 0, 1, nums[0], nums[1]]);
              } else if (func === 'translate' && nums.length === 1) {
                result = multiplyMatrix(result, [1, 0, 0, 1, nums[0], 0]);
              } else if (func === 'scale' && nums.length === 2) {
                result = multiplyMatrix(result, [nums[0], 0, 0, nums[1], 0, 0]);
              } else if (func === 'scale' && nums.length === 1) {
                result = multiplyMatrix(result, [nums[0], 0, 0, nums[0], 0, 0]);
              } else if (func === 'rotate' && nums.length === 3) {
                const a = nums[0] * Math.PI / 180;
                result = multiplyMatrix(result, [1, 0, 0, 1, nums[1], nums[2]], [Math.cos(a), Math.sin(a), -Math.sin(a), Math.cos(a), 0, 0], [1, 0, 0, 1, -nums[1], -nums[2]]);
              } else if (func === 'rotate' && nums.length === 1) {
                const _a = nums[0] * Math.PI / 180;

                result = multiplyMatrix(result, [Math.cos(_a), Math.sin(_a), -Math.sin(_a), Math.cos(_a), 0, 0]);
              } else if (func === 'skewX' && nums.length === 1) {
                const _a2 = nums[0] * Math.PI / 180;

                result = multiplyMatrix(result, [1, 0, Math.tan(_a2), 1, 0, 0]);
              } else if (func === 'skewY' && nums.length === 1) {
                const _a3 = nums[0] * Math.PI / 180;

                result = multiplyMatrix(result, [1, Math.tan(_a3), 0, 1, 0, 0]);
              } else {
                return;
              }

              parser.matchSeparator();
            }

            if (parser.matchAll()) {
              return;
            }

            return result;
          }

          function parseAspectRatio(aspectRatio, availWidth, availHeight, elemWidth, elemHeight, initAlign) {
            const temp = (aspectRatio || '').trim().match(/^(none)$|^x(Min|Mid|Max)Y(Min|Mid|Max)(?:\s+(meet|slice))?$/) || [];
            const ratioType = temp[1] || temp[4] || 'meet';
            const xAlign = temp[2] || 'Mid';
            const yAlign = temp[3] || 'Mid';
            let scaleX = availWidth / elemWidth;
            let scaleY = availHeight / elemHeight;
            const dx = {
              Min: 0,
              Mid: 0.5,
              Max: 1,
            }[xAlign] - (initAlign || 0);
            const dy = {
              Min: 0,
              Mid: 0.5,
              Max: 1,
            }[yAlign] - (initAlign || 0);

            if (ratioType === 'slice') {
              scaleY = scaleX = Math.max(scaleX, scaleY);
            } else if (ratioType === 'meet') {
              scaleY = scaleX = Math.min(scaleX, scaleY);
            }

            return [scaleX, 0, 0, scaleY, dx * (availWidth - elemWidth * scaleX), dy * (availHeight - elemHeight * scaleY)];
          }

          function parseStyleAttr(v) {
            const result = Object.create(null);
            v = (v || '').trim().split(/;/);

            for (let i = 0; i < v.length; i++) {
              const key = (v[i].split(':')[0] || '').trim();
              const value = (v[i].split(':')[1] || '').trim();

              if (key) {
                result[key] = value;
              }
            }

            if (result.marker) {
              if (!result['marker-start']) {
                result['marker-start'] = result.marker;
              }

              if (!result['marker-mid']) {
                result['marker-mid'] = result.marker;
              }

              if (!result['marker-end']) {
                result['marker-end'] = result.marker;
              }
            }

            if (result.font) {
              let fontFamily = null;
              let fontSize = null;
              let fontStyle = 'normal';
              let fontWeight = 'normal';
              let fontVariant = 'normal';
              const parts = result.font.split(/\s+/);

              for (let _i = 0; _i < parts.length; _i++) {
                switch (parts[_i]) {
                  case 'normal':
                    break;

                  case 'italic':
                  case 'oblique':
                    fontStyle = parts[_i];
                    break;

                  case 'small-caps':
                    fontVariant = parts[_i];
                    break;

                  case 'bold':
                  case 'bolder':
                  case 'lighter':
                  case '100':
                  case '200':
                  case '300':
                  case '400':
                  case '500':
                  case '600':
                  case '700':
                  case '800':
                  case '900':
                    fontWeight = parts[_i];
                    break;

                  default:
                    if (!fontSize) {
                      fontSize = parts[_i].split('/')[0];
                    } else if (!fontFamily) {
                      fontFamily = parts[_i];
                    } else {
                      fontFamily += ` ${parts[_i]}`;
                    }

                    break;
                }
              }

              if (!result['font-style']) {
                result['font-style'] = fontStyle;
              }

              if (!result['font-variant']) {
                result['font-variant'] = fontVariant;
              }

              if (!result['font-weight']) {
                result['font-weight'] = fontWeight;
              }

              if (!result['font-size']) {
                result['font-size'] = fontSize;
              }

              if (!result['font-family']) {
                result['font-family'] = fontFamily;
              }
            }

            return result;
          }

          function parseSelector(v) {
            const parts = v.split(/(?=[.#])/g);
            const ids = [];
            const classes = [];
            const tags = [];
            let temp;

            for (let i = 0; i < parts.length; i++) {
              if (temp = parts[i].match(/^[#]([_A-Za-z0-9-]+)$/)) {
                ids.push(temp[1]);
              } else if (temp = parts[i].match(/^[.]([_A-Za-z0-9-]+)$/)) {
                classes.push(temp[1]);
              } else if (temp = parts[i].match(/^([_A-Za-z0-9-]+)$/)) {
                tags.push(temp[1]);
              } else if (parts[i] !== '*') {
                return;
              }
            }

            return {
              tags,
              ids,
              classes,
              specificity: ids.length * 10000 + classes.length * 100 + tags.length,
            };
          }

          function parseStyleSheet(v) {
            const parser = new StringParser(v.trim());
            const rules = [];
            let rule;

            while (rule = parser.match(/^\s*([^\{\}]*?)\s*\{([^\{\}]*?)\}/, true)) {
              const selectors = rule[1].split(/\s*,\s*/g);
              const css = parseStyleAttr(rule[2]);

              for (let i = 0; i < selectors.length; i++) {
                const selector = parseSelector(selectors[i]);

                if (selector) {
                  rules.push({
                    selector,
                    css,
                  });
                }
              }
            }

            return rules;
          }

          function matchesSelector(elem, selector) {
            if (elem.nodeType !== 1) {
              return false;
            }

            for (let i = 0; i < selector.tags.length; i++) {
              if (selector.tags[i] !== elem.nodeName) {
                return false;
              }
            }

            for (let _i2 = 0; _i2 < selector.ids.length; _i2++) {
              if (selector.ids[_i2] !== elem.id) {
                return false;
              }
            }

            for (let _i3 = 0; _i3 < selector.classes.length; _i3++) {
              if (elem.classList.indexOf(selector.classes[_i3]) === -1) {
                return false;
              }
            }

            return true;
          }

          function getStyle(elem) {
            const result = Object.create(null);
            const specificities = Object.create(null);

            for (let i = 0; i < styleRules.length; i++) {
              const rule = styleRules[i];

              if (matchesSelector(elem, rule.selector)) {
                for (const key in rule.css) {
                  if (!(specificities[key] > rule.selector.specificity)) {
                    result[key] = rule.css[key];
                    specificities[key] = rule.selector.specificity;
                  }
                }
              }
            }

            return result;
          }

          function combineArrays(array1, array2) {
            return array1.concat(array2.slice(array1.length));
          }

          function getAscent(font, size) {
            return Math.max(font.ascender, (font.bbox[3] || font.bbox.maxY) * (font.scale || 1)) * size / 1000;
          }

          function getDescent(font, size) {
            return Math.min(font.descender, (font.bbox[1] || font.bbox.minY) * (font.scale || 1)) * size / 1000;
          }

          function getXHeight(font, size) {
            return (font.xHeight || 0.5 * (font.ascender - font.descender)) * size / 1000;
          }

          function getBaseline(font, size, baseline, shift) {
            let dy1; let
              dy2;

            switch (baseline) {
              case 'middle':
                dy1 = 0.5 * getXHeight(font, size);
                break;

              case 'central':
                dy1 = 0.5 * (getDescent(font, size) + getAscent(font, size));
                break;

              case 'after-edge':
              case 'text-after-edge':
                dy1 = getDescent(font, size);
                break;

              case 'alphabetic':
              case 'auto':
              case 'baseline':
                dy1 = 0;
                break;

              case 'mathematical':
                dy1 = 0.5 * getAscent(font, size);
                break;

              case 'hanging':
                dy1 = 0.8 * getAscent(font, size);
                break;

              case 'before-edge':
              case 'text-before-edge':
                dy1 = getAscent(font, size);
                break;

              default:
                dy1 = 0;
                break;
            }

            switch (shift) {
              case 'baseline':
                dy2 = 0;
                break;

              case 'super':
                dy2 = 0.6 * size;
                break;

              case 'sub':
                dy2 = -0.6 * size;
                break;

              default:
                dy2 = shift;
                break;
            }

            return dy1 - dy2;
          }

          function getTextPos(font, size, text) {
            const encoded = font.encode(`${text}`);
            const hex = encoded[0];
            const pos = encoded[1];
            const data = [];

            for (let i = 0; i < hex.length; i++) {
              const unicode = font.unicode ? font.unicode[parseInt(hex[i], 16)] : [text.charCodeAt(i)];
              data.push({
                glyph: hex[i],
                unicode,
                width: pos[i].advanceWidth * size / 1000,
                xOffset: pos[i].xOffset * size / 1000,
                yOffset: pos[i].yOffset * size / 1000,
                xAdvance: pos[i].xAdvance * size / 1000,
                yAdvance: pos[i].yAdvance * size / 1000,
              });
            }

            return data;
          }

          function createSVGElement(obj, inherits) {
            switch (obj.nodeName) {
              case 'use':
                return new SvgElemUse(obj, inherits);

              case 'symbol':
                return new SvgElemSymbol(obj, inherits);

              case 'g':
                return new SvgElemGroup(obj, inherits);

              case 'a':
                return new SvgElemLink(obj, inherits);

              case 'svg':
                return new SvgElemSvg(obj, inherits);

              case 'image':
                return new SVGElemImage(obj, inherits);

              case 'rect':
                return new SvgElemRect(obj, inherits);

              case 'circle':
                return new SvgElemCircle(obj, inherits);

              case 'ellipse':
                return new SvgElemEllipse(obj, inherits);

              case 'line':
                return new SvgElemLine(obj, inherits);

              case 'polyline':
                return new SvgElemPolyline(obj, inherits);

              case 'polygon':
                return new SvgElemPolygon(obj, inherits);

              case 'path':
                return new SvgElemPath(obj, inherits);

              case 'text':
                return new SvgElemText(obj, inherits);

              case 'tspan':
                return new SvgElemTspan(obj, inherits);

              case 'textPath':
                return new SvgElemTextPath(obj, inherits);

              case '#text':
              case '#cdata-section':
                return new SvgElemTextNode(obj, inherits);

              default:
                return new SvgElem(obj, inherits);
            }
          }

          var StringParser = function StringParser(str) {
            this.match = function (exp, all) {
              const temp = str.match(exp);

              if (!temp || temp.index !== 0) {
                return;
              }

              str = str.substring(temp[0].length);
              return all ? temp : temp[0];
            };

            this.matchSeparator = function () {
              return this.match(/^(?:\s*,\s*|\s*|)/);
            };

            this.matchSpace = function () {
              return this.match(/^(?:\s*)/);
            };

            this.matchLengthUnit = function () {
              return this.match(/^(?:px|pt|cm|mm|in|pc|em|ex|%|)/);
            };

            this.matchNumber = function () {
              return this.match(/^(?:[-+]?(?:[0-9]+[.][0-9]+|[0-9]+[.]|[.][0-9]+|[0-9]+)(?:[eE][-+]?[0-9]+)?)/);
            };

            this.matchAll = function () {
              return this.match(/^[\s\S]+/);
            };
          };

          const BezierSegment = function BezierSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) {
            const divisions = 6 * precision;
            const equationX = [p1x, -3 * p1x + 3 * c1x, 3 * p1x - 6 * c1x + 3 * c2x, -p1x + 3 * c1x - 3 * c2x + p2x];
            const equationY = [p1y, -3 * p1y + 3 * c1y, 3 * p1y - 6 * c1y + 3 * c2y, -p1y + 3 * c1y - 3 * c2y + p2y];
            const derivativeX = [-3 * p1x + 3 * c1x, 6 * p1x - 12 * c1x + 6 * c2x, -3 * p1x + 9 * c1x - 9 * c2x + 3 * p2x];
            const derivativeY = [-3 * p1y + 3 * c1y, 6 * p1y - 12 * c1y + 6 * c2y, -3 * p1y + 9 * c1y - 9 * c2y + 3 * p2y];
            const lengthMap = [0];

            for (let i = 1; i <= divisions; i++) {
              const t = (i - 0.5) / divisions;
              const dx = getCurveValue(t, derivativeX) / divisions;
              const dy = getCurveValue(t, derivativeY) / divisions;
              const l = Math.sqrt(dx * dx + dy * dy);
              lengthMap[i] = lengthMap[i - 1] + l;
            }

            this.totalLength = lengthMap[divisions];
            this.startPoint = [p1x, p1y, isEqual(p1x, c1x) && isEqual(p1y, c1y) ? Math.atan2(c2y - c1y, c2x - c1x) : Math.atan2(c1y - p1y, c1x - p1x)];
            this.endPoint = [p2x, p2y, isEqual(c2x, p2x) && isEqual(c2y, p2y) ? Math.atan2(c2y - c1y, c2x - c1x) : Math.atan2(p2y - c2y, p2x - c2x)];

            this.getBoundingBox = function () {
              let temp;
              let minX = getCurveValue(0, equationX);
              let minY = getCurveValue(0, equationY);
              let maxX = getCurveValue(1, equationX);
              let maxY = getCurveValue(1, equationY);

              if (minX > maxX) {
                temp = maxX;
                maxX = minX;
                minX = temp;
              }

              if (minY > maxY) {
                temp = maxY;
                maxY = minY;
                minY = temp;
              }

              const rootsX = solveEquation(derivativeX);

              for (let _i4 = 0; _i4 < rootsX.length; _i4++) {
                if (rootsX[_i4] >= 0 && rootsX[_i4] <= 1) {
                  const _x = getCurveValue(rootsX[_i4], equationX);

                  if (_x < minX) {
                    minX = _x;
                  }

                  if (_x > maxX) {
                    maxX = _x;
                  }
                }
              }

              const rootsY = solveEquation(derivativeY);

              for (let _i5 = 0; _i5 < rootsY.length; _i5++) {
                if (rootsY[_i5] >= 0 && rootsY[_i5] <= 1) {
                  const _y = getCurveValue(rootsY[_i5], equationY);

                  if (_y < minY) {
                    minY = _y;
                  }

                  if (_y > maxY) {
                    maxY = _y;
                  }
                }
              }

              return [minX, minY, maxX, maxY];
            };

            this.getPointAtLength = function (l) {
              if (isEqual(l, 0)) {
                return this.startPoint;
              }

              if (isEqual(l, this.totalLength)) {
                return this.endPoint;
              }

              if (l < 0 || l > this.totalLength) {
                return;
              }

              for (let _i6 = 1; _i6 <= divisions; _i6++) {
                const l1 = lengthMap[_i6 - 1];
                const l2 = lengthMap[_i6];

                if (l1 <= l && l <= l2) {
                  const _t = (_i6 - (l2 - l) / (l2 - l1)) / divisions;
                  const _x2 = getCurveValue(_t, equationX);
                  const _y2 = getCurveValue(_t, equationY);
                  const _dx = getCurveValue(_t, derivativeX);
                  const _dy = getCurveValue(_t, derivativeY);

                  return [_x2, _y2, Math.atan2(_dy, _dx)];
                }
              }
            };
          };

          const LineSegment = function LineSegment(p1x, p1y, p2x, p2y) {
            this.totalLength = Math.sqrt((p2x - p1x) * (p2x - p1x) + (p2y - p1y) * (p2y - p1y));
            this.startPoint = [p1x, p1y, Math.atan2(p2y - p1y, p2x - p1x)];
            this.endPoint = [p2x, p2y, Math.atan2(p2y - p1y, p2x - p1x)];

            this.getBoundingBox = function () {
              return [Math.min(this.startPoint[0], this.endPoint[0]), Math.min(this.startPoint[1], this.endPoint[1]), Math.max(this.startPoint[0], this.endPoint[0]), Math.max(this.startPoint[1], this.endPoint[1])];
            };

            this.getPointAtLength = function (l) {
              if (l >= 0 && l <= this.totalLength) {
                const r = l / this.totalLength || 0;
                const _x3 = this.startPoint[0] + r * (this.endPoint[0] - this.startPoint[0]);
                const _y3 = this.startPoint[1] + r * (this.endPoint[1] - this.startPoint[1]);

                return [_x3, _y3, this.startPoint[2]];
              }
            };
          };

          var SvgShape = function SvgShape() {
            this.pathCommands = [];
            this.pathSegments = [];
            this.startPoint = null;
            this.endPoint = null;
            this.totalLength = 0;
            let startX = 0;
            let startY = 0;
            let currX = 0;
            let currY = 0;
            let lastCom;
            let lastCtrlX;
            let lastCtrlY;

            this.move = function (x, y) {
              startX = currX = x;
              startY = currY = y;
              return null;
            };

            this.line = function (x, y) {
              const segment = new LineSegment(currX, currY, x, y);
              currX = x;
              currY = y;
              return segment;
            };

            this.curve = function (c1x, c1y, c2x, c2y, x, y) {
              const segment = new BezierSegment(currX, currY, c1x, c1y, c2x, c2y, x, y);
              currX = x;
              currY = y;
              return segment;
            };

            this.close = function () {
              const segment = new LineSegment(currX, currY, startX, startY);
              currX = startX;
              currY = startY;
              return segment;
            };

            this.addCommand = function (data) {
              this.pathCommands.push(data);
              const segment = this[data[0]].apply(this, data.slice(3));

              if (segment) {
                segment.hasStart = data[1];
                segment.hasEnd = data[2];
                this.startPoint = this.startPoint || segment.startPoint;
                this.endPoint = segment.endPoint;
                this.pathSegments.push(segment);
                this.totalLength += segment.totalLength;
              }
            };

            this.M = function (x, y) {
              this.addCommand(['move', true, true, x, y]);
              lastCom = 'M';
              return this;
            };

            this.m = function (x, y) {
              return this.M(currX + x, currY + y);
            };

            this.Z = this.z = function () {
              this.addCommand(['close', true, true]);
              lastCom = 'Z';
              return this;
            };

            this.L = function (x, y) {
              this.addCommand(['line', true, true, x, y]);
              lastCom = 'L';
              return this;
            };

            this.l = function (x, y) {
              return this.L(currX + x, currY + y);
            };

            this.H = function (x) {
              return this.L(x, currY);
            };

            this.h = function (x) {
              return this.L(currX + x, currY);
            };

            this.V = function (y) {
              return this.L(currX, y);
            };

            this.v = function (y) {
              return this.L(currX, currY + y);
            };

            this.C = function (c1x, c1y, c2x, c2y, x, y) {
              this.addCommand(['curve', true, true, c1x, c1y, c2x, c2y, x, y]);
              lastCom = 'C';
              lastCtrlX = c2x;
              lastCtrlY = c2y;
              return this;
            };

            this.c = function (c1x, c1y, c2x, c2y, x, y) {
              return this.C(currX + c1x, currY + c1y, currX + c2x, currY + c2y, currX + x, currY + y);
            };

            this.S = function (c1x, c1y, x, y) {
              return this.C(currX + (lastCom === 'C' ? currX - lastCtrlX : 0), currY + (lastCom === 'C' ? currY - lastCtrlY : 0), c1x, c1y, x, y);
            };

            this.s = function (c1x, c1y, x, y) {
              return this.C(currX + (lastCom === 'C' ? currX - lastCtrlX : 0), currY + (lastCom === 'C' ? currY - lastCtrlY : 0), currX + c1x, currY + c1y, currX + x, currY + y);
            };

            this.Q = function (cx, cy, x, y) {
              const c1x = currX + 2 / 3 * (cx - currX);
              const c1y = currY + 2 / 3 * (cy - currY);
              const c2x = x + 2 / 3 * (cx - x);
              const c2y = y + 2 / 3 * (cy - y);
              this.addCommand(['curve', true, true, c1x, c1y, c2x, c2y, x, y]);
              lastCom = 'Q';
              lastCtrlX = cx;
              lastCtrlY = cy;
              return this;
            };

            this.q = function (c1x, c1y, x, y) {
              return this.Q(currX + c1x, currY + c1y, currX + x, currY + y);
            };

            this.T = function (x, y) {
              return this.Q(currX + (lastCom === 'Q' ? currX - lastCtrlX : 0), currY + (lastCom === 'Q' ? currY - lastCtrlY : 0), x, y);
            };

            this.t = function (x, y) {
              return this.Q(currX + (lastCom === 'Q' ? currX - lastCtrlX : 0), currY + (lastCom === 'Q' ? currY - lastCtrlY : 0), currX + x, currY + y);
            };

            this.A = function (rx, ry, fi, fa, fs, x, y) {
              if (isEqual(rx, 0) || isEqual(ry, 0)) {
                this.addCommand(['line', true, true, x, y]);
              } else {
                fi *= (Math.PI / 180);
                rx = Math.abs(rx);
                ry = Math.abs(ry);
                fa = 1 * !!fa;
                fs = 1 * !!fs;
                const x1 = Math.cos(fi) * (currX - x) / 2 + Math.sin(fi) * (currY - y) / 2;
                const y1 = Math.cos(fi) * (currY - y) / 2 - Math.sin(fi) * (currX - x) / 2;
                const lambda = x1 * x1 / (rx * rx) + y1 * y1 / (ry * ry);

                if (lambda > 1) {
                  rx *= Math.sqrt(lambda);
                  ry *= Math.sqrt(lambda);
                }

                const r = Math.sqrt(Math.max(0, rx * rx * ry * ry - rx * rx * y1 * y1 - ry * ry * x1 * x1) / (rx * rx * y1 * y1 + ry * ry * x1 * x1));
                const x2 = (fa === fs ? -1 : 1) * r * rx * y1 / ry;
                const y2 = (fa === fs ? 1 : -1) * r * ry * x1 / rx;
                const cx = Math.cos(fi) * x2 - Math.sin(fi) * y2 + (currX + x) / 2;
                const cy = Math.sin(fi) * x2 + Math.cos(fi) * y2 + (currY + y) / 2;
                const th1 = Math.atan2((y1 - y2) / ry, (x1 - x2) / rx);
                let th2 = Math.atan2((-y1 - y2) / ry, (-x1 - x2) / rx);

                if (fs === 0 && th2 - th1 > 0) {
                  th2 -= 2 * Math.PI;
                } else if (fs === 1 && th2 - th1 < 0) {
                  th2 += 2 * Math.PI;
                }

                const segms = Math.ceil(Math.abs(th2 - th1) / (Math.PI / precision));

                for (let i = 0; i < segms; i++) {
                  const th3 = th1 + i * (th2 - th1) / segms;
                  const th4 = th1 + (i + 1) * (th2 - th1) / segms;
                  const t = 4 / 3 * Math.tan((th4 - th3) / 4);
                  const c1x = cx + Math.cos(fi) * rx * (Math.cos(th3) - t * Math.sin(th3)) - Math.sin(fi) * ry * (Math.sin(th3) + t * Math.cos(th3));
                  const c1y = cy + Math.sin(fi) * rx * (Math.cos(th3) - t * Math.sin(th3)) + Math.cos(fi) * ry * (Math.sin(th3) + t * Math.cos(th3));
                  const c2x = cx + Math.cos(fi) * rx * (Math.cos(th4) + t * Math.sin(th4)) - Math.sin(fi) * ry * (Math.sin(th4) - t * Math.cos(th4));
                  const c2y = cy + Math.sin(fi) * rx * (Math.cos(th4) + t * Math.sin(th4)) + Math.cos(fi) * ry * (Math.sin(th4) - t * Math.cos(th4));
                  const endX = cx + Math.cos(fi) * rx * Math.cos(th4) - Math.sin(fi) * ry * Math.sin(th4);
                  const endY = cy + Math.sin(fi) * rx * Math.cos(th4) + Math.cos(fi) * ry * Math.sin(th4);
                  this.addCommand(['curve', i === 0, i === segms - 1, c1x, c1y, c2x, c2y, endX, endY]);
                }
              }

              lastCom = 'A';
              return this;
            };

            this.a = function (rx, ry, fi, fa, fs, x, y) {
              return this.A(rx, ry, fi, fa, fs, currX + x, currY + y);
            };

            this.path = function (d) {
              let command;
              let value;
              let temp;
              const parser = new StringParser((d || '').trim());

              while (command = parser.match(/^[astvzqmhlcASTVZQMHLC]/)) {
                parser.matchSeparator();
                let values = [];

                while (value = PathFlags[command + values.length] ? parser.match(/^[01]/) : parser.matchNumber()) {
                  parser.matchSeparator();

                  if (values.length === PathArguments[command]) {
                    this[command].apply(this, values);
                    values = [];

                    if (command === 'M') {
                      command = 'L';
                    } else if (command === 'm') {
                      command = 'l';
                    }
                  }

                  values.push(Number(value));
                }

                if (values.length === PathArguments[command]) {
                  this[command].apply(this, values);
                } else {
                  warningCallback(`SvgPath: command ${command} with ${values.length} numbers`);
                  return;
                }
              }

              if (temp = parser.matchAll()) {
                warningCallback(`SvgPath: unexpected string ${temp}`);
              }

              return this;
            };

            this.getBoundingBox = function () {
              const bbox = [Infinity, Infinity, -Infinity, -Infinity];

              function addBounds(bbox1) {
                if (bbox1[0] < bbox[0]) {
                  bbox[0] = bbox1[0];
                }

                if (bbox1[2] > bbox[2]) {
                  bbox[2] = bbox1[2];
                }

                if (bbox1[1] < bbox[1]) {
                  bbox[1] = bbox1[1];
                }

                if (bbox1[3] > bbox[3]) {
                  bbox[3] = bbox1[3];
                }
              }

              for (let i = 0; i < this.pathSegments.length; i++) {
                addBounds(this.pathSegments[i].getBoundingBox());
              }

              if (bbox[0] === Infinity) {
                bbox[0] = 0;
              }

              if (bbox[1] === Infinity) {
                bbox[1] = 0;
              }

              if (bbox[2] === -Infinity) {
                bbox[2] = 0;
              }

              if (bbox[3] === -Infinity) {
                bbox[3] = 0;
              }

              return bbox;
            };

            this.getPointAtLength = function (l) {
              if (l >= 0 && l <= this.totalLength) {
                let temp;

                for (let i = 0; i < this.pathSegments.length; i++) {
                  if (temp = this.pathSegments[i].getPointAtLength(l)) {
                    return temp;
                  }

                  l -= this.pathSegments[i].totalLength;
                }

                return this.endPoint;
              }
            };

            this.transform = function (m) {
              this.pathSegments = [];
              this.startPoint = null;
              this.endPoint = null;
              this.totalLength = 0;

              for (let i = 0; i < this.pathCommands.length; i++) {
                const data = this.pathCommands.shift();

                for (let j = 3; j < data.length; j += 2) {
                  const p = transformPoint([data[j], data[j + 1]], m);
                  data[j] = p[0];
                  data[j + 1] = p[1];
                }

                this.addCommand(data);
              }

              return this;
            };

            this.mergeShape = function (shape) {
              for (let i = 0; i < shape.pathCommands.length; i++) {
                this.addCommand(shape.pathCommands[i].slice());
              }

              return this;
            };

            this.clone = function () {
              return new SvgShape().mergeShape(this);
            };

            this.insertInDocument = function () {
              for (let i = 0; i < this.pathCommands.length; i++) {
                const command = this.pathCommands[i][0];
                const values = this.pathCommands[i].slice(3);

                switch (command) {
                  case 'move':
                    doc.moveTo(values[0], values[1]);
                    break;

                  case 'line':
                    doc.lineTo(values[0], values[1]);
                    break;

                  case 'curve':
                    doc.bezierCurveTo(values[0], values[1], values[2], values[3], values[4], values[5]);
                    break;

                  case 'close':
                    doc.closePath();
                    break;
                }
              }
            };

            this.getSubPaths = function () {
              const subPaths = [];
              let shape = new SvgShape();

              for (let i = 0; i < this.pathCommands.length; i++) {
                const data = this.pathCommands[i];
                const command = this.pathCommands[i][0];

                if (command === 'move' && i !== 0) {
                  subPaths.push(shape);
                  shape = new SvgShape();
                }

                shape.addCommand(data);
              }

              subPaths.push(shape);
              return subPaths;
            };

            this.getMarkers = function () {
              let markers = [];
              const subPaths = this.getSubPaths();

              for (let i = 0; i < subPaths.length; i++) {
                const subPath = subPaths[i];
                const subPathMarkers = [];

                for (let j = 0; j < subPath.pathSegments.length; j++) {
                  const segment = subPath.pathSegments[j];

                  if (isNotEqual(segment.totalLength, 0) || j === 0 || j === subPath.pathSegments.length - 1) {
                    if (segment.hasStart) {
                      const startMarker = segment.getPointAtLength(0);
                      const prevEndMarker = subPathMarkers.pop();

                      if (prevEndMarker) {
                        startMarker[2] = 0.5 * (prevEndMarker[2] + startMarker[2]);
                      }

                      subPathMarkers.push(startMarker);
                    }

                    if (segment.hasEnd) {
                      const endMarker = segment.getPointAtLength(segment.totalLength);
                      subPathMarkers.push(endMarker);
                    }
                  }
                }

                markers = markers.concat(subPathMarkers);
              }

              return markers;
            };
          };

          var SvgElem = function SvgElem(obj, inherits) {
            const styleCache = Object.create(null);
            let childrenCache = null;
            this.name = obj.nodeName;
            this.isOuterElement = obj === svg || !obj.parentNode;
            this.inherits = inherits || (!this.isOuterElement ? createSVGElement(obj.parentNode, null) : null);
            this.stack = this.inherits ? this.inherits.stack.concat(obj) : [obj];
            this.style = parseStyleAttr(typeof obj.getAttribute === 'function' && obj.getAttribute('style'));
            this.css = useCSS ? getComputedStyle(obj) : getStyle(obj);
            this.allowedChildren = [];

            this.attr = function (key) {
              if (typeof obj.getAttribute === 'function') {
                return obj.getAttribute(key);
              }
            };

            this.resolveUrl = function (value) {
              const temp = (value || '').match(/^\s*(?:url\("(.*)#(.*)"\)|url\('(.*)#(.*)'\)|url\((.*)#(.*)\)|(.*)#(.*))\s*$/) || [];
              const file = temp[1] || temp[3] || temp[5] || temp[7];
              const id = temp[2] || temp[4] || temp[6] || temp[8];

              if (id) {
                if (!file) {
                  const svgObj = svg.getElementById(id);

                  if (svgObj) {
                    if (this.stack.indexOf(svgObj) === -1) {
                      return svgObj;
                    }
                    warningCallback(`SVGtoPDF: loop of circular references for id "${id}"`);
                    return;
                  }
                }

                if (documentCallback) {
                  let svgs = documentCache[file];

                  if (!svgs) {
                    svgs = documentCallback(file);

                    if (!isArrayLike(svgs)) {
                      svgs = [svgs];
                    }

                    for (let i = 0; i < svgs.length; i++) {
                      if (typeof svgs[i] === 'string') {
                        svgs[i] = parseXml(svgs[i]);
                      }
                    }

                    documentCache[file] = svgs;
                  }

                  for (let _i7 = 0; _i7 < svgs.length; _i7++) {
                    const _svgObj = svgs[_i7].getElementById(id);

                    if (_svgObj) {
                      if (this.stack.indexOf(_svgObj) === -1) {
                        return _svgObj;
                      }
                      warningCallback(`SVGtoPDF: loop of circular references for id "${file}#${id}"`);
                      return;
                    }
                  }
                }
              }
            };

            this.computeUnits = function (value, unit, percent, isFontSize) {
              if (unit === '%') {
                return parseFloat(value) / 100 * (isFontSize || percent != null ? percent : this.getViewport());
              } if (unit === 'ex' || unit === 'em') {
                return value * {
                  em: 1,
                  ex: 0.5,
                }[unit] * (isFontSize ? percent : this.get('font-size'));
              }
              return value * {
                '': 1,
                px: 1,
                pt: 96 / 72,
                cm: 96 / 2.54,
                mm: 96 / 25.4,
                in: 96,
                pc: 96 / 6,
              }[unit];
            };

            this.computeLength = function (value, percent, initial, isFontSize) {
              const parser = new StringParser((value || '').trim());
              let temp1;
              let temp2;

              if (typeof (temp1 = parser.matchNumber()) === 'string' && typeof (temp2 = parser.matchLengthUnit()) === 'string' && !parser.matchAll()) {
                return this.computeUnits(temp1, temp2, percent, isFontSize);
              }

              return initial;
            };

            this.computeLengthList = function (value, percent, strict) {
              const parser = new StringParser((value || '').trim());
              const result = [];
              let temp1;
              let temp2;

              while (typeof (temp1 = parser.matchNumber()) === 'string' && typeof (temp2 = parser.matchLengthUnit()) === 'string') {
                result.push(this.computeUnits(temp1, temp2, percent));
                parser.matchSeparator();
              }

              if (strict && parser.matchAll()) {
                return;
              }

              return result;
            };

            this.getLength = function (key, percent, initial) {
              return this.computeLength(this.attr(key), percent, initial);
            };

            this.getLengthList = function (key, percent) {
              return this.computeLengthList(this.attr(key), percent);
            };

            this.getUrl = function (key) {
              return this.resolveUrl(this.attr(key));
            };

            this.getNumberList = function (key) {
              const parser = new StringParser((this.attr(key) || '').trim());
              const result = [];
              let temp;

              while (temp = parser.matchNumber()) {
                result.push(Number(temp));
                parser.matchSeparator();
              }

              result.error = parser.matchAll();
              return result;
            };

            this.getViewbox = function (key, initial) {
              const viewBox = this.getNumberList(key);

              if (viewBox.length === 4 && viewBox[2] >= 0 && viewBox[3] >= 0) {
                return viewBox;
              }

              return initial;
            };

            this.getPercent = function (key, initial) {
              const value = this.attr(key);
              const parser = new StringParser((value || '').trim());
              let temp1;
              let temp2;
              let number = parser.matchNumber();

              if (!number) {
                return initial;
              }

              if (parser.match('%')) {
                number *= 0.01;
              }

              if (parser.matchAll()) {
                return initial;
              }

              return Math.max(0, Math.min(1, number));
            };

            this.chooseValue = function (args) {
              for (let i = 0; i < arguments.length; i++) {
                if (arguments[i] != null && arguments[i] === arguments[i]) {
                  return arguments[i];
                }
              }

              return arguments[arguments.length - 1];
            };

            this.get = function (key) {
              if (styleCache[key] !== undefined) {
                return styleCache[key];
              }

              const keyInfo = Properties[key] || {};
              let value;
              let result;

              for (let i = 0; i < 3; i++) {
                switch (i) {
                  case 0:
                    if (key !== 'transform') {
                      // the CSS transform behaves strangely
                      value = this.css[keyInfo.css || key];
                    }

                    break;

                  case 1:
                    value = this.style[key];
                    break;

                  case 2:
                    value = this.attr(key);
                    break;
                }

                if (value === 'inherit') {
                  result = this.inherits ? this.inherits.get(key) : keyInfo.initial;

                  if (result != null) {
                    return styleCache[key] = result;
                  }
                }

                if (keyInfo.values != null) {
                  result = keyInfo.values[value];

                  if (result != null) {
                    return styleCache[key] = result;
                  }
                }

                if (value != null) {
                  let parsed = void 0;

                  switch (key) {
                    case 'font-size':
                      result = this.computeLength(value, this.inherits ? this.inherits.get(key) : keyInfo.initial, undefined, true);
                      break;

                    case 'baseline-shift':
                      result = this.computeLength(value, this.get('font-size'));
                      break;

                    case 'font-family':
                      result = value || undefined;
                      break;

                    case 'opacity':
                    case 'stroke-opacity':
                    case 'fill-opacity':
                    case 'stop-opacity':
                      parsed = parseFloat(value);

                      if (!isNaN(parsed)) {
                        result = Math.max(0, Math.min(1, parsed));
                      }

                      break;

                    case 'transform':
                      result = parseTranform(value);
                      break;

                    case 'stroke-dasharray':
                      if (value === 'none') {
                        result = [];
                      } else if (parsed = this.computeLengthList(value, this.getViewport(), true)) {
                        let sum = 0;
                        let error = false;

                        for (let j = 0; j < parsed.length; j++) {
                          if (parsed[j] < 0) {
                            error = true;
                          }

                          sum += parsed[j];
                        }

                        if (!error) {
                          if (parsed.length % 2 === 1) {
                            parsed = parsed.concat(parsed);
                          }

                          result = sum === 0 ? [] : parsed;
                        }
                      }

                      break;

                    case 'color':
                      if (value === 'none' || value === 'transparent') {
                        result = 'none';
                      } else {
                        result = parseColor(value);
                      }

                      break;

                    case 'fill':
                    case 'stroke':
                      if (value === 'none' || value === 'transparent') {
                        result = 'none';
                      } else if (value === 'currentColor') {
                        result = this.get('color');
                      } else if (parsed = parseColor(value)) {
                        return parsed;
                      } else if (parsed = (value || '').split(' ')) {
                        const object = this.resolveUrl(parsed[0]);
                        const fallbackColor = parseColor(parsed[1]);

                        if (object == null) {
                          result = fallbackColor;
                        } else if (object.nodeName === 'linearGradient' || object.nodeName === 'radialGradient') {
                          result = new SvgElemGradient(object, null, fallbackColor);
                        } else if (object.nodeName === 'pattern') {
                          result = new SvgElemPattern(object, null, fallbackColor);
                        } else {
                          result = fallbackColor;
                        }
                      }

                      break;

                    case 'stop-color':
                      if (value === 'none' || value === 'transparent') {
                        result = 'none';
                      } else if (value === 'currentColor') {
                        result = this.get('color');
                      } else {
                        result = parseColor(value);
                      }

                      break;

                    case 'marker-start':
                    case 'marker-mid':
                    case 'marker-end':
                    case 'clip-path':
                    case 'mask':
                      if (value === 'none') {
                        result = 'none';
                      } else {
                        result = this.resolveUrl(value);
                      }

                      break;

                    case 'stroke-width':
                      parsed = this.computeLength(value, this.getViewport());

                      if (parsed != null && parsed >= 0) {
                        result = parsed;
                      }

                      break;

                    case 'stroke-miterlimit':
                      parsed = parseFloat(value);

                      if (parsed != null && parsed >= 1) {
                        result = parsed;
                      }

                      break;

                    case 'word-spacing':
                    case 'letter-spacing':
                      result = this.computeLength(value, this.getViewport());
                      break;

                    case 'stroke-dashoffset':
                      result = this.computeLength(value, this.getViewport());

                      if (result != null) {
                        if (result < 0) {
                          // fix for crbug.com/660850
                          const dasharray = this.get('stroke-dasharray');

                          for (let _j = 0; _j < dasharray.length; _j++) {
                            result += dasharray[_j];
                          }
                        }
                      }

                      break;
                  }

                  if (result != null) {
                    return styleCache[key] = result;
                  }
                }
              }

              return styleCache[key] = keyInfo.inherit && this.inherits ? this.inherits.get(key) : keyInfo.initial;
            };

            this.getChildren = function () {
              if (childrenCache != null) {
                return childrenCache;
              }

              const children = [];

              for (let i = 0; i < obj.childNodes.length; i++) {
                const child = obj.childNodes[i];

                if (!child.error && this.allowedChildren.indexOf(child.nodeName) !== -1) {
                  children.push(createSVGElement(child, this));
                }
              }

              return childrenCache = children;
            };

            this.getParentVWidth = function () {
              return this.inherits ? this.inherits.getVWidth() : viewportWidth;
            };

            this.getParentVHeight = function () {
              return this.inherits ? this.inherits.getVHeight() : viewportHeight;
            };

            this.getParentViewport = function () {
              return Math.sqrt(0.5 * this.getParentVWidth() * this.getParentVWidth() + 0.5 * this.getParentVHeight() * this.getParentVHeight());
            };

            this.getVWidth = function () {
              return this.getParentVWidth();
            };

            this.getVHeight = function () {
              return this.getParentVHeight();
            };

            this.getViewport = function () {
              return Math.sqrt(0.5 * this.getVWidth() * this.getVWidth() + 0.5 * this.getVHeight() * this.getVHeight());
            };

            this.getBoundingBox = function () {
              const shape = this.getBoundingShape();
              return shape.getBoundingBox();
            };
          };

          const SvgElemStylable = function SvgElemStylable(obj, inherits) {
            SvgElem.call(this, obj, inherits);

            this.transform = function () {
              doc.transform.apply(doc, this.getTransformation());
            };

            this.clip = function () {
              if (this.get('clip-path') !== 'none') {
                const clipPath = new SvgElemClipPath(this.get('clip-path'), null);
                clipPath.useMask(this.getBoundingBox());
                return true;
              }
            };

            this.mask = function () {
              if (this.get('mask') !== 'none') {
                const mask = new SvgElemMask(this.get('mask'), null);
                mask.useMask(this.getBoundingBox());
                return true;
              }
            };

            this.getFill = function (isClip, isMask) {
              const opacity = this.get('opacity');
              const fill = this.get('fill');
              const fillOpacity = this.get('fill-opacity');

              if (isClip) {
                return DefaultColors.white;
              }

              if (fill !== 'none' && opacity && fillOpacity) {
                if (fill instanceof SvgElemGradient || fill instanceof SvgElemPattern) {
                  return fill.getPaint(this.getBoundingBox(), fillOpacity * opacity, isClip, isMask);
                }

                return opacityToColor(fill, fillOpacity * opacity, isMask);
              }
            };

            this.getStroke = function (isClip, isMask) {
              const opacity = this.get('opacity');
              const stroke = this.get('stroke');
              const strokeOpacity = this.get('stroke-opacity');

              if (isClip || isEqual(this.get('stroke-width'), 0)) {
                return;
              }

              if (stroke !== 'none' && opacity && strokeOpacity) {
                if (stroke instanceof SvgElemGradient || stroke instanceof SvgElemPattern) {
                  return stroke.getPaint(this.getBoundingBox(), strokeOpacity * opacity, isClip, isMask);
                }

                return opacityToColor(stroke, strokeOpacity * opacity, isMask);
              }
            };
          };

          const SvgElemHasChildren = function SvgElemHasChildren(obj, inherits) {
            SvgElemStylable.call(this, obj, inherits);
            this.allowedChildren = ['use', 'g', 'a', 'svg', 'image', 'rect', 'circle', 'ellipse', 'line', 'polyline', 'polygon', 'path', 'text'];

            this.getBoundingShape = function () {
              const shape = new SvgShape();
              const children = this.getChildren();

              for (let i = 0; i < children.length; i++) {
                if (children[i].get('display') !== 'none') {
                  if (typeof children[i].getBoundingShape === 'function') {
                    const childShape = children[i].getBoundingShape().clone();

                    if (typeof children[i].getTransformation === 'function') {
                      childShape.transform(children[i].getTransformation());
                    }

                    shape.mergeShape(childShape);
                  }
                }
              }

              return shape;
            };

            this.drawChildren = function (isClip, isMask) {
              const children = this.getChildren();

              for (let i = 0; i < children.length; i++) {
                if (children[i].get('display') !== 'none') {
                  if (typeof children[i].drawInDocument === 'function') {
                    children[i].drawInDocument(isClip, isMask);
                  }
                }
              }
            };
          };

          const SvgElemContainer = function SvgElemContainer(obj, inherits) {
            SvgElemHasChildren.call(this, obj, inherits);

            this.drawContent = function (isClip, isMask) {
              this.transform();
              const clipped = this.clip();
              const masked = this.mask();
              let group;

              if ((this.get('opacity') < 1 || clipped || masked) && !isClip) {
                group = docBeginGroup(getPageBBox());
              }

              this.drawChildren(isClip, isMask);

              if (group) {
                docEndGroup(group);
                doc.fillOpacity(this.get('opacity'));
                docInsertGroup(group);
              }
            };
          };

          var SvgElemUse = function SvgElemUse(obj, inherits) {
            SvgElemContainer.call(this, obj, inherits);
            const x = this.getLength('x', this.getVWidth(), 0);
            const y = this.getLength('y', this.getVHeight(), 0);
            let child = this.getUrl('href') || this.getUrl('xlink:href');

            if (child) {
              child = createSVGElement(child, this);
            }

            this.getChildren = function () {
              return child ? [child] : [];
            };

            this.drawInDocument = function (isClip, isMask) {
              doc.save();
              this.drawContent(isClip, isMask);
              doc.restore();
            };

            this.getTransformation = function () {
              return multiplyMatrix(this.get('transform'), [1, 0, 0, 1, x, y]);
            };
          };

          var SvgElemSymbol = function SvgElemSymbol(obj, inherits) {
            SvgElemContainer.call(this, obj, inherits);
            let width = this.getLength('width', this.getParentVWidth(), this.getParentVWidth());
            let height = this.getLength('height', this.getParentVHeight(), this.getParentVHeight());

            if (inherits instanceof SvgElemUse) {
              width = inherits.getLength('width', inherits.getParentVWidth(), width);
              height = inherits.getLength('height', inherits.getParentVHeight(), height);
            }

            const aspectRatio = (this.attr('preserveAspectRatio') || '').trim();
            const viewBox = this.getViewbox('viewBox', [0, 0, width, height]);

            this.getVWidth = function () {
              return viewBox[2];
            };

            this.getVHeight = function () {
              return viewBox[3];
            };

            this.drawInDocument = function (isClip, isMask) {
              doc.save();
              this.drawContent(isClip, isMask);
              doc.restore();
            };

            this.getTransformation = function () {
              return multiplyMatrix(parseAspectRatio(aspectRatio, width, height, viewBox[2], viewBox[3]), [1, 0, 0, 1, -viewBox[0], -viewBox[1]]);
            };
          };

          var SvgElemGroup = function SvgElemGroup(obj, inherits) {
            SvgElemContainer.call(this, obj, inherits);

            this.drawInDocument = function (isClip, isMask) {
              doc.save();

              if (this.link && !isClip && !isMask) {
                this.addLink();
              }

              this.drawContent(isClip, isMask);
              doc.restore();
            };

            this.getTransformation = function () {
              return this.get('transform');
            };
          };

          var SvgElemLink = function SvgElemLink(obj, inherits) {
            if (inherits && inherits.isText) {
              SvgElemTspan.call(this, obj, inherits);
              this.allowedChildren = ['textPath', 'tspan', '#text', '#cdata-section', 'a'];
            } else {
              SvgElemGroup.call(this, obj, inherits);
            }

            this.link = this.attr('href') || this.attr('xlink:href');

            this.addLink = function () {
              if (this.link.match(/^(?:[a-z][a-z0-9+.-]*:|\/\/)?/i) && this.getChildren().length) {
                const bbox = this.getBoundingShape().transform(getGlobalMatrix()).getBoundingBox();
                docInsertLink(bbox[0], bbox[1], bbox[2], bbox[3], this.link);
              }
            };
          };

          var SvgElemSvg = function SvgElemSvg(obj, inherits) {
            SvgElemContainer.call(this, obj, inherits);
            let width = this.getLength('width', this.getParentVWidth(), this.getParentVWidth());
            let height = this.getLength('height', this.getParentVHeight(), this.getParentVHeight());
            let x = this.getLength('x', this.getParentVWidth(), 0);
            let y = this.getLength('y', this.getParentVHeight(), 0);

            if (inherits instanceof SvgElemUse) {
              width = inherits.getLength('width', inherits.getParentVWidth(), width);
              height = inherits.getLength('height', inherits.getParentVHeight(), height);
            }

            let aspectRatio = this.attr('preserveAspectRatio');
            const viewBox = this.getViewbox('viewBox', [0, 0, width, height]);

            if (this.isOuterElement && preserveAspectRatio) {
              x = y = 0;
              width = viewportWidth;
              height = viewportHeight;
              aspectRatio = preserveAspectRatio;
            }

            this.getVWidth = function () {
              return viewBox[2];
            };

            this.getVHeight = function () {
              return viewBox[3];
            };

            this.drawInDocument = function (isClip, isMask) {
              doc.save();

              if (this.get('overflow') === 'hidden') {
                new SvgShape().M(x, y).L(x + width, y).L(x + width, y + height)
                  .L(x, y + height)
                  .Z()
                  .transform(this.get('transform'))
                  .insertInDocument();
                doc.clip();
              }

              this.drawContent(isClip, isMask);
              doc.restore();
            };

            this.getTransformation = function () {
              return multiplyMatrix(this.get('transform'), [1, 0, 0, 1, x, y], parseAspectRatio(aspectRatio, width, height, viewBox[2], viewBox[3]), [1, 0, 0, 1, -viewBox[0], -viewBox[1]]);
            };
          };

          var SVGElemImage = function SVGElemImage(obj, inherits) {
            SvgElemStylable.call(this, obj, inherits);
            const link = imageCallback(this.attr('href') || this.attr('xlink:href') || '');
            const x = this.getLength('x', this.getVWidth(), 0);
            const y = this.getLength('y', this.getVHeight(), 0);
            let width = this.getLength('width', this.getVWidth(), 'auto');
            let height = this.getLength('height', this.getVHeight(), 'auto');
            let image;

            try {
              image = doc.openImage(link);
            } catch (e) {
              warningCallback(`SVGElemImage: failed to open image "${link}" in PDFKit`);
            }

            if (image) {
              if (width === 'auto' && height !== 'auto') {
                width = height * image.width / image.height;
              } else if (height === 'auto' && width !== 'auto') {
                height = width * image.height / image.width;
              } else if (width === 'auto' && height === 'auto') {
                width = image.width;
                height = image.height;
              }
            }

            if (width === 'auto' || width < 0) {
              width = 0;
            }

            if (height === 'auto' || height < 0) {
              height = 0;
            }

            this.getTransformation = function () {
              return this.get('transform');
            };

            this.getBoundingShape = function () {
              return new SvgShape().M(x, y).L(x + width, y).M(x + width, y + height)
                .L(x, y + height);
            };

            this.drawInDocument = function (isClip, isMask) {
              if (this.get('visibility') === 'hidden' || !image) {
                return;
              }

              doc.save();
              this.transform();

              if (this.get('overflow') === 'hidden') {
                doc.rect(x, y, width, height).clip();
              }

              this.clip();
              this.mask();
              doc.translate(x, y);
              doc.transform.apply(doc, parseAspectRatio(this.attr('preserveAspectRatio'), width, height, image ? image.width : width, image ? image.height : height));

              if (!isClip) {
                doc.fillOpacity(this.get('opacity'));
                doc.image(image, 0, 0);
              } else {
                doc.rect(0, 0, image.width, image.height);
                docFillColor(DefaultColors.white).fill();
              }

              doc.restore();
            };
          };

          var SvgElemPattern = function SvgElemPattern(obj, inherits, fallback) {
            SvgElemHasChildren.call(this, obj, inherits);

            this.ref = function () {
              const ref = this.getUrl('href') || this.getUrl('xlink:href');

              if (ref && ref.nodeName === obj.nodeName) {
                return new SvgElemPattern(ref, inherits, fallback);
              }
            }.call(this);

            const _attr = this.attr;

            this.attr = function (key) {
              const attr = _attr.call(this, key);

              if (attr != null || key === 'href' || key === 'xlink:href') {
                return attr;
              }

              return this.ref ? this.ref.attr(key) : null;
            };

            const _getChildren = this.getChildren;

            this.getChildren = function () {
              const children = _getChildren.call(this);

              if (children.length > 0) {
                return children;
              }

              return this.ref ? this.ref.getChildren() : [];
            };

            this.getPaint = function (bBox, gOpacity, isClip, isMask) {
              const bBoxUnitsPattern = this.attr('patternUnits') !== 'userSpaceOnUse';
              const bBoxUnitsContent = this.attr('patternContentUnits') === 'objectBoundingBox';
              let x = this.getLength('x', bBoxUnitsPattern ? 1 : this.getParentVWidth(), 0);
              let y = this.getLength('y', bBoxUnitsPattern ? 1 : this.getParentVHeight(), 0);
              let width = this.getLength('width', bBoxUnitsPattern ? 1 : this.getParentVWidth(), 0);
              let height = this.getLength('height', bBoxUnitsPattern ? 1 : this.getParentVHeight(), 0);

              if (bBoxUnitsContent && !bBoxUnitsPattern) {
                // Use the same units for pattern & pattern content
                x = (x - bBox[0]) / (bBox[2] - bBox[0]) || 0;
                y = (y - bBox[1]) / (bBox[3] - bBox[1]) || 0;
                width = width / (bBox[2] - bBox[0]) || 0;
                height = height / (bBox[3] - bBox[1]) || 0;
              } else if (!bBoxUnitsContent && bBoxUnitsPattern) {
                x = bBox[0] + x * (bBox[2] - bBox[0]);
                y = bBox[1] + y * (bBox[3] - bBox[1]);
                width *= (bBox[2] - bBox[0]);
                height *= (bBox[3] - bBox[1]);
              }

              const viewBox = this.getViewbox('viewBox', [0, 0, width, height]);
              const aspectRatio = (this.attr('preserveAspectRatio') || '').trim();
              let aspectRatioMatrix = multiplyMatrix(parseAspectRatio(aspectRatio, width, height, viewBox[2], viewBox[3], 0), [1, 0, 0, 1, -viewBox[0], -viewBox[1]]);
              let matrix = parseTranform(this.attr('patternTransform'));

              if (bBoxUnitsContent) {
                matrix = multiplyMatrix([bBox[2] - bBox[0], 0, 0, bBox[3] - bBox[1], bBox[0], bBox[1]], matrix);
              }

              matrix = multiplyMatrix(matrix, [1, 0, 0, 1, x, y]);

              if ((matrix = validateMatrix(matrix)) && (aspectRatioMatrix = validateMatrix(aspectRatioMatrix)) && (width = validateNumber(width)) && (height = validateNumber(height))) {
                const group = docBeginGroup([0, 0, width, height]);
                doc.transform.apply(doc, aspectRatioMatrix);
                this.drawChildren(isClip, isMask);
                docEndGroup(group);
                return [docCreatePattern(group, width, height, matrix), gOpacity];
              }
              return fallback ? [fallback[0], fallback[1] * gOpacity] : undefined;
            };

            this.getVWidth = function () {
              const bBoxUnitsPattern = this.attr('patternUnits') !== 'userSpaceOnUse';
              const width = this.getLength('width', bBoxUnitsPattern ? 1 : this.getParentVWidth(), 0);
              return this.getViewbox('viewBox', [0, 0, width, 0])[2];
            };

            this.getVHeight = function () {
              const bBoxUnitsPattern = this.attr('patternUnits') !== 'userSpaceOnUse';
              const height = this.getLength('height', bBoxUnitsPattern ? 1 : this.getParentVHeight(), 0);
              return this.getViewbox('viewBox', [0, 0, 0, height])[3];
            };
          };

          var SvgElemGradient = function SvgElemGradient(obj, inherits, fallback) {
            SvgElem.call(this, obj, inherits);
            this.allowedChildren = ['stop'];

            this.ref = function () {
              const ref = this.getUrl('href') || this.getUrl('xlink:href');

              if (ref && ref.nodeName === obj.nodeName) {
                return new SvgElemGradient(ref, inherits, fallback);
              }
            }.call(this);

            const _attr = this.attr;

            this.attr = function (key) {
              const attr = _attr.call(this, key);

              if (attr != null || key === 'href' || key === 'xlink:href') {
                return attr;
              }

              return this.ref ? this.ref.attr(key) : null;
            };

            const _getChildren = this.getChildren;

            this.getChildren = function () {
              const children = _getChildren.call(this);

              if (children.length > 0) {
                return children;
              }

              return this.ref ? this.ref.getChildren() : [];
            };

            this.getPaint = function (bBox, gOpacity, isClip, isMask) {
              const children = this.getChildren();

              if (children.length === 0) {
                return;
              }

              if (children.length === 1) {
                const child = children[0];
                const stopColor = child.get('stop-color');

                if (stopColor === 'none') {
                  return;
                }

                return opacityToColor(stopColor, child.get('stop-opacity') * gOpacity, isMask);
              }

              const bBoxUnits = this.attr('gradientUnits') !== 'userSpaceOnUse';
              let matrix = parseTranform(this.attr('gradientTransform'));
              const spread = this.attr('spreadMethod');
              let grad;
              let x1;
              let x2;
              let y1;
              let y2;
              let r2;
              let nAfter = 0;
              let nBefore = 0;
              let nTotal = 1;

              if (bBoxUnits) {
                matrix = multiplyMatrix([bBox[2] - bBox[0], 0, 0, bBox[3] - bBox[1], bBox[0], bBox[1]], matrix);
              }

              if (matrix = validateMatrix(matrix)) {
                if (this.name === 'linearGradient') {
                  x1 = this.getLength('x1', bBoxUnits ? 1 : this.getVWidth(), 0);
                  x2 = this.getLength('x2', bBoxUnits ? 1 : this.getVWidth(), bBoxUnits ? 1 : this.getVWidth());
                  y1 = this.getLength('y1', bBoxUnits ? 1 : this.getVHeight(), 0);
                  y2 = this.getLength('y2', bBoxUnits ? 1 : this.getVHeight(), 0);
                } else {
                  x2 = this.getLength('cx', bBoxUnits ? 1 : this.getVWidth(), bBoxUnits ? 0.5 : 0.5 * this.getVWidth());
                  y2 = this.getLength('cy', bBoxUnits ? 1 : this.getVHeight(), bBoxUnits ? 0.5 : 0.5 * this.getVHeight());
                  r2 = this.getLength('r', bBoxUnits ? 1 : this.getViewport(), bBoxUnits ? 0.5 : 0.5 * this.getViewport());
                  x1 = this.getLength('fx', bBoxUnits ? 1 : this.getVWidth(), x2);
                  y1 = this.getLength('fy', bBoxUnits ? 1 : this.getVHeight(), y2);

                  if (r2 < 0) {
                    warningCallback('SvgElemGradient: negative r value');
                  }

                  const d = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
                  let multiplier = 1;

                  if (d > r2) {
                    // according to specification
                    multiplier = r2 / d;
                    x1 = x2 + (x1 - x2) * multiplier;
                    y1 = y2 + (y1 - y2) * multiplier;
                  }

                  r2 = Math.max(r2, d * multiplier * (1 + 1e-6)); // fix for edge-case gradients see issue #84
                }

                if (spread === 'reflect' || spread === 'repeat') {
                  const inv = inverseMatrix(matrix);
                  const corner1 = transformPoint([bBox[0], bBox[1]], inv);
                  const corner2 = transformPoint([bBox[2], bBox[1]], inv);
                  const corner3 = transformPoint([bBox[2], bBox[3]], inv);
                  const corner4 = transformPoint([bBox[0], bBox[3]], inv);

                  if (this.name === 'linearGradient') {
                    // See file 'gradient-repeat-maths.png'
                    nAfter = Math.max((corner1[0] - x2) * (x2 - x1) + (corner1[1] - y2) * (y2 - y1), (corner2[0] - x2) * (x2 - x1) + (corner2[1] - y2) * (y2 - y1), (corner3[0] - x2) * (x2 - x1) + (corner3[1] - y2) * (y2 - y1), (corner4[0] - x2) * (x2 - x1) + (corner4[1] - y2) * (y2 - y1)) / (Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
                    nBefore = Math.max((corner1[0] - x1) * (x1 - x2) + (corner1[1] - y1) * (y1 - y2), (corner2[0] - x1) * (x1 - x2) + (corner2[1] - y1) * (y1 - y2), (corner3[0] - x1) * (x1 - x2) + (corner3[1] - y1) * (y1 - y2), (corner4[0] - x1) * (x1 - x2) + (corner4[1] - y1) * (y1 - y2)) / (Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
                  } else {
                    nAfter = Math.sqrt(Math.max(Math.pow(corner1[0] - x2, 2) + Math.pow(corner1[1] - y2, 2), Math.pow(corner2[0] - x2, 2) + Math.pow(corner2[1] - y2, 2), Math.pow(corner3[0] - x2, 2) + Math.pow(corner3[1] - y2, 2), Math.pow(corner4[0] - x2, 2) + Math.pow(corner4[1] - y2, 2))) / r2 - 1;
                  }

                  nAfter = Math.ceil(nAfter + 0.5); // Add a little more because the stroke can extend outside of the bounding box

                  nBefore = Math.ceil(nBefore + 0.5);
                  nTotal = nBefore + 1 + nAfter; // How many times the gradient needs to be repeated to fill the object bounding box
                }

                if (this.name === 'linearGradient') {
                  grad = doc.linearGradient(x1 - nBefore * (x2 - x1), y1 - nBefore * (y2 - y1), x2 + nAfter * (x2 - x1), y2 + nAfter * (y2 - y1));
                } else {
                  grad = doc.radialGradient(x1, y1, 0, x2, y2, r2 + nAfter * r2);
                }

                for (let n = 0; n < nTotal; n++) {
                  let offset = 0;
                  const inOrder = spread !== 'reflect' || (n - nBefore) % 2 === 0;

                  for (let i = 0; i < children.length; i++) {
                    const _child = children[inOrder ? i : children.length - 1 - i];
                    let _stopColor = _child.get('stop-color');

                    if (_stopColor === 'none') {
                      _stopColor = DefaultColors.transparent;
                    }

                    _stopColor = opacityToColor(_stopColor, _child.get('stop-opacity') * gOpacity, isMask);
                    offset = Math.max(offset, inOrder ? _child.getPercent('offset', 0) : 1 - _child.getPercent('offset', 0));

                    if (i === 0 && _stopColor[0].length === 4) {
                      grad._colorSpace = 'DeviceCMYK';
                    } // Fix until PR #763 is merged into PDFKit

                    if (i === 0 && offset > 0) {
                      grad.stop((n + 0) / nTotal, _stopColor[0], _stopColor[1]);
                    }

                    grad.stop((n + offset) / (nAfter + nBefore + 1), _stopColor[0], _stopColor[1]);

                    if (i === children.length - 1 && offset < 1) {
                      grad.stop((n + 1) / nTotal, _stopColor[0], _stopColor[1]);
                    }
                  }
                }

                grad.setTransform.apply(grad, matrix);
                return [grad, 1];
              }
              return fallback ? [fallback[0], fallback[1] * gOpacity] : undefined;
            };
          };

          const SvgElemBasicShape = function SvgElemBasicShape(obj, inherits) {
            SvgElemStylable.call(this, obj, inherits);
            this.dashScale = 1;

            this.getBoundingShape = function () {
              return this.shape;
            };

            this.getTransformation = function () {
              return this.get('transform');
            };

            this.drawInDocument = function (isClip, isMask) {
              if (this.get('visibility') === 'hidden' || !this.shape) {
                return;
              }

              doc.save();
              this.transform();
              this.clip();

              if (!isClip) {
                const masked = this.mask();
                let group;

                if (masked) {
                  group = docBeginGroup(getPageBBox());
                }

                const subPaths = this.shape.getSubPaths();
                const fill = this.getFill(isClip, isMask);
                const stroke = this.getStroke(isClip, isMask);
                const lineWidth = this.get('stroke-width');
                const lineCap = this.get('stroke-linecap');

                if (fill || stroke) {
                  if (fill) {
                    docFillColor(fill);
                  }

                  if (stroke) {
                    for (let j = 0; j < subPaths.length; j++) {
                      if (isEqual(subPaths[j].totalLength, 0)) {
                        if ((lineCap === 'square' || lineCap === 'round') && lineWidth > 0) {
                          if (subPaths[j].startPoint && subPaths[j].startPoint.length > 1) {
                            const _x4 = subPaths[j].startPoint[0];
                            const _y4 = subPaths[j].startPoint[1];
                            docFillColor(stroke);

                            if (lineCap === 'square') {
                              doc.rect(_x4 - 0.5 * lineWidth, _y4 - 0.5 * lineWidth, lineWidth, lineWidth);
                            } else if (lineCap === 'round') {
                              doc.circle(_x4, _y4, 0.5 * lineWidth);
                            }

                            doc.fill();
                          }
                        }
                      }
                    }

                    const dashArray = this.get('stroke-dasharray');
                    let dashOffset = this.get('stroke-dashoffset');

                    if (isNotEqual(this.dashScale, 1)) {
                      for (let _j2 = 0; _j2 < dashArray.length; _j2++) {
                        dashArray[_j2] *= this.dashScale;
                      }

                      dashOffset *= this.dashScale;
                    }

                    docStrokeColor(stroke);
                    doc.lineWidth(lineWidth).miterLimit(this.get('stroke-miterlimit')).lineJoin(this.get('stroke-linejoin')).lineCap(lineCap)
                      .dash(dashArray, {
                        phase: dashOffset,
                      });
                  }

                  for (let _j3 = 0; _j3 < subPaths.length; _j3++) {
                    if (subPaths[_j3].totalLength > 0) {
                      subPaths[_j3].insertInDocument();
                    }
                  }

                  if (fill && stroke) {
                    doc.fillAndStroke(this.get('fill-rule'));
                  } else if (fill) {
                    doc.fill(this.get('fill-rule'));
                  } else if (stroke) {
                    doc.stroke();
                  }
                }

                const markerStart = this.get('marker-start');
                const markerMid = this.get('marker-mid');
                const markerEnd = this.get('marker-end');

                if (markerStart !== 'none' || markerMid !== 'none' || markerEnd !== 'none') {
                  const markersPos = this.shape.getMarkers();

                  if (markerStart !== 'none') {
                    const marker = new SvgElemMarker(markerStart, null);
                    marker.drawMarker(false, isMask, markersPos[0], lineWidth);
                  }

                  if (markerMid !== 'none') {
                    for (let i = 1; i < markersPos.length - 1; i++) {
                      const _marker = new SvgElemMarker(markerMid, null);

                      _marker.drawMarker(false, isMask, markersPos[i], lineWidth);
                    }
                  }

                  if (markerEnd !== 'none') {
                    const _marker2 = new SvgElemMarker(markerEnd, null);

                    _marker2.drawMarker(false, isMask, markersPos[markersPos.length - 1], lineWidth);
                  }
                }

                if (group) {
                  docEndGroup(group);
                  docInsertGroup(group);
                }
              } else {
                this.shape.insertInDocument();
                docFillColor(DefaultColors.white);
                doc.fill(this.get('clip-rule'));
              }

              doc.restore();
            };
          };

          var SvgElemRect = function SvgElemRect(obj, inherits) {
            SvgElemBasicShape.call(this, obj, inherits);
            const x = this.getLength('x', this.getVWidth(), 0);
            const y = this.getLength('y', this.getVHeight(), 0);
            const w = this.getLength('width', this.getVWidth(), 0);
            const h = this.getLength('height', this.getVHeight(), 0);
            let rx = this.getLength('rx', this.getVWidth());
            let ry = this.getLength('ry', this.getVHeight());

            if (rx === undefined && ry === undefined) {
              rx = ry = 0;
            } else if (rx === undefined && ry !== undefined) {
              rx = ry;
            } else if (rx !== undefined && ry === undefined) {
              ry = rx;
            }

            if (w > 0 && h > 0) {
              if (rx && ry) {
                rx = Math.min(rx, 0.5 * w);
                ry = Math.min(ry, 0.5 * h);
                this.shape = new SvgShape().M(x + rx, y).L(x + w - rx, y).A(rx, ry, 0, 0, 1, x + w, y + ry)
                  .L(x + w, y + h - ry)
                  .A(rx, ry, 0, 0, 1, x + w - rx, y + h)
                  .L(x + rx, y + h)
                  .A(rx, ry, 0, 0, 1, x, y + h - ry)
                  .L(x, y + ry)
                  .A(rx, ry, 0, 0, 1, x + rx, y)
                  .Z();
              } else {
                this.shape = new SvgShape().M(x, y).L(x + w, y).L(x + w, y + h)
                  .L(x, y + h)
                  .Z();
              }
            } else {
              this.shape = new SvgShape();
            }
          };

          var SvgElemCircle = function SvgElemCircle(obj, inherits) {
            SvgElemBasicShape.call(this, obj, inherits);
            const cx = this.getLength('cx', this.getVWidth(), 0);
            const cy = this.getLength('cy', this.getVHeight(), 0);
            const r = this.getLength('r', this.getViewport(), 0);

            if (r > 0) {
              this.shape = new SvgShape().M(cx + r, cy).A(r, r, 0, 0, 1, cx - r, cy).A(r, r, 0, 0, 1, cx + r, cy)
                .Z();
            } else {
              this.shape = new SvgShape();
            }
          };

          var SvgElemEllipse = function SvgElemEllipse(obj, inherits) {
            SvgElemBasicShape.call(this, obj, inherits);
            const cx = this.getLength('cx', this.getVWidth(), 0);
            const cy = this.getLength('cy', this.getVHeight(), 0);
            const rx = this.getLength('rx', this.getVWidth(), 0);
            const ry = this.getLength('ry', this.getVHeight(), 0);

            if (rx > 0 && ry > 0) {
              this.shape = new SvgShape().M(cx + rx, cy).A(rx, ry, 0, 0, 1, cx - rx, cy).A(rx, ry, 0, 0, 1, cx + rx, cy)
                .Z();
            } else {
              this.shape = new SvgShape();
            }
          };

          var SvgElemLine = function SvgElemLine(obj, inherits) {
            SvgElemBasicShape.call(this, obj, inherits);
            const x1 = this.getLength('x1', this.getVWidth(), 0);
            const y1 = this.getLength('y1', this.getVHeight(), 0);
            const x2 = this.getLength('x2', this.getVWidth(), 0);
            const y2 = this.getLength('y2', this.getVHeight(), 0);
            this.shape = new SvgShape().M(x1, y1).L(x2, y2);
          };

          var SvgElemPolyline = function SvgElemPolyline(obj, inherits) {
            SvgElemBasicShape.call(this, obj, inherits);
            const points = this.getNumberList('points');
            this.shape = new SvgShape();

            for (let i = 0; i < points.length - 1; i += 2) {
              if (i === 0) {
                this.shape.M(points[i], points[i + 1]);
              } else {
                this.shape.L(points[i], points[i + 1]);
              }
            }

            if (points.error) {
              warningCallback(`SvgElemPolygon: unexpected string ${points.error}`);
            }

            if (points.length % 2 === 1) {
              warningCallback('SvgElemPolyline: uneven number of coordinates');
            }
          };

          var SvgElemPolygon = function SvgElemPolygon(obj, inherits) {
            SvgElemBasicShape.call(this, obj, inherits);
            const points = this.getNumberList('points');
            this.shape = new SvgShape();

            for (let i = 0; i < points.length - 1; i += 2) {
              if (i === 0) {
                this.shape.M(points[i], points[i + 1]);
              } else {
                this.shape.L(points[i], points[i + 1]);
              }
            }

            this.shape.Z();

            if (points.error) {
              warningCallback(`SvgElemPolygon: unexpected string ${points.error}`);
            }

            if (points.length % 2 === 1) {
              warningCallback('SvgElemPolygon: uneven number of coordinates');
            }
          };

          var SvgElemPath = function SvgElemPath(obj, inherits) {
            SvgElemBasicShape.call(this, obj, inherits);
            this.shape = new SvgShape().path(this.attr('d'));
            const pathLength = this.getLength('pathLength', this.getViewport());
            this.pathLength = pathLength > 0 ? pathLength : undefined;
            this.dashScale = this.pathLength !== undefined ? this.shape.totalLength / this.pathLength : 1;
          };

          var SvgElemMarker = function SvgElemMarker(obj, inherits) {
            SvgElemHasChildren.call(this, obj, inherits);
            const width = this.getLength('markerWidth', this.getParentVWidth(), 3);
            const height = this.getLength('markerHeight', this.getParentVHeight(), 3);
            const viewBox = this.getViewbox('viewBox', [0, 0, width, height]);

            this.getVWidth = function () {
              return viewBox[2];
            };

            this.getVHeight = function () {
              return viewBox[3];
            };

            this.drawMarker = function (isClip, isMask, posArray, strokeWidth) {
              doc.save();
              const orient = this.attr('orient');
              const units = this.attr('markerUnits');
              const rotate = orient === 'auto' ? posArray[2] : (parseFloat(orient) || 0) * Math.PI / 180;
              const scale = units === 'userSpaceOnUse' ? 1 : strokeWidth;
              doc.transform(Math.cos(rotate) * scale, Math.sin(rotate) * scale, -Math.sin(rotate) * scale, Math.cos(rotate) * scale, posArray[0], posArray[1]);
              const refX = this.getLength('refX', this.getVWidth(), 0);
              const refY = this.getLength('refY', this.getVHeight(), 0);
              const aspectRatioMatrix = parseAspectRatio(this.attr('preserveAspectRatio'), width, height, viewBox[2], viewBox[3], 0.5);

              if (this.get('overflow') === 'hidden') {
                doc.rect(aspectRatioMatrix[0] * (viewBox[0] + viewBox[2] / 2 - refX) - width / 2, aspectRatioMatrix[3] * (viewBox[1] + viewBox[3] / 2 - refY) - height / 2, width, height).clip();
              }

              doc.transform.apply(doc, aspectRatioMatrix);
              doc.translate(-refX, -refY);
              let group;

              if (this.get('opacity') < 1 && !isClip) {
                group = docBeginGroup(getPageBBox());
              }

              this.drawChildren(isClip, isMask);

              if (group) {
                docEndGroup(group);
                doc.fillOpacity(this.get('opacity'));
                docInsertGroup(group);
              }

              doc.restore();
            };
          };

          var SvgElemClipPath = function SvgElemClipPath(obj, inherits) {
            SvgElemHasChildren.call(this, obj, inherits);

            this.useMask = function (bBox) {
              const group = docBeginGroup(getPageBBox());
              doc.save();

              if (this.attr('clipPathUnits') === 'objectBoundingBox') {
                doc.transform(bBox[2] - bBox[0], 0, 0, bBox[3] - bBox[1], bBox[0], bBox[1]);
              }

              this.clip();
              this.drawChildren(true, false);
              doc.restore();
              docEndGroup(group);
              docApplyMask(group, true);
            };
          };

          var SvgElemMask = function SvgElemMask(obj, inherits) {
            SvgElemHasChildren.call(this, obj, inherits);

            this.useMask = function (bBox) {
              const group = docBeginGroup(getPageBBox());
              doc.save();
              let x; let y; let w; let
                h;

              if (this.attr('maskUnits') === 'userSpaceOnUse') {
                x = this.getLength('x', this.getVWidth(), -0.1 * (bBox[2] - bBox[0]) + bBox[0]);
                y = this.getLength('y', this.getVHeight(), -0.1 * (bBox[3] - bBox[1]) + bBox[1]);
                w = this.getLength('width', this.getVWidth(), 1.2 * (bBox[2] - bBox[0]));
                h = this.getLength('height', this.getVHeight(), 1.2 * (bBox[3] - bBox[1]));
              } else {
                x = this.getLength('x', this.getVWidth(), -0.1) * (bBox[2] - bBox[0]) + bBox[0];
                y = this.getLength('y', this.getVHeight(), -0.1) * (bBox[3] - bBox[1]) + bBox[1];
                w = this.getLength('width', this.getVWidth(), 1.2) * (bBox[2] - bBox[0]);
                h = this.getLength('height', this.getVHeight(), 1.2) * (bBox[3] - bBox[1]);
              }

              doc.rect(x, y, w, h).clip();

              if (this.attr('maskContentUnits') === 'objectBoundingBox') {
                doc.transform(bBox[2] - bBox[0], 0, 0, bBox[3] - bBox[1], bBox[0], bBox[1]);
              }

              this.clip();
              this.drawChildren(false, true);
              doc.restore();
              docEndGroup(group);
              docApplyMask(group, true);
            };
          };

          const SvgElemTextContainer = function SvgElemTextContainer(obj, inherits) {
            SvgElemStylable.call(this, obj, inherits);
            this.allowedChildren = ['tspan', '#text', '#cdata-section', 'a'];
            this.isText = true;

            this.getBoundingShape = function () {
              const shape = new SvgShape();

              for (let i = 0; i < this._pos.length; i++) {
                const pos = this._pos[i];

                if (!pos.hidden) {
                  const dx0 = pos.ascent * Math.sin(pos.rotate);
                  const dy0 = -pos.ascent * Math.cos(pos.rotate);
                  const dx1 = pos.descent * Math.sin(pos.rotate);
                  const dy1 = -pos.descent * Math.cos(pos.rotate);
                  const dx2 = pos.width * Math.cos(pos.rotate);
                  const dy2 = pos.width * Math.sin(pos.rotate);
                  shape.M(pos.x + dx0, pos.y + dy0).L(pos.x + dx0 + dx2, pos.y + dy0 + dy2).M(pos.x + dx1 + dx2, pos.y + dy1 + dy2).L(pos.x + dx1, pos.y + dy1);
                }
              }

              return shape;
            };

            this.drawTextInDocument = function (isClip, isMask) {
              if (this.link && !isClip && !isMask) {
                this.addLink();
              }

              if (this.get('text-decoration') === 'underline') {
                this.decorate(0.05 * this._font.size, -0.075 * this._font.size, isClip, isMask);
              }

              if (this.get('text-decoration') === 'overline') {
                this.decorate(0.05 * this._font.size, getAscent(this._font.font, this._font.size) + 0.075 * this._font.size, isClip, isMask);
              }

              const fill = this.getFill(isClip, isMask);
              let stroke = this.getStroke(isClip, isMask);
              let strokeWidth = this.get('stroke-width');

              if (this._font.fauxBold) {
                if (!stroke) {
                  stroke = fill;
                  strokeWidth = this._font.size * 0.03;
                } else {
                  strokeWidth += this._font.size * 0.03;
                }
              }

              const children = this.getChildren();

              for (let i = 0; i < children.length; i++) {
                const childElem = children[i];

                switch (childElem.name) {
                  case 'tspan':
                  case 'textPath':
                  case 'a':
                    if (childElem.get('display') !== 'none') {
                      childElem.drawTextInDocument(isClip, isMask);
                    }

                    break;

                  case '#text':
                  case '#cdata-section':
                    if (this.get('visibility') === 'hidden') {
                      continue;
                    }

                    if (fill || stroke || isClip) {
                      if (fill) {
                        docFillColor(fill);
                      }

                      if (stroke && strokeWidth) {
                        docStrokeColor(stroke);
                        doc.lineWidth(strokeWidth).miterLimit(this.get('stroke-miterlimit')).lineJoin(this.get('stroke-linejoin')).lineCap(this.get('stroke-linecap'))
                          .dash(this.get('stroke-dasharray'), {
                            phase: this.get('stroke-dashoffset'),
                          });
                      }

                      docBeginText(this._font.font, this._font.size);
                      docSetTextMode(!!fill, !!stroke);

                      for (let j = 0, pos = childElem._pos; j < pos.length; j++) {
                        if (!pos[j].hidden && isNotEqual(pos[j].width, 0)) {
                          const cos = Math.cos(pos[j].rotate);
                          const sin = Math.sin(pos[j].rotate);
                          const skew = this._font.fauxItalic ? -0.25 : 0;
                          docSetTextMatrix(cos * pos[j].scale, sin * pos[j].scale, cos * skew - sin, sin * skew + cos, pos[j].x, pos[j].y);
                          docWriteGlyph(pos[j].glyph);
                        }
                      }

                      docEndText();
                    }

                    break;
                }
              }

              if (this.get('text-decoration') === 'line-through') {
                this.decorate(0.05 * this._font.size, 0.5 * (getAscent(this._font.font, this._font.size) + getDescent(this._font.font, this._font.size)), isClip, isMask);
              }
            };

            this.decorate = function (lineWidth, linePosition, isClip, isMask) {
              const fill = this.getFill(isClip, isMask);
              const stroke = this.getStroke(isClip, isMask);

              if (fill) {
                docFillColor(fill);
              }

              if (stroke) {
                docStrokeColor(stroke);
                doc.lineWidth(this.get('stroke-width')).miterLimit(this.get('stroke-miterlimit')).lineJoin(this.get('stroke-linejoin')).lineCap(this.get('stroke-linecap'))
                  .dash(this.get('stroke-dasharray'), {
                    phase: this.get('stroke-dashoffset'),
                  });
              }

              for (let j = 0, pos = this._pos; j < pos.length; j++) {
                if (!pos[j].hidden && isNotEqual(pos[j].width, 0)) {
                  const dx0 = (linePosition + lineWidth / 2) * Math.sin(pos[j].rotate);
                  const dy0 = -(linePosition + lineWidth / 2) * Math.cos(pos[j].rotate);
                  const dx1 = (linePosition - lineWidth / 2) * Math.sin(pos[j].rotate);
                  const dy1 = -(linePosition - lineWidth / 2) * Math.cos(pos[j].rotate);
                  const dx2 = pos[j].width * Math.cos(pos[j].rotate);
                  const dy2 = pos[j].width * Math.sin(pos[j].rotate);
                  new SvgShape().M(pos[j].x + dx0, pos[j].y + dy0).L(pos[j].x + dx0 + dx2, pos[j].y + dy0 + dy2).L(pos[j].x + dx1 + dx2, pos[j].y + dy1 + dy2)
                    .L(pos[j].x + dx1, pos[j].y + dy1)
                    .Z()
                    .insertInDocument();

                  if (fill && stroke) {
                    doc.fillAndStroke();
                  } else if (fill) {
                    doc.fill();
                  } else if (stroke) {
                    doc.stroke();
                  }
                }
              }
            };
          };

          var SvgElemTextNode = function SvgElemTextNode(obj, inherits) {
            this.name = obj.nodeName;
            this.textContent = obj.nodeValue;
          };

          var SvgElemTspan = function SvgElemTspan(obj, inherits) {
            SvgElemTextContainer.call(this, obj, inherits);
          };

          var SvgElemTextPath = function SvgElemTextPath(obj, inherits) {
            SvgElemTextContainer.call(this, obj, inherits);
            let pathObject; let pathLength; let
              temp;

            if ((temp = this.attr('path')) && temp.trim() !== '') {
              const _pathLength = this.getLength('pathLength', this.getViewport());

              this.pathObject = new SvgShape().path(temp);
              this.pathLength = _pathLength > 0 ? _pathLength : this.pathObject.totalLength;
              this.pathScale = this.pathObject.totalLength / this.pathLength;
            } else if ((temp = this.getUrl('href') || this.getUrl('xlink:href')) && temp.nodeName === 'path') {
              const pathElem = new SvgElemPath(temp, this);
              this.pathObject = pathElem.shape.clone().transform(pathElem.get('transform'));
              this.pathLength = this.chooseValue(pathElem.pathLength, this.pathObject.totalLength);
              this.pathScale = this.pathObject.totalLength / this.pathLength;
            }
          };

          var SvgElemText = function SvgElemText(obj, inherits) {
            SvgElemTextContainer.call(this, obj, inherits);
            this.allowedChildren = ['textPath', 'tspan', '#text', '#cdata-section', 'a'];

            (function (textParentElem) {
              let processedText = '';
              let remainingText = obj.textContent;
              const textPaths = [];
              let currentChunk = [];
              let currentAnchor;
              let currentDirection;
              let currentX = 0;
              let currentY = 0;

              function doAnchoring() {
                if (currentChunk.length) {
                  const last = currentChunk[currentChunk.length - 1];
                  const first = currentChunk[0];
                  const width = last.x + last.width - first.x;
                  const anchordx = {
                    startltr: 0,
                    middleltr: 0.5,
                    endltr: 1,
                    startrtl: 1,
                    middlertl: 0.5,
                    endrtl: 0,
                  }[currentAnchor + currentDirection] * width || 0;

                  for (let i = 0; i < currentChunk.length; i++) {
                    currentChunk[i].x -= anchordx;
                  }
                }

                currentChunk = [];
              }

              function adjustLength(pos, length, spacingAndGlyphs) {
                const firstChar = pos[0];
                const lastChar = pos[pos.length - 1];
                const startX = firstChar.x;
                const endX = lastChar.x + lastChar.width;

                if (spacingAndGlyphs) {
                  const textScale = length / (endX - startX);

                  if (textScale > 0 && textScale < Infinity) {
                    for (let j = 0; j < pos.length; j++) {
                      pos[j].x = startX + textScale * (pos[j].x - startX);
                      pos[j].scale *= textScale;
                      pos[j].width *= textScale;
                    }
                  }
                } else if (pos.length >= 2) {
                  const spaceDiff = (length - (endX - startX)) / (pos.length - 1);

                  for (let _j4 = 0; _j4 < pos.length; _j4++) {
                    pos[_j4].x += _j4 * spaceDiff;
                  }
                }

                currentX += length - (endX - startX);
              }

              function recursive(currentElem, parentElem) {
                currentElem._x = combineArrays(currentElem.getLengthList('x', currentElem.getVWidth()), parentElem ? parentElem._x.slice(parentElem._pos.length) : []);
                currentElem._y = combineArrays(currentElem.getLengthList('y', currentElem.getVHeight()), parentElem ? parentElem._y.slice(parentElem._pos.length) : []);
                currentElem._dx = combineArrays(currentElem.getLengthList('dx', currentElem.getVWidth()), parentElem ? parentElem._dx.slice(parentElem._pos.length) : []);
                currentElem._dy = combineArrays(currentElem.getLengthList('dy', currentElem.getVHeight()), parentElem ? parentElem._dy.slice(parentElem._pos.length) : []);
                currentElem._rot = combineArrays(currentElem.getNumberList('rotate'), parentElem ? parentElem._rot.slice(parentElem._pos.length) : []);
                currentElem._defRot = currentElem.chooseValue(currentElem._rot[currentElem._rot.length - 1], parentElem && parentElem._defRot, 0);

                if (currentElem.name === 'textPath') {
                  currentElem._y = [];
                }

                const fontOptions = {
                  fauxItalic: false,
                  fauxBold: false,
                };
                const fontNameorLink = fontCallback(currentElem.get('font-family'), currentElem.get('font-weight') === 'bold', currentElem.get('font-style') === 'italic', fontOptions);

                try {
                  doc.font(fontNameorLink);
                } catch (e) {
                  warningCallback(`SVGElemText: failed to open font "${fontNameorLink}" in PDFKit`);
                }

                currentElem._pos = [];
                currentElem._index = 0;
                currentElem._font = {
                  font: doc._font,
                  size: currentElem.get('font-size'),
                  fauxItalic: fontOptions.fauxItalic,
                  fauxBold: fontOptions.fauxBold,
                };
                const textLength = currentElem.getLength('textLength', currentElem.getVWidth(), undefined);
                const spacingAndGlyphs = currentElem.attr('lengthAdjust') === 'spacingAndGlyphs';
                const wordSpacing = currentElem.get('word-spacing');
                const letterSpacing = currentElem.get('letter-spacing');
                const textAnchor = currentElem.get('text-anchor');
                const textDirection = currentElem.get('direction');
                const baseline = getBaseline(currentElem._font.font, currentElem._font.size, currentElem.get('alignment-baseline') || currentElem.get('dominant-baseline'), currentElem.get('baseline-shift'));

                if (currentElem.name === 'textPath') {
                  doAnchoring();
                  currentX = currentY = 0;
                }

                const children = currentElem.getChildren();

                for (let i = 0; i < children.length; i++) {
                  const childElem = children[i];

                  switch (childElem.name) {
                    case 'tspan':
                    case 'textPath':
                    case 'a':
                      recursive(childElem, currentElem);
                      break;

                    case '#text':
                    case '#cdata-section':
                      var rawText = childElem.textContent;
                      var renderedText = rawText;
                      var words = void 0;
                      childElem._font = currentElem._font;
                      childElem._pos = [];
                      remainingText = remainingText.substring(rawText.length);

                      if (currentElem.get('xml:space') === 'preserve') {
                        renderedText = renderedText.replace(/[\s]/g, ' ');
                      } else {
                        renderedText = renderedText.replace(/[\s]+/g, ' ');

                        if (processedText.match(/[\s]$|^$/)) {
                          renderedText = renderedText.replace(/^[\s]/, '');
                        }

                        if (remainingText.match(/^[\s]*$/)) {
                          renderedText = renderedText.replace(/[\s]$/, '');
                        }
                      }

                      processedText += rawText;

                      if (wordSpacing === 0) {
                        words = [renderedText];
                      } else {
                        words = renderedText.split(/(\s)/);
                      }

                      for (let w = 0; w < words.length; w++) {
                        const pos = getTextPos(currentElem._font.font, currentElem._font.size, words[w]);

                        for (let j = 0; j < pos.length; j++) {
                          const index = currentElem._index;
                          const xAttr = currentElem._x[index];
                          const yAttr = currentElem._y[index];
                          const dxAttr = currentElem._dx[index];
                          const dyAttr = currentElem._dy[index];
                          const rotAttr = currentElem._rot[index];
                          let continuous = !(w === 0 && j === 0);

                          if (xAttr !== undefined) {
                            continuous = false;
                            doAnchoring();
                            currentX = xAttr;
                          }

                          if (yAttr !== undefined) {
                            continuous = false;
                            doAnchoring();
                            currentY = yAttr;
                          }

                          if (dxAttr !== undefined) {
                            continuous = false;
                            currentX += dxAttr;
                          }

                          if (dyAttr !== undefined) {
                            continuous = false;
                            currentY += dyAttr;
                          }

                          if (rotAttr !== undefined || currentElem._defRot !== 0) {
                            continuous = false;
                          }

                          const position = {
                            glyph: pos[j].glyph,
                            rotate: Math.PI / 180 * currentElem.chooseValue(rotAttr, currentElem._defRot),
                            x: currentX + pos[j].xOffset,
                            y: currentY + baseline + pos[j].yOffset,
                            width: pos[j].width,
                            ascent: getAscent(currentElem._font.font, currentElem._font.size),
                            descent: getDescent(currentElem._font.font, currentElem._font.size),
                            scale: 1,
                            hidden: false,
                            continuous,
                          };
                          currentChunk.push(position);

                          childElem._pos.push(position);

                          currentElem._pos.push(position);

                          currentElem._index += pos[j].unicode.length;

                          if (currentChunk.length === 1) {
                            currentAnchor = textAnchor;
                            currentDirection = textDirection;
                          }

                          currentX += pos[j].xAdvance + letterSpacing;
                          currentY += pos[j].yAdvance;
                        }

                        if (words[w] === ' ') {
                          currentX += wordSpacing;
                        }
                      }

                      break;

                    default:
                      remainingText = remainingText.substring(childElem.textContent.length);
                  }
                }

                if (textLength && currentElem._pos.length) {
                  adjustLength(currentElem._pos, textLength, spacingAndGlyphs);
                }

                if (currentElem.name === 'textPath' || currentElem.name === 'text') {
                  doAnchoring();
                }

                if (currentElem.name === 'textPath') {
                  textPaths.push(currentElem);
                  const { pathObject } = currentElem;

                  if (pathObject) {
                    currentX = pathObject.endPoint[0];
                    currentY = pathObject.endPoint[1];
                  }
                }

                if (parentElem) {
                  parentElem._pos = parentElem._pos.concat(currentElem._pos);
                  parentElem._index += currentElem._index;
                }
              }

              function textOnPath(currentElem) {
                const { pathObject } = currentElem;
                const { pathLength } = currentElem;
                const { pathScale } = currentElem;

                if (pathObject) {
                  const textOffset = currentElem.getLength('startOffset', pathLength, 0);

                  for (let j = 0; j < currentElem._pos.length; j++) {
                    const charMidX = textOffset + currentElem._pos[j].x + 0.5 * currentElem._pos[j].width;

                    if (charMidX > pathLength || charMidX < 0) {
                      currentElem._pos[j].hidden = true;
                    } else {
                      const pointOnPath = pathObject.getPointAtLength(charMidX * pathScale);

                      if (isNotEqual(pathScale, 1)) {
                        currentElem._pos[j].scale *= pathScale;
                        currentElem._pos[j].width *= pathScale;
                      }

                      currentElem._pos[j].x = pointOnPath[0] - 0.5 * currentElem._pos[j].width * Math.cos(pointOnPath[2]) - currentElem._pos[j].y * Math.sin(pointOnPath[2]);
                      currentElem._pos[j].y = pointOnPath[1] - 0.5 * currentElem._pos[j].width * Math.sin(pointOnPath[2]) + currentElem._pos[j].y * Math.cos(pointOnPath[2]);
                      currentElem._pos[j].rotate = pointOnPath[2] + currentElem._pos[j].rotate;
                      currentElem._pos[j].continuous = false;
                    }
                  }
                } else {
                  for (let _j5 = 0; _j5 < currentElem._pos.length; _j5++) {
                    currentElem._pos[_j5].hidden = true;
                  }
                }
              }

              recursive(textParentElem, null);

              for (let i = 0; i < textPaths.length; i++) {
                textOnPath(textPaths[i]);
              }
            }(this));

            this.getTransformation = function () {
              return this.get('transform');
            };

            this.drawInDocument = function (isClip, isMask) {
              doc.save();
              this.transform();
              this.clip();
              const masked = this.mask();
              let group;

              if (masked) {
                group = docBeginGroup(getPageBBox());
              }

              this.drawTextInDocument(isClip, isMask);

              if (group) {
                docEndGroup(group);
                docInsertGroup(group);
              }

              doc.restore();
            };
          };

          options = options || {};
          const pxToPt = options.assumePt ? 1 : 72 / 96;
          // 1px = 72/96pt, but only if assumePt is false
          var viewportWidth = (options.width || doc.page.width) / pxToPt;
          var viewportHeight = (options.height || doc.page.height) / pxToPt;
          var preserveAspectRatio = options.preserveAspectRatio || null;
          // default to null so that the attr can override if not passed
          var useCSS = options.useCSS && typeof SVGElement !== 'undefined' && svg instanceof SVGElement && typeof getComputedStyle === 'function';
          var { warningCallback } = options;
          var { fontCallback } = options;
          var { imageCallback } = options;
          var { colorCallback } = options;
          var { documentCallback } = options;
          var precision = Math.ceil(Math.max(1, options.precision)) || 3;
          var groupStack = [];
          var documentCache = {};
          var links = [];
          var styleRules = [];

          if (typeof warningCallback !== 'function') {
            warningCallback = function warningCallback(str) {
              if (typeof console !== undefined && typeof console.warn === 'function') {
                console.warn(str);
              }
            };
          }

          if (typeof fontCallback !== 'function') {
            fontCallback = function fontCallback(family, bold, italic, fontOptions) {
              // Check if the font is already registered in the document
              if (bold && italic) {
                if (doc._registeredFonts.hasOwnProperty(`${family}-BoldItalic`)) {
                  return `${family}-BoldItalic`;
                } if (doc._registeredFonts.hasOwnProperty(`${family}-Italic`)) {
                  fontOptions.fauxBold = true;
                  return `${family}-Italic`;
                } if (doc._registeredFonts.hasOwnProperty(`${family}-Bold`)) {
                  fontOptions.fauxItalic = true;
                  return `${family}-Bold`;
                } if (doc._registeredFonts.hasOwnProperty(family)) {
                  fontOptions.fauxBold = true;
                  fontOptions.fauxItalic = true;
                  return family;
                }
              }

              if (bold && !italic) {
                if (doc._registeredFonts.hasOwnProperty(`${family}-Bold`)) {
                  return `${family}-Bold`;
                } if (doc._registeredFonts.hasOwnProperty(family)) {
                  fontOptions.fauxBold = true;
                  return family;
                }
              }

              if (!bold && italic) {
                if (doc._registeredFonts.hasOwnProperty(`${family}-Italic`)) {
                  return `${family}-Italic`;
                } if (doc._registeredFonts.hasOwnProperty(family)) {
                  fontOptions.fauxItalic = true;
                  return family;
                }
              }

              if (!bold && !italic) {
                if (doc._registeredFonts.hasOwnProperty(family)) {
                  return family;
                }
              } // Use standard fonts as fallback

              if (family.match(/(?:^|,)\s*serif\s*$/)) {
                if (bold && italic) {
                  return 'Times-BoldItalic';
                }

                if (bold && !italic) {
                  return 'Times-Bold';
                }

                if (!bold && italic) {
                  return 'Times-Italic';
                }

                if (!bold && !italic) {
                  return 'Times-Roman';
                }
              } else if (family.match(/(?:^|,)\s*monospace\s*$/)) {
                if (bold && italic) {
                  return 'Courier-BoldOblique';
                }

                if (bold && !italic) {
                  return 'Courier-Bold';
                }

                if (!bold && italic) {
                  return 'Courier-Oblique';
                }

                if (!bold && !italic) {
                  return 'Courier';
                }
              } else if (family.match(/(?:^|,)\s*sans-serif\s*$/) || true) {
                if (bold && italic) {
                  return 'Helvetica-BoldOblique';
                }

                if (bold && !italic) {
                  return 'Helvetica-Bold';
                }

                if (!bold && italic) {
                  return 'Helvetica-Oblique';
                }

                if (!bold && !italic) {
                  return 'Helvetica';
                }
              }
            };
          }

          if (typeof imageCallback !== 'function') {
            imageCallback = function imageCallback(link) {
              return link.replace(/\s+/g, '');
            };
          }

          if (typeof colorCallback !== 'function') {
            colorCallback = null;
          } else {
            for (const color in DefaultColors) {
              const newColor = colorCallback(DefaultColors[color]);
              DefaultColors[color][0] = newColor[0];
              DefaultColors[color][1] = newColor[1];
            }
          }

          if (typeof documentCallback !== 'function') {
            documentCallback = null;
          }

          if (typeof svg === 'string') {
            svg = parseXml(svg);
          }

          if (svg) {
            const styles = svg.getElementsByTagName('style');

            for (let i = 0; i < styles.length; i++) {
              styleRules = styleRules.concat(parseStyleSheet(styles[i].textContent));
            }

            const elem = createSVGElement(svg, null);

            if (typeof elem.drawInDocument === 'function') {
              if (options.useCSS && !useCSS) {
                warningCallback('SVGtoPDF: useCSS option can only be used for SVG *elements* in compatible browsers');
              }

              const savedFillColor = doc._fillColor;
              doc.save().translate(x || 0, y || 0).scale(pxToPt);
              elem.drawInDocument();

              for (let _i8 = 0; _i8 < links.length; _i8++) {
                doc.page.annotations.push(links[_i8]);
              }

              doc.restore();
              doc._fillColor = savedFillColor;
            } else {
              warningCallback(`SVGtoPDF: this element can't be rendered directly: ${svg.nodeName}`);
            }
          } else {
            warningCallback('SVGtoPDF: the input does not look like a valid SVG');
          }
        };

        if (true && module && typeof module.exports !== 'undefined') {
          module.exports = SVGtoPDF;
        }
        /***/ }),

      /***/ 9742:
      /***/ (function (__unused_webpack_module, exports) {
        exports.byteLength = byteLength;
        exports.toByteArray = toByteArray;
        exports.fromByteArray = fromByteArray;

        const lookup = [];
        const revLookup = [];
        const Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;

        const code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
        for (let i = 0, len = code.length; i < len; ++i) {
          lookup[i] = code[i];
          revLookup[code.charCodeAt(i)] = i;
        }

        // Support decoding URL-safe base64 strings, as Node.js does.
        // See: https://en.wikipedia.org/wiki/Base64#URL_applications
        revLookup['-'.charCodeAt(0)] = 62;
        revLookup['_'.charCodeAt(0)] = 63;

        function getLens(b64) {
          const len = b64.length;

          if (len % 4 > 0) {
            throw new Error('Invalid string. Length must be a multiple of 4');
          }

          // Trim off extra bytes after placeholder bytes are found
          // See: https://github.com/beatgammit/base64-js/issues/42
          let validLen = b64.indexOf('=');
          if (validLen === -1) validLen = len;

          const placeHoldersLen = validLen === len
            ? 0
            : 4 - (validLen % 4);

          return [validLen, placeHoldersLen];
        }

        // base64 is 4/3 + up to two characters of the original data
        function byteLength(b64) {
          const lens = getLens(b64);
          const validLen = lens[0];
          const placeHoldersLen = lens[1];
          return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen;
        }

        function _byteLength(b64, validLen, placeHoldersLen) {
          return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen;
        }

        function toByteArray(b64) {
          let tmp;
          const lens = getLens(b64);
          const validLen = lens[0];
          const placeHoldersLen = lens[1];

          const arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));

          let curByte = 0;

          // if there are placeholders, only get up to the last complete 4 chars
          const len = placeHoldersLen > 0
            ? validLen - 4
            : validLen;

          let i;
          for (i = 0; i < len; i += 4) {
            tmp = (revLookup[b64.charCodeAt(i)] << 18)
      | (revLookup[b64.charCodeAt(i + 1)] << 12)
      | (revLookup[b64.charCodeAt(i + 2)] << 6)
      | revLookup[b64.charCodeAt(i + 3)];
            arr[curByte++] = (tmp >> 16) & 0xFF;
            arr[curByte++] = (tmp >> 8) & 0xFF;
            arr[curByte++] = tmp & 0xFF;
          }

          if (placeHoldersLen === 2) {
            tmp = (revLookup[b64.charCodeAt(i)] << 2)
      | (revLookup[b64.charCodeAt(i + 1)] >> 4);
            arr[curByte++] = tmp & 0xFF;
          }

          if (placeHoldersLen === 1) {
            tmp = (revLookup[b64.charCodeAt(i)] << 10)
      | (revLookup[b64.charCodeAt(i + 1)] << 4)
      | (revLookup[b64.charCodeAt(i + 2)] >> 2);
            arr[curByte++] = (tmp >> 8) & 0xFF;
            arr[curByte++] = tmp & 0xFF;
          }

          return arr;
        }

        function tripletToBase64(num) {
          return lookup[num >> 18 & 0x3F]
    + lookup[num >> 12 & 0x3F]
    + lookup[num >> 6 & 0x3F]
    + lookup[num & 0x3F];
        }

        function encodeChunk(uint8, start, end) {
          let tmp;
          const output = [];
          for (let i = start; i < end; i += 3) {
            tmp = ((uint8[i] << 16) & 0xFF0000)
      + ((uint8[i + 1] << 8) & 0xFF00)
      + (uint8[i + 2] & 0xFF);
            output.push(tripletToBase64(tmp));
          }
          return output.join('');
        }

        function fromByteArray(uint8) {
          let tmp;
          const len = uint8.length;
          const extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
          const parts = [];
          const maxChunkLength = 16383; // must be multiple of 3

          // go through the array every three bytes, we'll deal with trailing stuff later
          for (let i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
            parts.push(encodeChunk(
              uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength),
            ));
          }

          // pad the end with zeros, but make sure to not forget the extra bytes
          if (extraBytes === 1) {
            tmp = uint8[len - 1];
            parts.push(
              `${lookup[tmp >> 2]
      + lookup[(tmp << 4) & 0x3F]
              }==`,
            );
          } else if (extraBytes === 2) {
            tmp = (uint8[len - 2] << 8) + uint8[len - 1];
            parts.push(
              `${lookup[tmp >> 10]
      + lookup[(tmp >> 4) & 0x3F]
      + lookup[(tmp << 2) & 0x3F]
              }=`,
            );
          }

          return parts.join('');
        }
        /***/ }),

      /***/ 4181:
      /***/ (function (module) {
        /* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Bit reading helpers
*/

        const BROTLI_READ_SIZE = 4096;
        const BROTLI_IBUF_SIZE = (2 * BROTLI_READ_SIZE + 32);
        const BROTLI_IBUF_MASK = (2 * BROTLI_READ_SIZE - 1);

        const kBitMask = new Uint32Array([
          0, 1, 3, 7, 15, 31, 63, 127, 255, 511, 1023, 2047, 4095, 8191, 16383, 32767,
          65535, 131071, 262143, 524287, 1048575, 2097151, 4194303, 8388607, 16777215,
        ]);

        /* Input byte buffer, consist of a ringbuffer and a "slack" region where */
        /* bytes from the start of the ringbuffer are copied. */
        function BrotliBitReader(input) {
          this.buf_ = new Uint8Array(BROTLI_IBUF_SIZE);
          this.input_ = input; /* input callback */

          this.reset();
        }

        BrotliBitReader.READ_SIZE = BROTLI_READ_SIZE;
        BrotliBitReader.IBUF_MASK = BROTLI_IBUF_MASK;

        BrotliBitReader.prototype.reset = function () {
          this.buf_ptr_ = 0; /* next input will write here */
          this.val_ = 0; /* pre-fetched bits */
          this.pos_ = 0; /* byte position in stream */
          this.bit_pos_ = 0; /* current bit-reading position in val_ */
          this.bit_end_pos_ = 0; /* bit-reading end position from LSB of val_ */
          this.eos_ = 0; /* input stream is finished */

          this.readMoreInput();
          for (let i = 0; i < 4; i++) {
            this.val_ |= this.buf_[this.pos_] << (8 * i);
            ++this.pos_;
          }

          return this.bit_end_pos_ > 0;
        };

        /* Fills up the input ringbuffer by calling the input callback.

   Does nothing if there are at least 32 bytes present after current position.

   Returns 0 if either:
    - the input callback returned an error, or
    - there is no more input and the position is past the end of the stream.

   After encountering the end of the input stream, 32 additional zero bytes are
   copied to the ringbuffer, therefore it is safe to call this function after
   every 32 bytes of input is read.
*/
        BrotliBitReader.prototype.readMoreInput = function () {
          if (this.bit_end_pos_ > 256) {

          } else if (this.eos_) {
            if (this.bit_pos_ > this.bit_end_pos_) throw new Error(`Unexpected end of input ${this.bit_pos_} ${this.bit_end_pos_}`);
          } else {
            const dst = this.buf_ptr_;
            const bytes_read = this.input_.read(this.buf_, dst, BROTLI_READ_SIZE);
            if (bytes_read < 0) {
              throw new Error('Unexpected end of input');
            }

            if (bytes_read < BROTLI_READ_SIZE) {
              this.eos_ = 1;
              /* Store 32 bytes of zero after the stream end. */
              for (var p = 0; p < 32; p++) this.buf_[dst + bytes_read + p] = 0;
            }

            if (dst === 0) {
              /* Copy the head of the ringbuffer to the slack region. */
              for (var p = 0; p < 32; p++) this.buf_[(BROTLI_READ_SIZE << 1) + p] = this.buf_[p];

              this.buf_ptr_ = BROTLI_READ_SIZE;
            } else {
              this.buf_ptr_ = 0;
            }

            this.bit_end_pos_ += bytes_read << 3;
          }
        };

        /* Guarantees that there are at least 24 bits in the buffer. */
        BrotliBitReader.prototype.fillBitWindow = function () {
          while (this.bit_pos_ >= 8) {
            this.val_ >>>= 8;
            this.val_ |= this.buf_[this.pos_ & BROTLI_IBUF_MASK] << 24;
            ++this.pos_;
            this.bit_pos_ = this.bit_pos_ - 8 >>> 0;
            this.bit_end_pos_ = this.bit_end_pos_ - 8 >>> 0;
          }
        };

        /* Reads the specified number of bits from Read Buffer. */
        BrotliBitReader.prototype.readBits = function (n_bits) {
          if (32 - this.bit_pos_ < n_bits) {
            this.fillBitWindow();
          }

          const val = ((this.val_ >>> this.bit_pos_) & kBitMask[n_bits]);
          this.bit_pos_ += n_bits;
          return val;
        };

        module.exports = BrotliBitReader;
        /***/ }),

      /***/ 7080:
      /***/ (function (__unused_webpack_module, exports) {
        /* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Lookup table to map the previous two bytes to a context id.

   There are four different context modeling modes defined here:
     CONTEXT_LSB6: context id is the least significant 6 bits of the last byte,
     CONTEXT_MSB6: context id is the most significant 6 bits of the last byte,
     CONTEXT_UTF8: second-order context model tuned for UTF8-encoded text,
     CONTEXT_SIGNED: second-order context model tuned for signed integers.

   The context id for the UTF8 context model is calculated as follows. If p1
   and p2 are the previous two bytes, we calcualte the context as

     context = kContextLookup[p1] | kContextLookup[p2 + 256].

   If the previous two bytes are ASCII characters (i.e. < 128), this will be
   equivalent to

     context = 4 * context1(p1) + context2(p2),

   where context1 is based on the previous byte in the following way:

     0  : non-ASCII control
     1  : \t, \n, \r
     2  : space
     3  : other punctuation
     4  : " '
     5  : %
     6  : ( < [ {
     7  : ) > ] }
     8  : , ; :
     9  : .
     10 : =
     11 : number
     12 : upper-case vowel
     13 : upper-case consonant
     14 : lower-case vowel
     15 : lower-case consonant

   and context2 is based on the second last byte:

     0 : control, space
     1 : punctuation
     2 : upper-case letter, number
     3 : lower-case letter

   If the last byte is ASCII, and the second last byte is not (in a valid UTF8
   stream it will be a continuation byte, value between 128 and 191), the
   context is the same as if the second last byte was an ASCII control or space.

   If the last byte is a UTF8 lead byte (value >= 192), then the next byte will
   be a continuation byte and the context id is 2 or 3 depending on the LSB of
   the last byte and to a lesser extent on the second last byte if it is ASCII.

   If the last byte is a UTF8 continuation byte, the second last byte can be:
     - continuation byte: the next byte is probably ASCII or lead byte (assuming
       4-byte UTF8 characters are rare) and the context id is 0 or 1.
     - lead byte (192 - 207): next byte is ASCII or lead byte, context is 0 or 1
     - lead byte (208 - 255): next byte is continuation byte, context is 2 or 3

   The possible value combinations of the previous two bytes, the range of
   context ids and the type of the next byte is summarized in the table below:

   |--------\-----------------------------------------------------------------|
   |         \                         Last byte                              |
   | Second   \---------------------------------------------------------------|
   | last byte \    ASCII            |   cont. byte        |   lead byte      |
   |            \   (0-127)          |   (128-191)         |   (192-)         |
   |=============|===================|=====================|==================|
   |  ASCII      | next: ASCII/lead  |  not valid          |  next: cont.     |
   |  (0-127)    | context: 4 - 63   |                     |  context: 2 - 3  |
   |-------------|-------------------|---------------------|------------------|
   |  cont. byte | next: ASCII/lead  |  next: ASCII/lead   |  next: cont.     |
   |  (128-191)  | context: 4 - 63   |  context: 0 - 1     |  context: 2 - 3  |
   |-------------|-------------------|---------------------|------------------|
   |  lead byte  | not valid         |  next: ASCII/lead   |  not valid       |
   |  (192-207)  |                   |  context: 0 - 1     |                  |
   |-------------|-------------------|---------------------|------------------|
   |  lead byte  | not valid         |  next: cont.        |  not valid       |
   |  (208-)     |                   |  context: 2 - 3     |                  |
   |-------------|-------------------|---------------------|------------------|

   The context id for the signed context mode is calculated as:

     context = (kContextLookup[512 + p1] << 3) | kContextLookup[512 + p2].

   For any context modeling modes, the context ids can be calculated by |-ing
   together two lookups from one table using context model dependent offsets:

     context = kContextLookup[offset1 + p1] | kContextLookup[offset2 + p2].

   where offset1 and offset2 are dependent on the context mode.
*/

        const CONTEXT_LSB6 = 0;
        const CONTEXT_MSB6 = 1;
        const CONTEXT_UTF8 = 2;
        const CONTEXT_SIGNED = 3;

        /* Common context lookup table for all context modes. */
        exports.lookup = new Uint8Array([
          /* CONTEXT_UTF8, last byte. */
          /* ASCII range. */
          0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 4, 0, 0, 4, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          8, 12, 16, 12, 12, 20, 12, 16, 24, 28, 12, 12, 32, 12, 36, 12,
          44, 44, 44, 44, 44, 44, 44, 44, 44, 44, 32, 32, 24, 40, 28, 12,
          12, 48, 52, 52, 52, 48, 52, 52, 52, 48, 52, 52, 52, 52, 52, 48,
          52, 52, 52, 52, 52, 48, 52, 52, 52, 52, 52, 24, 12, 28, 12, 12,
          12, 56, 60, 60, 60, 56, 60, 60, 60, 56, 60, 60, 60, 60, 60, 56,
          60, 60, 60, 60, 60, 56, 60, 60, 60, 60, 60, 24, 12, 28, 12, 0,
          /* UTF8 continuation byte range. */
          0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1,
          0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1,
          0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1,
          0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1,
          /* UTF8 lead byte range. */
          2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3,
          2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3,
          2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3,
          2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3,
          /* CONTEXT_UTF8 second last byte. */
          /* ASCII range. */
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
          2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1,
          1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
          2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1,
          1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
          3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 1, 1, 1, 0,
          /* UTF8 continuation byte range. */
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          /* UTF8 lead byte range. */
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
          2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
          /* CONTEXT_SIGNED, second last byte. */
          0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
          2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
          2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
          2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
          3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
          3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
          3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
          3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
          4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
          4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
          4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
          4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
          5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
          5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
          5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
          6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 7,
          /* CONTEXT_SIGNED, last byte, same as the above values shifted by 3 bits. */
          0, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
          16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16,
          16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16,
          16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16,
          24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
          24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
          24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
          24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
          32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32,
          32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32,
          32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32,
          32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32,
          40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40,
          40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40,
          40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40,
          48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 56,
          /* CONTEXT_LSB6, last byte. */
          0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
          16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
          32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
          48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
          0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
          16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
          32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
          48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
          0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
          16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
          32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
          48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
          0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
          16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
          32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
          48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
          /* CONTEXT_MSB6, last byte. */
          0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3,
          4, 4, 4, 4, 5, 5, 5, 5, 6, 6, 6, 6, 7, 7, 7, 7,
          8, 8, 8, 8, 9, 9, 9, 9, 10, 10, 10, 10, 11, 11, 11, 11,
          12, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 15, 15,
          16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19,
          20, 20, 20, 20, 21, 21, 21, 21, 22, 22, 22, 22, 23, 23, 23, 23,
          24, 24, 24, 24, 25, 25, 25, 25, 26, 26, 26, 26, 27, 27, 27, 27,
          28, 28, 28, 28, 29, 29, 29, 29, 30, 30, 30, 30, 31, 31, 31, 31,
          32, 32, 32, 32, 33, 33, 33, 33, 34, 34, 34, 34, 35, 35, 35, 35,
          36, 36, 36, 36, 37, 37, 37, 37, 38, 38, 38, 38, 39, 39, 39, 39,
          40, 40, 40, 40, 41, 41, 41, 41, 42, 42, 42, 42, 43, 43, 43, 43,
          44, 44, 44, 44, 45, 45, 45, 45, 46, 46, 46, 46, 47, 47, 47, 47,
          48, 48, 48, 48, 49, 49, 49, 49, 50, 50, 50, 50, 51, 51, 51, 51,
          52, 52, 52, 52, 53, 53, 53, 53, 54, 54, 54, 54, 55, 55, 55, 55,
          56, 56, 56, 56, 57, 57, 57, 57, 58, 58, 58, 58, 59, 59, 59, 59,
          60, 60, 60, 60, 61, 61, 61, 61, 62, 62, 62, 62, 63, 63, 63, 63,
          /* CONTEXT_{M,L}SB6, second last byte, */
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        ]);

        exports.lookupOffsets = new Uint16Array([
          /* CONTEXT_LSB6 */
          1024, 1536,
          /* CONTEXT_MSB6 */
          1280, 1536,
          /* CONTEXT_UTF8 */
          0, 256,
          /* CONTEXT_SIGNED */
          768, 512,
        ]);
        /***/ }),

      /***/ 6450:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        let __webpack_unused_export__;
        /* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/

        const BrotliInput = (__webpack_require__(6154).g);
        const BrotliOutput = (__webpack_require__(6154).j);
        const BrotliBitReader = __webpack_require__(4181);
        const BrotliDictionary = __webpack_require__(5139);
        const HuffmanCode = (__webpack_require__(966).h);
        const BrotliBuildHuffmanTable = (__webpack_require__(966).g);
        const Context = __webpack_require__(7080);
        const Prefix = __webpack_require__(8435);
        const Transform = __webpack_require__(2973);

        const kDefaultCodeLength = 8;
        const kCodeLengthRepeatCode = 16;
        const kNumLiteralCodes = 256;
        const kNumInsertAndCopyCodes = 704;
        const kNumBlockLengthCodes = 26;
        const kLiteralContextBits = 6;
        const kDistanceContextBits = 2;

        const HUFFMAN_TABLE_BITS = 8;
        const HUFFMAN_TABLE_MASK = 0xff;
        /* Maximum possible Huffman table size for an alphabet size of 704, max code
 * length 15 and root table bits 8. */
        const HUFFMAN_MAX_TABLE_SIZE = 1080;

        const CODE_LENGTH_CODES = 18;
        const kCodeLengthCodeOrder = new Uint8Array([
          1, 2, 3, 4, 0, 5, 17, 6, 16, 7, 8, 9, 10, 11, 12, 13, 14, 15,
        ]);

        const NUM_DISTANCE_SHORT_CODES = 16;
        const kDistanceShortCodeIndexOffset = new Uint8Array([
          3, 2, 1, 0, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2,
        ]);

        const kDistanceShortCodeValueOffset = new Int8Array([
          0, 0, 0, 0, -1, 1, -2, 2, -3, 3, -1, 1, -2, 2, -3, 3,
        ]);

        const kMaxHuffmanTableSize = new Uint16Array([
          256, 402, 436, 468, 500, 534, 566, 598, 630, 662, 694, 726, 758, 790, 822,
          854, 886, 920, 952, 984, 1016, 1048, 1080,
        ]);

        function DecodeWindowBits(br) {
          let n;
          if (br.readBits(1) === 0) {
            return 16;
          }

          n = br.readBits(3);
          if (n > 0) {
            return 17 + n;
          }

          n = br.readBits(3);
          if (n > 0) {
            return 8 + n;
          }

          return 17;
        }

        /* Decodes a number in the range [0..255], by reading 1 - 11 bits. */
        function DecodeVarLenUint8(br) {
          if (br.readBits(1)) {
            const nbits = br.readBits(3);
            if (nbits === 0) {
              return 1;
            }
            return br.readBits(nbits) + (1 << nbits);
          }
          return 0;
        }

        function MetaBlockLength() {
          this.meta_block_length = 0;
          this.input_end = 0;
          this.is_uncompressed = 0;
          this.is_metadata = false;
        }

        function DecodeMetaBlockLength(br) {
          const out = new MetaBlockLength();
          let size_nibbles;
          let size_bytes;
          let i;

          out.input_end = br.readBits(1);
          if (out.input_end && br.readBits(1)) {
            return out;
          }

          size_nibbles = br.readBits(2) + 4;
          if (size_nibbles === 7) {
            out.is_metadata = true;

            if (br.readBits(1) !== 0) throw new Error('Invalid reserved bit');

            size_bytes = br.readBits(2);
            if (size_bytes === 0) return out;

            for (i = 0; i < size_bytes; i++) {
              const next_byte = br.readBits(8);
              if (i + 1 === size_bytes && size_bytes > 1 && next_byte === 0) throw new Error('Invalid size byte');

              out.meta_block_length |= next_byte << (i * 8);
            }
          } else {
            for (i = 0; i < size_nibbles; ++i) {
              const next_nibble = br.readBits(4);
              if (i + 1 === size_nibbles && size_nibbles > 4 && next_nibble === 0) throw new Error('Invalid size nibble');

              out.meta_block_length |= next_nibble << (i * 4);
            }
          }

          ++out.meta_block_length;

          if (!out.input_end && !out.is_metadata) {
            out.is_uncompressed = br.readBits(1);
          }

          return out;
        }

        /* Decodes the next Huffman code from bit-stream. */
        function ReadSymbol(table, index, br) {
          const start_index = index;

          let nbits;
          br.fillBitWindow();
          index += (br.val_ >>> br.bit_pos_) & HUFFMAN_TABLE_MASK;
          nbits = table[index].bits - HUFFMAN_TABLE_BITS;
          if (nbits > 0) {
            br.bit_pos_ += HUFFMAN_TABLE_BITS;
            index += table[index].value;
            index += (br.val_ >>> br.bit_pos_) & ((1 << nbits) - 1);
          }
          br.bit_pos_ += table[index].bits;
          return table[index].value;
        }

        function ReadHuffmanCodeLengths(code_length_code_lengths, num_symbols, code_lengths, br) {
          let symbol = 0;
          let prev_code_len = kDefaultCodeLength;
          let repeat = 0;
          let repeat_code_len = 0;
          let space = 32768;

          const table = [];
          for (let i = 0; i < 32; i++) table.push(new HuffmanCode(0, 0));

          BrotliBuildHuffmanTable(table, 0, 5, code_length_code_lengths, CODE_LENGTH_CODES);

          while (symbol < num_symbols && space > 0) {
            let p = 0;
            var code_len;

            br.readMoreInput();
            br.fillBitWindow();
            p += (br.val_ >>> br.bit_pos_) & 31;
            br.bit_pos_ += table[p].bits;
            code_len = table[p].value & 0xff;
            if (code_len < kCodeLengthRepeatCode) {
              repeat = 0;
              code_lengths[symbol++] = code_len;
              if (code_len !== 0) {
                prev_code_len = code_len;
                space -= 32768 >> code_len;
              }
            } else {
              const extra_bits = code_len - 14;
              var old_repeat;
              var repeat_delta;
              let new_len = 0;
              if (code_len === kCodeLengthRepeatCode) {
                new_len = prev_code_len;
              }
              if (repeat_code_len !== new_len) {
                repeat = 0;
                repeat_code_len = new_len;
              }
              old_repeat = repeat;
              if (repeat > 0) {
                repeat -= 2;
                repeat <<= extra_bits;
              }
              repeat += br.readBits(extra_bits) + 3;
              repeat_delta = repeat - old_repeat;
              if (symbol + repeat_delta > num_symbols) {
                throw new Error('[ReadHuffmanCodeLengths] symbol + repeat_delta > num_symbols');
              }

              for (let x = 0; x < repeat_delta; x++) code_lengths[symbol + x] = repeat_code_len;

              symbol += repeat_delta;

              if (repeat_code_len !== 0) {
                space -= repeat_delta << (15 - repeat_code_len);
              }
            }
          }
          if (space !== 0) {
            throw new Error(`[ReadHuffmanCodeLengths] space = ${space}`);
          }

          for (; symbol < num_symbols; symbol++) code_lengths[symbol] = 0;
        }

        function ReadHuffmanCode(alphabet_size, tables, table, br) {
          let table_size = 0;
          let simple_code_or_skip;
          const code_lengths = new Uint8Array(alphabet_size);

          br.readMoreInput();

          /* simple_code_or_skip is used as follows:
     1 for simple code;
     0 for no skipping, 2 skips 2 code lengths, 3 skips 3 code lengths */
          simple_code_or_skip = br.readBits(2);
          if (simple_code_or_skip === 1) {
            /* Read symbols, codes & code lengths directly. */
            var i;
            let max_bits_counter = alphabet_size - 1;
            let max_bits = 0;
            const symbols = new Int32Array(4);
            const num_symbols = br.readBits(2) + 1;
            while (max_bits_counter) {
              max_bits_counter >>= 1;
              ++max_bits;
            }

            for (i = 0; i < num_symbols; ++i) {
              symbols[i] = br.readBits(max_bits) % alphabet_size;
              code_lengths[symbols[i]] = 2;
            }
            code_lengths[symbols[0]] = 1;
            switch (num_symbols) {
              case 1:
                break;
              case 3:
                if ((symbols[0] === symbols[1])
            || (symbols[0] === symbols[2])
            || (symbols[1] === symbols[2])) {
                  throw new Error('[ReadHuffmanCode] invalid symbols');
                }
                break;
              case 2:
                if (symbols[0] === symbols[1]) {
                  throw new Error('[ReadHuffmanCode] invalid symbols');
                }

                code_lengths[symbols[1]] = 1;
                break;
              case 4:
                if ((symbols[0] === symbols[1])
            || (symbols[0] === symbols[2])
            || (symbols[0] === symbols[3])
            || (symbols[1] === symbols[2])
            || (symbols[1] === symbols[3])
            || (symbols[2] === symbols[3])) {
                  throw new Error('[ReadHuffmanCode] invalid symbols');
                }

                if (br.readBits(1)) {
                  code_lengths[symbols[2]] = 3;
                  code_lengths[symbols[3]] = 3;
                } else {
                  code_lengths[symbols[0]] = 2;
                }
                break;
            }
          } else { /* Decode Huffman-coded code lengths. */
            var i;
            const code_length_code_lengths = new Uint8Array(CODE_LENGTH_CODES);
            let space = 32;
            let num_codes = 0;
            /* Static Huffman code for the code length code lengths */
            const huff = [
              new HuffmanCode(2, 0), new HuffmanCode(2, 4), new HuffmanCode(2, 3), new HuffmanCode(3, 2),
              new HuffmanCode(2, 0), new HuffmanCode(2, 4), new HuffmanCode(2, 3), new HuffmanCode(4, 1),
              new HuffmanCode(2, 0), new HuffmanCode(2, 4), new HuffmanCode(2, 3), new HuffmanCode(3, 2),
              new HuffmanCode(2, 0), new HuffmanCode(2, 4), new HuffmanCode(2, 3), new HuffmanCode(4, 5),
            ];
            for (i = simple_code_or_skip; i < CODE_LENGTH_CODES && space > 0; ++i) {
              const code_len_idx = kCodeLengthCodeOrder[i];
              let p = 0;
              var v;
              br.fillBitWindow();
              p += (br.val_ >>> br.bit_pos_) & 15;
              br.bit_pos_ += huff[p].bits;
              v = huff[p].value;
              code_length_code_lengths[code_len_idx] = v;
              if (v !== 0) {
                space -= (32 >> v);
                ++num_codes;
              }
            }

            if (!(num_codes === 1 || space === 0)) throw new Error('[ReadHuffmanCode] invalid num_codes or space');

            ReadHuffmanCodeLengths(code_length_code_lengths, alphabet_size, code_lengths, br);
          }

          table_size = BrotliBuildHuffmanTable(tables, table, HUFFMAN_TABLE_BITS, code_lengths, alphabet_size);

          if (table_size === 0) {
            throw new Error('[ReadHuffmanCode] BuildHuffmanTable failed: ');
          }

          return table_size;
        }

        function ReadBlockLength(table, index, br) {
          let code;
          let nbits;
          code = ReadSymbol(table, index, br);
          nbits = Prefix.kBlockLengthPrefixCode[code].nbits;
          return Prefix.kBlockLengthPrefixCode[code].offset + br.readBits(nbits);
        }

        function TranslateShortCodes(code, ringbuffer, index) {
          let val;
          if (code < NUM_DISTANCE_SHORT_CODES) {
            index += kDistanceShortCodeIndexOffset[code];
            index &= 3;
            val = ringbuffer[index] + kDistanceShortCodeValueOffset[code];
          } else {
            val = code - NUM_DISTANCE_SHORT_CODES + 1;
          }
          return val;
        }

        function MoveToFront(v, index) {
          const value = v[index];
          let i = index;
          for (; i; --i) v[i] = v[i - 1];
          v[0] = value;
        }

        function InverseMoveToFrontTransform(v, v_len) {
          const mtf = new Uint8Array(256);
          let i;
          for (i = 0; i < 256; ++i) {
            mtf[i] = i;
          }
          for (i = 0; i < v_len; ++i) {
            const index = v[i];
            v[i] = mtf[index];
            if (index) MoveToFront(mtf, index);
          }
        }

        /* Contains a collection of huffman trees with the same alphabet size. */
        function HuffmanTreeGroup(alphabet_size, num_htrees) {
          this.alphabet_size = alphabet_size;
          this.num_htrees = num_htrees;
          this.codes = new Array(num_htrees + num_htrees * kMaxHuffmanTableSize[(alphabet_size + 31) >>> 5]);
          this.htrees = new Uint32Array(num_htrees);
        }

        HuffmanTreeGroup.prototype.decode = function (br) {
          let i;
          let table_size;
          let next = 0;
          for (i = 0; i < this.num_htrees; ++i) {
            this.htrees[i] = next;
            table_size = ReadHuffmanCode(this.alphabet_size, this.codes, next, br);
            next += table_size;
          }
        };

        function DecodeContextMap(context_map_size, br) {
          const out = { num_htrees: null, context_map: null };
          let use_rle_for_zeros;
          let max_run_length_prefix = 0;
          let table;
          let i;

          br.readMoreInput();
          const num_htrees = out.num_htrees = DecodeVarLenUint8(br) + 1;

          const context_map = out.context_map = new Uint8Array(context_map_size);
          if (num_htrees <= 1) {
            return out;
          }

          use_rle_for_zeros = br.readBits(1);
          if (use_rle_for_zeros) {
            max_run_length_prefix = br.readBits(4) + 1;
          }

          table = [];
          for (i = 0; i < HUFFMAN_MAX_TABLE_SIZE; i++) {
            table[i] = new HuffmanCode(0, 0);
          }

          ReadHuffmanCode(num_htrees + max_run_length_prefix, table, 0, br);

          for (i = 0; i < context_map_size;) {
            var code;

            br.readMoreInput();
            code = ReadSymbol(table, 0, br);
            if (code === 0) {
              context_map[i] = 0;
              ++i;
            } else if (code <= max_run_length_prefix) {
              let reps = 1 + (1 << code) + br.readBits(code);
              while (--reps) {
                if (i >= context_map_size) {
                  throw new Error('[DecodeContextMap] i >= context_map_size');
                }
                context_map[i] = 0;
                ++i;
              }
            } else {
              context_map[i] = code - max_run_length_prefix;
              ++i;
            }
          }
          if (br.readBits(1)) {
            InverseMoveToFrontTransform(context_map, context_map_size);
          }

          return out;
        }

        function DecodeBlockType(max_block_type, trees, tree_type, block_types, ringbuffers, indexes, br) {
          const ringbuffer = tree_type * 2;
          const index = tree_type;
          const type_code = ReadSymbol(trees, tree_type * HUFFMAN_MAX_TABLE_SIZE, br);
          let block_type;
          if (type_code === 0) {
            block_type = ringbuffers[ringbuffer + (indexes[index] & 1)];
          } else if (type_code === 1) {
            block_type = ringbuffers[ringbuffer + ((indexes[index] - 1) & 1)] + 1;
          } else {
            block_type = type_code - 2;
          }
          if (block_type >= max_block_type) {
            block_type -= max_block_type;
          }
          block_types[tree_type] = block_type;
          ringbuffers[ringbuffer + (indexes[index] & 1)] = block_type;
          ++indexes[index];
        }

        function CopyUncompressedBlockToOutput(output, len, pos, ringbuffer, ringbuffer_mask, br) {
          const rb_size = ringbuffer_mask + 1;
          let rb_pos = pos & ringbuffer_mask;
          let br_pos = br.pos_ & BrotliBitReader.IBUF_MASK;
          let nbytes;

          /* For short lengths copy byte-by-byte */
          if (len < 8 || br.bit_pos_ + (len << 3) < br.bit_end_pos_) {
            while (len-- > 0) {
              br.readMoreInput();
              ringbuffer[rb_pos++] = br.readBits(8);
              if (rb_pos === rb_size) {
                output.write(ringbuffer, rb_size);
                rb_pos = 0;
              }
            }
            return;
          }

          if (br.bit_end_pos_ < 32) {
            throw new Error('[CopyUncompressedBlockToOutput] br.bit_end_pos_ < 32');
          }

          /* Copy remaining 0-4 bytes from br.val_ to ringbuffer. */
          while (br.bit_pos_ < 32) {
            ringbuffer[rb_pos] = (br.val_ >>> br.bit_pos_);
            br.bit_pos_ += 8;
            ++rb_pos;
            --len;
          }

          /* Copy remaining bytes from br.buf_ to ringbuffer. */
          nbytes = (br.bit_end_pos_ - br.bit_pos_) >> 3;
          if (br_pos + nbytes > BrotliBitReader.IBUF_MASK) {
            const tail = BrotliBitReader.IBUF_MASK + 1 - br_pos;
            for (var x = 0; x < tail; x++) ringbuffer[rb_pos + x] = br.buf_[br_pos + x];

            nbytes -= tail;
            rb_pos += tail;
            len -= tail;
            br_pos = 0;
          }

          for (var x = 0; x < nbytes; x++) ringbuffer[rb_pos + x] = br.buf_[br_pos + x];

          rb_pos += nbytes;
          len -= nbytes;

          /* If we wrote past the logical end of the ringbuffer, copy the tail of the
     ringbuffer to its beginning and flush the ringbuffer to the output. */
          if (rb_pos >= rb_size) {
            output.write(ringbuffer, rb_size);
            rb_pos -= rb_size;
            for (var x = 0; x < rb_pos; x++) ringbuffer[x] = ringbuffer[rb_size + x];
          }

          /* If we have more to copy than the remaining size of the ringbuffer, then we
     first fill the ringbuffer from the input and then flush the ringbuffer to
     the output */
          while (rb_pos + len >= rb_size) {
            nbytes = rb_size - rb_pos;
            if (br.input_.read(ringbuffer, rb_pos, nbytes) < nbytes) {
              throw new Error('[CopyUncompressedBlockToOutput] not enough bytes');
            }
            output.write(ringbuffer, rb_size);
            len -= nbytes;
            rb_pos = 0;
          }

          /* Copy straight from the input onto the ringbuffer. The ringbuffer will be
     flushed to the output at a later time. */
          if (br.input_.read(ringbuffer, rb_pos, len) < len) {
            throw new Error('[CopyUncompressedBlockToOutput] not enough bytes');
          }

          /* Restore the state of the bit reader. */
          br.reset();
        }

        /* Advances the bit reader position to the next byte boundary and verifies
   that any skipped bits are set to zero. */
        function JumpToByteBoundary(br) {
          const new_bit_pos = (br.bit_pos_ + 7) & ~7;
          const pad_bits = br.readBits(new_bit_pos - br.bit_pos_);
          return pad_bits == 0;
        }

        function BrotliDecompressedSize(buffer) {
          const input = new BrotliInput(buffer);
          const br = new BrotliBitReader(input);
          DecodeWindowBits(br);
          const out = DecodeMetaBlockLength(br);
          return out.meta_block_length;
        }

        __webpack_unused_export__ = BrotliDecompressedSize;

        function BrotliDecompressBuffer(buffer, output_size) {
          const input = new BrotliInput(buffer);

          if (output_size == null) {
            output_size = BrotliDecompressedSize(buffer);
          }

          const output_buffer = new Uint8Array(output_size);
          const output = new BrotliOutput(output_buffer);

          BrotliDecompress(input, output);

          if (output.pos < output.buffer.length) {
            output.buffer = output.buffer.subarray(0, output.pos);
          }

          return output.buffer;
        }

        exports.BrotliDecompressBuffer = BrotliDecompressBuffer;

        function BrotliDecompress(input, output) {
          let i;
          let pos = 0;
          let input_end = 0;
          let window_bits = 0;
          let max_backward_distance;
          let max_distance = 0;
          let ringbuffer_size;
          let ringbuffer_mask;
          let ringbuffer;
          let ringbuffer_end;
          /* This ring buffer holds a few past copy distances that will be used by */
          /* some special distance codes. */
          const dist_rb = [16, 15, 11, 4];
          let dist_rb_idx = 0;
          /* The previous 2 bytes used for context. */
          let prev_byte1 = 0;
          let prev_byte2 = 0;
          const hgroup = [new HuffmanTreeGroup(0, 0), new HuffmanTreeGroup(0, 0), new HuffmanTreeGroup(0, 0)];
          let block_type_trees;
          let block_len_trees;
          let br;

          /* We need the slack region for the following reasons:
       - always doing two 8-byte copies for fast backward copying
       - transforms
       - flushing the input ringbuffer when decoding uncompressed blocks */
          const kRingBufferWriteAheadSlack = 128 + BrotliBitReader.READ_SIZE;

          br = new BrotliBitReader(input);

          /* Decode window size. */
          window_bits = DecodeWindowBits(br);
          max_backward_distance = (1 << window_bits) - 16;

          ringbuffer_size = 1 << window_bits;
          ringbuffer_mask = ringbuffer_size - 1;
          ringbuffer = new Uint8Array(ringbuffer_size + kRingBufferWriteAheadSlack + BrotliDictionary.maxDictionaryWordLength);
          ringbuffer_end = ringbuffer_size;

          block_type_trees = [];
          block_len_trees = [];
          for (let x = 0; x < 3 * HUFFMAN_MAX_TABLE_SIZE; x++) {
            block_type_trees[x] = new HuffmanCode(0, 0);
            block_len_trees[x] = new HuffmanCode(0, 0);
          }

          while (!input_end) {
            let meta_block_remaining_len = 0;
            var is_uncompressed;
            const block_length = [1 << 28, 1 << 28, 1 << 28];
            const block_type = [0];
            const num_block_types = [1, 1, 1];
            const block_type_rb = [0, 1, 0, 1, 0, 1];
            const block_type_rb_index = [0];
            var distance_postfix_bits;
            var num_direct_distance_codes;
            var distance_postfix_mask;
            var num_distance_codes;
            let context_map = null;
            let context_modes = null;
            var num_literal_htrees;
            let dist_context_map = null;
            var num_dist_htrees;
            let context_offset = 0;
            let context_map_slice = null;
            let literal_htree_index = 0;
            let dist_context_offset = 0;
            let dist_context_map_slice = null;
            let dist_htree_index = 0;
            let context_lookup_offset1 = 0;
            let context_lookup_offset2 = 0;
            var context_mode;
            var htree_command;

            for (i = 0; i < 3; ++i) {
              hgroup[i].codes = null;
              hgroup[i].htrees = null;
            }

            br.readMoreInput();

            const _out = DecodeMetaBlockLength(br);
            meta_block_remaining_len = _out.meta_block_length;
            if (pos + meta_block_remaining_len > output.buffer.length) {
              /* We need to grow the output buffer to fit the additional data. */
              const tmp = new Uint8Array(pos + meta_block_remaining_len);
              tmp.set(output.buffer);
              output.buffer = tmp;
            }
            input_end = _out.input_end;
            is_uncompressed = _out.is_uncompressed;

            if (_out.is_metadata) {
              JumpToByteBoundary(br);

              for (; meta_block_remaining_len > 0; --meta_block_remaining_len) {
                br.readMoreInput();
                /* Read one byte and ignore it. */
                br.readBits(8);
              }

              continue;
            }

            if (meta_block_remaining_len === 0) {
              continue;
            }

            if (is_uncompressed) {
              br.bit_pos_ = (br.bit_pos_ + 7) & ~7;
              CopyUncompressedBlockToOutput(output, meta_block_remaining_len, pos,
                ringbuffer, ringbuffer_mask, br);
              pos += meta_block_remaining_len;
              continue;
            }

            for (i = 0; i < 3; ++i) {
              num_block_types[i] = DecodeVarLenUint8(br) + 1;
              if (num_block_types[i] >= 2) {
                ReadHuffmanCode(num_block_types[i] + 2, block_type_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
                ReadHuffmanCode(kNumBlockLengthCodes, block_len_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
                block_length[i] = ReadBlockLength(block_len_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
                block_type_rb_index[i] = 1;
              }
            }

            br.readMoreInput();

            distance_postfix_bits = br.readBits(2);
            num_direct_distance_codes = NUM_DISTANCE_SHORT_CODES + (br.readBits(4) << distance_postfix_bits);
            distance_postfix_mask = (1 << distance_postfix_bits) - 1;
            num_distance_codes = (num_direct_distance_codes + (48 << distance_postfix_bits));
            context_modes = new Uint8Array(num_block_types[0]);

            for (i = 0; i < num_block_types[0]; ++i) {
              br.readMoreInput();
              context_modes[i] = (br.readBits(2) << 1);
            }

            const _o1 = DecodeContextMap(num_block_types[0] << kLiteralContextBits, br);
            num_literal_htrees = _o1.num_htrees;
            context_map = _o1.context_map;

            const _o2 = DecodeContextMap(num_block_types[2] << kDistanceContextBits, br);
            num_dist_htrees = _o2.num_htrees;
            dist_context_map = _o2.context_map;

            hgroup[0] = new HuffmanTreeGroup(kNumLiteralCodes, num_literal_htrees);
            hgroup[1] = new HuffmanTreeGroup(kNumInsertAndCopyCodes, num_block_types[1]);
            hgroup[2] = new HuffmanTreeGroup(num_distance_codes, num_dist_htrees);

            for (i = 0; i < 3; ++i) {
              hgroup[i].decode(br);
            }

            context_map_slice = 0;
            dist_context_map_slice = 0;
            context_mode = context_modes[block_type[0]];
            context_lookup_offset1 = Context.lookupOffsets[context_mode];
            context_lookup_offset2 = Context.lookupOffsets[context_mode + 1];
            htree_command = hgroup[1].htrees[0];

            while (meta_block_remaining_len > 0) {
              var cmd_code;
              var range_idx;
              var insert_code;
              var copy_code;
              var insert_length;
              var copy_length;
              var distance_code;
              var distance;
              var context;
              var j;
              var copy_dst;

              br.readMoreInput();

              if (block_length[1] === 0) {
                DecodeBlockType(num_block_types[1],
                  block_type_trees, 1, block_type, block_type_rb,
                  block_type_rb_index, br);
                block_length[1] = ReadBlockLength(block_len_trees, HUFFMAN_MAX_TABLE_SIZE, br);
                htree_command = hgroup[1].htrees[block_type[1]];
              }
              --block_length[1];
              cmd_code = ReadSymbol(hgroup[1].codes, htree_command, br);
              range_idx = cmd_code >> 6;
              if (range_idx >= 2) {
                range_idx -= 2;
                distance_code = -1;
              } else {
                distance_code = 0;
              }
              insert_code = Prefix.kInsertRangeLut[range_idx] + ((cmd_code >> 3) & 7);
              copy_code = Prefix.kCopyRangeLut[range_idx] + (cmd_code & 7);
              insert_length = Prefix.kInsertLengthPrefixCode[insert_code].offset
          + br.readBits(Prefix.kInsertLengthPrefixCode[insert_code].nbits);
              copy_length = Prefix.kCopyLengthPrefixCode[copy_code].offset
          + br.readBits(Prefix.kCopyLengthPrefixCode[copy_code].nbits);
              prev_byte1 = ringbuffer[pos - 1 & ringbuffer_mask];
              prev_byte2 = ringbuffer[pos - 2 & ringbuffer_mask];
              for (j = 0; j < insert_length; ++j) {
                br.readMoreInput();

                if (block_length[0] === 0) {
                  DecodeBlockType(num_block_types[0],
                    block_type_trees, 0, block_type, block_type_rb,
                    block_type_rb_index, br);
                  block_length[0] = ReadBlockLength(block_len_trees, 0, br);
                  context_offset = block_type[0] << kLiteralContextBits;
                  context_map_slice = context_offset;
                  context_mode = context_modes[block_type[0]];
                  context_lookup_offset1 = Context.lookupOffsets[context_mode];
                  context_lookup_offset2 = Context.lookupOffsets[context_mode + 1];
                }
                context = (Context.lookup[context_lookup_offset1 + prev_byte1]
                   | Context.lookup[context_lookup_offset2 + prev_byte2]);
                literal_htree_index = context_map[context_map_slice + context];
                --block_length[0];
                prev_byte2 = prev_byte1;
                prev_byte1 = ReadSymbol(hgroup[0].codes, hgroup[0].htrees[literal_htree_index], br);
                ringbuffer[pos & ringbuffer_mask] = prev_byte1;
                if ((pos & ringbuffer_mask) === ringbuffer_mask) {
                  output.write(ringbuffer, ringbuffer_size);
                }
                ++pos;
              }
              meta_block_remaining_len -= insert_length;
              if (meta_block_remaining_len <= 0) break;

              if (distance_code < 0) {
                var context;

                br.readMoreInput();
                if (block_length[2] === 0) {
                  DecodeBlockType(num_block_types[2],
                    block_type_trees, 2, block_type, block_type_rb,
                    block_type_rb_index, br);
                  block_length[2] = ReadBlockLength(block_len_trees, 2 * HUFFMAN_MAX_TABLE_SIZE, br);
                  dist_context_offset = block_type[2] << kDistanceContextBits;
                  dist_context_map_slice = dist_context_offset;
                }
                --block_length[2];
                context = (copy_length > 4 ? 3 : copy_length - 2) & 0xff;
                dist_htree_index = dist_context_map[dist_context_map_slice + context];
                distance_code = ReadSymbol(hgroup[2].codes, hgroup[2].htrees[dist_htree_index], br);
                if (distance_code >= num_direct_distance_codes) {
                  var nbits;
                  var postfix;
                  var offset;
                  distance_code -= num_direct_distance_codes;
                  postfix = distance_code & distance_postfix_mask;
                  distance_code >>= distance_postfix_bits;
                  nbits = (distance_code >> 1) + 1;
                  offset = ((2 + (distance_code & 1)) << nbits) - 4;
                  distance_code = num_direct_distance_codes
              + ((offset + br.readBits(nbits))
               << distance_postfix_bits) + postfix;
                }
              }

              /* Convert the distance code to the actual distance by possibly looking */
              /* up past distnaces from the ringbuffer. */
              distance = TranslateShortCodes(distance_code, dist_rb, dist_rb_idx);
              if (distance < 0) {
                throw new Error('[BrotliDecompress] invalid distance');
              }

              if (pos < max_backward_distance
          && max_distance !== max_backward_distance) {
                max_distance = pos;
              } else {
                max_distance = max_backward_distance;
              }

              copy_dst = pos & ringbuffer_mask;

              if (distance > max_distance) {
                if (copy_length >= BrotliDictionary.minDictionaryWordLength
            && copy_length <= BrotliDictionary.maxDictionaryWordLength) {
                  var offset = BrotliDictionary.offsetsByLength[copy_length];
                  const word_id = distance - max_distance - 1;
                  const shift = BrotliDictionary.sizeBitsByLength[copy_length];
                  const mask = (1 << shift) - 1;
                  const word_idx = word_id & mask;
                  const transform_idx = word_id >> shift;
                  offset += word_idx * copy_length;
                  if (transform_idx < Transform.kNumTransforms) {
                    const len = Transform.transformDictionaryWord(ringbuffer, copy_dst, offset, copy_length, transform_idx);
                    copy_dst += len;
                    pos += len;
                    meta_block_remaining_len -= len;
                    if (copy_dst >= ringbuffer_end) {
                      output.write(ringbuffer, ringbuffer_size);

                      for (let _x = 0; _x < (copy_dst - ringbuffer_end); _x++) ringbuffer[_x] = ringbuffer[ringbuffer_end + _x];
                    }
                  } else {
                    throw new Error(`Invalid backward reference. pos: ${pos} distance: ${distance
                    } len: ${copy_length} bytes left: ${meta_block_remaining_len}`);
                  }
                } else {
                  throw new Error(`Invalid backward reference. pos: ${pos} distance: ${distance
                  } len: ${copy_length} bytes left: ${meta_block_remaining_len}`);
                }
              } else {
                if (distance_code > 0) {
                  dist_rb[dist_rb_idx & 3] = distance;
                  ++dist_rb_idx;
                }

                if (copy_length > meta_block_remaining_len) {
                  throw new Error(`Invalid backward reference. pos: ${pos} distance: ${distance
                  } len: ${copy_length} bytes left: ${meta_block_remaining_len}`);
                }

                for (j = 0; j < copy_length; ++j) {
                  ringbuffer[pos & ringbuffer_mask] = ringbuffer[(pos - distance) & ringbuffer_mask];
                  if ((pos & ringbuffer_mask) === ringbuffer_mask) {
                    output.write(ringbuffer, ringbuffer_size);
                  }
                  ++pos;
                  --meta_block_remaining_len;
                }
              }

              /* When we get here, we must have inserted at least one literal and */
              /* made a copy of at least length two, therefore accessing the last 2 */
              /* bytes is valid. */
              prev_byte1 = ringbuffer[(pos - 1) & ringbuffer_mask];
              prev_byte2 = ringbuffer[(pos - 2) & ringbuffer_mask];
            }

            /* Protect pos from overflow, wrap it around at every GB of input data */
            pos &= 0x3fffffff;
          }

          output.write(ringbuffer, pos & ringbuffer_mask);
        }

        __webpack_unused_export__ = BrotliDecompress;

        BrotliDictionary.init();
        /***/ }),

      /***/ 5340:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        const base64 = __webpack_require__(9742);
        const fs = __webpack_require__(3857);

        /**
 * The normal dictionary-data.js is quite large, which makes it
 * unsuitable for browser usage. In order to make it smaller,
 * we read dictionary.bin, which is a compressed version of
 * the dictionary, and on initial load, Brotli decompresses
 * it's own dictionary. 😜
 */
        exports.init = function () {
          const { BrotliDecompressBuffer } = __webpack_require__(6450);
          const compressed = base64.toByteArray(__webpack_require__(2722));
          return BrotliDecompressBuffer(compressed);
        };
        /***/ }),

      /***/ 2722:
      /***/ (function (module) {
        module.exports = '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';
        /***/ }),

      /***/ 5139:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        /* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Collection of static dictionary words.
*/

        const data = __webpack_require__(5340);
        exports.init = function () {
          exports.dictionary = data.init();
        };

        exports.offsetsByLength = new Uint32Array([
          0, 0, 0, 0, 0, 4096, 9216, 21504, 35840, 44032,
          53248, 63488, 74752, 87040, 93696, 100864, 104704, 106752, 108928, 113536,
          115968, 118528, 119872, 121280, 122016,
        ]);

        exports.sizeBitsByLength = new Uint8Array([
          0, 0, 0, 0, 10, 10, 11, 11, 10, 10,
          10, 10, 10, 9, 9, 8, 7, 7, 8, 7,
          7, 6, 6, 5, 5,
        ]);

        exports.minDictionaryWordLength = 4;
        exports.maxDictionaryWordLength = 24;
        /***/ }),

      /***/ 966:
      /***/ (function (__unused_webpack_module, exports) {
        function HuffmanCode(bits, value) {
          this.bits = bits; /* number of bits used for this symbol */
          this.value = value; /* symbol value or table offset */
        }

        exports.h = HuffmanCode;

        const MAX_LENGTH = 15;

        /* Returns reverse(reverse(key, len) + 1, len), where reverse(key, len) is the
   bit-wise reversal of the len least significant bits of key. */
        function GetNextKey(key, len) {
          let step = 1 << (len - 1);
          while (key & step) {
            step >>= 1;
          }
          return (key & (step - 1)) + step;
        }

        /* Stores code in table[0], table[step], table[2*step], ..., table[end] */
        /* Assumes that end is an integer multiple of step */
        function ReplicateValue(table, i, step, end, code) {
          do {
            end -= step;
            table[i + end] = new HuffmanCode(code.bits, code.value);
          } while (end > 0);
        }

        /* Returns the table width of the next 2nd level table. count is the histogram
   of bit lengths for the remaining symbols, len is the code length of the next
   processed symbol */
        function NextTableBitSize(count, len, root_bits) {
          let left = 1 << (len - root_bits);
          while (len < MAX_LENGTH) {
            left -= count[len];
            if (left <= 0) break;
            ++len;
            left <<= 1;
          }
          return len - root_bits;
        }

        exports.g = function (root_table, table, root_bits, code_lengths, code_lengths_size) {
          const start_table = table;
          let code; /* current table entry */
          let len; /* current code length */
          let symbol; /* symbol index in original or sorted table */
          let key; /* reversed prefix code */
          let step; /* step size to replicate values in current table */
          let low; /* low bits for current root entry */
          let mask; /* mask for low bits */
          let table_bits; /* key length of current table */
          let table_size; /* size of current table */
          let total_size; /* sum of root table size and 2nd level table sizes */
          let sorted; /* symbols sorted by code length */
          const count = new Int32Array(MAX_LENGTH + 1); /* number of codes of each length */
          const offset = new Int32Array(MAX_LENGTH + 1); /* offsets in sorted table for each length */

          sorted = new Int32Array(code_lengths_size);

          /* build histogram of code lengths */
          for (symbol = 0; symbol < code_lengths_size; symbol++) {
            count[code_lengths[symbol]]++;
          }

          /* generate offsets into sorted symbol table by code length */
          offset[1] = 0;
          for (len = 1; len < MAX_LENGTH; len++) {
            offset[len + 1] = offset[len] + count[len];
          }

          /* sort symbols by length, by symbol order within each length */
          for (symbol = 0; symbol < code_lengths_size; symbol++) {
            if (code_lengths[symbol] !== 0) {
              sorted[offset[code_lengths[symbol]]++] = symbol;
            }
          }

          table_bits = root_bits;
          table_size = 1 << table_bits;
          total_size = table_size;

          /* special case code with only one value */
          if (offset[MAX_LENGTH] === 1) {
            for (key = 0; key < total_size; ++key) {
              root_table[table + key] = new HuffmanCode(0, sorted[0] & 0xffff);
            }

            return total_size;
          }

          /* fill in root table */
          key = 0;
          symbol = 0;
          for (len = 1, step = 2; len <= root_bits; ++len, step <<= 1) {
            for (; count[len] > 0; --count[len]) {
              code = new HuffmanCode(len & 0xff, sorted[symbol++] & 0xffff);
              ReplicateValue(root_table, table + key, step, table_size, code);
              key = GetNextKey(key, len);
            }
          }

          /* fill in 2nd level tables and add pointers to root table */
          mask = total_size - 1;
          low = -1;
          for (len = root_bits + 1, step = 2; len <= MAX_LENGTH; ++len, step <<= 1) {
            for (; count[len] > 0; --count[len]) {
              if ((key & mask) !== low) {
                table += table_size;
                table_bits = NextTableBitSize(count, len, root_bits);
                table_size = 1 << table_bits;
                total_size += table_size;
                low = key & mask;
                root_table[start_table + low] = new HuffmanCode((table_bits + root_bits) & 0xff, ((table - start_table) - low) & 0xffff);
              }
              code = new HuffmanCode((len - root_bits) & 0xff, sorted[symbol++] & 0xffff);
              ReplicateValue(root_table, table + (key >> root_bits), step, table_size, code);
              key = GetNextKey(key, len);
            }
          }

          return total_size;
        };
        /***/ }),

      /***/ 8435:
      /***/ (function (__unused_webpack_module, exports) {
        /* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Lookup tables to map prefix codes to value ranges. This is used during
   decoding of the block lengths, literal insertion lengths and copy lengths.
*/

        /* Represents the range of values belonging to a prefix code: */
        /* [offset, offset + 2^nbits) */
        function PrefixCodeRange(offset, nbits) {
          this.offset = offset;
          this.nbits = nbits;
        }

        exports.kBlockLengthPrefixCode = [
          new PrefixCodeRange(1, 2), new PrefixCodeRange(5, 2), new PrefixCodeRange(9, 2), new PrefixCodeRange(13, 2),
          new PrefixCodeRange(17, 3), new PrefixCodeRange(25, 3), new PrefixCodeRange(33, 3), new PrefixCodeRange(41, 3),
          new PrefixCodeRange(49, 4), new PrefixCodeRange(65, 4), new PrefixCodeRange(81, 4), new PrefixCodeRange(97, 4),
          new PrefixCodeRange(113, 5), new PrefixCodeRange(145, 5), new PrefixCodeRange(177, 5), new PrefixCodeRange(209, 5),
          new PrefixCodeRange(241, 6), new PrefixCodeRange(305, 6), new PrefixCodeRange(369, 7), new PrefixCodeRange(497, 8),
          new PrefixCodeRange(753, 9), new PrefixCodeRange(1265, 10), new PrefixCodeRange(2289, 11), new PrefixCodeRange(4337, 12),
          new PrefixCodeRange(8433, 13), new PrefixCodeRange(16625, 24),
        ];

        exports.kInsertLengthPrefixCode = [
          new PrefixCodeRange(0, 0), new PrefixCodeRange(1, 0), new PrefixCodeRange(2, 0), new PrefixCodeRange(3, 0),
          new PrefixCodeRange(4, 0), new PrefixCodeRange(5, 0), new PrefixCodeRange(6, 1), new PrefixCodeRange(8, 1),
          new PrefixCodeRange(10, 2), new PrefixCodeRange(14, 2), new PrefixCodeRange(18, 3), new PrefixCodeRange(26, 3),
          new PrefixCodeRange(34, 4), new PrefixCodeRange(50, 4), new PrefixCodeRange(66, 5), new PrefixCodeRange(98, 5),
          new PrefixCodeRange(130, 6), new PrefixCodeRange(194, 7), new PrefixCodeRange(322, 8), new PrefixCodeRange(578, 9),
          new PrefixCodeRange(1090, 10), new PrefixCodeRange(2114, 12), new PrefixCodeRange(6210, 14), new PrefixCodeRange(22594, 24),
        ];

        exports.kCopyLengthPrefixCode = [
          new PrefixCodeRange(2, 0), new PrefixCodeRange(3, 0), new PrefixCodeRange(4, 0), new PrefixCodeRange(5, 0),
          new PrefixCodeRange(6, 0), new PrefixCodeRange(7, 0), new PrefixCodeRange(8, 0), new PrefixCodeRange(9, 0),
          new PrefixCodeRange(10, 1), new PrefixCodeRange(12, 1), new PrefixCodeRange(14, 2), new PrefixCodeRange(18, 2),
          new PrefixCodeRange(22, 3), new PrefixCodeRange(30, 3), new PrefixCodeRange(38, 4), new PrefixCodeRange(54, 4),
          new PrefixCodeRange(70, 5), new PrefixCodeRange(102, 5), new PrefixCodeRange(134, 6), new PrefixCodeRange(198, 7),
          new PrefixCodeRange(326, 8), new PrefixCodeRange(582, 9), new PrefixCodeRange(1094, 10), new PrefixCodeRange(2118, 24),
        ];

        exports.kInsertRangeLut = [
          0, 0, 8, 8, 0, 16, 8, 16, 16,
        ];

        exports.kCopyRangeLut = [
          0, 8, 0, 8, 16, 0, 16, 8, 16,
        ];
        /***/ }),

      /***/ 6154:
      /***/ (function (__unused_webpack_module, exports) {
        function BrotliInput(buffer) {
          this.buffer = buffer;
          this.pos = 0;
        }

        BrotliInput.prototype.read = function (buf, i, count) {
          if (this.pos + count > this.buffer.length) {
            count = this.buffer.length - this.pos;
          }

          for (let p = 0; p < count; p++) buf[i + p] = this.buffer[this.pos + p];

          this.pos += count;
          return count;
        };

        exports.g = BrotliInput;

        function BrotliOutput(buf) {
          this.buffer = buf;
          this.pos = 0;
        }

        BrotliOutput.prototype.write = function (buf, count) {
          if (this.pos + count > this.buffer.length) throw new Error('Output buffer is not large enough');

          this.buffer.set(buf.subarray(0, count), this.pos);
          this.pos += count;
          return count;
        };

        exports.j = BrotliOutput;
        /***/ }),

      /***/ 2973:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        /* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Transformations on dictionary words.
*/

        const BrotliDictionary = __webpack_require__(5139);

        const kIdentity = 0;
        const kOmitLast1 = 1;
        const kOmitLast2 = 2;
        const kOmitLast3 = 3;
        const kOmitLast4 = 4;
        const kOmitLast5 = 5;
        const kOmitLast6 = 6;
        const kOmitLast7 = 7;
        const kOmitLast8 = 8;
        const kOmitLast9 = 9;
        const kUppercaseFirst = 10;
        const kUppercaseAll = 11;
        const kOmitFirst1 = 12;
        const kOmitFirst2 = 13;
        const kOmitFirst3 = 14;
        const kOmitFirst4 = 15;
        const kOmitFirst5 = 16;
        const kOmitFirst6 = 17;
        const kOmitFirst7 = 18;
        const kOmitFirst8 = 19;
        const kOmitFirst9 = 20;

        function Transform(prefix, transform, suffix) {
          this.prefix = new Uint8Array(prefix.length);
          this.transform = transform;
          this.suffix = new Uint8Array(suffix.length);

          for (var i = 0; i < prefix.length; i++) this.prefix[i] = prefix.charCodeAt(i);

          for (var i = 0; i < suffix.length; i++) this.suffix[i] = suffix.charCodeAt(i);
        }

        const kTransforms = [
          new Transform('', kIdentity, ''),
          new Transform('', kIdentity, ' '),
          new Transform(' ', kIdentity, ' '),
          new Transform('', kOmitFirst1, ''),
          new Transform('', kUppercaseFirst, ' '),
          new Transform('', kIdentity, ' the '),
          new Transform(' ', kIdentity, ''),
          new Transform('s ', kIdentity, ' '),
          new Transform('', kIdentity, ' of '),
          new Transform('', kUppercaseFirst, ''),
          new Transform('', kIdentity, ' and '),
          new Transform('', kOmitFirst2, ''),
          new Transform('', kOmitLast1, ''),
          new Transform(', ', kIdentity, ' '),
          new Transform('', kIdentity, ', '),
          new Transform(' ', kUppercaseFirst, ' '),
          new Transform('', kIdentity, ' in '),
          new Transform('', kIdentity, ' to '),
          new Transform('e ', kIdentity, ' '),
          new Transform('', kIdentity, '"'),
          new Transform('', kIdentity, '.'),
          new Transform('', kIdentity, '">'),
          new Transform('', kIdentity, '\n'),
          new Transform('', kOmitLast3, ''),
          new Transform('', kIdentity, ']'),
          new Transform('', kIdentity, ' for '),
          new Transform('', kOmitFirst3, ''),
          new Transform('', kOmitLast2, ''),
          new Transform('', kIdentity, ' a '),
          new Transform('', kIdentity, ' that '),
          new Transform(' ', kUppercaseFirst, ''),
          new Transform('', kIdentity, '. '),
          new Transform('.', kIdentity, ''),
          new Transform(' ', kIdentity, ', '),
          new Transform('', kOmitFirst4, ''),
          new Transform('', kIdentity, ' with '),
          new Transform('', kIdentity, "'"),
          new Transform('', kIdentity, ' from '),
          new Transform('', kIdentity, ' by '),
          new Transform('', kOmitFirst5, ''),
          new Transform('', kOmitFirst6, ''),
          new Transform(' the ', kIdentity, ''),
          new Transform('', kOmitLast4, ''),
          new Transform('', kIdentity, '. The '),
          new Transform('', kUppercaseAll, ''),
          new Transform('', kIdentity, ' on '),
          new Transform('', kIdentity, ' as '),
          new Transform('', kIdentity, ' is '),
          new Transform('', kOmitLast7, ''),
          new Transform('', kOmitLast1, 'ing '),
          new Transform('', kIdentity, '\n\t'),
          new Transform('', kIdentity, ':'),
          new Transform(' ', kIdentity, '. '),
          new Transform('', kIdentity, 'ed '),
          new Transform('', kOmitFirst9, ''),
          new Transform('', kOmitFirst7, ''),
          new Transform('', kOmitLast6, ''),
          new Transform('', kIdentity, '('),
          new Transform('', kUppercaseFirst, ', '),
          new Transform('', kOmitLast8, ''),
          new Transform('', kIdentity, ' at '),
          new Transform('', kIdentity, 'ly '),
          new Transform(' the ', kIdentity, ' of '),
          new Transform('', kOmitLast5, ''),
          new Transform('', kOmitLast9, ''),
          new Transform(' ', kUppercaseFirst, ', '),
          new Transform('', kUppercaseFirst, '"'),
          new Transform('.', kIdentity, '('),
          new Transform('', kUppercaseAll, ' '),
          new Transform('', kUppercaseFirst, '">'),
          new Transform('', kIdentity, '="'),
          new Transform(' ', kIdentity, '.'),
          new Transform('.com/', kIdentity, ''),
          new Transform(' the ', kIdentity, ' of the '),
          new Transform('', kUppercaseFirst, "'"),
          new Transform('', kIdentity, '. This '),
          new Transform('', kIdentity, ','),
          new Transform('.', kIdentity, ' '),
          new Transform('', kUppercaseFirst, '('),
          new Transform('', kUppercaseFirst, '.'),
          new Transform('', kIdentity, ' not '),
          new Transform(' ', kIdentity, '="'),
          new Transform('', kIdentity, 'er '),
          new Transform(' ', kUppercaseAll, ' '),
          new Transform('', kIdentity, 'al '),
          new Transform(' ', kUppercaseAll, ''),
          new Transform('', kIdentity, "='"),
          new Transform('', kUppercaseAll, '"'),
          new Transform('', kUppercaseFirst, '. '),
          new Transform(' ', kIdentity, '('),
          new Transform('', kIdentity, 'ful '),
          new Transform(' ', kUppercaseFirst, '. '),
          new Transform('', kIdentity, 'ive '),
          new Transform('', kIdentity, 'less '),
          new Transform('', kUppercaseAll, "'"),
          new Transform('', kIdentity, 'est '),
          new Transform(' ', kUppercaseFirst, '.'),
          new Transform('', kUppercaseAll, '">'),
          new Transform(' ', kIdentity, "='"),
          new Transform('', kUppercaseFirst, ','),
          new Transform('', kIdentity, 'ize '),
          new Transform('', kUppercaseAll, '.'),
          new Transform('\xc2\xa0', kIdentity, ''),
          new Transform(' ', kIdentity, ','),
          new Transform('', kUppercaseFirst, '="'),
          new Transform('', kUppercaseAll, '="'),
          new Transform('', kIdentity, 'ous '),
          new Transform('', kUppercaseAll, ', '),
          new Transform('', kUppercaseFirst, "='"),
          new Transform(' ', kUppercaseFirst, ','),
          new Transform(' ', kUppercaseAll, '="'),
          new Transform(' ', kUppercaseAll, ', '),
          new Transform('', kUppercaseAll, ','),
          new Transform('', kUppercaseAll, '('),
          new Transform('', kUppercaseAll, '. '),
          new Transform(' ', kUppercaseAll, '.'),
          new Transform('', kUppercaseAll, "='"),
          new Transform(' ', kUppercaseAll, '. '),
          new Transform(' ', kUppercaseFirst, '="'),
          new Transform(' ', kUppercaseAll, "='"),
          new Transform(' ', kUppercaseFirst, "='"),
        ];

        exports.kTransforms = kTransforms;
        exports.kNumTransforms = kTransforms.length;

        function ToUpperCase(p, i) {
          if (p[i] < 0xc0) {
            if (p[i] >= 97 && p[i] <= 122) {
              p[i] ^= 32;
            }
            return 1;
          }

          /* An overly simplified uppercasing model for utf-8. */
          if (p[i] < 0xe0) {
            p[i + 1] ^= 32;
            return 2;
          }

          /* An arbitrary transform for three byte characters. */
          p[i + 2] ^= 5;
          return 3;
        }

        exports.transformDictionaryWord = function (dst, idx, word, len, transform) {
          const { prefix } = kTransforms[transform];
          const { suffix } = kTransforms[transform];
          const t = kTransforms[transform].transform;
          let skip = t < kOmitFirst1 ? 0 : t - (kOmitFirst1 - 1);
          let i = 0;
          const start_idx = idx;
          let uppercase;

          if (skip > len) {
            skip = len;
          }

          let prefix_pos = 0;
          while (prefix_pos < prefix.length) {
            dst[idx++] = prefix[prefix_pos++];
          }

          word += skip;
          len -= skip;

          if (t <= kOmitLast9) {
            len -= t;
          }

          for (i = 0; i < len; i++) {
            dst[idx++] = BrotliDictionary.dictionary[word + i];
          }

          uppercase = idx - len;

          if (t === kUppercaseFirst) {
            ToUpperCase(dst, uppercase);
          } else if (t === kUppercaseAll) {
            while (len > 0) {
              const step = ToUpperCase(dst, uppercase);
              uppercase += step;
              len -= step;
            }
          }

          let suffix_pos = 0;
          while (suffix_pos < suffix.length) {
            dst[idx++] = suffix[suffix_pos++];
          }

          return idx - start_idx;
        };
        /***/ }),

      /***/ 7709:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        module.exports = __webpack_require__(6450).BrotliDecompressBuffer;
        /***/ }),

      /***/ 4505:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        /* provided dependency */ const { Buffer } = __webpack_require__(8823);
        /* provided dependency */ const process = __webpack_require__(4155);

        /* eslint camelcase: "off" */

        const assert = __webpack_require__(9282);

        const Zstream = __webpack_require__(4860);
        const zlib_deflate = __webpack_require__(2233);
        const zlib_inflate = __webpack_require__(3001);
        const constants = __webpack_require__(7162);

        for (const key in constants) {
          exports[key] = constants[key];
        }

        // zlib modes
        exports.NONE = 0;
        exports.DEFLATE = 1;
        exports.INFLATE = 2;
        exports.GZIP = 3;
        exports.GUNZIP = 4;
        exports.DEFLATERAW = 5;
        exports.INFLATERAW = 6;
        exports.UNZIP = 7;

        const GZIP_HEADER_ID1 = 0x1f;
        const GZIP_HEADER_ID2 = 0x8b;

        /**
 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
 */
        function Zlib(mode) {
          if (typeof mode !== 'number' || mode < exports.DEFLATE || mode > exports.UNZIP) {
            throw new TypeError('Bad argument');
          }

          this.dictionary = null;
          this.err = 0;
          this.flush = 0;
          this.init_done = false;
          this.level = 0;
          this.memLevel = 0;
          this.mode = mode;
          this.strategy = 0;
          this.windowBits = 0;
          this.write_in_progress = false;
          this.pending_close = false;
          this.gzip_id_bytes_read = 0;
        }

        Zlib.prototype.close = function () {
          if (this.write_in_progress) {
            this.pending_close = true;
            return;
          }

          this.pending_close = false;

          assert(this.init_done, 'close before init');
          assert(this.mode <= exports.UNZIP);

          if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) {
            zlib_deflate.deflateEnd(this.strm);
          } else if (this.mode === exports.INFLATE || this.mode === exports.GUNZIP || this.mode === exports.INFLATERAW || this.mode === exports.UNZIP) {
            zlib_inflate.inflateEnd(this.strm);
          }

          this.mode = exports.NONE;

          this.dictionary = null;
        };

        Zlib.prototype.write = function (flush, input, in_off, in_len, out, out_off, out_len) {
          return this._write(true, flush, input, in_off, in_len, out, out_off, out_len);
        };

        Zlib.prototype.writeSync = function (flush, input, in_off, in_len, out, out_off, out_len) {
          return this._write(false, flush, input, in_off, in_len, out, out_off, out_len);
        };

        Zlib.prototype._write = function (async, flush, input, in_off, in_len, out, out_off, out_len) {
          assert.equal(arguments.length, 8);

          assert(this.init_done, 'write before init');
          assert(this.mode !== exports.NONE, 'already finalized');
          assert.equal(false, this.write_in_progress, 'write already in progress');
          assert.equal(false, this.pending_close, 'close is pending');

          this.write_in_progress = true;

          assert.equal(false, flush === undefined, 'must provide flush value');

          this.write_in_progress = true;

          if (flush !== exports.Z_NO_FLUSH && flush !== exports.Z_PARTIAL_FLUSH && flush !== exports.Z_SYNC_FLUSH && flush !== exports.Z_FULL_FLUSH && flush !== exports.Z_FINISH && flush !== exports.Z_BLOCK) {
            throw new Error('Invalid flush value');
          }

          if (input == null) {
            input = Buffer.alloc(0);
            in_len = 0;
            in_off = 0;
          }

          this.strm.avail_in = in_len;
          this.strm.input = input;
          this.strm.next_in = in_off;
          this.strm.avail_out = out_len;
          this.strm.output = out;
          this.strm.next_out = out_off;
          this.flush = flush;

          if (!async) {
            // sync version
            this._process();

            if (this._checkError()) {
              return this._afterSync();
            }
            return;
          }

          // async version
          const self = this;
          process.nextTick(() => {
            self._process();
            self._after();
          });

          return this;
        };

        Zlib.prototype._afterSync = function () {
          const { avail_out } = this.strm;
          const { avail_in } = this.strm;

          this.write_in_progress = false;

          return [avail_in, avail_out];
        };

        Zlib.prototype._process = function () {
          let next_expected_header_byte = null;

          // If the avail_out is left at 0, then it means that it ran out
          // of room.  If there was avail_out left over, then it means
          // that all of the input was consumed.
          switch (this.mode) {
            case exports.DEFLATE:
            case exports.GZIP:
            case exports.DEFLATERAW:
              this.err = zlib_deflate.deflate(this.strm, this.flush);
              break;
            case exports.UNZIP:
              if (this.strm.avail_in > 0) {
                next_expected_header_byte = this.strm.next_in;
              }

              switch (this.gzip_id_bytes_read) {
                case 0:
                  if (next_expected_header_byte === null) {
                    break;
                  }

                  if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID1) {
                    this.gzip_id_bytes_read = 1;
                    next_expected_header_byte++;

                    if (this.strm.avail_in === 1) {
                      // The only available byte was already read.
                      break;
                    }
                  } else {
                    this.mode = exports.INFLATE;
                    break;
                  }

                  // fallthrough
                case 1:
                  if (next_expected_header_byte === null) {
                    break;
                  }

                  if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID2) {
                    this.gzip_id_bytes_read = 2;
                    this.mode = exports.GUNZIP;
                  } else {
                    // There is no actual difference between INFLATE and INFLATERAW
                    // (after initialization).
                    this.mode = exports.INFLATE;
                  }

                  break;
                default:
                  throw new Error('invalid number of gzip magic number bytes read');
              }

              // fallthrough
            case exports.INFLATE:
            case exports.GUNZIP:
            case exports.INFLATERAW:
              this.err = zlib_inflate.inflate(this.strm, this.flush,

                // If data was encoded with dictionary
              ); if (this.err === exports.Z_NEED_DICT && this.dictionary) {
                // Load it
                this.err = zlib_inflate.inflateSetDictionary(this.strm, this.dictionary);
                if (this.err === exports.Z_OK) {
                  // And try to decode again
                  this.err = zlib_inflate.inflate(this.strm, this.flush);
                } else if (this.err === exports.Z_DATA_ERROR) {
                  // Both inflateSetDictionary() and inflate() return Z_DATA_ERROR.
                  // Make it possible for After() to tell a bad dictionary from bad
                  // input.
                  this.err = exports.Z_NEED_DICT;
                }
              }
              while (this.strm.avail_in > 0 && this.mode === exports.GUNZIP && this.err === exports.Z_STREAM_END && this.strm.next_in[0] !== 0x00) {
                // Bytes remain in input buffer. Perhaps this is another compressed
                // member in the same archive, or just trailing garbage.
                // Trailing zero bytes are okay, though, since they are frequently
                // used for padding.

                this.reset();
                this.err = zlib_inflate.inflate(this.strm, this.flush);
              }
              break;
            default:
              throw new Error(`Unknown mode ${this.mode}`);
          }
        };

        Zlib.prototype._checkError = function () {
          // Acceptable error states depend on the type of zlib stream.
          switch (this.err) {
            case exports.Z_OK:
            case exports.Z_BUF_ERROR:
              if (this.strm.avail_out !== 0 && this.flush === exports.Z_FINISH) {
                this._error('unexpected end of file');
                return false;
              }
              break;
            case exports.Z_STREAM_END:
              // normal statuses, not fatal
              break;
            case exports.Z_NEED_DICT:
              if (this.dictionary == null) {
                this._error('Missing dictionary');
              } else {
                this._error('Bad dictionary');
              }
              return false;
            default:
              // something else.
              this._error('Zlib error');
              return false;
          }

          return true;
        };

        Zlib.prototype._after = function () {
          if (!this._checkError()) {
            return;
          }

          const { avail_out } = this.strm;
          const { avail_in } = this.strm;

          this.write_in_progress = false;

          // call the write() cb
          this.callback(avail_in, avail_out);

          if (this.pending_close) {
            this.close();
          }
        };

        Zlib.prototype._error = function (message) {
          if (this.strm.msg) {
            message = this.strm.msg;
          }
          this.onerror(message, this.err,

            // no hope of rescue.
          ); this.write_in_progress = false;
          if (this.pending_close) {
            this.close();
          }
        };

        Zlib.prototype.init = function (windowBits, level, memLevel, strategy, dictionary) {
          assert(arguments.length === 4 || arguments.length === 5, 'init(windowBits, level, memLevel, strategy, [dictionary])');

          assert(windowBits >= 8 && windowBits <= 15, 'invalid windowBits');
          assert(level >= -1 && level <= 9, 'invalid compression level');

          assert(memLevel >= 1 && memLevel <= 9, 'invalid memlevel');

          assert(strategy === exports.Z_FILTERED || strategy === exports.Z_HUFFMAN_ONLY || strategy === exports.Z_RLE || strategy === exports.Z_FIXED || strategy === exports.Z_DEFAULT_STRATEGY, 'invalid strategy');

          this._init(level, windowBits, memLevel, strategy, dictionary);
          this._setDictionary();
        };

        Zlib.prototype.params = function () {
          throw new Error('deflateParams Not supported');
        };

        Zlib.prototype.reset = function () {
          this._reset();
          this._setDictionary();
        };

        Zlib.prototype._init = function (level, windowBits, memLevel, strategy, dictionary) {
          this.level = level;
          this.windowBits = windowBits;
          this.memLevel = memLevel;
          this.strategy = strategy;

          this.flush = exports.Z_NO_FLUSH;

          this.err = exports.Z_OK;

          if (this.mode === exports.GZIP || this.mode === exports.GUNZIP) {
            this.windowBits += 16;
          }

          if (this.mode === exports.UNZIP) {
            this.windowBits += 32;
          }

          if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW) {
            this.windowBits = -1 * this.windowBits;
          }

          this.strm = new Zstream();

          switch (this.mode) {
            case exports.DEFLATE:
            case exports.GZIP:
            case exports.DEFLATERAW:
              this.err = zlib_deflate.deflateInit2(this.strm, this.level, exports.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
              break;
            case exports.INFLATE:
            case exports.GUNZIP:
            case exports.INFLATERAW:
            case exports.UNZIP:
              this.err = zlib_inflate.inflateInit2(this.strm, this.windowBits);
              break;
            default:
              throw new Error(`Unknown mode ${this.mode}`);
          }

          if (this.err !== exports.Z_OK) {
            this._error('Init error');
          }

          this.dictionary = dictionary;

          this.write_in_progress = false;
          this.init_done = true;
        };

        Zlib.prototype._setDictionary = function () {
          if (this.dictionary == null) {
            return;
          }

          this.err = exports.Z_OK;

          switch (this.mode) {
            case exports.DEFLATE:
            case exports.DEFLATERAW:
              this.err = zlib_deflate.deflateSetDictionary(this.strm, this.dictionary);
              break;
            default:
              break;
          }

          if (this.err !== exports.Z_OK) {
            this._error('Failed to set dictionary');
          }
        };

        Zlib.prototype._reset = function () {
          this.err = exports.Z_OK;

          switch (this.mode) {
            case exports.DEFLATE:
            case exports.DEFLATERAW:
            case exports.GZIP:
              this.err = zlib_deflate.deflateReset(this.strm);
              break;
            case exports.INFLATE:
            case exports.INFLATERAW:
            case exports.GUNZIP:
              this.err = zlib_inflate.inflateReset(this.strm);
              break;
            default:
              break;
          }

          if (this.err !== exports.Z_OK) {
            this._error('Failed to reset stream');
          }
        };

        exports.Zlib = Zlib;
        /***/ }),

      /***/ 2635:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        /* provided dependency */ const process = __webpack_require__(4155);

        const { Buffer } = __webpack_require__(8823);
        const { Transform } = __webpack_require__(2830);
        const binding = __webpack_require__(4505);
        const util = __webpack_require__(9539);
        const assert = (__webpack_require__(9282).ok);
        const { kMaxLength } = __webpack_require__(8823);
        const kRangeErrorMessage = `${'Cannot create final Buffer. It would be larger ' + 'than 0x'}${kMaxLength.toString(16)} bytes`;

        // zlib doesn't provide these, so kludge them in following the same
        // const naming scheme zlib uses.
        binding.Z_MIN_WINDOWBITS = 8;
        binding.Z_MAX_WINDOWBITS = 15;
        binding.Z_DEFAULT_WINDOWBITS = 15;

        // fewer than 64 bytes per chunk is stupid.
        // technically it could work with as few as 8, but even 64 bytes
        // is absurdly low.  Usually a MB or more is best.
        binding.Z_MIN_CHUNK = 64;
        binding.Z_MAX_CHUNK = Infinity;
        binding.Z_DEFAULT_CHUNK = 16 * 1024;

        binding.Z_MIN_MEMLEVEL = 1;
        binding.Z_MAX_MEMLEVEL = 9;
        binding.Z_DEFAULT_MEMLEVEL = 8;

        binding.Z_MIN_LEVEL = -1;
        binding.Z_MAX_LEVEL = 9;
        binding.Z_DEFAULT_LEVEL = binding.Z_DEFAULT_COMPRESSION;

        // expose all the zlib constants
        const bkeys = Object.keys(binding);
        for (let bk = 0; bk < bkeys.length; bk++) {
          const bkey = bkeys[bk];
          if (bkey.match(/^Z/)) {
            Object.defineProperty(exports, bkey, {
              enumerable: true, value: binding[bkey], writable: false,
            });
          }
        }

        // translation table for return codes.
        const codes = {
          Z_OK: binding.Z_OK,
          Z_STREAM_END: binding.Z_STREAM_END,
          Z_NEED_DICT: binding.Z_NEED_DICT,
          Z_ERRNO: binding.Z_ERRNO,
          Z_STREAM_ERROR: binding.Z_STREAM_ERROR,
          Z_DATA_ERROR: binding.Z_DATA_ERROR,
          Z_MEM_ERROR: binding.Z_MEM_ERROR,
          Z_BUF_ERROR: binding.Z_BUF_ERROR,
          Z_VERSION_ERROR: binding.Z_VERSION_ERROR,
        };

        const ckeys = Object.keys(codes);
        for (let ck = 0; ck < ckeys.length; ck++) {
          const ckey = ckeys[ck];
          codes[codes[ckey]] = ckey;
        }

        Object.defineProperty(exports, 'codes', ({
          enumerable: true, value: Object.freeze(codes), writable: false,
        }));

        exports.Deflate = Deflate;
        exports.Inflate = Inflate;
        exports.Gzip = Gzip;
        exports.Gunzip = Gunzip;
        exports.DeflateRaw = DeflateRaw;
        exports.InflateRaw = InflateRaw;
        exports.Unzip = Unzip;

        exports.createDeflate = function (o) {
          return new Deflate(o);
        };

        exports.createInflate = function (o) {
          return new Inflate(o);
        };

        exports.createDeflateRaw = function (o) {
          return new DeflateRaw(o);
        };

        exports.createInflateRaw = function (o) {
          return new InflateRaw(o);
        };

        exports.createGzip = function (o) {
          return new Gzip(o);
        };

        exports.createGunzip = function (o) {
          return new Gunzip(o);
        };

        exports.createUnzip = function (o) {
          return new Unzip(o);
        };

        // Convenience methods.
        // compress/decompress a string or buffer in one step.
        exports.deflate = function (buffer, opts, callback) {
          if (typeof opts === 'function') {
            callback = opts;
            opts = {};
          }
          return zlibBuffer(new Deflate(opts), buffer, callback);
        };

        exports.deflateSync = function (buffer, opts) {
          return zlibBufferSync(new Deflate(opts), buffer);
        };

        exports.gzip = function (buffer, opts, callback) {
          if (typeof opts === 'function') {
            callback = opts;
            opts = {};
          }
          return zlibBuffer(new Gzip(opts), buffer, callback);
        };

        exports.gzipSync = function (buffer, opts) {
          return zlibBufferSync(new Gzip(opts), buffer);
        };

        exports.deflateRaw = function (buffer, opts, callback) {
          if (typeof opts === 'function') {
            callback = opts;
            opts = {};
          }
          return zlibBuffer(new DeflateRaw(opts), buffer, callback);
        };

        exports.deflateRawSync = function (buffer, opts) {
          return zlibBufferSync(new DeflateRaw(opts), buffer);
        };

        exports.unzip = function (buffer, opts, callback) {
          if (typeof opts === 'function') {
            callback = opts;
            opts = {};
          }
          return zlibBuffer(new Unzip(opts), buffer, callback);
        };

        exports.unzipSync = function (buffer, opts) {
          return zlibBufferSync(new Unzip(opts), buffer);
        };

        exports.inflate = function (buffer, opts, callback) {
          if (typeof opts === 'function') {
            callback = opts;
            opts = {};
          }
          return zlibBuffer(new Inflate(opts), buffer, callback);
        };

        exports.inflateSync = function (buffer, opts) {
          return zlibBufferSync(new Inflate(opts), buffer);
        };

        exports.gunzip = function (buffer, opts, callback) {
          if (typeof opts === 'function') {
            callback = opts;
            opts = {};
          }
          return zlibBuffer(new Gunzip(opts), buffer, callback);
        };

        exports.gunzipSync = function (buffer, opts) {
          return zlibBufferSync(new Gunzip(opts), buffer);
        };

        exports.inflateRaw = function (buffer, opts, callback) {
          if (typeof opts === 'function') {
            callback = opts;
            opts = {};
          }
          return zlibBuffer(new InflateRaw(opts), buffer, callback);
        };

        exports.inflateRawSync = function (buffer, opts) {
          return zlibBufferSync(new InflateRaw(opts), buffer);
        };

        function zlibBuffer(engine, buffer, callback) {
          let buffers = [];
          let nread = 0;

          engine.on('error', onError);
          engine.on('end', onEnd);

          engine.end(buffer);
          flow();

          function flow() {
            let chunk;
            while ((chunk = engine.read()) !== null) {
              buffers.push(chunk);
              nread += chunk.length;
            }
            engine.once('readable', flow);
          }

          function onError(err) {
            engine.removeListener('end', onEnd);
            engine.removeListener('readable', flow);
            callback(err);
          }

          function onEnd() {
            let buf;
            let err = null;

            if (nread >= kMaxLength) {
              err = new RangeError(kRangeErrorMessage);
            } else {
              buf = Buffer.concat(buffers, nread);
            }

            buffers = [];
            engine.close();
            callback(err, buf);
          }
        }

        function zlibBufferSync(engine, buffer) {
          if (typeof buffer === 'string') buffer = Buffer.from(buffer);

          if (!Buffer.isBuffer(buffer)) throw new TypeError('Not a string or buffer');

          const flushFlag = engine._finishFlushFlag;

          return engine._processChunk(buffer, flushFlag);
        }

        // generic zlib
        // minimal 2-byte header
        function Deflate(opts) {
          if (!(this instanceof Deflate)) return new Deflate(opts);
          Zlib.call(this, opts, binding.DEFLATE);
        }

        function Inflate(opts) {
          if (!(this instanceof Inflate)) return new Inflate(opts);
          Zlib.call(this, opts, binding.INFLATE);
        }

        // gzip - bigger header, same deflate compression
        function Gzip(opts) {
          if (!(this instanceof Gzip)) return new Gzip(opts);
          Zlib.call(this, opts, binding.GZIP);
        }

        function Gunzip(opts) {
          if (!(this instanceof Gunzip)) return new Gunzip(opts);
          Zlib.call(this, opts, binding.GUNZIP);
        }

        // raw - no header
        function DeflateRaw(opts) {
          if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
          Zlib.call(this, opts, binding.DEFLATERAW);
        }

        function InflateRaw(opts) {
          if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
          Zlib.call(this, opts, binding.INFLATERAW);
        }

        // auto-detect header.
        function Unzip(opts) {
          if (!(this instanceof Unzip)) return new Unzip(opts);
          Zlib.call(this, opts, binding.UNZIP);
        }

        function isValidFlushFlag(flag) {
          return flag === binding.Z_NO_FLUSH || flag === binding.Z_PARTIAL_FLUSH || flag === binding.Z_SYNC_FLUSH || flag === binding.Z_FULL_FLUSH || flag === binding.Z_FINISH || flag === binding.Z_BLOCK;
        }

        // the Zlib class they all inherit from
        // This thing manages the queue of requests, and returns
        // true or false if there is anything in the queue when
        // you call the .write() method.

        function Zlib(opts, mode) {
          const _this = this;

          this._opts = opts = opts || {};
          this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;

          Transform.call(this, opts);

          if (opts.flush && !isValidFlushFlag(opts.flush)) {
            throw new Error(`Invalid flush flag: ${opts.flush}`);
          }
          if (opts.finishFlush && !isValidFlushFlag(opts.finishFlush)) {
            throw new Error(`Invalid flush flag: ${opts.finishFlush}`);
          }

          this._flushFlag = opts.flush || binding.Z_NO_FLUSH;
          this._finishFlushFlag = typeof opts.finishFlush !== 'undefined' ? opts.finishFlush : binding.Z_FINISH;

          if (opts.chunkSize) {
            if (opts.chunkSize < exports.Z_MIN_CHUNK || opts.chunkSize > exports.Z_MAX_CHUNK) {
              throw new Error(`Invalid chunk size: ${opts.chunkSize}`);
            }
          }

          if (opts.windowBits) {
            if (opts.windowBits < exports.Z_MIN_WINDOWBITS || opts.windowBits > exports.Z_MAX_WINDOWBITS) {
              throw new Error(`Invalid windowBits: ${opts.windowBits}`);
            }
          }

          if (opts.level) {
            if (opts.level < exports.Z_MIN_LEVEL || opts.level > exports.Z_MAX_LEVEL) {
              throw new Error(`Invalid compression level: ${opts.level}`);
            }
          }

          if (opts.memLevel) {
            if (opts.memLevel < exports.Z_MIN_MEMLEVEL || opts.memLevel > exports.Z_MAX_MEMLEVEL) {
              throw new Error(`Invalid memLevel: ${opts.memLevel}`);
            }
          }

          if (opts.strategy) {
            if (opts.strategy != exports.Z_FILTERED && opts.strategy != exports.Z_HUFFMAN_ONLY && opts.strategy != exports.Z_RLE && opts.strategy != exports.Z_FIXED && opts.strategy != exports.Z_DEFAULT_STRATEGY) {
              throw new Error(`Invalid strategy: ${opts.strategy}`);
            }
          }

          if (opts.dictionary) {
            if (!Buffer.isBuffer(opts.dictionary)) {
              throw new Error('Invalid dictionary: it should be a Buffer instance');
            }
          }

          this._handle = new binding.Zlib(mode);

          const self = this;
          this._hadError = false;
          this._handle.onerror = function (message, errno) {
            // there is no way to cleanly recover.
            // continuing only obscures problems.
            _close(self);
            self._hadError = true;

            const error = new Error(message);
            error.errno = errno;
            error.code = exports.codes[errno];
            self.emit('error', error);
          };

          let level = exports.Z_DEFAULT_COMPRESSION;
          if (typeof opts.level === 'number') level = opts.level;

          let strategy = exports.Z_DEFAULT_STRATEGY;
          if (typeof opts.strategy === 'number') strategy = opts.strategy;

          this._handle.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS, level, opts.memLevel || exports.Z_DEFAULT_MEMLEVEL, strategy, opts.dictionary);

          this._buffer = Buffer.allocUnsafe(this._chunkSize);
          this._offset = 0;
          this._level = level;
          this._strategy = strategy;

          this.once('end', this.close);

          Object.defineProperty(this, '_closed', {
            get() {
              return !_this._handle;
            },
            configurable: true,
            enumerable: true,
          });
        }

        util.inherits(Zlib, Transform);

        Zlib.prototype.params = function (level, strategy, callback) {
          if (level < exports.Z_MIN_LEVEL || level > exports.Z_MAX_LEVEL) {
            throw new RangeError(`Invalid compression level: ${level}`);
          }
          if (strategy != exports.Z_FILTERED && strategy != exports.Z_HUFFMAN_ONLY && strategy != exports.Z_RLE && strategy != exports.Z_FIXED && strategy != exports.Z_DEFAULT_STRATEGY) {
            throw new TypeError(`Invalid strategy: ${strategy}`);
          }

          if (this._level !== level || this._strategy !== strategy) {
            const self = this;
            this.flush(binding.Z_SYNC_FLUSH, () => {
              assert(self._handle, 'zlib binding closed');
              self._handle.params(level, strategy);
              if (!self._hadError) {
                self._level = level;
                self._strategy = strategy;
                if (callback) callback();
              }
            });
          } else {
            process.nextTick(callback);
          }
        };

        Zlib.prototype.reset = function () {
          assert(this._handle, 'zlib binding closed');
          return this._handle.reset();
        };

        // This is the _flush function called by the transform class,
        // internally, when the last chunk has been written.
        Zlib.prototype._flush = function (callback) {
          this._transform(Buffer.alloc(0), '', callback);
        };

        Zlib.prototype.flush = function (kind, callback) {
          const _this2 = this;

          const ws = this._writableState;

          if (typeof kind === 'function' || kind === undefined && !callback) {
            callback = kind;
            kind = binding.Z_FULL_FLUSH;
          }

          if (ws.ended) {
            if (callback) process.nextTick(callback);
          } else if (ws.ending) {
            if (callback) this.once('end', callback);
          } else if (ws.needDrain) {
            if (callback) {
              this.once('drain', () => _this2.flush(kind, callback));
            }
          } else {
            this._flushFlag = kind;
            this.write(Buffer.alloc(0), '', callback);
          }
        };

        Zlib.prototype.close = function (callback) {
          _close(this, callback);
          process.nextTick(emitCloseNT, this);
        };

        function _close(engine, callback) {
          if (callback) process.nextTick(callback);

          // Caller may invoke .close after a zlib error (which will null _handle).
          if (!engine._handle) return;

          engine._handle.close();
          engine._handle = null;
        }

        function emitCloseNT(self) {
          self.emit('close');
        }

        Zlib.prototype._transform = function (chunk, encoding, cb) {
          let flushFlag;
          const ws = this._writableState;
          const ending = ws.ending || ws.ended;
          const last = ending && (!chunk || ws.length === chunk.length);

          if (chunk !== null && !Buffer.isBuffer(chunk)) return cb(new Error('invalid input'));

          if (!this._handle) return cb(new Error('zlib binding closed'));

          // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag
          // (or whatever flag was provided using opts.finishFlush).
          // If it's explicitly flushing at some other time, then we use
          // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
          // goodness.
          if (last) flushFlag = this._finishFlushFlag; else {
            flushFlag = this._flushFlag;
            // once we've flushed the last of the queue, stop flushing and
            // go back to the normal behavior.
            if (chunk.length >= ws.length) {
              this._flushFlag = this._opts.flush || binding.Z_NO_FLUSH;
            }
          }

          this._processChunk(chunk, flushFlag, cb);
        };

        Zlib.prototype._processChunk = function (chunk, flushFlag, cb) {
          let availInBefore = chunk && chunk.length;
          let availOutBefore = this._chunkSize - this._offset;
          let inOff = 0;

          const self = this;

          const async = typeof cb === 'function';

          if (!async) {
            var buffers = [];
            var nread = 0;

            let error;
            this.on('error', (er) => {
              error = er;
            });

            assert(this._handle, 'zlib binding closed');
            do {
              var res = this._handle.writeSync(flushFlag, chunk, // in
                inOff, // in_off
                availInBefore, // in_len
                this._buffer, // out
                this._offset, // out_off
                availOutBefore); // out_len
            } while (!this._hadError && callback(res[0], res[1]));

            if (this._hadError) {
              throw error;
            }

            if (nread >= kMaxLength) {
              _close(this);
              throw new RangeError(kRangeErrorMessage);
            }

            const buf = Buffer.concat(buffers, nread);
            _close(this);

            return buf;
          }

          assert(this._handle, 'zlib binding closed');
          const req = this._handle.write(flushFlag, chunk, // in
            inOff, // in_off
            availInBefore, // in_len
            this._buffer, // out
            this._offset, // out_off
            availOutBefore); // out_len

          req.buffer = chunk;
          req.callback = callback;

          function callback(availInAfter, availOutAfter) {
            // When the callback is used in an async write, the callback's
            // context is the `req` object that was created. The req object
            // is === this._handle, and that's why it's important to null
            // out the values after they are done being used. `this._handle`
            // can stay in memory longer than the callback and buffer are needed.
            if (this) {
              this.buffer = null;
              this.callback = null;
            }

            if (self._hadError) return;

            const have = availOutBefore - availOutAfter;
            assert(have >= 0, 'have should not go down');

            if (have > 0) {
              const out = self._buffer.slice(self._offset, self._offset + have);
              self._offset += have;
              // serve some output to the consumer.
              if (async) {
                self.push(out);
              } else {
                buffers.push(out);
                nread += out.length;
              }
            }

            // exhausted the output buffer, or used all the input create a new one.
            if (availOutAfter === 0 || self._offset >= self._chunkSize) {
              availOutBefore = self._chunkSize;
              self._offset = 0;
              self._buffer = Buffer.allocUnsafe(self._chunkSize);
            }

            if (availOutAfter === 0) {
              // Not actually done.  Need to reprocess.
              // Also, update the availInBefore to the availInAfter value,
              // so that if we have to hit it a third (fourth, etc.) time,
              // it'll have the correct byte counts.
              inOff += availInBefore - availInAfter;
              availInBefore = availInAfter;

              if (!async) return true;

              const newReq = self._handle.write(flushFlag, chunk, inOff, availInBefore, self._buffer, self._offset, self._chunkSize);
              newReq.callback = callback; // this same function
              newReq.buffer = chunk;
              return;
            }

            if (!async) return false;

            // finished with the chunk.
            cb();
          }
        };

        util.inherits(Deflate, Zlib);
        util.inherits(Inflate, Zlib);
        util.inherits(Gzip, Zlib);
        util.inherits(Gunzip, Zlib);
        util.inherits(DeflateRaw, Zlib);
        util.inherits(InflateRaw, Zlib);
        util.inherits(Unzip, Zlib);
        /***/ }),

      /***/ 6907:
      /***/ (function (__unused_webpack_module, exports) {
        const TYPED_OK = (typeof Uint8Array !== 'undefined')
                && (typeof Uint16Array !== 'undefined')
                && (typeof Int32Array !== 'undefined');

        function _has(obj, key) {
          return Object.prototype.hasOwnProperty.call(obj, key);
        }

        exports.assign = function (obj /* from1, from2, from3, ... */) {
          const sources = Array.prototype.slice.call(arguments, 1);
          while (sources.length) {
            const source = sources.shift();
            if (!source) { continue; }

            if (typeof source !== 'object') {
              throw new TypeError(`${source}must be non-object`);
            }

            for (const p in source) {
              if (_has(source, p)) {
                obj[p] = source[p];
              }
            }
          }

          return obj;
        };

        // reduce buffer size, avoiding mem copy
        exports.shrinkBuf = function (buf, size) {
          if (buf.length === size) { return buf; }
          if (buf.subarray) { return buf.subarray(0, size); }
          buf.length = size;
          return buf;
        };

        const fnTyped = {
          arraySet(dest, src, src_offs, len, dest_offs) {
            if (src.subarray && dest.subarray) {
              dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
              return;
            }
            // Fallback to ordinary array
            for (let i = 0; i < len; i++) {
              dest[dest_offs + i] = src[src_offs + i];
            }
          },
          // Join array of chunks to single array.
          flattenChunks(chunks) {
            let i; let l; let len; let pos; let chunk; let
              result;

            // calculate data length
            len = 0;
            for (i = 0, l = chunks.length; i < l; i++) {
              len += chunks[i].length;
            }

            // join chunks
            result = new Uint8Array(len);
            pos = 0;
            for (i = 0, l = chunks.length; i < l; i++) {
              chunk = chunks[i];
              result.set(chunk, pos);
              pos += chunk.length;
            }

            return result;
          },
        };

        const fnUntyped = {
          arraySet(dest, src, src_offs, len, dest_offs) {
            for (let i = 0; i < len; i++) {
              dest[dest_offs + i] = src[src_offs + i];
            }
          },
          // Join array of chunks to single array.
          flattenChunks(chunks) {
            return [].concat.apply([], chunks);
          },
        };

        // Enable/Disable typed arrays use, for testing
        //
        exports.setTyped = function (on) {
          if (on) {
            exports.Buf8 = Uint8Array;
            exports.Buf16 = Uint16Array;
            exports.Buf32 = Int32Array;
            exports.assign(exports, fnTyped);
          } else {
            exports.Buf8 = Array;
            exports.Buf16 = Array;
            exports.Buf32 = Array;
            exports.assign(exports, fnUntyped);
          }
        };

        exports.setTyped(TYPED_OK);
        /***/ }),

      /***/ 7575:
      /***/ (function (module) {
        // Note: adler32 takes 12% for level 0 and 2% for level 6.
        // It isn't worth it to make additional optimizations as in original.
        // Small size is preferable.

        // (C) 1995-2013 Jean-loup Gailly and Mark Adler
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.

        function adler32(adler, buf, len, pos) {
          let s1 = (adler & 0xffff) | 0;
          let s2 = ((adler >>> 16) & 0xffff) | 0;
          let n = 0;

          while (len !== 0) {
            // Set limit ~ twice less than 5552, to keep
            // s2 in 31-bits, because we force signed ints.
            // in other case %= will fail.
            n = len > 2000 ? 2000 : len;
            len -= n;

            do {
              s1 = (s1 + buf[pos++]) | 0;
              s2 = (s2 + s1) | 0;
            } while (--n);

            s1 %= 65521;
            s2 %= 65521;
          }

          return (s1 | (s2 << 16)) | 0;
        }

        module.exports = adler32;
        /***/ }),

      /***/ 7162:
      /***/ (function (module) {
        // (C) 1995-2013 Jean-loup Gailly and Mark Adler
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.

        module.exports = {

          /* Allowed flush values; see deflate() and inflate() below for details */
          Z_NO_FLUSH: 0,
          Z_PARTIAL_FLUSH: 1,
          Z_SYNC_FLUSH: 2,
          Z_FULL_FLUSH: 3,
          Z_FINISH: 4,
          Z_BLOCK: 5,
          Z_TREES: 6,

          /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
          Z_OK: 0,
          Z_STREAM_END: 1,
          Z_NEED_DICT: 2,
          Z_ERRNO: -1,
          Z_STREAM_ERROR: -2,
          Z_DATA_ERROR: -3,
          // Z_MEM_ERROR:     -4,
          Z_BUF_ERROR: -5,
          // Z_VERSION_ERROR: -6,

          /* compression levels */
          Z_NO_COMPRESSION: 0,
          Z_BEST_SPEED: 1,
          Z_BEST_COMPRESSION: 9,
          Z_DEFAULT_COMPRESSION: -1,

          Z_FILTERED: 1,
          Z_HUFFMAN_ONLY: 2,
          Z_RLE: 3,
          Z_FIXED: 4,
          Z_DEFAULT_STRATEGY: 0,

          /* Possible values of the data_type field (though see inflate()) */
          Z_BINARY: 0,
          Z_TEXT: 1,
          // Z_ASCII:                1, // = Z_TEXT (deprecated)
          Z_UNKNOWN: 2,

          /* The deflate compression method */
          Z_DEFLATED: 8,
          // Z_NULL:                 null // Use -1 or null inline, depending on var type
        };
        /***/ }),

      /***/ 3415:
      /***/ (function (module) {
        // Note: we can't get significant speed boost here.
        // So write code to minimize size - no pregenerated tables
        // and array tools dependencies.

        // (C) 1995-2013 Jean-loup Gailly and Mark Adler
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.

        // Use ordinary array, since untyped makes no boost here
        function makeTable() {
          let c; const
            table = [];

          for (let n = 0; n < 256; n++) {
            c = n;
            for (let k = 0; k < 8; k++) {
              c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
            }
            table[n] = c;
          }

          return table;
        }

        // Create table on load. Just 255 signed longs. Not a problem.
        const crcTable = makeTable();

        function crc32(crc, buf, len, pos) {
          const t = crcTable;
          const end = pos + len;

          crc ^= -1;

          for (let i = pos; i < end; i++) {
            crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
          }

          return (crc ^ (-1)); // >>> 0;
        }

        module.exports = crc32;
        /***/ }),

      /***/ 2233:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        // (C) 1995-2013 Jean-loup Gailly and Mark Adler
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.

        const utils = __webpack_require__(6907);
        const trees = __webpack_require__(1339);
        const adler32 = __webpack_require__(7575);
        const crc32 = __webpack_require__(3415);
        const msg = __webpack_require__(9364);

        /* Public constants ========================================================== */
        /* =========================================================================== */

        /* Allowed flush values; see deflate() and inflate() below for details */
        const Z_NO_FLUSH = 0;
        const Z_PARTIAL_FLUSH = 1;
        // var Z_SYNC_FLUSH    = 2;
        const Z_FULL_FLUSH = 3;
        const Z_FINISH = 4;
        const Z_BLOCK = 5;
        // var Z_TREES         = 6;

        /* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
        const Z_OK = 0;
        const Z_STREAM_END = 1;
        // var Z_NEED_DICT     = 2;
        // var Z_ERRNO         = -1;
        const Z_STREAM_ERROR = -2;
        const Z_DATA_ERROR = -3;
        // var Z_MEM_ERROR     = -4;
        const Z_BUF_ERROR = -5;
        // var Z_VERSION_ERROR = -6;

        /* compression levels */
        // var Z_NO_COMPRESSION      = 0;
        // var Z_BEST_SPEED          = 1;
        // var Z_BEST_COMPRESSION    = 9;
        const Z_DEFAULT_COMPRESSION = -1;

        const Z_FILTERED = 1;
        const Z_HUFFMAN_ONLY = 2;
        const Z_RLE = 3;
        const Z_FIXED = 4;
        const Z_DEFAULT_STRATEGY = 0;

        /* Possible values of the data_type field (though see inflate()) */
        // var Z_BINARY              = 0;
        // var Z_TEXT                = 1;
        // var Z_ASCII               = 1; // = Z_TEXT
        const Z_UNKNOWN = 2;

        /* The deflate compression method */
        const Z_DEFLATED = 8;

        /*= =========================================================================== */

        const MAX_MEM_LEVEL = 9;
        /* Maximum value for memLevel in deflateInit2 */
        const MAX_WBITS = 15;
        /* 32K LZ77 window */
        const DEF_MEM_LEVEL = 8;

        const LENGTH_CODES = 29;
        /* number of length codes, not counting the special END_BLOCK code */
        const LITERALS = 256;
        /* number of literal bytes 0..255 */
        const L_CODES = LITERALS + 1 + LENGTH_CODES;
        /* number of Literal or Length codes, including the END_BLOCK code */
        const D_CODES = 30;
        /* number of distance codes */
        const BL_CODES = 19;
        /* number of codes used to transfer the bit lengths */
        const HEAP_SIZE = 2 * L_CODES + 1;
        /* maximum heap size */
        const MAX_BITS = 15;
        /* All codes must not exceed MAX_BITS bits */

        const MIN_MATCH = 3;
        const MAX_MATCH = 258;
        const MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

        const PRESET_DICT = 0x20;

        const INIT_STATE = 42;
        const EXTRA_STATE = 69;
        const NAME_STATE = 73;
        const COMMENT_STATE = 91;
        const HCRC_STATE = 103;
        const BUSY_STATE = 113;
        const FINISH_STATE = 666;

        const BS_NEED_MORE = 1; /* block not completed, need more input or more output */
        const BS_BLOCK_DONE = 2; /* block flush performed */
        const BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
        const BS_FINISH_DONE = 4; /* finish done, accept no more input or output */

        const OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

        function err(strm, errorCode) {
          strm.msg = msg[errorCode];
          return errorCode;
        }

        function rank(f) {
          return ((f) << 1) - ((f) > 4 ? 9 : 0);
        }

        function zero(buf) { let len = buf.length; while (--len >= 0) { buf[len] = 0; } }

        /* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */
        function flush_pending(strm) {
          const s = strm.state;

          // _tr_flush_bits(s);
          let len = s.pending;
          if (len > strm.avail_out) {
            len = strm.avail_out;
          }
          if (len === 0) { return; }

          utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
          strm.next_out += len;
          s.pending_out += len;
          strm.total_out += len;
          strm.avail_out -= len;
          s.pending -= len;
          if (s.pending === 0) {
            s.pending_out = 0;
          }
        }

        function flush_block_only(s, last) {
          trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
          s.block_start = s.strstart;
          flush_pending(s.strm);
        }

        function put_byte(s, b) {
          s.pending_buf[s.pending++] = b;
        }

        /* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
        function putShortMSB(s, b) {
          //  put_byte(s, (Byte)(b >> 8));
          //  put_byte(s, (Byte)(b & 0xff));
          s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
          s.pending_buf[s.pending++] = b & 0xff;
        }

        /* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
        function read_buf(strm, buf, start, size) {
          let len = strm.avail_in;

          if (len > size) { len = size; }
          if (len === 0) { return 0; }

          strm.avail_in -= len;

          // zmemcpy(buf, strm->next_in, len);
          utils.arraySet(buf, strm.input, strm.next_in, len, start);
          if (strm.state.wrap === 1) {
            strm.adler = adler32(strm.adler, buf, len, start);
          } else if (strm.state.wrap === 2) {
            strm.adler = crc32(strm.adler, buf, len, start);
          }

          strm.next_in += len;
          strm.total_in += len;

          return len;
        }

        /* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
        function longest_match(s, cur_match) {
          let chain_length = s.max_chain_length; /* max hash chain length */
          let scan = s.strstart; /* current string */
          let match; /* matched string */
          let len; /* length of current match */
          let best_len = s.prev_length; /* best match length so far */
          let { nice_match } = s; /* stop if match long enough */
          const limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD))
            ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/* NIL */;

          const _win = s.window; // shortcut

          const wmask = s.w_mask;
          const { prev } = s;

          /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

          const strend = s.strstart + MAX_MATCH;
          let scan_end1 = _win[scan + best_len - 1];
          let scan_end = _win[scan + best_len];

          /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
          // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

          /* Do not waste too much time if we already have a good match: */
          if (s.prev_length >= s.good_match) {
            chain_length >>= 2;
          }
          /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
          if (nice_match > s.lookahead) { nice_match = s.lookahead; }

          // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

          do {
            // Assert(cur_match < s->strstart, "no future");
            match = cur_match;

            /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

            if (_win[match + best_len] !== scan_end
        || _win[match + best_len - 1] !== scan_end1
        || _win[match] !== _win[scan]
        || _win[++match] !== _win[scan + 1]) {
              continue;
            }

            /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
            scan += 2;
            match++;
            // Assert(*scan == *match, "match[2]?");

            /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
            do {
              /* jshint noempty:false */
            } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match]
             && _win[++scan] === _win[++match] && _win[++scan] === _win[++match]
             && _win[++scan] === _win[++match] && _win[++scan] === _win[++match]
             && _win[++scan] === _win[++match] && _win[++scan] === _win[++match]
             && scan < strend);

            // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

            len = MAX_MATCH - (strend - scan);
            scan = strend - MAX_MATCH;

            if (len > best_len) {
              s.match_start = cur_match;
              best_len = len;
              if (len >= nice_match) {
                break;
              }
              scan_end1 = _win[scan + best_len - 1];
              scan_end = _win[scan + best_len];
            }
          } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

          if (best_len <= s.lookahead) {
            return best_len;
          }
          return s.lookahead;
        }

        /* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
        function fill_window(s) {
          const _w_size = s.w_size;
          let p; let n; let m; let more; let
            str;

          // Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

          do {
            more = s.window_size - s.lookahead - s.strstart;

            // JS ints have 32 bit, block below not needed
            /* Deal with !@#$% 64K limit: */
            // if (sizeof(int) <= 2) {
            //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
            //        more = wsize;
            //
            //  } else if (more == (unsigned)(-1)) {
            //        /* Very unlikely, but possible on 16 bit machine if
            //         * strstart == 0 && lookahead == 1 (input done a byte at time)
            //         */
            //        more--;
            //    }
            // }

            /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
            if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
              utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
              s.match_start -= _w_size;
              s.strstart -= _w_size;
              /* we now have strstart >= MAX_DIST */
              s.block_start -= _w_size;

              /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */

              n = s.hash_size;
              p = n;
              do {
                m = s.head[--p];
                s.head[p] = (m >= _w_size ? m - _w_size : 0);
              } while (--n);

              n = _w_size;
              p = n;
              do {
                m = s.prev[--p];
                s.prev[p] = (m >= _w_size ? m - _w_size : 0);
                /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */
              } while (--n);

              more += _w_size;
            }
            if (s.strm.avail_in === 0) {
              break;
            }

            /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
            // Assert(more >= 2, "more < 2");
            n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
            s.lookahead += n;

            /* Initialize the hash value now that we have some input: */
            if (s.lookahead + s.insert >= MIN_MATCH) {
              str = s.strstart - s.insert;
              s.ins_h = s.window[str];

              /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
              s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
              // #if MIN_MATCH != 3
              //        Call update_hash() MIN_MATCH-3 more times
              // #endif
              while (s.insert) {
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
                s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < MIN_MATCH) {
                  break;
                }
              }
            }
            /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */
          } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

          /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
          //  if (s.high_water < s.window_size) {
          //    var curr = s.strstart + s.lookahead;
          //    var init = 0;
          //
          //    if (s.high_water < curr) {
          //      /* Previous high water mark below current data -- zero WIN_INIT
          //       * bytes or up to end of window, whichever is less.
          //       */
          //      init = s.window_size - curr;
          //      if (init > WIN_INIT)
          //        init = WIN_INIT;
          //      zmemzero(s->window + curr, (unsigned)init);
          //      s->high_water = curr + init;
          //    }
          //    else if (s->high_water < (ulg)curr + WIN_INIT) {
          //      /* High water mark at or above current data, but below current data
          //       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
          //       * to end of window, whichever is less.
          //       */
          //      init = (ulg)curr + WIN_INIT - s->high_water;
          //      if (init > s->window_size - s->high_water)
          //        init = s->window_size - s->high_water;
          //      zmemzero(s->window + s->high_water, (unsigned)init);
          //      s->high_water += init;
          //    }
          //  }
          //
          //  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
          //    "not enough room for search");
        }

        /* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */
        function deflate_stored(s, flush) {
          /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */
          let max_block_size = 0xffff;

          if (max_block_size > s.pending_buf_size - 5) {
            max_block_size = s.pending_buf_size - 5;
          }

          /* Copy as much as possible from input to output: */
          for (;;) {
            /* Fill the window as much as possible: */
            if (s.lookahead <= 1) {
              // Assert(s->strstart < s->w_size+MAX_DIST(s) ||
              //  s->block_start >= (long)s->w_size, "slide too late");
              //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
              //        s.block_start >= s.w_size)) {
              //        throw  new Error("slide too late");
              //      }

              fill_window(s);
              if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
                return BS_NEED_MORE;
              }

              if (s.lookahead === 0) {
                break;
              }
              /* flush the current block */
            }
            // Assert(s->block_start >= 0L, "block gone");
            //    if (s.block_start < 0) throw new Error("block gone");

            s.strstart += s.lookahead;
            s.lookahead = 0;

            /* Emit a stored block if pending_buf will be full: */
            const max_start = s.block_start + max_block_size;

            if (s.strstart === 0 || s.strstart >= max_start) {
              /* strstart == 0 is possible when wraparound on 16-bit machine */
              s.lookahead = s.strstart - max_start;
              s.strstart = max_start;
              /** * FLUSH_BLOCK(s, 0); ** */
              flush_block_only(s, false);
              if (s.strm.avail_out === 0) {
                return BS_NEED_MORE;
              }
              /***/
            }
            /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */
            if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
              /** * FLUSH_BLOCK(s, 0); ** */
              flush_block_only(s, false);
              if (s.strm.avail_out === 0) {
                return BS_NEED_MORE;
              }
              /***/
            }
          }

          s.insert = 0;

          if (flush === Z_FINISH) {
            /** * FLUSH_BLOCK(s, 1); ** */
            flush_block_only(s, true);
            if (s.strm.avail_out === 0) {
              return BS_FINISH_STARTED;
            }
            /***/
            return BS_FINISH_DONE;
          }

          if (s.strstart > s.block_start) {
            /** * FLUSH_BLOCK(s, 0); ** */
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/
          }

          return BS_NEED_MORE;
        }

        /* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
        function deflate_fast(s, flush) {
          let hash_head; /* head of the hash chain */
          let bflush; /* set if current block must be flushed */

          for (;;) {
            /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
            if (s.lookahead < MIN_LOOKAHEAD) {
              fill_window(s);
              if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
                return BS_NEED_MORE;
              }
              if (s.lookahead === 0) {
                break; /* flush the current block */
              }
            }

            /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
            hash_head = 0/* NIL */;
            if (s.lookahead >= MIN_MATCH) {
              /** * INSERT_STRING(s, s.strstart, hash_head); ** */
              s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
              hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
              s.head[s.ins_h] = s.strstart;
              /***/
            }

            /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
            if (hash_head !== 0/* NIL */ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
              /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
              s.match_length = longest_match(s, hash_head);
              /* longest_match() sets match_start */
            }
            if (s.match_length >= MIN_MATCH) {
              // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

              /** * _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ** */
              bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

              s.lookahead -= s.match_length;

              /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
              if (s.match_length <= s.max_lazy_match/* max_insert_length */ && s.lookahead >= MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */
                do {
                  s.strstart++;
                  /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                  s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                  hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                  s.head[s.ins_h] = s.strstart;
                  /***/
                  /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
                } while (--s.match_length !== 0);
                s.strstart++;
              } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
                s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;

                // #if MIN_MATCH != 3
                //                Call UPDATE_HASH() MIN_MATCH-3 more times
                // #endif
                /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
              }
            } else {
              /* No match, output a literal byte */
              // Tracevv((stderr,"%c", s.window[s.strstart]));
              /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
              bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

              s.lookahead--;
              s.strstart++;
            }
            if (bflush) {
              /** * FLUSH_BLOCK(s, 0); ** */
              flush_block_only(s, false);
              if (s.strm.avail_out === 0) {
                return BS_NEED_MORE;
              }
              /***/
            }
          }
          s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
          if (flush === Z_FINISH) {
            /** * FLUSH_BLOCK(s, 1); ** */
            flush_block_only(s, true);
            if (s.strm.avail_out === 0) {
              return BS_FINISH_STARTED;
            }
            /***/
            return BS_FINISH_DONE;
          }
          if (s.last_lit) {
            /** * FLUSH_BLOCK(s, 0); ** */
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/
          }
          return BS_BLOCK_DONE;
        }

        /* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
        function deflate_slow(s, flush) {
          let hash_head; /* head of hash chain */
          let bflush; /* set if current block must be flushed */

          let max_insert;

          /* Process the input block. */
          for (;;) {
            /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
            if (s.lookahead < MIN_LOOKAHEAD) {
              fill_window(s);
              if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
                return BS_NEED_MORE;
              }
              if (s.lookahead === 0) { break; } /* flush the current block */
            }

            /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
            hash_head = 0/* NIL */;
            if (s.lookahead >= MIN_MATCH) {
              /** * INSERT_STRING(s, s.strstart, hash_head); ** */
              s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
              hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
              s.head[s.ins_h] = s.strstart;
              /***/
            }

            /* Find the longest match, discarding those <= prev_length.
     */
            s.prev_length = s.match_length;
            s.prev_match = s.match_start;
            s.match_length = MIN_MATCH - 1;

            if (hash_head !== 0/* NIL */ && s.prev_length < s.max_lazy_match
        && s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/* MAX_DIST(s) */) {
              /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
              s.match_length = longest_match(s, hash_head);
              /* longest_match() sets match_start */

              if (s.match_length <= 5
         && (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/* TOO_FAR */))) {
                /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
                s.match_length = MIN_MATCH - 1;
              }
            }
            /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
            if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
              max_insert = s.strstart + s.lookahead - MIN_MATCH;
              /* Do not insert strings in hash table beyond this. */

              // check_match(s, s.strstart-1, s.prev_match, s.prev_length);

              /** *_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);** */
              bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
              /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
              s.lookahead -= s.prev_length - 1;
              s.prev_length -= 2;
              do {
                if (++s.strstart <= max_insert) {
                  /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                  s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                  hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                  s.head[s.ins_h] = s.strstart;
                  /***/
                }
              } while (--s.prev_length !== 0);
              s.match_available = 0;
              s.match_length = MIN_MATCH - 1;
              s.strstart++;

              if (bflush) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                  return BS_NEED_MORE;
                }
                /***/
              }
            } else if (s.match_available) {
              /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
              // Tracevv((stderr,"%c", s->window[s->strstart-1]));
              /** * _tr_tally_lit(s, s.window[s.strstart-1], bflush); ** */
              bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

              if (bflush) {
                /** * FLUSH_BLOCK_ONLY(s, 0) ** */
                flush_block_only(s, false);
                /***/
              }
              s.strstart++;
              s.lookahead--;
              if (s.strm.avail_out === 0) {
                return BS_NEED_MORE;
              }
            } else {
              /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
              s.match_available = 1;
              s.strstart++;
              s.lookahead--;
            }
          }
          // Assert (flush != Z_NO_FLUSH, "no flush?");
          if (s.match_available) {
            // Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /** * _tr_tally_lit(s, s.window[s.strstart-1], bflush); ** */
            bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

            s.match_available = 0;
          }
          s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
          if (flush === Z_FINISH) {
            /** * FLUSH_BLOCK(s, 1); ** */
            flush_block_only(s, true);
            if (s.strm.avail_out === 0) {
              return BS_FINISH_STARTED;
            }
            /***/
            return BS_FINISH_DONE;
          }
          if (s.last_lit) {
            /** * FLUSH_BLOCK(s, 0); ** */
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/
          }

          return BS_BLOCK_DONE;
        }

        /* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
        function deflate_rle(s, flush) {
          let bflush; /* set if current block must be flushed */
          let prev; /* byte at distance one to match */
          let scan; let
            strend; /* scan goes up to strend for length of run */

          const _win = s.window;

          for (;;) {
            /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
            if (s.lookahead <= MAX_MATCH) {
              fill_window(s);
              if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
                return BS_NEED_MORE;
              }
              if (s.lookahead === 0) { break; } /* flush the current block */
            }

            /* See how many times the previous byte repeats */
            s.match_length = 0;
            if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
              scan = s.strstart - 1;
              prev = _win[scan];
              if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + MAX_MATCH;
                do {
                  /* jshint noempty:false */
                } while (prev === _win[++scan] && prev === _win[++scan]
                 && prev === _win[++scan] && prev === _win[++scan]
                 && prev === _win[++scan] && prev === _win[++scan]
                 && prev === _win[++scan] && prev === _win[++scan]
                 && scan < strend);
                s.match_length = MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) {
                  s.match_length = s.lookahead;
                }
              }
              // Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
            }

            /* Emit match if have run of MIN_MATCH or longer, else emit literal */
            if (s.match_length >= MIN_MATCH) {
              // check_match(s, s.strstart, s.strstart - 1, s.match_length);

              /** * _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ** */
              bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);

              s.lookahead -= s.match_length;
              s.strstart += s.match_length;
              s.match_length = 0;
            } else {
              /* No match, output a literal byte */
              // Tracevv((stderr,"%c", s->window[s->strstart]));
              /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
              bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

              s.lookahead--;
              s.strstart++;
            }
            if (bflush) {
              /** * FLUSH_BLOCK(s, 0); ** */
              flush_block_only(s, false);
              if (s.strm.avail_out === 0) {
                return BS_NEED_MORE;
              }
              /***/
            }
          }
          s.insert = 0;
          if (flush === Z_FINISH) {
            /** * FLUSH_BLOCK(s, 1); ** */
            flush_block_only(s, true);
            if (s.strm.avail_out === 0) {
              return BS_FINISH_STARTED;
            }
            /***/
            return BS_FINISH_DONE;
          }
          if (s.last_lit) {
            /** * FLUSH_BLOCK(s, 0); ** */
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/
          }
          return BS_BLOCK_DONE;
        }

        /* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
        function deflate_huff(s, flush) {
          let bflush; /* set if current block must be flushed */

          for (;;) {
            /* Make sure that we have a literal to write. */
            if (s.lookahead === 0) {
              fill_window(s);
              if (s.lookahead === 0) {
                if (flush === Z_NO_FLUSH) {
                  return BS_NEED_MORE;
                }
                break; /* flush the current block */
              }
            }

            /* Output a literal byte */
            s.match_length = 0;
            // Tracevv((stderr,"%c", s->window[s->strstart]));
            /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
            bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
            if (bflush) {
              /** * FLUSH_BLOCK(s, 0); ** */
              flush_block_only(s, false);
              if (s.strm.avail_out === 0) {
                return BS_NEED_MORE;
              }
              /***/
            }
          }
          s.insert = 0;
          if (flush === Z_FINISH) {
            /** * FLUSH_BLOCK(s, 1); ** */
            flush_block_only(s, true);
            if (s.strm.avail_out === 0) {
              return BS_FINISH_STARTED;
            }
            /***/
            return BS_FINISH_DONE;
          }
          if (s.last_lit) {
            /** * FLUSH_BLOCK(s, 0); ** */
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/
          }
          return BS_BLOCK_DONE;
        }

        /* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
        function Config(good_length, max_lazy, nice_length, max_chain, func) {
          this.good_length = good_length;
          this.max_lazy = max_lazy;
          this.nice_length = nice_length;
          this.max_chain = max_chain;
          this.func = func;
        }

        let configuration_table;

        configuration_table = [
          /*      good lazy nice chain */
          new Config(0, 0, 0, 0, deflate_stored), /* 0 store only */
          new Config(4, 4, 8, 4, deflate_fast), /* 1 max speed, no lazy matches */
          new Config(4, 5, 16, 8, deflate_fast), /* 2 */
          new Config(4, 6, 32, 32, deflate_fast), /* 3 */

          new Config(4, 4, 16, 16, deflate_slow), /* 4 lazy matches */
          new Config(8, 16, 32, 32, deflate_slow), /* 5 */
          new Config(8, 16, 128, 128, deflate_slow), /* 6 */
          new Config(8, 32, 128, 256, deflate_slow), /* 7 */
          new Config(32, 128, 258, 1024, deflate_slow), /* 8 */
          new Config(32, 258, 258, 4096, deflate_slow), /* 9 max compression */
        ];

        /* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
        function lm_init(s) {
          s.window_size = 2 * s.w_size;

          /** * CLEAR_HASH(s); ** */
          zero(s.head); // Fill with NIL (= 0);

          /* Set the default configuration parameters:
   */
          s.max_lazy_match = configuration_table[s.level].max_lazy;
          s.good_match = configuration_table[s.level].good_length;
          s.nice_match = configuration_table[s.level].nice_length;
          s.max_chain_length = configuration_table[s.level].max_chain;

          s.strstart = 0;
          s.block_start = 0;
          s.lookahead = 0;
          s.insert = 0;
          s.match_length = s.prev_length = MIN_MATCH - 1;
          s.match_available = 0;
          s.ins_h = 0;
        }

        function DeflateState() {
          this.strm = null; /* pointer back to this zlib stream */
          this.status = 0; /* as the name implies */
          this.pending_buf = null; /* output still pending */
          this.pending_buf_size = 0; /* size of pending_buf */
          this.pending_out = 0; /* next pending byte to output to the stream */
          this.pending = 0; /* nb of bytes in the pending buffer */
          this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */
          this.gzhead = null; /* gzip header information to write */
          this.gzindex = 0; /* where in extra, name, or comment */
          this.method = Z_DEFLATED; /* can only be DEFLATED */
          this.last_flush = -1; /* value of flush param for previous deflate call */

          this.w_size = 0; /* LZ77 window size (32K by default) */
          this.w_bits = 0; /* log2(w_size)  (8..16) */
          this.w_mask = 0; /* w_size - 1 */

          this.window = null;
          /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

          this.window_size = 0;
          /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

          this.prev = null;
          /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

          this.head = null; /* Heads of the hash chains or NIL. */

          this.ins_h = 0; /* hash index of string to be inserted */
          this.hash_size = 0; /* number of elements in hash table */
          this.hash_bits = 0; /* log2(hash_size) */
          this.hash_mask = 0; /* hash_size-1 */

          this.hash_shift = 0;
          /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

          this.block_start = 0;
          /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

          this.match_length = 0; /* length of best match */
          this.prev_match = 0; /* previous match */
          this.match_available = 0; /* set if previous match exists */
          this.strstart = 0; /* start of string to insert */
          this.match_start = 0; /* start of matching string */
          this.lookahead = 0; /* number of valid bytes ahead in window */

          this.prev_length = 0;
          /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

          this.max_chain_length = 0;
          /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

          this.max_lazy_match = 0;
          /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
          // That's alias to max_lazy_match, don't use directly
          // this.max_insert_length = 0;
          /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

          this.level = 0; /* compression level (1..9) */
          this.strategy = 0; /* favor or force Huffman coding */

          this.good_match = 0;
          /* Use a faster search when the previous match is longer than this */

          this.nice_match = 0; /* Stop searching when current match exceeds this */

          /* used by trees.c: */

          /* Didn't use ct_data typedef below to suppress compiler warning */

          // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
          // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
          // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

          // Use flat array of DOUBLE size, with interleaved fata,
          // because JS does not support effective
          this.dyn_ltree = new utils.Buf16(HEAP_SIZE * 2);
          this.dyn_dtree = new utils.Buf16((2 * D_CODES + 1) * 2);
          this.bl_tree = new utils.Buf16((2 * BL_CODES + 1) * 2);
          zero(this.dyn_ltree);
          zero(this.dyn_dtree);
          zero(this.bl_tree);

          this.l_desc = null; /* desc. for literal tree */
          this.d_desc = null; /* desc. for distance tree */
          this.bl_desc = null; /* desc. for bit length tree */

          // ush bl_count[MAX_BITS+1];
          this.bl_count = new utils.Buf16(MAX_BITS + 1);
          /* number of codes at each bit length for an optimal tree */

          // int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
          this.heap = new utils.Buf16(2 * L_CODES + 1); /* heap used to build the Huffman trees */
          zero(this.heap);

          this.heap_len = 0; /* number of elements in the heap */
          this.heap_max = 0; /* element of largest frequency */
          /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

          this.depth = new utils.Buf16(2 * L_CODES + 1); // uch depth[2*L_CODES+1];
          zero(this.depth);
          /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

          this.l_buf = 0; /* buffer index for literals or lengths */

          this.lit_bufsize = 0;
          /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

          this.last_lit = 0; /* running index in l_buf */

          this.d_buf = 0;
          /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */

          this.opt_len = 0; /* bit length of current block with optimal trees */
          this.static_len = 0; /* bit length of current block with static trees */
          this.matches = 0; /* number of string matches in current block */
          this.insert = 0; /* bytes at end of window left to insert */

          this.bi_buf = 0;
          /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
          this.bi_valid = 0;
          /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

          // Used for window memory init. We safely ignore it for JS. That makes
          // sense only for pointers and memory check tools.
          // this.high_water = 0;
          /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
        }

        function deflateResetKeep(strm) {
          let s;

          if (!strm || !strm.state) {
            return err(strm, Z_STREAM_ERROR);
          }

          strm.total_in = strm.total_out = 0;
          strm.data_type = Z_UNKNOWN;

          s = strm.state;
          s.pending = 0;
          s.pending_out = 0;

          if (s.wrap < 0) {
            s.wrap = -s.wrap;
            /* was made negative by deflate(..., Z_FINISH); */
          }
          s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
          strm.adler = (s.wrap === 2)
            ? 0 // crc32(0, Z_NULL, 0)
            : 1; // adler32(0, Z_NULL, 0)
          s.last_flush = Z_NO_FLUSH;
          trees._tr_init(s);
          return Z_OK;
        }

        function deflateReset(strm) {
          const ret = deflateResetKeep(strm);
          if (ret === Z_OK) {
            lm_init(strm.state);
          }
          return ret;
        }

        function deflateSetHeader(strm, head) {
          if (!strm || !strm.state) { return Z_STREAM_ERROR; }
          if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
          strm.state.gzhead = head;
          return Z_OK;
        }

        function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
          if (!strm) { // === Z_NULL
            return Z_STREAM_ERROR;
          }
          let wrap = 1;

          if (level === Z_DEFAULT_COMPRESSION) {
            level = 6;
          }

          if (windowBits < 0) { /* suppress zlib wrapper */
            wrap = 0;
            windowBits = -windowBits;
          } else if (windowBits > 15) {
            wrap = 2; /* write gzip wrapper instead */
            windowBits -= 16;
          }

          if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED
    || windowBits < 8 || windowBits > 15 || level < 0 || level > 9
    || strategy < 0 || strategy > Z_FIXED) {
            return err(strm, Z_STREAM_ERROR);
          }

          if (windowBits === 8) {
            windowBits = 9;
          }
          /* until 256-byte window bug fixed */

          const s = new DeflateState();

          strm.state = s;
          s.strm = strm;

          s.wrap = wrap;
          s.gzhead = null;
          s.w_bits = windowBits;
          s.w_size = 1 << s.w_bits;
          s.w_mask = s.w_size - 1;

          s.hash_bits = memLevel + 7;
          s.hash_size = 1 << s.hash_bits;
          s.hash_mask = s.hash_size - 1;
          s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

          s.window = new utils.Buf8(s.w_size * 2);
          s.head = new utils.Buf16(s.hash_size);
          s.prev = new utils.Buf16(s.w_size);

          // Don't need mem init magic for JS.
          // s.high_water = 0;  /* nothing written to s->window yet */

          s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

          s.pending_buf_size = s.lit_bufsize * 4;

          // overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
          // s->pending_buf = (uchf *) overlay;
          s.pending_buf = new utils.Buf8(s.pending_buf_size);

          // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
          // s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
          s.d_buf = 1 * s.lit_bufsize;

          // s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
          s.l_buf = (1 + 2) * s.lit_bufsize;

          s.level = level;
          s.strategy = strategy;
          s.method = method;

          return deflateReset(strm);
        }

        function deflateInit(strm, level) {
          return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
        }

        function deflate(strm, flush) {
          let old_flush; let
            s;
          let beg; let
            val; // for gzip header write only

          if (!strm || !strm.state
    || flush > Z_BLOCK || flush < 0) {
            return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
          }

          s = strm.state;

          if (!strm.output
      || (!strm.input && strm.avail_in !== 0)
      || (s.status === FINISH_STATE && flush !== Z_FINISH)) {
            return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
          }

          s.strm = strm; /* just in case */
          old_flush = s.last_flush;
          s.last_flush = flush;

          /* Write the header */
          if (s.status === INIT_STATE) {
            if (s.wrap === 2) { // GZIP header
              strm.adler = 0; // crc32(0L, Z_NULL, 0);
              put_byte(s, 31);
              put_byte(s, 139);
              put_byte(s, 8);
              if (!s.gzhead) { // s->gzhead == Z_NULL
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, s.level === 9 ? 2
                  : (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2
                    ? 4 : 0));
                put_byte(s, OS_CODE);
                s.status = BUSY_STATE;
              } else {
                put_byte(s, (s.gzhead.text ? 1 : 0)
                    + (s.gzhead.hcrc ? 2 : 0)
                    + (!s.gzhead.extra ? 0 : 4)
                    + (!s.gzhead.name ? 0 : 8)
                    + (!s.gzhead.comment ? 0 : 16));
                put_byte(s, s.gzhead.time & 0xff);
                put_byte(s, (s.gzhead.time >> 8) & 0xff);
                put_byte(s, (s.gzhead.time >> 16) & 0xff);
                put_byte(s, (s.gzhead.time >> 24) & 0xff);
                put_byte(s, s.level === 9 ? 2
                  : (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2
                    ? 4 : 0));
                put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                  put_byte(s, s.gzhead.extra.length & 0xff);
                  put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
                }
                if (s.gzhead.hcrc) {
                  strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
                }
                s.gzindex = 0;
                s.status = EXTRA_STATE;
              }
            } else // DEFLATE header
            {
              let header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
              let level_flags = -1;

              if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
                level_flags = 0;
              } else if (s.level < 6) {
                level_flags = 1;
              } else if (s.level === 6) {
                level_flags = 2;
              } else {
                level_flags = 3;
              }
              header |= (level_flags << 6);
              if (s.strstart !== 0) { header |= PRESET_DICT; }
              header += 31 - (header % 31);

              s.status = BUSY_STATE;
              putShortMSB(s, header);

              /* Save the adler32 of the preset dictionary: */
              if (s.strstart !== 0) {
                putShortMSB(s, strm.adler >>> 16);
                putShortMSB(s, strm.adler & 0xffff);
              }
              strm.adler = 1; // adler32(0L, Z_NULL, 0);
            }
          }

          // #ifdef GZIP
          if (s.status === EXTRA_STATE) {
            if (s.gzhead.extra/* != Z_NULL */) {
              beg = s.pending; /* start of bytes to update crc */

              while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
                if (s.pending === s.pending_buf_size) {
                  if (s.gzhead.hcrc && s.pending > beg) {
                    strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                  }
                  flush_pending(strm);
                  beg = s.pending;
                  if (s.pending === s.pending_buf_size) {
                    break;
                  }
                }
                put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
              }
              if (s.gzhead.hcrc && s.pending > beg) {
                strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
              }
              if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = NAME_STATE;
              }
            } else {
              s.status = NAME_STATE;
            }
          }
          if (s.status === NAME_STATE) {
            if (s.gzhead.name/* != Z_NULL */) {
              beg = s.pending; /* start of bytes to update crc */
              // int val;

              do {
                if (s.pending === s.pending_buf_size) {
                  if (s.gzhead.hcrc && s.pending > beg) {
                    strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                  }
                  flush_pending(strm);
                  beg = s.pending;
                  if (s.pending === s.pending_buf_size) {
                    val = 1;
                    break;
                  }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) {
                  val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                } else {
                  val = 0;
                }
                put_byte(s, val);
              } while (val !== 0);

              if (s.gzhead.hcrc && s.pending > beg) {
                strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
              }
              if (val === 0) {
                s.gzindex = 0;
                s.status = COMMENT_STATE;
              }
            } else {
              s.status = COMMENT_STATE;
            }
          }
          if (s.status === COMMENT_STATE) {
            if (s.gzhead.comment/* != Z_NULL */) {
              beg = s.pending; /* start of bytes to update crc */
              // int val;

              do {
                if (s.pending === s.pending_buf_size) {
                  if (s.gzhead.hcrc && s.pending > beg) {
                    strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                  }
                  flush_pending(strm);
                  beg = s.pending;
                  if (s.pending === s.pending_buf_size) {
                    val = 1;
                    break;
                  }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) {
                  val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                } else {
                  val = 0;
                }
                put_byte(s, val);
              } while (val !== 0);

              if (s.gzhead.hcrc && s.pending > beg) {
                strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
              }
              if (val === 0) {
                s.status = HCRC_STATE;
              }
            } else {
              s.status = HCRC_STATE;
            }
          }
          if (s.status === HCRC_STATE) {
            if (s.gzhead.hcrc) {
              if (s.pending + 2 > s.pending_buf_size) {
                flush_pending(strm);
              }
              if (s.pending + 2 <= s.pending_buf_size) {
                put_byte(s, strm.adler & 0xff);
                put_byte(s, (strm.adler >> 8) & 0xff);
                strm.adler = 0; // crc32(0L, Z_NULL, 0);
                s.status = BUSY_STATE;
              }
            } else {
              s.status = BUSY_STATE;
            }
          }
          // #endif

          /* Flush as much pending output as possible */
          if (s.pending !== 0) {
            flush_pending(strm);
            if (strm.avail_out === 0) {
              /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
              s.last_flush = -1;
              return Z_OK;
            }

            /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
          } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush)
    && flush !== Z_FINISH) {
            return err(strm, Z_BUF_ERROR);
          }

          /* User must not provide more input after the first FINISH: */
          if (s.status === FINISH_STATE && strm.avail_in !== 0) {
            return err(strm, Z_BUF_ERROR);
          }

          /* Start a new block or continue the current one.
   */
          if (strm.avail_in !== 0 || s.lookahead !== 0
    || (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
            const bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush)
              : (s.strategy === Z_RLE ? deflate_rle(s, flush)
                : configuration_table[s.level].func(s, flush));

            if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
              s.status = FINISH_STATE;
            }
            if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
              if (strm.avail_out === 0) {
                s.last_flush = -1;
                /* avoid BUF_ERROR next call, see above */
              }
              return Z_OK;
              /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
            }
            if (bstate === BS_BLOCK_DONE) {
              if (flush === Z_PARTIAL_FLUSH) {
                trees._tr_align(s);
              } else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */
                trees._tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
                if (flush === Z_FULL_FLUSH) {
                  /** * CLEAR_HASH(s); ** */ /* forget history */
                  zero(s.head); // Fill with NIL (= 0);

                  if (s.lookahead === 0) {
                    s.strstart = 0;
                    s.block_start = 0;
                    s.insert = 0;
                  }
                }
              }
              flush_pending(strm);
              if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
                return Z_OK;
              }
            }
          }
          // Assert(strm->avail_out > 0, "bug2");
          // if (strm.avail_out <= 0) { throw new Error("bug2");}

          if (flush !== Z_FINISH) { return Z_OK; }
          if (s.wrap <= 0) { return Z_STREAM_END; }

          /* Write the trailer */
          if (s.wrap === 2) {
            put_byte(s, strm.adler & 0xff);
            put_byte(s, (strm.adler >> 8) & 0xff);
            put_byte(s, (strm.adler >> 16) & 0xff);
            put_byte(s, (strm.adler >> 24) & 0xff);
            put_byte(s, strm.total_in & 0xff);
            put_byte(s, (strm.total_in >> 8) & 0xff);
            put_byte(s, (strm.total_in >> 16) & 0xff);
            put_byte(s, (strm.total_in >> 24) & 0xff);
          } else {
            putShortMSB(s, strm.adler >>> 16);
            putShortMSB(s, strm.adler & 0xffff);
          }

          flush_pending(strm);
          /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
          if (s.wrap > 0) { s.wrap = -s.wrap; }
          /* write the trailer only once! */
          return s.pending !== 0 ? Z_OK : Z_STREAM_END;
        }

        function deflateEnd(strm) {
          let status;

          if (!strm/*= = Z_NULL */ || !strm.state/*= = Z_NULL */) {
            return Z_STREAM_ERROR;
          }

          status = strm.state.status;
          if (status !== INIT_STATE
    && status !== EXTRA_STATE
    && status !== NAME_STATE
    && status !== COMMENT_STATE
    && status !== HCRC_STATE
    && status !== BUSY_STATE
    && status !== FINISH_STATE
          ) {
            return err(strm, Z_STREAM_ERROR);
          }

          strm.state = null;

          return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
        }

        /* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */
        function deflateSetDictionary(strm, dictionary) {
          let dictLength = dictionary.length;

          let s;
          let str; let
            n;
          let wrap;
          let avail;
          let next;
          let input;
          let tmpDict;

          if (!strm/*= = Z_NULL */ || !strm.state/*= = Z_NULL */) {
            return Z_STREAM_ERROR;
          }

          s = strm.state;
          wrap = s.wrap;

          if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
            return Z_STREAM_ERROR;
          }

          /* when using zlib wrappers, compute Adler-32 for provided dictionary */
          if (wrap === 1) {
            /* adler32(strm->adler, dictionary, dictLength); */
            strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
          }

          s.wrap = 0; /* avoid computing Adler-32 in read_buf */

          /* if dictionary would fill window, just replace the history */
          if (dictLength >= s.w_size) {
            if (wrap === 0) { /* already empty otherwise */
              /** * CLEAR_HASH(s); ** */
              zero(s.head); // Fill with NIL (= 0);
              s.strstart = 0;
              s.block_start = 0;
              s.insert = 0;
            }
            /* use the tail */
            // dictionary = dictionary.slice(dictLength - s.w_size);
            tmpDict = new utils.Buf8(s.w_size);
            utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
            dictionary = tmpDict;
            dictLength = s.w_size;
          }
          /* insert dictionary into window and hash */
          avail = strm.avail_in;
          next = strm.next_in;
          input = strm.input;
          strm.avail_in = dictLength;
          strm.next_in = 0;
          strm.input = dictionary;
          fill_window(s);
          while (s.lookahead >= MIN_MATCH) {
            str = s.strstart;
            n = s.lookahead - (MIN_MATCH - 1);
            do {
              /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
              s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

              s.prev[str & s.w_mask] = s.head[s.ins_h];

              s.head[s.ins_h] = str;
              str++;
            } while (--n);
            s.strstart = str;
            s.lookahead = MIN_MATCH - 1;
            fill_window(s);
          }
          s.strstart += s.lookahead;
          s.block_start = s.strstart;
          s.insert = s.lookahead;
          s.lookahead = 0;
          s.match_length = s.prev_length = MIN_MATCH - 1;
          s.match_available = 0;
          strm.next_in = next;
          strm.input = input;
          strm.avail_in = avail;
          s.wrap = wrap;
          return Z_OK;
        }

        exports.deflateInit = deflateInit;
        exports.deflateInit2 = deflateInit2;
        exports.deflateReset = deflateReset;
        exports.deflateResetKeep = deflateResetKeep;
        exports.deflateSetHeader = deflateSetHeader;
        exports.deflate = deflate;
        exports.deflateEnd = deflateEnd;
        exports.deflateSetDictionary = deflateSetDictionary;
        exports.deflateInfo = 'pako deflate (from Nodeca project)';

        /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/
        /***/ }),

      /***/ 6438:
      /***/ (function (module) {
        // (C) 1995-2013 Jean-loup Gailly and Mark Adler
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.

        // See state defs from inflate.js
        const BAD = 30; /* got a data error -- remain here until reset */
        const TYPE = 12; /* i: waiting for type bits, including last-flag bit */

        /*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */
        module.exports = function inflate_fast(strm, start) {
          let state;
          let _in; /* local strm.input */
          let last; /* have enough input while in < last */
          let _out; /* local strm.output */
          let beg; /* inflate()'s initial strm.output */
          let end; /* while out < end, enough space available */
          // #ifdef INFLATE_STRICT
          let dmax; /* maximum distance from zlib header */
          // #endif
          let wsize; /* window size or zero if not using window */
          let whave; /* valid bytes in the window */
          let wnext; /* window write index */
          // Use `s_window` instead `window`, avoid conflict with instrumentation tools
          let s_window; /* allocated sliding window, if wsize != 0 */
          let hold; /* local strm.hold */
          let bits; /* local strm.bits */
          let lcode; /* local strm.lencode */
          let dcode; /* local strm.distcode */
          let lmask; /* mask for first level of length codes */
          let dmask; /* mask for first level of distance codes */
          let here; /* retrieved table entry */
          let op; /* code bits, operation, extra bits, or */
          /*  window position, window bytes to copy */
          let len; /* match length, unused bytes */
          let dist; /* match distance */
          let from; /* where to copy match from */
          let from_source;

          let input; let
            output; // JS specific, because we have no pointers

          /* copy state to local variables */
          state = strm.state;
          // here = state.here;
          _in = strm.next_in;
          input = strm.input;
          last = _in + (strm.avail_in - 5);
          _out = strm.next_out;
          output = strm.output;
          beg = _out - (start - strm.avail_out);
          end = _out + (strm.avail_out - 257);
          // #ifdef INFLATE_STRICT
          dmax = state.dmax;
          // #endif
          wsize = state.wsize;
          whave = state.whave;
          wnext = state.wnext;
          s_window = state.window;
          hold = state.hold;
          bits = state.bits;
          lcode = state.lencode;
          dcode = state.distcode;
          lmask = (1 << state.lenbits) - 1;
          dmask = (1 << state.distbits) - 1;

          /* decode literals and length/distances until end-of-block or not enough
     input data or output space */

          top:
          do {
            if (bits < 15) {
              hold += input[_in++] << bits;
              bits += 8;
              hold += input[_in++] << bits;
              bits += 8;
            }

            here = lcode[hold & lmask];

            for (;;) { // Goto emulation
              op = here >>> 24/* here.bits */;
              hold >>>= op;
              bits -= op;
              op = (here >>> 16) & 0xff/* here.op */;
              if (op === 0) { /* literal */
                // Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                output[_out++] = here & 0xffff/* here.val */;
              } else if (op & 16) { /* length base */
                len = here & 0xffff/* here.val */;
                op &= 15; /* number of extra bits */
                if (op) {
                  if (bits < op) {
                    hold += input[_in++] << bits;
                    bits += 8;
                  }
                  len += hold & ((1 << op) - 1);
                  hold >>>= op;
                  bits -= op;
                }
                // Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                  hold += input[_in++] << bits;
                  bits += 8;
                  hold += input[_in++] << bits;
                  bits += 8;
                }
                here = dcode[hold & dmask];

                for (;;) { // goto emulation
                  op = here >>> 24/* here.bits */;
                  hold >>>= op;
                  bits -= op;
                  op = (here >>> 16) & 0xff/* here.op */;

                  if (op & 16) { /* distance base */
                    dist = here & 0xffff/* here.val */;
                    op &= 15; /* number of extra bits */
                    if (bits < op) {
                      hold += input[_in++] << bits;
                      bits += 8;
                      if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                      }
                    }
                    dist += hold & ((1 << op) - 1);
                    // #ifdef INFLATE_STRICT
                    if (dist > dmax) {
                      strm.msg = 'invalid distance too far back';
                      state.mode = BAD;
                      break top;
                    }
                    // #endif
                    hold >>>= op;
                    bits -= op;
                    // Tracevv((stderr, "inflate:         distance %u\n", dist));
                    op = _out - beg; /* max distance in output */
                    if (dist > op) { /* see if copy from window */
                      op = dist - op; /* distance back in window */
                      if (op > whave) {
                        if (state.sane) {
                          strm.msg = 'invalid distance too far back';
                          state.mode = BAD;
                          break top;
                        }

                        // (!) This block is disabled in zlib defaults,
                        // don't enable it for binary compatibility
                        // #ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
                        //                if (len <= op - whave) {
                        //                  do {
                        //                    output[_out++] = 0;
                        //                  } while (--len);
                        //                  continue top;
                        //                }
                        //                len -= op - whave;
                        //                do {
                        //                  output[_out++] = 0;
                        //                } while (--op > whave);
                        //                if (op === 0) {
                        //                  from = _out - dist;
                        //                  do {
                        //                    output[_out++] = output[from++];
                        //                  } while (--len);
                        //                  continue top;
                        //                }
                        // #endif
                      }
                      from = 0; // window index
                      from_source = s_window;
                      if (wnext === 0) { /* very common case */
                        from += wsize - op;
                        if (op < len) { /* some from window */
                          len -= op;
                          do {
                            output[_out++] = s_window[from++];
                          } while (--op);
                          from = _out - dist; /* rest from output */
                          from_source = output;
                        }
                      } else if (wnext < op) { /* wrap around window */
                        from += wsize + wnext - op;
                        op -= wnext;
                        if (op < len) { /* some from end of window */
                          len -= op;
                          do {
                            output[_out++] = s_window[from++];
                          } while (--op);
                          from = 0;
                          if (wnext < len) { /* some from start of window */
                            op = wnext;
                            len -= op;
                            do {
                              output[_out++] = s_window[from++];
                            } while (--op);
                            from = _out - dist; /* rest from output */
                            from_source = output;
                          }
                        }
                      } else { /* contiguous in window */
                        from += wnext - op;
                        if (op < len) { /* some from window */
                          len -= op;
                          do {
                            output[_out++] = s_window[from++];
                          } while (--op);
                          from = _out - dist; /* rest from output */
                          from_source = output;
                        }
                      }
                      while (len > 2) {
                        output[_out++] = from_source[from++];
                        output[_out++] = from_source[from++];
                        output[_out++] = from_source[from++];
                        len -= 3;
                      }
                      if (len) {
                        output[_out++] = from_source[from++];
                        if (len > 1) {
                          output[_out++] = from_source[from++];
                        }
                      }
                    } else {
                      from = _out - dist; /* copy direct from output */
                      do { /* minimum length is three */
                        output[_out++] = output[from++];
                        output[_out++] = output[from++];
                        output[_out++] = output[from++];
                        len -= 3;
                      } while (len > 2);
                      if (len) {
                        output[_out++] = output[from++];
                        if (len > 1) {
                          output[_out++] = output[from++];
                        }
                      }
                    }
                  } else if ((op & 64) === 0) { /* 2nd level distance code */
                    here = dcode[(here & 0xffff)/* here.val */ + (hold & ((1 << op) - 1))];
                    continue;
                  } else {
                    strm.msg = 'invalid distance code';
                    state.mode = BAD;
                    break top;
                  }

                  break; // need to emulate goto via "continue"
                }
              } else if ((op & 64) === 0) { /* 2nd level length code */
                here = lcode[(here & 0xffff)/* here.val */ + (hold & ((1 << op) - 1))];
                continue;
              } else if (op & 32) { /* end-of-block */
                // Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = TYPE;
                break top;
              } else {
                strm.msg = 'invalid literal/length code';
                state.mode = BAD;
                break top;
              }

              break; // need to emulate goto via "continue"
            }
          } while (_in < last && _out < end);

          /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
          len = bits >> 3;
          _in -= len;
          bits -= len << 3;
          hold &= (1 << bits) - 1;

          /* update state and return */
          strm.next_in = _in;
          strm.next_out = _out;
          strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
          strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
          state.hold = hold;
          state.bits = bits;
        };
        /***/ }),

      /***/ 3001:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        // (C) 1995-2013 Jean-loup Gailly and Mark Adler
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.

        const utils = __webpack_require__(6907);
        const adler32 = __webpack_require__(7575);
        const crc32 = __webpack_require__(3415);
        const inflate_fast = __webpack_require__(6438);
        const inflate_table = __webpack_require__(1375);

        const CODES = 0;
        const LENS = 1;
        const DISTS = 2;

        /* Public constants ========================================================== */
        /* =========================================================================== */

        /* Allowed flush values; see deflate() and inflate() below for details */
        // var Z_NO_FLUSH      = 0;
        // var Z_PARTIAL_FLUSH = 1;
        // var Z_SYNC_FLUSH    = 2;
        // var Z_FULL_FLUSH    = 3;
        const Z_FINISH = 4;
        const Z_BLOCK = 5;
        const Z_TREES = 6;

        /* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
        const Z_OK = 0;
        const Z_STREAM_END = 1;
        const Z_NEED_DICT = 2;
        // var Z_ERRNO         = -1;
        const Z_STREAM_ERROR = -2;
        const Z_DATA_ERROR = -3;
        const Z_MEM_ERROR = -4;
        const Z_BUF_ERROR = -5;
        // var Z_VERSION_ERROR = -6;

        /* The deflate compression method */
        const Z_DEFLATED = 8;

        /* STATES ==================================================================== */
        /* =========================================================================== */

        const HEAD = 1; /* i: waiting for magic header */
        const FLAGS = 2; /* i: waiting for method and flags (gzip) */
        const TIME = 3; /* i: waiting for modification time (gzip) */
        const OS = 4; /* i: waiting for extra flags and operating system (gzip) */
        const EXLEN = 5; /* i: waiting for extra length (gzip) */
        const EXTRA = 6; /* i: waiting for extra bytes (gzip) */
        const NAME = 7; /* i: waiting for end of file name (gzip) */
        const COMMENT = 8; /* i: waiting for end of comment (gzip) */
        const HCRC = 9; /* i: waiting for header crc (gzip) */
        const DICTID = 10; /* i: waiting for dictionary check value */
        const DICT = 11; /* waiting for inflateSetDictionary() call */
        const TYPE = 12; /* i: waiting for type bits, including last-flag bit */
        const TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */
        const STORED = 14; /* i: waiting for stored size (length and complement) */
        const COPY_ = 15; /* i/o: same as COPY below, but only first time in */
        const COPY = 16; /* i/o: waiting for input or output to copy stored block */
        const TABLE = 17; /* i: waiting for dynamic block table lengths */
        const LENLENS = 18; /* i: waiting for code length code lengths */
        const CODELENS = 19; /* i: waiting for length/lit and distance code lengths */
        const LEN_ = 20; /* i: same as LEN below, but only first time in */
        const LEN = 21; /* i: waiting for length/lit/eob code */
        const LENEXT = 22; /* i: waiting for length extra bits */
        const DIST = 23; /* i: waiting for distance code */
        const DISTEXT = 24; /* i: waiting for distance extra bits */
        const MATCH = 25; /* o: waiting for output space to copy string */
        const LIT = 26; /* o: waiting for output space to write literal */
        const CHECK = 27; /* i: waiting for 32-bit check value */
        const LENGTH = 28; /* i: waiting for 32-bit length (gzip) */
        const DONE = 29; /* finished check, done -- remain here until reset */
        const BAD = 30; /* got a data error -- remain here until reset */
        const MEM = 31; /* got an inflate() memory error -- remain here until reset */
        const SYNC = 32; /* looking for synchronization bytes to restart inflate() */

        /* =========================================================================== */

        const ENOUGH_LENS = 852;
        const ENOUGH_DISTS = 592;
        // var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

        const MAX_WBITS = 15;
        /* 32K LZ77 window */
        const DEF_WBITS = MAX_WBITS;

        function zswap32(q) {
          return (((q >>> 24) & 0xff)
          + ((q >>> 8) & 0xff00)
          + ((q & 0xff00) << 8)
          + ((q & 0xff) << 24));
        }

        function InflateState() {
          this.mode = 0; /* current inflate mode */
          this.last = false; /* true if processing last block */
          this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */
          this.havedict = false; /* true if dictionary provided */
          this.flags = 0; /* gzip header method and flags (0 if zlib) */
          this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */
          this.check = 0; /* protected copy of check value */
          this.total = 0; /* protected copy of output count */
          // TODO: may be {}
          this.head = null; /* where to save gzip header information */

          /* sliding window */
          this.wbits = 0; /* log base 2 of requested window size */
          this.wsize = 0; /* window size or zero if not using window */
          this.whave = 0; /* valid bytes in the window */
          this.wnext = 0; /* window write index */
          this.window = null; /* allocated sliding window, if needed */

          /* bit accumulator */
          this.hold = 0; /* input bit accumulator */
          this.bits = 0; /* number of bits in "in" */

          /* for string and stored block copying */
          this.length = 0; /* literal or length of data to copy */
          this.offset = 0; /* distance back to copy string from */

          /* for table and code decoding */
          this.extra = 0; /* extra bits needed */

          /* fixed and dynamic code tables */
          this.lencode = null; /* starting table for length/literal codes */
          this.distcode = null; /* starting table for distance codes */
          this.lenbits = 0; /* index bits for lencode */
          this.distbits = 0; /* index bits for distcode */

          /* dynamic table building */
          this.ncode = 0; /* number of code length code lengths */
          this.nlen = 0; /* number of length code lengths */
          this.ndist = 0; /* number of distance code lengths */
          this.have = 0; /* number of code lengths in lens[] */
          this.next = null; /* next available space in codes[] */

          this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
          this.work = new utils.Buf16(288); /* work area for code table building */

          /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */
          // this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
          this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */
          this.distdyn = null; /* dynamic table for distance codes (JS specific) */
          this.sane = 0; /* if false, allow invalid distance too far */
          this.back = 0; /* bits back of last unprocessed length/lit */
          this.was = 0; /* initial length of match */
        }

        function inflateResetKeep(strm) {
          let state;

          if (!strm || !strm.state) { return Z_STREAM_ERROR; }
          state = strm.state;
          strm.total_in = strm.total_out = state.total = 0;
          strm.msg = ''; /* Z_NULL */
          if (state.wrap) { /* to support ill-conceived Java test suite */
            strm.adler = state.wrap & 1;
          }
          state.mode = HEAD;
          state.last = 0;
          state.havedict = 0;
          state.dmax = 32768;
          state.head = null/* Z_NULL */;
          state.hold = 0;
          state.bits = 0;
          // state.lencode = state.distcode = state.next = state.codes;
          state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
          state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);

          state.sane = 1;
          state.back = -1;
          // Tracev((stderr, "inflate: reset\n"));
          return Z_OK;
        }

        function inflateReset(strm) {
          let state;

          if (!strm || !strm.state) { return Z_STREAM_ERROR; }
          state = strm.state;
          state.wsize = 0;
          state.whave = 0;
          state.wnext = 0;
          return inflateResetKeep(strm);
        }

        function inflateReset2(strm, windowBits) {
          let wrap;
          let state;

          /* get the state */
          if (!strm || !strm.state) { return Z_STREAM_ERROR; }
          state = strm.state;

          /* extract wrap request from windowBits parameter */
          if (windowBits < 0) {
            wrap = 0;
            windowBits = -windowBits;
          } else {
            wrap = (windowBits >> 4) + 1;
            if (windowBits < 48) {
              windowBits &= 15;
            }
          }

          /* set number of window bits, free window if different */
          if (windowBits && (windowBits < 8 || windowBits > 15)) {
            return Z_STREAM_ERROR;
          }
          if (state.window !== null && state.wbits !== windowBits) {
            state.window = null;
          }

          /* update state and reset the rest of it */
          state.wrap = wrap;
          state.wbits = windowBits;
          return inflateReset(strm);
        }

        function inflateInit2(strm, windowBits) {
          let ret;
          let state;

          if (!strm) { return Z_STREAM_ERROR; }
          // strm.msg = Z_NULL;                 /* in case we return an error */

          state = new InflateState();

          // if (state === Z_NULL) return Z_MEM_ERROR;
          // Tracev((stderr, "inflate: allocated\n"));
          strm.state = state;
          state.window = null/* Z_NULL */;
          ret = inflateReset2(strm, windowBits);
          if (ret !== Z_OK) {
            strm.state = null/* Z_NULL */;
          }
          return ret;
        }

        function inflateInit(strm) {
          return inflateInit2(strm, DEF_WBITS);
        }

        /*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */
        let virgin = true;

        let lenfix; let
          distfix; // We have no pointers in JS, so keep tables separate

        function fixedtables(state) {
          /* build fixed huffman tables if first call (may not be thread safe) */
          if (virgin) {
            let sym;

            lenfix = new utils.Buf32(512);
            distfix = new utils.Buf32(32);

            /* literal/length table */
            sym = 0;
            while (sym < 144) { state.lens[sym++] = 8; }
            while (sym < 256) { state.lens[sym++] = 9; }
            while (sym < 280) { state.lens[sym++] = 7; }
            while (sym < 288) { state.lens[sym++] = 8; }

            inflate_table(LENS, state.lens, 0, 288, lenfix, 0, state.work, { bits: 9 });

            /* distance table */
            sym = 0;
            while (sym < 32) { state.lens[sym++] = 5; }

            inflate_table(DISTS, state.lens, 0, 32, distfix, 0, state.work, { bits: 5 });

            /* do this just once */
            virgin = false;
          }

          state.lencode = lenfix;
          state.lenbits = 9;
          state.distcode = distfix;
          state.distbits = 5;
        }

        /*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */
        function updatewindow(strm, src, end, copy) {
          let dist;
          const { state } = strm;

          /* if it hasn't been done already, allocate space for the window */
          if (state.window === null) {
            state.wsize = 1 << state.wbits;
            state.wnext = 0;
            state.whave = 0;

            state.window = new utils.Buf8(state.wsize);
          }

          /* copy state->wsize or less output bytes into the circular window */
          if (copy >= state.wsize) {
            utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
            state.wnext = 0;
            state.whave = state.wsize;
          } else {
            dist = state.wsize - state.wnext;
            if (dist > copy) {
              dist = copy;
            }
            // zmemcpy(state->window + state->wnext, end - copy, dist);
            utils.arraySet(state.window, src, end - copy, dist, state.wnext);
            copy -= dist;
            if (copy) {
              // zmemcpy(state->window, end - copy, copy);
              utils.arraySet(state.window, src, end - copy, copy, 0);
              state.wnext = copy;
              state.whave = state.wsize;
            } else {
              state.wnext += dist;
              if (state.wnext === state.wsize) { state.wnext = 0; }
              if (state.whave < state.wsize) { state.whave += dist; }
            }
          }
          return 0;
        }

        function inflate(strm, flush) {
          let state;
          let input; let
            output; // input/output buffers
          let next; /* next input INDEX */
          let put; /* next output INDEX */
          let have; let
            left; /* available input and output */
          let hold; /* bit buffer */
          let bits; /* bits in bit buffer */
          let _in; let
            _out; /* save starting available input and output */
          let copy; /* number of stored or match bytes to copy */
          let from; /* where to copy match bytes from */
          let from_source;
          let here = 0; /* current decoding table entry */
          let here_bits; let here_op; let
            here_val; // paked "here" denormalized (JS specific)
          // var last;                   /* parent table entry */
          let last_bits; let last_op; let
            last_val; // paked "last" denormalized (JS specific)
          let len; /* length to copy for repeats, bits to drop */
          let ret; /* return code */
          const hbuf = new utils.Buf8(4); /* buffer for gzip header crc calculation */
          let opts;

          let n; // temporary var for NEED_BITS

          const order = /* permutation of code lengths */
    [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];

          if (!strm || !strm.state || !strm.output
      || (!strm.input && strm.avail_in !== 0)) {
            return Z_STREAM_ERROR;
          }

          state = strm.state;
          if (state.mode === TYPE) { state.mode = TYPEDO; } /* skip check */

          // --- LOAD() ---
          put = strm.next_out;
          output = strm.output;
          left = strm.avail_out;
          next = strm.next_in;
          input = strm.input;
          have = strm.avail_in;
          hold = state.hold;
          bits = state.bits;
          //---

          _in = have;
          _out = left;
          ret = Z_OK;

          inf_leave: // goto emulation
          for (;;) {
            switch (state.mode) {
              case HEAD:
                if (state.wrap === 0) {
                  state.mode = TYPEDO;
                  break;
                }
                //= == NEEDBITS(16);
                while (bits < 16) {
                  if (have === 0) { break inf_leave; }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //= ==//
                if ((state.wrap & 2) && hold === 0x8b1f) { /* gzip header */
                  state.check = 0/* crc32(0L, Z_NULL, 0) */;
                  //= == CRC2(state.check, hold);
                  hbuf[0] = hold & 0xff;
                  hbuf[1] = (hold >>> 8) & 0xff;
                  state.check = crc32(state.check, hbuf, 2, 0);
                  //= ==//

                  //= == INITBITS();
                  hold = 0;
                  bits = 0;
                  //= ==//
                  state.mode = FLAGS;
                  break;
                }
                state.flags = 0; /* expect zlib header */
                if (state.head) {
                  state.head.done = false;
                }
                if (!(state.wrap & 1) /* check if zlib header allowed */
          || (((hold & 0xff)/* BITS(8) */ << 8) + (hold >> 8)) % 31) {
                  strm.msg = 'incorrect header check';
                  state.mode = BAD;
                  break;
                }
                if ((hold & 0x0f)/* BITS(4) */ !== Z_DEFLATED) {
                  strm.msg = 'unknown compression method';
                  state.mode = BAD;
                  break;
                }
                // --- DROPBITS(4) ---//
                hold >>>= 4;
                bits -= 4;
                // ---//
                len = (hold & 0x0f)/* BITS(4) */ + 8;
                if (state.wbits === 0) {
                  state.wbits = len;
                } else if (len > state.wbits) {
                  strm.msg = 'invalid window size';
                  state.mode = BAD;
                  break;
                }
                state.dmax = 1 << len;
                // Tracev((stderr, "inflate:   zlib header ok\n"));
                strm.adler = state.check = 1/* adler32(0L, Z_NULL, 0) */;
                state.mode = hold & 0x200 ? DICTID : TYPE;
                //= == INITBITS();
                hold = 0;
                bits = 0;
                //= ==//
                break;
              case FLAGS:
                //= == NEEDBITS(16); */
                while (bits < 16) {
                  if (have === 0) { break inf_leave; }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //= ==//
                state.flags = hold;
                if ((state.flags & 0xff) !== Z_DEFLATED) {
                  strm.msg = 'unknown compression method';
                  state.mode = BAD;
                  break;
                }
                if (state.flags & 0xe000) {
                  strm.msg = 'unknown header flags set';
                  state.mode = BAD;
                  break;
                }
                if (state.head) {
                  state.head.text = ((hold >> 8) & 1);
                }
                if (state.flags & 0x0200) {
                  //= == CRC2(state.check, hold);
                  hbuf[0] = hold & 0xff;
                  hbuf[1] = (hold >>> 8) & 0xff;
                  state.check = crc32(state.check, hbuf, 2, 0);
                  //= ==//
                }
                //= == INITBITS();
                hold = 0;
                bits = 0;
                //= ==//
                state.mode = TIME;
                /* falls through */
              case TIME:
                //= == NEEDBITS(32); */
                while (bits < 32) {
                  if (have === 0) { break inf_leave; }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //= ==//
                if (state.head) {
                  state.head.time = hold;
                }
                if (state.flags & 0x0200) {
                  //= == CRC4(state.check, hold)
                  hbuf[0] = hold & 0xff;
                  hbuf[1] = (hold >>> 8) & 0xff;
                  hbuf[2] = (hold >>> 16) & 0xff;
                  hbuf[3] = (hold >>> 24) & 0xff;
                  state.check = crc32(state.check, hbuf, 4, 0);
                  //= ==
                }
                //= == INITBITS();
                hold = 0;
                bits = 0;
                //= ==//
                state.mode = OS;
                /* falls through */
              case OS:
                //= == NEEDBITS(16); */
                while (bits < 16) {
                  if (have === 0) { break inf_leave; }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //= ==//
                if (state.head) {
                  state.head.xflags = (hold & 0xff);
                  state.head.os = (hold >> 8);
                }
                if (state.flags & 0x0200) {
                  //= == CRC2(state.check, hold);
                  hbuf[0] = hold & 0xff;
                  hbuf[1] = (hold >>> 8) & 0xff;
                  state.check = crc32(state.check, hbuf, 2, 0);
                  //= ==//
                }
                //= == INITBITS();
                hold = 0;
                bits = 0;
                //= ==//
                state.mode = EXLEN;
                /* falls through */
              case EXLEN:
                if (state.flags & 0x0400) {
                  //= == NEEDBITS(16); */
                  while (bits < 16) {
                    if (have === 0) { break inf_leave; }
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                  }
                  //= ==//
                  state.length = hold;
                  if (state.head) {
                    state.head.extra_len = hold;
                  }
                  if (state.flags & 0x0200) {
                    //= == CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = (hold >>> 8) & 0xff;
                    state.check = crc32(state.check, hbuf, 2, 0);
                    //= ==//
                  }
                  //= == INITBITS();
                  hold = 0;
                  bits = 0;
                  //= ==//
                } else if (state.head) {
                  state.head.extra = null/* Z_NULL */;
                }
                state.mode = EXTRA;
                /* falls through */
              case EXTRA:
                if (state.flags & 0x0400) {
                  copy = state.length;
                  if (copy > have) { copy = have; }
                  if (copy) {
                    if (state.head) {
                      len = state.head.extra_len - state.length;
                      if (!state.head.extra) {
                        // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                      }
                      utils.arraySet(
                        state.head.extra,
                        input,
                        next,
                        // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy,
                        /* len + copy > state.head.extra_max - len ? state.head.extra_max : copy, */
                        len,
                      );
                      // zmemcpy(state.head.extra + len, next,
                      //        len + copy > state.head.extra_max ?
                      //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) {
                      state.check = crc32(state.check, input, copy, next);
                    }
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                  }
                  if (state.length) { break inf_leave; }
                }
                state.length = 0;
                state.mode = NAME;
                /* falls through */
              case NAME:
                if (state.flags & 0x0800) {
                  if (have === 0) { break inf_leave; }
                  copy = 0;
                  do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */
                    if (state.head && len
                && (state.length < 65536 /* state.head.name_max */)) {
                      state.head.name += String.fromCharCode(len);
                    }
                  } while (len && copy < have);

                  if (state.flags & 0x0200) {
                    state.check = crc32(state.check, input, copy, next);
                  }
                  have -= copy;
                  next += copy;
                  if (len) { break inf_leave; }
                } else if (state.head) {
                  state.head.name = null;
                }
                state.length = 0;
                state.mode = COMMENT;
                /* falls through */
              case COMMENT:
                if (state.flags & 0x1000) {
                  if (have === 0) { break inf_leave; }
                  copy = 0;
                  do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */
                    if (state.head && len
                && (state.length < 65536 /* state.head.comm_max */)) {
                      state.head.comment += String.fromCharCode(len);
                    }
                  } while (len && copy < have);
                  if (state.flags & 0x0200) {
                    state.check = crc32(state.check, input, copy, next);
                  }
                  have -= copy;
                  next += copy;
                  if (len) { break inf_leave; }
                } else if (state.head) {
                  state.head.comment = null;
                }
                state.mode = HCRC;
                /* falls through */
              case HCRC:
                if (state.flags & 0x0200) {
                  //= == NEEDBITS(16); */
                  while (bits < 16) {
                    if (have === 0) { break inf_leave; }
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                  }
                  //= ==//
                  if (hold !== (state.check & 0xffff)) {
                    strm.msg = 'header crc mismatch';
                    state.mode = BAD;
                    break;
                  }
                  //= == INITBITS();
                  hold = 0;
                  bits = 0;
                  //= ==//
                }
                if (state.head) {
                  state.head.hcrc = ((state.flags >> 9) & 1);
                  state.head.done = true;
                }
                strm.adler = state.check = 0;
                state.mode = TYPE;
                break;
              case DICTID:
                //= == NEEDBITS(32); */
                while (bits < 32) {
                  if (have === 0) { break inf_leave; }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //= ==//
                strm.adler = state.check = zswap32(hold);
                //= == INITBITS();
                hold = 0;
                bits = 0;
                //= ==//
                state.mode = DICT;
                /* falls through */
              case DICT:
                if (state.havedict === 0) {
                  // --- RESTORE() ---
                  strm.next_out = put;
                  strm.avail_out = left;
                  strm.next_in = next;
                  strm.avail_in = have;
                  state.hold = hold;
                  state.bits = bits;
                  //---
                  return Z_NEED_DICT;
                }
                strm.adler = state.check = 1/* adler32(0L, Z_NULL, 0) */;
                state.mode = TYPE;
                /* falls through */
              case TYPE:
                if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
                /* falls through */
              case TYPEDO:
                if (state.last) {
                  // --- BYTEBITS() ---//
                  hold >>>= bits & 7;
                  bits -= bits & 7;
                  // ---//
                  state.mode = CHECK;
                  break;
                }
                //= == NEEDBITS(3); */
                while (bits < 3) {
                  if (have === 0) { break inf_leave; }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //= ==//
                state.last = (hold & 0x01)/* BITS(1) */;
                // --- DROPBITS(1) ---//
                hold >>>= 1;
                bits -= 1;
                // ---//

                switch ((hold & 0x03)/* BITS(2) */) {
                  case 0: /* stored block */
                    // Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = STORED;
                    break;
                  case 1: /* fixed block */
                    fixedtables(state);
                    // Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = LEN_; /* decode codes */
                    if (flush === Z_TREES) {
                      // --- DROPBITS(2) ---//
                      hold >>>= 2;
                      bits -= 2;
                      // ---//
                      break inf_leave;
                    }
                    break;
                  case 2: /* dynamic block */
                    // Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = TABLE;
                    break;
                  case 3:
                    strm.msg = 'invalid block type';
                    state.mode = BAD;
                }
                // --- DROPBITS(2) ---//
                hold >>>= 2;
                bits -= 2;
                // ---//
                break;
              case STORED:
                // --- BYTEBITS() ---// /* go to byte boundary */
                hold >>>= bits & 7;
                bits -= bits & 7;
                // ---//
                //= == NEEDBITS(32); */
                while (bits < 32) {
                  if (have === 0) { break inf_leave; }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //= ==//
                if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
                  strm.msg = 'invalid stored block lengths';
                  state.mode = BAD;
                  break;
                }
                state.length = hold & 0xffff;
                // Tracev((stderr, "inflate:       stored length %u\n",
                //        state.length));
                //= == INITBITS();
                hold = 0;
                bits = 0;
                //= ==//
                state.mode = COPY_;
                if (flush === Z_TREES) { break inf_leave; }
                /* falls through */
              case COPY_:
                state.mode = COPY;
                /* falls through */
              case COPY:
                copy = state.length;
                if (copy) {
                  if (copy > have) { copy = have; }
                  if (copy > left) { copy = left; }
                  if (copy === 0) { break inf_leave; }
                  // --- zmemcpy(put, next, copy); ---
                  utils.arraySet(output, input, next, copy, put);
                  // ---//
                  have -= copy;
                  next += copy;
                  left -= copy;
                  put += copy;
                  state.length -= copy;
                  break;
                }
                // Tracev((stderr, "inflate:       stored end\n"));
                state.mode = TYPE;
                break;
              case TABLE:
                //= == NEEDBITS(14); */
                while (bits < 14) {
                  if (have === 0) { break inf_leave; }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //= ==//
                state.nlen = (hold & 0x1f)/* BITS(5) */ + 257;
                // --- DROPBITS(5) ---//
                hold >>>= 5;
                bits -= 5;
                // ---//
                state.ndist = (hold & 0x1f)/* BITS(5) */ + 1;
                // --- DROPBITS(5) ---//
                hold >>>= 5;
                bits -= 5;
                // ---//
                state.ncode = (hold & 0x0f)/* BITS(4) */ + 4;
                // --- DROPBITS(4) ---//
                hold >>>= 4;
                bits -= 4;
                // ---//
                // #ifndef PKZIP_BUG_WORKAROUND
                if (state.nlen > 286 || state.ndist > 30) {
                  strm.msg = 'too many length or distance symbols';
                  state.mode = BAD;
                  break;
                }
                // #endif
                // Tracev((stderr, "inflate:       table sizes ok\n"));
                state.have = 0;
                state.mode = LENLENS;
                /* falls through */
              case LENLENS:
                while (state.have < state.ncode) {
                  //= == NEEDBITS(3);
                  while (bits < 3) {
                    if (have === 0) { break inf_leave; }
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                  }
                  //= ==//
                  state.lens[order[state.have++]] = (hold & 0x07);// BITS(3);
                  // --- DROPBITS(3) ---//
                  hold >>>= 3;
                  bits -= 3;
                  // ---//
                }
                while (state.have < 19) {
                  state.lens[order[state.have++]] = 0;
                }
                // We have separate tables & no pointers. 2 commented lines below not needed.
                // state.next = state.codes;
                // state.lencode = state.next;
                // Switch to use dynamic table
                state.lencode = state.lendyn;
                state.lenbits = 7;

                opts = { bits: state.lenbits };
                ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
                state.lenbits = opts.bits;

                if (ret) {
                  strm.msg = 'invalid code lengths set';
                  state.mode = BAD;
                  break;
                }
                // Tracev((stderr, "inflate:       code lengths ok\n"));
                state.have = 0;
                state.mode = CODELENS;
                /* falls through */
              case CODELENS:
                while (state.have < state.nlen + state.ndist) {
                  for (;;) {
                    here = state.lencode[hold & ((1 << state.lenbits) - 1)];/* BITS(state.lenbits) */
                    here_bits = here >>> 24;
                    here_op = (here >>> 16) & 0xff;
                    here_val = here & 0xffff;

                    if ((here_bits) <= bits) { break; }
                    // --- PULLBYTE() ---//
                    if (have === 0) { break inf_leave; }
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                    // ---//
                  }
                  if (here_val < 16) {
                    // --- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    // ---//
                    state.lens[state.have++] = here_val;
                  } else {
                    if (here_val === 16) {
                      //= == NEEDBITS(here.bits + 2);
                      n = here_bits + 2;
                      while (bits < n) {
                        if (have === 0) { break inf_leave; }
                        have--;
                        hold += input[next++] << bits;
                        bits += 8;
                      }
                      //= ==//
                      // --- DROPBITS(here.bits) ---//
                      hold >>>= here_bits;
                      bits -= here_bits;
                      // ---//
                      if (state.have === 0) {
                        strm.msg = 'invalid bit length repeat';
                        state.mode = BAD;
                        break;
                      }
                      len = state.lens[state.have - 1];
                      copy = 3 + (hold & 0x03);// BITS(2);
                      // --- DROPBITS(2) ---//
                      hold >>>= 2;
                      bits -= 2;
                      // ---//
                    } else if (here_val === 17) {
                      //= == NEEDBITS(here.bits + 3);
                      n = here_bits + 3;
                      while (bits < n) {
                        if (have === 0) { break inf_leave; }
                        have--;
                        hold += input[next++] << bits;
                        bits += 8;
                      }
                      //= ==//
                      // --- DROPBITS(here.bits) ---//
                      hold >>>= here_bits;
                      bits -= here_bits;
                      // ---//
                      len = 0;
                      copy = 3 + (hold & 0x07);// BITS(3);
                      // --- DROPBITS(3) ---//
                      hold >>>= 3;
                      bits -= 3;
                      // ---//
                    } else {
                      //= == NEEDBITS(here.bits + 7);
                      n = here_bits + 7;
                      while (bits < n) {
                        if (have === 0) { break inf_leave; }
                        have--;
                        hold += input[next++] << bits;
                        bits += 8;
                      }
                      //= ==//
                      // --- DROPBITS(here.bits) ---//
                      hold >>>= here_bits;
                      bits -= here_bits;
                      // ---//
                      len = 0;
                      copy = 11 + (hold & 0x7f);// BITS(7);
                      // --- DROPBITS(7) ---//
                      hold >>>= 7;
                      bits -= 7;
                      // ---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                      strm.msg = 'invalid bit length repeat';
                      state.mode = BAD;
                      break;
                    }
                    while (copy--) {
                      state.lens[state.have++] = len;
                    }
                  }
                }

                /* handle error breaks in while */
                if (state.mode === BAD) { break; }

                /* check for end-of-block code (better have one) */
                if (state.lens[256] === 0) {
                  strm.msg = 'invalid code -- missing end-of-block';
                  state.mode = BAD;
                  break;
                }

                /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */
                state.lenbits = 9;

                opts = { bits: state.lenbits };
                ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
                // We have separate tables & no pointers. 2 commented lines below not needed.
                // state.next_index = opts.table_index;
                state.lenbits = opts.bits;
                // state.lencode = state.next;

                if (ret) {
                  strm.msg = 'invalid literal/lengths set';
                  state.mode = BAD;
                  break;
                }

                state.distbits = 6;
                // state.distcode.copy(state.codes);
                // Switch to use dynamic table
                state.distcode = state.distdyn;
                opts = { bits: state.distbits };
                ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
                // We have separate tables & no pointers. 2 commented lines below not needed.
                // state.next_index = opts.table_index;
                state.distbits = opts.bits;
                // state.distcode = state.next;

                if (ret) {
                  strm.msg = 'invalid distances set';
                  state.mode = BAD;
                  break;
                }
                // Tracev((stderr, 'inflate:       codes ok\n'));
                state.mode = LEN_;
                if (flush === Z_TREES) { break inf_leave; }
                /* falls through */
              case LEN_:
                state.mode = LEN;
                /* falls through */
              case LEN:
                if (have >= 6 && left >= 258) {
                  // --- RESTORE() ---
                  strm.next_out = put;
                  strm.avail_out = left;
                  strm.next_in = next;
                  strm.avail_in = have;
                  state.hold = hold;
                  state.bits = bits;
                  //---
                  inflate_fast(strm, _out);
                  // --- LOAD() ---
                  put = strm.next_out;
                  output = strm.output;
                  left = strm.avail_out;
                  next = strm.next_in;
                  input = strm.input;
                  have = strm.avail_in;
                  hold = state.hold;
                  bits = state.bits;
                  //---

                  if (state.mode === TYPE) {
                    state.back = -1;
                  }
                  break;
                }
                state.back = 0;
                for (;;) {
                  here = state.lencode[hold & ((1 << state.lenbits) - 1)]; /* BITS(state.lenbits) */
                  here_bits = here >>> 24;
                  here_op = (here >>> 16) & 0xff;
                  here_val = here & 0xffff;

                  if (here_bits <= bits) { break; }
                  // --- PULLBYTE() ---//
                  if (have === 0) { break inf_leave; }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                  // ---//
                }
                if (here_op && (here_op & 0xf0) === 0) {
                  last_bits = here_bits;
                  last_op = here_op;
                  last_val = here_val;
                  for (;;) {
                    here = state.lencode[last_val
                    + ((hold & ((1 << (last_bits + last_op)) - 1))/* BITS(last.bits + last.op) */ >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = (here >>> 16) & 0xff;
                    here_val = here & 0xffff;

                    if ((last_bits + here_bits) <= bits) { break; }
                    // --- PULLBYTE() ---//
                    if (have === 0) { break inf_leave; }
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                    // ---//
                  }
                  // --- DROPBITS(last.bits) ---//
                  hold >>>= last_bits;
                  bits -= last_bits;
                  // ---//
                  state.back += last_bits;
                }
                // --- DROPBITS(here.bits) ---//
                hold >>>= here_bits;
                bits -= here_bits;
                // ---//
                state.back += here_bits;
                state.length = here_val;
                if (here_op === 0) {
                  // Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                  //        "inflate:         literal '%c'\n" :
                  //        "inflate:         literal 0x%02x\n", here.val));
                  state.mode = LIT;
                  break;
                }
                if (here_op & 32) {
                  // Tracevv((stderr, "inflate:         end of block\n"));
                  state.back = -1;
                  state.mode = TYPE;
                  break;
                }
                if (here_op & 64) {
                  strm.msg = 'invalid literal/length code';
                  state.mode = BAD;
                  break;
                }
                state.extra = here_op & 15;
                state.mode = LENEXT;
                /* falls through */
              case LENEXT:
                if (state.extra) {
                  //= == NEEDBITS(state.extra);
                  n = state.extra;
                  while (bits < n) {
                    if (have === 0) { break inf_leave; }
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                  }
                  //= ==//
                  state.length += hold & ((1 << state.extra) - 1)/* BITS(state.extra) */;
                  // --- DROPBITS(state.extra) ---//
                  hold >>>= state.extra;
                  bits -= state.extra;
                  // ---//
                  state.back += state.extra;
                }
                // Tracevv((stderr, "inflate:         length %u\n", state.length));
                state.was = state.length;
                state.mode = DIST;
                /* falls through */
              case DIST:
                for (;;) {
                  here = state.distcode[hold & ((1 << state.distbits) - 1)];/* BITS(state.distbits) */
                  here_bits = here >>> 24;
                  here_op = (here >>> 16) & 0xff;
                  here_val = here & 0xffff;

                  if ((here_bits) <= bits) { break; }
                  // --- PULLBYTE() ---//
                  if (have === 0) { break inf_leave; }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                  // ---//
                }
                if ((here_op & 0xf0) === 0) {
                  last_bits = here_bits;
                  last_op = here_op;
                  last_val = here_val;
                  for (;;) {
                    here = state.distcode[last_val
                    + ((hold & ((1 << (last_bits + last_op)) - 1))/* BITS(last.bits + last.op) */ >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = (here >>> 16) & 0xff;
                    here_val = here & 0xffff;

                    if ((last_bits + here_bits) <= bits) { break; }
                    // --- PULLBYTE() ---//
                    if (have === 0) { break inf_leave; }
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                    // ---//
                  }
                  // --- DROPBITS(last.bits) ---//
                  hold >>>= last_bits;
                  bits -= last_bits;
                  // ---//
                  state.back += last_bits;
                }
                // --- DROPBITS(here.bits) ---//
                hold >>>= here_bits;
                bits -= here_bits;
                // ---//
                state.back += here_bits;
                if (here_op & 64) {
                  strm.msg = 'invalid distance code';
                  state.mode = BAD;
                  break;
                }
                state.offset = here_val;
                state.extra = (here_op) & 15;
                state.mode = DISTEXT;
                /* falls through */
              case DISTEXT:
                if (state.extra) {
                  //= == NEEDBITS(state.extra);
                  n = state.extra;
                  while (bits < n) {
                    if (have === 0) { break inf_leave; }
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                  }
                  //= ==//
                  state.offset += hold & ((1 << state.extra) - 1)/* BITS(state.extra) */;
                  // --- DROPBITS(state.extra) ---//
                  hold >>>= state.extra;
                  bits -= state.extra;
                  // ---//
                  state.back += state.extra;
                }
                // #ifdef INFLATE_STRICT
                if (state.offset > state.dmax) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD;
                  break;
                }
                // #endif
                // Tracevv((stderr, "inflate:         distance %u\n", state.offset));
                state.mode = MATCH;
                /* falls through */
              case MATCH:
                if (left === 0) { break inf_leave; }
                copy = _out - left;
                if (state.offset > copy) { /* copy from window */
                  copy = state.offset - copy;
                  if (copy > state.whave) {
                    if (state.sane) {
                      strm.msg = 'invalid distance too far back';
                      state.mode = BAD;
                      break;
                    }
                    // (!) This block is disabled in zlib defaults,
                    // don't enable it for binary compatibility
                    // #ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
                    //          Trace((stderr, "inflate.c too far\n"));
                    //          copy -= state.whave;
                    //          if (copy > state.length) { copy = state.length; }
                    //          if (copy > left) { copy = left; }
                    //          left -= copy;
                    //          state.length -= copy;
                    //          do {
                    //            output[put++] = 0;
                    //          } while (--copy);
                    //          if (state.length === 0) { state.mode = LEN; }
                    //          break;
                    // #endif
                  }
                  if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                  } else {
                    from = state.wnext - copy;
                  }
                  if (copy > state.length) { copy = state.length; }
                  from_source = state.window;
                } else { /* copy from output */
                  from_source = output;
                  from = put - state.offset;
                  copy = state.length;
                }
                if (copy > left) { copy = left; }
                left -= copy;
                state.length -= copy;
                do {
                  output[put++] = from_source[from++];
                } while (--copy);
                if (state.length === 0) { state.mode = LEN; }
                break;
              case LIT:
                if (left === 0) { break inf_leave; }
                output[put++] = state.length;
                left--;
                state.mode = LEN;
                break;
              case CHECK:
                if (state.wrap) {
                  //= == NEEDBITS(32);
                  while (bits < 32) {
                    if (have === 0) { break inf_leave; }
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                  }
                  //= ==//
                  _out -= left;
                  strm.total_out += _out;
                  state.total += _out;
                  if (_out) {
                    strm.adler = state.check =
                /* UPDATE(state.check, put - _out, _out); */
                (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));
                  }
                  _out = left;
                  // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                  if ((state.flags ? hold : zswap32(hold)) !== state.check) {
                    strm.msg = 'incorrect data check';
                    state.mode = BAD;
                    break;
                  }
                  //= == INITBITS();
                  hold = 0;
                  bits = 0;
                  //= ==//
                  // Tracev((stderr, "inflate:   check matches trailer\n"));
                }
                state.mode = LENGTH;
                /* falls through */
              case LENGTH:
                if (state.wrap && state.flags) {
                  //= == NEEDBITS(32);
                  while (bits < 32) {
                    if (have === 0) { break inf_leave; }
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                  }
                  //= ==//
                  if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = 'incorrect length check';
                    state.mode = BAD;
                    break;
                  }
                  //= == INITBITS();
                  hold = 0;
                  bits = 0;
                  //= ==//
                  // Tracev((stderr, "inflate:   length matches trailer\n"));
                }
                state.mode = DONE;
                /* falls through */
              case DONE:
                ret = Z_STREAM_END;
                break inf_leave;
              case BAD:
                ret = Z_DATA_ERROR;
                break inf_leave;
              case MEM:
                return Z_MEM_ERROR;
              case SYNC:
                /* falls through */
              default:
                return Z_STREAM_ERROR;
            }
          }

          // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

          /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */

          // --- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---

          if (state.wsize || (_out !== strm.avail_out && state.mode < BAD
                      && (state.mode < CHECK || flush !== Z_FINISH))) {
            if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
              state.mode = MEM;
              return Z_MEM_ERROR;
            }
          }
          _in -= strm.avail_in;
          _out -= strm.avail_out;
          strm.total_in += _in;
          strm.total_out += _out;
          state.total += _out;
          if (state.wrap && _out) {
            strm.adler = state.check = /* UPDATE(state.check, strm.next_out - _out, _out); */
      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
          }
          strm.data_type = state.bits + (state.last ? 64 : 0)
                    + (state.mode === TYPE ? 128 : 0)
                    + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
          if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
            ret = Z_BUF_ERROR;
          }
          return ret;
        }

        function inflateEnd(strm) {
          if (!strm || !strm.state /* || strm->zfree == (free_func)0 */) {
            return Z_STREAM_ERROR;
          }

          const { state } = strm;
          if (state.window) {
            state.window = null;
          }
          strm.state = null;
          return Z_OK;
        }

        function inflateGetHeader(strm, head) {
          let state;

          /* check state */
          if (!strm || !strm.state) { return Z_STREAM_ERROR; }
          state = strm.state;
          if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }

          /* save header structure */
          state.head = head;
          head.done = false;
          return Z_OK;
        }

        function inflateSetDictionary(strm, dictionary) {
          const dictLength = dictionary.length;

          let state;
          let dictid;
          let ret;

          /* check state */
          if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
          state = strm.state;

          if (state.wrap !== 0 && state.mode !== DICT) {
            return Z_STREAM_ERROR;
          }

          /* check for correct dictionary identifier */
          if (state.mode === DICT) {
            dictid = 1; /* adler32(0, null, 0) */
            /* dictid = adler32(dictid, dictionary, dictLength); */
            dictid = adler32(dictid, dictionary, dictLength, 0);
            if (dictid !== state.check) {
              return Z_DATA_ERROR;
            }
          }
          /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */
          ret = updatewindow(strm, dictionary, dictLength, dictLength);
          if (ret) {
            state.mode = MEM;
            return Z_MEM_ERROR;
          }
          state.havedict = 1;
          // Tracev((stderr, "inflate:   dictionary set\n"));
          return Z_OK;
        }

        exports.inflateReset = inflateReset;
        exports.inflateReset2 = inflateReset2;
        exports.inflateResetKeep = inflateResetKeep;
        exports.inflateInit = inflateInit;
        exports.inflateInit2 = inflateInit2;
        exports.inflate = inflate;
        exports.inflateEnd = inflateEnd;
        exports.inflateGetHeader = inflateGetHeader;
        exports.inflateSetDictionary = inflateSetDictionary;
        exports.inflateInfo = 'pako inflate (from Nodeca project)';

        /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/
        /***/ }),

      /***/ 1375:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        // (C) 1995-2013 Jean-loup Gailly and Mark Adler
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.

        const utils = __webpack_require__(6907);

        const MAXBITS = 15;
        const ENOUGH_LENS = 852;
        const ENOUGH_DISTS = 592;
        // var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

        const CODES = 0;
        const LENS = 1;
        const DISTS = 2;

        const lbase = [ /* Length codes 257..285 base */
          3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
          35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0,
        ];

        const lext = [ /* Length codes 257..285 extra */
          16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
          19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78,
        ];

        const dbase = [ /* Distance codes 0..29 base */
          1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
          257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
          8193, 12289, 16385, 24577, 0, 0,
        ];

        const dext = [ /* Distance codes 0..29 extra */
          16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
          23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
          28, 28, 29, 29, 64, 64,
        ];

        module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
          const { bits } = opts;
          // here = opts.here; /* table entry for duplication */

          let len = 0; /* a code's length in bits */
          let sym = 0; /* index of code symbols */
          let min = 0; let
            max = 0; /* minimum and maximum code lengths */
          let root = 0; /* number of index bits for root table */
          let curr = 0; /* number of index bits for current table */
          let drop = 0; /* code bits to drop for sub-table */
          let left = 0; /* number of prefix codes available */
          let used = 0; /* code entries in table used */
          let huff = 0; /* Huffman code */
          let incr; /* for incrementing code, index */
          let fill; /* index for replicating entries */
          let low; /* low bits for current root entry */
          let mask; /* mask for low root bits */
          let next; /* next available space in table */
          let base = null; /* base value table to use */
          let base_index = 0;
          //  var shoextra;    /* extra bits table to use */
          let end; /* use base and extra for symbol > end */
          const count = new utils.Buf16(MAXBITS + 1); // [MAXBITS+1];    /* number of codes of each length */
          const offs = new utils.Buf16(MAXBITS + 1); // [MAXBITS+1];     /* offsets in table for each length */
          let extra = null;
          let extra_index = 0;

          let here_bits; let here_op; let
            here_val;

          /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */

          /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
          for (len = 0; len <= MAXBITS; len++) {
            count[len] = 0;
          }
          for (sym = 0; sym < codes; sym++) {
            count[lens[lens_index + sym]]++;
          }

          /* bound code lengths, force root to be within code lengths */
          root = bits;
          for (max = MAXBITS; max >= 1; max--) {
            if (count[max] !== 0) { break; }
          }
          if (root > max) {
            root = max;
          }
          if (max === 0) { /* no symbols to code at all */
            // table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
            // table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
            // table.val[opts.table_index++] = 0;   //here.val = (var short)0;
            table[table_index++] = (1 << 24) | (64 << 16) | 0;

            // table.op[opts.table_index] = 64;
            // table.bits[opts.table_index] = 1;
            // table.val[opts.table_index++] = 0;
            table[table_index++] = (1 << 24) | (64 << 16) | 0;

            opts.bits = 1;
            return 0; /* no symbols, but wait for decoding to report error */
          }
          for (min = 1; min < max; min++) {
            if (count[min] !== 0) { break; }
          }
          if (root < min) {
            root = min;
          }

          /* check for an over-subscribed or incomplete set of lengths */
          left = 1;
          for (len = 1; len <= MAXBITS; len++) {
            left <<= 1;
            left -= count[len];
            if (left < 0) {
              return -1;
            } /* over-subscribed */
          }
          if (left > 0 && (type === CODES || max !== 1)) {
            return -1; /* incomplete set */
          }

          /* generate offsets into symbol table for each length for sorting */
          offs[1] = 0;
          for (len = 1; len < MAXBITS; len++) {
            offs[len + 1] = offs[len] + count[len];
          }

          /* sort symbols by length, by symbol order within each length */
          for (sym = 0; sym < codes; sym++) {
            if (lens[lens_index + sym] !== 0) {
              work[offs[lens[lens_index + sym]]++] = sym;
            }
          }

          /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */

          /* set up for code type */
          // poor man optimization - use if-else instead of switch,
          // to avoid deopts in old v8
          if (type === CODES) {
            base = extra = work; /* dummy value--not used */
            end = 19;
          } else if (type === LENS) {
            base = lbase;
            base_index -= 257;
            extra = lext;
            extra_index -= 257;
            end = 256;
          } else { /* DISTS */
            base = dbase;
            extra = dext;
            end = -1;
          }

          /* initialize opts for loop */
          huff = 0; /* starting code */
          sym = 0; /* starting code symbol */
          len = min; /* starting code length */
          next = table_index; /* current table to fill in */
          curr = root; /* current table index bits */
          drop = 0; /* current bits to drop from code for index */
          low = -1; /* trigger new sub-table when len > root */
          used = 1 << root; /* use root table entries */
          mask = used - 1; /* mask for comparing low */

          /* check available table space */
          if ((type === LENS && used > ENOUGH_LENS)
    || (type === DISTS && used > ENOUGH_DISTS)) {
            return 1;
          }

          /* process all codes and make table entries */
          for (;;) {
            /* create table entry */
            here_bits = len - drop;
            if (work[sym] < end) {
              here_op = 0;
              here_val = work[sym];
            } else if (work[sym] > end) {
              here_op = extra[extra_index + work[sym]];
              here_val = base[base_index + work[sym]];
            } else {
              here_op = 32 + 64; /* end of block */
              here_val = 0;
            }

            /* replicate for those indices with low len bits equal to huff */
            incr = 1 << (len - drop);
            fill = 1 << curr;
            min = fill; /* save offset to next table */
            do {
              fill -= incr;
              table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val | 0;
            } while (fill !== 0);

            /* backwards increment the len-bit code huff */
            incr = 1 << (len - 1);
            while (huff & incr) {
              incr >>= 1;
            }
            if (incr !== 0) {
              huff &= incr - 1;
              huff += incr;
            } else {
              huff = 0;
            }

            /* go to next symbol, update count, len */
            sym++;
            if (--count[len] === 0) {
              if (len === max) { break; }
              len = lens[lens_index + work[sym]];
            }

            /* create new sub-table if needed */
            if (len > root && (huff & mask) !== low) {
              /* if first time, transition to sub-tables */
              if (drop === 0) {
                drop = root;
              }

              /* increment past last table */
              next += min; /* here min is 1 << curr */

              /* determine length of next table */
              curr = len - drop;
              left = 1 << curr;
              while (curr + drop < max) {
                left -= count[curr + drop];
                if (left <= 0) { break; }
                curr++;
                left <<= 1;
              }

              /* check for enough space */
              used += 1 << curr;
              if ((type === LENS && used > ENOUGH_LENS)
        || (type === DISTS && used > ENOUGH_DISTS)) {
                return 1;
              }

              /* point entry in root table to sub-table */
              low = huff & mask;
              /* table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index; */
              table[low] = (root << 24) | (curr << 16) | (next - table_index) | 0;
            }
          }

          /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */
          if (huff !== 0) {
            // table.op[next + huff] = 64;            /* invalid code marker */
            // table.bits[next + huff] = len - drop;
            // table.val[next + huff] = 0;
            table[next + huff] = ((len - drop) << 24) | (64 << 16) | 0;
          }

          /* set return parameters */
          // opts.table_index += used;
          opts.bits = root;
          return 0;
        };
        /***/ }),

      /***/ 9364:
      /***/ (function (module) {
        // (C) 1995-2013 Jean-loup Gailly and Mark Adler
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.

        module.exports = {
          2: 'need dictionary', /* Z_NEED_DICT       2  */
          1: 'stream end', /* Z_STREAM_END      1  */
          0: '', /* Z_OK              0  */
          '-1': 'file error', /* Z_ERRNO         (-1) */
          '-2': 'stream error', /* Z_STREAM_ERROR  (-2) */
          '-3': 'data error', /* Z_DATA_ERROR    (-3) */
          '-4': 'insufficient memory', /* Z_MEM_ERROR     (-4) */
          '-5': 'buffer error', /* Z_BUF_ERROR     (-5) */
          '-6': 'incompatible version', /* Z_VERSION_ERROR (-6) */
        };
        /***/ }),

      /***/ 1339:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        // (C) 1995-2013 Jean-loup Gailly and Mark Adler
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.

        /* eslint-disable space-unary-ops */

        const utils = __webpack_require__(6907);

        /* Public constants ========================================================== */
        /* =========================================================================== */

        // var Z_FILTERED          = 1;
        // var Z_HUFFMAN_ONLY      = 2;
        // var Z_RLE               = 3;
        const Z_FIXED = 4;
        // var Z_DEFAULT_STRATEGY  = 0;

        /* Possible values of the data_type field (though see inflate()) */
        const Z_BINARY = 0;
        const Z_TEXT = 1;
        // var Z_ASCII             = 1; // = Z_TEXT
        const Z_UNKNOWN = 2;

        /*= =========================================================================== */

        function zero(buf) { let len = buf.length; while (--len >= 0) { buf[len] = 0; } }

        // From zutil.h

        const STORED_BLOCK = 0;
        const STATIC_TREES = 1;
        const DYN_TREES = 2;
        /* The three kinds of block type */

        const MIN_MATCH = 3;
        const MAX_MATCH = 258;
        /* The minimum and maximum match lengths */

        // From deflate.h
        /* ===========================================================================
 * Internal compression state.
 */

        const LENGTH_CODES = 29;
        /* number of length codes, not counting the special END_BLOCK code */

        const LITERALS = 256;
        /* number of literal bytes 0..255 */

        const L_CODES = LITERALS + 1 + LENGTH_CODES;
        /* number of Literal or Length codes, including the END_BLOCK code */

        const D_CODES = 30;
        /* number of distance codes */

        const BL_CODES = 19;
        /* number of codes used to transfer the bit lengths */

        const HEAP_SIZE = 2 * L_CODES + 1;
        /* maximum heap size */

        const MAX_BITS = 15;
        /* All codes must not exceed MAX_BITS bits */

        const Buf_size = 16;
        /* size of bit buffer in bi_buf */

        /* ===========================================================================
 * Constants
 */

        const MAX_BL_BITS = 7;
        /* Bit length codes must not exceed MAX_BL_BITS bits */

        const END_BLOCK = 256;
        /* end of block literal code */

        const REP_3_6 = 16;
        /* repeat previous bit length 3-6 times (2 bits of repeat count) */

        const REPZ_3_10 = 17;
        /* repeat a zero length 3-10 times  (3 bits of repeat count) */

        const REPZ_11_138 = 18;
        /* repeat a zero length 11-138 times  (7 bits of repeat count) */

        /* eslint-disable comma-spacing,array-bracket-spacing */
        const extra_lbits = /* extra bits for each length code */
  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];

        const extra_dbits = /* extra bits for each distance code */
  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];

        const extra_blbits = /* extra bits for each bit length code */
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];

        const bl_order = [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
        /* eslint-enable comma-spacing,array-bracket-spacing */

        /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

        /* ===========================================================================
 * Local data. These are initialized only once.
 */

        // We pre-fill arrays with 0 to avoid uninitialized gaps

        const DIST_CODE_LEN = 512; /* see definition of array dist_code below */

        // !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
        const static_ltree = new Array((L_CODES + 2) * 2);
        zero(static_ltree);
        /* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

        const static_dtree = new Array(D_CODES * 2);
        zero(static_dtree);
        /* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

        const _dist_code = new Array(DIST_CODE_LEN);
        zero(_dist_code);
        /* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

        const _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);
        zero(_length_code);
        /* length code for each normalized match length (0 == MIN_MATCH) */

        const base_length = new Array(LENGTH_CODES);
        zero(base_length);
        /* First normalized length for each code (0 = MIN_MATCH) */

        const base_dist = new Array(D_CODES);
        zero(base_dist);
        /* First normalized distance for each code (0 = distance of 1) */

        function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
          this.static_tree = static_tree; /* static tree or NULL */
          this.extra_bits = extra_bits; /* extra bits for each code or NULL */
          this.extra_base = extra_base; /* base index for extra_bits */
          this.elems = elems; /* max number of elements in the tree */
          this.max_length = max_length; /* max bit length for the codes */

          // show if `static_tree` has data or dummy - needed for monomorphic objects
          this.has_stree = static_tree && static_tree.length;
        }

        let static_l_desc;
        let static_d_desc;
        let static_bl_desc;

        function TreeDesc(dyn_tree, stat_desc) {
          this.dyn_tree = dyn_tree; /* the dynamic tree */
          this.max_code = 0; /* largest code with non zero frequency */
          this.stat_desc = stat_desc; /* the corresponding static tree */
        }

        function d_code(dist) {
          return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
        }

        /* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
        function put_short(s, w) {
          //    put_byte(s, (uch)((w) & 0xff));
          //    put_byte(s, (uch)((ush)(w) >> 8));
          s.pending_buf[s.pending++] = (w) & 0xff;
          s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
        }

        /* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
        function send_bits(s, value, length) {
          if (s.bi_valid > (Buf_size - length)) {
            s.bi_buf |= (value << s.bi_valid) & 0xffff;
            put_short(s, s.bi_buf);
            s.bi_buf = value >> (Buf_size - s.bi_valid);
            s.bi_valid += length - Buf_size;
          } else {
            s.bi_buf |= (value << s.bi_valid) & 0xffff;
            s.bi_valid += length;
          }
        }

        function send_code(s, c, tree) {
          send_bits(s, tree[c * 2]/* .Code */, tree[c * 2 + 1]/* .Len */);
        }

        /* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
        function bi_reverse(code, len) {
          let res = 0;
          do {
            res |= code & 1;
            code >>>= 1;
            res <<= 1;
          } while (--len > 0);
          return res >>> 1;
        }

        /* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
        function bi_flush(s) {
          if (s.bi_valid === 16) {
            put_short(s, s.bi_buf);
            s.bi_buf = 0;
            s.bi_valid = 0;
          } else if (s.bi_valid >= 8) {
            s.pending_buf[s.pending++] = s.bi_buf & 0xff;
            s.bi_buf >>= 8;
            s.bi_valid -= 8;
          }
        }

        /* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
        function gen_bitlen(s, desc)
        //    deflate_state *s;
        //    tree_desc *desc;    /* the tree descriptor */
        {
          const tree = desc.dyn_tree;
          const { max_code } = desc;
          const stree = desc.stat_desc.static_tree;
          const { has_stree } = desc.stat_desc;
          const extra = desc.stat_desc.extra_bits;
          const base = desc.stat_desc.extra_base;
          const { max_length } = desc.stat_desc;
          let h; /* heap index */
          let n; let
            m; /* iterate over the tree elements */
          let bits; /* bit length */
          let xbits; /* extra bits */
          let f; /* frequency */
          let overflow = 0; /* number of elements with bit length too large */

          for (bits = 0; bits <= MAX_BITS; bits++) {
            s.bl_count[bits] = 0;
          }

          /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
          tree[s.heap[s.heap_max] * 2 + 1]/* .Len */ = 0; /* root of the heap */

          for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
            n = s.heap[h];
            bits = tree[tree[n * 2 + 1]/* .Dad */ * 2 + 1]/* .Len */ + 1;
            if (bits > max_length) {
              bits = max_length;
              overflow++;
            }
            tree[n * 2 + 1]/* .Len */ = bits;
            /* We overwrite tree[n].Dad which is no longer needed */

            if (n > max_code) { continue; } /* not a leaf node */

            s.bl_count[bits]++;
            xbits = 0;
            if (n >= base) {
              xbits = extra[n - base];
            }
            f = tree[n * 2]/* .Freq */;
            s.opt_len += f * (bits + xbits);
            if (has_stree) {
              s.static_len += f * (stree[n * 2 + 1]/* .Len */ + xbits);
            }
          }
          if (overflow === 0) { return; }

          // Trace((stderr,"\nbit length overflow\n"));
          /* This happens for example on obj2 and pic of the Calgary corpus */

          /* Find the first bit length which could increase: */
          do {
            bits = max_length - 1;
            while (s.bl_count[bits] === 0) { bits--; }
            s.bl_count[bits]--; /* move one leaf down the tree */
            s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
            s.bl_count[max_length]--;
            /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
            overflow -= 2;
          } while (overflow > 0);

          /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
          for (bits = max_length; bits !== 0; bits--) {
            n = s.bl_count[bits];
            while (n !== 0) {
              m = s.heap[--h];
              if (m > max_code) { continue; }
              if (tree[m * 2 + 1]/* .Len */ !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]/* .Len */) * tree[m * 2]/* .Freq */;
                tree[m * 2 + 1]/* .Len */ = bits;
              }
              n--;
            }
          }
        }

        /* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
        function gen_codes(tree, max_code, bl_count)
        //    ct_data *tree;             /* the tree to decorate */
        //    int max_code;              /* largest code with non zero frequency */
        //    ushf *bl_count;            /* number of codes at each bit length */
        {
          const next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
          let code = 0; /* running code value */
          let bits; /* bit index */
          let n; /* code index */

          /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
          for (bits = 1; bits <= MAX_BITS; bits++) {
            next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
          }
          /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
          // Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
          //        "inconsistent bit counts");
          // Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

          for (n = 0; n <= max_code; n++) {
            const len = tree[n * 2 + 1]/* .Len */;
            if (len === 0) { continue; }
            /* Now reverse the bits */
            tree[n * 2]/* .Code */ = bi_reverse(next_code[len]++, len);

            // Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
            //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
          }
        }

        /* ===========================================================================
 * Initialize the various 'constant' tables.
 */
        function tr_static_init() {
          let n; /* iterates over tree elements */
          let bits; /* bit counter */
          let length; /* length value */
          let code; /* code value */
          let dist; /* distance index */
          const bl_count = new Array(MAX_BITS + 1);
          /* number of codes at each bit length for an optimal tree */

          // do check in _tr_init()
          // if (static_init_done) return;

          /* For some embedded targets, global variables are not initialized: */
          /* #ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif */

          /* Initialize the mapping length (0..255) -> length code (0..28) */
          length = 0;
          for (code = 0; code < LENGTH_CODES - 1; code++) {
            base_length[code] = length;
            for (n = 0; n < (1 << extra_lbits[code]); n++) {
              _length_code[length++] = code;
            }
          }
          // Assert (length == 256, "tr_static_init: length != 256");
          /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
          _length_code[length - 1] = code;

          /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
          dist = 0;
          for (code = 0; code < 16; code++) {
            base_dist[code] = dist;
            for (n = 0; n < (1 << extra_dbits[code]); n++) {
              _dist_code[dist++] = code;
            }
          }
          // Assert (dist == 256, "tr_static_init: dist != 256");
          dist >>= 7; /* from now on, all distances are divided by 128 */
          for (; code < D_CODES; code++) {
            base_dist[code] = dist << 7;
            for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
              _dist_code[256 + dist++] = code;
            }
          }
          // Assert (dist == 256, "tr_static_init: 256+dist != 512");

          /* Construct the codes of the static literal tree */
          for (bits = 0; bits <= MAX_BITS; bits++) {
            bl_count[bits] = 0;
          }

          n = 0;
          while (n <= 143) {
            static_ltree[n * 2 + 1]/* .Len */ = 8;
            n++;
            bl_count[8]++;
          }
          while (n <= 255) {
            static_ltree[n * 2 + 1]/* .Len */ = 9;
            n++;
            bl_count[9]++;
          }
          while (n <= 279) {
            static_ltree[n * 2 + 1]/* .Len */ = 7;
            n++;
            bl_count[7]++;
          }
          while (n <= 287) {
            static_ltree[n * 2 + 1]/* .Len */ = 8;
            n++;
            bl_count[8]++;
          }
          /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
          gen_codes(static_ltree, L_CODES + 1, bl_count);

          /* The static distance tree is trivial: */
          for (n = 0; n < D_CODES; n++) {
            static_dtree[n * 2 + 1]/* .Len */ = 5;
            static_dtree[n * 2]/* .Code */ = bi_reverse(n, 5);
          }

          // Now data ready and we can init static trees
          static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
          static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
          static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS);

          // static_init_done = true;
        }

        /* ===========================================================================
 * Initialize a new block.
 */
        function init_block(s) {
          let n; /* iterates over tree elements */

          /* Initialize the trees. */
          for (n = 0; n < L_CODES; n++) { s.dyn_ltree[n * 2]/* .Freq */ = 0; }
          for (n = 0; n < D_CODES; n++) { s.dyn_dtree[n * 2]/* .Freq */ = 0; }
          for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/* .Freq */ = 0; }

          s.dyn_ltree[END_BLOCK * 2]/* .Freq */ = 1;
          s.opt_len = s.static_len = 0;
          s.last_lit = s.matches = 0;
        }

        /* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
        function bi_windup(s) {
          if (s.bi_valid > 8) {
            put_short(s, s.bi_buf);
          } else if (s.bi_valid > 0) {
            // put_byte(s, (Byte)s->bi_buf);
            s.pending_buf[s.pending++] = s.bi_buf;
          }
          s.bi_buf = 0;
          s.bi_valid = 0;
        }

        /* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */
        function copy_block(s, buf, len, header)
        // DeflateState *s;
        // charf    *buf;    /* the input data */
        // unsigned len;     /* its length */
        // int      header;  /* true if block header must be written */
        {
          bi_windup(s); /* align on byte boundary */

          if (header) {
            put_short(s, len);
            put_short(s, ~len);
          }
          //  while (len--) {
          //    put_byte(s, *buf++);
          //  }
          utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
          s.pending += len;
        }

        /* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
        function smaller(tree, n, m, depth) {
          const _n2 = n * 2;
          const _m2 = m * 2;
          return (tree[_n2]/* .Freq */ < tree[_m2]
         ||/* .Freq */ (tree[_n2]/* .Freq */ === tree[_m2]/* .Freq */ && depth[n] <= depth[m]));
        }

        /* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
        function pqdownheap(s, tree, k)
        //    deflate_state *s;
        //    ct_data *tree;  /* the tree to restore */
        //    int k;               /* node to move down */
        {
          const v = s.heap[k];
          let j = k << 1; /* left son of k */
          while (j <= s.heap_len) {
            /* Set j to the smallest of the two sons: */
            if (j < s.heap_len
      && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
              j++;
            }
            /* Exit if v is smaller than both sons */
            if (smaller(tree, v, s.heap[j], s.depth)) { break; }

            /* Exchange v with the smallest son */
            s.heap[k] = s.heap[j];
            k = j;

            /* And continue down the tree, setting j to the left son of k */
            j <<= 1;
          }
          s.heap[k] = v;
        }

        // inlined manually
        // var SMALLEST = 1;

        /* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
        function compress_block(s, ltree, dtree)
        //    deflate_state *s;
        //    const ct_data *ltree; /* literal tree */
        //    const ct_data *dtree; /* distance tree */
        {
          let dist; /* distance of matched string */
          let lc; /* match length or unmatched char (if dist == 0) */
          let lx = 0; /* running index in l_buf */
          let code; /* the code to send */
          let extra; /* number of extra bits to send */

          if (s.last_lit !== 0) {
            do {
              dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
              lc = s.pending_buf[s.l_buf + lx];
              lx++;

              if (dist === 0) {
                send_code(s, lc, ltree); /* send a literal byte */
                // Tracecv(isgraph(lc), (stderr," '%c' ", lc));
              } else {
                /* Here, lc is the match length - MIN_MATCH */
                code = _length_code[lc];
                send_code(s, code + LITERALS + 1, ltree); /* send the length code */
                extra = extra_lbits[code];
                if (extra !== 0) {
                  lc -= base_length[code];
                  send_bits(s, lc, extra); /* send the extra length bits */
                }
                dist--; /* dist is now the match distance - 1 */
                code = d_code(dist);
                // Assert (code < D_CODES, "bad d_code");

                send_code(s, code, dtree); /* send the distance code */
                extra = extra_dbits[code];
                if (extra !== 0) {
                  dist -= base_dist[code];
                  send_bits(s, dist, extra); /* send the extra distance bits */
                }
              } /* literal or match pair ? */

              /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
              // Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
              //       "pendingBuf overflow");
            } while (lx < s.last_lit);
          }

          send_code(s, END_BLOCK, ltree);
        }

        /* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
        function build_tree(s, desc)
        //    deflate_state *s;
        //    tree_desc *desc; /* the tree descriptor */
        {
          const tree = desc.dyn_tree;
          const stree = desc.stat_desc.static_tree;
          const { has_stree } = desc.stat_desc;
          const { elems } = desc.stat_desc;
          let n; let
            m; /* iterate over heap elements */
          let max_code = -1; /* largest code with non zero frequency */
          let node; /* new node being created */

          /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
          s.heap_len = 0;
          s.heap_max = HEAP_SIZE;

          for (n = 0; n < elems; n++) {
            if (tree[n * 2]/* .Freq */ !== 0) {
              s.heap[++s.heap_len] = max_code = n;
              s.depth[n] = 0;
            } else {
              tree[n * 2 + 1]/* .Len */ = 0;
            }
          }

          /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
          while (s.heap_len < 2) {
            node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
            tree[node * 2]/* .Freq */ = 1;
            s.depth[node] = 0;
            s.opt_len--;

            if (has_stree) {
              s.static_len -= stree[node * 2 + 1]/* .Len */;
            }
            /* node is 0 or 1 so it does not have extra bits */
          }
          desc.max_code = max_code;

          /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
          for (n = (s.heap_len >> 1/* int /2 */); n >= 1; n--) { pqdownheap(s, tree, n); }

          /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
          node = elems; /* next internal node of the tree */
          do {
            // pqremove(s, tree, n);  /* n = node of least frequency */
            /** * pqremove ** */
            n = s.heap[1/* SMALLEST */];
            s.heap[1/* SMALLEST */] = s.heap[s.heap_len--];
            pqdownheap(s, tree, 1/* SMALLEST */);
            /***/

            m = s.heap[1/* SMALLEST */]; /* m = node of next least frequency */

            s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
            s.heap[--s.heap_max] = m;

            /* Create a new node father of n and m */
            tree[node * 2]/* .Freq */ = tree[n * 2]/* .Freq */ + tree[m * 2]/* .Freq */;
            s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
            tree[n * 2 + 1]/* .Dad */ = tree[m * 2 + 1]/* .Dad */ = node;

            /* and insert the new node in the heap */
            s.heap[1/* SMALLEST */] = node++;
            pqdownheap(s, tree, 1/* SMALLEST */);
          } while (s.heap_len >= 2);

          s.heap[--s.heap_max] = s.heap[1/* SMALLEST */];

          /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
          gen_bitlen(s, desc);

          /* The field len is now set, we can generate the bit codes */
          gen_codes(tree, max_code, s.bl_count);
        }

        /* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
        function scan_tree(s, tree, max_code)
        //    deflate_state *s;
        //    ct_data *tree;   /* the tree to be scanned */
        //    int max_code;    /* and its largest code of non zero frequency */
        {
          let n; /* iterates over all tree elements */
          let prevlen = -1; /* last emitted length */
          let curlen; /* length of current code */

          let nextlen = tree[0 * 2 + 1]/* .Len */; /* length of next code */

          let count = 0; /* repeat count of the current code */
          let max_count = 7; /* max repeat count */
          let min_count = 4; /* min repeat count */

          if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
          }
          tree[(max_code + 1) * 2 + 1]/* .Len */ = 0xffff; /* guard */

          for (n = 0; n <= max_code; n++) {
            curlen = nextlen;
            nextlen = tree[(n + 1) * 2 + 1]/* .Len */;

            if (++count < max_count && curlen === nextlen) {
              continue;
            } else if (count < min_count) {
              s.bl_tree[curlen * 2]/* .Freq */ += count;
            } else if (curlen !== 0) {
              if (curlen !== prevlen) { s.bl_tree[curlen * 2]/* .Freq */++; }
              s.bl_tree[REP_3_6 * 2]/* .Freq */++;
            } else if (count <= 10) {
              s.bl_tree[REPZ_3_10 * 2]/* .Freq */++;
            } else {
              s.bl_tree[REPZ_11_138 * 2]/* .Freq */++;
            }

            count = 0;
            prevlen = curlen;

            if (nextlen === 0) {
              max_count = 138;
              min_count = 3;
            } else if (curlen === nextlen) {
              max_count = 6;
              min_count = 3;
            } else {
              max_count = 7;
              min_count = 4;
            }
          }
        }

        /* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
        function send_tree(s, tree, max_code)
        //    deflate_state *s;
        //    ct_data *tree; /* the tree to be scanned */
        //    int max_code;       /* and its largest code of non zero frequency */
        {
          let n; /* iterates over all tree elements */
          let prevlen = -1; /* last emitted length */
          let curlen; /* length of current code */

          let nextlen = tree[0 * 2 + 1]/* .Len */; /* length of next code */

          let count = 0; /* repeat count of the current code */
          let max_count = 7; /* max repeat count */
          let min_count = 4; /* min repeat count */

          /* tree[max_code+1].Len = -1; */ /* guard already set */
          if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
          }

          for (n = 0; n <= max_code; n++) {
            curlen = nextlen;
            nextlen = tree[(n + 1) * 2 + 1]/* .Len */;

            if (++count < max_count && curlen === nextlen) {
              continue;
            } else if (count < min_count) {
              do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);
            } else if (curlen !== 0) {
              if (curlen !== prevlen) {
                send_code(s, curlen, s.bl_tree);
                count--;
              }
              // Assert(count >= 3 && count <= 6, " 3_6?");
              send_code(s, REP_3_6, s.bl_tree);
              send_bits(s, count - 3, 2);
            } else if (count <= 10) {
              send_code(s, REPZ_3_10, s.bl_tree);
              send_bits(s, count - 3, 3);
            } else {
              send_code(s, REPZ_11_138, s.bl_tree);
              send_bits(s, count - 11, 7);
            }

            count = 0;
            prevlen = curlen;
            if (nextlen === 0) {
              max_count = 138;
              min_count = 3;
            } else if (curlen === nextlen) {
              max_count = 6;
              min_count = 3;
            } else {
              max_count = 7;
              min_count = 4;
            }
          }
        }

        /* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
        function build_bl_tree(s) {
          let max_blindex; /* index of last bit length code of non zero freq */

          /* Determine the bit length frequencies for literal and distance trees */
          scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
          scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

          /* Build the bit length tree: */
          build_tree(s, s.bl_desc);
          /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

          /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
          for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
            if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/* .Len */ !== 0) {
              break;
            }
          }
          /* Update opt_len to include the bit length tree and counts */
          s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
          // Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
          //        s->opt_len, s->static_len));

          return max_blindex;
        }

        /* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
        function send_all_trees(s, lcodes, dcodes, blcodes)
        //    deflate_state *s;
        //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
        {
          let rank; /* index in bl_order */

          // Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
          // Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
          //        "too many codes");
          // Tracev((stderr, "\nbl counts: "));
          send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
          send_bits(s, dcodes - 1, 5);
          send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */
          for (rank = 0; rank < blcodes; rank++) {
            // Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
            send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/* .Len */, 3);
          }
          // Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

          send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
          // Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

          send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
          // Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
        }

        /* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
        function detect_data_type(s) {
          /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
          let black_mask = 0xf3ffc07f;
          let n;

          /* Check for non-textual ("black-listed") bytes. */
          for (n = 0; n <= 31; n++, black_mask >>>= 1) {
            if ((black_mask & 1) && (s.dyn_ltree[n * 2]/* .Freq */ !== 0)) {
              return Z_BINARY;
            }
          }

          /* Check for textual ("white-listed") bytes. */
          if (s.dyn_ltree[9 * 2]/* .Freq */ !== 0 || s.dyn_ltree[10 * 2]/* .Freq */ !== 0
      || s.dyn_ltree[13 * 2]/* .Freq */ !== 0) {
            return Z_TEXT;
          }
          for (n = 32; n < LITERALS; n++) {
            if (s.dyn_ltree[n * 2]/* .Freq */ !== 0) {
              return Z_TEXT;
            }
          }

          /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
          return Z_BINARY;
        }

        let static_init_done = false;

        /* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
        function _tr_init(s) {
          if (!static_init_done) {
            tr_static_init();
            static_init_done = true;
          }

          s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
          s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
          s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

          s.bi_buf = 0;
          s.bi_valid = 0;

          /* Initialize the first block of the first file: */
          init_block(s);
        }

        /* ===========================================================================
 * Send a stored block
 */
        function _tr_stored_block(s, buf, stored_len, last)
        // DeflateState *s;
        // charf *buf;       /* input block */
        // ulg stored_len;   /* length of input block */
        // int last;         /* one if this is the last block for a file */
        {
          send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */
          copy_block(s, buf, stored_len, true); /* with header */
        }

        /* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
        function _tr_align(s) {
          send_bits(s, STATIC_TREES << 1, 3);
          send_code(s, END_BLOCK, static_ltree);
          bi_flush(s);
        }

        /* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */
        function _tr_flush_block(s, buf, stored_len, last)
        // DeflateState *s;
        // charf *buf;       /* input block, or NULL if too old */
        // ulg stored_len;   /* length of input block */
        // int last;         /* one if this is the last block for a file */
        {
          let opt_lenb; let
            static_lenb; /* opt_len and static_len in bytes */
          let max_blindex = 0; /* index of last bit length code of non zero freq */

          /* Build the Huffman trees unless a stored block is forced */
          if (s.level > 0) {
            /* Check if the file is binary or text */
            if (s.strm.data_type === Z_UNKNOWN) {
              s.strm.data_type = detect_data_type(s);
            }

            /* Construct the literal and distance trees */
            build_tree(s, s.l_desc);
            // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
            //        s->static_len));

            build_tree(s, s.d_desc);
            // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
            //        s->static_len));
            /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

            /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
            max_blindex = build_bl_tree(s);

            /* Determine the best encoding. Compute the block lengths in bytes. */
            opt_lenb = (s.opt_len + 3 + 7) >>> 3;
            static_lenb = (s.static_len + 3 + 7) >>> 3;

            // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
            //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
            //        s->last_lit));

            if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }
          } else {
            // Assert(buf != (char*)0, "lost buf");
            opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
          }

          if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
            /* 4: two words for the lengths */

            /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
            _tr_stored_block(s, buf, stored_len, last);
          } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
            send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
            compress_block(s, static_ltree, static_dtree);
          } else {
            send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
            send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
            compress_block(s, s.dyn_ltree, s.dyn_dtree);
          }
          // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
          /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
          init_block(s);

          if (last) {
            bi_windup(s);
          }
          // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
          //       s->compressed_len-7*last));
        }

        /* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
        function _tr_tally(s, dist, lc)
        //    deflate_state *s;
        //    unsigned dist;  /* distance of matched string */
        //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
        {
          // var out_length, in_length, dcode;

          s.pending_buf[s.d_buf + s.last_lit * 2] = (dist >>> 8) & 0xff;
          s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;

          s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
          s.last_lit++;

          if (dist === 0) {
            /* lc is the unmatched char */
            s.dyn_ltree[lc * 2]/* .Freq */++;
          } else {
            s.matches++;
            /* Here, lc is the match length - MIN_MATCH */
            dist--; /* dist = match distance - 1 */
            // Assert((ush)dist < (ush)MAX_DIST(s) &&
            //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
            //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

            s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/* .Freq */++;
            s.dyn_dtree[d_code(dist) * 2]/* .Freq */++;
          }

          // (!) This block is disabled in zlib defaults,
          // don't enable it for binary compatibility

          // #ifdef TRUNCATE_BLOCK
          //  /* Try to guess if it is profitable to stop the current block here */
          //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
          //    /* Compute an upper bound for the compressed length */
          //    out_length = s.last_lit*8;
          //    in_length = s.strstart - s.block_start;
          //
          //    for (dcode = 0; dcode < D_CODES; dcode++) {
          //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
          //    }
          //    out_length >>>= 3;
          //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
          //    //       s->last_lit, in_length, out_length,
          //    //       100L - out_length*100L/in_length));
          //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
          //      return true;
          //    }
          //  }
          // #endif

          return (s.last_lit === s.lit_bufsize - 1);
          /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */
        }

        exports._tr_init = _tr_init;
        exports._tr_stored_block = _tr_stored_block;
        exports._tr_flush_block = _tr_flush_block;
        exports._tr_tally = _tr_tally;
        exports._tr_align = _tr_align;
        /***/ }),

      /***/ 4860:
      /***/ (function (module) {
        // (C) 1995-2013 Jean-loup Gailly and Mark Adler
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.

        function ZStream() {
          /* next input byte */
          this.input = null; // JS specific, because we have no pointers
          this.next_in = 0;
          /* number of bytes available at input */
          this.avail_in = 0;
          /* total number of input bytes read so far */
          this.total_in = 0;
          /* next output byte should be put there */
          this.output = null; // JS specific, because we have no pointers
          this.next_out = 0;
          /* remaining free space at output */
          this.avail_out = 0;
          /* total number of bytes output so far */
          this.total_out = 0;
          /* last error message, NULL if no error */
          this.msg = ''/* Z_NULL */;
          /* not visible by applications */
          this.state = null;
          /* best guess about the data type: binary or text */
          this.data_type = 2/* Z_UNKNOWN */;
          /* adler32 value of the uncompressed data */
          this.adler = 0;
        }

        module.exports = ZStream;
        /***/ }),

      /***/ 1924:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const GetIntrinsic = __webpack_require__(210);

        const callBind = __webpack_require__(5559);

        const $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

        module.exports = function callBoundIntrinsic(name, allowMissing) {
          const intrinsic = GetIntrinsic(name, !!allowMissing);
          if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
            return callBind(intrinsic);
          }
          return intrinsic;
        };
        /***/ }),

      /***/ 5559:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const bind = __webpack_require__(8612);
        const GetIntrinsic = __webpack_require__(210);

        const $apply = GetIntrinsic('%Function.prototype.apply%');
        const $call = GetIntrinsic('%Function.prototype.call%');
        const $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

        const $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
        let $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
        const $max = GetIntrinsic('%Math.max%');

        if ($defineProperty) {
          try {
            $defineProperty({}, 'a', { value: 1 });
          } catch (e) {
            // IE 8 has a broken defineProperty
            $defineProperty = null;
          }
        }

        module.exports = function callBind(originalFunction) {
          const func = $reflectApply(bind, $call, arguments);
          if ($gOPD && $defineProperty) {
            const desc = $gOPD(func, 'length');
            if (desc.configurable) {
              // original length, plus the receiver, minus any additional arguments (after the receiver)
              $defineProperty(
                func,
                'length',
                { value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) },
              );
            }
          }
          return func;
        };

        const applyBind = function applyBind() {
          return $reflectApply(bind, $apply, arguments);
        };

        if ($defineProperty) {
          $defineProperty(module.exports, 'apply', { value: applyBind });
        } else {
          module.exports.apply = applyBind;
        }
        /***/ }),

      /***/ 6313:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* provided dependency */ const { Buffer } = __webpack_require__(8823);
        const clone = (function () {
          /**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
*/
          function clone(parent, circular, depth, prototype) {
            let filter;
            if (typeof circular === 'object') {
              depth = circular.depth;
              prototype = circular.prototype;
              filter = circular.filter;
              circular = circular.circular;
            }
            // maintain two arrays for circular references, where corresponding parents
            // and children have the same index
            const allParents = [];
            const allChildren = [];

            const useBuffer = typeof Buffer !== 'undefined';

            if (typeof circular === 'undefined') circular = true;

            if (typeof depth === 'undefined') depth = Infinity;

            // recurse this function so we don't reset allParents and allChildren
            function _clone(parent, depth) {
              // cloning null always returns null
              if (parent === null) return null;

              if (depth == 0) return parent;

              let child;
              let proto;
              if (typeof parent !== 'object') {
                return parent;
              }

              if (clone.__isArray(parent)) {
                child = [];
              } else if (clone.__isRegExp(parent)) {
                child = new RegExp(parent.source, __getRegExpFlags(parent));
                if (parent.lastIndex) child.lastIndex = parent.lastIndex;
              } else if (clone.__isDate(parent)) {
                child = new Date(parent.getTime());
              } else if (useBuffer && Buffer.isBuffer(parent)) {
                if (Buffer.allocUnsafe) {
                  // Node.js >= 4.5.0
                  child = Buffer.allocUnsafe(parent.length);
                } else {
                  // Older Node.js versions
                  child = new Buffer(parent.length);
                }
                parent.copy(child);
                return child;
              } else if (typeof prototype === 'undefined') {
                proto = Object.getPrototypeOf(parent);
                child = Object.create(proto);
              } else {
                child = Object.create(prototype);
                proto = prototype;
              }

              if (circular) {
                const index = allParents.indexOf(parent);

                if (index != -1) {
                  return allChildren[index];
                }
                allParents.push(parent);
                allChildren.push(child);
              }

              for (const i in parent) {
                var attrs;
                if (proto) {
                  attrs = Object.getOwnPropertyDescriptor(proto, i);
                }

                if (attrs && attrs.set == null) {
                  continue;
                }
                child[i] = _clone(parent[i], depth - 1);
              }

              return child;
            }

            return _clone(parent, depth);
          }

          /**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */
          clone.clonePrototype = function clonePrototype(parent) {
            if (parent === null) return null;

            const c = function () {};
            c.prototype = parent;
            return new c();
          };

          // private utility functions

          function __objToStr(o) {
            return Object.prototype.toString.call(o);
          }
          clone.__objToStr = __objToStr;

          function __isDate(o) {
            return typeof o === 'object' && __objToStr(o) === '[object Date]';
          }
          clone.__isDate = __isDate;

          function __isArray(o) {
            return typeof o === 'object' && __objToStr(o) === '[object Array]';
          }
          clone.__isArray = __isArray;

          function __isRegExp(o) {
            return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
          }
          clone.__isRegExp = __isRegExp;

          function __getRegExpFlags(re) {
            let flags = '';
            if (re.global) flags += 'g';
            if (re.ignoreCase) flags += 'i';
            if (re.multiline) flags += 'm';
            return flags;
          }
          clone.__getRegExpFlags = __getRegExpFlags;

          return clone;
        }());

        if (true && module.exports) {
          module.exports = clone;
        }
        /***/ }),

      /***/ 4667:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        __webpack_require__(2479);
        const path = __webpack_require__(857);

        module.exports = path.Object.values;
        /***/ }),

      /***/ 7633:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        __webpack_require__(9170);
        __webpack_require__(6992);
        __webpack_require__(1539);
        __webpack_require__(8674);
        __webpack_require__(7922);
        __webpack_require__(4668);
        __webpack_require__(7727);
        __webpack_require__(8783);
        const path = __webpack_require__(857);

        module.exports = path.Promise;
        /***/ }),

      /***/ 3867:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const parent = __webpack_require__(1150);
        __webpack_require__(8628);
        // TODO: Remove from `core-js@4`
        __webpack_require__(7314);
        __webpack_require__(7479);
        __webpack_require__(6290);

        module.exports = parent;
        /***/ }),

      /***/ 9662:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const isCallable = __webpack_require__(614);
        const tryToString = __webpack_require__(6330);

        const { TypeError } = global;

        // `Assert: IsCallable(argument) is true`
        module.exports = function (argument) {
          if (isCallable(argument)) return argument;
          throw TypeError(`${tryToString(argument)} is not a function`);
        };
        /***/ }),

      /***/ 9483:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const isConstructor = __webpack_require__(4411);
        const tryToString = __webpack_require__(6330);

        const { TypeError } = global;

        // `Assert: IsConstructor(argument) is true`
        module.exports = function (argument) {
          if (isConstructor(argument)) return argument;
          throw TypeError(`${tryToString(argument)} is not a constructor`);
        };
        /***/ }),

      /***/ 6077:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const isCallable = __webpack_require__(614);

        const { String } = global;
        const { TypeError } = global;

        module.exports = function (argument) {
          if (typeof argument === 'object' || isCallable(argument)) return argument;
          throw TypeError(`Can't set ${String(argument)} as a prototype`);
        };
        /***/ }),

      /***/ 1223:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const wellKnownSymbol = __webpack_require__(5112);
        const create = __webpack_require__(30);
        const definePropertyModule = __webpack_require__(3070);

        const UNSCOPABLES = wellKnownSymbol('unscopables');
        const ArrayPrototype = Array.prototype;

        // Array.prototype[@@unscopables]
        // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
        if (ArrayPrototype[UNSCOPABLES] == undefined) {
          definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
            configurable: true,
            value: create(null),
          });
        }

        // add a key to Array.prototype[@@unscopables]
        module.exports = function (key) {
          ArrayPrototype[UNSCOPABLES][key] = true;
        };
        /***/ }),

      /***/ 1530:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const { charAt } = __webpack_require__(8710);

        // `AdvanceStringIndex` abstract operation
        // https://tc39.es/ecma262/#sec-advancestringindex
        module.exports = function (S, index, unicode) {
          return index + (unicode ? charAt(S, index).length : 1);
        };
        /***/ }),

      /***/ 5787:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const isPrototypeOf = __webpack_require__(7976);

        const { TypeError } = global;

        module.exports = function (it, Prototype) {
          if (isPrototypeOf(Prototype, it)) return it;
          throw TypeError('Incorrect invocation');
        };
        /***/ }),

      /***/ 9670:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const isObject = __webpack_require__(111);

        const { String } = global;
        const { TypeError } = global;

        // `Assert: Type(argument) is Object`
        module.exports = function (argument) {
          if (isObject(argument)) return argument;
          throw TypeError(`${String(argument)} is not an object`);
        };
        /***/ }),

      /***/ 1048:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const toObject = __webpack_require__(7908);
        const toAbsoluteIndex = __webpack_require__(1400);
        const lengthOfArrayLike = __webpack_require__(6244);

        const { min } = Math;

        // `Array.prototype.copyWithin` method implementation
        // https://tc39.es/ecma262/#sec-array.prototype.copywithin
        // eslint-disable-next-line es/no-array-prototype-copywithin -- safe
        module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
          const O = toObject(this);
          const len = lengthOfArrayLike(O);
          let to = toAbsoluteIndex(target, len);
          let from = toAbsoluteIndex(start, len);
          const end = arguments.length > 2 ? arguments[2] : undefined;
          let count = min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
          let inc = 1;
          if (from < to && to < from + count) {
            inc = -1;
            from += count - 1;
            to += count - 1;
          }
          while (count-- > 0) {
            if (from in O) O[to] = O[from];
            else delete O[to];
            to += inc;
            from += inc;
          } return O;
        };
        /***/ }),

      /***/ 1285:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const toObject = __webpack_require__(7908);
        const toAbsoluteIndex = __webpack_require__(1400);
        const lengthOfArrayLike = __webpack_require__(6244);

        // `Array.prototype.fill` method implementation
        // https://tc39.es/ecma262/#sec-array.prototype.fill
        module.exports = function fill(value /* , start = 0, end = @length */) {
          const O = toObject(this);
          const length = lengthOfArrayLike(O);
          const argumentsLength = arguments.length;
          let index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
          const end = argumentsLength > 2 ? arguments[2] : undefined;
          const endPos = end === undefined ? length : toAbsoluteIndex(end, length);
          while (endPos > index) O[index++] = value;
          return O;
        };
        /***/ }),

      /***/ 8533:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const $forEach = (__webpack_require__(2092).forEach);
        const arrayMethodIsStrict = __webpack_require__(9341);

        const STRICT_METHOD = arrayMethodIsStrict('forEach');

        // `Array.prototype.forEach` method implementation
        // https://tc39.es/ecma262/#sec-array.prototype.foreach
        module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
          return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
          // eslint-disable-next-line es/no-array-prototype-foreach -- safe
        } : [].forEach;
        /***/ }),

      /***/ 7745:
      /***/ (function (module) {
        module.exports = function (Constructor, list) {
          let index = 0;
          const { length } = list;
          const result = new Constructor(length);
          while (length > index) result[index] = list[index++];
          return result;
        };
        /***/ }),

      /***/ 8457:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const bind = __webpack_require__(9974);
        const call = __webpack_require__(6916);
        const toObject = __webpack_require__(7908);
        const callWithSafeIterationClosing = __webpack_require__(3411);
        const isArrayIteratorMethod = __webpack_require__(7659);
        const isConstructor = __webpack_require__(4411);
        const lengthOfArrayLike = __webpack_require__(6244);
        const createProperty = __webpack_require__(6135);
        const getIterator = __webpack_require__(8554);
        const getIteratorMethod = __webpack_require__(1246);

        const { Array } = global;

        // `Array.from` method implementation
        // https://tc39.es/ecma262/#sec-array.from
        module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
          const O = toObject(arrayLike);
          const IS_CONSTRUCTOR = isConstructor(this);
          const argumentsLength = arguments.length;
          let mapfn = argumentsLength > 1 ? arguments[1] : undefined;
          const mapping = mapfn !== undefined;
          if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
          const iteratorMethod = getIteratorMethod(O);
          let index = 0;
          let length; let result; let step; let iterator; let next; let
            value;
          // if the target is not iterable or it's an array with the default iterator - use a simple case
          if (iteratorMethod && !(this == Array && isArrayIteratorMethod(iteratorMethod))) {
            iterator = getIterator(O, iteratorMethod);
            next = iterator.next;
            result = IS_CONSTRUCTOR ? new this() : [];
            for (;!(step = call(next, iterator)).done; index++) {
              value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
              createProperty(result, index, value);
            }
          } else {
            length = lengthOfArrayLike(O);
            result = IS_CONSTRUCTOR ? new this(length) : Array(length);
            for (;length > index; index++) {
              value = mapping ? mapfn(O[index], index) : O[index];
              createProperty(result, index, value);
            }
          }
          result.length = index;
          return result;
        };
        /***/ }),

      /***/ 1318:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const toIndexedObject = __webpack_require__(5656);
        const toAbsoluteIndex = __webpack_require__(1400);
        const lengthOfArrayLike = __webpack_require__(6244);

        // `Array.prototype.{ indexOf, includes }` methods implementation
        const createMethod = function (IS_INCLUDES) {
          return function ($this, el, fromIndex) {
            const O = toIndexedObject($this);
            const length = lengthOfArrayLike(O);
            let index = toAbsoluteIndex(fromIndex, length);
            let value;
            // Array#includes uses SameValueZero equality algorithm
            // eslint-disable-next-line no-self-compare -- NaN check
            if (IS_INCLUDES && el != el) {
              while (length > index) {
                value = O[index++];
                // eslint-disable-next-line no-self-compare -- NaN check
                if (value != value) return true;
              // Array#indexOf ignores holes, Array#includes - not
              }
            } else {
              for (;length > index; index++) {
                if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
              }
            } return !IS_INCLUDES && -1;
          };
        };

        module.exports = {
          // `Array.prototype.includes` method
          // https://tc39.es/ecma262/#sec-array.prototype.includes
          includes: createMethod(true),
          // `Array.prototype.indexOf` method
          // https://tc39.es/ecma262/#sec-array.prototype.indexof
          indexOf: createMethod(false),
        };
        /***/ }),

      /***/ 2092:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const bind = __webpack_require__(9974);
        const uncurryThis = __webpack_require__(1702);
        const IndexedObject = __webpack_require__(8361);
        const toObject = __webpack_require__(7908);
        const lengthOfArrayLike = __webpack_require__(6244);
        const arraySpeciesCreate = __webpack_require__(5417);

        const push = uncurryThis([].push);

        // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
        const createMethod = function (TYPE) {
          const IS_MAP = TYPE == 1;
          const IS_FILTER = TYPE == 2;
          const IS_SOME = TYPE == 3;
          const IS_EVERY = TYPE == 4;
          const IS_FIND_INDEX = TYPE == 6;
          const IS_FILTER_REJECT = TYPE == 7;
          const NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
          return function ($this, callbackfn, that, specificCreate) {
            const O = toObject($this);
            const self = IndexedObject(O);
            const boundFunction = bind(callbackfn, that);
            const length = lengthOfArrayLike(self);
            let index = 0;
            const create = specificCreate || arraySpeciesCreate;
            const target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
            let value; let
              result;
            for (;length > index; index++) {
              if (NO_HOLES || index in self) {
                value = self[index];
                result = boundFunction(value, index, O);
                if (TYPE) {
                  if (IS_MAP) target[index] = result; // map
                  else if (result) {
                    switch (TYPE) {
                      case 3: return true; // some
                      case 5: return value; // find
                      case 6: return index; // findIndex
                      case 2: push(target, value); // filter
                    }
                  } else {
                    switch (TYPE) {
                      case 4: return false; // every
                      case 7: push(target, value); // filterReject
                    }
                  }
                }
              }
            }
            return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
          };
        };

        module.exports = {
          // `Array.prototype.forEach` method
          // https://tc39.es/ecma262/#sec-array.prototype.foreach
          forEach: createMethod(0),
          // `Array.prototype.map` method
          // https://tc39.es/ecma262/#sec-array.prototype.map
          map: createMethod(1),
          // `Array.prototype.filter` method
          // https://tc39.es/ecma262/#sec-array.prototype.filter
          filter: createMethod(2),
          // `Array.prototype.some` method
          // https://tc39.es/ecma262/#sec-array.prototype.some
          some: createMethod(3),
          // `Array.prototype.every` method
          // https://tc39.es/ecma262/#sec-array.prototype.every
          every: createMethod(4),
          // `Array.prototype.find` method
          // https://tc39.es/ecma262/#sec-array.prototype.find
          find: createMethod(5),
          // `Array.prototype.findIndex` method
          // https://tc39.es/ecma262/#sec-array.prototype.findIndex
          findIndex: createMethod(6),
          // `Array.prototype.filterReject` method
          // https://github.com/tc39/proposal-array-filtering
          filterReject: createMethod(7),
        };
        /***/ }),

      /***/ 6583:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* eslint-disable es/no-array-prototype-lastindexof -- safe */
        const apply = __webpack_require__(2104);
        const toIndexedObject = __webpack_require__(5656);
        const toIntegerOrInfinity = __webpack_require__(9303);
        const lengthOfArrayLike = __webpack_require__(6244);
        const arrayMethodIsStrict = __webpack_require__(9341);

        const { min } = Math;
        const $lastIndexOf = [].lastIndexOf;
        const NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
        const STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
        const FORCED = NEGATIVE_ZERO || !STRICT_METHOD;

        // `Array.prototype.lastIndexOf` method implementation
        // https://tc39.es/ecma262/#sec-array.prototype.lastindexof
        module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
          // convert -0 to +0
          if (NEGATIVE_ZERO) return apply($lastIndexOf, this, arguments) || 0;
          const O = toIndexedObject(this);
          const length = lengthOfArrayLike(O);
          let index = length - 1;
          if (arguments.length > 1) index = min(index, toIntegerOrInfinity(arguments[1]));
          if (index < 0) index = length + index;
          for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
          return -1;
        } : $lastIndexOf;
        /***/ }),

      /***/ 1194:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const fails = __webpack_require__(7293);
        const wellKnownSymbol = __webpack_require__(5112);
        const V8_VERSION = __webpack_require__(7392);

        const SPECIES = wellKnownSymbol('species');

        module.exports = function (METHOD_NAME) {
          // We can't use this feature detection in V8 since it causes
          // deoptimization and serious performance degradation
          // https://github.com/zloirock/core-js/issues/677
          return V8_VERSION >= 51 || !fails(() => {
            const array = [];
            const constructor = array.constructor = {};
            constructor[SPECIES] = function () {
              return { foo: 1 };
            };
            return array[METHOD_NAME](Boolean).foo !== 1;
          });
        };
        /***/ }),

      /***/ 9341:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const fails = __webpack_require__(7293);

        module.exports = function (METHOD_NAME, argument) {
          const method = [][METHOD_NAME];
          return !!method && fails(() => {
            // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
            method.call(null, argument || (() => { throw 1; }), 1);
          });
        };
        /***/ }),

      /***/ 3671:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const aCallable = __webpack_require__(9662);
        const toObject = __webpack_require__(7908);
        const IndexedObject = __webpack_require__(8361);
        const lengthOfArrayLike = __webpack_require__(6244);

        const { TypeError } = global;

        // `Array.prototype.{ reduce, reduceRight }` methods implementation
        const createMethod = function (IS_RIGHT) {
          return function (that, callbackfn, argumentsLength, memo) {
            aCallable(callbackfn);
            const O = toObject(that);
            const self = IndexedObject(O);
            const length = lengthOfArrayLike(O);
            let index = IS_RIGHT ? length - 1 : 0;
            const i = IS_RIGHT ? -1 : 1;
            if (argumentsLength < 2) {
              while (true) {
                if (index in self) {
                  memo = self[index];
                  index += i;
                  break;
                }
                index += i;
                if (IS_RIGHT ? index < 0 : length <= index) {
                  throw TypeError('Reduce of empty array with no initial value');
                }
              }
            }
            for (;IS_RIGHT ? index >= 0 : length > index; index += i) {
              if (index in self) {
                memo = callbackfn(memo, self[index], index, O);
              }
            }
            return memo;
          };
        };

        module.exports = {
          // `Array.prototype.reduce` method
          // https://tc39.es/ecma262/#sec-array.prototype.reduce
          left: createMethod(false),
          // `Array.prototype.reduceRight` method
          // https://tc39.es/ecma262/#sec-array.prototype.reduceright
          right: createMethod(true),
        };
        /***/ }),

      /***/ 206:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const uncurryThis = __webpack_require__(1702);

        module.exports = uncurryThis([].slice);
        /***/ }),

      /***/ 4362:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const arraySlice = __webpack_require__(206);

        const { floor } = Math;

        var mergeSort = function (array, comparefn) {
          const { length } = array;
          const middle = floor(length / 2);
          return length < 8 ? insertionSort(array, comparefn) : merge(
            array,
            mergeSort(arraySlice(array, 0, middle), comparefn),
            mergeSort(arraySlice(array, middle), comparefn),
            comparefn,
          );
        };

        var insertionSort = function (array, comparefn) {
          const { length } = array;
          let i = 1;
          let element; let
            j;

          while (i < length) {
            j = i;
            element = array[i];
            while (j && comparefn(array[j - 1], element) > 0) {
              array[j] = array[--j];
            }
            if (j !== i++) array[j] = element;
          } return array;
        };

        var merge = function (array, left, right, comparefn) {
          const llength = left.length;
          const rlength = right.length;
          let lindex = 0;
          let rindex = 0;

          while (lindex < llength || rindex < rlength) {
            array[lindex + rindex] = (lindex < llength && rindex < rlength)
              ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
              : lindex < llength ? left[lindex++] : right[rindex++];
          } return array;
        };

        module.exports = mergeSort;
        /***/ }),

      /***/ 7475:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const isArray = __webpack_require__(3157);
        const isConstructor = __webpack_require__(4411);
        const isObject = __webpack_require__(111);
        const wellKnownSymbol = __webpack_require__(5112);

        const SPECIES = wellKnownSymbol('species');
        const { Array } = global;

        // a part of `ArraySpeciesCreate` abstract operation
        // https://tc39.es/ecma262/#sec-arrayspeciescreate
        module.exports = function (originalArray) {
          let C;
          if (isArray(originalArray)) {
            C = originalArray.constructor;
            // cross-realm fallback
            if (isConstructor(C) && (C === Array || isArray(C.prototype))) C = undefined;
            else if (isObject(C)) {
              C = C[SPECIES];
              if (C === null) C = undefined;
            }
          } return C === undefined ? Array : C;
        };
        /***/ }),

      /***/ 5417:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const arraySpeciesConstructor = __webpack_require__(7475);

        // `ArraySpeciesCreate` abstract operation
        // https://tc39.es/ecma262/#sec-arrayspeciescreate
        module.exports = function (originalArray, length) {
          return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
        };
        /***/ }),

      /***/ 3411:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const anObject = __webpack_require__(9670);
        const iteratorClose = __webpack_require__(9212);

        // call something on iterator step with safe closing on error
        module.exports = function (iterator, fn, value, ENTRIES) {
          try {
            return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
          } catch (error) {
            iteratorClose(iterator, 'throw', error);
          }
        };
        /***/ }),

      /***/ 7072:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const wellKnownSymbol = __webpack_require__(5112);

        const ITERATOR = wellKnownSymbol('iterator');
        let SAFE_CLOSING = false;

        try {
          let called = 0;
          const iteratorWithReturn = {
            next() {
              return { done: !!called++ };
            },
            return() {
              SAFE_CLOSING = true;
            },
          };
          iteratorWithReturn[ITERATOR] = function () {
            return this;
          };
          // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
          Array.from(iteratorWithReturn, () => { throw 2; });
        } catch (error) { /* empty */ }

        module.exports = function (exec, SKIP_CLOSING) {
          if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
          let ITERATION_SUPPORT = false;
          try {
            const object = {};
            object[ITERATOR] = function () {
              return {
                next() {
                  return { done: ITERATION_SUPPORT = true };
                },
              };
            };
            exec(object);
          } catch (error) { /* empty */ }
          return ITERATION_SUPPORT;
        };
        /***/ }),

      /***/ 4326:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const uncurryThis = __webpack_require__(1702);

        const toString = uncurryThis({}.toString);
        const stringSlice = uncurryThis(''.slice);

        module.exports = function (it) {
          return stringSlice(toString(it), 8, -1);
        };
        /***/ }),

      /***/ 648:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const TO_STRING_TAG_SUPPORT = __webpack_require__(1694);
        const isCallable = __webpack_require__(614);
        const classofRaw = __webpack_require__(4326);
        const wellKnownSymbol = __webpack_require__(5112);

        const TO_STRING_TAG = wellKnownSymbol('toStringTag');
        const { Object } = global;

        // ES3 wrong here
        const CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

        // fallback for IE11 Script Access Denied error
        const tryGet = function (it, key) {
          try {
            return it[key];
          } catch (error) { /* empty */ }
        };

        // getting tag from ES6+ `Object.prototype.toString`
        module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
          let O; let tag; let
            result;
          return it === undefined ? 'Undefined' : it === null ? 'Null'
          // @@toStringTag case
            : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) === 'string' ? tag
            // builtinTag case
              : CORRECT_ARGUMENTS ? classofRaw(O)
              // ES3 arguments fallback
                : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
        };
        /***/ }),

      /***/ 7741:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const uncurryThis = __webpack_require__(1702);
        const arraySlice = __webpack_require__(206);

        const replace = uncurryThis(''.replace);
        const split = uncurryThis(''.split);
        const join = uncurryThis([].join);

        const TEST = (function (arg) { return String(Error(arg).stack); }('zxcasd'));
        const V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
        const IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);
        const IS_FIREFOX_OR_SAFARI_STACK = /@[^\n]*\n/.test(TEST) && !/zxcasd/.test(TEST);

        module.exports = function (stack, dropEntries) {
          if (typeof stack !== 'string') return stack;
          if (IS_V8_OR_CHAKRA_STACK) {
            while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
          } else if (IS_FIREFOX_OR_SAFARI_STACK) {
            return join(arraySlice(split(stack, '\n'), dropEntries), '\n');
          } return stack;
        };
        /***/ }),

      /***/ 5631:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const defineProperty = (__webpack_require__(3070).f);
        const create = __webpack_require__(30);
        const redefineAll = __webpack_require__(2248);
        const bind = __webpack_require__(9974);
        const anInstance = __webpack_require__(5787);
        const iterate = __webpack_require__(408);
        const defineIterator = __webpack_require__(654);
        const setSpecies = __webpack_require__(6340);
        const DESCRIPTORS = __webpack_require__(9781);
        const { fastKey } = __webpack_require__(2423);
        const InternalStateModule = __webpack_require__(9909);

        const setInternalState = InternalStateModule.set;
        const internalStateGetterFor = InternalStateModule.getterFor;

        module.exports = {
          getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
            const Constructor = wrapper((that, iterable) => {
              anInstance(that, Prototype);
              setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                index: create(null),
                first: undefined,
                last: undefined,
                size: 0,
              });
              if (!DESCRIPTORS) that.size = 0;
              if (iterable != undefined) iterate(iterable, that[ADDER], { that, AS_ENTRIES: IS_MAP });
            });

            var Prototype = Constructor.prototype;

            const getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

            const define = function (that, key, value) {
              const state = getInternalState(that);
              let entry = getEntry(that, key);
              let previous; let
                index;
              // change existing entry
              if (entry) {
                entry.value = value;
                // create new entry
              } else {
                state.last = entry = {
                  index: index = fastKey(key, true),
                  key,
                  value,
                  previous: previous = state.last,
                  next: undefined,
                  removed: false,
                };
                if (!state.first) state.first = entry;
                if (previous) previous.next = entry;
                if (DESCRIPTORS) state.size++;
                else that.size++;
                // add to index
                if (index !== 'F') state.index[index] = entry;
              } return that;
            };

            var getEntry = function (that, key) {
              const state = getInternalState(that);
              // fast case
              const index = fastKey(key);
              let entry;
              if (index !== 'F') return state.index[index];
              // frozen object case
              for (entry = state.first; entry; entry = entry.next) {
                if (entry.key == key) return entry;
              }
            };

            redefineAll(Prototype, {
              // `{ Map, Set }.prototype.clear()` methods
              // https://tc39.es/ecma262/#sec-map.prototype.clear
              // https://tc39.es/ecma262/#sec-set.prototype.clear
              clear: function clear() {
                const that = this;
                const state = getInternalState(that);
                const data = state.index;
                let entry = state.first;
                while (entry) {
                  entry.removed = true;
                  if (entry.previous) entry.previous = entry.previous.next = undefined;
                  delete data[entry.index];
                  entry = entry.next;
                }
                state.first = state.last = undefined;
                if (DESCRIPTORS) state.size = 0;
                else that.size = 0;
              },
              // `{ Map, Set }.prototype.delete(key)` methods
              // https://tc39.es/ecma262/#sec-map.prototype.delete
              // https://tc39.es/ecma262/#sec-set.prototype.delete
              delete(key) {
                const that = this;
                const state = getInternalState(that);
                const entry = getEntry(that, key);
                if (entry) {
                  const { next } = entry;
                  const prev = entry.previous;
                  delete state.index[entry.index];
                  entry.removed = true;
                  if (prev) prev.next = next;
                  if (next) next.previous = prev;
                  if (state.first == entry) state.first = next;
                  if (state.last == entry) state.last = prev;
                  if (DESCRIPTORS) state.size--;
                  else that.size--;
                } return !!entry;
              },
              // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
              // https://tc39.es/ecma262/#sec-map.prototype.foreach
              // https://tc39.es/ecma262/#sec-set.prototype.foreach
              forEach: function forEach(callbackfn /* , that = undefined */) {
                const state = getInternalState(this);
                const boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                let entry;
                while (entry = entry ? entry.next : state.first) {
                  boundFunction(entry.value, entry.key, this);
                  // revert to the last existing entry
                  while (entry && entry.removed) entry = entry.previous;
                }
              },
              // `{ Map, Set}.prototype.has(key)` methods
              // https://tc39.es/ecma262/#sec-map.prototype.has
              // https://tc39.es/ecma262/#sec-set.prototype.has
              has: function has(key) {
                return !!getEntry(this, key);
              },
            });

            redefineAll(Prototype, IS_MAP ? {
              // `Map.prototype.get(key)` method
              // https://tc39.es/ecma262/#sec-map.prototype.get
              get: function get(key) {
                const entry = getEntry(this, key);
                return entry && entry.value;
              },
              // `Map.prototype.set(key, value)` method
              // https://tc39.es/ecma262/#sec-map.prototype.set
              set: function set(key, value) {
                return define(this, key === 0 ? 0 : key, value);
              },
            } : {
              // `Set.prototype.add(value)` method
              // https://tc39.es/ecma262/#sec-set.prototype.add
              add: function add(value) {
                return define(this, value = value === 0 ? 0 : value, value);
              },
            });
            if (DESCRIPTORS) {
              defineProperty(Prototype, 'size', {
                get() {
                  return getInternalState(this).size;
                },
              });
            }
            return Constructor;
          },
          setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP) {
            const ITERATOR_NAME = `${CONSTRUCTOR_NAME} Iterator`;
            const getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
            const getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
            // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
            // https://tc39.es/ecma262/#sec-map.prototype.entries
            // https://tc39.es/ecma262/#sec-map.prototype.keys
            // https://tc39.es/ecma262/#sec-map.prototype.values
            // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
            // https://tc39.es/ecma262/#sec-set.prototype.entries
            // https://tc39.es/ecma262/#sec-set.prototype.keys
            // https://tc39.es/ecma262/#sec-set.prototype.values
            // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
            defineIterator(Constructor, CONSTRUCTOR_NAME, function (iterated, kind) {
              setInternalState(this, {
                type: ITERATOR_NAME,
                target: iterated,
                state: getInternalCollectionState(iterated),
                kind,
                last: undefined,
              });
            }, function () {
              const state = getInternalIteratorState(this);
              const { kind } = state;
              let entry = state.last;
              // revert to the last existing entry
              while (entry && entry.removed) entry = entry.previous;
              // get next entry
              if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                // or finish the iteration
                state.target = undefined;
                return { value: undefined, done: true };
              }
              // return step by kind
              if (kind == 'keys') return { value: entry.key, done: false };
              if (kind == 'values') return { value: entry.value, done: false };
              return { value: [entry.key, entry.value], done: false };
            }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

            // `{ Map, Set }.prototype[@@species]` accessors
            // https://tc39.es/ecma262/#sec-get-map-@@species
            // https://tc39.es/ecma262/#sec-get-set-@@species
            setSpecies(CONSTRUCTOR_NAME);
          },
        };
        /***/ }),

      /***/ 7710:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const global = __webpack_require__(7854);
        const uncurryThis = __webpack_require__(1702);
        const isForced = __webpack_require__(4705);
        const redefine = __webpack_require__(1320);
        const InternalMetadataModule = __webpack_require__(2423);
        const iterate = __webpack_require__(408);
        const anInstance = __webpack_require__(5787);
        const isCallable = __webpack_require__(614);
        const isObject = __webpack_require__(111);
        const fails = __webpack_require__(7293);
        const checkCorrectnessOfIteration = __webpack_require__(7072);
        const setToStringTag = __webpack_require__(8003);
        const inheritIfRequired = __webpack_require__(9587);

        module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
          const IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
          const IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
          const ADDER = IS_MAP ? 'set' : 'add';
          const NativeConstructor = global[CONSTRUCTOR_NAME];
          const NativePrototype = NativeConstructor && NativeConstructor.prototype;
          let Constructor = NativeConstructor;
          const exported = {};

          const fixMethod = function (KEY) {
            const uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
            redefine(NativePrototype, KEY,
              KEY == 'add' ? function add(value) {
                uncurriedNativeMethod(this, value === 0 ? 0 : value);
                return this;
              } : KEY == 'delete' ? function (key) {
                return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
              } : KEY == 'get' ? function get(key) {
                return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
              } : KEY == 'has' ? function has(key) {
                return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
              } : function set(key, value) {
                uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
                return this;
              });
          };

          const REPLACE = isForced(
            CONSTRUCTOR_NAME,
            !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(() => {
              new NativeConstructor().entries().next();
            })),
          );

          if (REPLACE) {
            // create collection constructor
            Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
            InternalMetadataModule.enable();
          } else if (isForced(CONSTRUCTOR_NAME, true)) {
            const instance = new Constructor();
            // early implementations not supports chaining
            const HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
            // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
            const THROWS_ON_PRIMITIVES = fails(() => { instance.has(1); });
            // most early implementations doesn't supports iterables, most modern - not close it correctly
            // eslint-disable-next-line no-new -- required for testing
            const ACCEPT_ITERABLES = checkCorrectnessOfIteration((iterable) => { new NativeConstructor(iterable); });
            // for early implementations -0 and +0 not the same
            const BUGGY_ZERO = !IS_WEAK && fails(() => {
              // V8 ~ Chromium 42- fails only with 5+ elements
              const $instance = new NativeConstructor();
              let index = 5;
              while (index--) $instance[ADDER](index, index);
              return !$instance.has(-0);
            });

            if (!ACCEPT_ITERABLES) {
              Constructor = wrapper((dummy, iterable) => {
                anInstance(dummy, NativePrototype);
                const that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
                if (iterable != undefined) iterate(iterable, that[ADDER], { that, AS_ENTRIES: IS_MAP });
                return that;
              });
              Constructor.prototype = NativePrototype;
              NativePrototype.constructor = Constructor;
            }

            if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
              fixMethod('delete');
              fixMethod('has');
              IS_MAP && fixMethod('get');
            }

            if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

            // weak collections should not contains .clear method
            if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
          }

          exported[CONSTRUCTOR_NAME] = Constructor;
          $({ global: true, forced: Constructor != NativeConstructor }, exported);

          setToStringTag(Constructor, CONSTRUCTOR_NAME);

          if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

          return Constructor;
        };
        /***/ }),

      /***/ 9920:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const hasOwn = __webpack_require__(2597);
        const ownKeys = __webpack_require__(3887);
        const getOwnPropertyDescriptorModule = __webpack_require__(1236);
        const definePropertyModule = __webpack_require__(3070);

        module.exports = function (target, source) {
          const keys = ownKeys(source);
          const defineProperty = definePropertyModule.f;
          const getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
          for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if (!hasOwn(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
          }
        };
        /***/ }),

      /***/ 4964:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const wellKnownSymbol = __webpack_require__(5112);

        const MATCH = wellKnownSymbol('match');

        module.exports = function (METHOD_NAME) {
          const regexp = /./;
          try {
            '/./'[METHOD_NAME](regexp);
          } catch (error1) {
            try {
              regexp[MATCH] = false;
              return '/./'[METHOD_NAME](regexp);
            } catch (error2) { /* empty */ }
          } return false;
        };
        /***/ }),

      /***/ 8544:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const fails = __webpack_require__(7293);

        module.exports = !fails(() => {
          function F() { /* empty */ }
          F.prototype.constructor = null;
          // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
          return Object.getPrototypeOf(new F()) !== F.prototype;
        });
        /***/ }),

      /***/ 4230:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const uncurryThis = __webpack_require__(1702);
        const requireObjectCoercible = __webpack_require__(4488);
        const toString = __webpack_require__(1340);

        const quot = /"/g;
        const replace = uncurryThis(''.replace);

        // `CreateHTML` abstract operation
        // https://tc39.es/ecma262/#sec-createhtml
        module.exports = function (string, tag, attribute, value) {
          const S = toString(requireObjectCoercible(string));
          let p1 = `<${tag}`;
          if (attribute !== '') p1 += ` ${attribute}="${replace(toString(value), quot, '&quot;')}"`;
          return `${p1}>${S}</${tag}>`;
        };
        /***/ }),

      /***/ 4994:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const { IteratorPrototype } = __webpack_require__(3383);
        const create = __webpack_require__(30);
        const createPropertyDescriptor = __webpack_require__(9114);
        const setToStringTag = __webpack_require__(8003);
        const Iterators = __webpack_require__(7497);

        const returnThis = function () { return this; };

        module.exports = function (IteratorConstructor, NAME, next) {
          const TO_STRING_TAG = `${NAME} Iterator`;
          IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
          setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
          Iterators[TO_STRING_TAG] = returnThis;
          return IteratorConstructor;
        };
        /***/ }),

      /***/ 8880:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const DESCRIPTORS = __webpack_require__(9781);
        const definePropertyModule = __webpack_require__(3070);
        const createPropertyDescriptor = __webpack_require__(9114);

        module.exports = DESCRIPTORS ? function (object, key, value) {
          return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
        } : function (object, key, value) {
          object[key] = value;
          return object;
        };
        /***/ }),

      /***/ 9114:
      /***/ (function (module) {
        module.exports = function (bitmap, value) {
          return {
            enumerable: !(bitmap & 1),
            configurable: !(bitmap & 2),
            writable: !(bitmap & 4),
            value,
          };
        };
        /***/ }),

      /***/ 6135:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const toPropertyKey = __webpack_require__(4948);
        const definePropertyModule = __webpack_require__(3070);
        const createPropertyDescriptor = __webpack_require__(9114);

        module.exports = function (object, key, value) {
          const propertyKey = toPropertyKey(key);
          if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
          else object[propertyKey] = value;
        };
        /***/ }),

      /***/ 8709:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const anObject = __webpack_require__(9670);
        const ordinaryToPrimitive = __webpack_require__(2140);

        const { TypeError } = global;

        // `Date.prototype[@@toPrimitive](hint)` method implementation
        // https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
        module.exports = function (hint) {
          anObject(this);
          if (hint === 'string' || hint === 'default') hint = 'string';
          else if (hint !== 'number') throw TypeError('Incorrect hint');
          return ordinaryToPrimitive(this, hint);
        };
        /***/ }),

      /***/ 654:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const call = __webpack_require__(6916);
        const IS_PURE = __webpack_require__(1913);
        const FunctionName = __webpack_require__(6530);
        const isCallable = __webpack_require__(614);
        const createIteratorConstructor = __webpack_require__(4994);
        const getPrototypeOf = __webpack_require__(9518);
        const setPrototypeOf = __webpack_require__(7674);
        const setToStringTag = __webpack_require__(8003);
        const createNonEnumerableProperty = __webpack_require__(8880);
        const redefine = __webpack_require__(1320);
        const wellKnownSymbol = __webpack_require__(5112);
        const Iterators = __webpack_require__(7497);
        const IteratorsCore = __webpack_require__(3383);

        const PROPER_FUNCTION_NAME = FunctionName.PROPER;
        const CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
        const { IteratorPrototype } = IteratorsCore;
        const { BUGGY_SAFARI_ITERATORS } = IteratorsCore;
        const ITERATOR = wellKnownSymbol('iterator');
        const KEYS = 'keys';
        const VALUES = 'values';
        const ENTRIES = 'entries';

        const returnThis = function () { return this; };

        module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
          createIteratorConstructor(IteratorConstructor, NAME, next);

          const getIterationMethod = function (KIND) {
            if (KIND === DEFAULT && defaultIterator) return defaultIterator;
            if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
            switch (KIND) {
              case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
              case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
              case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
            } return function () { return new IteratorConstructor(this); };
          };

          const TO_STRING_TAG = `${NAME} Iterator`;
          let INCORRECT_VALUES_NAME = false;
          var IterablePrototype = Iterable.prototype;
          const nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
          var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
          const anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
          let CurrentIteratorPrototype; let methods; let
            KEY;

          // fix native
          if (anyNativeIterator) {
            CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
            if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
              if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
                if (setPrototypeOf) {
                  setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
                } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
                  redefine(CurrentIteratorPrototype, ITERATOR, returnThis);
                }
              }
              // Set @@toStringTag to native iterators
              setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
              if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
            }
          }

          // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
          if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
            if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
              createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
            } else {
              INCORRECT_VALUES_NAME = true;
              defaultIterator = function values() { return call(nativeIterator, this); };
            }
          }

          // export additional methods
          if (DEFAULT) {
            methods = {
              values: getIterationMethod(VALUES),
              keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
              entries: getIterationMethod(ENTRIES),
            };
            if (FORCED) {
              for (KEY in methods) {
                if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
                  redefine(IterablePrototype, KEY, methods[KEY]);
                }
              }
            } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
          }

          // define iterator
          if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
            redefine(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
          }
          Iterators[NAME] = defaultIterator;

          return methods;
        };
        /***/ }),

      /***/ 7235:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const path = __webpack_require__(857);
        const hasOwn = __webpack_require__(2597);
        const wrappedWellKnownSymbolModule = __webpack_require__(6061);
        const defineProperty = (__webpack_require__(3070).f);

        module.exports = function (NAME) {
          const Symbol = path.Symbol || (path.Symbol = {});
          if (!hasOwn(Symbol, NAME)) {
            defineProperty(Symbol, NAME, {
              value: wrappedWellKnownSymbolModule.f(NAME),
            });
          }
        };
        /***/ }),

      /***/ 9781:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const fails = __webpack_require__(7293);

        // Detect IE8's incomplete defineProperty implementation
        module.exports = !fails(() =>
        // eslint-disable-next-line es/no-object-defineproperty -- required for testing
          Object.defineProperty({}, 1, { get() { return 7; } })[1] != 7);
        /***/ }),

      /***/ 317:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const isObject = __webpack_require__(111);

        const { document } = global;
        // typeof document.createElement is 'object' in old IE
        const EXISTS = isObject(document) && isObject(document.createElement);

        module.exports = function (it) {
          return EXISTS ? document.createElement(it) : {};
        };
        /***/ }),

      /***/ 8324:
      /***/ (function (module) {
        // iterable DOM collections
        // flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
        module.exports = {
          CSSRuleList: 0,
          CSSStyleDeclaration: 0,
          CSSValueList: 0,
          ClientRectList: 0,
          DOMRectList: 0,
          DOMStringList: 0,
          DOMTokenList: 1,
          DataTransferItemList: 0,
          FileList: 0,
          HTMLAllCollection: 0,
          HTMLCollection: 0,
          HTMLFormElement: 0,
          HTMLSelectElement: 0,
          MediaList: 0,
          MimeTypeArray: 0,
          NamedNodeMap: 0,
          NodeList: 1,
          PaintRequestList: 0,
          Plugin: 0,
          PluginArray: 0,
          SVGLengthList: 0,
          SVGNumberList: 0,
          SVGPathSegList: 0,
          SVGPointList: 0,
          SVGStringList: 0,
          SVGTransformList: 0,
          SourceBufferList: 0,
          StyleSheetList: 0,
          TextTrackCueList: 0,
          TextTrackList: 0,
          TouchList: 0,
        };
        /***/ }),

      /***/ 8509:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        // in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
        const documentCreateElement = __webpack_require__(317);

        const { classList } = documentCreateElement('span');
        const DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

        module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;
        /***/ }),

      /***/ 8886:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const userAgent = __webpack_require__(8113);

        const firefox = userAgent.match(/firefox\/(\d+)/i);

        module.exports = !!firefox && +firefox[1];
        /***/ }),

      /***/ 7871:
      /***/ (function (module) {
        module.exports = typeof window === 'object';
        /***/ }),

      /***/ 256:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const UA = __webpack_require__(8113);

        module.exports = /MSIE|Trident/.test(UA);
        /***/ }),

      /***/ 1528:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const userAgent = __webpack_require__(8113);
        const global = __webpack_require__(7854);

        module.exports = /ipad|iphone|ipod/i.test(userAgent) && global.Pebble !== undefined;
        /***/ }),

      /***/ 6833:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const userAgent = __webpack_require__(8113);

        module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);
        /***/ }),

      /***/ 5268:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const classof = __webpack_require__(4326);
        const global = __webpack_require__(7854);

        module.exports = classof(global.process) == 'process';
        /***/ }),

      /***/ 1036:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const userAgent = __webpack_require__(8113);

        module.exports = /web0s(?!.*chrome)/i.test(userAgent);
        /***/ }),

      /***/ 8113:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const getBuiltIn = __webpack_require__(5005);

        module.exports = getBuiltIn('navigator', 'userAgent') || '';
        /***/ }),

      /***/ 7392:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const userAgent = __webpack_require__(8113);

        const { process } = global;
        const { Deno } = global;
        const versions = process && process.versions || Deno && Deno.version;
        const v8 = versions && versions.v8;
        let match; let
          version;

        if (v8) {
          match = v8.split('.');
          // in old Chrome, versions of V8 isn't V8 = Chrome / 10
          // but their correct versions are not interesting for us
          version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
        }

        // BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
        // so check `userAgent` even if `.v8` exists, but 0
        if (!version && userAgent) {
          match = userAgent.match(/Edge\/(\d+)/);
          if (!match || match[1] >= 74) {
            match = userAgent.match(/Chrome\/(\d+)/);
            if (match) version = +match[1];
          }
        }

        module.exports = version;
        /***/ }),

      /***/ 8008:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const userAgent = __webpack_require__(8113);

        const webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

        module.exports = !!webkit && +webkit[1];
        /***/ }),

      /***/ 748:
      /***/ (function (module) {
        // IE8- don't enum bug keys
        module.exports = [
          'constructor',
          'hasOwnProperty',
          'isPrototypeOf',
          'propertyIsEnumerable',
          'toLocaleString',
          'toString',
          'valueOf',
        ];
        /***/ }),

      /***/ 2914:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const fails = __webpack_require__(7293);
        const createPropertyDescriptor = __webpack_require__(9114);

        module.exports = !fails(() => {
          const error = Error('a');
          if (!('stack' in error)) return true;
          // eslint-disable-next-line es/no-object-defineproperty -- safe
          Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
          return error.stack !== 7;
        });
        /***/ }),

      /***/ 2109:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const getOwnPropertyDescriptor = (__webpack_require__(1236).f);
        const createNonEnumerableProperty = __webpack_require__(8880);
        const redefine = __webpack_require__(1320);
        const setGlobal = __webpack_require__(3505);
        const copyConstructorProperties = __webpack_require__(9920);
        const isForced = __webpack_require__(4705);

        /*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
        module.exports = function (options, source) {
          const TARGET = options.target;
          const GLOBAL = options.global;
          const STATIC = options.stat;
          let FORCED; let target; let key; let targetProperty; let sourceProperty; let
            descriptor;
          if (GLOBAL) {
            target = global;
          } else if (STATIC) {
            target = global[TARGET] || setGlobal(TARGET, {});
          } else {
            target = (global[TARGET] || {}).prototype;
          }
          if (target) {
            for (key in source) {
              sourceProperty = source[key];
              if (options.noTargetGet) {
                descriptor = getOwnPropertyDescriptor(target, key);
                targetProperty = descriptor && descriptor.value;
              } else targetProperty = target[key];
              FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
              // contained in target
              if (!FORCED && targetProperty !== undefined) {
                if (typeof sourceProperty === typeof targetProperty) continue;
                copyConstructorProperties(sourceProperty, targetProperty);
              }
              // add a flag to not completely full polyfills
              if (options.sham || (targetProperty && targetProperty.sham)) {
                createNonEnumerableProperty(sourceProperty, 'sham', true);
              }
              // extend global
              redefine(target, key, sourceProperty, options);
            }
          }
        };
        /***/ }),

      /***/ 7293:
      /***/ (function (module) {
        module.exports = function (exec) {
          try {
            return !!exec();
          } catch (error) {
            return true;
          }
        };
        /***/ }),

      /***/ 7007:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        // TODO: Remove from `core-js@4` since it's moved to entry points
        __webpack_require__(4916);
        const uncurryThis = __webpack_require__(1702);
        const redefine = __webpack_require__(1320);
        const regexpExec = __webpack_require__(2261);
        const fails = __webpack_require__(7293);
        const wellKnownSymbol = __webpack_require__(5112);
        const createNonEnumerableProperty = __webpack_require__(8880);

        const SPECIES = wellKnownSymbol('species');
        const RegExpPrototype = RegExp.prototype;

        module.exports = function (KEY, exec, FORCED, SHAM) {
          const SYMBOL = wellKnownSymbol(KEY);

          const DELEGATES_TO_SYMBOL = !fails(() => {
            // String methods call symbol-named RegEp methods
            const O = {};
            O[SYMBOL] = function () { return 7; };
            return ''[KEY](O) != 7;
          });

          const DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(() => {
            // Symbol-named RegExp methods call .exec
            let execCalled = false;
            let re = /a/;

            if (KEY === 'split') {
              // We can't use real regex here since it causes deoptimization
              // and serious performance degradation in V8
              // https://github.com/zloirock/core-js/issues/306
              re = {};
              // RegExp[@@split] doesn't call the regex's exec method, but first creates
              // a new one. We need to return the patched regex when creating the new one.
              re.constructor = {};
              re.constructor[SPECIES] = function () { return re; };
              re.flags = '';
              re[SYMBOL] = /./[SYMBOL];
            }

            re.exec = function () { execCalled = true; return null; };

            re[SYMBOL]('');
            return !execCalled;
          });

          if (
            !DELEGATES_TO_SYMBOL
    || !DELEGATES_TO_EXEC
    || FORCED
          ) {
            const uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
            const methods = exec(SYMBOL, ''[KEY], (nativeMethod, regexp, str, arg2, forceStringMethod) => {
              const uncurriedNativeMethod = uncurryThis(nativeMethod);
              const $exec = regexp.exec;
              if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
                  // The native String method already delegates to @@method (this
                  // polyfilled function), leasing to infinite recursion.
                  // We avoid it by directly calling the native @@method method.
                  return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
                }
                return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
              }
              return { done: false };
            });

            redefine(String.prototype, KEY, methods[0]);
            redefine(RegExpPrototype, SYMBOL, methods[1]);
          }

          if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
        };
        /***/ }),

      /***/ 6677:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const fails = __webpack_require__(7293);

        module.exports = !fails(() =>
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
          Object.isExtensible(Object.preventExtensions({})));
        /***/ }),

      /***/ 2104:
      /***/ (function (module) {
        const FunctionPrototype = Function.prototype;
        const { apply } = FunctionPrototype;
        const { bind } = FunctionPrototype;
        const { call } = FunctionPrototype;

        // eslint-disable-next-line es/no-reflect -- safe
        module.exports = typeof Reflect === 'object' && Reflect.apply || (bind ? call.bind(apply) : function () {
          return call.apply(apply, arguments);
        });
        /***/ }),

      /***/ 9974:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const uncurryThis = __webpack_require__(1702);
        const aCallable = __webpack_require__(9662);

        const bind = uncurryThis(uncurryThis.bind);

        // optional / simple context binding
        module.exports = function (fn, that) {
          aCallable(fn);
          return that === undefined ? fn : bind ? bind(fn, that) : function (/* ...args */) {
            return fn.apply(that, arguments);
          };
        };
        /***/ }),

      /***/ 7065:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const uncurryThis = __webpack_require__(1702);
        const aCallable = __webpack_require__(9662);
        const isObject = __webpack_require__(111);
        const hasOwn = __webpack_require__(2597);
        const arraySlice = __webpack_require__(206);

        const { Function } = global;
        const concat = uncurryThis([].concat);
        const join = uncurryThis([].join);
        const factories = {};

        const construct = function (C, argsLength, args) {
          if (!hasOwn(factories, argsLength)) {
            for (var list = [], i = 0; i < argsLength; i++) list[i] = `a[${i}]`;
            factories[argsLength] = Function('C,a', `return new C(${join(list, ',')})`);
          } return factories[argsLength](C, args);
        };

        // `Function.prototype.bind` method implementation
        // https://tc39.es/ecma262/#sec-function.prototype.bind
        module.exports = Function.bind || function bind(that /* , ...args */) {
          const F = aCallable(this);
          const Prototype = F.prototype;
          const partArgs = arraySlice(arguments, 1);
          var boundFunction = function bound(/* args... */) {
            const args = concat(partArgs, arraySlice(arguments));
            return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
          };
          if (isObject(Prototype)) boundFunction.prototype = Prototype;
          return boundFunction;
        };
        /***/ }),

      /***/ 6916:
      /***/ (function (module) {
        const { call } = Function.prototype;

        module.exports = call.bind ? call.bind(call) : function () {
          return call.apply(call, arguments);
        };
        /***/ }),

      /***/ 6530:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const DESCRIPTORS = __webpack_require__(9781);
        const hasOwn = __webpack_require__(2597);

        const FunctionPrototype = Function.prototype;
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        const getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

        const EXISTS = hasOwn(FunctionPrototype, 'name');
        // additional protection from minified / mangled / dropped function names
        const PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
        const CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

        module.exports = {
          EXISTS,
          PROPER,
          CONFIGURABLE,
        };
        /***/ }),

      /***/ 1702:
      /***/ (function (module) {
        const FunctionPrototype = Function.prototype;
        const { bind } = FunctionPrototype;
        const { call } = FunctionPrototype;
        const callBind = bind && bind.bind(call);

        module.exports = bind ? function (fn) {
          return fn && callBind(call, fn);
        } : function (fn) {
          return fn && function () {
            return call.apply(fn, arguments);
          };
        };
        /***/ }),

      /***/ 5005:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const isCallable = __webpack_require__(614);

        const aFunction = function (argument) {
          return isCallable(argument) ? argument : undefined;
        };

        module.exports = function (namespace, method) {
          return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
        };
        /***/ }),

      /***/ 1246:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const classof = __webpack_require__(648);
        const getMethod = __webpack_require__(8173);
        const Iterators = __webpack_require__(7497);
        const wellKnownSymbol = __webpack_require__(5112);

        const ITERATOR = wellKnownSymbol('iterator');

        module.exports = function (it) {
          if (it != undefined) {
            return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
          }
        };
        /***/ }),

      /***/ 8554:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const call = __webpack_require__(6916);
        const aCallable = __webpack_require__(9662);
        const anObject = __webpack_require__(9670);
        const tryToString = __webpack_require__(6330);
        const getIteratorMethod = __webpack_require__(1246);

        const { TypeError } = global;

        module.exports = function (argument, usingIterator) {
          const iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
          if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
          throw TypeError(`${tryToString(argument)} is not iterable`);
        };
        /***/ }),

      /***/ 8173:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const aCallable = __webpack_require__(9662);

        // `GetMethod` abstract operation
        // https://tc39.es/ecma262/#sec-getmethod
        module.exports = function (V, P) {
          const func = V[P];
          return func == null ? undefined : aCallable(func);
        };
        /***/ }),

      /***/ 647:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const uncurryThis = __webpack_require__(1702);
        const toObject = __webpack_require__(7908);

        const { floor } = Math;
        const charAt = uncurryThis(''.charAt);
        const replace = uncurryThis(''.replace);
        const stringSlice = uncurryThis(''.slice);
        const SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
        const SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

        // `GetSubstitution` abstract operation
        // https://tc39.es/ecma262/#sec-getsubstitution
        module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
          const tailPos = position + matched.length;
          const m = captures.length;
          let symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
          if (namedCaptures !== undefined) {
            namedCaptures = toObject(namedCaptures);
            symbols = SUBSTITUTION_SYMBOLS;
          }
          return replace(replacement, symbols, (match, ch) => {
            let capture;
            switch (charAt(ch, 0)) {
              case '$': return '$';
              case '&': return matched;
              case '`': return stringSlice(str, 0, position);
              case "'": return stringSlice(str, tailPos);
              case '<':
                capture = namedCaptures[stringSlice(ch, 1, -1)];
                break;
              default: // \d\d?
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                  const f = floor(n / 10);
                  if (f === 0) return match;
                  if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
                  return match;
                }
                capture = captures[n - 1];
            }
            return capture === undefined ? '' : capture;
          });
        };
        /***/ }),

      /***/ 7854:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const check = function (it) {
          return it && it.Math == Math && it;
        };

        // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
        module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis === 'object' && globalThis)
  || check(typeof window === 'object' && window)
  // eslint-disable-next-line no-restricted-globals -- safe
  || check(typeof self === 'object' && self)
  || check(typeof __webpack_require__.g === 'object' && __webpack_require__.g)
  // eslint-disable-next-line no-new-func -- fallback
  || (function () { return this; }()) || Function('return this')();
        /***/ }),

      /***/ 2597:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const uncurryThis = __webpack_require__(1702);
        const toObject = __webpack_require__(7908);

        const hasOwnProperty = uncurryThis({}.hasOwnProperty);

        // `HasOwnProperty` abstract operation
        // https://tc39.es/ecma262/#sec-hasownproperty
        module.exports = Object.hasOwn || function hasOwn(it, key) {
          return hasOwnProperty(toObject(it), key);
        };
        /***/ }),

      /***/ 3501:
      /***/ (function (module) {
        module.exports = {};
        /***/ }),

      /***/ 842:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);

        module.exports = function (a, b) {
          const { console } = global;
          if (console && console.error) {
            arguments.length == 1 ? console.error(a) : console.error(a, b);
          }
        };
        /***/ }),

      /***/ 490:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const getBuiltIn = __webpack_require__(5005);

        module.exports = getBuiltIn('document', 'documentElement');
        /***/ }),

      /***/ 4664:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const DESCRIPTORS = __webpack_require__(9781);
        const fails = __webpack_require__(7293);
        const createElement = __webpack_require__(317);

        // Thank's IE8 for his funny defineProperty
        module.exports = !DESCRIPTORS && !fails(() =>
        // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
          Object.defineProperty(createElement('div'), 'a', {
            get() { return 7; },
          }).a != 7);
        /***/ }),

      /***/ 1179:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        // IEEE754 conversions based on https://github.com/feross/ieee754
        const global = __webpack_require__(7854);

        const { Array } = global;
        const { abs } = Math;
        const { pow } = Math;
        const { floor } = Math;
        const { log } = Math;
        const { LN2 } = Math;

        const pack = function (number, mantissaLength, bytes) {
          const buffer = Array(bytes);
          let exponentLength = bytes * 8 - mantissaLength - 1;
          const eMax = (1 << exponentLength) - 1;
          const eBias = eMax >> 1;
          const rt = mantissaLength === 23 ? pow(2, -24) - pow(2, -77) : 0;
          const sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
          let index = 0;
          let exponent; let mantissa; let
            c;
          number = abs(number);
          // eslint-disable-next-line no-self-compare -- NaN check
          if (number != number || number === Infinity) {
            // eslint-disable-next-line no-self-compare -- NaN check
            mantissa = number != number ? 1 : 0;
            exponent = eMax;
          } else {
            exponent = floor(log(number) / LN2);
            if (number * (c = pow(2, -exponent)) < 1) {
              exponent--;
              c *= 2;
            }
            if (exponent + eBias >= 1) {
              number += rt / c;
            } else {
              number += rt * pow(2, 1 - eBias);
            }
            if (number * c >= 2) {
              exponent++;
              c /= 2;
            }
            if (exponent + eBias >= eMax) {
              mantissa = 0;
              exponent = eMax;
            } else if (exponent + eBias >= 1) {
              mantissa = (number * c - 1) * pow(2, mantissaLength);
              exponent += eBias;
            } else {
              mantissa = number * pow(2, eBias - 1) * pow(2, mantissaLength);
              exponent = 0;
            }
          }
          for (; mantissaLength >= 8; buffer[index++] = mantissa & 255, mantissa /= 256, mantissaLength -= 8);
          exponent = exponent << mantissaLength | mantissa;
          exponentLength += mantissaLength;
          for (; exponentLength > 0; buffer[index++] = exponent & 255, exponent /= 256, exponentLength -= 8);
          buffer[--index] |= sign * 128;
          return buffer;
        };

        const unpack = function (buffer, mantissaLength) {
          const bytes = buffer.length;
          const exponentLength = bytes * 8 - mantissaLength - 1;
          const eMax = (1 << exponentLength) - 1;
          const eBias = eMax >> 1;
          let nBits = exponentLength - 7;
          let index = bytes - 1;
          let sign = buffer[index--];
          let exponent = sign & 127;
          let mantissa;
          sign >>= 7;
          for (; nBits > 0; exponent = exponent * 256 + buffer[index], index--, nBits -= 8);
          mantissa = exponent & (1 << -nBits) - 1;
          exponent >>= -nBits;
          nBits += mantissaLength;
          for (; nBits > 0; mantissa = mantissa * 256 + buffer[index], index--, nBits -= 8);
          if (exponent === 0) {
            exponent = 1 - eBias;
          } else if (exponent === eMax) {
            return mantissa ? NaN : sign ? -Infinity : Infinity;
          } else {
            mantissa += pow(2, mantissaLength);
            exponent -= eBias;
          } return (sign ? -1 : 1) * mantissa * pow(2, exponent - mantissaLength);
        };

        module.exports = {
          pack,
          unpack,
        };
        /***/ }),

      /***/ 8361:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const uncurryThis = __webpack_require__(1702);
        const fails = __webpack_require__(7293);
        const classof = __webpack_require__(4326);

        const { Object } = global;
        const split = uncurryThis(''.split);

        // fallback for non-array-like ES3 and non-enumerable old V8 strings
        module.exports = fails(() =>
        // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
        // eslint-disable-next-line no-prototype-builtins -- safe
          !Object('z').propertyIsEnumerable(0)) ? function (it) {
            return classof(it) == 'String' ? split(it, '') : Object(it);
          } : Object;
        /***/ }),

      /***/ 9587:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const isCallable = __webpack_require__(614);
        const isObject = __webpack_require__(111);
        const setPrototypeOf = __webpack_require__(7674);

        // makes subclassing work correct for wrapped built-ins
        module.exports = function ($this, dummy, Wrapper) {
          let NewTarget; let
            NewTargetPrototype;
          if (
          // it can work only with native `setPrototypeOf`
            setPrototypeOf
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    && isCallable(NewTarget = dummy.constructor)
    && NewTarget !== Wrapper
    && isObject(NewTargetPrototype = NewTarget.prototype)
    && NewTargetPrototype !== Wrapper.prototype
          ) setPrototypeOf($this, NewTargetPrototype);
          return $this;
        };
        /***/ }),

      /***/ 2788:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const uncurryThis = __webpack_require__(1702);
        const isCallable = __webpack_require__(614);
        const store = __webpack_require__(5465);

        const functionToString = uncurryThis(Function.toString);

        // this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
        if (!isCallable(store.inspectSource)) {
          store.inspectSource = function (it) {
            return functionToString(it);
          };
        }

        module.exports = store.inspectSource;
        /***/ }),

      /***/ 8340:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const isObject = __webpack_require__(111);
        const createNonEnumerableProperty = __webpack_require__(8880);

        // `InstallErrorCause` abstract operation
        // https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
        module.exports = function (O, options) {
          if (isObject(options) && 'cause' in options) {
            createNonEnumerableProperty(O, 'cause', options.cause);
          }
        };
        /***/ }),

      /***/ 2423:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const uncurryThis = __webpack_require__(1702);
        const hiddenKeys = __webpack_require__(3501);
        const isObject = __webpack_require__(111);
        const hasOwn = __webpack_require__(2597);
        const defineProperty = (__webpack_require__(3070).f);
        const getOwnPropertyNamesModule = __webpack_require__(8006);
        const getOwnPropertyNamesExternalModule = __webpack_require__(1156);
        const uid = __webpack_require__(9711);
        const FREEZING = __webpack_require__(6677);

        let REQUIRED = false;
        const METADATA = uid('meta');
        let id = 0;

        // eslint-disable-next-line es/no-object-isextensible -- safe
        const isExtensible = Object.isExtensible || function () {
          return true;
        };

        const setMetadata = function (it) {
          defineProperty(it, METADATA, {
            value: {
              objectID: `O${id++}`, // object ID
              weakData: {}, // weak collections IDs
            },
          });
        };

        const fastKey = function (it, create) {
          // return a primitive with prefix
          if (!isObject(it)) return typeof it === 'symbol' ? it : (typeof it === 'string' ? 'S' : 'P') + it;
          if (!hasOwn(it, METADATA)) {
            // can't set metadata to uncaught frozen object
            if (!isExtensible(it)) return 'F';
            // not necessary to add metadata
            if (!create) return 'E';
            // add missing metadata
            setMetadata(it);
            // return object ID
          } return it[METADATA].objectID;
        };

        const getWeakData = function (it, create) {
          if (!hasOwn(it, METADATA)) {
            // can't set metadata to uncaught frozen object
            if (!isExtensible(it)) return true;
            // not necessary to add metadata
            if (!create) return false;
            // add missing metadata
            setMetadata(it);
            // return the store of weak collections IDs
          } return it[METADATA].weakData;
        };

        // add metadata on freeze-family methods calling
        const onFreeze = function (it) {
          if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
          return it;
        };

        const enable = function () {
          meta.enable = function () { /* empty */ };
          REQUIRED = true;
          const getOwnPropertyNames = getOwnPropertyNamesModule.f;
          const splice = uncurryThis([].splice);
          const test = {};
          test[METADATA] = 1;

          // prevent exposing of metadata key
          if (getOwnPropertyNames(test).length) {
            getOwnPropertyNamesModule.f = function (it) {
              const result = getOwnPropertyNames(it);
              for (let i = 0, { length } = result; i < length; i++) {
                if (result[i] === METADATA) {
                  splice(result, i, 1);
                  break;
                }
              } return result;
            };

            $({ target: 'Object', stat: true, forced: true }, {
              getOwnPropertyNames: getOwnPropertyNamesExternalModule.f,
            });
          }
        };

        var meta = module.exports = {
          enable,
          fastKey,
          getWeakData,
          onFreeze,
        };

        hiddenKeys[METADATA] = true;
        /***/ }),

      /***/ 9909:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const NATIVE_WEAK_MAP = __webpack_require__(8536);
        const global = __webpack_require__(7854);
        const uncurryThis = __webpack_require__(1702);
        const isObject = __webpack_require__(111);
        const createNonEnumerableProperty = __webpack_require__(8880);
        const hasOwn = __webpack_require__(2597);
        const shared = __webpack_require__(5465);
        const sharedKey = __webpack_require__(6200);
        const hiddenKeys = __webpack_require__(3501);

        const OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
        const { TypeError } = global;
        const { WeakMap } = global;
        let set; let get; let
          has;

        const enforce = function (it) {
          return has(it) ? get(it) : set(it, {});
        };

        const getterFor = function (TYPE) {
          return function (it) {
            let state;
            if (!isObject(it) || (state = get(it)).type !== TYPE) {
              throw TypeError(`Incompatible receiver, ${TYPE} required`);
            } return state;
          };
        };

        if (NATIVE_WEAK_MAP || shared.state) {
          const store = shared.state || (shared.state = new WeakMap());
          const wmget = uncurryThis(store.get);
          const wmhas = uncurryThis(store.has);
          const wmset = uncurryThis(store.set);
          set = function (it, metadata) {
            if (wmhas(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
            metadata.facade = it;
            wmset(store, it, metadata);
            return metadata;
          };
          get = function (it) {
            return wmget(store, it) || {};
          };
          has = function (it) {
            return wmhas(store, it);
          };
        } else {
          const STATE = sharedKey('state');
          hiddenKeys[STATE] = true;
          set = function (it, metadata) {
            if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
            metadata.facade = it;
            createNonEnumerableProperty(it, STATE, metadata);
            return metadata;
          };
          get = function (it) {
            return hasOwn(it, STATE) ? it[STATE] : {};
          };
          has = function (it) {
            return hasOwn(it, STATE);
          };
        }

        module.exports = {
          set,
          get,
          has,
          enforce,
          getterFor,
        };
        /***/ }),

      /***/ 7659:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const wellKnownSymbol = __webpack_require__(5112);
        const Iterators = __webpack_require__(7497);

        const ITERATOR = wellKnownSymbol('iterator');
        const ArrayPrototype = Array.prototype;

        // check on default Array iterator
        module.exports = function (it) {
          return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
        };
        /***/ }),

      /***/ 3157:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const classof = __webpack_require__(4326);

        // `IsArray` abstract operation
        // https://tc39.es/ecma262/#sec-isarray
        // eslint-disable-next-line es/no-array-isarray -- safe
        module.exports = Array.isArray || function isArray(argument) {
          return classof(argument) == 'Array';
        };
        /***/ }),

      /***/ 614:
      /***/ (function (module) {
        // `IsCallable` abstract operation
        // https://tc39.es/ecma262/#sec-iscallable
        module.exports = function (argument) {
          return typeof argument === 'function';
        };
        /***/ }),

      /***/ 4411:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const uncurryThis = __webpack_require__(1702);
        const fails = __webpack_require__(7293);
        const isCallable = __webpack_require__(614);
        const classof = __webpack_require__(648);
        const getBuiltIn = __webpack_require__(5005);
        const inspectSource = __webpack_require__(2788);

        const noop = function () { /* empty */ };
        const empty = [];
        const construct = getBuiltIn('Reflect', 'construct');
        const constructorRegExp = /^\s*(?:class|function)\b/;
        const exec = uncurryThis(constructorRegExp.exec);
        const INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

        const isConstructorModern = function (argument) {
          if (!isCallable(argument)) return false;
          try {
            construct(noop, empty, argument);
            return true;
          } catch (error) {
            return false;
          }
        };

        const isConstructorLegacy = function (argument) {
          if (!isCallable(argument)) return false;
          switch (classof(argument)) {
            case 'AsyncFunction':
            case 'GeneratorFunction':
            case 'AsyncGeneratorFunction': return false;
    // we can't check .prototype since constructors produced by .bind haven't it
          } return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
        };

        // `IsConstructor` abstract operation
        // https://tc39.es/ecma262/#sec-isconstructor
        module.exports = !construct || fails(() => {
          let called;
          return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(() => { called = true; })
    || called;
        }) ? isConstructorLegacy : isConstructorModern;
        /***/ }),

      /***/ 4705:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const fails = __webpack_require__(7293);
        const isCallable = __webpack_require__(614);

        const replacement = /#|\.prototype\./;

        const isForced = function (feature, detection) {
          const value = data[normalize(feature)];
          return value == POLYFILL ? true
            : value == NATIVE ? false
              : isCallable(detection) ? fails(detection)
                : !!detection;
        };

        var normalize = isForced.normalize = function (string) {
          return String(string).replace(replacement, '.').toLowerCase();
        };

        var data = isForced.data = {};
        var NATIVE = isForced.NATIVE = 'N';
        var POLYFILL = isForced.POLYFILL = 'P';

        module.exports = isForced;
        /***/ }),

      /***/ 5988:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const isObject = __webpack_require__(111);

        const { floor } = Math;

        // `IsIntegralNumber` abstract operation
        // https://tc39.es/ecma262/#sec-isintegralnumber
        // eslint-disable-next-line es/no-number-isinteger -- safe
        module.exports = Number.isInteger || function isInteger(it) {
          return !isObject(it) && isFinite(it) && floor(it) === it;
        };
        /***/ }),

      /***/ 111:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const isCallable = __webpack_require__(614);

        module.exports = function (it) {
          return typeof it === 'object' ? it !== null : isCallable(it);
        };
        /***/ }),

      /***/ 1913:
      /***/ (function (module) {
        module.exports = false;
        /***/ }),

      /***/ 7850:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const isObject = __webpack_require__(111);
        const classof = __webpack_require__(4326);
        const wellKnownSymbol = __webpack_require__(5112);

        const MATCH = wellKnownSymbol('match');

        // `IsRegExp` abstract operation
        // https://tc39.es/ecma262/#sec-isregexp
        module.exports = function (it) {
          let isRegExp;
          return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
        };
        /***/ }),

      /***/ 2190:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const getBuiltIn = __webpack_require__(5005);
        const isCallable = __webpack_require__(614);
        const isPrototypeOf = __webpack_require__(7976);
        const USE_SYMBOL_AS_UID = __webpack_require__(3307);

        const { Object } = global;

        module.exports = USE_SYMBOL_AS_UID ? function (it) {
          return typeof it === 'symbol';
        } : function (it) {
          const $Symbol = getBuiltIn('Symbol');
          return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, Object(it));
        };
        /***/ }),

      /***/ 408:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const bind = __webpack_require__(9974);
        const call = __webpack_require__(6916);
        const anObject = __webpack_require__(9670);
        const tryToString = __webpack_require__(6330);
        const isArrayIteratorMethod = __webpack_require__(7659);
        const lengthOfArrayLike = __webpack_require__(6244);
        const isPrototypeOf = __webpack_require__(7976);
        const getIterator = __webpack_require__(8554);
        const getIteratorMethod = __webpack_require__(1246);
        const iteratorClose = __webpack_require__(9212);

        const { TypeError } = global;

        const Result = function (stopped, result) {
          this.stopped = stopped;
          this.result = result;
        };

        const ResultPrototype = Result.prototype;

        module.exports = function (iterable, unboundFunction, options) {
          const that = options && options.that;
          const AS_ENTRIES = !!(options && options.AS_ENTRIES);
          const IS_ITERATOR = !!(options && options.IS_ITERATOR);
          const INTERRUPTED = !!(options && options.INTERRUPTED);
          const fn = bind(unboundFunction, that);
          let iterator; let iterFn; let index; let length; let result; let next; let
            step;

          const stop = function (condition) {
            if (iterator) iteratorClose(iterator, 'normal', condition);
            return new Result(true, condition);
          };

          const callFn = function (value) {
            if (AS_ENTRIES) {
              anObject(value);
              return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
            } return INTERRUPTED ? fn(value, stop) : fn(value);
          };

          if (IS_ITERATOR) {
            iterator = iterable;
          } else {
            iterFn = getIteratorMethod(iterable);
            if (!iterFn) throw TypeError(`${tryToString(iterable)} is not iterable`);
            // optimisation for array iterators
            if (isArrayIteratorMethod(iterFn)) {
              for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
                result = callFn(iterable[index]);
                if (result && isPrototypeOf(ResultPrototype, result)) return result;
              } return new Result(false);
            }
            iterator = getIterator(iterable, iterFn);
          }

          next = iterator.next;
          while (!(step = call(next, iterator)).done) {
            try {
              result = callFn(step.value);
            } catch (error) {
              iteratorClose(iterator, 'throw', error);
            }
            if (typeof result === 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
          } return new Result(false);
        };
        /***/ }),

      /***/ 9212:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const call = __webpack_require__(6916);
        const anObject = __webpack_require__(9670);
        const getMethod = __webpack_require__(8173);

        module.exports = function (iterator, kind, value) {
          let innerResult; let
            innerError;
          anObject(iterator);
          try {
            innerResult = getMethod(iterator, 'return');
            if (!innerResult) {
              if (kind === 'throw') throw value;
              return value;
            }
            innerResult = call(innerResult, iterator);
          } catch (error) {
            innerError = true;
            innerResult = error;
          }
          if (kind === 'throw') throw value;
          if (innerError) throw innerResult;
          anObject(innerResult);
          return value;
        };
        /***/ }),

      /***/ 3383:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const fails = __webpack_require__(7293);
        const isCallable = __webpack_require__(614);
        const create = __webpack_require__(30);
        const getPrototypeOf = __webpack_require__(9518);
        const redefine = __webpack_require__(1320);
        const wellKnownSymbol = __webpack_require__(5112);
        const IS_PURE = __webpack_require__(1913);

        const ITERATOR = wellKnownSymbol('iterator');
        let BUGGY_SAFARI_ITERATORS = false;

        // `%IteratorPrototype%` object
        // https://tc39.es/ecma262/#sec-%iteratorprototype%-object
        let IteratorPrototype; let PrototypeOfArrayIteratorPrototype; let
          arrayIterator;

        /* eslint-disable es/no-array-prototype-keys -- safe */
        if ([].keys) {
          arrayIterator = [].keys();
          // Safari 8 has buggy iterators w/o `next`
          if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
          else {
            PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
            if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
          }
        }

        const NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(() => {
          const test = {};
          // FF44- legacy iterators case
          return IteratorPrototype[ITERATOR].call(test) !== test;
        });

        if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
        else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

        // `%IteratorPrototype%[@@iterator]()` method
        // https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
        if (!isCallable(IteratorPrototype[ITERATOR])) {
          redefine(IteratorPrototype, ITERATOR, function () {
            return this;
          });
        }

        module.exports = {
          IteratorPrototype,
          BUGGY_SAFARI_ITERATORS,
        };
        /***/ }),

      /***/ 7497:
      /***/ (function (module) {
        module.exports = {};
        /***/ }),

      /***/ 6244:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const toLength = __webpack_require__(7466);

        // `LengthOfArrayLike` abstract operation
        // https://tc39.es/ecma262/#sec-lengthofarraylike
        module.exports = function (obj) {
          return toLength(obj.length);
        };
        /***/ }),

      /***/ 5948:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const bind = __webpack_require__(9974);
        const getOwnPropertyDescriptor = (__webpack_require__(1236).f);
        let macrotask = (__webpack_require__(261).set);
        const IS_IOS = __webpack_require__(6833);
        const IS_IOS_PEBBLE = __webpack_require__(1528);
        const IS_WEBOS_WEBKIT = __webpack_require__(1036);
        const IS_NODE = __webpack_require__(5268);

        const MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
        const { document } = global;
        const { process } = global;
        const { Promise } = global;
        // Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
        const queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
        const queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

        let flush; let head; let last; let notify; let toggle; let node; let promise; let
          then;

        // modern engines have queueMicrotask method
        if (!queueMicrotask) {
          flush = function () {
            let parent; let
              fn;
            if (IS_NODE && (parent = process.domain)) parent.exit();
            while (head) {
              fn = head.fn;
              head = head.next;
              try {
                fn();
              } catch (error) {
                if (head) notify();
                else last = undefined;
                throw error;
              }
            } last = undefined;
            if (parent) parent.enter();
          };

          // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
          // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
          if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
            toggle = true;
            node = document.createTextNode('');
            new MutationObserver(flush).observe(node, { characterData: true });
            notify = function () {
              node.data = toggle = !toggle;
            };
            // environments with maybe non-completely correct, but existent Promise
          } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
            // Promise.resolve without an argument throws an error in LG WebOS 2
            promise = Promise.resolve(undefined);
            // workaround of WebKit ~ iOS Safari 10.1 bug
            promise.constructor = Promise;
            then = bind(promise.then, promise);
            notify = function () {
              then(flush);
            };
            // Node.js without promises
          } else if (IS_NODE) {
            notify = function () {
              process.nextTick(flush);
            };
            // for other environments - macrotask based on:
            // - setImmediate
            // - MessageChannel
            // - window.postMessag
            // - onreadystatechange
            // - setTimeout
          } else {
            // strange IE + webpack dev server bug - use .bind(global)
            macrotask = bind(macrotask, global);
            notify = function () {
              macrotask(flush);
            };
          }
        }

        module.exports = queueMicrotask || function (fn) {
          const task = { fn, next: undefined };
          if (last) last.next = task;
          if (!head) {
            head = task;
            notify();
          } last = task;
        };
        /***/ }),

      /***/ 3366:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);

        module.exports = global.Promise;
        /***/ }),

      /***/ 133:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* eslint-disable es/no-symbol -- required for testing */
        const V8_VERSION = __webpack_require__(7392);
        const fails = __webpack_require__(7293);

        // eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
        module.exports = !!Object.getOwnPropertySymbols && !fails(() => {
          const symbol = Symbol();
          // Chrome 38 Symbol has incorrect toString conversion
          // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
          return !String(symbol) || !(Object(symbol) instanceof Symbol)
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    || !Symbol.sham && V8_VERSION && V8_VERSION < 41;
        });
        /***/ }),

      /***/ 8536:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const isCallable = __webpack_require__(614);
        const inspectSource = __webpack_require__(2788);

        const { WeakMap } = global;

        module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));
        /***/ }),

      /***/ 8523:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const aCallable = __webpack_require__(9662);

        const PromiseCapability = function (C) {
          let resolve; let
            reject;
          this.promise = new C((($$resolve, $$reject) => {
            if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
            resolve = $$resolve;
            reject = $$reject;
          }));
          this.resolve = aCallable(resolve);
          this.reject = aCallable(reject);
        };

        // `NewPromiseCapability` abstract operation
        // https://tc39.es/ecma262/#sec-newpromisecapability
        module.exports.f = function (C) {
          return new PromiseCapability(C);
        };
        /***/ }),

      /***/ 6277:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const toString = __webpack_require__(1340);

        module.exports = function (argument, $default) {
          return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
        };
        /***/ }),

      /***/ 3929:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const isRegExp = __webpack_require__(7850);

        const { TypeError } = global;

        module.exports = function (it) {
          if (isRegExp(it)) {
            throw TypeError("The method doesn't accept regular expressions");
          } return it;
        };
        /***/ }),

      /***/ 7023:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);

        const globalIsFinite = global.isFinite;

        // `Number.isFinite` method
        // https://tc39.es/ecma262/#sec-number.isfinite
        // eslint-disable-next-line es/no-number-isfinite -- safe
        module.exports = Number.isFinite || function isFinite(it) {
          return typeof it === 'number' && globalIsFinite(it);
        };
        /***/ }),

      /***/ 1574:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const DESCRIPTORS = __webpack_require__(9781);
        const uncurryThis = __webpack_require__(1702);
        const call = __webpack_require__(6916);
        const fails = __webpack_require__(7293);
        const objectKeys = __webpack_require__(1956);
        const getOwnPropertySymbolsModule = __webpack_require__(5181);
        const propertyIsEnumerableModule = __webpack_require__(5296);
        const toObject = __webpack_require__(7908);
        const IndexedObject = __webpack_require__(8361);

        // eslint-disable-next-line es/no-object-assign -- safe
        const $assign = Object.assign;
        // eslint-disable-next-line es/no-object-defineproperty -- required for testing
        const { defineProperty } = Object;
        const concat = uncurryThis([].concat);

        // `Object.assign` method
        // https://tc39.es/ecma262/#sec-object.assign
        module.exports = !$assign || fails(() => {
          // should have correct order of operations (Edge bug)
          if (DESCRIPTORS && ({
            b: 1,
            ...$assign(defineProperty({}, 'a', {
              enumerable: true,
              get() {
                defineProperty(this, 'b', {
                  value: 3,
                  enumerable: false,
                });
              },
            }), { b: 2 }),
          }).b !== 1) return true;
          // should work with symbols and should have deterministic property order (V8 bug)
          const A = {};
          const B = {};
          // eslint-disable-next-line es/no-symbol -- safe
          const symbol = Symbol();
          const alphabet = 'abcdefghijklmnopqrst';
          A[symbol] = 7;
          alphabet.split('').forEach((chr) => { B[chr] = chr; });
          return ({ ...A })[symbol] != 7 || objectKeys({ ...B }).join('') != alphabet;
        }) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
            const T = toObject(target);
            const argumentsLength = arguments.length;
            let index = 1;
            const getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
            const propertyIsEnumerable = propertyIsEnumerableModule.f;
            while (argumentsLength > index) {
              const S = IndexedObject(arguments[index++]);
              const keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
              const { length } = keys;
              let j = 0;
              var key;
              while (length > j) {
                key = keys[j++];
                if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
              }
            } return T;
          } : $assign;
        /***/ }),

      /***/ 30:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* global ActiveXObject -- old IE, WSH */
        const anObject = __webpack_require__(9670);
        const defineProperties = __webpack_require__(6048);
        const enumBugKeys = __webpack_require__(748);
        const hiddenKeys = __webpack_require__(3501);
        const html = __webpack_require__(490);
        const documentCreateElement = __webpack_require__(317);
        const sharedKey = __webpack_require__(6200);

        const GT = '>';
        const LT = '<';
        const PROTOTYPE = 'prototype';
        const SCRIPT = 'script';
        const IE_PROTO = sharedKey('IE_PROTO');

        const EmptyConstructor = function () { /* empty */ };

        const scriptTag = function (content) {
          return `${LT + SCRIPT + GT + content + LT}/${SCRIPT}${GT}`;
        };

        // Create object with fake `null` prototype: use ActiveX Object with cleared prototype
        const NullProtoObjectViaActiveX = function (activeXDocument) {
          activeXDocument.write(scriptTag(''));
          activeXDocument.close();
          const temp = activeXDocument.parentWindow.Object;
          activeXDocument = null; // avoid memory leak
          return temp;
        };

        // Create object with fake `null` prototype: use iframe Object with cleared prototype
        const NullProtoObjectViaIFrame = function () {
          // Thrash, waste and sodomy: IE GC bug
          const iframe = documentCreateElement('iframe');
          const JS = `java${SCRIPT}:`;
          let iframeDocument;
          iframe.style.display = 'none';
          html.appendChild(iframe);
          // https://github.com/zloirock/core-js/issues/475
          iframe.src = String(JS);
          iframeDocument = iframe.contentWindow.document;
          iframeDocument.open();
          iframeDocument.write(scriptTag('document.F=Object'));
          iframeDocument.close();
          return iframeDocument.F;
        };

        // Check for document.domain and active x support
        // No need to use active x approach when document.domain is not set
        // see https://github.com/es-shims/es5-shim/issues/150
        // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
        // avoid IE GC bug
        let activeXDocument;
        var NullProtoObject = function () {
          try {
            activeXDocument = new ActiveXObject('htmlfile');
          } catch (error) { /* ignore */ }
          NullProtoObject = typeof document !== 'undefined'
            ? document.domain && activeXDocument
              ? NullProtoObjectViaActiveX(activeXDocument) // old IE
              : NullProtoObjectViaIFrame()
            : NullProtoObjectViaActiveX(activeXDocument); // WSH
          let { length } = enumBugKeys;
          while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
          return NullProtoObject();
        };

        hiddenKeys[IE_PROTO] = true;

        // `Object.create` method
        // https://tc39.es/ecma262/#sec-object.create
        module.exports = Object.create || function create(O, Properties) {
          let result;
          if (O !== null) {
            EmptyConstructor[PROTOTYPE] = anObject(O);
            result = new EmptyConstructor();
            EmptyConstructor[PROTOTYPE] = null;
            // add "__proto__" for Object.getPrototypeOf polyfill
            result[IE_PROTO] = O;
          } else result = NullProtoObject();
          return Properties === undefined ? result : defineProperties(result, Properties);
        };
        /***/ }),

      /***/ 6048:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const DESCRIPTORS = __webpack_require__(9781);
        const definePropertyModule = __webpack_require__(3070);
        const anObject = __webpack_require__(9670);
        const toIndexedObject = __webpack_require__(5656);
        const objectKeys = __webpack_require__(1956);

        // `Object.defineProperties` method
        // https://tc39.es/ecma262/#sec-object.defineproperties
        // eslint-disable-next-line es/no-object-defineproperties -- safe
        module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
          anObject(O);
          const props = toIndexedObject(Properties);
          const keys = objectKeys(Properties);
          const { length } = keys;
          let index = 0;
          let key;
          while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
          return O;
        };
        /***/ }),

      /***/ 3070:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const DESCRIPTORS = __webpack_require__(9781);
        const IE8_DOM_DEFINE = __webpack_require__(4664);
        const anObject = __webpack_require__(9670);
        const toPropertyKey = __webpack_require__(4948);

        const { TypeError } = global;
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        const $defineProperty = Object.defineProperty;

        // `Object.defineProperty` method
        // https://tc39.es/ecma262/#sec-object.defineproperty
        exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
          anObject(O);
          P = toPropertyKey(P);
          anObject(Attributes);
          if (IE8_DOM_DEFINE) {
            try {
              return $defineProperty(O, P, Attributes);
            } catch (error) { /* empty */ }
          }
          if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
          if ('value' in Attributes) O[P] = Attributes.value;
          return O;
        };
        /***/ }),

      /***/ 1236:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        const DESCRIPTORS = __webpack_require__(9781);
        const call = __webpack_require__(6916);
        const propertyIsEnumerableModule = __webpack_require__(5296);
        const createPropertyDescriptor = __webpack_require__(9114);
        const toIndexedObject = __webpack_require__(5656);
        const toPropertyKey = __webpack_require__(4948);
        const hasOwn = __webpack_require__(2597);
        const IE8_DOM_DEFINE = __webpack_require__(4664);

        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        const $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

        // `Object.getOwnPropertyDescriptor` method
        // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
        exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
          O = toIndexedObject(O);
          P = toPropertyKey(P);
          if (IE8_DOM_DEFINE) {
            try {
              return $getOwnPropertyDescriptor(O, P);
            } catch (error) { /* empty */ }
          }
          if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
        };
        /***/ }),

      /***/ 1156:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* eslint-disable es/no-object-getownpropertynames -- safe */
        const classof = __webpack_require__(4326);
        const toIndexedObject = __webpack_require__(5656);
        const $getOwnPropertyNames = (__webpack_require__(8006).f);
        const arraySlice = __webpack_require__(206);

        const windowNames = typeof window === 'object' && window && Object.getOwnPropertyNames
          ? Object.getOwnPropertyNames(window) : [];

        const getWindowNames = function (it) {
          try {
            return $getOwnPropertyNames(it);
          } catch (error) {
            return arraySlice(windowNames);
          }
        };

        // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
        module.exports.f = function getOwnPropertyNames(it) {
          return windowNames && classof(it) == 'Window'
            ? getWindowNames(it)
            : $getOwnPropertyNames(toIndexedObject(it));
        };
        /***/ }),

      /***/ 8006:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        const internalObjectKeys = __webpack_require__(6324);
        const enumBugKeys = __webpack_require__(748);

        const hiddenKeys = enumBugKeys.concat('length', 'prototype');

        // `Object.getOwnPropertyNames` method
        // https://tc39.es/ecma262/#sec-object.getownpropertynames
        // eslint-disable-next-line es/no-object-getownpropertynames -- safe
        exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
          return internalObjectKeys(O, hiddenKeys);
        };
        /***/ }),

      /***/ 5181:
      /***/ (function (__unused_webpack_module, exports) {
        // eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
        exports.f = Object.getOwnPropertySymbols;
        /***/ }),

      /***/ 9518:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const hasOwn = __webpack_require__(2597);
        const isCallable = __webpack_require__(614);
        const toObject = __webpack_require__(7908);
        const sharedKey = __webpack_require__(6200);
        const CORRECT_PROTOTYPE_GETTER = __webpack_require__(8544);

        const IE_PROTO = sharedKey('IE_PROTO');
        const { Object } = global;
        const ObjectPrototype = Object.prototype;

        // `Object.getPrototypeOf` method
        // https://tc39.es/ecma262/#sec-object.getprototypeof
        module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
          const object = toObject(O);
          if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
          const { constructor } = object;
          if (isCallable(constructor) && object instanceof constructor) {
            return constructor.prototype;
          } return object instanceof Object ? ObjectPrototype : null;
        };
        /***/ }),

      /***/ 7976:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const uncurryThis = __webpack_require__(1702);

        module.exports = uncurryThis({}.isPrototypeOf);
        /***/ }),

      /***/ 6324:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const uncurryThis = __webpack_require__(1702);
        const hasOwn = __webpack_require__(2597);
        const toIndexedObject = __webpack_require__(5656);
        const { indexOf } = __webpack_require__(1318);
        const hiddenKeys = __webpack_require__(3501);

        const push = uncurryThis([].push);

        module.exports = function (object, names) {
          const O = toIndexedObject(object);
          let i = 0;
          const result = [];
          let key;
          for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
          // Don't enum bug & hidden keys
          while (names.length > i) {
            if (hasOwn(O, key = names[i++])) {
              ~indexOf(result, key) || push(result, key);
            }
          }
          return result;
        };
        /***/ }),

      /***/ 1956:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const internalObjectKeys = __webpack_require__(6324);
        const enumBugKeys = __webpack_require__(748);

        // `Object.keys` method
        // https://tc39.es/ecma262/#sec-object.keys
        // eslint-disable-next-line es/no-object-keys -- safe
        module.exports = Object.keys || function keys(O) {
          return internalObjectKeys(O, enumBugKeys);
        };
        /***/ }),

      /***/ 5296:
      /***/ (function (__unused_webpack_module, exports) {
        const $propertyIsEnumerable = {}.propertyIsEnumerable;
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        const { getOwnPropertyDescriptor } = Object;

        // Nashorn ~ JDK8 bug
        const NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

        // `Object.prototype.propertyIsEnumerable` method implementation
        // https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
        exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
          const descriptor = getOwnPropertyDescriptor(this, V);
          return !!descriptor && descriptor.enumerable;
        } : $propertyIsEnumerable;
        /***/ }),

      /***/ 7674:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* eslint-disable no-proto -- safe */
        const uncurryThis = __webpack_require__(1702);
        const anObject = __webpack_require__(9670);
        const aPossiblePrototype = __webpack_require__(6077);

        // `Object.setPrototypeOf` method
        // https://tc39.es/ecma262/#sec-object.setprototypeof
        // Works with __proto__ only. Old v8 can't work with null proto objects.
        // eslint-disable-next-line es/no-object-setprototypeof -- safe
        module.exports = Object.setPrototypeOf || ('__proto__' in {} ? (function () {
          let CORRECT_SETTER = false;
          const test = {};
          let setter;
          try {
            // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
            setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
            setter(test, []);
            CORRECT_SETTER = test instanceof Array;
          } catch (error) { /* empty */ }
          return function setPrototypeOf(O, proto) {
            anObject(O);
            aPossiblePrototype(proto);
            if (CORRECT_SETTER) setter(O, proto);
            else O.__proto__ = proto;
            return O;
          };
        }()) : undefined);
        /***/ }),

      /***/ 4699:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const DESCRIPTORS = __webpack_require__(9781);
        const uncurryThis = __webpack_require__(1702);
        const objectKeys = __webpack_require__(1956);
        const toIndexedObject = __webpack_require__(5656);
        const $propertyIsEnumerable = (__webpack_require__(5296).f);

        const propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
        const push = uncurryThis([].push);

        // `Object.{ entries, values }` methods implementation
        const createMethod = function (TO_ENTRIES) {
          return function (it) {
            const O = toIndexedObject(it);
            const keys = objectKeys(O);
            const { length } = keys;
            let i = 0;
            const result = [];
            let key;
            while (length > i) {
              key = keys[i++];
              if (!DESCRIPTORS || propertyIsEnumerable(O, key)) {
                push(result, TO_ENTRIES ? [key, O[key]] : O[key]);
              }
            }
            return result;
          };
        };

        module.exports = {
          // `Object.entries` method
          // https://tc39.es/ecma262/#sec-object.entries
          entries: createMethod(true),
          // `Object.values` method
          // https://tc39.es/ecma262/#sec-object.values
          values: createMethod(false),
        };
        /***/ }),

      /***/ 288:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const TO_STRING_TAG_SUPPORT = __webpack_require__(1694);
        const classof = __webpack_require__(648);

        // `Object.prototype.toString` method implementation
        // https://tc39.es/ecma262/#sec-object.prototype.tostring
        module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
          return `[object ${classof(this)}]`;
        };
        /***/ }),

      /***/ 2140:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const call = __webpack_require__(6916);
        const isCallable = __webpack_require__(614);
        const isObject = __webpack_require__(111);

        const { TypeError } = global;

        // `OrdinaryToPrimitive` abstract operation
        // https://tc39.es/ecma262/#sec-ordinarytoprimitive
        module.exports = function (input, pref) {
          let fn; let
            val;
          if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
          if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
          if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
          throw TypeError("Can't convert object to primitive value");
        };
        /***/ }),

      /***/ 3887:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const getBuiltIn = __webpack_require__(5005);
        const uncurryThis = __webpack_require__(1702);
        const getOwnPropertyNamesModule = __webpack_require__(8006);
        const getOwnPropertySymbolsModule = __webpack_require__(5181);
        const anObject = __webpack_require__(9670);

        const concat = uncurryThis([].concat);

        // all object keys, includes non-enumerable and symbols
        module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
          const keys = getOwnPropertyNamesModule.f(anObject(it));
          const getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
          return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
        };
        /***/ }),

      /***/ 857:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);

        module.exports = global;
        /***/ }),

      /***/ 2534:
      /***/ (function (module) {
        module.exports = function (exec) {
          try {
            return { error: false, value: exec() };
          } catch (error) {
            return { error: true, value: error };
          }
        };
        /***/ }),

      /***/ 9478:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const anObject = __webpack_require__(9670);
        const isObject = __webpack_require__(111);
        const newPromiseCapability = __webpack_require__(8523);

        module.exports = function (C, x) {
          anObject(C);
          if (isObject(x) && x.constructor === C) return x;
          const promiseCapability = newPromiseCapability.f(C);
          const { resolve } = promiseCapability;
          resolve(x);
          return promiseCapability.promise;
        };
        /***/ }),

      /***/ 2248:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const redefine = __webpack_require__(1320);

        module.exports = function (target, src, options) {
          for (const key in src) redefine(target, key, src[key], options);
          return target;
        };
        /***/ }),

      /***/ 1320:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const isCallable = __webpack_require__(614);
        const hasOwn = __webpack_require__(2597);
        const createNonEnumerableProperty = __webpack_require__(8880);
        const setGlobal = __webpack_require__(3505);
        const inspectSource = __webpack_require__(2788);
        const InternalStateModule = __webpack_require__(9909);
        const CONFIGURABLE_FUNCTION_NAME = (__webpack_require__(6530).CONFIGURABLE);

        const getInternalState = InternalStateModule.get;
        const enforceInternalState = InternalStateModule.enforce;
        const TEMPLATE = String(String).split('String');

        (module.exports = function (O, key, value, options) {
          const unsafe = options ? !!options.unsafe : false;
          let simple = options ? !!options.enumerable : false;
          const noTargetGet = options ? !!options.noTargetGet : false;
          let name = options && options.name !== undefined ? options.name : key;
          let state;
          if (isCallable(value)) {
            if (String(name).slice(0, 7) === 'Symbol(') {
              name = `[${String(name).replace(/^Symbol\(([^)]*)\)/, '$1')}]`;
            }
            if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
              createNonEnumerableProperty(value, 'name', name);
            }
            state = enforceInternalState(value);
            if (!state.source) {
              state.source = TEMPLATE.join(typeof name === 'string' ? name : '');
            }
          }
          if (O === global) {
            if (simple) O[key] = value;
            else setGlobal(key, value);
            return;
          } if (!unsafe) {
            delete O[key];
          } else if (!noTargetGet && O[key]) {
            simple = true;
          }
          if (simple) O[key] = value;
          else createNonEnumerableProperty(O, key, value);
          // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
        })(Function.prototype, 'toString', function toString() {
          return isCallable(this) && getInternalState(this).source || inspectSource(this);
        });
        /***/ }),

      /***/ 7651:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const call = __webpack_require__(6916);
        const anObject = __webpack_require__(9670);
        const isCallable = __webpack_require__(614);
        const classof = __webpack_require__(4326);
        const regexpExec = __webpack_require__(2261);

        const { TypeError } = global;

        // `RegExpExec` abstract operation
        // https://tc39.es/ecma262/#sec-regexpexec
        module.exports = function (R, S) {
          const { exec } = R;
          if (isCallable(exec)) {
            const result = call(exec, R, S);
            if (result !== null) anObject(result);
            return result;
          }
          if (classof(R) === 'RegExp') return call(regexpExec, R, S);
          throw TypeError('RegExp#exec called on incompatible receiver');
        };
        /***/ }),

      /***/ 2261:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
        /* eslint-disable regexp/no-useless-quantifier -- testing */
        const call = __webpack_require__(6916);
        const uncurryThis = __webpack_require__(1702);
        const toString = __webpack_require__(1340);
        const regexpFlags = __webpack_require__(7066);
        const stickyHelpers = __webpack_require__(2999);
        const shared = __webpack_require__(2309);
        const create = __webpack_require__(30);
        const getInternalState = (__webpack_require__(9909).get);
        const UNSUPPORTED_DOT_ALL = __webpack_require__(9441);
        const UNSUPPORTED_NCG = __webpack_require__(7168);

        const nativeReplace = shared('native-string-replace', String.prototype.replace);
        const nativeExec = RegExp.prototype.exec;
        let patchedExec = nativeExec;
        const charAt = uncurryThis(''.charAt);
        const indexOf = uncurryThis(''.indexOf);
        const replace = uncurryThis(''.replace);
        const stringSlice = uncurryThis(''.slice);

        const UPDATES_LAST_INDEX_WRONG = (function () {
          const re1 = /a/;
          const re2 = /b*/g;
          call(nativeExec, re1, 'a');
          call(nativeExec, re2, 'a');
          return re1.lastIndex !== 0 || re2.lastIndex !== 0;
        }());

        const UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

        // nonparticipating capturing group, copied from es5-shim's String#split patch.
        const NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

        const PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

        if (PATCH) {
          // eslint-disable-next-line max-statements -- TODO
          patchedExec = function exec(string) {
            const re = this;
            const state = getInternalState(re);
            const str = toString(string);
            const { raw } = state;
            let result; let reCopy; let lastIndex; let match; let i; let object; let
              group;

            if (raw) {
              raw.lastIndex = re.lastIndex;
              result = call(patchedExec, raw, str);
              re.lastIndex = raw.lastIndex;
              return result;
            }

            const { groups } = state;
            const sticky = UNSUPPORTED_Y && re.sticky;
            let flags = call(regexpFlags, re);
            let { source } = re;
            let charsAdded = 0;
            let strCopy = str;

            if (sticky) {
              flags = replace(flags, 'y', '');
              if (indexOf(flags, 'g') === -1) {
                flags += 'g';
              }

              strCopy = stringSlice(str, re.lastIndex);
              // Support anchored sticky behavior.
              if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
                source = `(?: ${source})`;
                strCopy = ` ${strCopy}`;
                charsAdded++;
              }
              // ^(? + rx + ) is needed, in combination with some str slicing, to
              // simulate the 'y' flag.
              reCopy = new RegExp(`^(?:${source})`, flags);
            }

            if (NPCG_INCLUDED) {
              reCopy = new RegExp(`^${source}$(?!\\s)`, flags);
            }
            if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

            match = call(nativeExec, sticky ? reCopy : re, strCopy);

            if (sticky) {
              if (match) {
                match.input = stringSlice(match.input, charsAdded);
                match[0] = stringSlice(match[0], charsAdded);
                match.index = re.lastIndex;
                re.lastIndex += match[0].length;
              } else re.lastIndex = 0;
            } else if (UPDATES_LAST_INDEX_WRONG && match) {
              re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
            }
            if (NPCG_INCLUDED && match && match.length > 1) {
              // Fix browsers whose `exec` methods don't consistently return `undefined`
              // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
              call(nativeReplace, match[0], reCopy, function () {
                for (i = 1; i < arguments.length - 2; i++) {
                  if (arguments[i] === undefined) match[i] = undefined;
                }
              });
            }

            if (match && groups) {
              match.groups = object = create(null);
              for (i = 0; i < groups.length; i++) {
                group = groups[i];
                object[group[0]] = match[group[1]];
              }
            }

            return match;
          };
        }

        module.exports = patchedExec;
        /***/ }),

      /***/ 7066:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const anObject = __webpack_require__(9670);

        // `RegExp.prototype.flags` getter implementation
        // https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
        module.exports = function () {
          const that = anObject(this);
          let result = '';
          if (that.global) result += 'g';
          if (that.ignoreCase) result += 'i';
          if (that.multiline) result += 'm';
          if (that.dotAll) result += 's';
          if (that.unicode) result += 'u';
          if (that.sticky) result += 'y';
          return result;
        };
        /***/ }),

      /***/ 2999:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        const fails = __webpack_require__(7293);
        const global = __webpack_require__(7854);

        // babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
        const $RegExp = global.RegExp;

        exports.UNSUPPORTED_Y = fails(() => {
          const re = $RegExp('a', 'y');
          re.lastIndex = 2;
          return re.exec('abcd') != null;
        });

        exports.BROKEN_CARET = fails(() => {
          // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
          const re = $RegExp('^r', 'gy');
          re.lastIndex = 2;
          return re.exec('str') != null;
        });
        /***/ }),

      /***/ 9441:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const fails = __webpack_require__(7293);
        const global = __webpack_require__(7854);

        // babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
        const $RegExp = global.RegExp;

        module.exports = fails(() => {
          const re = $RegExp('.', 's');
          return !(re.dotAll && re.exec('\n') && re.flags === 's');
        });
        /***/ }),

      /***/ 7168:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const fails = __webpack_require__(7293);
        const global = __webpack_require__(7854);

        // babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
        const $RegExp = global.RegExp;

        module.exports = fails(() => {
          const re = $RegExp('(?<a>b)', 'g');
          return re.exec('b').groups.a !== 'b'
    || 'b'.replace(re, '$<a>c') !== 'bc';
        });
        /***/ }),

      /***/ 4488:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);

        const { TypeError } = global;

        // `RequireObjectCoercible` abstract operation
        // https://tc39.es/ecma262/#sec-requireobjectcoercible
        module.exports = function (it) {
          if (it == undefined) throw TypeError(`Can't call method on ${it}`);
          return it;
        };
        /***/ }),

      /***/ 3505:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);

        // eslint-disable-next-line es/no-object-defineproperty -- safe
        const { defineProperty } = Object;

        module.exports = function (key, value) {
          try {
            defineProperty(global, key, { value, configurable: true, writable: true });
          } catch (error) {
            global[key] = value;
          } return value;
        };
        /***/ }),

      /***/ 6340:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const getBuiltIn = __webpack_require__(5005);
        const definePropertyModule = __webpack_require__(3070);
        const wellKnownSymbol = __webpack_require__(5112);
        const DESCRIPTORS = __webpack_require__(9781);

        const SPECIES = wellKnownSymbol('species');

        module.exports = function (CONSTRUCTOR_NAME) {
          const Constructor = getBuiltIn(CONSTRUCTOR_NAME);
          const defineProperty = definePropertyModule.f;

          if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
            defineProperty(Constructor, SPECIES, {
              configurable: true,
              get() { return this; },
            });
          }
        };
        /***/ }),

      /***/ 8003:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const defineProperty = (__webpack_require__(3070).f);
        const hasOwn = __webpack_require__(2597);
        const wellKnownSymbol = __webpack_require__(5112);

        const TO_STRING_TAG = wellKnownSymbol('toStringTag');

        module.exports = function (it, TAG, STATIC) {
          if (it && !hasOwn(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
            defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
          }
        };
        /***/ }),

      /***/ 6200:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const shared = __webpack_require__(2309);
        const uid = __webpack_require__(9711);

        const keys = shared('keys');

        module.exports = function (key) {
          return keys[key] || (keys[key] = uid(key));
        };
        /***/ }),

      /***/ 5465:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const setGlobal = __webpack_require__(3505);

        const SHARED = '__core-js_shared__';
        const store = global[SHARED] || setGlobal(SHARED, {});

        module.exports = store;
        /***/ }),

      /***/ 2309:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const IS_PURE = __webpack_require__(1913);
        const store = __webpack_require__(5465);

        (module.exports = function (key, value) {
          return store[key] || (store[key] = value !== undefined ? value : {});
        })('versions', []).push({
          version: '3.19.0',
          mode: IS_PURE ? 'pure' : 'global',
          copyright: '© 2021 Denis Pushkarev (zloirock.ru)',
        });
        /***/ }),

      /***/ 6707:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const anObject = __webpack_require__(9670);
        const aConstructor = __webpack_require__(9483);
        const wellKnownSymbol = __webpack_require__(5112);

        const SPECIES = wellKnownSymbol('species');

        // `SpeciesConstructor` abstract operation
        // https://tc39.es/ecma262/#sec-speciesconstructor
        module.exports = function (O, defaultConstructor) {
          const C = anObject(O).constructor;
          let S;
          return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aConstructor(S);
        };
        /***/ }),

      /***/ 3429:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const fails = __webpack_require__(7293);

        // check the existence of a method, lowercase
        // of a tag and escaping quotes in arguments
        module.exports = function (METHOD_NAME) {
          return fails(() => {
            const test = ''[METHOD_NAME]('"');
            return test !== test.toLowerCase() || test.split('"').length > 3;
          });
        };
        /***/ }),

      /***/ 8710:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const uncurryThis = __webpack_require__(1702);
        const toIntegerOrInfinity = __webpack_require__(9303);
        const toString = __webpack_require__(1340);
        const requireObjectCoercible = __webpack_require__(4488);

        const charAt = uncurryThis(''.charAt);
        const charCodeAt = uncurryThis(''.charCodeAt);
        const stringSlice = uncurryThis(''.slice);

        const createMethod = function (CONVERT_TO_STRING) {
          return function ($this, pos) {
            const S = toString(requireObjectCoercible($this));
            const position = toIntegerOrInfinity(pos);
            const size = S.length;
            let first; let
              second;
            if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
            first = charCodeAt(S, position);
            return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
              ? CONVERT_TO_STRING
                ? charAt(S, position)
                : first
              : CONVERT_TO_STRING
                ? stringSlice(S, position, position + 2)
                : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
          };
        };

        module.exports = {
          // `String.prototype.codePointAt` method
          // https://tc39.es/ecma262/#sec-string.prototype.codepointat
          codeAt: createMethod(false),
          // `String.prototype.at` method
          // https://github.com/mathiasbynens/String.prototype.at
          charAt: createMethod(true),
        };
        /***/ }),

      /***/ 8415:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const toIntegerOrInfinity = __webpack_require__(9303);
        const toString = __webpack_require__(1340);
        const requireObjectCoercible = __webpack_require__(4488);

        const { RangeError } = global;

        // `String.prototype.repeat` method implementation
        // https://tc39.es/ecma262/#sec-string.prototype.repeat
        module.exports = function repeat(count) {
          let str = toString(requireObjectCoercible(this));
          let result = '';
          let n = toIntegerOrInfinity(count);
          if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');
          for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
          return result;
        };
        /***/ }),

      /***/ 6091:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const PROPER_FUNCTION_NAME = (__webpack_require__(6530).PROPER);
        const fails = __webpack_require__(7293);
        const whitespaces = __webpack_require__(1361);

        const non = '\u200B\u0085\u180E';

        // check that a method works with the correct list
        // of whitespaces and has a correct name
        module.exports = function (METHOD_NAME) {
          return fails(() => !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME));
        };
        /***/ }),

      /***/ 3111:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const uncurryThis = __webpack_require__(1702);
        const requireObjectCoercible = __webpack_require__(4488);
        const toString = __webpack_require__(1340);
        const whitespaces = __webpack_require__(1361);

        const replace = uncurryThis(''.replace);
        const whitespace = `[${whitespaces}]`;
        const ltrim = RegExp(`^${whitespace}${whitespace}*`);
        const rtrim = RegExp(`${whitespace + whitespace}*$`);

        // `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
        const createMethod = function (TYPE) {
          return function ($this) {
            let string = toString(requireObjectCoercible($this));
            if (TYPE & 1) string = replace(string, ltrim, '');
            if (TYPE & 2) string = replace(string, rtrim, '');
            return string;
          };
        };

        module.exports = {
          // `String.prototype.{ trimLeft, trimStart }` methods
          // https://tc39.es/ecma262/#sec-string.prototype.trimstart
          start: createMethod(1),
          // `String.prototype.{ trimRight, trimEnd }` methods
          // https://tc39.es/ecma262/#sec-string.prototype.trimend
          end: createMethod(2),
          // `String.prototype.trim` method
          // https://tc39.es/ecma262/#sec-string.prototype.trim
          trim: createMethod(3),
        };
        /***/ }),

      /***/ 261:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const apply = __webpack_require__(2104);
        const bind = __webpack_require__(9974);
        const isCallable = __webpack_require__(614);
        const hasOwn = __webpack_require__(2597);
        const fails = __webpack_require__(7293);
        const html = __webpack_require__(490);
        const arraySlice = __webpack_require__(206);
        const createElement = __webpack_require__(317);
        const IS_IOS = __webpack_require__(6833);
        const IS_NODE = __webpack_require__(5268);

        let set = global.setImmediate;
        let clear = global.clearImmediate;
        const { process } = global;
        const { Dispatch } = global;
        const { Function } = global;
        const { MessageChannel } = global;
        const { String } = global;
        let counter = 0;
        const queue = {};
        const ONREADYSTATECHANGE = 'onreadystatechange';
        let location; let defer; let channel; let
          port;

        try {
          // Deno throws a ReferenceError on `location` access without `--location` flag
          location = global.location;
        } catch (error) { /* empty */ }

        const run = function (id) {
          if (hasOwn(queue, id)) {
            const fn = queue[id];
            delete queue[id];
            fn();
          }
        };

        const runner = function (id) {
          return function () {
            run(id);
          };
        };

        const listener = function (event) {
          run(event.data);
        };

        const post = function (id) {
          // old engines have not location.origin
          global.postMessage(String(id), `${location.protocol}//${location.host}`);
        };

        // Node.js 0.9+ & IE10+ has setImmediate, otherwise:
        if (!set || !clear) {
          set = function setImmediate(fn) {
            const args = arraySlice(arguments, 1);
            queue[++counter] = function () {
              apply(isCallable(fn) ? fn : Function(fn), undefined, args);
            };
            defer(counter);
            return counter;
          };
          clear = function clearImmediate(id) {
            delete queue[id];
          };
          // Node.js 0.8-
          if (IS_NODE) {
            defer = function (id) {
              process.nextTick(runner(id));
            };
            // Sphere (JS game engine) Dispatch API
          } else if (Dispatch && Dispatch.now) {
            defer = function (id) {
              Dispatch.now(runner(id));
            };
            // Browsers with MessageChannel, includes WebWorkers
            // except iOS - https://github.com/zloirock/core-js/issues/624
          } else if (MessageChannel && !IS_IOS) {
            channel = new MessageChannel();
            port = channel.port2;
            channel.port1.onmessage = listener;
            defer = bind(port.postMessage, port);
            // Browsers with postMessage, skip WebWorkers
            // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
          } else if (
            global.addEventListener
    && isCallable(global.postMessage)
    && !global.importScripts
    && location && location.protocol !== 'file:'
    && !fails(post)
          ) {
            defer = post;
            global.addEventListener('message', listener, false);
            // IE8-
          } else if (ONREADYSTATECHANGE in createElement('script')) {
            defer = function (id) {
              html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
                html.removeChild(this);
                run(id);
              };
            };
            // Rest old browsers
          } else {
            defer = function (id) {
              setTimeout(runner(id), 0);
            };
          }
        }

        module.exports = {
          set,
          clear,
        };
        /***/ }),

      /***/ 863:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const uncurryThis = __webpack_require__(1702);

        // `thisNumberValue` abstract operation
        // https://tc39.es/ecma262/#sec-thisnumbervalue
        module.exports = uncurryThis(1.0.valueOf);
        /***/ }),

      /***/ 1400:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const toIntegerOrInfinity = __webpack_require__(9303);

        const { max } = Math;
        const { min } = Math;

        // Helper for a popular repeating case of the spec:
        // Let integer be ? ToInteger(index).
        // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
        module.exports = function (index, length) {
          const integer = toIntegerOrInfinity(index);
          return integer < 0 ? max(integer + length, 0) : min(integer, length);
        };
        /***/ }),

      /***/ 7067:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const toIntegerOrInfinity = __webpack_require__(9303);
        const toLength = __webpack_require__(7466);

        const { RangeError } = global;

        // `ToIndex` abstract operation
        // https://tc39.es/ecma262/#sec-toindex
        module.exports = function (it) {
          if (it === undefined) return 0;
          const number = toIntegerOrInfinity(it);
          const length = toLength(number);
          if (number !== length) throw RangeError('Wrong length or index');
          return length;
        };
        /***/ }),

      /***/ 5656:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        // toObject with fallback for non-array-like ES3 strings
        const IndexedObject = __webpack_require__(8361);
        const requireObjectCoercible = __webpack_require__(4488);

        module.exports = function (it) {
          return IndexedObject(requireObjectCoercible(it));
        };
        /***/ }),

      /***/ 9303:
      /***/ (function (module) {
        const { ceil } = Math;
        const { floor } = Math;

        // `ToIntegerOrInfinity` abstract operation
        // https://tc39.es/ecma262/#sec-tointegerorinfinity
        module.exports = function (argument) {
          const number = +argument;
          // eslint-disable-next-line no-self-compare -- safe
          return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
        };
        /***/ }),

      /***/ 7466:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const toIntegerOrInfinity = __webpack_require__(9303);

        const { min } = Math;

        // `ToLength` abstract operation
        // https://tc39.es/ecma262/#sec-tolength
        module.exports = function (argument) {
          return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
        };
        /***/ }),

      /***/ 7908:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const requireObjectCoercible = __webpack_require__(4488);

        const { Object } = global;

        // `ToObject` abstract operation
        // https://tc39.es/ecma262/#sec-toobject
        module.exports = function (argument) {
          return Object(requireObjectCoercible(argument));
        };
        /***/ }),

      /***/ 4590:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const toPositiveInteger = __webpack_require__(3002);

        const { RangeError } = global;

        module.exports = function (it, BYTES) {
          const offset = toPositiveInteger(it);
          if (offset % BYTES) throw RangeError('Wrong offset');
          return offset;
        };
        /***/ }),

      /***/ 3002:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const toIntegerOrInfinity = __webpack_require__(9303);

        const { RangeError } = global;

        module.exports = function (it) {
          const result = toIntegerOrInfinity(it);
          if (result < 0) throw RangeError("The argument can't be less than 0");
          return result;
        };
        /***/ }),

      /***/ 7593:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const call = __webpack_require__(6916);
        const isObject = __webpack_require__(111);
        const isSymbol = __webpack_require__(2190);
        const getMethod = __webpack_require__(8173);
        const ordinaryToPrimitive = __webpack_require__(2140);
        const wellKnownSymbol = __webpack_require__(5112);

        const { TypeError } = global;
        const TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

        // `ToPrimitive` abstract operation
        // https://tc39.es/ecma262/#sec-toprimitive
        module.exports = function (input, pref) {
          if (!isObject(input) || isSymbol(input)) return input;
          const exoticToPrim = getMethod(input, TO_PRIMITIVE);
          let result;
          if (exoticToPrim) {
            if (pref === undefined) pref = 'default';
            result = call(exoticToPrim, input, pref);
            if (!isObject(result) || isSymbol(result)) return result;
            throw TypeError("Can't convert object to primitive value");
          }
          if (pref === undefined) pref = 'number';
          return ordinaryToPrimitive(input, pref);
        };
        /***/ }),

      /***/ 4948:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const toPrimitive = __webpack_require__(7593);
        const isSymbol = __webpack_require__(2190);

        // `ToPropertyKey` abstract operation
        // https://tc39.es/ecma262/#sec-topropertykey
        module.exports = function (argument) {
          const key = toPrimitive(argument, 'string');
          return isSymbol(key) ? key : `${key}`;
        };
        /***/ }),

      /***/ 1694:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const wellKnownSymbol = __webpack_require__(5112);

        const TO_STRING_TAG = wellKnownSymbol('toStringTag');
        const test = {};

        test[TO_STRING_TAG] = 'z';

        module.exports = String(test) === '[object z]';
        /***/ }),

      /***/ 1340:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const classof = __webpack_require__(648);

        const { String } = global;

        module.exports = function (argument) {
          if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
          return String(argument);
        };
        /***/ }),

      /***/ 6330:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);

        const { String } = global;

        module.exports = function (argument) {
          try {
            return String(argument);
          } catch (error) {
            return 'Object';
          }
        };
        /***/ }),

      /***/ 9843:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const global = __webpack_require__(7854);
        const call = __webpack_require__(6916);
        const DESCRIPTORS = __webpack_require__(9781);
        const TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(3832);
        const ArrayBufferViewCore = __webpack_require__(2094);
        const ArrayBufferModule = __webpack_require__(2091);
        const anInstance = __webpack_require__(5787);
        const createPropertyDescriptor = __webpack_require__(9114);
        const createNonEnumerableProperty = __webpack_require__(8880);
        const isIntegralNumber = __webpack_require__(5988);
        const toLength = __webpack_require__(7466);
        const toIndex = __webpack_require__(7067);
        const toOffset = __webpack_require__(4590);
        const toPropertyKey = __webpack_require__(4948);
        const hasOwn = __webpack_require__(2597);
        const classof = __webpack_require__(648);
        const isObject = __webpack_require__(111);
        const isSymbol = __webpack_require__(2190);
        const create = __webpack_require__(30);
        const isPrototypeOf = __webpack_require__(7976);
        const setPrototypeOf = __webpack_require__(7674);
        const getOwnPropertyNames = (__webpack_require__(8006).f);
        const typedArrayFrom = __webpack_require__(7321);
        const { forEach } = __webpack_require__(2092);
        const setSpecies = __webpack_require__(6340);
        const definePropertyModule = __webpack_require__(3070);
        const getOwnPropertyDescriptorModule = __webpack_require__(1236);
        const InternalStateModule = __webpack_require__(9909);
        const inheritIfRequired = __webpack_require__(9587);

        const getInternalState = InternalStateModule.get;
        const setInternalState = InternalStateModule.set;
        const nativeDefineProperty = definePropertyModule.f;
        const nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
        const { round } = Math;
        const { RangeError } = global;
        const { ArrayBuffer } = ArrayBufferModule;
        const ArrayBufferPrototype = ArrayBuffer.prototype;
        const { DataView } = ArrayBufferModule;
        const { NATIVE_ARRAY_BUFFER_VIEWS } = ArrayBufferViewCore;
        const { TYPED_ARRAY_CONSTRUCTOR } = ArrayBufferViewCore;
        const { TYPED_ARRAY_TAG } = ArrayBufferViewCore;
        const { TypedArray } = ArrayBufferViewCore;
        const { TypedArrayPrototype } = ArrayBufferViewCore;
        const { aTypedArrayConstructor } = ArrayBufferViewCore;
        const { isTypedArray } = ArrayBufferViewCore;
        const BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
        const WRONG_LENGTH = 'Wrong length';

        const fromList = function (C, list) {
          aTypedArrayConstructor(C);
          let index = 0;
          const { length } = list;
          const result = new C(length);
          while (length > index) result[index] = list[index++];
          return result;
        };

        const addGetter = function (it, key) {
          nativeDefineProperty(it, key, {
            get() {
              return getInternalState(this)[key];
            },
          });
        };

        const isArrayBuffer = function (it) {
          let klass;
          return isPrototypeOf(ArrayBufferPrototype, it) || (klass = classof(it)) == 'ArrayBuffer' || klass == 'SharedArrayBuffer';
        };

        const isTypedArrayIndex = function (target, key) {
          return isTypedArray(target)
    && !isSymbol(key)
    && key in target
    && isIntegralNumber(+key)
    && key >= 0;
        };

        const wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
          key = toPropertyKey(key);
          return isTypedArrayIndex(target, key)
            ? createPropertyDescriptor(2, target[key])
            : nativeGetOwnPropertyDescriptor(target, key);
        };

        const wrappedDefineProperty = function defineProperty(target, key, descriptor) {
          key = toPropertyKey(key);
          if (isTypedArrayIndex(target, key)
    && isObject(descriptor)
    && hasOwn(descriptor, 'value')
    && !hasOwn(descriptor, 'get')
    && !hasOwn(descriptor, 'set')
    // TODO: add validation descriptor w/o calling accessors
    && !descriptor.configurable
    && (!hasOwn(descriptor, 'writable') || descriptor.writable)
    && (!hasOwn(descriptor, 'enumerable') || descriptor.enumerable)
          ) {
            target[key] = descriptor.value;
            return target;
          } return nativeDefineProperty(target, key, descriptor);
        };

        if (DESCRIPTORS) {
          if (!NATIVE_ARRAY_BUFFER_VIEWS) {
            getOwnPropertyDescriptorModule.f = wrappedGetOwnPropertyDescriptor;
            definePropertyModule.f = wrappedDefineProperty;
            addGetter(TypedArrayPrototype, 'buffer');
            addGetter(TypedArrayPrototype, 'byteOffset');
            addGetter(TypedArrayPrototype, 'byteLength');
            addGetter(TypedArrayPrototype, 'length');
          }

          $({ target: 'Object', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
            getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
            defineProperty: wrappedDefineProperty,
          });

          module.exports = function (TYPE, wrapper, CLAMPED) {
            const BYTES = TYPE.match(/\d+$/)[0] / 8;
            const CONSTRUCTOR_NAME = `${TYPE + (CLAMPED ? 'Clamped' : '')}Array`;
            const GETTER = `get${TYPE}`;
            const SETTER = `set${TYPE}`;
            const NativeTypedArrayConstructor = global[CONSTRUCTOR_NAME];
            let TypedArrayConstructor = NativeTypedArrayConstructor;
            let TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
            const exported = {};

            const getter = function (that, index) {
              const data = getInternalState(that);
              return data.view[GETTER](index * BYTES + data.byteOffset, true);
            };

            const setter = function (that, index, value) {
              const data = getInternalState(that);
              if (CLAMPED) value = (value = round(value)) < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
              data.view[SETTER](index * BYTES + data.byteOffset, value, true);
            };

            const addElement = function (that, index) {
              nativeDefineProperty(that, index, {
                get() {
                  return getter(this, index);
                },
                set(value) {
                  return setter(this, index, value);
                },
                enumerable: true,
              });
            };

            if (!NATIVE_ARRAY_BUFFER_VIEWS) {
              TypedArrayConstructor = wrapper((that, data, offset, $length) => {
                anInstance(that, TypedArrayConstructorPrototype);
                let index = 0;
                let byteOffset = 0;
                let buffer; let byteLength; let
                  length;
                if (!isObject(data)) {
                  length = toIndex(data);
                  byteLength = length * BYTES;
                  buffer = new ArrayBuffer(byteLength);
                } else if (isArrayBuffer(data)) {
                  buffer = data;
                  byteOffset = toOffset(offset, BYTES);
                  const $len = data.byteLength;
                  if ($length === undefined) {
                    if ($len % BYTES) throw RangeError(WRONG_LENGTH);
                    byteLength = $len - byteOffset;
                    if (byteLength < 0) throw RangeError(WRONG_LENGTH);
                  } else {
                    byteLength = toLength($length) * BYTES;
                    if (byteLength + byteOffset > $len) throw RangeError(WRONG_LENGTH);
                  }
                  length = byteLength / BYTES;
                } else if (isTypedArray(data)) {
                  return fromList(TypedArrayConstructor, data);
                } else {
                  return call(typedArrayFrom, TypedArrayConstructor, data);
                }
                setInternalState(that, {
                  buffer,
                  byteOffset,
                  byteLength,
                  length,
                  view: new DataView(buffer),
                });
                while (index < length) addElement(that, index++);
              });

              if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
              TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = create(TypedArrayPrototype);
            } else if (TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS) {
              TypedArrayConstructor = wrapper((dummy, data, typedArrayOffset, $length) => {
                anInstance(dummy, TypedArrayConstructorPrototype);
                return inheritIfRequired((function () {
                  if (!isObject(data)) return new NativeTypedArrayConstructor(toIndex(data));
                  if (isArrayBuffer(data)) {
                    return $length !== undefined
                      ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES), $length)
                      : typedArrayOffset !== undefined
                        ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES))
                        : new NativeTypedArrayConstructor(data);
                  }
                  if (isTypedArray(data)) return fromList(TypedArrayConstructor, data);
                  return call(typedArrayFrom, TypedArrayConstructor, data);
                }()), dummy, TypedArrayConstructor);
              });

              if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
              forEach(getOwnPropertyNames(NativeTypedArrayConstructor), (key) => {
                if (!(key in TypedArrayConstructor)) {
                  createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
                }
              });
              TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
            }

            if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
              createNonEnumerableProperty(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
            }

            createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_CONSTRUCTOR, TypedArrayConstructor);

            if (TYPED_ARRAY_TAG) {
              createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
            }

            exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;

            $({
              global: true, forced: TypedArrayConstructor != NativeTypedArrayConstructor, sham: !NATIVE_ARRAY_BUFFER_VIEWS,
            }, exported);

            if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
              createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
            }

            if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
              createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
            }

            setSpecies(CONSTRUCTOR_NAME);
          };
        } else module.exports = function () { /* empty */ };
        /***/ }),

      /***/ 3832:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* eslint-disable no-new -- required for testing */
        const global = __webpack_require__(7854);
        const fails = __webpack_require__(7293);
        const checkCorrectnessOfIteration = __webpack_require__(7072);
        const { NATIVE_ARRAY_BUFFER_VIEWS } = __webpack_require__(2094);

        const { ArrayBuffer } = global;
        const { Int8Array } = global;

        module.exports = !NATIVE_ARRAY_BUFFER_VIEWS || !fails(() => {
          Int8Array(1);
        }) || !fails(() => {
          new Int8Array(-1);
        }) || !checkCorrectnessOfIteration((iterable) => {
          new Int8Array();
          new Int8Array(null);
          new Int8Array(1.5);
          new Int8Array(iterable);
        }, true) || fails(() =>
        // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
          new Int8Array(new ArrayBuffer(2), 1, undefined).length !== 1);
        /***/ }),

      /***/ 3074:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const arrayFromConstructorAndList = __webpack_require__(7745);
        const typedArraySpeciesConstructor = __webpack_require__(6304);

        module.exports = function (instance, list) {
          return arrayFromConstructorAndList(typedArraySpeciesConstructor(instance), list);
        };
        /***/ }),

      /***/ 7321:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const bind = __webpack_require__(9974);
        const call = __webpack_require__(6916);
        const aConstructor = __webpack_require__(9483);
        const toObject = __webpack_require__(7908);
        const lengthOfArrayLike = __webpack_require__(6244);
        const getIterator = __webpack_require__(8554);
        const getIteratorMethod = __webpack_require__(1246);
        const isArrayIteratorMethod = __webpack_require__(7659);
        const { aTypedArrayConstructor } = __webpack_require__(2094);

        module.exports = function from(source /* , mapfn, thisArg */) {
          const C = aConstructor(this);
          let O = toObject(source);
          const argumentsLength = arguments.length;
          let mapfn = argumentsLength > 1 ? arguments[1] : undefined;
          const mapping = mapfn !== undefined;
          const iteratorMethod = getIteratorMethod(O);
          let i; let length; let result; let step; let iterator; let
            next;
          if (iteratorMethod && !isArrayIteratorMethod(iteratorMethod)) {
            iterator = getIterator(O, iteratorMethod);
            next = iterator.next;
            O = [];
            while (!(step = call(next, iterator)).done) {
              O.push(step.value);
            }
          }
          if (mapping && argumentsLength > 2) {
            mapfn = bind(mapfn, arguments[2]);
          }
          length = lengthOfArrayLike(O);
          result = new (aTypedArrayConstructor(C))(length);
          for (i = 0; length > i; i++) {
            result[i] = mapping ? mapfn(O[i], i) : O[i];
          }
          return result;
        };
        /***/ }),

      /***/ 6304:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const ArrayBufferViewCore = __webpack_require__(2094);
        const speciesConstructor = __webpack_require__(6707);

        const { TYPED_ARRAY_CONSTRUCTOR } = ArrayBufferViewCore;
        const { aTypedArrayConstructor } = ArrayBufferViewCore;

        // a part of `TypedArraySpeciesCreate` abstract operation
        // https://tc39.es/ecma262/#typedarray-species-create
        module.exports = function (originalArray) {
          return aTypedArrayConstructor(speciesConstructor(originalArray, originalArray[TYPED_ARRAY_CONSTRUCTOR]));
        };
        /***/ }),

      /***/ 9711:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const uncurryThis = __webpack_require__(1702);

        let id = 0;
        const postfix = Math.random();
        const toString = uncurryThis(1.0.toString);

        module.exports = function (key) {
          return `Symbol(${key === undefined ? '' : key})_${toString(++id + postfix, 36)}`;
        };
        /***/ }),

      /***/ 3307:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* eslint-disable es/no-symbol -- required for testing */
        const NATIVE_SYMBOL = __webpack_require__(133);

        module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator === 'symbol';
        /***/ }),

      /***/ 6061:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        const wellKnownSymbol = __webpack_require__(5112);

        exports.f = wellKnownSymbol;
        /***/ }),

      /***/ 5112:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const shared = __webpack_require__(2309);
        const hasOwn = __webpack_require__(2597);
        const uid = __webpack_require__(9711);
        const NATIVE_SYMBOL = __webpack_require__(133);
        const USE_SYMBOL_AS_UID = __webpack_require__(3307);

        const WellKnownSymbolsStore = shared('wks');
        const { Symbol } = global;
        const symbolFor = Symbol && Symbol.for;
        const createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

        module.exports = function (name) {
          if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] === 'string')) {
            const description = `Symbol.${name}`;
            if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
              WellKnownSymbolsStore[name] = Symbol[name];
            } else if (USE_SYMBOL_AS_UID && symbolFor) {
              WellKnownSymbolsStore[name] = symbolFor(description);
            } else {
              WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
            }
          } return WellKnownSymbolsStore[name];
        };
        /***/ }),

      /***/ 1361:
      /***/ (function (module) {
        // a string of all valid unicode whitespaces
        module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002'
  + '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';
        /***/ }),

      /***/ 9170:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const global = __webpack_require__(7854);
        const isPrototypeOf = __webpack_require__(7976);
        const getPrototypeOf = __webpack_require__(9518);
        const setPrototypeOf = __webpack_require__(7674);
        const copyConstructorProperties = __webpack_require__(9920);
        const create = __webpack_require__(30);
        const createNonEnumerableProperty = __webpack_require__(8880);
        const createPropertyDescriptor = __webpack_require__(9114);
        const clearErrorStack = __webpack_require__(7741);
        const installErrorCause = __webpack_require__(8340);
        const iterate = __webpack_require__(408);
        const normalizeStringArgument = __webpack_require__(6277);
        const ERROR_STACK_INSTALLABLE = __webpack_require__(2914);

        const { Error } = global;
        const { push } = [];

        const $AggregateError = function AggregateError(errors, message /* , options */) {
          let that = isPrototypeOf(AggregateErrorPrototype, this) ? this : create(AggregateErrorPrototype);
          const options = arguments.length > 2 ? arguments[2] : undefined;
          if (setPrototypeOf) {
            that = setPrototypeOf(new Error(undefined), getPrototypeOf(that));
          }
          createNonEnumerableProperty(that, 'message', normalizeStringArgument(message, ''));
          if (ERROR_STACK_INSTALLABLE) createNonEnumerableProperty(that, 'stack', clearErrorStack(that.stack, 1));
          installErrorCause(that, options);
          const errorsArray = [];
          iterate(errors, push, { that: errorsArray });
          createNonEnumerableProperty(that, 'errors', errorsArray);
          return that;
        };

        if (setPrototypeOf) setPrototypeOf($AggregateError, Error);
        else copyConstructorProperties($AggregateError, Error);

        var AggregateErrorPrototype = $AggregateError.prototype = create(Error.prototype, {
          constructor: createPropertyDescriptor(1, $AggregateError),
          message: createPropertyDescriptor(1, ''),
          name: createPropertyDescriptor(1, 'AggregateError'),
        });

        // `AggregateError` constructor
        // https://tc39.es/ecma262/#sec-aggregate-error-constructor
        $({ global: true }, {
          AggregateError: $AggregateError,
        });
        /***/ }),

      /***/ 2222:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const global = __webpack_require__(7854);
        const fails = __webpack_require__(7293);
        const isArray = __webpack_require__(3157);
        const isObject = __webpack_require__(111);
        const toObject = __webpack_require__(7908);
        const lengthOfArrayLike = __webpack_require__(6244);
        const createProperty = __webpack_require__(6135);
        const arraySpeciesCreate = __webpack_require__(5417);
        const arrayMethodHasSpeciesSupport = __webpack_require__(1194);
        const wellKnownSymbol = __webpack_require__(5112);
        const V8_VERSION = __webpack_require__(7392);

        const IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
        const MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
        const MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';
        const { TypeError } = global;

        // We can't use this feature detection in V8 since it causes
        // deoptimization and serious performance degradation
        // https://github.com/zloirock/core-js/issues/679
        const IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(() => {
          const array = [];
          array[IS_CONCAT_SPREADABLE] = false;
          return array.concat()[0] !== array;
        });

        const SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

        const isConcatSpreadable = function (O) {
          if (!isObject(O)) return false;
          const spreadable = O[IS_CONCAT_SPREADABLE];
          return spreadable !== undefined ? !!spreadable : isArray(O);
        };

        const FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

        // `Array.prototype.concat` method
        // https://tc39.es/ecma262/#sec-array.prototype.concat
        // with adding support of @@isConcatSpreadable and @@species
        $({ target: 'Array', proto: true, forced: FORCED }, {
          // eslint-disable-next-line no-unused-vars -- required for `.length`
          concat: function concat(arg) {
            const O = toObject(this);
            const A = arraySpeciesCreate(O, 0);
            let n = 0;
            let i; let k; let length; let len; let
              E;
            for (i = -1, length = arguments.length; i < length; i++) {
              E = i === -1 ? O : arguments[i];
              if (isConcatSpreadable(E)) {
                len = lengthOfArrayLike(E);
                if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
                for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
              } else {
                if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
                createProperty(A, n++, E);
              }
            }
            A.length = n;
            return A;
          },
        });
        /***/ }),

      /***/ 545:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const copyWithin = __webpack_require__(1048);
        const addToUnscopables = __webpack_require__(1223);

        // `Array.prototype.copyWithin` method
        // https://tc39.es/ecma262/#sec-array.prototype.copywithin
        $({ target: 'Array', proto: true }, {
          copyWithin,
        });

        // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
        addToUnscopables('copyWithin');
        /***/ }),

      /***/ 3290:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const fill = __webpack_require__(1285);
        const addToUnscopables = __webpack_require__(1223);

        // `Array.prototype.fill` method
        // https://tc39.es/ecma262/#sec-array.prototype.fill
        $({ target: 'Array', proto: true }, {
          fill,
        });

        // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
        addToUnscopables('fill');
        /***/ }),

      /***/ 7327:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const $filter = (__webpack_require__(2092).filter);
        const arrayMethodHasSpeciesSupport = __webpack_require__(1194);

        const HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

        // `Array.prototype.filter` method
        // https://tc39.es/ecma262/#sec-array.prototype.filter
        // with adding support of @@species
        $({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
          filter: function filter(callbackfn /* , thisArg */) {
            return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
          },
        });
        /***/ }),

      /***/ 1038:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const from = __webpack_require__(8457);
        const checkCorrectnessOfIteration = __webpack_require__(7072);

        const INCORRECT_ITERATION = !checkCorrectnessOfIteration((iterable) => {
          // eslint-disable-next-line es/no-array-from -- required for testing
          Array.from(iterable);
        });

        // `Array.from` method
        // https://tc39.es/ecma262/#sec-array.from
        $({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
          from,
        });
        /***/ }),

      /***/ 6699:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const $includes = (__webpack_require__(1318).includes);
        const addToUnscopables = __webpack_require__(1223);

        // `Array.prototype.includes` method
        // https://tc39.es/ecma262/#sec-array.prototype.includes
        $({ target: 'Array', proto: true }, {
          includes: function includes(el /* , fromIndex = 0 */) {
            return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
          },
        });

        // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
        addToUnscopables('includes');
        /***/ }),

      /***/ 6992:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const toIndexedObject = __webpack_require__(5656);
        const addToUnscopables = __webpack_require__(1223);
        const Iterators = __webpack_require__(7497);
        const InternalStateModule = __webpack_require__(9909);
        const defineIterator = __webpack_require__(654);

        const ARRAY_ITERATOR = 'Array Iterator';
        const setInternalState = InternalStateModule.set;
        const getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

        // `Array.prototype.entries` method
        // https://tc39.es/ecma262/#sec-array.prototype.entries
        // `Array.prototype.keys` method
        // https://tc39.es/ecma262/#sec-array.prototype.keys
        // `Array.prototype.values` method
        // https://tc39.es/ecma262/#sec-array.prototype.values
        // `Array.prototype[@@iterator]` method
        // https://tc39.es/ecma262/#sec-array.prototype-@@iterator
        // `CreateArrayIterator` internal method
        // https://tc39.es/ecma262/#sec-createarrayiterator
        module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
          setInternalState(this, {
            type: ARRAY_ITERATOR,
            target: toIndexedObject(iterated), // target
            index: 0, // next index
            kind, // kind
          });
          // `%ArrayIteratorPrototype%.next` method
          // https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
        }, function () {
          const state = getInternalState(this);
          const { target } = state;
          const { kind } = state;
          const index = state.index++;
          if (!target || index >= target.length) {
            state.target = undefined;
            return { value: undefined, done: true };
          }
          if (kind == 'keys') return { value: index, done: false };
          if (kind == 'values') return { value: target[index], done: false };
          return { value: [index, target[index]], done: false };
        }, 'values');

        // argumentsList[@@iterator] is %ArrayProto_values%
        // https://tc39.es/ecma262/#sec-createunmappedargumentsobject
        // https://tc39.es/ecma262/#sec-createmappedargumentsobject
        Iterators.Arguments = Iterators.Array;

        // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
        addToUnscopables('keys');
        addToUnscopables('values');
        addToUnscopables('entries');
        /***/ }),

      /***/ 9600:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const uncurryThis = __webpack_require__(1702);
        const IndexedObject = __webpack_require__(8361);
        const toIndexedObject = __webpack_require__(5656);
        const arrayMethodIsStrict = __webpack_require__(9341);

        const un$Join = uncurryThis([].join);

        const ES3_STRINGS = IndexedObject != Object;
        const STRICT_METHOD = arrayMethodIsStrict('join', ',');

        // `Array.prototype.join` method
        // https://tc39.es/ecma262/#sec-array.prototype.join
        $({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
          join: function join(separator) {
            return un$Join(toIndexedObject(this), separator === undefined ? ',' : separator);
          },
        });
        /***/ }),

      /***/ 1249:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const $map = (__webpack_require__(2092).map);
        const arrayMethodHasSpeciesSupport = __webpack_require__(1194);

        const HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

        // `Array.prototype.map` method
        // https://tc39.es/ecma262/#sec-array.prototype.map
        // with adding support of @@species
        $({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
          map: function map(callbackfn /* , thisArg */) {
            return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
          },
        });
        /***/ }),

      /***/ 7042:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const global = __webpack_require__(7854);
        const isArray = __webpack_require__(3157);
        const isConstructor = __webpack_require__(4411);
        const isObject = __webpack_require__(111);
        const toAbsoluteIndex = __webpack_require__(1400);
        const lengthOfArrayLike = __webpack_require__(6244);
        const toIndexedObject = __webpack_require__(5656);
        const createProperty = __webpack_require__(6135);
        const wellKnownSymbol = __webpack_require__(5112);
        const arrayMethodHasSpeciesSupport = __webpack_require__(1194);
        const un$Slice = __webpack_require__(206);

        const HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

        const SPECIES = wellKnownSymbol('species');
        const { Array } = global;
        const { max } = Math;

        // `Array.prototype.slice` method
        // https://tc39.es/ecma262/#sec-array.prototype.slice
        // fallback for not array-like ES3 strings and DOM objects
        $({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
          slice: function slice(start, end) {
            const O = toIndexedObject(this);
            const length = lengthOfArrayLike(O);
            let k = toAbsoluteIndex(start, length);
            const fin = toAbsoluteIndex(end === undefined ? length : end, length);
            // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
            let Constructor; let result; let
              n;
            if (isArray(O)) {
              Constructor = O.constructor;
              // cross-realm fallback
              if (isConstructor(Constructor) && (Constructor === Array || isArray(Constructor.prototype))) {
                Constructor = undefined;
              } else if (isObject(Constructor)) {
                Constructor = Constructor[SPECIES];
                if (Constructor === null) Constructor = undefined;
              }
              if (Constructor === Array || Constructor === undefined) {
                return un$Slice(O, k, fin);
              }
            }
            result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
            for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
            result.length = n;
            return result;
          },
        });
        /***/ }),

      /***/ 2707:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const uncurryThis = __webpack_require__(1702);
        const aCallable = __webpack_require__(9662);
        const toObject = __webpack_require__(7908);
        const lengthOfArrayLike = __webpack_require__(6244);
        const toString = __webpack_require__(1340);
        const fails = __webpack_require__(7293);
        const internalSort = __webpack_require__(4362);
        const arrayMethodIsStrict = __webpack_require__(9341);
        const FF = __webpack_require__(8886);
        const IE_OR_EDGE = __webpack_require__(256);
        const V8 = __webpack_require__(7392);
        const WEBKIT = __webpack_require__(8008);

        const test = [];
        const un$Sort = uncurryThis(test.sort);
        const push = uncurryThis(test.push);

        // IE8-
        const FAILS_ON_UNDEFINED = fails(() => {
          test.sort(undefined);
        });
        // V8 bug
        const FAILS_ON_NULL = fails(() => {
          test.sort(null);
        });
        // Old WebKit
        const STRICT_METHOD = arrayMethodIsStrict('sort');

        const STABLE_SORT = !fails(() => {
          // feature detection can be too slow, so check engines versions
          if (V8) return V8 < 70;
          if (FF && FF > 3) return;
          if (IE_OR_EDGE) return true;
          if (WEBKIT) return WEBKIT < 603;

          let result = '';
          let code; let chr; let value; let
            index;

          // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
          for (code = 65; code < 76; code++) {
            chr = String.fromCharCode(code);

            switch (code) {
              case 66: case 69: case 70: case 72: value = 3; break;
              case 68: case 71: value = 4; break;
              default: value = 2;
            }

            for (index = 0; index < 47; index++) {
              test.push({ k: chr + index, v: value });
            }
          }

          test.sort((a, b) => b.v - a.v);

          for (index = 0; index < test.length; index++) {
            chr = test[index].k.charAt(0);
            if (result.charAt(result.length - 1) !== chr) result += chr;
          }

          return result !== 'DGBEFHACIJK';
        });

        const FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

        const getSortCompare = function (comparefn) {
          return function (x, y) {
            if (y === undefined) return -1;
            if (x === undefined) return 1;
            if (comparefn !== undefined) return +comparefn(x, y) || 0;
            return toString(x) > toString(y) ? 1 : -1;
          };
        };

        // `Array.prototype.sort` method
        // https://tc39.es/ecma262/#sec-array.prototype.sort
        $({ target: 'Array', proto: true, forced: FORCED }, {
          sort: function sort(comparefn) {
            if (comparefn !== undefined) aCallable(comparefn);

            const array = toObject(this);

            if (STABLE_SORT) return comparefn === undefined ? un$Sort(array) : un$Sort(array, comparefn);

            const items = [];
            const arrayLength = lengthOfArrayLike(array);
            let itemsLength; let
              index;

            for (index = 0; index < arrayLength; index++) {
              if (index in array) push(items, array[index]);
            }

            internalSort(items, getSortCompare(comparefn));

            itemsLength = items.length;
            index = 0;

            while (index < itemsLength) array[index] = items[index++];
            while (index < arrayLength) delete array[index++];

            return array;
          },
        });
        /***/ }),

      /***/ 561:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const global = __webpack_require__(7854);
        const toAbsoluteIndex = __webpack_require__(1400);
        const toIntegerOrInfinity = __webpack_require__(9303);
        const lengthOfArrayLike = __webpack_require__(6244);
        const toObject = __webpack_require__(7908);
        const arraySpeciesCreate = __webpack_require__(5417);
        const createProperty = __webpack_require__(6135);
        const arrayMethodHasSpeciesSupport = __webpack_require__(1194);

        const HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

        const { TypeError } = global;
        const { max } = Math;
        const { min } = Math;
        const MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
        const MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

        // `Array.prototype.splice` method
        // https://tc39.es/ecma262/#sec-array.prototype.splice
        // with adding support of @@species
        $({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
          splice: function splice(start, deleteCount /* , ...items */) {
            const O = toObject(this);
            const len = lengthOfArrayLike(O);
            const actualStart = toAbsoluteIndex(start, len);
            const argumentsLength = arguments.length;
            let insertCount; let actualDeleteCount; let A; let k; let from; let
              to;
            if (argumentsLength === 0) {
              insertCount = actualDeleteCount = 0;
            } else if (argumentsLength === 1) {
              insertCount = 0;
              actualDeleteCount = len - actualStart;
            } else {
              insertCount = argumentsLength - 2;
              actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
            }
            if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
              throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
            }
            A = arraySpeciesCreate(O, actualDeleteCount);
            for (k = 0; k < actualDeleteCount; k++) {
              from = actualStart + k;
              if (from in O) createProperty(A, k, O[from]);
            }
            A.length = actualDeleteCount;
            if (insertCount < actualDeleteCount) {
              for (k = actualStart; k < len - actualDeleteCount; k++) {
                from = k + actualDeleteCount;
                to = k + insertCount;
                if (from in O) O[to] = O[from];
                else delete O[to];
              }
              for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
            } else if (insertCount > actualDeleteCount) {
              for (k = len - actualDeleteCount; k > actualStart; k--) {
                from = k + actualDeleteCount - 1;
                to = k + insertCount - 1;
                if (from in O) O[to] = O[from];
                else delete O[to];
              }
            }
            for (k = 0; k < insertCount; k++) {
              O[k + actualStart] = arguments[k + 2];
            }
            O.length = len - actualDeleteCount + insertCount;
            return A;
          },
        });
        /***/ }),

      /***/ 6078:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const hasOwn = __webpack_require__(2597);
        const redefine = __webpack_require__(1320);
        const dateToPrimitive = __webpack_require__(8709);
        const wellKnownSymbol = __webpack_require__(5112);

        const TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
        const DatePrototype = Date.prototype;

        // `Date.prototype[@@toPrimitive]` method
        // https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
        if (!hasOwn(DatePrototype, TO_PRIMITIVE)) {
          redefine(DatePrototype, TO_PRIMITIVE, dateToPrimitive);
        }
        /***/ }),

      /***/ 8309:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const DESCRIPTORS = __webpack_require__(9781);
        const FUNCTION_NAME_EXISTS = (__webpack_require__(6530).EXISTS);
        const uncurryThis = __webpack_require__(1702);
        const defineProperty = (__webpack_require__(3070).f);

        const FunctionPrototype = Function.prototype;
        const functionToString = uncurryThis(FunctionPrototype.toString);
        const nameRE = /^\s*function ([^ (]*)/;
        const regExpExec = uncurryThis(nameRE.exec);
        const NAME = 'name';

        // Function instances `.name` property
        // https://tc39.es/ecma262/#sec-function-instances-name
        if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
          defineProperty(FunctionPrototype, NAME, {
            configurable: true,
            get() {
              try {
                return regExpExec(nameRE, functionToString(this))[1];
              } catch (error) {
                return '';
              }
            },
          });
        }
        /***/ }),

      /***/ 5837:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const global = __webpack_require__(7854);

        // `globalThis` object
        // https://tc39.es/ecma262/#sec-globalthis
        $({ global: true }, {
          globalThis: global,
        });
        /***/ }),

      /***/ 1532:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const collection = __webpack_require__(7710);
        const collectionStrong = __webpack_require__(5631);

        // `Map` constructor
        // https://tc39.es/ecma262/#sec-map-objects
        collection('Map', (init) => function Map() { return init(this, arguments.length ? arguments[0] : undefined); }, collectionStrong);
        /***/ }),

      /***/ 4256:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);

        const { log } = Math;
        const { LN2 } = Math;

        // `Math.log2` method
        // https://tc39.es/ecma262/#sec-math.log2
        $({ target: 'Math', stat: true }, {
          log2: function log2(x) {
            return log(x) / LN2;
          },
        });
        /***/ }),

      /***/ 9653:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const DESCRIPTORS = __webpack_require__(9781);
        const global = __webpack_require__(7854);
        const uncurryThis = __webpack_require__(1702);
        const isForced = __webpack_require__(4705);
        const redefine = __webpack_require__(1320);
        const hasOwn = __webpack_require__(2597);
        const inheritIfRequired = __webpack_require__(9587);
        const isPrototypeOf = __webpack_require__(7976);
        const isSymbol = __webpack_require__(2190);
        const toPrimitive = __webpack_require__(7593);
        const fails = __webpack_require__(7293);
        const getOwnPropertyNames = (__webpack_require__(8006).f);
        const getOwnPropertyDescriptor = (__webpack_require__(1236).f);
        const defineProperty = (__webpack_require__(3070).f);
        const thisNumberValue = __webpack_require__(863);
        const { trim } = __webpack_require__(3111);

        const NUMBER = 'Number';
        const NativeNumber = global[NUMBER];
        const NumberPrototype = NativeNumber.prototype;
        const { TypeError } = global;
        const arraySlice = uncurryThis(''.slice);
        const charCodeAt = uncurryThis(''.charCodeAt);

        // `ToNumeric` abstract operation
        // https://tc39.es/ecma262/#sec-tonumeric
        const toNumeric = function (value) {
          const primValue = toPrimitive(value, 'number');
          return typeof primValue === 'bigint' ? primValue : toNumber(primValue);
        };

        // `ToNumber` abstract operation
        // https://tc39.es/ecma262/#sec-tonumber
        var toNumber = function (argument) {
          let it = toPrimitive(argument, 'number');
          let first; let third; let radix; let maxCode; let digits; let length; let index; let
            code;
          if (isSymbol(it)) throw TypeError('Cannot convert a Symbol value to a number');
          if (typeof it === 'string' && it.length > 2) {
            it = trim(it);
            first = charCodeAt(it, 0);
            if (first === 43 || first === 45) {
              third = charCodeAt(it, 2);
              if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
            } else if (first === 48) {
              switch (charCodeAt(it, 1)) {
                case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
                case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
                default: return +it;
              }
              digits = arraySlice(it, 2);
              length = digits.length;
              for (index = 0; index < length; index++) {
                code = charCodeAt(digits, index);
                // parseInt parses a string to a first unavailable symbol
                // but ToNumber should return NaN if a string contains unavailable symbols
                if (code < 48 || code > maxCode) return NaN;
              } return parseInt(digits, radix);
            }
          } return +it;
        };

        // `Number` constructor
        // https://tc39.es/ecma262/#sec-number-constructor
        if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
          var NumberWrapper = function Number(value) {
            const n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
            const dummy = this;
            // check on 1..constructor(foo) case
            return isPrototypeOf(NumberPrototype, dummy) && fails(() => { thisNumberValue(dummy); })
              ? inheritIfRequired(Object(n), dummy, NumberWrapper) : n;
          };
          for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
            // ES3:
              'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,'
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    + 'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,'
    // ESNext
    + 'fromString,range'
            ).split(','), j = 0, key; keys.length > j; j++) {
            if (hasOwn(NativeNumber, key = keys[j]) && !hasOwn(NumberWrapper, key)) {
              defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
            }
          }
          NumberWrapper.prototype = NumberPrototype;
          NumberPrototype.constructor = NumberWrapper;
          redefine(global, NUMBER, NumberWrapper);
        }
        /***/ }),

      /***/ 3299:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);

        // `Number.EPSILON` constant
        // https://tc39.es/ecma262/#sec-number.epsilon
        $({ target: 'Number', stat: true }, {
          EPSILON: Math.pow(2, -52),
        });
        /***/ }),

      /***/ 5192:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const numberIsFinite = __webpack_require__(7023);

        // `Number.isFinite` method
        // https://tc39.es/ecma262/#sec-number.isfinite
        $({ target: 'Number', stat: true }, { isFinite: numberIsFinite });
        /***/ }),

      /***/ 3161:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const isIntegralNumber = __webpack_require__(5988);

        // `Number.isInteger` method
        // https://tc39.es/ecma262/#sec-number.isinteger
        $({ target: 'Number', stat: true }, {
          isInteger: isIntegralNumber,
        });
        /***/ }),

      /***/ 6977:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const global = __webpack_require__(7854);
        const uncurryThis = __webpack_require__(1702);
        const toIntegerOrInfinity = __webpack_require__(9303);
        const thisNumberValue = __webpack_require__(863);
        const $repeat = __webpack_require__(8415);
        const fails = __webpack_require__(7293);

        const { RangeError } = global;
        const { String } = global;
        const { floor } = Math;
        const repeat = uncurryThis($repeat);
        const stringSlice = uncurryThis(''.slice);
        const un$ToFixed = uncurryThis(1.0.toFixed);

        var pow = function (x, n, acc) {
          return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
        };

        const log = function (x) {
          let n = 0;
          let x2 = x;
          while (x2 >= 4096) {
            n += 12;
            x2 /= 4096;
          }
          while (x2 >= 2) {
            n += 1;
            x2 /= 2;
          } return n;
        };

        const multiply = function (data, n, c) {
          let index = -1;
          let c2 = c;
          while (++index < 6) {
            c2 += n * data[index];
            data[index] = c2 % 1e7;
            c2 = floor(c2 / 1e7);
          }
        };

        const divide = function (data, n) {
          let index = 6;
          let c = 0;
          while (--index >= 0) {
            c += data[index];
            data[index] = floor(c / n);
            c = (c % n) * 1e7;
          }
        };

        const dataToString = function (data) {
          let index = 6;
          let s = '';
          while (--index >= 0) {
            if (s !== '' || index === 0 || data[index] !== 0) {
              const t = String(data[index]);
              s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
            }
          } return s;
        };

        const FORCED = fails(() => un$ToFixed(0.00008, 3) !== '0.000'
    || un$ToFixed(0.9, 0) !== '1'
    || un$ToFixed(1.255, 2) !== '1.25'
    || un$ToFixed(1000000000000000128.0, 0) !== '1000000000000000128') || !fails(() => {
          // V8 ~ Android 4.3-
          un$ToFixed({});
        });

        // `Number.prototype.toFixed` method
        // https://tc39.es/ecma262/#sec-number.prototype.tofixed
        $({ target: 'Number', proto: true, forced: FORCED }, {
          toFixed: function toFixed(fractionDigits) {
            let number = thisNumberValue(this);
            const fractDigits = toIntegerOrInfinity(fractionDigits);
            const data = [0, 0, 0, 0, 0, 0];
            let sign = '';
            let result = '0';
            let e; let z; let j; let
              k;

            if (fractDigits < 0 || fractDigits > 20) throw RangeError('Incorrect fraction digits');
            // eslint-disable-next-line no-self-compare -- NaN check
            if (number != number) return 'NaN';
            if (number <= -1e21 || number >= 1e21) return String(number);
            if (number < 0) {
              sign = '-';
              number = -number;
            }
            if (number > 1e-21) {
              e = log(number * pow(2, 69, 1)) - 69;
              z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
              z *= 0x10000000000000;
              e = 52 - e;
              if (e > 0) {
                multiply(data, 0, z);
                j = fractDigits;
                while (j >= 7) {
                  multiply(data, 1e7, 0);
                  j -= 7;
                }
                multiply(data, pow(10, j, 1), 0);
                j = e - 1;
                while (j >= 23) {
                  divide(data, 1 << 23);
                  j -= 23;
                }
                divide(data, 1 << j);
                multiply(data, 1, 1);
                divide(data, 2);
                result = dataToString(data);
              } else {
                multiply(data, 0, z);
                multiply(data, 1 << -e, 0);
                result = dataToString(data) + repeat('0', fractDigits);
              }
            }
            if (fractDigits > 0) {
              k = result.length;
              result = sign + (k <= fractDigits
                ? `0.${repeat('0', fractDigits - k)}${result}`
                : `${stringSlice(result, 0, k - fractDigits)}.${stringSlice(result, k - fractDigits)}`);
            } else {
              result = sign + result;
            } return result;
          },
        });
        /***/ }),

      /***/ 9601:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const assign = __webpack_require__(1574);

        // `Object.assign` method
        // https://tc39.es/ecma262/#sec-object.assign
        // eslint-disable-next-line es/no-object-assign -- required for testing
        $({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
          assign,
        });
        /***/ }),

      /***/ 3371:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const FREEZING = __webpack_require__(6677);
        const fails = __webpack_require__(7293);
        const isObject = __webpack_require__(111);
        const { onFreeze } = __webpack_require__(2423);

        // eslint-disable-next-line es/no-object-freeze -- safe
        const $freeze = Object.freeze;
        const FAILS_ON_PRIMITIVES = fails(() => { $freeze(1); });

        // `Object.freeze` method
        // https://tc39.es/ecma262/#sec-object.freeze
        $({
          target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING,
        }, {
          freeze: function freeze(it) {
            return $freeze && isObject(it) ? $freeze(onFreeze(it)) : it;
          },
        });
        /***/ }),

      /***/ 5003:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const fails = __webpack_require__(7293);
        const toIndexedObject = __webpack_require__(5656);
        const nativeGetOwnPropertyDescriptor = (__webpack_require__(1236).f);
        const DESCRIPTORS = __webpack_require__(9781);

        const FAILS_ON_PRIMITIVES = fails(() => { nativeGetOwnPropertyDescriptor(1); });
        const FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

        // `Object.getOwnPropertyDescriptor` method
        // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
        $({
          target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS,
        }, {
          getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
            return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
          },
        });
        /***/ }),

      /***/ 9337:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const DESCRIPTORS = __webpack_require__(9781);
        const ownKeys = __webpack_require__(3887);
        const toIndexedObject = __webpack_require__(5656);
        const getOwnPropertyDescriptorModule = __webpack_require__(1236);
        const createProperty = __webpack_require__(6135);

        // `Object.getOwnPropertyDescriptors` method
        // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
        $({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
          getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
            const O = toIndexedObject(object);
            const getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
            const keys = ownKeys(O);
            const result = {};
            let index = 0;
            let key; let
              descriptor;
            while (keys.length > index) {
              descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
              if (descriptor !== undefined) createProperty(result, key, descriptor);
            }
            return result;
          },
        });
        /***/ }),

      /***/ 489:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const fails = __webpack_require__(7293);
        const toObject = __webpack_require__(7908);
        const nativeGetPrototypeOf = __webpack_require__(9518);
        const CORRECT_PROTOTYPE_GETTER = __webpack_require__(8544);

        const FAILS_ON_PRIMITIVES = fails(() => { nativeGetPrototypeOf(1); });

        // `Object.getPrototypeOf` method
        // https://tc39.es/ecma262/#sec-object.getprototypeof
        $({
          target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER,
        }, {
          getPrototypeOf: function getPrototypeOf(it) {
            return nativeGetPrototypeOf(toObject(it));
          },
        });
        /***/ }),

      /***/ 7941:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const toObject = __webpack_require__(7908);
        const nativeKeys = __webpack_require__(1956);
        const fails = __webpack_require__(7293);

        const FAILS_ON_PRIMITIVES = fails(() => { nativeKeys(1); });

        // `Object.keys` method
        // https://tc39.es/ecma262/#sec-object.keys
        $({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
          keys: function keys(it) {
            return nativeKeys(toObject(it));
          },
        });
        /***/ }),

      /***/ 1539:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const TO_STRING_TAG_SUPPORT = __webpack_require__(1694);
        const redefine = __webpack_require__(1320);
        const toString = __webpack_require__(288);

        // `Object.prototype.toString` method
        // https://tc39.es/ecma262/#sec-object.prototype.tostring
        if (!TO_STRING_TAG_SUPPORT) {
          redefine(Object.prototype, 'toString', toString, { unsafe: true });
        }
        /***/ }),

      /***/ 2479:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const $values = (__webpack_require__(4699).values);

        // `Object.values` method
        // https://tc39.es/ecma262/#sec-object.values
        $({ target: 'Object', stat: true }, {
          values: function values(O) {
            return $values(O);
          },
        });
        /***/ }),

      /***/ 7922:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const call = __webpack_require__(6916);
        const aCallable = __webpack_require__(9662);
        const newPromiseCapabilityModule = __webpack_require__(8523);
        const perform = __webpack_require__(2534);
        const iterate = __webpack_require__(408);

        // `Promise.allSettled` method
        // https://tc39.es/ecma262/#sec-promise.allsettled
        $({ target: 'Promise', stat: true }, {
          allSettled: function allSettled(iterable) {
            const C = this;
            const capability = newPromiseCapabilityModule.f(C);
            const { resolve } = capability;
            const { reject } = capability;
            const result = perform(() => {
              const promiseResolve = aCallable(C.resolve);
              const values = [];
              let counter = 0;
              let remaining = 1;
              iterate(iterable, (promise) => {
                const index = counter++;
                let alreadyCalled = false;
                remaining++;
                call(promiseResolve, C, promise).then((value) => {
                  if (alreadyCalled) return;
                  alreadyCalled = true;
                  values[index] = { status: 'fulfilled', value };
                  --remaining || resolve(values);
                }, (error) => {
                  if (alreadyCalled) return;
                  alreadyCalled = true;
                  values[index] = { status: 'rejected', reason: error };
                  --remaining || resolve(values);
                });
              });
              --remaining || resolve(values);
            });
            if (result.error) reject(result.value);
            return capability.promise;
          },
        });
        /***/ }),

      /***/ 4668:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const aCallable = __webpack_require__(9662);
        const getBuiltIn = __webpack_require__(5005);
        const call = __webpack_require__(6916);
        const newPromiseCapabilityModule = __webpack_require__(8523);
        const perform = __webpack_require__(2534);
        const iterate = __webpack_require__(408);

        const PROMISE_ANY_ERROR = 'No one promise resolved';

        // `Promise.any` method
        // https://tc39.es/ecma262/#sec-promise.any
        $({ target: 'Promise', stat: true }, {
          any: function any(iterable) {
            const C = this;
            const AggregateError = getBuiltIn('AggregateError');
            const capability = newPromiseCapabilityModule.f(C);
            const { resolve } = capability;
            const { reject } = capability;
            const result = perform(() => {
              const promiseResolve = aCallable(C.resolve);
              const errors = [];
              let counter = 0;
              let remaining = 1;
              let alreadyResolved = false;
              iterate(iterable, (promise) => {
                const index = counter++;
                let alreadyRejected = false;
                remaining++;
                call(promiseResolve, C, promise).then((value) => {
                  if (alreadyRejected || alreadyResolved) return;
                  alreadyResolved = true;
                  resolve(value);
                }, (error) => {
                  if (alreadyRejected || alreadyResolved) return;
                  alreadyRejected = true;
                  errors[index] = error;
                  --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
                });
              });
              --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
            });
            if (result.error) reject(result.value);
            return capability.promise;
          },
        });
        /***/ }),

      /***/ 7727:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const IS_PURE = __webpack_require__(1913);
        const NativePromise = __webpack_require__(3366);
        const fails = __webpack_require__(7293);
        const getBuiltIn = __webpack_require__(5005);
        const isCallable = __webpack_require__(614);
        const speciesConstructor = __webpack_require__(6707);
        const promiseResolve = __webpack_require__(9478);
        const redefine = __webpack_require__(1320);

        // Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
        const NON_GENERIC = !!NativePromise && fails(() => {
          NativePromise.prototype.finally.call({ then() { /* empty */ } }, () => { /* empty */ });
        });

        // `Promise.prototype.finally` method
        // https://tc39.es/ecma262/#sec-promise.prototype.finally
        $({
          target: 'Promise', proto: true, real: true, forced: NON_GENERIC,
        }, {
          finally(onFinally) {
            const C = speciesConstructor(this, getBuiltIn('Promise'));
            const isFunction = isCallable(onFinally);
            return this.then(
              isFunction ? (x) => promiseResolve(C, onFinally()).then(() => x) : onFinally,
              isFunction ? (e) => promiseResolve(C, onFinally()).then(() => { throw e; }) : onFinally,
            );
          },
        });

        // makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
        if (!IS_PURE && isCallable(NativePromise)) {
          const method = getBuiltIn('Promise').prototype.finally;
          if (NativePromise.prototype.finally !== method) {
            redefine(NativePromise.prototype, 'finally', method, { unsafe: true });
          }
        }
        /***/ }),

      /***/ 8674:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const IS_PURE = __webpack_require__(1913);
        const global = __webpack_require__(7854);
        const getBuiltIn = __webpack_require__(5005);
        const call = __webpack_require__(6916);
        const NativePromise = __webpack_require__(3366);
        const redefine = __webpack_require__(1320);
        const redefineAll = __webpack_require__(2248);
        const setPrototypeOf = __webpack_require__(7674);
        const setToStringTag = __webpack_require__(8003);
        const setSpecies = __webpack_require__(6340);
        const aCallable = __webpack_require__(9662);
        const isCallable = __webpack_require__(614);
        const isObject = __webpack_require__(111);
        const anInstance = __webpack_require__(5787);
        const inspectSource = __webpack_require__(2788);
        const iterate = __webpack_require__(408);
        const checkCorrectnessOfIteration = __webpack_require__(7072);
        const speciesConstructor = __webpack_require__(6707);
        const task = (__webpack_require__(261).set);
        const microtask = __webpack_require__(5948);
        const promiseResolve = __webpack_require__(9478);
        const hostReportErrors = __webpack_require__(842);
        const newPromiseCapabilityModule = __webpack_require__(8523);
        const perform = __webpack_require__(2534);
        const InternalStateModule = __webpack_require__(9909);
        const isForced = __webpack_require__(4705);
        const wellKnownSymbol = __webpack_require__(5112);
        const IS_BROWSER = __webpack_require__(7871);
        const IS_NODE = __webpack_require__(5268);
        const V8_VERSION = __webpack_require__(7392);

        const SPECIES = wellKnownSymbol('species');
        const PROMISE = 'Promise';

        const getInternalState = InternalStateModule.get;
        const setInternalState = InternalStateModule.set;
        const getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
        const NativePromisePrototype = NativePromise && NativePromise.prototype;
        let PromiseConstructor = NativePromise;
        let PromisePrototype = NativePromisePrototype;
        const { TypeError } = global;
        const { document } = global;
        const { process } = global;
        let newPromiseCapability = newPromiseCapabilityModule.f;
        const newGenericPromiseCapability = newPromiseCapability;

        const DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
        const NATIVE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);
        const UNHANDLED_REJECTION = 'unhandledrejection';
        const REJECTION_HANDLED = 'rejectionhandled';
        const PENDING = 0;
        const FULFILLED = 1;
        const REJECTED = 2;
        const HANDLED = 1;
        const UNHANDLED = 2;
        let SUBCLASSING = false;

        let Internal; let OwnPromiseCapability; let PromiseWrapper; let
          nativeThen;

        const FORCED = isForced(PROMISE, () => {
          const PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
          const GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor);
          // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
          // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
          // We can't detect it synchronously, so just check versions
          if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
          // We need Promise#finally in the pure version for preventing prototype pollution
          if (IS_PURE && !PromisePrototype.finally) return true;
          // We can't use @@species feature detection in V8 since it causes
          // deoptimization and performance degradation
          // https://github.com/zloirock/core-js/issues/679
          if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
          // Detect correctness of subclassing with @@species support
          const promise = new PromiseConstructor(((resolve) => { resolve(1); }));
          const FakePromise = function (exec) {
            exec(() => { /* empty */ }, () => { /* empty */ });
          };
          const constructor = promise.constructor = {};
          constructor[SPECIES] = FakePromise;
          SUBCLASSING = promise.then(() => { /* empty */ }) instanceof FakePromise;
          if (!SUBCLASSING) return true;
          // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
          return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
        });

        const INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration((iterable) => {
          PromiseConstructor.all(iterable).catch(() => { /* empty */ });
        });

        // helpers
        const isThenable = function (it) {
          let then;
          return isObject(it) && isCallable(then = it.then) ? then : false;
        };

        const notify = function (state, isReject) {
          if (state.notified) return;
          state.notified = true;
          const chain = state.reactions;
          microtask(() => {
            const { value } = state;
            const ok = state.state == FULFILLED;
            let index = 0;
            // variable length - can't use forEach
            while (chain.length > index) {
              const reaction = chain[index++];
              const handler = ok ? reaction.ok : reaction.fail;
              const { resolve } = reaction;
              const { reject } = reaction;
              const { domain } = reaction;
              var result; var then; var
                exited;
              try {
                if (handler) {
                  if (!ok) {
                    if (state.rejection === UNHANDLED) onHandleUnhandled(state);
                    state.rejection = HANDLED;
                  }
                  if (handler === true) result = value;
                  else {
                    if (domain) domain.enter();
                    result = handler(value); // can throw
                    if (domain) {
                      domain.exit();
                      exited = true;
                    }
                  }
                  if (result === reaction.promise) {
                    reject(TypeError('Promise-chain cycle'));
                  } else if (then = isThenable(result)) {
                    call(then, result, resolve, reject);
                  } else resolve(result);
                } else reject(value);
              } catch (error) {
                if (domain && !exited) domain.exit();
                reject(error);
              }
            }
            state.reactions = [];
            state.notified = false;
            if (isReject && !state.rejection) onUnhandled(state);
          });
        };

        const dispatchEvent = function (name, promise, reason) {
          let event; let
            handler;
          if (DISPATCH_EVENT) {
            event = document.createEvent('Event');
            event.promise = promise;
            event.reason = reason;
            event.initEvent(name, false, true);
            global.dispatchEvent(event);
          } else event = { promise, reason };
          if (!NATIVE_REJECTION_EVENT && (handler = global[`on${name}`])) handler(event);
          else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
        };

        var onUnhandled = function (state) {
          call(task, global, () => {
            const promise = state.facade;
            const { value } = state;
            const IS_UNHANDLED = isUnhandled(state);
            let result;
            if (IS_UNHANDLED) {
              result = perform(() => {
                if (IS_NODE) {
                  process.emit('unhandledRejection', value, promise);
                } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
              });
              // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
              state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
              if (result.error) throw result.value;
            }
          });
        };

        var isUnhandled = function (state) {
          return state.rejection !== HANDLED && !state.parent;
        };

        var onHandleUnhandled = function (state) {
          call(task, global, () => {
            const promise = state.facade;
            if (IS_NODE) {
              process.emit('rejectionHandled', promise);
            } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
          });
        };

        const bind = function (fn, state, unwrap) {
          return function (value) {
            fn(state, value, unwrap);
          };
        };

        const internalReject = function (state, value, unwrap) {
          if (state.done) return;
          state.done = true;
          if (unwrap) state = unwrap;
          state.value = value;
          state.state = REJECTED;
          notify(state, true);
        };

        var internalResolve = function (state, value, unwrap) {
          if (state.done) return;
          state.done = true;
          if (unwrap) state = unwrap;
          try {
            if (state.facade === value) throw TypeError("Promise can't be resolved itself");
            const then = isThenable(value);
            if (then) {
              microtask(() => {
                const wrapper = { done: false };
                try {
                  call(then, value,
                    bind(internalResolve, wrapper, state),
                    bind(internalReject, wrapper, state));
                } catch (error) {
                  internalReject(wrapper, error, state);
                }
              });
            } else {
              state.value = value;
              state.state = FULFILLED;
              notify(state, false);
            }
          } catch (error) {
            internalReject({ done: false }, error, state);
          }
        };

        // constructor polyfill
        if (FORCED) {
          // 25.4.3.1 Promise(executor)
          PromiseConstructor = function Promise(executor) {
            anInstance(this, PromisePrototype);
            aCallable(executor);
            call(Internal, this);
            const state = getInternalState(this);
            try {
              executor(bind(internalResolve, state), bind(internalReject, state));
            } catch (error) {
              internalReject(state, error);
            }
          };
          PromisePrototype = PromiseConstructor.prototype;
          // eslint-disable-next-line no-unused-vars -- required for `.length`
          Internal = function Promise(executor) {
            setInternalState(this, {
              type: PROMISE,
              done: false,
              notified: false,
              parent: false,
              reactions: [],
              rejection: false,
              state: PENDING,
              value: undefined,
            });
          };
          Internal.prototype = redefineAll(PromisePrototype, {
            // `Promise.prototype.then` method
            // https://tc39.es/ecma262/#sec-promise.prototype.then
            then: function then(onFulfilled, onRejected) {
              const state = getInternalPromiseState(this);
              const { reactions } = state;
              const reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
              reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
              reaction.fail = isCallable(onRejected) && onRejected;
              reaction.domain = IS_NODE ? process.domain : undefined;
              state.parent = true;
              reactions[reactions.length] = reaction;
              if (state.state != PENDING) notify(state, false);
              return reaction.promise;
            },
            // `Promise.prototype.catch` method
            // https://tc39.es/ecma262/#sec-promise.prototype.catch
            catch(onRejected) {
              return this.then(undefined, onRejected);
            },
          });
          OwnPromiseCapability = function () {
            const promise = new Internal();
            const state = getInternalState(promise);
            this.promise = promise;
            this.resolve = bind(internalResolve, state);
            this.reject = bind(internalReject, state);
          };
          newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
            return C === PromiseConstructor || C === PromiseWrapper
              ? new OwnPromiseCapability(C)
              : newGenericPromiseCapability(C);
          };

          if (!IS_PURE && isCallable(NativePromise) && NativePromisePrototype !== Object.prototype) {
            nativeThen = NativePromisePrototype.then;

            if (!SUBCLASSING) {
              // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
              redefine(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
                const that = this;
                return new PromiseConstructor(((resolve, reject) => {
                  call(nativeThen, that, resolve, reject);
                })).then(onFulfilled, onRejected);
                // https://github.com/zloirock/core-js/issues/640
              }, { unsafe: true });

              // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
              redefine(NativePromisePrototype, 'catch', PromisePrototype.catch, { unsafe: true });
            }

            // make `.constructor === Promise` work for native promise-based APIs
            try {
              delete NativePromisePrototype.constructor;
            } catch (error) { /* empty */ }

            // make `instanceof Promise` work for native promise-based APIs
            if (setPrototypeOf) {
              setPrototypeOf(NativePromisePrototype, PromisePrototype);
            }
          }
        }

        $({ global: true, wrap: true, forced: FORCED }, {
          Promise: PromiseConstructor,
        });

        setToStringTag(PromiseConstructor, PROMISE, false, true);
        setSpecies(PROMISE);

        PromiseWrapper = getBuiltIn(PROMISE);

        // statics
        $({ target: PROMISE, stat: true, forced: FORCED }, {
          // `Promise.reject` method
          // https://tc39.es/ecma262/#sec-promise.reject
          reject: function reject(r) {
            const capability = newPromiseCapability(this);
            call(capability.reject, undefined, r);
            return capability.promise;
          },
        });

        $({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
          // `Promise.resolve` method
          // https://tc39.es/ecma262/#sec-promise.resolve
          resolve: function resolve(x) {
            return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
          },
        });

        $({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
          // `Promise.all` method
          // https://tc39.es/ecma262/#sec-promise.all
          all: function all(iterable) {
            const C = this;
            const capability = newPromiseCapability(C);
            const { resolve } = capability;
            const { reject } = capability;
            const result = perform(() => {
              const $promiseResolve = aCallable(C.resolve);
              const values = [];
              let counter = 0;
              let remaining = 1;
              iterate(iterable, (promise) => {
                const index = counter++;
                let alreadyCalled = false;
                remaining++;
                call($promiseResolve, C, promise).then((value) => {
                  if (alreadyCalled) return;
                  alreadyCalled = true;
                  values[index] = value;
                  --remaining || resolve(values);
                }, reject);
              });
              --remaining || resolve(values);
            });
            if (result.error) reject(result.value);
            return capability.promise;
          },
          // `Promise.race` method
          // https://tc39.es/ecma262/#sec-promise.race
          race: function race(iterable) {
            const C = this;
            const capability = newPromiseCapability(C);
            const { reject } = capability;
            const result = perform(() => {
              const $promiseResolve = aCallable(C.resolve);
              iterate(iterable, (promise) => {
                call($promiseResolve, C, promise).then(capability.resolve, reject);
              });
            });
            if (result.error) reject(result.value);
            return capability.promise;
          },
        });
        /***/ }),

      /***/ 2419:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const getBuiltIn = __webpack_require__(5005);
        const apply = __webpack_require__(2104);
        const bind = __webpack_require__(7065);
        const aConstructor = __webpack_require__(9483);
        const anObject = __webpack_require__(9670);
        const isObject = __webpack_require__(111);
        const create = __webpack_require__(30);
        const fails = __webpack_require__(7293);

        const nativeConstruct = getBuiltIn('Reflect', 'construct');
        const ObjectPrototype = Object.prototype;
        const { push } = [];

        // `Reflect.construct` method
        // https://tc39.es/ecma262/#sec-reflect.construct
        // MS Edge supports only 2 arguments and argumentsList argument is optional
        // FF Nightly sets third argument as `new.target`, but does not create `this` from it
        const NEW_TARGET_BUG = fails(() => {
          function F() { /* empty */ }
          return !(nativeConstruct(() => { /* empty */ }, [], F) instanceof F);
        });

        const ARGS_BUG = !fails(() => {
          nativeConstruct(() => { /* empty */ });
        });

        const FORCED = NEW_TARGET_BUG || ARGS_BUG;

        $({
          target: 'Reflect', stat: true, forced: FORCED, sham: FORCED,
        }, {
          construct: function construct(Target, args /* , newTarget */) {
            aConstructor(Target);
            anObject(args);
            const newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
            if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
            if (Target == newTarget) {
              // w/o altered newTarget, optimization for 0-4 arguments
              switch (args.length) {
                case 0: return new Target();
                case 1: return new Target(args[0]);
                case 2: return new Target(args[0], args[1]);
                case 3: return new Target(args[0], args[1], args[2]);
                case 4: return new Target(args[0], args[1], args[2], args[3]);
              }
              // w/o altered newTarget, lot of arguments case
              const $args = [null];
              apply(push, $args, args);
              return new (apply(bind, Target, $args))();
            }
            // with altered newTarget, not support built-in constructors
            const proto = newTarget.prototype;
            const instance = create(isObject(proto) ? proto : ObjectPrototype);
            const result = apply(Target, instance, args);
            return isObject(result) ? result : instance;
          },
        });
        /***/ }),

      /***/ 4916:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const exec = __webpack_require__(2261);

        // `RegExp.prototype.exec` method
        // https://tc39.es/ecma262/#sec-regexp.prototype.exec
        $({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
          exec,
        });
        /***/ }),

      /***/ 2087:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const DESCRIPTORS = __webpack_require__(9781);
        const objectDefinePropertyModule = __webpack_require__(3070);
        const regExpFlags = __webpack_require__(7066);
        const fails = __webpack_require__(7293);

        const RegExpPrototype = RegExp.prototype;

        const FORCED = DESCRIPTORS && fails(() =>
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
          Object.getOwnPropertyDescriptor(RegExpPrototype, 'flags').get.call({ dotAll: true, sticky: true }) !== 'sy');

        // `RegExp.prototype.flags` getter
        // https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
        if (FORCED) {
          objectDefinePropertyModule.f(RegExpPrototype, 'flags', {
            configurable: true,
            get: regExpFlags,
          });
        }
        /***/ }),

      /***/ 9714:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const uncurryThis = __webpack_require__(1702);
        const PROPER_FUNCTION_NAME = (__webpack_require__(6530).PROPER);
        const redefine = __webpack_require__(1320);
        const anObject = __webpack_require__(9670);
        const isPrototypeOf = __webpack_require__(7976);
        const $toString = __webpack_require__(1340);
        const fails = __webpack_require__(7293);
        const regExpFlags = __webpack_require__(7066);

        const TO_STRING = 'toString';
        const RegExpPrototype = RegExp.prototype;
        const n$ToString = RegExpPrototype[TO_STRING];
        const getFlags = uncurryThis(regExpFlags);

        const NOT_GENERIC = fails(() => n$ToString.call({ source: 'a', flags: 'b' }) != '/a/b');
        // FF44- RegExp#toString has a wrong name
        const INCORRECT_NAME = PROPER_FUNCTION_NAME && n$ToString.name != TO_STRING;

        // `RegExp.prototype.toString` method
        // https://tc39.es/ecma262/#sec-regexp.prototype.tostring
        if (NOT_GENERIC || INCORRECT_NAME) {
          redefine(RegExp.prototype, TO_STRING, function toString() {
            const R = anObject(this);
            const p = $toString(R.source);
            const rf = R.flags;
            const f = $toString(rf === undefined && isPrototypeOf(RegExpPrototype, R) && !('flags' in RegExpPrototype) ? getFlags(R) : rf);
            return `/${p}/${f}`;
          }, { unsafe: true });
        }
        /***/ }),

      /***/ 189:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const collection = __webpack_require__(7710);
        const collectionStrong = __webpack_require__(5631);

        // `Set` constructor
        // https://tc39.es/ecma262/#sec-set-objects
        collection('Set', (init) => function Set() { return init(this, arguments.length ? arguments[0] : undefined); }, collectionStrong);
        /***/ }),

      /***/ 9841:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const { codeAt } = __webpack_require__(8710);

        // `String.prototype.codePointAt` method
        // https://tc39.es/ecma262/#sec-string.prototype.codepointat
        $({ target: 'String', proto: true }, {
          codePointAt: function codePointAt(pos) {
            return codeAt(this, pos);
          },
        });
        /***/ }),

      /***/ 4953:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const global = __webpack_require__(7854);
        const uncurryThis = __webpack_require__(1702);
        const toAbsoluteIndex = __webpack_require__(1400);

        const { RangeError } = global;
        const { fromCharCode } = String;
        // eslint-disable-next-line es/no-string-fromcodepoint -- required for testing
        const $fromCodePoint = String.fromCodePoint;
        const join = uncurryThis([].join);

        // length should be 1, old FF problem
        const INCORRECT_LENGTH = !!$fromCodePoint && $fromCodePoint.length != 1;

        // `String.fromCodePoint` method
        // https://tc39.es/ecma262/#sec-string.fromcodepoint
        $({ target: 'String', stat: true, forced: INCORRECT_LENGTH }, {
          // eslint-disable-next-line no-unused-vars -- required for `.length`
          fromCodePoint: function fromCodePoint(x) {
            const elements = [];
            const { length } = arguments;
            let i = 0;
            let code;
            while (length > i) {
              code = +arguments[i++];
              if (toAbsoluteIndex(code, 0x10FFFF) !== code) throw RangeError(`${code} is not a valid code point`);
              elements[i] = code < 0x10000
                ? fromCharCode(code)
                : fromCharCode(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
            } return join(elements, '');
          },
        });
        /***/ }),

      /***/ 2023:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const uncurryThis = __webpack_require__(1702);
        const notARegExp = __webpack_require__(3929);
        const requireObjectCoercible = __webpack_require__(4488);
        const toString = __webpack_require__(1340);
        const correctIsRegExpLogic = __webpack_require__(4964);

        const stringIndexOf = uncurryThis(''.indexOf);

        // `String.prototype.includes` method
        // https://tc39.es/ecma262/#sec-string.prototype.includes
        $({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
          includes: function includes(searchString /* , position = 0 */) {
            return !!~stringIndexOf(
              toString(requireObjectCoercible(this)),
              toString(notARegExp(searchString)),
              arguments.length > 1 ? arguments[1] : undefined,
            );
          },
        });
        /***/ }),

      /***/ 8734:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const createHTML = __webpack_require__(4230);
        const forcedStringHTMLMethod = __webpack_require__(3429);

        // `String.prototype.italics` method
        // https://tc39.es/ecma262/#sec-string.prototype.italics
        $({ target: 'String', proto: true, forced: forcedStringHTMLMethod('italics') }, {
          italics: function italics() {
            return createHTML(this, 'i', '', '');
          },
        });
        /***/ }),

      /***/ 8783:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const { charAt } = __webpack_require__(8710);
        const toString = __webpack_require__(1340);
        const InternalStateModule = __webpack_require__(9909);
        const defineIterator = __webpack_require__(654);

        const STRING_ITERATOR = 'String Iterator';
        const setInternalState = InternalStateModule.set;
        const getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

        // `String.prototype[@@iterator]` method
        // https://tc39.es/ecma262/#sec-string.prototype-@@iterator
        defineIterator(String, 'String', function (iterated) {
          setInternalState(this, {
            type: STRING_ITERATOR,
            string: toString(iterated),
            index: 0,
          });
          // `%StringIteratorPrototype%.next` method
          // https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
        }, function next() {
          const state = getInternalState(this);
          const { string } = state;
          const { index } = state;
          let point;
          if (index >= string.length) return { value: undefined, done: true };
          point = charAt(string, index);
          state.index += point.length;
          return { value: point, done: false };
        });
        /***/ }),

      /***/ 9254:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const createHTML = __webpack_require__(4230);
        const forcedStringHTMLMethod = __webpack_require__(3429);

        // `String.prototype.link` method
        // https://tc39.es/ecma262/#sec-string.prototype.link
        $({ target: 'String', proto: true, forced: forcedStringHTMLMethod('link') }, {
          link: function link(url) {
            return createHTML(this, 'a', 'href', url);
          },
        });
        /***/ }),

      /***/ 6373:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        /* eslint-disable es/no-string-prototype-matchall -- safe */
        const $ = __webpack_require__(2109);
        const global = __webpack_require__(7854);
        const call = __webpack_require__(6916);
        const uncurryThis = __webpack_require__(1702);
        const createIteratorConstructor = __webpack_require__(4994);
        const requireObjectCoercible = __webpack_require__(4488);
        const toLength = __webpack_require__(7466);
        const toString = __webpack_require__(1340);
        const anObject = __webpack_require__(9670);
        const classof = __webpack_require__(4326);
        const isPrototypeOf = __webpack_require__(7976);
        const isRegExp = __webpack_require__(7850);
        const regExpFlags = __webpack_require__(7066);
        const getMethod = __webpack_require__(8173);
        const redefine = __webpack_require__(1320);
        const fails = __webpack_require__(7293);
        const wellKnownSymbol = __webpack_require__(5112);
        const speciesConstructor = __webpack_require__(6707);
        const advanceStringIndex = __webpack_require__(1530);
        const regExpExec = __webpack_require__(7651);
        const InternalStateModule = __webpack_require__(9909);
        const IS_PURE = __webpack_require__(1913);

        const MATCH_ALL = wellKnownSymbol('matchAll');
        const REGEXP_STRING = 'RegExp String';
        const REGEXP_STRING_ITERATOR = `${REGEXP_STRING} Iterator`;
        const setInternalState = InternalStateModule.set;
        const getInternalState = InternalStateModule.getterFor(REGEXP_STRING_ITERATOR);
        const RegExpPrototype = RegExp.prototype;
        const { TypeError } = global;
        const getFlags = uncurryThis(regExpFlags);
        const stringIndexOf = uncurryThis(''.indexOf);
        const un$MatchAll = uncurryThis(''.matchAll);

        const WORKS_WITH_NON_GLOBAL_REGEX = !!un$MatchAll && !fails(() => {
          un$MatchAll('a', /./);
        });

        const $RegExpStringIterator = createIteratorConstructor(function RegExpStringIterator(regexp, string, $global, fullUnicode) {
          setInternalState(this, {
            type: REGEXP_STRING_ITERATOR,
            regexp,
            string,
            global: $global,
            unicode: fullUnicode,
            done: false,
          });
        }, REGEXP_STRING, function next() {
          const state = getInternalState(this);
          if (state.done) return { value: undefined, done: true };
          const R = state.regexp;
          const S = state.string;
          const match = regExpExec(R, S);
          if (match === null) return { value: undefined, done: state.done = true };
          if (state.global) {
            if (toString(match[0]) === '') R.lastIndex = advanceStringIndex(S, toLength(R.lastIndex), state.unicode);
            return { value: match, done: false };
          }
          state.done = true;
          return { value: match, done: false };
        });

        const $matchAll = function (string) {
          const R = anObject(this);
          const S = toString(string);
          let C; let flagsValue; let flags; let matcher; let $global; let
            fullUnicode;
          C = speciesConstructor(R, RegExp);
          flagsValue = R.flags;
          if (flagsValue === undefined && isPrototypeOf(RegExpPrototype, R) && !('flags' in RegExpPrototype)) {
            flagsValue = getFlags(R);
          }
          flags = flagsValue === undefined ? '' : toString(flagsValue);
          matcher = new C(C === RegExp ? R.source : R, flags);
          $global = !!~stringIndexOf(flags, 'g');
          fullUnicode = !!~stringIndexOf(flags, 'u');
          matcher.lastIndex = toLength(R.lastIndex);
          return new $RegExpStringIterator(matcher, S, $global, fullUnicode);
        };

        // `String.prototype.matchAll` method
        // https://tc39.es/ecma262/#sec-string.prototype.matchall
        $({ target: 'String', proto: true, forced: WORKS_WITH_NON_GLOBAL_REGEX }, {
          matchAll: function matchAll(regexp) {
            const O = requireObjectCoercible(this);
            let flags; let S; let matcher; let
              rx;
            if (regexp != null) {
              if (isRegExp(regexp)) {
                flags = toString(requireObjectCoercible('flags' in RegExpPrototype
                  ? regexp.flags
                  : getFlags(regexp)));
                if (!~stringIndexOf(flags, 'g')) throw TypeError('`.matchAll` does not allow non-global regexes');
              }
              if (WORKS_WITH_NON_GLOBAL_REGEX) return un$MatchAll(O, regexp);
              matcher = getMethod(regexp, MATCH_ALL);
              if (matcher === undefined && IS_PURE && classof(regexp) == 'RegExp') matcher = $matchAll;
              if (matcher) return call(matcher, regexp, O);
            } else if (WORKS_WITH_NON_GLOBAL_REGEX) return un$MatchAll(O, regexp);
            S = toString(O);
            rx = new RegExp(regexp, 'g');
            return IS_PURE ? call($matchAll, rx, S) : rx[MATCH_ALL](S);
          },
        });

        IS_PURE || MATCH_ALL in RegExpPrototype || redefine(RegExpPrototype, MATCH_ALL, $matchAll);
        /***/ }),

      /***/ 4723:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const call = __webpack_require__(6916);
        const fixRegExpWellKnownSymbolLogic = __webpack_require__(7007);
        const anObject = __webpack_require__(9670);
        const toLength = __webpack_require__(7466);
        const toString = __webpack_require__(1340);
        const requireObjectCoercible = __webpack_require__(4488);
        const getMethod = __webpack_require__(8173);
        const advanceStringIndex = __webpack_require__(1530);
        const regExpExec = __webpack_require__(7651);

        // @@match logic
        fixRegExpWellKnownSymbolLogic('match', (MATCH, nativeMatch, maybeCallNative) => [
          // `String.prototype.match` method
          // https://tc39.es/ecma262/#sec-string.prototype.match
          function match(regexp) {
            const O = requireObjectCoercible(this);
            const matcher = regexp == undefined ? undefined : getMethod(regexp, MATCH);
            return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
          },
          // `RegExp.prototype[@@match]` method
          // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
          function (string) {
            const rx = anObject(this);
            const S = toString(string);
            const res = maybeCallNative(nativeMatch, rx, S);

            if (res.done) return res.value;

            if (!rx.global) return regExpExec(rx, S);

            const fullUnicode = rx.unicode;
            rx.lastIndex = 0;
            const A = [];
            let n = 0;
            let result;
            while ((result = regExpExec(rx, S)) !== null) {
              const matchStr = toString(result[0]);
              A[n] = matchStr;
              if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
              n++;
            }
            return n === 0 ? null : A;
          },
        ]);
        /***/ }),

      /***/ 2481:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const repeat = __webpack_require__(8415);

        // `String.prototype.repeat` method
        // https://tc39.es/ecma262/#sec-string.prototype.repeat
        $({ target: 'String', proto: true }, {
          repeat,
        });
        /***/ }),

      /***/ 5306:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const apply = __webpack_require__(2104);
        const call = __webpack_require__(6916);
        const uncurryThis = __webpack_require__(1702);
        const fixRegExpWellKnownSymbolLogic = __webpack_require__(7007);
        const fails = __webpack_require__(7293);
        const anObject = __webpack_require__(9670);
        const isCallable = __webpack_require__(614);
        const toIntegerOrInfinity = __webpack_require__(9303);
        const toLength = __webpack_require__(7466);
        const toString = __webpack_require__(1340);
        const requireObjectCoercible = __webpack_require__(4488);
        const advanceStringIndex = __webpack_require__(1530);
        const getMethod = __webpack_require__(8173);
        const getSubstitution = __webpack_require__(647);
        const regExpExec = __webpack_require__(7651);
        const wellKnownSymbol = __webpack_require__(5112);

        const REPLACE = wellKnownSymbol('replace');
        const { max } = Math;
        const { min } = Math;
        const concat = uncurryThis([].concat);
        const push = uncurryThis([].push);
        const stringIndexOf = uncurryThis(''.indexOf);
        const stringSlice = uncurryThis(''.slice);

        const maybeToString = function (it) {
          return it === undefined ? it : String(it);
        };

        // IE <= 11 replaces $0 with the whole match, as if it was $&
        // https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
        const REPLACE_KEEPS_$0 = (function () {
          // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
          return 'a'.replace(/./, '$0') === '$0';
        }());

        // Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
        const REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
          if (/./[REPLACE]) {
            return /./[REPLACE]('a', '$0') === '';
          }
          return false;
        }());

        const REPLACE_SUPPORTS_NAMED_GROUPS = !fails(() => {
          const re = /./;
          re.exec = function () {
            const result = [];
            result.groups = { a: '7' };
            return result;
          };
          // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
          return ''.replace(re, '$<a>') !== '7';
        });

        // @@replace logic
        fixRegExpWellKnownSymbolLogic('replace', (_, nativeReplace, maybeCallNative) => {
          const UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

          return [
            // `String.prototype.replace` method
            // https://tc39.es/ecma262/#sec-string.prototype.replace
            function replace(searchValue, replaceValue) {
              const O = requireObjectCoercible(this);
              const replacer = searchValue == undefined ? undefined : getMethod(searchValue, REPLACE);
              return replacer
                ? call(replacer, searchValue, O, replaceValue)
                : call(nativeReplace, toString(O), searchValue, replaceValue);
            },
            // `RegExp.prototype[@@replace]` method
            // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
            function (string, replaceValue) {
              const rx = anObject(this);
              const S = toString(string);

              if (
                typeof replaceValue === 'string'
        && stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1
        && stringIndexOf(replaceValue, '$<') === -1
              ) {
                const res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                if (res.done) return res.value;
              }

              const functionalReplace = isCallable(replaceValue);
              if (!functionalReplace) replaceValue = toString(replaceValue);

              const { global } = rx;
              if (global) {
                var fullUnicode = rx.unicode;
                rx.lastIndex = 0;
              }
              const results = [];
              while (true) {
                var result = regExpExec(rx, S);
                if (result === null) break;

                push(results, result);
                if (!global) break;

                const matchStr = toString(result[0]);
                if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
              }

              let accumulatedResult = '';
              let nextSourcePosition = 0;
              for (let i = 0; i < results.length; i++) {
                result = results[i];

                const matched = toString(result[0]);
                const position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
                const captures = [];
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for (let j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
                const namedCaptures = result.groups;
                if (functionalReplace) {
                  const replacerArgs = concat([matched], captures, position, S);
                  if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
                  var replacement = toString(apply(replaceValue, undefined, replacerArgs));
                } else {
                  replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
                }
                if (position >= nextSourcePosition) {
                  accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
                  nextSourcePosition = position + matched.length;
                }
              }
              return accumulatedResult + stringSlice(S, nextSourcePosition);
            },
          ];
        }, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);
        /***/ }),

      /***/ 3123:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const apply = __webpack_require__(2104);
        const call = __webpack_require__(6916);
        const uncurryThis = __webpack_require__(1702);
        const fixRegExpWellKnownSymbolLogic = __webpack_require__(7007);
        const isRegExp = __webpack_require__(7850);
        const anObject = __webpack_require__(9670);
        const requireObjectCoercible = __webpack_require__(4488);
        const speciesConstructor = __webpack_require__(6707);
        const advanceStringIndex = __webpack_require__(1530);
        const toLength = __webpack_require__(7466);
        const toString = __webpack_require__(1340);
        const getMethod = __webpack_require__(8173);
        const arraySlice = __webpack_require__(206);
        const callRegExpExec = __webpack_require__(7651);
        const regexpExec = __webpack_require__(2261);
        const stickyHelpers = __webpack_require__(2999);
        const fails = __webpack_require__(7293);

        const { UNSUPPORTED_Y } = stickyHelpers;
        const MAX_UINT32 = 0xFFFFFFFF;
        const { min } = Math;
        const $push = [].push;
        const exec = uncurryThis(/./.exec);
        const push = uncurryThis($push);
        const stringSlice = uncurryThis(''.slice);

        // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
        // Weex JS has frozen built-in prototypes, so use try / catch wrapper
        const SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(() => {
          // eslint-disable-next-line regexp/no-empty-group -- required for testing
          const re = /(?:)/;
          const originalExec = re.exec;
          re.exec = function () { return originalExec.apply(this, arguments); };
          const result = 'ab'.split(re);
          return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
        });

        // @@split logic
        fixRegExpWellKnownSymbolLogic('split', (SPLIT, nativeSplit, maybeCallNative) => {
          let internalSplit;
          if (
            'abbc'.split(/(b)*/)[1] == 'c'
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    || 'test'.split(/(?:)/, -1).length != 4
    || 'ab'.split(/(?:ab)*/).length != 2
    || '.'.split(/(.?)(.?)/).length != 4
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    || '.'.split(/()()/).length > 1
    || ''.split(/.?/).length
          ) {
            // based on es5-shim implementation, need to rework it
            internalSplit = function (separator, limit) {
              const string = toString(requireObjectCoercible(this));
              const lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
              if (lim === 0) return [];
              if (separator === undefined) return [string];
              // If `separator` is not a regex, use native split
              if (!isRegExp(separator)) {
                return call(nativeSplit, string, separator, lim);
              }
              const output = [];
              const flags = (separator.ignoreCase ? 'i' : '')
                  + (separator.multiline ? 'm' : '')
                  + (separator.unicode ? 'u' : '')
                  + (separator.sticky ? 'y' : '');
              let lastLastIndex = 0;
              // Make `global` and avoid `lastIndex` issues by working with a copy
              const separatorCopy = new RegExp(separator.source, `${flags}g`);
              let match; let lastIndex; let
                lastLength;
              while (match = call(regexpExec, separatorCopy, string)) {
                lastIndex = separatorCopy.lastIndex;
                if (lastIndex > lastLastIndex) {
                  push(output, stringSlice(string, lastLastIndex, match.index));
                  if (match.length > 1 && match.index < string.length) apply($push, output, arraySlice(match, 1));
                  lastLength = match[0].length;
                  lastLastIndex = lastIndex;
                  if (output.length >= lim) break;
                }
                if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
              }
              if (lastLastIndex === string.length) {
                if (lastLength || !exec(separatorCopy, '')) push(output, '');
              } else push(output, stringSlice(string, lastLastIndex));
              return output.length > lim ? arraySlice(output, 0, lim) : output;
            };
            // Chakra, V8
          } else if ('0'.split(undefined, 0).length) {
            internalSplit = function (separator, limit) {
              return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
            };
          } else internalSplit = nativeSplit;

          return [
            // `String.prototype.split` method
            // https://tc39.es/ecma262/#sec-string.prototype.split
            function split(separator, limit) {
              const O = requireObjectCoercible(this);
              const splitter = separator == undefined ? undefined : getMethod(separator, SPLIT);
              return splitter
                ? call(splitter, separator, O, limit)
                : call(internalSplit, toString(O), separator, limit);
            },
            // `RegExp.prototype[@@split]` method
            // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
            //
            // NOTE: This cannot be properly polyfilled in engines that don't support
            // the 'y' flag.
            function (string, limit) {
              const rx = anObject(this);
              const S = toString(string);
              const res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

              if (res.done) return res.value;

              const C = speciesConstructor(rx, RegExp);

              const unicodeMatching = rx.unicode;
              const flags = (rx.ignoreCase ? 'i' : '')
                  + (rx.multiline ? 'm' : '')
                  + (rx.unicode ? 'u' : '')
                  + (UNSUPPORTED_Y ? 'g' : 'y');

              // ^(? + rx + ) is needed, in combination with some S slicing, to
              // simulate the 'y' flag.
              const splitter = new C(UNSUPPORTED_Y ? `^(?:${rx.source})` : rx, flags);
              const lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
              if (lim === 0) return [];
              if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
              let p = 0;
              let q = 0;
              const A = [];
              while (q < S.length) {
                splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
                const z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
                var e;
                if (
                  z === null
          || (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
                ) {
                  q = advanceStringIndex(S, q, unicodeMatching);
                } else {
                  push(A, stringSlice(S, p, q));
                  if (A.length === lim) return A;
                  for (let i = 1; i <= z.length - 1; i++) {
                    push(A, z[i]);
                    if (A.length === lim) return A;
                  }
                  q = p = e;
                }
              }
              push(A, stringSlice(S, p));
              return A;
            },
          ];
        }, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);
        /***/ }),

      /***/ 7397:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const createHTML = __webpack_require__(4230);
        const forcedStringHTMLMethod = __webpack_require__(3429);

        // `String.prototype.strike` method
        // https://tc39.es/ecma262/#sec-string.prototype.strike
        $({ target: 'String', proto: true, forced: forcedStringHTMLMethod('strike') }, {
          strike: function strike() {
            return createHTML(this, 'strike', '', '');
          },
        });
        /***/ }),

      /***/ 3210:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const $trim = (__webpack_require__(3111).trim);
        const forcedStringTrimMethod = __webpack_require__(6091);

        // `String.prototype.trim` method
        // https://tc39.es/ecma262/#sec-string.prototype.trim
        $({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
          trim: function trim() {
            return $trim(this);
          },
        });
        /***/ }),

      /***/ 1817:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        // `Symbol.prototype.description` getter
        // https://tc39.es/ecma262/#sec-symbol.prototype.description

        const $ = __webpack_require__(2109);
        const DESCRIPTORS = __webpack_require__(9781);
        const global = __webpack_require__(7854);
        const uncurryThis = __webpack_require__(1702);
        const hasOwn = __webpack_require__(2597);
        const isCallable = __webpack_require__(614);
        const isPrototypeOf = __webpack_require__(7976);
        const toString = __webpack_require__(1340);
        const defineProperty = (__webpack_require__(3070).f);
        const copyConstructorProperties = __webpack_require__(9920);

        const NativeSymbol = global.Symbol;
        const SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

        if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype)
  // Safari 12 bug
  || NativeSymbol().description !== undefined
        )) {
          const EmptyStringDescriptionStore = {};
          // wrap Symbol constructor for correct work with undefined description
          const SymbolWrapper = function Symbol() {
            const description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
            const result = isPrototypeOf(SymbolPrototype, this)
              ? new NativeSymbol(description)
            // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
              : description === undefined ? NativeSymbol() : NativeSymbol(description);
            if (description === '') EmptyStringDescriptionStore[result] = true;
            return result;
          };

          copyConstructorProperties(SymbolWrapper, NativeSymbol);
          SymbolWrapper.prototype = SymbolPrototype;
          SymbolPrototype.constructor = SymbolWrapper;

          const NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
          const symbolToString = uncurryThis(SymbolPrototype.toString);
          const symbolValueOf = uncurryThis(SymbolPrototype.valueOf);
          const regexp = /^Symbol\((.*)\)[^)]+$/;
          const replace = uncurryThis(''.replace);
          const stringSlice = uncurryThis(''.slice);

          defineProperty(SymbolPrototype, 'description', {
            configurable: true,
            get: function description() {
              const symbol = symbolValueOf(this);
              const string = symbolToString(symbol);
              if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
              const desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
              return desc === '' ? undefined : desc;
            },
          });

          $({ global: true, forced: true }, {
            Symbol: SymbolWrapper,
          });
        }
        /***/ }),

      /***/ 2165:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const defineWellKnownSymbol = __webpack_require__(7235);

        // `Symbol.iterator` well-known symbol
        // https://tc39.es/ecma262/#sec-symbol.iterator
        defineWellKnownSymbol('iterator');
        /***/ }),

      /***/ 2526:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const global = __webpack_require__(7854);
        const getBuiltIn = __webpack_require__(5005);
        const apply = __webpack_require__(2104);
        const call = __webpack_require__(6916);
        const uncurryThis = __webpack_require__(1702);
        const IS_PURE = __webpack_require__(1913);
        const DESCRIPTORS = __webpack_require__(9781);
        const NATIVE_SYMBOL = __webpack_require__(133);
        const fails = __webpack_require__(7293);
        const hasOwn = __webpack_require__(2597);
        const isArray = __webpack_require__(3157);
        const isCallable = __webpack_require__(614);
        const isObject = __webpack_require__(111);
        const isPrototypeOf = __webpack_require__(7976);
        const isSymbol = __webpack_require__(2190);
        const anObject = __webpack_require__(9670);
        const toObject = __webpack_require__(7908);
        const toIndexedObject = __webpack_require__(5656);
        const toPropertyKey = __webpack_require__(4948);
        const $toString = __webpack_require__(1340);
        const createPropertyDescriptor = __webpack_require__(9114);
        const nativeObjectCreate = __webpack_require__(30);
        const objectKeys = __webpack_require__(1956);
        const getOwnPropertyNamesModule = __webpack_require__(8006);
        const getOwnPropertyNamesExternal = __webpack_require__(1156);
        const getOwnPropertySymbolsModule = __webpack_require__(5181);
        const getOwnPropertyDescriptorModule = __webpack_require__(1236);
        const definePropertyModule = __webpack_require__(3070);
        const propertyIsEnumerableModule = __webpack_require__(5296);
        const arraySlice = __webpack_require__(206);
        const redefine = __webpack_require__(1320);
        const shared = __webpack_require__(2309);
        const sharedKey = __webpack_require__(6200);
        const hiddenKeys = __webpack_require__(3501);
        const uid = __webpack_require__(9711);
        const wellKnownSymbol = __webpack_require__(5112);
        const wrappedWellKnownSymbolModule = __webpack_require__(6061);
        const defineWellKnownSymbol = __webpack_require__(7235);
        const setToStringTag = __webpack_require__(8003);
        const InternalStateModule = __webpack_require__(9909);
        const $forEach = (__webpack_require__(2092).forEach);

        const HIDDEN = sharedKey('hidden');
        const SYMBOL = 'Symbol';
        const PROTOTYPE = 'prototype';
        const TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

        const setInternalState = InternalStateModule.set;
        const getInternalState = InternalStateModule.getterFor(SYMBOL);

        const ObjectPrototype = Object[PROTOTYPE];
        let $Symbol = global.Symbol;
        let SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
        const { TypeError } = global;
        const { QObject } = global;
        const $stringify = getBuiltIn('JSON', 'stringify');
        const nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
        const nativeDefineProperty = definePropertyModule.f;
        const nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
        const nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
        const push = uncurryThis([].push);

        const AllSymbols = shared('symbols');
        const ObjectPrototypeSymbols = shared('op-symbols');
        const StringToSymbolRegistry = shared('string-to-symbol-registry');
        const SymbolToStringRegistry = shared('symbol-to-string-registry');
        const WellKnownSymbolsStore = shared('wks');

        // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
        let USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

        // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
        const setSymbolDescriptor = DESCRIPTORS && fails(() => nativeObjectCreate(nativeDefineProperty({}, 'a', {
          get() { return nativeDefineProperty(this, 'a', { value: 7 }).a; },
        })).a != 7) ? function (O, P, Attributes) {
            const ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
            if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
            nativeDefineProperty(O, P, Attributes);
            if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
              nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
            }
          } : nativeDefineProperty;

        const wrap = function (tag, description) {
          const symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
          setInternalState(symbol, {
            type: SYMBOL,
            tag,
            description,
          });
          if (!DESCRIPTORS) symbol.description = description;
          return symbol;
        };

        var $defineProperty = function defineProperty(O, P, Attributes) {
          if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
          anObject(O);
          const key = toPropertyKey(P);
          anObject(Attributes);
          if (hasOwn(AllSymbols, key)) {
            if (!Attributes.enumerable) {
              if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
              O[HIDDEN][key] = true;
            } else {
              if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
              Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
            } return setSymbolDescriptor(O, key, Attributes);
          } return nativeDefineProperty(O, key, Attributes);
        };

        const $defineProperties = function defineProperties(O, Properties) {
          anObject(O);
          const properties = toIndexedObject(Properties);
          const keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
          $forEach(keys, (key) => {
            if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
          });
          return O;
        };

        const $create = function create(O, Properties) {
          return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
        };

        var $propertyIsEnumerable = function propertyIsEnumerable(V) {
          const P = toPropertyKey(V);
          const enumerable = call(nativePropertyIsEnumerable, this, P);
          if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
          return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
            ? enumerable : true;
        };

        const $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
          const it = toIndexedObject(O);
          const key = toPropertyKey(P);
          if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
          const descriptor = nativeGetOwnPropertyDescriptor(it, key);
          if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
            descriptor.enumerable = true;
          }
          return descriptor;
        };

        const $getOwnPropertyNames = function getOwnPropertyNames(O) {
          const names = nativeGetOwnPropertyNames(toIndexedObject(O));
          const result = [];
          $forEach(names, (key) => {
            if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
          });
          return result;
        };

        var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
          const IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
          const names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
          const result = [];
          $forEach(names, (key) => {
            if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
              push(result, AllSymbols[key]);
            }
          });
          return result;
        };

        // `Symbol` constructor
        // https://tc39.es/ecma262/#sec-symbol-constructor
        if (!NATIVE_SYMBOL) {
          $Symbol = function Symbol() {
            if (isPrototypeOf(SymbolPrototype, this)) throw TypeError('Symbol is not a constructor');
            const description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
            const tag = uid(description);
            var setter = function (value) {
              if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
              if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
              setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
            };
            if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
            return wrap(tag, description);
          };

          SymbolPrototype = $Symbol[PROTOTYPE];

          redefine(SymbolPrototype, 'toString', function toString() {
            return getInternalState(this).tag;
          });

          redefine($Symbol, 'withoutSetter', (description) => wrap(uid(description), description));

          propertyIsEnumerableModule.f = $propertyIsEnumerable;
          definePropertyModule.f = $defineProperty;
          getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
          getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
          getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

          wrappedWellKnownSymbolModule.f = function (name) {
            return wrap(wellKnownSymbol(name), name);
          };

          if (DESCRIPTORS) {
            // https://github.com/tc39/proposal-Symbol-description
            nativeDefineProperty(SymbolPrototype, 'description', {
              configurable: true,
              get: function description() {
                return getInternalState(this).description;
              },
            });
            if (!IS_PURE) {
              redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
            }
          }
        }

        $({
          global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL,
        }, {
          Symbol: $Symbol,
        });

        $forEach(objectKeys(WellKnownSymbolsStore), (name) => {
          defineWellKnownSymbol(name);
        });

        $({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
          // `Symbol.for` method
          // https://tc39.es/ecma262/#sec-symbol.for
          for(key) {
            const string = $toString(key);
            if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
            const symbol = $Symbol(string);
            StringToSymbolRegistry[string] = symbol;
            SymbolToStringRegistry[symbol] = string;
            return symbol;
          },
          // `Symbol.keyFor` method
          // https://tc39.es/ecma262/#sec-symbol.keyfor
          keyFor: function keyFor(sym) {
            if (!isSymbol(sym)) throw TypeError(`${sym} is not a symbol`);
            if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
          },
          useSetter() { USE_SETTER = true; },
          useSimple() { USE_SETTER = false; },
        });

        $({
          target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS,
        }, {
          // `Object.create` method
          // https://tc39.es/ecma262/#sec-object.create
          create: $create,
          // `Object.defineProperty` method
          // https://tc39.es/ecma262/#sec-object.defineproperty
          defineProperty: $defineProperty,
          // `Object.defineProperties` method
          // https://tc39.es/ecma262/#sec-object.defineproperties
          defineProperties: $defineProperties,
          // `Object.getOwnPropertyDescriptor` method
          // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
          getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
        });

        $({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
          // `Object.getOwnPropertyNames` method
          // https://tc39.es/ecma262/#sec-object.getownpropertynames
          getOwnPropertyNames: $getOwnPropertyNames,
          // `Object.getOwnPropertySymbols` method
          // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
          getOwnPropertySymbols: $getOwnPropertySymbols,
        });

        // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
        // https://bugs.chromium.org/p/v8/issues/detail?id=3443
        $({ target: 'Object', stat: true, forced: fails(() => { getOwnPropertySymbolsModule.f(1); }) }, {
          getOwnPropertySymbols: function getOwnPropertySymbols(it) {
            return getOwnPropertySymbolsModule.f(toObject(it));
          },
        });

        // `JSON.stringify` method behavior with symbols
        // https://tc39.es/ecma262/#sec-json.stringify
        if ($stringify) {
          const FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(() => {
            const symbol = $Symbol();
            // MS Edge converts symbol values to JSON as {}
            return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
          });

          $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
            // eslint-disable-next-line no-unused-vars -- required for `.length`
            stringify: function stringify(it, replacer, space) {
              const args = arraySlice(arguments);
              const $replacer = replacer;
              if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
              if (!isArray(replacer)) {
                replacer = function (key, value) {
                  if (isCallable($replacer)) value = call($replacer, this, key, value);
                  if (!isSymbol(value)) return value;
                };
              }
              args[1] = replacer;
              return apply($stringify, null, args);
            },
          });
        }

        // `Symbol.prototype[@@toPrimitive]` method
        // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
        if (!SymbolPrototype[TO_PRIMITIVE]) {
          const { valueOf } = SymbolPrototype;
          // eslint-disable-next-line no-unused-vars -- required for .length
          redefine(SymbolPrototype, TO_PRIMITIVE, function (hint) {
            // TODO: improve hint logic
            return call(valueOf, this);
          });
        }
        // `Symbol.prototype[@@toStringTag]` property
        // https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
        setToStringTag($Symbol, SYMBOL);

        hiddenKeys[HIDDEN] = true;
        /***/ }),

      /***/ 6649:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const defineWellKnownSymbol = __webpack_require__(7235);

        // `Symbol.toPrimitive` well-known symbol
        // https://tc39.es/ecma262/#sec-symbol.toprimitive
        defineWellKnownSymbol('toPrimitive');
        /***/ }),

      /***/ 2990:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const uncurryThis = __webpack_require__(1702);
        const ArrayBufferViewCore = __webpack_require__(2094);
        const $ArrayCopyWithin = __webpack_require__(1048);

        const u$ArrayCopyWithin = uncurryThis($ArrayCopyWithin);
        const { aTypedArray } = ArrayBufferViewCore;
        const { exportTypedArrayMethod } = ArrayBufferViewCore;

        // `%TypedArray%.prototype.copyWithin` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin
        exportTypedArrayMethod('copyWithin', function copyWithin(target, start /* , end */) {
          return u$ArrayCopyWithin(aTypedArray(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
        });
        /***/ }),

      /***/ 8927:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const ArrayBufferViewCore = __webpack_require__(2094);
        const $every = (__webpack_require__(2092).every);

        const { aTypedArray } = ArrayBufferViewCore;
        const { exportTypedArrayMethod } = ArrayBufferViewCore;

        // `%TypedArray%.prototype.every` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype.every
        exportTypedArrayMethod('every', function every(callbackfn /* , thisArg */) {
          return $every(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        });
        /***/ }),

      /***/ 3105:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const ArrayBufferViewCore = __webpack_require__(2094);
        const call = __webpack_require__(6916);
        const $fill = __webpack_require__(1285);

        const { aTypedArray } = ArrayBufferViewCore;
        const { exportTypedArrayMethod } = ArrayBufferViewCore;

        // `%TypedArray%.prototype.fill` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
        exportTypedArrayMethod('fill', function fill(value /* , start, end */) {
          const { length } = arguments;
          return call(
            $fill,
            aTypedArray(this),
            value,
            length > 1 ? arguments[1] : undefined,
            length > 2 ? arguments[2] : undefined,
          );
        });
        /***/ }),

      /***/ 5035:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const ArrayBufferViewCore = __webpack_require__(2094);
        const $filter = (__webpack_require__(2092).filter);
        const fromSpeciesAndList = __webpack_require__(3074);

        const { aTypedArray } = ArrayBufferViewCore;
        const { exportTypedArrayMethod } = ArrayBufferViewCore;

        // `%TypedArray%.prototype.filter` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter
        exportTypedArrayMethod('filter', function filter(callbackfn /* , thisArg */) {
          const list = $filter(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
          return fromSpeciesAndList(this, list);
        });
        /***/ }),

      /***/ 7174:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const ArrayBufferViewCore = __webpack_require__(2094);
        const $findIndex = (__webpack_require__(2092).findIndex);

        const { aTypedArray } = ArrayBufferViewCore;
        const { exportTypedArrayMethod } = ArrayBufferViewCore;

        // `%TypedArray%.prototype.findIndex` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex
        exportTypedArrayMethod('findIndex', function findIndex(predicate /* , thisArg */) {
          return $findIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
        });
        /***/ }),

      /***/ 4345:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const ArrayBufferViewCore = __webpack_require__(2094);
        const $find = (__webpack_require__(2092).find);

        const { aTypedArray } = ArrayBufferViewCore;
        const { exportTypedArrayMethod } = ArrayBufferViewCore;

        // `%TypedArray%.prototype.find` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype.find
        exportTypedArrayMethod('find', function find(predicate /* , thisArg */) {
          return $find(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
        });
        /***/ }),

      /***/ 4197:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const createTypedArrayConstructor = __webpack_require__(9843);

        // `Float32Array` constructor
        // https://tc39.es/ecma262/#sec-typedarray-objects
        createTypedArrayConstructor('Float32', (init) => function Float32Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        });
        /***/ }),

      /***/ 6495:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const createTypedArrayConstructor = __webpack_require__(9843);

        // `Float64Array` constructor
        // https://tc39.es/ecma262/#sec-typedarray-objects
        createTypedArrayConstructor('Float64', (init) => function Float64Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        });
        /***/ }),

      /***/ 2846:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const ArrayBufferViewCore = __webpack_require__(2094);
        const $forEach = (__webpack_require__(2092).forEach);

        const { aTypedArray } = ArrayBufferViewCore;
        const { exportTypedArrayMethod } = ArrayBufferViewCore;

        // `%TypedArray%.prototype.forEach` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach
        exportTypedArrayMethod('forEach', function forEach(callbackfn /* , thisArg */) {
          $forEach(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        });
        /***/ }),

      /***/ 8145:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(3832);
        const { exportTypedArrayStaticMethod } = __webpack_require__(2094);
        const typedArrayFrom = __webpack_require__(7321);

        // `%TypedArray%.from` method
        // https://tc39.es/ecma262/#sec-%typedarray%.from
        exportTypedArrayStaticMethod('from', typedArrayFrom, TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS);
        /***/ }),

      /***/ 4731:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const ArrayBufferViewCore = __webpack_require__(2094);
        const $includes = (__webpack_require__(1318).includes);

        const { aTypedArray } = ArrayBufferViewCore;
        const { exportTypedArrayMethod } = ArrayBufferViewCore;

        // `%TypedArray%.prototype.includes` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes
        exportTypedArrayMethod('includes', function includes(searchElement /* , fromIndex */) {
          return $includes(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
        });
        /***/ }),

      /***/ 7209:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const ArrayBufferViewCore = __webpack_require__(2094);
        const $indexOf = (__webpack_require__(1318).indexOf);

        const { aTypedArray } = ArrayBufferViewCore;
        const { exportTypedArrayMethod } = ArrayBufferViewCore;

        // `%TypedArray%.prototype.indexOf` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof
        exportTypedArrayMethod('indexOf', function indexOf(searchElement /* , fromIndex */) {
          return $indexOf(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
        });
        /***/ }),

      /***/ 5109:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const createTypedArrayConstructor = __webpack_require__(9843);

        // `Int16Array` constructor
        // https://tc39.es/ecma262/#sec-typedarray-objects
        createTypedArrayConstructor('Int16', (init) => function Int16Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        });
        /***/ }),

      /***/ 5125:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const createTypedArrayConstructor = __webpack_require__(9843);

        // `Int32Array` constructor
        // https://tc39.es/ecma262/#sec-typedarray-objects
        createTypedArrayConstructor('Int32', (init) => function Int32Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        });
        /***/ }),

      /***/ 7145:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const createTypedArrayConstructor = __webpack_require__(9843);

        // `Int8Array` constructor
        // https://tc39.es/ecma262/#sec-typedarray-objects
        createTypedArrayConstructor('Int8', (init) => function Int8Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        });
        /***/ }),

      /***/ 6319:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const uncurryThis = __webpack_require__(1702);
        const PROPER_FUNCTION_NAME = (__webpack_require__(6530).PROPER);
        const ArrayBufferViewCore = __webpack_require__(2094);
        const ArrayIterators = __webpack_require__(6992);
        const wellKnownSymbol = __webpack_require__(5112);

        const ITERATOR = wellKnownSymbol('iterator');
        const { Uint8Array } = global;
        const arrayValues = uncurryThis(ArrayIterators.values);
        const arrayKeys = uncurryThis(ArrayIterators.keys);
        const arrayEntries = uncurryThis(ArrayIterators.entries);
        const { aTypedArray } = ArrayBufferViewCore;
        const { exportTypedArrayMethod } = ArrayBufferViewCore;
        const nativeTypedArrayIterator = Uint8Array && Uint8Array.prototype[ITERATOR];

        const PROPER_ARRAY_VALUES_NAME = !!nativeTypedArrayIterator && nativeTypedArrayIterator.name === 'values';

        const typedArrayValues = function values() {
          return arrayValues(aTypedArray(this));
        };

        // `%TypedArray%.prototype.entries` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries
        exportTypedArrayMethod('entries', function entries() {
          return arrayEntries(aTypedArray(this));
        });
        // `%TypedArray%.prototype.keys` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys
        exportTypedArrayMethod('keys', function keys() {
          return arrayKeys(aTypedArray(this));
        });
        // `%TypedArray%.prototype.values` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype.values
        exportTypedArrayMethod('values', typedArrayValues, PROPER_FUNCTION_NAME && !PROPER_ARRAY_VALUES_NAME);
        // `%TypedArray%.prototype[@@iterator]` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator
        exportTypedArrayMethod(ITERATOR, typedArrayValues, PROPER_FUNCTION_NAME && !PROPER_ARRAY_VALUES_NAME);
        /***/ }),

      /***/ 8867:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const ArrayBufferViewCore = __webpack_require__(2094);
        const uncurryThis = __webpack_require__(1702);

        const { aTypedArray } = ArrayBufferViewCore;
        const { exportTypedArrayMethod } = ArrayBufferViewCore;
        const $join = uncurryThis([].join);

        // `%TypedArray%.prototype.join` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype.join
        exportTypedArrayMethod('join', function join(separator) {
          return $join(aTypedArray(this), separator);
        });
        /***/ }),

      /***/ 7789:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const ArrayBufferViewCore = __webpack_require__(2094);
        const apply = __webpack_require__(2104);
        const $lastIndexOf = __webpack_require__(6583);

        const { aTypedArray } = ArrayBufferViewCore;
        const { exportTypedArrayMethod } = ArrayBufferViewCore;

        // `%TypedArray%.prototype.lastIndexOf` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof
        exportTypedArrayMethod('lastIndexOf', function lastIndexOf(searchElement /* , fromIndex */) {
          const { length } = arguments;
          return apply($lastIndexOf, aTypedArray(this), length > 1 ? [searchElement, arguments[1]] : [searchElement]);
        });
        /***/ }),

      /***/ 3739:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const ArrayBufferViewCore = __webpack_require__(2094);
        const $map = (__webpack_require__(2092).map);
        const typedArraySpeciesConstructor = __webpack_require__(6304);

        const { aTypedArray } = ArrayBufferViewCore;
        const { exportTypedArrayMethod } = ArrayBufferViewCore;

        // `%TypedArray%.prototype.map` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype.map
        exportTypedArrayMethod('map', function map(mapfn /* , thisArg */) {
          return $map(aTypedArray(this), mapfn, arguments.length > 1 ? arguments[1] : undefined, (O, length) => new (typedArraySpeciesConstructor(O))(length));
        });
        /***/ }),

      /***/ 4483:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const ArrayBufferViewCore = __webpack_require__(2094);
        const $reduceRight = (__webpack_require__(3671).right);

        const { aTypedArray } = ArrayBufferViewCore;
        const { exportTypedArrayMethod } = ArrayBufferViewCore;

        // `%TypedArray%.prototype.reduceRicht` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright
        exportTypedArrayMethod('reduceRight', function reduceRight(callbackfn /* , initialValue */) {
          const { length } = arguments;
          return $reduceRight(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
        });
        /***/ }),

      /***/ 9368:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const ArrayBufferViewCore = __webpack_require__(2094);
        const $reduce = (__webpack_require__(3671).left);

        const { aTypedArray } = ArrayBufferViewCore;
        const { exportTypedArrayMethod } = ArrayBufferViewCore;

        // `%TypedArray%.prototype.reduce` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce
        exportTypedArrayMethod('reduce', function reduce(callbackfn /* , initialValue */) {
          const { length } = arguments;
          return $reduce(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
        });
        /***/ }),

      /***/ 2056:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const ArrayBufferViewCore = __webpack_require__(2094);

        const { aTypedArray } = ArrayBufferViewCore;
        const { exportTypedArrayMethod } = ArrayBufferViewCore;
        const { floor } = Math;

        // `%TypedArray%.prototype.reverse` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse
        exportTypedArrayMethod('reverse', function reverse() {
          const that = this;
          let { length } = aTypedArray(that);
          const middle = floor(length / 2);
          let index = 0;
          let value;
          while (index < middle) {
            value = that[index];
            that[index++] = that[--length];
            that[length] = value;
          } return that;
        });
        /***/ }),

      /***/ 3462:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const ArrayBufferViewCore = __webpack_require__(2094);
        const lengthOfArrayLike = __webpack_require__(6244);
        const toOffset = __webpack_require__(4590);
        const toObject = __webpack_require__(7908);
        const fails = __webpack_require__(7293);

        const { RangeError } = global;
        const { aTypedArray } = ArrayBufferViewCore;
        const { exportTypedArrayMethod } = ArrayBufferViewCore;

        const FORCED = fails(() => {
          // eslint-disable-next-line es/no-typed-arrays -- required for testing
          new Int8Array(1).set({});
        });

        // `%TypedArray%.prototype.set` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
        exportTypedArrayMethod('set', function set(arrayLike /* , offset */) {
          aTypedArray(this);
          const offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
          const { length } = this;
          const src = toObject(arrayLike);
          const len = lengthOfArrayLike(src);
          let index = 0;
          if (len + offset > length) throw RangeError('Wrong length');
          while (index < len) this[offset + index] = src[index++];
        }, FORCED);
        /***/ }),

      /***/ 678:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const ArrayBufferViewCore = __webpack_require__(2094);
        const typedArraySpeciesConstructor = __webpack_require__(6304);
        const fails = __webpack_require__(7293);
        const arraySlice = __webpack_require__(206);

        const { aTypedArray } = ArrayBufferViewCore;
        const { exportTypedArrayMethod } = ArrayBufferViewCore;

        const FORCED = fails(() => {
          // eslint-disable-next-line es/no-typed-arrays -- required for testing
          new Int8Array(1).slice();
        });

        // `%TypedArray%.prototype.slice` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice
        exportTypedArrayMethod('slice', function slice(start, end) {
          const list = arraySlice(aTypedArray(this), start, end);
          const C = typedArraySpeciesConstructor(this);
          let index = 0;
          const { length } = list;
          const result = new C(length);
          while (length > index) result[index] = list[index++];
          return result;
        }, FORCED);
        /***/ }),

      /***/ 7462:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const ArrayBufferViewCore = __webpack_require__(2094);
        const $some = (__webpack_require__(2092).some);

        const { aTypedArray } = ArrayBufferViewCore;
        const { exportTypedArrayMethod } = ArrayBufferViewCore;

        // `%TypedArray%.prototype.some` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype.some
        exportTypedArrayMethod('some', function some(callbackfn /* , thisArg */) {
          return $some(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        });
        /***/ }),

      /***/ 3824:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const uncurryThis = __webpack_require__(1702);
        const fails = __webpack_require__(7293);
        const aCallable = __webpack_require__(9662);
        const internalSort = __webpack_require__(4362);
        const ArrayBufferViewCore = __webpack_require__(2094);
        const FF = __webpack_require__(8886);
        const IE_OR_EDGE = __webpack_require__(256);
        const V8 = __webpack_require__(7392);
        const WEBKIT = __webpack_require__(8008);

        const { Array } = global;
        const { aTypedArray } = ArrayBufferViewCore;
        const { exportTypedArrayMethod } = ArrayBufferViewCore;
        const { Uint16Array } = global;
        const un$Sort = Uint16Array && uncurryThis(Uint16Array.prototype.sort);

        // WebKit
        const ACCEPT_INCORRECT_ARGUMENTS = !!un$Sort && !(fails(() => {
          un$Sort(new Uint16Array(2), null);
        }) && fails(() => {
          un$Sort(new Uint16Array(2), {});
        }));

        const STABLE_SORT = !!un$Sort && !fails(() => {
          // feature detection can be too slow, so check engines versions
          if (V8) return V8 < 74;
          if (FF) return FF < 67;
          if (IE_OR_EDGE) return true;
          if (WEBKIT) return WEBKIT < 602;

          const array = new Uint16Array(516);
          const expected = Array(516);
          let index; let
            mod;

          for (index = 0; index < 516; index++) {
            mod = index % 4;
            array[index] = 515 - index;
            expected[index] = index - 2 * mod + 3;
          }

          un$Sort(array, (a, b) => (a / 4 | 0) - (b / 4 | 0));

          for (index = 0; index < 516; index++) {
            if (array[index] !== expected[index]) return true;
          }
        });

        const getSortCompare = function (comparefn) {
          return function (x, y) {
            if (comparefn !== undefined) return +comparefn(x, y) || 0;
            // eslint-disable-next-line no-self-compare -- NaN check
            if (y !== y) return -1;
            // eslint-disable-next-line no-self-compare -- NaN check
            if (x !== x) return 1;
            if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
            return x > y;
          };
        };

        // `%TypedArray%.prototype.sort` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
        exportTypedArrayMethod('sort', function sort(comparefn) {
          if (comparefn !== undefined) aCallable(comparefn);
          if (STABLE_SORT) return un$Sort(this, comparefn);

          return internalSort(aTypedArray(this), getSortCompare(comparefn));
        }, !STABLE_SORT || ACCEPT_INCORRECT_ARGUMENTS);
        /***/ }),

      /***/ 5021:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const ArrayBufferViewCore = __webpack_require__(2094);
        const toLength = __webpack_require__(7466);
        const toAbsoluteIndex = __webpack_require__(1400);
        const typedArraySpeciesConstructor = __webpack_require__(6304);

        const { aTypedArray } = ArrayBufferViewCore;
        const { exportTypedArrayMethod } = ArrayBufferViewCore;

        // `%TypedArray%.prototype.subarray` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray
        exportTypedArrayMethod('subarray', function subarray(begin, end) {
          const O = aTypedArray(this);
          const { length } = O;
          const beginIndex = toAbsoluteIndex(begin, length);
          const C = typedArraySpeciesConstructor(O);
          return new C(
            O.buffer,
            O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT,
            toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - beginIndex),
          );
        });
        /***/ }),

      /***/ 2974:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const apply = __webpack_require__(2104);
        const ArrayBufferViewCore = __webpack_require__(2094);
        const fails = __webpack_require__(7293);
        const arraySlice = __webpack_require__(206);

        const { Int8Array } = global;
        const { aTypedArray } = ArrayBufferViewCore;
        const { exportTypedArrayMethod } = ArrayBufferViewCore;
        const $toLocaleString = [].toLocaleString;

        // iOS Safari 6.x fails here
        const TO_LOCALE_STRING_BUG = !!Int8Array && fails(() => {
          $toLocaleString.call(new Int8Array(1));
        });

        const FORCED = fails(() => [1, 2].toLocaleString() != new Int8Array([1, 2]).toLocaleString()) || !fails(() => {
          Int8Array.prototype.toLocaleString.call([1, 2]);
        });

        // `%TypedArray%.prototype.toLocaleString` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
        exportTypedArrayMethod('toLocaleString', function toLocaleString() {
          return apply(
            $toLocaleString,
            TO_LOCALE_STRING_BUG ? arraySlice(aTypedArray(this)) : aTypedArray(this),
            arraySlice(arguments),
          );
        }, FORCED);
        /***/ }),

      /***/ 5016:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const { exportTypedArrayMethod } = __webpack_require__(2094);
        const fails = __webpack_require__(7293);
        const global = __webpack_require__(7854);
        const uncurryThis = __webpack_require__(1702);

        const { Uint8Array } = global;
        const Uint8ArrayPrototype = Uint8Array && Uint8Array.prototype || {};
        let arrayToString = [].toString;
        const join = uncurryThis([].join);

        if (fails(() => { arrayToString.call({}); })) {
          arrayToString = function toString() {
            return join(this);
          };
        }

        const IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString != arrayToString;

        // `%TypedArray%.prototype.toString` method
        // https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring
        exportTypedArrayMethod('toString', arrayToString, IS_NOT_ARRAY_METHOD);
        /***/ }),

      /***/ 8255:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const createTypedArrayConstructor = __webpack_require__(9843);

        // `Uint16Array` constructor
        // https://tc39.es/ecma262/#sec-typedarray-objects
        createTypedArrayConstructor('Uint16', (init) => function Uint16Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        });
        /***/ }),

      /***/ 9135:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const createTypedArrayConstructor = __webpack_require__(9843);

        // `Uint32Array` constructor
        // https://tc39.es/ecma262/#sec-typedarray-objects
        createTypedArrayConstructor('Uint32', (init) => function Uint32Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        });
        /***/ }),

      /***/ 2472:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const createTypedArrayConstructor = __webpack_require__(9843);

        // `Uint8Array` constructor
        // https://tc39.es/ecma262/#sec-typedarray-objects
        createTypedArrayConstructor('Uint8', (init) => function Uint8Array(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        });
        /***/ }),

      /***/ 9743:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const createTypedArrayConstructor = __webpack_require__(9843);

        // `Uint8ClampedArray` constructor
        // https://tc39.es/ecma262/#sec-typedarray-objects
        createTypedArrayConstructor('Uint8', (init) => function Uint8ClampedArray(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        }, true);
        /***/ }),

      /***/ 8628:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        // TODO: Remove from `core-js@4`
        __webpack_require__(9170);
        /***/ }),

      /***/ 5743:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        // TODO: Remove from `core-js@4`
        __webpack_require__(5837);
        /***/ }),

      /***/ 7314:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        // TODO: Remove from `core-js@4`
        __webpack_require__(7922);
        /***/ }),

      /***/ 6290:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        // TODO: Remove from `core-js@4`
        __webpack_require__(4668);
        /***/ }),

      /***/ 7479:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const newPromiseCapabilityModule = __webpack_require__(8523);
        const perform = __webpack_require__(2534);

        // `Promise.try` method
        // https://github.com/tc39/proposal-promise-try
        $({ target: 'Promise', stat: true }, {
          try(callbackfn) {
            const promiseCapability = newPromiseCapabilityModule.f(this);
            const result = perform(callbackfn);
            (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
            return promiseCapability.promise;
          },
        });
        /***/ }),

      /***/ 3728:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        // TODO: Remove from `core-js@4`
        __webpack_require__(6373);
        /***/ }),

      /***/ 4747:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const DOMIterables = __webpack_require__(8324);
        const DOMTokenListPrototype = __webpack_require__(8509);
        const forEach = __webpack_require__(8533);
        const createNonEnumerableProperty = __webpack_require__(8880);

        const handlePrototype = function (CollectionPrototype) {
          // some Chrome versions have non-configurable methods on DOMTokenList
          if (CollectionPrototype && CollectionPrototype.forEach !== forEach) {
            try {
              createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
            } catch (error) {
              CollectionPrototype.forEach = forEach;
            }
          }
        };

        for (const COLLECTION_NAME in DOMIterables) {
          if (DOMIterables[COLLECTION_NAME]) {
            handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
          }
        }

        handlePrototype(DOMTokenListPrototype);
        /***/ }),

      /***/ 3948:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const global = __webpack_require__(7854);
        const DOMIterables = __webpack_require__(8324);
        const DOMTokenListPrototype = __webpack_require__(8509);
        const ArrayIteratorMethods = __webpack_require__(6992);
        const createNonEnumerableProperty = __webpack_require__(8880);
        const wellKnownSymbol = __webpack_require__(5112);

        const ITERATOR = wellKnownSymbol('iterator');
        const TO_STRING_TAG = wellKnownSymbol('toStringTag');
        const ArrayValues = ArrayIteratorMethods.values;

        const handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
          if (CollectionPrototype) {
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[ITERATOR] !== ArrayValues) {
              try {
                createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
              } catch (error) {
                CollectionPrototype[ITERATOR] = ArrayValues;
              }
            }
            if (!CollectionPrototype[TO_STRING_TAG]) {
              createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
            }
            if (DOMIterables[COLLECTION_NAME]) {
              for (const METHOD_NAME in ArrayIteratorMethods) {
              // some Chrome versions have non-configurable methods on DOMTokenList
                if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) {
                  try {
                    createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
                  } catch (error) {
                    CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
                  }
                }
              }
            }
          }
        };

        for (const COLLECTION_NAME in DOMIterables) {
          handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
        }

        handlePrototype(DOMTokenListPrototype, 'DOMTokenList');
        /***/ }),

      /***/ 3753:
      /***/ (function (__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {
        const $ = __webpack_require__(2109);
        const call = __webpack_require__(6916);

        // `URL.prototype.toJSON` method
        // https://url.spec.whatwg.org/#dom-url-tojson
        $({ target: 'URL', proto: true, enumerable: true }, {
          toJSON: function toJSON() {
            return call(URL.prototype.toString, this);
          },
        });
        /***/ }),

      /***/ 1150:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const parent = __webpack_require__(7633);
        __webpack_require__(3948);

        module.exports = parent;
        /***/ }),

      /***/ 251:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const objectKeys = __webpack_require__(2215);
        const isArguments = __webpack_require__(2584);
        const is = __webpack_require__(609);
        const isRegex = __webpack_require__(8420);
        const flags = __webpack_require__(2847);
        const isDate = __webpack_require__(8923);

        const { getTime } = Date.prototype;

        function deepEqual(actual, expected, options) {
          const opts = options || {};

          // 7.1. All identical values are equivalent, as determined by ===.
          if (opts.strict ? is(actual, expected) : actual === expected) {
            return true;
          }

          // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
          if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
            return opts.strict ? is(actual, expected) : actual == expected;
          }

          /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
          // eslint-disable-next-line no-use-before-define
          return objEquiv(actual, expected, opts);
        }

        function isUndefinedOrNull(value) {
          return value === null || value === undefined;
        }

        function isBuffer(x) {
          if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
            return false;
          }
          if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
            return false;
          }
          if (x.length > 0 && typeof x[0] !== 'number') {
            return false;
          }
          return true;
        }

        function objEquiv(a, b, opts) {
          /* eslint max-statements: [2, 50] */
          let i; let
            key;
          if (typeof a !== typeof b) { return false; }
          if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }

          // an identical 'prototype' property.
          if (a.prototype !== b.prototype) { return false; }

          if (isArguments(a) !== isArguments(b)) { return false; }

          const aIsRegex = isRegex(a);
          const bIsRegex = isRegex(b);
          if (aIsRegex !== bIsRegex) { return false; }
          if (aIsRegex || bIsRegex) {
            return a.source === b.source && flags(a) === flags(b);
          }

          if (isDate(a) && isDate(b)) {
            return getTime.call(a) === getTime.call(b);
          }

          const aIsBuffer = isBuffer(a);
          const bIsBuffer = isBuffer(b);
          if (aIsBuffer !== bIsBuffer) { return false; }
          if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
            if (a.length !== b.length) { return false; }
            for (i = 0; i < a.length; i++) {
              if (a[i] !== b[i]) { return false; }
            }
            return true;
          }

          if (typeof a !== typeof b) { return false; }

          try {
            var ka = objectKeys(a);
            var kb = objectKeys(b);
          } catch (e) { // happens when one is a string literal and the other isn't
            return false;
          }
          // having the same number of owned properties (keys incorporates hasOwnProperty)
          if (ka.length !== kb.length) { return false; }

          // the same set of keys (although not necessarily the same order),
          ka.sort();
          kb.sort();
          // ~~~cheap key test
          for (i = ka.length - 1; i >= 0; i--) {
            if (ka[i] != kb[i]) { return false; }
          }
          // equivalent values for every corresponding key, and ~~~possibly expensive deep test
          for (i = ka.length - 1; i >= 0; i--) {
            key = ka[i];
            if (!deepEqual(a[key], b[key], opts)) { return false; }
          }

          return true;
        }

        module.exports = deepEqual;
        /***/ }),

      /***/ 4289:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const keys = __webpack_require__(2215);
        const hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

        const toStr = Object.prototype.toString;
        const { concat } = Array.prototype;
        const origDefineProperty = Object.defineProperty;

        const isFunction = function (fn) {
          return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
        };

        const arePropertyDescriptorsSupported = function () {
          const obj = {};
          try {
            origDefineProperty(obj, 'x', { enumerable: false, value: obj });
            // eslint-disable-next-line no-unused-vars, no-restricted-syntax
            for (const _ in obj) { // jscs:ignore disallowUnusedVariables
              return false;
            }
            return obj.x === obj;
          } catch (e) { /* this is IE 8. */
            return false;
          }
        };
        const supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

        const defineProperty = function (object, name, value, predicate) {
          if (name in object && (!isFunction(predicate) || !predicate())) {
            return;
          }
          if (supportsDescriptors) {
            origDefineProperty(object, name, {
              configurable: true,
              enumerable: false,
              value,
              writable: true,
            });
          } else {
            object[name] = value;
          }
        };

        const defineProperties = function (object, map) {
          const predicates = arguments.length > 2 ? arguments[2] : {};
          let props = keys(map);
          if (hasSymbols) {
            props = concat.call(props, Object.getOwnPropertySymbols(map));
          }
          for (let i = 0; i < props.length; i += 1) {
            defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
          }
        };

        defineProperties.supportsDescriptors = !!supportsDescriptors;

        module.exports = defineProperties;
        /***/ }),

      /***/ 8091:
      /***/ (function (module) {
        /**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */

        function assign(target, firstSource) {
          if (target === undefined || target === null) {
            throw new TypeError('Cannot convert first argument to object');
          }

          const to = Object(target);
          for (let i = 1; i < arguments.length; i++) {
            const nextSource = arguments[i];
            if (nextSource === undefined || nextSource === null) {
              continue;
            }

            const keysArray = Object.keys(Object(nextSource));
            for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
              const nextKey = keysArray[nextIndex];
              const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
              if (desc !== undefined && desc.enumerable) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
          return to;
        }

        function polyfill() {
          if (!Object.assign) {
            Object.defineProperty(Object, 'assign', {
              enumerable: false,
              configurable: true,
              writable: true,
              value: assign,
            });
          }
        }

        module.exports = {
          assign,
          polyfill,
        };
        /***/ }),

      /***/ 7187:
      /***/ (function (module) {
        // Copyright Joyent, Inc. and other Node contributors.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a
        // copy of this software and associated documentation files (the
        // "Software"), to deal in the Software without restriction, including
        // without limitation the rights to use, copy, modify, merge, publish,
        // distribute, sublicense, and/or sell copies of the Software, and to permit
        // persons to whom the Software is furnished to do so, subject to the
        // following conditions:
        //
        // The above copyright notice and this permission notice shall be included
        // in all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
        // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
        // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
        // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
        // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
        // USE OR OTHER DEALINGS IN THE SOFTWARE.

        const R = typeof Reflect === 'object' ? Reflect : null;
        const ReflectApply = R && typeof R.apply === 'function'
          ? R.apply
          : function ReflectApply(target, receiver, args) {
            return Function.prototype.apply.call(target, receiver, args);
          };

        let ReflectOwnKeys;
        if (R && typeof R.ownKeys === 'function') {
          ReflectOwnKeys = R.ownKeys;
        } else if (Object.getOwnPropertySymbols) {
          ReflectOwnKeys = function ReflectOwnKeys(target) {
            return Object.getOwnPropertyNames(target)
              .concat(Object.getOwnPropertySymbols(target));
          };
        } else {
          ReflectOwnKeys = function ReflectOwnKeys(target) {
            return Object.getOwnPropertyNames(target);
          };
        }

        function ProcessEmitWarning(warning) {
          if (console && console.warn) console.warn(warning);
        }

        const NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
          return value !== value;
        };

        function EventEmitter() {
          EventEmitter.init.call(this);
        }
        module.exports = EventEmitter;
        module.exports.once = once;

        // Backwards-compat with node 0.10.x
        EventEmitter.EventEmitter = EventEmitter;

        EventEmitter.prototype._events = undefined;
        EventEmitter.prototype._eventsCount = 0;
        EventEmitter.prototype._maxListeners = undefined;

        // By default EventEmitters will print a warning if more than 10 listeners are
        // added to it. This is a useful default which helps finding memory leaks.
        let defaultMaxListeners = 10;

        function checkListener(listener) {
          if (typeof listener !== 'function') {
            throw new TypeError(`The "listener" argument must be of type Function. Received type ${typeof listener}`);
          }
        }

        Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
          enumerable: true,
          get() {
            return defaultMaxListeners;
          },
          set(arg) {
            if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
              throw new RangeError(`The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ${arg}.`);
            }
            defaultMaxListeners = arg;
          },
        });

        EventEmitter.init = function () {
          if (this._events === undefined
      || this._events === Object.getPrototypeOf(this)._events) {
            this._events = Object.create(null);
            this._eventsCount = 0;
          }

          this._maxListeners = this._maxListeners || undefined;
        };

        // Obviously not all Emitters should be limited to 10. This function allows
        // that to be increased. Set to zero for unlimited.
        EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
          if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
            throw new RangeError(`The value of "n" is out of range. It must be a non-negative number. Received ${n}.`);
          }
          this._maxListeners = n;
          return this;
        };

        function _getMaxListeners(that) {
          if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
          return that._maxListeners;
        }

        EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
          return _getMaxListeners(this);
        };

        EventEmitter.prototype.emit = function emit(type) {
          const args = [];
          for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
          let doError = (type === 'error');

          const events = this._events;
          if (events !== undefined) doError = (doError && events.error === undefined);
          else if (!doError) return false;

          // If there is no 'error' event listener then throw.
          if (doError) {
            let er;
            if (args.length > 0) er = args[0];
            if (er instanceof Error) {
              // Note: The comments on the `throw` lines are intentional, they show
              // up in Node's output if this results in an unhandled exception.
              throw er; // Unhandled 'error' event
            }
            // At least give some kind of context to the user
            const err = new Error(`Unhandled error.${er ? ` (${er.message})` : ''}`);
            err.context = er;
            throw err; // Unhandled 'error' event
          }

          const handler = events[type];

          if (handler === undefined) return false;

          if (typeof handler === 'function') {
            ReflectApply(handler, this, args);
          } else {
            const len = handler.length;
            const listeners = arrayClone(handler, len);
            for (var i = 0; i < len; ++i) ReflectApply(listeners[i], this, args);
          }

          return true;
        };

        function _addListener(target, type, listener, prepend) {
          let m;
          let events;
          let existing;

          checkListener(listener);

          events = target._events;
          if (events === undefined) {
            events = target._events = Object.create(null);
            target._eventsCount = 0;
          } else {
            // To avoid recursion in the case that type === "newListener"! Before
            // adding it to the listeners, first emit "newListener".
            if (events.newListener !== undefined) {
              target.emit('newListener', type,
                listener.listener ? listener.listener : listener);

              // Re-assign `events` because a newListener handler could have caused the
              // this._events to be assigned to a new object
              events = target._events;
            }
            existing = events[type];
          }

          if (existing === undefined) {
            // Optimize the case of one listener. Don't need the extra array object.
            existing = events[type] = listener;
            ++target._eventsCount;
          } else {
            if (typeof existing === 'function') {
              // Adding the second element, need to change to array.
              existing = events[type] = prepend ? [listener, existing] : [existing, listener];
              // If we've already got an array, just append.
            } else if (prepend) {
              existing.unshift(listener);
            } else {
              existing.push(listener);
            }

            // Check for listener leak
            m = _getMaxListeners(target);
            if (m > 0 && existing.length > m && !existing.warned) {
              existing.warned = true;
              // No error code for this since it is a Warning
              // eslint-disable-next-line no-restricted-syntax
              const w = new Error(`Possible EventEmitter memory leak detected. ${
                existing.length} ${String(type)} listeners `
                          + 'added. Use emitter.setMaxListeners() to '
                          + 'increase limit');
              w.name = 'MaxListenersExceededWarning';
              w.emitter = target;
              w.type = type;
              w.count = existing.length;
              ProcessEmitWarning(w);
            }
          }

          return target;
        }

        EventEmitter.prototype.addListener = function addListener(type, listener) {
          return _addListener(this, type, listener, false);
        };

        EventEmitter.prototype.on = EventEmitter.prototype.addListener;

        EventEmitter.prototype.prependListener = function prependListener(type, listener) {
          return _addListener(this, type, listener, true);
        };

        function onceWrapper() {
          if (!this.fired) {
            this.target.removeListener(this.type, this.wrapFn);
            this.fired = true;
            if (arguments.length === 0) return this.listener.call(this.target);
            return this.listener.apply(this.target, arguments);
          }
        }

        function _onceWrap(target, type, listener) {
          const state = {
            fired: false, wrapFn: undefined, target, type, listener,
          };
          const wrapped = onceWrapper.bind(state);
          wrapped.listener = listener;
          state.wrapFn = wrapped;
          return wrapped;
        }

        EventEmitter.prototype.once = function once(type, listener) {
          checkListener(listener);
          this.on(type, _onceWrap(this, type, listener));
          return this;
        };

        EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
          checkListener(listener);
          this.prependListener(type, _onceWrap(this, type, listener));
          return this;
        };

        // Emits a 'removeListener' event if and only if the listener was removed.
        EventEmitter.prototype.removeListener = function removeListener(type, listener) {
          let list; let events; let position; let i; let
            originalListener;

          checkListener(listener);

          events = this._events;
          if (events === undefined) return this;

          list = events[type];
          if (list === undefined) return this;

          if (list === listener || list.listener === listener) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else {
              delete events[type];
              if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
            }
          } else if (typeof list !== 'function') {
            position = -1;

            for (i = list.length - 1; i >= 0; i--) {
              if (list[i] === listener || list[i].listener === listener) {
                originalListener = list[i].listener;
                position = i;
                break;
              }
            }

            if (position < 0) return this;

            if (position === 0) list.shift();
            else {
              spliceOne(list, position);
            }

            if (list.length === 1) events[type] = list[0];

            if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
          }

          return this;
        };

        EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

        EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
          let listeners; let events; let
            i;

          events = this._events;
          if (events === undefined) return this;

          // not listening for removeListener, no need to emit
          if (events.removeListener === undefined) {
            if (arguments.length === 0) {
              this._events = Object.create(null);
              this._eventsCount = 0;
            } else if (events[type] !== undefined) {
              if (--this._eventsCount === 0) this._events = Object.create(null);
              else delete events[type];
            }
            return this;
          }

          // emit removeListener for all listeners on all events
          if (arguments.length === 0) {
            const keys = Object.keys(events);
            let key;
            for (i = 0; i < keys.length; ++i) {
              key = keys[i];
              if (key === 'removeListener') continue;
              this.removeAllListeners(key);
            }
            this.removeAllListeners('removeListener');
            this._events = Object.create(null);
            this._eventsCount = 0;
            return this;
          }

          listeners = events[type];

          if (typeof listeners === 'function') {
            this.removeListener(type, listeners);
          } else if (listeners !== undefined) {
            // LIFO order
            for (i = listeners.length - 1; i >= 0; i--) {
              this.removeListener(type, listeners[i]);
            }
          }

          return this;
        };

        function _listeners(target, type, unwrap) {
          const events = target._events;

          if (events === undefined) return [];

          const evlistener = events[type];
          if (evlistener === undefined) return [];

          if (typeof evlistener === 'function') return unwrap ? [evlistener.listener || evlistener] : [evlistener];

          return unwrap
            ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
        }

        EventEmitter.prototype.listeners = function listeners(type) {
          return _listeners(this, type, true);
        };

        EventEmitter.prototype.rawListeners = function rawListeners(type) {
          return _listeners(this, type, false);
        };

        EventEmitter.listenerCount = function (emitter, type) {
          if (typeof emitter.listenerCount === 'function') {
            return emitter.listenerCount(type);
          }
          return listenerCount.call(emitter, type);
        };

        EventEmitter.prototype.listenerCount = listenerCount;
        function listenerCount(type) {
          const events = this._events;

          if (events !== undefined) {
            const evlistener = events[type];

            if (typeof evlistener === 'function') {
              return 1;
            } if (evlistener !== undefined) {
              return evlistener.length;
            }
          }

          return 0;
        }

        EventEmitter.prototype.eventNames = function eventNames() {
          return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
        };

        function arrayClone(arr, n) {
          const copy = new Array(n);
          for (let i = 0; i < n; ++i) copy[i] = arr[i];
          return copy;
        }

        function spliceOne(list, index) {
          for (; index + 1 < list.length; index++) list[index] = list[index + 1];
          list.pop();
        }

        function unwrapListeners(arr) {
          const ret = new Array(arr.length);
          for (let i = 0; i < ret.length; ++i) {
            ret[i] = arr[i].listener || arr[i];
          }
          return ret;
        }

        function once(emitter, name) {
          return new Promise(((resolve, reject) => {
            function errorListener(err) {
              emitter.removeListener(name, resolver);
              reject(err);
            }

            function resolver() {
              if (typeof emitter.removeListener === 'function') {
                emitter.removeListener('error', errorListener);
              }
              resolve([].slice.call(arguments));
            }

            eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
            if (name !== 'error') {
              addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
            }
          }));
        }

        function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
          if (typeof emitter.on === 'function') {
            eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
          }
        }

        function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
          if (typeof emitter.on === 'function') {
            if (flags.once) {
              emitter.once(name, listener);
            } else {
              emitter.on(name, listener);
            }
          } else if (typeof emitter.addEventListener === 'function') {
            // EventTarget does not have `error` event semantics like Node
            // EventEmitters, we do not listen for `error` events here.
            emitter.addEventListener(name, function wrapListener(arg) {
              // IE does not have builtin `{ once: true }` support so we
              // have to do it manually.
              if (flags.once) {
                emitter.removeEventListener(name, wrapListener);
              }
              listener(arg);
            });
          } else {
            throw new TypeError(`The "emitter" argument must be of type EventEmitter. Received type ${typeof emitter}`);
          }
        }
        /***/ }),

      /***/ 2536:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const ___EXPOSE_LOADER_IMPORT___ = __webpack_require__(4275);
        const ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = __webpack_require__(7672);
        const ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
        if (typeof ___EXPOSE_LOADER_GLOBAL_THIS___.pdfMake === 'undefined') ___EXPOSE_LOADER_GLOBAL_THIS___.pdfMake = ___EXPOSE_LOADER_IMPORT___;
        module.exports = ___EXPOSE_LOADER_IMPORT___;
        /***/ }),

      /***/ 7672:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        // eslint-disable-next-line func-names
        module.exports = (function () {
          if (typeof globalThis === 'object') {
            return globalThis;
          }

          let g;

          try {
            // This works if eval is allowed (see CSP)
            // eslint-disable-next-line no-new-func
            g = this || new Function('return this')();
          } catch (e) {
            // This works if the window reference is available
            if (typeof window === 'object') {
              return window;
            } // This works if the self reference is available

            if (typeof self === 'object') {
              return self;
            } // This works if the global reference is available

            if (typeof __webpack_require__.g !== 'undefined') {
              return __webpack_require__.g;
            }
          }

          return g;
        }());
        /***/ }),

      /***/ 9804:
      /***/ (function (module) {
        const hasOwn = Object.prototype.hasOwnProperty;
        const { toString } = Object.prototype;

        module.exports = function forEach(obj, fn, ctx) {
          if (toString.call(fn) !== '[object Function]') {
            throw new TypeError('iterator must be a function');
          }
          const l = obj.length;
          if (l === +l) {
            for (let i = 0; i < l; i++) {
              fn.call(ctx, obj[i], i, obj);
            }
          } else {
            for (const k in obj) {
              if (hasOwn.call(obj, k)) {
                fn.call(ctx, obj[k], k, obj);
              }
            }
          }
        };
        /***/ }),

      /***/ 7648:
      /***/ (function (module) {
        /* eslint no-invalid-this: 1 */

        const ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
        const { slice } = Array.prototype;
        const toStr = Object.prototype.toString;
        const funcType = '[object Function]';

        module.exports = function bind(that) {
          const target = this;
          if (typeof target !== 'function' || toStr.call(target) !== funcType) {
            throw new TypeError(ERROR_MESSAGE + target);
          }
          const args = slice.call(arguments, 1);

          let bound;
          const binder = function () {
            if (this instanceof bound) {
              const result = target.apply(
                this,
                args.concat(slice.call(arguments)),
              );
              if (Object(result) === result) {
                return result;
              }
              return this;
            }
            return target.apply(
              that,
              args.concat(slice.call(arguments)),
            );
          };

          const boundLength = Math.max(0, target.length - args.length);
          const boundArgs = [];
          for (let i = 0; i < boundLength; i++) {
            boundArgs.push(`$${i}`);
          }

          bound = Function('binder', `return function (${boundArgs.join(',')}){ return binder.apply(this,arguments); }`)(binder);

          if (target.prototype) {
            const Empty = function Empty() {};
            Empty.prototype = target.prototype;
            bound.prototype = new Empty();
            Empty.prototype = null;
          }

          return bound;
        };
        /***/ }),

      /***/ 8612:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const implementation = __webpack_require__(7648);

        module.exports = Function.prototype.bind || implementation;
        /***/ }),

      /***/ 210:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        let undefined;

        const $SyntaxError = SyntaxError;
        const $Function = Function;
        const $TypeError = TypeError;

        // eslint-disable-next-line consistent-return
        const getEvalledConstructor = function (expressionSyntax) {
          try {
            return $Function(`"use strict"; return (${expressionSyntax}).constructor;`)();
          } catch (e) {}
        };

        let $gOPD = Object.getOwnPropertyDescriptor;
        if ($gOPD) {
          try {
            $gOPD({}, '');
          } catch (e) {
            $gOPD = null; // this is IE 8, which has a broken gOPD
          }
        }

        const throwTypeError = function () {
          throw new $TypeError();
        };
        const ThrowTypeError = $gOPD
          ? (function () {
            try {
              // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
              arguments.callee; // IE 8 does not throw here
              return throwTypeError;
            } catch (calleeThrows) {
              try {
                // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
                return $gOPD(arguments, 'callee').get;
              } catch (gOPDthrows) {
                return throwTypeError;
              }
            }
          }())
          : throwTypeError;

        const hasSymbols = __webpack_require__(1405)();

        const getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

        const needsEval = {};

        const TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

        const INTRINSICS = {
          '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
          '%Array%': Array,
          '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
          '%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
          '%AsyncFromSyncIteratorPrototype%': undefined,
          '%AsyncFunction%': needsEval,
          '%AsyncGenerator%': needsEval,
          '%AsyncGeneratorFunction%': needsEval,
          '%AsyncIteratorPrototype%': needsEval,
          '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
          '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
          '%Boolean%': Boolean,
          '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
          '%Date%': Date,
          '%decodeURI%': decodeURI,
          '%decodeURIComponent%': decodeURIComponent,
          '%encodeURI%': encodeURI,
          '%encodeURIComponent%': encodeURIComponent,
          '%Error%': Error,
          '%eval%': eval, // eslint-disable-line no-eval
          '%EvalError%': EvalError,
          '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
          '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
          '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
          '%Function%': $Function,
          '%GeneratorFunction%': needsEval,
          '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
          '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
          '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
          '%isFinite%': isFinite,
          '%isNaN%': isNaN,
          '%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
          '%JSON%': typeof JSON === 'object' ? JSON : undefined,
          '%Map%': typeof Map === 'undefined' ? undefined : Map,
          '%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
          '%Math%': Math,
          '%Number%': Number,
          '%Object%': Object,
          '%parseFloat%': parseFloat,
          '%parseInt%': parseInt,
          '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
          '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
          '%RangeError%': RangeError,
          '%ReferenceError%': ReferenceError,
          '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
          '%RegExp%': RegExp,
          '%Set%': typeof Set === 'undefined' ? undefined : Set,
          '%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
          '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
          '%String%': String,
          '%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
          '%Symbol%': hasSymbols ? Symbol : undefined,
          '%SyntaxError%': $SyntaxError,
          '%ThrowTypeError%': ThrowTypeError,
          '%TypedArray%': TypedArray,
          '%TypeError%': $TypeError,
          '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
          '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
          '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
          '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
          '%URIError%': URIError,
          '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
          '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
          '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
        };

        const doEval = function doEval(name) {
          let value;
          if (name === '%AsyncFunction%') {
            value = getEvalledConstructor('async function () {}');
          } else if (name === '%GeneratorFunction%') {
            value = getEvalledConstructor('function* () {}');
          } else if (name === '%AsyncGeneratorFunction%') {
            value = getEvalledConstructor('async function* () {}');
          } else if (name === '%AsyncGenerator%') {
            const fn = doEval('%AsyncGeneratorFunction%');
            if (fn) {
              value = fn.prototype;
            }
          } else if (name === '%AsyncIteratorPrototype%') {
            const gen = doEval('%AsyncGenerator%');
            if (gen) {
              value = getProto(gen.prototype);
            }
          }

          INTRINSICS[name] = value;

          return value;
        };

        const LEGACY_ALIASES = {
          '%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
          '%ArrayPrototype%': ['Array', 'prototype'],
          '%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
          '%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
          '%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
          '%ArrayProto_values%': ['Array', 'prototype', 'values'],
          '%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
          '%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
          '%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
          '%BooleanPrototype%': ['Boolean', 'prototype'],
          '%DataViewPrototype%': ['DataView', 'prototype'],
          '%DatePrototype%': ['Date', 'prototype'],
          '%ErrorPrototype%': ['Error', 'prototype'],
          '%EvalErrorPrototype%': ['EvalError', 'prototype'],
          '%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
          '%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
          '%FunctionPrototype%': ['Function', 'prototype'],
          '%Generator%': ['GeneratorFunction', 'prototype'],
          '%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
          '%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
          '%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
          '%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
          '%JSONParse%': ['JSON', 'parse'],
          '%JSONStringify%': ['JSON', 'stringify'],
          '%MapPrototype%': ['Map', 'prototype'],
          '%NumberPrototype%': ['Number', 'prototype'],
          '%ObjectPrototype%': ['Object', 'prototype'],
          '%ObjProto_toString%': ['Object', 'prototype', 'toString'],
          '%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
          '%PromisePrototype%': ['Promise', 'prototype'],
          '%PromiseProto_then%': ['Promise', 'prototype', 'then'],
          '%Promise_all%': ['Promise', 'all'],
          '%Promise_reject%': ['Promise', 'reject'],
          '%Promise_resolve%': ['Promise', 'resolve'],
          '%RangeErrorPrototype%': ['RangeError', 'prototype'],
          '%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
          '%RegExpPrototype%': ['RegExp', 'prototype'],
          '%SetPrototype%': ['Set', 'prototype'],
          '%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
          '%StringPrototype%': ['String', 'prototype'],
          '%SymbolPrototype%': ['Symbol', 'prototype'],
          '%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
          '%TypedArrayPrototype%': ['TypedArray', 'prototype'],
          '%TypeErrorPrototype%': ['TypeError', 'prototype'],
          '%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
          '%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
          '%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
          '%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
          '%URIErrorPrototype%': ['URIError', 'prototype'],
          '%WeakMapPrototype%': ['WeakMap', 'prototype'],
          '%WeakSetPrototype%': ['WeakSet', 'prototype'],
        };

        const bind = __webpack_require__(8612);
        const hasOwn = __webpack_require__(7642);
        const $concat = bind.call(Function.call, Array.prototype.concat);
        const $spliceApply = bind.call(Function.apply, Array.prototype.splice);
        const $replace = bind.call(Function.call, String.prototype.replace);
        const $strSlice = bind.call(Function.call, String.prototype.slice);

        /* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
        const rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
        const reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
        const stringToPath = function stringToPath(string) {
          const first = $strSlice(string, 0, 1);
          const last = $strSlice(string, -1);
          if (first === '%' && last !== '%') {
            throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
          } else if (last === '%' && first !== '%') {
            throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
          }
          const result = [];
          $replace(string, rePropName, (match, number, quote, subString) => {
            result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
          });
          return result;
        };
        /* end adaptation */

        const getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
          let intrinsicName = name;
          let alias;
          if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
            alias = LEGACY_ALIASES[intrinsicName];
            intrinsicName = `%${alias[0]}%`;
          }

          if (hasOwn(INTRINSICS, intrinsicName)) {
            let value = INTRINSICS[intrinsicName];
            if (value === needsEval) {
              value = doEval(intrinsicName);
            }
            if (typeof value === 'undefined' && !allowMissing) {
              throw new $TypeError(`intrinsic ${name} exists, but is not available. Please file an issue!`);
            }

            return {
              alias,
              name: intrinsicName,
              value,
            };
          }

          throw new $SyntaxError(`intrinsic ${name} does not exist!`);
        };

        module.exports = function GetIntrinsic(name, allowMissing) {
          if (typeof name !== 'string' || name.length === 0) {
            throw new $TypeError('intrinsic name must be a non-empty string');
          }
          if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
            throw new $TypeError('"allowMissing" argument must be a boolean');
          }

          const parts = stringToPath(name);
          let intrinsicBaseName = parts.length > 0 ? parts[0] : '';

          const intrinsic = getBaseIntrinsic(`%${intrinsicBaseName}%`, allowMissing);
          let intrinsicRealName = intrinsic.name;
          let { value } = intrinsic;
          let skipFurtherCaching = false;

          const { alias } = intrinsic;
          if (alias) {
            intrinsicBaseName = alias[0];
            $spliceApply(parts, $concat([0, 1], alias));
          }

          for (let i = 1, isOwn = true; i < parts.length; i += 1) {
            const part = parts[i];
            const first = $strSlice(part, 0, 1);
            const last = $strSlice(part, -1);
            if (
              (
                (first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
              )
			&& first !== last
            ) {
              throw new $SyntaxError('property names with quotes must have matching quotes');
            }
            if (part === 'constructor' || !isOwn) {
              skipFurtherCaching = true;
            }

            intrinsicBaseName += `.${part}`;
            intrinsicRealName = `%${intrinsicBaseName}%`;

            if (hasOwn(INTRINSICS, intrinsicRealName)) {
              value = INTRINSICS[intrinsicRealName];
            } else if (value != null) {
              if (!(part in value)) {
                if (!allowMissing) {
                  throw new $TypeError(`base intrinsic for ${name} exists, but the property is not available.`);
                }
                return void undefined;
              }
              if ($gOPD && (i + 1) >= parts.length) {
                const desc = $gOPD(value, part);
                isOwn = !!desc;

                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
                  value = desc.get;
                } else {
                  value = value[part];
                }
              } else {
                isOwn = hasOwn(value, part);
                value = value[part];
              }

              if (isOwn && !skipFurtherCaching) {
                INTRINSICS[intrinsicRealName] = value;
              }
            }
          }
          return value;
        };
        /***/ }),

      /***/ 1405:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const origSymbol = typeof Symbol !== 'undefined' && Symbol;
        const hasSymbolSham = __webpack_require__(5419);

        module.exports = function hasNativeSymbols() {
          if (typeof origSymbol !== 'function') { return false; }
          if (typeof Symbol !== 'function') { return false; }
          if (typeof origSymbol('foo') !== 'symbol') { return false; }
          if (typeof Symbol('bar') !== 'symbol') { return false; }

          return hasSymbolSham();
        };
        /***/ }),

      /***/ 5419:
      /***/ (function (module) {
        /* eslint complexity: [2, 18], max-statements: [2, 33] */
        module.exports = function hasSymbols() {
          if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
          if (typeof Symbol.iterator === 'symbol') { return true; }

          const obj = {};
          let sym = Symbol('test');
          const symObj = Object(sym);
          if (typeof sym === 'string') { return false; }

          if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
          if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

          // temp disabled per https://github.com/ljharb/object.assign/issues/17
          // if (sym instanceof Symbol) { return false; }
          // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
          // if (!(symObj instanceof Symbol)) { return false; }

          // if (typeof Symbol.prototype.toString !== 'function') { return false; }
          // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

          const symVal = 42;
          obj[sym] = symVal;
          for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
          if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

          if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

          const syms = Object.getOwnPropertySymbols(obj);
          if (syms.length !== 1 || syms[0] !== sym) { return false; }

          if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

          if (typeof Object.getOwnPropertyDescriptor === 'function') {
            const descriptor = Object.getOwnPropertyDescriptor(obj, sym);
            if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
          }

          return true;
        };
        /***/ }),

      /***/ 6410:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const hasSymbols = __webpack_require__(5419);

        module.exports = function hasToStringTagShams() {
          return hasSymbols() && !!Symbol.toStringTag;
        };
        /***/ }),

      /***/ 7642:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const bind = __webpack_require__(8612);

        module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);
        /***/ }),

      /***/ 688:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        const { Buffer } = __webpack_require__(7103);

        // Multibyte codec. In this scheme, a character is represented by 1 or more bytes.
        // Our codec supports UTF-16 surrogates, extensions for GB18030 and unicode sequences.
        // To save memory and loading time, we read table files only when requested.

        exports._dbcs = DBCSCodec;

        const UNASSIGNED = -1;
        const GB18030_CODE = -2;
        const SEQ_START = -10;
        const NODE_START = -1000;
        const UNASSIGNED_NODE = new Array(0x100);
        const DEF_CHAR = -1;

        for (let i = 0; i < 0x100; i++) UNASSIGNED_NODE[i] = UNASSIGNED;

        // Class DBCSCodec reads and initializes mapping tables.
        function DBCSCodec(codecOptions, iconv) {
          this.encodingName = codecOptions.encodingName;
          if (!codecOptions) throw new Error('DBCS codec is called without the data.');
          if (!codecOptions.table) throw new Error(`Encoding '${this.encodingName}' has no data.`);

          // Load tables.
          const mappingTable = codecOptions.table();

          // Decode tables: MBCS -> Unicode.

          // decodeTables is a trie, encoded as an array of arrays of integers. Internal arrays are trie nodes and all have len = 256.
          // Trie root is decodeTables[0].
          // Values: >=  0 -> unicode character code. can be > 0xFFFF
          //         == UNASSIGNED -> unknown/unassigned sequence.
          //         == GB18030_CODE -> this is the end of a GB18030 4-byte sequence.
          //         <= NODE_START -> index of the next node in our trie to process next byte.
          //         <= SEQ_START  -> index of the start of a character code sequence, in decodeTableSeq.
          this.decodeTables = [];
          this.decodeTables[0] = UNASSIGNED_NODE.slice(0); // Create root node.

          // Sometimes a MBCS char corresponds to a sequence of unicode chars. We store them as arrays of integers here.
          this.decodeTableSeq = [];

          // Actual mapping tables consist of chunks. Use them to fill up decode tables.
          for (var i = 0; i < mappingTable.length; i++) this._addDecodeChunk(mappingTable[i]);

          // Load & create GB18030 tables when needed.
          if (typeof codecOptions.gb18030 === 'function') {
            this.gb18030 = codecOptions.gb18030(); // Load GB18030 ranges.

            // Add GB18030 common decode nodes.
            const commonThirdByteNodeIdx = this.decodeTables.length;
            this.decodeTables.push(UNASSIGNED_NODE.slice(0));

            const commonFourthByteNodeIdx = this.decodeTables.length;
            this.decodeTables.push(UNASSIGNED_NODE.slice(0));

            // Fill out the tree
            const firstByteNode = this.decodeTables[0];
            for (var i = 0x81; i <= 0xFE; i++) {
              const secondByteNode = this.decodeTables[NODE_START - firstByteNode[i]];
              for (var j = 0x30; j <= 0x39; j++) {
                if (secondByteNode[j] === UNASSIGNED) {
                  secondByteNode[j] = NODE_START - commonThirdByteNodeIdx;
                } else if (secondByteNode[j] > NODE_START) {
                  throw new Error('gb18030 decode tables conflict at byte 2');
                }

                const thirdByteNode = this.decodeTables[NODE_START - secondByteNode[j]];
                for (let k = 0x81; k <= 0xFE; k++) {
                  if (thirdByteNode[k] === UNASSIGNED) {
                    thirdByteNode[k] = NODE_START - commonFourthByteNodeIdx;
                  } else if (thirdByteNode[k] === NODE_START - commonFourthByteNodeIdx) {
                    continue;
                  } else if (thirdByteNode[k] > NODE_START) {
                    throw new Error('gb18030 decode tables conflict at byte 3');
                  }

                  const fourthByteNode = this.decodeTables[NODE_START - thirdByteNode[k]];
                  for (let l = 0x30; l <= 0x39; l++) {
                    if (fourthByteNode[l] === UNASSIGNED) fourthByteNode[l] = GB18030_CODE;
                  }
                }
              }
            }
          }

          this.defaultCharUnicode = iconv.defaultCharUnicode;

          // Encode tables: Unicode -> DBCS.

          // `encodeTable` is array mapping from unicode char to encoded char. All its values are integers for performance.
          // Because it can be sparse, it is represented as array of buckets by 256 chars each. Bucket can be null.
          // Values: >=  0 -> it is a normal char. Write the value (if <=256 then 1 byte, if <=65536 then 2 bytes, etc.).
          //         == UNASSIGNED -> no conversion found. Output a default char.
          //         <= SEQ_START  -> it's an index in encodeTableSeq, see below. The character starts a sequence.
          this.encodeTable = [];

          // `encodeTableSeq` is used when a sequence of unicode characters is encoded as a single code. We use a tree of
          // objects where keys correspond to characters in sequence and leafs are the encoded dbcs values. A special DEF_CHAR key
          // means end of sequence (needed when one sequence is a strict subsequence of another).
          // Objects are kept separately from encodeTable to increase performance.
          this.encodeTableSeq = [];

          // Some chars can be decoded, but need not be encoded.
          const skipEncodeChars = {};
          if (codecOptions.encodeSkipVals) {
            for (var i = 0; i < codecOptions.encodeSkipVals.length; i++) {
              const val = codecOptions.encodeSkipVals[i];
              if (typeof val === 'number') skipEncodeChars[val] = true;
              else for (var j = val.from; j <= val.to; j++) skipEncodeChars[j] = true;
            }
          }

          // Use decode trie to recursively fill out encode tables.
          this._fillEncodeTable(0, 0, skipEncodeChars);

          // Add more encoding pairs when needed.
          if (codecOptions.encodeAdd) {
            for (const uChar in codecOptions.encodeAdd) if (Object.prototype.hasOwnProperty.call(codecOptions.encodeAdd, uChar)) this._setEncodeChar(uChar.charCodeAt(0), codecOptions.encodeAdd[uChar]);
          }

          this.defCharSB = this.encodeTable[0][iconv.defaultCharSingleByte.charCodeAt(0)];
          if (this.defCharSB === UNASSIGNED) this.defCharSB = this.encodeTable[0]['?'];
          if (this.defCharSB === UNASSIGNED) this.defCharSB = '?'.charCodeAt(0);
        }

        DBCSCodec.prototype.encoder = DBCSEncoder;
        DBCSCodec.prototype.decoder = DBCSDecoder;

        // Decoder helpers
        DBCSCodec.prototype._getDecodeTrieNode = function (addr) {
          const bytes = [];
          for (; addr > 0; addr >>>= 8) bytes.push(addr & 0xFF);
          if (bytes.length == 0) bytes.push(0);

          let node = this.decodeTables[0];
          for (let i = bytes.length - 1; i > 0; i--) { // Traverse nodes deeper into the trie.
            const val = node[bytes[i]];

            if (val == UNASSIGNED) { // Create new node.
              node[bytes[i]] = NODE_START - this.decodeTables.length;
              this.decodeTables.push(node = UNASSIGNED_NODE.slice(0));
            } else if (val <= NODE_START) { // Existing node.
              node = this.decodeTables[NODE_START - val];
            } else throw new Error(`Overwrite byte in ${this.encodingName}, addr: ${addr.toString(16)}`);
          }
          return node;
        };

        DBCSCodec.prototype._addDecodeChunk = function (chunk) {
          // First element of chunk is the hex mbcs code where we start.
          let curAddr = parseInt(chunk[0], 16);

          // Choose the decoding node where we'll write our chars.
          const writeTable = this._getDecodeTrieNode(curAddr);
          curAddr &= 0xFF;

          // Write all other elements of the chunk to the table.
          for (let k = 1; k < chunk.length; k++) {
            const part = chunk[k];
            if (typeof part === 'string') { // String, write as-is.
              for (var l = 0; l < part.length;) {
                const code = part.charCodeAt(l++);
                if (code >= 0xD800 && code < 0xDC00) { // Decode surrogate
                  const codeTrail = part.charCodeAt(l++);
                  if (codeTrail >= 0xDC00 && codeTrail < 0xE000) writeTable[curAddr++] = 0x10000 + (code - 0xD800) * 0x400 + (codeTrail - 0xDC00);
                  else throw new Error(`Incorrect surrogate pair in ${this.encodingName} at chunk ${chunk[0]}`);
                } else if (code > 0x0FF0 && code <= 0x0FFF) { // Character sequence (our own encoding used)
                  const len = 0xFFF - code + 2;
                  const seq = [];
                  for (let m = 0; m < len; m++) seq.push(part.charCodeAt(l++)); // Simple variation: don't support surrogates or subsequences in seq.

                  writeTable[curAddr++] = SEQ_START - this.decodeTableSeq.length;
                  this.decodeTableSeq.push(seq);
                } else writeTable[curAddr++] = code; // Basic char
              }
            } else if (typeof part === 'number') { // Integer, meaning increasing sequence starting with prev character.
              let charCode = writeTable[curAddr - 1] + 1;
              for (var l = 0; l < part; l++) writeTable[curAddr++] = charCode++;
            } else throw new Error(`Incorrect type '${typeof part}' given in ${this.encodingName} at chunk ${chunk[0]}`);
          }
          if (curAddr > 0xFF) throw new Error(`Incorrect chunk in ${this.encodingName} at addr ${chunk[0]}: too long${curAddr}`);
        };

        // Encoder helpers
        DBCSCodec.prototype._getEncodeBucket = function (uCode) {
          const high = uCode >> 8; // This could be > 0xFF because of astral characters.
          if (this.encodeTable[high] === undefined) this.encodeTable[high] = UNASSIGNED_NODE.slice(0); // Create bucket on demand.
          return this.encodeTable[high];
        };

        DBCSCodec.prototype._setEncodeChar = function (uCode, dbcsCode) {
          const bucket = this._getEncodeBucket(uCode);
          const low = uCode & 0xFF;
          if (bucket[low] <= SEQ_START) this.encodeTableSeq[SEQ_START - bucket[low]][DEF_CHAR] = dbcsCode; // There's already a sequence, set a single-char subsequence of it.
          else if (bucket[low] == UNASSIGNED) bucket[low] = dbcsCode;
        };

        DBCSCodec.prototype._setEncodeSequence = function (seq, dbcsCode) {
          // Get the root of character tree according to first character of the sequence.
          let uCode = seq[0];
          const bucket = this._getEncodeBucket(uCode);
          const low = uCode & 0xFF;

          let node;
          if (bucket[low] <= SEQ_START) {
            // There's already a sequence with  - use it.
            node = this.encodeTableSeq[SEQ_START - bucket[low]];
          } else {
            // There was no sequence object - allocate a new one.
            node = {};
            if (bucket[low] !== UNASSIGNED) node[DEF_CHAR] = bucket[low]; // If a char was set before - make it a single-char subsequence.
            bucket[low] = SEQ_START - this.encodeTableSeq.length;
            this.encodeTableSeq.push(node);
          }

          // Traverse the character tree, allocating new nodes as needed.
          for (let j = 1; j < seq.length - 1; j++) {
            const oldVal = node[uCode];
            if (typeof oldVal === 'object') node = oldVal;
            else {
              node = node[uCode] = {};
              if (oldVal !== undefined) node[DEF_CHAR] = oldVal;
            }
          }

          // Set the leaf to given dbcsCode.
          uCode = seq[seq.length - 1];
          node[uCode] = dbcsCode;
        };

        DBCSCodec.prototype._fillEncodeTable = function (nodeIdx, prefix, skipEncodeChars) {
          const node = this.decodeTables[nodeIdx];
          let hasValues = false;
          const subNodeEmpty = {};
          for (let i = 0; i < 0x100; i++) {
            const uCode = node[i];
            const mbCode = prefix + i;
            if (skipEncodeChars[mbCode]) continue;

            if (uCode >= 0) {
              this._setEncodeChar(uCode, mbCode);
              hasValues = true;
            } else if (uCode <= NODE_START) {
              const subNodeIdx = NODE_START - uCode;
              if (!subNodeEmpty[subNodeIdx]) { // Skip empty subtrees (they are too large in gb18030).
                const newPrefix = (mbCode << 8) >>> 0; // NOTE: '>>> 0' keeps 32-bit num positive.
                if (this._fillEncodeTable(subNodeIdx, newPrefix, skipEncodeChars)) hasValues = true;
                else subNodeEmpty[subNodeIdx] = true;
              }
            } else if (uCode <= SEQ_START) {
              this._setEncodeSequence(this.decodeTableSeq[SEQ_START - uCode], mbCode);
              hasValues = true;
            }
          }
          return hasValues;
        };

        // == Encoder ==================================================================

        function DBCSEncoder(options, codec) {
          // Encoder state
          this.leadSurrogate = -1;
          this.seqObj = undefined;

          // Static data
          this.encodeTable = codec.encodeTable;
          this.encodeTableSeq = codec.encodeTableSeq;
          this.defaultCharSingleByte = codec.defCharSB;
          this.gb18030 = codec.gb18030;
        }

        DBCSEncoder.prototype.write = function (str) {
          const newBuf = Buffer.alloc(str.length * (this.gb18030 ? 4 : 3));
          let { leadSurrogate } = this;
          let { seqObj } = this; let nextChar = -1;
          let i = 0; let
            j = 0;

          while (true) {
            // 0. Get next character.
            if (nextChar === -1) {
              if (i == str.length) break;
              var uCode = str.charCodeAt(i++);
            } else {
              var uCode = nextChar;
              nextChar = -1;
            }

            // 1. Handle surrogates.
            if (uCode >= 0xD800 && uCode < 0xE000) { // Char is one of surrogates.
              if (uCode < 0xDC00) { // We've got lead surrogate.
                if (leadSurrogate === -1) {
                  leadSurrogate = uCode;
                  continue;
                } else {
                  leadSurrogate = uCode;
                  // Double lead surrogate found.
                  uCode = UNASSIGNED;
                }
              } else { // We've got trail surrogate.
                if (leadSurrogate !== -1) {
                  uCode = 0x10000 + (leadSurrogate - 0xD800) * 0x400 + (uCode - 0xDC00);
                  leadSurrogate = -1;
                } else {
                  // Incomplete surrogate pair - only trail surrogate found.
                  uCode = UNASSIGNED;
                }
              }
            } else if (leadSurrogate !== -1) {
            // Incomplete surrogate pair - only lead surrogate found.
              nextChar = uCode; uCode = UNASSIGNED; // Write an error, then current char.
              leadSurrogate = -1;
            }

            // 2. Convert uCode character.
            var dbcsCode = UNASSIGNED;
            if (seqObj !== undefined && uCode != UNASSIGNED) { // We are in the middle of the sequence
              let resCode = seqObj[uCode];
              if (typeof resCode === 'object') { // Sequence continues.
                seqObj = resCode;
                continue;
              } else if (typeof resCode === 'number') { // Sequence finished. Write it.
                dbcsCode = resCode;
              } else if (resCode == undefined) { // Current character is not part of the sequence.
                // Try default character for this sequence
                resCode = seqObj[DEF_CHAR];
                if (resCode !== undefined) {
                  dbcsCode = resCode; // Found. Write it.
                  nextChar = uCode; // Current character will be written too in the next iteration.
                } else {
                  // TODO: What if we have no default? (resCode == undefined)
                  // Then, we should write first char of the sequence as-is and try the rest recursively.
                  // Didn't do it for now because no encoding has this situation yet.
                  // Currently, just skip the sequence and write current char.
                }
              }
              seqObj = undefined;
            } else if (uCode >= 0) { // Regular character
              const subtable = this.encodeTable[uCode >> 8];
              if (subtable !== undefined) dbcsCode = subtable[uCode & 0xFF];

              if (dbcsCode <= SEQ_START) { // Sequence start
                seqObj = this.encodeTableSeq[SEQ_START - dbcsCode];
                continue;
              }

              if (dbcsCode == UNASSIGNED && this.gb18030) {
                // Use GB18030 algorithm to find character(s) to write.
                const idx = findIdx(this.gb18030.uChars, uCode);
                if (idx != -1) {
                  var dbcsCode = this.gb18030.gbChars[idx] + (uCode - this.gb18030.uChars[idx]);
                  newBuf[j++] = 0x81 + Math.floor(dbcsCode / 12600); dbcsCode %= 12600;
                  newBuf[j++] = 0x30 + Math.floor(dbcsCode / 1260); dbcsCode %= 1260;
                  newBuf[j++] = 0x81 + Math.floor(dbcsCode / 10); dbcsCode %= 10;
                  newBuf[j++] = 0x30 + dbcsCode;
                  continue;
                }
              }
            }

            // 3. Write dbcsCode character.
            if (dbcsCode === UNASSIGNED) dbcsCode = this.defaultCharSingleByte;

            if (dbcsCode < 0x100) {
              newBuf[j++] = dbcsCode;
            } else if (dbcsCode < 0x10000) {
              newBuf[j++] = dbcsCode >> 8; // high byte
              newBuf[j++] = dbcsCode & 0xFF; // low byte
            } else if (dbcsCode < 0x1000000) {
              newBuf[j++] = dbcsCode >> 16;
              newBuf[j++] = (dbcsCode >> 8) & 0xFF;
              newBuf[j++] = dbcsCode & 0xFF;
            } else {
              newBuf[j++] = dbcsCode >>> 24;
              newBuf[j++] = (dbcsCode >>> 16) & 0xFF;
              newBuf[j++] = (dbcsCode >>> 8) & 0xFF;
              newBuf[j++] = dbcsCode & 0xFF;
            }
          }

          this.seqObj = seqObj;
          this.leadSurrogate = leadSurrogate;
          return newBuf.slice(0, j);
        };

        DBCSEncoder.prototype.end = function () {
          if (this.leadSurrogate === -1 && this.seqObj === undefined) return; // All clean. Most often case.

          const newBuf = Buffer.alloc(10); let
            j = 0;

          if (this.seqObj) { // We're in the sequence.
            const dbcsCode = this.seqObj[DEF_CHAR];
            if (dbcsCode !== undefined) { // Write beginning of the sequence.
              if (dbcsCode < 0x100) {
                newBuf[j++] = dbcsCode;
              } else {
                newBuf[j++] = dbcsCode >> 8; // high byte
                newBuf[j++] = dbcsCode & 0xFF; // low byte
              }
            } else {
            // See todo above.
            }
            this.seqObj = undefined;
          }

          if (this.leadSurrogate !== -1) {
            // Incomplete surrogate pair - only lead surrogate found.
            newBuf[j++] = this.defaultCharSingleByte;
            this.leadSurrogate = -1;
          }

          return newBuf.slice(0, j);
        };

        // Export for testing
        DBCSEncoder.prototype.findIdx = findIdx;

        // == Decoder ==================================================================

        function DBCSDecoder(options, codec) {
          // Decoder state
          this.nodeIdx = 0;
          this.prevBytes = [];

          // Static data
          this.decodeTables = codec.decodeTables;
          this.decodeTableSeq = codec.decodeTableSeq;
          this.defaultCharUnicode = codec.defaultCharUnicode;
          this.gb18030 = codec.gb18030;
        }

        DBCSDecoder.prototype.write = function (buf) {
          const newBuf = Buffer.alloc(buf.length * 2);
          let { nodeIdx } = this;
          const { prevBytes } = this; const prevOffset = this.prevBytes.length;
          let seqStart = -this.prevBytes.length; // idx of the start of current parsed sequence.
          var uCode;

          for (var i = 0, j = 0; i < buf.length; i++) {
            const curByte = (i >= 0) ? buf[i] : prevBytes[i + prevOffset];

            // Lookup in current trie node.
            var uCode = this.decodeTables[nodeIdx][curByte];

            if (uCode >= 0) {
            // Normal character, just use it.
            } else if (uCode === UNASSIGNED) { // Unknown char.
            // TODO: Callback with seq.
              uCode = this.defaultCharUnicode.charCodeAt(0);
              i = seqStart; // Skip one byte ('i' will be incremented by the for loop) and try to parse again.
            } else if (uCode === GB18030_CODE) {
              if (i >= 3) {
                var ptr = (buf[i - 3] - 0x81) * 12600 + (buf[i - 2] - 0x30) * 1260 + (buf[i - 1] - 0x81) * 10 + (curByte - 0x30);
              } else {
                var ptr = (prevBytes[i - 3 + prevOffset] - 0x81) * 12600
                          + (((i - 2 >= 0) ? buf[i - 2] : prevBytes[i - 2 + prevOffset]) - 0x30) * 1260
                          + (((i - 1 >= 0) ? buf[i - 1] : prevBytes[i - 1 + prevOffset]) - 0x81) * 10
                          + (curByte - 0x30);
              }
              const idx = findIdx(this.gb18030.gbChars, ptr);
              uCode = this.gb18030.uChars[idx] + ptr - this.gb18030.gbChars[idx];
            } else if (uCode <= NODE_START) { // Go to next trie node.
              nodeIdx = NODE_START - uCode;
              continue;
            } else if (uCode <= SEQ_START) { // Output a sequence of chars.
              const seq = this.decodeTableSeq[SEQ_START - uCode];
              for (let k = 0; k < seq.length - 1; k++) {
                uCode = seq[k];
                newBuf[j++] = uCode & 0xFF;
                newBuf[j++] = uCode >> 8;
              }
              uCode = seq[seq.length - 1];
            } else throw new Error(`iconv-lite internal error: invalid decoding table value ${uCode} at ${nodeIdx}/${curByte}`);

            // Write the character to buffer, handling higher planes using surrogate pair.
            if (uCode >= 0x10000) {
              uCode -= 0x10000;
              const uCodeLead = 0xD800 | (uCode >> 10);
              newBuf[j++] = uCodeLead & 0xFF;
              newBuf[j++] = uCodeLead >> 8;

              uCode = 0xDC00 | (uCode & 0x3FF);
            }
            newBuf[j++] = uCode & 0xFF;
            newBuf[j++] = uCode >> 8;

            // Reset trie node.
            nodeIdx = 0; seqStart = i + 1;
          }

          this.nodeIdx = nodeIdx;
          this.prevBytes = (seqStart >= 0)
            ? Array.prototype.slice.call(buf, seqStart)
            : prevBytes.slice(seqStart + prevOffset).concat(Array.prototype.slice.call(buf));

          return newBuf.slice(0, j).toString('ucs2');
        };

        DBCSDecoder.prototype.end = function () {
          let ret = '';

          // Try to parse all remaining chars.
          while (this.prevBytes.length > 0) {
            // Skip 1 character in the buffer.
            ret += this.defaultCharUnicode;
            const bytesArr = this.prevBytes.slice(1);

            // Parse remaining as usual.
            this.prevBytes = [];
            this.nodeIdx = 0;
            if (bytesArr.length > 0) ret += this.write(bytesArr);
          }

          this.prevBytes = [];
          this.nodeIdx = 0;
          return ret;
        };

        // Binary search for GB18030. Returns largest i such that table[i] <= val.
        function findIdx(table, val) {
          if (table[0] > val) return -1;

          let l = 0; let
            r = table.length;
          while (l < r - 1) { // always table[l] <= val < table[r]
            const mid = l + ((r - l + 1) >> 1);
            if (table[mid] <= val) l = mid;
            else r = mid;
          }
          return l;
        }
        /***/ }),

      /***/ 5990:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        // Description of supported double byte encodings and aliases.
        // Tables are not require()-d until they are needed to speed up library load.
        // require()-s are direct to support Browserify.

        module.exports = {

          // == Japanese/ShiftJIS ====================================================
          // All japanese encodings are based on JIS X set of standards:
          // JIS X 0201 - Single-byte encoding of ASCII + ¥ + Kana chars at 0xA1-0xDF.
          // JIS X 0208 - Main set of 6879 characters, placed in 94x94 plane, to be encoded by 2 bytes.
          //              Has several variations in 1978, 1983, 1990 and 1997.
          // JIS X 0212 - Supplementary plane of 6067 chars in 94x94 plane. 1990. Effectively dead.
          // JIS X 0213 - Extension and modern replacement of 0208 and 0212. Total chars: 11233.
          //              2 planes, first is superset of 0208, second - revised 0212.
          //              Introduced in 2000, revised 2004. Some characters are in Unicode Plane 2 (0x2xxxx)

          // Byte encodings are:
          //  * Shift_JIS: Compatible with 0201, uses not defined chars in top half as lead bytes for double-byte
          //               encoding of 0208. Lead byte ranges: 0x81-0x9F, 0xE0-0xEF; Trail byte ranges: 0x40-0x7E, 0x80-0x9E, 0x9F-0xFC.
          //               Windows CP932 is a superset of Shift_JIS. Some companies added more chars, notably KDDI.
          //  * EUC-JP:    Up to 3 bytes per character. Used mostly on *nixes.
          //               0x00-0x7F       - lower part of 0201
          //               0x8E, 0xA1-0xDF - upper part of 0201
          //               (0xA1-0xFE)x2   - 0208 plane (94x94).
          //               0x8F, (0xA1-0xFE)x2 - 0212 plane (94x94).
          //  * JIS X 208: 7-bit, direct encoding of 0208. Byte ranges: 0x21-0x7E (94 values). Uncommon.
          //               Used as-is in ISO2022 family.
          //  * ISO2022-JP: Stateful encoding, with escape sequences to switch between ASCII,
          //                0201-1976 Roman, 0208-1978, 0208-1983.
          //  * ISO2022-JP-1: Adds esc seq for 0212-1990.
          //  * ISO2022-JP-2: Adds esc seq for GB2313-1980, KSX1001-1992, ISO8859-1, ISO8859-7.
          //  * ISO2022-JP-3: Adds esc seq for 0201-1976 Kana set, 0213-2000 Planes 1, 2.
          //  * ISO2022-JP-2004: Adds 0213-2004 Plane 1.
          //
          // After JIS X 0213 appeared, Shift_JIS-2004, EUC-JISX0213 and ISO2022-JP-2004 followed, with just changing the planes.
          //
          // Overall, it seems that it's a mess :( http://www8.plala.or.jp/tkubota1/unicode-symbols-map2.html

          shiftjis: {
            type: '_dbcs',
            table() { return __webpack_require__(7014); },
            encodeAdd: { '\u00a5': 0x5C, '\u203E': 0x7E },
            encodeSkipVals: [{ from: 0xED40, to: 0xF940 }],
          },
          csshiftjis: 'shiftjis',
          mskanji: 'shiftjis',
          sjis: 'shiftjis',
          windows31j: 'shiftjis',
          ms31j: 'shiftjis',
          xsjis: 'shiftjis',
          windows932: 'shiftjis',
          ms932: 'shiftjis',
          932: 'shiftjis',
          cp932: 'shiftjis',

          eucjp: {
            type: '_dbcs',
            table() { return __webpack_require__(5633); },
            encodeAdd: { '\u00a5': 0x5C, '\u203E': 0x7E },
          },

          // TODO: KDDI extension to Shift_JIS
          // TODO: IBM CCSID 942 = CP932, but F0-F9 custom chars and other char changes.
          // TODO: IBM CCSID 943 = Shift_JIS = CP932 with original Shift_JIS lower 128 chars.

          // == Chinese/GBK ==========================================================
          // http://en.wikipedia.org/wiki/GBK
          // We mostly implement W3C recommendation: https://www.w3.org/TR/encoding/#gbk-encoder

          // Oldest GB2312 (1981, ~7600 chars) is a subset of CP936
          gb2312: 'cp936',
          gb231280: 'cp936',
          gb23121980: 'cp936',
          csgb2312: 'cp936',
          csiso58gb231280: 'cp936',
          euccn: 'cp936',

          // Microsoft's CP936 is a subset and approximation of GBK.
          windows936: 'cp936',
          ms936: 'cp936',
          936: 'cp936',
          cp936: {
            type: '_dbcs',
            table() { return __webpack_require__(3336); },
          },

          // GBK (~22000 chars) is an extension of CP936 that added user-mapped chars and some other.
          gbk: {
            type: '_dbcs',
            table() { return (__webpack_require__(3336).concat)(__webpack_require__(4346)); },
          },
          xgbk: 'gbk',
          isoir58: 'gbk',

          // GB18030 is an algorithmic extension of GBK.
          // Main source: https://www.w3.org/TR/encoding/#gbk-encoder
          // http://icu-project.org/docs/papers/gb18030.html
          // http://source.icu-project.org/repos/icu/data/trunk/charset/data/xml/gb-18030-2000.xml
          // http://www.khngai.com/chinese/charmap/tblgbk.php?page=0
          gb18030: {
            type: '_dbcs',
            table() { return (__webpack_require__(3336).concat)(__webpack_require__(4346)); },
            gb18030() { return __webpack_require__(6258); },
            encodeSkipVals: [0x80],
            encodeAdd: { '€': 0xA2E3 },
          },

          chinese: 'gb18030',

          // == Korean ===============================================================
          // EUC-KR, KS_C_5601 and KS X 1001 are exactly the same.
          windows949: 'cp949',
          ms949: 'cp949',
          949: 'cp949',
          cp949: {
            type: '_dbcs',
            table() { return __webpack_require__(7348); },
          },

          cseuckr: 'cp949',
          csksc56011987: 'cp949',
          euckr: 'cp949',
          isoir149: 'cp949',
          korean: 'cp949',
          ksc56011987: 'cp949',
          ksc56011989: 'cp949',
          ksc5601: 'cp949',

          // == Big5/Taiwan/Hong Kong ================================================
          // There are lots of tables for Big5 and cp950. Please see the following links for history:
          // http://moztw.org/docs/big5/  http://www.haible.de/bruno/charsets/conversion-tables/Big5.html
          // Variations, in roughly number of defined chars:
          //  * Windows CP 950: Microsoft variant of Big5. Canonical: http://www.unicode.org/Public/MAPPINGS/VENDORS/MICSFT/WINDOWS/CP950.TXT
          //  * Windows CP 951: Microsoft variant of Big5-HKSCS-2001. Seems to be never public. http://me.abelcheung.org/articles/research/what-is-cp951/
          //  * Big5-2003 (Taiwan standard) almost superset of cp950.
          //  * Unicode-at-on (UAO) / Mozilla 1.8. Falling out of use on the Web. Not supported by other browsers.
          //  * Big5-HKSCS (-2001, -2004, -2008). Hong Kong standard.
          //    many unicode code points moved from PUA to Supplementary plane (U+2XXXX) over the years.
          //    Plus, it has 4 combining sequences.
          //    Seems that Mozilla refused to support it for 10 yrs. https://bugzilla.mozilla.org/show_bug.cgi?id=162431 https://bugzilla.mozilla.org/show_bug.cgi?id=310299
          //    because big5-hkscs is the only encoding to include astral characters in non-algorithmic way.
          //    Implementations are not consistent within browsers; sometimes labeled as just big5.
          //    MS Internet Explorer switches from big5 to big5-hkscs when a patch applied.
          //    Great discussion & recap of what's going on https://bugzilla.mozilla.org/show_bug.cgi?id=912470#c31
          //    In the encoder, it might make sense to support encoding old PUA mappings to Big5 bytes seq-s.
          //    Official spec: http://www.ogcio.gov.hk/en/business/tech_promotion/ccli/terms/doc/2003cmp_2008.txt
          //                   http://www.ogcio.gov.hk/tc/business/tech_promotion/ccli/terms/doc/hkscs-2008-big5-iso.txt
          //
          // Current understanding of how to deal with Big5(-HKSCS) is in the Encoding Standard, http://encoding.spec.whatwg.org/#big5-encoder
          // Unicode mapping (http://www.unicode.org/Public/MAPPINGS/OBSOLETE/EASTASIA/OTHER/BIG5.TXT) is said to be wrong.

          windows950: 'cp950',
          ms950: 'cp950',
          950: 'cp950',
          cp950: {
            type: '_dbcs',
            table() { return __webpack_require__(4284); },
          },

          // Big5 has many variations and is an extension of cp950. We use Encoding Standard's as a consensus.
          big5: 'big5hkscs',
          big5hkscs: {
            type: '_dbcs',
            table() { return (__webpack_require__(4284).concat)(__webpack_require__(3480)); },
            encodeSkipVals: [
            // Although Encoding Standard says we should avoid encoding to HKSCS area (See Step 1 of
            // https://encoding.spec.whatwg.org/#index-big5-pointer), we still do it to increase compatibility with ICU.
            // But if a single unicode point can be encoded both as HKSCS and regular Big5, we prefer the latter.
              0x8e69, 0x8e6f, 0x8e7e, 0x8eab, 0x8eb4, 0x8ecd, 0x8ed0, 0x8f57, 0x8f69, 0x8f6e, 0x8fcb, 0x8ffe,
              0x906d, 0x907a, 0x90c4, 0x90dc, 0x90f1, 0x91bf, 0x92af, 0x92b0, 0x92b1, 0x92b2, 0x92d1, 0x9447, 0x94ca,
              0x95d9, 0x96fc, 0x9975, 0x9b76, 0x9b78, 0x9b7b, 0x9bc6, 0x9bde, 0x9bec, 0x9bf6, 0x9c42, 0x9c53, 0x9c62,
              0x9c68, 0x9c6b, 0x9c77, 0x9cbc, 0x9cbd, 0x9cd0, 0x9d57, 0x9d5a, 0x9dc4, 0x9def, 0x9dfb, 0x9ea9, 0x9eef,
              0x9efd, 0x9f60, 0x9fcb, 0xa077, 0xa0dc, 0xa0df, 0x8fcc, 0x92c8, 0x9644, 0x96ed,

              // Step 2 of https://encoding.spec.whatwg.org/#index-big5-pointer: Use last pointer for U+2550, U+255E, U+2561, U+256A, U+5341, or U+5345
              0xa2a4, 0xa2a5, 0xa2a7, 0xa2a6, 0xa2cc, 0xa2ce,
            ],
          },

          cnbig5: 'big5hkscs',
          csbig5: 'big5hkscs',
          xxbig5: 'big5hkscs',
        };
        /***/ }),

      /***/ 6934:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        // Update this array if you add/rename/remove files in this directory.
        // We support Browserify by skipping automatic module discovery and requiring modules directly.
        const modules = [
          __webpack_require__(1025),
          __webpack_require__(7688),
          __webpack_require__(1279),
          __webpack_require__(758),
          __webpack_require__(9068),
          __webpack_require__(3769),
          __webpack_require__(7018),
          __webpack_require__(688),
          __webpack_require__(5990),
        ];

        // Put all encoding/alias/codec definitions to single object and export it.
        for (let i = 0; i < modules.length; i++) {
          const module = modules[i];
          for (const enc in module) if (Object.prototype.hasOwnProperty.call(module, enc)) exports[enc] = module[enc];
        }
        /***/ }),

      /***/ 1025:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const { Buffer } = __webpack_require__(7103);

        // Export Node.js internal encodings.

        module.exports = {
          // Encodings
          utf8: { type: '_internal', bomAware: true },
          cesu8: { type: '_internal', bomAware: true },
          unicode11utf8: 'utf8',

          ucs2: { type: '_internal', bomAware: true },
          utf16le: 'ucs2',

          binary: { type: '_internal' },
          base64: { type: '_internal' },
          hex: { type: '_internal' },

          // Codec.
          _internal: InternalCodec,
        };

        //------------------------------------------------------------------------------

        function InternalCodec(codecOptions, iconv) {
          this.enc = codecOptions.encodingName;
          this.bomAware = codecOptions.bomAware;

          if (this.enc === 'base64') this.encoder = InternalEncoderBase64;
          else if (this.enc === 'cesu8') {
            this.enc = 'utf8'; // Use utf8 for decoding.
            this.encoder = InternalEncoderCesu8;

            // Add decoder for versions of Node not supporting CESU-8
            if (Buffer.from('eda0bdedb2a9', 'hex').toString() !== '💩') {
              this.decoder = InternalDecoderCesu8;
              this.defaultCharUnicode = iconv.defaultCharUnicode;
            }
          }
        }

        InternalCodec.prototype.encoder = InternalEncoder;
        InternalCodec.prototype.decoder = InternalDecoder;

        //------------------------------------------------------------------------------

        // We use node.js internal decoder. Its signature is the same as ours.
        const StringDecoder = (__webpack_require__(2553).s);

        if (!StringDecoder.prototype.end) // Node v0.8 doesn't have this method.
        { StringDecoder.prototype.end = function () {}; }

        function InternalDecoder(options, codec) {
          this.decoder = new StringDecoder(codec.enc);
        }

        InternalDecoder.prototype.write = function (buf) {
          if (!Buffer.isBuffer(buf)) {
            buf = Buffer.from(buf);
          }

          return this.decoder.write(buf);
        };

        InternalDecoder.prototype.end = function () {
          return this.decoder.end();
        };

        //------------------------------------------------------------------------------
        // Encoder is mostly trivial

        function InternalEncoder(options, codec) {
          this.enc = codec.enc;
        }

        InternalEncoder.prototype.write = function (str) {
          return Buffer.from(str, this.enc);
        };

        InternalEncoder.prototype.end = function () {
        };

        //------------------------------------------------------------------------------
        // Except base64 encoder, which must keep its state.

        function InternalEncoderBase64(options, codec) {
          this.prevStr = '';
        }

        InternalEncoderBase64.prototype.write = function (str) {
          str = this.prevStr + str;
          const completeQuads = str.length - (str.length % 4);
          this.prevStr = str.slice(completeQuads);
          str = str.slice(0, completeQuads);

          return Buffer.from(str, 'base64');
        };

        InternalEncoderBase64.prototype.end = function () {
          return Buffer.from(this.prevStr, 'base64');
        };

        //------------------------------------------------------------------------------
        // CESU-8 encoder is also special.

        function InternalEncoderCesu8(options, codec) {
        }

        InternalEncoderCesu8.prototype.write = function (str) {
          const buf = Buffer.alloc(str.length * 3); let
            bufIdx = 0;
          for (let i = 0; i < str.length; i++) {
            const charCode = str.charCodeAt(i);
            // Naive implementation, but it works because CESU-8 is especially easy
            // to convert from UTF-16 (which all JS strings are encoded in).
            if (charCode < 0x80) buf[bufIdx++] = charCode;
            else if (charCode < 0x800) {
              buf[bufIdx++] = 0xC0 + (charCode >>> 6);
              buf[bufIdx++] = 0x80 + (charCode & 0x3f);
            } else { // charCode will always be < 0x10000 in javascript.
              buf[bufIdx++] = 0xE0 + (charCode >>> 12);
              buf[bufIdx++] = 0x80 + ((charCode >>> 6) & 0x3f);
              buf[bufIdx++] = 0x80 + (charCode & 0x3f);
            }
          }
          return buf.slice(0, bufIdx);
        };

        InternalEncoderCesu8.prototype.end = function () {
        };

        //------------------------------------------------------------------------------
        // CESU-8 decoder is not implemented in Node v4.0+

        function InternalDecoderCesu8(options, codec) {
          this.acc = 0;
          this.contBytes = 0;
          this.accBytes = 0;
          this.defaultCharUnicode = codec.defaultCharUnicode;
        }

        InternalDecoderCesu8.prototype.write = function (buf) {
          let { acc } = this;
          let { contBytes } = this;
          let { accBytes } = this;
          let res = '';
          for (let i = 0; i < buf.length; i++) {
            const curByte = buf[i];
            if ((curByte & 0xC0) !== 0x80) { // Leading byte
              if (contBytes > 0) { // Previous code is invalid
                res += this.defaultCharUnicode;
                contBytes = 0;
              }

              if (curByte < 0x80) { // Single-byte code
                res += String.fromCharCode(curByte);
              } else if (curByte < 0xE0) { // Two-byte code
                acc = curByte & 0x1F;
                contBytes = 1; accBytes = 1;
              } else if (curByte < 0xF0) { // Three-byte code
                acc = curByte & 0x0F;
                contBytes = 2; accBytes = 1;
              } else { // Four or more are not supported for CESU-8.
                res += this.defaultCharUnicode;
              }
            } else { // Continuation byte
              if (contBytes > 0) { // We're waiting for it.
                acc = (acc << 6) | (curByte & 0x3f);
                contBytes--; accBytes++;
                if (contBytes === 0) {
                  // Check for overlong encoding, but support Modified UTF-8 (encoding NULL as C0 80)
                  if (accBytes === 2 && acc < 0x80 && acc > 0) res += this.defaultCharUnicode;
                  else if (accBytes === 3 && acc < 0x800) res += this.defaultCharUnicode;
                  else
                  // Actually add character.
                  { res += String.fromCharCode(acc); }
                }
              } else { // Unexpected continuation byte
                res += this.defaultCharUnicode;
              }
            }
          }
          this.acc = acc; this.contBytes = contBytes; this.accBytes = accBytes;
          return res;
        };

        InternalDecoderCesu8.prototype.end = function () {
          let res = 0;
          if (this.contBytes > 0) res += this.defaultCharUnicode;
          return res;
        };
        /***/ }),

      /***/ 9068:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        const { Buffer } = __webpack_require__(7103);

        // Single-byte codec. Needs a 'chars' string parameter that contains 256 or 128 chars that
        // correspond to encoded bytes (if 128 - then lower half is ASCII).

        exports._sbcs = SBCSCodec;
        function SBCSCodec(codecOptions, iconv) {
          if (!codecOptions) throw new Error('SBCS codec is called without the data.');

          // Prepare char buffer for decoding.
          if (!codecOptions.chars || (codecOptions.chars.length !== 128 && codecOptions.chars.length !== 256)) throw new Error(`Encoding '${codecOptions.type}' has incorrect 'chars' (must be of len 128 or 256)`);

          if (codecOptions.chars.length === 128) {
            let asciiString = '';
            for (var i = 0; i < 128; i++) asciiString += String.fromCharCode(i);
            codecOptions.chars = asciiString + codecOptions.chars;
          }

          this.decodeBuf = Buffer.from(codecOptions.chars, 'ucs2');

          // Encoding buffer.
          const encodeBuf = Buffer.alloc(65536, iconv.defaultCharSingleByte.charCodeAt(0));

          for (var i = 0; i < codecOptions.chars.length; i++) encodeBuf[codecOptions.chars.charCodeAt(i)] = i;

          this.encodeBuf = encodeBuf;
        }

        SBCSCodec.prototype.encoder = SBCSEncoder;
        SBCSCodec.prototype.decoder = SBCSDecoder;

        function SBCSEncoder(options, codec) {
          this.encodeBuf = codec.encodeBuf;
        }

        SBCSEncoder.prototype.write = function (str) {
          const buf = Buffer.alloc(str.length);
          for (let i = 0; i < str.length; i++) buf[i] = this.encodeBuf[str.charCodeAt(i)];

          return buf;
        };

        SBCSEncoder.prototype.end = function () {
        };

        function SBCSDecoder(options, codec) {
          this.decodeBuf = codec.decodeBuf;
        }

        SBCSDecoder.prototype.write = function (buf) {
          // Strings are immutable in JS -> we use ucs2 buffer to speed up computations.
          const { decodeBuf } = this;
          const newBuf = Buffer.alloc(buf.length * 2);
          let idx1 = 0; let
            idx2 = 0;
          for (let i = 0; i < buf.length; i++) {
            idx1 = buf[i] * 2; idx2 = i * 2;
            newBuf[idx2] = decodeBuf[idx1];
            newBuf[idx2 + 1] = decodeBuf[idx1 + 1];
          }
          return newBuf.toString('ucs2');
        };

        SBCSDecoder.prototype.end = function () {
        };
        /***/ }),

      /***/ 7018:
      /***/ (function (module) {
        // Generated data for sbcs codec. Don't edit manually. Regenerate using generation/gen-sbcs.js script.
        module.exports = {
          437: 'cp437',
          737: 'cp737',
          775: 'cp775',
          850: 'cp850',
          852: 'cp852',
          855: 'cp855',
          856: 'cp856',
          857: 'cp857',
          858: 'cp858',
          860: 'cp860',
          861: 'cp861',
          862: 'cp862',
          863: 'cp863',
          864: 'cp864',
          865: 'cp865',
          866: 'cp866',
          869: 'cp869',
          874: 'windows874',
          922: 'cp922',
          1046: 'cp1046',
          1124: 'cp1124',
          1125: 'cp1125',
          1129: 'cp1129',
          1133: 'cp1133',
          1161: 'cp1161',
          1162: 'cp1162',
          1163: 'cp1163',
          1250: 'windows1250',
          1251: 'windows1251',
          1252: 'windows1252',
          1253: 'windows1253',
          1254: 'windows1254',
          1255: 'windows1255',
          1256: 'windows1256',
          1257: 'windows1257',
          1258: 'windows1258',
          28591: 'iso88591',
          28592: 'iso88592',
          28593: 'iso88593',
          28594: 'iso88594',
          28595: 'iso88595',
          28596: 'iso88596',
          28597: 'iso88597',
          28598: 'iso88598',
          28599: 'iso88599',
          28600: 'iso885910',
          28601: 'iso885911',
          28603: 'iso885913',
          28604: 'iso885914',
          28605: 'iso885915',
          28606: 'iso885916',
          windows874: {
            type: '_sbcs',
            chars: '€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����',
          },
          win874: 'windows874',
          cp874: 'windows874',
          windows1250: {
            type: '_sbcs',
            chars: '€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙',
          },
          win1250: 'windows1250',
          cp1250: 'windows1250',
          windows1251: {
            type: '_sbcs',
            chars: 'ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя',
          },
          win1251: 'windows1251',
          cp1251: 'windows1251',
          windows1252: {
            type: '_sbcs',
            chars: '€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ',
          },
          win1252: 'windows1252',
          cp1252: 'windows1252',
          windows1253: {
            type: '_sbcs',
            chars: '€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�',
          },
          win1253: 'windows1253',
          cp1253: 'windows1253',
          windows1254: {
            type: '_sbcs',
            chars: '€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ',
          },
          win1254: 'windows1254',
          cp1254: 'windows1254',
          windows1255: {
            type: '_sbcs',
            chars: '€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹֺֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�',
          },
          win1255: 'windows1255',
          cp1255: 'windows1255',
          windows1256: {
            type: '_sbcs',
            chars: '€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے',
          },
          win1256: 'windows1256',
          cp1256: 'windows1256',
          windows1257: {
            type: '_sbcs',
            chars: '€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙',
          },
          win1257: 'windows1257',
          cp1257: 'windows1257',
          windows1258: {
            type: '_sbcs',
            chars: '€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ',
          },
          win1258: 'windows1258',
          cp1258: 'windows1258',
          iso88591: {
            type: '_sbcs',
            chars: ' ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ',
          },
          cp28591: 'iso88591',
          iso88592: {
            type: '_sbcs',
            chars: ' Ą˘Ł¤ĽŚ§¨ŠŞŤŹ­ŽŻ°ą˛ł´ľśˇ¸šşťź˝žżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙',
          },
          cp28592: 'iso88592',
          iso88593: {
            type: '_sbcs',
            chars: ' Ħ˘£¤�Ĥ§¨İŞĞĴ­�Ż°ħ²³´µĥ·¸ışğĵ½�żÀÁÂ�ÄĊĈÇÈÉÊËÌÍÎÏ�ÑÒÓÔĠÖ×ĜÙÚÛÜŬŜßàáâ�äċĉçèéêëìíîï�ñòóôġö÷ĝùúûüŭŝ˙',
          },
          cp28593: 'iso88593',
          iso88594: {
            type: '_sbcs',
            chars: ' ĄĸŖ¤ĨĻ§¨ŠĒĢŦ­Ž¯°ą˛ŗ´ĩļˇ¸šēģŧŊžŋĀÁÂÃÄÅÆĮČÉĘËĖÍÎĪĐŅŌĶÔÕÖ×ØŲÚÛÜŨŪßāáâãäåæįčéęëėíîīđņōķôõö÷øųúûüũū˙',
          },
          cp28594: 'iso88594',
          iso88595: {
            type: '_sbcs',
            chars: ' ЁЂЃЄЅІЇЈЉЊЋЌ­ЎЏАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя№ёђѓєѕіїјљњћќ§ўџ',
          },
          cp28595: 'iso88595',
          iso88596: {
            type: '_sbcs',
            chars: ' ���¤�������،­�������������؛���؟�ءآأؤإئابةتثجحخدذرزسشصضطظعغ�����ـفقكلمنهوىيًٌٍَُِّْ�������������',
          },
          cp28596: 'iso88596',
          iso88597: {
            type: '_sbcs',
            chars: ' ‘’£€₯¦§¨©ͺ«¬­�―°±²³΄΅Ά·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�',
          },
          cp28597: 'iso88597',
          iso88598: {
            type: '_sbcs',
            chars: ' �¢£¤¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾��������������������������������‗אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�',
          },
          cp28598: 'iso88598',
          iso88599: {
            type: '_sbcs',
            chars: ' ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ',
          },
          cp28599: 'iso88599',
          iso885910: {
            type: '_sbcs',
            chars: ' ĄĒĢĪĨĶ§ĻĐŠŦŽ­ŪŊ°ąēģīĩķ·ļđšŧž―ūŋĀÁÂÃÄÅÆĮČÉĘËĖÍÎÏÐŅŌÓÔÕÖŨØŲÚÛÜÝÞßāáâãäåæįčéęëėíîïðņōóôõöũøųúûüýþĸ',
          },
          cp28600: 'iso885910',
          iso885911: {
            type: '_sbcs',
            chars: ' กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����',
          },
          cp28601: 'iso885911',
          iso885913: {
            type: '_sbcs',
            chars: ' ”¢£¤„¦§Ø©Ŗ«¬­®Æ°±²³“µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž’',
          },
          cp28603: 'iso885913',
          iso885914: {
            type: '_sbcs',
            chars: ' Ḃḃ£ĊċḊ§Ẁ©ẂḋỲ­®ŸḞḟĠġṀṁ¶ṖẁṗẃṠỳẄẅṡÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏŴÑÒÓÔÕÖṪØÙÚÛÜÝŶßàáâãäåæçèéêëìíîïŵñòóôõöṫøùúûüýŷÿ',
          },
          cp28604: 'iso885914',
          iso885915: {
            type: '_sbcs',
            chars: ' ¡¢£€¥Š§š©ª«¬­®¯°±²³Žµ¶·ž¹º»ŒœŸ¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ',
          },
          cp28605: 'iso885915',
          iso885916: {
            type: '_sbcs',
            chars: ' ĄąŁ€„Š§š©Ș«Ź­źŻ°±ČłŽ”¶·žčș»ŒœŸżÀÁÂĂÄĆÆÇÈÉÊËÌÍÎÏĐŃÒÓÔŐÖŚŰÙÚÛÜĘȚßàáâăäćæçèéêëìíîïđńòóôőöśűùúûüęțÿ',
          },
          cp28606: 'iso885916',
          cp437: {
            type: '_sbcs',
            chars: 'ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ',
          },
          ibm437: 'cp437',
          csibm437: 'cp437',
          cp737: {
            type: '_sbcs',
            chars: 'ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ ',
          },
          ibm737: 'cp737',
          csibm737: 'cp737',
          cp775: {
            type: '_sbcs',
            chars: 'ĆüéāäģåćłēŖŗīŹÄÅÉæÆōöĢ¢ŚśÖÜø£Ø×¤ĀĪóŻżź”¦©®¬½¼Ł«»░▒▓│┤ĄČĘĖ╣║╗╝ĮŠ┐└┴┬├─┼ŲŪ╚╔╩╦╠═╬Žąčęėįšųūž┘┌█▄▌▐▀ÓßŌŃõÕµńĶķĻļņĒŅ’­±“¾¶§÷„°∙·¹³²■ ',
          },
          ibm775: 'cp775',
          csibm775: 'cp775',
          cp850: {
            type: '_sbcs',
            chars: 'ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ ',
          },
          ibm850: 'cp850',
          csibm850: 'cp850',
          cp852: {
            type: '_sbcs',
            chars: 'ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ ',
          },
          ibm852: 'cp852',
          csibm852: 'cp852',
          cp855: {
            type: '_sbcs',
            chars: 'ђЂѓЃёЁєЄѕЅіІїЇјЈљЉњЊћЋќЌўЎџЏюЮъЪаАбБцЦдДеЕфФгГ«»░▒▓│┤хХиИ╣║╗╝йЙ┐└┴┬├─┼кК╚╔╩╦╠═╬¤лЛмМнНоОп┘┌█▄Пя▀ЯрРсСтТуУжЖвВьЬ№­ыЫзЗшШэЭщЩчЧ§■ ',
          },
          ibm855: 'cp855',
          csibm855: 'cp855',
          cp856: {
            type: '_sbcs',
            chars: 'אבגדהוזחטיךכלםמןנסעףפץצקרשת�£�×����������®¬½¼�«»░▒▓│┤���©╣║╗╝¢¥┐└┴┬├─┼��╚╔╩╦╠═╬¤���������┘┌█▄¦�▀������µ�������¯´­±‗¾¶§÷¸°¨·¹³²■ ',
          },
          ibm856: 'cp856',
          csibm856: 'cp856',
          cp857: {
            type: '_sbcs',
            chars: 'ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ ',
          },
          ibm857: 'cp857',
          csibm857: 'cp857',
          cp858: {
            type: '_sbcs',
            chars: 'ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈ€ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ ',
          },
          ibm858: 'cp858',
          csibm858: 'cp858',
          cp860: {
            type: '_sbcs',
            chars: 'ÇüéâãàÁçêÊèÍÔìÃÂÉÀÈôõòÚùÌÕÜ¢£Ù₧ÓáíóúñÑªº¿Ò¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ',
          },
          ibm860: 'cp860',
          csibm860: 'cp860',
          cp861: {
            type: '_sbcs',
            chars: 'ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ',
          },
          ibm861: 'cp861',
          csibm861: 'cp861',
          cp862: {
            type: '_sbcs',
            chars: 'אבגדהוזחטיךכלםמןנסעףפץצקרשת¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ',
          },
          ibm862: 'cp862',
          csibm862: 'cp862',
          cp863: {
            type: '_sbcs',
            chars: 'ÇüéâÂà¶çêëèïî‗À§ÉÈÊôËÏûù¤ÔÜ¢£ÙÛƒ¦´óú¨¸³¯Î⌐¬½¼¾«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ',
          },
          ibm863: 'cp863',
          csibm863: 'cp863',
          cp864: {
            type: '_sbcs',
            chars: "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$٪&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~°·∙√▒─│┼┤┬├┴┐┌└┘β∞φ±½¼≈«»ﻷﻸ��ﻻﻼ� ­ﺂ£¤ﺄ��ﺎﺏﺕﺙ،ﺝﺡﺥ٠١٢٣٤٥٦٧٨٩ﻑ؛ﺱﺵﺹ؟¢ﺀﺁﺃﺅﻊﺋﺍﺑﺓﺗﺛﺟﺣﺧﺩﺫﺭﺯﺳﺷﺻﺿﻁﻅﻋﻏ¦¬÷×ﻉـﻓﻗﻛﻟﻣﻧﻫﻭﻯﻳﺽﻌﻎﻍﻡﹽّﻥﻩﻬﻰﻲﻐﻕﻵﻶﻝﻙﻱ■�",
          },
          ibm864: 'cp864',
          csibm864: 'cp864',
          cp865: {
            type: '_sbcs',
            chars: 'ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ',
          },
          ibm865: 'cp865',
          csibm865: 'cp865',
          cp866: {
            type: '_sbcs',
            chars: 'АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ ',
          },
          ibm866: 'cp866',
          csibm866: 'cp866',
          cp869: {
            type: '_sbcs',
            chars: '������Ά�·¬¦‘’Έ―ΉΊΪΌ��ΎΫ©Ώ²³ά£έήίϊΐόύΑΒΓΔΕΖΗ½ΘΙ«»░▒▓│┤ΚΛΜΝ╣║╗╝ΞΟ┐└┴┬├─┼ΠΡ╚╔╩╦╠═╬ΣΤΥΦΧΨΩαβγ┘┌█▄δε▀ζηθικλμνξοπρσςτ΄­±υφχ§ψ΅°¨ωϋΰώ■ ',
          },
          ibm869: 'cp869',
          csibm869: 'cp869',
          cp922: {
            type: '_sbcs',
            chars: ' ¡¢£¤¥¦§¨©ª«¬­®‾°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏŠÑÒÓÔÕÖ×ØÙÚÛÜÝŽßàáâãäåæçèéêëìíîïšñòóôõö÷øùúûüýžÿ',
          },
          ibm922: 'cp922',
          csibm922: 'cp922',
          cp1046: {
            type: '_sbcs',
            chars: 'ﺈ×÷ﹱ■│─┐┌└┘ﹹﹻﹽﹿﹷﺊﻰﻳﻲﻎﻏﻐﻶﻸﻺﻼ ¤ﺋﺑﺗﺛﺟﺣ،­ﺧﺳ٠١٢٣٤٥٦٧٨٩ﺷ؛ﺻﺿﻊ؟ﻋءآأؤإئابةتثجحخدذرزسشصضطﻇعغﻌﺂﺄﺎﻓـفقكلمنهوىيًٌٍَُِّْﻗﻛﻟﻵﻷﻹﻻﻣﻧﻬﻩ�',
          },
          ibm1046: 'cp1046',
          csibm1046: 'cp1046',
          cp1124: {
            type: '_sbcs',
            chars: ' ЁЂҐЄЅІЇЈЉЊЋЌ­ЎЏАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя№ёђґєѕіїјљњћќ§ўџ',
          },
          ibm1124: 'cp1124',
          csibm1124: 'cp1124',
          cp1125: {
            type: '_sbcs',
            chars: 'АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёҐґЄєІіЇї·√№¤■ ',
          },
          ibm1125: 'cp1125',
          csibm1125: 'cp1125',
          cp1129: {
            type: '_sbcs',
            chars: ' ¡¢£¤¥¦§œ©ª«¬­®¯°±²³Ÿµ¶·Œ¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ',
          },
          ibm1129: 'cp1129',
          csibm1129: 'cp1129',
          cp1133: {
            type: '_sbcs',
            chars: ' ກຂຄງຈສຊຍດຕຖທນບປຜຝພຟມຢຣລວຫອຮ���ຯະາຳິີຶືຸູຼັົຽ���ເແໂໃໄ່້໊໋໌ໍໆ�ໜໝ₭����������������໐໑໒໓໔໕໖໗໘໙��¢¬¦�',
          },
          ibm1133: 'cp1133',
          csibm1133: 'cp1133',
          cp1161: {
            type: '_sbcs',
            chars: '��������������������������������่กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู้๊๋€฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛¢¬¦ ',
          },
          ibm1161: 'cp1161',
          csibm1161: 'cp1161',
          cp1162: {
            type: '_sbcs',
            chars: '€…‘’“”•–— กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����',
          },
          ibm1162: 'cp1162',
          csibm1162: 'cp1162',
          cp1163: {
            type: '_sbcs',
            chars: ' ¡¢£€¥¦§œ©ª«¬­®¯°±²³Ÿµ¶·Œ¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ',
          },
          ibm1163: 'cp1163',
          csibm1163: 'cp1163',
          maccroatian: {
            type: '_sbcs',
            chars: 'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®Š™´¨≠ŽØ∞±≤≥∆µ∂∑∏š∫ªºΩžø¿¡¬√ƒ≈Ć«Č… ÀÃÕŒœĐ—“”‘’÷◊�©⁄¤‹›Æ»–·‚„‰ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ˜¯πË˚¸Êæˇ',
          },
          maccyrillic: {
            type: '_sbcs',
            chars: 'АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤',
          },
          macgreek: {
            type: '_sbcs',
            chars: 'Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�',
          },
          maciceland: {
            type: '_sbcs',
            chars: 'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ',
          },
          macroman: {
            type: '_sbcs',
            chars: 'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ',
          },
          macromania: {
            type: '_sbcs',
            chars: 'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ĂŞ∞±≤≥¥µ∂∑∏π∫ªºΩăş¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›Ţţ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ',
          },
          macthai: {
            type: '_sbcs',
            chars: '«»…“”�•‘’� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู﻿​–—฿เแโใไๅๆ็่้๊๋์ํ™๏๐๑๒๓๔๕๖๗๘๙®©����',
          },
          macturkish: {
            type: '_sbcs',
            chars: 'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ',
          },
          macukraine: {
            type: '_sbcs',
            chars: 'АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°Ґ£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµґЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤',
          },
          koi8r: {
            type: '_sbcs',
            chars: '─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ё╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡Ё╢╣╤╥╦╧╨╩╪╫╬©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ',
          },
          koi8u: {
            type: '_sbcs',
            chars: '─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ёє╔ії╗╘╙╚╛ґ╝╞╟╠╡ЁЄ╣ІЇ╦╧╨╩╪Ґ╬©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ',
          },
          koi8ru: {
            type: '_sbcs',
            chars: '─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ёє╔ії╗╘╙╚╛ґў╞╟╠╡ЁЄ╣ІЇ╦╧╨╩╪ҐЎ©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ',
          },
          koi8t: {
            type: '_sbcs',
            chars: 'қғ‚Ғ„…†‡�‰ҳ‹ҲҷҶ�Қ‘’“”•–—�™�›�����ӯӮё¤ӣ¦§���«¬­®�°±²Ё�Ӣ¶·�№�»���©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ',
          },
          armscii8: {
            type: '_sbcs',
            chars: ' �և։)(»«—.՝,-֊…՜՛՞ԱաԲբԳգԴդԵեԶզԷէԸըԹթԺժԻիԼլԽխԾծԿկՀհՁձՂղՃճՄմՅյՆնՇշՈոՉչՊպՋջՌռՍսՎվՏտՐրՑցՒւՓփՔքՕօՖֆ՚�',
          },
          rk1048: {
            type: '_sbcs',
            chars: 'ЂЃ‚ѓ„…†‡€‰Љ‹ЊҚҺЏђ‘’“”•–—�™љ›њқһџ ҰұӘ¤Ө¦§Ё©Ғ«¬­®Ү°±Ііөµ¶·ё№ғ»әҢңүАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя',
          },
          tcvn: {
            type: '_sbcs',
            chars: "\u0000ÚỤ\u0003ỪỬỮ\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010ỨỰỲỶỸÝỴ\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÀẢÃÁẠẶẬÈẺẼÉẸỆÌỈĨÍỊÒỎÕÓỌỘỜỞỠỚỢÙỦŨ ĂÂÊÔƠƯĐăâêôơưđẶ̀̀̉̃́àảãáạẲằẳẵắẴẮẦẨẪẤỀặầẩẫấậèỂẻẽéẹềểễếệìỉỄẾỒĩíịòỔỏõóọồổỗốộờởỡớợùỖủũúụừửữứựỳỷỹýỵỐ",
          },
          georgianacademy: {
            type: '_sbcs',
            chars: '‚ƒ„…†‡ˆ‰Š‹Œ‘’“”•–—˜™š›œŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿აბგდევზთიკლმნოპჟრსტუფქღყშჩცძწჭხჯჰჱჲჳჴჵჶçèéêëìíîïðñòóôõö÷øùúûüýþÿ',
          },
          georgianps: {
            type: '_sbcs',
            chars: '‚ƒ„…†‡ˆ‰Š‹Œ‘’“”•–—˜™š›œŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿აბგდევზჱთიკლმნჲოპჟრსტჳუფქღყშჩცძწჭხჴჯჰჵæçèéêëìíîïðñòóôõö÷øùúûüýþÿ',
          },
          pt154: {
            type: '_sbcs',
            chars: 'ҖҒӮғ„…ҶҮҲүҠӢҢҚҺҸҗ‘’“”•–—ҳҷҡӣңқһҹ ЎўЈӨҘҰ§Ё©Ә«¬ӯ®Ҝ°ұІіҙө¶·ё№ә»јҪҫҝАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя',
          },
          viscii: {
            type: '_sbcs',
            chars: "\u0000\u0001Ẳ\u0003\u0004ẴẪ\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013Ỷ\u0015\u0016\u0017\u0018Ỹ\u001a\u001b\u001c\u001dỴ\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ẠẮẰẶẤẦẨẬẼẸẾỀỂỄỆỐỒỔỖỘỢỚỜỞỊỎỌỈỦŨỤỲÕắằặấầẩậẽẹếềểễệốồổỗỠƠộờởịỰỨỪỬơớƯÀÁÂÃẢĂẳẵÈÉÊẺÌÍĨỳĐứÒÓÔạỷừửÙÚỹỵÝỡưàáâãảăữẫèéêẻìíĩỉđựòóôõỏọụùúũủýợỮ",
          },
          iso646cn: {
            type: '_sbcs',
            chars: "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#¥%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}‾��������������������������������������������������������������������������������������������������������������������������������",
          },
          iso646jp: {
            type: '_sbcs',
            chars: "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[¥]^_`abcdefghijklmnopqrstuvwxyz{|}‾��������������������������������������������������������������������������������������������������������������������������������",
          },
          hproman8: {
            type: '_sbcs',
            chars: ' ÀÂÈÊËÎÏ´ˋˆ¨˜ÙÛ₤¯Ýý°ÇçÑñ¡¿¤£¥§ƒ¢âêôûáéóúàèòùäëöüÅîØÆåíøæÄìÖÜÉïßÔÁÃãÐðÍÌÓÒÕõŠšÚŸÿÞþ·µ¶¾—¼½ªº«■»±�',
          },
          macintosh: {
            type: '_sbcs',
            chars: 'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ',
          },
          ascii: {
            type: '_sbcs',
            chars: '��������������������������������������������������������������������������������������������������������������������������������',
          },
          tis620: {
            type: '_sbcs',
            chars: '���������������������������������กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����',
          },
        };
        /***/ }),

      /***/ 3769:
      /***/ (function (module) {
        // Manually added data to be used by sbcs codec in addition to generated one.

        module.exports = {
          // Not supported by iconv, not sure why.
          10029: 'maccenteuro',
          maccenteuro: {
            type: '_sbcs',
            chars: 'ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ',
          },

          808: 'cp808',
          ibm808: 'cp808',
          cp808: {
            type: '_sbcs',
            chars: 'АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№€■ ',
          },

          mik: {
            type: '_sbcs',
            chars: 'АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя└┴┬├─┼╣║╚╔╩╦╠═╬┐░▒▓│┤№§╗╝┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ',
          },

          cp720: {
            type: '_sbcs',
            chars: '\x80\x81éâ\x84à\x86çêëèïî\x8d\x8e\x8f\x90\u0651\u0652ô¤ـûùءآأؤ£إئابةتثجحخدذرزسشص«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ضطظعغفµقكلمنهوىي≡\u064b\u064c\u064d\u064e\u064f\u0650≈°∙·√ⁿ²■\u00a0',
          },

          // Aliases of generated encodings.
          ascii8bit: 'ascii',
          usascii: 'ascii',
          ansix34: 'ascii',
          ansix341968: 'ascii',
          ansix341986: 'ascii',
          csascii: 'ascii',
          cp367: 'ascii',
          ibm367: 'ascii',
          isoir6: 'ascii',
          iso646us: 'ascii',
          iso646irv: 'ascii',
          us: 'ascii',

          latin1: 'iso88591',
          latin2: 'iso88592',
          latin3: 'iso88593',
          latin4: 'iso88594',
          latin5: 'iso88599',
          latin6: 'iso885910',
          latin7: 'iso885913',
          latin8: 'iso885914',
          latin9: 'iso885915',
          latin10: 'iso885916',

          csisolatin1: 'iso88591',
          csisolatin2: 'iso88592',
          csisolatin3: 'iso88593',
          csisolatin4: 'iso88594',
          csisolatincyrillic: 'iso88595',
          csisolatinarabic: 'iso88596',
          csisolatingreek: 'iso88597',
          csisolatinhebrew: 'iso88598',
          csisolatin5: 'iso88599',
          csisolatin6: 'iso885910',

          l1: 'iso88591',
          l2: 'iso88592',
          l3: 'iso88593',
          l4: 'iso88594',
          l5: 'iso88599',
          l6: 'iso885910',
          l7: 'iso885913',
          l8: 'iso885914',
          l9: 'iso885915',
          l10: 'iso885916',

          isoir14: 'iso646jp',
          isoir57: 'iso646cn',
          isoir100: 'iso88591',
          isoir101: 'iso88592',
          isoir109: 'iso88593',
          isoir110: 'iso88594',
          isoir144: 'iso88595',
          isoir127: 'iso88596',
          isoir126: 'iso88597',
          isoir138: 'iso88598',
          isoir148: 'iso88599',
          isoir157: 'iso885910',
          isoir166: 'tis620',
          isoir179: 'iso885913',
          isoir199: 'iso885914',
          isoir203: 'iso885915',
          isoir226: 'iso885916',

          cp819: 'iso88591',
          ibm819: 'iso88591',

          cyrillic: 'iso88595',

          arabic: 'iso88596',
          arabic8: 'iso88596',
          ecma114: 'iso88596',
          asmo708: 'iso88596',

          greek: 'iso88597',
          greek8: 'iso88597',
          ecma118: 'iso88597',
          elot928: 'iso88597',

          hebrew: 'iso88598',
          hebrew8: 'iso88598',

          turkish: 'iso88599',
          turkish8: 'iso88599',

          thai: 'iso885911',
          thai8: 'iso885911',

          celtic: 'iso885914',
          celtic8: 'iso885914',
          isoceltic: 'iso885914',

          tis6200: 'tis620',
          tis62025291: 'tis620',
          tis62025330: 'tis620',

          10000: 'macroman',
          10006: 'macgreek',
          10007: 'maccyrillic',
          10079: 'maciceland',
          10081: 'macturkish',

          cspc8codepage437: 'cp437',
          cspc775baltic: 'cp775',
          cspc850multilingual: 'cp850',
          cspcp852: 'cp852',
          cspc862latinhebrew: 'cp862',
          cpgr: 'cp869',

          msee: 'cp1250',
          mscyrl: 'cp1251',
          msansi: 'cp1252',
          msgreek: 'cp1253',
          msturk: 'cp1254',
          mshebr: 'cp1255',
          msarab: 'cp1256',
          winbaltrim: 'cp1257',

          cp20866: 'koi8r',
          20866: 'koi8r',
          ibm878: 'koi8r',
          cskoi8r: 'koi8r',

          cp21866: 'koi8u',
          21866: 'koi8u',
          ibm1168: 'koi8u',

          strk10482002: 'rk1048',

          tcvn5712: 'tcvn',
          tcvn57121: 'tcvn',

          gb198880: 'iso646cn',
          cn: 'iso646cn',

          csiso14jisc6220ro: 'iso646jp',
          jisc62201969ro: 'iso646jp',
          jp: 'iso646jp',

          cshproman8: 'hproman8',
          r8: 'hproman8',
          roman8: 'hproman8',
          xroman8: 'hproman8',
          ibm1051: 'hproman8',

          mac: 'macintosh',
          csmacintosh: 'macintosh',
        };
        /***/ }),

      /***/ 1279:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        const { Buffer } = __webpack_require__(7103);

        // Note: UTF16-LE (or UCS2) codec is Node.js native. See encodings/internal.js

        // == UTF16-BE codec. ==========================================================

        exports.utf16be = Utf16BECodec;
        function Utf16BECodec() {
        }

        Utf16BECodec.prototype.encoder = Utf16BEEncoder;
        Utf16BECodec.prototype.decoder = Utf16BEDecoder;
        Utf16BECodec.prototype.bomAware = true;

        // -- Encoding

        function Utf16BEEncoder() {
        }

        Utf16BEEncoder.prototype.write = function (str) {
          const buf = Buffer.from(str, 'ucs2');
          for (let i = 0; i < buf.length; i += 2) {
            const tmp = buf[i]; buf[i] = buf[i + 1]; buf[i + 1] = tmp;
          }
          return buf;
        };

        Utf16BEEncoder.prototype.end = function () {
        };

        // -- Decoding

        function Utf16BEDecoder() {
          this.overflowByte = -1;
        }

        Utf16BEDecoder.prototype.write = function (buf) {
          if (buf.length == 0) return '';

          const buf2 = Buffer.alloc(buf.length + 1);
          let i = 0; let
            j = 0;

          if (this.overflowByte !== -1) {
            buf2[0] = buf[0];
            buf2[1] = this.overflowByte;
            i = 1; j = 2;
          }

          for (; i < buf.length - 1; i += 2, j += 2) {
            buf2[j] = buf[i + 1];
            buf2[j + 1] = buf[i];
          }

          this.overflowByte = (i == buf.length - 1) ? buf[buf.length - 1] : -1;

          return buf2.slice(0, j).toString('ucs2');
        };

        Utf16BEDecoder.prototype.end = function () {
          this.overflowByte = -1;
        };

        // == UTF-16 codec =============================================================
        // Decoder chooses automatically from UTF-16LE and UTF-16BE using BOM and space-based heuristic.
        // Defaults to UTF-16LE, as it's prevalent and default in Node.
        // http://en.wikipedia.org/wiki/UTF-16 and http://encoding.spec.whatwg.org/#utf-16le
        // Decoder default can be changed: iconv.decode(buf, 'utf16', {defaultEncoding: 'utf-16be'});

        // Encoder uses UTF-16LE and prepends BOM (which can be overridden with addBOM: false).

        exports.utf16 = Utf16Codec;
        function Utf16Codec(codecOptions, iconv) {
          this.iconv = iconv;
        }

        Utf16Codec.prototype.encoder = Utf16Encoder;
        Utf16Codec.prototype.decoder = Utf16Decoder;

        // -- Encoding (pass-through)

        function Utf16Encoder(options, codec) {
          options = options || {};
          if (options.addBOM === undefined) options.addBOM = true;
          this.encoder = codec.iconv.getEncoder('utf-16le', options);
        }

        Utf16Encoder.prototype.write = function (str) {
          return this.encoder.write(str);
        };

        Utf16Encoder.prototype.end = function () {
          return this.encoder.end();
        };

        // -- Decoding

        function Utf16Decoder(options, codec) {
          this.decoder = null;
          this.initialBufs = [];
          this.initialBufsLen = 0;

          this.options = options || {};
          this.iconv = codec.iconv;
        }

        Utf16Decoder.prototype.write = function (buf) {
          if (!this.decoder) {
            // Codec is not chosen yet. Accumulate initial bytes.
            this.initialBufs.push(buf);
            this.initialBufsLen += buf.length;

            if (this.initialBufsLen < 16) // We need more bytes to use space heuristic (see below)
            { return ''; }

            // We have enough bytes -> detect endianness.
            const encoding = detectEncoding(this.initialBufs, this.options.defaultEncoding);
            this.decoder = this.iconv.getDecoder(encoding, this.options);

            let resStr = '';
            for (let i = 0; i < this.initialBufs.length; i++) resStr += this.decoder.write(this.initialBufs[i]);

            this.initialBufs.length = this.initialBufsLen = 0;
            return resStr;
          }

          return this.decoder.write(buf);
        };

        Utf16Decoder.prototype.end = function () {
          if (!this.decoder) {
            const encoding = detectEncoding(this.initialBufs, this.options.defaultEncoding);
            this.decoder = this.iconv.getDecoder(encoding, this.options);

            let resStr = '';
            for (let i = 0; i < this.initialBufs.length; i++) resStr += this.decoder.write(this.initialBufs[i]);

            const trail = this.decoder.end();
            if (trail) resStr += trail;

            this.initialBufs.length = this.initialBufsLen = 0;
            return resStr;
          }
          return this.decoder.end();
        };

        function detectEncoding(bufs, defaultEncoding) {
          const b = [];
          let charsProcessed = 0;
          let asciiCharsLE = 0; let
            asciiCharsBE = 0; // Number of ASCII chars when decoded as LE or BE.

          outer_loop:
          for (let i = 0; i < bufs.length; i++) {
            const buf = bufs[i];
            for (let j = 0; j < buf.length; j++) {
              b.push(buf[j]);
              if (b.length === 2) {
                if (charsProcessed === 0) {
                  // Check BOM first.
                  if (b[0] === 0xFF && b[1] === 0xFE) return 'utf-16le';
                  if (b[0] === 0xFE && b[1] === 0xFF) return 'utf-16be';
                }

                if (b[0] === 0 && b[1] !== 0) asciiCharsBE++;
                if (b[0] !== 0 && b[1] === 0) asciiCharsLE++;

                b.length = 0;
                charsProcessed++;

                if (charsProcessed >= 100) {
                  break outer_loop;
                }
              }
            }
          }

          // Make decisions.
          // Most of the time, the content has ASCII chars (U+00**), but the opposite (U+**00) is uncommon.
          // So, we count ASCII as if it was LE or BE, and decide from that.
          if (asciiCharsBE > asciiCharsLE) return 'utf-16be';
          if (asciiCharsBE < asciiCharsLE) return 'utf-16le';

          // Couldn't decide (likely all zeros or not enough data).
          return defaultEncoding || 'utf-16le';
        }
        /***/ }),

      /***/ 7688:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        const { Buffer } = __webpack_require__(7103);

        // == UTF32-LE/BE codec. ==========================================================

        exports._utf32 = Utf32Codec;

        function Utf32Codec(codecOptions, iconv) {
          this.iconv = iconv;
          this.bomAware = true;
          this.isLE = codecOptions.isLE;
        }

        exports.utf32le = { type: '_utf32', isLE: true };
        exports.utf32be = { type: '_utf32', isLE: false };

        // Aliases
        exports.ucs4le = 'utf32le';
        exports.ucs4be = 'utf32be';

        Utf32Codec.prototype.encoder = Utf32Encoder;
        Utf32Codec.prototype.decoder = Utf32Decoder;

        // -- Encoding

        function Utf32Encoder(options, codec) {
          this.isLE = codec.isLE;
          this.highSurrogate = 0;
        }

        Utf32Encoder.prototype.write = function (str) {
          const src = Buffer.from(str, 'ucs2');
          let dst = Buffer.alloc(src.length * 2);
          const write32 = this.isLE ? dst.writeUInt32LE : dst.writeUInt32BE;
          let offset = 0;

          for (let i = 0; i < src.length; i += 2) {
            const code = src.readUInt16LE(i);
            const isHighSurrogate = (code >= 0xD800 && code < 0xDC00);
            const isLowSurrogate = (code >= 0xDC00 && code < 0xE000);

            if (this.highSurrogate) {
              if (isHighSurrogate || !isLowSurrogate) {
                // There shouldn't be two high surrogates in a row, nor a high surrogate which isn't followed by a low
                // surrogate. If this happens, keep the pending high surrogate as a stand-alone semi-invalid character
                // (technically wrong, but expected by some applications, like Windows file names).
                write32.call(dst, this.highSurrogate, offset);
                offset += 4;
              } else {
                // Create 32-bit value from high and low surrogates;
                const codepoint = (((this.highSurrogate - 0xD800) << 10) | (code - 0xDC00)) + 0x10000;

                write32.call(dst, codepoint, offset);
                offset += 4;
                this.highSurrogate = 0;

                continue;
              }
            }

            if (isHighSurrogate) this.highSurrogate = code;
            else {
            // Even if the current character is a low surrogate, with no previous high surrogate, we'll
            // encode it as a semi-invalid stand-alone character for the same reasons expressed above for
            // unpaired high surrogates.
              write32.call(dst, code, offset);
              offset += 4;
              this.highSurrogate = 0;
            }
          }

          if (offset < dst.length) dst = dst.slice(0, offset);

          return dst;
        };

        Utf32Encoder.prototype.end = function () {
          // Treat any leftover high surrogate as a semi-valid independent character.
          if (!this.highSurrogate) return;

          const buf = Buffer.alloc(4);

          if (this.isLE) buf.writeUInt32LE(this.highSurrogate, 0);
          else buf.writeUInt32BE(this.highSurrogate, 0);

          this.highSurrogate = 0;

          return buf;
        };

        // -- Decoding

        function Utf32Decoder(options, codec) {
          this.isLE = codec.isLE;
          this.badChar = codec.iconv.defaultCharUnicode.charCodeAt(0);
          this.overflow = [];
        }

        Utf32Decoder.prototype.write = function (src) {
          if (src.length === 0) return '';

          let i = 0;
          let codepoint = 0;
          const dst = Buffer.alloc(src.length + 4);
          let offset = 0;
          const { isLE } = this;
          const { overflow } = this;
          const { badChar } = this;

          if (overflow.length > 0) {
            for (; i < src.length && overflow.length < 4; i++) overflow.push(src[i]);

            if (overflow.length === 4) {
            // NOTE: codepoint is a signed int32 and can be negative.
            // NOTE: We copied this block from below to help V8 optimize it (it works with array, not buffer).
              if (isLE) {
                codepoint = overflow[i] | (overflow[i + 1] << 8) | (overflow[i + 2] << 16) | (overflow[i + 3] << 24);
              } else {
                codepoint = overflow[i + 3] | (overflow[i + 2] << 8) | (overflow[i + 1] << 16) | (overflow[i] << 24);
              }
              overflow.length = 0;

              offset = _writeCodepoint(dst, offset, codepoint, badChar);
            }
          }

          // Main loop. Should be as optimized as possible.
          for (; i < src.length - 3; i += 4) {
            // NOTE: codepoint is a signed int32 and can be negative.
            if (isLE) {
              codepoint = src[i] | (src[i + 1] << 8) | (src[i + 2] << 16) | (src[i + 3] << 24);
            } else {
              codepoint = src[i + 3] | (src[i + 2] << 8) | (src[i + 1] << 16) | (src[i] << 24);
            }
            offset = _writeCodepoint(dst, offset, codepoint, badChar);
          }

          // Keep overflowing bytes.
          for (; i < src.length; i++) {
            overflow.push(src[i]);
          }

          return dst.slice(0, offset).toString('ucs2');
        };

        function _writeCodepoint(dst, offset, codepoint, badChar) {
          // NOTE: codepoint is signed int32 and can be negative. We keep it that way to help V8 with optimizations.
          if (codepoint < 0 || codepoint > 0x10FFFF) {
            // Not a valid Unicode codepoint
            codepoint = badChar;
          }

          // Ephemeral Planes: Write high surrogate.
          if (codepoint >= 0x10000) {
            codepoint -= 0x10000;

            const high = 0xD800 | (codepoint >> 10);
            dst[offset++] = high & 0xff;
            dst[offset++] = high >> 8;

            // Low surrogate is written below.
            var codepoint = 0xDC00 | (codepoint & 0x3FF);
          }

          // Write BMP char or low surrogate.
          dst[offset++] = codepoint & 0xff;
          dst[offset++] = codepoint >> 8;

          return offset;
        }

        Utf32Decoder.prototype.end = function () {
          this.overflow.length = 0;
        };

        // == UTF-32 Auto codec =============================================================
        // Decoder chooses automatically from UTF-32LE and UTF-32BE using BOM and space-based heuristic.
        // Defaults to UTF-32LE. http://en.wikipedia.org/wiki/UTF-32
        // Encoder/decoder default can be changed: iconv.decode(buf, 'utf32', {defaultEncoding: 'utf-32be'});

        // Encoder prepends BOM (which can be overridden with (addBOM: false}).

        exports.utf32 = Utf32AutoCodec;
        exports.ucs4 = 'utf32';

        function Utf32AutoCodec(options, iconv) {
          this.iconv = iconv;
        }

        Utf32AutoCodec.prototype.encoder = Utf32AutoEncoder;
        Utf32AutoCodec.prototype.decoder = Utf32AutoDecoder;

        // -- Encoding

        function Utf32AutoEncoder(options, codec) {
          options = options || {};

          if (options.addBOM === undefined) options.addBOM = true;

          this.encoder = codec.iconv.getEncoder(options.defaultEncoding || 'utf-32le', options);
        }

        Utf32AutoEncoder.prototype.write = function (str) {
          return this.encoder.write(str);
        };

        Utf32AutoEncoder.prototype.end = function () {
          return this.encoder.end();
        };

        // -- Decoding

        function Utf32AutoDecoder(options, codec) {
          this.decoder = null;
          this.initialBufs = [];
          this.initialBufsLen = 0;
          this.options = options || {};
          this.iconv = codec.iconv;
        }

        Utf32AutoDecoder.prototype.write = function (buf) {
          if (!this.decoder) {
            // Codec is not chosen yet. Accumulate initial bytes.
            this.initialBufs.push(buf);
            this.initialBufsLen += buf.length;

            if (this.initialBufsLen < 32) // We need more bytes to use space heuristic (see below)
            { return ''; }

            // We have enough bytes -> detect endianness.
            const encoding = detectEncoding(this.initialBufs, this.options.defaultEncoding);
            this.decoder = this.iconv.getDecoder(encoding, this.options);

            let resStr = '';
            for (let i = 0; i < this.initialBufs.length; i++) resStr += this.decoder.write(this.initialBufs[i]);

            this.initialBufs.length = this.initialBufsLen = 0;
            return resStr;
          }

          return this.decoder.write(buf);
        };

        Utf32AutoDecoder.prototype.end = function () {
          if (!this.decoder) {
            const encoding = detectEncoding(this.initialBufs, this.options.defaultEncoding);
            this.decoder = this.iconv.getDecoder(encoding, this.options);

            let resStr = '';
            for (let i = 0; i < this.initialBufs.length; i++) resStr += this.decoder.write(this.initialBufs[i]);

            const trail = this.decoder.end();
            if (trail) resStr += trail;

            this.initialBufs.length = this.initialBufsLen = 0;
            return resStr;
          }

          return this.decoder.end();
        };

        function detectEncoding(bufs, defaultEncoding) {
          const b = [];
          let charsProcessed = 0;
          let invalidLE = 0; let
            invalidBE = 0; // Number of invalid chars when decoded as LE or BE.
          let bmpCharsLE = 0; let
            bmpCharsBE = 0; // Number of BMP chars when decoded as LE or BE.

          outer_loop:
          for (let i = 0; i < bufs.length; i++) {
            const buf = bufs[i];
            for (let j = 0; j < buf.length; j++) {
              b.push(buf[j]);
              if (b.length === 4) {
                if (charsProcessed === 0) {
                  // Check BOM first.
                  if (b[0] === 0xFF && b[1] === 0xFE && b[2] === 0 && b[3] === 0) {
                    return 'utf-32le';
                  }
                  if (b[0] === 0 && b[1] === 0 && b[2] === 0xFE && b[3] === 0xFF) {
                    return 'utf-32be';
                  }
                }

                if (b[0] !== 0 || b[1] > 0x10) invalidBE++;
                if (b[3] !== 0 || b[2] > 0x10) invalidLE++;

                if (b[0] === 0 && b[1] === 0 && (b[2] !== 0 || b[3] !== 0)) bmpCharsBE++;
                if ((b[0] !== 0 || b[1] !== 0) && b[2] === 0 && b[3] === 0) bmpCharsLE++;

                b.length = 0;
                charsProcessed++;

                if (charsProcessed >= 100) {
                  break outer_loop;
                }
              }
            }
          }

          // Make decisions.
          if (bmpCharsBE - invalidBE > bmpCharsLE - invalidLE) return 'utf-32be';
          if (bmpCharsBE - invalidBE < bmpCharsLE - invalidLE) return 'utf-32le';

          // Couldn't decide (likely all zeros or not enough data).
          return defaultEncoding || 'utf-32le';
        }
        /***/ }),

      /***/ 758:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        const { Buffer } = __webpack_require__(7103);

        // UTF-7 codec, according to https://tools.ietf.org/html/rfc2152
        // See also below a UTF-7-IMAP codec, according to http://tools.ietf.org/html/rfc3501#section-5.1.3

        exports.utf7 = Utf7Codec;
        exports.unicode11utf7 = 'utf7'; // Alias UNICODE-1-1-UTF-7
        function Utf7Codec(codecOptions, iconv) {
          this.iconv = iconv;
        }

        Utf7Codec.prototype.encoder = Utf7Encoder;
        Utf7Codec.prototype.decoder = Utf7Decoder;
        Utf7Codec.prototype.bomAware = true;

        // -- Encoding

        const nonDirectChars = /[^A-Za-z0-9'\(\),-\.\/:\? \n\r\t]+/g;

        function Utf7Encoder(options, codec) {
          this.iconv = codec.iconv;
        }

        Utf7Encoder.prototype.write = function (str) {
          // Naive implementation.
          // Non-direct chars are encoded as "+<base64>-"; single "+" char is encoded as "+-".
          return Buffer.from(str.replace(nonDirectChars, (chunk) => `+${chunk === '+' ? ''
            : this.iconv.encode(chunk, 'utf16-be').toString('base64').replace(/=+$/, '')
          }-`));
        };

        Utf7Encoder.prototype.end = function () {
        };

        // -- Decoding

        function Utf7Decoder(options, codec) {
          this.iconv = codec.iconv;
          this.inBase64 = false;
          this.base64Accum = '';
        }

        const base64Regex = /[A-Za-z0-9\/+]/;
        const base64Chars = [];
        for (let i = 0; i < 256; i++) base64Chars[i] = base64Regex.test(String.fromCharCode(i));

        const plusChar = '+'.charCodeAt(0);
        const minusChar = '-'.charCodeAt(0);
        const andChar = '&'.charCodeAt(0);

        Utf7Decoder.prototype.write = function (buf) {
          let res = '';
          let lastI = 0;
          let { inBase64 } = this;
          let { base64Accum } = this;

          // The decoder is more involved as we must handle chunks in stream.

          for (let i = 0; i < buf.length; i++) {
            if (!inBase64) { // We're in direct mode.
            // Write direct chars until '+'
              if (buf[i] == plusChar) {
                res += this.iconv.decode(buf.slice(lastI, i), 'ascii'); // Write direct chars.
                lastI = i + 1;
                inBase64 = true;
              }
            } else { // We decode base64.
              if (!base64Chars[buf[i]]) { // Base64 ended.
                if (i == lastI && buf[i] == minusChar) { // "+-" -> "+"
                  res += '+';
                } else {
                  var b64str = base64Accum + this.iconv.decode(buf.slice(lastI, i), 'ascii');
                  res += this.iconv.decode(Buffer.from(b64str, 'base64'), 'utf16-be');
                }

                if (buf[i] != minusChar) // Minus is absorbed after base64.
                { i--; }

                lastI = i + 1;
                inBase64 = false;
                base64Accum = '';
              }
            }
          }

          if (!inBase64) {
            res += this.iconv.decode(buf.slice(lastI), 'ascii'); // Write direct chars.
          } else {
            var b64str = base64Accum + this.iconv.decode(buf.slice(lastI), 'ascii');

            const canBeDecoded = b64str.length - (b64str.length % 8); // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
            base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
            b64str = b64str.slice(0, canBeDecoded);

            res += this.iconv.decode(Buffer.from(b64str, 'base64'), 'utf16-be');
          }

          this.inBase64 = inBase64;
          this.base64Accum = base64Accum;

          return res;
        };

        Utf7Decoder.prototype.end = function () {
          let res = '';
          if (this.inBase64 && this.base64Accum.length > 0) res = this.iconv.decode(Buffer.from(this.base64Accum, 'base64'), 'utf16-be');

          this.inBase64 = false;
          this.base64Accum = '';
          return res;
        };

        // UTF-7-IMAP codec.
        // RFC3501 Sec. 5.1.3 Modified UTF-7 (http://tools.ietf.org/html/rfc3501#section-5.1.3)
        // Differences:
        //  * Base64 part is started by "&" instead of "+"
        //  * Direct characters are 0x20-0x7E, except "&" (0x26)
        //  * In Base64, "," is used instead of "/"
        //  * Base64 must not be used to represent direct characters.
        //  * No implicit shift back from Base64 (should always end with '-')
        //  * String must end in non-shifted position.
        //  * "-&" while in base64 is not allowed.

        exports.utf7imap = Utf7IMAPCodec;
        function Utf7IMAPCodec(codecOptions, iconv) {
          this.iconv = iconv;
        }

        Utf7IMAPCodec.prototype.encoder = Utf7IMAPEncoder;
        Utf7IMAPCodec.prototype.decoder = Utf7IMAPDecoder;
        Utf7IMAPCodec.prototype.bomAware = true;

        // -- Encoding

        function Utf7IMAPEncoder(options, codec) {
          this.iconv = codec.iconv;
          this.inBase64 = false;
          this.base64Accum = Buffer.alloc(6);
          this.base64AccumIdx = 0;
        }

        Utf7IMAPEncoder.prototype.write = function (str) {
          let { inBase64 } = this;
          const { base64Accum } = this;
          let { base64AccumIdx } = this;
          const buf = Buffer.alloc(str.length * 5 + 10);
          let bufIdx = 0;

          for (let i = 0; i < str.length; i++) {
            const uChar = str.charCodeAt(i);
            if (uChar >= 0x20 && uChar <= 0x7E) { // Direct character or '&'.
              if (inBase64) {
                if (base64AccumIdx > 0) {
                  bufIdx += buf.write(base64Accum.slice(0, base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
                  base64AccumIdx = 0;
                }

                buf[bufIdx++] = minusChar; // Write '-', then go to direct mode.
                inBase64 = false;
              }

              if (!inBase64) {
                buf[bufIdx++] = uChar; // Write direct character

                if (uChar === andChar) // Ampersand -> '&-'
                { buf[bufIdx++] = minusChar; }
              }
            } else { // Non-direct character
              if (!inBase64) {
                buf[bufIdx++] = andChar; // Write '&', then go to base64 mode.
                inBase64 = true;
              }
              if (inBase64) {
                base64Accum[base64AccumIdx++] = uChar >> 8;
                base64Accum[base64AccumIdx++] = uChar & 0xFF;

                if (base64AccumIdx == base64Accum.length) {
                  bufIdx += buf.write(base64Accum.toString('base64').replace(/\//g, ','), bufIdx);
                  base64AccumIdx = 0;
                }
              }
            }
          }

          this.inBase64 = inBase64;
          this.base64AccumIdx = base64AccumIdx;

          return buf.slice(0, bufIdx);
        };

        Utf7IMAPEncoder.prototype.end = function () {
          const buf = Buffer.alloc(10); let
            bufIdx = 0;
          if (this.inBase64) {
            if (this.base64AccumIdx > 0) {
              bufIdx += buf.write(this.base64Accum.slice(0, this.base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
              this.base64AccumIdx = 0;
            }

            buf[bufIdx++] = minusChar; // Write '-', then go to direct mode.
            this.inBase64 = false;
          }

          return buf.slice(0, bufIdx);
        };

        // -- Decoding

        function Utf7IMAPDecoder(options, codec) {
          this.iconv = codec.iconv;
          this.inBase64 = false;
          this.base64Accum = '';
        }

        const base64IMAPChars = base64Chars.slice();
        base64IMAPChars[','.charCodeAt(0)] = true;

        Utf7IMAPDecoder.prototype.write = function (buf) {
          let res = '';
          let lastI = 0;
          let { inBase64 } = this;
          let { base64Accum } = this;

          // The decoder is more involved as we must handle chunks in stream.
          // It is forgiving, closer to standard UTF-7 (for example, '-' is optional at the end).

          for (let i = 0; i < buf.length; i++) {
            if (!inBase64) { // We're in direct mode.
            // Write direct chars until '&'
              if (buf[i] == andChar) {
                res += this.iconv.decode(buf.slice(lastI, i), 'ascii'); // Write direct chars.
                lastI = i + 1;
                inBase64 = true;
              }
            } else { // We decode base64.
              if (!base64IMAPChars[buf[i]]) { // Base64 ended.
                if (i == lastI && buf[i] == minusChar) { // "&-" -> "&"
                  res += '&';
                } else {
                  var b64str = base64Accum + this.iconv.decode(buf.slice(lastI, i), 'ascii').replace(/,/g, '/');
                  res += this.iconv.decode(Buffer.from(b64str, 'base64'), 'utf16-be');
                }

                if (buf[i] != minusChar) // Minus may be absorbed after base64.
                { i--; }

                lastI = i + 1;
                inBase64 = false;
                base64Accum = '';
              }
            }
          }

          if (!inBase64) {
            res += this.iconv.decode(buf.slice(lastI), 'ascii'); // Write direct chars.
          } else {
            var b64str = base64Accum + this.iconv.decode(buf.slice(lastI), 'ascii').replace(/,/g, '/');

            const canBeDecoded = b64str.length - (b64str.length % 8); // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
            base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
            b64str = b64str.slice(0, canBeDecoded);

            res += this.iconv.decode(Buffer.from(b64str, 'base64'), 'utf16-be');
          }

          this.inBase64 = inBase64;
          this.base64Accum = base64Accum;

          return res;
        };

        Utf7IMAPDecoder.prototype.end = function () {
          let res = '';
          if (this.inBase64 && this.base64Accum.length > 0) res = this.iconv.decode(Buffer.from(this.base64Accum, 'base64'), 'utf16-be');

          this.inBase64 = false;
          this.base64Accum = '';
          return res;
        };
        /***/ }),

      /***/ 5395:
      /***/ (function (__unused_webpack_module, exports) {
        const BOMChar = '\uFEFF';

        exports.PrependBOM = PrependBOMWrapper;
        function PrependBOMWrapper(encoder, options) {
          this.encoder = encoder;
          this.addBOM = true;
        }

        PrependBOMWrapper.prototype.write = function (str) {
          if (this.addBOM) {
            str = BOMChar + str;
            this.addBOM = false;
          }

          return this.encoder.write(str);
        };

        PrependBOMWrapper.prototype.end = function () {
          return this.encoder.end();
        };

        //------------------------------------------------------------------------------

        exports.StripBOM = StripBOMWrapper;
        function StripBOMWrapper(decoder, options) {
          this.decoder = decoder;
          this.pass = false;
          this.options = options || {};
        }

        StripBOMWrapper.prototype.write = function (buf) {
          let res = this.decoder.write(buf);
          if (this.pass || !res) return res;

          if (res[0] === BOMChar) {
            res = res.slice(1);
            if (typeof this.options.stripBOM === 'function') this.options.stripBOM();
          }

          this.pass = true;
          return res;
        };

        StripBOMWrapper.prototype.end = function () {
          return this.decoder.end();
        };
        /***/ }),

      /***/ 4914:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const { Buffer } = __webpack_require__(7103);

        const bomHandling = __webpack_require__(5395);
        const iconv = module.exports;

        // All codecs and aliases are kept here, keyed by encoding name/alias.
        // They are lazy loaded in `iconv.getCodec` from `encodings/index.js`.
        iconv.encodings = null;

        // Characters emitted in case of error.
        iconv.defaultCharUnicode = '�';
        iconv.defaultCharSingleByte = '?';

        // Public API.
        iconv.encode = function encode(str, encoding, options) {
          str = `${str || ''}`; // Ensure string.

          const encoder = iconv.getEncoder(encoding, options);

          const res = encoder.write(str);
          const trail = encoder.end();

          return (trail && trail.length > 0) ? Buffer.concat([res, trail]) : res;
        };

        iconv.decode = function decode(buf, encoding, options) {
          if (typeof buf === 'string') {
            if (!iconv.skipDecodeWarning) {
              console.error('Iconv-lite warning: decode()-ing strings is deprecated. Refer to https://github.com/ashtuchkin/iconv-lite/wiki/Use-Buffers-when-decoding');
              iconv.skipDecodeWarning = true;
            }

            buf = Buffer.from(`${buf || ''}`, 'binary'); // Ensure buffer.
          }

          const decoder = iconv.getDecoder(encoding, options);

          const res = decoder.write(buf);
          const trail = decoder.end();

          return trail ? (res + trail) : res;
        };

        iconv.encodingExists = function encodingExists(enc) {
          try {
            iconv.getCodec(enc);
            return true;
          } catch (e) {
            return false;
          }
        };

        // Legacy aliases to convert functions
        iconv.toEncoding = iconv.encode;
        iconv.fromEncoding = iconv.decode;

        // Search for a codec in iconv.encodings. Cache codec data in iconv._codecDataCache.
        iconv._codecDataCache = {};
        iconv.getCodec = function getCodec(encoding) {
          if (!iconv.encodings) iconv.encodings = __webpack_require__(6934); // Lazy load all encoding definitions.

          // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
          let enc = iconv._canonicalizeEncoding(encoding);

          // Traverse iconv.encodings to find actual codec.
          const codecOptions = {};
          while (true) {
            let codec = iconv._codecDataCache[enc];
            if (codec) return codec;

            const codecDef = iconv.encodings[enc];

            switch (typeof codecDef) {
              case 'string': // Direct alias to other encoding.
                enc = codecDef;
                break;

              case 'object': // Alias with options. Can be layered.
                for (const key in codecDef) codecOptions[key] = codecDef[key];

                if (!codecOptions.encodingName) codecOptions.encodingName = enc;

                enc = codecDef.type;
                break;

              case 'function': // Codec itself.
                if (!codecOptions.encodingName) codecOptions.encodingName = enc;

                // The codec function must load all tables and return object with .encoder and .decoder methods.
                // It'll be called only once (for each different options object).
                codec = new codecDef(codecOptions, iconv);

                iconv._codecDataCache[codecOptions.encodingName] = codec; // Save it to be reused later.
                return codec;

              default:
                throw new Error(`Encoding not recognized: '${encoding}' (searched as: '${enc}')`);
            }
          }
        };

        iconv._canonicalizeEncoding = function (encoding) {
          // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
          return (`${encoding}`).toLowerCase().replace(/:\d{4}$|[^0-9a-z]/g, '');
        };

        iconv.getEncoder = function getEncoder(encoding, options) {
          const codec = iconv.getCodec(encoding);
          let encoder = new codec.encoder(options, codec);

          if (codec.bomAware && options && options.addBOM) encoder = new bomHandling.PrependBOM(encoder, options);

          return encoder;
        };

        iconv.getDecoder = function getDecoder(encoding, options) {
          const codec = iconv.getCodec(encoding);
          let decoder = new codec.decoder(options, codec);

          if (codec.bomAware && !(options && options.stripBOM === false)) decoder = new bomHandling.StripBOM(decoder, options);

          return decoder;
        };

        // Streaming API
        // NOTE: Streaming API naturally depends on 'stream' module from Node.js. Unfortunately in browser environments this module can add
        // up to 100Kb to the output bundle. To avoid unnecessary code bloat, we don't enable Streaming API in browser by default.
        // If you would like to enable it explicitly, please add the following code to your app:
        // > iconv.enableStreamingAPI(require('stream'));
        iconv.enableStreamingAPI = function enableStreamingAPI(stream_module) {
          if (iconv.supportsStreams) return;

          // Dependency-inject stream module to create IconvLite stream classes.
          const streams = __webpack_require__(8044)(stream_module);

          // Not public API yet, but expose the stream classes.
          iconv.IconvLiteEncoderStream = streams.IconvLiteEncoderStream;
          iconv.IconvLiteDecoderStream = streams.IconvLiteDecoderStream;

          // Streaming API.
          iconv.encodeStream = function encodeStream(encoding, options) {
            return new iconv.IconvLiteEncoderStream(iconv.getEncoder(encoding, options), options);
          };

          iconv.decodeStream = function decodeStream(encoding, options) {
            return new iconv.IconvLiteDecoderStream(iconv.getDecoder(encoding, options), options);
          };

          iconv.supportsStreams = true;
        };

        // Enable Streaming API automatically if 'stream' module is available and non-empty (the majority of environments).
        let stream_module;
        try {
          stream_module = __webpack_require__(5832);
        } catch (e) {}

        if (stream_module && stream_module.Transform) {
          iconv.enableStreamingAPI(stream_module);
        } else {
          // In rare cases where 'stream' module is not available by default, throw a helpful exception.
          iconv.encodeStream = iconv.decodeStream = function () {
            throw new Error("iconv-lite Streaming API is not enabled. Use iconv.enableStreamingAPI(require('stream')); to enable it.");
          };
        }

        if (false) {}
        /***/ }),

      /***/ 8044:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const { Buffer } = __webpack_require__(7103);

        // NOTE: Due to 'stream' module being pretty large (~100Kb, significant in browser environments),
        // we opt to dependency-inject it instead of creating a hard dependency.
        module.exports = function (stream_module) {
          const { Transform } = stream_module;

          // == Encoder stream =======================================================

          function IconvLiteEncoderStream(conv, options) {
            this.conv = conv;
            options = options || {};
            options.decodeStrings = false; // We accept only strings, so we don't need to decode them.
            Transform.call(this, options);
          }

          IconvLiteEncoderStream.prototype = Object.create(Transform.prototype, {
            constructor: { value: IconvLiteEncoderStream },
          });

          IconvLiteEncoderStream.prototype._transform = function (chunk, encoding, done) {
            if (typeof chunk !== 'string') return done(new Error('Iconv encoding stream needs strings as its input.'));
            try {
              const res = this.conv.write(chunk);
              if (res && res.length) this.push(res);
              done();
            } catch (e) {
              done(e);
            }
          };

          IconvLiteEncoderStream.prototype._flush = function (done) {
            try {
              const res = this.conv.end();
              if (res && res.length) this.push(res);
              done();
            } catch (e) {
              done(e);
            }
          };

          IconvLiteEncoderStream.prototype.collect = function (cb) {
            const chunks = [];
            this.on('error', cb);
            this.on('data', (chunk) => { chunks.push(chunk); });
            this.on('end', () => {
              cb(null, Buffer.concat(chunks));
            });
            return this;
          };

          // == Decoder stream =======================================================

          function IconvLiteDecoderStream(conv, options) {
            this.conv = conv;
            options = options || {};
            options.encoding = this.encoding = 'utf8'; // We output strings.
            Transform.call(this, options);
          }

          IconvLiteDecoderStream.prototype = Object.create(Transform.prototype, {
            constructor: { value: IconvLiteDecoderStream },
          });

          IconvLiteDecoderStream.prototype._transform = function (chunk, encoding, done) {
            if (!Buffer.isBuffer(chunk) && !(chunk instanceof Uint8Array)) return done(new Error('Iconv decoding stream needs buffers as its input.'));
            try {
              const res = this.conv.write(chunk);
              if (res && res.length) this.push(res, this.encoding);
              done();
            } catch (e) {
              done(e);
            }
          };

          IconvLiteDecoderStream.prototype._flush = function (done) {
            try {
              const res = this.conv.end();
              if (res && res.length) this.push(res, this.encoding);
              done();
            } catch (e) {
              done(e);
            }
          };

          IconvLiteDecoderStream.prototype.collect = function (cb) {
            let res = '';
            this.on('error', cb);
            this.on('data', (chunk) => { res += chunk; });
            this.on('end', () => {
              cb(null, res);
            });
            return this;
          };

          return {
            IconvLiteEncoderStream,
            IconvLiteDecoderStream,
          };
        };
        /***/ }),

      /***/ 645:
      /***/ (function (__unused_webpack_module, exports) {
        /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
        exports.read = function (buffer, offset, isLE, mLen, nBytes) {
          let e; let
            m;
          const eLen = (nBytes * 8) - mLen - 1;
          const eMax = (1 << eLen) - 1;
          const eBias = eMax >> 1;
          let nBits = -7;
          let i = isLE ? (nBytes - 1) : 0;
          const d = isLE ? -1 : 1;
          let s = buffer[offset + i];

          i += d;

          e = s & ((1 << (-nBits)) - 1);
          s >>= (-nBits);
          nBits += eLen;
          for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

          m = e & ((1 << (-nBits)) - 1);
          e >>= (-nBits);
          nBits += mLen;
          for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

          if (e === 0) {
            e = 1 - eBias;
          } else if (e === eMax) {
            return m ? NaN : ((s ? -1 : 1) * Infinity);
          } else {
            m += Math.pow(2, mLen);
            e -= eBias;
          }
          return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
        };

        exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
          let e; let m; let
            c;
          let eLen = (nBytes * 8) - mLen - 1;
          const eMax = (1 << eLen) - 1;
          const eBias = eMax >> 1;
          const rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0);
          let i = isLE ? 0 : (nBytes - 1);
          const d = isLE ? 1 : -1;
          const s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;

          value = Math.abs(value);

          if (isNaN(value) || value === Infinity) {
            m = isNaN(value) ? 1 : 0;
            e = eMax;
          } else {
            e = Math.floor(Math.log(value) / Math.LN2);
            if (value * (c = Math.pow(2, -e)) < 1) {
              e--;
              c *= 2;
            }
            if (e + eBias >= 1) {
              value += rt / c;
            } else {
              value += rt * Math.pow(2, 1 - eBias);
            }
            if (value * c >= 2) {
              e++;
              c /= 2;
            }

            if (e + eBias >= eMax) {
              m = 0;
              e = eMax;
            } else if (e + eBias >= 1) {
              m = ((value * c) - 1) * Math.pow(2, mLen);
              e += eBias;
            } else {
              m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
              e = 0;
            }
          }

          for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

          e = (e << mLen) | m;
          eLen += mLen;
          for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

          buffer[offset + i - d] |= s * 128;
        };
        /***/ }),

      /***/ 5717:
      /***/ (function (module) {
        if (typeof Object.create === 'function') {
          // implementation from standard node.js 'util' module
          module.exports = function inherits(ctor, superCtor) {
            if (superCtor) {
              ctor.super_ = superCtor;
              ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                  value: ctor,
                  enumerable: false,
                  writable: true,
                  configurable: true,
                },
              });
            }
          };
        } else {
          // old school shim for old browsers
          module.exports = function inherits(ctor, superCtor) {
            if (superCtor) {
              ctor.super_ = superCtor;
              const TempCtor = function () {};
              TempCtor.prototype = superCtor.prototype;
              ctor.prototype = new TempCtor();
              ctor.prototype.constructor = ctor;
            }
          };
        }
        /***/ }),

      /***/ 2584:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const hasToStringTag = __webpack_require__(6410)();
        const callBound = __webpack_require__(1924);

        const $toString = callBound('Object.prototype.toString');

        const isStandardArguments = function isArguments(value) {
          if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
            return false;
          }
          return $toString(value) === '[object Arguments]';
        };

        const isLegacyArguments = function isArguments(value) {
          if (isStandardArguments(value)) {
            return true;
          }
          return value !== null
		&& typeof value === 'object'
		&& typeof value.length === 'number'
		&& value.length >= 0
		&& $toString(value) !== '[object Array]'
		&& $toString(value.callee) === '[object Function]';
        };

        const supportsStandardArguments = (function () {
          return isStandardArguments(arguments);
        }());

        isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

        module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;
        /***/ }),

      /***/ 8923:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const { getDay } = Date.prototype;
        const tryDateObject = function tryDateGetDayCall(value) {
          try {
            getDay.call(value);
            return true;
          } catch (e) {
            return false;
          }
        };

        const toStr = Object.prototype.toString;
        const dateClass = '[object Date]';
        const hasToStringTag = __webpack_require__(6410)();

        module.exports = function isDateObject(value) {
          if (typeof value !== 'object' || value === null) {
            return false;
          }
          return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
        };
        /***/ }),

      /***/ 8662:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const toStr = Object.prototype.toString;
        const fnToStr = Function.prototype.toString;
        const isFnRegex = /^\s*(?:function)?\*/;
        const hasToStringTag = __webpack_require__(6410)();
        const getProto = Object.getPrototypeOf;
        const getGeneratorFunc = function () { // eslint-disable-line consistent-return
          if (!hasToStringTag) {
            return false;
          }
          try {
            return Function('return function*() {}')();
          } catch (e) {
          }
        };
        let GeneratorFunction;

        module.exports = function isGeneratorFunction(fn) {
          if (typeof fn !== 'function') {
            return false;
          }
          if (isFnRegex.test(fnToStr.call(fn))) {
            return true;
          }
          if (!hasToStringTag) {
            const str = toStr.call(fn);
            return str === '[object GeneratorFunction]';
          }
          if (!getProto) {
            return false;
          }
          if (typeof GeneratorFunction === 'undefined') {
            const generatorFunc = getGeneratorFunc();
            GeneratorFunction = generatorFunc ? getProto(generatorFunc) : false;
          }
          return getProto(fn) === GeneratorFunction;
        };
        /***/ }),

      /***/ 8611:
      /***/ (function (module) {
        /* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */

        module.exports = function isNaN(value) {
          return value !== value;
        };
        /***/ }),

      /***/ 360:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const callBind = __webpack_require__(5559);
        const define = __webpack_require__(4289);

        const implementation = __webpack_require__(8611);
        const getPolyfill = __webpack_require__(9415);
        const shim = __webpack_require__(6743);

        const polyfill = callBind(getPolyfill(), Number);

        /* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */

        define(polyfill, {
          getPolyfill,
          implementation,
          shim,
        });

        module.exports = polyfill;
        /***/ }),

      /***/ 9415:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const implementation = __webpack_require__(8611);

        module.exports = function getPolyfill() {
          if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) {
            return Number.isNaN;
          }
          return implementation;
        };
        /***/ }),

      /***/ 6743:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const define = __webpack_require__(4289);
        const getPolyfill = __webpack_require__(9415);

        /* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */

        module.exports = function shimNumberIsNaN() {
          const polyfill = getPolyfill();
          define(Number, { isNaN: polyfill }, {
            isNaN: function testIsNaN() {
              return Number.isNaN !== polyfill;
            },
          });
          return polyfill;
        };
        /***/ }),

      /***/ 8420:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const callBound = __webpack_require__(1924);
        const hasToStringTag = __webpack_require__(6410)();
        let has;
        let $exec;
        let isRegexMarker;
        let badStringifier;

        if (hasToStringTag) {
          has = callBound('Object.prototype.hasOwnProperty');
          $exec = callBound('RegExp.prototype.exec');
          isRegexMarker = {};

          const throwRegexMarker = function () {
            throw isRegexMarker;
          };
          badStringifier = {
            toString: throwRegexMarker,
            valueOf: throwRegexMarker,
          };

          if (typeof Symbol.toPrimitive === 'symbol') {
            badStringifier[Symbol.toPrimitive] = throwRegexMarker;
          }
        }

        const $toString = callBound('Object.prototype.toString');
        const gOPD = Object.getOwnPropertyDescriptor;
        const regexClass = '[object RegExp]';

        module.exports = hasToStringTag
        // eslint-disable-next-line consistent-return
          ? function isRegex(value) {
            if (!value || typeof value !== 'object') {
              return false;
            }

            const descriptor = gOPD(value, 'lastIndex');
            const hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
            if (!hasLastIndexDataProperty) {
              return false;
            }

            try {
              $exec(value, badStringifier);
            } catch (e) {
              return e === isRegexMarker;
            }
          }
          : function isRegex(value) {
            // In older browsers, typeof regex incorrectly returns 'function'
            if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
              return false;
            }

            return $toString(value) === regexClass;
          };
        /***/ }),

      /***/ 5692:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const forEach = __webpack_require__(9804);
        const availableTypedArrays = __webpack_require__(3083);
        const callBound = __webpack_require__(1924);

        const $toString = callBound('Object.prototype.toString');
        const hasToStringTag = __webpack_require__(6410)();

        const g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;
        const typedArrays = availableTypedArrays();

        const $indexOf = callBound('Array.prototype.indexOf', true) || function indexOf(array, value) {
          for (let i = 0; i < array.length; i += 1) {
            if (array[i] === value) {
              return i;
            }
          }
          return -1;
        };
        const $slice = callBound('String.prototype.slice');
        const toStrTags = {};
        const gOPD = __webpack_require__(882);
        const { getPrototypeOf } = Object; // require('getprototypeof');
        if (hasToStringTag && gOPD && getPrototypeOf) {
          forEach(typedArrays, (typedArray) => {
            const arr = new g[typedArray]();
            if (Symbol.toStringTag in arr) {
              const proto = getPrototypeOf(arr);
              let descriptor = gOPD(proto, Symbol.toStringTag);
              if (!descriptor) {
                const superProto = getPrototypeOf(proto);
                descriptor = gOPD(superProto, Symbol.toStringTag);
              }
              toStrTags[typedArray] = descriptor.get;
            }
          });
        }

        const tryTypedArrays = function tryAllTypedArrays(value) {
          let anyTrue = false;
          forEach(toStrTags, (getter, typedArray) => {
            if (!anyTrue) {
              try {
                anyTrue = getter.call(value) === typedArray;
              } catch (e) { /**/ }
            }
          });
          return anyTrue;
        };

        module.exports = function isTypedArray(value) {
          if (!value || typeof value !== 'object') { return false; }
          if (!hasToStringTag || !(Symbol.toStringTag in value)) {
            const tag = $slice($toString(value), 8, -1);
            return $indexOf(typedArrays, tag) > -1;
          }
          if (!gOPD) { return false; }
          return tryTypedArrays(value);
        };
        /***/ }),

      /***/ 4244:
      /***/ (function (module) {
        const numberIsNaN = function (value) {
          return value !== value;
        };

        module.exports = function is(a, b) {
          if (a === 0 && b === 0) {
            return 1 / a === 1 / b;
          }
          if (a === b) {
            return true;
          }
          if (numberIsNaN(a) && numberIsNaN(b)) {
            return true;
          }
          return false;
        };
        /***/ }),

      /***/ 609:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const define = __webpack_require__(4289);
        const callBind = __webpack_require__(5559);

        const implementation = __webpack_require__(4244);
        const getPolyfill = __webpack_require__(5624);
        const shim = __webpack_require__(2281);

        const polyfill = callBind(getPolyfill(), Object);

        define(polyfill, {
          getPolyfill,
          implementation,
          shim,
        });

        module.exports = polyfill;
        /***/ }),

      /***/ 5624:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const implementation = __webpack_require__(4244);

        module.exports = function getPolyfill() {
          return typeof Object.is === 'function' ? Object.is : implementation;
        };
        /***/ }),

      /***/ 2281:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const getPolyfill = __webpack_require__(5624);
        const define = __webpack_require__(4289);

        module.exports = function shimObjectIs() {
          const polyfill = getPolyfill();
          define(Object, { is: polyfill }, {
            is: function testObjectIs() {
              return Object.is !== polyfill;
            },
          });
          return polyfill;
        };
        /***/ }),

      /***/ 8987:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        let keysShim;
        if (!Object.keys) {
          // modified from https://github.com/es-shims/es5-shim
          const has = Object.prototype.hasOwnProperty;
          const toStr = Object.prototype.toString;
          const isArgs = __webpack_require__(1414); // eslint-disable-line global-require
          const isEnumerable = Object.prototype.propertyIsEnumerable;
          const hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
          const hasProtoEnumBug = isEnumerable.call(() => {}, 'prototype');
          const dontEnums = [
            'toString',
            'toLocaleString',
            'valueOf',
            'hasOwnProperty',
            'isPrototypeOf',
            'propertyIsEnumerable',
            'constructor',
          ];
          const equalsConstructorPrototype = function (o) {
            const ctor = o.constructor;
            return ctor && ctor.prototype === o;
          };
          const excludedKeys = {
            $applicationCache: true,
            $console: true,
            $external: true,
            $frame: true,
            $frameElement: true,
            $frames: true,
            $innerHeight: true,
            $innerWidth: true,
            $onmozfullscreenchange: true,
            $onmozfullscreenerror: true,
            $outerHeight: true,
            $outerWidth: true,
            $pageXOffset: true,
            $pageYOffset: true,
            $parent: true,
            $scrollLeft: true,
            $scrollTop: true,
            $scrollX: true,
            $scrollY: true,
            $self: true,
            $webkitIndexedDB: true,
            $webkitStorageInfo: true,
            $window: true,
          };
          const hasAutomationEqualityBug = (function () {
            /* global window */
            if (typeof window === 'undefined') { return false; }
            for (const k in window) {
              try {
                if (!excludedKeys[`$${k}`] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
                  try {
                    equalsConstructorPrototype(window[k]);
                  } catch (e) {
                    return true;
                  }
                }
              } catch (e) {
                return true;
              }
            }
            return false;
          }());
          const equalsConstructorPrototypeIfNotBuggy = function (o) {
            /* global window */
            if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
              return equalsConstructorPrototype(o);
            }
            try {
              return equalsConstructorPrototype(o);
            } catch (e) {
              return false;
            }
          };

          keysShim = function keys(object) {
            const isObject = object !== null && typeof object === 'object';
            const isFunction = toStr.call(object) === '[object Function]';
            const isArguments = isArgs(object);
            const isString = isObject && toStr.call(object) === '[object String]';
            const theKeys = [];

            if (!isObject && !isFunction && !isArguments) {
              throw new TypeError('Object.keys called on a non-object');
            }

            const skipProto = hasProtoEnumBug && isFunction;
            if (isString && object.length > 0 && !has.call(object, 0)) {
              for (let i = 0; i < object.length; ++i) {
                theKeys.push(String(i));
              }
            }

            if (isArguments && object.length > 0) {
              for (let j = 0; j < object.length; ++j) {
                theKeys.push(String(j));
              }
            } else {
              for (const name in object) {
                if (!(skipProto && name === 'prototype') && has.call(object, name)) {
                  theKeys.push(String(name));
                }
              }
            }

            if (hasDontEnumBug) {
              const skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

              for (let k = 0; k < dontEnums.length; ++k) {
                if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
                  theKeys.push(dontEnums[k]);
                }
              }
            }
            return theKeys;
          };
        }
        module.exports = keysShim;
        /***/ }),

      /***/ 2215:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const { slice } = Array.prototype;
        const isArgs = __webpack_require__(1414);

        const origKeys = Object.keys;
        const keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(8987);

        const originalKeys = Object.keys;

        keysShim.shim = function shimObjectKeys() {
          if (Object.keys) {
            const keysWorksWithArguments = (function () {
              // Safari 5.0 bug
              const args = Object.keys(arguments);
              return args && args.length === arguments.length;
            }(1, 2));
            if (!keysWorksWithArguments) {
              Object.keys = function keys(object) { // eslint-disable-line func-name-matching
                if (isArgs(object)) {
                  return originalKeys(slice.call(object));
                }
                return originalKeys(object);
              };
            }
          } else {
            Object.keys = keysShim;
          }
          return Object.keys || keysShim;
        };

        module.exports = keysShim;
        /***/ }),

      /***/ 1414:
      /***/ (function (module) {
        const toStr = Object.prototype.toString;

        module.exports = function isArguments(value) {
          const str = toStr.call(value);
          let isArgs = str === '[object Arguments]';
          if (!isArgs) {
            isArgs = str !== '[object Array]'
			&& value !== null
			&& typeof value === 'object'
			&& typeof value.length === 'number'
			&& value.length >= 0
			&& toStr.call(value.callee) === '[object Function]';
          }
          return isArgs;
        };
        /***/ }),

      /***/ 4155:
      /***/ (function (module) {
        // shim for using process in browser
        const process = module.exports = {};

        // cached from whatever global is present so that test runners that stub it
        // don't break things.  But we need to wrap it in a try catch in case it is
        // wrapped in strict mode code which doesn't define any globals.  It's inside a
        // function because try/catches deoptimize in certain engines.

        let cachedSetTimeout;
        let cachedClearTimeout;

        function defaultSetTimout() {
          throw new Error('setTimeout has not been defined');
        }
        function defaultClearTimeout() {
          throw new Error('clearTimeout has not been defined');
        }
        (function () {
          try {
            if (typeof setTimeout === 'function') {
              cachedSetTimeout = setTimeout;
            } else {
              cachedSetTimeout = defaultSetTimout;
            }
          } catch (e) {
            cachedSetTimeout = defaultSetTimout;
          }
          try {
            if (typeof clearTimeout === 'function') {
              cachedClearTimeout = clearTimeout;
            } else {
              cachedClearTimeout = defaultClearTimeout;
            }
          } catch (e) {
            cachedClearTimeout = defaultClearTimeout;
          }
        }());
        function runTimeout(fun) {
          if (cachedSetTimeout === setTimeout) {
            // normal enviroments in sane situations
            return setTimeout(fun, 0);
          }
          // if setTimeout wasn't available but was latter defined
          if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
            cachedSetTimeout = setTimeout;
            return setTimeout(fun, 0);
          }
          try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedSetTimeout(fun, 0);
          } catch (e) {
            try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
              return cachedSetTimeout.call(null, fun, 0);
            } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
              return cachedSetTimeout.call(this, fun, 0);
            }
          }
        }
        function runClearTimeout(marker) {
          if (cachedClearTimeout === clearTimeout) {
            // normal enviroments in sane situations
            return clearTimeout(marker);
          }
          // if clearTimeout wasn't available but was latter defined
          if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
            cachedClearTimeout = clearTimeout;
            return clearTimeout(marker);
          }
          try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedClearTimeout(marker);
          } catch (e) {
            try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
              return cachedClearTimeout.call(null, marker);
            } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
              return cachedClearTimeout.call(this, marker);
            }
          }
        }
        let queue = [];
        let draining = false;
        let currentQueue;
        let queueIndex = -1;

        function cleanUpNextTick() {
          if (!draining || !currentQueue) {
            return;
          }
          draining = false;
          if (currentQueue.length) {
            queue = currentQueue.concat(queue);
          } else {
            queueIndex = -1;
          }
          if (queue.length) {
            drainQueue();
          }
        }

        function drainQueue() {
          if (draining) {
            return;
          }
          const timeout = runTimeout(cleanUpNextTick);
          draining = true;

          let len = queue.length;
          while (len) {
            currentQueue = queue;
            queue = [];
            while (++queueIndex < len) {
              if (currentQueue) {
                currentQueue[queueIndex].run();
              }
            }
            queueIndex = -1;
            len = queue.length;
          }
          currentQueue = null;
          draining = false;
          runClearTimeout(timeout);
        }

        process.nextTick = function (fun) {
          const args = new Array(arguments.length - 1);
          if (arguments.length > 1) {
            for (let i = 1; i < arguments.length; i++) {
              args[i - 1] = arguments[i];
            }
          }
          queue.push(new Item(fun, args));
          if (queue.length === 1 && !draining) {
            runTimeout(drainQueue);
          }
        };

        // v8 likes predictible objects
        function Item(fun, array) {
          this.fun = fun;
          this.array = array;
        }
        Item.prototype.run = function () {
          this.fun.apply(null, this.array);
        };
        process.title = 'browser';
        process.browser = true;
        process.env = {};
        process.argv = [];
        process.version = ''; // empty string to avoid regexp issues
        process.versions = {};

        function noop() {}

        process.on = noop;
        process.addListener = noop;
        process.once = noop;
        process.off = noop;
        process.removeListener = noop;
        process.removeAllListeners = noop;
        process.emit = noop;
        process.prependListener = noop;
        process.prependOnceListener = noop;

        process.listeners = function (name) { return []; };

        process.binding = function (name) {
          throw new Error('process.binding is not supported');
        };

        process.cwd = function () { return '/'; };
        process.chdir = function (dir) {
          throw new Error('process.chdir is not supported');
        };
        process.umask = function () { return 0; };
        /***/ }),

      /***/ 5666:
      /***/ (function (module) {
        /**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

        const runtime = (function (exports) {
          const Op = Object.prototype;
          const hasOwn = Op.hasOwnProperty;
          let undefined; // More compressible than void 0.
          const $Symbol = typeof Symbol === 'function' ? Symbol : {};
          const iteratorSymbol = $Symbol.iterator || '@@iterator';
          const asyncIteratorSymbol = $Symbol.asyncIterator || '@@asyncIterator';
          const toStringTagSymbol = $Symbol.toStringTag || '@@toStringTag';

          function define(obj, key, value) {
            Object.defineProperty(obj, key, {
              value,
              enumerable: true,
              configurable: true,
              writable: true,
            });
            return obj[key];
          }
          try {
            // IE 8 has a broken Object.defineProperty that only works on DOM objects.
            define({}, '');
          } catch (err) {
            define = function (obj, key, value) {
              return obj[key] = value;
            };
          }

          function wrap(innerFn, outerFn, self, tryLocsList) {
            // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
            const protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
            const generator = Object.create(protoGenerator.prototype);
            const context = new Context(tryLocsList || []);

            // The ._invoke method unifies the implementations of the .next,
            // .throw, and .return methods.
            generator._invoke = makeInvokeMethod(innerFn, self, context);

            return generator;
          }
          exports.wrap = wrap;

          // Try/catch helper to minimize deoptimizations. Returns a completion
          // record like context.tryEntries[i].completion. This interface could
          // have been (and was previously) designed to take a closure to be
          // invoked without arguments, but in all the cases we care about we
          // already have an existing method we want to call, so there's no need
          // to create a new function object. We can even get away with assuming
          // the method takes exactly one argument, since that happens to be true
          // in every case, so we don't have to touch the arguments object. The
          // only additional allocation required is the completion record, which
          // has a stable shape and so hopefully should be cheap to allocate.
          function tryCatch(fn, obj, arg) {
            try {
              return { type: 'normal', arg: fn.call(obj, arg) };
            } catch (err) {
              return { type: 'throw', arg: err };
            }
          }

          const GenStateSuspendedStart = 'suspendedStart';
          const GenStateSuspendedYield = 'suspendedYield';
          const GenStateExecuting = 'executing';
          const GenStateCompleted = 'completed';

          // Returning this object from the innerFn has the same effect as
          // breaking out of the dispatch switch statement.
          const ContinueSentinel = {};

          // Dummy constructor functions that we use as the .constructor and
          // .constructor.prototype properties for functions that return Generator
          // objects. For full spec compliance, you may wish to configure your
          // minifier not to mangle the names of these two functions.
          function Generator() {}
          function GeneratorFunction() {}
          function GeneratorFunctionPrototype() {}

          // This is a polyfill for %IteratorPrototype% for environments that
          // don't natively support it.
          let IteratorPrototype = {};
          define(IteratorPrototype, iteratorSymbol, function () {
            return this;
          });

          const getProto = Object.getPrototypeOf;
          const NativeIteratorPrototype = getProto && getProto(getProto(values([])));
          if (NativeIteratorPrototype
      && NativeIteratorPrototype !== Op
      && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
            // This environment has a native %IteratorPrototype%; use it instead
            // of the polyfill.
            IteratorPrototype = NativeIteratorPrototype;
          }

          const Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
          GeneratorFunction.prototype = GeneratorFunctionPrototype;
          define(Gp, 'constructor', GeneratorFunctionPrototype);
          define(GeneratorFunctionPrototype, 'constructor', GeneratorFunction);
          GeneratorFunction.displayName = define(
            GeneratorFunctionPrototype,
            toStringTagSymbol,
            'GeneratorFunction',
          );

          // Helper for defining the .next, .throw, and .return methods of the
          // Iterator interface in terms of a single ._invoke method.
          function defineIteratorMethods(prototype) {
            ['next', 'throw', 'return'].forEach((method) => {
              define(prototype, method, function (arg) {
                return this._invoke(method, arg);
              });
            });
          }

          exports.isGeneratorFunction = function (genFun) {
            const ctor = typeof genFun === 'function' && genFun.constructor;
            return ctor
              ? ctor === GeneratorFunction
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        || (ctor.displayName || ctor.name) === 'GeneratorFunction'
              : false;
          };

          exports.mark = function (genFun) {
            if (Object.setPrototypeOf) {
              Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
            } else {
              genFun.__proto__ = GeneratorFunctionPrototype;
              define(genFun, toStringTagSymbol, 'GeneratorFunction');
            }
            genFun.prototype = Object.create(Gp);
            return genFun;
          };

          // Within the body of any async function, `await x` is transformed to
          // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
          // `hasOwn.call(value, "__await")` to determine if the yielded value is
          // meant to be awaited.
          exports.awrap = function (arg) {
            return { __await: arg };
          };

          function AsyncIterator(generator, PromiseImpl) {
            function invoke(method, arg, resolve, reject) {
              const record = tryCatch(generator[method], generator, arg);
              if (record.type === 'throw') {
                reject(record.arg);
              } else {
                const result = record.arg;
                const { value } = result;
                if (value
            && typeof value === 'object'
            && hasOwn.call(value, '__await')) {
                  return PromiseImpl.resolve(value.__await).then((value) => {
                    invoke('next', value, resolve, reject);
                  }, (err) => {
                    invoke('throw', err, resolve, reject);
                  });
                }

                return PromiseImpl.resolve(value).then((unwrapped) => {
                  // When a yielded Promise is resolved, its final value becomes
                  // the .value of the Promise<{value,done}> result for the
                  // current iteration.
                  result.value = unwrapped;
                  resolve(result);
                }, (error) =>
                // If a rejected Promise was yielded, throw the rejection back
                // into the async generator function so it can be handled there.
                  invoke('throw', error, resolve, reject));
              }
            }

            let previousPromise;

            function enqueue(method, arg) {
              function callInvokeWithMethodAndArg() {
                return new PromiseImpl(((resolve, reject) => {
                  invoke(method, arg, resolve, reject);
                }));
              }

              return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg,
        ) : callInvokeWithMethodAndArg();
            }

            // Define the unified helper method that is used to implement .next,
            // .throw, and .return (see defineIteratorMethods).
            this._invoke = enqueue;
          }

          defineIteratorMethods(AsyncIterator.prototype);
          define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
            return this;
          });
          exports.AsyncIterator = AsyncIterator;

          // Note that simple async functions are implemented on top of
          // AsyncIterator objects; they just return a Promise for the value of
          // the final result produced by the iterator.
          exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
            if (PromiseImpl === void 0) PromiseImpl = Promise;

            const iter = new AsyncIterator(
              wrap(innerFn, outerFn, self, tryLocsList),
              PromiseImpl,
            );

            return exports.isGeneratorFunction(outerFn)
              ? iter // If outerFn is a generator, return the full iterator.
              : iter.next().then((result) => (result.done ? result.value : iter.next()));
          };

          function makeInvokeMethod(innerFn, self, context) {
            let state = GenStateSuspendedStart;

            return function invoke(method, arg) {
              if (state === GenStateExecuting) {
                throw new Error('Generator is already running');
              }

              if (state === GenStateCompleted) {
                if (method === 'throw') {
                  throw arg;
                }

                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
              }

              context.method = method;
              context.arg = arg;

              while (true) {
                const { delegate } = context;
                if (delegate) {
                  const delegateResult = maybeInvokeDelegate(delegate, context);
                  if (delegateResult) {
                    if (delegateResult === ContinueSentinel) continue;
                    return delegateResult;
                  }
                }

                if (context.method === 'next') {
                  // Setting context._sent for legacy support of Babel's
                  // function.sent implementation.
                  context.sent = context._sent = context.arg;
                } else if (context.method === 'throw') {
                  if (state === GenStateSuspendedStart) {
                    state = GenStateCompleted;
                    throw context.arg;
                  }

                  context.dispatchException(context.arg);
                } else if (context.method === 'return') {
                  context.abrupt('return', context.arg);
                }

                state = GenStateExecuting;

                const record = tryCatch(innerFn, self, context);
                if (record.type === 'normal') {
                  // If an exception is thrown from innerFn, we leave state ===
                  // GenStateExecuting and loop back for another invocation.
                  state = context.done
                    ? GenStateCompleted
                    : GenStateSuspendedYield;

                  if (record.arg === ContinueSentinel) {
                    continue;
                  }

                  return {
                    value: record.arg,
                    done: context.done,
                  };
                } if (record.type === 'throw') {
                  state = GenStateCompleted;
                  // Dispatch the exception by looping back around to the
                  // context.dispatchException(context.arg) call above.
                  context.method = 'throw';
                  context.arg = record.arg;
                }
              }
            };
          }

          // Call delegate.iterator[context.method](context.arg) and handle the
          // result, either by returning a { value, done } result from the
          // delegate iterator, or by modifying context.method and context.arg,
          // setting context.delegate to null, and returning the ContinueSentinel.
          function maybeInvokeDelegate(delegate, context) {
            const method = delegate.iterator[context.method];
            if (method === undefined) {
              // A .throw or .return when the delegate iterator has no .throw
              // method always terminates the yield* loop.
              context.delegate = null;

              if (context.method === 'throw') {
                // Note: ["return"] must be used for ES3 parsing compatibility.
                if (delegate.iterator.return) {
                  // If the delegate iterator has a return method, give it a
                  // chance to clean up.
                  context.method = 'return';
                  context.arg = undefined;
                  maybeInvokeDelegate(delegate, context);

                  if (context.method === 'throw') {
                    // If maybeInvokeDelegate(context) changed context.method from
                    // "return" to "throw", let that override the TypeError below.
                    return ContinueSentinel;
                  }
                }

                context.method = 'throw';
                context.arg = new TypeError(
                  "The iterator does not provide a 'throw' method",
                );
              }

              return ContinueSentinel;
            }

            const record = tryCatch(method, delegate.iterator, context.arg);

            if (record.type === 'throw') {
              context.method = 'throw';
              context.arg = record.arg;
              context.delegate = null;
              return ContinueSentinel;
            }

            const info = record.arg;

            if (! info) {
              context.method = 'throw';
              context.arg = new TypeError('iterator result is not an object');
              context.delegate = null;
              return ContinueSentinel;
            }

            if (info.done) {
              // Assign the result of the finished delegate to the temporary
              // variable specified by delegate.resultName (see delegateYield).
              context[delegate.resultName] = info.value;

              // Resume execution at the desired location (see delegateYield).
              context.next = delegate.nextLoc;

              // If context.method was "throw" but the delegate handled the
              // exception, let the outer generator proceed normally. If
              // context.method was "next", forget context.arg since it has been
              // "consumed" by the delegate iterator. If context.method was
              // "return", allow the original .return call to continue in the
              // outer generator.
              if (context.method !== 'return') {
                context.method = 'next';
                context.arg = undefined;
              }
            } else {
              // Re-yield the result returned by the delegate method.
              return info;
            }

            // The delegate iterator is finished, so forget it and continue with
            // the outer generator.
            context.delegate = null;
            return ContinueSentinel;
          }

          // Define Generator.prototype.{next,throw,return} in terms of the
          // unified ._invoke helper method.
          defineIteratorMethods(Gp);

          define(Gp, toStringTagSymbol, 'Generator');

          // A Generator should always return itself as the iterator object when the
          // @@iterator function is called on it. Some browsers' implementations of the
          // iterator prototype chain incorrectly implement this, causing the Generator
          // object to not be returned from this call. This ensures that doesn't happen.
          // See https://github.com/facebook/regenerator/issues/274 for more details.
          define(Gp, iteratorSymbol, function () {
            return this;
          });

          define(Gp, 'toString', () => '[object Generator]');

          function pushTryEntry(locs) {
            const entry = { tryLoc: locs[0] };

            if (1 in locs) {
              entry.catchLoc = locs[1];
            }

            if (2 in locs) {
              entry.finallyLoc = locs[2];
              entry.afterLoc = locs[3];
            }

            this.tryEntries.push(entry);
          }

          function resetTryEntry(entry) {
            const record = entry.completion || {};
            record.type = 'normal';
            delete record.arg;
            entry.completion = record;
          }

          function Context(tryLocsList) {
            // The root entry object (effectively a try statement without a catch
            // or a finally block) gives us a place to store values thrown from
            // locations where there is no enclosing try statement.
            this.tryEntries = [{ tryLoc: 'root' }];
            tryLocsList.forEach(pushTryEntry, this);
            this.reset(true);
          }

          exports.keys = function (object) {
            const keys = [];
            for (const key in object) {
              keys.push(key);
            }
            keys.reverse();

            // Rather than returning an object with a next method, we keep
            // things simple and return the next function itself.
            return function next() {
              while (keys.length) {
                const key = keys.pop();
                if (key in object) {
                  next.value = key;
                  next.done = false;
                  return next;
                }
              }

              // To avoid creating an additional object, we just hang the .value
              // and .done properties off the next function object itself. This
              // also ensures that the minifier will not anonymize the function.
              next.done = true;
              return next;
            };
          };

          function values(iterable) {
            if (iterable) {
              const iteratorMethod = iterable[iteratorSymbol];
              if (iteratorMethod) {
                return iteratorMethod.call(iterable);
              }

              if (typeof iterable.next === 'function') {
                return iterable;
              }

              if (!isNaN(iterable.length)) {
                let i = -1; const
                  next = function next() {
                    while (++i < iterable.length) {
                      if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                      }
                    }

                    next.value = undefined;
                    next.done = true;

                    return next;
                  };

                return next.next = next;
              }
            }

            // Return an iterator with no values.
            return { next: doneResult };
          }
          exports.values = values;

          function doneResult() {
            return { value: undefined, done: true };
          }

          Context.prototype = {
            constructor: Context,

            reset(skipTempReset) {
              this.prev = 0;
              this.next = 0;
              // Resetting context._sent for legacy support of Babel's
              // function.sent implementation.
              this.sent = this._sent = undefined;
              this.done = false;
              this.delegate = null;

              this.method = 'next';
              this.arg = undefined;

              this.tryEntries.forEach(resetTryEntry);

              if (!skipTempReset) {
                for (const name in this) {
                  // Not sure about the optimal order of these conditions:
                  if (name.charAt(0) === 't'
              && hasOwn.call(this, name)
              && !isNaN(+name.slice(1))) {
                    this[name] = undefined;
                  }
                }
              }
            },

            stop() {
              this.done = true;

              const rootEntry = this.tryEntries[0];
              const rootRecord = rootEntry.completion;
              if (rootRecord.type === 'throw') {
                throw rootRecord.arg;
              }

              return this.rval;
            },

            dispatchException(exception) {
              if (this.done) {
                throw exception;
              }

              const context = this;
              function handle(loc, caught) {
                record.type = 'throw';
                record.arg = exception;
                context.next = loc;

                if (caught) {
                  // If the dispatched exception was caught by a catch block,
                  // then let that catch block handle the exception normally.
                  context.method = 'next';
                  context.arg = undefined;
                }

                return !! caught;
              }

              for (let i = this.tryEntries.length - 1; i >= 0; --i) {
                const entry = this.tryEntries[i];
                var record = entry.completion;

                if (entry.tryLoc === 'root') {
                  // Exception thrown outside of any try block that could handle
                  // it, so set the completion value of the entire function to
                  // throw the exception.
                  return handle('end');
                }

                if (entry.tryLoc <= this.prev) {
                  const hasCatch = hasOwn.call(entry, 'catchLoc');
                  const hasFinally = hasOwn.call(entry, 'finallyLoc');

                  if (hasCatch && hasFinally) {
                    if (this.prev < entry.catchLoc) {
                      return handle(entry.catchLoc, true);
                    } if (this.prev < entry.finallyLoc) {
                      return handle(entry.finallyLoc);
                    }
                  } else if (hasCatch) {
                    if (this.prev < entry.catchLoc) {
                      return handle(entry.catchLoc, true);
                    }
                  } else if (hasFinally) {
                    if (this.prev < entry.finallyLoc) {
                      return handle(entry.finallyLoc);
                    }
                  } else {
                    throw new Error('try statement without catch or finally');
                  }
                }
              }
            },

            abrupt(type, arg) {
              for (let i = this.tryEntries.length - 1; i >= 0; --i) {
                const entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev
            && hasOwn.call(entry, 'finallyLoc')
            && this.prev < entry.finallyLoc) {
                  var finallyEntry = entry;
                  break;
                }
              }

              if (finallyEntry
          && (type === 'break'
           || type === 'continue')
          && finallyEntry.tryLoc <= arg
          && arg <= finallyEntry.finallyLoc) {
                // Ignore the finally entry if control is not jumping to a
                // location outside the try/catch block.
                finallyEntry = null;
              }

              const record = finallyEntry ? finallyEntry.completion : {};
              record.type = type;
              record.arg = arg;

              if (finallyEntry) {
                this.method = 'next';
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
              }

              return this.complete(record);
            },

            complete(record, afterLoc) {
              if (record.type === 'throw') {
                throw record.arg;
              }

              if (record.type === 'break'
          || record.type === 'continue') {
                this.next = record.arg;
              } else if (record.type === 'return') {
                this.rval = this.arg = record.arg;
                this.method = 'return';
                this.next = 'end';
              } else if (record.type === 'normal' && afterLoc) {
                this.next = afterLoc;
              }

              return ContinueSentinel;
            },

            finish(finallyLoc) {
              for (let i = this.tryEntries.length - 1; i >= 0; --i) {
                const entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                  this.complete(entry.completion, entry.afterLoc);
                  resetTryEntry(entry);
                  return ContinueSentinel;
                }
              }
            },

            catch(tryLoc) {
              for (let i = this.tryEntries.length - 1; i >= 0; --i) {
                const entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                  const record = entry.completion;
                  if (record.type === 'throw') {
                    var thrown = record.arg;
                    resetTryEntry(entry);
                  }
                  return thrown;
                }
              }

              // The context.catch method must only be called with a location
              // argument that corresponds to a known catch block.
              throw new Error('illegal catch attempt');
            },

            delegateYield(iterable, resultName, nextLoc) {
              this.delegate = {
                iterator: values(iterable),
                resultName,
                nextLoc,
              };

              if (this.method === 'next') {
                // Deliberately forget the last sent value so that we don't
                // accidentally pass it on to the delegate.
                this.arg = undefined;
              }

              return ContinueSentinel;
            },
          };

          // Regardless of whether this script is executing as a CommonJS module
          // or not, return the runtime object so that we can declare the variable
          // regeneratorRuntime in the outer scope, which allows this module to be
          // injected easily by `bin/regenerator --include-runtime script.js`.
          return exports;
        }(
          // If this script is executing as a CommonJS module, use module.exports
          // as the regeneratorRuntime namespace. Otherwise create a new empty
          // object. Either way, the resulting object will be used to initialize
          // the regeneratorRuntime variable at the top of this file.
          true ? module.exports : 0,
        ));

        try {
          regeneratorRuntime = runtime;
        } catch (accidentalStrictMode) {
          // This module should not be running in strict mode, so the above
          // assignment should always work unless something is misconfigured. Just
          // in case runtime.js accidentally runs in strict mode, in modern engines
          // we can explicitly access globalThis. In older engines we can escape
          // strict mode using a global Function call. This could conceivably fail
          // if a Content Security Policy forbids using Function, but in that case
          // the proper solution is to fix the accidental strict mode problem. If
          // you've misconfigured your bundler to force strict mode and applied a
          // CSP to forbid Function, and you're not willing to fix either of those
          // problems, please detail your unique predicament in a GitHub issue.
          if (typeof globalThis === 'object') {
            globalThis.regeneratorRuntime = runtime;
          } else {
            Function('r', 'regeneratorRuntime = r')(runtime);
          }
        }
        /***/ }),

      /***/ 3697:
      /***/ (function (module) {
        const $Object = Object;
        const $TypeError = TypeError;

        module.exports = function flags() {
          if (this != null && this !== $Object(this)) {
            throw new $TypeError('RegExp.prototype.flags getter called on non-object');
          }
          let result = '';
          if (this.global) {
            result += 'g';
          }
          if (this.ignoreCase) {
            result += 'i';
          }
          if (this.multiline) {
            result += 'm';
          }
          if (this.dotAll) {
            result += 's';
          }
          if (this.unicode) {
            result += 'u';
          }
          if (this.sticky) {
            result += 'y';
          }
          return result;
        };
        /***/ }),

      /***/ 2847:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const define = __webpack_require__(4289);
        const callBind = __webpack_require__(5559);

        const implementation = __webpack_require__(3697);
        const getPolyfill = __webpack_require__(1721);
        const shim = __webpack_require__(2753);

        const flagsBound = callBind(implementation);

        define(flagsBound, {
          getPolyfill,
          implementation,
          shim,
        });

        module.exports = flagsBound;
        /***/ }),

      /***/ 1721:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const implementation = __webpack_require__(3697);

        const { supportsDescriptors } = __webpack_require__(4289);
        const $gOPD = Object.getOwnPropertyDescriptor;
        const $TypeError = TypeError;

        module.exports = function getPolyfill() {
          if (!supportsDescriptors) {
            throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
          }
          if ((/a/mig).flags === 'gim') {
            const descriptor = $gOPD(RegExp.prototype, 'flags');
            if (descriptor && typeof descriptor.get === 'function' && typeof (/a/).dotAll === 'boolean') {
              return descriptor.get;
            }
          }
          return implementation;
        };
        /***/ }),

      /***/ 2753:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const { supportsDescriptors } = __webpack_require__(4289);
        const getPolyfill = __webpack_require__(1721);
        const gOPD = Object.getOwnPropertyDescriptor;
        const { defineProperty } = Object;
        const TypeErr = TypeError;
        const getProto = Object.getPrototypeOf;
        const regex = /a/;

        module.exports = function shimFlags() {
          if (!supportsDescriptors || !getProto) {
            throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
          }
          const polyfill = getPolyfill();
          const proto = getProto(regex);
          const descriptor = gOPD(proto, 'flags');
          if (!descriptor || descriptor.get !== polyfill) {
            defineProperty(proto, 'flags', {
              configurable: true,
              enumerable: false,
              get: polyfill,
            });
          }
          return polyfill;
        };
        /***/ }),

      /***/ 6099:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        /* provided dependency */ const { Buffer } = __webpack_require__(8823);
        (function (sax) { // wrapper for non-node envs
          sax.parser = function (strict, opt) { return new SAXParser(strict, opt); };
          sax.SAXParser = SAXParser;
          sax.SAXStream = SAXStream;
          sax.createStream = createStream;

          // When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
          // When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
          // since that's the earliest that a buffer overrun could occur.  This way, checks are
          // as rare as required, but as often as necessary to ensure never crossing this bound.
          // Furthermore, buffers are only tested at most once per write(), so passing a very
          // large string into write() might have undesirable effects, but this is manageable by
          // the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
          // edge case, result in creating at most one complete copy of the string passed in.
          // Set to Infinity to have unlimited buffers.
          sax.MAX_BUFFER_LENGTH = 64 * 1024;

          const buffers = [
            'comment', 'sgmlDecl', 'textNode', 'tagName', 'doctype',
            'procInstName', 'procInstBody', 'entity', 'attribName',
            'attribValue', 'cdata', 'script',
          ];

          sax.EVENTS = [
            'text',
            'processinginstruction',
            'sgmldeclaration',
            'doctype',
            'comment',
            'opentagstart',
            'attribute',
            'opentag',
            'closetag',
            'opencdata',
            'cdata',
            'closecdata',
            'error',
            'end',
            'ready',
            'script',
            'opennamespace',
            'closenamespace',
          ];

          function SAXParser(strict, opt) {
            if (!(this instanceof SAXParser)) {
              return new SAXParser(strict, opt);
            }

            const parser = this;
            clearBuffers(parser);
            parser.q = parser.c = '';
            parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH;
            parser.opt = opt || {};
            parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags;
            parser.looseCase = parser.opt.lowercase ? 'toLowerCase' : 'toUpperCase';
            parser.tags = [];
            parser.closed = parser.closedRoot = parser.sawRoot = false;
            parser.tag = parser.error = null;
            parser.strict = !!strict;
            parser.noscript = !!(strict || parser.opt.noscript);
            parser.state = S.BEGIN;
            parser.strictEntities = parser.opt.strictEntities;
            parser.ENTITIES = parser.strictEntities ? Object.create(sax.XML_ENTITIES) : Object.create(sax.ENTITIES);
            parser.attribList = [];

            // namespaces form a prototype chain.
            // it always points at the current tag,
            // which protos to its parent tag.
            if (parser.opt.xmlns) {
              parser.ns = Object.create(rootNS);
            }

            // mostly just for error reporting
            parser.trackPosition = parser.opt.position !== false;
            if (parser.trackPosition) {
              parser.position = parser.line = parser.column = 0;
            }
            emit(parser, 'onready');
          }

          if (!Object.create) {
            Object.create = function (o) {
              function F() {}
              F.prototype = o;
              const newf = new F();
              return newf;
            };
          }

          if (!Object.keys) {
            Object.keys = function (o) {
              const a = [];
              for (const i in o) if (o.hasOwnProperty(i)) a.push(i);
              return a;
            };
          }

          function checkBufferLength(parser) {
            const maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10);
            let maxActual = 0;
            for (let i = 0, l = buffers.length; i < l; i++) {
              const len = parser[buffers[i]].length;
              if (len > maxAllowed) {
                // Text/cdata nodes can get big, and since they're buffered,
                // we can get here under normal conditions.
                // Avoid issues by emitting the text node now,
                // so at least it won't get any bigger.
                switch (buffers[i]) {
                  case 'textNode':
                    closeText(parser);
                    break;

                  case 'cdata':
                    emitNode(parser, 'oncdata', parser.cdata);
                    parser.cdata = '';
                    break;

                  case 'script':
                    emitNode(parser, 'onscript', parser.script);
                    parser.script = '';
                    break;

                  default:
                    error(parser, `Max buffer length exceeded: ${buffers[i]}`);
                }
              }
              maxActual = Math.max(maxActual, len);
            }
            // schedule the next check for the earliest possible buffer overrun.
            const m = sax.MAX_BUFFER_LENGTH - maxActual;
            parser.bufferCheckPosition = m + parser.position;
          }

          function clearBuffers(parser) {
            for (let i = 0, l = buffers.length; i < l; i++) {
              parser[buffers[i]] = '';
            }
          }

          function flushBuffers(parser) {
            closeText(parser);
            if (parser.cdata !== '') {
              emitNode(parser, 'oncdata', parser.cdata);
              parser.cdata = '';
            }
            if (parser.script !== '') {
              emitNode(parser, 'onscript', parser.script);
              parser.script = '';
            }
          }

          SAXParser.prototype = {
            end() { end(this); },
            write,
            resume() { this.error = null; return this; },
            close() { return this.write(null); },
            flush() { flushBuffers(this); },
          };

          let Stream;
          try {
            Stream = (__webpack_require__(2830).Stream);
          } catch (ex) {
            Stream = function () {};
          }

          const streamWraps = sax.EVENTS.filter((ev) => ev !== 'error' && ev !== 'end');

          function createStream(strict, opt) {
            return new SAXStream(strict, opt);
          }

          function SAXStream(strict, opt) {
            if (!(this instanceof SAXStream)) {
              return new SAXStream(strict, opt);
            }

            Stream.apply(this);

            this._parser = new SAXParser(strict, opt);
            this.writable = true;
            this.readable = true;

            const me = this;

            this._parser.onend = function () {
              me.emit('end');
            };

            this._parser.onerror = function (er) {
              me.emit('error', er);

              // if didn't throw, then means error was handled.
              // go ahead and clear error, so we can write again.
              me._parser.error = null;
            };

            this._decoder = null;

            streamWraps.forEach((ev) => {
              Object.defineProperty(me, `on${ev}`, {
                get() {
                  return me._parser[`on${ev}`];
                },
                set(h) {
                  if (!h) {
                    me.removeAllListeners(ev);
                    me._parser[`on${ev}`] = h;
                    return h;
                  }
                  me.on(ev, h);
                },
                enumerable: true,
                configurable: false,
              });
            });
          }

          SAXStream.prototype = Object.create(Stream.prototype, {
            constructor: {
              value: SAXStream,
            },
          });

          SAXStream.prototype.write = function (data) {
            if (typeof Buffer === 'function'
      && typeof Buffer.isBuffer === 'function'
      && Buffer.isBuffer(data)) {
              if (!this._decoder) {
                const SD = (__webpack_require__(2553).s);
                this._decoder = new SD('utf8');
              }
              data = this._decoder.write(data);
            }

            this._parser.write(data.toString());
            this.emit('data', data);
            return true;
          };

          SAXStream.prototype.end = function (chunk) {
            if (chunk && chunk.length) {
              this.write(chunk);
            }
            this._parser.end();
            return true;
          };

          SAXStream.prototype.on = function (ev, handler) {
            const me = this;
            if (!me._parser[`on${ev}`] && streamWraps.indexOf(ev) !== -1) {
              me._parser[`on${ev}`] = function () {
                const args = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments);
                args.splice(0, 0, ev);
                me.emit.apply(me, args);
              };
            }

            return Stream.prototype.on.call(me, ev, handler);
          };

          // this really needs to be replaced with character classes.
          // XML allows all manner of ridiculous numbers and digits.
          const CDATA = '[CDATA[';
          const DOCTYPE = 'DOCTYPE';
          const XML_NAMESPACE = 'http://www.w3.org/XML/1998/namespace';
          const XMLNS_NAMESPACE = 'http://www.w3.org/2000/xmlns/';
          var rootNS = { xml: XML_NAMESPACE, xmlns: XMLNS_NAMESPACE };

          // http://www.w3.org/TR/REC-xml/#NT-NameStartChar
          // This implementation works on strings, a single character at a time
          // as such, it cannot ever support astral-plane characters (10000-EFFFF)
          // without a significant breaking change to either this  parser, or the
          // JavaScript language.  Implementation of an emoji-capable xml parser
          // is left as an exercise for the reader.
          const nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;

          const nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;

          const entityStart = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
          const entityBody = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;

          function isWhitespace(c) {
            return c === ' ' || c === '\n' || c === '\r' || c === '\t';
          }

          function isQuote(c) {
            return c === '"' || c === '\'';
          }

          function isAttribEnd(c) {
            return c === '>' || isWhitespace(c);
          }

          function isMatch(regex, c) {
            return regex.test(c);
          }

          function notMatch(regex, c) {
            return !isMatch(regex, c);
          }

          var S = 0;
          sax.STATE = {
            BEGIN: S++, // leading byte order mark or whitespace
            BEGIN_WHITESPACE: S++, // leading whitespace
            TEXT: S++, // general stuff
            TEXT_ENTITY: S++, // &amp and such.
            OPEN_WAKA: S++, // <
            SGML_DECL: S++, // <!BLARG
            SGML_DECL_QUOTED: S++, // <!BLARG foo "bar
            DOCTYPE: S++, // <!DOCTYPE
            DOCTYPE_QUOTED: S++, // <!DOCTYPE "//blah
            DOCTYPE_DTD: S++, // <!DOCTYPE "//blah" [ ...
            DOCTYPE_DTD_QUOTED: S++, // <!DOCTYPE "//blah" [ "foo
            COMMENT_STARTING: S++, // <!-
            COMMENT: S++, // <!--
            COMMENT_ENDING: S++, // <!-- blah -
            COMMENT_ENDED: S++, // <!-- blah --
            CDATA: S++, // <![CDATA[ something
            CDATA_ENDING: S++, // ]
            CDATA_ENDING_2: S++, // ]]
            PROC_INST: S++, // <?hi
            PROC_INST_BODY: S++, // <?hi there
            PROC_INST_ENDING: S++, // <?hi "there" ?
            OPEN_TAG: S++, // <strong
            OPEN_TAG_SLASH: S++, // <strong /
            ATTRIB: S++, // <a
            ATTRIB_NAME: S++, // <a foo
            ATTRIB_NAME_SAW_WHITE: S++, // <a foo _
            ATTRIB_VALUE: S++, // <a foo=
            ATTRIB_VALUE_QUOTED: S++, // <a foo="bar
            ATTRIB_VALUE_CLOSED: S++, // <a foo="bar"
            ATTRIB_VALUE_UNQUOTED: S++, // <a foo=bar
            ATTRIB_VALUE_ENTITY_Q: S++, // <foo bar="&quot;"
            ATTRIB_VALUE_ENTITY_U: S++, // <foo bar=&quot
            CLOSE_TAG: S++, // </a
            CLOSE_TAG_SAW_WHITE: S++, // </a   >
            SCRIPT: S++, // <script> ...
            SCRIPT_ENDING: S++, // <script> ... <
          };

          sax.XML_ENTITIES = {
            amp: '&',
            gt: '>',
            lt: '<',
            quot: '"',
            apos: "'",
          };

          sax.ENTITIES = {
            amp: '&',
            gt: '>',
            lt: '<',
            quot: '"',
            apos: "'",
            AElig: 198,
            Aacute: 193,
            Acirc: 194,
            Agrave: 192,
            Aring: 197,
            Atilde: 195,
            Auml: 196,
            Ccedil: 199,
            ETH: 208,
            Eacute: 201,
            Ecirc: 202,
            Egrave: 200,
            Euml: 203,
            Iacute: 205,
            Icirc: 206,
            Igrave: 204,
            Iuml: 207,
            Ntilde: 209,
            Oacute: 211,
            Ocirc: 212,
            Ograve: 210,
            Oslash: 216,
            Otilde: 213,
            Ouml: 214,
            THORN: 222,
            Uacute: 218,
            Ucirc: 219,
            Ugrave: 217,
            Uuml: 220,
            Yacute: 221,
            aacute: 225,
            acirc: 226,
            aelig: 230,
            agrave: 224,
            aring: 229,
            atilde: 227,
            auml: 228,
            ccedil: 231,
            eacute: 233,
            ecirc: 234,
            egrave: 232,
            eth: 240,
            euml: 235,
            iacute: 237,
            icirc: 238,
            igrave: 236,
            iuml: 239,
            ntilde: 241,
            oacute: 243,
            ocirc: 244,
            ograve: 242,
            oslash: 248,
            otilde: 245,
            ouml: 246,
            szlig: 223,
            thorn: 254,
            uacute: 250,
            ucirc: 251,
            ugrave: 249,
            uuml: 252,
            yacute: 253,
            yuml: 255,
            copy: 169,
            reg: 174,
            nbsp: 160,
            iexcl: 161,
            cent: 162,
            pound: 163,
            curren: 164,
            yen: 165,
            brvbar: 166,
            sect: 167,
            uml: 168,
            ordf: 170,
            laquo: 171,
            not: 172,
            shy: 173,
            macr: 175,
            deg: 176,
            plusmn: 177,
            sup1: 185,
            sup2: 178,
            sup3: 179,
            acute: 180,
            micro: 181,
            para: 182,
            middot: 183,
            cedil: 184,
            ordm: 186,
            raquo: 187,
            frac14: 188,
            frac12: 189,
            frac34: 190,
            iquest: 191,
            times: 215,
            divide: 247,
            OElig: 338,
            oelig: 339,
            Scaron: 352,
            scaron: 353,
            Yuml: 376,
            fnof: 402,
            circ: 710,
            tilde: 732,
            Alpha: 913,
            Beta: 914,
            Gamma: 915,
            Delta: 916,
            Epsilon: 917,
            Zeta: 918,
            Eta: 919,
            Theta: 920,
            Iota: 921,
            Kappa: 922,
            Lambda: 923,
            Mu: 924,
            Nu: 925,
            Xi: 926,
            Omicron: 927,
            Pi: 928,
            Rho: 929,
            Sigma: 931,
            Tau: 932,
            Upsilon: 933,
            Phi: 934,
            Chi: 935,
            Psi: 936,
            Omega: 937,
            alpha: 945,
            beta: 946,
            gamma: 947,
            delta: 948,
            epsilon: 949,
            zeta: 950,
            eta: 951,
            theta: 952,
            iota: 953,
            kappa: 954,
            lambda: 955,
            mu: 956,
            nu: 957,
            xi: 958,
            omicron: 959,
            pi: 960,
            rho: 961,
            sigmaf: 962,
            sigma: 963,
            tau: 964,
            upsilon: 965,
            phi: 966,
            chi: 967,
            psi: 968,
            omega: 969,
            thetasym: 977,
            upsih: 978,
            piv: 982,
            ensp: 8194,
            emsp: 8195,
            thinsp: 8201,
            zwnj: 8204,
            zwj: 8205,
            lrm: 8206,
            rlm: 8207,
            ndash: 8211,
            mdash: 8212,
            lsquo: 8216,
            rsquo: 8217,
            sbquo: 8218,
            ldquo: 8220,
            rdquo: 8221,
            bdquo: 8222,
            dagger: 8224,
            Dagger: 8225,
            bull: 8226,
            hellip: 8230,
            permil: 8240,
            prime: 8242,
            Prime: 8243,
            lsaquo: 8249,
            rsaquo: 8250,
            oline: 8254,
            frasl: 8260,
            euro: 8364,
            image: 8465,
            weierp: 8472,
            real: 8476,
            trade: 8482,
            alefsym: 8501,
            larr: 8592,
            uarr: 8593,
            rarr: 8594,
            darr: 8595,
            harr: 8596,
            crarr: 8629,
            lArr: 8656,
            uArr: 8657,
            rArr: 8658,
            dArr: 8659,
            hArr: 8660,
            forall: 8704,
            part: 8706,
            exist: 8707,
            empty: 8709,
            nabla: 8711,
            isin: 8712,
            notin: 8713,
            ni: 8715,
            prod: 8719,
            sum: 8721,
            minus: 8722,
            lowast: 8727,
            radic: 8730,
            prop: 8733,
            infin: 8734,
            ang: 8736,
            and: 8743,
            or: 8744,
            cap: 8745,
            cup: 8746,
            int: 8747,
            there4: 8756,
            sim: 8764,
            cong: 8773,
            asymp: 8776,
            ne: 8800,
            equiv: 8801,
            le: 8804,
            ge: 8805,
            sub: 8834,
            sup: 8835,
            nsub: 8836,
            sube: 8838,
            supe: 8839,
            oplus: 8853,
            otimes: 8855,
            perp: 8869,
            sdot: 8901,
            lceil: 8968,
            rceil: 8969,
            lfloor: 8970,
            rfloor: 8971,
            lang: 9001,
            rang: 9002,
            loz: 9674,
            spades: 9824,
            clubs: 9827,
            hearts: 9829,
            diams: 9830,
          };

          Object.keys(sax.ENTITIES).forEach((key) => {
            const e = sax.ENTITIES[key];
            const s = typeof e === 'number' ? String.fromCharCode(e) : e;
            sax.ENTITIES[key] = s;
          });

          for (const s in sax.STATE) {
            sax.STATE[sax.STATE[s]] = s;
          }

          // shorthand
          S = sax.STATE;

          function emit(parser, event, data) {
            parser[event] && parser[event](data);
          }

          function emitNode(parser, nodeType, data) {
            if (parser.textNode) closeText(parser);
            emit(parser, nodeType, data);
          }

          function closeText(parser) {
            parser.textNode = textopts(parser.opt, parser.textNode);
            if (parser.textNode) emit(parser, 'ontext', parser.textNode);
            parser.textNode = '';
          }

          function textopts(opt, text) {
            if (opt.trim) text = text.trim();
            if (opt.normalize) text = text.replace(/\s+/g, ' ');
            return text;
          }

          function error(parser, er) {
            closeText(parser);
            if (parser.trackPosition) {
              er += `\nLine: ${parser.line
              }\nColumn: ${parser.column
              }\nChar: ${parser.c}`;
            }
            er = new Error(er);
            parser.error = er;
            emit(parser, 'onerror', er);
            return parser;
          }

          function end(parser) {
            if (parser.sawRoot && !parser.closedRoot) strictFail(parser, 'Unclosed root tag');
            if ((parser.state !== S.BEGIN)
      && (parser.state !== S.BEGIN_WHITESPACE)
      && (parser.state !== S.TEXT)) {
              error(parser, 'Unexpected end');
            }
            closeText(parser);
            parser.c = '';
            parser.closed = true;
            emit(parser, 'onend');
            SAXParser.call(parser, parser.strict, parser.opt);
            return parser;
          }

          function strictFail(parser, message) {
            if (typeof parser !== 'object' || !(parser instanceof SAXParser)) {
              throw new Error('bad call to strictFail');
            }
            if (parser.strict) {
              error(parser, message);
            }
          }

          function newTag(parser) {
            if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]();
            const parent = parser.tags[parser.tags.length - 1] || parser;
            const tag = parser.tag = { name: parser.tagName, attributes: {} };

            // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
            if (parser.opt.xmlns) {
              tag.ns = parent.ns;
            }
            parser.attribList.length = 0;
            emitNode(parser, 'onopentagstart', tag);
          }

          function qname(name, attribute) {
            const i = name.indexOf(':');
            const qualName = i < 0 ? ['', name] : name.split(':');
            let prefix = qualName[0];
            let local = qualName[1];

            // <x "xmlns"="http://foo">
            if (attribute && name === 'xmlns') {
              prefix = 'xmlns';
              local = '';
            }

            return { prefix, local };
          }

          function attrib(parser) {
            if (!parser.strict) {
              parser.attribName = parser.attribName[parser.looseCase]();
            }

            if (parser.attribList.indexOf(parser.attribName) !== -1
      || parser.tag.attributes.hasOwnProperty(parser.attribName)) {
              parser.attribName = parser.attribValue = '';
              return;
            }

            if (parser.opt.xmlns) {
              const qn = qname(parser.attribName, true);
              const { prefix } = qn;
              const { local } = qn;

              if (prefix === 'xmlns') {
                // namespace binding attribute. push the binding into scope
                if (local === 'xml' && parser.attribValue !== XML_NAMESPACE) {
                  strictFail(parser,
                    `xml: prefix must be bound to ${XML_NAMESPACE}\n`
            + `Actual: ${parser.attribValue}`);
                } else if (local === 'xmlns' && parser.attribValue !== XMLNS_NAMESPACE) {
                  strictFail(parser,
                    `xmlns: prefix must be bound to ${XMLNS_NAMESPACE}\n`
            + `Actual: ${parser.attribValue}`);
                } else {
                  const { tag } = parser;
                  const parent = parser.tags[parser.tags.length - 1] || parser;
                  if (tag.ns === parent.ns) {
                    tag.ns = Object.create(parent.ns);
                  }
                  tag.ns[local] = parser.attribValue;
                }
              }

              // defer onattribute events until all attributes have been seen
              // so any new bindings can take effect. preserve attribute order
              // so deferred events can be emitted in document order
              parser.attribList.push([parser.attribName, parser.attribValue]);
            } else {
              // in non-xmlns mode, we can emit the event right away
              parser.tag.attributes[parser.attribName] = parser.attribValue;
              emitNode(parser, 'onattribute', {
                name: parser.attribName,
                value: parser.attribValue,
              });
            }

            parser.attribName = parser.attribValue = '';
          }

          function openTag(parser, selfClosing) {
            if (parser.opt.xmlns) {
              // emit namespace binding events
              const { tag } = parser;

              // add namespace info to tag
              const qn = qname(parser.tagName);
              tag.prefix = qn.prefix;
              tag.local = qn.local;
              tag.uri = tag.ns[qn.prefix] || '';

              if (tag.prefix && !tag.uri) {
                strictFail(parser, `Unbound namespace prefix: ${
                  JSON.stringify(parser.tagName)}`);
                tag.uri = qn.prefix;
              }

              const parent = parser.tags[parser.tags.length - 1] || parser;
              if (tag.ns && parent.ns !== tag.ns) {
                Object.keys(tag.ns).forEach((p) => {
                  emitNode(parser, 'onopennamespace', {
                    prefix: p,
                    uri: tag.ns[p],
                  });
                });
              }

              // handle deferred onattribute events
              // Note: do not apply default ns to attributes:
              //   http://www.w3.org/TR/REC-xml-names/#defaulting
              for (let i = 0, l = parser.attribList.length; i < l; i++) {
                const nv = parser.attribList[i];
                const name = nv[0];
                const value = nv[1];
                const qualName = qname(name, true);
                const { prefix } = qualName;
                const { local } = qualName;
                const uri = prefix === '' ? '' : (tag.ns[prefix] || '');
                const a = {
                  name,
                  value,
                  prefix,
                  local,
                  uri,
                };

                // if there's any attributes with an undefined namespace,
                // then fail on them now.
                if (prefix && prefix !== 'xmlns' && !uri) {
                  strictFail(parser, `Unbound namespace prefix: ${
                    JSON.stringify(prefix)}`);
                  a.uri = prefix;
                }
                parser.tag.attributes[name] = a;
                emitNode(parser, 'onattribute', a);
              }
              parser.attribList.length = 0;
            }

            parser.tag.isSelfClosing = !!selfClosing;

            // process the tag
            parser.sawRoot = true;
            parser.tags.push(parser.tag);
            emitNode(parser, 'onopentag', parser.tag);
            if (!selfClosing) {
              // special case for <script> in non-strict mode.
              if (!parser.noscript && parser.tagName.toLowerCase() === 'script') {
                parser.state = S.SCRIPT;
              } else {
                parser.state = S.TEXT;
              }
              parser.tag = null;
              parser.tagName = '';
            }
            parser.attribName = parser.attribValue = '';
            parser.attribList.length = 0;
          }

          function closeTag(parser) {
            if (!parser.tagName) {
              strictFail(parser, 'Weird empty close tag.');
              parser.textNode += '</>';
              parser.state = S.TEXT;
              return;
            }

            if (parser.script) {
              if (parser.tagName !== 'script') {
                parser.script += `</${parser.tagName}>`;
                parser.tagName = '';
                parser.state = S.SCRIPT;
                return;
              }
              emitNode(parser, 'onscript', parser.script);
              parser.script = '';
            }

            // first make sure that the closing tag actually exists.
            // <a><b></c></b></a> will close everything, otherwise.
            let t = parser.tags.length;
            let { tagName } = parser;
            if (!parser.strict) {
              tagName = tagName[parser.looseCase]();
            }
            const closeTo = tagName;
            while (t--) {
              const close = parser.tags[t];
              if (close.name !== closeTo) {
                // fail the first time in strict mode
                strictFail(parser, 'Unexpected close tag');
              } else {
                break;
              }
            }

            // didn't find it.  we already failed for strict, so just abort.
            if (t < 0) {
              strictFail(parser, `Unmatched closing tag: ${parser.tagName}`);
              parser.textNode += `</${parser.tagName}>`;
              parser.state = S.TEXT;
              return;
            }
            parser.tagName = tagName;
            let s = parser.tags.length;
            while (s-- > t) {
              var tag = parser.tag = parser.tags.pop();
              parser.tagName = parser.tag.name;
              emitNode(parser, 'onclosetag', parser.tagName);

              const x = {};
              for (const i in tag.ns) {
                x[i] = tag.ns[i];
              }

              const parent = parser.tags[parser.tags.length - 1] || parser;
              if (parser.opt.xmlns && tag.ns !== parent.ns) {
                // remove namespace bindings introduced by tag
                Object.keys(tag.ns).forEach((p) => {
                  const n = tag.ns[p];
                  emitNode(parser, 'onclosenamespace', { prefix: p, uri: n });
                });
              }
            }
            if (t === 0) parser.closedRoot = true;
            parser.tagName = parser.attribValue = parser.attribName = '';
            parser.attribList.length = 0;
            parser.state = S.TEXT;
          }

          function parseEntity(parser) {
            let { entity } = parser;
            const entityLC = entity.toLowerCase();
            let num;
            let numStr = '';

            if (parser.ENTITIES[entity]) {
              return parser.ENTITIES[entity];
            }
            if (parser.ENTITIES[entityLC]) {
              return parser.ENTITIES[entityLC];
            }
            entity = entityLC;
            if (entity.charAt(0) === '#') {
              if (entity.charAt(1) === 'x') {
                entity = entity.slice(2);
                num = parseInt(entity, 16);
                numStr = num.toString(16);
              } else {
                entity = entity.slice(1);
                num = parseInt(entity, 10);
                numStr = num.toString(10);
              }
            }
            entity = entity.replace(/^0+/, '');
            if (isNaN(num) || numStr.toLowerCase() !== entity) {
              strictFail(parser, 'Invalid character entity');
              return `&${parser.entity};`;
            }

            return String.fromCodePoint(num);
          }

          function beginWhiteSpace(parser, c) {
            if (c === '<') {
              parser.state = S.OPEN_WAKA;
              parser.startTagPosition = parser.position;
            } else if (!isWhitespace(c)) {
              // have to process this as a text node.
              // weird, but happens.
              strictFail(parser, 'Non-whitespace before first tag.');
              parser.textNode = c;
              parser.state = S.TEXT;
            }
          }

          function charAt(chunk, i) {
            let result = '';
            if (i < chunk.length) {
              result = chunk.charAt(i);
            }
            return result;
          }

          function write(chunk) {
            const parser = this;
            if (this.error) {
              throw this.error;
            }
            if (parser.closed) {
              return error(parser,
                'Cannot write after close. Assign an onready handler.');
            }
            if (chunk === null) {
              return end(parser);
            }
            if (typeof chunk === 'object') {
              chunk = chunk.toString();
            }
            let i = 0;
            let c = '';
            while (true) {
              c = charAt(chunk, i++);
              parser.c = c;

              if (!c) {
                break;
              }

              if (parser.trackPosition) {
                parser.position++;
                if (c === '\n') {
                  parser.line++;
                  parser.column = 0;
                } else {
                  parser.column++;
                }
              }

              switch (parser.state) {
                case S.BEGIN:
                  parser.state = S.BEGIN_WHITESPACE;
                  if (c === '\uFEFF') {
                    continue;
                  }
                  beginWhiteSpace(parser, c);
                  continue;

                case S.BEGIN_WHITESPACE:
                  beginWhiteSpace(parser, c);
                  continue;

                case S.TEXT:
                  if (parser.sawRoot && !parser.closedRoot) {
                    const starti = i - 1;
                    while (c && c !== '<' && c !== '&') {
                      c = charAt(chunk, i++);
                      if (c && parser.trackPosition) {
                        parser.position++;
                        if (c === '\n') {
                          parser.line++;
                          parser.column = 0;
                        } else {
                          parser.column++;
                        }
                      }
                    }
                    parser.textNode += chunk.substring(starti, i - 1);
                  }
                  if (c === '<' && !(parser.sawRoot && parser.closedRoot && !parser.strict)) {
                    parser.state = S.OPEN_WAKA;
                    parser.startTagPosition = parser.position;
                  } else {
                    if (!isWhitespace(c) && (!parser.sawRoot || parser.closedRoot)) {
                      strictFail(parser, 'Text data outside of root node.');
                    }
                    if (c === '&') {
                      parser.state = S.TEXT_ENTITY;
                    } else {
                      parser.textNode += c;
                    }
                  }
                  continue;

                case S.SCRIPT:
                  // only non-strict
                  if (c === '<') {
                    parser.state = S.SCRIPT_ENDING;
                  } else {
                    parser.script += c;
                  }
                  continue;

                case S.SCRIPT_ENDING:
                  if (c === '/') {
                    parser.state = S.CLOSE_TAG;
                  } else {
                    parser.script += `<${c}`;
                    parser.state = S.SCRIPT;
                  }
                  continue;

                case S.OPEN_WAKA:
                  // either a /, ?, !, or text is coming next.
                  if (c === '!') {
                    parser.state = S.SGML_DECL;
                    parser.sgmlDecl = '';
                  } else if (isWhitespace(c)) {
                    // wait for it...
                  } else if (isMatch(nameStart, c)) {
                    parser.state = S.OPEN_TAG;
                    parser.tagName = c;
                  } else if (c === '/') {
                    parser.state = S.CLOSE_TAG;
                    parser.tagName = '';
                  } else if (c === '?') {
                    parser.state = S.PROC_INST;
                    parser.procInstName = parser.procInstBody = '';
                  } else {
                    strictFail(parser, 'Unencoded <');
                    // if there was some whitespace, then add that in.
                    if (parser.startTagPosition + 1 < parser.position) {
                      const pad = parser.position - parser.startTagPosition;
                      c = new Array(pad).join(' ') + c;
                    }
                    parser.textNode += `<${c}`;
                    parser.state = S.TEXT;
                  }
                  continue;

                case S.SGML_DECL:
                  if ((parser.sgmlDecl + c).toUpperCase() === CDATA) {
                    emitNode(parser, 'onopencdata');
                    parser.state = S.CDATA;
                    parser.sgmlDecl = '';
                    parser.cdata = '';
                  } else if (parser.sgmlDecl + c === '--') {
                    parser.state = S.COMMENT;
                    parser.comment = '';
                    parser.sgmlDecl = '';
                  } else if ((parser.sgmlDecl + c).toUpperCase() === DOCTYPE) {
                    parser.state = S.DOCTYPE;
                    if (parser.doctype || parser.sawRoot) {
                      strictFail(parser,
                        'Inappropriately located doctype declaration');
                    }
                    parser.doctype = '';
                    parser.sgmlDecl = '';
                  } else if (c === '>') {
                    emitNode(parser, 'onsgmldeclaration', parser.sgmlDecl);
                    parser.sgmlDecl = '';
                    parser.state = S.TEXT;
                  } else if (isQuote(c)) {
                    parser.state = S.SGML_DECL_QUOTED;
                    parser.sgmlDecl += c;
                  } else {
                    parser.sgmlDecl += c;
                  }
                  continue;

                case S.SGML_DECL_QUOTED:
                  if (c === parser.q) {
                    parser.state = S.SGML_DECL;
                    parser.q = '';
                  }
                  parser.sgmlDecl += c;
                  continue;

                case S.DOCTYPE:
                  if (c === '>') {
                    parser.state = S.TEXT;
                    emitNode(parser, 'ondoctype', parser.doctype);
                    parser.doctype = true; // just remember that we saw it.
                  } else {
                    parser.doctype += c;
                    if (c === '[') {
                      parser.state = S.DOCTYPE_DTD;
                    } else if (isQuote(c)) {
                      parser.state = S.DOCTYPE_QUOTED;
                      parser.q = c;
                    }
                  }
                  continue;

                case S.DOCTYPE_QUOTED:
                  parser.doctype += c;
                  if (c === parser.q) {
                    parser.q = '';
                    parser.state = S.DOCTYPE;
                  }
                  continue;

                case S.DOCTYPE_DTD:
                  parser.doctype += c;
                  if (c === ']') {
                    parser.state = S.DOCTYPE;
                  } else if (isQuote(c)) {
                    parser.state = S.DOCTYPE_DTD_QUOTED;
                    parser.q = c;
                  }
                  continue;

                case S.DOCTYPE_DTD_QUOTED:
                  parser.doctype += c;
                  if (c === parser.q) {
                    parser.state = S.DOCTYPE_DTD;
                    parser.q = '';
                  }
                  continue;

                case S.COMMENT:
                  if (c === '-') {
                    parser.state = S.COMMENT_ENDING;
                  } else {
                    parser.comment += c;
                  }
                  continue;

                case S.COMMENT_ENDING:
                  if (c === '-') {
                    parser.state = S.COMMENT_ENDED;
                    parser.comment = textopts(parser.opt, parser.comment);
                    if (parser.comment) {
                      emitNode(parser, 'oncomment', parser.comment);
                    }
                    parser.comment = '';
                  } else {
                    parser.comment += `-${c}`;
                    parser.state = S.COMMENT;
                  }
                  continue;

                case S.COMMENT_ENDED:
                  if (c !== '>') {
                    strictFail(parser, 'Malformed comment');
                    // allow <!-- blah -- bloo --> in non-strict mode,
                    // which is a comment of " blah -- bloo "
                    parser.comment += `--${c}`;
                    parser.state = S.COMMENT;
                  } else {
                    parser.state = S.TEXT;
                  }
                  continue;

                case S.CDATA:
                  if (c === ']') {
                    parser.state = S.CDATA_ENDING;
                  } else {
                    parser.cdata += c;
                  }
                  continue;

                case S.CDATA_ENDING:
                  if (c === ']') {
                    parser.state = S.CDATA_ENDING_2;
                  } else {
                    parser.cdata += `]${c}`;
                    parser.state = S.CDATA;
                  }
                  continue;

                case S.CDATA_ENDING_2:
                  if (c === '>') {
                    if (parser.cdata) {
                      emitNode(parser, 'oncdata', parser.cdata);
                    }
                    emitNode(parser, 'onclosecdata');
                    parser.cdata = '';
                    parser.state = S.TEXT;
                  } else if (c === ']') {
                    parser.cdata += ']';
                  } else {
                    parser.cdata += `]]${c}`;
                    parser.state = S.CDATA;
                  }
                  continue;

                case S.PROC_INST:
                  if (c === '?') {
                    parser.state = S.PROC_INST_ENDING;
                  } else if (isWhitespace(c)) {
                    parser.state = S.PROC_INST_BODY;
                  } else {
                    parser.procInstName += c;
                  }
                  continue;

                case S.PROC_INST_BODY:
                  if (!parser.procInstBody && isWhitespace(c)) {
                    continue;
                  } else if (c === '?') {
                    parser.state = S.PROC_INST_ENDING;
                  } else {
                    parser.procInstBody += c;
                  }
                  continue;

                case S.PROC_INST_ENDING:
                  if (c === '>') {
                    emitNode(parser, 'onprocessinginstruction', {
                      name: parser.procInstName,
                      body: parser.procInstBody,
                    });
                    parser.procInstName = parser.procInstBody = '';
                    parser.state = S.TEXT;
                  } else {
                    parser.procInstBody += `?${c}`;
                    parser.state = S.PROC_INST_BODY;
                  }
                  continue;

                case S.OPEN_TAG:
                  if (isMatch(nameBody, c)) {
                    parser.tagName += c;
                  } else {
                    newTag(parser);
                    if (c === '>') {
                      openTag(parser);
                    } else if (c === '/') {
                      parser.state = S.OPEN_TAG_SLASH;
                    } else {
                      if (!isWhitespace(c)) {
                        strictFail(parser, 'Invalid character in tag name');
                      }
                      parser.state = S.ATTRIB;
                    }
                  }
                  continue;

                case S.OPEN_TAG_SLASH:
                  if (c === '>') {
                    openTag(parser, true);
                    closeTag(parser);
                  } else {
                    strictFail(parser, 'Forward-slash in opening tag not followed by >');
                    parser.state = S.ATTRIB;
                  }
                  continue;

                case S.ATTRIB:
                  // haven't read the attribute name yet.
                  if (isWhitespace(c)) {
                    continue;
                  } else if (c === '>') {
                    openTag(parser);
                  } else if (c === '/') {
                    parser.state = S.OPEN_TAG_SLASH;
                  } else if (isMatch(nameStart, c)) {
                    parser.attribName = c;
                    parser.attribValue = '';
                    parser.state = S.ATTRIB_NAME;
                  } else {
                    strictFail(parser, 'Invalid attribute name');
                  }
                  continue;

                case S.ATTRIB_NAME:
                  if (c === '=') {
                    parser.state = S.ATTRIB_VALUE;
                  } else if (c === '>') {
                    strictFail(parser, 'Attribute without value');
                    parser.attribValue = parser.attribName;
                    attrib(parser);
                    openTag(parser);
                  } else if (isWhitespace(c)) {
                    parser.state = S.ATTRIB_NAME_SAW_WHITE;
                  } else if (isMatch(nameBody, c)) {
                    parser.attribName += c;
                  } else {
                    strictFail(parser, 'Invalid attribute name');
                  }
                  continue;

                case S.ATTRIB_NAME_SAW_WHITE:
                  if (c === '=') {
                    parser.state = S.ATTRIB_VALUE;
                  } else if (isWhitespace(c)) {
                    continue;
                  } else {
                    strictFail(parser, 'Attribute without value');
                    parser.tag.attributes[parser.attribName] = '';
                    parser.attribValue = '';
                    emitNode(parser, 'onattribute', {
                      name: parser.attribName,
                      value: '',
                    });
                    parser.attribName = '';
                    if (c === '>') {
                      openTag(parser);
                    } else if (isMatch(nameStart, c)) {
                      parser.attribName = c;
                      parser.state = S.ATTRIB_NAME;
                    } else {
                      strictFail(parser, 'Invalid attribute name');
                      parser.state = S.ATTRIB;
                    }
                  }
                  continue;

                case S.ATTRIB_VALUE:
                  if (isWhitespace(c)) {
                    continue;
                  } else if (isQuote(c)) {
                    parser.q = c;
                    parser.state = S.ATTRIB_VALUE_QUOTED;
                  } else {
                    strictFail(parser, 'Unquoted attribute value');
                    parser.state = S.ATTRIB_VALUE_UNQUOTED;
                    parser.attribValue = c;
                  }
                  continue;

                case S.ATTRIB_VALUE_QUOTED:
                  if (c !== parser.q) {
                    if (c === '&') {
                      parser.state = S.ATTRIB_VALUE_ENTITY_Q;
                    } else {
                      parser.attribValue += c;
                    }
                    continue;
                  }
                  attrib(parser);
                  parser.q = '';
                  parser.state = S.ATTRIB_VALUE_CLOSED;
                  continue;

                case S.ATTRIB_VALUE_CLOSED:
                  if (isWhitespace(c)) {
                    parser.state = S.ATTRIB;
                  } else if (c === '>') {
                    openTag(parser);
                  } else if (c === '/') {
                    parser.state = S.OPEN_TAG_SLASH;
                  } else if (isMatch(nameStart, c)) {
                    strictFail(parser, 'No whitespace between attributes');
                    parser.attribName = c;
                    parser.attribValue = '';
                    parser.state = S.ATTRIB_NAME;
                  } else {
                    strictFail(parser, 'Invalid attribute name');
                  }
                  continue;

                case S.ATTRIB_VALUE_UNQUOTED:
                  if (!isAttribEnd(c)) {
                    if (c === '&') {
                      parser.state = S.ATTRIB_VALUE_ENTITY_U;
                    } else {
                      parser.attribValue += c;
                    }
                    continue;
                  }
                  attrib(parser);
                  if (c === '>') {
                    openTag(parser);
                  } else {
                    parser.state = S.ATTRIB;
                  }
                  continue;

                case S.CLOSE_TAG:
                  if (!parser.tagName) {
                    if (isWhitespace(c)) {
                      continue;
                    } else if (notMatch(nameStart, c)) {
                      if (parser.script) {
                        parser.script += `</${c}`;
                        parser.state = S.SCRIPT;
                      } else {
                        strictFail(parser, 'Invalid tagname in closing tag.');
                      }
                    } else {
                      parser.tagName = c;
                    }
                  } else if (c === '>') {
                    closeTag(parser);
                  } else if (isMatch(nameBody, c)) {
                    parser.tagName += c;
                  } else if (parser.script) {
                    parser.script += `</${parser.tagName}`;
                    parser.tagName = '';
                    parser.state = S.SCRIPT;
                  } else {
                    if (!isWhitespace(c)) {
                      strictFail(parser, 'Invalid tagname in closing tag');
                    }
                    parser.state = S.CLOSE_TAG_SAW_WHITE;
                  }
                  continue;

                case S.CLOSE_TAG_SAW_WHITE:
                  if (isWhitespace(c)) {
                    continue;
                  }
                  if (c === '>') {
                    closeTag(parser);
                  } else {
                    strictFail(parser, 'Invalid characters in closing tag');
                  }
                  continue;

                case S.TEXT_ENTITY:
                case S.ATTRIB_VALUE_ENTITY_Q:
                case S.ATTRIB_VALUE_ENTITY_U:
                  var returnState;
                  var buffer;
                  switch (parser.state) {
                    case S.TEXT_ENTITY:
                      returnState = S.TEXT;
                      buffer = 'textNode';
                      break;

                    case S.ATTRIB_VALUE_ENTITY_Q:
                      returnState = S.ATTRIB_VALUE_QUOTED;
                      buffer = 'attribValue';
                      break;

                    case S.ATTRIB_VALUE_ENTITY_U:
                      returnState = S.ATTRIB_VALUE_UNQUOTED;
                      buffer = 'attribValue';
                      break;
                  }

                  if (c === ';') {
                    parser[buffer] += parseEntity(parser);
                    parser.entity = '';
                    parser.state = returnState;
                  } else if (isMatch(parser.entity.length ? entityBody : entityStart, c)) {
                    parser.entity += c;
                  } else {
                    strictFail(parser, 'Invalid character in entity name');
                    parser[buffer] += `&${parser.entity}${c}`;
                    parser.entity = '';
                    parser.state = returnState;
                  }

                  continue;

                default:
                  throw new Error(parser, `Unknown state: ${parser.state}`);
              }
            } // while

            if (parser.position >= parser.bufferCheckPosition) {
              checkBufferLength(parser);
            }
            return parser;
          }

          /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */
          /* istanbul ignore next */
          if (!String.fromCodePoint) {
            (function () {
              const stringFromCharCode = String.fromCharCode;
              const { floor } = Math;
              const fromCodePoint = function () {
                const MAX_SIZE = 0x4000;
                const codeUnits = [];
                let highSurrogate;
                let lowSurrogate;
                let index = -1;
                const { length } = arguments;
                if (!length) {
                  return '';
                }
                let result = '';
                while (++index < length) {
                  let codePoint = Number(arguments[index]);
                  if (
                    !isFinite(codePoint) // `NaN`, `+Infinity`, or `-Infinity`
            || codePoint < 0 // not a valid Unicode code point
            || codePoint > 0x10FFFF // not a valid Unicode code point
            || floor(codePoint) !== codePoint // not an integer
                  ) {
                    throw RangeError(`Invalid code point: ${codePoint}`);
                  }
                  if (codePoint <= 0xFFFF) { // BMP code point
                    codeUnits.push(codePoint);
                  } else { // Astral code point; split in surrogate halves
                    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                    codePoint -= 0x10000;
                    highSurrogate = (codePoint >> 10) + 0xD800;
                    lowSurrogate = (codePoint % 0x400) + 0xDC00;
                    codeUnits.push(highSurrogate, lowSurrogate);
                  }
                  if (index + 1 === length || codeUnits.length > MAX_SIZE) {
                    result += stringFromCharCode.apply(null, codeUnits);
                    codeUnits.length = 0;
                  }
                }
                return result;
              };
              /* istanbul ignore next */
              if (Object.defineProperty) {
                Object.defineProperty(String, 'fromCodePoint', {
                  value: fromCodePoint,
                  configurable: true,
                  writable: true,
                });
              } else {
                String.fromCodePoint = fromCodePoint;
              }
            }());
          }
        }(false ? 0 : exports));
        /***/ }),

      /***/ 2830:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        // Copyright Joyent, Inc. and other Node contributors.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a
        // copy of this software and associated documentation files (the
        // "Software"), to deal in the Software without restriction, including
        // without limitation the rights to use, copy, modify, merge, publish,
        // distribute, sublicense, and/or sell copies of the Software, and to permit
        // persons to whom the Software is furnished to do so, subject to the
        // following conditions:
        //
        // The above copyright notice and this permission notice shall be included
        // in all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
        // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
        // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
        // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
        // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
        // USE OR OTHER DEALINGS IN THE SOFTWARE.

        module.exports = Stream;

        const EE = (__webpack_require__(7187).EventEmitter);
        const inherits = __webpack_require__(5717);

        inherits(Stream, EE);
        Stream.Readable = __webpack_require__(6577);
        Stream.Writable = __webpack_require__(323);
        Stream.Duplex = __webpack_require__(8656);
        Stream.Transform = __webpack_require__(4473);
        Stream.PassThrough = __webpack_require__(2366);
        Stream.finished = __webpack_require__(1086);
        Stream.pipeline = __webpack_require__(6472);

        // Backwards-compat with node 0.4.x
        Stream.Stream = Stream;

        // old-style streams.  Note that the pipe method (the only relevant
        // part of this class) is overridden in the Readable class.

        function Stream() {
          EE.call(this);
        }

        Stream.prototype.pipe = function (dest, options) {
          const source = this;

          function ondata(chunk) {
            if (dest.writable) {
              if (dest.write(chunk) === false && source.pause) {
                source.pause();
              }
            }
          }

          source.on('data', ondata);

          function ondrain() {
            if (source.readable && source.resume) {
              source.resume();
            }
          }

          dest.on('drain', ondrain);

          // If the 'end' option is not supplied, dest.end() will be called when
          // source gets the 'end' or 'close' events.  Only dest.end() once.
          if (!dest._isStdio && (!options || options.end !== false)) {
            source.on('end', onend);
            source.on('close', onclose);
          }

          let didOnEnd = false;
          function onend() {
            if (didOnEnd) return;
            didOnEnd = true;

            dest.end();
          }

          function onclose() {
            if (didOnEnd) return;
            didOnEnd = true;

            if (typeof dest.destroy === 'function') dest.destroy();
          }

          // don't leave dangling pipes when there are errors.
          function onerror(er) {
            cleanup();
            if (EE.listenerCount(this, 'error') === 0) {
              throw er; // Unhandled stream error in pipe.
            }
          }

          source.on('error', onerror);
          dest.on('error', onerror);

          // remove all the event listeners that were added.
          function cleanup() {
            source.removeListener('data', ondata);
            dest.removeListener('drain', ondrain);

            source.removeListener('end', onend);
            source.removeListener('close', onclose);

            source.removeListener('error', onerror);
            dest.removeListener('error', onerror);

            source.removeListener('end', cleanup);
            source.removeListener('close', cleanup);

            dest.removeListener('close', cleanup);
          }

          source.on('end', cleanup);
          source.on('close', cleanup);

          dest.on('close', cleanup);

          dest.emit('pipe', source);

          // Allow for unix-like usage: A.pipe(B).pipe(C)
          return dest;
        };
        /***/ }),

      /***/ 8106:
      /***/ (function (module) {
        function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

        const codes = {};

        function createErrorType(code, message, Base) {
          if (!Base) {
            Base = Error;
          }

          function getMessage(arg1, arg2, arg3) {
            if (typeof message === 'string') {
              return message;
            }
            return message(arg1, arg2, arg3);
          }

          const NodeError =
  /* #__PURE__ */
  (function (_Base) {
    _inheritsLoose(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
    }

    return NodeError;
  }(Base));

          NodeError.prototype.name = Base.name;
          NodeError.prototype.code = code;
          codes[code] = NodeError;
        } // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js

        function oneOf(expected, thing) {
          if (Array.isArray(expected)) {
            const len = expected.length;
            expected = expected.map((i) => String(i));

            if (len > 2) {
              return 'one of '.concat(thing, ' ').concat(expected.slice(0, len - 1).join(', '), ', or ') + expected[len - 1];
            } if (len === 2) {
              return 'one of '.concat(thing, ' ').concat(expected[0], ' or ').concat(expected[1]);
            }
            return 'of '.concat(thing, ' ').concat(expected[0]);
          }
          return 'of '.concat(thing, ' ').concat(String(expected));
        } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith

        function startsWith(str, search, pos) {
          return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
        } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith

        function endsWith(str, search, this_len) {
          if (this_len === undefined || this_len > str.length) {
            this_len = str.length;
          }

          return str.substring(this_len - search.length, this_len) === search;
        } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes

        function includes(str, search, start) {
          if (typeof start !== 'number') {
            start = 0;
          }

          if (start + search.length > str.length) {
            return false;
          }
          return str.indexOf(search, start) !== -1;
        }

        createErrorType('ERR_INVALID_OPT_VALUE', (name, value) => `The value "${value}" is invalid for option "${name}"`, TypeError);
        createErrorType('ERR_INVALID_ARG_TYPE', (name, expected, actual) => {
          // determiner: 'must be' or 'must not be'
          let determiner;

          if (typeof expected === 'string' && startsWith(expected, 'not ')) {
            determiner = 'must not be';
            expected = expected.replace(/^not /, '');
          } else {
            determiner = 'must be';
          }

          let msg;

          if (endsWith(name, ' argument')) {
            // For cases like 'first argument'
            msg = 'The '.concat(name, ' ').concat(determiner, ' ').concat(oneOf(expected, 'type'));
          } else {
            const type = includes(name, '.') ? 'property' : 'argument';
            msg = 'The "'.concat(name, '" ').concat(type, ' ').concat(determiner, ' ').concat(oneOf(expected, 'type'));
          }

          msg += '. Received type '.concat(typeof actual);
          return msg;
        }, TypeError);
        createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
        createErrorType('ERR_METHOD_NOT_IMPLEMENTED', (name) => `The ${name} method is not implemented`);
        createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
        createErrorType('ERR_STREAM_DESTROYED', (name) => `Cannot call ${name} after a stream was destroyed`);
        createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
        createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
        createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
        createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
        createErrorType('ERR_UNKNOWN_ENCODING', (arg) => `Unknown encoding: ${arg}`, TypeError);
        createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
        module.exports.q = codes;
        /***/ }),

      /***/ 8656:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* provided dependency */ const process = __webpack_require__(4155);
        // Copyright Joyent, Inc. and other Node contributors.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a
        // copy of this software and associated documentation files (the
        // "Software"), to deal in the Software without restriction, including
        // without limitation the rights to use, copy, modify, merge, publish,
        // distribute, sublicense, and/or sell copies of the Software, and to permit
        // persons to whom the Software is furnished to do so, subject to the
        // following conditions:
        //
        // The above copyright notice and this permission notice shall be included
        // in all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
        // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
        // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
        // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
        // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
        // USE OR OTHER DEALINGS IN THE SOFTWARE.
        // a duplex stream is just a stream that is both readable and writable.
        // Since JS doesn't have multiple prototypal inheritance, this class
        // prototypally inherits from Readable, and then parasitically from
        // Writable.

        /* <replacement> */

        const objectKeys = Object.keys || function (obj) {
          const keys = [];

          for (const key in obj) {
            keys.push(key);
          }

          return keys;
        };
        /* </replacement> */

        module.exports = Duplex;

        const Readable = __webpack_require__(6577);

        const Writable = __webpack_require__(323);

        __webpack_require__(5717)(Duplex, Readable);

        {
          // Allow the keys array to be GC'ed.
          const keys = objectKeys(Writable.prototype);

          for (let v = 0; v < keys.length; v++) {
            const method = keys[v];
            if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
          }
        }

        function Duplex(options) {
          if (!(this instanceof Duplex)) return new Duplex(options);
          Readable.call(this, options);
          Writable.call(this, options);
          this.allowHalfOpen = true;

          if (options) {
            if (options.readable === false) this.readable = false;
            if (options.writable === false) this.writable = false;

            if (options.allowHalfOpen === false) {
              this.allowHalfOpen = false;
              this.once('end', onend);
            }
          }
        }

        Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
          // making it explicit this property is not enumerable
          // because otherwise some prototype manipulation in
          // userland will fail
          enumerable: false,
          get: function get() {
            return this._writableState.highWaterMark;
          },
        });
        Object.defineProperty(Duplex.prototype, 'writableBuffer', {
          // making it explicit this property is not enumerable
          // because otherwise some prototype manipulation in
          // userland will fail
          enumerable: false,
          get: function get() {
            return this._writableState && this._writableState.getBuffer();
          },
        });
        Object.defineProperty(Duplex.prototype, 'writableLength', {
          // making it explicit this property is not enumerable
          // because otherwise some prototype manipulation in
          // userland will fail
          enumerable: false,
          get: function get() {
            return this._writableState.length;
          },
        }); // the no-half-open enforcer

        function onend() {
          // If the writable side ended, then we're ok.
          if (this._writableState.ended) return; // no more data can be written.
          // But allow more writes to happen in this tick.

          process.nextTick(onEndNT, this);
        }

        function onEndNT(self) {
          self.end();
        }

        Object.defineProperty(Duplex.prototype, 'destroyed', {
          // making it explicit this property is not enumerable
          // because otherwise some prototype manipulation in
          // userland will fail
          enumerable: false,
          get: function get() {
            if (this._readableState === undefined || this._writableState === undefined) {
              return false;
            }

            return this._readableState.destroyed && this._writableState.destroyed;
          },
          set: function set(value) {
            // we ignore the value if the stream
            // has not been initialized yet
            if (this._readableState === undefined || this._writableState === undefined) {
              return;
            } // backward compatibility, the user is explicitly
            // managing destroyed

            this._readableState.destroyed = value;
            this._writableState.destroyed = value;
          },
        });
        /***/ }),

      /***/ 2366:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        // Copyright Joyent, Inc. and other Node contributors.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a
        // copy of this software and associated documentation files (the
        // "Software"), to deal in the Software without restriction, including
        // without limitation the rights to use, copy, modify, merge, publish,
        // distribute, sublicense, and/or sell copies of the Software, and to permit
        // persons to whom the Software is furnished to do so, subject to the
        // following conditions:
        //
        // The above copyright notice and this permission notice shall be included
        // in all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
        // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
        // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
        // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
        // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
        // USE OR OTHER DEALINGS IN THE SOFTWARE.
        // a passthrough stream.
        // basically just the most minimal sort of Transform stream.
        // Every written chunk gets output as-is.

        module.exports = PassThrough;

        const Transform = __webpack_require__(4473);

        __webpack_require__(5717)(PassThrough, Transform);

        function PassThrough(options) {
          if (!(this instanceof PassThrough)) return new PassThrough(options);
          Transform.call(this, options);
        }

        PassThrough.prototype._transform = function (chunk, encoding, cb) {
          cb(null, chunk);
        };
        /***/ }),

      /***/ 6577:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* provided dependency */ const process = __webpack_require__(4155);
        // Copyright Joyent, Inc. and other Node contributors.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a
        // copy of this software and associated documentation files (the
        // "Software"), to deal in the Software without restriction, including
        // without limitation the rights to use, copy, modify, merge, publish,
        // distribute, sublicense, and/or sell copies of the Software, and to permit
        // persons to whom the Software is furnished to do so, subject to the
        // following conditions:
        //
        // The above copyright notice and this permission notice shall be included
        // in all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
        // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
        // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
        // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
        // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
        // USE OR OTHER DEALINGS IN THE SOFTWARE.

        module.exports = Readable;
        /* <replacement> */

        let Duplex;
        /* </replacement> */

        Readable.ReadableState = ReadableState;
        /* <replacement> */

        const EE = (__webpack_require__(7187).EventEmitter);

        const EElistenerCount = function EElistenerCount(emitter, type) {
          return emitter.listeners(type).length;
        };
        /* </replacement> */

        /* <replacement> */

        const Stream = __webpack_require__(3194);
        /* </replacement> */

        const { Buffer } = __webpack_require__(8823);

        const OurUint8Array = __webpack_require__.g.Uint8Array || function () {};

        function _uint8ArrayToBuffer(chunk) {
          return Buffer.from(chunk);
        }

        function _isUint8Array(obj) {
          return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
        }
        /* <replacement> */

        const debugUtil = __webpack_require__(964);

        let debug;

        if (debugUtil && debugUtil.debuglog) {
          debug = debugUtil.debuglog('stream');
        } else {
          debug = function debug() {};
        }
        /* </replacement> */

        const BufferList = __webpack_require__(3361);

        const destroyImpl = __webpack_require__(1029);

        const _require = __webpack_require__(94);
        const { getHighWaterMark } = _require;

        const _require$codes = (__webpack_require__(8106).q);
        const { ERR_INVALID_ARG_TYPE } = _require$codes;
        const { ERR_STREAM_PUSH_AFTER_EOF } = _require$codes;
        const { ERR_METHOD_NOT_IMPLEMENTED } = _require$codes;
        const { ERR_STREAM_UNSHIFT_AFTER_END_EVENT } = _require$codes; // Lazy loaded to improve the startup performance.

        let StringDecoder;
        let createReadableStreamAsyncIterator;
        let from;

        __webpack_require__(5717)(Readable, Stream);

        const { errorOrDestroy } = destroyImpl;
        const kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

        function prependListener(emitter, event, fn) {
          // Sadly this is not cacheable as some libraries bundle their own
          // event emitter implementation with them.
          if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
          // userland ones.  NEVER DO THIS. This is here only because this code needs
          // to continue to work with older versions of Node.js that do not include
          // the prependListener() method. The goal is to eventually remove this hack.

          if (!emitter._events || !emitter._events[event]) emitter.on(event, fn); else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn); else emitter._events[event] = [fn, emitter._events[event]];
        }

        function ReadableState(options, stream, isDuplex) {
          Duplex = Duplex || __webpack_require__(8656);
          options = options || {}; // Duplex streams are both readable and writable, but share
          // the same options object.
          // However, some cases require setting options to different
          // values for the readable and the writable sides of the duplex stream.
          // These options can be provided separately as readableXXX and writableXXX.

          if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex; // object stream flag. Used to make read(n) ignore n and to
          // make all the buffer merging and length checks go away

          this.objectMode = !!options.objectMode;
          if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
          // Note: 0 is a valid value, means "don't call _read preemptively ever"

          this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex); // A linked list is used to store data chunks instead of an array because the
          // linked list can remove elements from the beginning faster than
          // array.shift()

          this.buffer = new BufferList();
          this.length = 0;
          this.pipes = null;
          this.pipesCount = 0;
          this.flowing = null;
          this.ended = false;
          this.endEmitted = false;
          this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
          // immediately, or on a later tick.  We set this to true at first, because
          // any actions that shouldn't happen until "later" should generally also
          // not happen before the first read call.

          this.sync = true; // whenever we return null, then we set a flag to say
          // that we're awaiting a 'readable' event emission.

          this.needReadable = false;
          this.emittedReadable = false;
          this.readableListening = false;
          this.resumeScheduled = false;
          this.paused = true; // Should close be emitted on destroy. Defaults to true.

          this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'end' (and potentially 'finish')

          this.autoDestroy = !!options.autoDestroy; // has it been destroyed

          this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
          // encoding is 'binary' so we have to make this configurable.
          // Everything else in the universe uses 'utf8', though.

          this.defaultEncoding = options.defaultEncoding || 'utf8'; // the number of writers that are awaiting a drain event in .pipe()s

          this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled

          this.readingMore = false;
          this.decoder = null;
          this.encoding = null;

          if (options.encoding) {
            if (!StringDecoder) StringDecoder = (__webpack_require__(2553).s);
            this.decoder = new StringDecoder(options.encoding);
            this.encoding = options.encoding;
          }
        }

        function Readable(options) {
          Duplex = Duplex || __webpack_require__(8656);
          if (!(this instanceof Readable)) return new Readable(options); // Checking for a Stream.Duplex instance is faster here instead of inside
          // the ReadableState constructor, at least with V8 6.5

          const isDuplex = this instanceof Duplex;
          this._readableState = new ReadableState(options, this, isDuplex); // legacy

          this.readable = true;

          if (options) {
            if (typeof options.read === 'function') this._read = options.read;
            if (typeof options.destroy === 'function') this._destroy = options.destroy;
          }

          Stream.call(this);
        }

        Object.defineProperty(Readable.prototype, 'destroyed', {
          // making it explicit this property is not enumerable
          // because otherwise some prototype manipulation in
          // userland will fail
          enumerable: false,
          get: function get() {
            if (this._readableState === undefined) {
              return false;
            }

            return this._readableState.destroyed;
          },
          set: function set(value) {
            // we ignore the value if the stream
            // has not been initialized yet
            if (!this._readableState) {
              return;
            } // backward compatibility, the user is explicitly
            // managing destroyed

            this._readableState.destroyed = value;
          },
        });
        Readable.prototype.destroy = destroyImpl.destroy;
        Readable.prototype._undestroy = destroyImpl.undestroy;

        Readable.prototype._destroy = function (err, cb) {
          cb(err);
        }; // Manually shove something into the read() buffer.
        // This returns true if the highWaterMark has not been hit yet,
        // similar to how Writable.write() returns true if you should
        // write() some more.

        Readable.prototype.push = function (chunk, encoding) {
          const state = this._readableState;
          let skipChunkCheck;

          if (!state.objectMode) {
            if (typeof chunk === 'string') {
              encoding = encoding || state.defaultEncoding;

              if (encoding !== state.encoding) {
                chunk = Buffer.from(chunk, encoding);
                encoding = '';
              }

              skipChunkCheck = true;
            }
          } else {
            skipChunkCheck = true;
          }

          return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
        }; // Unshift should *always* be something directly out of read()

        Readable.prototype.unshift = function (chunk) {
          return readableAddChunk(this, chunk, null, true, false);
        };

        function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
          debug('readableAddChunk', chunk);
          const state = stream._readableState;

          if (chunk === null) {
            state.reading = false;
            onEofChunk(stream, state);
          } else {
            let er;
            if (!skipChunkCheck) er = chunkInvalid(state, chunk);

            if (er) {
              errorOrDestroy(stream, er);
            } else if (state.objectMode || chunk && chunk.length > 0) {
              if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
                chunk = _uint8ArrayToBuffer(chunk);
              }

              if (addToFront) {
                if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT()); else addChunk(stream, state, chunk, true);
              } else if (state.ended) {
                errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
              } else if (state.destroyed) {
                return false;
              } else {
                state.reading = false;

                if (state.decoder && !encoding) {
                  chunk = state.decoder.write(chunk);
                  if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false); else maybeReadMore(stream, state);
                } else {
                  addChunk(stream, state, chunk, false);
                }
              }
            } else if (!addToFront) {
              state.reading = false;
              maybeReadMore(stream, state);
            }
          } // We can push more data if we are below the highWaterMark.
          // Also, if we have no data yet, we can stand some more bytes.
          // This is to work around cases where hwm=0, such as the repl.

          return !state.ended && (state.length < state.highWaterMark || state.length === 0);
        }

        function addChunk(stream, state, chunk, addToFront) {
          if (state.flowing && state.length === 0 && !state.sync) {
            state.awaitDrain = 0;
            stream.emit('data', chunk);
          } else {
            // update the buffer info.
            state.length += state.objectMode ? 1 : chunk.length;
            if (addToFront) state.buffer.unshift(chunk); else state.buffer.push(chunk);
            if (state.needReadable) emitReadable(stream);
          }

          maybeReadMore(stream, state);
        }

        function chunkInvalid(state, chunk) {
          let er;

          if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
            er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
          }

          return er;
        }

        Readable.prototype.isPaused = function () {
          return this._readableState.flowing === false;
        }; // backwards compatibility.

        Readable.prototype.setEncoding = function (enc) {
          if (!StringDecoder) StringDecoder = (__webpack_require__(2553).s);
          const decoder = new StringDecoder(enc);
          this._readableState.decoder = decoder; // If setEncoding(null), decoder.encoding equals utf8

          this._readableState.encoding = this._readableState.decoder.encoding; // Iterate over current buffer to convert already stored Buffers:

          let p = this._readableState.buffer.head;
          let content = '';

          while (p !== null) {
            content += decoder.write(p.data);
            p = p.next;
          }

          this._readableState.buffer.clear();

          if (content !== '') this._readableState.buffer.push(content);
          this._readableState.length = content.length;
          return this;
        }; // Don't raise the hwm > 1GB

        const MAX_HWM = 0x40000000;

        function computeNewHighWaterMark(n) {
          if (n >= MAX_HWM) {
            // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
            n = MAX_HWM;
          } else {
            // Get the next highest power of 2 to prevent increasing hwm excessively in
            // tiny amounts
            n--;
            n |= n >>> 1;
            n |= n >>> 2;
            n |= n >>> 4;
            n |= n >>> 8;
            n |= n >>> 16;
            n++;
          }

          return n;
        } // This function is designed to be inlinable, so please take care when making
        // changes to the function body.

        function howMuchToRead(n, state) {
          if (n <= 0 || state.length === 0 && state.ended) return 0;
          if (state.objectMode) return 1;

          if (n !== n) {
            // Only flow one buffer at a time
            if (state.flowing && state.length) return state.buffer.head.data.length; return state.length;
          } // If we're asking for more than the current hwm, then raise the hwm.

          if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
          if (n <= state.length) return n; // Don't have enough

          if (!state.ended) {
            state.needReadable = true;
            return 0;
          }

          return state.length;
        } // you can override either this method, or the async _read(n) below.

        Readable.prototype.read = function (n) {
          debug('read', n);
          n = parseInt(n, 10);
          const state = this._readableState;
          const nOrig = n;
          if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
          // already have a bunch of data in the buffer, then just trigger
          // the 'readable' event and move on.

          if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
            debug('read: emitReadable', state.length, state.ended);
            if (state.length === 0 && state.ended) endReadable(this); else emitReadable(this);
            return null;
          }

          n = howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.

          if (n === 0 && state.ended) {
            if (state.length === 0) endReadable(this);
            return null;
          } // All the actual chunk generation logic needs to be
          // *below* the call to _read.  The reason is that in certain
          // synthetic stream cases, such as passthrough streams, _read
          // may be a completely synchronous operation which may change
          // the state of the read buffer, providing enough data when
          // before there was *not* enough.
          //
          // So, the steps are:
          // 1. Figure out what the state of things will be after we do
          // a read from the buffer.
          //
          // 2. If that resulting state will trigger a _read, then call _read.
          // Note that this may be asynchronous, or synchronous.  Yes, it is
          // deeply ugly to write APIs this way, but that still doesn't mean
          // that the Readable class should behave improperly, as streams are
          // designed to be sync/async agnostic.
          // Take note if the _read call is sync or async (ie, if the read call
          // has returned yet), so that we know whether or not it's safe to emit
          // 'readable' etc.
          //
          // 3. Actually pull the requested chunks out of the buffer and return.
          // if we need a readable event, then we need to do some reading.

          let doRead = state.needReadable;
          debug('need readable', doRead); // if we currently have less than the highWaterMark, then also read some

          if (state.length === 0 || state.length - n < state.highWaterMark) {
            doRead = true;
            debug('length less than watermark', doRead);
          } // however, if we've ended, then there's no point, and if we're already
          // reading, then it's unnecessary.

          if (state.ended || state.reading) {
            doRead = false;
            debug('reading or ended', doRead);
          } else if (doRead) {
            debug('do read');
            state.reading = true;
            state.sync = true; // if the length is currently zero, then we *need* a readable event.

            if (state.length === 0) state.needReadable = true; // call internal read method

            this._read(state.highWaterMark);

            state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
            // and we need to re-evaluate how much data we can return to the user.

            if (!state.reading) n = howMuchToRead(nOrig, state);
          }

          let ret;
          if (n > 0) ret = fromList(n, state); else ret = null;

          if (ret === null) {
            state.needReadable = state.length <= state.highWaterMark;
            n = 0;
          } else {
            state.length -= n;
            state.awaitDrain = 0;
          }

          if (state.length === 0) {
            // If we have nothing in the buffer, then we want to know
            // as soon as we *do* get something into the buffer.
            if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.

            if (nOrig !== n && state.ended) endReadable(this);
          }

          if (ret !== null) this.emit('data', ret);
          return ret;
        };

        function onEofChunk(stream, state) {
          debug('onEofChunk');
          if (state.ended) return;

          if (state.decoder) {
            const chunk = state.decoder.end();

            if (chunk && chunk.length) {
              state.buffer.push(chunk);
              state.length += state.objectMode ? 1 : chunk.length;
            }
          }

          state.ended = true;

          if (state.sync) {
            // if we are sync, wait until next tick to emit the data.
            // Otherwise we risk emitting data in the flow()
            // the readable code triggers during a read() call
            emitReadable(stream);
          } else {
            // emit 'readable' now to make sure it gets picked up.
            state.needReadable = false;

            if (!state.emittedReadable) {
              state.emittedReadable = true;
              emitReadable_(stream);
            }
          }
        } // Don't emit readable right away in sync mode, because this can trigger
        // another read() call => stack overflow.  This way, it might trigger
        // a nextTick recursion warning, but that's not so bad.

        function emitReadable(stream) {
          const state = stream._readableState;
          debug('emitReadable', state.needReadable, state.emittedReadable);
          state.needReadable = false;

          if (!state.emittedReadable) {
            debug('emitReadable', state.flowing);
            state.emittedReadable = true;
            process.nextTick(emitReadable_, stream);
          }
        }

        function emitReadable_(stream) {
          const state = stream._readableState;
          debug('emitReadable_', state.destroyed, state.length, state.ended);

          if (!state.destroyed && (state.length || state.ended)) {
            stream.emit('readable');
            state.emittedReadable = false;
          } // The stream needs another readable event if
          // 1. It is not flowing, as the flow mechanism will take
          //    care of it.
          // 2. It is not ended.
          // 3. It is below the highWaterMark, so we can schedule
          //    another readable later.

          state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
          flow(stream);
        } // at this point, the user has presumably seen the 'readable' event,
        // and called read() to consume some data.  that may have triggered
        // in turn another _read(n) call, in which case reading = true if
        // it's in progress.
        // However, if we're not ended, or reading, and the length < hwm,
        // then go ahead and try to read some more preemptively.

        function maybeReadMore(stream, state) {
          if (!state.readingMore) {
            state.readingMore = true;
            process.nextTick(maybeReadMore_, stream, state);
          }
        }

        function maybeReadMore_(stream, state) {
          // Attempt to read more data if we should.
          //
          // The conditions for reading more data are (one of):
          // - Not enough data buffered (state.length < state.highWaterMark). The loop
          //   is responsible for filling the buffer with enough data if such data
          //   is available. If highWaterMark is 0 and we are not in the flowing mode
          //   we should _not_ attempt to buffer any extra data. We'll get more data
          //   when the stream consumer calls read() instead.
          // - No data in the buffer, and the stream is in flowing mode. In this mode
          //   the loop below is responsible for ensuring read() is called. Failing to
          //   call read here would abort the flow and there's no other mechanism for
          //   continuing the flow if the stream consumer has just subscribed to the
          //   'data' event.
          //
          // In addition to the above conditions to keep reading data, the following
          // conditions prevent the data from being read:
          // - The stream has ended (state.ended).
          // - There is already a pending 'read' operation (state.reading). This is a
          //   case where the the stream has called the implementation defined _read()
          //   method, but they are processing the call asynchronously and have _not_
          //   called push() with new data. In this case we skip performing more
          //   read()s. The execution ends in this method again after the _read() ends
          //   up calling push() with more data.
          while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
            const len = state.length;
            debug('maybeReadMore read 0');
            stream.read(0);
            if (len === state.length) // didn't get any data, stop spinning.
            { break; }
          }

          state.readingMore = false;
        } // abstract method.  to be overridden in specific implementation classes.
        // call cb(er, data) where data is <= n in length.
        // for virtual (non-string, non-buffer) streams, "length" is somewhat
        // arbitrary, and perhaps not very meaningful.

        Readable.prototype._read = function (n) {
          errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
        };

        Readable.prototype.pipe = function (dest, pipeOpts) {
          const src = this;
          const state = this._readableState;

          switch (state.pipesCount) {
            case 0:
              state.pipes = dest;
              break;

            case 1:
              state.pipes = [state.pipes, dest];
              break;

            default:
              state.pipes.push(dest);
              break;
          }

          state.pipesCount += 1;
          debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
          const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
          const endFn = doEnd ? onend : unpipe;
          if (state.endEmitted) process.nextTick(endFn); else src.once('end', endFn);
          dest.on('unpipe', onunpipe);

          function onunpipe(readable, unpipeInfo) {
            debug('onunpipe');

            if (readable === src) {
              if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
              }
            }
          }

          function onend() {
            debug('onend');
            dest.end();
          } // when the dest drains, it reduces the awaitDrain counter
          // on the source.  This would be more elegant with a .once()
          // handler in flow(), but adding and removing repeatedly is
          // too slow.

          const ondrain = pipeOnDrain(src);
          dest.on('drain', ondrain);
          let cleanedUp = false;

          function cleanup() {
            debug('cleanup'); // cleanup event handlers once the pipe is broken

            dest.removeListener('close', onclose);
            dest.removeListener('finish', onfinish);
            dest.removeListener('drain', ondrain);
            dest.removeListener('error', onerror);
            dest.removeListener('unpipe', onunpipe);
            src.removeListener('end', onend);
            src.removeListener('end', unpipe);
            src.removeListener('data', ondata);
            cleanedUp = true; // if the reader is waiting for a drain event from this
            // specific writer, then it would cause it to never start
            // flowing again.
            // So, if this is awaiting a drain, then we just call it now.
            // If we don't know, then assume that we are waiting for one.

            if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
          }

          src.on('data', ondata);

          function ondata(chunk) {
            debug('ondata');
            const ret = dest.write(chunk);
            debug('dest.write', ret);

            if (ret === false) {
              // If the user unpiped during `dest.write()`, it is possible
              // to get stuck in a permanently paused state if that write
              // also returned false.
              // => Check whether `dest` is still a piping destination.
              if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
              }

              src.pause();
            }
          } // if the dest has an error, then stop piping into it.
          // however, don't suppress the throwing behavior for this.

          function onerror(er) {
            debug('onerror', er);
            unpipe();
            dest.removeListener('error', onerror);
            if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
          } // Make sure our error handler is attached before userland ones.

          prependListener(dest, 'error', onerror); // Both close and finish should trigger unpipe, but only once.

          function onclose() {
            dest.removeListener('finish', onfinish);
            unpipe();
          }

          dest.once('close', onclose);

          function onfinish() {
            debug('onfinish');
            dest.removeListener('close', onclose);
            unpipe();
          }

          dest.once('finish', onfinish);

          function unpipe() {
            debug('unpipe');
            src.unpipe(dest);
          } // tell the dest that it's being piped to

          dest.emit('pipe', src); // start the flow if it hasn't been started already.

          if (!state.flowing) {
            debug('pipe resume');
            src.resume();
          }

          return dest;
        };

        function pipeOnDrain(src) {
          return function pipeOnDrainFunctionResult() {
            const state = src._readableState;
            debug('pipeOnDrain', state.awaitDrain);
            if (state.awaitDrain) state.awaitDrain--;

            if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
              state.flowing = true;
              flow(src);
            }
          };
        }

        Readable.prototype.unpipe = function (dest) {
          const state = this._readableState;
          const unpipeInfo = {
            hasUnpiped: false,
          }; // if we're not piping anywhere, then do nothing.

          if (state.pipesCount === 0) return this; // just one destination.  most common case.

          if (state.pipesCount === 1) {
            // passed in one, but it's not the right one.
            if (dest && dest !== state.pipes) return this;
            if (!dest) dest = state.pipes; // got a match.

            state.pipes = null;
            state.pipesCount = 0;
            state.flowing = false;
            if (dest) dest.emit('unpipe', this, unpipeInfo);
            return this;
          } // slow case. multiple pipe destinations.

          if (!dest) {
            // remove all.
            const dests = state.pipes;
            const len = state.pipesCount;
            state.pipes = null;
            state.pipesCount = 0;
            state.flowing = false;

            for (let i = 0; i < len; i++) {
              dests[i].emit('unpipe', this, {
                hasUnpiped: false,
              });
            }

            return this;
          } // try to find the right one.

          const index = indexOf(state.pipes, dest);
          if (index === -1) return this;
          state.pipes.splice(index, 1);
          state.pipesCount -= 1;
          if (state.pipesCount === 1) state.pipes = state.pipes[0];
          dest.emit('unpipe', this, unpipeInfo);
          return this;
        }; // set up data events if they are asked for
        // Ensure readable listeners eventually get something

        Readable.prototype.on = function (ev, fn) {
          const res = Stream.prototype.on.call(this, ev, fn);
          const state = this._readableState;

          if (ev === 'data') {
            // update readableListening so that resume() may be a no-op
            // a few lines down. This is needed to support once('readable').
            state.readableListening = this.listenerCount('readable') > 0; // Try start flowing on next tick if stream isn't explicitly paused

            if (state.flowing !== false) this.resume();
          } else if (ev === 'readable') {
            if (!state.endEmitted && !state.readableListening) {
              state.readableListening = state.needReadable = true;
              state.flowing = false;
              state.emittedReadable = false;
              debug('on readable', state.length, state.reading);

              if (state.length) {
                emitReadable(this);
              } else if (!state.reading) {
                process.nextTick(nReadingNextTick, this);
              }
            }
          }

          return res;
        };

        Readable.prototype.addListener = Readable.prototype.on;

        Readable.prototype.removeListener = function (ev, fn) {
          const res = Stream.prototype.removeListener.call(this, ev, fn);

          if (ev === 'readable') {
            // We need to check if there is someone still listening to
            // readable and reset the state. However this needs to happen
            // after readable has been emitted but before I/O (nextTick) to
            // support once('readable', fn) cycles. This means that calling
            // resume within the same tick will have no
            // effect.
            process.nextTick(updateReadableListening, this);
          }

          return res;
        };

        Readable.prototype.removeAllListeners = function (ev) {
          const res = Stream.prototype.removeAllListeners.apply(this, arguments);

          if (ev === 'readable' || ev === undefined) {
            // We need to check if there is someone still listening to
            // readable and reset the state. However this needs to happen
            // after readable has been emitted but before I/O (nextTick) to
            // support once('readable', fn) cycles. This means that calling
            // resume within the same tick will have no
            // effect.
            process.nextTick(updateReadableListening, this);
          }

          return res;
        };

        function updateReadableListening(self) {
          const state = self._readableState;
          state.readableListening = self.listenerCount('readable') > 0;

          if (state.resumeScheduled && !state.paused) {
            // flowing needs to be set to true now, otherwise
            // the upcoming resume will not flow.
            state.flowing = true; // crude way to check if we should resume
          } else if (self.listenerCount('data') > 0) {
            self.resume();
          }
        }

        function nReadingNextTick(self) {
          debug('readable nexttick read 0');
          self.read(0);
        } // pause() and resume() are remnants of the legacy readable stream API
        // If the user uses them, then switch into old mode.

        Readable.prototype.resume = function () {
          const state = this._readableState;

          if (!state.flowing) {
            debug('resume'); // we flow only if there is no one listening
            // for readable, but we still have to call
            // resume()

            state.flowing = !state.readableListening;
            resume(this, state);
          }

          state.paused = false;
          return this;
        };

        function resume(stream, state) {
          if (!state.resumeScheduled) {
            state.resumeScheduled = true;
            process.nextTick(resume_, stream, state);
          }
        }

        function resume_(stream, state) {
          debug('resume', state.reading);

          if (!state.reading) {
            stream.read(0);
          }

          state.resumeScheduled = false;
          stream.emit('resume');
          flow(stream);
          if (state.flowing && !state.reading) stream.read(0);
        }

        Readable.prototype.pause = function () {
          debug('call pause flowing=%j', this._readableState.flowing);

          if (this._readableState.flowing !== false) {
            debug('pause');
            this._readableState.flowing = false;
            this.emit('pause');
          }

          this._readableState.paused = true;
          return this;
        };

        function flow(stream) {
          const state = stream._readableState;
          debug('flow', state.flowing);

          while (state.flowing && stream.read() !== null) {

          }
        } // wrap an old-style stream as the async data source.
        // This is *not* part of the readable stream interface.
        // It is an ugly unfortunate mess of history.

        Readable.prototype.wrap = function (stream) {
          const _this = this;

          const state = this._readableState;
          let paused = false;
          stream.on('end', () => {
            debug('wrapped end');

            if (state.decoder && !state.ended) {
              const chunk = state.decoder.end();
              if (chunk && chunk.length) _this.push(chunk);
            }

            _this.push(null);
          });
          stream.on('data', (chunk) => {
            debug('wrapped data');
            if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode

            if (state.objectMode && (chunk === null || chunk === undefined)) return; if (!state.objectMode && (!chunk || !chunk.length)) return;

            const ret = _this.push(chunk);

            if (!ret) {
              paused = true;
              stream.pause();
            }
          }); // proxy all the other methods.
          // important when wrapping filters and duplexes.

          for (const i in stream) {
            if (this[i] === undefined && typeof stream[i] === 'function') {
              this[i] = (function methodWrap(method) {
                return function methodWrapReturnFunction() {
                  return stream[method].apply(stream, arguments);
                };
              }(i));
            }
          } // proxy certain important events.

          for (let n = 0; n < kProxyEvents.length; n++) {
            stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
          } // when we try to consume some more bytes, simply unpause the
          // underlying stream.

          this._read = function (n) {
            debug('wrapped _read', n);

            if (paused) {
              paused = false;
              stream.resume();
            }
          };

          return this;
        };

        if (typeof Symbol === 'function') {
          Readable.prototype[Symbol.asyncIterator] = function () {
            if (createReadableStreamAsyncIterator === undefined) {
              createReadableStreamAsyncIterator = __webpack_require__(828);
            }

            return createReadableStreamAsyncIterator(this);
          };
        }

        Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
          // making it explicit this property is not enumerable
          // because otherwise some prototype manipulation in
          // userland will fail
          enumerable: false,
          get: function get() {
            return this._readableState.highWaterMark;
          },
        });
        Object.defineProperty(Readable.prototype, 'readableBuffer', {
          // making it explicit this property is not enumerable
          // because otherwise some prototype manipulation in
          // userland will fail
          enumerable: false,
          get: function get() {
            return this._readableState && this._readableState.buffer;
          },
        });
        Object.defineProperty(Readable.prototype, 'readableFlowing', {
          // making it explicit this property is not enumerable
          // because otherwise some prototype manipulation in
          // userland will fail
          enumerable: false,
          get: function get() {
            return this._readableState.flowing;
          },
          set: function set(state) {
            if (this._readableState) {
              this._readableState.flowing = state;
            }
          },
        }); // exposed for testing purposes only.

        Readable._fromList = fromList;
        Object.defineProperty(Readable.prototype, 'readableLength', {
          // making it explicit this property is not enumerable
          // because otherwise some prototype manipulation in
          // userland will fail
          enumerable: false,
          get: function get() {
            return this._readableState.length;
          },
        }); // Pluck off n bytes from an array of buffers.
        // Length is the combined lengths of all the buffers in the list.
        // This function is designed to be inlinable, so please take care when making
        // changes to the function body.

        function fromList(n, state) {
          // nothing buffered
          if (state.length === 0) return null;
          let ret;
          if (state.objectMode) ret = state.buffer.shift(); else if (!n || n >= state.length) {
            // read it all, truncate the list
            if (state.decoder) ret = state.buffer.join(''); else if (state.buffer.length === 1) ret = state.buffer.first(); else ret = state.buffer.concat(state.length);
            state.buffer.clear();
          } else {
            // read part of list
            ret = state.buffer.consume(n, state.decoder);
          }
          return ret;
        }

        function endReadable(stream) {
          const state = stream._readableState;
          debug('endReadable', state.endEmitted);

          if (!state.endEmitted) {
            state.ended = true;
            process.nextTick(endReadableNT, state, stream);
          }
        }

        function endReadableNT(state, stream) {
          debug('endReadableNT', state.endEmitted, state.length); // Check that we didn't get one last unshift.

          if (!state.endEmitted && state.length === 0) {
            state.endEmitted = true;
            stream.readable = false;
            stream.emit('end');

            if (state.autoDestroy) {
              // In case of duplex streams we need a way to detect
              // if the writable side is ready for autoDestroy as well
              const wState = stream._writableState;

              if (!wState || wState.autoDestroy && wState.finished) {
                stream.destroy();
              }
            }
          }
        }

        if (typeof Symbol === 'function') {
          Readable.from = function (iterable, opts) {
            if (from === undefined) {
              from = __webpack_require__(1265);
            }

            return from(Readable, iterable, opts);
          };
        }

        function indexOf(xs, x) {
          for (let i = 0, l = xs.length; i < l; i++) {
            if (xs[i] === x) return i;
          }

          return -1;
        }
        /***/ }),

      /***/ 4473:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        // Copyright Joyent, Inc. and other Node contributors.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a
        // copy of this software and associated documentation files (the
        // "Software"), to deal in the Software without restriction, including
        // without limitation the rights to use, copy, modify, merge, publish,
        // distribute, sublicense, and/or sell copies of the Software, and to permit
        // persons to whom the Software is furnished to do so, subject to the
        // following conditions:
        //
        // The above copyright notice and this permission notice shall be included
        // in all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
        // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
        // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
        // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
        // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
        // USE OR OTHER DEALINGS IN THE SOFTWARE.
        // a transform stream is a readable/writable stream where you do
        // something with the data.  Sometimes it's called a "filter",
        // but that's not a great name for it, since that implies a thing where
        // some bits pass through, and others are simply ignored.  (That would
        // be a valid example of a transform, of course.)
        //
        // While the output is causally related to the input, it's not a
        // necessarily symmetric or synchronous transformation.  For example,
        // a zlib stream might take multiple plain-text writes(), and then
        // emit a single compressed chunk some time in the future.
        //
        // Here's how this works:
        //
        // The Transform stream has all the aspects of the readable and writable
        // stream classes.  When you write(chunk), that calls _write(chunk,cb)
        // internally, and returns false if there's a lot of pending writes
        // buffered up.  When you call read(), that calls _read(n) until
        // there's enough pending readable data buffered up.
        //
        // In a transform stream, the written data is placed in a buffer.  When
        // _read(n) is called, it transforms the queued up data, calling the
        // buffered _write cb's as it consumes chunks.  If consuming a single
        // written chunk would result in multiple output chunks, then the first
        // outputted bit calls the readcb, and subsequent chunks just go into
        // the read buffer, and will cause it to emit 'readable' if necessary.
        //
        // This way, back-pressure is actually determined by the reading side,
        // since _read has to be called to start processing a new chunk.  However,
        // a pathological inflate type of transform can cause excessive buffering
        // here.  For example, imagine a stream where every byte of input is
        // interpreted as an integer from 0-255, and then results in that many
        // bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
        // 1kb of data being output.  In this case, you could write a very small
        // amount of input, and end up with a very large amount of output.  In
        // such a pathological inflating mechanism, there'd be no way to tell
        // the system to stop doing the transform.  A single 4MB write could
        // cause the system to run out of memory.
        //
        // However, even in such a pathological case, only a single written chunk
        // would be consumed, and then the rest would wait (un-transformed) until
        // the results of the previous transformed chunk were consumed.

        module.exports = Transform;

        const _require$codes = (__webpack_require__(8106).q);
        const { ERR_METHOD_NOT_IMPLEMENTED } = _require$codes;
        const { ERR_MULTIPLE_CALLBACK } = _require$codes;
        const { ERR_TRANSFORM_ALREADY_TRANSFORMING } = _require$codes;
        const { ERR_TRANSFORM_WITH_LENGTH_0 } = _require$codes;

        const Duplex = __webpack_require__(8656);

        __webpack_require__(5717)(Transform, Duplex);

        function afterTransform(er, data) {
          const ts = this._transformState;
          ts.transforming = false;
          const cb = ts.writecb;

          if (cb === null) {
            return this.emit('error', new ERR_MULTIPLE_CALLBACK());
          }

          ts.writechunk = null;
          ts.writecb = null;
          if (data != null) // single equals check for both `null` and `undefined`
          { this.push(data); }
          cb(er);
          const rs = this._readableState;
          rs.reading = false;

          if (rs.needReadable || rs.length < rs.highWaterMark) {
            this._read(rs.highWaterMark);
          }
        }

        function Transform(options) {
          if (!(this instanceof Transform)) return new Transform(options);
          Duplex.call(this, options);
          this._transformState = {
            afterTransform: afterTransform.bind(this),
            needTransform: false,
            transforming: false,
            writecb: null,
            writechunk: null,
            writeencoding: null,
          }; // start out asking for a readable event once data is transformed.

          this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
          // that Readable wants before the first _read call, so unset the
          // sync guard flag.

          this._readableState.sync = false;

          if (options) {
            if (typeof options.transform === 'function') this._transform = options.transform;
            if (typeof options.flush === 'function') this._flush = options.flush;
          } // When the writable side finishes, then flush out anything remaining.

          this.on('prefinish', prefinish);
        }

        function prefinish() {
          const _this = this;

          if (typeof this._flush === 'function' && !this._readableState.destroyed) {
            this._flush((er, data) => {
              done(_this, er, data);
            });
          } else {
            done(this, null, null);
          }
        }

        Transform.prototype.push = function (chunk, encoding) {
          this._transformState.needTransform = false;
          return Duplex.prototype.push.call(this, chunk, encoding);
        }; // This is the part where you do stuff!
        // override this function in implementation classes.
        // 'chunk' is an input chunk.
        //
        // Call `push(newChunk)` to pass along transformed output
        // to the readable side.  You may call 'push' zero or more times.
        //
        // Call `cb(err)` when you are done with this chunk.  If you pass
        // an error, then that'll put the hurt on the whole operation.  If you
        // never call cb(), then you'll never get another chunk.

        Transform.prototype._transform = function (chunk, encoding, cb) {
          cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
        };

        Transform.prototype._write = function (chunk, encoding, cb) {
          const ts = this._transformState;
          ts.writecb = cb;
          ts.writechunk = chunk;
          ts.writeencoding = encoding;

          if (!ts.transforming) {
            const rs = this._readableState;
            if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
          }
        }; // Doesn't matter what the args are here.
        // _transform does all the work.
        // That we got here means that the readable side wants more data.

        Transform.prototype._read = function (n) {
          const ts = this._transformState;

          if (ts.writechunk !== null && !ts.transforming) {
            ts.transforming = true;

            this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
          } else {
            // mark that we need a transform, so that any data that comes in
            // will get processed, now that we've asked for it.
            ts.needTransform = true;
          }
        };

        Transform.prototype._destroy = function (err, cb) {
          Duplex.prototype._destroy.call(this, err, (err2) => {
            cb(err2);
          });
        };

        function done(stream, er, data) {
          if (er) return stream.emit('error', er);
          if (data != null) // single equals check for both `null` and `undefined`
          { stream.push(data); } // TODO(BridgeAR): Write a test for these two error cases
          // if there's nothing in the write buffer, then that means
          // that nothing more will ever be provided

          if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
          if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
          return stream.push(null);
        }
        /***/ }),

      /***/ 323:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* provided dependency */ const process = __webpack_require__(4155);
        // Copyright Joyent, Inc. and other Node contributors.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a
        // copy of this software and associated documentation files (the
        // "Software"), to deal in the Software without restriction, including
        // without limitation the rights to use, copy, modify, merge, publish,
        // distribute, sublicense, and/or sell copies of the Software, and to permit
        // persons to whom the Software is furnished to do so, subject to the
        // following conditions:
        //
        // The above copyright notice and this permission notice shall be included
        // in all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
        // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
        // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
        // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
        // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
        // USE OR OTHER DEALINGS IN THE SOFTWARE.
        // A bit simpler than readable streams.
        // Implement an async ._write(chunk, encoding, cb), and it'll handle all
        // the drain event emission and buffering.

        module.exports = Writable;
        /* <replacement> */

        function WriteReq(chunk, encoding, cb) {
          this.chunk = chunk;
          this.encoding = encoding;
          this.callback = cb;
          this.next = null;
        } // It seems a linked list but it is not
        // there will be only 2 of these for each stream

        function CorkedRequest(state) {
          const _this = this;

          this.next = null;
          this.entry = null;

          this.finish = function () {
            onCorkedFinish(_this, state);
          };
        }
        /* </replacement> */

        /* <replacement> */

        let Duplex;
        /* </replacement> */

        Writable.WritableState = WritableState;
        /* <replacement> */

        const internalUtil = {
          deprecate: __webpack_require__(4927),
        };
        /* </replacement> */

        /* <replacement> */

        const Stream = __webpack_require__(3194);
        /* </replacement> */

        const { Buffer } = __webpack_require__(8823);

        const OurUint8Array = __webpack_require__.g.Uint8Array || function () {};

        function _uint8ArrayToBuffer(chunk) {
          return Buffer.from(chunk);
        }

        function _isUint8Array(obj) {
          return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
        }

        const destroyImpl = __webpack_require__(1029);

        const _require = __webpack_require__(94);
        const { getHighWaterMark } = _require;

        const _require$codes = (__webpack_require__(8106).q);
        const { ERR_INVALID_ARG_TYPE } = _require$codes;
        const { ERR_METHOD_NOT_IMPLEMENTED } = _require$codes;
        const { ERR_MULTIPLE_CALLBACK } = _require$codes;
        const { ERR_STREAM_CANNOT_PIPE } = _require$codes;
        const { ERR_STREAM_DESTROYED } = _require$codes;
        const { ERR_STREAM_NULL_VALUES } = _require$codes;
        const { ERR_STREAM_WRITE_AFTER_END } = _require$codes;
        const { ERR_UNKNOWN_ENCODING } = _require$codes;

        const { errorOrDestroy } = destroyImpl;

        __webpack_require__(5717)(Writable, Stream);

        function nop() {}

        function WritableState(options, stream, isDuplex) {
          Duplex = Duplex || __webpack_require__(8656);
          options = options || {}; // Duplex streams are both readable and writable, but share
          // the same options object.
          // However, some cases require setting options to different
          // values for the readable and the writable sides of the duplex stream,
          // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.

          if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex; // object stream flag to indicate whether or not this stream
          // contains buffers or objects.

          this.objectMode = !!options.objectMode;
          if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
          // Note: 0 is a valid value, means that we always return false if
          // the entire buffer is not flushed immediately on write()

          this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex); // if _final has been called

          this.finalCalled = false; // drain event flag.

          this.needDrain = false; // at the start of calling end()

          this.ending = false; // when end() has been called, and returned

          this.ended = false; // when 'finish' is emitted

          this.finished = false; // has it been destroyed

          this.destroyed = false; // should we decode strings into buffers before passing to _write?
          // this is here so that some node-core streams can optimize string
          // handling at a lower level.

          const noDecode = options.decodeStrings === false;
          this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
          // encoding is 'binary' so we have to make this configurable.
          // Everything else in the universe uses 'utf8', though.

          this.defaultEncoding = options.defaultEncoding || 'utf8'; // not an actual buffer we keep track of, but a measurement
          // of how much we're waiting to get pushed to some underlying
          // socket or file.

          this.length = 0; // a flag to see when we're in the middle of a write.

          this.writing = false; // when true all writes will be buffered until .uncork() call

          this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
          // or on a later tick.  We set this to true at first, because any
          // actions that shouldn't happen until "later" should generally also
          // not happen before the first write call.

          this.sync = true; // a flag to know if we're processing previously buffered items, which
          // may call the _write() callback in the same tick, so that we don't
          // end up in an overlapped onwrite situation.

          this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)

          this.onwrite = function (er) {
            onwrite(stream, er);
          }; // the callback that the user supplies to write(chunk,encoding,cb)

          this.writecb = null; // the amount that is being written when _write is called.

          this.writelen = 0;
          this.bufferedRequest = null;
          this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
          // this must be 0 before 'finish' can be emitted

          this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
          // This is relevant for synchronous Transform streams

          this.prefinished = false; // True if the error was already emitted and should not be thrown again

          this.errorEmitted = false; // Should close be emitted on destroy. Defaults to true.

          this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'finish' (and potentially 'end')

          this.autoDestroy = !!options.autoDestroy; // count buffered requests

          this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
          // one allocated and free to use, and we maintain at most two

          this.corkedRequestsFree = new CorkedRequest(this);
        }

        WritableState.prototype.getBuffer = function getBuffer() {
          let current = this.bufferedRequest;
          const out = [];

          while (current) {
            out.push(current);
            current = current.next;
          }

          return out;
        };

        (function () {
          try {
            Object.defineProperty(WritableState.prototype, 'buffer', {
              get: internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
              }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003'),
            });
          } catch (_) {}
        }()); // Test _writableState for inheritance to account for Duplex streams,
        // whose prototype chain only points to Readable.

        let realHasInstance;

        if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
          realHasInstance = Function.prototype[Symbol.hasInstance];
          Object.defineProperty(Writable, Symbol.hasInstance, {
            value: function value(object) {
              if (realHasInstance.call(this, object)) return true;
              if (this !== Writable) return false;
              return object && object._writableState instanceof WritableState;
            },
          });
        } else {
          realHasInstance = function realHasInstance(object) {
            return object instanceof this;
          };
        }

        function Writable(options) {
          Duplex = Duplex || __webpack_require__(8656); // Writable ctor is applied to Duplexes, too.
          // `realHasInstance` is necessary because using plain `instanceof`
          // would return false, as no `_writableState` property is attached.
          // Trying to use the custom `instanceof` for Writable here will also break the
          // Node.js LazyTransform implementation, which has a non-trivial getter for
          // `_writableState` that would lead to infinite recursion.
          // Checking for a Stream.Duplex instance is faster here instead of inside
          // the WritableState constructor, at least with V8 6.5

          const isDuplex = this instanceof Duplex;
          if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
          this._writableState = new WritableState(options, this, isDuplex); // legacy.

          this.writable = true;

          if (options) {
            if (typeof options.write === 'function') this._write = options.write;
            if (typeof options.writev === 'function') this._writev = options.writev;
            if (typeof options.destroy === 'function') this._destroy = options.destroy;
            if (typeof options.final === 'function') this._final = options.final;
          }

          Stream.call(this);
        } // Otherwise people can pipe Writable streams, which is just wrong.

        Writable.prototype.pipe = function () {
          errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
        };

        function writeAfterEnd(stream, cb) {
          const er = new ERR_STREAM_WRITE_AFTER_END(); // TODO: defer error events consistently everywhere, not just the cb

          errorOrDestroy(stream, er);
          process.nextTick(cb, er);
        } // Checks that a user-supplied chunk is valid, especially for the particular
        // mode the stream is in. Currently this means that `null` is never accepted
        // and undefined/non-string values are only allowed in object mode.

        function validChunk(stream, state, chunk, cb) {
          let er;

          if (chunk === null) {
            er = new ERR_STREAM_NULL_VALUES();
          } else if (typeof chunk !== 'string' && !state.objectMode) {
            er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
          }

          if (er) {
            errorOrDestroy(stream, er);
            process.nextTick(cb, er);
            return false;
          }

          return true;
        }

        Writable.prototype.write = function (chunk, encoding, cb) {
          const state = this._writableState;
          let ret = false;

          const isBuf = !state.objectMode && _isUint8Array(chunk);

          if (isBuf && !Buffer.isBuffer(chunk)) {
            chunk = _uint8ArrayToBuffer(chunk);
          }

          if (typeof encoding === 'function') {
            cb = encoding;
            encoding = null;
          }

          if (isBuf) encoding = 'buffer'; else if (!encoding) encoding = state.defaultEncoding;
          if (typeof cb !== 'function') cb = nop;
          if (state.ending) writeAfterEnd(this, cb); else if (isBuf || validChunk(this, state, chunk, cb)) {
            state.pendingcb++;
            ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
          }
          return ret;
        };

        Writable.prototype.cork = function () {
          this._writableState.corked++;
        };

        Writable.prototype.uncork = function () {
          const state = this._writableState;

          if (state.corked) {
            state.corked--;
            if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
          }
        };

        Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
          // node::ParseEncoding() requires lower case.
          if (typeof encoding === 'string') encoding = encoding.toLowerCase();
          if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((`${encoding}`).toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
          this._writableState.defaultEncoding = encoding;
          return this;
        };

        Object.defineProperty(Writable.prototype, 'writableBuffer', {
          // making it explicit this property is not enumerable
          // because otherwise some prototype manipulation in
          // userland will fail
          enumerable: false,
          get: function get() {
            return this._writableState && this._writableState.getBuffer();
          },
        });

        function decodeChunk(state, chunk, encoding) {
          if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
            chunk = Buffer.from(chunk, encoding);
          }

          return chunk;
        }

        Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
          // making it explicit this property is not enumerable
          // because otherwise some prototype manipulation in
          // userland will fail
          enumerable: false,
          get: function get() {
            return this._writableState.highWaterMark;
          },
        }); // if we're already writing something, then just put this
        // in the queue, and wait our turn.  Otherwise, call _write
        // If we return false, then we need a drain event, so set that flag.

        function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
          if (!isBuf) {
            const newChunk = decodeChunk(state, chunk, encoding);

            if (chunk !== newChunk) {
              isBuf = true;
              encoding = 'buffer';
              chunk = newChunk;
            }
          }

          const len = state.objectMode ? 1 : chunk.length;
          state.length += len;
          const ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.

          if (!ret) state.needDrain = true;

          if (state.writing || state.corked) {
            const last = state.lastBufferedRequest;
            state.lastBufferedRequest = {
              chunk,
              encoding,
              isBuf,
              callback: cb,
              next: null,
            };

            if (last) {
              last.next = state.lastBufferedRequest;
            } else {
              state.bufferedRequest = state.lastBufferedRequest;
            }

            state.bufferedRequestCount += 1;
          } else {
            doWrite(stream, state, false, len, chunk, encoding, cb);
          }

          return ret;
        }

        function doWrite(stream, state, writev, len, chunk, encoding, cb) {
          state.writelen = len;
          state.writecb = cb;
          state.writing = true;
          state.sync = true;
          if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write')); else if (writev) stream._writev(chunk, state.onwrite); else stream._write(chunk, encoding, state.onwrite);
          state.sync = false;
        }

        function onwriteError(stream, state, sync, er, cb) {
          --state.pendingcb;

          if (sync) {
            // defer the callback if we are being called synchronously
            // to avoid piling up things on the stack
            process.nextTick(cb, er); // this can emit finish, and it will always happen
            // after error

            process.nextTick(finishMaybe, stream, state);
            stream._writableState.errorEmitted = true;
            errorOrDestroy(stream, er);
          } else {
            // the caller expect this to happen before if
            // it is async
            cb(er);
            stream._writableState.errorEmitted = true;
            errorOrDestroy(stream, er); // this can emit finish, but finish must
            // always follow error

            finishMaybe(stream, state);
          }
        }

        function onwriteStateUpdate(state) {
          state.writing = false;
          state.writecb = null;
          state.length -= state.writelen;
          state.writelen = 0;
        }

        function onwrite(stream, er) {
          const state = stream._writableState;
          const { sync } = state;
          const cb = state.writecb;
          if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
          onwriteStateUpdate(state);
          if (er) onwriteError(stream, state, sync, er, cb); else {
            // Check if we're actually ready to finish, but don't emit yet
            const finished = needFinish(state) || stream.destroyed;

            if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
              clearBuffer(stream, state);
            }

            if (sync) {
              process.nextTick(afterWrite, stream, state, finished, cb);
            } else {
              afterWrite(stream, state, finished, cb);
            }
          }
        }

        function afterWrite(stream, state, finished, cb) {
          if (!finished) onwriteDrain(stream, state);
          state.pendingcb--;
          cb();
          finishMaybe(stream, state);
        } // Must force callback to be called on nextTick, so that we don't
        // emit 'drain' before the write() consumer gets the 'false' return
        // value, and has a chance to attach a 'drain' listener.

        function onwriteDrain(stream, state) {
          if (state.length === 0 && state.needDrain) {
            state.needDrain = false;
            stream.emit('drain');
          }
        } // if there's something in the buffer waiting, then process it

        function clearBuffer(stream, state) {
          state.bufferProcessing = true;
          let entry = state.bufferedRequest;

          if (stream._writev && entry && entry.next) {
            // Fast case, write everything using _writev()
            const l = state.bufferedRequestCount;
            const buffer = new Array(l);
            const holder = state.corkedRequestsFree;
            holder.entry = entry;
            let count = 0;
            let allBuffers = true;

            while (entry) {
              buffer[count] = entry;
              if (!entry.isBuf) allBuffers = false;
              entry = entry.next;
              count += 1;
            }

            buffer.allBuffers = allBuffers;
            doWrite(stream, state, true, state.length, buffer, '', holder.finish); // doWrite is almost always async, defer these to save a bit of time
            // as the hot path ends with doWrite

            state.pendingcb++;
            state.lastBufferedRequest = null;

            if (holder.next) {
              state.corkedRequestsFree = holder.next;
              holder.next = null;
            } else {
              state.corkedRequestsFree = new CorkedRequest(state);
            }

            state.bufferedRequestCount = 0;
          } else {
            // Slow case, write chunks one-by-one
            while (entry) {
              const { chunk } = entry;
              const { encoding } = entry;
              const cb = entry.callback;
              const len = state.objectMode ? 1 : chunk.length;
              doWrite(stream, state, false, len, chunk, encoding, cb);
              entry = entry.next;
              state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
              // it means that we need to wait until it does.
              // also, that means that the chunk and cb are currently
              // being processed, so move the buffer counter past them.

              if (state.writing) {
                break;
              }
            }

            if (entry === null) state.lastBufferedRequest = null;
          }

          state.bufferedRequest = entry;
          state.bufferProcessing = false;
        }

        Writable.prototype._write = function (chunk, encoding, cb) {
          cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
        };

        Writable.prototype._writev = null;

        Writable.prototype.end = function (chunk, encoding, cb) {
          const state = this._writableState;

          if (typeof chunk === 'function') {
            cb = chunk;
            chunk = null;
            encoding = null;
          } else if (typeof encoding === 'function') {
            cb = encoding;
            encoding = null;
          }

          if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks

          if (state.corked) {
            state.corked = 1;
            this.uncork();
          } // ignore unnecessary end() calls.

          if (!state.ending) endWritable(this, state, cb);
          return this;
        };

        Object.defineProperty(Writable.prototype, 'writableLength', {
          // making it explicit this property is not enumerable
          // because otherwise some prototype manipulation in
          // userland will fail
          enumerable: false,
          get: function get() {
            return this._writableState.length;
          },
        });

        function needFinish(state) {
          return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
        }

        function callFinal(stream, state) {
          stream._final((err) => {
            state.pendingcb--;

            if (err) {
              errorOrDestroy(stream, err);
            }

            state.prefinished = true;
            stream.emit('prefinish');
            finishMaybe(stream, state);
          });
        }

        function prefinish(stream, state) {
          if (!state.prefinished && !state.finalCalled) {
            if (typeof stream._final === 'function' && !state.destroyed) {
              state.pendingcb++;
              state.finalCalled = true;
              process.nextTick(callFinal, stream, state);
            } else {
              state.prefinished = true;
              stream.emit('prefinish');
            }
          }
        }

        function finishMaybe(stream, state) {
          const need = needFinish(state);

          if (need) {
            prefinish(stream, state);

            if (state.pendingcb === 0) {
              state.finished = true;
              stream.emit('finish');

              if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                const rState = stream._readableState;

                if (!rState || rState.autoDestroy && rState.endEmitted) {
                  stream.destroy();
                }
              }
            }
          }

          return need;
        }

        function endWritable(stream, state, cb) {
          state.ending = true;
          finishMaybe(stream, state);

          if (cb) {
            if (state.finished) process.nextTick(cb); else stream.once('finish', cb);
          }

          state.ended = true;
          stream.writable = false;
        }

        function onCorkedFinish(corkReq, state, err) {
          let { entry } = corkReq;
          corkReq.entry = null;

          while (entry) {
            const cb = entry.callback;
            state.pendingcb--;
            cb(err);
            entry = entry.next;
          } // reuse the free corkReq.

          state.corkedRequestsFree.next = corkReq;
        }

        Object.defineProperty(Writable.prototype, 'destroyed', {
          // making it explicit this property is not enumerable
          // because otherwise some prototype manipulation in
          // userland will fail
          enumerable: false,
          get: function get() {
            if (this._writableState === undefined) {
              return false;
            }

            return this._writableState.destroyed;
          },
          set: function set(value) {
            // we ignore the value if the stream
            // has not been initialized yet
            if (!this._writableState) {
              return;
            } // backward compatibility, the user is explicitly
            // managing destroyed

            this._writableState.destroyed = value;
          },
        });
        Writable.prototype.destroy = destroyImpl.destroy;
        Writable.prototype._undestroy = destroyImpl.undestroy;

        Writable.prototype._destroy = function (err, cb) {
          cb(err);
        };
        /***/ }),

      /***/ 828:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* provided dependency */ const process = __webpack_require__(4155);

        let _Object$setPrototypeO;

        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value, enumerable: true, configurable: true, writable: true,
            });
          } else { obj[key] = value; } return obj;
        }

        const finished = __webpack_require__(1086);

        const kLastResolve = Symbol('lastResolve');
        const kLastReject = Symbol('lastReject');
        const kError = Symbol('error');
        const kEnded = Symbol('ended');
        const kLastPromise = Symbol('lastPromise');
        const kHandlePromise = Symbol('handlePromise');
        const kStream = Symbol('stream');

        function createIterResult(value, done) {
          return {
            value,
            done,
          };
        }

        function readAndResolve(iter) {
          const resolve = iter[kLastResolve];

          if (resolve !== null) {
            const data = iter[kStream].read(); // we defer if data is null
            // we can be expecting either 'end' or
            // 'error'

            if (data !== null) {
              iter[kLastPromise] = null;
              iter[kLastResolve] = null;
              iter[kLastReject] = null;
              resolve(createIterResult(data, false));
            }
          }
        }

        function onReadable(iter) {
          // we wait for the next tick, because it might
          // emit an error with process.nextTick
          process.nextTick(readAndResolve, iter);
        }

        function wrapForNext(lastPromise, iter) {
          return function (resolve, reject) {
            lastPromise.then(() => {
              if (iter[kEnded]) {
                resolve(createIterResult(undefined, true));
                return;
              }

              iter[kHandlePromise](resolve, reject);
            }, reject);
          };
        }

        const AsyncIteratorPrototype = Object.getPrototypeOf(() => {});
        const ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
          get stream() {
            return this[kStream];
          },

          next: function next() {
            const _this = this;

            // if we have detected an error in the meanwhile
            // reject straight away
            const error = this[kError];

            if (error !== null) {
              return Promise.reject(error);
            }

            if (this[kEnded]) {
              return Promise.resolve(createIterResult(undefined, true));
            }

            if (this[kStream].destroyed) {
              // We need to defer via nextTick because if .destroy(err) is
              // called, the error will be emitted via nextTick, and
              // we cannot guarantee that there is no error lingering around
              // waiting to be emitted.
              return new Promise(((resolve, reject) => {
                process.nextTick(() => {
                  if (_this[kError]) {
                    reject(_this[kError]);
                  } else {
                    resolve(createIterResult(undefined, true));
                  }
                });
              }));
            } // if we have multiple next() calls
            // we will wait for the previous Promise to finish
            // this logic is optimized to support for await loops,
            // where next() is only called once at a time

            const lastPromise = this[kLastPromise];
            let promise;

            if (lastPromise) {
              promise = new Promise(wrapForNext(lastPromise, this));
            } else {
              // fast path needed to support multiple this.push()
              // without triggering the next() queue
              const data = this[kStream].read();

              if (data !== null) {
                return Promise.resolve(createIterResult(data, false));
              }

              promise = new Promise(this[kHandlePromise]);
            }

            this[kLastPromise] = promise;
            return promise;
          },
        }, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
          return this;
        }), _defineProperty(_Object$setPrototypeO, 'return', function _return() {
          const _this2 = this;

          // destroy(err, cb) is a private API
          // we can guarantee we have that here, because we control the
          // Readable class this is attached to
          return new Promise(((resolve, reject) => {
            _this2[kStream].destroy(null, (err) => {
              if (err) {
                reject(err);
                return;
              }

              resolve(createIterResult(undefined, true));
            });
          }));
        }), _Object$setPrototypeO), AsyncIteratorPrototype);

        const createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
          let _Object$create;

          var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
            value: stream,
            writable: true,
          }), _defineProperty(_Object$create, kLastResolve, {
            value: null,
            writable: true,
          }), _defineProperty(_Object$create, kLastReject, {
            value: null,
            writable: true,
          }), _defineProperty(_Object$create, kError, {
            value: null,
            writable: true,
          }), _defineProperty(_Object$create, kEnded, {
            value: stream._readableState.endEmitted,
            writable: true,
          }), _defineProperty(_Object$create, kHandlePromise, {
            value: function value(resolve, reject) {
              const data = iterator[kStream].read();

              if (data) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                resolve(createIterResult(data, false));
              } else {
                iterator[kLastResolve] = resolve;
                iterator[kLastReject] = reject;
              }
            },
            writable: true,
          }), _Object$create));
          iterator[kLastPromise] = null;
          finished(stream, (err) => {
            if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
              const reject = iterator[kLastReject]; // reject if we are waiting for data in the Promise
              // returned by next() and store the error

              if (reject !== null) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                reject(err);
              }

              iterator[kError] = err;
              return;
            }

            const resolve = iterator[kLastResolve];

            if (resolve !== null) {
              iterator[kLastPromise] = null;
              iterator[kLastResolve] = null;
              iterator[kLastReject] = null;
              resolve(createIterResult(undefined, true));
            }

            iterator[kEnded] = true;
          });
          stream.on('readable', onReadable.bind(null, iterator));
          return iterator;
        };

        module.exports = createReadableStreamAsyncIterator;
        /***/ }),

      /***/ 1029:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* provided dependency */ const process = __webpack_require__(4155);
        // undocumented cb() API, needed for core, not for public API

        function destroy(err, cb) {
          const _this = this;

          const readableDestroyed = this._readableState && this._readableState.destroyed;
          const writableDestroyed = this._writableState && this._writableState.destroyed;

          if (readableDestroyed || writableDestroyed) {
            if (cb) {
              cb(err);
            } else if (err) {
              if (!this._writableState) {
                process.nextTick(emitErrorNT, this, err);
              } else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                process.nextTick(emitErrorNT, this, err);
              }
            }

            return this;
          } // we set destroyed to true before firing error callbacks in order
          // to make it re-entrance safe in case destroy() is called within callbacks

          if (this._readableState) {
            this._readableState.destroyed = true;
          } // if this is a duplex stream mark the writable part as destroyed as well

          if (this._writableState) {
            this._writableState.destroyed = true;
          }

          this._destroy(err || null, (err) => {
            if (!cb && err) {
              if (!_this._writableState) {
                process.nextTick(emitErrorAndCloseNT, _this, err);
              } else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                process.nextTick(emitErrorAndCloseNT, _this, err);
              } else {
                process.nextTick(emitCloseNT, _this);
              }
            } else if (cb) {
              process.nextTick(emitCloseNT, _this);
              cb(err);
            } else {
              process.nextTick(emitCloseNT, _this);
            }
          });

          return this;
        }

        function emitErrorAndCloseNT(self, err) {
          emitErrorNT(self, err);
          emitCloseNT(self);
        }

        function emitCloseNT(self) {
          if (self._writableState && !self._writableState.emitClose) return;
          if (self._readableState && !self._readableState.emitClose) return;
          self.emit('close');
        }

        function undestroy() {
          if (this._readableState) {
            this._readableState.destroyed = false;
            this._readableState.reading = false;
            this._readableState.ended = false;
            this._readableState.endEmitted = false;
          }

          if (this._writableState) {
            this._writableState.destroyed = false;
            this._writableState.ended = false;
            this._writableState.ending = false;
            this._writableState.finalCalled = false;
            this._writableState.prefinished = false;
            this._writableState.finished = false;
            this._writableState.errorEmitted = false;
          }
        }

        function emitErrorNT(self, err) {
          self.emit('error', err);
        }

        function errorOrDestroy(stream, err) {
          // We have tests that rely on errors being emitted
          // in the same tick, so changing this is semver major.
          // For now when you opt-in to autoDestroy we allow
          // the error to be emitted nextTick. In a future
          // semver major update we should change the default to this.
          const rState = stream._readableState;
          const wState = stream._writableState;
          if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err); else stream.emit('error', err);
        }

        module.exports = {
          destroy,
          undestroy,
          errorOrDestroy,
        };
        /***/ }),

      /***/ 1086:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        // Ported from https://github.com/mafintosh/end-of-stream with
        // permission from the author, Mathias Buus (@mafintosh).

        const { ERR_STREAM_PREMATURE_CLOSE } = __webpack_require__(8106).q;

        function once(callback) {
          let called = false;
          return function () {
            if (called) return;
            called = true;

            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            callback.apply(this, args);
          };
        }

        function noop() {}

        function isRequest(stream) {
          return stream.setHeader && typeof stream.abort === 'function';
        }

        function eos(stream, opts, callback) {
          if (typeof opts === 'function') return eos(stream, null, opts);
          if (!opts) opts = {};
          callback = once(callback || noop);
          let readable = opts.readable || opts.readable !== false && stream.readable;
          let writable = opts.writable || opts.writable !== false && stream.writable;

          const onlegacyfinish = function onlegacyfinish() {
            if (!stream.writable) onfinish();
          };

          let writableEnded = stream._writableState && stream._writableState.finished;

          var onfinish = function onfinish() {
            writable = false;
            writableEnded = true;
            if (!readable) callback.call(stream);
          };

          let readableEnded = stream._readableState && stream._readableState.endEmitted;

          const onend = function onend() {
            readable = false;
            readableEnded = true;
            if (!writable) callback.call(stream);
          };

          const onerror = function onerror(err) {
            callback.call(stream, err);
          };

          const onclose = function onclose() {
            let err;

            if (readable && !readableEnded) {
              if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
              return callback.call(stream, err);
            }

            if (writable && !writableEnded) {
              if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
              return callback.call(stream, err);
            }
          };

          const onrequest = function onrequest() {
            stream.req.on('finish', onfinish);
          };

          if (isRequest(stream)) {
            stream.on('complete', onfinish);
            stream.on('abort', onclose);
            if (stream.req) onrequest(); else stream.on('request', onrequest);
          } else if (writable && !stream._writableState) {
            // legacy streams
            stream.on('end', onlegacyfinish);
            stream.on('close', onlegacyfinish);
          }

          stream.on('end', onend);
          stream.on('finish', onfinish);
          if (opts.error !== false) stream.on('error', onerror);
          stream.on('close', onclose);
          return function () {
            stream.removeListener('complete', onfinish);
            stream.removeListener('abort', onclose);
            stream.removeListener('request', onrequest);
            if (stream.req) stream.req.removeListener('finish', onfinish);
            stream.removeListener('end', onlegacyfinish);
            stream.removeListener('close', onlegacyfinish);
            stream.removeListener('finish', onfinish);
            stream.removeListener('end', onend);
            stream.removeListener('error', onerror);
            stream.removeListener('close', onclose);
          };
        }

        module.exports = eos;
        /***/ }),

      /***/ 1265:
      /***/ (function (module) {
        module.exports = function () {
          throw new Error('Readable.from is not available in the browser');
        };
        /***/ }),

      /***/ 6472:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        // Ported from https://github.com/mafintosh/pump with
        // permission from the author, Mathias Buus (@mafintosh).

        let eos;

        function once(callback) {
          let called = false;
          return function () {
            if (called) return;
            called = true;
            callback.apply(void 0, arguments);
          };
        }

        const _require$codes = (__webpack_require__(8106).q);
        const { ERR_MISSING_ARGS } = _require$codes;
        const { ERR_STREAM_DESTROYED } = _require$codes;

        function noop(err) {
          // Rethrow the error if it exists to avoid swallowing it
          if (err) throw err;
        }

        function isRequest(stream) {
          return stream.setHeader && typeof stream.abort === 'function';
        }

        function destroyer(stream, reading, writing, callback) {
          callback = once(callback);
          let closed = false;
          stream.on('close', () => {
            closed = true;
          });
          if (eos === undefined) eos = __webpack_require__(1086);
          eos(stream, {
            readable: reading,
            writable: writing,
          }, (err) => {
            if (err) return callback(err);
            closed = true;
            callback();
          });
          let destroyed = false;
          return function (err) {
            if (closed) return;
            if (destroyed) return;
            destroyed = true; // request.destroy just do .end - .abort is what we want

            if (isRequest(stream)) return stream.abort();
            if (typeof stream.destroy === 'function') return stream.destroy();
            callback(err || new ERR_STREAM_DESTROYED('pipe'));
          };
        }

        function call(fn) {
          fn();
        }

        function pipe(from, to) {
          return from.pipe(to);
        }

        function popCallback(streams) {
          if (!streams.length) return noop;
          if (typeof streams[streams.length - 1] !== 'function') return noop;
          return streams.pop();
        }

        function pipeline() {
          for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
            streams[_key] = arguments[_key];
          }

          const callback = popCallback(streams);
          if (Array.isArray(streams[0])) streams = streams[0];

          if (streams.length < 2) {
            throw new ERR_MISSING_ARGS('streams');
          }

          let error;
          var destroys = streams.map((stream, i) => {
            const reading = i < streams.length - 1;
            const writing = i > 0;
            return destroyer(stream, reading, writing, (err) => {
              if (!error) error = err;
              if (err) destroys.forEach(call);
              if (reading) return;
              destroys.forEach(call);
              callback(error);
            });
          });
          return streams.reduce(pipe);
        }

        module.exports = pipeline;
        /***/ }),

      /***/ 94:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const { ERR_INVALID_OPT_VALUE } = __webpack_require__(8106).q;

        function highWaterMarkFrom(options, isDuplex, duplexKey) {
          return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
        }

        function getHighWaterMark(state, options, duplexKey, isDuplex) {
          const hwm = highWaterMarkFrom(options, isDuplex, duplexKey);

          if (hwm != null) {
            if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
              const name = isDuplex ? duplexKey : 'highWaterMark';
              throw new ERR_INVALID_OPT_VALUE(name, hwm);
            }

            return Math.floor(hwm);
          } // Default value

          return state.objectMode ? 16 : 16 * 1024;
        }

        module.exports = {
          getHighWaterMark,
        };
        /***/ }),

      /***/ 3194:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        module.exports = __webpack_require__(7187).EventEmitter;
        /***/ }),

      /***/ 4896:
      /***/ (function (module, exports, __webpack_require__) {
        let __WEBPACK_AMD_DEFINE_FACTORY__; let __WEBPACK_AMD_DEFINE_ARRAY__; let
          __WEBPACK_AMD_DEFINE_RESULT__; (function (a, b) {
          if (true) {
            !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
            __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function'
              ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
            __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
          } else {}
        }(this, () => {
          function b(a, b) { return typeof b === 'undefined' ? b = { autoBom: !1 } : typeof b !== 'object' && (console.warn('Deprecated: Expected third argument to be a object'), b = { autoBom: !b }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob(['\uFEFF', a], { type: a.type }) : a; } function c(a, b, c) { const d = new XMLHttpRequest(); d.open('GET', a), d.responseType = 'blob', d.onload = function () { g(d.response, b, c); }, d.onerror = function () { console.error('could not download file'); }, d.send(); } function d(a) { const b = new XMLHttpRequest(); b.open('HEAD', a, !1); try { b.send(); } catch (a) {} return b.status >= 200 && b.status <= 299; } function e(a) { try { a.dispatchEvent(new MouseEvent('click')); } catch (c) { const b = document.createEvent('MouseEvents'); b.initMouseEvent('click', !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b); } } const f = typeof window === 'object' && window.window === window ? window : typeof self === 'object' && self.self === self ? self : typeof __webpack_require__.g === 'object' && __webpack_require__.g.global === __webpack_require__.g ? __webpack_require__.g : void 0; const a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent); var g = f.saveAs || (typeof window !== 'object' || window !== f ? function () {} : (typeof HTMLAnchorElement !== 'undefined' && 'download' in HTMLAnchorElement.prototype) && !a ? function (b, g, h) { const i = f.URL || f.webkitURL; const j = document.createElement('a'); g = g || b.name || 'download', j.download = g, j.rel = 'noopener', typeof b === 'string' ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = '_blank')) : (j.href = i.createObjectURL(b), setTimeout(() => { i.revokeObjectURL(j.href); }, 4E4), setTimeout(() => { e(j); }, 0)); } : 'msSaveOrOpenBlob' in navigator ? function (f, g, h) { if (g = g || f.name || 'download', typeof f !== 'string')navigator.msSaveOrOpenBlob(b(f, h), g); else if (d(f))c(f, g, h); else { const i = document.createElement('a'); i.href = f, i.target = '_blank', setTimeout(() => { e(i); }); } } : function (b, d, e, g) { if (g = g || open('', '_blank'), g && (g.document.title = g.document.body.innerText = 'downloading...'), typeof b === 'string') return c(b, d, e); const h = b.type === 'application/octet-stream'; const i = /constructor/i.test(f.HTMLElement) || f.safari; const j = /CriOS\/[\d]+/.test(navigator.userAgent); if ((j || h && i || a) && typeof FileReader !== 'undefined') { const k = new FileReader(); k.onloadend = function () { let a = k.result; a = j ? a : a.replace(/^data:[^;]*;/, 'data:attachment/file;'), g ? g.location.href = a : location = a, g = null; }, k.readAsDataURL(b); } else { const l = f.URL || f.webkitURL; const m = l.createObjectURL(b); g ? g.location = m : location.href = m, g = null, setTimeout(() => { l.revokeObjectURL(m); }, 4E4); } }); f.saveAs = g.saveAs = g, true && (module.exports = g);
        }));

        // # sourceMappingURL=FileSaver.min.js.map
        /***/ }),

      /***/ 2553:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        // Copyright Joyent, Inc. and other Node contributors.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a
        // copy of this software and associated documentation files (the
        // "Software"), to deal in the Software without restriction, including
        // without limitation the rights to use, copy, modify, merge, publish,
        // distribute, sublicense, and/or sell copies of the Software, and to permit
        // persons to whom the Software is furnished to do so, subject to the
        // following conditions:
        //
        // The above copyright notice and this permission notice shall be included
        // in all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
        // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
        // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
        // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
        // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
        // USE OR OTHER DEALINGS IN THE SOFTWARE.

        /* <replacement> */

        const { Buffer } = __webpack_require__(1750);
        /* </replacement> */

        const isEncoding = Buffer.isEncoding || function (encoding) {
          encoding = `${encoding}`;
          switch (encoding && encoding.toLowerCase()) {
            case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw':
              return true;
            default:
              return false;
          }
        };

        function _normalizeEncoding(enc) {
          if (!enc) return 'utf8';
          let retried;
          while (true) {
            switch (enc) {
              case 'utf8':
              case 'utf-8':
                return 'utf8';
              case 'ucs2':
              case 'ucs-2':
              case 'utf16le':
              case 'utf-16le':
                return 'utf16le';
              case 'latin1':
              case 'binary':
                return 'latin1';
              case 'base64':
              case 'ascii':
              case 'hex':
                return enc;
              default:
                if (retried) return; // undefined
                enc = (`${enc}`).toLowerCase();
                retried = true;
            }
          }
        }

        // Do not cache `Buffer.isEncoding` when checking encoding names as some
        // modules monkey-patch it to support additional encodings
        function normalizeEncoding(enc) {
          const nenc = _normalizeEncoding(enc);
          if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error(`Unknown encoding: ${enc}`);
          return nenc || enc;
        }

        // StringDecoder provides an interface for efficiently splitting a series of
        // buffers into a series of JS strings without breaking apart multi-byte
        // characters.
        exports.s = StringDecoder;
        function StringDecoder(encoding) {
          this.encoding = normalizeEncoding(encoding);
          let nb;
          switch (this.encoding) {
            case 'utf16le':
              this.text = utf16Text;
              this.end = utf16End;
              nb = 4;
              break;
            case 'utf8':
              this.fillLast = utf8FillLast;
              nb = 4;
              break;
            case 'base64':
              this.text = base64Text;
              this.end = base64End;
              nb = 3;
              break;
            default:
              this.write = simpleWrite;
              this.end = simpleEnd;
              return;
          }
          this.lastNeed = 0;
          this.lastTotal = 0;
          this.lastChar = Buffer.allocUnsafe(nb);
        }

        StringDecoder.prototype.write = function (buf) {
          if (buf.length === 0) return '';
          let r;
          let i;
          if (this.lastNeed) {
            r = this.fillLast(buf);
            if (r === undefined) return '';
            i = this.lastNeed;
            this.lastNeed = 0;
          } else {
            i = 0;
          }
          if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
          return r || '';
        };

        StringDecoder.prototype.end = utf8End;

        // Returns only complete characters in a Buffer
        StringDecoder.prototype.text = utf8Text;

        // Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
        StringDecoder.prototype.fillLast = function (buf) {
          if (this.lastNeed <= buf.length) {
            buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
            return this.lastChar.toString(this.encoding, 0, this.lastTotal);
          }
          buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
          this.lastNeed -= buf.length;
        };

        // Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
        // continuation byte. If an invalid byte is detected, -2 is returned.
        function utf8CheckByte(byte) {
          if (byte <= 0x7F) return 0; if (byte >> 5 === 0x06) return 2; if (byte >> 4 === 0x0E) return 3; if (byte >> 3 === 0x1E) return 4;
          return byte >> 6 === 0x02 ? -1 : -2;
        }

        // Checks at most 3 bytes at the end of a Buffer in order to detect an
        // incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
        // needed to complete the UTF-8 character (if applicable) are returned.
        function utf8CheckIncomplete(self, buf, i) {
          let j = buf.length - 1;
          if (j < i) return 0;
          let nb = utf8CheckByte(buf[j]);
          if (nb >= 0) {
            if (nb > 0) self.lastNeed = nb - 1;
            return nb;
          }
          if (--j < i || nb === -2) return 0;
          nb = utf8CheckByte(buf[j]);
          if (nb >= 0) {
            if (nb > 0) self.lastNeed = nb - 2;
            return nb;
          }
          if (--j < i || nb === -2) return 0;
          nb = utf8CheckByte(buf[j]);
          if (nb >= 0) {
            if (nb > 0) {
              if (nb === 2) nb = 0; else self.lastNeed = nb - 3;
            }
            return nb;
          }
          return 0;
        }

        // Validates as many continuation bytes for a multi-byte UTF-8 character as
        // needed or are available. If we see a non-continuation byte where we expect
        // one, we "replace" the validated continuation bytes we've seen so far with
        // a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
        // behavior. The continuation byte check is included three times in the case
        // where all of the continuation bytes for a character exist in the same buffer.
        // It is also done this way as a slight performance increase instead of using a
        // loop.
        function utf8CheckExtraBytes(self, buf, p) {
          if ((buf[0] & 0xC0) !== 0x80) {
            self.lastNeed = 0;
            return '\ufffd';
          }
          if (self.lastNeed > 1 && buf.length > 1) {
            if ((buf[1] & 0xC0) !== 0x80) {
              self.lastNeed = 1;
              return '\ufffd';
            }
            if (self.lastNeed > 2 && buf.length > 2) {
              if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
              }
            }
          }
        }

        // Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
        function utf8FillLast(buf) {
          const p = this.lastTotal - this.lastNeed;
          const r = utf8CheckExtraBytes(this, buf, p);
          if (r !== undefined) return r;
          if (this.lastNeed <= buf.length) {
            buf.copy(this.lastChar, p, 0, this.lastNeed);
            return this.lastChar.toString(this.encoding, 0, this.lastTotal);
          }
          buf.copy(this.lastChar, p, 0, buf.length);
          this.lastNeed -= buf.length;
        }

        // Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
        // partial character, the character's bytes are buffered until the required
        // number of bytes are available.
        function utf8Text(buf, i) {
          const total = utf8CheckIncomplete(this, buf, i);
          if (!this.lastNeed) return buf.toString('utf8', i);
          this.lastTotal = total;
          const end = buf.length - (total - this.lastNeed);
          buf.copy(this.lastChar, 0, end);
          return buf.toString('utf8', i, end);
        }

        // For UTF-8, a replacement character is added when ending on a partial
        // character.
        function utf8End(buf) {
          const r = buf && buf.length ? this.write(buf) : '';
          if (this.lastNeed) return `${r}\ufffd`;
          return r;
        }

        // UTF-16LE typically needs two bytes per character, but even if we have an even
        // number of bytes available, we need to check if we end on a leading/high
        // surrogate. In that case, we need to wait for the next two bytes in order to
        // decode the last character properly.
        function utf16Text(buf, i) {
          if ((buf.length - i) % 2 === 0) {
            const r = buf.toString('utf16le', i);
            if (r) {
              const c = r.charCodeAt(r.length - 1);
              if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
              }
            }
            return r;
          }
          this.lastNeed = 1;
          this.lastTotal = 2;
          this.lastChar[0] = buf[buf.length - 1];
          return buf.toString('utf16le', i, buf.length - 1);
        }

        // For UTF-16LE we do not explicitly append special replacement characters if we
        // end on a partial character, we simply let v8 handle that.
        function utf16End(buf) {
          const r = buf && buf.length ? this.write(buf) : '';
          if (this.lastNeed) {
            const end = this.lastTotal - this.lastNeed;
            return r + this.lastChar.toString('utf16le', 0, end);
          }
          return r;
        }

        function base64Text(buf, i) {
          const n = (buf.length - i) % 3;
          if (n === 0) return buf.toString('base64', i);
          this.lastNeed = 3 - n;
          this.lastTotal = 3;
          if (n === 1) {
            this.lastChar[0] = buf[buf.length - 1];
          } else {
            this.lastChar[0] = buf[buf.length - 2];
            this.lastChar[1] = buf[buf.length - 1];
          }
          return buf.toString('base64', i, buf.length - n);
        }

        function base64End(buf) {
          const r = buf && buf.length ? this.write(buf) : '';
          if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
          return r;
        }

        // Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
        function simpleWrite(buf) {
          return buf.toString(this.encoding);
        }

        function simpleEnd(buf) {
          return buf && buf.length ? this.write(buf) : '';
        }
        /***/ }),

      /***/ 311:
      /***/ (function (module) {
        const TINF_OK = 0;
        const TINF_DATA_ERROR = -3;

        function Tree() {
          this.table = new Uint16Array(16); /* table of code length counts */
          this.trans = new Uint16Array(288); /* code -> symbol translation table */
        }

        function Data(source, dest) {
          this.source = source;
          this.sourceIndex = 0;
          this.tag = 0;
          this.bitcount = 0;

          this.dest = dest;
          this.destLen = 0;

          this.ltree = new Tree(); /* dynamic length/symbol tree */
          this.dtree = new Tree(); /* dynamic distance tree */
        }

        /* --------------------------------------------------- *
 * -- uninitialized global data (static structures) -- *
 * --------------------------------------------------- */

        const sltree = new Tree();
        const sdtree = new Tree();

        /* extra bits and base tables for length codes */
        const length_bits = new Uint8Array(30);
        const length_base = new Uint16Array(30);

        /* extra bits and base tables for distance codes */
        const dist_bits = new Uint8Array(30);
        const dist_base = new Uint16Array(30);

        /* special ordering of code length codes */
        const clcidx = new Uint8Array([
          16, 17, 18, 0, 8, 7, 9, 6,
          10, 5, 11, 4, 12, 3, 13, 2,
          14, 1, 15,
        ]);

        /* used by tinf_decode_trees, avoids allocations every call */
        const code_tree = new Tree();
        const lengths = new Uint8Array(288 + 32);

        /* ----------------------- *
 * -- utility functions -- *
 * ----------------------- */

        /* build extra bits and base tables */
        function tinf_build_bits_base(bits, base, delta, first) {
          let i; let
            sum;

          /* build bits table */
          for (i = 0; i < delta; ++i) bits[i] = 0;
          for (i = 0; i < 30 - delta; ++i) bits[i + delta] = i / delta | 0;

          /* build base table */
          for (sum = first, i = 0; i < 30; ++i) {
            base[i] = sum;
            sum += 1 << bits[i];
          }
        }

        /* build the fixed huffman trees */
        function tinf_build_fixed_trees(lt, dt) {
          let i;

          /* build fixed length tree */
          for (i = 0; i < 7; ++i) lt.table[i] = 0;

          lt.table[7] = 24;
          lt.table[8] = 152;
          lt.table[9] = 112;

          for (i = 0; i < 24; ++i) lt.trans[i] = 256 + i;
          for (i = 0; i < 144; ++i) lt.trans[24 + i] = i;
          for (i = 0; i < 8; ++i) lt.trans[24 + 144 + i] = 280 + i;
          for (i = 0; i < 112; ++i) lt.trans[24 + 144 + 8 + i] = 144 + i;

          /* build fixed distance tree */
          for (i = 0; i < 5; ++i) dt.table[i] = 0;

          dt.table[5] = 32;

          for (i = 0; i < 32; ++i) dt.trans[i] = i;
        }

        /* given an array of code lengths, build a tree */
        const offs = new Uint16Array(16);

        function tinf_build_tree(t, lengths, off, num) {
          let i; let
            sum;

          /* clear code length count table */
          for (i = 0; i < 16; ++i) t.table[i] = 0;

          /* scan symbol lengths, and sum code length counts */
          for (i = 0; i < num; ++i) t.table[lengths[off + i]]++;

          t.table[0] = 0;

          /* compute offset table for distribution sort */
          for (sum = 0, i = 0; i < 16; ++i) {
            offs[i] = sum;
            sum += t.table[i];
          }

          /* create code->symbol translation table (symbols sorted by code) */
          for (i = 0; i < num; ++i) {
            if (lengths[off + i]) t.trans[offs[lengths[off + i]]++] = i;
          }
        }

        /* ---------------------- *
 * -- decode functions -- *
 * ---------------------- */

        /* get one bit from source stream */
        function tinf_getbit(d) {
          /* check if tag is empty */
          if (!d.bitcount--) {
            /* load next tag */
            d.tag = d.source[d.sourceIndex++];
            d.bitcount = 7;
          }

          /* shift bit out of tag */
          const bit = d.tag & 1;
          d.tag >>>= 1;

          return bit;
        }

        /* read a num bit value from a stream and add base */
        function tinf_read_bits(d, num, base) {
          if (!num) return base;

          while (d.bitcount < 24) {
            d.tag |= d.source[d.sourceIndex++] << d.bitcount;
            d.bitcount += 8;
          }

          const val = d.tag & (0xffff >>> (16 - num));
          d.tag >>>= num;
          d.bitcount -= num;
          return val + base;
        }

        /* given a data stream and a tree, decode a symbol */
        function tinf_decode_symbol(d, t) {
          while (d.bitcount < 24) {
            d.tag |= d.source[d.sourceIndex++] << d.bitcount;
            d.bitcount += 8;
          }

          let sum = 0; let cur = 0; let
            len = 0;
          let { tag } = d;

          /* get more bits while code value is above sum */
          do {
            cur = 2 * cur + (tag & 1);
            tag >>>= 1;
            ++len;

            sum += t.table[len];
            cur -= t.table[len];
          } while (cur >= 0);

          d.tag = tag;
          d.bitcount -= len;

          return t.trans[sum + cur];
        }

        /* given a data stream, decode dynamic trees from it */
        function tinf_decode_trees(d, lt, dt) {
          let hlit; let hdist; let
            hclen;
          let i; let num; let
            length;

          /* get 5 bits HLIT (257-286) */
          hlit = tinf_read_bits(d, 5, 257);

          /* get 5 bits HDIST (1-32) */
          hdist = tinf_read_bits(d, 5, 1);

          /* get 4 bits HCLEN (4-19) */
          hclen = tinf_read_bits(d, 4, 4);

          for (i = 0; i < 19; ++i) lengths[i] = 0;

          /* read code lengths for code length alphabet */
          for (i = 0; i < hclen; ++i) {
            /* get 3 bits code length (0-7) */
            const clen = tinf_read_bits(d, 3, 0);
            lengths[clcidx[i]] = clen;
          }

          /* build code length tree */
          tinf_build_tree(code_tree, lengths, 0, 19);

          /* decode code lengths for the dynamic trees */
          for (num = 0; num < hlit + hdist;) {
            const sym = tinf_decode_symbol(d, code_tree);

            switch (sym) {
              case 16:
                /* copy previous code length 3-6 times (read 2 bits) */
                var prev = lengths[num - 1];
                for (length = tinf_read_bits(d, 2, 3); length; --length) {
                  lengths[num++] = prev;
                }
                break;
              case 17:
                /* repeat code length 0 for 3-10 times (read 3 bits) */
                for (length = tinf_read_bits(d, 3, 3); length; --length) {
                  lengths[num++] = 0;
                }
                break;
              case 18:
                /* repeat code length 0 for 11-138 times (read 7 bits) */
                for (length = tinf_read_bits(d, 7, 11); length; --length) {
                  lengths[num++] = 0;
                }
                break;
              default:
                /* values 0-15 represent the actual code lengths */
                lengths[num++] = sym;
                break;
            }
          }

          /* build dynamic trees */
          tinf_build_tree(lt, lengths, 0, hlit);
          tinf_build_tree(dt, lengths, hlit, hdist);
        }

        /* ----------------------------- *
 * -- block inflate functions -- *
 * ----------------------------- */

        /* given a stream and two trees, inflate a block of data */
        function tinf_inflate_block_data(d, lt, dt) {
          while (1) {
            let sym = tinf_decode_symbol(d, lt);

            /* check for end of block */
            if (sym === 256) {
              return TINF_OK;
            }

            if (sym < 256) {
              d.dest[d.destLen++] = sym;
            } else {
              var length; var dist; var
                offs;
              var i;

              sym -= 257;

              /* possibly get more bits from length code */
              length = tinf_read_bits(d, length_bits[sym], length_base[sym]);

              dist = tinf_decode_symbol(d, dt);

              /* possibly get more bits from distance code */
              offs = d.destLen - tinf_read_bits(d, dist_bits[dist], dist_base[dist]);

              /* copy match */
              for (i = offs; i < offs + length; ++i) {
                d.dest[d.destLen++] = d.dest[i];
              }
            }
          }
        }

        /* inflate an uncompressed block of data */
        function tinf_inflate_uncompressed_block(d) {
          let length; let
            invlength;
          let i;

          /* unread from bitbuffer */
          while (d.bitcount > 8) {
            d.sourceIndex--;
            d.bitcount -= 8;
          }

          /* get length */
          length = d.source[d.sourceIndex + 1];
          length = 256 * length + d.source[d.sourceIndex];

          /* get one's complement of length */
          invlength = d.source[d.sourceIndex + 3];
          invlength = 256 * invlength + d.source[d.sourceIndex + 2];

          /* check length */
          if (length !== (~invlength & 0x0000ffff)) return TINF_DATA_ERROR;

          d.sourceIndex += 4;

          /* copy block */
          for (i = length; i; --i) d.dest[d.destLen++] = d.source[d.sourceIndex++];

          /* make sure we start next block on a byte boundary */
          d.bitcount = 0;

          return TINF_OK;
        }

        /* inflate stream from source to dest */
        function tinf_uncompress(source, dest) {
          const d = new Data(source, dest);
          let bfinal; let btype; let
            res;

          do {
            /* read final block flag */
            bfinal = tinf_getbit(d);

            /* read block type (2 bits) */
            btype = tinf_read_bits(d, 2, 0);

            /* decompress block */
            switch (btype) {
              case 0:
                /* decompress uncompressed block */
                res = tinf_inflate_uncompressed_block(d);
                break;
              case 1:
                /* decompress block with fixed huffman trees */
                res = tinf_inflate_block_data(d, sltree, sdtree);
                break;
              case 2:
                /* decompress block with dynamic huffman trees */
                tinf_decode_trees(d, d.ltree, d.dtree);
                res = tinf_inflate_block_data(d, d.ltree, d.dtree);
                break;
              default:
                res = TINF_DATA_ERROR;
            }

            if (res !== TINF_OK) throw new Error('Data error');
          } while (!bfinal);

          if (d.destLen < d.dest.length) {
            if (typeof d.dest.slice === 'function') return d.dest.slice(0, d.destLen);
            return d.dest.subarray(0, d.destLen);
          }

          return d.dest;
        }

        /* -------------------- *
 * -- initialization -- *
 * -------------------- */

        /* build fixed huffman trees */
        tinf_build_fixed_trees(sltree, sdtree);

        /* build extra bits and base tables */
        tinf_build_bits_base(length_bits, length_base, 4, 3);
        tinf_build_bits_base(dist_bits, dist_base, 2, 1);

        /* fix a special case */
        length_bits[28] = 0;
        length_base[28] = 258;

        module.exports = tinf_uncompress;
        /***/ }),

      /***/ 1917:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* provided dependency */ const { Buffer } = __webpack_require__(8823);

        __webpack_require__(2526);

        __webpack_require__(1817);

        __webpack_require__(2165);

        __webpack_require__(1539);

        __webpack_require__(4747);

        __webpack_require__(7941);

        __webpack_require__(7042);

        __webpack_require__(6992);

        __webpack_require__(1532);

        __webpack_require__(8783);

        __webpack_require__(3948);

        __webpack_require__(2222);

        __webpack_require__(9653);

        __webpack_require__(1249);

        __webpack_require__(2087);

        __webpack_require__(8309);

        __webpack_require__(9601);

        __webpack_require__(4953);

        __webpack_require__(8674);

        __webpack_require__(5003);

        __webpack_require__(189);

        __webpack_require__(561);

        __webpack_require__(2481);

        __webpack_require__(2707);

        __webpack_require__(4916);

        __webpack_require__(4723);

        __webpack_require__(1038);

        __webpack_require__(9600);

        __webpack_require__(3371);

        __webpack_require__(3290);

        __webpack_require__(3299);

        __webpack_require__(8255);

        __webpack_require__(2990);

        __webpack_require__(8927);

        __webpack_require__(3105);

        __webpack_require__(5035);

        __webpack_require__(4345);

        __webpack_require__(7174);

        __webpack_require__(2846);

        __webpack_require__(4731);

        __webpack_require__(7209);

        __webpack_require__(6319);

        __webpack_require__(8867);

        __webpack_require__(7789);

        __webpack_require__(3739);

        __webpack_require__(9368);

        __webpack_require__(4483);

        __webpack_require__(2056);

        __webpack_require__(3462);

        __webpack_require__(678);

        __webpack_require__(7462);

        __webpack_require__(3824);

        __webpack_require__(5021);

        __webpack_require__(2974);

        __webpack_require__(5016);

        __webpack_require__(5109);

        __webpack_require__(9714);

        __webpack_require__(3210);

        let _;

        function _defineProperties(target, props) { for (let i = 0; i < props.length; i++) { const descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

        function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

        function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

        function _createForOfIteratorHelperLoose(o, allowArrayLike) { let it = typeof Symbol !== 'undefined' && o[Symbol.iterator] || o['@@iterator']; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === 'number') { if (it) o = it; let i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError('Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'); }

        function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === 'string') return _arrayLikeToArray(o, minLen); let n = Object.prototype.toString.call(o).slice(8, -1); if (n === 'Object' && o.constructor) n = o.constructor.name; if (n === 'Map' || n === 'Set') return Array.from(o); if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

        function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

        function _interopDefault(ex) {
          return ex && typeof ex === 'object' && 'default' in ex ? ex.default : ex;
        }

        const r = _interopDefault(__webpack_require__(5106));

        const utils = __webpack_require__(6610);

        const isEqual = _interopDefault(__webpack_require__(251));

        const unicode = _interopDefault(__webpack_require__(9160));

        const UnicodeTrie = _interopDefault(__webpack_require__(4781));

        const StateMachine = _interopDefault(__webpack_require__(9811));

        const cloneDeep = _interopDefault(__webpack_require__(6313));

        const inflate = _interopDefault(__webpack_require__(311));

        const brotli = _interopDefault(__webpack_require__(7709));

        const fs = __webpack_require__(3857);

        const fontkit = {};
        fontkit.logErrors = false;
        const formats = [];

        fontkit.registerFormat = function (format) {
          formats.push(format);
        };

        fontkit.openSync = function (filename, postscriptName) {
          const buffer = fs.readFileSync(filename);
          return fontkit.create(buffer, postscriptName);
        };

        fontkit.open = function (filename, postscriptName, callback) {
          if (typeof postscriptName === 'function') {
            callback = postscriptName;
            postscriptName = null;
          }

          fs.readFile(filename, (err, buffer) => {
            if (err) {
              return callback(err);
            }

            try {
              var font = fontkit.create(buffer, postscriptName);
            } catch (e) {
              return callback(e);
            }

            return callback(null, font);
          });
        };

        fontkit.create = function (buffer, postscriptName) {
          for (let i = 0; i < formats.length; i++) {
            const format = formats[i];

            if (format.probe(buffer)) {
              const font = new format(new r.DecodeStream(buffer));

              if (postscriptName) {
                return font.getFont(postscriptName);
              }

              return font;
            }
          }

          throw new Error('Unknown font format');
        };

        fontkit.defaultLanguage = 'en';

        fontkit.setDefaultLanguage = function (lang) {
          if (lang === void 0) {
            lang = 'en';
          }

          fontkit.defaultLanguage = lang;
        };

        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value,
              enumerable: true,
              configurable: true,
              writable: true,
            });
          } else {
            obj[key] = value;
          }

          return obj;
        }

        function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
          let desc = {};
          Object.keys(descriptor).forEach((key) => {
            desc[key] = descriptor[key];
          });
          desc.enumerable = !!desc.enumerable;
          desc.configurable = !!desc.configurable;

          if ('value' in desc || desc.initializer) {
            desc.writable = true;
          }

          desc = decorators.slice().reverse().reduce((desc, decorator) => decorator(target, property, desc) || desc, desc);

          if (context && desc.initializer !== void 0) {
            desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
            desc.initializer = undefined;
          }

          if (desc.initializer === void 0) {
            Object.defineProperty(target, property, desc);
            desc = null;
          }

          return desc;
        }
        /**
 * This decorator caches the results of a getter or method such that
 * the results are lazily computed once, and then cached.
 * @private
 */

        function cache(target, key, descriptor) {
          if (descriptor.get) {
            const { get } = descriptor;

            descriptor.get = function () {
              const value = get.call(this);
              Object.defineProperty(this, key, {
                value,
              });
              return value;
            };
          } else if (typeof descriptor.value === 'function') {
            const fn = descriptor.value;
            return {
              get: function get() {
                const cache = new Map();

                function memoized() {
                  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                  }

                  const key = args.length > 0 ? args[0] : 'value';

                  if (cache.has(key)) {
                    return cache.get(key);
                  }

                  const result = fn.apply(this, args);
                  cache.set(key, result);
                  return result;
                }

                Object.defineProperty(this, key, {
                  value: memoized,
                });
                return memoized;
              },
            };
          }
        }

        const SubHeader = new r.Struct({
          firstCode: r.uint16,
          entryCount: r.uint16,
          idDelta: r.int16,
          idRangeOffset: r.uint16,
        });
        const CmapGroup = new r.Struct({
          startCharCode: r.uint32,
          endCharCode: r.uint32,
          glyphID: r.uint32,
        });
        const UnicodeValueRange = new r.Struct({
          startUnicodeValue: r.uint24,
          additionalCount: r.uint8,
        });
        const UVSMapping = new r.Struct({
          unicodeValue: r.uint24,
          glyphID: r.uint16,
        });
        const DefaultUVS = new r.Array(UnicodeValueRange, r.uint32);
        const NonDefaultUVS = new r.Array(UVSMapping, r.uint32);
        const VarSelectorRecord = new r.Struct({
          varSelector: r.uint24,
          defaultUVS: new r.Pointer(r.uint32, DefaultUVS, {
            type: 'parent',
          }),
          nonDefaultUVS: new r.Pointer(r.uint32, NonDefaultUVS, {
            type: 'parent',
          }),
        });
        const CmapSubtable = new r.VersionedStruct(r.uint16, {
          0: {
            // Byte encoding
            length: r.uint16,
            // Total table length in bytes (set to 262 for format 0)
            language: r.uint16,
            // Language code for this encoding subtable, or zero if language-independent
            codeMap: new r.LazyArray(r.uint8, 256),
          },
          2: {
            // High-byte mapping (CJK)
            length: r.uint16,
            language: r.uint16,
            subHeaderKeys: new r.Array(r.uint16, 256),
            subHeaderCount: function subHeaderCount(t) {
              return Math.max.apply(Math, t.subHeaderKeys);
            },
            subHeaders: new r.LazyArray(SubHeader, 'subHeaderCount'),
            glyphIndexArray: new r.LazyArray(r.uint16, 'subHeaderCount'),
          },
          4: {
            // Segment mapping to delta values
            length: r.uint16,
            // Total table length in bytes
            language: r.uint16,
            // Language code
            segCountX2: r.uint16,
            segCount: function segCount(t) {
              return t.segCountX2 >> 1;
            },
            searchRange: r.uint16,
            entrySelector: r.uint16,
            rangeShift: r.uint16,
            endCode: new r.LazyArray(r.uint16, 'segCount'),
            reservedPad: new r.Reserved(r.uint16),
            // This value should be zero
            startCode: new r.LazyArray(r.uint16, 'segCount'),
            idDelta: new r.LazyArray(r.int16, 'segCount'),
            idRangeOffset: new r.LazyArray(r.uint16, 'segCount'),
            glyphIndexArray: new r.LazyArray(r.uint16, ((t) => (t.length - t._currentOffset) / 2)),
          },
          6: {
            // Trimmed table
            length: r.uint16,
            language: r.uint16,
            firstCode: r.uint16,
            entryCount: r.uint16,
            glyphIndices: new r.LazyArray(r.uint16, 'entryCount'),
          },
          8: {
            // mixed 16-bit and 32-bit coverage
            reserved: new r.Reserved(r.uint16),
            length: r.uint32,
            language: r.uint16,
            is32: new r.LazyArray(r.uint8, 8192),
            nGroups: r.uint32,
            groups: new r.LazyArray(CmapGroup, 'nGroups'),
          },
          10: {
            // Trimmed Array
            reserved: new r.Reserved(r.uint16),
            length: r.uint32,
            language: r.uint32,
            firstCode: r.uint32,
            entryCount: r.uint32,
            glyphIndices: new r.LazyArray(r.uint16, 'numChars'),
          },
          12: {
            // Segmented coverage
            reserved: new r.Reserved(r.uint16),
            length: r.uint32,
            language: r.uint32,
            nGroups: r.uint32,
            groups: new r.LazyArray(CmapGroup, 'nGroups'),
          },
          13: {
            // Many-to-one range mappings (same as 12 except for group.startGlyphID)
            reserved: new r.Reserved(r.uint16),
            length: r.uint32,
            language: r.uint32,
            nGroups: r.uint32,
            groups: new r.LazyArray(CmapGroup, 'nGroups'),
          },
          14: {
            // Unicode Variation Sequences
            length: r.uint32,
            numRecords: r.uint32,
            varSelectors: new r.LazyArray(VarSelectorRecord, 'numRecords'),
          },
        });
        const CmapEntry = new r.Struct({
          platformID: r.uint16,
          // Platform identifier
          encodingID: r.uint16,
          // Platform-specific encoding identifier
          table: new r.Pointer(r.uint32, CmapSubtable, {
            type: 'parent',
            lazy: true,
          }),
        }); // character to glyph mapping

        const cmap = new r.Struct({
          version: r.uint16,
          numSubtables: r.uint16,
          tables: new r.Array(CmapEntry, 'numSubtables'),
        });
        const head = new r.Struct({
          version: r.int32,
          // 0x00010000 (version 1.0)
          revision: r.int32,
          // set by font manufacturer
          checkSumAdjustment: r.uint32,
          magicNumber: r.uint32,
          // set to 0x5F0F3CF5
          flags: r.uint16,
          unitsPerEm: r.uint16,
          // range from 64 to 16384
          created: new r.Array(r.int32, 2),
          modified: new r.Array(r.int32, 2),
          xMin: r.int16,
          // for all glyph bounding boxes
          yMin: r.int16,
          // for all glyph bounding boxes
          xMax: r.int16,
          // for all glyph bounding boxes
          yMax: r.int16,
          // for all glyph bounding boxes
          macStyle: new r.Bitfield(r.uint16, ['bold', 'italic', 'underline', 'outline', 'shadow', 'condensed', 'extended']),
          lowestRecPPEM: r.uint16,
          // smallest readable size in pixels
          fontDirectionHint: r.int16,
          indexToLocFormat: r.int16,
          // 0 for short offsets, 1 for long
          glyphDataFormat: r.int16, // 0 for current format

        });
        const hhea = new r.Struct({
          version: r.int32,
          ascent: r.int16,
          // Distance from baseline of highest ascender
          descent: r.int16,
          // Distance from baseline of lowest descender
          lineGap: r.int16,
          // Typographic line gap
          advanceWidthMax: r.uint16,
          // Maximum advance width value in 'hmtx' table
          minLeftSideBearing: r.int16,
          // Maximum advance width value in 'hmtx' table
          minRightSideBearing: r.int16,
          // Minimum right sidebearing value
          xMaxExtent: r.int16,
          caretSlopeRise: r.int16,
          // Used to calculate the slope of the cursor (rise/run); 1 for vertical
          caretSlopeRun: r.int16,
          // 0 for vertical
          caretOffset: r.int16,
          // Set to 0 for non-slanted fonts
          reserved: new r.Reserved(r.int16, 4),
          metricDataFormat: r.int16,
          // 0 for current format
          numberOfMetrics: r.uint16, // Number of advance widths in 'hmtx' table

        });
        const HmtxEntry = new r.Struct({
          advance: r.uint16,
          bearing: r.int16,
        });
        const hmtx = new r.Struct({
          metrics: new r.LazyArray(HmtxEntry, ((t) => t.parent.hhea.numberOfMetrics)),
          bearings: new r.LazyArray(r.int16, ((t) => t.parent.maxp.numGlyphs - t.parent.hhea.numberOfMetrics)),
        });
        const maxp = new r.Struct({
          version: r.int32,
          numGlyphs: r.uint16,
          // The number of glyphs in the font
          maxPoints: r.uint16,
          // Maximum points in a non-composite glyph
          maxContours: r.uint16,
          // Maximum contours in a non-composite glyph
          maxComponentPoints: r.uint16,
          // Maximum points in a composite glyph
          maxComponentContours: r.uint16,
          // Maximum contours in a composite glyph
          maxZones: r.uint16,
          // 1 if instructions do not use the twilight zone, 2 otherwise
          maxTwilightPoints: r.uint16,
          // Maximum points used in Z0
          maxStorage: r.uint16,
          // Number of Storage Area locations
          maxFunctionDefs: r.uint16,
          // Number of FDEFs
          maxInstructionDefs: r.uint16,
          // Number of IDEFs
          maxStackElements: r.uint16,
          // Maximum stack depth
          maxSizeOfInstructions: r.uint16,
          // Maximum byte count for glyph instructions
          maxComponentElements: r.uint16,
          // Maximum number of components referenced at “top level” for any composite glyph
          maxComponentDepth: r.uint16, // Maximum levels of recursion; 1 for simple components

        });
        /**
 * Gets an encoding name from platform, encoding, and language ids.
 * Returned encoding names can be used in iconv-lite to decode text.
 */

        function getEncoding(platformID, encodingID, languageID) {
          if (languageID === void 0) {
            languageID = 0;
          }

          if (platformID === 1 && MAC_LANGUAGE_ENCODINGS[languageID]) {
            return MAC_LANGUAGE_ENCODINGS[languageID];
          }

          return ENCODINGS[platformID][encodingID];
        } // Map of platform ids to encoding ids.

        var ENCODINGS = [// unicode
          ['utf16be', 'utf16be', 'utf16be', 'utf16be', 'utf16be', 'utf16be'], // macintosh
          // Mappings available at http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/
          // 0	Roman                 17	Malayalam
          // 1	Japanese	            18	Sinhalese
          // 2	Traditional Chinese	  19	Burmese
          // 3	Korean	              20	Khmer
          // 4	Arabic	              21	Thai
          // 5	Hebrew	              22	Laotian
          // 6	Greek	                23	Georgian
          // 7	Russian	              24	Armenian
          // 8	RSymbol	              25	Simplified Chinese
          // 9	Devanagari	          26	Tibetan
          // 10	Gurmukhi	            27	Mongolian
          // 11	Gujarati	            28	Geez
          // 12	Oriya	                29	Slavic
          // 13	Bengali	              30	Vietnamese
          // 14	Tamil	                31	Sindhi
          // 15	Telugu	              32	(Uninterpreted)
          // 16	Kannada
          ['macroman', 'shift-jis', 'big5', 'euc-kr', 'iso-8859-6', 'iso-8859-8', 'macgreek', 'maccyrillic', 'symbol', 'Devanagari', 'Gurmukhi', 'Gujarati', 'Oriya', 'Bengali', 'Tamil', 'Telugu', 'Kannada', 'Malayalam', 'Sinhalese', 'Burmese', 'Khmer', 'macthai', 'Laotian', 'Georgian', 'Armenian', 'gb-2312-80', 'Tibetan', 'Mongolian', 'Geez', 'maccenteuro', 'Vietnamese', 'Sindhi'], // ISO (deprecated)
          ['ascii'], // windows
          // Docs here: http://msdn.microsoft.com/en-us/library/system.text.encoding(v=vs.110).aspx
          ['symbol', 'utf16be', 'shift-jis', 'gb18030', 'big5', 'wansung', 'johab', null, null, null, 'utf16be']]; // Overrides for Mac scripts by language id.
        // See http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/Readme.txt

        var MAC_LANGUAGE_ENCODINGS = {
          15: 'maciceland',
          17: 'macturkish',
          18: 'maccroatian',
          24: 'maccenteuro',
          25: 'maccenteuro',
          26: 'maccenteuro',
          27: 'maccenteuro',
          28: 'maccenteuro',
          30: 'maciceland',
          37: 'macromania',
          38: 'maccenteuro',
          39: 'maccenteuro',
          40: 'maccenteuro',
          143: 'macinuit',
          // Unsupported by iconv-lite
          146: 'macgaelic', // Unsupported by iconv-lite

        }; // Map of platform ids to BCP-47 language codes.

        const LANGUAGES = [// unicode
          [], {
            // macintosh
            0: 'en',
            30: 'fo',
            60: 'ks',
            90: 'rw',
            1: 'fr',
            31: 'fa',
            61: 'ku',
            91: 'rn',
            2: 'de',
            32: 'ru',
            62: 'sd',
            92: 'ny',
            3: 'it',
            33: 'zh',
            63: 'bo',
            93: 'mg',
            4: 'nl',
            34: 'nl-BE',
            64: 'ne',
            94: 'eo',
            5: 'sv',
            35: 'ga',
            65: 'sa',
            128: 'cy',
            6: 'es',
            36: 'sq',
            66: 'mr',
            129: 'eu',
            7: 'da',
            37: 'ro',
            67: 'bn',
            130: 'ca',
            8: 'pt',
            38: 'cz',
            68: 'as',
            131: 'la',
            9: 'no',
            39: 'sk',
            69: 'gu',
            132: 'qu',
            10: 'he',
            40: 'si',
            70: 'pa',
            133: 'gn',
            11: 'ja',
            41: 'yi',
            71: 'or',
            134: 'ay',
            12: 'ar',
            42: 'sr',
            72: 'ml',
            135: 'tt',
            13: 'fi',
            43: 'mk',
            73: 'kn',
            136: 'ug',
            14: 'el',
            44: 'bg',
            74: 'ta',
            137: 'dz',
            15: 'is',
            45: 'uk',
            75: 'te',
            138: 'jv',
            16: 'mt',
            46: 'be',
            76: 'si',
            139: 'su',
            17: 'tr',
            47: 'uz',
            77: 'my',
            140: 'gl',
            18: 'hr',
            48: 'kk',
            78: 'km',
            141: 'af',
            19: 'zh-Hant',
            49: 'az-Cyrl',
            79: 'lo',
            142: 'br',
            20: 'ur',
            50: 'az-Arab',
            80: 'vi',
            143: 'iu',
            21: 'hi',
            51: 'hy',
            81: 'id',
            144: 'gd',
            22: 'th',
            52: 'ka',
            82: 'tl',
            145: 'gv',
            23: 'ko',
            53: 'mo',
            83: 'ms',
            146: 'ga',
            24: 'lt',
            54: 'ky',
            84: 'ms-Arab',
            147: 'to',
            25: 'pl',
            55: 'tg',
            85: 'am',
            148: 'el-polyton',
            26: 'hu',
            56: 'tk',
            86: 'ti',
            149: 'kl',
            27: 'es',
            57: 'mn-CN',
            87: 'om',
            150: 'az',
            28: 'lv',
            58: 'mn',
            88: 'so',
            151: 'nn',
            29: 'se',
            59: 'ps',
            89: 'sw',
          }, // ISO (deprecated)
          [], {
            // windows
            0x0436: 'af',
            0x4009: 'en-IN',
            0x0487: 'rw',
            0x0432: 'tn',
            0x041C: 'sq',
            0x1809: 'en-IE',
            0x0441: 'sw',
            0x045B: 'si',
            0x0484: 'gsw',
            0x2009: 'en-JM',
            0x0457: 'kok',
            0x041B: 'sk',
            0x045E: 'am',
            0x4409: 'en-MY',
            0x0412: 'ko',
            0x0424: 'sl',
            0x1401: 'ar-DZ',
            0x1409: 'en-NZ',
            0x0440: 'ky',
            0x2C0A: 'es-AR',
            0x3C01: 'ar-BH',
            0x3409: 'en-PH',
            0x0454: 'lo',
            0x400A: 'es-BO',
            0x0C01: 'ar',
            0x4809: 'en-SG',
            0x0426: 'lv',
            0x340A: 'es-CL',
            0x0801: 'ar-IQ',
            0x1C09: 'en-ZA',
            0x0427: 'lt',
            0x240A: 'es-CO',
            0x2C01: 'ar-JO',
            0x2C09: 'en-TT',
            0x082E: 'dsb',
            0x140A: 'es-CR',
            0x3401: 'ar-KW',
            0x0809: 'en-GB',
            0x046E: 'lb',
            0x1C0A: 'es-DO',
            0x3001: 'ar-LB',
            0x0409: 'en',
            0x042F: 'mk',
            0x300A: 'es-EC',
            0x1001: 'ar-LY',
            0x3009: 'en-ZW',
            0x083E: 'ms-BN',
            0x440A: 'es-SV',
            0x1801: 'ary',
            0x0425: 'et',
            0x043E: 'ms',
            0x100A: 'es-GT',
            0x2001: 'ar-OM',
            0x0438: 'fo',
            0x044C: 'ml',
            0x480A: 'es-HN',
            0x4001: 'ar-QA',
            0x0464: 'fil',
            0x043A: 'mt',
            0x080A: 'es-MX',
            0x0401: 'ar-SA',
            0x040B: 'fi',
            0x0481: 'mi',
            0x4C0A: 'es-NI',
            0x2801: 'ar-SY',
            0x080C: 'fr-BE',
            0x047A: 'arn',
            0x180A: 'es-PA',
            0x1C01: 'aeb',
            0x0C0C: 'fr-CA',
            0x044E: 'mr',
            0x3C0A: 'es-PY',
            0x3801: 'ar-AE',
            0x040C: 'fr',
            0x047C: 'moh',
            0x280A: 'es-PE',
            0x2401: 'ar-YE',
            0x140C: 'fr-LU',
            0x0450: 'mn',
            0x500A: 'es-PR',
            0x042B: 'hy',
            0x180C: 'fr-MC',
            0x0850: 'mn-CN',
            0x0C0A: 'es',
            0x044D: 'as',
            0x100C: 'fr-CH',
            0x0461: 'ne',
            0x040A: 'es',
            0x082C: 'az-Cyrl',
            0x0462: 'fy',
            0x0414: 'nb',
            0x540A: 'es-US',
            0x042C: 'az',
            0x0456: 'gl',
            0x0814: 'nn',
            0x380A: 'es-UY',
            0x046D: 'ba',
            0x0437: 'ka',
            0x0482: 'oc',
            0x200A: 'es-VE',
            0x042D: 'eu',
            0x0C07: 'de-AT',
            0x0448: 'or',
            0x081D: 'sv-FI',
            0x0423: 'be',
            0x0407: 'de',
            0x0463: 'ps',
            0x041D: 'sv',
            0x0845: 'bn',
            0x1407: 'de-LI',
            0x0415: 'pl',
            0x045A: 'syr',
            0x0445: 'bn-IN',
            0x1007: 'de-LU',
            0x0416: 'pt',
            0x0428: 'tg',
            0x201A: 'bs-Cyrl',
            0x0807: 'de-CH',
            0x0816: 'pt-PT',
            0x085F: 'tzm',
            0x141A: 'bs',
            0x0408: 'el',
            0x0446: 'pa',
            0x0449: 'ta',
            0x047E: 'br',
            0x046F: 'kl',
            0x046B: 'qu-BO',
            0x0444: 'tt',
            0x0402: 'bg',
            0x0447: 'gu',
            0x086B: 'qu-EC',
            0x044A: 'te',
            0x0403: 'ca',
            0x0468: 'ha',
            0x0C6B: 'qu',
            0x041E: 'th',
            0x0C04: 'zh-HK',
            0x040D: 'he',
            0x0418: 'ro',
            0x0451: 'bo',
            0x1404: 'zh-MO',
            0x0439: 'hi',
            0x0417: 'rm',
            0x041F: 'tr',
            0x0804: 'zh',
            0x040E: 'hu',
            0x0419: 'ru',
            0x0442: 'tk',
            0x1004: 'zh-SG',
            0x040F: 'is',
            0x243B: 'smn',
            0x0480: 'ug',
            0x0404: 'zh-TW',
            0x0470: 'ig',
            0x103B: 'smj-NO',
            0x0422: 'uk',
            0x0483: 'co',
            0x0421: 'id',
            0x143B: 'smj',
            0x042E: 'hsb',
            0x041A: 'hr',
            0x045D: 'iu',
            0x0C3B: 'se-FI',
            0x0420: 'ur',
            0x101A: 'hr-BA',
            0x085D: 'iu-Latn',
            0x043B: 'se',
            0x0843: 'uz-Cyrl',
            0x0405: 'cs',
            0x083C: 'ga',
            0x083B: 'se-SE',
            0x0443: 'uz',
            0x0406: 'da',
            0x0434: 'xh',
            0x203B: 'sms',
            0x042A: 'vi',
            0x048C: 'prs',
            0x0435: 'zu',
            0x183B: 'sma-NO',
            0x0452: 'cy',
            0x0465: 'dv',
            0x0410: 'it',
            0x1C3B: 'sms',
            0x0488: 'wo',
            0x0813: 'nl-BE',
            0x0810: 'it-CH',
            0x044F: 'sa',
            0x0485: 'sah',
            0x0413: 'nl',
            0x0411: 'ja',
            0x1C1A: 'sr-Cyrl-BA',
            0x0478: 'ii',
            0x0C09: 'en-AU',
            0x044B: 'kn',
            0x0C1A: 'sr',
            0x046A: 'yo',
            0x2809: 'en-BZ',
            0x043F: 'kk',
            0x181A: 'sr-Latn-BA',
            0x1009: 'en-CA',
            0x0453: 'km',
            0x081A: 'sr-Latn',
            0x2409: 'en-029',
            0x0486: 'quc',
            0x046C: 'nso',
          }];
        const NameRecord = new r.Struct({
          platformID: r.uint16,
          encodingID: r.uint16,
          languageID: r.uint16,
          nameID: r.uint16,
          length: r.uint16,
          string: new r.Pointer(r.uint16, new r.String('length', ((t) => getEncoding(t.platformID, t.encodingID, t.languageID))), {
            type: 'parent',
            relativeTo: function relativeTo(ctx) {
              return ctx.parent.stringOffset;
            },
            allowNull: false,
          }),
        });
        const LangTagRecord = new r.Struct({
          length: r.uint16,
          tag: new r.Pointer(r.uint16, new r.String('length', 'utf16be'), {
            type: 'parent',
            relativeTo: function relativeTo(ctx) {
              return ctx.stringOffset;
            },
          }),
        });
        const NameTable = new r.VersionedStruct(r.uint16, {
          0: {
            count: r.uint16,
            stringOffset: r.uint16,
            records: new r.Array(NameRecord, 'count'),
          },
          1: {
            count: r.uint16,
            stringOffset: r.uint16,
            records: new r.Array(NameRecord, 'count'),
            langTagCount: r.uint16,
            langTags: new r.Array(LangTagRecord, 'langTagCount'),
          },
        });
        const NAMES = ['copyright', 'fontFamily', 'fontSubfamily', 'uniqueSubfamily', 'fullName', 'version', 'postscriptName', // Note: A font may have only one PostScript name and that name must be ASCII.
          'trademark', 'manufacturer', 'designer', 'description', 'vendorURL', 'designerURL', 'license', 'licenseURL', null, // reserved
          'preferredFamily', 'preferredSubfamily', 'compatibleFull', 'sampleText', 'postscriptCIDFontName', 'wwsFamilyName', 'wwsSubfamilyName'];

        NameTable.process = function (stream) {
          const records = {};

          for (var _iterator = _createForOfIteratorHelperLoose(this.records), _step; !(_step = _iterator()).done;) {
            const record = _step.value;
            // find out what language this is for
            let language = LANGUAGES[record.platformID][record.languageID];

            if (language == null && this.langTags != null && record.languageID >= 0x8000) {
              language = this.langTags[record.languageID - 0x8000].tag;
            }

            if (language == null) {
              language = `${record.platformID}-${record.languageID}`;
            } // if the nameID is >= 256, it is a font feature record (AAT)

            const key = record.nameID >= 256 ? 'fontFeatures' : NAMES[record.nameID] || record.nameID;

            if (records[key] == null) {
              records[key] = {};
            }

            let obj = records[key];

            if (record.nameID >= 256) {
              obj = obj[record.nameID] || (obj[record.nameID] = {});
            }

            if (typeof record.string === 'string' || typeof obj[language] !== 'string') {
              obj[language] = record.string;
            }
          }

          this.records = records;
        };

        NameTable.preEncode = function () {
          if (Array.isArray(this.records)) return;
          this.version = 0;
          const records = [];

          for (const key in this.records) {
            const val = this.records[key];
            if (key === 'fontFeatures') continue;
            records.push({
              platformID: 3,
              encodingID: 1,
              languageID: 0x409,
              nameID: NAMES.indexOf(key),
              length: Buffer.byteLength(val.en, 'utf16le'),
              string: val.en,
            });

            if (key === 'postscriptName') {
              records.push({
                platformID: 1,
                encodingID: 0,
                languageID: 0,
                nameID: NAMES.indexOf(key),
                length: val.en.length,
                string: val.en,
              });
            }
          }

          this.records = records;
          this.count = records.length;
          this.stringOffset = NameTable.size(this, null, false);
        };

        const OS2 = new r.VersionedStruct(r.uint16, {
          header: {
            xAvgCharWidth: r.int16,
            // average weighted advance width of lower case letters and space
            usWeightClass: r.uint16,
            // visual weight of stroke in glyphs
            usWidthClass: r.uint16,
            // relative change from the normal aspect ratio (width to height ratio)
            fsType: new r.Bitfield(r.uint16, [// Indicates font embedding licensing rights
              null, 'noEmbedding', 'viewOnly', 'editable', null, null, null, null, 'noSubsetting', 'bitmapOnly']),
            ySubscriptXSize: r.int16,
            // recommended horizontal size in pixels for subscripts
            ySubscriptYSize: r.int16,
            // recommended vertical size in pixels for subscripts
            ySubscriptXOffset: r.int16,
            // recommended horizontal offset for subscripts
            ySubscriptYOffset: r.int16,
            // recommended vertical offset form the baseline for subscripts
            ySuperscriptXSize: r.int16,
            // recommended horizontal size in pixels for superscripts
            ySuperscriptYSize: r.int16,
            // recommended vertical size in pixels for superscripts
            ySuperscriptXOffset: r.int16,
            // recommended horizontal offset for superscripts
            ySuperscriptYOffset: r.int16,
            // recommended vertical offset from the baseline for superscripts
            yStrikeoutSize: r.int16,
            // width of the strikeout stroke
            yStrikeoutPosition: r.int16,
            // position of the strikeout stroke relative to the baseline
            sFamilyClass: r.int16,
            // classification of font-family design
            panose: new r.Array(r.uint8, 10),
            // describe the visual characteristics of a given typeface
            ulCharRange: new r.Array(r.uint32, 4),
            vendorID: new r.String(4),
            // four character identifier for the font vendor
            fsSelection: new r.Bitfield(r.uint16, [// bit field containing information about the font
              'italic', 'underscore', 'negative', 'outlined', 'strikeout', 'bold', 'regular', 'useTypoMetrics', 'wws', 'oblique']),
            usFirstCharIndex: r.uint16,
            // The minimum Unicode index in this font
            usLastCharIndex: r.uint16, // The maximum Unicode index in this font

          },
          // The Apple version of this table ends here, but the Microsoft one continues on...
          0: {},
          1: {
            typoAscender: r.int16,
            typoDescender: r.int16,
            typoLineGap: r.int16,
            winAscent: r.uint16,
            winDescent: r.uint16,
            codePageRange: new r.Array(r.uint32, 2),
          },
          2: {
            // these should be common with version 1 somehow
            typoAscender: r.int16,
            typoDescender: r.int16,
            typoLineGap: r.int16,
            winAscent: r.uint16,
            winDescent: r.uint16,
            codePageRange: new r.Array(r.uint32, 2),
            xHeight: r.int16,
            capHeight: r.int16,
            defaultChar: r.uint16,
            breakChar: r.uint16,
            maxContent: r.uint16,
          },
          5: {
            typoAscender: r.int16,
            typoDescender: r.int16,
            typoLineGap: r.int16,
            winAscent: r.uint16,
            winDescent: r.uint16,
            codePageRange: new r.Array(r.uint32, 2),
            xHeight: r.int16,
            capHeight: r.int16,
            defaultChar: r.uint16,
            breakChar: r.uint16,
            maxContent: r.uint16,
            usLowerOpticalPointSize: r.uint16,
            usUpperOpticalPointSize: r.uint16,
          },
        });
        const { versions } = OS2;
        versions[3] = versions[4] = versions[2];
        const post = new r.VersionedStruct(r.fixed32, {
          header: {
            // these fields exist at the top of all versions
            italicAngle: r.fixed32,
            // Italic angle in counter-clockwise degrees from the vertical.
            underlinePosition: r.int16,
            // Suggested distance of the top of the underline from the baseline
            underlineThickness: r.int16,
            // Suggested values for the underline thickness
            isFixedPitch: r.uint32,
            // Whether the font is monospaced
            minMemType42: r.uint32,
            // Minimum memory usage when a TrueType font is downloaded as a Type 42 font
            maxMemType42: r.uint32,
            // Maximum memory usage when a TrueType font is downloaded as a Type 42 font
            minMemType1: r.uint32,
            // Minimum memory usage when a TrueType font is downloaded as a Type 1 font
            maxMemType1: r.uint32, // Maximum memory usage when a TrueType font is downloaded as a Type 1 font

          },
          1: {},
          // version 1 has no additional fields
          2: {
            numberOfGlyphs: r.uint16,
            glyphNameIndex: new r.Array(r.uint16, 'numberOfGlyphs'),
            names: new r.Array(new r.String(r.uint8)),
          },
          2.5: {
            numberOfGlyphs: r.uint16,
            offsets: new r.Array(r.uint8, 'numberOfGlyphs'),
          },
          3: {},
          // version 3 has no additional fields
          4: {
            map: new r.Array(r.uint32, ((t) => t.parent.maxp.numGlyphs)),
          },
        });
        const cvt = new r.Struct({
          controlValues: new r.Array(r.int16),
        }); // These instructions are known as the font program. The main use of this table
        // is for the definition of functions that are used in many different glyph programs.

        const fpgm = new r.Struct({
          instructions: new r.Array(r.uint8),
        });
        const loca = new r.VersionedStruct('head.indexToLocFormat', {
          0: {
            offsets: new r.Array(r.uint16),
          },
          1: {
            offsets: new r.Array(r.uint32),
          },
        });

        loca.process = function () {
          if (this.version === 0) {
            for (let i = 0; i < this.offsets.length; i++) {
              this.offsets[i] <<= 1;
            }
          }
        };

        loca.preEncode = function () {
          if (this.version === 0) {
            for (let i = 0; i < this.offsets.length; i++) {
              this.offsets[i] >>>= 1;
            }
          }
        };

        const prep = new r.Struct({
          controlValueProgram: new r.Array(r.uint8),
        });
        const glyf = new r.Array(new r.Buffer());

        const CFFIndex = /* #__PURE__ */(function () {
          function CFFIndex(type) {
            this.type = type;
          }

          const _proto = CFFIndex.prototype;

          _proto.getCFFVersion = function getCFFVersion(ctx) {
            while (ctx && !ctx.hdrSize) {
              ctx = ctx.parent;
            }

            return ctx ? ctx.version : -1;
          };

          _proto.decode = function decode(stream, parent) {
            const version = this.getCFFVersion(parent);
            const count = version >= 2 ? stream.readUInt32BE() : stream.readUInt16BE();

            if (count === 0) {
              return [];
            }

            const offSize = stream.readUInt8();
            let offsetType;

            if (offSize === 1) {
              offsetType = r.uint8;
            } else if (offSize === 2) {
              offsetType = r.uint16;
            } else if (offSize === 3) {
              offsetType = r.uint24;
            } else if (offSize === 4) {
              offsetType = r.uint32;
            } else {
              throw new Error('Bad offset size in CFFIndex: '.concat(offSize, ' ').concat(stream.pos));
            }

            const ret = [];
            const startPos = stream.pos + (count + 1) * offSize - 1;
            let start = offsetType.decode(stream);

            for (let i = 0; i < count; i++) {
              const end = offsetType.decode(stream);

              if (this.type != null) {
                const { pos } = stream;
                stream.pos = startPos + start;
                parent.length = end - start;
                ret.push(this.type.decode(stream, parent));
                stream.pos = pos;
              } else {
                ret.push({
                  offset: startPos + start,
                  length: end - start,
                });
              }

              start = end;
            }

            stream.pos = startPos + start;
            return ret;
          };

          _proto.size = function size(arr, parent) {
            let size = 2;

            if (arr.length === 0) {
              return size;
            }

            const type = this.type || new r.Buffer(); // find maximum offset to detminine offset type

            let offset = 1;

            for (let i = 0; i < arr.length; i++) {
              const item = arr[i];
              offset += type.size(item, parent);
            }

            let offsetType;

            if (offset <= 0xff) {
              offsetType = r.uint8;
            } else if (offset <= 0xffff) {
              offsetType = r.uint16;
            } else if (offset <= 0xffffff) {
              offsetType = r.uint24;
            } else if (offset <= 0xffffffff) {
              offsetType = r.uint32;
            } else {
              throw new Error('Bad offset in CFFIndex');
            }

            size += 1 + offsetType.size() * (arr.length + 1);
            size += offset - 1;
            return size;
          };

          _proto.encode = function encode(stream, arr, parent) {
            stream.writeUInt16BE(arr.length);

            if (arr.length === 0) {
              return;
            }

            const type = this.type || new r.Buffer(); // find maximum offset to detminine offset type

            const sizes = [];
            let offset = 1;

            for (var _iterator2 = _createForOfIteratorHelperLoose(arr), _step2; !(_step2 = _iterator2()).done;) {
              const item = _step2.value;
              const s = type.size(item, parent);
              sizes.push(s);
              offset += s;
            }

            let offsetType;

            if (offset <= 0xff) {
              offsetType = r.uint8;
            } else if (offset <= 0xffff) {
              offsetType = r.uint16;
            } else if (offset <= 0xffffff) {
              offsetType = r.uint24;
            } else if (offset <= 0xffffffff) {
              offsetType = r.uint32;
            } else {
              throw new Error('Bad offset in CFFIndex');
            } // write offset size

            stream.writeUInt8(offsetType.size()); // write elements

            offset = 1;
            offsetType.encode(stream, offset);

            for (let _i22 = 0, _sizes = sizes; _i22 < _sizes.length; _i22++) {
              const size = _sizes[_i22];
              offset += size;
              offsetType.encode(stream, offset);
            }

            for (var _iterator3 = _createForOfIteratorHelperLoose(arr), _step3; !(_step3 = _iterator3()).done;) {
              const _item = _step3.value;
              type.encode(stream, _item, parent);
            }
          };

          return CFFIndex;
        }());

        const FLOAT_EOF = 0xf;
        const FLOAT_LOOKUP = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', 'E', 'E-', null, '-'];
        const FLOAT_ENCODE_LOOKUP = {
          '.': 10,
          E: 11,
          'E-': 12,
          '-': 14,
        };

        const CFFOperand = /* #__PURE__ */(function () {
          function CFFOperand() {}

          CFFOperand.decode = function decode(stream, value) {
            if (value >= 32 && value <= 246) {
              return value - 139;
            }

            if (value >= 247 && value <= 250) {
              return (value - 247) * 256 + stream.readUInt8() + 108;
            }

            if (value >= 251 && value <= 254) {
              return -(value - 251) * 256 - stream.readUInt8() - 108;
            }

            if (value === 28) {
              return stream.readInt16BE();
            }

            if (value === 29) {
              return stream.readInt32BE();
            }

            if (value === 30) {
              let str = '';

              while (true) {
                const b = stream.readUInt8();
                const n1 = b >> 4;

                if (n1 === FLOAT_EOF) {
                  break;
                }

                str += FLOAT_LOOKUP[n1];
                const n2 = b & 15;

                if (n2 === FLOAT_EOF) {
                  break;
                }

                str += FLOAT_LOOKUP[n2];
              }

              return parseFloat(str);
            }

            return null;
          };

          CFFOperand.size = function size(value) {
            // if the value needs to be forced to the largest size (32 bit)
            // e.g. for unknown pointers, set to 32768
            if (value.forceLarge) {
              value = 32768;
            }

            if ((value | 0) !== value) {
              // floating point
              const str = `${value}`;
              return 1 + Math.ceil((str.length + 1) / 2);
            } if (value >= -107 && value <= 107) {
              return 1;
            } if (value >= 108 && value <= 1131 || value >= -1131 && value <= -108) {
              return 2;
            } if (value >= -32768 && value <= 32767) {
              return 3;
            }
            return 5;
          };

          CFFOperand.encode = function encode(stream, value) {
            // if the value needs to be forced to the largest size (32 bit)
            // e.g. for unknown pointers, save the old value and set to 32768
            let val = Number(value);

            if (value.forceLarge) {
              stream.writeUInt8(29);
              return stream.writeInt32BE(val);
            } if ((val | 0) !== val) {
              // floating point
              stream.writeUInt8(30);
              const str = `${val}`;

              for (let i = 0; i < str.length; i += 2) {
                const c1 = str[i];
                const n1 = FLOAT_ENCODE_LOOKUP[c1] || +c1;

                if (i === str.length - 1) {
                  var n2 = FLOAT_EOF;
                } else {
                  const c2 = str[i + 1];
                  var n2 = FLOAT_ENCODE_LOOKUP[c2] || +c2;
                }

                stream.writeUInt8(n1 << 4 | n2 & 15);
              }

              if (n2 !== FLOAT_EOF) {
                return stream.writeUInt8(FLOAT_EOF << 4);
              }
            } else if (val >= -107 && val <= 107) {
              return stream.writeUInt8(val + 139);
            } else if (val >= 108 && val <= 1131) {
              val -= 108;
              stream.writeUInt8((val >> 8) + 247);
              return stream.writeUInt8(val & 0xff);
            } else if (val >= -1131 && val <= -108) {
              val = -val - 108;
              stream.writeUInt8((val >> 8) + 251);
              return stream.writeUInt8(val & 0xff);
            } else if (val >= -32768 && val <= 32767) {
              stream.writeUInt8(28);
              return stream.writeInt16BE(val);
            } else {
              stream.writeUInt8(29);
              return stream.writeInt32BE(val);
            }
          };

          return CFFOperand;
        }());

        const CFFDict = /* #__PURE__ */(function () {
          function CFFDict(ops) {
            if (ops === void 0) {
              ops = [];
            }

            this.ops = ops;
            this.fields = {};

            for (var _iterator4 = _createForOfIteratorHelperLoose(ops), _step4; !(_step4 = _iterator4()).done;) {
              const field = _step4.value;
              const key = Array.isArray(field[0]) ? field[0][0] << 8 | field[0][1] : field[0];
              this.fields[key] = field;
            }
          }

          const _proto2 = CFFDict.prototype;

          _proto2.decodeOperands = function decodeOperands(type, stream, ret, operands) {
            const _this = this;

            if (Array.isArray(type)) {
              return operands.map((op, i) => _this.decodeOperands(type[i], stream, ret, [op]));
            } if (type.decode != null) {
              return type.decode(stream, ret, operands);
            }
            switch (type) {
              case 'number':
              case 'offset':
              case 'sid':
                return operands[0];

              case 'boolean':
                return !!operands[0];

              default:
                return operands;
            }
          };

          _proto2.encodeOperands = function encodeOperands(type, stream, ctx, operands) {
            const _this2 = this;

            if (Array.isArray(type)) {
              return operands.map((op, i) => _this2.encodeOperands(type[i], stream, ctx, op)[0]);
            } if (type.encode != null) {
              return type.encode(stream, operands, ctx);
            } if (typeof operands === 'number') {
              return [operands];
            } if (typeof operands === 'boolean') {
              return [+operands];
            } if (Array.isArray(operands)) {
              return operands;
            }
            return [operands];
          };

          _proto2.decode = function decode(stream, parent) {
            const end = stream.pos + parent.length;
            const ret = {};
            let operands = []; // define hidden properties

            Object.defineProperties(ret, {
              parent: {
                value: parent,
              },
              _startOffset: {
                value: stream.pos,
              },
            }); // fill in defaults

            for (const key in this.fields) {
              const field = this.fields[key];
              ret[field[1]] = field[3];
            }

            while (stream.pos < end) {
              let b = stream.readUInt8();

              if (b < 28) {
                if (b === 12) {
                  b = b << 8 | stream.readUInt8();
                }

                const _field = this.fields[b];

                if (!_field) {
                  throw new Error('Unknown operator '.concat(b));
                }

                const val = this.decodeOperands(_field[2], stream, ret, operands);

                if (val != null) {
                  if (val instanceof utils.PropertyDescriptor) {
                    Object.defineProperty(ret, _field[1], val);
                  } else {
                    ret[_field[1]] = val;
                  }
                }

                operands = [];
              } else {
                operands.push(CFFOperand.decode(stream, b));
              }
            }

            return ret;
          };

          _proto2.size = function size(dict, parent, includePointers) {
            if (includePointers === void 0) {
              includePointers = true;
            }

            const ctx = {
              parent,
              val: dict,
              pointerSize: 0,
              startOffset: parent.startOffset || 0,
            };
            let len = 0;

            for (const k in this.fields) {
              const field = this.fields[k];
              const val = dict[field[1]];

              if (val == null || isEqual(val, field[3])) {
                continue;
              }

              const operands = this.encodeOperands(field[2], null, ctx, val);

              for (var _iterator5 = _createForOfIteratorHelperLoose(operands), _step5; !(_step5 = _iterator5()).done;) {
                const op = _step5.value;
                len += CFFOperand.size(op);
              }

              const key = Array.isArray(field[0]) ? field[0] : [field[0]];
              len += key.length;
            }

            if (includePointers) {
              len += ctx.pointerSize;
            }

            return len;
          };

          _proto2.encode = function encode(stream, dict, parent) {
            const ctx = {
              pointers: [],
              startOffset: stream.pos,
              parent,
              val: dict,
              pointerSize: 0,
            };
            ctx.pointerOffset = stream.pos + this.size(dict, ctx, false);

            for (var _iterator6 = _createForOfIteratorHelperLoose(this.ops), _step6; !(_step6 = _iterator6()).done;) {
              const field = _step6.value;
              const val = dict[field[1]];

              if (val == null || isEqual(val, field[3])) {
                continue;
              }

              const operands = this.encodeOperands(field[2], stream, ctx, val);

              for (var _iterator7 = _createForOfIteratorHelperLoose(operands), _step7; !(_step7 = _iterator7()).done;) {
                const op = _step7.value;
                CFFOperand.encode(stream, op);
              }

              const key = Array.isArray(field[0]) ? field[0] : [field[0]];

              for (var _iterator8 = _createForOfIteratorHelperLoose(key), _step8; !(_step8 = _iterator8()).done;) {
                const _op = _step8.value;
                stream.writeUInt8(_op);
              }
            }

            let i = 0;

            while (i < ctx.pointers.length) {
              const ptr = ctx.pointers[i++];
              ptr.type.encode(stream, ptr.val, ptr.parent);
            }
          };

          return CFFDict;
        }());

        const CFFPointer = /* #__PURE__ */(function (_r$Pointer) {
          _inheritsLoose(CFFPointer, _r$Pointer);

          function CFFPointer(type, options) {
            if (options === void 0) {
              options = {};
            }

            if (options.type == null) {
              options.type = 'global';
            }

            return _r$Pointer.call(this, null, type, options) || this;
          }

          const _proto3 = CFFPointer.prototype;

          _proto3.decode = function decode(stream, parent, operands) {
            this.offsetType = {
              decode: function decode() {
                return operands[0];
              },
            };
            return _r$Pointer.prototype.decode.call(this, stream, parent, operands);
          };

          _proto3.encode = function encode(stream, value, ctx) {
            if (!stream) {
              // compute the size (so ctx.pointerSize is correct)
              this.offsetType = {
                size: function size() {
                  return 0;
                },
              };
              this.size(value, ctx);
              return [new Ptr(0)];
            }

            let ptr = null;
            this.offsetType = {
              encode: function encode(stream, val) {
                return ptr = val;
              },
            };

            _r$Pointer.prototype.encode.call(this, stream, value, ctx);

            return [new Ptr(ptr)];
          };

          return CFFPointer;
        }(r.Pointer));

        var Ptr = /* #__PURE__ */(function () {
          function Ptr(val) {
            this.val = val;
            this.forceLarge = true;
          }

          const _proto4 = Ptr.prototype;

          _proto4.valueOf = function valueOf() {
            return this.val;
          };

          return Ptr;
        }());

        const CFFBlendOp = /* #__PURE__ */(function () {
          function CFFBlendOp() {}

          CFFBlendOp.decode = function decode(stream, parent, operands) {
            const numBlends = operands.pop(); // TODO: actually blend. For now just consume the deltas
            // since we don't use any of the values anyway.

            while (operands.length > numBlends) {
              operands.pop();
            }
          };

          return CFFBlendOp;
        }());

        const CFFPrivateDict = new CFFDict([// key       name                    type                                          default
          [6, 'BlueValues', 'delta', null], [7, 'OtherBlues', 'delta', null], [8, 'FamilyBlues', 'delta', null], [9, 'FamilyOtherBlues', 'delta', null], [[12, 9], 'BlueScale', 'number', 0.039625], [[12, 10], 'BlueShift', 'number', 7], [[12, 11], 'BlueFuzz', 'number', 1], [10, 'StdHW', 'number', null], [11, 'StdVW', 'number', null], [[12, 12], 'StemSnapH', 'delta', null], [[12, 13], 'StemSnapV', 'delta', null], [[12, 14], 'ForceBold', 'boolean', false], [[12, 17], 'LanguageGroup', 'number', 0], [[12, 18], 'ExpansionFactor', 'number', 0.06], [[12, 19], 'initialRandomSeed', 'number', 0], [20, 'defaultWidthX', 'number', 0], [21, 'nominalWidthX', 'number', 0], [22, 'vsindex', 'number', 0], [23, 'blend', CFFBlendOp, null], [19, 'Subrs', new CFFPointer(new CFFIndex(), {
            type: 'local',
          }), null]]); // Automatically generated from Appendix A of the CFF specification; do
        // not edit. Length should be 391.

        const standardStrings = ['.notdef', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'exclamdown', 'cent', 'sterling', 'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle', 'quotedblleft', 'guillemotleft', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'endash', 'dagger', 'daggerdbl', 'periodcentered', 'paragraph', 'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright', 'guillemotright', 'ellipsis', 'perthousand', 'questiondown', 'grave', 'acute', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'dieresis', 'ring', 'cedilla', 'hungarumlaut', 'ogonek', 'caron', 'emdash', 'AE', 'ordfeminine', 'Lslash', 'Oslash', 'OE', 'ordmasculine', 'ae', 'dotlessi', 'lslash', 'oslash', 'oe', 'germandbls', 'onesuperior', 'logicalnot', 'mu', 'trademark', 'Eth', 'onehalf', 'plusminus', 'Thorn', 'onequarter', 'divide', 'brokenbar', 'degree', 'thorn', 'threequarters', 'twosuperior', 'registered', 'minus', 'eth', 'multiply', 'threesuperior', 'copyright', 'Aacute', 'Acircumflex', 'Adieresis', 'Agrave', 'Aring', 'Atilde', 'Ccedilla', 'Eacute', 'Ecircumflex', 'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Ntilde', 'Oacute', 'Ocircumflex', 'Odieresis', 'Ograve', 'Otilde', 'Scaron', 'Uacute', 'Ucircumflex', 'Udieresis', 'Ugrave', 'Yacute', 'Ydieresis', 'Zcaron', 'aacute', 'acircumflex', 'adieresis', 'agrave', 'aring', 'atilde', 'ccedilla', 'eacute', 'ecircumflex', 'edieresis', 'egrave', 'iacute', 'icircumflex', 'idieresis', 'igrave', 'ntilde', 'oacute', 'ocircumflex', 'odieresis', 'ograve', 'otilde', 'scaron', 'uacute', 'ucircumflex', 'udieresis', 'ugrave', 'yacute', 'ydieresis', 'zcaron', 'exclamsmall', 'Hungarumlautsmall', 'dollaroldstyle', 'dollarsuperior', 'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'questionsmall', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', 'isuperior', 'lsuperior', 'msuperior', 'nsuperior', 'osuperior', 'rsuperior', 'ssuperior', 'tsuperior', 'ff', 'ffi', 'ffl', 'parenleftinferior', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall', 'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall', 'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall', 'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', 'exclamdownsmall', 'centoldstyle', 'Lslashsmall', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall', 'Brevesmall', 'Caronsmall', 'Dotaccentsmall', 'Macronsmall', 'figuredash', 'hypheninferior', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall', 'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', 'zerosuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior', 'Agravesmall', 'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall', 'Aringsmall', 'AEsmall', 'Ccedillasmall', 'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Igravesmall', 'Iacutesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall', 'Oacutesmall', 'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall', 'Uacutesmall', 'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall', '001.000', '001.001', '001.002', '001.003', 'Black', 'Bold', 'Book', 'Light', 'Medium', 'Regular', 'Roman', 'Semibold'];
        const StandardEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'exclamdown', 'cent', 'sterling', 'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle', 'quotedblleft', 'guillemotleft', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', '', 'endash', 'dagger', 'daggerdbl', 'periodcentered', '', 'paragraph', 'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright', 'guillemotright', 'ellipsis', 'perthousand', '', 'questiondown', '', 'grave', 'acute', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'dieresis', '', 'ring', 'cedilla', '', 'hungarumlaut', 'ogonek', 'caron', 'emdash', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'AE', '', 'ordfeminine', '', '', '', '', 'Lslash', 'Oslash', 'OE', 'ordmasculine', '', '', '', '', '', 'ae', '', '', '', 'dotlessi', '', '', 'lslash', 'oslash', 'oe', 'germandbls'];
        const ExpertEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclamsmall', 'Hungarumlautsmall', '', 'dollaroldstyle', 'dollarsuperior', 'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon', 'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'questionsmall', '', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', '', '', 'isuperior', '', '', 'lsuperior', 'msuperior', 'nsuperior', 'osuperior', '', '', 'rsuperior', 'ssuperior', 'tsuperior', '', 'ff', 'fi', 'fl', 'ffi', 'ffl', 'parenleftinferior', '', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall', 'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall', 'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall', 'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'exclamdownsmall', 'centoldstyle', 'Lslashsmall', '', '', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall', 'Brevesmall', 'Caronsmall', '', 'Dotaccentsmall', '', '', 'Macronsmall', '', '', 'figuredash', 'hypheninferior', '', '', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall', '', '', '', 'onequarter', 'onehalf', 'threequarters', 'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', '', '', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior', 'Agravesmall', 'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall', 'Aringsmall', 'AEsmall', 'Ccedillasmall', 'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Igravesmall', 'Iacutesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall', 'Oacutesmall', 'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall', 'Uacutesmall', 'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall'];
        const ISOAdobeCharset = ['.notdef', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'exclamdown', 'cent', 'sterling', 'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle', 'quotedblleft', 'guillemotleft', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'endash', 'dagger', 'daggerdbl', 'periodcentered', 'paragraph', 'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright', 'guillemotright', 'ellipsis', 'perthousand', 'questiondown', 'grave', 'acute', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'dieresis', 'ring', 'cedilla', 'hungarumlaut', 'ogonek', 'caron', 'emdash', 'AE', 'ordfeminine', 'Lslash', 'Oslash', 'OE', 'ordmasculine', 'ae', 'dotlessi', 'lslash', 'oslash', 'oe', 'germandbls', 'onesuperior', 'logicalnot', 'mu', 'trademark', 'Eth', 'onehalf', 'plusminus', 'Thorn', 'onequarter', 'divide', 'brokenbar', 'degree', 'thorn', 'threequarters', 'twosuperior', 'registered', 'minus', 'eth', 'multiply', 'threesuperior', 'copyright', 'Aacute', 'Acircumflex', 'Adieresis', 'Agrave', 'Aring', 'Atilde', 'Ccedilla', 'Eacute', 'Ecircumflex', 'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Ntilde', 'Oacute', 'Ocircumflex', 'Odieresis', 'Ograve', 'Otilde', 'Scaron', 'Uacute', 'Ucircumflex', 'Udieresis', 'Ugrave', 'Yacute', 'Ydieresis', 'Zcaron', 'aacute', 'acircumflex', 'adieresis', 'agrave', 'aring', 'atilde', 'ccedilla', 'eacute', 'ecircumflex', 'edieresis', 'egrave', 'iacute', 'icircumflex', 'idieresis', 'igrave', 'ntilde', 'oacute', 'ocircumflex', 'odieresis', 'ograve', 'otilde', 'scaron', 'uacute', 'ucircumflex', 'udieresis', 'ugrave', 'yacute', 'ydieresis', 'zcaron'];
        const ExpertCharset = ['.notdef', 'space', 'exclamsmall', 'Hungarumlautsmall', 'dollaroldstyle', 'dollarsuperior', 'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon', 'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'questionsmall', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', 'isuperior', 'lsuperior', 'msuperior', 'nsuperior', 'osuperior', 'rsuperior', 'ssuperior', 'tsuperior', 'ff', 'fi', 'fl', 'ffi', 'ffl', 'parenleftinferior', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall', 'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall', 'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall', 'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', 'exclamdownsmall', 'centoldstyle', 'Lslashsmall', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall', 'Brevesmall', 'Caronsmall', 'Dotaccentsmall', 'Macronsmall', 'figuredash', 'hypheninferior', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall', 'onequarter', 'onehalf', 'threequarters', 'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior', 'Agravesmall', 'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall', 'Aringsmall', 'AEsmall', 'Ccedillasmall', 'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Igravesmall', 'Iacutesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall', 'Oacutesmall', 'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall', 'Uacutesmall', 'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall'];
        const ExpertSubsetCharset = ['.notdef', 'space', 'dollaroldstyle', 'dollarsuperior', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon', 'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', 'isuperior', 'lsuperior', 'msuperior', 'nsuperior', 'osuperior', 'rsuperior', 'ssuperior', 'tsuperior', 'ff', 'fi', 'fl', 'ffi', 'ffl', 'parenleftinferior', 'parenrightinferior', 'hyphensuperior', 'colonmonetary', 'onefitted', 'rupiah', 'centoldstyle', 'figuredash', 'hypheninferior', 'onequarter', 'onehalf', 'threequarters', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior']; // Scripts and Languages #
        // ########################

        const LangSysTable = new r.Struct({
          reserved: new r.Reserved(r.uint16),
          reqFeatureIndex: r.uint16,
          featureCount: r.uint16,
          featureIndexes: new r.Array(r.uint16, 'featureCount'),
        });
        const LangSysRecord = new r.Struct({
          tag: new r.String(4),
          langSys: new r.Pointer(r.uint16, LangSysTable, {
            type: 'parent',
          }),
        });
        const Script = new r.Struct({
          defaultLangSys: new r.Pointer(r.uint16, LangSysTable),
          count: r.uint16,
          langSysRecords: new r.Array(LangSysRecord, 'count'),
        });
        const ScriptRecord = new r.Struct({
          tag: new r.String(4),
          script: new r.Pointer(r.uint16, Script, {
            type: 'parent',
          }),
        });
        const ScriptList = new r.Array(ScriptRecord, r.uint16); // #######################
        // Features and Lookups #
        // #######################

        const Feature = new r.Struct({
          featureParams: r.uint16,
          // pointer
          lookupCount: r.uint16,
          lookupListIndexes: new r.Array(r.uint16, 'lookupCount'),
        });
        const FeatureRecord = new r.Struct({
          tag: new r.String(4),
          feature: new r.Pointer(r.uint16, Feature, {
            type: 'parent',
          }),
        });
        const FeatureList = new r.Array(FeatureRecord, r.uint16);
        const LookupFlags = new r.Struct({
          markAttachmentType: r.uint8,
          flags: new r.Bitfield(r.uint8, ['rightToLeft', 'ignoreBaseGlyphs', 'ignoreLigatures', 'ignoreMarks', 'useMarkFilteringSet']),
        });

        function LookupList(SubTable) {
          const Lookup = new r.Struct({
            lookupType: r.uint16,
            flags: LookupFlags,
            subTableCount: r.uint16,
            subTables: new r.Array(new r.Pointer(r.uint16, SubTable), 'subTableCount'),
            markFilteringSet: new r.Optional(r.uint16, ((t) => t.flags.flags.useMarkFilteringSet)),
          });
          return new r.LazyArray(new r.Pointer(r.uint16, Lookup), r.uint16);
        } // #################
        // Coverage Table #
        // #################

        const RangeRecord = new r.Struct({
          start: r.uint16,
          end: r.uint16,
          startCoverageIndex: r.uint16,
        });
        const Coverage = new r.VersionedStruct(r.uint16, {
          1: {
            glyphCount: r.uint16,
            glyphs: new r.Array(r.uint16, 'glyphCount'),
          },
          2: {
            rangeCount: r.uint16,
            rangeRecords: new r.Array(RangeRecord, 'rangeCount'),
          },
        }); // #########################
        // Class Definition Table #
        // #########################

        const ClassRangeRecord = new r.Struct({
          start: r.uint16,
          end: r.uint16,
          class: r.uint16,
        });
        const ClassDef = new r.VersionedStruct(r.uint16, {
          1: {
            // Class array
            startGlyph: r.uint16,
            glyphCount: r.uint16,
            classValueArray: new r.Array(r.uint16, 'glyphCount'),
          },
          2: {
            // Class ranges
            classRangeCount: r.uint16,
            classRangeRecord: new r.Array(ClassRangeRecord, 'classRangeCount'),
          },
        }); // ###############
        // Device Table #
        // ###############

        const Device = new r.Struct({
          a: r.uint16,
          // startSize for hinting Device, outerIndex for VariationIndex
          b: r.uint16,
          // endSize for Device, innerIndex for VariationIndex
          deltaFormat: r.uint16,
        }); // #############################################
        // Contextual Substitution/Positioning Tables #
        // #############################################

        const LookupRecord = new r.Struct({
          sequenceIndex: r.uint16,
          lookupListIndex: r.uint16,
        });
        const Rule = new r.Struct({
          glyphCount: r.uint16,
          lookupCount: r.uint16,
          input: new r.Array(r.uint16, ((t) => t.glyphCount - 1)),
          lookupRecords: new r.Array(LookupRecord, 'lookupCount'),
        });
        const RuleSet = new r.Array(new r.Pointer(r.uint16, Rule), r.uint16);
        const ClassRule = new r.Struct({
          glyphCount: r.uint16,
          lookupCount: r.uint16,
          classes: new r.Array(r.uint16, ((t) => t.glyphCount - 1)),
          lookupRecords: new r.Array(LookupRecord, 'lookupCount'),
        });
        const ClassSet = new r.Array(new r.Pointer(r.uint16, ClassRule), r.uint16);
        const Context = new r.VersionedStruct(r.uint16, {
          1: {
            // Simple context
            coverage: new r.Pointer(r.uint16, Coverage),
            ruleSetCount: r.uint16,
            ruleSets: new r.Array(new r.Pointer(r.uint16, RuleSet), 'ruleSetCount'),
          },
          2: {
            // Class-based context
            coverage: new r.Pointer(r.uint16, Coverage),
            classDef: new r.Pointer(r.uint16, ClassDef),
            classSetCnt: r.uint16,
            classSet: new r.Array(new r.Pointer(r.uint16, ClassSet), 'classSetCnt'),
          },
          3: {
            glyphCount: r.uint16,
            lookupCount: r.uint16,
            coverages: new r.Array(new r.Pointer(r.uint16, Coverage), 'glyphCount'),
            lookupRecords: new r.Array(LookupRecord, 'lookupCount'),
          },
        }); // ######################################################
        // Chaining Contextual Substitution/Positioning Tables #
        // ######################################################

        const ChainRule = new r.Struct({
          backtrackGlyphCount: r.uint16,
          backtrack: new r.Array(r.uint16, 'backtrackGlyphCount'),
          inputGlyphCount: r.uint16,
          input: new r.Array(r.uint16, ((t) => t.inputGlyphCount - 1)),
          lookaheadGlyphCount: r.uint16,
          lookahead: new r.Array(r.uint16, 'lookaheadGlyphCount'),
          lookupCount: r.uint16,
          lookupRecords: new r.Array(LookupRecord, 'lookupCount'),
        });
        const ChainRuleSet = new r.Array(new r.Pointer(r.uint16, ChainRule), r.uint16);
        const ChainingContext = new r.VersionedStruct(r.uint16, {
          1: {
            // Simple context glyph substitution
            coverage: new r.Pointer(r.uint16, Coverage),
            chainCount: r.uint16,
            chainRuleSets: new r.Array(new r.Pointer(r.uint16, ChainRuleSet), 'chainCount'),
          },
          2: {
            // Class-based chaining context
            coverage: new r.Pointer(r.uint16, Coverage),
            backtrackClassDef: new r.Pointer(r.uint16, ClassDef),
            inputClassDef: new r.Pointer(r.uint16, ClassDef),
            lookaheadClassDef: new r.Pointer(r.uint16, ClassDef),
            chainCount: r.uint16,
            chainClassSet: new r.Array(new r.Pointer(r.uint16, ChainRuleSet), 'chainCount'),
          },
          3: {
            // Coverage-based chaining context
            backtrackGlyphCount: r.uint16,
            backtrackCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'backtrackGlyphCount'),
            inputGlyphCount: r.uint16,
            inputCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'inputGlyphCount'),
            lookaheadGlyphCount: r.uint16,
            lookaheadCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'lookaheadGlyphCount'),
            lookupCount: r.uint16,
            lookupRecords: new r.Array(LookupRecord, 'lookupCount'),
          },
        });
        /** *****************
 * Variation Store *
 ****************** */

        const F2DOT14 = new r.Fixed(16, 'BE', 14);
        const RegionAxisCoordinates = new r.Struct({
          startCoord: F2DOT14,
          peakCoord: F2DOT14,
          endCoord: F2DOT14,
        });
        const VariationRegionList = new r.Struct({
          axisCount: r.uint16,
          regionCount: r.uint16,
          variationRegions: new r.Array(new r.Array(RegionAxisCoordinates, 'axisCount'), 'regionCount'),
        });
        const DeltaSet = new r.Struct({
          shortDeltas: new r.Array(r.int16, ((t) => t.parent.shortDeltaCount)),
          regionDeltas: new r.Array(r.int8, ((t) => t.parent.regionIndexCount - t.parent.shortDeltaCount)),
          deltas: function deltas(t) {
            return t.shortDeltas.concat(t.regionDeltas);
          },
        });
        const ItemVariationData = new r.Struct({
          itemCount: r.uint16,
          shortDeltaCount: r.uint16,
          regionIndexCount: r.uint16,
          regionIndexes: new r.Array(r.uint16, 'regionIndexCount'),
          deltaSets: new r.Array(DeltaSet, 'itemCount'),
        });
        const ItemVariationStore = new r.Struct({
          format: r.uint16,
          variationRegionList: new r.Pointer(r.uint32, VariationRegionList),
          variationDataCount: r.uint16,
          itemVariationData: new r.Array(new r.Pointer(r.uint32, ItemVariationData), 'variationDataCount'),
        });
        /** ********************
 * Feature Variations *
 ********************* */

        const ConditionTable = new r.VersionedStruct(r.uint16, {
          1: (_ = {
            axisIndex: r.uint16,
          }, _.axisIndex = r.uint16, _.filterRangeMinValue = F2DOT14, _.filterRangeMaxValue = F2DOT14, _),
        });
        const ConditionSet = new r.Struct({
          conditionCount: r.uint16,
          conditionTable: new r.Array(new r.Pointer(r.uint32, ConditionTable), 'conditionCount'),
        });
        const FeatureTableSubstitutionRecord = new r.Struct({
          featureIndex: r.uint16,
          alternateFeatureTable: new r.Pointer(r.uint32, Feature, {
            type: 'parent',
          }),
        });
        const FeatureTableSubstitution = new r.Struct({
          version: r.fixed32,
          substitutionCount: r.uint16,
          substitutions: new r.Array(FeatureTableSubstitutionRecord, 'substitutionCount'),
        });
        const FeatureVariationRecord = new r.Struct({
          conditionSet: new r.Pointer(r.uint32, ConditionSet, {
            type: 'parent',
          }),
          featureTableSubstitution: new r.Pointer(r.uint32, FeatureTableSubstitution, {
            type: 'parent',
          }),
        });
        const FeatureVariations = new r.Struct({
          majorVersion: r.uint16,
          minorVersion: r.uint16,
          featureVariationRecordCount: r.uint32,
          featureVariationRecords: new r.Array(FeatureVariationRecord, 'featureVariationRecordCount'),
        }); // otherwise delegates to the provided type.

        const PredefinedOp = /* #__PURE__ */(function () {
          function PredefinedOp(predefinedOps, type) {
            this.predefinedOps = predefinedOps;
            this.type = type;
          }

          const _proto5 = PredefinedOp.prototype;

          _proto5.decode = function decode(stream, parent, operands) {
            if (this.predefinedOps[operands[0]]) {
              return this.predefinedOps[operands[0]];
            }

            return this.type.decode(stream, parent, operands);
          };

          _proto5.size = function size(value, ctx) {
            return this.type.size(value, ctx);
          };

          _proto5.encode = function encode(stream, value, ctx) {
            const index = this.predefinedOps.indexOf(value);

            if (index !== -1) {
              return index;
            }

            return this.type.encode(stream, value, ctx);
          };

          return PredefinedOp;
        }());

        const CFFEncodingVersion = /* #__PURE__ */(function (_r$Number) {
          _inheritsLoose(CFFEncodingVersion, _r$Number);

          function CFFEncodingVersion() {
            return _r$Number.call(this, 'UInt8') || this;
          }

          const _proto6 = CFFEncodingVersion.prototype;

          _proto6.decode = function decode(stream) {
            return r.uint8.decode(stream) & 0x7f;
          };

          return CFFEncodingVersion;
        }(r.Number));

        const Range1 = new r.Struct({
          first: r.uint16,
          nLeft: r.uint8,
        });
        const Range2 = new r.Struct({
          first: r.uint16,
          nLeft: r.uint16,
        });
        const CFFCustomEncoding = new r.VersionedStruct(new CFFEncodingVersion(), {
          0: {
            nCodes: r.uint8,
            codes: new r.Array(r.uint8, 'nCodes'),
          },
          1: {
            nRanges: r.uint8,
            ranges: new r.Array(Range1, 'nRanges'),
          }, // TODO: supplement?

        });
        const CFFEncoding = new PredefinedOp([StandardEncoding, ExpertEncoding], new CFFPointer(CFFCustomEncoding, {
          lazy: true,
        })); // Decodes an array of ranges until the total
        // length is equal to the provided length.

        const RangeArray = /* #__PURE__ */(function (_r$Array) {
          _inheritsLoose(RangeArray, _r$Array);

          function RangeArray() {
            return _r$Array.apply(this, arguments) || this;
          }

          const _proto7 = RangeArray.prototype;

          _proto7.decode = function decode(stream, parent) {
            const length = utils.resolveLength(this.length, stream, parent);
            let count = 0;
            const res = [];

            while (count < length) {
              const range = this.type.decode(stream, parent);
              range.offset = count;
              count += range.nLeft + 1;
              res.push(range);
            }

            return res;
          };

          return RangeArray;
        }(r.Array));

        const CFFCustomCharset = new r.VersionedStruct(r.uint8, {
          0: {
            glyphs: new r.Array(r.uint16, ((t) => t.parent.CharStrings.length - 1)),
          },
          1: {
            ranges: new RangeArray(Range1, ((t) => t.parent.CharStrings.length - 1)),
          },
          2: {
            ranges: new RangeArray(Range2, ((t) => t.parent.CharStrings.length - 1)),
          },
        });
        const CFFCharset = new PredefinedOp([ISOAdobeCharset, ExpertCharset, ExpertSubsetCharset], new CFFPointer(CFFCustomCharset, {
          lazy: true,
        }));
        const FDRange3 = new r.Struct({
          first: r.uint16,
          fd: r.uint8,
        });
        const FDRange4 = new r.Struct({
          first: r.uint32,
          fd: r.uint16,
        });
        const FDSelect = new r.VersionedStruct(r.uint8, {
          0: {
            fds: new r.Array(r.uint8, ((t) => t.parent.CharStrings.length)),
          },
          3: {
            nRanges: r.uint16,
            ranges: new r.Array(FDRange3, 'nRanges'),
            sentinel: r.uint16,
          },
          4: {
            nRanges: r.uint32,
            ranges: new r.Array(FDRange4, 'nRanges'),
            sentinel: r.uint32,
          },
        });
        const ptr = new CFFPointer(CFFPrivateDict);

        const CFFPrivateOp = /* #__PURE__ */(function () {
          function CFFPrivateOp() {}

          const _proto8 = CFFPrivateOp.prototype;

          _proto8.decode = function decode(stream, parent, operands) {
            parent.length = operands[0];
            return ptr.decode(stream, parent, [operands[1]]);
          };

          _proto8.size = function size(dict, ctx) {
            return [CFFPrivateDict.size(dict, ctx, false), ptr.size(dict, ctx)[0]];
          };

          _proto8.encode = function encode(stream, dict, ctx) {
            return [CFFPrivateDict.size(dict, ctx, false), ptr.encode(stream, dict, ctx)[0]];
          };

          return CFFPrivateOp;
        }());

        const FontDict = new CFFDict([// key       name                   type(s)                                 default
          [18, 'Private', new CFFPrivateOp(), null], [[12, 38], 'FontName', 'sid', null], [[12, 7], 'FontMatrix', 'array', [0.001, 0, 0, 0.001, 0, 0]], [[12, 5], 'PaintType', 'number', 0]]);
        const CFFTopDict = new CFFDict([// key       name                   type(s)                                 default
          [[12, 30], 'ROS', ['sid', 'sid', 'number'], null], [0, 'version', 'sid', null], [1, 'Notice', 'sid', null], [[12, 0], 'Copyright', 'sid', null], [2, 'FullName', 'sid', null], [3, 'FamilyName', 'sid', null], [4, 'Weight', 'sid', null], [[12, 1], 'isFixedPitch', 'boolean', false], [[12, 2], 'ItalicAngle', 'number', 0], [[12, 3], 'UnderlinePosition', 'number', -100], [[12, 4], 'UnderlineThickness', 'number', 50], [[12, 5], 'PaintType', 'number', 0], [[12, 6], 'CharstringType', 'number', 2], [[12, 7], 'FontMatrix', 'array', [0.001, 0, 0, 0.001, 0, 0]], [13, 'UniqueID', 'number', null], [5, 'FontBBox', 'array', [0, 0, 0, 0]], [[12, 8], 'StrokeWidth', 'number', 0], [14, 'XUID', 'array', null], [15, 'charset', CFFCharset, ISOAdobeCharset], [16, 'Encoding', CFFEncoding, StandardEncoding], [17, 'CharStrings', new CFFPointer(new CFFIndex()), null], [18, 'Private', new CFFPrivateOp(), null], [[12, 20], 'SyntheticBase', 'number', null], [[12, 21], 'PostScript', 'sid', null], [[12, 22], 'BaseFontName', 'sid', null], [[12, 23], 'BaseFontBlend', 'delta', null], // CID font specific
          [[12, 31], 'CIDFontVersion', 'number', 0], [[12, 32], 'CIDFontRevision', 'number', 0], [[12, 33], 'CIDFontType', 'number', 0], [[12, 34], 'CIDCount', 'number', 8720], [[12, 35], 'UIDBase', 'number', null], [[12, 37], 'FDSelect', new CFFPointer(FDSelect), null], [[12, 36], 'FDArray', new CFFPointer(new CFFIndex(FontDict)), null], [[12, 38], 'FontName', 'sid', null]]);
        const VariationStore = new r.Struct({
          length: r.uint16,
          itemVariationStore: ItemVariationStore,
        });
        const CFF2TopDict = new CFFDict([[[12, 7], 'FontMatrix', 'array', [0.001, 0, 0, 0.001, 0, 0]], [17, 'CharStrings', new CFFPointer(new CFFIndex()), null], [[12, 37], 'FDSelect', new CFFPointer(FDSelect), null], [[12, 36], 'FDArray', new CFFPointer(new CFFIndex(FontDict)), null], [24, 'vstore', new CFFPointer(VariationStore), null], [25, 'maxstack', 'number', 193]]);
        const CFFTop = new r.VersionedStruct(r.fixed16, {
          1: {
            hdrSize: r.uint8,
            offSize: r.uint8,
            nameIndex: new CFFIndex(new r.String('length')),
            topDictIndex: new CFFIndex(CFFTopDict),
            stringIndex: new CFFIndex(new r.String('length')),
            globalSubrIndex: new CFFIndex(),
          },
          2: {
            hdrSize: r.uint8,
            length: r.uint16,
            topDict: CFF2TopDict,
            globalSubrIndex: new CFFIndex(),
          },
        });

        const CFFFont = /* #__PURE__ */(function () {
          function CFFFont(stream) {
            this.stream = stream;
            this.decode();
          }

          CFFFont.decode = function decode(stream) {
            return new CFFFont(stream);
          };

          const _proto9 = CFFFont.prototype;

          _proto9.decode = function decode() {
            const start = this.stream.pos;
            const top = CFFTop.decode(this.stream);

            for (const key in top) {
              const val = top[key];
              this[key] = val;
            }

            if (this.version < 2) {
              if (this.topDictIndex.length !== 1) {
                throw new Error('Only a single font is allowed in CFF');
              }

              this.topDict = this.topDictIndex[0];
            }

            this.isCIDFont = this.topDict.ROS != null;
            return this;
          };

          _proto9.string = function string(sid) {
            if (this.version >= 2) {
              return null;
            }

            if (sid < standardStrings.length) {
              return standardStrings[sid];
            }

            return this.stringIndex[sid - standardStrings.length];
          };

          _proto9.getCharString = function getCharString(glyph) {
            this.stream.pos = this.topDict.CharStrings[glyph].offset;
            return this.stream.readBuffer(this.topDict.CharStrings[glyph].length);
          };

          _proto9.getGlyphName = function getGlyphName(gid) {
            // CFF2 glyph names are in the post table.
            if (this.version >= 2) {
              return null;
            } // CID-keyed fonts don't have glyph names

            if (this.isCIDFont) {
              return null;
            }

            const { charset } = this.topDict;

            if (Array.isArray(charset)) {
              return charset[gid];
            }

            if (gid === 0) {
              return '.notdef';
            }

            gid -= 1;

            switch (charset.version) {
              case 0:
                return this.string(charset.glyphs[gid]);

              case 1:
              case 2:
                for (let i = 0; i < charset.ranges.length; i++) {
                  const range = charset.ranges[i];

                  if (range.offset <= gid && gid <= range.offset + range.nLeft) {
                    return this.string(range.first + (gid - range.offset));
                  }
                }

                break;
            }

            return null;
          };

          _proto9.fdForGlyph = function fdForGlyph(gid) {
            if (!this.topDict.FDSelect) {
              return null;
            }

            switch (this.topDict.FDSelect.version) {
              case 0:
                return this.topDict.FDSelect.fds[gid];

              case 3:
              case 4:
                var { ranges } = this.topDict.FDSelect;
                var low = 0;
                var high = ranges.length - 1;

                while (low <= high) {
                  const mid = low + high >> 1;

                  if (gid < ranges[mid].first) {
                    high = mid - 1;
                  } else if (mid < high && gid >= ranges[mid + 1].first) {
                    low = mid + 1;
                  } else {
                    return ranges[mid].fd;
                  }
                }

              default:
                throw new Error('Unknown FDSelect version: '.concat(this.topDict.FDSelect.version));
            }
          };

          _proto9.privateDictForGlyph = function privateDictForGlyph(gid) {
            if (this.topDict.FDSelect) {
              const fd = this.fdForGlyph(gid);

              if (this.topDict.FDArray[fd]) {
                return this.topDict.FDArray[fd].Private;
              }

              return null;
            }

            if (this.version < 2) {
              return this.topDict.Private;
            }

            return this.topDict.FDArray[0].Private;
          };

          _createClass(CFFFont, [{
            key: 'postscriptName',
            get: function get() {
              if (this.version < 2) {
                return this.nameIndex[0];
              }

              return null;
            },
          }, {
            key: 'fullName',
            get: function get() {
              return this.string(this.topDict.FullName);
            },
          }, {
            key: 'familyName',
            get: function get() {
              return this.string(this.topDict.FamilyName);
            },
          }]);

          return CFFFont;
        }());

        const VerticalOrigin = new r.Struct({
          glyphIndex: r.uint16,
          vertOriginY: r.int16,
        });
        const VORG = new r.Struct({
          majorVersion: r.uint16,
          minorVersion: r.uint16,
          defaultVertOriginY: r.int16,
          numVertOriginYMetrics: r.uint16,
          metrics: new r.Array(VerticalOrigin, 'numVertOriginYMetrics'),
        });
        const BigMetrics = new r.Struct({
          height: r.uint8,
          width: r.uint8,
          horiBearingX: r.int8,
          horiBearingY: r.int8,
          horiAdvance: r.uint8,
          vertBearingX: r.int8,
          vertBearingY: r.int8,
          vertAdvance: r.uint8,
        });
        const SmallMetrics = new r.Struct({
          height: r.uint8,
          width: r.uint8,
          bearingX: r.int8,
          bearingY: r.int8,
          advance: r.uint8,
        });
        const EBDTComponent = new r.Struct({
          glyph: r.uint16,
          xOffset: r.int8,
          yOffset: r.int8,
        });

        const ByteAligned = function ByteAligned() {};

        const BitAligned = function BitAligned() {};

        const glyph = new r.VersionedStruct('version', {
          1: {
            metrics: SmallMetrics,
            data: ByteAligned,
          },
          2: {
            metrics: SmallMetrics,
            data: BitAligned,
          },
          // format 3 is deprecated
          // format 4 is not supported by Microsoft
          5: {
            data: BitAligned,
          },
          6: {
            metrics: BigMetrics,
            data: ByteAligned,
          },
          7: {
            metrics: BigMetrics,
            data: BitAligned,
          },
          8: {
            metrics: SmallMetrics,
            pad: new r.Reserved(r.uint8),
            numComponents: r.uint16,
            components: new r.Array(EBDTComponent, 'numComponents'),
          },
          9: {
            metrics: BigMetrics,
            pad: new r.Reserved(r.uint8),
            numComponents: r.uint16,
            components: new r.Array(EBDTComponent, 'numComponents'),
          },
          17: {
            metrics: SmallMetrics,
            dataLen: r.uint32,
            data: new r.Buffer('dataLen'),
          },
          18: {
            metrics: BigMetrics,
            dataLen: r.uint32,
            data: new r.Buffer('dataLen'),
          },
          19: {
            dataLen: r.uint32,
            data: new r.Buffer('dataLen'),
          },
        });
        const SBitLineMetrics = new r.Struct({
          ascender: r.int8,
          descender: r.int8,
          widthMax: r.uint8,
          caretSlopeNumerator: r.int8,
          caretSlopeDenominator: r.int8,
          caretOffset: r.int8,
          minOriginSB: r.int8,
          minAdvanceSB: r.int8,
          maxBeforeBL: r.int8,
          minAfterBL: r.int8,
          pad: new r.Reserved(r.int8, 2),
        });
        const CodeOffsetPair = new r.Struct({
          glyphCode: r.uint16,
          offset: r.uint16,
        });
        const IndexSubtable = new r.VersionedStruct(r.uint16, {
          header: {
            imageFormat: r.uint16,
            imageDataOffset: r.uint32,
          },
          1: {
            offsetArray: new r.Array(r.uint32, ((t) => t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1)),
          },
          2: {
            imageSize: r.uint32,
            bigMetrics: BigMetrics,
          },
          3: {
            offsetArray: new r.Array(r.uint16, ((t) => t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1)),
          },
          4: {
            numGlyphs: r.uint32,
            glyphArray: new r.Array(CodeOffsetPair, ((t) => t.numGlyphs + 1)),
          },
          5: {
            imageSize: r.uint32,
            bigMetrics: BigMetrics,
            numGlyphs: r.uint32,
            glyphCodeArray: new r.Array(r.uint16, 'numGlyphs'),
          },
        });
        const IndexSubtableArray = new r.Struct({
          firstGlyphIndex: r.uint16,
          lastGlyphIndex: r.uint16,
          subtable: new r.Pointer(r.uint32, IndexSubtable),
        });
        const BitmapSizeTable = new r.Struct({
          indexSubTableArray: new r.Pointer(r.uint32, new r.Array(IndexSubtableArray, 1), {
            type: 'parent',
          }),
          indexTablesSize: r.uint32,
          numberOfIndexSubTables: r.uint32,
          colorRef: r.uint32,
          hori: SBitLineMetrics,
          vert: SBitLineMetrics,
          startGlyphIndex: r.uint16,
          endGlyphIndex: r.uint16,
          ppemX: r.uint8,
          ppemY: r.uint8,
          bitDepth: r.uint8,
          flags: new r.Bitfield(r.uint8, ['horizontal', 'vertical']),
        });
        const EBLC = new r.Struct({
          version: r.uint32,
          // 0x00020000
          numSizes: r.uint32,
          sizes: new r.Array(BitmapSizeTable, 'numSizes'),
        });
        const ImageTable = new r.Struct({
          ppem: r.uint16,
          resolution: r.uint16,
          imageOffsets: new r.Array(new r.Pointer(r.uint32, 'void'), ((t) => t.parent.parent.maxp.numGlyphs + 1)),
        }); // This is the Apple sbix table, used by the "Apple Color Emoji" font.
        // It includes several image tables with images for each bitmap glyph
        // of several different sizes.

        const sbix = new r.Struct({
          version: r.uint16,
          flags: new r.Bitfield(r.uint16, ['renderOutlines']),
          numImgTables: r.uint32,
          imageTables: new r.Array(new r.Pointer(r.uint32, ImageTable), 'numImgTables'),
        });
        const LayerRecord = new r.Struct({
          gid: r.uint16,
          // Glyph ID of layer glyph (must be in z-order from bottom to top).
          paletteIndex: r.uint16, // Index value to use in the appropriate palette. This value must

        }); // be less than numPaletteEntries in the CPAL table, except for
        // the special case noted below. Each palette entry is 16 bits.
        // A palette index of 0xFFFF is a special case indicating that
        // the text foreground color should be used.

        const BaseGlyphRecord = new r.Struct({
          gid: r.uint16,
          // Glyph ID of reference glyph. This glyph is for reference only
          // and is not rendered for color.
          firstLayerIndex: r.uint16,
          // Index (from beginning of the Layer Records) to the layer record.
          // There will be numLayers consecutive entries for this base glyph.
          numLayers: r.uint16,
        });
        const COLR = new r.Struct({
          version: r.uint16,
          numBaseGlyphRecords: r.uint16,
          baseGlyphRecord: new r.Pointer(r.uint32, new r.Array(BaseGlyphRecord, 'numBaseGlyphRecords')),
          layerRecords: new r.Pointer(r.uint32, new r.Array(LayerRecord, 'numLayerRecords'), {
            lazy: true,
          }),
          numLayerRecords: r.uint16,
        });
        const ColorRecord = new r.Struct({
          blue: r.uint8,
          green: r.uint8,
          red: r.uint8,
          alpha: r.uint8,
        });
        const CPAL = new r.VersionedStruct(r.uint16, {
          header: {
            numPaletteEntries: r.uint16,
            numPalettes: r.uint16,
            numColorRecords: r.uint16,
            colorRecords: new r.Pointer(r.uint32, new r.Array(ColorRecord, 'numColorRecords')),
            colorRecordIndices: new r.Array(r.uint16, 'numPalettes'),
          },
          0: {},
          1: {
            offsetPaletteTypeArray: new r.Pointer(r.uint32, new r.Array(r.uint32, 'numPalettes')),
            offsetPaletteLabelArray: new r.Pointer(r.uint32, new r.Array(r.uint16, 'numPalettes')),
            offsetPaletteEntryLabelArray: new r.Pointer(r.uint32, new r.Array(r.uint16, 'numPaletteEntries')),
          },
        });
        const BaseCoord = new r.VersionedStruct(r.uint16, {
          1: {
            // Design units only
            coordinate: r.int16, // X or Y value, in design units

          },
          2: {
            // Design units plus contour point
            coordinate: r.int16,
            // X or Y value, in design units
            referenceGlyph: r.uint16,
            // GlyphID of control glyph
            baseCoordPoint: r.uint16, // Index of contour point on the referenceGlyph

          },
          3: {
            // Design units plus Device table
            coordinate: r.int16,
            // X or Y value, in design units
            deviceTable: new r.Pointer(r.uint16, Device), // Device table for X or Y value

          },
        });
        const BaseValues = new r.Struct({
          defaultIndex: r.uint16,
          // Index of default baseline for this script-same index in the BaseTagList
          baseCoordCount: r.uint16,
          baseCoords: new r.Array(new r.Pointer(r.uint16, BaseCoord), 'baseCoordCount'),
        });
        const FeatMinMaxRecord = new r.Struct({
          tag: new r.String(4),
          // 4-byte feature identification tag-must match FeatureTag in FeatureList
          minCoord: new r.Pointer(r.uint16, BaseCoord, {
            type: 'parent',
          }),
          // May be NULL
          maxCoord: new r.Pointer(r.uint16, BaseCoord, {
            type: 'parent',
          }), // May be NULL

        });
        const MinMax = new r.Struct({
          minCoord: new r.Pointer(r.uint16, BaseCoord),
          // May be NULL
          maxCoord: new r.Pointer(r.uint16, BaseCoord),
          // May be NULL
          featMinMaxCount: r.uint16,
          // May be 0
          featMinMaxRecords: new r.Array(FeatMinMaxRecord, 'featMinMaxCount'), // In alphabetical order

        });
        const BaseLangSysRecord = new r.Struct({
          tag: new r.String(4),
          // 4-byte language system identification tag
          minMax: new r.Pointer(r.uint16, MinMax, {
            type: 'parent',
          }),
        });
        const BaseScript = new r.Struct({
          baseValues: new r.Pointer(r.uint16, BaseValues),
          // May be NULL
          defaultMinMax: new r.Pointer(r.uint16, MinMax),
          // May be NULL
          baseLangSysCount: r.uint16,
          // May be 0
          baseLangSysRecords: new r.Array(BaseLangSysRecord, 'baseLangSysCount'), // in alphabetical order by BaseLangSysTag

        });
        const BaseScriptRecord = new r.Struct({
          tag: new r.String(4),
          // 4-byte script identification tag
          script: new r.Pointer(r.uint16, BaseScript, {
            type: 'parent',
          }),
        });
        const BaseScriptList = new r.Array(BaseScriptRecord, r.uint16); // Array of 4-byte baseline identification tags-must be in alphabetical order

        const BaseTagList = new r.Array(new r.String(4), r.uint16);
        const Axis = new r.Struct({
          baseTagList: new r.Pointer(r.uint16, BaseTagList),
          // May be NULL
          baseScriptList: new r.Pointer(r.uint16, BaseScriptList),
        });
        const BASE = new r.VersionedStruct(r.uint32, {
          header: {
            horizAxis: new r.Pointer(r.uint16, Axis),
            // May be NULL
            vertAxis: new r.Pointer(r.uint16, Axis), // May be NULL

          },
          0x00010000: {},
          0x00010001: {
            itemVariationStore: new r.Pointer(r.uint32, ItemVariationStore),
          },
        });
        const AttachPoint = new r.Array(r.uint16, r.uint16);
        const AttachList = new r.Struct({
          coverage: new r.Pointer(r.uint16, Coverage),
          glyphCount: r.uint16,
          attachPoints: new r.Array(new r.Pointer(r.uint16, AttachPoint), 'glyphCount'),
        });
        const CaretValue = new r.VersionedStruct(r.uint16, {
          1: {
            // Design units only
            coordinate: r.int16,
          },
          2: {
            // Contour point
            caretValuePoint: r.uint16,
          },
          3: {
            // Design units plus Device table
            coordinate: r.int16,
            deviceTable: new r.Pointer(r.uint16, Device),
          },
        });
        const LigGlyph = new r.Array(new r.Pointer(r.uint16, CaretValue), r.uint16);
        const LigCaretList = new r.Struct({
          coverage: new r.Pointer(r.uint16, Coverage),
          ligGlyphCount: r.uint16,
          ligGlyphs: new r.Array(new r.Pointer(r.uint16, LigGlyph), 'ligGlyphCount'),
        });
        const MarkGlyphSetsDef = new r.Struct({
          markSetTableFormat: r.uint16,
          markSetCount: r.uint16,
          coverage: new r.Array(new r.Pointer(r.uint32, Coverage), 'markSetCount'),
        });
        const GDEF = new r.VersionedStruct(r.uint32, {
          header: {
            glyphClassDef: new r.Pointer(r.uint16, ClassDef),
            attachList: new r.Pointer(r.uint16, AttachList),
            ligCaretList: new r.Pointer(r.uint16, LigCaretList),
            markAttachClassDef: new r.Pointer(r.uint16, ClassDef),
          },
          0x00010000: {},
          0x00010002: {
            markGlyphSetsDef: new r.Pointer(r.uint16, MarkGlyphSetsDef),
          },
          0x00010003: {
            markGlyphSetsDef: new r.Pointer(r.uint16, MarkGlyphSetsDef),
            itemVariationStore: new r.Pointer(r.uint32, ItemVariationStore),
          },
        });
        const ValueFormat = new r.Bitfield(r.uint16, ['xPlacement', 'yPlacement', 'xAdvance', 'yAdvance', 'xPlaDevice', 'yPlaDevice', 'xAdvDevice', 'yAdvDevice']);
        const types = {
          xPlacement: r.int16,
          yPlacement: r.int16,
          xAdvance: r.int16,
          yAdvance: r.int16,
          xPlaDevice: new r.Pointer(r.uint16, Device, {
            type: 'global',
            relativeTo: function relativeTo(ctx) {
              return ctx.rel;
            },
          }),
          yPlaDevice: new r.Pointer(r.uint16, Device, {
            type: 'global',
            relativeTo: function relativeTo(ctx) {
              return ctx.rel;
            },
          }),
          xAdvDevice: new r.Pointer(r.uint16, Device, {
            type: 'global',
            relativeTo: function relativeTo(ctx) {
              return ctx.rel;
            },
          }),
          yAdvDevice: new r.Pointer(r.uint16, Device, {
            type: 'global',
            relativeTo: function relativeTo(ctx) {
              return ctx.rel;
            },
          }),
        };

        const ValueRecord = /* #__PURE__ */(function () {
          function ValueRecord(key) {
            if (key === void 0) {
              key = 'valueFormat';
            }

            this.key = key;
          }

          const _proto10 = ValueRecord.prototype;

          _proto10.buildStruct = function buildStruct(parent) {
            let struct = parent;

            while (!struct[this.key] && struct.parent) {
              struct = struct.parent;
            }

            if (!struct[this.key]) return;
            const fields = {};

            fields.rel = function () {
              return struct._startOffset;
            };

            const format = struct[this.key];

            for (const key in format) {
              if (format[key]) {
                fields[key] = types[key];
              }
            }

            return new r.Struct(fields);
          };

          _proto10.size = function size(val, ctx) {
            return this.buildStruct(ctx).size(val, ctx);
          };

          _proto10.decode = function decode(stream, parent) {
            const res = this.buildStruct(parent).decode(stream, parent);
            delete res.rel;
            return res;
          };

          return ValueRecord;
        }());

        const PairValueRecord = new r.Struct({
          secondGlyph: r.uint16,
          value1: new ValueRecord('valueFormat1'),
          value2: new ValueRecord('valueFormat2'),
        });
        const PairSet = new r.Array(PairValueRecord, r.uint16);
        const Class2Record = new r.Struct({
          value1: new ValueRecord('valueFormat1'),
          value2: new ValueRecord('valueFormat2'),
        });
        const Anchor = new r.VersionedStruct(r.uint16, {
          1: {
            // Design units only
            xCoordinate: r.int16,
            yCoordinate: r.int16,
          },
          2: {
            // Design units plus contour point
            xCoordinate: r.int16,
            yCoordinate: r.int16,
            anchorPoint: r.uint16,
          },
          3: {
            // Design units plus Device tables
            xCoordinate: r.int16,
            yCoordinate: r.int16,
            xDeviceTable: new r.Pointer(r.uint16, Device),
            yDeviceTable: new r.Pointer(r.uint16, Device),
          },
        });
        const EntryExitRecord = new r.Struct({
          entryAnchor: new r.Pointer(r.uint16, Anchor, {
            type: 'parent',
          }),
          exitAnchor: new r.Pointer(r.uint16, Anchor, {
            type: 'parent',
          }),
        });
        const MarkRecord = new r.Struct({
          class: r.uint16,
          markAnchor: new r.Pointer(r.uint16, Anchor, {
            type: 'parent',
          }),
        });
        const MarkArray = new r.Array(MarkRecord, r.uint16);
        const BaseRecord = new r.Array(new r.Pointer(r.uint16, Anchor), ((t) => t.parent.classCount));
        const BaseArray = new r.Array(BaseRecord, r.uint16);
        const ComponentRecord = new r.Array(new r.Pointer(r.uint16, Anchor), ((t) => t.parent.parent.classCount));
        const LigatureAttach = new r.Array(ComponentRecord, r.uint16);
        const LigatureArray = new r.Array(new r.Pointer(r.uint16, LigatureAttach), r.uint16);
        var GPOSLookup = new r.VersionedStruct('lookupType', {
          1: new r.VersionedStruct(r.uint16, {
            // Single Adjustment
            1: {
              // Single positioning value
              coverage: new r.Pointer(r.uint16, Coverage),
              valueFormat: ValueFormat,
              value: new ValueRecord(),
            },
            2: {
              coverage: new r.Pointer(r.uint16, Coverage),
              valueFormat: ValueFormat,
              valueCount: r.uint16,
              values: new r.LazyArray(new ValueRecord(), 'valueCount'),
            },
          }),
          2: new r.VersionedStruct(r.uint16, {
            // Pair Adjustment Positioning
            1: {
              // Adjustments for glyph pairs
              coverage: new r.Pointer(r.uint16, Coverage),
              valueFormat1: ValueFormat,
              valueFormat2: ValueFormat,
              pairSetCount: r.uint16,
              pairSets: new r.LazyArray(new r.Pointer(r.uint16, PairSet), 'pairSetCount'),
            },
            2: {
              // Class pair adjustment
              coverage: new r.Pointer(r.uint16, Coverage),
              valueFormat1: ValueFormat,
              valueFormat2: ValueFormat,
              classDef1: new r.Pointer(r.uint16, ClassDef),
              classDef2: new r.Pointer(r.uint16, ClassDef),
              class1Count: r.uint16,
              class2Count: r.uint16,
              classRecords: new r.LazyArray(new r.LazyArray(Class2Record, 'class2Count'), 'class1Count'),
            },
          }),
          3: {
            // Cursive Attachment Positioning
            format: r.uint16,
            coverage: new r.Pointer(r.uint16, Coverage),
            entryExitCount: r.uint16,
            entryExitRecords: new r.Array(EntryExitRecord, 'entryExitCount'),
          },
          4: {
            // MarkToBase Attachment Positioning
            format: r.uint16,
            markCoverage: new r.Pointer(r.uint16, Coverage),
            baseCoverage: new r.Pointer(r.uint16, Coverage),
            classCount: r.uint16,
            markArray: new r.Pointer(r.uint16, MarkArray),
            baseArray: new r.Pointer(r.uint16, BaseArray),
          },
          5: {
            // MarkToLigature Attachment Positioning
            format: r.uint16,
            markCoverage: new r.Pointer(r.uint16, Coverage),
            ligatureCoverage: new r.Pointer(r.uint16, Coverage),
            classCount: r.uint16,
            markArray: new r.Pointer(r.uint16, MarkArray),
            ligatureArray: new r.Pointer(r.uint16, LigatureArray),
          },
          6: {
            // MarkToMark Attachment Positioning
            format: r.uint16,
            mark1Coverage: new r.Pointer(r.uint16, Coverage),
            mark2Coverage: new r.Pointer(r.uint16, Coverage),
            classCount: r.uint16,
            mark1Array: new r.Pointer(r.uint16, MarkArray),
            mark2Array: new r.Pointer(r.uint16, BaseArray),
          },
          7: Context,
          // Contextual positioning
          8: ChainingContext,
          // Chaining contextual positioning
          9: {
            // Extension Positioning
            posFormat: r.uint16,
            lookupType: r.uint16,
            // cannot also be 9
            extension: new r.Pointer(r.uint32, GPOSLookup),
          },
        }); // Fix circular reference

        GPOSLookup.versions[9].extension.type = GPOSLookup;
        const GPOS = new r.VersionedStruct(r.uint32, {
          header: {
            scriptList: new r.Pointer(r.uint16, ScriptList),
            featureList: new r.Pointer(r.uint16, FeatureList),
            lookupList: new r.Pointer(r.uint16, new LookupList(GPOSLookup)),
          },
          0x00010000: {},
          0x00010001: {
            featureVariations: new r.Pointer(r.uint32, FeatureVariations),
          },
        }); // export GPOSLookup for JSTF table

        const Sequence = new r.Array(r.uint16, r.uint16);
        const AlternateSet = Sequence;
        const Ligature = new r.Struct({
          glyph: r.uint16,
          compCount: r.uint16,
          components: new r.Array(r.uint16, ((t) => t.compCount - 1)),
        });
        const LigatureSet = new r.Array(new r.Pointer(r.uint16, Ligature), r.uint16);
        var GSUBLookup = new r.VersionedStruct('lookupType', {
          1: new r.VersionedStruct(r.uint16, {
            // Single Substitution
            1: {
              coverage: new r.Pointer(r.uint16, Coverage),
              deltaGlyphID: r.int16,
            },
            2: {
              coverage: new r.Pointer(r.uint16, Coverage),
              glyphCount: r.uint16,
              substitute: new r.LazyArray(r.uint16, 'glyphCount'),
            },
          }),
          2: {
            // Multiple Substitution
            substFormat: r.uint16,
            coverage: new r.Pointer(r.uint16, Coverage),
            count: r.uint16,
            sequences: new r.LazyArray(new r.Pointer(r.uint16, Sequence), 'count'),
          },
          3: {
            // Alternate Substitution
            substFormat: r.uint16,
            coverage: new r.Pointer(r.uint16, Coverage),
            count: r.uint16,
            alternateSet: new r.LazyArray(new r.Pointer(r.uint16, AlternateSet), 'count'),
          },
          4: {
            // Ligature Substitution
            substFormat: r.uint16,
            coverage: new r.Pointer(r.uint16, Coverage),
            count: r.uint16,
            ligatureSets: new r.LazyArray(new r.Pointer(r.uint16, LigatureSet), 'count'),
          },
          5: Context,
          // Contextual Substitution
          6: ChainingContext,
          // Chaining Contextual Substitution
          7: {
            // Extension Substitution
            substFormat: r.uint16,
            lookupType: r.uint16,
            // cannot also be 7
            extension: new r.Pointer(r.uint32, GSUBLookup),
          },
          8: {
            // Reverse Chaining Contextual Single Substitution
            substFormat: r.uint16,
            coverage: new r.Pointer(r.uint16, Coverage),
            backtrackCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'backtrackGlyphCount'),
            lookaheadGlyphCount: r.uint16,
            lookaheadCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'lookaheadGlyphCount'),
            glyphCount: r.uint16,
            substitutes: new r.Array(r.uint16, 'glyphCount'),
          },
        }); // Fix circular reference

        GSUBLookup.versions[7].extension.type = GSUBLookup;
        const GSUB = new r.VersionedStruct(r.uint32, {
          header: {
            scriptList: new r.Pointer(r.uint16, ScriptList),
            featureList: new r.Pointer(r.uint16, FeatureList),
            lookupList: new r.Pointer(r.uint16, new LookupList(GSUBLookup)),
          },
          0x00010000: {},
          0x00010001: {
            featureVariations: new r.Pointer(r.uint32, FeatureVariations),
          },
        });
        const JstfGSUBModList = new r.Array(r.uint16, r.uint16);
        const JstfPriority = new r.Struct({
          shrinkageEnableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
          shrinkageDisableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
          shrinkageEnableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
          shrinkageDisableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
          shrinkageJstfMax: new r.Pointer(r.uint16, new LookupList(GPOSLookup)),
          extensionEnableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
          extensionDisableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
          extensionEnableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
          extensionDisableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
          extensionJstfMax: new r.Pointer(r.uint16, new LookupList(GPOSLookup)),
        });
        const JstfLangSys = new r.Array(new r.Pointer(r.uint16, JstfPriority), r.uint16);
        const JstfLangSysRecord = new r.Struct({
          tag: new r.String(4),
          jstfLangSys: new r.Pointer(r.uint16, JstfLangSys),
        });
        const JstfScript = new r.Struct({
          extenderGlyphs: new r.Pointer(r.uint16, new r.Array(r.uint16, r.uint16)),
          // array of glyphs to extend line length
          defaultLangSys: new r.Pointer(r.uint16, JstfLangSys),
          langSysCount: r.uint16,
          langSysRecords: new r.Array(JstfLangSysRecord, 'langSysCount'),
        });
        const JstfScriptRecord = new r.Struct({
          tag: new r.String(4),
          script: new r.Pointer(r.uint16, JstfScript, {
            type: 'parent',
          }),
        });
        const JSTF = new r.Struct({
          version: r.uint32,
          // should be 0x00010000
          scriptCount: r.uint16,
          scriptList: new r.Array(JstfScriptRecord, 'scriptCount'),
        });

        const VariableSizeNumber = /* #__PURE__ */(function () {
          function VariableSizeNumber(size) {
            this._size = size;
          }

          const _proto11 = VariableSizeNumber.prototype;

          _proto11.decode = function decode(stream, parent) {
            switch (this.size(0, parent)) {
              case 1:
                return stream.readUInt8();

              case 2:
                return stream.readUInt16BE();

              case 3:
                return stream.readUInt24BE();

              case 4:
                return stream.readUInt32BE();
            }
          };

          _proto11.size = function size(val, parent) {
            return utils.resolveLength(this._size, null, parent);
          };

          return VariableSizeNumber;
        }());

        const MapDataEntry = new r.Struct({
          entry: new VariableSizeNumber(((t) => ((t.parent.entryFormat & 0x0030) >> 4) + 1)),
          outerIndex: function outerIndex(t) {
            return t.entry >> (t.parent.entryFormat & 0x000F) + 1;
          },
          innerIndex: function innerIndex(t) {
            return t.entry & (1 << (t.parent.entryFormat & 0x000F) + 1) - 1;
          },
        });
        const DeltaSetIndexMap = new r.Struct({
          entryFormat: r.uint16,
          mapCount: r.uint16,
          mapData: new r.Array(MapDataEntry, 'mapCount'),
        });
        const HVAR = new r.Struct({
          majorVersion: r.uint16,
          minorVersion: r.uint16,
          itemVariationStore: new r.Pointer(r.uint32, ItemVariationStore),
          advanceWidthMapping: new r.Pointer(r.uint32, DeltaSetIndexMap),
          LSBMapping: new r.Pointer(r.uint32, DeltaSetIndexMap),
          RSBMapping: new r.Pointer(r.uint32, DeltaSetIndexMap),
        });
        const Signature = new r.Struct({
          format: r.uint32,
          length: r.uint32,
          offset: r.uint32,
        });
        const SignatureBlock = new r.Struct({
          reserved: new r.Reserved(r.uint16, 2),
          cbSignature: r.uint32,
          // Length (in bytes) of the PKCS#7 packet in pbSignature
          signature: new r.Buffer('cbSignature'),
        });
        const DSIG = new r.Struct({
          ulVersion: r.uint32,
          // Version number of the DSIG table (0x00000001)
          usNumSigs: r.uint16,
          // Number of signatures in the table
          usFlag: r.uint16,
          // Permission flags
          signatures: new r.Array(Signature, 'usNumSigs'),
          signatureBlocks: new r.Array(SignatureBlock, 'usNumSigs'),
        });
        const GaspRange = new r.Struct({
          rangeMaxPPEM: r.uint16,
          // Upper limit of range, in ppem
          rangeGaspBehavior: new r.Bitfield(r.uint16, [// Flags describing desired rasterizer behavior
            'grayscale', 'gridfit', 'symmetricSmoothing', 'symmetricGridfit', // only in version 1, for ClearType
          ]),
        });
        const gasp = new r.Struct({
          version: r.uint16,
          // set to 0
          numRanges: r.uint16,
          gaspRanges: new r.Array(GaspRange, 'numRanges'), // Sorted by ppem

        });
        const DeviceRecord = new r.Struct({
          pixelSize: r.uint8,
          maximumWidth: r.uint8,
          widths: new r.Array(r.uint8, ((t) => t.parent.parent.maxp.numGlyphs)),
        }); // The Horizontal Device Metrics table stores integer advance widths scaled to particular pixel sizes

        const hdmx = new r.Struct({
          version: r.uint16,
          numRecords: r.int16,
          sizeDeviceRecord: r.int32,
          records: new r.Array(DeviceRecord, 'numRecords'),
        });
        const KernPair = new r.Struct({
          left: r.uint16,
          right: r.uint16,
          value: r.int16,
        });
        const ClassTable = new r.Struct({
          firstGlyph: r.uint16,
          nGlyphs: r.uint16,
          offsets: new r.Array(r.uint16, 'nGlyphs'),
          max: function max(t) {
            return t.offsets.length && Math.max.apply(Math, t.offsets);
          },
        });
        const Kern2Array = new r.Struct({
          off: function off(t) {
            return t._startOffset - t.parent.parent._startOffset;
          },
          len: function len(t) {
            return ((t.parent.leftTable.max - t.off) / t.parent.rowWidth + 1) * (t.parent.rowWidth / 2);
          },
          values: new r.LazyArray(r.int16, 'len'),
        });
        const KernSubtable = new r.VersionedStruct('format', {
          0: {
            nPairs: r.uint16,
            searchRange: r.uint16,
            entrySelector: r.uint16,
            rangeShift: r.uint16,
            pairs: new r.Array(KernPair, 'nPairs'),
          },
          2: {
            rowWidth: r.uint16,
            leftTable: new r.Pointer(r.uint16, ClassTable, {
              type: 'parent',
            }),
            rightTable: new r.Pointer(r.uint16, ClassTable, {
              type: 'parent',
            }),
            array: new r.Pointer(r.uint16, Kern2Array, {
              type: 'parent',
            }),
          },
          3: {
            glyphCount: r.uint16,
            kernValueCount: r.uint8,
            leftClassCount: r.uint8,
            rightClassCount: r.uint8,
            flags: r.uint8,
            kernValue: new r.Array(r.int16, 'kernValueCount'),
            leftClass: new r.Array(r.uint8, 'glyphCount'),
            rightClass: new r.Array(r.uint8, 'glyphCount'),
            kernIndex: new r.Array(r.uint8, ((t) => t.leftClassCount * t.rightClassCount)),
          },
        });
        const KernTable = new r.VersionedStruct('version', {
          0: {
            // Microsoft uses this format
            subVersion: r.uint16,
            // Microsoft has an extra sub-table version number
            length: r.uint16,
            // Length of the subtable, in bytes
            format: r.uint8,
            // Format of subtable
            coverage: new r.Bitfield(r.uint8, ['horizontal', // 1 if table has horizontal data, 0 if vertical
              'minimum', // If set to 1, the table has minimum values. If set to 0, the table has kerning values.
              'crossStream', // If set to 1, kerning is perpendicular to the flow of the text
              'override', // If set to 1 the value in this table replaces the accumulated value
            ]),
            subtable: KernSubtable,
            padding: new r.Reserved(r.uint8, ((t) => t.length - t._currentOffset)),
          },
          1: {
            // Apple uses this format
            length: r.uint32,
            coverage: new r.Bitfield(r.uint8, [null, null, null, null, null, 'variation', // Set if table has variation kerning values
              'crossStream', // Set if table has cross-stream kerning values
              'vertical', // Set if table has vertical kerning values
            ]),
            format: r.uint8,
            tupleIndex: r.uint16,
            subtable: KernSubtable,
            padding: new r.Reserved(r.uint8, ((t) => t.length - t._currentOffset)),
          },
        });
        const kern = new r.VersionedStruct(r.uint16, {
          0: {
            // Microsoft Version
            nTables: r.uint16,
            tables: new r.Array(KernTable, 'nTables'),
          },
          1: {
            // Apple Version
            reserved: new r.Reserved(r.uint16),
            // the other half of the version number
            nTables: r.uint32,
            tables: new r.Array(KernTable, 'nTables'),
          },
        }); // Records the ppem for each glyph at which the scaling becomes linear again,
        // despite instructions effecting the advance width

        const LTSH = new r.Struct({
          version: r.uint16,
          numGlyphs: r.uint16,
          yPels: new r.Array(r.uint8, 'numGlyphs'),
        }); // NOTE: The PCLT table is strongly discouraged for OpenType fonts with TrueType outlines

        const PCLT = new r.Struct({
          version: r.uint16,
          fontNumber: r.uint32,
          pitch: r.uint16,
          xHeight: r.uint16,
          style: r.uint16,
          typeFamily: r.uint16,
          capHeight: r.uint16,
          symbolSet: r.uint16,
          typeface: new r.String(16),
          characterComplement: new r.String(8),
          fileName: new r.String(6),
          strokeWeight: new r.String(1),
          widthType: new r.String(1),
          serifStyle: r.uint8,
          reserved: new r.Reserved(r.uint8),
        }); // sizes. This is needed in order to match font metrics on Windows.

        const Ratio = new r.Struct({
          bCharSet: r.uint8,
          // Character set
          xRatio: r.uint8,
          // Value to use for x-Ratio
          yStartRatio: r.uint8,
          // Starting y-Ratio value
          yEndRatio: r.uint8, // Ending y-Ratio value

        });
        const vTable = new r.Struct({
          yPelHeight: r.uint16,
          // yPelHeight to which values apply
          yMax: r.int16,
          // Maximum value (in pels) for this yPelHeight
          yMin: r.int16, // Minimum value (in pels) for this yPelHeight

        });
        const VdmxGroup = new r.Struct({
          recs: r.uint16,
          // Number of height records in this group
          startsz: r.uint8,
          // Starting yPelHeight
          endsz: r.uint8,
          // Ending yPelHeight
          entries: new r.Array(vTable, 'recs'), // The VDMX records

        });
        const VDMX = new r.Struct({
          version: r.uint16,
          // Version number (0 or 1)
          numRecs: r.uint16,
          // Number of VDMX groups present
          numRatios: r.uint16,
          // Number of aspect ratio groupings
          ratioRanges: new r.Array(Ratio, 'numRatios'),
          // Ratio ranges
          offsets: new r.Array(r.uint16, 'numRatios'),
          // Offset to the VDMX group for this ratio range
          groups: new r.Array(VdmxGroup, 'numRecs'), // The actual VDMX groupings

        });
        const vhea = new r.Struct({
          version: r.uint16,
          // Version number of the Vertical Header Table
          ascent: r.int16,
          // The vertical typographic ascender for this font
          descent: r.int16,
          // The vertical typographic descender for this font
          lineGap: r.int16,
          // The vertical typographic line gap for this font
          advanceHeightMax: r.int16,
          // The maximum advance height measurement found in the font
          minTopSideBearing: r.int16,
          // The minimum top side bearing measurement found in the font
          minBottomSideBearing: r.int16,
          // The minimum bottom side bearing measurement found in the font
          yMaxExtent: r.int16,
          caretSlopeRise: r.int16,
          // Caret slope (rise/run)
          caretSlopeRun: r.int16,
          caretOffset: r.int16,
          // Set value equal to 0 for nonslanted fonts
          reserved: new r.Reserved(r.int16, 4),
          metricDataFormat: r.int16,
          // Set to 0
          numberOfMetrics: r.uint16, // Number of advance heights in the Vertical Metrics table

        });
        const VmtxEntry = new r.Struct({
          advance: r.uint16,
          // The advance height of the glyph
          bearing: r.int16, // The top sidebearing of the glyph

        }); // Vertical Metrics Table

        const vmtx = new r.Struct({
          metrics: new r.LazyArray(VmtxEntry, ((t) => t.parent.vhea.numberOfMetrics)),
          bearings: new r.LazyArray(r.int16, ((t) => t.parent.maxp.numGlyphs - t.parent.vhea.numberOfMetrics)),
        });
        const shortFrac = new r.Fixed(16, 'BE', 14);
        const Correspondence = new r.Struct({
          fromCoord: shortFrac,
          toCoord: shortFrac,
        });
        const Segment = new r.Struct({
          pairCount: r.uint16,
          correspondence: new r.Array(Correspondence, 'pairCount'),
        });
        const avar = new r.Struct({
          version: r.fixed32,
          axisCount: r.uint32,
          segment: new r.Array(Segment, 'axisCount'),
        });

        const UnboundedArrayAccessor = /* #__PURE__ */(function () {
          function UnboundedArrayAccessor(type, stream, parent) {
            this.type = type;
            this.stream = stream;
            this.parent = parent;
            this.base = this.stream.pos;
            this._items = [];
          }

          const _proto12 = UnboundedArrayAccessor.prototype;

          _proto12.getItem = function getItem(index) {
            if (this._items[index] == null) {
              const { pos } = this.stream;
              this.stream.pos = this.base + this.type.size(null, this.parent) * index;
              this._items[index] = this.type.decode(this.stream, this.parent);
              this.stream.pos = pos;
            }

            return this._items[index];
          };

          _proto12.inspect = function inspect() {
            return '[UnboundedArray '.concat(this.type.constructor.name, ']');
          };

          return UnboundedArrayAccessor;
        }());

        const UnboundedArray = /* #__PURE__ */(function (_r$Array2) {
          _inheritsLoose(UnboundedArray, _r$Array2);

          function UnboundedArray(type) {
            return _r$Array2.call(this, type, 0) || this;
          }

          const _proto13 = UnboundedArray.prototype;

          _proto13.decode = function decode(stream, parent) {
            return new UnboundedArrayAccessor(this.type, stream, parent);
          };

          return UnboundedArray;
        }(r.Array));

        const LookupTable = function LookupTable(ValueType) {
          if (ValueType === void 0) {
            ValueType = r.uint16;
          }

          // Helper class that makes internal structures invisible to pointers
          const Shadow = /* #__PURE__ */(function () {
            function Shadow(type) {
              this.type = type;
            }

            const _proto14 = Shadow.prototype;

            _proto14.decode = function decode(stream, ctx) {
              ctx = ctx.parent.parent;
              return this.type.decode(stream, ctx);
            };

            _proto14.size = function size(val, ctx) {
              ctx = ctx.parent.parent;
              return this.type.size(val, ctx);
            };

            _proto14.encode = function encode(stream, val, ctx) {
              ctx = ctx.parent.parent;
              return this.type.encode(stream, val, ctx);
            };

            return Shadow;
          }());

          ValueType = new Shadow(ValueType);
          const BinarySearchHeader = new r.Struct({
            unitSize: r.uint16,
            nUnits: r.uint16,
            searchRange: r.uint16,
            entrySelector: r.uint16,
            rangeShift: r.uint16,
          });
          const LookupSegmentSingle = new r.Struct({
            lastGlyph: r.uint16,
            firstGlyph: r.uint16,
            value: ValueType,
          });
          const LookupSegmentArray = new r.Struct({
            lastGlyph: r.uint16,
            firstGlyph: r.uint16,
            values: new r.Pointer(r.uint16, new r.Array(ValueType, ((t) => t.lastGlyph - t.firstGlyph + 1)), {
              type: 'parent',
            }),
          });
          const LookupSingle = new r.Struct({
            glyph: r.uint16,
            value: ValueType,
          });
          return new r.VersionedStruct(r.uint16, {
            0: {
              values: new UnboundedArray(ValueType), // length == number of glyphs maybe?

            },
            2: {
              binarySearchHeader: BinarySearchHeader,
              segments: new r.Array(LookupSegmentSingle, ((t) => t.binarySearchHeader.nUnits)),
            },
            4: {
              binarySearchHeader: BinarySearchHeader,
              segments: new r.Array(LookupSegmentArray, ((t) => t.binarySearchHeader.nUnits)),
            },
            6: {
              binarySearchHeader: BinarySearchHeader,
              segments: new r.Array(LookupSingle, ((t) => t.binarySearchHeader.nUnits)),
            },
            8: {
              firstGlyph: r.uint16,
              count: r.uint16,
              values: new r.Array(ValueType, 'count'),
            },
          });
        };

        function StateTable(entryData, lookupType) {
          if (entryData === void 0) {
            entryData = {};
          }

          if (lookupType === void 0) {
            lookupType = r.uint16;
          }

          const entry = {
            newState: r.uint16,
            flags: r.uint16,
            ...entryData,
          };
          const Entry = new r.Struct(entry);
          const StateArray = new UnboundedArray(new r.Array(r.uint16, ((t) => t.nClasses)));
          const StateHeader = new r.Struct({
            nClasses: r.uint32,
            classTable: new r.Pointer(r.uint32, new LookupTable(lookupType)),
            stateArray: new r.Pointer(r.uint32, StateArray),
            entryTable: new r.Pointer(r.uint32, new UnboundedArray(Entry)),
          });
          return StateHeader;
        } // This is the old version of the StateTable structure

        function StateTable1(entryData, lookupType) {
          if (entryData === void 0) {
            entryData = {};
          }

          if (lookupType === void 0) {
            lookupType = r.uint16;
          }

          const ClassLookupTable = new r.Struct({
            version: function version() {
              return 8;
            },
            // simulate LookupTable
            firstGlyph: r.uint16,
            values: new r.Array(r.uint8, r.uint16),
          });
          const entry = {
            newStateOffset: r.uint16,
            // convert offset to stateArray index
            newState: function newState(t) {
              return (t.newStateOffset - (t.parent.stateArray.base - t.parent._startOffset)) / t.parent.nClasses;
            },
            flags: r.uint16,
            ...entryData,
          };
          const Entry = new r.Struct(entry);
          const StateArray = new UnboundedArray(new r.Array(r.uint8, ((t) => t.nClasses)));
          const StateHeader1 = new r.Struct({
            nClasses: r.uint16,
            classTable: new r.Pointer(r.uint16, ClassLookupTable),
            stateArray: new r.Pointer(r.uint16, StateArray),
            entryTable: new r.Pointer(r.uint16, new UnboundedArray(Entry)),
          });
          return StateHeader1;
        }

        const BslnSubtable = new r.VersionedStruct('format', {
          0: {
            // Distance-based, no mapping
            deltas: new r.Array(r.int16, 32),
          },
          1: {
            // Distance-based, with mapping
            deltas: new r.Array(r.int16, 32),
            mappingData: new LookupTable(r.uint16),
          },
          2: {
            // Control point-based, no mapping
            standardGlyph: r.uint16,
            controlPoints: new r.Array(r.uint16, 32),
          },
          3: {
            // Control point-based, with mapping
            standardGlyph: r.uint16,
            controlPoints: new r.Array(r.uint16, 32),
            mappingData: new LookupTable(r.uint16),
          },
        });
        const bsln = new r.Struct({
          version: r.fixed32,
          format: r.uint16,
          defaultBaseline: r.uint16,
          subtable: BslnSubtable,
        });
        const Setting = new r.Struct({
          setting: r.uint16,
          nameIndex: r.int16,
          name: function name(t) {
            return t.parent.parent.parent.name.records.fontFeatures[t.nameIndex];
          },
        });
        const FeatureName = new r.Struct({
          feature: r.uint16,
          nSettings: r.uint16,
          settingTable: new r.Pointer(r.uint32, new r.Array(Setting, 'nSettings'), {
            type: 'parent',
          }),
          featureFlags: new r.Bitfield(r.uint8, [null, null, null, null, null, null, 'hasDefault', 'exclusive']),
          defaultSetting: r.uint8,
          nameIndex: r.int16,
          name: function name(t) {
            return t.parent.parent.name.records.fontFeatures[t.nameIndex];
          },
        });
        const feat = new r.Struct({
          version: r.fixed32,
          featureNameCount: r.uint16,
          reserved1: new r.Reserved(r.uint16),
          reserved2: new r.Reserved(r.uint32),
          featureNames: new r.Array(FeatureName, 'featureNameCount'),
        });
        const Axis$1 = new r.Struct({
          axisTag: new r.String(4),
          minValue: r.fixed32,
          defaultValue: r.fixed32,
          maxValue: r.fixed32,
          flags: r.uint16,
          nameID: r.uint16,
          name: function name(t) {
            return t.parent.parent.name.records.fontFeatures[t.nameID];
          },
        });
        const Instance = new r.Struct({
          nameID: r.uint16,
          name: function name(t) {
            return t.parent.parent.name.records.fontFeatures[t.nameID];
          },
          flags: r.uint16,
          coord: new r.Array(r.fixed32, ((t) => t.parent.axisCount)),
          postscriptNameID: new r.Optional(r.uint16, ((t) => t.parent.instanceSize - t._currentOffset > 0)),
        });
        const fvar = new r.Struct({
          version: r.fixed32,
          offsetToData: r.uint16,
          countSizePairs: r.uint16,
          axisCount: r.uint16,
          axisSize: r.uint16,
          instanceCount: r.uint16,
          instanceSize: r.uint16,
          axis: new r.Array(Axis$1, 'axisCount'),
          instance: new r.Array(Instance, 'instanceCount'),
        });
        const shortFrac$1 = new r.Fixed(16, 'BE', 14);

        const Offset = /* #__PURE__ */(function () {
          function Offset() {}

          Offset.decode = function decode(stream, parent) {
            // In short format, offsets are multiplied by 2.
            // This doesn't seem to be documented by Apple, but it
            // is implemented this way in Freetype.
            return parent.flags ? stream.readUInt32BE() : stream.readUInt16BE() * 2;
          };

          return Offset;
        }());

        const gvar = new r.Struct({
          version: r.uint16,
          reserved: new r.Reserved(r.uint16),
          axisCount: r.uint16,
          globalCoordCount: r.uint16,
          globalCoords: new r.Pointer(r.uint32, new r.Array(new r.Array(shortFrac$1, 'axisCount'), 'globalCoordCount')),
          glyphCount: r.uint16,
          flags: r.uint16,
          offsetToData: r.uint32,
          offsets: new r.Array(new r.Pointer(Offset, 'void', {
            relativeTo: function relativeTo(ctx) {
              return ctx.offsetToData;
            },
            allowNull: false,
          }), ((t) => t.glyphCount + 1)),
        });
        const ClassTable$1 = new r.Struct({
          length: r.uint16,
          coverage: r.uint16,
          subFeatureFlags: r.uint32,
          stateTable: new StateTable1(),
        });
        const WidthDeltaRecord = new r.Struct({
          justClass: r.uint32,
          beforeGrowLimit: r.fixed32,
          beforeShrinkLimit: r.fixed32,
          afterGrowLimit: r.fixed32,
          afterShrinkLimit: r.fixed32,
          growFlags: r.uint16,
          shrinkFlags: r.uint16,
        });
        const WidthDeltaCluster = new r.Array(WidthDeltaRecord, r.uint32);
        const ActionData = new r.VersionedStruct('actionType', {
          0: {
            // Decomposition action
            lowerLimit: r.fixed32,
            upperLimit: r.fixed32,
            order: r.uint16,
            glyphs: new r.Array(r.uint16, r.uint16),
          },
          1: {
            // Unconditional add glyph action
            addGlyph: r.uint16,
          },
          2: {
            // Conditional add glyph action
            substThreshold: r.fixed32,
            addGlyph: r.uint16,
            substGlyph: r.uint16,
          },
          3: {},
          // Stretch glyph action (no data, not supported by CoreText)
          4: {
            // Ductile glyph action (not supported by CoreText)
            variationAxis: r.uint32,
            minimumLimit: r.fixed32,
            noStretchValue: r.fixed32,
            maximumLimit: r.fixed32,
          },
          5: {
            // Repeated add glyph action
            flags: r.uint16,
            glyph: r.uint16,
          },
        });
        const Action = new r.Struct({
          actionClass: r.uint16,
          actionType: r.uint16,
          actionLength: r.uint32,
          actionData: ActionData,
          padding: new r.Reserved(r.uint8, ((t) => t.actionLength - t._currentOffset)),
        });
        const PostcompensationAction = new r.Array(Action, r.uint32);
        const PostCompensationTable = new r.Struct({
          lookupTable: new LookupTable(new r.Pointer(r.uint16, PostcompensationAction)),
        });
        const JustificationTable = new r.Struct({
          classTable: new r.Pointer(r.uint16, ClassTable$1, {
            type: 'parent',
          }),
          wdcOffset: r.uint16,
          postCompensationTable: new r.Pointer(r.uint16, PostCompensationTable, {
            type: 'parent',
          }),
          widthDeltaClusters: new LookupTable(new r.Pointer(r.uint16, WidthDeltaCluster, {
            type: 'parent',
            relativeTo: function relativeTo(ctx) {
              return ctx.wdcOffset;
            },
          })),
        });
        const just = new r.Struct({
          version: r.uint32,
          format: r.uint16,
          horizontal: new r.Pointer(r.uint16, JustificationTable),
          vertical: new r.Pointer(r.uint16, JustificationTable),
        });
        const LigatureData = {
          action: r.uint16,
        };
        const ContextualData = {
          markIndex: r.uint16,
          currentIndex: r.uint16,
        };
        const InsertionData = {
          currentInsertIndex: r.uint16,
          markedInsertIndex: r.uint16,
        };
        const SubstitutionTable = new r.Struct({
          items: new UnboundedArray(new r.Pointer(r.uint32, new LookupTable())),
        });
        const SubtableData = new r.VersionedStruct('type', {
          0: {
            // Indic Rearrangement Subtable
            stateTable: new StateTable(),
          },
          1: {
            // Contextual Glyph Substitution Subtable
            stateTable: new StateTable(ContextualData),
            substitutionTable: new r.Pointer(r.uint32, SubstitutionTable),
          },
          2: {
            // Ligature subtable
            stateTable: new StateTable(LigatureData),
            ligatureActions: new r.Pointer(r.uint32, new UnboundedArray(r.uint32)),
            components: new r.Pointer(r.uint32, new UnboundedArray(r.uint16)),
            ligatureList: new r.Pointer(r.uint32, new UnboundedArray(r.uint16)),
          },
          4: {
            // Non-contextual Glyph Substitution Subtable
            lookupTable: new LookupTable(),
          },
          5: {
            // Glyph Insertion Subtable
            stateTable: new StateTable(InsertionData),
            insertionActions: new r.Pointer(r.uint32, new UnboundedArray(r.uint16)),
          },
        });
        const Subtable = new r.Struct({
          length: r.uint32,
          coverage: r.uint24,
          type: r.uint8,
          subFeatureFlags: r.uint32,
          table: SubtableData,
          padding: new r.Reserved(r.uint8, ((t) => t.length - t._currentOffset)),
        });
        const FeatureEntry = new r.Struct({
          featureType: r.uint16,
          featureSetting: r.uint16,
          enableFlags: r.uint32,
          disableFlags: r.uint32,
        });
        const MorxChain = new r.Struct({
          defaultFlags: r.uint32,
          chainLength: r.uint32,
          nFeatureEntries: r.uint32,
          nSubtables: r.uint32,
          features: new r.Array(FeatureEntry, 'nFeatureEntries'),
          subtables: new r.Array(Subtable, 'nSubtables'),
        });
        const morx = new r.Struct({
          version: r.uint16,
          unused: new r.Reserved(r.uint16),
          nChains: r.uint32,
          chains: new r.Array(MorxChain, 'nChains'),
        });
        const OpticalBounds = new r.Struct({
          left: r.int16,
          top: r.int16,
          right: r.int16,
          bottom: r.int16,
        });
        const opbd = new r.Struct({
          version: r.fixed32,
          format: r.uint16,
          lookupTable: new LookupTable(OpticalBounds),
        });
        const tables = {};
        tables.cmap = cmap;
        tables.head = head;
        tables.hhea = hhea;
        tables.hmtx = hmtx;
        tables.maxp = maxp;
        tables.name = NameTable;
        tables['OS/2'] = OS2;
        tables.post = post; // TrueType Outlines

        tables.fpgm = fpgm;
        tables.loca = loca;
        tables.prep = prep;
        tables['cvt '] = cvt;
        tables.glyf = glyf; // PostScript Outlines

        tables['CFF '] = CFFFont;
        tables.CFF2 = CFFFont;
        tables.VORG = VORG; // Bitmap Glyphs

        tables.EBLC = EBLC;
        tables.CBLC = tables.EBLC;
        tables.sbix = sbix;
        tables.COLR = COLR;
        tables.CPAL = CPAL; // Advanced OpenType Tables

        tables.BASE = BASE;
        tables.GDEF = GDEF;
        tables.GPOS = GPOS;
        tables.GSUB = GSUB;
        tables.JSTF = JSTF; // OpenType variations tables

        tables.HVAR = HVAR; // Other OpenType Tables

        tables.DSIG = DSIG;
        tables.gasp = gasp;
        tables.hdmx = hdmx;
        tables.kern = kern;
        tables.LTSH = LTSH;
        tables.PCLT = PCLT;
        tables.VDMX = VDMX;
        tables.vhea = vhea;
        tables.vmtx = vmtx; // Apple Advanced Typography Tables

        tables.avar = avar;
        tables.bsln = bsln;
        tables.feat = feat;
        tables.fvar = fvar;
        tables.gvar = gvar;
        tables.just = just;
        tables.morx = morx;
        tables.opbd = opbd;
        const TableEntry = new r.Struct({
          tag: new r.String(4),
          checkSum: r.uint32,
          offset: new r.Pointer(r.uint32, 'void', {
            type: 'global',
          }),
          length: r.uint32,
        });
        const Directory = new r.Struct({
          tag: new r.String(4),
          numTables: r.uint16,
          searchRange: r.uint16,
          entrySelector: r.uint16,
          rangeShift: r.uint16,
          tables: new r.Array(TableEntry, 'numTables'),
        });

        Directory.process = function () {
          const tables = {};

          for (var _iterator9 = _createForOfIteratorHelperLoose(this.tables), _step9; !(_step9 = _iterator9()).done;) {
            const table = _step9.value;
            tables[table.tag] = table;
          }

          this.tables = tables;
        };

        Directory.preEncode = function (stream) {
          const tables$1 = [];

          for (const tag in this.tables) {
            const table = this.tables[tag];

            if (table) {
              tables$1.push({
                tag,
                checkSum: 0,
                offset: new r.VoidPointer(tables[tag], table),
                length: tables[tag].size(table),
              });
            }
          }

          this.tag = 'true';
          this.numTables = tables$1.length;
          this.tables = tables$1;
          const maxExponentFor2 = Math.floor(Math.log(this.numTables) / Math.LN2);
          const maxPowerOf2 = Math.pow(2, maxExponentFor2);
          this.searchRange = maxPowerOf2 * 16;
          this.entrySelector = Math.log(maxPowerOf2) / Math.LN2;
          this.rangeShift = this.numTables * 16 - this.searchRange;
        };

        function binarySearch(arr, cmp) {
          let min = 0;
          let max = arr.length - 1;

          while (min <= max) {
            const mid = min + max >> 1;
            const res = cmp(arr[mid]);

            if (res < 0) {
              max = mid - 1;
            } else if (res > 0) {
              min = mid + 1;
            } else {
              return mid;
            }
          }

          return -1;
        }

        function range(index, end) {
          const range = [];

          while (index < end) {
            range.push(index++);
          }

          return range;
        }

        let _class;

        try {
          var iconv = __webpack_require__(4914);
        } catch (err) {}

        const CmapProcessor = (_class = /* #__PURE__ */(function () {
          function CmapProcessor(cmapTable) {
            // Attempt to find a Unicode cmap first
            this.encoding = null;
            this.cmap = this.findSubtable(cmapTable, [// 32-bit subtables
              [3, 10], [0, 6], [0, 4], // 16-bit subtables
              [3, 1], [0, 3], [0, 2], [0, 1], [0, 0]]); // If not unicode cmap was found, and iconv-lite is installed,
            // take the first table with a supported encoding.

            if (!this.cmap && iconv) {
              for (var _iterator10 = _createForOfIteratorHelperLoose(cmapTable.tables), _step10; !(_step10 = _iterator10()).done;) {
                const cmap = _step10.value;
                const encoding = getEncoding(cmap.platformID, cmap.encodingID, cmap.table.language - 1);

                if (iconv.encodingExists(encoding)) {
                  this.cmap = cmap.table;
                  this.encoding = encoding;
                }
              }
            }

            if (!this.cmap) {
              throw new Error('Could not find a supported cmap table');
            }

            this.uvs = this.findSubtable(cmapTable, [[0, 5]]);

            if (this.uvs && this.uvs.version !== 14) {
              this.uvs = null;
            }
          }

          const _proto15 = CmapProcessor.prototype;

          _proto15.findSubtable = function findSubtable(cmapTable, pairs) {
            for (var _iterator11 = _createForOfIteratorHelperLoose(pairs), _step11; !(_step11 = _iterator11()).done;) {
              const _step11$value = _step11.value;
              const platformID = _step11$value[0];
              const encodingID = _step11$value[1];

              for (var _iterator12 = _createForOfIteratorHelperLoose(cmapTable.tables), _step12; !(_step12 = _iterator12()).done;) {
                const cmap = _step12.value;

                if (cmap.platformID === platformID && cmap.encodingID === encodingID) {
                  return cmap.table;
                }
              }
            }

            return null;
          };

          _proto15.lookup = function lookup(codepoint, variationSelector) {
            // If there is no Unicode cmap in this font, we need to re-encode
            // the codepoint in the encoding that the cmap supports.
            if (this.encoding) {
              const buf = iconv.encode(String.fromCodePoint(codepoint), this.encoding);
              codepoint = 0;

              for (let i = 0; i < buf.length; i++) {
                codepoint = codepoint << 8 | buf[i];
              } // Otherwise, try to get a Unicode variation selector for this codepoint if one is provided.
            } else if (variationSelector) {
              const gid = this.getVariationSelector(codepoint, variationSelector);

              if (gid) {
                return gid;
              }
            }

            const { cmap } = this;

            switch (cmap.version) {
              case 0:
                return cmap.codeMap.get(codepoint) || 0;

              case 4:
              {
                let min = 0;
                let max = cmap.segCount - 1;

                while (min <= max) {
                  const mid = min + max >> 1;

                  if (codepoint < cmap.startCode.get(mid)) {
                    max = mid - 1;
                  } else if (codepoint > cmap.endCode.get(mid)) {
                    min = mid + 1;
                  } else {
                    const rangeOffset = cmap.idRangeOffset.get(mid);

                    let _gid = void 0;

                    if (rangeOffset === 0) {
                      _gid = codepoint + cmap.idDelta.get(mid);
                    } else {
                      const index = rangeOffset / 2 + (codepoint - cmap.startCode.get(mid)) - (cmap.segCount - mid);
                      _gid = cmap.glyphIndexArray.get(index) || 0;

                      if (_gid !== 0) {
                        _gid += cmap.idDelta.get(mid);
                      }
                    }

                    return _gid & 0xffff;
                  }
                }

                return 0;
              }

              case 8:
                throw new Error('TODO: cmap format 8');

              case 6:
              case 10:
                return cmap.glyphIndices.get(codepoint - cmap.firstCode) || 0;

              case 12:
              case 13:
              {
                let _min = 0;

                let _max = cmap.nGroups - 1;

                while (_min <= _max) {
                  const _mid = _min + _max >> 1;

                  const group = cmap.groups.get(_mid);

                  if (codepoint < group.startCharCode) {
                    _max = _mid - 1;
                  } else if (codepoint > group.endCharCode) {
                    _min = _mid + 1;
                  } else {
                    if (cmap.version === 12) {
                      return group.glyphID + (codepoint - group.startCharCode);
                    }
                    return group.glyphID;
                  }
                }

                return 0;
              }

              case 14:
                throw new Error('TODO: cmap format 14');

              default:
                throw new Error('Unknown cmap format '.concat(cmap.version));
            }
          };

          _proto15.getVariationSelector = function getVariationSelector(codepoint, variationSelector) {
            if (!this.uvs) {
              return 0;
            }

            const selectors = this.uvs.varSelectors.toArray();
            let i = binarySearch(selectors, (x) => variationSelector - x.varSelector);
            const sel = selectors[i];

            if (i !== -1 && sel.defaultUVS) {
              i = binarySearch(sel.defaultUVS, (x) => (codepoint < x.startUnicodeValue ? -1 : codepoint > x.startUnicodeValue + x.additionalCount ? +1 : 0));
            }

            if (i !== -1 && sel.nonDefaultUVS) {
              i = binarySearch(sel.nonDefaultUVS, (x) => codepoint - x.unicodeValue);

              if (i !== -1) {
                return sel.nonDefaultUVS[i].glyphID;
              }
            }

            return 0;
          };

          _proto15.getCharacterSet = function getCharacterSet() {
            const { cmap } = this;

            switch (cmap.version) {
              case 0:
                return range(0, cmap.codeMap.length);

              case 4:
              {
                const res = [];
                const endCodes = cmap.endCode.toArray();

                for (let i = 0; i < endCodes.length; i++) {
                  const tail = endCodes[i] + 1;
                  const start = cmap.startCode.get(i);
                  res.push.apply(res, range(start, tail));
                }

                return res;
              }

              case 8:
                throw new Error('TODO: cmap format 8');

              case 6:
              case 10:
                return range(cmap.firstCode, cmap.firstCode + cmap.glyphIndices.length);

              case 12:
              case 13:
              {
                const _res = [];

                for (var _iterator13 = _createForOfIteratorHelperLoose(cmap.groups.toArray()), _step13; !(_step13 = _iterator13()).done;) {
                  const group = _step13.value;

                  _res.push.apply(_res, range(group.startCharCode, group.endCharCode + 1));
                }

                return _res;
              }

              case 14:
                throw new Error('TODO: cmap format 14');

              default:
                throw new Error('Unknown cmap format '.concat(cmap.version));
            }
          };

          _proto15.codePointsForGlyph = function codePointsForGlyph(gid) {
            const { cmap } = this;

            switch (cmap.version) {
              case 0:
              {
                const res = [];

                for (let i = 0; i < 256; i++) {
                  if (cmap.codeMap.get(i) === gid) {
                    res.push(i);
                  }
                }

                return res;
              }

              case 4:
              {
                const _res2 = [];

                for (let _i = 0; _i < cmap.segCount; _i++) {
                  const end = cmap.endCode.get(_i);
                  const start = cmap.startCode.get(_i);
                  const rangeOffset = cmap.idRangeOffset.get(_i);
                  const delta = cmap.idDelta.get(_i);

                  for (let c = start; c <= end; c++) {
                    let g = 0;

                    if (rangeOffset === 0) {
                      g = c + delta;
                    } else {
                      const index = rangeOffset / 2 + (c - start) - (cmap.segCount - _i);
                      g = cmap.glyphIndexArray.get(index) || 0;

                      if (g !== 0) {
                        g += delta;
                      }
                    }

                    if (g === gid) {
                      _res2.push(c);
                    }
                  }
                }

                return _res2;
              }

              case 12:
              {
                const _res3 = [];

                for (var _iterator14 = _createForOfIteratorHelperLoose(cmap.groups.toArray()), _step14; !(_step14 = _iterator14()).done;) {
                  const group = _step14.value;

                  if (gid >= group.glyphID && gid <= group.glyphID + (group.endCharCode - group.startCharCode)) {
                    _res3.push(group.startCharCode + (gid - group.glyphID));
                  }
                }

                return _res3;
              }

              case 13:
              {
                const _res4 = [];

                for (var _iterator15 = _createForOfIteratorHelperLoose(cmap.groups.toArray()), _step15; !(_step15 = _iterator15()).done;) {
                  const _group = _step15.value;

                  if (gid === _group.glyphID) {
                    _res4.push.apply(_res4, range(_group.startCharCode, _group.endCharCode + 1));
                  }
                }

                return _res4;
              }

              default:
                throw new Error('Unknown cmap format '.concat(cmap.version));
            }
          };

          return CmapProcessor;
        }()), (_applyDecoratedDescriptor(_class.prototype, 'getCharacterSet', [cache], Object.getOwnPropertyDescriptor(_class.prototype, 'getCharacterSet'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'codePointsForGlyph', [cache], Object.getOwnPropertyDescriptor(_class.prototype, 'codePointsForGlyph'), _class.prototype)), _class);

        const KernProcessor = /* #__PURE__ */(function () {
          function KernProcessor(font) {
            this.kern = font.kern;
          }

          const _proto16 = KernProcessor.prototype;

          _proto16.process = function process(glyphs, positions) {
            for (let glyphIndex = 0; glyphIndex < glyphs.length - 1; glyphIndex++) {
              const left = glyphs[glyphIndex].id;
              const right = glyphs[glyphIndex + 1].id;
              positions[glyphIndex].xAdvance += this.getKerning(left, right);
            }
          };

          _proto16.getKerning = function getKerning(left, right) {
            let res = 0;

            for (var _iterator16 = _createForOfIteratorHelperLoose(this.kern.tables), _step16; !(_step16 = _iterator16()).done;) {
              const table = _step16.value;

              if (table.coverage.crossStream) {
                continue;
              }

              switch (table.version) {
                case 0:
                  if (!table.coverage.horizontal) {
                    continue;
                  }

                  break;

                case 1:
                  if (table.coverage.vertical || table.coverage.variation) {
                    continue;
                  }

                  break;

                default:
                  throw new Error('Unsupported kerning table version '.concat(table.version));
              }

              let val = 0;
              const s = table.subtable;

              switch (table.format) {
                case 0:
                  var pairIdx = binarySearch(s.pairs, (pair) => left - pair.left || right - pair.right);

                  if (pairIdx >= 0) {
                    val = s.pairs[pairIdx].value;
                  }

                  break;

                case 2:
                  var leftOffset = 0;
                  var rightOffset = 0;

                  if (left >= s.leftTable.firstGlyph && left < s.leftTable.firstGlyph + s.leftTable.nGlyphs) {
                    leftOffset = s.leftTable.offsets[left - s.leftTable.firstGlyph];
                  } else {
                    leftOffset = s.array.off;
                  }

                  if (right >= s.rightTable.firstGlyph && right < s.rightTable.firstGlyph + s.rightTable.nGlyphs) {
                    rightOffset = s.rightTable.offsets[right - s.rightTable.firstGlyph];
                  }

                  var index = (leftOffset + rightOffset - s.array.off) / 2;
                  val = s.array.values.get(index);
                  break;

                case 3:
                  if (left >= s.glyphCount || right >= s.glyphCount) {
                    return 0;
                  }

                  val = s.kernValue[s.kernIndex[s.leftClass[left] * s.rightClassCount + s.rightClass[right]]];
                  break;

                default:
                  throw new Error('Unsupported kerning sub-table format '.concat(table.format));
              } // Microsoft supports the override flag, which resets the result
              // Otherwise, the sum of the results from all subtables is returned

              if (table.coverage.override) {
                res = val;
              } else {
                res += val;
              }
            }

            return res;
          };

          return KernProcessor;
        }());
        /**
 * This class is used when GPOS does not define 'mark' or 'mkmk' features
 * for positioning marks relative to base glyphs. It uses the unicode
 * combining class property to position marks.
 *
 * Based on code from Harfbuzz, thanks!
 * https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-fallback.cc
 */

        const UnicodeLayoutEngine = /* #__PURE__ */(function () {
          function UnicodeLayoutEngine(font) {
            this.font = font;
          }

          const _proto17 = UnicodeLayoutEngine.prototype;

          _proto17.positionGlyphs = function positionGlyphs(glyphs, positions) {
            // find each base + mark cluster, and position the marks relative to the base
            let clusterStart = 0;
            let clusterEnd = 0;

            for (let index = 0; index < glyphs.length; index++) {
              const glyph = glyphs[index];

              if (glyph.isMark) {
                // TODO: handle ligatures
                clusterEnd = index;
              } else {
                if (clusterStart !== clusterEnd) {
                  this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
                }

                clusterStart = clusterEnd = index;
              }
            }

            if (clusterStart !== clusterEnd) {
              this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
            }

            return positions;
          };

          _proto17.positionCluster = function positionCluster(glyphs, positions, clusterStart, clusterEnd) {
            const base = glyphs[clusterStart];
            const baseBox = base.cbox.copy(); // adjust bounding box for ligature glyphs

            if (base.codePoints.length > 1) {
              // LTR. TODO: RTL support.
              baseBox.minX += (base.codePoints.length - 1) * baseBox.width / base.codePoints.length;
            }

            let xOffset = -positions[clusterStart].xAdvance;
            let yOffset = 0;
            const yGap = this.font.unitsPerEm / 16; // position each of the mark glyphs relative to the base glyph

            for (let index = clusterStart + 1; index <= clusterEnd; index++) {
              const mark = glyphs[index];
              const markBox = mark.cbox;
              const position = positions[index];
              const combiningClass = this.getCombiningClass(mark.codePoints[0]);

              if (combiningClass !== 'Not_Reordered') {
                position.xOffset = position.yOffset = 0; // x positioning

                switch (combiningClass) {
                  case 'Double_Above':
                  case 'Double_Below':
                    // LTR. TODO: RTL support.
                    position.xOffset += baseBox.minX - markBox.width / 2 - markBox.minX;
                    break;

                  case 'Attached_Below_Left':
                  case 'Below_Left':
                  case 'Above_Left':
                    // left align
                    position.xOffset += baseBox.minX - markBox.minX;
                    break;

                  case 'Attached_Above_Right':
                  case 'Below_Right':
                  case 'Above_Right':
                    // right align
                    position.xOffset += baseBox.maxX - markBox.width - markBox.minX;
                    break;

                  default:
                    // Attached_Below, Attached_Above, Below, Above, other
                    // center align
                    position.xOffset += baseBox.minX + (baseBox.width - markBox.width) / 2 - markBox.minX;
                } // y positioning

                switch (combiningClass) {
                  case 'Double_Below':
                  case 'Below_Left':
                  case 'Below':
                  case 'Below_Right':
                  case 'Attached_Below_Left':
                  case 'Attached_Below':
                    // add a small gap between the glyphs if they are not attached
                    if (combiningClass === 'Attached_Below_Left' || combiningClass === 'Attached_Below') {
                      baseBox.minY += yGap;
                    }

                    position.yOffset = -baseBox.minY - markBox.maxY;
                    baseBox.minY += markBox.height;
                    break;

                  case 'Double_Above':
                  case 'Above_Left':
                  case 'Above':
                  case 'Above_Right':
                  case 'Attached_Above':
                  case 'Attached_Above_Right':
                    // add a small gap between the glyphs if they are not attached
                    if (combiningClass === 'Attached_Above' || combiningClass === 'Attached_Above_Right') {
                      baseBox.maxY += yGap;
                    }

                    position.yOffset = baseBox.maxY - markBox.minY;
                    baseBox.maxY += markBox.height;
                    break;
                }

                position.xAdvance = position.yAdvance = 0;
                position.xOffset += xOffset;
                position.yOffset += yOffset;
              } else {
                xOffset -= position.xAdvance;
                yOffset -= position.yAdvance;
              }
            }
          };

          _proto17.getCombiningClass = function getCombiningClass(codePoint) {
            const combiningClass = unicode.getCombiningClass(codePoint); // Thai / Lao need some per-character work

            if ((codePoint & ~0xff) === 0x0e00) {
              if (combiningClass === 'Not_Reordered') {
                switch (codePoint) {
                  case 0x0e31:
                  case 0x0e34:
                  case 0x0e35:
                  case 0x0e36:
                  case 0x0e37:
                  case 0x0e47:
                  case 0x0e4c:
                  case 0x0e3d:
                  case 0x0e4e:
                    return 'Above_Right';

                  case 0x0eb1:
                  case 0x0eb4:
                  case 0x0eb5:
                  case 0x0eb6:
                  case 0x0eb7:
                  case 0x0ebb:
                  case 0x0ecc:
                  case 0x0ecd:
                    return 'Above';

                  case 0x0ebc:
                    return 'Below';
                }
              } else if (codePoint === 0x0e3a) {
                // virama
                return 'Below_Right';
              }
            }

            switch (combiningClass) {
              // Hebrew
              case 'CCC10': // sheva

              case 'CCC11': // hataf segol

              case 'CCC12': // hataf patah

              case 'CCC13': // hataf qamats

              case 'CCC14': // hiriq

              case 'CCC15': // tsere

              case 'CCC16': // segol

              case 'CCC17': // patah

              case 'CCC18': // qamats

              case 'CCC20': // qubuts

              case 'CCC22':
                // meteg
                return 'Below';

              case 'CCC23':
                // rafe
                return 'Attached_Above';

              case 'CCC24':
                // shin dot
                return 'Above_Right';

              case 'CCC25': // sin dot

              case 'CCC19':
                // holam
                return 'Above_Left';

              case 'CCC26':
                // point varika
                return 'Above';

              case 'CCC21':
                // dagesh
                break;
                // Arabic and Syriac

              case 'CCC27': // fathatan

              case 'CCC28': // dammatan

              case 'CCC30': // fatha

              case 'CCC31': // damma

              case 'CCC33': // shadda

              case 'CCC34': // sukun

              case 'CCC35': // superscript alef

              case 'CCC36':
                // superscript alaph
                return 'Above';

              case 'CCC29': // kasratan

              case 'CCC32':
                // kasra
                return 'Below';
                // Thai

              case 'CCC103':
                // sara u / sara uu
                return 'Below_Right';

              case 'CCC107':
                // mai
                return 'Above_Right';
                // Lao

              case 'CCC118':
                // sign u / sign uu
                return 'Below';

              case 'CCC122':
                // mai
                return 'Above';
                // Tibetan

              case 'CCC129': // sign aa

              case 'CCC132':
                // sign u
                return 'Below';

              case 'CCC130':
                // sign i
                return 'Above';
            }

            return combiningClass;
          };

          return UnicodeLayoutEngine;
        }());
        /**
 * Represents a glyph bounding box
 */

        const BBox = /* #__PURE__ */(function () {
          function BBox(minX, minY, maxX, maxY) {
            if (minX === void 0) {
              minX = Infinity;
            }

            if (minY === void 0) {
              minY = Infinity;
            }

            if (maxX === void 0) {
              maxX = -Infinity;
            }

            if (maxY === void 0) {
              maxY = -Infinity;
            }

            /**
     * The minimum X position in the bounding box
     * @type {number}
     */
            this.minX = minX;
            /**
     * The minimum Y position in the bounding box
     * @type {number}
     */

            this.minY = minY;
            /**
     * The maxmimum X position in the bounding box
     * @type {number}
     */

            this.maxX = maxX;
            /**
     * The maxmimum Y position in the bounding box
     * @type {number}
     */

            this.maxY = maxY;
          }
          /**
   * The width of the bounding box
   * @type {number}
   */

          const _proto18 = BBox.prototype;

          _proto18.addPoint = function addPoint(x, y) {
            if (Math.abs(x) !== Infinity) {
              if (x < this.minX) {
                this.minX = x;
              }

              if (x > this.maxX) {
                this.maxX = x;
              }
            }

            if (Math.abs(y) !== Infinity) {
              if (y < this.minY) {
                this.minY = y;
              }

              if (y > this.maxY) {
                this.maxY = y;
              }
            }
          };

          _proto18.copy = function copy() {
            return new BBox(this.minX, this.minY, this.maxX, this.maxY);
          };

          _createClass(BBox, [{
            key: 'width',
            get: function get() {
              return this.maxX - this.minX;
            },
            /**
     * The height of the bounding box
     * @type {number}
     */

          }, {
            key: 'height',
            get: function get() {
              return this.maxY - this.minY;
            },
          }]);

          return BBox;
        }()); // Data from http://www.microsoft.com/typography/otspec/scripttags.htm
        // and http://www.unicode.org/Public/UNIDATA/PropertyValueAliases.txt.

        const UNICODE_SCRIPTS = {
          Caucasian_Albanian: 'aghb',
          Arabic: 'arab',
          Imperial_Aramaic: 'armi',
          Armenian: 'armn',
          Avestan: 'avst',
          Balinese: 'bali',
          Bamum: 'bamu',
          Bassa_Vah: 'bass',
          Batak: 'batk',
          Bengali: ['bng2', 'beng'],
          Bopomofo: 'bopo',
          Brahmi: 'brah',
          Braille: 'brai',
          Buginese: 'bugi',
          Buhid: 'buhd',
          Chakma: 'cakm',
          Canadian_Aboriginal: 'cans',
          Carian: 'cari',
          Cham: 'cham',
          Cherokee: 'cher',
          Coptic: 'copt',
          Cypriot: 'cprt',
          Cyrillic: 'cyrl',
          Devanagari: ['dev2', 'deva'],
          Deseret: 'dsrt',
          Duployan: 'dupl',
          Egyptian_Hieroglyphs: 'egyp',
          Elbasan: 'elba',
          Ethiopic: 'ethi',
          Georgian: 'geor',
          Glagolitic: 'glag',
          Gothic: 'goth',
          Grantha: 'gran',
          Greek: 'grek',
          Gujarati: ['gjr2', 'gujr'],
          Gurmukhi: ['gur2', 'guru'],
          Hangul: 'hang',
          Han: 'hani',
          Hanunoo: 'hano',
          Hebrew: 'hebr',
          Hiragana: 'hira',
          Pahawh_Hmong: 'hmng',
          Katakana_Or_Hiragana: 'hrkt',
          Old_Italic: 'ital',
          Javanese: 'java',
          Kayah_Li: 'kali',
          Katakana: 'kana',
          Kharoshthi: 'khar',
          Khmer: 'khmr',
          Khojki: 'khoj',
          Kannada: ['knd2', 'knda'],
          Kaithi: 'kthi',
          Tai_Tham: 'lana',
          Lao: 'lao ',
          Latin: 'latn',
          Lepcha: 'lepc',
          Limbu: 'limb',
          Linear_A: 'lina',
          Linear_B: 'linb',
          Lisu: 'lisu',
          Lycian: 'lyci',
          Lydian: 'lydi',
          Mahajani: 'mahj',
          Mandaic: 'mand',
          Manichaean: 'mani',
          Mende_Kikakui: 'mend',
          Meroitic_Cursive: 'merc',
          Meroitic_Hieroglyphs: 'mero',
          Malayalam: ['mlm2', 'mlym'],
          Modi: 'modi',
          Mongolian: 'mong',
          Mro: 'mroo',
          Meetei_Mayek: 'mtei',
          Myanmar: ['mym2', 'mymr'],
          Old_North_Arabian: 'narb',
          Nabataean: 'nbat',
          Nko: 'nko ',
          Ogham: 'ogam',
          Ol_Chiki: 'olck',
          Old_Turkic: 'orkh',
          Oriya: ['ory2', 'orya'],
          Osmanya: 'osma',
          Palmyrene: 'palm',
          Pau_Cin_Hau: 'pauc',
          Old_Permic: 'perm',
          Phags_Pa: 'phag',
          Inscriptional_Pahlavi: 'phli',
          Psalter_Pahlavi: 'phlp',
          Phoenician: 'phnx',
          Miao: 'plrd',
          Inscriptional_Parthian: 'prti',
          Rejang: 'rjng',
          Runic: 'runr',
          Samaritan: 'samr',
          Old_South_Arabian: 'sarb',
          Saurashtra: 'saur',
          Shavian: 'shaw',
          Sharada: 'shrd',
          Siddham: 'sidd',
          Khudawadi: 'sind',
          Sinhala: 'sinh',
          Sora_Sompeng: 'sora',
          Sundanese: 'sund',
          Syloti_Nagri: 'sylo',
          Syriac: 'syrc',
          Tagbanwa: 'tagb',
          Takri: 'takr',
          Tai_Le: 'tale',
          New_Tai_Lue: 'talu',
          Tamil: ['tml2', 'taml'],
          Tai_Viet: 'tavt',
          Telugu: ['tel2', 'telu'],
          Tifinagh: 'tfng',
          Tagalog: 'tglg',
          Thaana: 'thaa',
          Thai: 'thai',
          Tibetan: 'tibt',
          Tirhuta: 'tirh',
          Ugaritic: 'ugar',
          Vai: 'vai ',
          Warang_Citi: 'wara',
          Old_Persian: 'xpeo',
          Cuneiform: 'xsux',
          Yi: 'yi  ',
          Inherited: 'zinh',
          Common: 'zyyy',
          Unknown: 'zzzz',
        };
        const OPENTYPE_SCRIPTS = {};

        for (const script in UNICODE_SCRIPTS) {
          const tag = UNICODE_SCRIPTS[script];

          if (Array.isArray(tag)) {
            for (var _iterator17 = _createForOfIteratorHelperLoose(tag), _step17; !(_step17 = _iterator17()).done;) {
              const t = _step17.value;
              OPENTYPE_SCRIPTS[t] = script;
            }
          } else {
            OPENTYPE_SCRIPTS[tag] = script;
          }
        }

        function fromOpenType(tag) {
          return OPENTYPE_SCRIPTS[tag];
        }

        function forString(string) {
          const len = string.length;
          let idx = 0;

          while (idx < len) {
            let code = string.charCodeAt(idx++); // Check if this is a high surrogate

            if (code >= 0xd800 && code <= 0xdbff && idx < len) {
              const next = string.charCodeAt(idx); // Check if this is a low surrogate

              if (next >= 0xdc00 && next <= 0xdfff) {
                idx++;
                code = ((code & 0x3FF) << 10) + (next & 0x3FF) + 0x10000;
              }
            }

            const _script = unicode.getScript(code);

            if (_script !== 'Common' && _script !== 'Inherited' && _script !== 'Unknown') {
              return UNICODE_SCRIPTS[_script];
            }
          }

          return UNICODE_SCRIPTS.Unknown;
        }

        function forCodePoints(codePoints) {
          for (let i = 0; i < codePoints.length; i++) {
            const codePoint = codePoints[i];

            const _script2 = unicode.getScript(codePoint);

            if (_script2 !== 'Common' && _script2 !== 'Inherited' && _script2 !== 'Unknown') {
              return UNICODE_SCRIPTS[_script2];
            }
          }

          return UNICODE_SCRIPTS.Unknown;
        } // The scripts in this map are written from right to left

        const RTL = {
          arab: true,
          // Arabic
          hebr: true,
          // Hebrew
          syrc: true,
          // Syriac
          thaa: true,
          // Thaana
          cprt: true,
          // Cypriot Syllabary
          khar: true,
          // Kharosthi
          phnx: true,
          // Phoenician
          'nko ': true,
          // N'Ko
          lydi: true,
          // Lydian
          avst: true,
          // Avestan
          armi: true,
          // Imperial Aramaic
          phli: true,
          // Inscriptional Pahlavi
          prti: true,
          // Inscriptional Parthian
          sarb: true,
          // Old South Arabian
          orkh: true,
          // Old Turkic, Orkhon Runic
          samr: true,
          // Samaritan
          mand: true,
          // Mandaic, Mandaean
          merc: true,
          // Meroitic Cursive
          mero: true,
          // Meroitic Hieroglyphs
          // Unicode 7.0 (not listed on http://www.microsoft.com/typography/otspec/scripttags.htm)
          mani: true,
          // Manichaean
          mend: true,
          // Mende Kikakui
          nbat: true,
          // Nabataean
          narb: true,
          // Old North Arabian
          palm: true,
          // Palmyrene
          phlp: true, // Psalter Pahlavi

        };

        function direction(script) {
          if (RTL[script]) {
            return 'rtl';
          }

          return 'ltr';
        }
        /**
 * Represents a run of Glyph and GlyphPosition objects.
 * Returned by the font layout method.
 */

        const GlyphRun = /* #__PURE__ */(function () {
          function GlyphRun(glyphs, features, script, language, direction$1) {
            /**
     * An array of Glyph objects in the run
     * @type {Glyph[]}
     */
            this.glyphs = glyphs;
            /**
     * An array of GlyphPosition objects for each glyph in the run
     * @type {GlyphPosition[]}
     */

            this.positions = null;
            /**
     * The script that was requested for shaping. This was either passed in or detected automatically.
     * @type {string}
     */

            this.script = script;
            /**
     * The language requested for shaping, as passed in. If `null`, the default language for the
     * script was used.
     * @type {string}
     */

            this.language = language || null;
            /**
     * The direction requested for shaping, as passed in (either ltr or rtl).
     * If `null`, the default direction of the script is used.
     * @type {string}
     */

            this.direction = direction$1 || direction(script);
            /**
     * The features requested during shaping. This is a combination of user
     * specified features and features chosen by the shaper.
     * @type {object}
     */

            this.features = {}; // Convert features to an object

            if (Array.isArray(features)) {
              for (var _iterator18 = _createForOfIteratorHelperLoose(features), _step18; !(_step18 = _iterator18()).done;) {
                const tag = _step18.value;
                this.features[tag] = true;
              }
            } else if (typeof features === 'object') {
              this.features = features;
            }
          }
          /**
   * The total advance width of the run.
   * @type {number}
   */

          _createClass(GlyphRun, [{
            key: 'advanceWidth',
            get: function get() {
              let width = 0;

              for (var _iterator19 = _createForOfIteratorHelperLoose(this.positions), _step19; !(_step19 = _iterator19()).done;) {
                const position = _step19.value;
                width += position.xAdvance;
              }

              return width;
            },
            /**
     * The total advance height of the run.
     * @type {number}
     */

          }, {
            key: 'advanceHeight',
            get: function get() {
              let height = 0;

              for (var _iterator20 = _createForOfIteratorHelperLoose(this.positions), _step20; !(_step20 = _iterator20()).done;) {
                const position = _step20.value;
                height += position.yAdvance;
              }

              return height;
            },
            /**
     * The bounding box containing all glyphs in the run.
     * @type {BBox}
     */

          }, {
            key: 'bbox',
            get: function get() {
              const bbox = new BBox();
              let x = 0;
              let y = 0;

              for (let index = 0; index < this.glyphs.length; index++) {
                const glyph = this.glyphs[index];
                const p = this.positions[index];
                const b = glyph.bbox;
                bbox.addPoint(b.minX + x + p.xOffset, b.minY + y + p.yOffset);
                bbox.addPoint(b.maxX + x + p.xOffset, b.maxY + y + p.yOffset);
                x += p.xAdvance;
                y += p.yAdvance;
              }

              return bbox;
            },
          }]);

          return GlyphRun;
        }());
        /**
 * Represents positioning information for a glyph in a GlyphRun.
 */

        const GlyphPosition = function GlyphPosition(xAdvance, yAdvance, xOffset, yOffset) {
          if (xAdvance === void 0) {
            xAdvance = 0;
          }

          if (yAdvance === void 0) {
            yAdvance = 0;
          }

          if (xOffset === void 0) {
            xOffset = 0;
          }

          if (yOffset === void 0) {
            yOffset = 0;
          }

          /**
   * The amount to move the virtual pen in the X direction after rendering this glyph.
   * @type {number}
   */
          this.xAdvance = xAdvance;
          /**
   * The amount to move the virtual pen in the Y direction after rendering this glyph.
   * @type {number}
   */

          this.yAdvance = yAdvance;
          /**
   * The offset from the pen position in the X direction at which to render this glyph.
   * @type {number}
   */

          this.xOffset = xOffset;
          /**
   * The offset from the pen position in the Y direction at which to render this glyph.
   * @type {number}
   */

          this.yOffset = yOffset;
        }; // see https://developer.apple.com/fonts/TrueType-Reference-Manual/RM09/AppendixF.html
        // and /System/Library/Frameworks/CoreText.framework/Versions/A/Headers/SFNTLayoutTypes.h on a Mac

        const features = {
          allTypographicFeatures: {
            code: 0,
            exclusive: false,
            allTypeFeatures: 0,
          },
          ligatures: {
            code: 1,
            exclusive: false,
            requiredLigatures: 0,
            commonLigatures: 2,
            rareLigatures: 4,
            // logos: 6
            rebusPictures: 8,
            diphthongLigatures: 10,
            squaredLigatures: 12,
            abbrevSquaredLigatures: 14,
            symbolLigatures: 16,
            contextualLigatures: 18,
            historicalLigatures: 20,
          },
          cursiveConnection: {
            code: 2,
            exclusive: true,
            unconnected: 0,
            partiallyConnected: 1,
            cursive: 2,
          },
          letterCase: {
            code: 3,
            exclusive: true,
          },
          // upperAndLowerCase: 0          # deprecated
          // allCaps: 1                    # deprecated
          // allLowerCase: 2               # deprecated
          // smallCaps: 3                  # deprecated
          // initialCaps: 4                # deprecated
          // initialCapsAndSmallCaps: 5    # deprecated
          verticalSubstitution: {
            code: 4,
            exclusive: false,
            substituteVerticalForms: 0,
          },
          linguisticRearrangement: {
            code: 5,
            exclusive: false,
            linguisticRearrangement: 0,
          },
          numberSpacing: {
            code: 6,
            exclusive: true,
            monospacedNumbers: 0,
            proportionalNumbers: 1,
            thirdWidthNumbers: 2,
            quarterWidthNumbers: 3,
          },
          smartSwash: {
            code: 8,
            exclusive: false,
            wordInitialSwashes: 0,
            wordFinalSwashes: 2,
            // lineInitialSwashes: 4
            // lineFinalSwashes: 6
            nonFinalSwashes: 8,
          },
          diacritics: {
            code: 9,
            exclusive: true,
            showDiacritics: 0,
            hideDiacritics: 1,
            decomposeDiacritics: 2,
          },
          verticalPosition: {
            code: 10,
            exclusive: true,
            normalPosition: 0,
            superiors: 1,
            inferiors: 2,
            ordinals: 3,
            scientificInferiors: 4,
          },
          fractions: {
            code: 11,
            exclusive: true,
            noFractions: 0,
            verticalFractions: 1,
            diagonalFractions: 2,
          },
          overlappingCharacters: {
            code: 13,
            exclusive: false,
            preventOverlap: 0,
          },
          typographicExtras: {
            code: 14,
            exclusive: false,
            // hyphensToEmDash: 0
            // hyphenToEnDash: 2
            slashedZero: 4,
          },
          // formInterrobang: 6
          // smartQuotes: 8
          // periodsToEllipsis: 10
          mathematicalExtras: {
            code: 15,
            exclusive: false,
            // hyphenToMinus: 0
            // asteristoMultiply: 2
            // slashToDivide: 4
            // inequalityLigatures: 6
            // exponents: 8
            mathematicalGreek: 10,
          },
          ornamentSets: {
            code: 16,
            exclusive: true,
            noOrnaments: 0,
            dingbats: 1,
            piCharacters: 2,
            fleurons: 3,
            decorativeBorders: 4,
            internationalSymbols: 5,
            mathSymbols: 6,
          },
          characterAlternatives: {
            code: 17,
            exclusive: true,
            noAlternates: 0,
          },
          // user defined options
          designComplexity: {
            code: 18,
            exclusive: true,
            designLevel1: 0,
            designLevel2: 1,
            designLevel3: 2,
            designLevel4: 3,
            designLevel5: 4,
          },
          styleOptions: {
            code: 19,
            exclusive: true,
            noStyleOptions: 0,
            displayText: 1,
            engravedText: 2,
            illuminatedCaps: 3,
            titlingCaps: 4,
            tallCaps: 5,
          },
          characterShape: {
            code: 20,
            exclusive: true,
            traditionalCharacters: 0,
            simplifiedCharacters: 1,
            JIS1978Characters: 2,
            JIS1983Characters: 3,
            JIS1990Characters: 4,
            traditionalAltOne: 5,
            traditionalAltTwo: 6,
            traditionalAltThree: 7,
            traditionalAltFour: 8,
            traditionalAltFive: 9,
            expertCharacters: 10,
            JIS2004Characters: 11,
            hojoCharacters: 12,
            NLCCharacters: 13,
            traditionalNamesCharacters: 14,
          },
          numberCase: {
            code: 21,
            exclusive: true,
            lowerCaseNumbers: 0,
            upperCaseNumbers: 1,
          },
          textSpacing: {
            code: 22,
            exclusive: true,
            proportionalText: 0,
            monospacedText: 1,
            halfWidthText: 2,
            thirdWidthText: 3,
            quarterWidthText: 4,
            altProportionalText: 5,
            altHalfWidthText: 6,
          },
          transliteration: {
            code: 23,
            exclusive: true,
            noTransliteration: 0,
          },
          // hanjaToHangul: 1
          // hiraganaToKatakana: 2
          // katakanaToHiragana: 3
          // kanaToRomanization: 4
          // romanizationToHiragana: 5
          // romanizationToKatakana: 6
          // hanjaToHangulAltOne: 7
          // hanjaToHangulAltTwo: 8
          // hanjaToHangulAltThree: 9
          annotation: {
            code: 24,
            exclusive: true,
            noAnnotation: 0,
            boxAnnotation: 1,
            roundedBoxAnnotation: 2,
            circleAnnotation: 3,
            invertedCircleAnnotation: 4,
            parenthesisAnnotation: 5,
            periodAnnotation: 6,
            romanNumeralAnnotation: 7,
            diamondAnnotation: 8,
            invertedBoxAnnotation: 9,
            invertedRoundedBoxAnnotation: 10,
          },
          kanaSpacing: {
            code: 25,
            exclusive: true,
            fullWidthKana: 0,
            proportionalKana: 1,
          },
          ideographicSpacing: {
            code: 26,
            exclusive: true,
            fullWidthIdeographs: 0,
            proportionalIdeographs: 1,
            halfWidthIdeographs: 2,
          },
          unicodeDecomposition: {
            code: 27,
            exclusive: false,
            canonicalComposition: 0,
            compatibilityComposition: 2,
            transcodingComposition: 4,
          },
          rubyKana: {
            code: 28,
            exclusive: false,
            // noRubyKana: 0     # deprecated - use rubyKanaOff instead
            // rubyKana: 1     # deprecated - use rubyKanaOn instead
            rubyKana: 2,
          },
          CJKSymbolAlternatives: {
            code: 29,
            exclusive: true,
            noCJKSymbolAlternatives: 0,
            CJKSymbolAltOne: 1,
            CJKSymbolAltTwo: 2,
            CJKSymbolAltThree: 3,
            CJKSymbolAltFour: 4,
            CJKSymbolAltFive: 5,
          },
          ideographicAlternatives: {
            code: 30,
            exclusive: true,
            noIdeographicAlternatives: 0,
            ideographicAltOne: 1,
            ideographicAltTwo: 2,
            ideographicAltThree: 3,
            ideographicAltFour: 4,
            ideographicAltFive: 5,
          },
          CJKVerticalRomanPlacement: {
            code: 31,
            exclusive: true,
            CJKVerticalRomanCentered: 0,
            CJKVerticalRomanHBaseline: 1,
          },
          italicCJKRoman: {
            code: 32,
            exclusive: false,
            // noCJKItalicRoman: 0     # deprecated - use CJKItalicRomanOff instead
            // CJKItalicRoman: 1     # deprecated - use CJKItalicRomanOn instead
            CJKItalicRoman: 2,
          },
          caseSensitiveLayout: {
            code: 33,
            exclusive: false,
            caseSensitiveLayout: 0,
            caseSensitiveSpacing: 2,
          },
          alternateKana: {
            code: 34,
            exclusive: false,
            alternateHorizKana: 0,
            alternateVertKana: 2,
          },
          stylisticAlternatives: {
            code: 35,
            exclusive: false,
            noStylisticAlternates: 0,
            stylisticAltOne: 2,
            stylisticAltTwo: 4,
            stylisticAltThree: 6,
            stylisticAltFour: 8,
            stylisticAltFive: 10,
            stylisticAltSix: 12,
            stylisticAltSeven: 14,
            stylisticAltEight: 16,
            stylisticAltNine: 18,
            stylisticAltTen: 20,
            stylisticAltEleven: 22,
            stylisticAltTwelve: 24,
            stylisticAltThirteen: 26,
            stylisticAltFourteen: 28,
            stylisticAltFifteen: 30,
            stylisticAltSixteen: 32,
            stylisticAltSeventeen: 34,
            stylisticAltEighteen: 36,
            stylisticAltNineteen: 38,
            stylisticAltTwenty: 40,
          },
          contextualAlternates: {
            code: 36,
            exclusive: false,
            contextualAlternates: 0,
            swashAlternates: 2,
            contextualSwashAlternates: 4,
          },
          lowerCase: {
            code: 37,
            exclusive: true,
            defaultLowerCase: 0,
            lowerCaseSmallCaps: 1,
            lowerCasePetiteCaps: 2,
          },
          upperCase: {
            code: 38,
            exclusive: true,
            defaultUpperCase: 0,
            upperCaseSmallCaps: 1,
            upperCasePetiteCaps: 2,
          },
          languageTag: {
            // indices into ltag table
            code: 39,
            exclusive: true,
          },
          CJKRomanSpacing: {
            code: 103,
            exclusive: true,
            halfWidthCJKRoman: 0,
            proportionalCJKRoman: 1,
            defaultCJKRoman: 2,
            fullWidthCJKRoman: 3,
          },
        };

        const feature = function feature(name, selector) {
          return [features[name].code, features[name][selector]];
        };

        const OTMapping = {
          rlig: feature('ligatures', 'requiredLigatures'),
          clig: feature('ligatures', 'contextualLigatures'),
          dlig: feature('ligatures', 'rareLigatures'),
          hlig: feature('ligatures', 'historicalLigatures'),
          liga: feature('ligatures', 'commonLigatures'),
          hist: feature('ligatures', 'historicalLigatures'),
          // ??
          smcp: feature('lowerCase', 'lowerCaseSmallCaps'),
          pcap: feature('lowerCase', 'lowerCasePetiteCaps'),
          frac: feature('fractions', 'diagonalFractions'),
          dnom: feature('fractions', 'diagonalFractions'),
          // ??
          numr: feature('fractions', 'diagonalFractions'),
          // ??
          afrc: feature('fractions', 'verticalFractions'),
          // aalt
          // abvf, abvm, abvs, akhn, blwf, blwm, blws, cfar, cjct, cpsp, falt, isol, jalt, ljmo, mset?
          // ltra, ltrm, nukt, pref, pres, pstf, psts, rand, rkrf, rphf, rtla, rtlm, size, tjmo, tnum?
          // unic, vatu, vhal, vjmo, vpal, vrt2
          // dist -> trak table?
          // kern, vkrn -> kern table
          // lfbd + opbd + rtbd -> opbd table?
          // mark, mkmk -> acnt table?
          // locl -> languageTag + ltag table
          case: feature('caseSensitiveLayout', 'caseSensitiveLayout'),
          // also caseSensitiveSpacing
          ccmp: feature('unicodeDecomposition', 'canonicalComposition'),
          // compatibilityComposition?
          cpct: feature('CJKVerticalRomanPlacement', 'CJKVerticalRomanCentered'),
          // guess..., probably not given below
          valt: feature('CJKVerticalRomanPlacement', 'CJKVerticalRomanCentered'),
          swsh: feature('contextualAlternates', 'swashAlternates'),
          cswh: feature('contextualAlternates', 'contextualSwashAlternates'),
          curs: feature('cursiveConnection', 'cursive'),
          // ??
          c2pc: feature('upperCase', 'upperCasePetiteCaps'),
          c2sc: feature('upperCase', 'upperCaseSmallCaps'),
          init: feature('smartSwash', 'wordInitialSwashes'),
          // ??
          fin2: feature('smartSwash', 'wordFinalSwashes'),
          // ??
          medi: feature('smartSwash', 'nonFinalSwashes'),
          // ??
          med2: feature('smartSwash', 'nonFinalSwashes'),
          // ??
          fin3: feature('smartSwash', 'wordFinalSwashes'),
          // ??
          fina: feature('smartSwash', 'wordFinalSwashes'),
          // ??
          pkna: feature('kanaSpacing', 'proportionalKana'),
          half: feature('textSpacing', 'halfWidthText'),
          // also HalfWidthCJKRoman, HalfWidthIdeographs?
          halt: feature('textSpacing', 'altHalfWidthText'),
          hkna: feature('alternateKana', 'alternateHorizKana'),
          vkna: feature('alternateKana', 'alternateVertKana'),
          // hngl: feature 'transliteration', 'hanjaToHangulSelector' # deprecated
          ital: feature('italicCJKRoman', 'CJKItalicRoman'),
          lnum: feature('numberCase', 'upperCaseNumbers'),
          onum: feature('numberCase', 'lowerCaseNumbers'),
          mgrk: feature('mathematicalExtras', 'mathematicalGreek'),
          // nalt: not enough info. what type of annotation?
          // ornm: ditto, which ornament style?
          calt: feature('contextualAlternates', 'contextualAlternates'),
          // or more?
          vrt2: feature('verticalSubstitution', 'substituteVerticalForms'),
          // oh... below?
          vert: feature('verticalSubstitution', 'substituteVerticalForms'),
          tnum: feature('numberSpacing', 'monospacedNumbers'),
          pnum: feature('numberSpacing', 'proportionalNumbers'),
          sups: feature('verticalPosition', 'superiors'),
          subs: feature('verticalPosition', 'inferiors'),
          ordn: feature('verticalPosition', 'ordinals'),
          pwid: feature('textSpacing', 'proportionalText'),
          hwid: feature('textSpacing', 'halfWidthText'),
          qwid: feature('textSpacing', 'quarterWidthText'),
          // also QuarterWidthNumbers?
          twid: feature('textSpacing', 'thirdWidthText'),
          // also ThirdWidthNumbers?
          fwid: feature('textSpacing', 'proportionalText'),
          // ??
          palt: feature('textSpacing', 'altProportionalText'),
          trad: feature('characterShape', 'traditionalCharacters'),
          smpl: feature('characterShape', 'simplifiedCharacters'),
          jp78: feature('characterShape', 'JIS1978Characters'),
          jp83: feature('characterShape', 'JIS1983Characters'),
          jp90: feature('characterShape', 'JIS1990Characters'),
          jp04: feature('characterShape', 'JIS2004Characters'),
          expt: feature('characterShape', 'expertCharacters'),
          hojo: feature('characterShape', 'hojoCharacters'),
          nlck: feature('characterShape', 'NLCCharacters'),
          tnam: feature('characterShape', 'traditionalNamesCharacters'),
          ruby: feature('rubyKana', 'rubyKana'),
          titl: feature('styleOptions', 'titlingCaps'),
          zero: feature('typographicExtras', 'slashedZero'),
          ss01: feature('stylisticAlternatives', 'stylisticAltOne'),
          ss02: feature('stylisticAlternatives', 'stylisticAltTwo'),
          ss03: feature('stylisticAlternatives', 'stylisticAltThree'),
          ss04: feature('stylisticAlternatives', 'stylisticAltFour'),
          ss05: feature('stylisticAlternatives', 'stylisticAltFive'),
          ss06: feature('stylisticAlternatives', 'stylisticAltSix'),
          ss07: feature('stylisticAlternatives', 'stylisticAltSeven'),
          ss08: feature('stylisticAlternatives', 'stylisticAltEight'),
          ss09: feature('stylisticAlternatives', 'stylisticAltNine'),
          ss10: feature('stylisticAlternatives', 'stylisticAltTen'),
          ss11: feature('stylisticAlternatives', 'stylisticAltEleven'),
          ss12: feature('stylisticAlternatives', 'stylisticAltTwelve'),
          ss13: feature('stylisticAlternatives', 'stylisticAltThirteen'),
          ss14: feature('stylisticAlternatives', 'stylisticAltFourteen'),
          ss15: feature('stylisticAlternatives', 'stylisticAltFifteen'),
          ss16: feature('stylisticAlternatives', 'stylisticAltSixteen'),
          ss17: feature('stylisticAlternatives', 'stylisticAltSeventeen'),
          ss18: feature('stylisticAlternatives', 'stylisticAltEighteen'),
          ss19: feature('stylisticAlternatives', 'stylisticAltNineteen'),
          ss20: feature('stylisticAlternatives', 'stylisticAltTwenty'),
        }; // salt: feature 'stylisticAlternatives', 'stylisticAltOne' # hmm, which one to choose
        // Add cv01-cv99 features

        for (let i = 1; i <= 99; i++) {
          OTMapping['cv'.concat('00'.concat(i).slice(-2))] = [features.characterAlternatives.code, i];
        } // create inverse mapping

        const AATMapping = {};

        for (const ot in OTMapping) {
          const aat = OTMapping[ot];

          if (AATMapping[aat[0]] == null) {
            AATMapping[aat[0]] = {};
          }

          AATMapping[aat[0]][aat[1]] = ot;
        } // Maps an array of OpenType features to AAT features
        // in the form of {featureType:{featureSetting:true}}

        function mapOTToAAT(features) {
          const res = {};

          for (const k in features) {
            let r = void 0;

            if (r = OTMapping[k]) {
              if (res[r[0]] == null) {
                res[r[0]] = {};
              }

              res[r[0]][r[1]] = features[k];
            }
          }

          return res;
        } // Maps strings in a [featureType, featureSetting]
        // to their equivalent number codes

        function mapFeatureStrings(f) {
          const type = f[0];
          const setting = f[1];

          if (isNaN(type)) {
            var typeCode = features[type] && features[type].code;
          } else {
            var typeCode = type;
          }

          if (isNaN(setting)) {
            var settingCode = features[type] && features[type][setting];
          } else {
            var settingCode = setting;
          }

          return [typeCode, settingCode];
        } // Maps AAT features to an array of OpenType features
        // Supports both arrays in the form of [[featureType, featureSetting]]
        // and objects in the form of {featureType:{featureSetting:true}}
        // featureTypes and featureSettings can be either strings or number codes

        function mapAATToOT(features) {
          const res = {};

          if (Array.isArray(features)) {
            for (let k = 0; k < features.length; k++) {
              let r = void 0;
              const f = mapFeatureStrings(features[k]);

              if (r = AATMapping[f[0]] && AATMapping[f[0]][f[1]]) {
                res[r] = true;
              }
            }
          } else if (typeof features === 'object') {
            for (const type in features) {
              const _feature = features[type];

              for (const setting in _feature) {
                let _r = void 0;

                const _f = mapFeatureStrings([type, setting]);

                if (_feature[setting] && (_r = AATMapping[_f[0]] && AATMapping[_f[0]][_f[1]])) {
                  res[_r] = true;
                }
              }
            }
          }

          return Object.keys(res);
        }

        let _class$1;

        const AATLookupTable = (_class$1 = /* #__PURE__ */(function () {
          function AATLookupTable(table) {
            this.table = table;
          }

          const _proto19 = AATLookupTable.prototype;

          _proto19.lookup = function lookup(glyph) {
            switch (this.table.version) {
              case 0:
                // simple array format
                return this.table.values.getItem(glyph);

              case 2: // segment format

              case 4:
              {
                let min = 0;
                let max = this.table.binarySearchHeader.nUnits - 1;

                while (min <= max) {
                  var mid = min + max >> 1;
                  var seg = this.table.segments[mid]; // special end of search value

                  if (seg.firstGlyph === 0xffff) {
                    return null;
                  }

                  if (glyph < seg.firstGlyph) {
                    max = mid - 1;
                  } else if (glyph > seg.lastGlyph) {
                    min = mid + 1;
                  } else {
                    if (this.table.version === 2) {
                      return seg.value;
                    }
                    return seg.values[glyph - seg.firstGlyph];
                  }
                }

                return null;
              }

              case 6:
              {
                // lookup single
                let _min = 0;

                let _max = this.table.binarySearchHeader.nUnits - 1;

                while (_min <= _max) {
                  var mid = _min + _max >> 1;
                  var seg = this.table.segments[mid]; // special end of search value

                  if (seg.glyph === 0xffff) {
                    return null;
                  }

                  if (glyph < seg.glyph) {
                    _max = mid - 1;
                  } else if (glyph > seg.glyph) {
                    _min = mid + 1;
                  } else {
                    return seg.value;
                  }
                }

                return null;
              }

              case 8:
                // lookup trimmed
                return this.table.values[glyph - this.table.firstGlyph];

              default:
                throw new Error('Unknown lookup table format: '.concat(this.table.version));
            }
          };

          _proto19.glyphsForValue = function glyphsForValue(classValue) {
            const res = [];

            switch (this.table.version) {
              case 2: // segment format

              case 4:
              {
                for (var _iterator21 = _createForOfIteratorHelperLoose(this.table.segments), _step21; !(_step21 = _iterator21()).done;) {
                  const segment = _step21.value;

                  if (this.table.version === 2 && segment.value === classValue) {
                    res.push.apply(res, range(segment.firstGlyph, segment.lastGlyph + 1));
                  } else {
                    for (let index = 0; index < segment.values.length; index++) {
                      if (segment.values[index] === classValue) {
                        res.push(segment.firstGlyph + index);
                      }
                    }
                  }
                }

                break;
              }

              case 6:
              {
                // lookup single
                for (var _iterator22 = _createForOfIteratorHelperLoose(this.table.segments), _step22; !(_step22 = _iterator22()).done;) {
                  const _segment = _step22.value;

                  if (_segment.value === classValue) {
                    res.push(_segment.glyph);
                  }
                }

                break;
              }

              case 8:
              {
                // lookup trimmed
                for (let i = 0; i < this.table.values.length; i++) {
                  if (this.table.values[i] === classValue) {
                    res.push(this.table.firstGlyph + i);
                  }
                }

                break;
              }

              default:
                throw new Error('Unknown lookup table format: '.concat(this.table.version));
            }

            return res;
          };

          return AATLookupTable;
        }()), _applyDecoratedDescriptor(_class$1.prototype, 'glyphsForValue', [cache], Object.getOwnPropertyDescriptor(_class$1.prototype, 'glyphsForValue'), _class$1.prototype), _class$1);
        const START_OF_TEXT_STATE = 0;
        const END_OF_TEXT_CLASS = 0;
        const OUT_OF_BOUNDS_CLASS = 1;
        const DELETED_GLYPH_CLASS = 2;
        const DONT_ADVANCE = 0x4000;

        const AATStateMachine = /* #__PURE__ */(function () {
          function AATStateMachine(stateTable) {
            this.stateTable = stateTable;
            this.lookupTable = new AATLookupTable(stateTable.classTable);
          }

          const _proto20 = AATStateMachine.prototype;

          _proto20.process = function process(glyphs, reverse, processEntry) {
            let currentState = START_OF_TEXT_STATE; // START_OF_LINE_STATE is used for kashida glyph insertions sometimes I think?

            let index = reverse ? glyphs.length - 1 : 0;
            const dir = reverse ? -1 : 1;

            while (dir === 1 && index <= glyphs.length || dir === -1 && index >= -1) {
              let glyph = null;
              let classCode = OUT_OF_BOUNDS_CLASS;
              let shouldAdvance = true;

              if (index === glyphs.length || index === -1) {
                classCode = END_OF_TEXT_CLASS;
              } else {
                glyph = glyphs[index];

                if (glyph.id === 0xffff) {
                  // deleted glyph
                  classCode = DELETED_GLYPH_CLASS;
                } else {
                  classCode = this.lookupTable.lookup(glyph.id);

                  if (classCode == null) {
                    classCode = OUT_OF_BOUNDS_CLASS;
                  }
                }
              }

              const row = this.stateTable.stateArray.getItem(currentState);
              const entryIndex = row[classCode];
              const entry = this.stateTable.entryTable.getItem(entryIndex);

              if (classCode !== END_OF_TEXT_CLASS && classCode !== DELETED_GLYPH_CLASS) {
                processEntry(glyph, entry, index);
                shouldAdvance = !(entry.flags & DONT_ADVANCE);
              }

              currentState = entry.newState;

              if (shouldAdvance) {
                index += dir;
              }
            }

            return glyphs;
          }
          /**
   * Performs a depth-first traversal of the glyph strings
   * represented by the state machine.
   */
          ;

          _proto20.traverse = function traverse(opts, state, visited) {
            if (state === void 0) {
              state = 0;
            }

            if (visited === void 0) {
              visited = new Set();
            }

            if (visited.has(state)) {
              return;
            }

            visited.add(state);
            const _this$stateTable = this.stateTable;
            const { nClasses } = _this$stateTable;
            const { stateArray } = _this$stateTable;
            const { entryTable } = _this$stateTable;
            const row = stateArray.getItem(state); // Skip predefined classes

            for (let classCode = 4; classCode < nClasses; classCode++) {
              const entryIndex = row[classCode];
              const entry = entryTable.getItem(entryIndex); // Try all glyphs in the class

              for (var _iterator23 = _createForOfIteratorHelperLoose(this.lookupTable.glyphsForValue(classCode)), _step23; !(_step23 = _iterator23()).done;) {
                const glyph = _step23.value;

                if (opts.enter) {
                  opts.enter(glyph, entry);
                }

                if (entry.newState !== 0) {
                  this.traverse(opts, entry.newState, visited);
                }

                if (opts.exit) {
                  opts.exit(glyph, entry);
                }
              }
            }
          };

          return AATStateMachine;
        }());

        let _class$2;

        const MARK_FIRST = 0x8000;
        const MARK_LAST = 0x2000;
        const VERB = 0x000F; // contextual substitution and glyph insertion flag

        const SET_MARK = 0x8000; // ligature entry flags

        const SET_COMPONENT = 0x8000;
        const PERFORM_ACTION = 0x2000; // ligature action masks

        const LAST_MASK = 0x80000000;
        const STORE_MASK = 0x40000000;
        const OFFSET_MASK = 0x3FFFFFFF;
        const REVERSE_DIRECTION = 0x400000;
        const CURRENT_INSERT_BEFORE = 0x0800;
        const MARKED_INSERT_BEFORE = 0x0400;
        const CURRENT_INSERT_COUNT = 0x03E0;
        const MARKED_INSERT_COUNT = 0x001F;
        const AATMorxProcessor = (_class$2 = /* #__PURE__ */(function () {
          function AATMorxProcessor(font) {
            this.processIndicRearragement = this.processIndicRearragement.bind(this);
            this.processContextualSubstitution = this.processContextualSubstitution.bind(this);
            this.processLigature = this.processLigature.bind(this);
            this.processNoncontextualSubstitutions = this.processNoncontextualSubstitutions.bind(this);
            this.processGlyphInsertion = this.processGlyphInsertion.bind(this);
            this.font = font;
            this.morx = font.morx;
            this.inputCache = null;
          } // Processes an array of glyphs and applies the specified features
          // Features should be in the form of {featureType:{featureSetting:boolean}}

          const _proto21 = AATMorxProcessor.prototype;

          _proto21.process = function process(glyphs, features) {
            if (features === void 0) {
              features = {};
            }

            for (var _iterator24 = _createForOfIteratorHelperLoose(this.morx.chains), _step24; !(_step24 = _iterator24()).done;) {
              const chain = _step24.value;
              let flags = chain.defaultFlags; // enable/disable the requested features

              for (var _iterator25 = _createForOfIteratorHelperLoose(chain.features), _step25; !(_step25 = _iterator25()).done;) {
                const feature = _step25.value;
                let f = void 0;

                if (f = features[feature.featureType]) {
                  if (f[feature.featureSetting]) {
                    flags &= feature.disableFlags;
                    flags |= feature.enableFlags;
                  } else if (f[feature.featureSetting] === false) {
                    flags |= ~feature.disableFlags;
                    flags &= ~feature.enableFlags;
                  }
                }
              }

              for (var _iterator26 = _createForOfIteratorHelperLoose(chain.subtables), _step26; !(_step26 = _iterator26()).done;) {
                const subtable = _step26.value;

                if (subtable.subFeatureFlags & flags) {
                  this.processSubtable(subtable, glyphs);
                }
              }
            } // remove deleted glyphs

            let index = glyphs.length - 1;

            while (index >= 0) {
              if (glyphs[index].id === 0xffff) {
                glyphs.splice(index, 1);
              }

              index--;
            }

            return glyphs;
          };

          _proto21.processSubtable = function processSubtable(subtable, glyphs) {
            this.subtable = subtable;
            this.glyphs = glyphs;

            if (this.subtable.type === 4) {
              this.processNoncontextualSubstitutions(this.subtable, this.glyphs);
              return;
            }

            this.ligatureStack = [];
            this.markedGlyph = null;
            this.firstGlyph = null;
            this.lastGlyph = null;
            this.markedIndex = null;
            const stateMachine = this.getStateMachine(subtable);
            const process = this.getProcessor();
            const reverse = !!(this.subtable.coverage & REVERSE_DIRECTION);
            return stateMachine.process(this.glyphs, reverse, process);
          };

          _proto21.getStateMachine = function getStateMachine(subtable) {
            return new AATStateMachine(subtable.table.stateTable);
          };

          _proto21.getProcessor = function getProcessor() {
            switch (this.subtable.type) {
              case 0:
                return this.processIndicRearragement;

              case 1:
                return this.processContextualSubstitution;

              case 2:
                return this.processLigature;

              case 4:
                return this.processNoncontextualSubstitutions;

              case 5:
                return this.processGlyphInsertion;

              default:
                throw new Error('Invalid morx subtable type: '.concat(this.subtable.type));
            }
          };

          _proto21.processIndicRearragement = function processIndicRearragement(glyph, entry, index) {
            if (entry.flags & MARK_FIRST) {
              this.firstGlyph = index;
            }

            if (entry.flags & MARK_LAST) {
              this.lastGlyph = index;
            }

            reorderGlyphs(this.glyphs, entry.flags & VERB, this.firstGlyph, this.lastGlyph);
          };

          _proto21.processContextualSubstitution = function processContextualSubstitution(glyph, entry, index) {
            const subsitutions = this.subtable.table.substitutionTable.items;

            if (entry.markIndex !== 0xffff) {
              const lookup = subsitutions.getItem(entry.markIndex);
              const lookupTable = new AATLookupTable(lookup);
              glyph = this.glyphs[this.markedGlyph];
              var gid = lookupTable.lookup(glyph.id);

              if (gid) {
                this.glyphs[this.markedGlyph] = this.font.getGlyph(gid, glyph.codePoints);
              }
            }

            if (entry.currentIndex !== 0xffff) {
              const _lookup = subsitutions.getItem(entry.currentIndex);

              const _lookupTable = new AATLookupTable(_lookup);

              glyph = this.glyphs[index];

              var gid = _lookupTable.lookup(glyph.id);

              if (gid) {
                this.glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
              }
            }

            if (entry.flags & SET_MARK) {
              this.markedGlyph = index;
            }
          };

          _proto21.processLigature = function processLigature(glyph, entry, index) {
            if (entry.flags & SET_COMPONENT) {
              this.ligatureStack.push(index);
            }

            if (entry.flags & PERFORM_ACTION) {
              let _this$ligatureStack;

              const actions = this.subtable.table.ligatureActions;
              const { components } = this.subtable.table;
              const { ligatureList } = this.subtable.table;
              let actionIndex = entry.action;
              let last = false;
              let ligatureIndex = 0;
              let codePoints = [];
              const ligatureGlyphs = [];

              while (!last) {
                var _codePoints;

                const componentGlyph = this.ligatureStack.pop();

                (_codePoints = codePoints).unshift.apply(_codePoints, this.glyphs[componentGlyph].codePoints);

                const action = actions.getItem(actionIndex++);
                last = !!(action & LAST_MASK);
                const store = !!(action & STORE_MASK);
                let offset = (action & OFFSET_MASK) << 2 >> 2; // sign extend 30 to 32 bits

                offset += this.glyphs[componentGlyph].id;
                const component = components.getItem(offset);
                ligatureIndex += component;

                if (last || store) {
                  const ligatureEntry = ligatureList.getItem(ligatureIndex);
                  this.glyphs[componentGlyph] = this.font.getGlyph(ligatureEntry, codePoints);
                  ligatureGlyphs.push(componentGlyph);
                  ligatureIndex = 0;
                  codePoints = [];
                } else {
                  this.glyphs[componentGlyph] = this.font.getGlyph(0xffff);
                }
              } // Put ligature glyph indexes back on the stack

              (_this$ligatureStack = this.ligatureStack).push.apply(_this$ligatureStack, ligatureGlyphs);
            }
          };

          _proto21.processNoncontextualSubstitutions = function processNoncontextualSubstitutions(subtable, glyphs, index) {
            const lookupTable = new AATLookupTable(subtable.table.lookupTable);

            for (index = 0; index < glyphs.length; index++) {
              const glyph = glyphs[index];

              if (glyph.id !== 0xffff) {
                const gid = lookupTable.lookup(glyph.id);

                if (gid) {
                  // 0 means do nothing
                  glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
                }
              }
            }
          };

          _proto21._insertGlyphs = function _insertGlyphs(glyphIndex, insertionActionIndex, count, isBefore) {
            let _this$glyphs;

            const insertions = [];

            while (count--) {
              const gid = this.subtable.table.insertionActions.getItem(insertionActionIndex++);
              insertions.push(this.font.getGlyph(gid));
            }

            if (!isBefore) {
              glyphIndex++;
            }

            (_this$glyphs = this.glyphs).splice.apply(_this$glyphs, [glyphIndex, 0].concat(insertions));
          };

          _proto21.processGlyphInsertion = function processGlyphInsertion(glyph, entry, index) {
            if (entry.flags & SET_MARK) {
              this.markedIndex = index;
            }

            if (entry.markedInsertIndex !== 0xffff) {
              const count = (entry.flags & MARKED_INSERT_COUNT) >>> 5;
              const isBefore = !!(entry.flags & MARKED_INSERT_BEFORE);

              this._insertGlyphs(this.markedIndex, entry.markedInsertIndex, count, isBefore);
            }

            if (entry.currentInsertIndex !== 0xffff) {
              const _count = (entry.flags & CURRENT_INSERT_COUNT) >>> 5;

              const _isBefore = !!(entry.flags & CURRENT_INSERT_BEFORE);

              this._insertGlyphs(index, entry.currentInsertIndex, _count, _isBefore);
            }
          };

          _proto21.getSupportedFeatures = function getSupportedFeatures() {
            const features = [];

            for (var _iterator27 = _createForOfIteratorHelperLoose(this.morx.chains), _step27; !(_step27 = _iterator27()).done;) {
              const chain = _step27.value;

              for (var _iterator28 = _createForOfIteratorHelperLoose(chain.features), _step28; !(_step28 = _iterator28()).done;) {
                const feature = _step28.value;
                features.push([feature.featureType, feature.featureSetting]);
              }
            }

            return features;
          };

          _proto21.generateInputs = function generateInputs(gid) {
            if (!this.inputCache) {
              this.generateInputCache();
            }

            return this.inputCache[gid] || [];
          };

          _proto21.generateInputCache = function generateInputCache() {
            this.inputCache = {};

            for (var _iterator29 = _createForOfIteratorHelperLoose(this.morx.chains), _step29; !(_step29 = _iterator29()).done;) {
              const chain = _step29.value;
              const flags = chain.defaultFlags;

              for (var _iterator30 = _createForOfIteratorHelperLoose(chain.subtables), _step30; !(_step30 = _iterator30()).done;) {
                const subtable = _step30.value;

                if (subtable.subFeatureFlags & flags) {
                  this.generateInputsForSubtable(subtable);
                }
              }
            }
          };

          _proto21.generateInputsForSubtable = function generateInputsForSubtable(subtable) {
            const _this3 = this;

            // Currently, only supporting ligature subtables.
            if (subtable.type !== 2) {
              return;
            }

            const reverse = !!(subtable.coverage & REVERSE_DIRECTION);

            if (reverse) {
              throw new Error('Reverse subtable, not supported.');
            }

            this.subtable = subtable;
            this.ligatureStack = [];
            const stateMachine = this.getStateMachine(subtable);
            const process = this.getProcessor();
            const input = [];
            const stack = [];
            this.glyphs = [];
            stateMachine.traverse({
              enter: function enter(glyph, entry) {
                const { glyphs } = _this3;
                stack.push({
                  glyphs: glyphs.slice(),
                  ligatureStack: _this3.ligatureStack.slice(),
                }); // Add glyph to input and glyphs to process.

                const g = _this3.font.getGlyph(glyph);

                input.push(g);
                glyphs.push(input[input.length - 1]); // Process ligature substitution

                process(glyphs[glyphs.length - 1], entry, glyphs.length - 1); // Add input to result if only one matching (non-deleted) glyph remains.

                let count = 0;
                let found = 0;

                for (let i = 0; i < glyphs.length && count <= 1; i++) {
                  if (glyphs[i].id !== 0xffff) {
                    count++;
                    found = glyphs[i].id;
                  }
                }

                if (count === 1) {
                  const result = input.map((g) => g.id);
                  const _cache = _this3.inputCache[found];

                  if (_cache) {
                    _cache.push(result);
                  } else {
                    _this3.inputCache[found] = [result];
                  }
                }
              },
              exit: function exit() {
                const _stack$pop = stack.pop();

                _this3.glyphs = _stack$pop.glyphs;
                _this3.ligatureStack = _stack$pop.ligatureStack;
                input.pop();
              },
            });
          };

          return AATMorxProcessor;
        }()), _applyDecoratedDescriptor(_class$2.prototype, 'getStateMachine', [cache], Object.getOwnPropertyDescriptor(_class$2.prototype, 'getStateMachine'), _class$2.prototype), _class$2); // reverse the glyphs inside those ranges if specified
        // ranges are in [offset, length] format

        function swap(glyphs, rangeA, rangeB, reverseA, reverseB) {
          if (reverseA === void 0) {
            reverseA = false;
          }

          if (reverseB === void 0) {
            reverseB = false;
          }

          const end = glyphs.splice(rangeB[0] - (rangeB[1] - 1), rangeB[1]);

          if (reverseB) {
            end.reverse();
          }

          const start = glyphs.splice.apply(glyphs, [rangeA[0], rangeA[1]].concat(end));

          if (reverseA) {
            start.reverse();
          }

          glyphs.splice.apply(glyphs, [rangeB[0] - (rangeA[1] - 1), 0].concat(start));
          return glyphs;
        }

        function reorderGlyphs(glyphs, verb, firstGlyph, lastGlyph) {
          switch (verb) {
            case 0:
              // no change
              return glyphs;

            case 1:
              // Ax => xA
              return swap(glyphs, [firstGlyph, 1], [lastGlyph, 0]);

            case 2:
              // xD => Dx
              return swap(glyphs, [firstGlyph, 0], [lastGlyph, 1]);

            case 3:
              // AxD => DxA
              return swap(glyphs, [firstGlyph, 1], [lastGlyph, 1]);

            case 4:
              // ABx => xAB
              return swap(glyphs, [firstGlyph, 2], [lastGlyph, 0]);

            case 5:
              // ABx => xBA
              return swap(glyphs, [firstGlyph, 2], [lastGlyph, 0], true, false);

            case 6:
              // xCD => CDx
              return swap(glyphs, [firstGlyph, 0], [lastGlyph, 2]);

            case 7:
              // xCD => DCx
              return swap(glyphs, [firstGlyph, 0], [lastGlyph, 2], false, true);

            case 8:
              // AxCD => CDxA
              return swap(glyphs, [firstGlyph, 1], [lastGlyph, 2]);

            case 9:
              // AxCD => DCxA
              return swap(glyphs, [firstGlyph, 1], [lastGlyph, 2], false, true);

            case 10:
              // ABxD => DxAB
              return swap(glyphs, [firstGlyph, 2], [lastGlyph, 1]);

            case 11:
              // ABxD => DxBA
              return swap(glyphs, [firstGlyph, 2], [lastGlyph, 1], true, false);

            case 12:
              // ABxCD => CDxAB
              return swap(glyphs, [firstGlyph, 2], [lastGlyph, 2]);

            case 13:
              // ABxCD => CDxBA
              return swap(glyphs, [firstGlyph, 2], [lastGlyph, 2], true, false);

            case 14:
              // ABxCD => DCxAB
              return swap(glyphs, [firstGlyph, 2], [lastGlyph, 2], false, true);

            case 15:
              // ABxCD => DCxBA
              return swap(glyphs, [firstGlyph, 2], [lastGlyph, 2], true, true);

            default:
              throw new Error('Unknown verb: '.concat(verb));
          }
        }

        const AATLayoutEngine = /* #__PURE__ */(function () {
          function AATLayoutEngine(font) {
            this.font = font;
            this.morxProcessor = new AATMorxProcessor(font);
            this.fallbackPosition = false;
          }

          const _proto22 = AATLayoutEngine.prototype;

          _proto22.substitute = function substitute(glyphRun) {
            // AAT expects the glyphs to be in visual order prior to morx processing,
            // so reverse the glyphs if the script is right-to-left.
            if (glyphRun.direction === 'rtl') {
              glyphRun.glyphs.reverse();
            }

            this.morxProcessor.process(glyphRun.glyphs, mapOTToAAT(glyphRun.features));
          };

          _proto22.getAvailableFeatures = function getAvailableFeatures(script, language) {
            return mapAATToOT(this.morxProcessor.getSupportedFeatures());
          };

          _proto22.stringsForGlyph = function stringsForGlyph(gid) {
            const glyphStrings = this.morxProcessor.generateInputs(gid);
            const result = new Set();

            for (var _iterator31 = _createForOfIteratorHelperLoose(glyphStrings), _step31; !(_step31 = _iterator31()).done;) {
              const glyphs = _step31.value;

              this._addStrings(glyphs, 0, result, '');
            }

            return result;
          };

          _proto22._addStrings = function _addStrings(glyphs, index, strings, string) {
            const codePoints = this.font._cmapProcessor.codePointsForGlyph(glyphs[index]);

            for (var _iterator32 = _createForOfIteratorHelperLoose(codePoints), _step32; !(_step32 = _iterator32()).done;) {
              const codePoint = _step32.value;
              const s = string + String.fromCodePoint(codePoint);

              if (index < glyphs.length - 1) {
                this._addStrings(glyphs, index + 1, strings, s);
              } else {
                strings.add(s);
              }
            }
          };

          return AATLayoutEngine;
        }());
        /**
 * ShapingPlans are used by the OpenType shapers to store which
 * features should by applied, and in what order to apply them.
 * The features are applied in groups called stages. A feature
 * can be applied globally to all glyphs, or locally to only
 * specific glyphs.
 *
 * @private
 */

        const ShapingPlan = /* #__PURE__ */(function () {
          function ShapingPlan(font, script, direction) {
            this.font = font;
            this.script = script;
            this.direction = direction;
            this.stages = [];
            this.globalFeatures = {};
            this.allFeatures = {};
          }
          /**
   * Adds the given features to the last stage.
   * Ignores features that have already been applied.
   */

          const _proto23 = ShapingPlan.prototype;

          _proto23._addFeatures = function _addFeatures(features, global) {
            const stageIndex = this.stages.length - 1;
            const stage = this.stages[stageIndex];

            for (var _iterator33 = _createForOfIteratorHelperLoose(features), _step33; !(_step33 = _iterator33()).done;) {
              const feature = _step33.value;

              if (this.allFeatures[feature] == null) {
                stage.push(feature);
                this.allFeatures[feature] = stageIndex;

                if (global) {
                  this.globalFeatures[feature] = true;
                }
              }
            }
          }
          /**
   * Add features to the last stage
   */
          ;

          _proto23.add = function add(arg, global) {
            if (global === void 0) {
              global = true;
            }

            if (this.stages.length === 0) {
              this.stages.push([]);
            }

            if (typeof arg === 'string') {
              arg = [arg];
            }

            if (Array.isArray(arg)) {
              this._addFeatures(arg, global);
            } else if (typeof arg === 'object') {
              this._addFeatures(arg.global || [], true);

              this._addFeatures(arg.local || [], false);
            } else {
              throw new Error('Unsupported argument to ShapingPlan#add');
            }
          }
          /**
   * Add a new stage
   */
          ;

          _proto23.addStage = function addStage(arg, global) {
            if (typeof arg === 'function') {
              this.stages.push(arg, []);
            } else {
              this.stages.push([]);
              this.add(arg, global);
            }
          };

          _proto23.setFeatureOverrides = function setFeatureOverrides(features) {
            if (Array.isArray(features)) {
              this.add(features);
            } else if (typeof features === 'object') {
              for (const tag in features) {
                if (features[tag]) {
                  this.add(tag);
                } else if (this.allFeatures[tag] != null) {
                  const stage = this.stages[this.allFeatures[tag]];
                  stage.splice(stage.indexOf(tag), 1);
                  delete this.allFeatures[tag];
                  delete this.globalFeatures[tag];
                }
              }
            }
          }
          /**
   * Assigns the global features to the given glyphs
   */
          ;

          _proto23.assignGlobalFeatures = function assignGlobalFeatures(glyphs) {
            for (var _iterator34 = _createForOfIteratorHelperLoose(glyphs), _step34; !(_step34 = _iterator34()).done;) {
              const glyph = _step34.value;

              for (const feature in this.globalFeatures) {
                glyph.features[feature] = true;
              }
            }
          }
          /**
   * Executes the planned stages using the given OTProcessor
   */
          ;

          _proto23.process = function process(processor, glyphs, positions) {
            for (var _iterator35 = _createForOfIteratorHelperLoose(this.stages), _step35; !(_step35 = _iterator35()).done;) {
              const stage = _step35.value;

              if (typeof stage === 'function') {
                if (!positions) {
                  stage(this.font, glyphs, this);
                }
              } else if (stage.length > 0) {
                processor.applyFeatures(stage, glyphs, positions);
              }
            }
          };

          return ShapingPlan;
        }());

        const VARIATION_FEATURES = ['rvrn'];
        const COMMON_FEATURES = ['ccmp', 'locl', 'rlig', 'mark', 'mkmk'];
        const FRACTIONAL_FEATURES = ['frac', 'numr', 'dnom'];
        const HORIZONTAL_FEATURES = ['calt', 'clig', 'liga', 'rclt', 'curs', 'kern'];
        const DIRECTIONAL_FEATURES = {
          ltr: ['ltra', 'ltrm'],
          rtl: ['rtla', 'rtlm'],
        };

        const DefaultShaper = /* #__PURE__ */(function () {
          function DefaultShaper() {}

          DefaultShaper.plan = function plan(_plan, glyphs, features) {
            // Plan the features we want to apply
            this.planPreprocessing(_plan);
            this.planFeatures(_plan);
            this.planPostprocessing(_plan, features); // Assign the global features to all the glyphs

            _plan.assignGlobalFeatures(glyphs); // Assign local features to glyphs

            this.assignFeatures(_plan, glyphs);
          };

          DefaultShaper.planPreprocessing = function planPreprocessing(plan) {
            plan.add({
              global: [].concat(VARIATION_FEATURES, DIRECTIONAL_FEATURES[plan.direction]),
              local: FRACTIONAL_FEATURES,
            });
          };

          DefaultShaper.planFeatures = function planFeatures(plan) { // Do nothing by default. Let subclasses override this.
          };

          DefaultShaper.planPostprocessing = function planPostprocessing(plan, userFeatures) {
            plan.add([].concat(COMMON_FEATURES, HORIZONTAL_FEATURES));
            plan.setFeatureOverrides(userFeatures);
          };

          DefaultShaper.assignFeatures = function assignFeatures(plan, glyphs) {
            // Enable contextual fractions
            for (let i = 0; i < glyphs.length; i++) {
              const glyph = glyphs[i];

              if (glyph.codePoints[0] === 0x2044) {
                // fraction slash
                let start = i;
                let end = i + 1; // Apply numerator

                while (start > 0 && unicode.isDigit(glyphs[start - 1].codePoints[0])) {
                  glyphs[start - 1].features.numr = true;
                  glyphs[start - 1].features.frac = true;
                  start--;
                } // Apply denominator

                while (end < glyphs.length && unicode.isDigit(glyphs[end].codePoints[0])) {
                  glyphs[end].features.dnom = true;
                  glyphs[end].features.frac = true;
                  end++;
                } // Apply fraction slash

                glyph.features.frac = true;
                i = end - 1;
              }
            }
          };

          return DefaultShaper;
        }());

        _defineProperty(DefaultShaper, 'zeroMarkWidths', 'AFTER_GPOS');

        const trie = new UnicodeTrie(Buffer('APABAAAAAAAAOAAAAf0BAv7tmi1MxDAUx7vtvjhAgcDgkEgEAnmXEBIMCYaEcygEiqBQ4FAkCE4ikUgMiiBJSAgSiUQSDMn9L9eSl6bddddug9t7yS/trevre+3r27pcNxZiG+yCfdCVv/9LeQxOwRm4AJegD27ALbgD9+ABPJF+z+BN/h7yDj5k/VOWX6SdmU5+wLWknggxDxaS8u0qiiX4uiz9XamQ3wzDMAzDMAzDMAzDVI/h959V/v7BMAzDMAzDMLlyNTNiMSdewVxbiA44B4/guz1qW58VYlMI0WsJ0W+N6kXw0spvPtdwhtkwnGM6uLaV4Xyzg3v3PM9DPfQ/sOg4xPWjipy31P8LTqbU304c/cLCUmWJLNB2Uz2U1KTeRKNmKHVMfbJC+/0loTZRH/W5cvEvBJPMbREkWt3FD1NcqXZBSpuE2Ad0PBehPtNrPtIEdYP+hiRt/V1jIiE69X4NT/uVZI3PUHE9bm5M7ePGdZWy951v7Nn6j8v1WWKP3mt6ttnsigx6VN7Vc0VomSSGqW2mGNP1muZPl7LfjNUaKNFtDGVf2fvE9O7VlBS5j333c5p/eeoOqcs1R/hIqDWLJ7TTlksirVT1SI7l8k4Yp+g3jafGcrU1RM6l9th80XOpnlN97bDNY4i4s61B0Si/ipa0uHMl6zqEjlFfCZm/TM8KmzQDjmuTAQ==', 'base64'));
        const FEATURES = ['isol', 'fina', 'fin2', 'fin3', 'medi', 'med2', 'init'];
        const ShapingClasses = {
          Non_Joining: 0,
          Left_Joining: 1,
          Right_Joining: 2,
          Dual_Joining: 3,
          Join_Causing: 3,
          ALAPH: 4,
          'DALATH RISH': 5,
          Transparent: 6,
        };
        const ISOL = 'isol';
        const FINA = 'fina';
        const FIN2 = 'fin2';
        const FIN3 = 'fin3';
        const MEDI = 'medi';
        const MED2 = 'med2';
        const INIT = 'init';
        const NONE = null; // Each entry is [prevAction, curAction, nextState]

        const STATE_TABLE = [//   Non_Joining,        Left_Joining,       Right_Joining,     Dual_Joining,           ALAPH,            DALATH RISH
          // State 0: prev was U,  not willing to join.
          [[NONE, NONE, 0], [NONE, ISOL, 2], [NONE, ISOL, 1], [NONE, ISOL, 2], [NONE, ISOL, 1], [NONE, ISOL, 6]], // State 1: prev was R or ISOL/ALAPH,  not willing to join.
          [[NONE, NONE, 0], [NONE, ISOL, 2], [NONE, ISOL, 1], [NONE, ISOL, 2], [NONE, FIN2, 5], [NONE, ISOL, 6]], // State 2: prev was D/L in ISOL form,  willing to join.
          [[NONE, NONE, 0], [NONE, ISOL, 2], [INIT, FINA, 1], [INIT, FINA, 3], [INIT, FINA, 4], [INIT, FINA, 6]], // State 3: prev was D in FINA form,  willing to join.
          [[NONE, NONE, 0], [NONE, ISOL, 2], [MEDI, FINA, 1], [MEDI, FINA, 3], [MEDI, FINA, 4], [MEDI, FINA, 6]], // State 4: prev was FINA ALAPH,  not willing to join.
          [[NONE, NONE, 0], [NONE, ISOL, 2], [MED2, ISOL, 1], [MED2, ISOL, 2], [MED2, FIN2, 5], [MED2, ISOL, 6]], // State 5: prev was FIN2/FIN3 ALAPH,  not willing to join.
          [[NONE, NONE, 0], [NONE, ISOL, 2], [ISOL, ISOL, 1], [ISOL, ISOL, 2], [ISOL, FIN2, 5], [ISOL, ISOL, 6]], // State 6: prev was DALATH/RISH,  not willing to join.
          [[NONE, NONE, 0], [NONE, ISOL, 2], [NONE, ISOL, 1], [NONE, ISOL, 2], [NONE, FIN3, 5], [NONE, ISOL, 6]]];
        /**
 * This is a shaper for Arabic, and other cursive scripts.
 * It uses data from ArabicShaping.txt in the Unicode database,
 * compiled to a UnicodeTrie by generate-data.coffee.
 *
 * The shaping state machine was ported from Harfbuzz.
 * https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-complex-arabic.cc
 */

        const ArabicShaper = /* #__PURE__ */(function (_DefaultShaper) {
          _inheritsLoose(ArabicShaper, _DefaultShaper);

          function ArabicShaper() {
            return _DefaultShaper.apply(this, arguments) || this;
          }

          ArabicShaper.planFeatures = function planFeatures(plan) {
            plan.add(['ccmp', 'locl']);

            for (let i = 0; i < FEATURES.length; i++) {
              const feature = FEATURES[i];
              plan.addStage(feature, false);
            }

            plan.addStage('mset');
          };

          ArabicShaper.assignFeatures = function assignFeatures(plan, glyphs) {
            _DefaultShaper.assignFeatures.call(this, plan, glyphs);

            let prev = -1;
            let state = 0;
            const actions = []; // Apply the state machine to map glyphs to features

            for (let i = 0; i < glyphs.length; i++) {
              let curAction = void 0;
              let prevAction = void 0;
              var glyph = glyphs[i];
              const type = getShapingClass(glyph.codePoints[0]);

              if (type === ShapingClasses.Transparent) {
                actions[i] = NONE;
                continue;
              }

              const _STATE_TABLE$state$ty = STATE_TABLE[state][type];
              prevAction = _STATE_TABLE$state$ty[0];
              curAction = _STATE_TABLE$state$ty[1];
              state = _STATE_TABLE$state$ty[2];

              if (prevAction !== NONE && prev !== -1) {
                actions[prev] = prevAction;
              }

              actions[i] = curAction;
              prev = i;
            } // Apply the chosen features to their respective glyphs

            for (let index = 0; index < glyphs.length; index++) {
              let feature = void 0;
              var glyph = glyphs[index];

              if (feature = actions[index]) {
                glyph.features[feature] = true;
              }
            }
          };

          return ArabicShaper;
        }(DefaultShaper));

        function getShapingClass(codePoint) {
          const res = trie.get(codePoint);

          if (res) {
            return res - 1;
          }

          const category = unicode.getCategory(codePoint);

          if (category === 'Mn' || category === 'Me' || category === 'Cf') {
            return ShapingClasses.Transparent;
          }

          return ShapingClasses.Non_Joining;
        }

        const GlyphIterator = /* #__PURE__ */(function () {
          function GlyphIterator(glyphs, options) {
            this.glyphs = glyphs;
            this.reset(options);
          }

          const _proto24 = GlyphIterator.prototype;

          _proto24.reset = function reset(options, index) {
            if (options === void 0) {
              options = {};
            }

            if (index === void 0) {
              index = 0;
            }

            this.options = options;
            this.flags = options.flags || {};
            this.markAttachmentType = options.markAttachmentType || 0;
            this.index = index;
          };

          _proto24.shouldIgnore = function shouldIgnore(glyph) {
            return this.flags.ignoreMarks && glyph.isMark || this.flags.ignoreBaseGlyphs && glyph.isBase || this.flags.ignoreLigatures && glyph.isLigature || this.markAttachmentType && glyph.isMark && glyph.markAttachmentType !== this.markAttachmentType;
          };

          _proto24.move = function move(dir) {
            this.index += dir;

            while (this.index >= 0 && this.index < this.glyphs.length && this.shouldIgnore(this.glyphs[this.index])) {
              this.index += dir;
            }

            if (this.index < 0 || this.index >= this.glyphs.length) {
              return null;
            }

            return this.glyphs[this.index];
          };

          _proto24.next = function next() {
            return this.move(+1);
          };

          _proto24.prev = function prev() {
            return this.move(-1);
          };

          _proto24.peek = function peek(count) {
            if (count === void 0) {
              count = 1;
            }

            const idx = this.index;
            const res = this.increment(count);
            this.index = idx;
            return res;
          };

          _proto24.peekIndex = function peekIndex(count) {
            if (count === void 0) {
              count = 1;
            }

            const idx = this.index;
            this.increment(count);
            const res = this.index;
            this.index = idx;
            return res;
          };

          _proto24.increment = function increment(count) {
            if (count === void 0) {
              count = 1;
            }

            const dir = count < 0 ? -1 : 1;
            count = Math.abs(count);

            while (count--) {
              this.move(dir);
            }

            return this.glyphs[this.index];
          };

          _createClass(GlyphIterator, [{
            key: 'cur',
            get: function get() {
              return this.glyphs[this.index] || null;
            },
          }]);

          return GlyphIterator;
        }());

        const DEFAULT_SCRIPTS = ['DFLT', 'dflt', 'latn'];

        const OTProcessor = /* #__PURE__ */(function () {
          function OTProcessor(font, table) {
            this.font = font;
            this.table = table;
            this.script = null;
            this.scriptTag = null;
            this.language = null;
            this.languageTag = null;
            this.features = {};
            this.lookups = {}; // Setup variation substitutions

            this.variationsIndex = font._variationProcessor ? this.findVariationsIndex(font._variationProcessor.normalizedCoords) : -1; // initialize to default script + language

            this.selectScript(); // current context (set by applyFeatures)

            this.glyphs = [];
            this.positions = []; // only used by GPOS

            this.ligatureID = 1;
            this.currentFeature = null;
          }

          const _proto25 = OTProcessor.prototype;

          _proto25.findScript = function findScript(script) {
            if (this.table.scriptList == null) {
              return null;
            }

            if (!Array.isArray(script)) {
              script = [script];
            }

            for (var _iterator36 = _createForOfIteratorHelperLoose(script), _step36; !(_step36 = _iterator36()).done;) {
              const s = _step36.value;

              for (var _iterator37 = _createForOfIteratorHelperLoose(this.table.scriptList), _step37; !(_step37 = _iterator37()).done;) {
                const entry = _step37.value;

                if (entry.tag === s) {
                  return entry;
                }
              }
            }

            return null;
          };

          _proto25.selectScript = function selectScript(script, language, direction$1) {
            let changed = false;
            let entry;

            if (!this.script || script !== this.scriptTag) {
              entry = this.findScript(script);

              if (!entry) {
                entry = this.findScript(DEFAULT_SCRIPTS);
              }

              if (!entry) {
                return this.scriptTag;
              }

              this.scriptTag = entry.tag;
              this.script = entry.script;
              this.language = null;
              this.languageTag = null;
              changed = true;
            }

            if (!direction$1 || direction$1 !== this.direction) {
              this.direction = direction$1 || direction(script);
            }

            if (language && language.length < 4) {
              language += ' '.repeat(4 - language.length);
            }

            if (!language || language !== this.languageTag) {
              this.language = null;

              for (var _iterator38 = _createForOfIteratorHelperLoose(this.script.langSysRecords), _step38; !(_step38 = _iterator38()).done;) {
                const lang = _step38.value;

                if (lang.tag === language) {
                  this.language = lang.langSys;
                  this.languageTag = lang.tag;
                  break;
                }
              }

              if (!this.language) {
                this.language = this.script.defaultLangSys;
                this.languageTag = null;
              }

              changed = true;
            } // Build a feature lookup table

            if (changed) {
              this.features = {};

              if (this.language) {
                for (var _iterator39 = _createForOfIteratorHelperLoose(this.language.featureIndexes), _step39; !(_step39 = _iterator39()).done;) {
                  const featureIndex = _step39.value;
                  const record = this.table.featureList[featureIndex];
                  const substituteFeature = this.substituteFeatureForVariations(featureIndex);
                  this.features[record.tag] = substituteFeature || record.feature;
                }
              }
            }

            return this.scriptTag;
          };

          _proto25.lookupsForFeatures = function lookupsForFeatures(userFeatures, exclude) {
            if (userFeatures === void 0) {
              userFeatures = [];
            }

            const lookups = [];

            for (var _iterator40 = _createForOfIteratorHelperLoose(userFeatures), _step40; !(_step40 = _iterator40()).done;) {
              const tag = _step40.value;
              const feature = this.features[tag];

              if (!feature) {
                continue;
              }

              for (var _iterator41 = _createForOfIteratorHelperLoose(feature.lookupListIndexes), _step41; !(_step41 = _iterator41()).done;) {
                const lookupIndex = _step41.value;

                if (exclude && exclude.indexOf(lookupIndex) !== -1) {
                  continue;
                }

                lookups.push({
                  feature: tag,
                  index: lookupIndex,
                  lookup: this.table.lookupList.get(lookupIndex),
                });
              }
            }

            lookups.sort((a, b) => a.index - b.index);
            return lookups;
          };

          _proto25.substituteFeatureForVariations = function substituteFeatureForVariations(featureIndex) {
            if (this.variationsIndex === -1) {
              return null;
            }

            const record = this.table.featureVariations.featureVariationRecords[this.variationsIndex];
            const { substitutions } = record.featureTableSubstitution;

            for (var _iterator42 = _createForOfIteratorHelperLoose(substitutions), _step42; !(_step42 = _iterator42()).done;) {
              const substitution = _step42.value;

              if (substitution.featureIndex === featureIndex) {
                return substitution.alternateFeatureTable;
              }
            }

            return null;
          };

          _proto25.findVariationsIndex = function findVariationsIndex(coords) {
            const variations = this.table.featureVariations;

            if (!variations) {
              return -1;
            }

            const records = variations.featureVariationRecords;

            for (let i = 0; i < records.length; i++) {
              const conditions = records[i].conditionSet.conditionTable;

              if (this.variationConditionsMatch(conditions, coords)) {
                return i;
              }
            }

            return -1;
          };

          _proto25.variationConditionsMatch = function variationConditionsMatch(conditions, coords) {
            return conditions.every((condition) => {
              const coord = condition.axisIndex < coords.length ? coords[condition.axisIndex] : 0;
              return condition.filterRangeMinValue <= coord && coord <= condition.filterRangeMaxValue;
            });
          };

          _proto25.applyFeatures = function applyFeatures(userFeatures, glyphs, advances) {
            const lookups = this.lookupsForFeatures(userFeatures);
            this.applyLookups(lookups, glyphs, advances);
          };

          _proto25.applyLookups = function applyLookups(lookups, glyphs, positions) {
            this.glyphs = glyphs;
            this.positions = positions;
            this.glyphIterator = new GlyphIterator(glyphs);

            for (var _iterator43 = _createForOfIteratorHelperLoose(lookups), _step43; !(_step43 = _iterator43()).done;) {
              const _step43$value = _step43.value;
              const { feature } = _step43$value;
              const { lookup } = _step43$value;
              this.currentFeature = feature;
              this.glyphIterator.reset(lookup.flags);

              while (this.glyphIterator.index < glyphs.length) {
                if (!(feature in this.glyphIterator.cur.features)) {
                  this.glyphIterator.next();
                  continue;
                }

                for (var _iterator44 = _createForOfIteratorHelperLoose(lookup.subTables), _step44; !(_step44 = _iterator44()).done;) {
                  const table = _step44.value;
                  const res = this.applyLookup(lookup.lookupType, table);

                  if (res) {
                    break;
                  }
                }

                this.glyphIterator.next();
              }
            }
          };

          _proto25.applyLookup = function applyLookup(lookup, table) {
            throw new Error('applyLookup must be implemented by subclasses');
          };

          _proto25.applyLookupList = function applyLookupList(lookupRecords) {
            const { options } = this.glyphIterator;
            const glyphIndex = this.glyphIterator.index;

            for (var _iterator45 = _createForOfIteratorHelperLoose(lookupRecords), _step45; !(_step45 = _iterator45()).done;) {
              const lookupRecord = _step45.value;
              // Reset flags and find glyph index for this lookup record
              this.glyphIterator.reset(options, glyphIndex);
              this.glyphIterator.increment(lookupRecord.sequenceIndex); // Get the lookup and setup flags for subtables

              const lookup = this.table.lookupList.get(lookupRecord.lookupListIndex);
              this.glyphIterator.reset(lookup.flags, this.glyphIterator.index); // Apply lookup subtables until one matches

              for (var _iterator46 = _createForOfIteratorHelperLoose(lookup.subTables), _step46; !(_step46 = _iterator46()).done;) {
                const table = _step46.value;

                if (this.applyLookup(lookup.lookupType, table)) {
                  break;
                }
              }
            }

            this.glyphIterator.reset(options, glyphIndex);
            return true;
          };

          _proto25.coverageIndex = function coverageIndex(coverage, glyph) {
            if (glyph == null) {
              glyph = this.glyphIterator.cur.id;
            }

            switch (coverage.version) {
              case 1:
                return coverage.glyphs.indexOf(glyph);

              case 2:
                for (var _iterator47 = _createForOfIteratorHelperLoose(coverage.rangeRecords), _step47; !(_step47 = _iterator47()).done;) {
                  const range = _step47.value;

                  if (range.start <= glyph && glyph <= range.end) {
                    return range.startCoverageIndex + glyph - range.start;
                  }
                }

                break;
            }

            return -1;
          };

          _proto25.match = function match(sequenceIndex, sequence, fn, matched) {
            const pos = this.glyphIterator.index;
            let glyph = this.glyphIterator.increment(sequenceIndex);
            let idx = 0;

            while (idx < sequence.length && glyph && fn(sequence[idx], glyph)) {
              if (matched) {
                matched.push(this.glyphIterator.index);
              }

              idx++;
              glyph = this.glyphIterator.next();
            }

            this.glyphIterator.index = pos;

            if (idx < sequence.length) {
              return false;
            }

            return matched || true;
          };

          _proto25.sequenceMatches = function sequenceMatches(sequenceIndex, sequence) {
            return this.match(sequenceIndex, sequence, (component, glyph) => component === glyph.id);
          };

          _proto25.sequenceMatchIndices = function sequenceMatchIndices(sequenceIndex, sequence) {
            const _this4 = this;

            return this.match(sequenceIndex, sequence, (component, glyph) => {
              // If the current feature doesn't apply to this glyph,
              if (!(_this4.currentFeature in glyph.features)) {
                return false;
              }

              return component === glyph.id;
            }, []);
          };

          _proto25.coverageSequenceMatches = function coverageSequenceMatches(sequenceIndex, sequence) {
            const _this5 = this;

            return this.match(sequenceIndex, sequence, (coverage, glyph) => _this5.coverageIndex(coverage, glyph.id) >= 0);
          };

          _proto25.getClassID = function getClassID(glyph, classDef) {
            switch (classDef.version) {
              case 1:
                // Class array
                var i = glyph - classDef.startGlyph;

                if (i >= 0 && i < classDef.classValueArray.length) {
                  return classDef.classValueArray[i];
                }

                break;

              case 2:
                for (var _iterator48 = _createForOfIteratorHelperLoose(classDef.classRangeRecord), _step48; !(_step48 = _iterator48()).done;) {
                  const range = _step48.value;

                  if (range.start <= glyph && glyph <= range.end) {
                    return range.class;
                  }
                }

                break;
            }

            return 0;
          };

          _proto25.classSequenceMatches = function classSequenceMatches(sequenceIndex, sequence, classDef) {
            const _this6 = this;

            return this.match(sequenceIndex, sequence, (classID, glyph) => classID === _this6.getClassID(glyph.id, classDef));
          };

          _proto25.applyContext = function applyContext(table) {
            switch (table.version) {
              case 1:
                var index = this.coverageIndex(table.coverage);

                if (index === -1) {
                  return false;
                }

                var set = table.ruleSets[index];

                for (var _iterator49 = _createForOfIteratorHelperLoose(set), _step49; !(_step49 = _iterator49()).done;) {
                  const rule = _step49.value;

                  if (this.sequenceMatches(1, rule.input)) {
                    return this.applyLookupList(rule.lookupRecords);
                  }
                }

                break;

              case 2:
                if (this.coverageIndex(table.coverage) === -1) {
                  return false;
                }

                index = this.getClassID(this.glyphIterator.cur.id, table.classDef);

                if (index === -1) {
                  return false;
                }

                set = table.classSet[index];

                for (var _iterator50 = _createForOfIteratorHelperLoose(set), _step50; !(_step50 = _iterator50()).done;) {
                  const _rule = _step50.value;

                  if (this.classSequenceMatches(1, _rule.classes, table.classDef)) {
                    return this.applyLookupList(_rule.lookupRecords);
                  }
                }

                break;

              case 3:
                if (this.coverageSequenceMatches(0, table.coverages)) {
                  return this.applyLookupList(table.lookupRecords);
                }

                break;
            }

            return false;
          };

          _proto25.applyChainingContext = function applyChainingContext(table) {
            switch (table.version) {
              case 1:
                var index = this.coverageIndex(table.coverage);

                if (index === -1) {
                  return false;
                }

                var set = table.chainRuleSets[index];

                for (var _iterator51 = _createForOfIteratorHelperLoose(set), _step51; !(_step51 = _iterator51()).done;) {
                  const rule = _step51.value;

                  if (this.sequenceMatches(-rule.backtrack.length, rule.backtrack) && this.sequenceMatches(1, rule.input) && this.sequenceMatches(1 + rule.input.length, rule.lookahead)) {
                    return this.applyLookupList(rule.lookupRecords);
                  }
                }

                break;

              case 2:
                if (this.coverageIndex(table.coverage) === -1) {
                  return false;
                }

                index = this.getClassID(this.glyphIterator.cur.id, table.inputClassDef);
                var rules = table.chainClassSet[index];

                if (!rules) {
                  return false;
                }

                for (var _iterator52 = _createForOfIteratorHelperLoose(rules), _step52; !(_step52 = _iterator52()).done;) {
                  const _rule2 = _step52.value;

                  if (this.classSequenceMatches(-_rule2.backtrack.length, _rule2.backtrack, table.backtrackClassDef) && this.classSequenceMatches(1, _rule2.input, table.inputClassDef) && this.classSequenceMatches(1 + _rule2.input.length, _rule2.lookahead, table.lookaheadClassDef)) {
                    return this.applyLookupList(_rule2.lookupRecords);
                  }
                }

                break;

              case 3:
                if (this.coverageSequenceMatches(-table.backtrackGlyphCount, table.backtrackCoverage) && this.coverageSequenceMatches(0, table.inputCoverage) && this.coverageSequenceMatches(table.inputGlyphCount, table.lookaheadCoverage)) {
                  return this.applyLookupList(table.lookupRecords);
                }

                break;
            }

            return false;
          };

          return OTProcessor;
        }());

        const GlyphInfo = /* #__PURE__ */(function () {
          function GlyphInfo(font, id, codePoints, features) {
            if (codePoints === void 0) {
              codePoints = [];
            }

            this._font = font;
            this.codePoints = codePoints;
            this.id = id;
            this.features = {};

            if (Array.isArray(features)) {
              for (let i = 0; i < features.length; i++) {
                const feature = features[i];
                this.features[feature] = true;
              }
            } else if (typeof features === 'object') {
              Object.assign(this.features, features);
            }

            this.ligatureID = null;
            this.ligatureComponent = null;
            this.isLigated = false;
            this.cursiveAttachment = null;
            this.markAttachment = null;
            this.shaperInfo = null;
            this.substituted = false;
            this.isMultiplied = false;
          }

          const _proto26 = GlyphInfo.prototype;

          _proto26.copy = function copy() {
            return new GlyphInfo(this._font, this.id, this.codePoints, this.features);
          };

          _createClass(GlyphInfo, [{
            key: 'id',
            get: function get() {
              return this._id;
            },
            set: function set(id) {
              this._id = id;
              this.substituted = true;
              const { GDEF } = this._font;

              if (GDEF && GDEF.glyphClassDef) {
                // TODO: clean this up
                const classID = OTProcessor.prototype.getClassID(id, GDEF.glyphClassDef);
                this.isBase = classID === 1;
                this.isLigature = classID === 2;
                this.isMark = classID === 3;
                this.markAttachmentType = GDEF.markAttachClassDef ? OTProcessor.prototype.getClassID(id, GDEF.markAttachClassDef) : 0;
              } else {
                this.isMark = this.codePoints.length > 0 && this.codePoints.every(unicode.isMark);
                this.isBase = !this.isMark;
                this.isLigature = this.codePoints.length > 1;
                this.markAttachmentType = 0;
              }
            },
          }]);

          return GlyphInfo;
        }());
        /**
 * This is a shaper for the Hangul script, used by the Korean language.
 * It does the following:
 *   - decompose if unsupported by the font:
 *     <LV>   -> <L,V>
 *     <LVT>  -> <L,V,T>
 *     <LV,T> -> <L,V,T>
 *
 *   - compose if supported by the font:
 *     <L,V>   -> <LV>
 *     <L,V,T> -> <LVT>
 *     <LV,T>  -> <LVT>
 *
 *   - reorder tone marks (S is any valid syllable):
 *     <S, M> -> <M, S>
 *
 *   - apply ljmo, vjmo, and tjmo OpenType features to decomposed Jamo sequences.
 *
 * This logic is based on the following documents:
 *   - http://www.microsoft.com/typography/OpenTypeDev/hangul/intro.htm
 *   - http://ktug.org/~nomos/harfbuzz-hangul/hangulshaper.pdf
 */

        const HangulShaper = /* #__PURE__ */(function (_DefaultShaper2) {
          _inheritsLoose(HangulShaper, _DefaultShaper2);

          function HangulShaper() {
            return _DefaultShaper2.apply(this, arguments) || this;
          }

          HangulShaper.planFeatures = function planFeatures(plan) {
            plan.add(['ljmo', 'vjmo', 'tjmo'], false);
          };

          HangulShaper.assignFeatures = function assignFeatures(plan, glyphs) {
            let state = 0;
            let i = 0;

            while (i < glyphs.length) {
              let action = void 0;
              const glyph = glyphs[i];
              const code = glyph.codePoints[0];
              const type = getType(code);
              const _STATE_TABLE$1$state$ = STATE_TABLE$1[state][type];
              action = _STATE_TABLE$1$state$[0];
              state = _STATE_TABLE$1$state$[1];

              switch (action) {
                case DECOMPOSE:
                  // Decompose the composed syllable if it is not supported by the font.
                  if (!plan.font.hasGlyphForCodePoint(code)) {
                    i = decompose(glyphs, i, plan.font);
                  }

                  break;

                case COMPOSE:
                  // Found a decomposed syllable. Try to compose if supported by the font.
                  i = compose(glyphs, i, plan.font);
                  break;

                case TONE_MARK:
                  // Got a valid syllable, followed by a tone mark. Move the tone mark to the beginning of the syllable.
                  reorderToneMark(glyphs, i, plan.font);
                  break;

                case INVALID:
                  // Tone mark has no valid syllable to attach to, so insert a dotted circle
                  i = insertDottedCircle(glyphs, i, plan.font);
                  break;
              }

              i++;
            }
          };

          return HangulShaper;
        }(DefaultShaper));

        _defineProperty(HangulShaper, 'zeroMarkWidths', 'NONE');

        const HANGUL_BASE = 0xac00;
        const HANGUL_END = 0xd7a4;
        const HANGUL_COUNT = HANGUL_END - HANGUL_BASE + 1;
        const L_BASE = 0x1100; // lead

        const V_BASE = 0x1161; // vowel

        const T_BASE = 0x11a7; // trail

        const L_COUNT = 19;
        const V_COUNT = 21;
        const T_COUNT = 28;
        const L_END = L_BASE + L_COUNT - 1;
        const V_END = V_BASE + V_COUNT - 1;
        const T_END = T_BASE + T_COUNT - 1;
        const DOTTED_CIRCLE = 0x25cc;

        const isL = function isL(code) {
          return code >= 0x1100 && code <= 0x115f || code >= 0xa960 && code <= 0xa97c;
        };

        const isV = function isV(code) {
          return code >= 0x1160 && code <= 0x11a7 || code >= 0xd7b0 && code <= 0xd7c6;
        };

        const isT = function isT(code) {
          return code >= 0x11a8 && code <= 0x11ff || code >= 0xd7cb && code <= 0xd7fb;
        };

        const isTone = function isTone(code) {
          return code >= 0x302e && code <= 0x302f;
        };

        const isLVT = function isLVT(code) {
          return HANGUL_BASE <= code && code <= HANGUL_END;
        };

        const isLV = function isLV(code) {
          return code - HANGUL_BASE < HANGUL_COUNT && (code - HANGUL_BASE) % T_COUNT === 0;
        };

        const isCombiningL = function isCombiningL(code) {
          return L_BASE <= code && code <= L_END;
        };

        const isCombiningV = function isCombiningV(code) {
          return V_BASE <= code && code <= V_END;
        };

        const isCombiningT = function isCombiningT(code) {
          return code >= 1 && code <= T_END;
        }; // Character categories

        const X = 0; // Other character

        const L = 1; // Leading consonant

        const V = 2; // Medial vowel

        const T = 3; // Trailing consonant

        const LV = 4; // Composed <LV> syllable

        const LVT = 5; // Composed <LVT> syllable

        const M = 6; // Tone mark
        // This function classifies a character using the above categories.

        function getType(code) {
          if (isL(code)) {
            return L;
          }

          if (isV(code)) {
            return V;
          }

          if (isT(code)) {
            return T;
          }

          if (isLV(code)) {
            return LV;
          }

          if (isLVT(code)) {
            return LVT;
          }

          if (isTone(code)) {
            return M;
          }

          return X;
        } // State machine actions

        const NO_ACTION = 0;
        var DECOMPOSE = 1;
        var COMPOSE = 2;
        var TONE_MARK = 4;
        var INVALID = 5; // Build a state machine that accepts valid syllables, and applies actions along the way.
        // The logic this is implementing is documented at the top of the file.

        var STATE_TABLE$1 = [//       X                 L                 V                T                  LV                LVT               M
          // State 0: start state
          [[NO_ACTION, 0], [NO_ACTION, 1], [NO_ACTION, 0], [NO_ACTION, 0], [DECOMPOSE, 2], [DECOMPOSE, 3], [INVALID, 0]], // State 1: <L>
          [[NO_ACTION, 0], [NO_ACTION, 1], [COMPOSE, 2], [NO_ACTION, 0], [DECOMPOSE, 2], [DECOMPOSE, 3], [INVALID, 0]], // State 2: <L,V> or <LV>
          [[NO_ACTION, 0], [NO_ACTION, 1], [NO_ACTION, 0], [COMPOSE, 3], [DECOMPOSE, 2], [DECOMPOSE, 3], [TONE_MARK, 0]], // State 3: <L,V,T> or <LVT>
          [[NO_ACTION, 0], [NO_ACTION, 1], [NO_ACTION, 0], [NO_ACTION, 0], [DECOMPOSE, 2], [DECOMPOSE, 3], [TONE_MARK, 0]]];

        function getGlyph(font, code, features) {
          return new GlyphInfo(font, font.glyphForCodePoint(code).id, [code], features);
        }

        function decompose(glyphs, i, font) {
          const glyph = glyphs[i];
          const code = glyph.codePoints[0];
          let s = code - HANGUL_BASE;
          const t = T_BASE + s % T_COUNT;
          s = s / T_COUNT | 0;
          const l = L_BASE + s / V_COUNT | 0;
          const v = V_BASE + s % V_COUNT; // Don't decompose if all of the components are not available

          if (!font.hasGlyphForCodePoint(l) || !font.hasGlyphForCodePoint(v) || t !== T_BASE && !font.hasGlyphForCodePoint(t)) {
            return i;
          } // Replace the current glyph with decomposed L, V, and T glyphs,
          // and apply the proper OpenType features to each component.

          const ljmo = getGlyph(font, l, glyph.features);
          ljmo.features.ljmo = true;
          const vjmo = getGlyph(font, v, glyph.features);
          vjmo.features.vjmo = true;
          const insert = [ljmo, vjmo];

          if (t > T_BASE) {
            const tjmo = getGlyph(font, t, glyph.features);
            tjmo.features.tjmo = true;
            insert.push(tjmo);
          }

          glyphs.splice.apply(glyphs, [i, 1].concat(insert));
          return i + insert.length - 1;
        }

        function compose(glyphs, i, font) {
          const glyph = glyphs[i];
          const code = glyphs[i].codePoints[0];
          const type = getType(code);
          const prev = glyphs[i - 1].codePoints[0];
          const prevType = getType(prev); // Figure out what type of syllable we're dealing with

          let lv; let ljmo; let vjmo; let
            tjmo;

          if (prevType === LV && type === T) {
            // <LV,T>
            lv = prev;
            tjmo = glyph;
          } else {
            if (type === V) {
              // <L,V>
              ljmo = glyphs[i - 1];
              vjmo = glyph;
            } else {
              // <L,V,T>
              ljmo = glyphs[i - 2];
              vjmo = glyphs[i - 1];
              tjmo = glyph;
            }

            const l = ljmo.codePoints[0];
            const v = vjmo.codePoints[0]; // Make sure L and V are combining characters

            if (isCombiningL(l) && isCombiningV(v)) {
              lv = HANGUL_BASE + ((l - L_BASE) * V_COUNT + (v - V_BASE)) * T_COUNT;
            }
          }

          const t = tjmo && tjmo.codePoints[0] || T_BASE;

          if (lv != null && (t === T_BASE || isCombiningT(t))) {
            const s = lv + (t - T_BASE); // Replace with a composed glyph if supported by the font,
            // otherwise apply the proper OpenType features to each component.

            if (font.hasGlyphForCodePoint(s)) {
              const del = prevType === V ? 3 : 2;
              glyphs.splice(i - del + 1, del, getGlyph(font, s, glyph.features));
              return i - del + 1;
            }
          } // Didn't compose (either a non-combining component or unsupported by font).

          if (ljmo) {
            ljmo.features.ljmo = true;
          }

          if (vjmo) {
            vjmo.features.vjmo = true;
          }

          if (tjmo) {
            tjmo.features.tjmo = true;
          }

          if (prevType === LV) {
            // Sequence was originally <L,V>, which got combined earlier.
            // Either the T was non-combining, or the LVT glyph wasn't supported.
            // Decompose the glyph again and apply OT features.
            decompose(glyphs, i - 1, font);
            return i + 1;
          }

          return i;
        }

        function getLength(code) {
          switch (getType(code)) {
            case LV:
            case LVT:
              return 1;

            case V:
              return 2;

            case T:
              return 3;
          }
        }

        function reorderToneMark(glyphs, i, font) {
          const glyph = glyphs[i];
          const code = glyphs[i].codePoints[0]; // Move tone mark to the beginning of the previous syllable, unless it is zero width

          if (font.glyphForCodePoint(code).advanceWidth === 0) {
            return;
          }

          const prev = glyphs[i - 1].codePoints[0];
          const len = getLength(prev);
          glyphs.splice(i, 1);
          return glyphs.splice(i - len, 0, glyph);
        }

        function insertDottedCircle(glyphs, i, font) {
          const glyph = glyphs[i];
          const code = glyphs[i].codePoints[0];

          if (font.hasGlyphForCodePoint(DOTTED_CIRCLE)) {
            const dottedCircle = getGlyph(font, DOTTED_CIRCLE, glyph.features); // If the tone mark is zero width, insert the dotted circle before, otherwise after

            const idx = font.glyphForCodePoint(code).advanceWidth === 0 ? i : i + 1;
            glyphs.splice(idx, 0, dottedCircle);
            i++;
          }

          return i;
        }

        const stateTable = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 2, 3, 4, 5, 6, 7, 8, 9, 0, 10, 11, 11, 12, 13, 14, 15, 16, 17], [0, 0, 0, 18, 19, 20, 21, 22, 23, 0, 24, 0, 0, 25, 26, 0, 0, 27, 0], [0, 0, 0, 28, 29, 30, 31, 32, 33, 0, 34, 0, 0, 35, 36, 0, 0, 37, 0], [0, 0, 0, 38, 5, 7, 7, 8, 9, 0, 10, 0, 0, 0, 13, 0, 0, 16, 0], [0, 39, 0, 0, 0, 40, 41, 0, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0], [0, 0, 0, 0, 43, 44, 44, 8, 9, 0, 0, 0, 0, 12, 43, 0, 0, 0, 0], [0, 0, 0, 0, 43, 44, 44, 8, 9, 0, 0, 0, 0, 0, 43, 0, 0, 0, 0], [0, 0, 0, 45, 46, 47, 48, 49, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 50, 0, 0, 51, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 52, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 53, 54, 55, 56, 57, 58, 0, 59, 0, 0, 60, 61, 0, 0, 62, 0], [0, 0, 0, 4, 5, 7, 7, 8, 9, 0, 10, 0, 0, 0, 13, 0, 0, 16, 0], [0, 63, 64, 0, 0, 40, 41, 0, 9, 0, 10, 0, 0, 0, 42, 0, 63, 0, 0], [0, 2, 3, 4, 5, 6, 7, 8, 9, 0, 10, 11, 11, 12, 13, 0, 2, 16, 0], [0, 0, 0, 18, 65, 20, 21, 22, 23, 0, 24, 0, 0, 25, 26, 0, 0, 27, 0], [0, 0, 0, 0, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 0, 0], [0, 0, 0, 69, 0, 70, 70, 0, 71, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 73, 19, 74, 74, 22, 23, 0, 24, 0, 0, 0, 26, 0, 0, 27, 0], [0, 75, 0, 0, 0, 76, 77, 0, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0, 0], [0, 0, 0, 0, 79, 80, 80, 22, 23, 0, 0, 0, 0, 25, 79, 0, 0, 0, 0], [0, 0, 0, 18, 19, 20, 74, 22, 23, 0, 24, 0, 0, 25, 26, 0, 0, 27, 0], [0, 0, 0, 81, 82, 83, 84, 85, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 86, 0, 0, 87, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 88, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 18, 19, 74, 74, 22, 23, 0, 24, 0, 0, 0, 26, 0, 0, 27, 0], [0, 89, 90, 0, 0, 76, 77, 0, 23, 0, 24, 0, 0, 0, 78, 0, 89, 0, 0], [0, 0, 0, 0, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 0, 0], [0, 0, 0, 94, 29, 95, 31, 32, 33, 0, 34, 0, 0, 0, 36, 0, 0, 37, 0], [0, 96, 0, 0, 0, 97, 98, 0, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0, 0], [0, 0, 0, 0, 100, 101, 101, 32, 33, 0, 0, 0, 0, 35, 100, 0, 0, 0, 0], [0, 0, 0, 0, 100, 101, 101, 32, 33, 0, 0, 0, 0, 0, 100, 0, 0, 0, 0], [0, 0, 0, 102, 103, 104, 105, 106, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 107, 0, 0, 108, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 109, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 28, 29, 95, 31, 32, 33, 0, 34, 0, 0, 0, 36, 0, 0, 37, 0], [0, 110, 111, 0, 0, 97, 98, 0, 33, 0, 34, 0, 0, 0, 99, 0, 110, 0, 0], [0, 0, 0, 0, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 0, 0], [0, 0, 0, 0, 5, 7, 7, 8, 9, 0, 10, 0, 0, 0, 13, 0, 0, 16, 0], [0, 0, 0, 115, 116, 117, 118, 8, 9, 0, 10, 0, 0, 119, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 39, 0, 122, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0], [0, 124, 64, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 124, 0, 0], [0, 39, 0, 0, 0, 121, 125, 0, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0], [0, 0, 0, 0, 0, 126, 126, 8, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 46, 47, 48, 49, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 47, 47, 49, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 127, 127, 49, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 128, 127, 127, 49, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 129, 130, 131, 132, 133, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 50, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 134, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 135, 54, 56, 56, 57, 58, 0, 59, 0, 0, 0, 61, 0, 0, 62, 0], [0, 136, 0, 0, 0, 137, 138, 0, 58, 0, 59, 0, 0, 0, 139, 0, 136, 0, 0], [0, 0, 0, 0, 140, 141, 141, 57, 58, 0, 0, 0, 0, 60, 140, 0, 0, 0, 0], [0, 0, 0, 0, 140, 141, 141, 57, 58, 0, 0, 0, 0, 0, 140, 0, 0, 0, 0], [0, 0, 0, 142, 143, 144, 145, 146, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 147, 0, 0, 148, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 149, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 53, 54, 56, 56, 57, 58, 0, 59, 0, 0, 0, 61, 0, 0, 62, 0], [0, 150, 151, 0, 0, 137, 138, 0, 58, 0, 59, 0, 0, 0, 139, 0, 150, 0, 0], [0, 0, 0, 0, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 0, 0], [0, 0, 0, 155, 116, 156, 157, 8, 9, 0, 10, 0, 0, 158, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 75, 3, 4, 5, 159, 160, 8, 161, 0, 162, 0, 11, 12, 163, 0, 75, 16, 0], [0, 0, 0, 0, 0, 40, 164, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 165, 44, 44, 8, 9, 0, 0, 0, 0, 0, 165, 0, 0, 0, 0], [0, 124, 64, 0, 0, 40, 164, 0, 9, 0, 10, 0, 0, 0, 42, 0, 124, 0, 0], [0, 0, 0, 0, 0, 70, 70, 0, 71, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 166, 0, 0, 167, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 168, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 19, 74, 74, 22, 23, 0, 24, 0, 0, 0, 26, 0, 0, 27, 0], [0, 0, 0, 0, 79, 80, 80, 22, 23, 0, 0, 0, 0, 0, 79, 0, 0, 0, 0], [0, 0, 0, 169, 170, 171, 172, 22, 23, 0, 24, 0, 0, 173, 174, 0, 0, 27, 0], [0, 0, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 75, 0, 176, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0, 0], [0, 178, 90, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 178, 0, 0], [0, 75, 0, 0, 0, 175, 179, 0, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0, 0], [0, 0, 0, 0, 0, 180, 180, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 82, 83, 84, 85, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 83, 83, 85, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 181, 181, 85, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 182, 181, 181, 85, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 183, 184, 185, 186, 187, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 86, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 188, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 189, 170, 190, 191, 22, 23, 0, 24, 0, 0, 192, 174, 0, 0, 27, 0], [0, 0, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 76, 193, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 194, 80, 80, 22, 23, 0, 0, 0, 0, 0, 194, 0, 0, 0, 0], [0, 178, 90, 0, 0, 76, 193, 0, 23, 0, 24, 0, 0, 0, 78, 0, 178, 0, 0], [0, 0, 0, 0, 29, 95, 31, 32, 33, 0, 34, 0, 0, 0, 36, 0, 0, 37, 0], [0, 0, 0, 0, 100, 101, 101, 32, 33, 0, 0, 0, 0, 0, 100, 0, 0, 0, 0], [0, 0, 0, 195, 196, 197, 198, 32, 33, 0, 34, 0, 0, 199, 200, 0, 0, 37, 0], [0, 0, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 96, 0, 202, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0, 0], [0, 204, 111, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 204, 0, 0], [0, 96, 0, 0, 0, 201, 205, 0, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0, 0], [0, 0, 0, 0, 0, 206, 206, 32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 103, 104, 105, 106, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 104, 104, 106, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 207, 207, 106, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 208, 207, 207, 106, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 209, 210, 211, 212, 213, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 107, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 214, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 215, 196, 216, 217, 32, 33, 0, 34, 0, 0, 218, 200, 0, 0, 37, 0], [0, 0, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 97, 219, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 220, 101, 101, 32, 33, 0, 0, 0, 0, 0, 220, 0, 0, 0, 0], [0, 204, 111, 0, 0, 97, 219, 0, 33, 0, 34, 0, 0, 0, 99, 0, 204, 0, 0], [0, 0, 0, 221, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0, 16, 0], [0, 223, 0, 0, 0, 40, 224, 0, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0, 0], [0, 0, 0, 0, 225, 44, 44, 8, 9, 0, 0, 0, 0, 119, 225, 0, 0, 0, 0], [0, 0, 0, 115, 116, 117, 222, 8, 9, 0, 10, 0, 0, 119, 120, 0, 0, 16, 0], [0, 0, 0, 115, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0, 16, 0], [0, 226, 64, 0, 0, 40, 224, 0, 9, 0, 10, 0, 0, 0, 42, 0, 226, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 39, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0], [0, 0, 0, 0, 0, 44, 44, 8, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 227, 0, 228, 229, 0, 9, 0, 10, 0, 0, 230, 0, 0, 0, 0, 0], [0, 39, 0, 122, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0], [0, 0, 0, 0, 0, 0, 0, 8, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 231, 231, 49, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 232, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 130, 131, 132, 133, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 131, 131, 133, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 233, 233, 133, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 234, 233, 233, 133, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 235, 236, 237, 238, 239, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 54, 56, 56, 57, 58, 0, 59, 0, 0, 0, 61, 0, 0, 62, 0], [0, 0, 0, 240, 241, 242, 243, 57, 58, 0, 59, 0, 0, 244, 245, 0, 0, 62, 0], [0, 0, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 136, 0, 247, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 136, 0, 0], [0, 249, 151, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 249, 0, 0], [0, 136, 0, 0, 0, 246, 250, 0, 58, 0, 59, 0, 0, 0, 139, 0, 136, 0, 0], [0, 0, 0, 0, 0, 251, 251, 57, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 143, 144, 145, 146, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 144, 144, 146, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 252, 252, 146, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 253, 252, 252, 146, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 254, 255, 256, 257, 258, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 147, 0, 0, 0, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 259, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 260, 241, 261, 262, 57, 58, 0, 59, 0, 0, 263, 245, 0, 0, 62, 0], [0, 0, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 137, 264, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 265, 141, 141, 57, 58, 0, 0, 0, 0, 0, 265, 0, 0, 0, 0], [0, 249, 151, 0, 0, 137, 264, 0, 58, 0, 59, 0, 0, 0, 139, 0, 249, 0, 0], [0, 0, 0, 221, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 225, 44, 44, 8, 9, 0, 0, 0, 0, 158, 225, 0, 0, 0, 0], [0, 0, 0, 155, 116, 156, 222, 8, 9, 0, 10, 0, 0, 158, 120, 0, 0, 16, 0], [0, 0, 0, 155, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 43, 266, 266, 8, 161, 0, 24, 0, 0, 12, 267, 0, 0, 0, 0], [0, 75, 0, 176, 43, 268, 268, 269, 161, 0, 24, 0, 0, 0, 267, 0, 75, 0, 0], [0, 0, 0, 0, 0, 270, 0, 0, 271, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 272, 0, 0, 0, 0, 0, 0, 0, 0], [0, 273, 274, 0, 0, 40, 41, 0, 9, 0, 10, 0, 0, 0, 42, 0, 273, 0, 0], [0, 0, 0, 40, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 121, 275, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 166, 0, 0, 0, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 276, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 277, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0, 27, 0], [0, 279, 0, 0, 0, 76, 280, 0, 23, 0, 24, 0, 0, 0, 78, 0, 279, 0, 0], [0, 0, 0, 0, 281, 80, 80, 22, 23, 0, 0, 0, 0, 173, 281, 0, 0, 0, 0], [0, 0, 0, 169, 170, 171, 278, 22, 23, 0, 24, 0, 0, 173, 174, 0, 0, 27, 0], [0, 0, 0, 169, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0, 27, 0], [0, 282, 90, 0, 0, 76, 280, 0, 23, 0, 24, 0, 0, 0, 78, 0, 282, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 75, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0, 0], [0, 0, 0, 0, 0, 80, 80, 22, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 283, 0, 284, 285, 0, 23, 0, 24, 0, 0, 286, 0, 0, 0, 0, 0], [0, 75, 0, 176, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0, 0], [0, 0, 0, 0, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 287, 287, 85, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 288, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 184, 185, 186, 187, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 185, 185, 187, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 289, 289, 187, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 290, 289, 289, 187, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 291, 292, 293, 294, 295, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 277, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0, 27, 0], [0, 0, 0, 0, 281, 80, 80, 22, 23, 0, 0, 0, 0, 192, 281, 0, 0, 0, 0], [0, 0, 0, 189, 170, 190, 278, 22, 23, 0, 24, 0, 0, 192, 174, 0, 0, 27, 0], [0, 0, 0, 189, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0, 27, 0], [0, 0, 0, 76, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 175, 296, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 297, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0, 37, 0], [0, 299, 0, 0, 0, 97, 300, 0, 33, 0, 34, 0, 0, 0, 99, 0, 299, 0, 0], [0, 0, 0, 0, 301, 101, 101, 32, 33, 0, 0, 0, 0, 199, 301, 0, 0, 0, 0], [0, 0, 0, 195, 196, 197, 298, 32, 33, 0, 34, 0, 0, 199, 200, 0, 0, 37, 0], [0, 0, 0, 195, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0, 37, 0], [0, 302, 111, 0, 0, 97, 300, 0, 33, 0, 34, 0, 0, 0, 99, 0, 302, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 96, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0, 0], [0, 0, 0, 0, 0, 101, 101, 32, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 303, 0, 304, 305, 0, 33, 0, 34, 0, 0, 306, 0, 0, 0, 0, 0], [0, 96, 0, 202, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0, 0], [0, 0, 0, 0, 0, 0, 0, 32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 307, 307, 106, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 308, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 210, 211, 212, 213, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 211, 211, 213, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 309, 309, 213, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 310, 309, 309, 213, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 311, 312, 313, 314, 315, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 297, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0, 37, 0], [0, 0, 0, 0, 301, 101, 101, 32, 33, 0, 0, 0, 0, 218, 301, 0, 0, 0, 0], [0, 0, 0, 215, 196, 216, 298, 32, 33, 0, 34, 0, 0, 218, 200, 0, 0, 37, 0], [0, 0, 0, 215, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0, 37, 0], [0, 0, 0, 97, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 201, 316, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 225, 44, 44, 8, 9, 0, 0, 0, 0, 0, 225, 0, 0, 0, 0], [0, 0, 0, 317, 318, 319, 320, 8, 9, 0, 10, 0, 0, 321, 322, 0, 0, 16, 0], [0, 223, 0, 323, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0, 0], [0, 223, 0, 0, 0, 121, 324, 0, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0, 0], [0, 0, 0, 325, 318, 326, 327, 8, 9, 0, 10, 0, 0, 328, 322, 0, 0, 16, 0], [0, 0, 0, 64, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 230, 0, 0, 0, 0, 0], [0, 0, 0, 227, 0, 228, 121, 0, 9, 0, 10, 0, 0, 230, 0, 0, 0, 0, 0], [0, 0, 0, 227, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 49, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 46, 0, 0], [0, 0, 0, 0, 0, 329, 329, 133, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 330, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 236, 237, 238, 239, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 237, 237, 239, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 331, 331, 239, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 332, 331, 331, 239, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 333, 40, 121, 334, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 335, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0, 62, 0], [0, 337, 0, 0, 0, 137, 338, 0, 58, 0, 59, 0, 0, 0, 139, 0, 337, 0, 0], [0, 0, 0, 0, 339, 141, 141, 57, 58, 0, 0, 0, 0, 244, 339, 0, 0, 0, 0], [0, 0, 0, 240, 241, 242, 336, 57, 58, 0, 59, 0, 0, 244, 245, 0, 0, 62, 0], [0, 0, 0, 240, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0, 62, 0], [0, 340, 151, 0, 0, 137, 338, 0, 58, 0, 59, 0, 0, 0, 139, 0, 340, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 136, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 136, 0, 0], [0, 0, 0, 0, 0, 141, 141, 57, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 341, 0, 342, 343, 0, 58, 0, 59, 0, 0, 344, 0, 0, 0, 0, 0], [0, 136, 0, 247, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 136, 0, 0], [0, 0, 0, 0, 0, 0, 0, 57, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 345, 345, 146, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 346, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 255, 256, 257, 258, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 256, 256, 258, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 347, 347, 258, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 348, 347, 347, 258, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 349, 350, 351, 352, 353, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 335, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0, 62, 0], [0, 0, 0, 0, 339, 141, 141, 57, 58, 0, 0, 0, 0, 263, 339, 0, 0, 0, 0], [0, 0, 0, 260, 241, 261, 336, 57, 58, 0, 59, 0, 0, 263, 245, 0, 0, 62, 0], [0, 0, 0, 260, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0, 62, 0], [0, 0, 0, 137, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 246, 354, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 126, 126, 8, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 355, 90, 0, 0, 121, 125, 0, 9, 0, 10, 0, 0, 0, 42, 0, 355, 0, 0], [0, 0, 0, 0, 0, 356, 356, 269, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 357, 358, 359, 360, 361, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 270, 0, 0, 0, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 363, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 364, 116, 365, 366, 8, 161, 0, 162, 0, 0, 367, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 368, 368, 0, 161, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 40, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0, 27, 0], [0, 0, 0, 0, 281, 80, 80, 22, 23, 0, 0, 0, 0, 0, 281, 0, 0, 0, 0], [0, 0, 0, 369, 370, 371, 372, 22, 23, 0, 24, 0, 0, 373, 374, 0, 0, 27, 0], [0, 279, 0, 375, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 279, 0, 0], [0, 279, 0, 0, 0, 175, 376, 0, 23, 0, 24, 0, 0, 0, 78, 0, 279, 0, 0], [0, 0, 0, 377, 370, 378, 379, 22, 23, 0, 24, 0, 0, 380, 374, 0, 0, 27, 0], [0, 0, 0, 90, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 23, 0, 0, 0, 0, 286, 0, 0, 0, 0, 0], [0, 0, 0, 283, 0, 284, 175, 0, 23, 0, 24, 0, 0, 286, 0, 0, 0, 0, 0], [0, 0, 0, 283, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 85, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 82, 0, 0], [0, 0, 0, 0, 0, 381, 381, 187, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 382, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 292, 293, 294, 295, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 293, 293, 295, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 383, 383, 295, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 384, 383, 383, 295, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 385, 76, 175, 386, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 76, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0, 37, 0], [0, 0, 0, 0, 301, 101, 101, 32, 33, 0, 0, 0, 0, 0, 301, 0, 0, 0, 0], [0, 0, 0, 387, 388, 389, 390, 32, 33, 0, 34, 0, 0, 391, 392, 0, 0, 37, 0], [0, 299, 0, 393, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 299, 0, 0], [0, 299, 0, 0, 0, 201, 394, 0, 33, 0, 34, 0, 0, 0, 99, 0, 299, 0, 0], [0, 0, 0, 395, 388, 396, 397, 32, 33, 0, 34, 0, 0, 398, 392, 0, 0, 37, 0], [0, 0, 0, 111, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 33, 0, 0, 0, 0, 306, 0, 0, 0, 0, 0], [0, 0, 0, 303, 0, 304, 201, 0, 33, 0, 34, 0, 0, 306, 0, 0, 0, 0, 0], [0, 0, 0, 303, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 106, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 103, 0, 0], [0, 0, 0, 0, 0, 399, 399, 213, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 400, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 312, 313, 314, 315, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 313, 313, 315, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 401, 401, 315, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 402, 401, 401, 315, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 403, 97, 201, 404, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 97, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 405, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0, 16, 0], [0, 407, 0, 0, 0, 40, 408, 0, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0, 0], [0, 0, 0, 0, 409, 44, 44, 8, 9, 0, 0, 0, 0, 321, 409, 0, 0, 0, 0], [0, 0, 0, 317, 318, 319, 406, 8, 9, 0, 10, 0, 0, 321, 322, 0, 0, 16, 0], [0, 0, 0, 317, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0, 16, 0], [0, 410, 64, 0, 0, 40, 408, 0, 9, 0, 10, 0, 0, 0, 42, 0, 410, 0, 0], [0, 223, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0, 0], [0, 223, 0, 323, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0, 0], [0, 0, 0, 405, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0, 16, 0], [0, 0, 0, 0, 409, 44, 44, 8, 9, 0, 0, 0, 0, 328, 409, 0, 0, 0, 0], [0, 0, 0, 325, 318, 326, 406, 8, 9, 0, 10, 0, 0, 328, 322, 0, 0, 16, 0], [0, 0, 0, 325, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0, 16, 0], [0, 0, 0, 0, 0, 0, 0, 133, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 130, 0, 0], [0, 0, 0, 0, 0, 411, 411, 239, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 412, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 40, 121, 334, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 413, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0, 62, 0], [0, 0, 0, 0, 339, 141, 141, 57, 58, 0, 0, 0, 0, 0, 339, 0, 0, 0, 0], [0, 0, 0, 414, 415, 416, 417, 57, 58, 0, 59, 0, 0, 418, 419, 0, 0, 62, 0], [0, 337, 0, 420, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 337, 0, 0], [0, 337, 0, 0, 0, 246, 421, 0, 58, 0, 59, 0, 0, 0, 139, 0, 337, 0, 0], [0, 0, 0, 422, 415, 423, 424, 57, 58, 0, 59, 0, 0, 425, 419, 0, 0, 62, 0], [0, 0, 0, 151, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 58, 0, 0, 0, 0, 344, 0, 0, 0, 0, 0], [0, 0, 0, 341, 0, 342, 246, 0, 58, 0, 59, 0, 0, 344, 0, 0, 0, 0, 0], [0, 0, 0, 341, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 146, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 143, 0, 0], [0, 0, 0, 0, 0, 426, 426, 258, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 427, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 350, 351, 352, 353, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 351, 351, 353, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 428, 428, 353, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 429, 428, 428, 353, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 430, 137, 246, 431, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 137, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 432, 116, 433, 434, 8, 161, 0, 162, 0, 0, 435, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 180, 180, 269, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 358, 359, 360, 361, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 359, 359, 361, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 436, 436, 361, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 437, 436, 436, 361, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 438, 439, 440, 441, 442, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 443, 274, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 443, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 444, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 225, 44, 44, 8, 161, 0, 0, 0, 0, 367, 225, 0, 0, 0, 0], [0, 0, 0, 364, 116, 365, 445, 8, 161, 0, 162, 0, 0, 367, 120, 0, 0, 16, 0], [0, 0, 0, 364, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 0, 0, 0, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 446, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0, 27, 0], [0, 448, 0, 0, 0, 76, 449, 0, 23, 0, 24, 0, 0, 0, 78, 0, 448, 0, 0], [0, 0, 0, 0, 450, 80, 80, 22, 23, 0, 0, 0, 0, 373, 450, 0, 0, 0, 0], [0, 0, 0, 369, 370, 371, 447, 22, 23, 0, 24, 0, 0, 373, 374, 0, 0, 27, 0], [0, 0, 0, 369, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0, 27, 0], [0, 451, 90, 0, 0, 76, 449, 0, 23, 0, 24, 0, 0, 0, 78, 0, 451, 0, 0], [0, 279, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 279, 0, 0], [0, 279, 0, 375, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 279, 0, 0], [0, 0, 0, 446, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0, 27, 0], [0, 0, 0, 0, 450, 80, 80, 22, 23, 0, 0, 0, 0, 380, 450, 0, 0, 0, 0], [0, 0, 0, 377, 370, 378, 447, 22, 23, 0, 24, 0, 0, 380, 374, 0, 0, 27, 0], [0, 0, 0, 377, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0, 27, 0], [0, 0, 0, 0, 0, 0, 0, 187, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 184, 0, 0], [0, 0, 0, 0, 0, 452, 452, 295, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 453, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 76, 175, 386, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 454, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 455, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0, 37, 0], [0, 457, 0, 0, 0, 97, 458, 0, 33, 0, 34, 0, 0, 0, 99, 0, 457, 0, 0], [0, 0, 0, 0, 459, 101, 101, 32, 33, 0, 0, 0, 0, 391, 459, 0, 0, 0, 0], [0, 0, 0, 387, 388, 389, 456, 32, 33, 0, 34, 0, 0, 391, 392, 0, 0, 37, 0], [0, 0, 0, 387, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0, 37, 0], [0, 460, 111, 0, 0, 97, 458, 0, 33, 0, 34, 0, 0, 0, 99, 0, 460, 0, 0], [0, 299, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 299, 0, 0], [0, 299, 0, 393, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 299, 0, 0], [0, 0, 0, 455, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0, 37, 0], [0, 0, 0, 0, 459, 101, 101, 32, 33, 0, 0, 0, 0, 398, 459, 0, 0, 0, 0], [0, 0, 0, 395, 388, 396, 456, 32, 33, 0, 34, 0, 0, 398, 392, 0, 0, 37, 0], [0, 0, 0, 395, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0, 37, 0], [0, 0, 0, 0, 0, 0, 0, 213, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 210, 0, 0], [0, 0, 0, 0, 0, 461, 461, 315, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 462, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 97, 201, 404, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 463, 0, 0, 0, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0, 16, 0], [0, 0, 0, 0, 409, 44, 44, 8, 9, 0, 0, 0, 0, 0, 409, 0, 0, 0, 0], [0, 0, 0, 464, 465, 466, 467, 8, 9, 0, 10, 0, 0, 468, 469, 0, 0, 16, 0], [0, 407, 0, 470, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0, 0], [0, 407, 0, 0, 0, 121, 471, 0, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0, 0], [0, 0, 0, 472, 465, 473, 474, 8, 9, 0, 10, 0, 0, 475, 469, 0, 0, 16, 0], [0, 0, 0, 0, 0, 0, 0, 239, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 236, 0, 0], [0, 0, 0, 0, 0, 0, 476, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 477, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0, 62, 0], [0, 479, 0, 0, 0, 137, 480, 0, 58, 0, 59, 0, 0, 0, 139, 0, 479, 0, 0], [0, 0, 0, 0, 481, 141, 141, 57, 58, 0, 0, 0, 0, 418, 481, 0, 0, 0, 0], [0, 0, 0, 414, 415, 416, 478, 57, 58, 0, 59, 0, 0, 418, 419, 0, 0, 62, 0], [0, 0, 0, 414, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0, 62, 0], [0, 482, 151, 0, 0, 137, 480, 0, 58, 0, 59, 0, 0, 0, 139, 0, 482, 0, 0], [0, 337, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 337, 0, 0], [0, 337, 0, 420, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 337, 0, 0], [0, 0, 0, 477, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0, 62, 0], [0, 0, 0, 0, 481, 141, 141, 57, 58, 0, 0, 0, 0, 425, 481, 0, 0, 0, 0], [0, 0, 0, 422, 415, 423, 478, 57, 58, 0, 59, 0, 0, 425, 419, 0, 0, 62, 0], [0, 0, 0, 422, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0, 62, 0], [0, 0, 0, 0, 0, 0, 0, 258, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 255, 0, 0], [0, 0, 0, 0, 0, 483, 483, 353, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 484, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 137, 246, 431, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 485, 0, 0, 0, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 444, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 225, 44, 44, 8, 161, 0, 0, 0, 0, 435, 225, 0, 0, 0, 0], [0, 0, 0, 432, 116, 433, 445, 8, 161, 0, 162, 0, 0, 435, 120, 0, 0, 16, 0], [0, 0, 0, 432, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 486, 486, 361, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 487, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 439, 440, 441, 442, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 440, 440, 442, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 488, 488, 442, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 489, 488, 488, 442, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 490, 491, 492, 493, 494, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 495, 0, 496, 497, 0, 161, 0, 162, 0, 0, 498, 0, 0, 0, 0, 0], [0, 0, 0, 0, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 225, 44, 44, 8, 161, 0, 0, 0, 0, 0, 225, 0, 0, 0, 0], [0, 0, 0, 0, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0, 27, 0], [0, 0, 0, 0, 450, 80, 80, 22, 23, 0, 0, 0, 0, 0, 450, 0, 0, 0, 0], [0, 0, 0, 499, 500, 501, 502, 22, 23, 0, 24, 0, 0, 503, 504, 0, 0, 27, 0], [0, 448, 0, 505, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 448, 0, 0], [0, 448, 0, 0, 0, 175, 506, 0, 23, 0, 24, 0, 0, 0, 78, 0, 448, 0, 0], [0, 0, 0, 507, 500, 508, 509, 22, 23, 0, 24, 0, 0, 510, 504, 0, 0, 27, 0], [0, 0, 0, 0, 0, 0, 0, 295, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 292, 0, 0], [0, 0, 0, 0, 0, 0, 511, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0, 37, 0], [0, 0, 0, 0, 459, 101, 101, 32, 33, 0, 0, 0, 0, 0, 459, 0, 0, 0, 0], [0, 0, 0, 512, 513, 514, 515, 32, 33, 0, 34, 0, 0, 516, 517, 0, 0, 37, 0], [0, 457, 0, 518, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 457, 0, 0], [0, 457, 0, 0, 0, 201, 519, 0, 33, 0, 34, 0, 0, 0, 99, 0, 457, 0, 0], [0, 0, 0, 520, 513, 521, 522, 32, 33, 0, 34, 0, 0, 523, 517, 0, 0, 37, 0], [0, 0, 0, 0, 0, 0, 0, 315, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 312, 0, 0], [0, 0, 0, 0, 0, 0, 524, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 525, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0, 16, 0], [0, 527, 0, 0, 0, 40, 528, 0, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0, 0], [0, 0, 0, 0, 529, 44, 44, 8, 9, 0, 0, 0, 0, 468, 529, 0, 0, 0, 0], [0, 0, 0, 464, 465, 466, 526, 8, 9, 0, 10, 0, 0, 468, 469, 0, 0, 16, 0], [0, 0, 0, 464, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0, 16, 0], [0, 530, 64, 0, 0, 40, 528, 0, 9, 0, 10, 0, 0, 0, 42, 0, 530, 0, 0], [0, 407, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0, 0], [0, 407, 0, 470, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0, 0], [0, 0, 0, 525, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0, 16, 0], [0, 0, 0, 0, 529, 44, 44, 8, 9, 0, 0, 0, 0, 475, 529, 0, 0, 0, 0], [0, 0, 0, 472, 465, 473, 526, 8, 9, 0, 10, 0, 0, 475, 469, 0, 0, 16, 0], [0, 0, 0, 472, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0, 16, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 40, 0, 0], [0, 0, 0, 0, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0, 62, 0], [0, 0, 0, 0, 481, 141, 141, 57, 58, 0, 0, 0, 0, 0, 481, 0, 0, 0, 0], [0, 0, 0, 531, 532, 533, 534, 57, 58, 0, 59, 0, 0, 535, 536, 0, 0, 62, 0], [0, 479, 0, 537, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 479, 0, 0], [0, 479, 0, 0, 0, 246, 538, 0, 58, 0, 59, 0, 0, 0, 139, 0, 479, 0, 0], [0, 0, 0, 539, 532, 540, 541, 57, 58, 0, 59, 0, 0, 542, 536, 0, 0, 62, 0], [0, 0, 0, 0, 0, 0, 0, 353, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 350, 0, 0], [0, 0, 0, 0, 0, 0, 543, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 361, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 358, 0, 0], [0, 0, 0, 0, 0, 544, 544, 442, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 545, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 491, 492, 493, 494, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 492, 492, 494, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 546, 546, 494, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 547, 546, 546, 494, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 548, 549, 368, 550, 0, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 274, 0, 368, 368, 0, 161, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 161, 0, 0, 0, 0, 498, 0, 0, 0, 0, 0], [0, 0, 0, 495, 0, 496, 368, 0, 161, 0, 162, 0, 0, 498, 0, 0, 0, 0, 0], [0, 0, 0, 495, 0, 368, 368, 0, 161, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 551, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0, 27, 0], [0, 553, 0, 0, 0, 76, 554, 0, 23, 0, 24, 0, 0, 0, 78, 0, 553, 0, 0], [0, 0, 0, 0, 555, 80, 80, 22, 23, 0, 0, 0, 0, 503, 555, 0, 0, 0, 0], [0, 0, 0, 499, 500, 501, 552, 22, 23, 0, 24, 0, 0, 503, 504, 0, 0, 27, 0], [0, 0, 0, 499, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0, 27, 0], [0, 556, 90, 0, 0, 76, 554, 0, 23, 0, 24, 0, 0, 0, 78, 0, 556, 0, 0], [0, 448, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 448, 0, 0], [0, 448, 0, 505, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 448, 0, 0], [0, 0, 0, 551, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0, 27, 0], [0, 0, 0, 0, 555, 80, 80, 22, 23, 0, 0, 0, 0, 510, 555, 0, 0, 0, 0], [0, 0, 0, 507, 500, 508, 552, 22, 23, 0, 24, 0, 0, 510, 504, 0, 0, 27, 0], [0, 0, 0, 507, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0, 27, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 76, 0, 0], [0, 0, 0, 557, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0, 37, 0], [0, 559, 0, 0, 0, 97, 560, 0, 33, 0, 34, 0, 0, 0, 99, 0, 559, 0, 0], [0, 0, 0, 0, 561, 101, 101, 32, 33, 0, 0, 0, 0, 516, 561, 0, 0, 0, 0], [0, 0, 0, 512, 513, 514, 558, 32, 33, 0, 34, 0, 0, 516, 517, 0, 0, 37, 0], [0, 0, 0, 512, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0, 37, 0], [0, 562, 111, 0, 0, 97, 560, 0, 33, 0, 34, 0, 0, 0, 99, 0, 562, 0, 0], [0, 457, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 457, 0, 0], [0, 457, 0, 518, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 457, 0, 0], [0, 0, 0, 557, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0, 37, 0], [0, 0, 0, 0, 561, 101, 101, 32, 33, 0, 0, 0, 0, 523, 561, 0, 0, 0, 0], [0, 0, 0, 520, 513, 521, 558, 32, 33, 0, 34, 0, 0, 523, 517, 0, 0, 37, 0], [0, 0, 0, 520, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0, 37, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 97, 0, 0], [0, 0, 0, 0, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0, 16, 0], [0, 0, 0, 0, 529, 44, 44, 8, 9, 0, 0, 0, 0, 0, 529, 0, 0, 0, 0], [0, 0, 0, 563, 66, 564, 565, 8, 9, 0, 10, 0, 0, 566, 68, 0, 0, 16, 0], [0, 527, 0, 567, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0, 0], [0, 527, 0, 0, 0, 121, 568, 0, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0, 0], [0, 0, 0, 569, 66, 570, 571, 8, 9, 0, 10, 0, 0, 572, 68, 0, 0, 16, 0], [0, 0, 0, 573, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0, 62, 0], [0, 575, 0, 0, 0, 137, 576, 0, 58, 0, 59, 0, 0, 0, 139, 0, 575, 0, 0], [0, 0, 0, 0, 577, 141, 141, 57, 58, 0, 0, 0, 0, 535, 577, 0, 0, 0, 0], [0, 0, 0, 531, 532, 533, 574, 57, 58, 0, 59, 0, 0, 535, 536, 0, 0, 62, 0], [0, 0, 0, 531, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0, 62, 0], [0, 578, 151, 0, 0, 137, 576, 0, 58, 0, 59, 0, 0, 0, 139, 0, 578, 0, 0], [0, 479, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 479, 0, 0], [0, 479, 0, 537, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 479, 0, 0], [0, 0, 0, 573, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0, 62, 0], [0, 0, 0, 0, 577, 141, 141, 57, 58, 0, 0, 0, 0, 542, 577, 0, 0, 0, 0], [0, 0, 0, 539, 532, 540, 574, 57, 58, 0, 59, 0, 0, 542, 536, 0, 0, 62, 0], [0, 0, 0, 539, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0, 62, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 137, 0, 0], [0, 0, 0, 0, 0, 0, 0, 442, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 439, 0, 0], [0, 0, 0, 0, 0, 579, 579, 494, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 580, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 549, 368, 550, 0, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 368, 368, 0, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 581, 0, 0, 0, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0, 27, 0], [0, 0, 0, 0, 555, 80, 80, 22, 23, 0, 0, 0, 0, 0, 555, 0, 0, 0, 0], [0, 0, 0, 582, 91, 583, 584, 22, 23, 0, 24, 0, 0, 585, 93, 0, 0, 27, 0], [0, 553, 0, 586, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 553, 0, 0], [0, 553, 0, 0, 0, 175, 587, 0, 23, 0, 24, 0, 0, 0, 78, 0, 553, 0, 0], [0, 0, 0, 588, 91, 589, 590, 22, 23, 0, 24, 0, 0, 591, 93, 0, 0, 27, 0], [0, 0, 0, 0, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0, 37, 0], [0, 0, 0, 0, 561, 101, 101, 32, 33, 0, 0, 0, 0, 0, 561, 0, 0, 0, 0], [0, 0, 0, 592, 112, 593, 594, 32, 33, 0, 34, 0, 0, 595, 114, 0, 0, 37, 0], [0, 559, 0, 596, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 559, 0, 0], [0, 559, 0, 0, 0, 201, 597, 0, 33, 0, 34, 0, 0, 0, 99, 0, 559, 0, 0], [0, 0, 0, 598, 112, 599, 600, 32, 33, 0, 34, 0, 0, 601, 114, 0, 0, 37, 0], [0, 0, 0, 602, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0], [0, 0, 0, 0, 165, 44, 44, 8, 9, 0, 0, 0, 0, 566, 165, 0, 0, 0, 0], [0, 0, 0, 563, 66, 564, 67, 8, 9, 0, 10, 0, 0, 566, 68, 0, 0, 16, 0], [0, 0, 0, 563, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0], [0, 527, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0, 0], [0, 527, 0, 567, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0, 0], [0, 0, 0, 602, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0], [0, 0, 0, 0, 165, 44, 44, 8, 9, 0, 0, 0, 0, 572, 165, 0, 0, 0, 0], [0, 0, 0, 569, 66, 570, 67, 8, 9, 0, 10, 0, 0, 572, 68, 0, 0, 16, 0], [0, 0, 0, 569, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0], [0, 0, 0, 0, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0, 62, 0], [0, 0, 0, 0, 577, 141, 141, 57, 58, 0, 0, 0, 0, 0, 577, 0, 0, 0, 0], [0, 0, 0, 603, 152, 604, 605, 57, 58, 0, 59, 0, 0, 606, 154, 0, 0, 62, 0], [0, 575, 0, 607, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 575, 0, 0], [0, 575, 0, 0, 0, 246, 608, 0, 58, 0, 59, 0, 0, 0, 139, 0, 575, 0, 0], [0, 0, 0, 609, 152, 610, 611, 57, 58, 0, 59, 0, 0, 612, 154, 0, 0, 62, 0], [0, 0, 0, 0, 0, 0, 0, 494, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 491, 0, 0], [0, 0, 0, 0, 0, 0, 613, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 614, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27, 0], [0, 0, 0, 0, 194, 80, 80, 22, 23, 0, 0, 0, 0, 585, 194, 0, 0, 0, 0], [0, 0, 0, 582, 91, 583, 92, 22, 23, 0, 24, 0, 0, 585, 93, 0, 0, 27, 0], [0, 0, 0, 582, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27, 0], [0, 553, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 553, 0, 0], [0, 553, 0, 586, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 553, 0, 0], [0, 0, 0, 614, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27, 0], [0, 0, 0, 0, 194, 80, 80, 22, 23, 0, 0, 0, 0, 591, 194, 0, 0, 0, 0], [0, 0, 0, 588, 91, 589, 92, 22, 23, 0, 24, 0, 0, 591, 93, 0, 0, 27, 0], [0, 0, 0, 588, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27, 0], [0, 0, 0, 615, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 37, 0], [0, 0, 0, 0, 220, 101, 101, 32, 33, 0, 0, 0, 0, 595, 220, 0, 0, 0, 0], [0, 0, 0, 592, 112, 593, 113, 32, 33, 0, 34, 0, 0, 595, 114, 0, 0, 37, 0], [0, 0, 0, 592, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 37, 0], [0, 559, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 559, 0, 0], [0, 559, 0, 596, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 559, 0, 0], [0, 0, 0, 615, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 37, 0], [0, 0, 0, 0, 220, 101, 101, 32, 33, 0, 0, 0, 0, 601, 220, 0, 0, 0, 0], [0, 0, 0, 598, 112, 599, 113, 32, 33, 0, 34, 0, 0, 601, 114, 0, 0, 37, 0], [0, 0, 0, 598, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 37, 0], [0, 0, 0, 0, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0], [0, 0, 0, 616, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 62, 0], [0, 0, 0, 0, 265, 141, 141, 57, 58, 0, 0, 0, 0, 606, 265, 0, 0, 0, 0], [0, 0, 0, 603, 152, 604, 153, 57, 58, 0, 59, 0, 0, 606, 154, 0, 0, 62, 0], [0, 0, 0, 603, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 62, 0], [0, 575, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 575, 0, 0], [0, 575, 0, 607, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 575, 0, 0], [0, 0, 0, 616, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 62, 0], [0, 0, 0, 0, 265, 141, 141, 57, 58, 0, 0, 0, 0, 612, 265, 0, 0, 0, 0], [0, 0, 0, 609, 152, 610, 153, 57, 58, 0, 59, 0, 0, 612, 154, 0, 0, 62, 0], [0, 0, 0, 609, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 62, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 549, 0, 0], [0, 0, 0, 0, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27, 0], [0, 0, 0, 0, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 37, 0], [0, 0, 0, 0, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 62, 0]];
        const accepting = [false, true, true, true, true, true, false, false, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, false, true, false, true, true, false, false, true, true, true, true, true, true, false, false, true, true, true, true, true, true, true, true, true, true, false, true, true, false, true, true, true, false, true, true, true, false, true, false, true, true, false, false, true, true, true, true, true, true, true, false, true, true, false, true, true, true, false, true, false, true, true, false, false, true, true, true, true, true, true, true, false, true, true, true, false, true, true, true, false, true, false, true, true, false, false, false, true, true, false, false, true, true, true, true, true, true, false, true, false, true, true, false, false, true, true, true, true, true, true, true, false, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, false, true, false, true, true, false, false, false, true, true, false, false, true, true, true, false, true, true, true, true, true, true, false, true, true, true, false, true, false, true, true, false, false, false, true, true, false, false, true, true, true, false, true, true, true, true, true, false, true, true, true, true, true, false, true, true, false, false, false, false, true, true, false, false, true, true, true, false, true, true, true, false, true, false, true, true, false, false, false, true, true, false, false, true, true, true, false, true, true, true, true, false, true, false, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, false, true, true, false, false, false, false, true, true, false, false, true, true, true, false, true, true, true, true, true, false, true, true, false, false, false, false, true, true, false, false, true, true, true, true, false, true, true, true, true, true, true, false, true, true, false, false, false, false, true, false, true, false, true, true, true, true, true, false, true, true, false, false, false, false, true, true, false, false, true, true, true, false, true, true, false, false, true, false, true, true, false, true, true, false, true, true, false, true, true, true, true, true, true, false, true, true, false, false, false, false, true, false, true, true, false, true, true, true, true, true, true, false, true, true, false, false, false, false, true, false, true, false, true, true, true, true, false, false, false, true, true, false, true, true, true, true, true, true, false, true, true, false, false, false, false, true, false, true, false, true, true, false, false, true, true, false, false, true, true, true, false, true, false, true, true, true, true, false, false, false, true, false, true, true, true, true, false, false, false, true, true, false, true, true, true, true, true, true, false, true, true, false, true, false, true, true, true, true, false, false, false, false, false, false, false, true, true, false, false, true, true, false, true, true, true, true, false, true, true, true, true, true, true, false, true, true, false, true, true, false, true, true, true, true, true, true, false, true, true, false, true, false, true, true, true, true, true, true, false, true, true, true, true, true, true, false, true, true, false, false, false, false, false, true, true, false, true, false, true, true, true, true, true, false, true, true, true, true, true, false, true, true, true, true, true, false, true, true, true, false, true, true, true, true, false, false, false, true, false, true, true, true, true, true, false, true, true, true, false, true, true, true, true, true, false, true, true, true, true, false, true, true, true, true, true, false, true, true, false, true, true, true];
        const tags = [[], ['broken_cluster'], ['consonant_syllable'], ['vowel_syllable'], ['broken_cluster'], ['broken_cluster'], [], [], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['standalone_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['consonant_syllable'], ['broken_cluster'], ['symbol_cluster'], ['consonant_syllable'], ['consonant_syllable'], [], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], ['vowel_syllable'], ['vowel_syllable'], [], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], [], ['broken_cluster'], [], ['broken_cluster'], ['broken_cluster'], [], [], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['standalone_cluster'], ['standalone_cluster'], [], [], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], ['broken_cluster'], ['broken_cluster'], ['consonant_syllable', 'broken_cluster'], ['broken_cluster'], [], ['broken_cluster'], ['symbol_cluster'], [], ['symbol_cluster'], ['symbol_cluster'], ['consonant_syllable'], [], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], [], ['consonant_syllable'], [], ['consonant_syllable'], ['consonant_syllable'], [], [], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], [], ['consonant_syllable'], ['vowel_syllable'], [], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], [], ['vowel_syllable'], [], ['vowel_syllable'], ['vowel_syllable'], [], [], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], [], ['vowel_syllable'], ['broken_cluster'], ['broken_cluster'], [], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], [], ['broken_cluster'], [], ['broken_cluster'], ['broken_cluster'], [], [], [], ['broken_cluster'], ['broken_cluster'], [], [], ['broken_cluster'], ['broken_cluster'], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], [], ['standalone_cluster'], [], ['standalone_cluster'], ['standalone_cluster'], [], [], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], [], ['standalone_cluster'], ['broken_cluster'], [], ['broken_cluster'], ['broken_cluster'], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable', 'broken_cluster'], ['consonant_syllable', 'broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['symbol_cluster'], ['symbol_cluster'], ['symbol_cluster'], ['consonant_syllable'], ['consonant_syllable'], [], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], [], ['consonant_syllable'], [], ['consonant_syllable'], ['consonant_syllable'], [], [], [], ['consonant_syllable'], ['consonant_syllable'], [], [], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], [], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], ['vowel_syllable'], ['vowel_syllable'], [], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], [], ['vowel_syllable'], [], ['vowel_syllable'], ['vowel_syllable'], [], [], [], ['vowel_syllable'], ['vowel_syllable'], [], [], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], [], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], ['broken_cluster'], [], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], [], ['broken_cluster'], ['broken_cluster'], [], [], [], [], ['broken_cluster'], ['broken_cluster'], [], [], ['broken_cluster'], ['standalone_cluster'], ['standalone_cluster'], [], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], [], ['standalone_cluster'], [], ['standalone_cluster'], ['standalone_cluster'], [], [], [], ['standalone_cluster'], ['standalone_cluster'], [], [], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], [], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], [], ['broken_cluster'], [], ['consonant_syllable', 'broken_cluster'], ['consonant_syllable', 'broken_cluster'], ['consonant_syllable', 'broken_cluster'], ['consonant_syllable', 'broken_cluster'], ['consonant_syllable', 'broken_cluster'], ['consonant_syllable', 'broken_cluster'], ['broken_cluster'], ['symbol_cluster'], ['consonant_syllable'], [], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], [], ['consonant_syllable'], ['consonant_syllable'], [], [], [], [], ['consonant_syllable'], ['consonant_syllable'], [], [], ['consonant_syllable'], ['consonant_syllable'], ['vowel_syllable'], [], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], [], ['vowel_syllable'], ['vowel_syllable'], [], [], [], [], ['vowel_syllable'], ['vowel_syllable'], [], [], ['vowel_syllable'], ['vowel_syllable'], ['broken_cluster'], ['broken_cluster'], [], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], [], ['broken_cluster'], ['broken_cluster'], [], [], [], [], ['broken_cluster'], [], ['standalone_cluster'], [], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], [], ['standalone_cluster'], ['standalone_cluster'], [], [], [], [], ['standalone_cluster'], ['standalone_cluster'], [], [], ['standalone_cluster'], ['standalone_cluster'], ['consonant_syllable', 'broken_cluster'], [], ['consonant_syllable', 'broken_cluster'], ['consonant_syllable', 'broken_cluster'], [], [], ['consonant_syllable', 'broken_cluster'], [], ['consonant_syllable', 'broken_cluster'], ['consonant_syllable', 'broken_cluster'], [], ['consonant_syllable', 'broken_cluster'], ['consonant_syllable', 'broken_cluster'], [], ['consonant_syllable'], ['consonant_syllable'], [], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], [], ['consonant_syllable'], ['consonant_syllable'], [], [], [], [], ['consonant_syllable'], [], ['vowel_syllable'], ['vowel_syllable'], [], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], [], ['vowel_syllable'], ['vowel_syllable'], [], [], [], [], ['vowel_syllable'], [], ['broken_cluster'], [], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], [], [], [], ['standalone_cluster'], ['standalone_cluster'], [], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], [], ['standalone_cluster'], ['standalone_cluster'], [], [], [], [], ['standalone_cluster'], [], ['consonant_syllable', 'broken_cluster'], [], ['consonant_syllable', 'broken_cluster'], ['consonant_syllable', 'broken_cluster'], [], [], ['consonant_syllable', 'broken_cluster'], ['consonant_syllable', 'broken_cluster'], [], [], ['consonant_syllable', 'broken_cluster'], ['consonant_syllable', 'broken_cluster'], ['consonant_syllable', 'broken_cluster'], [], ['consonant_syllable'], [], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], [], [], [], ['vowel_syllable'], [], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], [], [], [], ['broken_cluster'], ['broken_cluster'], [], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], [], ['broken_cluster'], ['broken_cluster'], [], ['standalone_cluster'], [], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], [], [], [], [], [], [], [], ['consonant_syllable', 'broken_cluster'], ['consonant_syllable', 'broken_cluster'], [], [], ['consonant_syllable', 'broken_cluster'], ['consonant_syllable', 'broken_cluster'], [], ['consonant_syllable', 'broken_cluster'], ['consonant_syllable', 'broken_cluster'], ['consonant_syllable'], ['consonant_syllable'], [], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], [], ['consonant_syllable'], ['consonant_syllable'], [], ['vowel_syllable'], ['vowel_syllable'], [], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], [], ['vowel_syllable'], ['vowel_syllable'], [], ['broken_cluster'], [], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['standalone_cluster'], ['standalone_cluster'], [], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], [], ['standalone_cluster'], ['standalone_cluster'], [], [], [], [], [], ['consonant_syllable', 'broken_cluster'], ['consonant_syllable', 'broken_cluster'], [], ['consonant_syllable'], [], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], ['vowel_syllable'], [], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], ['broken_cluster'], [], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], [], ['broken_cluster'], ['broken_cluster'], ['standalone_cluster'], [], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], [], [], [], ['consonant_syllable'], [], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], ['consonant_syllable'], [], ['consonant_syllable'], ['consonant_syllable'], ['vowel_syllable'], [], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], ['vowel_syllable'], [], ['vowel_syllable'], ['vowel_syllable'], ['broken_cluster'], ['standalone_cluster'], [], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], ['standalone_cluster'], [], ['standalone_cluster'], ['standalone_cluster'], [], ['consonant_syllable'], ['vowel_syllable'], ['standalone_cluster']];
        const indicMachine = {
          stateTable,
          accepting,
          tags,
        };
        const categories = ['O', 'IND', 'S', 'GB', 'B', 'FM', 'CGJ', 'VMAbv', 'VMPst', 'VAbv', 'VPst', 'CMBlw', 'VPre', 'VBlw', 'H', 'VMBlw', 'CMAbv', 'MBlw', 'CS', 'R', 'SUB', 'MPst', 'MPre', 'FAbv', 'FPst', 'FBlw', 'null', 'SMAbv', 'SMBlw', 'VMPre', 'ZWNJ', 'ZWJ', 'WJ', 'M', 'VS', 'N', 'HN', 'MAbv'];
        const decompositions = {
          2507: [2503, 2494],
          2508: [2503, 2519],
          2888: [2887, 2902],
          2891: [2887, 2878],
          2892: [2887, 2903],
          3018: [3014, 3006],
          3019: [3015, 3006],
          3020: [3014, 3031],
          3144: [3142, 3158],
          3264: [3263, 3285],
          3271: [3270, 3285],
          3272: [3270, 3286],
          3274: [3270, 3266],
          3275: [3270, 3266, 3285],
          3402: [3398, 3390],
          3403: [3399, 3390],
          3404: [3398, 3415],
          3546: [3545, 3530],
          3548: [3545, 3535],
          3549: [3545, 3535, 3530],
          3550: [3545, 3551],
          3635: [3661, 3634],
          3763: [3789, 3762],
          3955: [3953, 3954],
          3957: [3953, 3956],
          3958: [4018, 3968],
          3959: [4018, 3953, 3968],
          3960: [4019, 3968],
          3961: [4019, 3953, 3968],
          3969: [3953, 3968],
          6971: [6970, 6965],
          6973: [6972, 6965],
          6976: [6974, 6965],
          6977: [6975, 6965],
          6979: [6978, 6965],
          69934: [69937, 69927],
          69935: [69938, 69927],
          70475: [70471, 70462],
          70476: [70471, 70487],
          70843: [70841, 70842],
          70844: [70841, 70832],
          70846: [70841, 70845],
          71098: [71096, 71087],
          71099: [71097, 71087],
        };
        const stateTable$1 = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [2, 2, 3, 4, 4, 5, 0, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 0, 17, 18, 11, 19, 20, 21, 22, 0, 0, 0, 23, 0, 0, 2, 0, 0, 24, 0, 25], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 26, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 27, 28, 0, 0, 0, 0, 0, 27, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 39, 0, 0, 47], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 0, 12, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 0, 9, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 10, 11, 12, 13, 14, 0, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 11, 12, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 0, 9, 0, 0, 12, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 18, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 0, 7, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 11, 12, 0, 14, 0, 0, 0, 0, 0, 11, 0, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 4, 4, 5, 0, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 48, 11, 12, 13, 14, 48, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 49, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 11, 12, 0, 14, 0, 16, 0, 0, 0, 11, 0, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 21, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 50, 0, 51, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 11, 12, 0, 14, 0, 16, 0, 0, 0, 11, 0, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 27, 28, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 28, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 0, 0, 0, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 0, 31, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 0, 36, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 0, 33, 0, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 34, 35, 36, 37, 38, 0, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 47], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 35, 36, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 0, 33, 0, 0, 36, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 41, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 0, 31, 0, 0, 0, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 47], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 35, 36, 0, 38, 0, 0, 0, 0, 0, 35, 0, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 52, 35, 36, 37, 38, 52, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 53, 0, 0, 47], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 35, 36, 0, 38, 0, 40, 0, 0, 0, 35, 0, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 47], [0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 44, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 0, 0, 0, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 35, 36, 0, 38, 0, 40, 0, 0, 0, 35, 0, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 48, 11, 12, 13, 14, 0, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 48, 11, 12, 13, 14, 48, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 51, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 54, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 52, 35, 36, 37, 38, 0, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 47], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 52, 35, 36, 37, 38, 52, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 47], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 50, 0, 51, 0]];
        const accepting$1 = [false, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true];
        const tags$1 = [[], ['broken_cluster'], ['independent_cluster'], ['symbol_cluster'], ['standard_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], [], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['broken_cluster'], ['numeral_cluster'], ['broken_cluster'], ['independent_cluster'], ['symbol_cluster'], ['symbol_cluster'], ['standard_cluster'], ['standard_cluster'], ['standard_cluster'], ['standard_cluster'], ['standard_cluster'], ['standard_cluster'], ['standard_cluster'], ['standard_cluster'], ['virama_terminated_cluster'], ['standard_cluster'], ['standard_cluster'], ['standard_cluster'], ['standard_cluster'], ['standard_cluster'], ['standard_cluster'], ['standard_cluster'], ['standard_cluster'], ['standard_cluster'], ['standard_cluster'], ['broken_cluster'], ['broken_cluster'], ['numeral_cluster'], ['number_joiner_terminated_cluster'], ['standard_cluster'], ['standard_cluster'], ['numeral_cluster']];
        const useData = {
          categories,
          decompositions,
          stateTable: stateTable$1,
          accepting: accepting$1,
          tags: tags$1,
        }; // Cateories used in the OpenType spec:
        // https://www.microsoft.com/typography/otfntdev/devanot/shaping.aspx

        const CATEGORIES = {
          X: 1 << 0,
          C: 1 << 1,
          V: 1 << 2,
          N: 1 << 3,
          H: 1 << 4,
          ZWNJ: 1 << 5,
          ZWJ: 1 << 6,
          M: 1 << 7,
          SM: 1 << 8,
          VD: 1 << 9,
          A: 1 << 10,
          Placeholder: 1 << 11,
          Dotted_Circle: 1 << 12,
          RS: 1 << 13,
          // Register Shifter, used in Khmer OT spec.
          Coeng: 1 << 14,
          // Khmer-style Virama.
          Repha: 1 << 15,
          // Atomically-encoded logical or visual repha.
          Ra: 1 << 16,
          CM: 1 << 17,
          // Consonant-Medial.
          Symbol: 1 << 18, // Avagraha, etc that take marks (SM,A,VD).

        }; // Visual positions in a syllable from left to right.

        const POSITIONS = {
          Start: 1 << 0,
          Ra_To_Become_Reph: 1 << 1,
          Pre_M: 1 << 2,
          Pre_C: 1 << 3,
          Base_C: 1 << 4,
          After_Main: 1 << 5,
          Above_C: 1 << 6,
          Before_Sub: 1 << 7,
          Below_C: 1 << 8,
          After_Sub: 1 << 9,
          Before_Post: 1 << 10,
          Post_C: 1 << 11,
          After_Post: 1 << 12,
          Final_C: 1 << 13,
          SMVD: 1 << 14,
          End: 1 << 15,
        };
        const CONSONANT_FLAGS = CATEGORIES.C | CATEGORIES.Ra | CATEGORIES.CM | CATEGORIES.V | CATEGORIES.Placeholder | CATEGORIES.Dotted_Circle;
        const JOINER_FLAGS = CATEGORIES.ZWJ | CATEGORIES.ZWNJ;
        const HALANT_OR_COENG_FLAGS = CATEGORIES.H | CATEGORIES.Coeng;
        const INDIC_CONFIGS = {
          Default: {
            hasOldSpec: false,
            virama: 0,
            basePos: 'Last',
            rephPos: POSITIONS.Before_Post,
            rephMode: 'Implicit',
            blwfMode: 'Pre_And_Post',
          },
          Devanagari: {
            hasOldSpec: true,
            virama: 0x094D,
            basePos: 'Last',
            rephPos: POSITIONS.Before_Post,
            rephMode: 'Implicit',
            blwfMode: 'Pre_And_Post',
          },
          Bengali: {
            hasOldSpec: true,
            virama: 0x09CD,
            basePos: 'Last',
            rephPos: POSITIONS.After_Sub,
            rephMode: 'Implicit',
            blwfMode: 'Pre_And_Post',
          },
          Gurmukhi: {
            hasOldSpec: true,
            virama: 0x0A4D,
            basePos: 'Last',
            rephPos: POSITIONS.Before_Sub,
            rephMode: 'Implicit',
            blwfMode: 'Pre_And_Post',
          },
          Gujarati: {
            hasOldSpec: true,
            virama: 0x0ACD,
            basePos: 'Last',
            rephPos: POSITIONS.Before_Post,
            rephMode: 'Implicit',
            blwfMode: 'Pre_And_Post',
          },
          Oriya: {
            hasOldSpec: true,
            virama: 0x0B4D,
            basePos: 'Last',
            rephPos: POSITIONS.After_Main,
            rephMode: 'Implicit',
            blwfMode: 'Pre_And_Post',
          },
          Tamil: {
            hasOldSpec: true,
            virama: 0x0BCD,
            basePos: 'Last',
            rephPos: POSITIONS.After_Post,
            rephMode: 'Implicit',
            blwfMode: 'Pre_And_Post',
          },
          Telugu: {
            hasOldSpec: true,
            virama: 0x0C4D,
            basePos: 'Last',
            rephPos: POSITIONS.After_Post,
            rephMode: 'Explicit',
            blwfMode: 'Post_Only',
          },
          Kannada: {
            hasOldSpec: true,
            virama: 0x0CCD,
            basePos: 'Last',
            rephPos: POSITIONS.After_Post,
            rephMode: 'Implicit',
            blwfMode: 'Post_Only',
          },
          Malayalam: {
            hasOldSpec: true,
            virama: 0x0D4D,
            basePos: 'Last',
            rephPos: POSITIONS.After_Main,
            rephMode: 'Log_Repha',
            blwfMode: 'Pre_And_Post',
          },
          // Handled by UniversalShaper
          // Sinhala: {
          //   hasOldSpec: false,
          //   virama: 0x0DCA,
          //   basePos: 'Last_Sinhala',
          //   rephPos: POSITIONS.After_Main,
          //   rephMode: 'Explicit',
          //   blwfMode: 'Pre_And_Post'
          // },
          Khmer: {
            hasOldSpec: false,
            virama: 0x17D2,
            basePos: 'First',
            rephPos: POSITIONS.Ra_To_Become_Reph,
            rephMode: 'Vis_Repha',
            blwfMode: 'Pre_And_Post',
          },
        }; // Additional decompositions that aren't in Unicode

        const INDIC_DECOMPOSITIONS = {
          // Khmer
          0x17BE: [0x17C1, 0x17BE],
          0x17BF: [0x17C1, 0x17BF],
          0x17C0: [0x17C1, 0x17C0],
          0x17C4: [0x17C1, 0x17C4],
          0x17C5: [0x17C1, 0x17C5],
        };
        const decompositions$1 = useData.decompositions;
        const trie$1 = new UnicodeTrie(Buffer('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', 'base64'));
        const stateMachine = new StateMachine(indicMachine);
        /**
 * The IndicShaper supports indic scripts e.g. Devanagari, Kannada, etc.
 * Based on code from Harfbuzz: https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-complex-indic.cc
 */

        const IndicShaper = /* #__PURE__ */(function (_DefaultShaper3) {
          _inheritsLoose(IndicShaper, _DefaultShaper3);

          function IndicShaper() {
            return _DefaultShaper3.apply(this, arguments) || this;
          }

          IndicShaper.planFeatures = function planFeatures(plan) {
            plan.addStage(setupSyllables);
            plan.addStage(['locl', 'ccmp']);
            plan.addStage(initialReordering);
            plan.addStage('nukt');
            plan.addStage('akhn');
            plan.addStage('rphf', false);
            plan.addStage('rkrf');
            plan.addStage('pref', false);
            plan.addStage('blwf', false);
            plan.addStage('abvf', false);
            plan.addStage('half', false);
            plan.addStage('pstf', false);
            plan.addStage('vatu');
            plan.addStage('cjct');
            plan.addStage('cfar', false);
            plan.addStage(finalReordering);
            plan.addStage({
              local: ['init'],
              global: ['pres', 'abvs', 'blws', 'psts', 'haln', 'dist', 'abvm', 'blwm', 'calt', 'clig'],
            }); // Setup the indic config for the selected script

            plan.unicodeScript = fromOpenType(plan.script);
            plan.indicConfig = INDIC_CONFIGS[plan.unicodeScript] || INDIC_CONFIGS.Default;
            plan.isOldSpec = plan.indicConfig.hasOldSpec && plan.script[plan.script.length - 1] !== '2'; // TODO: turn off kern (Khmer) and liga features.
          };

          IndicShaper.assignFeatures = function assignFeatures(plan, glyphs) {
            const _loop = function _loop(i) {
              const codepoint = glyphs[i].codePoints[0];
              const d = INDIC_DECOMPOSITIONS[codepoint] || decompositions$1[codepoint];

              if (d) {
                const decomposed = d.map((c) => {
                  const g = plan.font.glyphForCodePoint(c);
                  return new GlyphInfo(plan.font, g.id, [c], glyphs[i].features);
                });
                glyphs.splice.apply(glyphs, [i, 1].concat(decomposed));
              }
            }; // Decompose split matras
            // TODO: do this in a more general unicode normalizer

            for (let i = glyphs.length - 1; i >= 0; i--) {
              _loop(i);
            }
          };

          return IndicShaper;
        }(DefaultShaper));

        _defineProperty(IndicShaper, 'zeroMarkWidths', 'NONE');

        function indicCategory(glyph) {
          return trie$1.get(glyph.codePoints[0]) >> 8;
        }

        function indicPosition(glyph) {
          return 1 << (trie$1.get(glyph.codePoints[0]) & 0xff);
        }

        const IndicInfo = function IndicInfo(category, position, syllableType, syllable) {
          this.category = category;
          this.position = position;
          this.syllableType = syllableType;
          this.syllable = syllable;
        };

        function setupSyllables(font, glyphs) {
          let syllable = 0;
          let last = 0;

          for (var _iterator53 = _createForOfIteratorHelperLoose(stateMachine.match(glyphs.map(indicCategory))), _step53; !(_step53 = _iterator53()).done;) {
            const _step53$value = _step53.value;
            const start = _step53$value[0];
            const end = _step53$value[1];
            const tags = _step53$value[2];

            if (start > last) {
              ++syllable;

              for (let i = last; i < start; i++) {
                glyphs[i].shaperInfo = new IndicInfo(CATEGORIES.X, POSITIONS.End, 'non_indic_cluster', syllable);
              }
            }

            ++syllable; // Create shaper info

            for (let _i = start; _i <= end; _i++) {
              glyphs[_i].shaperInfo = new IndicInfo(1 << indicCategory(glyphs[_i]), indicPosition(glyphs[_i]), tags[0], syllable);
            }

            last = end + 1;
          }

          if (last < glyphs.length) {
            ++syllable;

            for (let _i2 = last; _i2 < glyphs.length; _i2++) {
              glyphs[_i2].shaperInfo = new IndicInfo(CATEGORIES.X, POSITIONS.End, 'non_indic_cluster', syllable);
            }
          }
        }

        function isConsonant(glyph) {
          return glyph.shaperInfo.category & CONSONANT_FLAGS;
        }

        function isJoiner(glyph) {
          return glyph.shaperInfo.category & JOINER_FLAGS;
        }

        function isHalantOrCoeng(glyph) {
          return glyph.shaperInfo.category & HALANT_OR_COENG_FLAGS;
        }

        function wouldSubstitute(glyphs, feature) {
          for (var _iterator54 = _createForOfIteratorHelperLoose(glyphs), _step54; !(_step54 = _iterator54()).done;) {
            var _glyph$features;

            const glyph = _step54.value;
            glyph.features = (_glyph$features = {}, _glyph$features[feature] = true, _glyph$features);
          }

          const GSUB = glyphs[0]._font._layoutEngine.engine.GSUBProcessor;
          GSUB.applyFeatures([feature], glyphs);
          return glyphs.length === 1;
        }

        function consonantPosition(font, consonant, virama) {
          const glyphs = [virama, consonant, virama];

          if (wouldSubstitute(glyphs.slice(0, 2), 'blwf') || wouldSubstitute(glyphs.slice(1, 3), 'blwf')) {
            return POSITIONS.Below_C;
          } if (wouldSubstitute(glyphs.slice(0, 2), 'pstf') || wouldSubstitute(glyphs.slice(1, 3), 'pstf')) {
            return POSITIONS.Post_C;
          } if (wouldSubstitute(glyphs.slice(0, 2), 'pref') || wouldSubstitute(glyphs.slice(1, 3), 'pref')) {
            return POSITIONS.Post_C;
          }

          return POSITIONS.Base_C;
        }

        function initialReordering(font, glyphs, plan) {
          const { indicConfig } = plan;
          const { features } = font._layoutEngine.engine.GSUBProcessor;
          const dottedCircle = font.glyphForCodePoint(0x25cc).id;
          const virama = font.glyphForCodePoint(indicConfig.virama).id;

          if (virama) {
            const info = new GlyphInfo(font, virama, [indicConfig.virama]);

            for (let i = 0; i < glyphs.length; i++) {
              if (glyphs[i].shaperInfo.position === POSITIONS.Base_C) {
                glyphs[i].shaperInfo.position = consonantPosition(font, glyphs[i].copy(), info);
              }
            }
          }

          for (let start = 0, end = nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = nextSyllable(glyphs, start)) {
            const _glyphs$start$shaperI = glyphs[start].shaperInfo;
            const { category } = _glyphs$start$shaperI;
            const { syllableType } = _glyphs$start$shaperI;

            if (syllableType === 'symbol_cluster' || syllableType === 'non_indic_cluster') {
              continue;
            }

            if (syllableType === 'broken_cluster' && dottedCircle) {
              const g = new GlyphInfo(font, dottedCircle, [0x25cc]);
              g.shaperInfo = new IndicInfo(1 << indicCategory(g), indicPosition(g), glyphs[start].shaperInfo.syllableType, glyphs[start].shaperInfo.syllable); // Insert after possible Repha.

              let _i3 = start;

              while (_i3 < end && glyphs[_i3].shaperInfo.category === CATEGORIES.Repha) {
                _i3++;
              }

              glyphs.splice(_i3++, 0, g);
              end++;
            } // 1. Find base consonant:
            //
            // The shaping engine finds the base consonant of the syllable, using the
            // following algorithm: starting from the end of the syllable, move backwards
            // until a consonant is found that does not have a below-base or post-base
            // form (post-base forms have to follow below-base forms), or that is not a
            // pre-base reordering Ra, or arrive at the first consonant. The consonant
            // stopped at will be the base.

            let base = end;
            let limit = start;
            let hasReph = false; // If the syllable starts with Ra + Halant (in a script that has Reph)
            // and has more than one consonant, Ra is excluded from candidates for
            // base consonants.

            if (indicConfig.rephPos !== POSITIONS.Ra_To_Become_Reph && features.rphf && start + 3 <= end && (indicConfig.rephMode === 'Implicit' && !isJoiner(glyphs[start + 2]) || indicConfig.rephMode === 'Explicit' && glyphs[start + 2].shaperInfo.category === CATEGORIES.ZWJ)) {
              // See if it matches the 'rphf' feature.
              const _g = [glyphs[start].copy(), glyphs[start + 1].copy(), glyphs[start + 2].copy()];

              if (wouldSubstitute(_g.slice(0, 2), 'rphf') || indicConfig.rephMode === 'Explicit' && wouldSubstitute(_g, 'rphf')) {
                limit += 2;

                while (limit < end && isJoiner(glyphs[limit])) {
                  limit++;
                }

                base = start;
                hasReph = true;
              }
            } else if (indicConfig.rephMode === 'Log_Repha' && glyphs[start].shaperInfo.category === CATEGORIES.Repha) {
              limit++;

              while (limit < end && isJoiner(glyphs[limit])) {
                limit++;
              }

              base = start;
              hasReph = true;
            }

            switch (indicConfig.basePos) {
              case 'Last':
              {
                // starting from the end of the syllable, move backwards
                let _i4 = end;
                let seenBelow = false;

                do {
                  const _info = glyphs[--_i4].shaperInfo; // until a consonant is found

                  if (isConsonant(glyphs[_i4])) {
                    // that does not have a below-base or post-base form
                    // (post-base forms have to follow below-base forms),
                    if (_info.position !== POSITIONS.Below_C && (_info.position !== POSITIONS.Post_C || seenBelow)) {
                      base = _i4;
                      break;
                    } // or that is not a pre-base reordering Ra,
                    //
                    // IMPLEMENTATION NOTES:
                    //
                    // Our pre-base reordering Ra's are marked POS_POST_C, so will be skipped
                    // by the logic above already.
                    //
                    // or arrive at the first consonant. The consonant stopped at will
                    // be the base.

                    if (_info.position === POSITIONS.Below_C) {
                      seenBelow = true;
                    }

                    base = _i4;
                  } else if (start < _i4 && _info.category === CATEGORIES.ZWJ && glyphs[_i4 - 1].shaperInfo.category === CATEGORIES.H) {
                    // A ZWJ after a Halant stops the base search, and requests an explicit
                    // half form.
                    // A ZWJ before a Halant, requests a subjoined form instead, and hence
                    // search continues.  This is particularly important for Bengali
                    // sequence Ra,H,Ya that should form Ya-Phalaa by subjoining Ya.
                    break;
                  }
                } while (_i4 > limit);

                break;
              }

              case 'First':
              {
                // The first consonant is always the base.
                base = start; // Mark all subsequent consonants as below.

                for (let _i5 = base + 1; _i5 < end; _i5++) {
                  if (isConsonant(glyphs[_i5])) {
                    glyphs[_i5].shaperInfo.position = POSITIONS.Below_C;
                  }
                }
              }
            } // If the syllable starts with Ra + Halant (in a script that has Reph)
            // and has more than one consonant, Ra is excluded from candidates for
            // base consonants.
            //
            //  Only do this for unforced Reph. (ie. not for Ra,H,ZWJ)

            if (hasReph && base === start && limit - base <= 2) {
              hasReph = false;
            } // 2. Decompose and reorder Matras:
            //
            // Each matra and any syllable modifier sign in the cluster are moved to the
            // appropriate position relative to the consonant(s) in the cluster. The
            // shaping engine decomposes two- or three-part matras into their constituent
            // parts before any repositioning. Matra characters are classified by which
            // consonant in a conjunct they have affinity for and are reordered to the
            // following positions:
            //
            //   o Before first half form in the syllable
            //   o After subjoined consonants
            //   o After post-form consonant
            //   o After main consonant (for above marks)
            //
            // IMPLEMENTATION NOTES:
            //
            // The normalize() routine has already decomposed matras for us, so we don't
            // need to worry about that.
            // 3.  Reorder marks to canonical order:
            //
            // Adjacent nukta and halant or nukta and vedic sign are always repositioned
            // if necessary, so that the nukta is first.
            //
            // IMPLEMENTATION NOTES:
            //
            // We don't need to do this: the normalize() routine already did this for us.
            // Reorder characters

            for (let _i6 = start; _i6 < base; _i6++) {
              const _info2 = glyphs[_i6].shaperInfo;
              _info2.position = Math.min(POSITIONS.Pre_C, _info2.position);
            }

            if (base < end) {
              glyphs[base].shaperInfo.position = POSITIONS.Base_C;
            } // Mark final consonants.  A final consonant is one appearing after a matra,
            // like in Khmer.

            for (let _i7 = base + 1; _i7 < end; _i7++) {
              if (glyphs[_i7].shaperInfo.category === CATEGORIES.M) {
                for (let j = _i7 + 1; j < end; j++) {
                  if (isConsonant(glyphs[j])) {
                    glyphs[j].shaperInfo.position = POSITIONS.Final_C;
                    break;
                  }
                }

                break;
              }
            } // Handle beginning Ra

            if (hasReph) {
              glyphs[start].shaperInfo.position = POSITIONS.Ra_To_Become_Reph;
            } // For old-style Indic script tags, move the first post-base Halant after
            // last consonant.
            //
            // Reports suggest that in some scripts Uniscribe does this only if there
            // is *not* a Halant after last consonant already (eg. Kannada), while it
            // does it unconditionally in other scripts (eg. Malayalam).  We don't
            // currently know about other scripts, so we single out Malayalam for now.
            //
            // Kannada test case:
            // U+0C9A,U+0CCD,U+0C9A,U+0CCD
            // With some versions of Lohit Kannada.
            // https://bugs.freedesktop.org/show_bug.cgi?id=59118
            //
            // Malayalam test case:
            // U+0D38,U+0D4D,U+0D31,U+0D4D,U+0D31,U+0D4D
            // With lohit-ttf-20121122/Lohit-Malayalam.ttf

            if (plan.isOldSpec) {
              const disallowDoubleHalants = plan.unicodeScript !== 'Malayalam';

              for (let _i8 = base + 1; _i8 < end; _i8++) {
                if (glyphs[_i8].shaperInfo.category === CATEGORIES.H) {
                  let _j = void 0;

                  for (_j = end - 1; _j > _i8; _j--) {
                    if (isConsonant(glyphs[_j]) || disallowDoubleHalants && glyphs[_j].shaperInfo.category === CATEGORIES.H) {
                      break;
                    }
                  }

                  if (glyphs[_j].shaperInfo.category !== CATEGORIES.H && _j > _i8) {
                    // Move Halant to after last consonant.
                    const t = glyphs[_i8];
                    glyphs.splice.apply(glyphs, [_i8, 0].concat(glyphs.splice(_i8 + 1, _j - _i8)));
                    glyphs[_j] = t;
                  }

                  break;
                }
              }
            } // Attach misc marks to previous char to move with them.

            let lastPos = POSITIONS.Start;

            for (let _i9 = start; _i9 < end; _i9++) {
              const _info3 = glyphs[_i9].shaperInfo;

              if (_info3.category & (JOINER_FLAGS | CATEGORIES.N | CATEGORIES.RS | CATEGORIES.CM | HALANT_OR_COENG_FLAGS & _info3.category)) {
                _info3.position = lastPos;

                if (_info3.category === CATEGORIES.H && _info3.position === POSITIONS.Pre_M) {
                  // Uniscribe doesn't move the Halant with Left Matra.
                  // TEST: U+092B,U+093F,U+094DE
                  // We follow.  This is important for the Sinhala
                  // U+0DDA split matra since it decomposes to U+0DD9,U+0DCA
                  // where U+0DD9 is a left matra and U+0DCA is the virama.
                  // We don't want to move the virama with the left matra.
                  // TEST: U+0D9A,U+0DDA
                  for (let _j2 = _i9; _j2 > start; _j2--) {
                    if (glyphs[_j2 - 1].shaperInfo.position !== POSITIONS.Pre_M) {
                      _info3.position = glyphs[_j2 - 1].shaperInfo.position;
                      break;
                    }
                  }
                }
              } else if (_info3.position !== POSITIONS.SMVD) {
                lastPos = _info3.position;
              }
            } // For post-base consonants let them own anything before them
            // since the last consonant or matra.

            let last = base;

            for (let _i10 = base + 1; _i10 < end; _i10++) {
              if (isConsonant(glyphs[_i10])) {
                for (let _j3 = last + 1; _j3 < _i10; _j3++) {
                  if (glyphs[_j3].shaperInfo.position < POSITIONS.SMVD) {
                    glyphs[_j3].shaperInfo.position = glyphs[_i10].shaperInfo.position;
                  }
                }

                last = _i10;
              } else if (glyphs[_i10].shaperInfo.category === CATEGORIES.M) {
                last = _i10;
              }
            }

            const arr = glyphs.slice(start, end);
            arr.sort((a, b) => a.shaperInfo.position - b.shaperInfo.position);
            glyphs.splice.apply(glyphs, [start, arr.length].concat(arr)); // Find base again

            for (let _i11 = start; _i11 < end; _i11++) {
              if (glyphs[_i11].shaperInfo.position === POSITIONS.Base_C) {
                base = _i11;
                break;
              }
            } // Setup features now
            // Reph

            for (let _i12 = start; _i12 < end && glyphs[_i12].shaperInfo.position === POSITIONS.Ra_To_Become_Reph; _i12++) {
              glyphs[_i12].features.rphf = true;
            } // Pre-base

            const blwf = !plan.isOldSpec && indicConfig.blwfMode === 'Pre_And_Post';

            for (let _i13 = start; _i13 < base; _i13++) {
              glyphs[_i13].features.half = true;

              if (blwf) {
                glyphs[_i13].features.blwf = true;
              }
            } // Post-base

            for (let _i14 = base + 1; _i14 < end; _i14++) {
              glyphs[_i14].features.abvf = true;
              glyphs[_i14].features.pstf = true;
              glyphs[_i14].features.blwf = true;
            }

            if (plan.isOldSpec && plan.unicodeScript === 'Devanagari') {
              // Old-spec eye-lash Ra needs special handling.  From the
              // spec:
              //
              // "The feature 'below-base form' is applied to consonants
              // having below-base forms and following the base consonant.
              // The exception is vattu, which may appear below half forms
              // as well as below the base glyph. The feature 'below-base
              // form' will be applied to all such occurrences of Ra as well."
              //
              // Test case: U+0924,U+094D,U+0930,U+094d,U+0915
              // with Sanskrit 2003 font.
              //
              // However, note that Ra,Halant,ZWJ is the correct way to
              // request eyelash form of Ra, so we wouldbn't inhibit it
              // in that sequence.
              //
              // Test case: U+0924,U+094D,U+0930,U+094d,U+200D,U+0915
              for (let _i15 = start; _i15 + 1 < base; _i15++) {
                if (glyphs[_i15].shaperInfo.category === CATEGORIES.Ra && glyphs[_i15 + 1].shaperInfo.category === CATEGORIES.H && (_i15 + 1 === base || glyphs[_i15 + 2].shaperInfo.category === CATEGORIES.ZWJ)) {
                  glyphs[_i15].features.blwf = true;
                  glyphs[_i15 + 1].features.blwf = true;
                }
              }
            }

            const prefLen = 2;

            if (features.pref && base + prefLen < end) {
              // Find a Halant,Ra sequence and mark it for pre-base reordering processing.
              for (let _i16 = base + 1; _i16 + prefLen - 1 < end; _i16++) {
                const _g2 = [glyphs[_i16].copy(), glyphs[_i16 + 1].copy()];

                if (wouldSubstitute(_g2, 'pref')) {
                  for (let _j4 = 0; _j4 < prefLen; _j4++) {
                    glyphs[_i16++].features.pref = true;
                  } // Mark the subsequent stuff with 'cfar'.  Used in Khmer.
                  // Read the feature spec.
                  // This allows distinguishing the following cases with MS Khmer fonts:
                  // U+1784,U+17D2,U+179A,U+17D2,U+1782
                  // U+1784,U+17D2,U+1782,U+17D2,U+179A

                  if (features.cfar) {
                    for (; _i16 < end; _i16++) {
                      glyphs[_i16].features.cfar = true;
                    }
                  }

                  break;
                }
              }
            } // Apply ZWJ/ZWNJ effects

            for (let _i17 = start + 1; _i17 < end; _i17++) {
              if (isJoiner(glyphs[_i17])) {
                const nonJoiner = glyphs[_i17].shaperInfo.category === CATEGORIES.ZWNJ;
                let _j5 = _i17;

                do {
                  _j5--; // ZWJ/ZWNJ should disable CJCT.  They do that by simply
                  // being there, since we don't skip them for the CJCT
                  // feature (ie. F_MANUAL_ZWJ)
                  // A ZWNJ disables HALF.

                  if (nonJoiner) {
                    delete glyphs[_j5].features.half;
                  }
                } while (_j5 > start && !isConsonant(glyphs[_j5]));
              }
            }
          }
        }

        function finalReordering(font, glyphs, plan) {
          const { indicConfig } = plan;
          const { features } = font._layoutEngine.engine.GSUBProcessor;

          for (let start = 0, end = nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = nextSyllable(glyphs, start)) {
            // 4. Final reordering:
            //
            // After the localized forms and basic shaping forms GSUB features have been
            // applied (see below), the shaping engine performs some final glyph
            // reordering before applying all the remaining font features to the entire
            // cluster.
            let tryPref = !!features.pref; // Find base again

            let base = start;

            for (; base < end; base++) {
              if (glyphs[base].shaperInfo.position >= POSITIONS.Base_C) {
                if (tryPref && base + 1 < end) {
                  for (let i = base + 1; i < end; i++) {
                    if (glyphs[i].features.pref) {
                      if (!(glyphs[i].substituted && glyphs[i].isLigated && !glyphs[i].isMultiplied)) {
                        // Ok, this was a 'pref' candidate but didn't form any.
                        // Base is around here...
                        base = i;

                        while (base < end && isHalantOrCoeng(glyphs[base])) {
                          base++;
                        }

                        glyphs[base].shaperInfo.position = POSITIONS.BASE_C;
                        tryPref = false;
                      }

                      break;
                    }
                  }
                } // For Malayalam, skip over unformed below- (but NOT post-) forms.

                if (plan.unicodeScript === 'Malayalam') {
                  for (let _i18 = base + 1; _i18 < end; _i18++) {
                    while (_i18 < end && isJoiner(glyphs[_i18])) {
                      _i18++;
                    }

                    if (_i18 === end || !isHalantOrCoeng(glyphs[_i18])) {
                      break;
                    }

                    _i18++; // Skip halant.

                    while (_i18 < end && isJoiner(glyphs[_i18])) {
                      _i18++;
                    }

                    if (_i18 < end && isConsonant(glyphs[_i18]) && glyphs[_i18].shaperInfo.position === POSITIONS.Below_C) {
                      base = _i18;
                      glyphs[base].shaperInfo.position = POSITIONS.Base_C;
                    }
                  }
                }

                if (start < base && glyphs[base].shaperInfo.position > POSITIONS.Base_C) {
                  base--;
                }

                break;
              }
            }

            if (base === end && start < base && glyphs[base - 1].shaperInfo.category === CATEGORIES.ZWJ) {
              base--;
            }

            if (base < end) {
              while (start < base && glyphs[base].shaperInfo.category & (CATEGORIES.N | HALANT_OR_COENG_FLAGS)) {
                base--;
              }
            } // o Reorder matras:
            //
            // If a pre-base matra character had been reordered before applying basic
            // features, the glyph can be moved closer to the main consonant based on
            // whether half-forms had been formed. Actual position for the matra is
            // defined as “after last standalone halant glyph, after initial matra
            // position and before the main consonant”. If ZWJ or ZWNJ follow this
            // halant, position is moved after it.
            //

            if (start + 1 < end && start < base) {
              // Otherwise there can't be any pre-base matra characters.
              // If we lost track of base, alas, position before last thingy.
              let newPos = base === end ? base - 2 : base - 1; // Malayalam / Tamil do not have "half" forms or explicit virama forms.
              // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
              // We want to position matra after them.

              if (plan.unicodeScript !== 'Malayalam' && plan.unicodeScript !== 'Tamil') {
                while (newPos > start && !(glyphs[newPos].shaperInfo.category & (CATEGORIES.M | HALANT_OR_COENG_FLAGS))) {
                  newPos--;
                } // If we found no Halant we are done.
                // Otherwise only proceed if the Halant does
                // not belong to the Matra itself!

                if (isHalantOrCoeng(glyphs[newPos]) && glyphs[newPos].shaperInfo.position !== POSITIONS.Pre_M) {
                  // If ZWJ or ZWNJ follow this halant, position is moved after it.
                  if (newPos + 1 < end && isJoiner(glyphs[newPos + 1])) {
                    newPos++;
                  }
                } else {
                  newPos = start; // No move.
                }
              }

              if (start < newPos && glyphs[newPos].shaperInfo.position !== POSITIONS.Pre_M) {
                // Now go see if there's actually any matras...
                for (let _i19 = newPos; _i19 > start; _i19--) {
                  if (glyphs[_i19 - 1].shaperInfo.position === POSITIONS.Pre_M) {
                    const oldPos = _i19 - 1;

                    if (oldPos < base && base <= newPos) {
                      // Shouldn't actually happen.
                      base--;
                    }

                    const tmp = glyphs[oldPos];
                    glyphs.splice.apply(glyphs, [oldPos, 0].concat(glyphs.splice(oldPos + 1, newPos - oldPos)));
                    glyphs[newPos] = tmp;
                    newPos--;
                  }
                }
              }
            } // o Reorder reph:
            //
            // Reph’s original position is always at the beginning of the syllable,
            // (i.e. it is not reordered at the character reordering stage). However,
            // it will be reordered according to the basic-forms shaping results.
            // Possible positions for reph, depending on the script, are; after main,
            // before post-base consonant forms, and after post-base consonant forms.
            // Two cases:
            //
            // - If repha is encoded as a sequence of characters (Ra,H or Ra,H,ZWJ), then
            //   we should only move it if the sequence ligated to the repha form.
            //
            // - If repha is encoded separately and in the logical position, we should only
            //   move it if it did NOT ligate.  If it ligated, it's probably the font trying
            //   to make it work without the reordering.

            if (start + 1 < end && glyphs[start].shaperInfo.position === POSITIONS.Ra_To_Become_Reph && glyphs[start].shaperInfo.category === CATEGORIES.Repha !== (glyphs[start].isLigated && !glyphs[start].isMultiplied)) {
              let newRephPos = void 0;
              const { rephPos } = indicConfig;
              let found = false; // 1. If reph should be positioned after post-base consonant forms,
              //    proceed to step 5.

              if (rephPos !== POSITIONS.After_Post) {
                //  2. If the reph repositioning class is not after post-base: target
                //     position is after the first explicit halant glyph between the
                //     first post-reph consonant and last main consonant. If ZWJ or ZWNJ
                //     are following this halant, position is moved after it. If such
                //     position is found, this is the target position. Otherwise,
                //     proceed to the next step.
                //
                //     Note: in old-implementation fonts, where classifications were
                //     fixed in shaping engine, there was no case where reph position
                //     will be found on this step.
                newRephPos = start + 1;

                while (newRephPos < base && !isHalantOrCoeng(glyphs[newRephPos])) {
                  newRephPos++;
                }

                if (newRephPos < base && isHalantOrCoeng(glyphs[newRephPos])) {
                  // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
                  if (newRephPos + 1 < base && isJoiner(glyphs[newRephPos + 1])) {
                    newRephPos++;
                  }

                  found = true;
                } // 3. If reph should be repositioned after the main consonant: find the
                //    first consonant not ligated with main, or find the first
                //    consonant that is not a potential pre-base reordering Ra.

                if (!found && rephPos === POSITIONS.After_Main) {
                  newRephPos = base;

                  while (newRephPos + 1 < end && glyphs[newRephPos + 1].shaperInfo.position <= POSITIONS.After_Main) {
                    newRephPos++;
                  }

                  found = newRephPos < end;
                } // 4. If reph should be positioned before post-base consonant, find
                //    first post-base classified consonant not ligated with main. If no
                //    consonant is found, the target position should be before the
                //    first matra, syllable modifier sign or vedic sign.
                //
                // This is our take on what step 4 is trying to say (and failing, BADLY).

                if (!found && rephPos === POSITIONS.After_Sub) {
                  newRephPos = base;

                  while (newRephPos + 1 < end && !(glyphs[newRephPos + 1].shaperInfo.position & (POSITIONS.Post_C | POSITIONS.After_Post | POSITIONS.SMVD))) {
                    newRephPos++;
                  }

                  found = newRephPos < end;
                }
              } //  5. If no consonant is found in steps 3 or 4, move reph to a position
              //     immediately before the first post-base matra, syllable modifier
              //     sign or vedic sign that has a reordering class after the intended
              //     reph position. For example, if the reordering position for reph
              //     is post-main, it will skip above-base matras that also have a
              //     post-main position.

              if (!found) {
                // Copied from step 2.
                newRephPos = start + 1;

                while (newRephPos < base && !isHalantOrCoeng(glyphs[newRephPos])) {
                  newRephPos++;
                }

                if (newRephPos < base && isHalantOrCoeng(glyphs[newRephPos])) {
                  // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
                  if (newRephPos + 1 < base && isJoiner(glyphs[newRephPos + 1])) {
                    newRephPos++;
                  }

                  found = true;
                }
              } // 6. Otherwise, reorder reph to the end of the syllable.

              if (!found) {
                newRephPos = end - 1;

                while (newRephPos > start && glyphs[newRephPos].shaperInfo.position === POSITIONS.SMVD) {
                  newRephPos--;
                } // If the Reph is to be ending up after a Matra,Halant sequence,
                // position it before that Halant so it can interact with the Matra.
                // However, if it's a plain Consonant,Halant we shouldn't do that.
                // Uniscribe doesn't do this.
                // TEST: U+0930,U+094D,U+0915,U+094B,U+094D

                if (isHalantOrCoeng(glyphs[newRephPos])) {
                  for (let _i20 = base + 1; _i20 < newRephPos; _i20++) {
                    if (glyphs[_i20].shaperInfo.category === CATEGORIES.M) {
                      newRephPos--;
                    }
                  }
                }
              }

              const reph = glyphs[start];
              glyphs.splice.apply(glyphs, [start, 0].concat(glyphs.splice(start + 1, newRephPos - start)));
              glyphs[newRephPos] = reph;

              if (start < base && base <= newRephPos) {
                base--;
              }
            } // o Reorder pre-base reordering consonants:
            //
            // If a pre-base reordering consonant is found, reorder it according to
            // the following rules:

            if (tryPref && base + 1 < end) {
              for (let _i21 = base + 1; _i21 < end; _i21++) {
                if (glyphs[_i21].features.pref) {
                  // 1. Only reorder a glyph produced by substitution during application
                  //    of the <pref> feature. (Note that a font may shape a Ra consonant with
                  //    the feature generally but block it in certain contexts.)
                  // Note: We just check that something got substituted.  We don't check that
                  // the <pref> feature actually did it...
                  //
                  // Reorder pref only if it ligated.
                  if (glyphs[_i21].isLigated && !glyphs[_i21].isMultiplied) {
                    // 2. Try to find a target position the same way as for pre-base matra.
                    //    If it is found, reorder pre-base consonant glyph.
                    //
                    // 3. If position is not found, reorder immediately before main
                    //    consonant.
                    let _newPos = base; // Malayalam / Tamil do not have "half" forms or explicit virama forms.
                    // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
                    // We want to position matra after them.

                    if (plan.unicodeScript !== 'Malayalam' && plan.unicodeScript !== 'Tamil') {
                      while (_newPos > start && !(glyphs[_newPos - 1].shaperInfo.category & (CATEGORIES.M | HALANT_OR_COENG_FLAGS))) {
                        _newPos--;
                      } // In Khmer coeng model, a H,Ra can go *after* matras.  If it goes after a
                      // split matra, it should be reordered to *before* the left part of such matra.

                      if (_newPos > start && glyphs[_newPos - 1].shaperInfo.category === CATEGORIES.M) {
                        const _oldPos2 = _i21;

                        for (let j = base + 1; j < _oldPos2; j++) {
                          if (glyphs[j].shaperInfo.category === CATEGORIES.M) {
                            _newPos--;
                            break;
                          }
                        }
                      }
                    }

                    if (_newPos > start && isHalantOrCoeng(glyphs[_newPos - 1])) {
                      // -> If ZWJ or ZWNJ follow this halant, position is moved after it.
                      if (_newPos < end && isJoiner(glyphs[_newPos])) {
                        _newPos++;
                      }
                    }

                    const _oldPos = _i21;
                    const _tmp = glyphs[_oldPos];
                    glyphs.splice.apply(glyphs, [_newPos + 1, 0].concat(glyphs.splice(_newPos, _oldPos - _newPos)));
                    glyphs[_newPos] = _tmp;

                    if (_newPos <= base && base < _oldPos) {
                      base++;
                    }
                  }

                  break;
                }
              }
            } // Apply 'init' to the Left Matra if it's a word start.

            if (glyphs[start].shaperInfo.position === POSITIONS.Pre_M && (!start || !/Cf|Mn/.test(unicode.getCategory(glyphs[start - 1].codePoints[0])))) {
              glyphs[start].features.init = true;
            }
          }
        }

        function nextSyllable(glyphs, start) {
          if (start >= glyphs.length) return start;
          const { syllable } = glyphs[start].shaperInfo;

          while (++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable) {}

          return start;
        }

        const categories$1 = useData.categories;
        const decompositions$2 = useData.decompositions;
        const trie$2 = new UnicodeTrie(Buffer('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', 'base64'));
        const stateMachine$1 = new StateMachine(useData);
        /**
 * This shaper is an implementation of the Universal Shaping Engine, which
 * uses Unicode data to shape a number of scripts without a dedicated shaping engine.
 * See https://www.microsoft.com/typography/OpenTypeDev/USE/intro.htm.
 */

        const UniversalShaper = /* #__PURE__ */(function (_DefaultShaper4) {
          _inheritsLoose(UniversalShaper, _DefaultShaper4);

          function UniversalShaper() {
            return _DefaultShaper4.apply(this, arguments) || this;
          }

          UniversalShaper.planFeatures = function planFeatures(plan) {
            plan.addStage(setupSyllables$1); // Default glyph pre-processing group

            plan.addStage(['locl', 'ccmp', 'nukt', 'akhn']); // Reordering group

            plan.addStage(clearSubstitutionFlags);
            plan.addStage(['rphf'], false);
            plan.addStage(recordRphf);
            plan.addStage(clearSubstitutionFlags);
            plan.addStage(['pref']);
            plan.addStage(recordPref); // Orthographic unit shaping group

            plan.addStage(['rkrf', 'abvf', 'blwf', 'half', 'pstf', 'vatu', 'cjct']);
            plan.addStage(reorder); // Topographical features
            // Scripts that need this are handled by the Arabic shaper, not implemented here for now.
            // plan.addStage(['isol', 'init', 'medi', 'fina', 'med2', 'fin2', 'fin3'], false);
            // Standard topographic presentation and positional feature application

            plan.addStage(['abvs', 'blws', 'pres', 'psts', 'dist', 'abvm', 'blwm']);
          };

          UniversalShaper.assignFeatures = function assignFeatures(plan, glyphs) {
            const _loop = function _loop(i) {
              const codepoint = glyphs[i].codePoints[0];

              if (decompositions$2[codepoint]) {
                const decomposed = decompositions$2[codepoint].map((c) => {
                  const g = plan.font.glyphForCodePoint(c);
                  return new GlyphInfo(plan.font, g.id, [c], glyphs[i].features);
                });
                glyphs.splice.apply(glyphs, [i, 1].concat(decomposed));
              }
            }; // Decompose split vowels
            // TODO: do this in a more general unicode normalizer

            for (let i = glyphs.length - 1; i >= 0; i--) {
              _loop(i);
            }
          };

          return UniversalShaper;
        }(DefaultShaper));

        _defineProperty(UniversalShaper, 'zeroMarkWidths', 'BEFORE_GPOS');

        function useCategory(glyph) {
          return trie$2.get(glyph.codePoints[0]);
        }

        const USEInfo = function USEInfo(category, syllableType, syllable) {
          this.category = category;
          this.syllableType = syllableType;
          this.syllable = syllable;
        };

        function setupSyllables$1(font, glyphs) {
          let syllable = 0;

          for (var _iterator55 = _createForOfIteratorHelperLoose(stateMachine$1.match(glyphs.map(useCategory))), _step55; !(_step55 = _iterator55()).done;) {
            const _step55$value = _step55.value;
            const start = _step55$value[0];
            const end = _step55$value[1];
            const tags = _step55$value[2];
            ++syllable; // Create shaper info

            for (let i = start; i <= end; i++) {
              glyphs[i].shaperInfo = new USEInfo(categories$1[useCategory(glyphs[i])], tags[0], syllable);
            } // Assign rphf feature

            const limit = glyphs[start].shaperInfo.category === 'R' ? 1 : Math.min(3, end - start);

            for (let _i = start; _i < start + limit; _i++) {
              glyphs[_i].features.rphf = true;
            }
          }
        }

        function clearSubstitutionFlags(font, glyphs) {
          for (var _iterator56 = _createForOfIteratorHelperLoose(glyphs), _step56; !(_step56 = _iterator56()).done;) {
            const glyph = _step56.value;
            glyph.substituted = false;
          }
        }

        function recordRphf(font, glyphs) {
          for (var _iterator57 = _createForOfIteratorHelperLoose(glyphs), _step57; !(_step57 = _iterator57()).done;) {
            const glyph = _step57.value;

            if (glyph.substituted && glyph.features.rphf) {
              // Mark a substituted repha.
              glyph.shaperInfo.category = 'R';
            }
          }
        }

        function recordPref(font, glyphs) {
          for (var _iterator58 = _createForOfIteratorHelperLoose(glyphs), _step58; !(_step58 = _iterator58()).done;) {
            const glyph = _step58.value;

            if (glyph.substituted) {
              // Mark a substituted pref as VPre, as they behave the same way.
              glyph.shaperInfo.category = 'VPre';
            }
          }
        }

        function reorder(font, glyphs) {
          const dottedCircle = font.glyphForCodePoint(0x25cc).id;

          for (let start = 0, end = nextSyllable$1(glyphs, 0); start < glyphs.length; start = end, end = nextSyllable$1(glyphs, start)) {
            let i = void 0;
            let j = void 0;
            let info = glyphs[start].shaperInfo;
            const type = info.syllableType; // Only a few syllable types need reordering.

            if (type !== 'virama_terminated_cluster' && type !== 'standard_cluster' && type !== 'broken_cluster') {
              continue;
            } // Insert a dotted circle glyph in broken clusters.

            if (type === 'broken_cluster' && dottedCircle) {
              const g = new GlyphInfo(font, dottedCircle, [0x25cc]);
              g.shaperInfo = info; // Insert after possible Repha.

              for (i = start; i < end && glyphs[i].shaperInfo.category === 'R'; i++) {}

              glyphs.splice(++i, 0, g);
              end++;
            } // Move things forward.

            if (info.category === 'R' && end - start > 1) {
              // Got a repha. Reorder it to after first base, before first halant.
              for (i = start + 1; i < end; i++) {
                info = glyphs[i].shaperInfo;

                if (isBase(info) || isHalant(glyphs[i])) {
                  // If we hit a halant, move before it; otherwise it's a base: move to it's
                  // place, and shift things in between backward.
                  if (isHalant(glyphs[i])) {
                    i--;
                  }

                  glyphs.splice.apply(glyphs, [start, 0].concat(glyphs.splice(start + 1, i - start), [glyphs[i]]));
                  break;
                }
              }
            } // Move things back.

            for (i = start, j = end; i < end; i++) {
              info = glyphs[i].shaperInfo;

              if (isBase(info) || isHalant(glyphs[i])) {
                // If we hit a halant, move after it; otherwise it's a base: move to it's
                // place, and shift things in between backward.
                j = isHalant(glyphs[i]) ? i + 1 : i;
              } else if ((info.category === 'VPre' || info.category === 'VMPre') && j < i) {
                glyphs.splice.apply(glyphs, [j, 1, glyphs[i]].concat(glyphs.splice(j, i - j)));
              }
            }
          }
        }

        function nextSyllable$1(glyphs, start) {
          if (start >= glyphs.length) return start;
          const { syllable } = glyphs[start].shaperInfo;

          while (++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable) {}

          return start;
        }

        function isHalant(glyph) {
          return glyph.shaperInfo.category === 'H' && !glyph.isLigated;
        }

        function isBase(info) {
          return info.category === 'B' || info.category === 'GB';
        }

        const SHAPERS = {
          arab: ArabicShaper,
          // Arabic
          mong: ArabicShaper,
          // Mongolian
          syrc: ArabicShaper,
          // Syriac
          'nko ': ArabicShaper,
          // N'Ko
          phag: ArabicShaper,
          // Phags Pa
          mand: ArabicShaper,
          // Mandaic
          mani: ArabicShaper,
          // Manichaean
          phlp: ArabicShaper,
          // Psalter Pahlavi
          hang: HangulShaper,
          // Hangul
          bng2: IndicShaper,
          // Bengali
          beng: IndicShaper,
          // Bengali
          dev2: IndicShaper,
          // Devanagari
          deva: IndicShaper,
          // Devanagari
          gjr2: IndicShaper,
          // Gujarati
          gujr: IndicShaper,
          // Gujarati
          guru: IndicShaper,
          // Gurmukhi
          gur2: IndicShaper,
          // Gurmukhi
          knda: IndicShaper,
          // Kannada
          knd2: IndicShaper,
          // Kannada
          mlm2: IndicShaper,
          // Malayalam
          mlym: IndicShaper,
          // Malayalam
          ory2: IndicShaper,
          // Oriya
          orya: IndicShaper,
          // Oriya
          taml: IndicShaper,
          // Tamil
          tml2: IndicShaper,
          // Tamil
          telu: IndicShaper,
          // Telugu
          tel2: IndicShaper,
          // Telugu
          khmr: IndicShaper,
          // Khmer
          bali: UniversalShaper,
          // Balinese
          batk: UniversalShaper,
          // Batak
          brah: UniversalShaper,
          // Brahmi
          bugi: UniversalShaper,
          // Buginese
          buhd: UniversalShaper,
          // Buhid
          cakm: UniversalShaper,
          // Chakma
          cham: UniversalShaper,
          // Cham
          dupl: UniversalShaper,
          // Duployan
          egyp: UniversalShaper,
          // Egyptian Hieroglyphs
          gran: UniversalShaper,
          // Grantha
          hano: UniversalShaper,
          // Hanunoo
          java: UniversalShaper,
          // Javanese
          kthi: UniversalShaper,
          // Kaithi
          kali: UniversalShaper,
          // Kayah Li
          khar: UniversalShaper,
          // Kharoshthi
          khoj: UniversalShaper,
          // Khojki
          sind: UniversalShaper,
          // Khudawadi
          lepc: UniversalShaper,
          // Lepcha
          limb: UniversalShaper,
          // Limbu
          mahj: UniversalShaper,
          // Mahajani
          // mand: UniversalShaper, // Mandaic
          // mani: UniversalShaper, // Manichaean
          mtei: UniversalShaper,
          // Meitei Mayek
          modi: UniversalShaper,
          // Modi
          // mong: UniversalShaper, // Mongolian
          // 'nko ': UniversalShaper, // N’Ko
          hmng: UniversalShaper,
          // Pahawh Hmong
          // phag: UniversalShaper, // Phags-pa
          // phlp: UniversalShaper, // Psalter Pahlavi
          rjng: UniversalShaper,
          // Rejang
          saur: UniversalShaper,
          // Saurashtra
          shrd: UniversalShaper,
          // Sharada
          sidd: UniversalShaper,
          // Siddham
          sinh: UniversalShaper,
          // Sinhala
          sund: UniversalShaper,
          // Sundanese
          sylo: UniversalShaper,
          // Syloti Nagri
          tglg: UniversalShaper,
          // Tagalog
          tagb: UniversalShaper,
          // Tagbanwa
          tale: UniversalShaper,
          // Tai Le
          lana: UniversalShaper,
          // Tai Tham
          tavt: UniversalShaper,
          // Tai Viet
          takr: UniversalShaper,
          // Takri
          tibt: UniversalShaper,
          // Tibetan
          tfng: UniversalShaper,
          // Tifinagh
          tirh: UniversalShaper,
          // Tirhuta
          latn: DefaultShaper,
          // Latin
          DFLT: DefaultShaper, // Default

        };

        function choose(script) {
          if (!Array.isArray(script)) {
            script = [script];
          }

          for (var _iterator59 = _createForOfIteratorHelperLoose(script), _step59; !(_step59 = _iterator59()).done;) {
            const s = _step59.value;
            const shaper = SHAPERS[s];

            if (shaper) {
              return shaper;
            }
          }

          return DefaultShaper;
        }

        const GSUBProcessor = /* #__PURE__ */(function (_OTProcessor) {
          _inheritsLoose(GSUBProcessor, _OTProcessor);

          function GSUBProcessor() {
            return _OTProcessor.apply(this, arguments) || this;
          }

          const _proto27 = GSUBProcessor.prototype;

          _proto27.applyLookup = function applyLookup(lookupType, table) {
            const _this7 = this;

            switch (lookupType) {
              case 1:
              {
                // Single Substitution
                const index = this.coverageIndex(table.coverage);

                if (index === -1) {
                  return false;
                }

                const glyph = this.glyphIterator.cur;

                switch (table.version) {
                  case 1:
                    glyph.id = glyph.id + table.deltaGlyphID & 0xffff;
                    break;

                  case 2:
                    glyph.id = table.substitute.get(index);
                    break;
                }

                return true;
              }

              case 2:
              {
                // Multiple Substitution
                const _index = this.coverageIndex(table.coverage);

                if (_index !== -1) {
                  let _this$glyphs2;

                  const sequence = table.sequences.get(_index);

                  if (sequence.length === 0) {
                    // If the sequence length is zero, delete the glyph.
                    // The OpenType spec disallows this, but seems like Harfbuzz and Uniscribe allow it.
                    this.glyphs.splice(this.glyphIterator.index, 1);
                    return true;
                  }

                  this.glyphIterator.cur.id = sequence[0];
                  this.glyphIterator.cur.ligatureComponent = 0;
                  const { features } = this.glyphIterator.cur;
                  const curGlyph = this.glyphIterator.cur;
                  const replacement = sequence.slice(1).map((gid, i) => {
                    const glyph = new GlyphInfo(_this7.font, gid, undefined, features);
                    glyph.shaperInfo = curGlyph.shaperInfo;
                    glyph.isLigated = curGlyph.isLigated;
                    glyph.ligatureComponent = i + 1;
                    glyph.substituted = true;
                    glyph.isMultiplied = true;
                    return glyph;
                  });

                  (_this$glyphs2 = this.glyphs).splice.apply(_this$glyphs2, [this.glyphIterator.index + 1, 0].concat(replacement));

                  return true;
                }

                return false;
              }

              case 3:
              {
                // Alternate Substitution
                const _index2 = this.coverageIndex(table.coverage);

                if (_index2 !== -1) {
                  const USER_INDEX = 0; // TODO

                  this.glyphIterator.cur.id = table.alternateSet.get(_index2)[USER_INDEX];
                  return true;
                }

                return false;
              }

              case 4:
              {
                // Ligature Substitution
                const _index3 = this.coverageIndex(table.coverage);

                if (_index3 === -1) {
                  return false;
                }

                for (var _iterator60 = _createForOfIteratorHelperLoose(table.ligatureSets.get(_index3)), _step60; !(_step60 = _iterator60()).done;) {
                  const ligature = _step60.value;
                  const matched = this.sequenceMatchIndices(1, ligature.components);

                  if (!matched) {
                    continue;
                  }

                  const _curGlyph = this.glyphIterator.cur; // Concatenate all of the characters the new ligature will represent

                  const characters = _curGlyph.codePoints.slice();

                  for (var _iterator61 = _createForOfIteratorHelperLoose(matched), _step61; !(_step61 = _iterator61()).done;) {
                    const _index4 = _step61.value;
                    characters.push.apply(characters, this.glyphs[_index4].codePoints);
                  } // Create the replacement ligature glyph

                  const ligatureGlyph = new GlyphInfo(this.font, ligature.glyph, characters, _curGlyph.features);
                  ligatureGlyph.shaperInfo = _curGlyph.shaperInfo;
                  ligatureGlyph.isLigated = true;
                  ligatureGlyph.substituted = true; // From Harfbuzz:
                  // - If it *is* a mark ligature, we don't allocate a new ligature id, and leave
                  //   the ligature to keep its old ligature id.  This will allow it to attach to
                  //   a base ligature in GPOS.  Eg. if the sequence is: LAM,LAM,SHADDA,FATHA,HEH,
                  //   and LAM,LAM,HEH for a ligature, they will leave SHADDA and FATHA with a
                  //   ligature id and component value of 2.  Then if SHADDA,FATHA form a ligature
                  //   later, we don't want them to lose their ligature id/component, otherwise
                  //   GPOS will fail to correctly position the mark ligature on top of the
                  //   LAM,LAM,HEH ligature. See https://bugzilla.gnome.org/show_bug.cgi?id=676343
                  //
                  // - If a ligature is formed of components that some of which are also ligatures
                  //   themselves, and those ligature components had marks attached to *their*
                  //   components, we have to attach the marks to the new ligature component
                  //   positions!  Now *that*'s tricky!  And these marks may be following the
                  //   last component of the whole sequence, so we should loop forward looking
                  //   for them and update them.
                  //
                  //   Eg. the sequence is LAM,LAM,SHADDA,FATHA,HEH, and the font first forms a
                  //   'calt' ligature of LAM,HEH, leaving the SHADDA and FATHA with a ligature
                  //   id and component == 1.  Now, during 'liga', the LAM and the LAM-HEH ligature
                  //   form a LAM-LAM-HEH ligature.  We need to reassign the SHADDA and FATHA to
                  //   the new ligature with a component value of 2.
                  //
                  //   This in fact happened to a font...  See https://bugzilla.gnome.org/show_bug.cgi?id=437633

                  let isMarkLigature = _curGlyph.isMark;

                  for (let i = 0; i < matched.length && isMarkLigature; i++) {
                    isMarkLigature = this.glyphs[matched[i]].isMark;
                  }

                  ligatureGlyph.ligatureID = isMarkLigature ? null : this.ligatureID++;
                  let lastLigID = _curGlyph.ligatureID;
                  let lastNumComps = _curGlyph.codePoints.length;
                  let curComps = lastNumComps;
                  let idx = this.glyphIterator.index + 1; // Set ligatureID and ligatureComponent on glyphs that were skipped in the matched sequence.
                  // This allows GPOS to attach marks to the correct ligature components.

                  for (var _iterator62 = _createForOfIteratorHelperLoose(matched), _step62; !(_step62 = _iterator62()).done;) {
                    const matchIndex = _step62.value;

                    // Don't assign new ligature components for mark ligatures (see above)
                    if (isMarkLigature) {
                      idx = matchIndex;
                    } else {
                      while (idx < matchIndex) {
                        var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[idx].ligatureComponent || 1, lastNumComps);
                        this.glyphs[idx].ligatureID = ligatureGlyph.ligatureID;
                        this.glyphs[idx].ligatureComponent = ligatureComponent;
                        idx++;
                      }
                    }

                    lastLigID = this.glyphs[idx].ligatureID;
                    lastNumComps = this.glyphs[idx].codePoints.length;
                    curComps += lastNumComps;
                    idx++; // skip base glyph
                  } // Adjust ligature components for any marks following

                  if (lastLigID && !isMarkLigature) {
                    for (let _i = idx; _i < this.glyphs.length; _i++) {
                      if (this.glyphs[_i].ligatureID === lastLigID) {
                        var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[_i].ligatureComponent || 1, lastNumComps);
                        this.glyphs[_i].ligatureComponent = ligatureComponent;
                      } else {
                        break;
                      }
                    }
                  } // Delete the matched glyphs, and replace the current glyph with the ligature glyph

                  for (let _i2 = matched.length - 1; _i2 >= 0; _i2--) {
                    this.glyphs.splice(matched[_i2], 1);
                  }

                  this.glyphs[this.glyphIterator.index] = ligatureGlyph;
                  return true;
                }

                return false;
              }

              case 5:
                // Contextual Substitution
                return this.applyContext(table);

              case 6:
                // Chaining Contextual Substitution
                return this.applyChainingContext(table);

              case 7:
                // Extension Substitution
                return this.applyLookup(table.lookupType, table.extension);

              default:
                throw new Error('GSUB lookupType '.concat(lookupType, ' is not supported'));
            }
          };

          return GSUBProcessor;
        }(OTProcessor));

        const GPOSProcessor = /* #__PURE__ */(function (_OTProcessor2) {
          _inheritsLoose(GPOSProcessor, _OTProcessor2);

          function GPOSProcessor() {
            return _OTProcessor2.apply(this, arguments) || this;
          }

          const _proto28 = GPOSProcessor.prototype;

          _proto28.applyPositionValue = function applyPositionValue(sequenceIndex, value) {
            const position = this.positions[this.glyphIterator.peekIndex(sequenceIndex)];

            if (value.xAdvance != null) {
              position.xAdvance += value.xAdvance;
            }

            if (value.yAdvance != null) {
              position.yAdvance += value.yAdvance;
            }

            if (value.xPlacement != null) {
              position.xOffset += value.xPlacement;
            }

            if (value.yPlacement != null) {
              position.yOffset += value.yPlacement;
            } // Adjustments for font variations

            const variationProcessor = this.font._variationProcessor;
            const variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;

            if (variationProcessor && variationStore) {
              if (value.xPlaDevice) {
                position.xOffset += variationProcessor.getDelta(variationStore, value.xPlaDevice.a, value.xPlaDevice.b);
              }

              if (value.yPlaDevice) {
                position.yOffset += variationProcessor.getDelta(variationStore, value.yPlaDevice.a, value.yPlaDevice.b);
              }

              if (value.xAdvDevice) {
                position.xAdvance += variationProcessor.getDelta(variationStore, value.xAdvDevice.a, value.xAdvDevice.b);
              }

              if (value.yAdvDevice) {
                position.yAdvance += variationProcessor.getDelta(variationStore, value.yAdvDevice.a, value.yAdvDevice.b);
              }
            } // TODO: device tables
          };

          _proto28.applyLookup = function applyLookup(lookupType, table) {
            switch (lookupType) {
              case 1:
              {
                // Single positioning value
                const index = this.coverageIndex(table.coverage);

                if (index === -1) {
                  return false;
                }

                switch (table.version) {
                  case 1:
                    this.applyPositionValue(0, table.value);
                    break;

                  case 2:
                    this.applyPositionValue(0, table.values.get(index));
                    break;
                }

                return true;
              }

              case 2:
              {
                // Pair Adjustment Positioning
                const nextGlyph = this.glyphIterator.peek();

                if (!nextGlyph) {
                  return false;
                }

                const _index = this.coverageIndex(table.coverage);

                if (_index === -1) {
                  return false;
                }

                switch (table.version) {
                  case 1:
                    // Adjustments for glyph pairs
                    var set = table.pairSets.get(_index);

                    for (var _iterator63 = _createForOfIteratorHelperLoose(set), _step63; !(_step63 = _iterator63()).done;) {
                      const _pair = _step63.value;

                      if (_pair.secondGlyph === nextGlyph.id) {
                        this.applyPositionValue(0, _pair.value1);
                        this.applyPositionValue(1, _pair.value2);
                        return true;
                      }
                    }

                    return false;

                  case 2:
                    // Class pair adjustment
                    var class1 = this.getClassID(this.glyphIterator.cur.id, table.classDef1);
                    var class2 = this.getClassID(nextGlyph.id, table.classDef2);

                    if (class1 === -1 || class2 === -1) {
                      return false;
                    }

                    var pair = table.classRecords.get(class1).get(class2);
                    this.applyPositionValue(0, pair.value1);
                    this.applyPositionValue(1, pair.value2);
                    return true;
                }
              }

              case 3:
              {
                // Cursive Attachment Positioning
                const nextIndex = this.glyphIterator.peekIndex();
                const _nextGlyph = this.glyphs[nextIndex];

                if (!_nextGlyph) {
                  return false;
                }

                const curRecord = table.entryExitRecords[this.coverageIndex(table.coverage)];

                if (!curRecord || !curRecord.exitAnchor) {
                  return false;
                }

                const nextRecord = table.entryExitRecords[this.coverageIndex(table.coverage, _nextGlyph.id)];

                if (!nextRecord || !nextRecord.entryAnchor) {
                  return false;
                }

                const entry = this.getAnchor(nextRecord.entryAnchor);
                const exit = this.getAnchor(curRecord.exitAnchor);
                const cur = this.positions[this.glyphIterator.index];
                const next = this.positions[nextIndex];

                switch (this.direction) {
                  case 'ltr':
                    cur.xAdvance = exit.x + cur.xOffset;
                    var d = entry.x + next.xOffset;
                    next.xAdvance -= d;
                    next.xOffset -= d;
                    break;

                  case 'rtl':
                    d = exit.x + cur.xOffset;
                    cur.xAdvance -= d;
                    cur.xOffset -= d;
                    next.xAdvance = entry.x + next.xOffset;
                    break;
                }

                if (this.glyphIterator.flags.rightToLeft) {
                  this.glyphIterator.cur.cursiveAttachment = nextIndex;
                  cur.yOffset = entry.y - exit.y;
                } else {
                  _nextGlyph.cursiveAttachment = this.glyphIterator.index;
                  cur.yOffset = exit.y - entry.y;
                }

                return true;
              }

              case 4:
              {
                // Mark to base positioning
                const markIndex = this.coverageIndex(table.markCoverage);

                if (markIndex === -1) {
                  return false;
                } // search backward for a base glyph

                let baseGlyphIndex = this.glyphIterator.index;

                while (--baseGlyphIndex >= 0 && (this.glyphs[baseGlyphIndex].isMark || this.glyphs[baseGlyphIndex].ligatureComponent > 0)) {}

                if (baseGlyphIndex < 0) {
                  return false;
                }

                const baseIndex = this.coverageIndex(table.baseCoverage, this.glyphs[baseGlyphIndex].id);

                if (baseIndex === -1) {
                  return false;
                }

                const markRecord = table.markArray[markIndex];
                const baseAnchor = table.baseArray[baseIndex][markRecord.class];
                this.applyAnchor(markRecord, baseAnchor, baseGlyphIndex);
                return true;
              }

              case 5:
              {
                // Mark to ligature positioning
                const _markIndex = this.coverageIndex(table.markCoverage);

                if (_markIndex === -1) {
                  return false;
                } // search backward for a base glyph

                let _baseGlyphIndex = this.glyphIterator.index;

                while (--_baseGlyphIndex >= 0 && this.glyphs[_baseGlyphIndex].isMark) {}

                if (_baseGlyphIndex < 0) {
                  return false;
                }

                const ligIndex = this.coverageIndex(table.ligatureCoverage, this.glyphs[_baseGlyphIndex].id);

                if (ligIndex === -1) {
                  return false;
                }

                const ligAttach = table.ligatureArray[ligIndex];
                const markGlyph = this.glyphIterator.cur;
                const ligGlyph = this.glyphs[_baseGlyphIndex];
                const compIndex = ligGlyph.ligatureID && ligGlyph.ligatureID === markGlyph.ligatureID && markGlyph.ligatureComponent > 0 ? Math.min(markGlyph.ligatureComponent, ligGlyph.codePoints.length) - 1 : ligGlyph.codePoints.length - 1;
                const _markRecord = table.markArray[_markIndex];
                const _baseAnchor = ligAttach[compIndex][_markRecord.class];
                this.applyAnchor(_markRecord, _baseAnchor, _baseGlyphIndex);
                return true;
              }

              case 6:
              {
                // Mark to mark positioning
                const mark1Index = this.coverageIndex(table.mark1Coverage);

                if (mark1Index === -1) {
                  return false;
                } // get the previous mark to attach to

                const prevIndex = this.glyphIterator.peekIndex(-1);
                const prev = this.glyphs[prevIndex];

                if (!prev || !prev.isMark) {
                  return false;
                }

                const _cur = this.glyphIterator.cur; // The following logic was borrowed from Harfbuzz

                let good = false;

                if (_cur.ligatureID === prev.ligatureID) {
                  if (!_cur.ligatureID) {
                    // Marks belonging to the same base
                    good = true;
                  } else if (_cur.ligatureComponent === prev.ligatureComponent) {
                    // Marks belonging to the same ligature component
                    good = true;
                  }
                } else {
                  // If ligature ids don't match, it may be the case that one of the marks
                  // itself is a ligature, in which case match.
                  if (_cur.ligatureID && !_cur.ligatureComponent || prev.ligatureID && !prev.ligatureComponent) {
                    good = true;
                  }
                }

                if (!good) {
                  return false;
                }

                const mark2Index = this.coverageIndex(table.mark2Coverage, prev.id);

                if (mark2Index === -1) {
                  return false;
                }

                const _markRecord2 = table.mark1Array[mark1Index];
                const _baseAnchor2 = table.mark2Array[mark2Index][_markRecord2.class];
                this.applyAnchor(_markRecord2, _baseAnchor2, prevIndex);
                return true;
              }

              case 7:
                // Contextual positioning
                return this.applyContext(table);

              case 8:
                // Chaining contextual positioning
                return this.applyChainingContext(table);

              case 9:
                // Extension positioning
                return this.applyLookup(table.lookupType, table.extension);

              default:
                throw new Error('Unsupported GPOS table: '.concat(lookupType));
            }
          };

          _proto28.applyAnchor = function applyAnchor(markRecord, baseAnchor, baseGlyphIndex) {
            const baseCoords = this.getAnchor(baseAnchor);
            const markCoords = this.getAnchor(markRecord.markAnchor);
            const basePos = this.positions[baseGlyphIndex];
            const markPos = this.positions[this.glyphIterator.index];
            markPos.xOffset = baseCoords.x - markCoords.x;
            markPos.yOffset = baseCoords.y - markCoords.y;
            this.glyphIterator.cur.markAttachment = baseGlyphIndex;
          };

          _proto28.getAnchor = function getAnchor(anchor) {
            // TODO: contour point, device tables
            let x = anchor.xCoordinate;
            let y = anchor.yCoordinate; // Adjustments for font variations

            const variationProcessor = this.font._variationProcessor;
            const variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;

            if (variationProcessor && variationStore) {
              if (anchor.xDeviceTable) {
                x += variationProcessor.getDelta(variationStore, anchor.xDeviceTable.a, anchor.xDeviceTable.b);
              }

              if (anchor.yDeviceTable) {
                y += variationProcessor.getDelta(variationStore, anchor.yDeviceTable.a, anchor.yDeviceTable.b);
              }
            }

            return {
              x,
              y,
            };
          };

          _proto28.applyFeatures = function applyFeatures(userFeatures, glyphs, advances) {
            _OTProcessor2.prototype.applyFeatures.call(this, userFeatures, glyphs, advances);

            for (let i = 0; i < this.glyphs.length; i++) {
              this.fixCursiveAttachment(i);
            }

            this.fixMarkAttachment();
          };

          _proto28.fixCursiveAttachment = function fixCursiveAttachment(i) {
            const glyph = this.glyphs[i];

            if (glyph.cursiveAttachment != null) {
              const j = glyph.cursiveAttachment;
              glyph.cursiveAttachment = null;
              this.fixCursiveAttachment(j);
              this.positions[i].yOffset += this.positions[j].yOffset;
            }
          };

          _proto28.fixMarkAttachment = function fixMarkAttachment() {
            for (let i = 0; i < this.glyphs.length; i++) {
              const glyph = this.glyphs[i];

              if (glyph.markAttachment != null) {
                const j = glyph.markAttachment;
                this.positions[i].xOffset += this.positions[j].xOffset;
                this.positions[i].yOffset += this.positions[j].yOffset;

                if (this.direction === 'ltr') {
                  for (let k = j; k < i; k++) {
                    this.positions[i].xOffset -= this.positions[k].xAdvance;
                    this.positions[i].yOffset -= this.positions[k].yAdvance;
                  }
                } else {
                  for (let _k = j + 1; _k < i + 1; _k++) {
                    this.positions[i].xOffset += this.positions[_k].xAdvance;
                    this.positions[i].yOffset += this.positions[_k].yAdvance;
                  }
                }
              }
            }
          };

          return GPOSProcessor;
        }(OTProcessor));

        const OTLayoutEngine = /* #__PURE__ */(function () {
          function OTLayoutEngine(font) {
            this.font = font;
            this.glyphInfos = null;
            this.plan = null;
            this.GSUBProcessor = null;
            this.GPOSProcessor = null;
            this.fallbackPosition = true;

            if (font.GSUB) {
              this.GSUBProcessor = new GSUBProcessor(font, font.GSUB);
            }

            if (font.GPOS) {
              this.GPOSProcessor = new GPOSProcessor(font, font.GPOS);
            }
          }

          const _proto29 = OTLayoutEngine.prototype;

          _proto29.setup = function setup(glyphRun) {
            const _this8 = this;

            // Map glyphs to GlyphInfo objects so data can be passed between
            // GSUB and GPOS without mutating the real (shared) Glyph objects.
            this.glyphInfos = glyphRun.glyphs.map((glyph) => new GlyphInfo(_this8.font, glyph.id, [].concat(glyph.codePoints))); // Select a script based on what is available in GSUB/GPOS.

            let script = null;

            if (this.GPOSProcessor) {
              script = this.GPOSProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
            }

            if (this.GSUBProcessor) {
              script = this.GSUBProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
            } // Choose a shaper based on the script, and setup a shaping plan.
            // This determines which features to apply to which glyphs.

            this.shaper = choose(script);
            this.plan = new ShapingPlan(this.font, script, glyphRun.direction);
            this.shaper.plan(this.plan, this.glyphInfos, glyphRun.features); // Assign chosen features to output glyph run

            for (const key in this.plan.allFeatures) {
              glyphRun.features[key] = true;
            }
          };

          _proto29.substitute = function substitute(glyphRun) {
            const _this9 = this;

            if (this.GSUBProcessor) {
              this.plan.process(this.GSUBProcessor, this.glyphInfos); // Map glyph infos back to normal Glyph objects

              glyphRun.glyphs = this.glyphInfos.map((glyphInfo) => _this9.font.getGlyph(glyphInfo.id, glyphInfo.codePoints));
            }
          };

          _proto29.position = function position(glyphRun) {
            if (this.shaper.zeroMarkWidths === 'BEFORE_GPOS') {
              this.zeroMarkAdvances(glyphRun.positions);
            }

            if (this.GPOSProcessor) {
              this.plan.process(this.GPOSProcessor, this.glyphInfos, glyphRun.positions);
            }

            if (this.shaper.zeroMarkWidths === 'AFTER_GPOS') {
              this.zeroMarkAdvances(glyphRun.positions);
            } // Reverse the glyphs and positions if the script is right-to-left

            if (glyphRun.direction === 'rtl') {
              glyphRun.glyphs.reverse();
              glyphRun.positions.reverse();
            }

            return this.GPOSProcessor && this.GPOSProcessor.features;
          };

          _proto29.zeroMarkAdvances = function zeroMarkAdvances(positions) {
            for (let i = 0; i < this.glyphInfos.length; i++) {
              if (this.glyphInfos[i].isMark) {
                positions[i].xAdvance = 0;
                positions[i].yAdvance = 0;
              }
            }
          };

          _proto29.cleanup = function cleanup() {
            this.glyphInfos = null;
            this.plan = null;
            this.shaper = null;
          };

          _proto29.getAvailableFeatures = function getAvailableFeatures(script, language) {
            const features = [];

            if (this.GSUBProcessor) {
              this.GSUBProcessor.selectScript(script, language);
              features.push.apply(features, Object.keys(this.GSUBProcessor.features));
            }

            if (this.GPOSProcessor) {
              this.GPOSProcessor.selectScript(script, language);
              features.push.apply(features, Object.keys(this.GPOSProcessor.features));
            }

            return features;
          };

          return OTLayoutEngine;
        }());

        const LayoutEngine = /* #__PURE__ */(function () {
          function LayoutEngine(font) {
            this.font = font;
            this.unicodeLayoutEngine = null;
            this.kernProcessor = null; // Choose an advanced layout engine. We try the AAT morx table first since more
            // scripts are currently supported because the shaping logic is built into the font.

            if (this.font.morx) {
              this.engine = new AATLayoutEngine(this.font);
            } else if (this.font.GSUB || this.font.GPOS) {
              this.engine = new OTLayoutEngine(this.font);
            }
          }

          const _proto30 = LayoutEngine.prototype;

          _proto30.layout = function layout(string, features, script, language, direction) {
            // Make the features parameter optional
            if (typeof features === 'string') {
              direction = language;
              language = script;
              script = features;
              features = [];
            } // Map string to glyphs if needed

            if (typeof string === 'string') {
              // Attempt to detect the script from the string if not provided.
              if (script == null) {
                script = forString(string);
              }

              var glyphs = this.font.glyphsForString(string);
            } else {
              // Attempt to detect the script from the glyph code points if not provided.
              if (script == null) {
                const codePoints = [];

                for (var _iterator64 = _createForOfIteratorHelperLoose(string), _step64; !(_step64 = _iterator64()).done;) {
                  const glyph = _step64.value;
                  codePoints.push.apply(codePoints, glyph.codePoints);
                }

                script = forCodePoints(codePoints);
              }

              var glyphs = string;
            }

            const glyphRun = new GlyphRun(glyphs, features, script, language, direction); // Return early if there are no glyphs

            if (glyphs.length === 0) {
              glyphRun.positions = [];
              return glyphRun;
            } // Setup the advanced layout engine

            if (this.engine && this.engine.setup) {
              this.engine.setup(glyphRun);
            } // Substitute and position the glyphs

            this.substitute(glyphRun);
            this.position(glyphRun);
            this.hideDefaultIgnorables(glyphRun.glyphs, glyphRun.positions); // Let the layout engine clean up any state it might have

            if (this.engine && this.engine.cleanup) {
              this.engine.cleanup();
            }

            return glyphRun;
          };

          _proto30.substitute = function substitute(glyphRun) {
            // Call the advanced layout engine to make substitutions
            if (this.engine && this.engine.substitute) {
              this.engine.substitute(glyphRun);
            }
          };

          _proto30.position = function position(glyphRun) {
            // Get initial glyph positions
            glyphRun.positions = glyphRun.glyphs.map((glyph) => new GlyphPosition(glyph.advanceWidth));
            let positioned = null; // Call the advanced layout engine. Returns the features applied.

            if (this.engine && this.engine.position) {
              positioned = this.engine.position(glyphRun);
            } // if there is no GPOS table, use unicode properties to position marks.

            if (!positioned && (!this.engine || this.engine.fallbackPosition)) {
              if (!this.unicodeLayoutEngine) {
                this.unicodeLayoutEngine = new UnicodeLayoutEngine(this.font);
              }

              this.unicodeLayoutEngine.positionGlyphs(glyphRun.glyphs, glyphRun.positions);
            } // if kerning is not supported by GPOS, do kerning with the TrueType/AAT kern table

            if ((!positioned || !positioned.kern) && glyphRun.features.kern !== false && this.font.kern) {
              if (!this.kernProcessor) {
                this.kernProcessor = new KernProcessor(this.font);
              }

              this.kernProcessor.process(glyphRun.glyphs, glyphRun.positions);
              glyphRun.features.kern = true;
            }
          };

          _proto30.hideDefaultIgnorables = function hideDefaultIgnorables(glyphs, positions) {
            const space = this.font.glyphForCodePoint(0x20);

            for (let i = 0; i < glyphs.length; i++) {
              if (this.isDefaultIgnorable(glyphs[i].codePoints[0])) {
                glyphs[i] = space;
                positions[i].xAdvance = 0;
                positions[i].yAdvance = 0;
              }
            }
          };

          _proto30.isDefaultIgnorable = function isDefaultIgnorable(ch) {
            // From DerivedCoreProperties.txt in the Unicode database,
            // minus U+115F, U+1160, U+3164 and U+FFA0, which is what
            // Harfbuzz and Uniscribe do.
            const plane = ch >> 16;

            if (plane === 0) {
              // BMP
              switch (ch >> 8) {
                case 0x00:
                  return ch === 0x00AD;

                case 0x03:
                  return ch === 0x034F;

                case 0x06:
                  return ch === 0x061C;

                case 0x17:
                  return ch >= 0x17B4 && ch <= 0x17B5;

                case 0x18:
                  return ch >= 0x180B && ch <= 0x180E;

                case 0x20:
                  return ch >= 0x200B && ch <= 0x200F || ch >= 0x202A && ch <= 0x202E || ch >= 0x2060 && ch <= 0x206F;

                case 0xFE:
                  return ch >= 0xFE00 && ch <= 0xFE0F || ch === 0xFEFF;

                case 0xFF:
                  return ch >= 0xFFF0 && ch <= 0xFFF8;

                default:
                  return false;
              }
            } else {
              // Other planes
              switch (plane) {
                case 0x01:
                  return ch >= 0x1BCA0 && ch <= 0x1BCA3 || ch >= 0x1D173 && ch <= 0x1D17A;

                case 0x0E:
                  return ch >= 0xE0000 && ch <= 0xE0FFF;

                default:
                  return false;
              }
            }
          };

          _proto30.getAvailableFeatures = function getAvailableFeatures(script, language) {
            const features = [];

            if (this.engine) {
              features.push.apply(features, this.engine.getAvailableFeatures(script, language));
            }

            if (this.font.kern && features.indexOf('kern') === -1) {
              features.push('kern');
            }

            return features;
          };

          _proto30.stringsForGlyph = function stringsForGlyph(gid) {
            const result = new Set();

            const codePoints = this.font._cmapProcessor.codePointsForGlyph(gid);

            for (var _iterator65 = _createForOfIteratorHelperLoose(codePoints), _step65; !(_step65 = _iterator65()).done;) {
              const codePoint = _step65.value;
              result.add(String.fromCodePoint(codePoint));
            }

            if (this.engine && this.engine.stringsForGlyph) {
              for (var _iterator66 = _createForOfIteratorHelperLoose(this.engine.stringsForGlyph(gid)), _step66; !(_step66 = _iterator66()).done;) {
                const string = _step66.value;
                result.add(string);
              }
            }

            return Array.from(result);
          };

          return LayoutEngine;
        }());

        const SVG_COMMANDS = {
          moveTo: 'M',
          lineTo: 'L',
          quadraticCurveTo: 'Q',
          bezierCurveTo: 'C',
          closePath: 'Z',
        };
        /**
 * Path objects are returned by glyphs and represent the actual
 * vector outlines for each glyph in the font. Paths can be converted
 * to SVG path data strings, or to functions that can be applied to
 * render the path to a graphics context.
 */

        const Path = /* #__PURE__ */(function () {
          function Path() {
            this.commands = [];
            this._bbox = null;
            this._cbox = null;
          }
          /**
   * Compiles the path to a JavaScript function that can be applied with
   * a graphics context in order to render the path.
   * @return {string}
   */

          const _proto31 = Path.prototype;

          _proto31.toFunction = function toFunction() {
            const _this10 = this;

            return function (ctx) {
              _this10.commands.forEach((c) => ctx[c.command].apply(ctx, c.args));
            };
          }
          /**
   * Converts the path to an SVG path data string
   * @return {string}
   */
          ;

          _proto31.toSVG = function toSVG() {
            const cmds = this.commands.map((c) => {
              const args = c.args.map((arg) => Math.round(arg * 100) / 100);
              return ''.concat(SVG_COMMANDS[c.command]).concat(args.join(' '));
            });
            return cmds.join('');
          }
          /**
   * Gets the "control box" of a path.
   * This is like the bounding box, but it includes all points including
   * control points of bezier segments and is much faster to compute than
   * the real bounding box.
   * @type {BBox}
   */
          ;

          /**
   * Applies a mapping function to each point in the path.
   * @param {function} fn
   * @return {Path}
   */
          _proto31.mapPoints = function mapPoints(fn) {
            const path = new Path();

            for (var _iterator67 = _createForOfIteratorHelperLoose(this.commands), _step67; !(_step67 = _iterator67()).done;) {
              const c = _step67.value;
              const args = [];

              for (let i = 0; i < c.args.length; i += 2) {
                const _fn = fn(c.args[i], c.args[i + 1]);
                const x = _fn[0];
                const y = _fn[1];

                args.push(x, y);
              }

              path[c.command].apply(path, args);
            }

            return path;
          }
          /**
   * Transforms the path by the given matrix.
   */
          ;

          _proto31.transform = function transform(m0, m1, m2, m3, m4, m5) {
            return this.mapPoints((x, y) => {
              x = m0 * x + m2 * y + m4;
              y = m1 * x + m3 * y + m5;
              return [x, y];
            });
          }
          /**
   * Translates the path by the given offset.
   */
          ;

          _proto31.translate = function translate(x, y) {
            return this.transform(1, 0, 0, 1, x, y);
          }
          /**
   * Rotates the path by the given angle (in radians).
   */
          ;

          _proto31.rotate = function rotate(angle) {
            const cos = Math.cos(angle);
            const sin = Math.sin(angle);
            return this.transform(cos, sin, -sin, cos, 0, 0);
          }
          /**
   * Scales the path.
   */
          ;

          _proto31.scale = function scale(scaleX, scaleY) {
            if (scaleY === void 0) {
              scaleY = scaleX;
            }

            return this.transform(scaleX, 0, 0, scaleY, 0, 0);
          };

          _createClass(Path, [{
            key: 'cbox',
            get: function get() {
              if (!this._cbox) {
                const cbox = new BBox();

                for (var _iterator68 = _createForOfIteratorHelperLoose(this.commands), _step68; !(_step68 = _iterator68()).done;) {
                  const command = _step68.value;

                  for (let i = 0; i < command.args.length; i += 2) {
                    cbox.addPoint(command.args[i], command.args[i + 1]);
                  }
                }

                this._cbox = Object.freeze(cbox);
              }

              return this._cbox;
            },
            /**
     * Gets the exact bounding box of the path by evaluating curve segments.
     * Slower to compute than the control box, but more accurate.
     * @type {BBox}
     */

          }, {
            key: 'bbox',
            get: function get() {
              if (this._bbox) {
                return this._bbox;
              }

              const bbox = new BBox();
              let cx = 0;
              let cy = 0;

              const f = function f(t) {
                return Math.pow(1 - t, 3) * p0[i] + 3 * Math.pow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * Math.pow(t, 2) * p2[i] + Math.pow(t, 3) * p3[i];
              };

              for (var _iterator69 = _createForOfIteratorHelperLoose(this.commands), _step69; !(_step69 = _iterator69()).done;) {
                let c = _step69.value;

                switch (c.command) {
                  case 'moveTo':
                  case 'lineTo':
                    var _c$args = c.args;
                    var x = _c$args[0];
                    var y = _c$args[1];
                    bbox.addPoint(x, y);
                    cx = x;
                    cy = y;
                    break;

                  case 'quadraticCurveTo':
                  case 'bezierCurveTo':
                    if (c.command === 'quadraticCurveTo') {
                      // http://fontforge.org/bezier.html
                      const _c$args2 = c.args;
                      const qp1x = _c$args2[0];
                      const qp1y = _c$args2[1];
                      var p3x = _c$args2[2];
                      var p3y = _c$args2[3];
                      var cp1x = cx + 2 / 3 * (qp1x - cx); // CP1 = QP0 + 2/3 * (QP1-QP0)

                      var cp1y = cy + 2 / 3 * (qp1y - cy);
                      var cp2x = p3x + 2 / 3 * (qp1x - p3x); // CP2 = QP2 + 2/3 * (QP1-QP2)

                      var cp2y = p3y + 2 / 3 * (qp1y - p3y);
                    } else {
                      const _c$args3 = c.args;
                      var cp1x = _c$args3[0];
                      var cp1y = _c$args3[1];
                      var cp2x = _c$args3[2];
                      var cp2y = _c$args3[3];
                      var p3x = _c$args3[4];
                      var p3y = _c$args3[5];
                    } // http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html

                    bbox.addPoint(p3x, p3y);
                    var p0 = [cx, cy];
                    var p1 = [cp1x, cp1y];
                    var p2 = [cp2x, cp2y];
                    var p3 = [p3x, p3y];

                    for (var i = 0; i <= 1; i++) {
                      const b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
                      const a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
                      c = 3 * p1[i] - 3 * p0[i];

                      if (a === 0) {
                        if (b === 0) {
                          continue;
                        }

                        const t = -c / b;

                        if (t > 0 && t < 1) {
                          if (i === 0) {
                            bbox.addPoint(f(t), bbox.maxY);
                          } else if (i === 1) {
                            bbox.addPoint(bbox.maxX, f(t));
                          }
                        }

                        continue;
                      }

                      const b2ac = Math.pow(b, 2) - 4 * c * a;

                      if (b2ac < 0) {
                        continue;
                      }

                      const t1 = (-b + Math.sqrt(b2ac)) / (2 * a);

                      if (t1 > 0 && t1 < 1) {
                        if (i === 0) {
                          bbox.addPoint(f(t1), bbox.maxY);
                        } else if (i === 1) {
                          bbox.addPoint(bbox.maxX, f(t1));
                        }
                      }

                      const t2 = (-b - Math.sqrt(b2ac)) / (2 * a);

                      if (t2 > 0 && t2 < 1) {
                        if (i === 0) {
                          bbox.addPoint(f(t2), bbox.maxY);
                        } else if (i === 1) {
                          bbox.addPoint(bbox.maxX, f(t2));
                        }
                      }
                    }

                    cx = p3x;
                    cy = p3y;
                    break;
                }
              }

              return this._bbox = Object.freeze(bbox);
            },
          }]);

          return Path;
        }());

        const _loop = function _loop(command) {
          Path.prototype[command] = function () {
            this._bbox = this._cbox = null;

            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }

            this.commands.push({
              command,
              args,
            });
            return this;
          };
        };

        for (let _i23 = 0, _arr = ['moveTo', 'lineTo', 'quadraticCurveTo', 'bezierCurveTo', 'closePath']; _i23 < _arr.length; _i23++) {
          const command = _arr[_i23];

          _loop(command);
        }

        const StandardNames = ['.notdef', '.null', 'nonmarkingreturn', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quotesingle', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'grave', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'Adieresis', 'Aring', 'Ccedilla', 'Eacute', 'Ntilde', 'Odieresis', 'Udieresis', 'aacute', 'agrave', 'acircumflex', 'adieresis', 'atilde', 'aring', 'ccedilla', 'eacute', 'egrave', 'ecircumflex', 'edieresis', 'iacute', 'igrave', 'icircumflex', 'idieresis', 'ntilde', 'oacute', 'ograve', 'ocircumflex', 'odieresis', 'otilde', 'uacute', 'ugrave', 'ucircumflex', 'udieresis', 'dagger', 'degree', 'cent', 'sterling', 'section', 'bullet', 'paragraph', 'germandbls', 'registered', 'copyright', 'trademark', 'acute', 'dieresis', 'notequal', 'AE', 'Oslash', 'infinity', 'plusminus', 'lessequal', 'greaterequal', 'yen', 'mu', 'partialdiff', 'summation', 'product', 'pi', 'integral', 'ordfeminine', 'ordmasculine', 'Omega', 'ae', 'oslash', 'questiondown', 'exclamdown', 'logicalnot', 'radical', 'florin', 'approxequal', 'Delta', 'guillemotleft', 'guillemotright', 'ellipsis', 'nonbreakingspace', 'Agrave', 'Atilde', 'Otilde', 'OE', 'oe', 'endash', 'emdash', 'quotedblleft', 'quotedblright', 'quoteleft', 'quoteright', 'divide', 'lozenge', 'ydieresis', 'Ydieresis', 'fraction', 'currency', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'daggerdbl', 'periodcentered', 'quotesinglbase', 'quotedblbase', 'perthousand', 'Acircumflex', 'Ecircumflex', 'Aacute', 'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Oacute', 'Ocircumflex', 'apple', 'Ograve', 'Uacute', 'Ucircumflex', 'Ugrave', 'dotlessi', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'ring', 'cedilla', 'hungarumlaut', 'ogonek', 'caron', 'Lslash', 'lslash', 'Scaron', 'scaron', 'Zcaron', 'zcaron', 'brokenbar', 'Eth', 'eth', 'Yacute', 'yacute', 'Thorn', 'thorn', 'minus', 'multiply', 'onesuperior', 'twosuperior', 'threesuperior', 'onehalf', 'onequarter', 'threequarters', 'franc', 'Gbreve', 'gbreve', 'Idotaccent', 'Scedilla', 'scedilla', 'Cacute', 'cacute', 'Ccaron', 'ccaron', 'dcroat'];

        let _class$3;
        /**
 * Glyph objects represent a glyph in the font. They have various properties for accessing metrics and
 * the actual vector path the glyph represents, and methods for rendering the glyph to a graphics context.
 *
 * You do not create glyph objects directly. They are created by various methods on the font object.
 * There are several subclasses of the base Glyph class internally that may be returned depending
 * on the font format, but they all inherit from this class.
 */

        const Glyph = (_class$3 = /* #__PURE__ */(function () {
          function Glyph(id, codePoints, font) {
            /**
     * The glyph id in the font
     * @type {number}
     */
            this.id = id;
            /**
     * An array of unicode code points that are represented by this glyph.
     * There can be multiple code points in the case of ligatures and other glyphs
     * that represent multiple visual characters.
     * @type {number[]}
     */

            this.codePoints = codePoints;
            this._font = font; // TODO: get this info from GDEF if available

            this.isMark = this.codePoints.length > 0 && this.codePoints.every(unicode.isMark);
            this.isLigature = this.codePoints.length > 1;
          }

          const _proto32 = Glyph.prototype;

          _proto32._getPath = function _getPath() {
            return new Path();
          };

          _proto32._getCBox = function _getCBox() {
            return this.path.cbox;
          };

          _proto32._getBBox = function _getBBox() {
            return this.path.bbox;
          };

          _proto32._getTableMetrics = function _getTableMetrics(table) {
            if (this.id < table.metrics.length) {
              return table.metrics.get(this.id);
            }

            const metric = table.metrics.get(table.metrics.length - 1);
            const res = {
              advance: metric ? metric.advance : 0,
              bearing: table.bearings.get(this.id - table.metrics.length) || 0,
            };
            return res;
          };

          _proto32._getMetrics = function _getMetrics(cbox) {
            if (this._metrics) {
              return this._metrics;
            }

            const _this$_getTableMetric = this._getTableMetrics(this._font.hmtx);
            let advanceWidth = _this$_getTableMetric.advance;
            const leftBearing = _this$_getTableMetric.bearing; // For vertical metrics, use vmtx if available, or fall back to global data from OS/2 or hhea

            if (this._font.vmtx) {
              const _this$_getTableMetric2 = this._getTableMetrics(this._font.vmtx);
              var advanceHeight = _this$_getTableMetric2.advance;
              var topBearing = _this$_getTableMetric2.bearing;
            } else {
              let os2;

              if (typeof cbox === 'undefined' || cbox === null) {
                cbox = this.cbox;
              }

              if ((os2 = this._font['OS/2']) && os2.version > 0) {
                var advanceHeight = Math.abs(os2.typoAscender - os2.typoDescender);
                var topBearing = os2.typoAscender - cbox.maxY;
              } else {
                const { hhea } = this._font;
                var advanceHeight = Math.abs(hhea.ascent - hhea.descent);
                var topBearing = hhea.ascent - cbox.maxY;
              }
            }

            if (this._font._variationProcessor && this._font.HVAR) {
              advanceWidth += this._font._variationProcessor.getAdvanceAdjustment(this.id, this._font.HVAR);
            }

            return this._metrics = {
              advanceWidth,
              advanceHeight,
              leftBearing,
              topBearing,
            };
          }
          /**
   * The glyph’s control box.
   * This is often the same as the bounding box, but is faster to compute.
   * Because of the way bezier curves are defined, some of the control points
   * can be outside of the bounding box. Where `bbox` takes this into account,
   * `cbox` does not. Thus, cbox is less accurate, but faster to compute.
   * See [here](http://www.freetype.org/freetype2/docs/glyphs/glyphs-6.html#section-2)
   * for a more detailed description.
   *
   * @type {BBox}
   */
          ;

          /**
   * Returns a path scaled to the given font size.
   * @param {number} size
   * @return {Path}
   */
          _proto32.getScaledPath = function getScaledPath(size) {
            const scale = 1 / this._font.unitsPerEm * size;
            return this.path.scale(scale);
          }
          /**
   * The glyph's advance width.
   * @type {number}
   */
          ;

          _proto32._getName = function _getName() {
            const { post } = this._font;

            if (!post) {
              return null;
            }

            switch (post.version) {
              case 1:
                return StandardNames[this.id];

              case 2:
                var id = post.glyphNameIndex[this.id];

                if (id < StandardNames.length) {
                  return StandardNames[id];
                }

                return post.names[id - StandardNames.length];

              case 2.5:
                return StandardNames[this.id + post.offsets[this.id]];

              case 4:
                return String.fromCharCode(post.map[this.id]);
            }
          }
          /**
   * The glyph's name
   * @type {string}
   */
          ;

          /**
   * Renders the glyph to the given graphics context, at the specified font size.
   * @param {CanvasRenderingContext2d} ctx
   * @param {number} size
   */
          _proto32.render = function render(ctx, size) {
            ctx.save();
            const scale = 1 / this._font.head.unitsPerEm * size;
            ctx.scale(scale, scale);
            const fn = this.path.toFunction();
            fn(ctx);
            ctx.fill();
            ctx.restore();
          };

          _createClass(Glyph, [{
            key: 'cbox',
            get: function get() {
              return this._getCBox();
            },
            /**
     * The glyph’s bounding box, i.e. the rectangle that encloses the
     * glyph outline as tightly as possible.
     * @type {BBox}
     */

          }, {
            key: 'bbox',
            get: function get() {
              return this._getBBox();
            },
            /**
     * A vector Path object representing the glyph outline.
     * @type {Path}
     */

          }, {
            key: 'path',
            get: function get() {
              // Cache the path so we only decode it once
              // Decoding is actually performed by subclasses
              return this._getPath();
            },
          }, {
            key: 'advanceWidth',
            get: function get() {
              return this._getMetrics().advanceWidth;
            },
            /**
     * The glyph's advance height.
     * @type {number}
     */

          }, {
            key: 'advanceHeight',
            get: function get() {
              return this._getMetrics().advanceHeight;
            },
          }, {
            key: 'ligatureCaretPositions',
            get: function get() {},
          }, {
            key: 'name',
            get: function get() {
              return this._getName();
            },
          }]);

          return Glyph;
        }()), (_applyDecoratedDescriptor(_class$3.prototype, 'cbox', [cache], Object.getOwnPropertyDescriptor(_class$3.prototype, 'cbox'), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, 'bbox', [cache], Object.getOwnPropertyDescriptor(_class$3.prototype, 'bbox'), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, 'path', [cache], Object.getOwnPropertyDescriptor(_class$3.prototype, 'path'), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, 'advanceWidth', [cache], Object.getOwnPropertyDescriptor(_class$3.prototype, 'advanceWidth'), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, 'advanceHeight', [cache], Object.getOwnPropertyDescriptor(_class$3.prototype, 'advanceHeight'), _class$3.prototype), _applyDecoratedDescriptor(_class$3.prototype, 'name', [cache], Object.getOwnPropertyDescriptor(_class$3.prototype, 'name'), _class$3.prototype)), _class$3);
        const GlyfHeader = new r.Struct({
          numberOfContours: r.int16,
          // if negative, this is a composite glyph
          xMin: r.int16,
          yMin: r.int16,
          xMax: r.int16,
          yMax: r.int16,
        }); // Flags for simple glyphs

        const ON_CURVE = 1 << 0;
        const X_SHORT_VECTOR = 1 << 1;
        const Y_SHORT_VECTOR = 1 << 2;
        const REPEAT = 1 << 3;
        const SAME_X = 1 << 4;
        const SAME_Y = 1 << 5; // Flags for composite glyphs

        const ARG_1_AND_2_ARE_WORDS = 1 << 0;
        const WE_HAVE_A_SCALE = 1 << 3;
        const MORE_COMPONENTS = 1 << 5;
        const WE_HAVE_AN_X_AND_Y_SCALE = 1 << 6;
        const WE_HAVE_A_TWO_BY_TWO = 1 << 7;
        const WE_HAVE_INSTRUCTIONS = 1 << 8;

        const Point = /* #__PURE__ */(function () {
          function Point(onCurve, endContour, x, y) {
            if (x === void 0) {
              x = 0;
            }

            if (y === void 0) {
              y = 0;
            }

            this.onCurve = onCurve;
            this.endContour = endContour;
            this.x = x;
            this.y = y;
          }

          const _proto33 = Point.prototype;

          _proto33.copy = function copy() {
            return new Point(this.onCurve, this.endContour, this.x, this.y);
          };

          return Point;
        }()); // Represents a component in a composite glyph

        const Component = function Component(glyphID, dx, dy) {
          this.glyphID = glyphID;
          this.dx = dx;
          this.dy = dy;
          this.pos = 0;
          this.scaleX = this.scaleY = 1;
          this.scale01 = this.scale10 = 0;
        };
        /**
 * Represents a TrueType glyph.
 */

        const TTFGlyph = /* #__PURE__ */(function (_Glyph) {
          _inheritsLoose(TTFGlyph, _Glyph);

          function TTFGlyph() {
            return _Glyph.apply(this, arguments) || this;
          }

          const _proto34 = TTFGlyph.prototype;

          // Parses just the glyph header and returns the bounding box
          _proto34._getCBox = function _getCBox(internal) {
            // We need to decode the glyph if variation processing is requested,
            // so it's easier just to recompute the path's cbox after decoding.
            if (this._font._variationProcessor && !internal) {
              return this.path.cbox;
            }

            const stream = this._font._getTableStream('glyf');

            stream.pos += this._font.loca.offsets[this.id];
            const glyph = GlyfHeader.decode(stream);
            const cbox = new BBox(glyph.xMin, glyph.yMin, glyph.xMax, glyph.yMax);
            return Object.freeze(cbox);
          } // Parses a single glyph coordinate
          ;

          _proto34._parseGlyphCoord = function _parseGlyphCoord(stream, prev, short, same) {
            if (short) {
              var val = stream.readUInt8();

              if (!same) {
                val = -val;
              }

              val += prev;
            } else if (same) {
              var val = prev;
            } else {
              var val = prev + stream.readInt16BE();
            }

            return val;
          } // Decodes the glyph data into points for simple glyphs,
          // or components for composite glyphs
          ;

          _proto34._decode = function _decode() {
            const glyfPos = this._font.loca.offsets[this.id];
            const nextPos = this._font.loca.offsets[this.id + 1]; // Nothing to do if there is no data for this glyph

            if (glyfPos === nextPos) {
              return null;
            }

            const stream = this._font._getTableStream('glyf');

            stream.pos += glyfPos;
            const startPos = stream.pos;
            const glyph = GlyfHeader.decode(stream);

            if (glyph.numberOfContours > 0) {
              this._decodeSimple(glyph, stream);
            } else if (glyph.numberOfContours < 0) {
              this._decodeComposite(glyph, stream, startPos);
            }

            return glyph;
          };

          _proto34._decodeSimple = function _decodeSimple(glyph, stream) {
            // this is a simple glyph
            glyph.points = [];
            const endPtsOfContours = new r.Array(r.uint16, glyph.numberOfContours).decode(stream);
            glyph.instructions = new r.Array(r.uint8, r.uint16).decode(stream);
            const flags = [];
            const numCoords = endPtsOfContours[endPtsOfContours.length - 1] + 1;

            while (flags.length < numCoords) {
              var flag = stream.readUInt8();
              flags.push(flag); // check for repeat flag

              if (flag & REPEAT) {
                const count = stream.readUInt8();

                for (let j = 0; j < count; j++) {
                  flags.push(flag);
                }
              }
            }

            for (var i = 0; i < flags.length; i++) {
              var flag = flags[i];
              const point = new Point(!!(flag & ON_CURVE), endPtsOfContours.indexOf(i) >= 0, 0, 0);
              glyph.points.push(point);
            }

            let px = 0;

            for (var i = 0; i < flags.length; i++) {
              var flag = flags[i];
              glyph.points[i].x = px = this._parseGlyphCoord(stream, px, flag & X_SHORT_VECTOR, flag & SAME_X);
            }

            let py = 0;

            for (var i = 0; i < flags.length; i++) {
              var flag = flags[i];
              glyph.points[i].y = py = this._parseGlyphCoord(stream, py, flag & Y_SHORT_VECTOR, flag & SAME_Y);
            }

            if (this._font._variationProcessor) {
              const points = glyph.points.slice();
              points.push.apply(points, this._getPhantomPoints(glyph));

              this._font._variationProcessor.transformPoints(this.id, points);

              glyph.phantomPoints = points.slice(-4);
            }
          };

          _proto34._decodeComposite = function _decodeComposite(glyph, stream, offset) {
            if (offset === void 0) {
              offset = 0;
            }

            // this is a composite glyph
            glyph.components = [];
            let haveInstructions = false;
            let flags = MORE_COMPONENTS;

            while (flags & MORE_COMPONENTS) {
              flags = stream.readUInt16BE();
              const gPos = stream.pos - offset;
              const glyphID = stream.readUInt16BE();

              if (!haveInstructions) {
                haveInstructions = (flags & WE_HAVE_INSTRUCTIONS) !== 0;
              }

              if (flags & ARG_1_AND_2_ARE_WORDS) {
                var dx = stream.readInt16BE();
                var dy = stream.readInt16BE();
              } else {
                var dx = stream.readInt8();
                var dy = stream.readInt8();
              }

              var component = new Component(glyphID, dx, dy);
              component.pos = gPos;

              if (flags & WE_HAVE_A_SCALE) {
                // fixed number with 14 bits of fraction
                component.scaleX = component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
              } else if (flags & WE_HAVE_AN_X_AND_Y_SCALE) {
                component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
              } else if (flags & WE_HAVE_A_TWO_BY_TWO) {
                component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scale01 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scale10 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
              }

              glyph.components.push(component);
            }

            if (this._font._variationProcessor) {
              const points = [];

              for (let j = 0; j < glyph.components.length; j++) {
                var component = glyph.components[j];
                points.push(new Point(true, true, component.dx, component.dy));
              }

              points.push.apply(points, this._getPhantomPoints(glyph));

              this._font._variationProcessor.transformPoints(this.id, points);

              glyph.phantomPoints = points.splice(-4, 4);

              for (let i = 0; i < points.length; i++) {
                const point = points[i];
                glyph.components[i].dx = point.x;
                glyph.components[i].dy = point.y;
              }
            }

            return haveInstructions;
          };

          _proto34._getPhantomPoints = function _getPhantomPoints(glyph) {
            const cbox = this._getCBox(true);

            if (this._metrics == null) {
              this._metrics = Glyph.prototype._getMetrics.call(this, cbox);
            }

            const _this$_metrics = this._metrics;
            const { advanceWidth } = _this$_metrics;
            const { advanceHeight } = _this$_metrics;
            const { leftBearing } = _this$_metrics;
            const { topBearing } = _this$_metrics;
            return [new Point(false, true, glyph.xMin - leftBearing, 0), new Point(false, true, glyph.xMin - leftBearing + advanceWidth, 0), new Point(false, true, 0, glyph.yMax + topBearing), new Point(false, true, 0, glyph.yMax + topBearing + advanceHeight)];
          } // Decodes font data, resolves composite glyphs, and returns an array of contours
          ;

          _proto34._getContours = function _getContours() {
            const glyph = this._decode();

            if (!glyph) {
              return [];
            }

            let points = [];

            if (glyph.numberOfContours < 0) {
              // resolve composite glyphs
              for (var _iterator70 = _createForOfIteratorHelperLoose(glyph.components), _step70; !(_step70 = _iterator70()).done;) {
                const component = _step70.value;

                const _contours = this._font.getGlyph(component.glyphID)._getContours();

                for (let i = 0; i < _contours.length; i++) {
                  const contour = _contours[i];

                  for (let j = 0; j < contour.length; j++) {
                    const _point = contour[j];
                    const x = _point.x * component.scaleX + _point.y * component.scale01 + component.dx;
                    const y = _point.y * component.scaleY + _point.x * component.scale10 + component.dy;
                    points.push(new Point(_point.onCurve, _point.endContour, x, y));
                  }
                }
              }
            } else {
              points = glyph.points || [];
            } // Recompute and cache metrics if we performed variation processing, and don't have an HVAR table

            if (glyph.phantomPoints && !this._font.directory.tables.HVAR) {
              this._metrics.advanceWidth = glyph.phantomPoints[1].x - glyph.phantomPoints[0].x;
              this._metrics.advanceHeight = glyph.phantomPoints[3].y - glyph.phantomPoints[2].y;
              this._metrics.leftBearing = glyph.xMin - glyph.phantomPoints[0].x;
              this._metrics.topBearing = glyph.phantomPoints[2].y - glyph.yMax;
            }

            const contours = [];
            let cur = [];

            for (let k = 0; k < points.length; k++) {
              const point = points[k];
              cur.push(point);

              if (point.endContour) {
                contours.push(cur);
                cur = [];
              }
            }

            return contours;
          };

          _proto34._getMetrics = function _getMetrics() {
            if (this._metrics) {
              return this._metrics;
            }

            const cbox = this._getCBox(true);

            _Glyph.prototype._getMetrics.call(this, cbox);

            if (this._font._variationProcessor && !this._font.HVAR) {
              // No HVAR table, decode the glyph. This triggers recomputation of metrics.
              this.path;
            }

            return this._metrics;
          } // Converts contours to a Path object that can be rendered
          ;

          _proto34._getPath = function _getPath() {
            const contours = this._getContours();

            const path = new Path();

            for (let i = 0; i < contours.length; i++) {
              const contour = contours[i];
              let firstPt = contour[0];
              const lastPt = contour[contour.length - 1];
              let start = 0;

              if (firstPt.onCurve) {
                // The first point will be consumed by the moveTo command, so skip in the loop
                var curvePt = null;
                start = 1;
              } else {
                if (lastPt.onCurve) {
                  // Start at the last point if the first point is off curve and the last point is on curve
                  firstPt = lastPt;
                } else {
                  // Start at the middle if both the first and last points are off curve
                  firstPt = new Point(false, false, (firstPt.x + lastPt.x) / 2, (firstPt.y + lastPt.y) / 2);
                }

                var curvePt = firstPt;
              }

              path.moveTo(firstPt.x, firstPt.y);

              for (let j = start; j < contour.length; j++) {
                const pt = contour[j];
                const prevPt = j === 0 ? firstPt : contour[j - 1];

                if (prevPt.onCurve && pt.onCurve) {
                  path.lineTo(pt.x, pt.y);
                } else if (prevPt.onCurve && !pt.onCurve) {
                  var curvePt = pt;
                } else if (!prevPt.onCurve && !pt.onCurve) {
                  const midX = (prevPt.x + pt.x) / 2;
                  const midY = (prevPt.y + pt.y) / 2;
                  path.quadraticCurveTo(prevPt.x, prevPt.y, midX, midY);
                  var curvePt = pt;
                } else if (!prevPt.onCurve && pt.onCurve) {
                  path.quadraticCurveTo(curvePt.x, curvePt.y, pt.x, pt.y);
                  var curvePt = null;
                } else {
                  throw new Error('Unknown TTF path state');
                }
              } // Connect the first and last points

              if (curvePt) {
                path.quadraticCurveTo(curvePt.x, curvePt.y, firstPt.x, firstPt.y);
              }

              path.closePath();
            }

            return path;
          };

          return TTFGlyph;
        }(Glyph));
        /**
 * Represents an OpenType PostScript glyph, in the Compact Font Format.
 */

        const CFFGlyph = /* #__PURE__ */(function (_Glyph2) {
          _inheritsLoose(CFFGlyph, _Glyph2);

          function CFFGlyph() {
            return _Glyph2.apply(this, arguments) || this;
          }

          const _proto35 = CFFGlyph.prototype;

          _proto35._getName = function _getName() {
            if (this._font.CFF2) {
              return _Glyph2.prototype._getName.call(this);
            }

            return this._font['CFF '].getGlyphName(this.id);
          };

          _proto35.bias = function bias(s) {
            if (s.length < 1240) {
              return 107;
            } if (s.length < 33900) {
              return 1131;
            }
            return 32768;
          };

          _proto35._getPath = function _getPath() {
            const cff = this._font.CFF2 || this._font['CFF '];
            const { stream } = cff;
            const str = cff.topDict.CharStrings[this.id];
            let end = str.offset + str.length;
            stream.pos = str.offset;
            const path = new Path();
            const stack = [];
            const trans = [];
            let width = null;
            let nStems = 0;
            let x = 0;
            let y = 0;
            let usedGsubrs;
            let usedSubrs;
            let open = false;
            this._usedGsubrs = usedGsubrs = {};
            this._usedSubrs = usedSubrs = {};
            const gsubrs = cff.globalSubrIndex || [];
            const gsubrsBias = this.bias(gsubrs);
            const privateDict = cff.privateDictForGlyph(this.id) || {};
            const subrs = privateDict.Subrs || [];
            const subrsBias = this.bias(subrs);
            const vstore = cff.topDict.vstore && cff.topDict.vstore.itemVariationStore;
            let { vsindex } = privateDict;
            const variationProcessor = this._font._variationProcessor;

            function checkWidth() {
              if (width == null) {
                width = stack.shift() + privateDict.nominalWidthX;
              }
            }

            function parseStems() {
              if (stack.length % 2 !== 0) {
                checkWidth();
              }

              nStems += stack.length >> 1;
              return stack.length = 0;
            }

            function moveTo(x, y) {
              if (open) {
                path.closePath();
              }

              path.moveTo(x, y);
              open = true;
            }

            const parse = function parse() {
              while (stream.pos < end) {
                let op = stream.readUInt8();

                if (op < 32) {
                  switch (op) {
                    case 1: // hstem

                    case 3: // vstem

                    case 18: // hstemhm

                    case 23:
                      // vstemhm
                      parseStems();
                      break;

                    case 4:
                      // vmoveto
                      if (stack.length > 1) {
                        checkWidth();
                      }

                      y += stack.shift();
                      moveTo(x, y);
                      break;

                    case 5:
                      // rlineto
                      while (stack.length >= 2) {
                        x += stack.shift();
                        y += stack.shift();
                        path.lineTo(x, y);
                      }

                      break;

                    case 6: // hlineto

                    case 7:
                      // vlineto
                      var phase = op === 6;

                      while (stack.length >= 1) {
                        if (phase) {
                          x += stack.shift();
                        } else {
                          y += stack.shift();
                        }

                        path.lineTo(x, y);
                        phase = !phase;
                      }

                      break;

                    case 8:
                      // rrcurveto
                      while (stack.length > 0) {
                        var c1x = x + stack.shift();
                        var c1y = y + stack.shift();
                        var c2x = c1x + stack.shift();
                        var c2y = c1y + stack.shift();
                        x = c2x + stack.shift();
                        y = c2y + stack.shift();
                        path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                      }

                      break;

                    case 10:
                      // callsubr
                      var index = stack.pop() + subrsBias;
                      var subr = subrs[index];

                      if (subr) {
                        usedSubrs[index] = true;
                        var p = stream.pos;
                        var e = end;
                        stream.pos = subr.offset;
                        end = subr.offset + subr.length;
                        parse();
                        stream.pos = p;
                        end = e;
                      }

                      break;

                    case 11:
                      // return
                      if (cff.version >= 2) {
                        break;
                      }

                      return;

                    case 14:
                      // endchar
                      if (cff.version >= 2) {
                        break;
                      }

                      if (stack.length > 0) {
                        checkWidth();
                      }

                      if (open) {
                        path.closePath();
                        open = false;
                      }

                      break;

                    case 15:
                    {
                      // vsindex
                      if (cff.version < 2) {
                        throw new Error('vsindex operator not supported in CFF v1');
                      }

                      vsindex = stack.pop();
                      break;
                    }

                    case 16:
                    {
                      // blend
                      if (cff.version < 2) {
                        throw new Error('blend operator not supported in CFF v1');
                      }

                      if (!variationProcessor) {
                        throw new Error('blend operator in non-variation font');
                      }

                      const blendVector = variationProcessor.getBlendVector(vstore, vsindex);
                      const numBlends = stack.pop();
                      let numOperands = numBlends * blendVector.length;
                      let delta = stack.length - numOperands;
                      const base = delta - numBlends;

                      for (let i = 0; i < numBlends; i++) {
                        let sum = stack[base + i];

                        for (let j = 0; j < blendVector.length; j++) {
                          sum += blendVector[j] * stack[delta++];
                        }

                        stack[base + i] = sum;
                      }

                      while (numOperands--) {
                        stack.pop();
                      }

                      break;
                    }

                    case 19: // hintmask

                    case 20:
                      // cntrmask
                      parseStems();
                      stream.pos += nStems + 7 >> 3;
                      break;

                    case 21:
                      // rmoveto
                      if (stack.length > 2) {
                        checkWidth();
                      }

                      x += stack.shift();
                      y += stack.shift();
                      moveTo(x, y);
                      break;

                    case 22:
                      // hmoveto
                      if (stack.length > 1) {
                        checkWidth();
                      }

                      x += stack.shift();
                      moveTo(x, y);
                      break;

                    case 24:
                      // rcurveline
                      while (stack.length >= 8) {
                        var c1x = x + stack.shift();
                        var c1y = y + stack.shift();
                        var c2x = c1x + stack.shift();
                        var c2y = c1y + stack.shift();
                        x = c2x + stack.shift();
                        y = c2y + stack.shift();
                        path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                      }

                      x += stack.shift();
                      y += stack.shift();
                      path.lineTo(x, y);
                      break;

                    case 25:
                      // rlinecurve
                      while (stack.length >= 8) {
                        x += stack.shift();
                        y += stack.shift();
                        path.lineTo(x, y);
                      }

                      var c1x = x + stack.shift();
                      var c1y = y + stack.shift();
                      var c2x = c1x + stack.shift();
                      var c2y = c1y + stack.shift();
                      x = c2x + stack.shift();
                      y = c2y + stack.shift();
                      path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                      break;

                    case 26:
                      // vvcurveto
                      if (stack.length % 2) {
                        x += stack.shift();
                      }

                      while (stack.length >= 4) {
                        c1x = x;
                        c1y = y + stack.shift();
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        x = c2x;
                        y = c2y + stack.shift();
                        path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                      }

                      break;

                    case 27:
                      // hhcurveto
                      if (stack.length % 2) {
                        y += stack.shift();
                      }

                      while (stack.length >= 4) {
                        c1x = x + stack.shift();
                        c1y = y;
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        x = c2x + stack.shift();
                        y = c2y;
                        path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                      }

                      break;

                    case 28:
                      // shortint
                      stack.push(stream.readInt16BE());
                      break;

                    case 29:
                      // callgsubr
                      index = stack.pop() + gsubrsBias;
                      subr = gsubrs[index];

                      if (subr) {
                        usedGsubrs[index] = true;
                        var p = stream.pos;
                        var e = end;
                        stream.pos = subr.offset;
                        end = subr.offset + subr.length;
                        parse();
                        stream.pos = p;
                        end = e;
                      }

                      break;

                    case 30: // vhcurveto

                    case 31:
                      // hvcurveto
                      phase = op === 31;

                      while (stack.length >= 4) {
                        if (phase) {
                          c1x = x + stack.shift();
                          c1y = y;
                          c2x = c1x + stack.shift();
                          c2y = c1y + stack.shift();
                          y = c2y + stack.shift();
                          x = c2x + (stack.length === 1 ? stack.shift() : 0);
                        } else {
                          c1x = x;
                          c1y = y + stack.shift();
                          c2x = c1x + stack.shift();
                          c2y = c1y + stack.shift();
                          x = c2x + stack.shift();
                          y = c2y + (stack.length === 1 ? stack.shift() : 0);
                        }

                        path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                        phase = !phase;
                      }

                      break;

                    case 12:
                      op = stream.readUInt8();

                      switch (op) {
                        case 3:
                          // and
                          var a = stack.pop();
                          var b = stack.pop();
                          stack.push(a && b ? 1 : 0);
                          break;

                        case 4:
                          // or
                          a = stack.pop();
                          b = stack.pop();
                          stack.push(a || b ? 1 : 0);
                          break;

                        case 5:
                          // not
                          a = stack.pop();
                          stack.push(a ? 0 : 1);
                          break;

                        case 9:
                          // abs
                          a = stack.pop();
                          stack.push(Math.abs(a));
                          break;

                        case 10:
                          // add
                          a = stack.pop();
                          b = stack.pop();
                          stack.push(a + b);
                          break;

                        case 11:
                          // sub
                          a = stack.pop();
                          b = stack.pop();
                          stack.push(a - b);
                          break;

                        case 12:
                          // div
                          a = stack.pop();
                          b = stack.pop();
                          stack.push(a / b);
                          break;

                        case 14:
                          // neg
                          a = stack.pop();
                          stack.push(-a);
                          break;

                        case 15:
                          // eq
                          a = stack.pop();
                          b = stack.pop();
                          stack.push(a === b ? 1 : 0);
                          break;

                        case 18:
                          // drop
                          stack.pop();
                          break;

                        case 20:
                          // put
                          var val = stack.pop();
                          var idx = stack.pop();
                          trans[idx] = val;
                          break;

                        case 21:
                          // get
                          idx = stack.pop();
                          stack.push(trans[idx] || 0);
                          break;

                        case 22:
                          // ifelse
                          var s1 = stack.pop();
                          var s2 = stack.pop();
                          var v1 = stack.pop();
                          var v2 = stack.pop();
                          stack.push(v1 <= v2 ? s1 : s2);
                          break;

                        case 23:
                          // random
                          stack.push(Math.random());
                          break;

                        case 24:
                          // mul
                          a = stack.pop();
                          b = stack.pop();
                          stack.push(a * b);
                          break;

                        case 26:
                          // sqrt
                          a = stack.pop();
                          stack.push(Math.sqrt(a));
                          break;

                        case 27:
                          // dup
                          a = stack.pop();
                          stack.push(a, a);
                          break;

                        case 28:
                          // exch
                          a = stack.pop();
                          b = stack.pop();
                          stack.push(b, a);
                          break;

                        case 29:
                          // index
                          idx = stack.pop();

                          if (idx < 0) {
                            idx = 0;
                          } else if (idx > stack.length - 1) {
                            idx = stack.length - 1;
                          }

                          stack.push(stack[idx]);
                          break;

                        case 30:
                          // roll
                          var n = stack.pop();

                          var _j = stack.pop();

                          if (_j >= 0) {
                            while (_j > 0) {
                              var t = stack[n - 1];

                              for (let _i = n - 2; _i >= 0; _i--) {
                                stack[_i + 1] = stack[_i];
                              }

                              stack[0] = t;
                              _j--;
                            }
                          } else {
                            while (_j < 0) {
                              var t = stack[0];

                              for (let _i2 = 0; _i2 <= n; _i2++) {
                                stack[_i2] = stack[_i2 + 1];
                              }

                              stack[n - 1] = t;
                              _j++;
                            }
                          }

                          break;

                        case 34:
                          // hflex
                          c1x = x + stack.shift();
                          c1y = y;
                          c2x = c1x + stack.shift();
                          c2y = c1y + stack.shift();
                          var c3x = c2x + stack.shift();
                          var c3y = c2y;
                          var c4x = c3x + stack.shift();
                          var c4y = c3y;
                          var c5x = c4x + stack.shift();
                          var c5y = c4y;
                          var c6x = c5x + stack.shift();
                          var c6y = c5y;
                          x = c6x;
                          y = c6y;
                          path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                          path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                          break;

                        case 35:
                          // flex
                          var pts = [];

                          for (let _i3 = 0; _i3 <= 5; _i3++) {
                            x += stack.shift();
                            y += stack.shift();
                            pts.push(x, y);
                          }

                          path.bezierCurveTo.apply(path, pts.slice(0, 6));
                          path.bezierCurveTo.apply(path, pts.slice(6));
                          stack.shift(); // fd

                          break;

                        case 36:
                          // hflex1
                          c1x = x + stack.shift();
                          c1y = y + stack.shift();
                          c2x = c1x + stack.shift();
                          c2y = c1y + stack.shift();
                          c3x = c2x + stack.shift();
                          c3y = c2y;
                          c4x = c3x + stack.shift();
                          c4y = c3y;
                          c5x = c4x + stack.shift();
                          c5y = c4y + stack.shift();
                          c6x = c5x + stack.shift();
                          c6y = c5y;
                          x = c6x;
                          y = c6y;
                          path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                          path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                          break;

                        case 37:
                          // flex1
                          var startx = x;
                          var starty = y;
                          pts = [];

                          for (let _i4 = 0; _i4 <= 4; _i4++) {
                            x += stack.shift();
                            y += stack.shift();
                            pts.push(x, y);
                          }

                          if (Math.abs(x - startx) > Math.abs(y - starty)) {
                            // horizontal
                            x += stack.shift();
                            y = starty;
                          } else {
                            x = startx;
                            y += stack.shift();
                          }

                          pts.push(x, y);
                          path.bezierCurveTo.apply(path, pts.slice(0, 6));
                          path.bezierCurveTo.apply(path, pts.slice(6));
                          break;

                        default:
                          throw new Error('Unknown op: 12 '.concat(op));
                      }

                      break;

                    default:
                      throw new Error('Unknown op: '.concat(op));
                  }
                } else if (op < 247) {
                  stack.push(op - 139);
                } else if (op < 251) {
                  var b1 = stream.readUInt8();
                  stack.push((op - 247) * 256 + b1 + 108);
                } else if (op < 255) {
                  var b1 = stream.readUInt8();
                  stack.push(-(op - 251) * 256 - b1 - 108);
                } else {
                  stack.push(stream.readInt32BE() / 65536);
                }
              }
            };

            parse();

            if (open) {
              path.closePath();
            }

            return path;
          };

          return CFFGlyph;
        }(Glyph));

        const SBIXImage = new r.Struct({
          originX: r.uint16,
          originY: r.uint16,
          type: new r.String(4),
          data: new r.Buffer(((t) => t.parent.buflen - t._currentOffset)),
        });
        /**
 * Represents a color (e.g. emoji) glyph in Apple's SBIX format.
 */

        const SBIXGlyph = /* #__PURE__ */(function (_TTFGlyph) {
          _inheritsLoose(SBIXGlyph, _TTFGlyph);

          function SBIXGlyph() {
            return _TTFGlyph.apply(this, arguments) || this;
          }

          const _proto36 = SBIXGlyph.prototype;

          /**
   * Returns an object representing a glyph image at the given point size.
   * The object has a data property with a Buffer containing the actual image data,
   * along with the image type, and origin.
   *
   * @param {number} size
   * @return {object}
   */
          _proto36.getImageForSize = function getImageForSize(size) {
            for (let i = 0; i < this._font.sbix.imageTables.length; i++) {
              var table = this._font.sbix.imageTables[i];

              if (table.ppem >= size) {
                break;
              }
            }

            const offsets = table.imageOffsets;
            const start = offsets[this.id];
            const end = offsets[this.id + 1];

            if (start === end) {
              return null;
            }

            this._font.stream.pos = start;
            return SBIXImage.decode(this._font.stream, {
              buflen: end - start,
            });
          };

          _proto36.render = function render(ctx, size) {
            const img = this.getImageForSize(size);

            if (img != null) {
              const scale = size / this._font.unitsPerEm;
              ctx.image(img.data, {
                height: size,
                x: img.originX,
                y: (this.bbox.minY - img.originY) * scale,
              });
            }

            if (this._font.sbix.flags.renderOutlines) {
              _TTFGlyph.prototype.render.call(this, ctx, size);
            }
          };

          return SBIXGlyph;
        }(TTFGlyph));

        const COLRLayer = function COLRLayer(glyph, color) {
          this.glyph = glyph;
          this.color = color;
        };
        /**
 * Represents a color (e.g. emoji) glyph in Microsoft's COLR format.
 * Each glyph in this format contain a list of colored layers, each
 * of which  is another vector glyph.
 */

        const COLRGlyph = /* #__PURE__ */(function (_Glyph3) {
          _inheritsLoose(COLRGlyph, _Glyph3);

          function COLRGlyph() {
            return _Glyph3.apply(this, arguments) || this;
          }

          const _proto37 = COLRGlyph.prototype;

          _proto37._getBBox = function _getBBox() {
            const bbox = new BBox();

            for (let i = 0; i < this.layers.length; i++) {
              const layer = this.layers[i];
              const b = layer.glyph.bbox;
              bbox.addPoint(b.minX, b.minY);
              bbox.addPoint(b.maxX, b.maxY);
            }

            return bbox;
          }
          /**
   * Returns an array of objects containing the glyph and color for
   * each layer in the composite color glyph.
   * @type {object[]}
   */
          ;

          _proto37.render = function render(ctx, size) {
            for (var _iterator71 = _createForOfIteratorHelperLoose(this.layers), _step71; !(_step71 = _iterator71()).done;) {
              const _step71$value = _step71.value;
              const { glyph } = _step71$value;
              const { color } = _step71$value;
              ctx.fillColor([color.red, color.green, color.blue], color.alpha / 255 * 100);
              glyph.render(ctx, size);
            }
          };

          _createClass(COLRGlyph, [{
            key: 'layers',
            get: function get() {
              const cpal = this._font.CPAL;
              const colr = this._font.COLR;
              let low = 0;
              let high = colr.baseGlyphRecord.length - 1;

              while (low <= high) {
                const mid = low + high >> 1;
                var rec = colr.baseGlyphRecord[mid];

                if (this.id < rec.gid) {
                  high = mid - 1;
                } else if (this.id > rec.gid) {
                  low = mid + 1;
                } else {
                  var baseLayer = rec;
                  break;
                }
              } // if base glyph not found in COLR table,
              // default to normal glyph from glyf or CFF

              if (baseLayer == null) {
                var g = this._font._getBaseGlyph(this.id);

                var color = {
                  red: 0,
                  green: 0,
                  blue: 0,
                  alpha: 255,
                };
                return [new COLRLayer(g, color)];
              } // otherwise, return an array of all the layers

              const layers = [];

              for (let i = baseLayer.firstLayerIndex; i < baseLayer.firstLayerIndex + baseLayer.numLayers; i++) {
                var rec = colr.layerRecords[i];
                var color = cpal.colorRecords[rec.paletteIndex];

                var g = this._font._getBaseGlyph(rec.gid);

                layers.push(new COLRLayer(g, color));
              }

              return layers;
            },
          }]);

          return COLRGlyph;
        }(Glyph));

        const TUPLES_SHARE_POINT_NUMBERS = 0x8000;
        const TUPLE_COUNT_MASK = 0x0fff;
        const EMBEDDED_TUPLE_COORD = 0x8000;
        const INTERMEDIATE_TUPLE = 0x4000;
        const PRIVATE_POINT_NUMBERS = 0x2000;
        const TUPLE_INDEX_MASK = 0x0fff;
        const POINTS_ARE_WORDS = 0x80;
        const POINT_RUN_COUNT_MASK = 0x7f;
        const DELTAS_ARE_ZERO = 0x80;
        const DELTAS_ARE_WORDS = 0x40;
        const DELTA_RUN_COUNT_MASK = 0x3f;
        /**
 * This class is transforms TrueType glyphs according to the data from
 * the Apple Advanced Typography variation tables (fvar, gvar, and avar).
 * These tables allow infinite adjustments to glyph weight, width, slant,
 * and optical size without the designer needing to specify every exact style.
 *
 * Apple's documentation for these tables is not great, so thanks to the
 * Freetype project for figuring much of this out.
 *
 * @private
 */

        const GlyphVariationProcessor = /* #__PURE__ */(function () {
          function GlyphVariationProcessor(font, coords) {
            this.font = font;
            this.normalizedCoords = this.normalizeCoords(coords);
            this.blendVectors = new Map();
          }

          const _proto38 = GlyphVariationProcessor.prototype;

          _proto38.normalizeCoords = function normalizeCoords(coords) {
            // the default mapping is linear along each axis, in two segments:
            // from the minValue to defaultValue, and from defaultValue to maxValue.
            const normalized = [];

            for (var i = 0; i < this.font.fvar.axis.length; i++) {
              const axis = this.font.fvar.axis[i];

              if (coords[i] < axis.defaultValue) {
                normalized.push((coords[i] - axis.defaultValue + Number.EPSILON) / (axis.defaultValue - axis.minValue + Number.EPSILON));
              } else {
                normalized.push((coords[i] - axis.defaultValue + Number.EPSILON) / (axis.maxValue - axis.defaultValue + Number.EPSILON));
              }
            } // if there is an avar table, the normalized value is calculated
            // by interpolating between the two nearest mapped values.

            if (this.font.avar) {
              for (var i = 0; i < this.font.avar.segment.length; i++) {
                const segment = this.font.avar.segment[i];

                for (let j = 0; j < segment.correspondence.length; j++) {
                  const pair = segment.correspondence[j];

                  if (j >= 1 && normalized[i] < pair.fromCoord) {
                    const prev = segment.correspondence[j - 1];
                    normalized[i] = ((normalized[i] - prev.fromCoord) * (pair.toCoord - prev.toCoord) + Number.EPSILON) / (pair.fromCoord - prev.fromCoord + Number.EPSILON) + prev.toCoord;
                    break;
                  }
                }
              }
            }

            return normalized;
          };

          _proto38.transformPoints = function transformPoints(gid, glyphPoints) {
            if (!this.font.fvar || !this.font.gvar) {
              return;
            }

            const { gvar } = this.font;

            if (gid >= gvar.glyphCount) {
              return;
            }

            const offset = gvar.offsets[gid];

            if (offset === gvar.offsets[gid + 1]) {
              return;
            } // Read the gvar data for this glyph

            const { stream } = this.font;
            stream.pos = offset;

            if (stream.pos >= stream.length) {
              return;
            }

            let tupleCount = stream.readUInt16BE();
            let offsetToData = offset + stream.readUInt16BE();

            if (tupleCount & TUPLES_SHARE_POINT_NUMBERS) {
              var here = stream.pos;
              stream.pos = offsetToData;
              var sharedPoints = this.decodePoints();
              offsetToData = stream.pos;
              stream.pos = here;
            }

            const origPoints = glyphPoints.map((pt) => pt.copy());
            tupleCount &= TUPLE_COUNT_MASK;

            for (let i = 0; i < tupleCount; i++) {
              const tupleDataSize = stream.readUInt16BE();
              const tupleIndex = stream.readUInt16BE();

              if (tupleIndex & EMBEDDED_TUPLE_COORD) {
                var tupleCoords = [];

                for (let a = 0; a < gvar.axisCount; a++) {
                  tupleCoords.push(stream.readInt16BE() / 16384);
                }
              } else {
                if ((tupleIndex & TUPLE_INDEX_MASK) >= gvar.globalCoordCount) {
                  throw new Error('Invalid gvar table');
                }

                var tupleCoords = gvar.globalCoords[tupleIndex & TUPLE_INDEX_MASK];
              }

              if (tupleIndex & INTERMEDIATE_TUPLE) {
                var startCoords = [];

                for (let _a = 0; _a < gvar.axisCount; _a++) {
                  startCoords.push(stream.readInt16BE() / 16384);
                }

                var endCoords = [];

                for (let _a2 = 0; _a2 < gvar.axisCount; _a2++) {
                  endCoords.push(stream.readInt16BE() / 16384);
                }
              } // Get the factor at which to apply this tuple

              const factor = this.tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords);

              if (factor === 0) {
                offsetToData += tupleDataSize;
                continue;
              }

              var here = stream.pos;
              stream.pos = offsetToData;

              if (tupleIndex & PRIVATE_POINT_NUMBERS) {
                var points = this.decodePoints();
              } else {
                var points = sharedPoints;
              } // points.length = 0 means there are deltas for all points

              const nPoints = points.length === 0 ? glyphPoints.length : points.length;
              const xDeltas = this.decodeDeltas(nPoints);
              const yDeltas = this.decodeDeltas(nPoints);

              if (points.length === 0) {
                // all points
                for (let _i = 0; _i < glyphPoints.length; _i++) {
                  const point = glyphPoints[_i];
                  point.x += Math.round(xDeltas[_i] * factor);
                  point.y += Math.round(yDeltas[_i] * factor);
                }
              } else {
                const outPoints = origPoints.map((pt) => pt.copy());
                const hasDelta = glyphPoints.map(() => false);

                for (let _i2 = 0; _i2 < points.length; _i2++) {
                  const idx = points[_i2];

                  if (idx < glyphPoints.length) {
                    const _point = outPoints[idx];
                    hasDelta[idx] = true;
                    _point.x += Math.round(xDeltas[_i2] * factor);
                    _point.y += Math.round(yDeltas[_i2] * factor);
                  }
                }

                this.interpolateMissingDeltas(outPoints, origPoints, hasDelta);

                for (let _i3 = 0; _i3 < glyphPoints.length; _i3++) {
                  const deltaX = outPoints[_i3].x - origPoints[_i3].x;
                  const deltaY = outPoints[_i3].y - origPoints[_i3].y;
                  glyphPoints[_i3].x += deltaX;
                  glyphPoints[_i3].y += deltaY;
                }
              }

              offsetToData += tupleDataSize;
              stream.pos = here;
            }
          };

          _proto38.decodePoints = function decodePoints() {
            const { stream } = this.font;
            let count = stream.readUInt8();

            if (count & POINTS_ARE_WORDS) {
              count = (count & POINT_RUN_COUNT_MASK) << 8 | stream.readUInt8();
            }

            const points = new Uint16Array(count);
            let i = 0;
            let point = 0;

            while (i < count) {
              const run = stream.readUInt8();
              const runCount = (run & POINT_RUN_COUNT_MASK) + 1;
              const fn = run & POINTS_ARE_WORDS ? stream.readUInt16 : stream.readUInt8;

              for (let j = 0; j < runCount && i < count; j++) {
                point += fn.call(stream);
                points[i++] = point;
              }
            }

            return points;
          };

          _proto38.decodeDeltas = function decodeDeltas(count) {
            const { stream } = this.font;
            let i = 0;
            const deltas = new Int16Array(count);

            while (i < count) {
              const run = stream.readUInt8();
              const runCount = (run & DELTA_RUN_COUNT_MASK) + 1;

              if (run & DELTAS_ARE_ZERO) {
                i += runCount;
              } else {
                const fn = run & DELTAS_ARE_WORDS ? stream.readInt16BE : stream.readInt8;

                for (let j = 0; j < runCount && i < count; j++) {
                  deltas[i++] = fn.call(stream);
                }
              }
            }

            return deltas;
          };

          _proto38.tupleFactor = function tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords) {
            const normalized = this.normalizedCoords;
            const { gvar } = this.font;
            let factor = 1;

            for (let i = 0; i < gvar.axisCount; i++) {
              if (tupleCoords[i] === 0) {
                continue;
              }

              if (normalized[i] === 0) {
                return 0;
              }

              if ((tupleIndex & INTERMEDIATE_TUPLE) === 0) {
                if (normalized[i] < Math.min(0, tupleCoords[i]) || normalized[i] > Math.max(0, tupleCoords[i])) {
                  return 0;
                }

                factor = (factor * normalized[i] + Number.EPSILON) / (tupleCoords[i] + Number.EPSILON);
              } else {
                if (normalized[i] < startCoords[i] || normalized[i] > endCoords[i]) {
                  return 0;
                } if (normalized[i] < tupleCoords[i]) {
                  factor = factor * (normalized[i] - startCoords[i] + Number.EPSILON) / (tupleCoords[i] - startCoords[i] + Number.EPSILON);
                } else {
                  factor = factor * (endCoords[i] - normalized[i] + Number.EPSILON) / (endCoords[i] - tupleCoords[i] + Number.EPSILON);
                }
              }
            }

            return factor;
          } // Interpolates points without delta values.
          // Needed for the Ø and Q glyphs in Skia.
          // Algorithm from Freetype.
          ;

          _proto38.interpolateMissingDeltas = function interpolateMissingDeltas(points, inPoints, hasDelta) {
            if (points.length === 0) {
              return;
            }

            let point = 0;

            while (point < points.length) {
              const firstPoint = point; // find the end point of the contour

              let endPoint = point;
              let pt = points[endPoint];

              while (!pt.endContour) {
                pt = points[++endPoint];
              } // find the first point that has a delta

              while (point <= endPoint && !hasDelta[point]) {
                point++;
              }

              if (point > endPoint) {
                continue;
              }

              const firstDelta = point;
              let curDelta = point;
              point++;

              while (point <= endPoint) {
                // find the next point with a delta, and interpolate intermediate points
                if (hasDelta[point]) {
                  this.deltaInterpolate(curDelta + 1, point - 1, curDelta, point, inPoints, points);
                  curDelta = point;
                }

                point++;
              } // shift contour if we only have a single delta

              if (curDelta === firstDelta) {
                this.deltaShift(firstPoint, endPoint, curDelta, inPoints, points);
              } else {
                // otherwise, handle the remaining points at the end and beginning of the contour
                this.deltaInterpolate(curDelta + 1, endPoint, curDelta, firstDelta, inPoints, points);

                if (firstDelta > 0) {
                  this.deltaInterpolate(firstPoint, firstDelta - 1, curDelta, firstDelta, inPoints, points);
                }
              }

              point = endPoint + 1;
            }
          };

          _proto38.deltaInterpolate = function deltaInterpolate(p1, p2, ref1, ref2, inPoints, outPoints) {
            if (p1 > p2) {
              return;
            }

            const iterable = ['x', 'y'];

            for (let i = 0; i < iterable.length; i++) {
              const k = iterable[i];

              if (inPoints[ref1][k] > inPoints[ref2][k]) {
                const p = ref1;
                ref1 = ref2;
                ref2 = p;
              }

              const in1 = inPoints[ref1][k];
              const in2 = inPoints[ref2][k];
              const out1 = outPoints[ref1][k];
              const out2 = outPoints[ref2][k]; // If the reference points have the same coordinate but different
              // delta, inferred delta is zero.  Otherwise interpolate.

              if (in1 !== in2 || out1 === out2) {
                const scale = in1 === in2 ? 0 : (out2 - out1) / (in2 - in1);

                for (let _p = p1; _p <= p2; _p++) {
                  let out = inPoints[_p][k];

                  if (out <= in1) {
                    out += out1 - in1;
                  } else if (out >= in2) {
                    out += out2 - in2;
                  } else {
                    out = out1 + (out - in1) * scale;
                  }

                  outPoints[_p][k] = out;
                }
              }
            }
          };

          _proto38.deltaShift = function deltaShift(p1, p2, ref, inPoints, outPoints) {
            const deltaX = outPoints[ref].x - inPoints[ref].x;
            const deltaY = outPoints[ref].y - inPoints[ref].y;

            if (deltaX === 0 && deltaY === 0) {
              return;
            }

            for (let p = p1; p <= p2; p++) {
              if (p !== ref) {
                outPoints[p].x += deltaX;
                outPoints[p].y += deltaY;
              }
            }
          };

          _proto38.getAdvanceAdjustment = function getAdvanceAdjustment(gid, table) {
            let outerIndex; let
              innerIndex;

            if (table.advanceWidthMapping) {
              let idx = gid;

              if (idx >= table.advanceWidthMapping.mapCount) {
                idx = table.advanceWidthMapping.mapCount - 1;
              }

              const { entryFormat } = table.advanceWidthMapping;
              const _table$advanceWidthMa = table.advanceWidthMapping.mapData[idx];
              outerIndex = _table$advanceWidthMa.outerIndex;
              innerIndex = _table$advanceWidthMa.innerIndex;
            } else {
              outerIndex = 0;
              innerIndex = gid;
            }

            return this.getDelta(table.itemVariationStore, outerIndex, innerIndex);
          } // See pseudo code from `Font Variations Overview'
          // in the OpenType specification.
          ;

          _proto38.getDelta = function getDelta(itemStore, outerIndex, innerIndex) {
            if (outerIndex >= itemStore.itemVariationData.length) {
              return 0;
            }

            const varData = itemStore.itemVariationData[outerIndex];

            if (innerIndex >= varData.deltaSets.length) {
              return 0;
            }

            const deltaSet = varData.deltaSets[innerIndex];
            const blendVector = this.getBlendVector(itemStore, outerIndex);
            let netAdjustment = 0;

            for (let master = 0; master < varData.regionIndexCount; master++) {
              netAdjustment += deltaSet.deltas[master] * blendVector[master];
            }

            return netAdjustment;
          };

          _proto38.getBlendVector = function getBlendVector(itemStore, outerIndex) {
            const varData = itemStore.itemVariationData[outerIndex];

            if (this.blendVectors.has(varData)) {
              return this.blendVectors.get(varData);
            }

            const { normalizedCoords } = this;
            const blendVector = []; // outer loop steps through master designs to be blended

            for (let master = 0; master < varData.regionIndexCount; master++) {
              let scalar = 1;
              const regionIndex = varData.regionIndexes[master];
              const axes = itemStore.variationRegionList.variationRegions[regionIndex]; // inner loop steps through axes in this region

              for (let j = 0; j < axes.length; j++) {
                const axis = axes[j];
                let axisScalar = void 0; // compute the scalar contribution of this axis
                // ignore invalid ranges

                if (axis.startCoord > axis.peakCoord || axis.peakCoord > axis.endCoord) {
                  axisScalar = 1;
                } else if (axis.startCoord < 0 && axis.endCoord > 0 && axis.peakCoord !== 0) {
                  axisScalar = 1; // peak of 0 means ignore this axis
                } else if (axis.peakCoord === 0) {
                  axisScalar = 1; // ignore this region if coords are out of range
                } else if (normalizedCoords[j] < axis.startCoord || normalizedCoords[j] > axis.endCoord) {
                  axisScalar = 0; // calculate a proportional factor
                } else if (normalizedCoords[j] === axis.peakCoord) {
                  axisScalar = 1;
                } else if (normalizedCoords[j] < axis.peakCoord) {
                  axisScalar = (normalizedCoords[j] - axis.startCoord + Number.EPSILON) / (axis.peakCoord - axis.startCoord + Number.EPSILON);
                } else {
                  axisScalar = (axis.endCoord - normalizedCoords[j] + Number.EPSILON) / (axis.endCoord - axis.peakCoord + Number.EPSILON);
                } // take product of all the axis scalars

                scalar *= axisScalar;
              }

              blendVector[master] = scalar;
            }

            this.blendVectors.set(varData, blendVector);
            return blendVector;
          };

          return GlyphVariationProcessor;
        }());

        const resolved = Promise.resolve();

        const Subset = /* #__PURE__ */(function () {
          function Subset(font) {
            this.font = font;
            this.glyphs = [];
            this.mapping = {}; // always include the missing glyph

            this.includeGlyph(0);
          }

          const _proto39 = Subset.prototype;

          _proto39.includeGlyph = function includeGlyph(glyph) {
            if (typeof glyph === 'object') {
              glyph = glyph.id;
            }

            if (this.mapping[glyph] == null) {
              this.glyphs.push(glyph);
              this.mapping[glyph] = this.glyphs.length - 1;
            }

            return this.mapping[glyph];
          };

          _proto39.encodeStream = function encodeStream() {
            const _this11 = this;

            const s = new r.EncodeStream();
            resolved.then(() => {
              _this11.encode(s);

              return s.end();
            });
            return s;
          };

          return Subset;
        }());

        const ON_CURVE$1 = 1 << 0;
        const X_SHORT_VECTOR$1 = 1 << 1;
        const Y_SHORT_VECTOR$1 = 1 << 2;
        const REPEAT$1 = 1 << 3;
        const SAME_X$1 = 1 << 4;
        const SAME_Y$1 = 1 << 5;

        const Point$1 = /* #__PURE__ */(function () {
          function Point$1() {}

          Point$1.size = function size(val) {
            return val >= 0 && val <= 255 ? 1 : 2;
          };

          Point$1.encode = function encode(stream, value) {
            if (value >= 0 && value <= 255) {
              stream.writeUInt8(value);
            } else {
              stream.writeInt16BE(value);
            }
          };

          return Point$1;
        }());

        const Glyf = new r.Struct({
          numberOfContours: r.int16,
          // if negative, this is a composite glyph
          xMin: r.int16,
          yMin: r.int16,
          xMax: r.int16,
          yMax: r.int16,
          endPtsOfContours: new r.Array(r.uint16, 'numberOfContours'),
          instructions: new r.Array(r.uint8, r.uint16),
          flags: new r.Array(r.uint8, 0),
          xPoints: new r.Array(Point$1, 0),
          yPoints: new r.Array(Point$1, 0),
        });
        /**
 * Encodes TrueType glyph outlines
 */

        const TTFGlyphEncoder = /* #__PURE__ */(function () {
          function TTFGlyphEncoder() {}

          const _proto40 = TTFGlyphEncoder.prototype;

          _proto40.encodeSimple = function encodeSimple(path, instructions) {
            if (instructions === void 0) {
              instructions = [];
            }

            const endPtsOfContours = [];
            const xPoints = [];
            const yPoints = [];
            const flags = [];
            let same = 0;
            let lastX = 0;
            let lastY = 0;
            let lastFlag = 0;
            let pointCount = 0;

            for (let i = 0; i < path.commands.length; i++) {
              const c = path.commands[i];

              for (let j = 0; j < c.args.length; j += 2) {
                const x = c.args[j];
                const y = c.args[j + 1];
                let flag = 0; // If the ending point of a quadratic curve is the midpoint
                // between the control point and the control point of the next
                // quadratic curve, we can omit the ending point.

                if (c.command === 'quadraticCurveTo' && j === 2) {
                  const next = path.commands[i + 1];

                  if (next && next.command === 'quadraticCurveTo') {
                    const midX = (lastX + next.args[0]) / 2;
                    const midY = (lastY + next.args[1]) / 2;

                    if (x === midX && y === midY) {
                      continue;
                    }
                  }
                } // All points except control points are on curve.

                if (!(c.command === 'quadraticCurveTo' && j === 0)) {
                  flag |= ON_CURVE$1;
                }

                flag = this._encodePoint(x, lastX, xPoints, flag, X_SHORT_VECTOR$1, SAME_X$1);
                flag = this._encodePoint(y, lastY, yPoints, flag, Y_SHORT_VECTOR$1, SAME_Y$1);

                if (flag === lastFlag && same < 255) {
                  flags[flags.length - 1] |= REPEAT$1;
                  same++;
                } else {
                  if (same > 0) {
                    flags.push(same);
                    same = 0;
                  }

                  flags.push(flag);
                  lastFlag = flag;
                }

                lastX = x;
                lastY = y;
                pointCount++;
              }

              if (c.command === 'closePath') {
                endPtsOfContours.push(pointCount - 1);
              }
            } // Close the path if the last command didn't already

            if (path.commands.length > 1 && path.commands[path.commands.length - 1].command !== 'closePath') {
              endPtsOfContours.push(pointCount - 1);
            }

            const { bbox } = path;
            const glyf = {
              numberOfContours: endPtsOfContours.length,
              xMin: bbox.minX,
              yMin: bbox.minY,
              xMax: bbox.maxX,
              yMax: bbox.maxY,
              endPtsOfContours,
              instructions,
              flags,
              xPoints,
              yPoints,
            };
            const size = Glyf.size(glyf);
            const tail = 4 - size % 4;
            const stream = new r.EncodeStream(size + tail);
            Glyf.encode(stream, glyf); // Align to 4-byte length

            if (tail !== 0) {
              stream.fill(0, tail);
            }

            return stream.buffer;
          };

          _proto40._encodePoint = function _encodePoint(value, last, points, flag, shortFlag, sameFlag) {
            let diff = value - last;

            if (value === last) {
              flag |= sameFlag;
            } else {
              if (diff >= -255 && diff <= 255) {
                flag |= shortFlag;

                if (diff < 0) {
                  diff = -diff;
                } else {
                  flag |= sameFlag;
                }
              }

              points.push(diff);
            }

            return flag;
          };

          return TTFGlyphEncoder;
        }());

        const TTFSubset = /* #__PURE__ */(function (_Subset) {
          _inheritsLoose(TTFSubset, _Subset);

          function TTFSubset(font) {
            let _this12;

            _this12 = _Subset.call(this, font) || this;
            _this12.glyphEncoder = new TTFGlyphEncoder();
            return _this12;
          }

          const _proto41 = TTFSubset.prototype;

          _proto41._addGlyph = function _addGlyph(gid) {
            const glyph = this.font.getGlyph(gid);

            const glyf = glyph._decode(); // get the offset to the glyph from the loca table

            const curOffset = this.font.loca.offsets[gid];
            const nextOffset = this.font.loca.offsets[gid + 1];

            const stream = this.font._getTableStream('glyf');

            stream.pos += curOffset;
            let buffer = stream.readBuffer(nextOffset - curOffset); // if it is a compound glyph, include its components

            if (glyf && glyf.numberOfContours < 0) {
              buffer = Buffer.from(buffer);

              for (var _iterator72 = _createForOfIteratorHelperLoose(glyf.components), _step72; !(_step72 = _iterator72()).done;) {
                const component = _step72.value;
                gid = this.includeGlyph(component.glyphID);
                buffer.writeUInt16BE(gid, component.pos);
              }
            } else if (glyf && this.font._variationProcessor) {
              // If this is a TrueType variation glyph, re-encode the path
              buffer = this.glyphEncoder.encodeSimple(glyph.path, glyf.instructions);
            }

            this.glyf.push(buffer);
            this.loca.offsets.push(this.offset);
            this.hmtx.metrics.push({
              advance: glyph.advanceWidth,
              bearing: glyph._getMetrics().leftBearing,
            });
            this.offset += buffer.length;
            return this.glyf.length - 1;
          };

          _proto41.encode = function encode(stream) {
            // tables required by PDF spec:
            //   head, hhea, loca, maxp, cvt , prep, glyf, hmtx, fpgm
            //
            // additional tables required for standalone fonts:
            //   name, cmap, OS/2, post
            this.glyf = [];
            this.offset = 0;
            this.loca = {
              offsets: [],
              version: this.font.loca.version,
            };
            this.hmtx = {
              metrics: [],
              bearings: [],
            }; // include all the glyphs
            // not using a for loop because we need to support adding more
            // glyphs to the array as we go, and CoffeeScript caches the length.

            let i = 0;

            while (i < this.glyphs.length) {
              this._addGlyph(this.glyphs[i++]);
            }

            const maxp = cloneDeep(this.font.maxp);
            maxp.numGlyphs = this.glyf.length;
            this.loca.offsets.push(this.offset);
            const head = cloneDeep(this.font.head);
            head.indexToLocFormat = this.loca.version;
            const hhea = cloneDeep(this.font.hhea);
            hhea.numberOfMetrics = this.hmtx.metrics.length; // map = []
            // for index in [0...256]
            //     if index < @numGlyphs
            //         map[index] = index
            //     else
            //         map[index] = 0
            //
            // cmapTable =
            //     version: 0
            //     length: 262
            //     language: 0
            //     codeMap: map
            //
            // cmap =
            //     version: 0
            //     numSubtables: 1
            //     tables: [
            //         platformID: 1
            //         encodingID: 0
            //         table: cmapTable
            //     ]
            // TODO: subset prep, cvt, fpgm?

            Directory.encode(stream, {
              tables: {
                head,
                hhea,
                loca: this.loca,
                maxp,
                'cvt ': this.font['cvt '],
                prep: this.font.prep,
                glyf: this.glyf,
                hmtx: this.hmtx,
                fpgm: this.font.fpgm, // name: clone @font.name
                // 'OS/2': clone @font['OS/2']
                // post: clone @font.post
                // cmap: cmap

              },
            });
          };

          return TTFSubset;
        }(Subset));

        const CFFSubset = /* #__PURE__ */(function (_Subset2) {
          _inheritsLoose(CFFSubset, _Subset2);

          function CFFSubset(font) {
            let _this13;

            _this13 = _Subset2.call(this, font) || this;
            _this13.cff = _this13.font['CFF '];

            if (!_this13.cff) {
              throw new Error('Not a CFF Font');
            }

            return _this13;
          }

          const _proto42 = CFFSubset.prototype;

          _proto42.subsetCharstrings = function subsetCharstrings() {
            this.charstrings = [];
            const gsubrs = {};

            for (var _iterator73 = _createForOfIteratorHelperLoose(this.glyphs), _step73; !(_step73 = _iterator73()).done;) {
              const gid = _step73.value;
              this.charstrings.push(this.cff.getCharString(gid));
              const glyph = this.font.getGlyph(gid);
              const { path } = glyph; // this causes the glyph to be parsed

              for (const subr in glyph._usedGsubrs) {
                gsubrs[subr] = true;
              }
            }

            this.gsubrs = this.subsetSubrs(this.cff.globalSubrIndex, gsubrs);
          };

          _proto42.subsetSubrs = function subsetSubrs(subrs, used) {
            const res = [];

            for (let i = 0; i < subrs.length; i++) {
              const subr = subrs[i];

              if (used[i]) {
                this.cff.stream.pos = subr.offset;
                res.push(this.cff.stream.readBuffer(subr.length));
              } else {
                res.push(Buffer.from([11])); // return
              }
            }

            return res;
          };

          _proto42.subsetFontdict = function subsetFontdict(topDict) {
            topDict.FDArray = [];
            topDict.FDSelect = {
              version: 0,
              fds: [],
            };
            const used_fds = {};
            const used_subrs = [];
            const fd_select = {};

            for (var _iterator74 = _createForOfIteratorHelperLoose(this.glyphs), _step74; !(_step74 = _iterator74()).done;) {
              const gid = _step74.value;
              const fd = this.cff.fdForGlyph(gid);

              if (fd == null) {
                continue;
              }

              if (!used_fds[fd]) {
                topDict.FDArray.push({ ...this.cff.topDict.FDArray[fd] });
                used_subrs.push({});
                fd_select[fd] = topDict.FDArray.length - 1;
              }

              used_fds[fd] = true;
              topDict.FDSelect.fds.push(fd_select[fd]);
              const glyph = this.font.getGlyph(gid);
              const { path } = glyph; // this causes the glyph to be parsed

              for (const subr in glyph._usedSubrs) {
                used_subrs[fd_select[fd]][subr] = true;
              }
            }

            for (let i = 0; i < topDict.FDArray.length; i++) {
              const dict = topDict.FDArray[i];
              delete dict.FontName;

              if (dict.Private && dict.Private.Subrs) {
                dict.Private = { ...dict.Private };
                dict.Private.Subrs = this.subsetSubrs(dict.Private.Subrs, used_subrs[i]);
              }
            }
          };

          _proto42.createCIDFontdict = function createCIDFontdict(topDict) {
            const used_subrs = {};

            for (var _iterator75 = _createForOfIteratorHelperLoose(this.glyphs), _step75; !(_step75 = _iterator75()).done;) {
              const gid = _step75.value;
              const glyph = this.font.getGlyph(gid);
              const { path } = glyph; // this causes the glyph to be parsed

              for (const subr in glyph._usedSubrs) {
                used_subrs[subr] = true;
              }
            }

            const privateDict = { ...this.cff.topDict.Private };

            if (this.cff.topDict.Private && this.cff.topDict.Private.Subrs) {
              privateDict.Subrs = this.subsetSubrs(this.cff.topDict.Private.Subrs, used_subrs);
            }

            topDict.FDArray = [{
              Private: privateDict,
            }];
            return topDict.FDSelect = {
              version: 3,
              nRanges: 1,
              ranges: [{
                first: 0,
                fd: 0,
              }],
              sentinel: this.charstrings.length,
            };
          };

          _proto42.addString = function addString(string) {
            if (!string) {
              return null;
            }

            if (!this.strings) {
              this.strings = [];
            }

            this.strings.push(string);
            return standardStrings.length + this.strings.length - 1;
          };

          _proto42.encode = function encode(stream) {
            this.subsetCharstrings();
            const charset = {
              version: this.charstrings.length > 255 ? 2 : 1,
              ranges: [{
                first: 1,
                nLeft: this.charstrings.length - 2,
              }],
            };
            const topDict = { ...this.cff.topDict };
            topDict.Private = null;
            topDict.charset = charset;
            topDict.Encoding = null;
            topDict.CharStrings = this.charstrings;

            for (let _i24 = 0, _arr2 = ['version', 'Notice', 'Copyright', 'FullName', 'FamilyName', 'Weight', 'PostScript', 'BaseFontName', 'FontName']; _i24 < _arr2.length; _i24++) {
              const key = _arr2[_i24];
              topDict[key] = this.addString(this.cff.string(topDict[key]));
            }

            topDict.ROS = [this.addString('Adobe'), this.addString('Identity'), 0];
            topDict.CIDCount = this.charstrings.length;

            if (this.cff.isCIDFont) {
              this.subsetFontdict(topDict);
            } else {
              this.createCIDFontdict(topDict);
            }

            const top = {
              version: 1,
              hdrSize: this.cff.hdrSize,
              offSize: 4,
              header: this.cff.header,
              nameIndex: [this.cff.postscriptName],
              topDictIndex: [topDict],
              stringIndex: this.strings,
              globalSubrIndex: this.gsubrs,
            };
            CFFTop.encode(stream, top);
          };

          return CFFSubset;
        }(Subset));

        let _class$4;
        /**
 * This is the base class for all SFNT-based font formats in fontkit.
 * It supports TrueType, and PostScript glyphs, and several color glyph formats.
 */

        const TTFFont = (_class$4 = /* #__PURE__ */(function () {
          TTFFont.probe = function probe(buffer) {
            const format = buffer.toString('ascii', 0, 4);
            return format === 'true' || format === 'OTTO' || format === String.fromCharCode(0, 1, 0, 0);
          };

          function TTFFont(stream, variationCoords) {
            if (variationCoords === void 0) {
              variationCoords = null;
            }

            this.defaultLanguage = null;
            this.stream = stream;
            this.variationCoords = variationCoords;
            this._directoryPos = this.stream.pos;
            this._tables = {};
            this._glyphs = {};

            this._decodeDirectory(); // define properties for each table to lazily parse

            for (const tag in this.directory.tables) {
              const table = this.directory.tables[tag];

              if (tables[tag] && table.length > 0) {
                Object.defineProperty(this, tag, {
                  get: this._getTable.bind(this, table),
                });
              }
            }
          }

          const _proto43 = TTFFont.prototype;

          _proto43.setDefaultLanguage = function setDefaultLanguage(lang) {
            if (lang === void 0) {
              lang = null;
            }

            this.defaultLanguage = lang;
          };

          _proto43._getTable = function _getTable(table) {
            if (!(table.tag in this._tables)) {
              try {
                this._tables[table.tag] = this._decodeTable(table);
              } catch (e) {
                if (fontkit.logErrors) {
                  console.error('Error decoding table '.concat(table.tag));
                  console.error(e.stack);
                }
              }
            }

            return this._tables[table.tag];
          };

          _proto43._getTableStream = function _getTableStream(tag) {
            const table = this.directory.tables[tag];

            if (table) {
              this.stream.pos = table.offset;
              return this.stream;
            }

            return null;
          };

          _proto43._decodeDirectory = function _decodeDirectory() {
            return this.directory = Directory.decode(this.stream, {
              _startOffset: 0,
            });
          };

          _proto43._decodeTable = function _decodeTable(table) {
            const { pos } = this.stream;

            const stream = this._getTableStream(table.tag);

            const result = tables[table.tag].decode(stream, this, table.length);
            this.stream.pos = pos;
            return result;
          }
          /**
   * Gets a string from the font's `name` table
   * `lang` is a BCP-47 language code.
   * @return {string}
   */
          ;

          _proto43.getName = function getName(key, lang) {
            if (lang === void 0) {
              lang = this.defaultLanguage || fontkit.defaultLanguage;
            }

            const record = this.name && this.name.records[key];

            if (record) {
              // Attempt to retrieve the entry, depending on which translation is available:
              return record[lang] || record[this.defaultLanguage] || record[fontkit.defaultLanguage] || record.en || record[Object.keys(record)[0]] // Seriously, ANY language would be fine
      || null;
            }

            return null;
          }
          /**
   * The unique PostScript name for this font, e.g. "Helvetica-Bold"
   * @type {string}
   */
          ;

          /**
   * Returns whether there is glyph in the font for the given unicode code point.
   *
   * @param {number} codePoint
   * @return {boolean}
   */
          _proto43.hasGlyphForCodePoint = function hasGlyphForCodePoint(codePoint) {
            return !!this._cmapProcessor.lookup(codePoint);
          }
          /**
   * Maps a single unicode code point to a Glyph object.
   * Does not perform any advanced substitutions (there is no context to do so).
   *
   * @param {number} codePoint
   * @return {Glyph}
   */
          ;

          _proto43.glyphForCodePoint = function glyphForCodePoint(codePoint) {
            return this.getGlyph(this._cmapProcessor.lookup(codePoint), [codePoint]);
          }
          /**
   * Returns an array of Glyph objects for the given string.
   * This is only a one-to-one mapping from characters to glyphs.
   * For most uses, you should use font.layout (described below), which
   * provides a much more advanced mapping supporting AAT and OpenType shaping.
   *
   * @param {string} string
   * @return {Glyph[]}
   */
          ;

          _proto43.glyphsForString = function glyphsForString(string) {
            const glyphs = [];
            const len = string.length;
            let idx = 0;
            let last = -1;
            let state = -1;

            while (idx <= len) {
              let code = 0;
              let nextState = 0;

              if (idx < len) {
                // Decode the next codepoint from UTF 16
                code = string.charCodeAt(idx++);

                if (code >= 0xd800 && code <= 0xdbff && idx < len) {
                  const next = string.charCodeAt(idx);

                  if (next >= 0xdc00 && next <= 0xdfff) {
                    idx++;
                    code = ((code & 0x3ff) << 10) + (next & 0x3ff) + 0x10000;
                  }
                } // Compute the next state: 1 if the next codepoint is a variation selector, 0 otherwise.

                nextState = code >= 0xfe00 && code <= 0xfe0f || code >= 0xe0100 && code <= 0xe01ef ? 1 : 0;
              } else {
                idx++;
              }

              if (state === 0 && nextState === 1) {
                // Variation selector following normal codepoint.
                glyphs.push(this.getGlyph(this._cmapProcessor.lookup(last, code), [last, code]));
              } else if (state === 0 && nextState === 0) {
                // Normal codepoint following normal codepoint.
                glyphs.push(this.glyphForCodePoint(last));
              }

              last = code;
              state = nextState;
            }

            return glyphs;
          };

          /**
   * Returns a GlyphRun object, which includes an array of Glyphs and GlyphPositions for the given string.
   *
   * @param {string} string
   * @param {string[]} [userFeatures]
   * @param {string} [script]
   * @param {string} [language]
   * @param {string} [direction]
   * @return {GlyphRun}
   */
          _proto43.layout = function layout(string, userFeatures, script, language, direction) {
            return this._layoutEngine.layout(string, userFeatures, script, language, direction);
          }
          /**
   * Returns an array of strings that map to the given glyph id.
   * @param {number} gid - glyph id
   */
          ;

          _proto43.stringsForGlyph = function stringsForGlyph(gid) {
            return this._layoutEngine.stringsForGlyph(gid);
          }
          /**
   * An array of all [OpenType feature tags](https://www.microsoft.com/typography/otspec/featuretags.htm)
   * (or mapped AAT tags) supported by the font.
   * The features parameter is an array of OpenType feature tags to be applied in addition to the default set.
   * If this is an AAT font, the OpenType feature tags are mapped to AAT features.
   *
   * @type {string[]}
   */
          ;

          _proto43.getAvailableFeatures = function getAvailableFeatures(script, language) {
            return this._layoutEngine.getAvailableFeatures(script, language);
          };

          _proto43._getBaseGlyph = function _getBaseGlyph(glyph, characters) {
            if (characters === void 0) {
              characters = [];
            }

            if (!this._glyphs[glyph]) {
              if (this.directory.tables.glyf) {
                this._glyphs[glyph] = new TTFGlyph(glyph, characters, this);
              } else if (this.directory.tables['CFF '] || this.directory.tables.CFF2) {
                this._glyphs[glyph] = new CFFGlyph(glyph, characters, this);
              }
            }

            return this._glyphs[glyph] || null;
          }
          /**
   * Returns a glyph object for the given glyph id.
   * You can pass the array of code points this glyph represents for
   * your use later, and it will be stored in the glyph object.
   *
   * @param {number} glyph
   * @param {number[]} characters
   * @return {Glyph}
   */
          ;

          _proto43.getGlyph = function getGlyph(glyph, characters) {
            if (characters === void 0) {
              characters = [];
            }

            if (!this._glyphs[glyph]) {
              if (this.directory.tables.sbix) {
                this._glyphs[glyph] = new SBIXGlyph(glyph, characters, this);
              } else if (this.directory.tables.COLR && this.directory.tables.CPAL) {
                this._glyphs[glyph] = new COLRGlyph(glyph, characters, this);
              } else {
                this._getBaseGlyph(glyph, characters);
              }
            }

            return this._glyphs[glyph] || null;
          }
          /**
   * Returns a Subset for this font.
   * @return {Subset}
   */
          ;

          _proto43.createSubset = function createSubset() {
            if (this.directory.tables['CFF ']) {
              return new CFFSubset(this);
            }

            return new TTFSubset(this);
          }
          /**
   * Returns an object describing the available variation axes
   * that this font supports. Keys are setting tags, and values
   * contain the axis name, range, and default value.
   *
   * @type {object}
   */
          ;

          /**
   * Returns a new font with the given variation settings applied.
   * Settings can either be an instance name, or an object containing
   * variation tags as specified by the `variationAxes` property.
   *
   * @param {object} settings
   * @return {TTFFont}
   */
          _proto43.getVariation = function getVariation(settings) {
            if (!(this.directory.tables.fvar && (this.directory.tables.gvar && this.directory.tables.glyf || this.directory.tables.CFF2))) {
              throw new Error('Variations require a font with the fvar, gvar and glyf, or CFF2 tables.');
            }

            if (typeof settings === 'string') {
              settings = this.namedVariations[settings];
            }

            if (typeof settings !== 'object') {
              throw new Error('Variation settings must be either a variation name or settings object.');
            } // normalize the coordinates

            const coords = this.fvar.axis.map((axis, i) => {
              const axisTag = axis.axisTag.trim();

              if (axisTag in settings) {
                return Math.max(axis.minValue, Math.min(axis.maxValue, settings[axisTag]));
              }
              return axis.defaultValue;
            });
            const stream = new r.DecodeStream(this.stream.buffer);
            stream.pos = this._directoryPos;
            const font = new TTFFont(stream, coords);
            font._tables = this._tables;
            return font;
          };

          // Standardized format plugin API
          _proto43.getFont = function getFont(name) {
            return this.getVariation(name);
          };

          _createClass(TTFFont, [{
            key: 'postscriptName',
            get: function get() {
              return this.getName('postscriptName');
            },
            /**
     * The font's full name, e.g. "Helvetica Bold"
     * @type {string}
     */

          }, {
            key: 'fullName',
            get: function get() {
              return this.getName('fullName');
            },
            /**
     * The font's family name, e.g. "Helvetica"
     * @type {string}
     */

          }, {
            key: 'familyName',
            get: function get() {
              return this.getName('fontFamily');
            },
            /**
     * The font's sub-family, e.g. "Bold".
     * @type {string}
     */

          }, {
            key: 'subfamilyName',
            get: function get() {
              return this.getName('fontSubfamily');
            },
            /**
     * The font's copyright information
     * @type {string}
     */

          }, {
            key: 'copyright',
            get: function get() {
              return this.getName('copyright');
            },
            /**
     * The font's version number
     * @type {string}
     */

          }, {
            key: 'version',
            get: function get() {
              return this.getName('version');
            },
            /**
     * The font’s [ascender](https://en.wikipedia.org/wiki/Ascender_(typography))
     * @type {number}
     */

          }, {
            key: 'ascent',
            get: function get() {
              return this.hhea.ascent;
            },
            /**
     * The font’s [descender](https://en.wikipedia.org/wiki/Descender)
     * @type {number}
     */

          }, {
            key: 'descent',
            get: function get() {
              return this.hhea.descent;
            },
            /**
     * The amount of space that should be included between lines
     * @type {number}
     */

          }, {
            key: 'lineGap',
            get: function get() {
              return this.hhea.lineGap;
            },
            /**
     * The offset from the normal underline position that should be used
     * @type {number}
     */

          }, {
            key: 'underlinePosition',
            get: function get() {
              return this.post.underlinePosition;
            },
            /**
     * The weight of the underline that should be used
     * @type {number}
     */

          }, {
            key: 'underlineThickness',
            get: function get() {
              return this.post.underlineThickness;
            },
            /**
     * If this is an italic font, the angle the cursor should be drawn at to match the font design
     * @type {number}
     */

          }, {
            key: 'italicAngle',
            get: function get() {
              return this.post.italicAngle;
            },
            /**
     * The height of capital letters above the baseline.
     * See [here](https://en.wikipedia.org/wiki/Cap_height) for more details.
     * @type {number}
     */

          }, {
            key: 'capHeight',
            get: function get() {
              const os2 = this['OS/2'];
              return os2 ? os2.capHeight : this.ascent;
            },
            /**
     * The height of lower case letters in the font.
     * See [here](https://en.wikipedia.org/wiki/X-height) for more details.
     * @type {number}
     */

          }, {
            key: 'xHeight',
            get: function get() {
              const os2 = this['OS/2'];
              return os2 ? os2.xHeight : 0;
            },
            /**
     * The number of glyphs in the font.
     * @type {number}
     */

          }, {
            key: 'numGlyphs',
            get: function get() {
              return this.maxp.numGlyphs;
            },
            /**
     * The size of the font’s internal coordinate grid
     * @type {number}
     */

          }, {
            key: 'unitsPerEm',
            get: function get() {
              return this.head.unitsPerEm;
            },
            /**
     * The font’s bounding box, i.e. the box that encloses all glyphs in the font.
     * @type {BBox}
     */

          }, {
            key: 'bbox',
            get: function get() {
              return Object.freeze(new BBox(this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax));
            },
          }, {
            key: '_cmapProcessor',
            get: function get() {
              return new CmapProcessor(this.cmap);
            },
            /**
     * An array of all of the unicode code points supported by the font.
     * @type {number[]}
     */

          }, {
            key: 'characterSet',
            get: function get() {
              return this._cmapProcessor.getCharacterSet();
            },
          }, {
            key: '_layoutEngine',
            get: function get() {
              return new LayoutEngine(this);
            },
          }, {
            key: 'availableFeatures',
            get: function get() {
              return this._layoutEngine.getAvailableFeatures();
            },
          }, {
            key: 'variationAxes',
            get: function get() {
              const res = {};

              if (!this.fvar) {
                return res;
              }

              for (var _iterator76 = _createForOfIteratorHelperLoose(this.fvar.axis), _step76; !(_step76 = _iterator76()).done;) {
                const axis = _step76.value;
                res[axis.axisTag.trim()] = {
                  name: axis.name.en,
                  min: axis.minValue,
                  default: axis.defaultValue,
                  max: axis.maxValue,
                };
              }

              return res;
            },
            /**
     * Returns an object describing the named variation instances
     * that the font designer has specified. Keys are variation names
     * and values are the variation settings for this instance.
     *
     * @type {object}
     */

          }, {
            key: 'namedVariations',
            get: function get() {
              const res = {};

              if (!this.fvar) {
                return res;
              }

              for (var _iterator77 = _createForOfIteratorHelperLoose(this.fvar.instance), _step77; !(_step77 = _iterator77()).done;) {
                const instance = _step77.value;
                const settings = {};

                for (let i = 0; i < this.fvar.axis.length; i++) {
                  const axis = this.fvar.axis[i];
                  settings[axis.axisTag.trim()] = instance.coord[i];
                }

                res[instance.name.en] = settings;
              }

              return res;
            },
          }, {
            key: '_variationProcessor',
            get: function get() {
              if (!this.fvar) {
                return null;
              }

              let { variationCoords } = this; // Ignore if no variation coords and not CFF2

              if (!variationCoords && !this.CFF2) {
                return null;
              }

              if (!variationCoords) {
                variationCoords = this.fvar.axis.map((axis) => axis.defaultValue);
              }

              return new GlyphVariationProcessor(this, variationCoords);
            },
          }]);

          return TTFFont;
        }()), (_applyDecoratedDescriptor(_class$4.prototype, 'bbox', [cache], Object.getOwnPropertyDescriptor(_class$4.prototype, 'bbox'), _class$4.prototype), _applyDecoratedDescriptor(_class$4.prototype, '_cmapProcessor', [cache], Object.getOwnPropertyDescriptor(_class$4.prototype, '_cmapProcessor'), _class$4.prototype), _applyDecoratedDescriptor(_class$4.prototype, 'characterSet', [cache], Object.getOwnPropertyDescriptor(_class$4.prototype, 'characterSet'), _class$4.prototype), _applyDecoratedDescriptor(_class$4.prototype, '_layoutEngine', [cache], Object.getOwnPropertyDescriptor(_class$4.prototype, '_layoutEngine'), _class$4.prototype), _applyDecoratedDescriptor(_class$4.prototype, 'variationAxes', [cache], Object.getOwnPropertyDescriptor(_class$4.prototype, 'variationAxes'), _class$4.prototype), _applyDecoratedDescriptor(_class$4.prototype, 'namedVariations', [cache], Object.getOwnPropertyDescriptor(_class$4.prototype, 'namedVariations'), _class$4.prototype), _applyDecoratedDescriptor(_class$4.prototype, '_variationProcessor', [cache], Object.getOwnPropertyDescriptor(_class$4.prototype, '_variationProcessor'), _class$4.prototype)), _class$4);
        const WOFFDirectoryEntry = new r.Struct({
          tag: new r.String(4),
          offset: new r.Pointer(r.uint32, 'void', {
            type: 'global',
          }),
          compLength: r.uint32,
          length: r.uint32,
          origChecksum: r.uint32,
        });
        const WOFFDirectory = new r.Struct({
          tag: new r.String(4),
          // should be 'wOFF'
          flavor: r.uint32,
          length: r.uint32,
          numTables: r.uint16,
          reserved: new r.Reserved(r.uint16),
          totalSfntSize: r.uint32,
          majorVersion: r.uint16,
          minorVersion: r.uint16,
          metaOffset: r.uint32,
          metaLength: r.uint32,
          metaOrigLength: r.uint32,
          privOffset: r.uint32,
          privLength: r.uint32,
          tables: new r.Array(WOFFDirectoryEntry, 'numTables'),
        });

        WOFFDirectory.process = function () {
          const tables = {};

          for (var _iterator78 = _createForOfIteratorHelperLoose(this.tables), _step78; !(_step78 = _iterator78()).done;) {
            const table = _step78.value;
            tables[table.tag] = table;
          }

          this.tables = tables;
        };

        const WOFFFont = /* #__PURE__ */(function (_TTFFont) {
          _inheritsLoose(WOFFFont, _TTFFont);

          function WOFFFont() {
            return _TTFFont.apply(this, arguments) || this;
          }

          WOFFFont.probe = function probe(buffer) {
            return buffer.toString('ascii', 0, 4) === 'wOFF';
          };

          const _proto44 = WOFFFont.prototype;

          _proto44._decodeDirectory = function _decodeDirectory() {
            this.directory = WOFFDirectory.decode(this.stream, {
              _startOffset: 0,
            });
          };

          _proto44._getTableStream = function _getTableStream(tag) {
            const table = this.directory.tables[tag];

            if (table) {
              this.stream.pos = table.offset;

              if (table.compLength < table.length) {
                this.stream.pos += 2; // skip deflate header

                const outBuffer = Buffer.alloc(table.length);
                const buf = inflate(this.stream.readBuffer(table.compLength - 2), outBuffer);
                return new r.DecodeStream(buf);
              }
              return this.stream;
            }

            return null;
          };

          return WOFFFont;
        }(TTFFont));
        /**
 * Represents a TrueType glyph in the WOFF2 format, which compresses glyphs differently.
 */

        const WOFF2Glyph = /* #__PURE__ */(function (_TTFGlyph2) {
          _inheritsLoose(WOFF2Glyph, _TTFGlyph2);

          function WOFF2Glyph() {
            return _TTFGlyph2.apply(this, arguments) || this;
          }

          const _proto45 = WOFF2Glyph.prototype;

          _proto45._decode = function _decode() {
            // We have to decode in advance (in WOFF2Font), so just return the pre-decoded data.
            return this._font._transformedGlyphs[this.id];
          };

          _proto45._getCBox = function _getCBox() {
            return this.path.bbox;
          };

          return WOFF2Glyph;
        }(TTFGlyph));

        const Base128 = {
          decode: function decode(stream) {
            let result = 0;
            const iterable = [0, 1, 2, 3, 4];

            for (let j = 0; j < iterable.length; j++) {
              const code = stream.readUInt8(); // If any of the top seven bits are set then we're about to overflow.

              if (result & 0xe0000000) {
                throw new Error('Overflow');
              }

              result = result << 7 | code & 0x7f;

              if ((code & 0x80) === 0) {
                return result;
              }
            }

            throw new Error('Bad base 128 number');
          },
        };
        const knownTags = ['cmap', 'head', 'hhea', 'hmtx', 'maxp', 'name', 'OS/2', 'post', 'cvt ', 'fpgm', 'glyf', 'loca', 'prep', 'CFF ', 'VORG', 'EBDT', 'EBLC', 'gasp', 'hdmx', 'kern', 'LTSH', 'PCLT', 'VDMX', 'vhea', 'vmtx', 'BASE', 'GDEF', 'GPOS', 'GSUB', 'EBSC', 'JSTF', 'MATH', 'CBDT', 'CBLC', 'COLR', 'CPAL', 'SVG ', 'sbix', 'acnt', 'avar', 'bdat', 'bloc', 'bsln', 'cvar', 'fdsc', 'feat', 'fmtx', 'fvar', 'gvar', 'hsty', 'just', 'lcar', 'mort', 'morx', 'opbd', 'prop', 'trak', 'Zapf', 'Silf', 'Glat', 'Gloc', 'Feat', 'Sill'];
        const WOFF2DirectoryEntry = new r.Struct({
          flags: r.uint8,
          customTag: new r.Optional(new r.String(4), ((t) => (t.flags & 0x3f) === 0x3f)),
          tag: function tag(t) {
            return t.customTag || knownTags[t.flags & 0x3f];
          },
          // || (() => { throw new Error(`Bad tag: ${flags & 0x3f}`); })(); },
          length: Base128,
          transformVersion: function transformVersion(t) {
            return t.flags >>> 6 & 0x03;
          },
          transformed: function transformed(t) {
            return t.tag === 'glyf' || t.tag === 'loca' ? t.transformVersion === 0 : t.transformVersion !== 0;
          },
          transformLength: new r.Optional(Base128, ((t) => t.transformed)),
        });
        const WOFF2Directory = new r.Struct({
          tag: new r.String(4),
          // should be 'wOF2'
          flavor: r.uint32,
          length: r.uint32,
          numTables: r.uint16,
          reserved: new r.Reserved(r.uint16),
          totalSfntSize: r.uint32,
          totalCompressedSize: r.uint32,
          majorVersion: r.uint16,
          minorVersion: r.uint16,
          metaOffset: r.uint32,
          metaLength: r.uint32,
          metaOrigLength: r.uint32,
          privOffset: r.uint32,
          privLength: r.uint32,
          tables: new r.Array(WOFF2DirectoryEntry, 'numTables'),
        });

        WOFF2Directory.process = function () {
          const tables = {};

          for (let i = 0; i < this.tables.length; i++) {
            const table = this.tables[i];
            tables[table.tag] = table;
          }

          return this.tables = tables;
        };
        /**
 * Subclass of TTFFont that represents a TTF/OTF font compressed by WOFF2
 * See spec here: http://www.w3.org/TR/WOFF2/
 */

        const WOFF2Font = /* #__PURE__ */(function (_TTFFont2) {
          _inheritsLoose(WOFF2Font, _TTFFont2);

          function WOFF2Font() {
            return _TTFFont2.apply(this, arguments) || this;
          }

          WOFF2Font.probe = function probe(buffer) {
            return buffer.toString('ascii', 0, 4) === 'wOF2';
          };

          const _proto46 = WOFF2Font.prototype;

          _proto46._decodeDirectory = function _decodeDirectory() {
            this.directory = WOFF2Directory.decode(this.stream);
            this._dataPos = this.stream.pos;
          };

          _proto46._decompress = function _decompress() {
            // decompress data and setup table offsets if we haven't already
            if (!this._decompressed) {
              this.stream.pos = this._dataPos;
              const buffer = this.stream.readBuffer(this.directory.totalCompressedSize);
              let decompressedSize = 0;

              for (const tag in this.directory.tables) {
                const entry = this.directory.tables[tag];
                entry.offset = decompressedSize;
                decompressedSize += entry.transformLength != null ? entry.transformLength : entry.length;
              }

              const decompressed = brotli(buffer, decompressedSize);

              if (!decompressed) {
                throw new Error('Error decoding compressed data in WOFF2');
              }

              this.stream = new r.DecodeStream(Buffer.from(decompressed));
              this._decompressed = true;
            }
          };

          _proto46._decodeTable = function _decodeTable(table) {
            this._decompress();

            return _TTFFont2.prototype._decodeTable.call(this, table);
          } // Override this method to get a glyph and return our
          // custom subclass if there is a glyf table.
          ;

          _proto46._getBaseGlyph = function _getBaseGlyph(glyph, characters) {
            if (characters === void 0) {
              characters = [];
            }

            if (!this._glyphs[glyph]) {
              if (this.directory.tables.glyf && this.directory.tables.glyf.transformed) {
                if (!this._transformedGlyphs) {
                  this._transformGlyfTable();
                }

                return this._glyphs[glyph] = new WOFF2Glyph(glyph, characters, this);
              }
              return _TTFFont2.prototype._getBaseGlyph.call(this, glyph, characters);
            }
          };

          _proto46._transformGlyfTable = function _transformGlyfTable() {
            this._decompress();

            this.stream.pos = this.directory.tables.glyf.offset;
            const table = GlyfTable.decode(this.stream);
            const glyphs = [];

            for (let index = 0; index < table.numGlyphs; index++) {
              const glyph = {};
              const nContours = table.nContours.readInt16BE();
              glyph.numberOfContours = nContours;

              if (nContours > 0) {
                // simple glyph
                const nPoints = [];
                let totalPoints = 0;

                for (let i = 0; i < nContours; i++) {
                  const _r = read255UInt16(table.nPoints);

                  totalPoints += _r;
                  nPoints.push(totalPoints);
                }

                glyph.points = decodeTriplet(table.flags, table.glyphs, totalPoints);

                for (let _i = 0; _i < nContours; _i++) {
                  glyph.points[nPoints[_i] - 1].endContour = true;
                }

                var instructionSize = read255UInt16(table.glyphs);
              } else if (nContours < 0) {
                // composite glyph
                const haveInstructions = TTFGlyph.prototype._decodeComposite.call({
                  _font: this,
                }, glyph, table.composites);

                if (haveInstructions) {
                  var instructionSize = read255UInt16(table.glyphs);
                }
              }

              glyphs.push(glyph);
            }

            this._transformedGlyphs = glyphs;
          };

          return WOFF2Font;
        }(TTFFont)); // Special class that accepts a length and returns a sub-stream for that data

        const Substream = /* #__PURE__ */(function () {
          function Substream(length) {
            this.length = length;
            this._buf = new r.Buffer(length);
          }

          const _proto47 = Substream.prototype;

          _proto47.decode = function decode(stream, parent) {
            return new r.DecodeStream(this._buf.decode(stream, parent));
          };

          return Substream;
        }()); // This struct represents the entire glyf table

        var GlyfTable = new r.Struct({
          version: r.uint32,
          numGlyphs: r.uint16,
          indexFormat: r.uint16,
          nContourStreamSize: r.uint32,
          nPointsStreamSize: r.uint32,
          flagStreamSize: r.uint32,
          glyphStreamSize: r.uint32,
          compositeStreamSize: r.uint32,
          bboxStreamSize: r.uint32,
          instructionStreamSize: r.uint32,
          nContours: new Substream('nContourStreamSize'),
          nPoints: new Substream('nPointsStreamSize'),
          flags: new Substream('flagStreamSize'),
          glyphs: new Substream('glyphStreamSize'),
          composites: new Substream('compositeStreamSize'),
          bboxes: new Substream('bboxStreamSize'),
          instructions: new Substream('instructionStreamSize'),
        });
        const WORD_CODE = 253;
        const ONE_MORE_BYTE_CODE2 = 254;
        const ONE_MORE_BYTE_CODE1 = 255;
        const LOWEST_U_CODE = 253;

        function read255UInt16(stream) {
          const code = stream.readUInt8();

          if (code === WORD_CODE) {
            return stream.readUInt16BE();
          }

          if (code === ONE_MORE_BYTE_CODE1) {
            return stream.readUInt8() + LOWEST_U_CODE;
          }

          if (code === ONE_MORE_BYTE_CODE2) {
            return stream.readUInt8() + LOWEST_U_CODE * 2;
          }

          return code;
        }

        function withSign(flag, baseval) {
          return flag & 1 ? baseval : -baseval;
        }

        function decodeTriplet(flags, glyphs, nPoints) {
          let y;
          let x = y = 0;
          const res = [];

          for (let i = 0; i < nPoints; i++) {
            let dx = 0;
            let dy = 0;
            let flag = flags.readUInt8();
            const onCurve = !(flag >> 7);
            flag &= 0x7f;

            if (flag < 10) {
              dx = 0;
              dy = withSign(flag, ((flag & 14) << 7) + glyphs.readUInt8());
            } else if (flag < 20) {
              dx = withSign(flag, ((flag - 10 & 14) << 7) + glyphs.readUInt8());
              dy = 0;
            } else if (flag < 84) {
              var b0 = flag - 20;
              var b1 = glyphs.readUInt8();
              dx = withSign(flag, 1 + (b0 & 0x30) + (b1 >> 4));
              dy = withSign(flag >> 1, 1 + ((b0 & 0x0c) << 2) + (b1 & 0x0f));
            } else if (flag < 120) {
              var b0 = flag - 84;
              dx = withSign(flag, 1 + (b0 / 12 << 8) + glyphs.readUInt8());
              dy = withSign(flag >> 1, 1 + (b0 % 12 >> 2 << 8) + glyphs.readUInt8());
            } else if (flag < 124) {
              var b1 = glyphs.readUInt8();
              const b2 = glyphs.readUInt8();
              dx = withSign(flag, (b1 << 4) + (b2 >> 4));
              dy = withSign(flag >> 1, ((b2 & 0x0f) << 8) + glyphs.readUInt8());
            } else {
              dx = withSign(flag, glyphs.readUInt16BE());
              dy = withSign(flag >> 1, glyphs.readUInt16BE());
            }

            x += dx;
            y += dy;
            res.push(new Point(onCurve, false, x, y));
          }

          return res;
        }

        const TTCHeader = new r.VersionedStruct(r.uint32, {
          0x00010000: {
            numFonts: r.uint32,
            offsets: new r.Array(r.uint32, 'numFonts'),
          },
          0x00020000: {
            numFonts: r.uint32,
            offsets: new r.Array(r.uint32, 'numFonts'),
            dsigTag: r.uint32,
            dsigLength: r.uint32,
            dsigOffset: r.uint32,
          },
        });

        const TrueTypeCollection = /* #__PURE__ */(function () {
          TrueTypeCollection.probe = function probe(buffer) {
            return buffer.toString('ascii', 0, 4) === 'ttcf';
          };

          function TrueTypeCollection(stream) {
            this.stream = stream;

            if (stream.readString(4) !== 'ttcf') {
              throw new Error('Not a TrueType collection');
            }

            this.header = TTCHeader.decode(stream);
          }

          const _proto48 = TrueTypeCollection.prototype;

          _proto48.getFont = function getFont(name) {
            for (var _iterator79 = _createForOfIteratorHelperLoose(this.header.offsets), _step79; !(_step79 = _iterator79()).done;) {
              const offset = _step79.value;
              const stream = new r.DecodeStream(this.stream.buffer);
              stream.pos = offset;
              const font = new TTFFont(stream);

              if (font.postscriptName === name) {
                return font;
              }
            }

            return null;
          };

          _createClass(TrueTypeCollection, [{
            key: 'fonts',
            get: function get() {
              const fonts = [];

              for (var _iterator80 = _createForOfIteratorHelperLoose(this.header.offsets), _step80; !(_step80 = _iterator80()).done;) {
                const offset = _step80.value;
                const stream = new r.DecodeStream(this.stream.buffer);
                stream.pos = offset;
                fonts.push(new TTFFont(stream));
              }

              return fonts;
            },
          }]);

          return TrueTypeCollection;
        }());

        const DFontName = new r.String(r.uint8);
        const DFontData = new r.Struct({
          len: r.uint32,
          buf: new r.Buffer('len'),
        });
        const Ref = new r.Struct({
          id: r.uint16,
          nameOffset: r.int16,
          attr: r.uint8,
          dataOffset: r.uint24,
          handle: r.uint32,
        });
        const Type = new r.Struct({
          name: new r.String(4),
          maxTypeIndex: r.uint16,
          refList: new r.Pointer(r.uint16, new r.Array(Ref, ((t) => t.maxTypeIndex + 1)), {
            type: 'parent',
          }),
        });
        const TypeList = new r.Struct({
          length: r.uint16,
          types: new r.Array(Type, ((t) => t.length + 1)),
        });
        const DFontMap = new r.Struct({
          reserved: new r.Reserved(r.uint8, 24),
          typeList: new r.Pointer(r.uint16, TypeList),
          nameListOffset: new r.Pointer(r.uint16, 'void'),
        });
        const DFontHeader = new r.Struct({
          dataOffset: r.uint32,
          map: new r.Pointer(r.uint32, DFontMap),
          dataLength: r.uint32,
          mapLength: r.uint32,
        });

        const DFont = /* #__PURE__ */(function () {
          DFont.probe = function probe(buffer) {
            const stream = new r.DecodeStream(buffer);

            try {
              var header = DFontHeader.decode(stream);
            } catch (e) {
              return false;
            }

            for (var _iterator81 = _createForOfIteratorHelperLoose(header.map.typeList.types), _step81; !(_step81 = _iterator81()).done;) {
              const type = _step81.value;

              if (type.name === 'sfnt') {
                return true;
              }
            }

            return false;
          };

          function DFont(stream) {
            this.stream = stream;
            this.header = DFontHeader.decode(this.stream);

            for (var _iterator82 = _createForOfIteratorHelperLoose(this.header.map.typeList.types), _step82; !(_step82 = _iterator82()).done;) {
              const type = _step82.value;

              for (var _iterator83 = _createForOfIteratorHelperLoose(type.refList), _step83; !(_step83 = _iterator83()).done;) {
                const ref = _step83.value;

                if (ref.nameOffset >= 0) {
                  this.stream.pos = ref.nameOffset + this.header.map.nameListOffset;
                  ref.name = DFontName.decode(this.stream);
                } else {
                  ref.name = null;
                }
              }

              if (type.name === 'sfnt') {
                this.sfnt = type;
              }
            }
          }

          const _proto49 = DFont.prototype;

          _proto49.getFont = function getFont(name) {
            if (!this.sfnt) {
              return null;
            }

            for (var _iterator84 = _createForOfIteratorHelperLoose(this.sfnt.refList), _step84; !(_step84 = _iterator84()).done;) {
              const ref = _step84.value;
              const pos = this.header.dataOffset + ref.dataOffset + 4;
              const stream = new r.DecodeStream(this.stream.buffer.slice(pos));
              const font = new TTFFont(stream);

              if (font.postscriptName === name) {
                return font;
              }
            }

            return null;
          };

          _createClass(DFont, [{
            key: 'fonts',
            get: function get() {
              const fonts = [];

              for (var _iterator85 = _createForOfIteratorHelperLoose(this.sfnt.refList), _step85; !(_step85 = _iterator85()).done;) {
                const ref = _step85.value;
                const pos = this.header.dataOffset + ref.dataOffset + 4;
                const stream = new r.DecodeStream(this.stream.buffer.slice(pos));
                fonts.push(new TTFFont(stream));
              }

              return fonts;
            },
          }]);

          return DFont;
        }());

        fontkit.registerFormat(TTFFont);
        fontkit.registerFormat(WOFFFont);
        fontkit.registerFormat(WOFF2Font);
        fontkit.registerFormat(TrueTypeCollection);
        fontkit.registerFormat(DFont);
        module.exports = fontkit;
        /***/ }),

      /***/ 7337:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const UnicodeTrie = __webpack_require__(4781);

        const base64 = __webpack_require__(9742);

        const _require = __webpack_require__(2055);
        const { BK } = _require;
        const { CR } = _require;
        const { LF } = _require;
        const { NL } = _require;
        const { SG } = _require;
        const { WJ } = _require;
        const { SP } = _require;
        const { ZWJ } = _require;
        const { BA } = _require;
        const { HY } = _require;
        const { NS } = _require;
        const { AI } = _require;
        const { AL } = _require;
        const { CJ } = _require;
        const { HL } = _require;
        const { RI } = _require;
        const { SA } = _require;
        const { XX } = _require;

        const _require2 = __webpack_require__(8383);
        const { DI_BRK } = _require2;
        const { IN_BRK } = _require2;
        const { CI_BRK } = _require2;
        const { CP_BRK } = _require2;
        const { PR_BRK } = _require2;
        const { pairTable } = _require2;

        const data = base64.toByteArray('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');
        const classTrie = new UnicodeTrie(data);

        const mapClass = function mapClass(c) {
          switch (c) {
            case AI:
              return AL;

            case SA:
            case SG:
            case XX:
              return AL;

            case CJ:
              return NS;

            default:
              return c;
          }
        };

        const mapFirst = function mapFirst(c) {
          switch (c) {
            case LF:
            case NL:
              return BK;

            case SP:
              return WJ;

            default:
              return c;
          }
        };

        const Break = function Break(position, required) {
          if (required === void 0) {
            required = false;
          }

          this.position = position;
          this.required = required;
        };

        const LineBreaker = /* #__PURE__ */(function () {
          function LineBreaker(string) {
            this.string = string;
            this.pos = 0;
            this.lastPos = 0;
            this.curClass = null;
            this.nextClass = null;
            this.LB8a = false;
            this.LB21a = false;
            this.LB30a = 0;
          }

          const _proto = LineBreaker.prototype;

          _proto.nextCodePoint = function nextCodePoint() {
            const code = this.string.charCodeAt(this.pos++);
            const next = this.string.charCodeAt(this.pos); // If a surrogate pair

            if (code >= 0xd800 && code <= 0xdbff && next >= 0xdc00 && next <= 0xdfff) {
              this.pos++;
              return (code - 0xd800) * 0x400 + (next - 0xdc00) + 0x10000;
            }

            return code;
          };

          _proto.nextCharClass = function nextCharClass() {
            return mapClass(classTrie.get(this.nextCodePoint()));
          };

          _proto.getSimpleBreak = function getSimpleBreak() {
            // handle classes not handled by the pair table
            switch (this.nextClass) {
              case SP:
                return false;

              case BK:
              case LF:
              case NL:
                this.curClass = BK;
                return false;

              case CR:
                this.curClass = CR;
                return false;
            }

            return null;
          };

          _proto.getPairTableBreak = function getPairTableBreak(lastClass) {
            // if not handled already, use the pair table
            let shouldBreak = false;

            switch (pairTable[this.curClass][this.nextClass]) {
              case DI_BRK:
                // Direct break
                shouldBreak = true;
                break;

              case IN_BRK:
                // possible indirect break
                shouldBreak = lastClass === SP;
                break;

              case CI_BRK:
                shouldBreak = lastClass === SP;

                if (!shouldBreak) {
                  shouldBreak = false;
                  return shouldBreak;
                }

                break;

              case CP_BRK:
                // prohibited for combining marks
                if (lastClass !== SP) {
                  return shouldBreak;
                }

                break;

              case PR_BRK:
                break;
            }

            if (this.LB8a) {
              shouldBreak = false;
            } // Rule LB21a

            if (this.LB21a && (this.curClass === HY || this.curClass === BA)) {
              shouldBreak = false;
              this.LB21a = false;
            } else {
              this.LB21a = this.curClass === HL;
            } // Rule LB30a

            if (this.curClass === RI) {
              this.LB30a++;

              if (this.LB30a == 2 && this.nextClass === RI) {
                shouldBreak = true;
                this.LB30a = 0;
              }
            } else {
              this.LB30a = 0;
            }

            this.curClass = this.nextClass;
            return shouldBreak;
          };

          _proto.nextBreak = function nextBreak() {
            // get the first char if we're at the beginning of the string
            if (this.curClass == null) {
              const firstClass = this.nextCharClass();
              this.curClass = mapFirst(firstClass);
              this.nextClass = firstClass;
              this.LB8a = firstClass === ZWJ;
              this.LB30a = 0;
            }

            while (this.pos < this.string.length) {
              this.lastPos = this.pos;
              const lastClass = this.nextClass;
              this.nextClass = this.nextCharClass(); // explicit newline

              if (this.curClass === BK || this.curClass === CR && this.nextClass !== LF) {
                this.curClass = mapFirst(mapClass(this.nextClass));
                return new Break(this.lastPos, true);
              }

              let shouldBreak = this.getSimpleBreak();

              if (shouldBreak === null) {
                shouldBreak = this.getPairTableBreak(lastClass);
              } // Rule LB8a

              this.LB8a = this.nextClass === ZWJ;

              if (shouldBreak) {
                return new Break(this.lastPos);
              }
            }

            if (this.lastPos < this.string.length) {
              this.lastPos = this.string.length;
              return new Break(this.string.length);
            }

            return null;
          };

          return LineBreaker;
        }());

        module.exports = LineBreaker;
        /***/ }),

      /***/ 4927:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /**
 * Module exports.
 */

        module.exports = deprecate;

        /**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

        function deprecate(fn, msg) {
          if (config('noDeprecation')) {
            return fn;
          }

          let warned = false;
          function deprecated() {
            if (!warned) {
              if (config('throwDeprecation')) {
                throw new Error(msg);
              } else if (config('traceDeprecation')) {
                console.trace(msg);
              } else {
                console.warn(msg);
              }
              warned = true;
            }
            return fn.apply(this, arguments);
          }

          return deprecated;
        }

        /**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

        function config(name) {
          // accessing global.localStorage can trigger a DOMException in sandboxed iframes
          try {
            if (!__webpack_require__.g.localStorage) return false;
          } catch (_) {
            return false;
          }
          const val = __webpack_require__.g.localStorage[name];
          if (val == null) return false;
          return String(val).toLowerCase() === 'true';
        }
        /***/ }),

      /***/ 384:
      /***/ (function (module) {
        module.exports = function isBuffer(arg) {
          return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
        };
        /***/ }),

      /***/ 5955:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        // Currently in sync with Node.js lib/internal/util/types.js
        // https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9

        const isArgumentsObject = __webpack_require__(2584);
        const isGeneratorFunction = __webpack_require__(8662);
        const whichTypedArray = __webpack_require__(6430);
        const isTypedArray = __webpack_require__(5692);

        function uncurryThis(f) {
          return f.call.bind(f);
        }

        const BigIntSupported = typeof BigInt !== 'undefined';
        const SymbolSupported = typeof Symbol !== 'undefined';

        const ObjectToString = uncurryThis(Object.prototype.toString);

        const numberValue = uncurryThis(Number.prototype.valueOf);
        const stringValue = uncurryThis(String.prototype.valueOf);
        const booleanValue = uncurryThis(Boolean.prototype.valueOf);

        if (BigIntSupported) {
          var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
        }

        if (SymbolSupported) {
          var symbolValue = uncurryThis(Symbol.prototype.valueOf);
        }

        function checkBoxedPrimitive(value, prototypeValueOf) {
          if (typeof value !== 'object') {
            return false;
          }
          try {
            prototypeValueOf(value);
            return true;
          } catch (e) {
            return false;
          }
        }

        exports.isArgumentsObject = isArgumentsObject;
        exports.isGeneratorFunction = isGeneratorFunction;
        exports.isTypedArray = isTypedArray;

        // Taken from here and modified for better browser support
        // https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
        function isPromise(input) {
          return (
            (
              typeof Promise !== 'undefined'
			&& input instanceof Promise
            )
		|| (
		  input !== null
			&& typeof input === 'object'
			&& typeof input.then === 'function'
			&& typeof input.catch === 'function'
		)
          );
        }
        exports.isPromise = isPromise;

        function isArrayBufferView(value) {
          if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
            return ArrayBuffer.isView(value);
          }

          return (
            isTypedArray(value)
    || isDataView(value)
          );
        }
        exports.isArrayBufferView = isArrayBufferView;

        function isUint8Array(value) {
          return whichTypedArray(value) === 'Uint8Array';
        }
        exports.isUint8Array = isUint8Array;

        function isUint8ClampedArray(value) {
          return whichTypedArray(value) === 'Uint8ClampedArray';
        }
        exports.isUint8ClampedArray = isUint8ClampedArray;

        function isUint16Array(value) {
          return whichTypedArray(value) === 'Uint16Array';
        }
        exports.isUint16Array = isUint16Array;

        function isUint32Array(value) {
          return whichTypedArray(value) === 'Uint32Array';
        }
        exports.isUint32Array = isUint32Array;

        function isInt8Array(value) {
          return whichTypedArray(value) === 'Int8Array';
        }
        exports.isInt8Array = isInt8Array;

        function isInt16Array(value) {
          return whichTypedArray(value) === 'Int16Array';
        }
        exports.isInt16Array = isInt16Array;

        function isInt32Array(value) {
          return whichTypedArray(value) === 'Int32Array';
        }
        exports.isInt32Array = isInt32Array;

        function isFloat32Array(value) {
          return whichTypedArray(value) === 'Float32Array';
        }
        exports.isFloat32Array = isFloat32Array;

        function isFloat64Array(value) {
          return whichTypedArray(value) === 'Float64Array';
        }
        exports.isFloat64Array = isFloat64Array;

        function isBigInt64Array(value) {
          return whichTypedArray(value) === 'BigInt64Array';
        }
        exports.isBigInt64Array = isBigInt64Array;

        function isBigUint64Array(value) {
          return whichTypedArray(value) === 'BigUint64Array';
        }
        exports.isBigUint64Array = isBigUint64Array;

        function isMapToString(value) {
          return ObjectToString(value) === '[object Map]';
        }
        isMapToString.working = (
          typeof Map !== 'undefined'
  && isMapToString(new Map())
        );

        function isMap(value) {
          if (typeof Map === 'undefined') {
            return false;
          }

          return isMapToString.working
            ? isMapToString(value)
            : value instanceof Map;
        }
        exports.isMap = isMap;

        function isSetToString(value) {
          return ObjectToString(value) === '[object Set]';
        }
        isSetToString.working = (
          typeof Set !== 'undefined'
  && isSetToString(new Set())
        );
        function isSet(value) {
          if (typeof Set === 'undefined') {
            return false;
          }

          return isSetToString.working
            ? isSetToString(value)
            : value instanceof Set;
        }
        exports.isSet = isSet;

        function isWeakMapToString(value) {
          return ObjectToString(value) === '[object WeakMap]';
        }
        isWeakMapToString.working = (
          typeof WeakMap !== 'undefined'
  && isWeakMapToString(new WeakMap())
        );
        function isWeakMap(value) {
          if (typeof WeakMap === 'undefined') {
            return false;
          }

          return isWeakMapToString.working
            ? isWeakMapToString(value)
            : value instanceof WeakMap;
        }
        exports.isWeakMap = isWeakMap;

        function isWeakSetToString(value) {
          return ObjectToString(value) === '[object WeakSet]';
        }
        isWeakSetToString.working = (
          typeof WeakSet !== 'undefined'
  && isWeakSetToString(new WeakSet())
        );
        function isWeakSet(value) {
          return isWeakSetToString(value);
        }
        exports.isWeakSet = isWeakSet;

        function isArrayBufferToString(value) {
          return ObjectToString(value) === '[object ArrayBuffer]';
        }
        isArrayBufferToString.working = (
          typeof ArrayBuffer !== 'undefined'
  && isArrayBufferToString(new ArrayBuffer())
        );
        function isArrayBuffer(value) {
          if (typeof ArrayBuffer === 'undefined') {
            return false;
          }

          return isArrayBufferToString.working
            ? isArrayBufferToString(value)
            : value instanceof ArrayBuffer;
        }
        exports.isArrayBuffer = isArrayBuffer;

        function isDataViewToString(value) {
          return ObjectToString(value) === '[object DataView]';
        }
        isDataViewToString.working = (
          typeof ArrayBuffer !== 'undefined'
  && typeof DataView !== 'undefined'
  && isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1))
        );
        function isDataView(value) {
          if (typeof DataView === 'undefined') {
            return false;
          }

          return isDataViewToString.working
            ? isDataViewToString(value)
            : value instanceof DataView;
        }
        exports.isDataView = isDataView;

        // Store a copy of SharedArrayBuffer in case it's deleted elsewhere
        const SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
        function isSharedArrayBufferToString(value) {
          return ObjectToString(value) === '[object SharedArrayBuffer]';
        }
        function isSharedArrayBuffer(value) {
          if (typeof SharedArrayBufferCopy === 'undefined') {
            return false;
          }

          if (typeof isSharedArrayBufferToString.working === 'undefined') {
            isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
          }

          return isSharedArrayBufferToString.working
            ? isSharedArrayBufferToString(value)
            : value instanceof SharedArrayBufferCopy;
        }
        exports.isSharedArrayBuffer = isSharedArrayBuffer;

        function isAsyncFunction(value) {
          return ObjectToString(value) === '[object AsyncFunction]';
        }
        exports.isAsyncFunction = isAsyncFunction;

        function isMapIterator(value) {
          return ObjectToString(value) === '[object Map Iterator]';
        }
        exports.isMapIterator = isMapIterator;

        function isSetIterator(value) {
          return ObjectToString(value) === '[object Set Iterator]';
        }
        exports.isSetIterator = isSetIterator;

        function isGeneratorObject(value) {
          return ObjectToString(value) === '[object Generator]';
        }
        exports.isGeneratorObject = isGeneratorObject;

        function isWebAssemblyCompiledModule(value) {
          return ObjectToString(value) === '[object WebAssembly.Module]';
        }
        exports.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;

        function isNumberObject(value) {
          return checkBoxedPrimitive(value, numberValue);
        }
        exports.isNumberObject = isNumberObject;

        function isStringObject(value) {
          return checkBoxedPrimitive(value, stringValue);
        }
        exports.isStringObject = isStringObject;

        function isBooleanObject(value) {
          return checkBoxedPrimitive(value, booleanValue);
        }
        exports.isBooleanObject = isBooleanObject;

        function isBigIntObject(value) {
          return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
        }
        exports.isBigIntObject = isBigIntObject;

        function isSymbolObject(value) {
          return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
        }
        exports.isSymbolObject = isSymbolObject;

        function isBoxedPrimitive(value) {
          return (
            isNumberObject(value)
    || isStringObject(value)
    || isBooleanObject(value)
    || isBigIntObject(value)
    || isSymbolObject(value)
          );
        }
        exports.isBoxedPrimitive = isBoxedPrimitive;

        function isAnyArrayBuffer(value) {
          return typeof Uint8Array !== 'undefined' && (
            isArrayBuffer(value)
    || isSharedArrayBuffer(value)
          );
        }
        exports.isAnyArrayBuffer = isAnyArrayBuffer;

        ['isProxy', 'isExternal', 'isModuleNamespaceObject'].forEach((method) => {
          Object.defineProperty(exports, method, {
            enumerable: false,
            value() {
              throw new Error(`${method} is not supported in userland`);
            },
          });
        });
        /***/ }),

      /***/ 9539:
      /***/ (function (__unused_webpack_module, exports, __webpack_require__) {
        /* provided dependency */ const process = __webpack_require__(4155);
        // Copyright Joyent, Inc. and other Node contributors.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a
        // copy of this software and associated documentation files (the
        // "Software"), to deal in the Software without restriction, including
        // without limitation the rights to use, copy, modify, merge, publish,
        // distribute, sublicense, and/or sell copies of the Software, and to permit
        // persons to whom the Software is furnished to do so, subject to the
        // following conditions:
        //
        // The above copyright notice and this permission notice shall be included
        // in all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
        // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
        // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
        // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
        // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
        // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
        // USE OR OTHER DEALINGS IN THE SOFTWARE.

        const getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors
  || function getOwnPropertyDescriptors(obj) {
    const keys = Object.keys(obj);
    const descriptors = {};
    for (let i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

        const formatRegExp = /%[sdj%]/g;
        exports.format = function (f) {
          if (!isString(f)) {
            const objects = [];
            for (var i = 0; i < arguments.length; i++) {
              objects.push(inspect(arguments[i]));
            }
            return objects.join(' ');
          }

          var i = 1;
          const args = arguments;
          const len = args.length;
          let str = String(f).replace(formatRegExp, (x) => {
            if (x === '%%') return '%';
            if (i >= len) return x;
            switch (x) {
              case '%s': return String(args[i++]);
              case '%d': return Number(args[i++]);
              case '%j':
                try {
                  return JSON.stringify(args[i++]);
                } catch (_) {
                  return '[Circular]';
                }
              default:
                return x;
            }
          });
          for (let x = args[i]; i < len; x = args[++i]) {
            if (isNull(x) || !isObject(x)) {
              str += ` ${x}`;
            } else {
              str += ` ${inspect(x)}`;
            }
          }
          return str;
        };

        // Mark that a method should not be used.
        // Returns a modified function which warns once by default.
        // If --no-deprecation is set, then it is a no-op.
        exports.deprecate = function (fn, msg) {
          if (typeof process !== 'undefined' && process.noDeprecation === true) {
            return fn;
          }

          // Allow for deprecating things in the process of starting up.
          if (typeof process === 'undefined') {
            return function () {
              return exports.deprecate(fn, msg).apply(this, arguments);
            };
          }

          let warned = false;
          function deprecated() {
            if (!warned) {
              if (process.throwDeprecation) {
                throw new Error(msg);
              } else if (process.traceDeprecation) {
                console.trace(msg);
              } else {
                console.error(msg);
              }
              warned = true;
            }
            return fn.apply(this, arguments);
          }

          return deprecated;
        };

        const debugs = {};
        let debugEnvRegex = /^$/;

        if (process.env.NODE_DEBUG) {
          let debugEnv = process.env.NODE_DEBUG;
          debugEnv = debugEnv.replace(/[|\\{}()[\]^$+?.]/g, '\\$&')
            .replace(/\*/g, '.*')
            .replace(/,/g, '$|^')
            .toUpperCase();
          debugEnvRegex = new RegExp(`^${debugEnv}$`, 'i');
        }
        exports.debuglog = function (set) {
          set = set.toUpperCase();
          if (!debugs[set]) {
            if (debugEnvRegex.test(set)) {
              const { pid } = process;
              debugs[set] = function () {
                const msg = exports.format.apply(exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
              };
            } else {
              debugs[set] = function () {};
            }
          }
          return debugs[set];
        };

        /**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
        /* legacy: obj, showHidden, depth, colors */
        function inspect(obj, opts) {
          // default options
          const ctx = {
            seen: [],
            stylize: stylizeNoColor,
          };
          // legacy...
          if (arguments.length >= 3) ctx.depth = arguments[2];
          if (arguments.length >= 4) ctx.colors = arguments[3];
          if (isBoolean(opts)) {
            // legacy...
            ctx.showHidden = opts;
          } else if (opts) {
            // got an "options" object
            exports._extend(ctx, opts);
          }
          // set default options
          if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
          if (isUndefined(ctx.depth)) ctx.depth = 2;
          if (isUndefined(ctx.colors)) ctx.colors = false;
          if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
          if (ctx.colors) ctx.stylize = stylizeWithColor;
          return formatValue(ctx, obj, ctx.depth);
        }
        exports.inspect = inspect;

        // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
        inspect.colors = {
          bold: [1, 22],
          italic: [3, 23],
          underline: [4, 24],
          inverse: [7, 27],
          white: [37, 39],
          grey: [90, 39],
          black: [30, 39],
          blue: [34, 39],
          cyan: [36, 39],
          green: [32, 39],
          magenta: [35, 39],
          red: [31, 39],
          yellow: [33, 39],
        };

        // Don't use 'blue' not visible on cmd.exe
        inspect.styles = {
          special: 'cyan',
          number: 'yellow',
          boolean: 'yellow',
          undefined: 'grey',
          null: 'bold',
          string: 'green',
          date: 'magenta',
          // "name": intentionally not styling
          regexp: 'red',
        };

        function stylizeWithColor(str, styleType) {
          const style = inspect.styles[styleType];

          if (style) {
            return `\u001b[${inspect.colors[style][0]}m${str
            }\u001b[${inspect.colors[style][1]}m`;
          }
          return str;
        }

        function stylizeNoColor(str, styleType) {
          return str;
        }

        function arrayToHash(array) {
          const hash = {};

          array.forEach((val, idx) => {
            hash[val] = true;
          });

          return hash;
        }

        function formatValue(ctx, value, recurseTimes) {
          // Provide a hook for user-specified inspect functions.
          // Check that value is an object with an inspect function on it
          if (ctx.customInspect
      && value
      && isFunction(value.inspect)
      // Filter out the util module, it's inspect function is special
      && value.inspect !== exports.inspect
      // Also filter out any prototype objects using the circular check.
      && !(value.constructor && value.constructor.prototype === value)) {
            let ret = value.inspect(recurseTimes, ctx);
            if (!isString(ret)) {
              ret = formatValue(ctx, ret, recurseTimes);
            }
            return ret;
          }

          // Primitive types cannot have properties
          const primitive = formatPrimitive(ctx, value);
          if (primitive) {
            return primitive;
          }

          // Look up the keys of the object.
          let keys = Object.keys(value);
          const visibleKeys = arrayToHash(keys);

          if (ctx.showHidden) {
            keys = Object.getOwnPropertyNames(value);
          }

          // IE doesn't make error fields non-enumerable
          // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
          if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
            return formatError(value);
          }

          // Some type of object without properties can be shortcutted.
          if (keys.length === 0) {
            if (isFunction(value)) {
              const name = value.name ? `: ${value.name}` : '';
              return ctx.stylize(`[Function${name}]`, 'special');
            }
            if (isRegExp(value)) {
              return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
            }
            if (isDate(value)) {
              return ctx.stylize(Date.prototype.toString.call(value), 'date');
            }
            if (isError(value)) {
              return formatError(value);
            }
          }

          let base = ''; let array = false; let
            braces = ['{', '}'];

          // Make Array say that they are Array
          if (isArray(value)) {
            array = true;
            braces = ['[', ']'];
          }

          // Make functions say that they are functions
          if (isFunction(value)) {
            const n = value.name ? `: ${value.name}` : '';
            base = ` [Function${n}]`;
          }

          // Make RegExps say that they are RegExps
          if (isRegExp(value)) {
            base = ` ${RegExp.prototype.toString.call(value)}`;
          }

          // Make dates with properties first say the date
          if (isDate(value)) {
            base = ` ${Date.prototype.toUTCString.call(value)}`;
          }

          // Make error with message first say the error
          if (isError(value)) {
            base = ` ${formatError(value)}`;
          }

          if (keys.length === 0 && (!array || value.length == 0)) {
            return braces[0] + base + braces[1];
          }

          if (recurseTimes < 0) {
            if (isRegExp(value)) {
              return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
            }
            return ctx.stylize('[Object]', 'special');
          }

          ctx.seen.push(value);

          let output;
          if (array) {
            output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
          } else {
            output = keys.map((key) => formatProperty(ctx, value, recurseTimes, visibleKeys, key, array));
          }

          ctx.seen.pop();

          return reduceToSingleString(output, base, braces);
        }

        function formatPrimitive(ctx, value) {
          if (isUndefined(value)) return ctx.stylize('undefined', 'undefined');
          if (isString(value)) {
            const simple = `'${JSON.stringify(value).replace(/^"|"$/g, '')
              .replace(/'/g, "\\'")
              .replace(/\\"/g, '"')}'`;
            return ctx.stylize(simple, 'string');
          }
          if (isNumber(value)) return ctx.stylize(`${value}`, 'number');
          if (isBoolean(value)) return ctx.stylize(`${value}`, 'boolean');
          // For some reason typeof null is "object", so special case here.
          if (isNull(value)) return ctx.stylize('null', 'null');
        }

        function formatError(value) {
          return `[${Error.prototype.toString.call(value)}]`;
        }

        function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
          const output = [];
          for (let i = 0, l = value.length; i < l; ++i) {
            if (hasOwnProperty(value, String(i))) {
              output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
                String(i), true));
            } else {
              output.push('');
            }
          }
          keys.forEach((key) => {
            if (!key.match(/^\d+$/)) {
              output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
                key, true));
            }
          });
          return output;
        }

        function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
          let name; let str; let
            desc;
          desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
          if (desc.get) {
            if (desc.set) {
              str = ctx.stylize('[Getter/Setter]', 'special');
            } else {
              str = ctx.stylize('[Getter]', 'special');
            }
          } else if (desc.set) {
            str = ctx.stylize('[Setter]', 'special');
          }
          if (!hasOwnProperty(visibleKeys, key)) {
            name = `[${key}]`;
          }
          if (!str) {
            if (ctx.seen.indexOf(desc.value) < 0) {
              if (isNull(recurseTimes)) {
                str = formatValue(ctx, desc.value, null);
              } else {
                str = formatValue(ctx, desc.value, recurseTimes - 1);
              }
              if (str.indexOf('\n') > -1) {
                if (array) {
                  str = str.split('\n').map((line) => `  ${line}`).join('\n').substr(2);
                } else {
                  str = `\n${str.split('\n').map((line) => `   ${line}`).join('\n')}`;
                }
              }
            } else {
              str = ctx.stylize('[Circular]', 'special');
            }
          }
          if (isUndefined(name)) {
            if (array && key.match(/^\d+$/)) {
              return str;
            }
            name = JSON.stringify(`${key}`);
            if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
              name = name.substr(1, name.length - 2);
              name = ctx.stylize(name, 'name');
            } else {
              name = name.replace(/'/g, "\\'")
                .replace(/\\"/g, '"')
                .replace(/(^"|"$)/g, "'");
              name = ctx.stylize(name, 'string');
            }
          }

          return `${name}: ${str}`;
        }

        function reduceToSingleString(output, base, braces) {
          let numLinesEst = 0;
          const length = output.reduce((prev, cur) => {
            numLinesEst++;
            if (cur.indexOf('\n') >= 0) numLinesEst++;
            return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
          }, 0);

          if (length > 60) {
            return `${braces[0]
           + (base === '' ? '' : `${base}\n `)
            } ${
              output.join(',\n  ')
            } ${
              braces[1]}`;
          }

          return `${braces[0] + base} ${output.join(', ')} ${braces[1]}`;
        }

        // NOTE: These type checking functions intentionally don't use `instanceof`
        // because it is fragile and can be easily faked with `Object.create()`.
        exports.types = __webpack_require__(5955);

        function isArray(ar) {
          return Array.isArray(ar);
        }
        exports.isArray = isArray;

        function isBoolean(arg) {
          return typeof arg === 'boolean';
        }
        exports.isBoolean = isBoolean;

        function isNull(arg) {
          return arg === null;
        }
        exports.isNull = isNull;

        function isNullOrUndefined(arg) {
          return arg == null;
        }
        exports.isNullOrUndefined = isNullOrUndefined;

        function isNumber(arg) {
          return typeof arg === 'number';
        }
        exports.isNumber = isNumber;

        function isString(arg) {
          return typeof arg === 'string';
        }
        exports.isString = isString;

        function isSymbol(arg) {
          return typeof arg === 'symbol';
        }
        exports.isSymbol = isSymbol;

        function isUndefined(arg) {
          return arg === void 0;
        }
        exports.isUndefined = isUndefined;

        function isRegExp(re) {
          return isObject(re) && objectToString(re) === '[object RegExp]';
        }
        exports.isRegExp = isRegExp;
        exports.types.isRegExp = isRegExp;

        function isObject(arg) {
          return typeof arg === 'object' && arg !== null;
        }
        exports.isObject = isObject;

        function isDate(d) {
          return isObject(d) && objectToString(d) === '[object Date]';
        }
        exports.isDate = isDate;
        exports.types.isDate = isDate;

        function isError(e) {
          return isObject(e)
      && (objectToString(e) === '[object Error]' || e instanceof Error);
        }
        exports.isError = isError;
        exports.types.isNativeError = isError;

        function isFunction(arg) {
          return typeof arg === 'function';
        }
        exports.isFunction = isFunction;

        function isPrimitive(arg) {
          return arg === null
         || typeof arg === 'boolean'
         || typeof arg === 'number'
         || typeof arg === 'string'
         || typeof arg === 'symbol' // ES6 symbol
         || typeof arg === 'undefined';
        }
        exports.isPrimitive = isPrimitive;

        exports.isBuffer = __webpack_require__(384);

        function objectToString(o) {
          return Object.prototype.toString.call(o);
        }

        function pad(n) {
          return n < 10 ? `0${n.toString(10)}` : n.toString(10);
        }

        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
          'Oct', 'Nov', 'Dec'];

        // 26 Feb 16:19:34
        function timestamp() {
          const d = new Date();
          const time = [pad(d.getHours()),
            pad(d.getMinutes()),
            pad(d.getSeconds())].join(':');
          return [d.getDate(), months[d.getMonth()], time].join(' ');
        }

        // log is just a thin wrapper to console.log that prepends a timestamp
        exports.log = function () {
          console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
        };

        /**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
        exports.inherits = __webpack_require__(5717);

        exports._extend = function (origin, add) {
          // Don't do anything if add isn't an object
          if (!add || !isObject(add)) return origin;

          const keys = Object.keys(add);
          let i = keys.length;
          while (i--) {
            origin[keys[i]] = add[keys[i]];
          }
          return origin;
        };

        function hasOwnProperty(obj, prop) {
          return Object.prototype.hasOwnProperty.call(obj, prop);
        }

        const kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

        exports.promisify = function promisify(original) {
          if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');

          if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
            var fn = original[kCustomPromisifiedSymbol];
            if (typeof fn !== 'function') {
              throw new TypeError('The "util.promisify.custom" argument must be of type Function');
            }
            Object.defineProperty(fn, kCustomPromisifiedSymbol, {
              value: fn, enumerable: false, writable: false, configurable: true,
            });
            return fn;
          }

          function fn() {
            let promiseResolve; let
              promiseReject;
            const promise = new Promise(((resolve, reject) => {
              promiseResolve = resolve;
              promiseReject = reject;
            }));

            const args = [];
            for (let i = 0; i < arguments.length; i++) {
              args.push(arguments[i]);
            }
            args.push((err, value) => {
              if (err) {
                promiseReject(err);
              } else {
                promiseResolve(value);
              }
            });

            try {
              original.apply(this, args);
            } catch (err) {
              promiseReject(err);
            }

            return promise;
          }

          Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

          if (kCustomPromisifiedSymbol) {
            Object.defineProperty(fn, kCustomPromisifiedSymbol, {
              value: fn, enumerable: false, writable: false, configurable: true,
            });
          }
          return Object.defineProperties(
            fn,
            getOwnPropertyDescriptors(original),
          );
        };

        exports.promisify.custom = kCustomPromisifiedSymbol;

        function callbackifyOnRejected(reason, cb) {
          // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
          // Because `null` is a special error value in callbacks which means "no error
          // occurred", we error-wrap so the callback consumer can distinguish between
          // "the promise rejected with null" or "the promise fulfilled with undefined".
          if (!reason) {
            const newReason = new Error('Promise was rejected with a falsy value');
            newReason.reason = reason;
            reason = newReason;
          }
          return cb(reason);
        }

        function callbackify(original) {
          if (typeof original !== 'function') {
            throw new TypeError('The "original" argument must be of type Function');
          }

          // We DO NOT return the promise as it gives the user a false sense that
          // the promise is actually somehow related to the callback's execution
          // and that the callback throwing will reject the promise.
          function callbackified() {
            const args = [];
            for (let i = 0; i < arguments.length; i++) {
              args.push(arguments[i]);
            }

            const maybeCb = args.pop();
            if (typeof maybeCb !== 'function') {
              throw new TypeError('The last argument must be of type Function');
            }
            const self = this;
            const cb = function () {
              return maybeCb.apply(self, arguments);
            };
            // In true node style we process the callback on `nextTick` with all the
            // implications (stack, `uncaughtException`, `async_hooks`)
            original.apply(this, args)
              .then((ret) => { process.nextTick(cb.bind(null, null, ret)); },
                (rej) => { process.nextTick(callbackifyOnRejected.bind(null, rej, cb)); });
          }

          Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
          Object.defineProperties(callbackified,
            getOwnPropertyDescriptors(original));
          return callbackified;
        }
        exports.callbackify = callbackify;
        /***/ }),

      /***/ 6430:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const forEach = __webpack_require__(9804);
        const availableTypedArrays = __webpack_require__(3083);
        const callBound = __webpack_require__(1924);

        const $toString = callBound('Object.prototype.toString');
        const hasToStringTag = __webpack_require__(6410)();

        const g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;
        const typedArrays = availableTypedArrays();

        const $slice = callBound('String.prototype.slice');
        const toStrTags = {};
        const gOPD = __webpack_require__(882);
        const { getPrototypeOf } = Object; // require('getprototypeof');
        if (hasToStringTag && gOPD && getPrototypeOf) {
          forEach(typedArrays, (typedArray) => {
            if (typeof g[typedArray] === 'function') {
              const arr = new g[typedArray]();
              if (Symbol.toStringTag in arr) {
                const proto = getPrototypeOf(arr);
                let descriptor = gOPD(proto, Symbol.toStringTag);
                if (!descriptor) {
                  const superProto = getPrototypeOf(proto);
                  descriptor = gOPD(superProto, Symbol.toStringTag);
                }
                toStrTags[typedArray] = descriptor.get;
              }
            }
          });
        }

        const tryTypedArrays = function tryAllTypedArrays(value) {
          let foundName = false;
          forEach(toStrTags, (getter, typedArray) => {
            if (!foundName) {
              try {
                const name = getter.call(value);
                if (name === typedArray) {
                  foundName = name;
                }
              } catch (e) {}
            }
          });
          return foundName;
        };

        const isTypedArray = __webpack_require__(5692);

        module.exports = function whichTypedArray(value) {
          if (!isTypedArray(value)) { return false; }
          if (!hasToStringTag || !(Symbol.toStringTag in value)) { return $slice($toString(value), 8, -1); }
          return tryTypedArrays(value);
        };
        /***/ }),

      /***/ 6513:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        // This file is just added for convenience so this repository can be
        // directly checked out into a project's deps folder
        module.exports = __webpack_require__(5011);
        /***/ }),

      /***/ 5011:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        (function () {
          let sax;

          if (true && module.exports && !__webpack_require__.g.xmldocAssumeBrowser) {
            // We're being used in a Node-like environment
            sax = __webpack_require__(6099);
          } else {
            // assume it's attached to the Window object in a browser
            sax = this.sax;

            if (!sax) // no sax for you!
            { throw new Error("Expected sax to be defined. Make sure you're including sax.js before this file."); }
          }

          /*
XmlElement is our basic building block. Everything is an XmlElement; even XmlDocument
behaves like an XmlElement by inheriting its attributes and functions.
*/

          function XmlElement(tag) {
            // Capture the parser object off of the XmlDocument delegate
            const { parser } = delegates[delegates.length - 1];

            this.name = tag.name;
            this.attr = tag.attributes;
            this.val = '';
            this.children = [];
            this.firstChild = null;
            this.lastChild = null;

            // Assign parse information
            this.line = parser.line;
            this.column = parser.column;
            this.position = parser.position;
            this.startTagPosition = parser.startTagPosition;
          }

          // Private methods

          XmlElement.prototype._addChild = function (child) {
            // add to our children array
            this.children.push(child);

            // update first/last pointers
            if (!this.firstChild) this.firstChild = child;
            this.lastChild = child;
          };

          // SaxParser handlers

          XmlElement.prototype._opentag = function (tag) {
            const child = new XmlElement(tag);

            this._addChild(child);

            delegates.unshift(child);
          };

          XmlElement.prototype._closetag = function () {
            delegates.shift();
          };

          XmlElement.prototype._text = function (text) {
            if (typeof this.children === 'undefined') return;

            this.val += text;

            this._addChild(new XmlTextNode(text));
          };

          XmlElement.prototype._cdata = function (cdata) {
            this.val += cdata;

            this._addChild(new XmlCDataNode(cdata));
          };

          XmlElement.prototype._comment = function (comment) {
            if (typeof this.children === 'undefined') return;

            this._addChild(new XmlCommentNode(comment));
          };

          XmlElement.prototype._error = function (err) {
            throw err;
          };

          // Useful functions

          XmlElement.prototype.eachChild = function (iterator, context) {
            for (let i = 0, l = this.children.length; i < l; i++) if (this.children[i].type === 'element') if (iterator.call(context, this.children[i], i, this.children) === false) return;
          };

          XmlElement.prototype.childNamed = function (name) {
            for (let i = 0, l = this.children.length; i < l; i++) {
              const child = this.children[i];
              if (child.name === name) return child;
            }
            return undefined;
          };

          XmlElement.prototype.childrenNamed = function (name) {
            const matches = [];

            for (let i = 0, l = this.children.length; i < l; i++) if (this.children[i].name === name) matches.push(this.children[i]);

            return matches;
          };

          XmlElement.prototype.childWithAttribute = function (name, value) {
            for (let i = 0, l = this.children.length; i < l; i++) {
              const child = this.children[i];
              if (child.type === 'element' && ((value && child.attr[name] === value) || (!value && child.attr[name]))) return child;
            }
            return undefined;
          };

          XmlElement.prototype.descendantWithPath = function (path) {
            let descendant = this;
            const components = path.split('.');

            for (let i = 0, l = components.length; i < l; i++) {
              if (descendant && descendant.type === 'element') descendant = descendant.childNamed(components[i]);
              else return undefined;
            }

            return descendant;
          };

          XmlElement.prototype.valueWithPath = function (path) {
            const components = path.split('@');
            const descendant = this.descendantWithPath(components[0]);
            if (descendant) return components.length > 1 ? descendant.attr[components[1]] : descendant.val;
            return undefined;
          };

          // String formatting (for debugging)

          XmlElement.prototype.toString = function (options) {
            return this.toStringWithIndent('', options);
          };

          XmlElement.prototype.toStringWithIndent = function (indent, options) {
            let s = `${indent}<${this.name}`;
            const linebreak = options && options.compressed ? '' : '\n';
            const preserveWhitespace = options && options.preserveWhitespace;

            for (const name in this.attr) if (Object.prototype.hasOwnProperty.call(this.attr, name)) s += ` ${name}="${escapeXML(this.attr[name])}"`;

            if (this.children.length === 1 && this.children[0].type !== 'element') {
              s += `>${this.children[0].toString(options)}</${this.name}>`;
            } else if (this.children.length) {
              s += `>${linebreak}`;

              const childIndent = indent + (options && options.compressed ? '' : '  ');

              for (let i = 0, l = this.children.length; i < l; i++) {
                s += this.children[i].toStringWithIndent(childIndent, options) + linebreak;
              }

              s += `${indent}</${this.name}>`;
            } else if (options && options.html) {
              const whiteList = [
                'area', 'base', 'br', 'col', 'embed', 'frame', 'hr', 'img', 'input',
                'keygen', 'link', 'menuitem', 'meta', 'param', 'source', 'track', 'wbr',
              ];
              if (whiteList.indexOf(this.name) !== -1) s += '/>';
              else s += `></${this.name}>`;
            } else {
              s += '/>';
            }

            return s;
          };

          // Alternative XML nodes

          function XmlTextNode(text) {
            this.text = text;
          }

          XmlTextNode.prototype.toString = function (options) {
            return formatText(escapeXML(this.text), options);
          };

          XmlTextNode.prototype.toStringWithIndent = function (indent, options) {
            return indent + this.toString(options);
          };

          function XmlCDataNode(cdata) {
            this.cdata = cdata;
          }

          XmlCDataNode.prototype.toString = function (options) {
            return `<![CDATA[${formatText(this.cdata, options)}]]>`;
          };

          XmlCDataNode.prototype.toStringWithIndent = function (indent, options) {
            return indent + this.toString(options);
          };

          function XmlCommentNode(comment) {
            this.comment = comment;
          }

          XmlCommentNode.prototype.toString = function (options) {
            return `<!--${formatText(escapeXML(this.comment), options)}-->`;
          };

          XmlCommentNode.prototype.toStringWithIndent = function (indent, options) {
            return indent + this.toString(options);
          };

          // Node type tag

          XmlElement.prototype.type = 'element';
          XmlTextNode.prototype.type = 'text';
          XmlCDataNode.prototype.type = 'cdata';
          XmlCommentNode.prototype.type = 'comment';

          /*
XmlDocument is the class we expose to the user; it uses the sax parser to create a hierarchy
of XmlElements.
*/

          function XmlDocument(xml) {
            xml && (xml = xml.toString().trim());

            if (!xml) throw new Error('No XML to parse!');

            // Stores doctype (if defined)
            this.doctype = '';

            // Expose the parser to the other delegates while the parser is running
            this.parser = sax.parser(true); // strict
            addParserEvents(this.parser);

            // We'll use the file-scoped "delegates" var to remember what elements we're currently
            // parsing; they will push and pop off the stack as we get deeper into the XML hierarchy.
            // It's safe to use a global because JS is single-threaded.
            delegates = [this];

            this.parser.write(xml);

            // Remove the parser as it is no longer needed and should not be exposed to clients
            delete this.parser;
          }

          // make XmlDocument inherit XmlElement's methods
          extend(XmlDocument.prototype, XmlElement.prototype);

          XmlDocument.prototype._opentag = function (tag) {
            if (typeof this.children === 'undefined')
            // the first tag we encounter should be the root - we'll "become" the root XmlElement
            { XmlElement.call(this, tag); } else
            // all other tags will be the root element's children
            { XmlElement.prototype._opentag.apply(this, arguments); }
          };

          XmlDocument.prototype._doctype = function (doctype) {
            this.doctype += doctype;
          };

          // file-scoped global stack of delegates
          var delegates = null;

          /*
Helper functions
*/

          function addParserEvents(parser) {
            parser.onopentag = parser_opentag;
            parser.onclosetag = parser_closetag;
            parser.ontext = parser_text;
            parser.oncdata = parser_cdata;
            parser.oncomment = parser_comment;
            parser.ondoctype = parser_doctype;
            parser.onerror = parser_error;
          }

          // create these closures and cache them by keeping them file-scoped
          function parser_opentag() { delegates[0] && delegates[0]._opentag.apply(delegates[0], arguments); }
          function parser_closetag() { delegates[0] && delegates[0]._closetag.apply(delegates[0], arguments); }
          function parser_text() { delegates[0] && delegates[0]._text.apply(delegates[0], arguments); }
          function parser_cdata() { delegates[0] && delegates[0]._cdata.apply(delegates[0], arguments); }
          function parser_comment() { delegates[0] && delegates[0]._comment.apply(delegates[0], arguments); }
          function parser_doctype() { delegates[0] && delegates[0]._doctype.apply(delegates[0], arguments); }
          function parser_error() { delegates[0] && delegates[0]._error.apply(delegates[0], arguments); }

          // a relatively standard extend method
          function extend(destination, source) {
            for (const prop in source) if (source.hasOwnProperty(prop)) destination[prop] = source[prop];
          }

          // escapes XML entities like "<", "&", etc.
          function escapeXML(value) {
            return value.toString().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
              .replace(/'/g, '&apos;')
              .replace(/"/g, '&quot;');
          }

          // formats some text for debugging given a few options
          function formatText(text, options) {
            let finalText = text;

            if (options && options.trimmed && text.length > 25) finalText = `${finalText.substring(0, 25).trim()}…`;
            if (!(options && options.preserveWhitespace)) finalText = finalText.trim();

            return finalText;
          }

          // Are we being used in a Node-like environment?
          if (true && module.exports && !__webpack_require__.g.xmldocAssumeBrowser) module.exports.XmlDocument = XmlDocument;
          else this.XmlDocument = XmlDocument;
        }());
        /***/ }),

      /***/ 6255:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        // Internet Explorer polyfills
        if (typeof window !== 'undefined' && !window.Promise) {
          __webpack_require__(3867);
        }
        __webpack_require__(4667);

        const fetchUrl = function (url) {
          return new Promise(((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.responseType = 'arraybuffer';

            xhr.onreadystatechange = function () {
              if (xhr.readyState !== 4) {
                return;
              }

              const ok = xhr.status >= 200 && xhr.status < 300;
              if (!ok) {
                setTimeout(() => {
                  reject(new TypeError(`Failed to fetch (url: "${url}")`));
                }, 0);
              }
            };

            xhr.onload = function () {
              const ok = xhr.status >= 200 && xhr.status < 300;
              if (ok) {
                resolve(xhr.response);
              }
            };

            xhr.onerror = function () {
              setTimeout(() => {
                reject(new TypeError(`Network request failed (url: "${url}")`));
              }, 0);
            };

            xhr.ontimeout = function () {
              setTimeout(() => {
                reject(new TypeError(`Network request failed (url: "${url}")`));
              }, 0);
            };

            xhr.send();
          }));
        };

        function URLBrowserResolver(fs) {
          this.fs = fs;
          this.resolving = {};
        }

        URLBrowserResolver.prototype.resolve = function (url) {
          if (!this.resolving[url]) {
            const _this = this;
            this.resolving[url] = new Promise(((resolve, reject) => {
              if (url.toLowerCase().indexOf('https://') === 0 || url.toLowerCase().indexOf('http://') === 0) {
                fetchUrl(url).then((buffer) => {
                  _this.fs.writeFileSync(url, buffer);
                  resolve();
                }, (result) => {
                  reject(result);
                });
              } else {
                // cannot be resolved
                resolve();
              }
            }));
          }

          return this.resolving[url];
        };

        URLBrowserResolver.prototype.resolved = function () {
          const _this = this;
          return new Promise(((resolve, reject) => {
            Promise.all(Object.values(_this.resolving)).then(() => {
              resolve();
            }, (result) => {
              reject(result);
            });
          }));
        };

        module.exports = URLBrowserResolver;
        /***/ }),

      /***/ 4275:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* provided dependency */ const { Buffer } = __webpack_require__(8823);

        const { isFunction } = __webpack_require__(6225);
        const { isUndefined } = __webpack_require__(6225);
        const { isNull } = __webpack_require__(6225);
        const FileSaver = __webpack_require__(4896);
        const { saveAs } = FileSaver;

        const defaultClientFonts = {
          Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Medium.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-MediumItalic.ttf',
          },
        };

        function Document(docDefinition, tableLayouts, fonts, vfs) {
          this.docDefinition = docDefinition;
          this.tableLayouts = tableLayouts || null;
          this.fonts = fonts || defaultClientFonts;
          this.vfs = vfs;
        }

        function canCreatePdf() {
          // Ensure the browser provides the level of support needed
          try {
            const arr = new Uint8Array(1);
            const proto = { foo() { return 42; } };
            Object.setPrototypeOf(proto, Uint8Array.prototype);
            Object.setPrototypeOf(arr, proto);
            return arr.foo() === 42;
          } catch (e) {
            return false;
          }
        }

        Document.prototype._createDoc = function (options, cb) {
          options = options || {};
          if (this.tableLayouts) {
            options.tableLayouts = this.tableLayouts;
          }

          const PdfPrinter = __webpack_require__(8617);

          const printer = new PdfPrinter(this.fonts);
          (__webpack_require__(3857).bindFS)(this.vfs); // bind virtual file system to file system

          if (!isFunction(cb)) {
            const doc = printer.createPdfKitDocument(this.docDefinition, options);

            return doc;
          }

          const URLBrowserResolver = __webpack_require__(6255);
          const urlResolver = new URLBrowserResolver(__webpack_require__(3857));

          for (const font in this.fonts) {
            if (this.fonts.hasOwnProperty(font)) {
              if (this.fonts[font].normal) {
                urlResolver.resolve(this.fonts[font].normal);
              }
              if (this.fonts[font].bold) {
                urlResolver.resolve(this.fonts[font].bold);
              }
              if (this.fonts[font].italics) {
                urlResolver.resolve(this.fonts[font].italics);
              }
              if (this.fonts[font].bolditalics) {
                urlResolver.resolve(this.fonts[font].bolditalics);
              }
            }
          }

          if (this.docDefinition.images) {
            for (const image in this.docDefinition.images) {
              if (this.docDefinition.images.hasOwnProperty(image)) {
                urlResolver.resolve(this.docDefinition.images[image]);
              }
            }
          }

          const _this = this;

          urlResolver.resolved().then(() => {
            const doc = printer.createPdfKitDocument(_this.docDefinition, options);

            cb(doc);
          }, (result) => {
            throw result;
          });
        };

        Document.prototype._flushDoc = function (doc, callback) {
          const chunks = [];
          let result;

          doc.on('readable', () => {
            let chunk;
            while ((chunk = doc.read(9007199254740991)) !== null) {
              chunks.push(chunk);
            }
          });
          doc.on('end', () => {
            result = Buffer.concat(chunks);
            callback(result, doc._pdfMakePages);
          });
          doc.end();
        };

        Document.prototype._getPages = function (options, cb) {
          if (!cb) {
            throw '_getPages is an async method and needs a callback argument';
          }
          const _this = this;

          this._createDoc(options, (doc) => {
            _this._flushDoc(doc, (ignoreBuffer, pages) => {
              cb(pages);
            });
          });
        };

        Document.prototype._bufferToBlob = function (buffer) {
          let blob;
          try {
            blob = new Blob([buffer], { type: 'application/pdf' });
          } catch (e) {
            // Old browser which can't handle it without making it an byte array (ie10)
            if (e.name === 'InvalidStateError') {
              const byteArray = new Uint8Array(buffer);
              blob = new Blob([byteArray.buffer], { type: 'application/pdf' });
            }
          }

          if (!blob) {
            throw 'Could not generate blob';
          }

          return blob;
        };

        Document.prototype._openWindow = function () {
          // we have to open the window immediately and store the reference
          // otherwise popup blockers will stop us
          const win = window.open('', '_blank');
          if (win === null) {
            throw 'Open PDF in new window blocked by browser';
          }

          return win;
        };

        Document.prototype._openPdf = function (options, win) {
          if (!win) {
            win = this._openWindow();
          }
          try {
            this.getBlob((result) => {
              const urlCreator = window.URL || window.webkitURL;
              const pdfUrl = urlCreator.createObjectURL(result);
              win.location.href = pdfUrl;

              /* temporarily disabled
			if (win !== window) {
				setTimeout(function () {
					if (isNull(win.window)) { // is closed by AdBlock
						window.location.href = pdfUrl; // open in actual window
					}
				}, 500);
			}
			*/
            }, options);
          } catch (e) {
            win.close();
            throw e;
          }
        };

        Document.prototype.open = function (options, win) {
          options = options || {};
          options.autoPrint = false;
          win = win || null;

          this._openPdf(options, win);
        };

        Document.prototype.print = function (options, win) {
          options = options || {};
          options.autoPrint = true;
          win = win || null;

          this._openPdf(options, win);
        };

        /**
 * download(defaultFileName = 'file.pdf', cb = null, options = {})
 * or
 * download(cb, options = {})
 */
        Document.prototype.download = function (defaultFileName, cb, options) {
          if (isFunction(defaultFileName)) {
            if (!isUndefined(cb)) {
              options = cb;
            }
            cb = defaultFileName;
            defaultFileName = null;
          }

          defaultFileName = defaultFileName || 'file.pdf';
          this.getBlob((result) => {
            saveAs(result, defaultFileName);

            if (isFunction(cb)) {
              cb();
            }
          }, options);
        };

        Document.prototype.getBase64 = function (cb, options) {
          if (!cb) {
            throw 'getBase64 is an async method and needs a callback argument';
          }
          this.getBuffer((buffer) => {
            cb(buffer.toString('base64'));
          }, options);
        };

        Document.prototype.getDataUrl = function (cb, options) {
          if (!cb) {
            throw 'getDataUrl is an async method and needs a callback argument';
          }
          this.getBuffer((buffer) => {
            cb(`data:application/pdf;base64,${buffer.toString('base64')}`);
          }, options);
        };

        Document.prototype.getBlob = function (cb, options) {
          if (!cb) {
            throw 'getBlob is an async method and needs a callback argument';
          }
          const that = this;
          this.getBuffer((result) => {
            const blob = that._bufferToBlob(result);
            cb(blob);
          }, options);
        };

        Document.prototype.getBuffer = function (cb, options) {
          if (!cb) {
            throw 'getBuffer is an async method and needs a callback argument';
          }

          const _this = this;

          this._createDoc(options, (doc) => {
            _this._flushDoc(doc, (buffer) => {
              cb(buffer);
            });
          });
        };

        Document.prototype.getStream = function (options, cb) {
          if (!isFunction(cb)) {
            const doc = this._createDoc(options);
            return doc;
          }

          this._createDoc(options, (doc) => {
            cb(doc);
          });
        };

        module.exports = {
          createPdf(docDefinition, tableLayouts, fonts, vfs) {
            if (!canCreatePdf()) {
              throw 'Your browser does not provide the level of support needed';
            }
            return new Document(
              docDefinition,
              tableLayouts || __webpack_require__.g.pdfMake.tableLayouts,
              fonts || __webpack_require__.g.pdfMake.fonts,
              vfs || __webpack_require__.g.pdfMake.vfs,
            );
          },
        };
        /***/ }),

      /***/ 3857:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const __dirname = '/';
        /* provided dependency */ const { Buffer } = __webpack_require__(8823);

        function VirtualFileSystem() {
          this.fileSystem = {};
          this.dataSystem = {};
        }

        VirtualFileSystem.prototype.existsSync = function (filename) {
          filename = fixFilename(filename);
          return typeof this.fileSystem[filename] !== 'undefined'
		|| typeof this.dataSystem[filename] !== 'undefined';
        };

        VirtualFileSystem.prototype.readFileSync = function (filename, options) {
          filename = fixFilename(filename);

          const dataContent = this.dataSystem[filename];
          if (typeof dataContent === 'string' && options === 'utf8') {
            return dataContent;
          }

          if (dataContent) {
            return new Buffer(dataContent, typeof dataContent === 'string' ? 'base64' : undefined);
          }

          const content = this.fileSystem[filename];
          if (content) {
            return content;
          }

          throw `File '${filename}' not found in virtual file system`;
        };

        VirtualFileSystem.prototype.writeFileSync = function (filename, content) {
          this.fileSystem[fixFilename(filename)] = content;
        };

        VirtualFileSystem.prototype.bindFS = function (data) {
          this.dataSystem = data || {};
        };

        function fixFilename(filename) {
          if (filename.indexOf(__dirname) === 0) {
            filename = filename.substring(__dirname.length);
          }

          if (filename.indexOf('/') === 0) {
            filename = filename.substring(1);
          }

          return filename;
        }

        module.exports = new VirtualFileSystem();
        /***/ }),

      /***/ 4498:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const { isString } = __webpack_require__(6225);

        function buildColumnWidths(columns, availableWidth) {
          const autoColumns = [];
          let autoMin = 0; let autoMax = 0;
          const starColumns = [];
          let starMaxMin = 0;
          let starMaxMax = 0;
          const fixedColumns = [];
          const initial_availableWidth = availableWidth;

          columns.forEach((column) => {
            if (isAutoColumn(column)) {
              autoColumns.push(column);
              autoMin += column._minWidth;
              autoMax += column._maxWidth;
            } else if (isStarColumn(column)) {
              starColumns.push(column);
              starMaxMin = Math.max(starMaxMin, column._minWidth);
              starMaxMax = Math.max(starMaxMax, column._maxWidth);
            } else {
              fixedColumns.push(column);
            }
          });

          fixedColumns.forEach((col) => {
            // width specified as %
            if (isString(col.width) && /\d+%/.test(col.width)) {
              col.width = parseFloat(col.width) * initial_availableWidth / 100;
            }
            if (col.width < (col._minWidth) && col.elasticWidth) {
              col._calcWidth = col._minWidth;
            } else {
              col._calcWidth = col.width;
            }

            availableWidth -= col._calcWidth;
          });

          // http://www.freesoft.org/CIE/RFC/1942/18.htm
          // http://www.w3.org/TR/CSS2/tables.html#width-layout
          // http://dev.w3.org/csswg/css3-tables-algorithms/Overview.src.htm
          const minW = autoMin + starMaxMin * starColumns.length;
          const maxW = autoMax + starMaxMax * starColumns.length;
          if (minW >= availableWidth) {
            // case 1 - there's no way to fit all columns within available width
            // that's actually pretty bad situation with PDF as we have no horizontal scroll
            // no easy workaround (unless we decide, in the future, to split single words)
            // currently we simply use minWidths for all columns
            autoColumns.forEach((col) => {
              col._calcWidth = col._minWidth;
            });

            starColumns.forEach((col) => {
              col._calcWidth = starMaxMin; // starMaxMin already contains padding
            });
          } else {
            if (maxW < availableWidth) {
              // case 2 - we can fit rest of the table within available space
              autoColumns.forEach((col) => {
                col._calcWidth = col._maxWidth;
                availableWidth -= col._calcWidth;
              });
            } else {
              // maxW is too large, but minW fits within available width
              const W = availableWidth - minW;
              const D = maxW - minW;

              autoColumns.forEach((col) => {
                const d = col._maxWidth - col._minWidth;
                col._calcWidth = col._minWidth + d * W / D;
                availableWidth -= col._calcWidth;
              });
            }

            if (starColumns.length > 0) {
              const starSize = availableWidth / starColumns.length;

              starColumns.forEach((col) => {
                col._calcWidth = starSize;
              });
            }
          }
        }

        function isAutoColumn(column) {
          return column.width === 'auto';
        }

        function isStarColumn(column) {
          return column.width === null || column.width === undefined || column.width === '*' || column.width === 'star';
        }

        // TODO: refactor and reuse in measureTable
        function measureMinMax(columns) {
          const result = { min: 0, max: 0 };

          const maxStar = { min: 0, max: 0 };
          let starCount = 0;

          for (let i = 0, l = columns.length; i < l; i++) {
            const c = columns[i];

            if (isStarColumn(c)) {
              maxStar.min = Math.max(maxStar.min, c._minWidth);
              maxStar.max = Math.max(maxStar.max, c._maxWidth);
              starCount++;
            } else if (isAutoColumn(c)) {
              result.min += c._minWidth;
              result.max += c._maxWidth;
            } else {
              result.min += ((c.width !== undefined && c.width) || c._minWidth);
              result.max += ((c.width !== undefined && c.width) || c._maxWidth);
            }
          }

          if (starCount) {
            result.min += starCount * maxStar.min;
            result.max += starCount * maxStar.max;
          }

          return result;
        }

        /**
 * Calculates column widths
 * @private
 */
        module.exports = {
          buildColumnWidths,
          measureMinMax,
          isAutoColumn,
          isStarColumn,
        };
        /***/ }),

      /***/ 1728:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* eslint no-unused-vars: ["error", {"args": "none"}] */

        const TextTools = __webpack_require__(1350);
        const StyleContextStack = __webpack_require__(7597);
        const ColumnCalculator = __webpack_require__(4498);
        const { isString } = __webpack_require__(6225);
        const { isNumber } = __webpack_require__(6225);
        const { isObject } = __webpack_require__(6225);
        const { isArray } = __webpack_require__(6225);
        const { fontStringify } = __webpack_require__(6225);
        const { getNodeId } = __webpack_require__(6225);
        const { pack } = __webpack_require__(6225);
        const qrEncoder = __webpack_require__(145);

        /**
 * @private
 */
        function DocMeasure(fontProvider, styleDictionary, defaultStyle, imageMeasure, svgMeasure, tableLayouts, images) {
          this.textTools = new TextTools(fontProvider);
          this.styleStack = new StyleContextStack(styleDictionary, defaultStyle);
          this.imageMeasure = imageMeasure;
          this.svgMeasure = svgMeasure;
          this.tableLayouts = tableLayouts;
          this.images = images;
          this.autoImageIndex = 1;
        }

        /**
 * Measures all nodes and sets min/max-width properties required for the second
 * layout-pass.
 * @param  {Object} docStructure document-definition-object
 * @return {Object}              document-measurement-object
 */
        DocMeasure.prototype.measureDocument = function (docStructure) {
          return this.measureNode(docStructure);
        };

        DocMeasure.prototype.measureNode = function (node) {
          const self = this;

          return this.styleStack.auto(node, () => {
            // TODO: refactor + rethink whether this is the proper way to handle margins
            node._margin = getNodeMargin(node);

            if (node.columns) {
              return extendMargins(self.measureColumns(node));
            } if (node.stack) {
              return extendMargins(self.measureVerticalContainer(node));
            } if (node.ul) {
              return extendMargins(self.measureUnorderedList(node));
            } if (node.ol) {
              return extendMargins(self.measureOrderedList(node));
            } if (node.table) {
              return extendMargins(self.measureTable(node));
            } if (node.text !== undefined) {
              return extendMargins(self.measureLeaf(node));
            } if (node.toc) {
              return extendMargins(self.measureToc(node));
            } if (node.image) {
              return extendMargins(self.measureImage(node));
            } if (node.svg) {
              return extendMargins(self.measureSVG(node));
            } if (node.canvas) {
              return extendMargins(self.measureCanvas(node));
            } if (node.qr) {
              return extendMargins(self.measureQr(node));
            }
            throw `Unrecognized document structure: ${JSON.stringify(node, fontStringify)}`;
          });

          function extendMargins(node) {
            const margin = node._margin;

            if (margin) {
              node._minWidth += margin[0] + margin[2];
              node._maxWidth += margin[0] + margin[2];
            }

            return node;
          }

          function getNodeMargin() {
            function processSingleMargins(node, currentMargin) {
              if (node.marginLeft || node.marginTop || node.marginRight || node.marginBottom) {
                return [
                  node.marginLeft || currentMargin[0] || 0,
                  node.marginTop || currentMargin[1] || 0,
                  node.marginRight || currentMargin[2] || 0,
                  node.marginBottom || currentMargin[3] || 0,
                ];
              }
              return currentMargin;
            }

            function flattenStyleArray(styleArray) {
              const flattenedStyles = {};
              for (let i = styleArray.length - 1; i >= 0; i--) {
                const styleName = styleArray[i];
                const style = self.styleStack.styleDictionary[styleName];
                for (const key in style) {
                  if (style.hasOwnProperty(key)) {
                    flattenedStyles[key] = style[key];
                  }
                }
              }
              return flattenedStyles;
            }

            function convertMargin(margin) {
              if (isNumber(margin)) {
                margin = [margin, margin, margin, margin];
              } else if (isArray(margin)) {
                if (margin.length === 2) {
                  margin = [margin[0], margin[1], margin[0], margin[1]];
                }
              }
              return margin;
            }

            let margin = [undefined, undefined, undefined, undefined];

            if (node.style) {
              const styleArray = isArray(node.style) ? node.style : [node.style];
              const flattenedStyleArray = flattenStyleArray(styleArray);

              if (flattenedStyleArray) {
                margin = processSingleMargins(flattenedStyleArray, margin);
              }

              if (flattenedStyleArray.margin) {
                margin = convertMargin(flattenedStyleArray.margin);
              }
            }

            margin = processSingleMargins(node, margin);

            if (node.margin) {
              margin = convertMargin(node.margin);
            }

            if (margin[0] === undefined && margin[1] === undefined && margin[2] === undefined && margin[3] === undefined) {
              return null;
            }
            return margin;
          }
        };

        DocMeasure.prototype.convertIfBase64Image = function (node) {
          if (/^data:image\/(jpeg|jpg|png);base64,/.test(node.image)) {
            const label = `$$pdfmake$$${this.autoImageIndex++}`;
            this.images[label] = node.image;
            node.image = label;
          }
        };

        DocMeasure.prototype.measureImageWithDimensions = function (node, dimensions) {
          if (node.fit) {
            const factor = (dimensions.width / dimensions.height > node.fit[0] / node.fit[1]) ? node.fit[0] / dimensions.width : node.fit[1] / dimensions.height;
            node._width = node._minWidth = node._maxWidth = dimensions.width * factor;
            node._height = dimensions.height * factor;
          } else {
            node._width = node._minWidth = node._maxWidth = node.width || dimensions.width;
            node._height = node.height || (dimensions.height * node._width / dimensions.width);

            if (isNumber(node.maxWidth) && node.maxWidth < node._width) {
              node._width = node._minWidth = node._maxWidth = node.maxWidth;
              node._height = node._width * dimensions.height / dimensions.width;
            }

            if (isNumber(node.maxHeight) && node.maxHeight < node._height) {
              node._height = node.maxHeight;
              node._width = node._minWidth = node._maxWidth = node._height * dimensions.width / dimensions.height;
            }

            if (isNumber(node.minWidth) && node.minWidth > node._width) {
              node._width = node._minWidth = node._maxWidth = node.minWidth;
              node._height = node._width * dimensions.height / dimensions.width;
            }

            if (isNumber(node.minHeight) && node.minHeight > node._height) {
              node._height = node.minHeight;
              node._width = node._minWidth = node._maxWidth = node._height * dimensions.width / dimensions.height;
            }
          }

          node._alignment = this.styleStack.getProperty('alignment');
        };

        DocMeasure.prototype.measureImage = function (node) {
          if (this.images) {
            this.convertIfBase64Image(node);
          }

          const dimensions = this.imageMeasure.measureImage(node.image);

          this.measureImageWithDimensions(node, dimensions);

          return node;
        };

        DocMeasure.prototype.measureSVG = function (node) {
          const dimensions = this.svgMeasure.measureSVG(node.svg);

          this.measureImageWithDimensions(node, dimensions);

          node.font = this.styleStack.getProperty('font');

          // scale SVG based on final dimension
          node.svg = this.svgMeasure.writeDimensions(node.svg, {
            width: node._width,
            height: node._height,
          });

          return node;
        };

        DocMeasure.prototype.measureLeaf = function (node) {
          if (node._textRef && node._textRef._textNodeRef.text) {
            node.text = node._textRef._textNodeRef.text;
          }

          // Make sure style properties of the node itself are considered when building inlines.
          // We could also just pass [node] to buildInlines, but that fails for bullet points.
          const styleStack = this.styleStack.clone();
          styleStack.push(node);

          const data = this.textTools.buildInlines(node.text, styleStack);

          node._inlines = data.items;
          node._minWidth = data.minWidth;
          node._maxWidth = data.maxWidth;

          return node;
        };

        DocMeasure.prototype.measureToc = function (node) {
          if (node.toc.title) {
            node.toc.title = this.measureNode(node.toc.title);
          }

          if (node.toc._items.length > 0) {
            const body = [];
            const textStyle = node.toc.textStyle || {};
            const numberStyle = node.toc.numberStyle || textStyle;
            const textMargin = node.toc.textMargin || [0, 0, 0, 0];
            for (let i = 0, l = node.toc._items.length; i < l; i++) {
              const item = node.toc._items[i];
              const lineStyle = item._textNodeRef.tocStyle || textStyle;
              const lineMargin = item._textNodeRef.tocMargin || textMargin;
              const lineNumberStyle = item._textNodeRef.tocNumberStyle || numberStyle;
              const destination = getNodeId(item._nodeRef);
              body.push([
                {
                  text: item._textNodeRef.text, linkToDestination: destination, alignment: 'left', style: lineStyle, margin: lineMargin,
                },
                {
                  text: '00000', linkToDestination: destination, alignment: 'right', _tocItemRef: item._nodeRef, style: lineNumberStyle, margin: [0, lineMargin[1], 0, lineMargin[3]],
                },
              ]);
            }

            node.toc._table = {
              table: {
                dontBreakRows: true,
                widths: ['*', 'auto'],
                body,
              },
              layout: 'noBorders',
            };

            node.toc._table = this.measureNode(node.toc._table);
          }

          return node;
        };

        DocMeasure.prototype.measureVerticalContainer = function (node) {
          const items = node.stack;

          node._minWidth = 0;
          node._maxWidth = 0;

          for (let i = 0, l = items.length; i < l; i++) {
            items[i] = this.measureNode(items[i]);

            node._minWidth = Math.max(node._minWidth, items[i]._minWidth);
            node._maxWidth = Math.max(node._maxWidth, items[i]._maxWidth);
          }

          return node;
        };

        DocMeasure.prototype.gapSizeForList = function () {
          return this.textTools.sizeOfString('9. ', this.styleStack);
        };

        DocMeasure.prototype.buildUnorderedMarker = function (styleStack, gapSize, type) {
          function buildDisc(gapSize, color) {
            // TODO: ascender-based calculations
            const radius = gapSize.fontSize / 6;
            return {
              canvas: [{
                x: radius,
                y: (gapSize.height / gapSize.lineHeight) + gapSize.descender - gapSize.fontSize / 3,
                r1: radius,
                r2: radius,
                type: 'ellipse',
                color,
              }],
            };
          }

          function buildSquare(gapSize, color) {
            // TODO: ascender-based calculations
            const size = gapSize.fontSize / 3;
            return {
              canvas: [{
                x: 0,
                y: (gapSize.height / gapSize.lineHeight) + gapSize.descender - (gapSize.fontSize / 3) - (size / 2),
                h: size,
                w: size,
                type: 'rect',
                color,
              }],
            };
          }

          function buildCircle(gapSize, color) {
            // TODO: ascender-based calculations
            const radius = gapSize.fontSize / 6;
            return {
              canvas: [{
                x: radius,
                y: (gapSize.height / gapSize.lineHeight) + gapSize.descender - gapSize.fontSize / 3,
                r1: radius,
                r2: radius,
                type: 'ellipse',
                lineColor: color,
              }],
            };
          }

          let marker;
          const color = styleStack.getProperty('markerColor') || styleStack.getProperty('color') || 'black';

          switch (type) {
            case 'circle':
              marker = buildCircle(gapSize, color);
              break;

            case 'square':
              marker = buildSquare(gapSize, color);
              break;

            case 'none':
              marker = {};
              break;

            case 'disc':
            default:
              marker = buildDisc(gapSize, color);
              break;
          }

          marker._minWidth = marker._maxWidth = gapSize.width;
          marker._minHeight = marker._maxHeight = gapSize.height;

          return marker;
        };

        DocMeasure.prototype.buildOrderedMarker = function (counter, styleStack, type, separator) {
          function prepareAlpha(counter) {
            function toAlpha(num) {
              return (num >= 26 ? toAlpha((num / 26 >> 0) - 1) : '') + 'abcdefghijklmnopqrstuvwxyz'[num % 26 >> 0];
            }

            if (counter < 1) {
              return counter.toString();
            }

            return toAlpha(counter - 1);
          }

          function prepareRoman(counter) {
            if (counter < 1 || counter > 4999) {
              return counter.toString();
            }
            let num = counter;
            const lookup = {
              M: 1000, CM: 900, D: 500, CD: 400, C: 100, XC: 90, L: 50, XL: 40, X: 10, IX: 9, V: 5, IV: 4, I: 1,
            }; let roman = ''; let
              i;
            for (i in lookup) {
              while (num >= lookup[i]) {
                roman += i;
                num -= lookup[i];
              }
            }
            return roman;
          }

          function prepareDecimal(counter) {
            return counter.toString();
          }

          let counterText;
          switch (type) {
            case 'none':
              counterText = null;
              break;

            case 'upper-alpha':
              counterText = prepareAlpha(counter).toUpperCase();
              break;

            case 'lower-alpha':
              counterText = prepareAlpha(counter);
              break;

            case 'upper-roman':
              counterText = prepareRoman(counter);
              break;

            case 'lower-roman':
              counterText = prepareRoman(counter).toLowerCase();
              break;

            case 'decimal':
            default:
              counterText = prepareDecimal(counter);
              break;
          }

          if (counterText === null) {
            return {};
          }

          if (separator) {
            if (isArray(separator)) {
              if (separator[0]) {
                counterText = separator[0] + counterText;
              }

              if (separator[1]) {
                counterText += separator[1];
              }
              counterText += ' ';
            } else {
              counterText += `${separator} `;
            }
          }

          const textArray = { text: counterText };
          const markerColor = styleStack.getProperty('markerColor');
          if (markerColor) {
            textArray.color = markerColor;
          }

          return { _inlines: this.textTools.buildInlines(textArray, styleStack).items };
        };

        DocMeasure.prototype.measureUnorderedList = function (node) {
          const style = this.styleStack.clone();
          const items = node.ul;
          node.type = node.type || 'disc';
          node._gapSize = this.gapSizeForList();
          node._minWidth = 0;
          node._maxWidth = 0;

          for (let i = 0, l = items.length; i < l; i++) {
            const item = items[i] = this.measureNode(items[i]);

            if (!item.ol && !item.ul) {
              item.listMarker = this.buildUnorderedMarker(style, node._gapSize, item.listType || node.type);
            }

            node._minWidth = Math.max(node._minWidth, items[i]._minWidth + node._gapSize.width);
            node._maxWidth = Math.max(node._maxWidth, items[i]._maxWidth + node._gapSize.width);
          }

          return node;
        };

        DocMeasure.prototype.measureOrderedList = function (node) {
          const style = this.styleStack.clone();
          const items = node.ol;
          node.type = node.type || 'decimal';
          node.separator = node.separator || '.';
          node.reversed = node.reversed || false;
          if (!isNumber(node.start)) {
            node.start = node.reversed ? items.length : 1;
          }
          node._gapSize = this.gapSizeForList();
          node._minWidth = 0;
          node._maxWidth = 0;

          let counter = node.start;
          for (var i = 0, l = items.length; i < l; i++) {
            var item = items[i] = this.measureNode(items[i]);

            if (!item.ol && !item.ul) {
              const counterValue = isNumber(item.counter) ? item.counter : counter;
              item.listMarker = this.buildOrderedMarker(counterValue, style, item.listType || node.type, node.separator);
              if (item.listMarker._inlines) {
                node._gapSize.width = Math.max(node._gapSize.width, item.listMarker._inlines[0].width);
              }
            } // TODO: else - nested lists numbering

            node._minWidth = Math.max(node._minWidth, items[i]._minWidth);
            node._maxWidth = Math.max(node._maxWidth, items[i]._maxWidth);

            if (node.reversed) {
              counter--;
            } else {
              counter++;
            }
          }

          node._minWidth += node._gapSize.width;
          node._maxWidth += node._gapSize.width;

          for (var i = 0, l = items.length; i < l; i++) {
            var item = items[i];
            if (!item.ol && !item.ul) {
              item.listMarker._minWidth = item.listMarker._maxWidth = node._gapSize.width;
            }
          }

          return node;
        };

        DocMeasure.prototype.measureColumns = function (node) {
          const { columns } = node;
          node._gap = this.styleStack.getProperty('columnGap') || 0;

          for (let i = 0, l = columns.length; i < l; i++) {
            columns[i] = this.measureNode(columns[i]);
          }

          const measures = ColumnCalculator.measureMinMax(columns);

          const numGaps = (columns.length > 0) ? (columns.length - 1) : 0;
          node._minWidth = measures.min + node._gap * numGaps;
          node._maxWidth = measures.max + node._gap * numGaps;

          return node;
        };

        DocMeasure.prototype.measureTable = function (node) {
          extendTableWidths(node);
          node._layout = getLayout(this.tableLayouts);
          node._offsets = getOffsets(node._layout);

          const colSpans = [];
          let col; let row; let cols; let
            rows;

          for (col = 0, cols = node.table.body[0].length; col < cols; col++) {
            const c = node.table.widths[col];
            c._minWidth = 0;
            c._maxWidth = 0;

            for (row = 0, rows = node.table.body.length; row < rows; row++) {
              const rowData = node.table.body[row];
              let data = rowData[col];
              if (data === undefined) {
                console.error('Malformed table row ', rowData, 'in node ', node);
                throw 'Malformed table row, a cell is undefined.';
              }
              if (data === null) { // transform to object
                data = '';
              }

              if (!data._span) {
                data = rowData[col] = this.styleStack.auto(data, measureCb(this, data));

                if (data.colSpan && data.colSpan > 1) {
                  markSpans(rowData, col, data.colSpan);
                  colSpans.push({
                    col, span: data.colSpan, minWidth: data._minWidth, maxWidth: data._maxWidth,
                  });
                } else {
                  c._minWidth = Math.max(c._minWidth, data._minWidth);
                  c._maxWidth = Math.max(c._maxWidth, data._maxWidth);
                }
              }

              if (data.rowSpan && data.rowSpan > 1) {
                markVSpans(node.table, row, col, data.rowSpan);
              }
            }
          }

          extendWidthsForColSpans();

          const measures = ColumnCalculator.measureMinMax(node.table.widths);

          node._minWidth = measures.min + node._offsets.total;
          node._maxWidth = measures.max + node._offsets.total;

          return node;

          function measureCb(_this, data) {
            return function () {
              if (isObject(data)) {
                data.fillColor = _this.styleStack.getProperty('fillColor');
                data.fillOpacity = _this.styleStack.getProperty('fillOpacity');
              }
              return _this.measureNode(data);
            };
          }

          function getLayout(tableLayouts) {
            let { layout } = node;

            if (isString(layout)) {
              layout = tableLayouts[layout];
            }

            const defaultLayout = {
              hLineWidth(i, node) {
                return 1;
              },
              vLineWidth(i, node) {
                return 1;
              },
              hLineColor(i, node) {
                return 'black';
              },
              vLineColor(i, node) {
                return 'black';
              },
              hLineStyle(i, node) {
                return null;
              },
              vLineStyle(i, node) {
                return null;
              },
              paddingLeft(i, node) {
                return 4;
              },
              paddingRight(i, node) {
                return 4;
              },
              paddingTop(i, node) {
                return 2;
              },
              paddingBottom(i, node) {
                return 2;
              },
              fillColor(i, node) {
                return null;
              },
              fillOpacity(i, node) {
                return 1;
              },
              defaultBorder: true,
            };

            return pack(defaultLayout, layout);
          }

          function getOffsets(layout) {
            const offsets = [];
            let totalOffset = 0;
            let prevRightPadding = 0;

            for (let i = 0, l = node.table.widths.length; i < l; i++) {
              const lOffset = prevRightPadding + layout.vLineWidth(i, node) + layout.paddingLeft(i, node);
              offsets.push(lOffset);
              totalOffset += lOffset;
              prevRightPadding = layout.paddingRight(i, node);
            }

            totalOffset += prevRightPadding + layout.vLineWidth(node.table.widths.length, node);

            return {
              total: totalOffset,
              offsets,
            };
          }

          function extendWidthsForColSpans() {
            let q; let
              j;

            for (let i = 0, l = colSpans.length; i < l; i++) {
              const span = colSpans[i];

              const currentMinMax = getMinMax(span.col, span.span, node._offsets);
              const minDifference = span.minWidth - currentMinMax.minWidth;
              const maxDifference = span.maxWidth - currentMinMax.maxWidth;

              if (minDifference > 0) {
                q = minDifference / span.span;

                for (j = 0; j < span.span; j++) {
                  node.table.widths[span.col + j]._minWidth += q;
                }
              }

              if (maxDifference > 0) {
                q = maxDifference / span.span;

                for (j = 0; j < span.span; j++) {
                  node.table.widths[span.col + j]._maxWidth += q;
                }
              }
            }
          }

          function getMinMax(col, span, offsets) {
            const result = { minWidth: 0, maxWidth: 0 };

            for (let i = 0; i < span; i++) {
              result.minWidth += node.table.widths[col + i]._minWidth + (i ? offsets.offsets[col + i] : 0);
              result.maxWidth += node.table.widths[col + i]._maxWidth + (i ? offsets.offsets[col + i] : 0);
            }

            return result;
          }

          function markSpans(rowData, col, span) {
            for (let i = 1; i < span; i++) {
              rowData[col + i] = {
                _span: true,
                _minWidth: 0,
                _maxWidth: 0,
                rowSpan: rowData[col].rowSpan,
              };
            }
          }

          function markVSpans(table, row, col, span) {
            for (let i = 1; i < span; i++) {
              table.body[row + i][col] = {
                _span: true,
                _minWidth: 0,
                _maxWidth: 0,
                fillColor: table.body[row][col].fillColor,
                fillOpacity: table.body[row][col].fillOpacity,
              };
            }
          }

          function extendTableWidths(node) {
            if (!node.table.widths) {
              node.table.widths = 'auto';
            }

            if (isString(node.table.widths)) {
              node.table.widths = [node.table.widths];

              while (node.table.widths.length < node.table.body[0].length) {
                node.table.widths.push(node.table.widths[node.table.widths.length - 1]);
              }
            }

            for (let i = 0, l = node.table.widths.length; i < l; i++) {
              const w = node.table.widths[i];
              if (isNumber(w) || isString(w)) {
                node.table.widths[i] = { width: w };
              }
            }
          }
        };

        DocMeasure.prototype.measureCanvas = function (node) {
          let w = 0; let
            h = 0;

          for (let i = 0, l = node.canvas.length; i < l; i++) {
            const vector = node.canvas[i];

            switch (vector.type) {
              case 'ellipse':
                w = Math.max(w, vector.x + vector.r1);
                h = Math.max(h, vector.y + vector.r2);
                break;
              case 'rect':
                w = Math.max(w, vector.x + vector.w);
                h = Math.max(h, vector.y + vector.h);
                break;
              case 'line':
                w = Math.max(w, vector.x1, vector.x2);
                h = Math.max(h, vector.y1, vector.y2);
                break;
              case 'polyline':
                for (let i2 = 0, l2 = vector.points.length; i2 < l2; i2++) {
                  w = Math.max(w, vector.points[i2].x);
                  h = Math.max(h, vector.points[i2].y);
                }
                break;
            }
          }

          node._minWidth = node._maxWidth = w;
          node._minHeight = node._maxHeight = h;
          node._alignment = this.styleStack.getProperty('alignment');

          return node;
        };

        DocMeasure.prototype.measureQr = function (node) {
          node = qrEncoder.measure(node);
          node._alignment = this.styleStack.getProperty('alignment');
          return node;
        };

        module.exports = DocMeasure;
        /***/ }),

      /***/ 4889:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* provided dependency */ const { Buffer } = __webpack_require__(8823);

        const { isString } = __webpack_require__(6225);
        const { isNumber } = __webpack_require__(6225);
        const { isBoolean } = __webpack_require__(6225);
        const { isArray } = __webpack_require__(6225);
        const { isUndefined } = __webpack_require__(6225);
        const { fontStringify } = __webpack_require__(6225);

        function DocPreprocessor() {

        }

        DocPreprocessor.prototype.preprocessDocument = function (docStructure) {
          this.parentNode = null;
          this.tocs = [];
          this.nodeReferences = [];
          return this.preprocessNode(docStructure);
        };

        DocPreprocessor.prototype.preprocessNode = function (node) {
          // expand shortcuts and casting values
          if (isArray(node)) {
            node = { stack: node };
          } else if (isString(node)) {
            node = { text: node };
          } else if (isNumber(node) || isBoolean(node)) {
            node = { text: node.toString() };
          } else if (node === undefined || node === null) {
            node = { text: '' };
          } else if (Object.keys(node).length === 0) { // empty object
            node = { text: '' };
          } else if ('text' in node && (node.text === undefined || node.text === null)) {
            node.text = '';
          }

          if (node.columns) {
            return this.preprocessColumns(node);
          } if (node.stack) {
            return this.preprocessVerticalContainer(node);
          } if (node.ul) {
            return this.preprocessList(node);
          } if (node.ol) {
            return this.preprocessList(node);
          } if (node.table) {
            return this.preprocessTable(node);
          } if (node.text !== undefined) {
            return this.preprocessText(node);
          } if (node.toc) {
            return this.preprocessToc(node);
          } if (node.image) {
            return this.preprocessImage(node);
          } if (node.svg) {
            return this.preprocessSVG(node);
          } if (node.canvas) {
            return this.preprocessCanvas(node);
          } if (node.qr) {
            return this.preprocessQr(node);
          } if (node.pageReference || node.textReference) {
            return this.preprocessText(node);
          }
          throw `Unrecognized document structure: ${JSON.stringify(node, fontStringify)}`;
        };

        DocPreprocessor.prototype.preprocessColumns = function (node) {
          const { columns } = node;

          for (let i = 0, l = columns.length; i < l; i++) {
            columns[i] = this.preprocessNode(columns[i]);
          }

          return node;
        };

        DocPreprocessor.prototype.preprocessVerticalContainer = function (node) {
          const items = node.stack;

          for (let i = 0, l = items.length; i < l; i++) {
            items[i] = this.preprocessNode(items[i]);
          }

          return node;
        };

        DocPreprocessor.prototype.preprocessList = function (node) {
          const items = node.ul || node.ol;

          for (let i = 0, l = items.length; i < l; i++) {
            items[i] = this.preprocessNode(items[i]);
          }

          return node;
        };

        DocPreprocessor.prototype.preprocessTable = function (node) {
          let col; let row; let cols; let
            rows;

          for (col = 0, cols = node.table.body[0].length; col < cols; col++) {
            for (row = 0, rows = node.table.body.length; row < rows; row++) {
              const rowData = node.table.body[row];
              let data = rowData[col];
              if (data !== undefined) {
                if (data === null) { // transform to object
                  data = '';
                }
                if (!data._span) {
                  rowData[col] = this.preprocessNode(data);
                }
              }
            }
          }

          return node;
        };

        DocPreprocessor.prototype.preprocessText = function (node) {
          if (node.tocItem) {
            if (!isArray(node.tocItem)) {
              node.tocItem = [node.tocItem];
            }

            for (var i = 0, l = node.tocItem.length; i < l; i++) {
              if (!isString(node.tocItem[i])) {
                node.tocItem[i] = '_default_';
              }

              const tocItemId = node.tocItem[i];

              if (!this.tocs[tocItemId]) {
                this.tocs[tocItemId] = { toc: { _items: [], _pseudo: true } };
              }

              if (!node.id) {
                node.id = `toc-${tocItemId}-${this.tocs[tocItemId].toc._items.length}`;
              }

              const tocItemRef = {
                _nodeRef: this._getNodeForNodeRef(node),
                _textNodeRef: node,
              };
              this.tocs[tocItemId].toc._items.push(tocItemRef);
            }
          }

          if (node.id) {
            if (this.nodeReferences[node.id]) {
              if (!this.nodeReferences[node.id]._pseudo) {
                throw `Node id '${node.id}' already exists`;
              }

              this.nodeReferences[node.id]._nodeRef = this._getNodeForNodeRef(node);
              this.nodeReferences[node.id]._textNodeRef = node;
              this.nodeReferences[node.id]._pseudo = false;
            } else {
              this.nodeReferences[node.id] = {
                _nodeRef: this._getNodeForNodeRef(node),
                _textNodeRef: node,
              };
            }
          }

          if (node.pageReference) {
            if (!this.nodeReferences[node.pageReference]) {
              this.nodeReferences[node.pageReference] = {
                _nodeRef: {},
                _textNodeRef: {},
                _pseudo: true,
              };
            }
            node.text = '00000';
            node.linkToDestination = node.pageReference;
            node._pageRef = this.nodeReferences[node.pageReference];
          }

          if (node.textReference) {
            if (!this.nodeReferences[node.textReference]) {
              this.nodeReferences[node.textReference] = { _nodeRef: {}, _pseudo: true };
            }

            node.text = '';
            node.linkToDestination = node.textReference;
            node._textRef = this.nodeReferences[node.textReference];
          }

          if (node.text && node.text.text) {
            node.text = [this.preprocessNode(node.text)];
          } else if (isArray(node.text)) {
            let isSetParentNode = false;
            if (this.parentNode === null) {
              this.parentNode = node;
              isSetParentNode = true;
            }

            for (var i = 0, l = node.text.length; i < l; i++) {
              node.text[i] = this.preprocessNode(node.text[i]);
            }

            if (isSetParentNode) {
              this.parentNode = null;
            }
          }

          return node;
        };

        DocPreprocessor.prototype.preprocessToc = function (node) {
          if (!node.toc.id) {
            node.toc.id = '_default_';
          }

          node.toc.title = node.toc.title ? this.preprocessNode(node.toc.title) : null;
          node.toc._items = [];

          if (this.tocs[node.toc.id]) {
            if (!this.tocs[node.toc.id].toc._pseudo) {
              throw `TOC '${node.toc.id}' already exists`;
            }

            node.toc._items = this.tocs[node.toc.id].toc._items;
          }

          this.tocs[node.toc.id] = node;

          return node;
        };

        DocPreprocessor.prototype.preprocessImage = function (node) {
          if (!isUndefined(node.image.type) && !isUndefined(node.image.data) && (node.image.type === 'Buffer') && isArray(node.image.data)) {
            node.image = Buffer.from(node.image.data);
          }
          return node;
        };

        DocPreprocessor.prototype.preprocessSVG = function (node) {
          return node;
        };

        DocPreprocessor.prototype.preprocessCanvas = function (node) {
          return node;
        };

        DocPreprocessor.prototype.preprocessQr = function (node) {
          return node;
        };

        DocPreprocessor.prototype._getNodeForNodeRef = function (node) {
          if (this.parentNode) {
            return this.parentNode;
          }

          return node;
        };

        module.exports = DocPreprocessor;
        /***/ }),

      /***/ 3858:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const TraversalTracker = __webpack_require__(8537);
        const { isString } = __webpack_require__(6225);

        /**
 * Creates an instance of DocumentContext - a store for current x, y positions and available width/height.
 * It facilitates column divisions and vertical sync
 */
        function DocumentContext(pageSize, pageMargins) {
          this.pages = [];

          this.pageMargins = pageMargins;

          this.x = pageMargins.left;
          this.availableWidth = pageSize.width - pageMargins.left - pageMargins.right;
          this.availableHeight = 0;
          this.page = -1;

          this.snapshots = [];

          this.endingCell = null;

          this.tracker = new TraversalTracker();

          this.backgroundLength = [];

          this.addPage(pageSize);
        }

        DocumentContext.prototype.beginColumnGroup = function () {
          this.snapshots.push({
            x: this.x,
            y: this.y,
            availableHeight: this.availableHeight,
            availableWidth: this.availableWidth,
            page: this.page,
            bottomMost: {
              x: this.x,
              y: this.y,
              availableHeight: this.availableHeight,
              availableWidth: this.availableWidth,
              page: this.page,
            },
            endingCell: this.endingCell,
            lastColumnWidth: this.lastColumnWidth,
          });

          this.lastColumnWidth = 0;
        };

        DocumentContext.prototype.beginColumn = function (width, offset, endingCell) {
          const saved = this.snapshots[this.snapshots.length - 1];

          this.calculateBottomMost(saved);

          this.endingCell = endingCell;
          this.page = saved.page;
          this.x = this.x + this.lastColumnWidth + (offset || 0);
          this.y = saved.y;
          this.availableWidth = width;	// saved.availableWidth - offset;
          this.availableHeight = saved.availableHeight;

          this.lastColumnWidth = width;
        };

        DocumentContext.prototype.calculateBottomMost = function (destContext) {
          if (this.endingCell) {
            this.saveContextInEndingCell(this.endingCell);
            this.endingCell = null;
          } else {
            destContext.bottomMost = bottomMostContext(this, destContext.bottomMost);
          }
        };

        DocumentContext.prototype.markEnding = function (endingCell) {
          this.page = endingCell._columnEndingContext.page;
          this.x = endingCell._columnEndingContext.x;
          this.y = endingCell._columnEndingContext.y;
          this.availableWidth = endingCell._columnEndingContext.availableWidth;
          this.availableHeight = endingCell._columnEndingContext.availableHeight;
          this.lastColumnWidth = endingCell._columnEndingContext.lastColumnWidth;
        };

        DocumentContext.prototype.saveContextInEndingCell = function (endingCell) {
          endingCell._columnEndingContext = {
            page: this.page,
            x: this.x,
            y: this.y,
            availableHeight: this.availableHeight,
            availableWidth: this.availableWidth,
            lastColumnWidth: this.lastColumnWidth,
          };
        };

        DocumentContext.prototype.completeColumnGroup = function (height) {
          const saved = this.snapshots.pop();

          this.calculateBottomMost(saved);

          this.endingCell = null;
          this.x = saved.x;

          let { y } = saved.bottomMost;
          if (height) {
            if (saved.page === saved.bottomMost.page) {
              if ((saved.y + height) > y) {
                y = saved.y + height;
              }
            } else {
              y += height;
            }
          }

          this.y = y;
          this.page = saved.bottomMost.page;
          this.availableWidth = saved.availableWidth;
          this.availableHeight = saved.bottomMost.availableHeight;
          if (height) {
            this.availableHeight -= (y - saved.bottomMost.y);
          }
          this.lastColumnWidth = saved.lastColumnWidth;
        };

        DocumentContext.prototype.addMargin = function (left, right) {
          this.x += left;
          this.availableWidth -= left + (right || 0);
        };

        DocumentContext.prototype.moveDown = function (offset) {
          this.y += offset;
          this.availableHeight -= offset;

          return this.availableHeight > 0;
        };

        DocumentContext.prototype.initializePage = function () {
          this.y = this.pageMargins.top;
          this.availableHeight = this.getCurrentPage().pageSize.height - this.pageMargins.top - this.pageMargins.bottom;
          this.pageSnapshot().availableWidth = this.getCurrentPage().pageSize.width - this.pageMargins.left - this.pageMargins.right;
        };

        DocumentContext.prototype.pageSnapshot = function () {
          if (this.snapshots[0]) {
            return this.snapshots[0];
          }
          return this;
        };

        DocumentContext.prototype.moveTo = function (x, y) {
          if (x !== undefined && x !== null) {
            this.x = x;
            this.availableWidth = this.getCurrentPage().pageSize.width - this.x - this.pageMargins.right;
          }
          if (y !== undefined && y !== null) {
            this.y = y;
            this.availableHeight = this.getCurrentPage().pageSize.height - this.y - this.pageMargins.bottom;
          }
        };

        DocumentContext.prototype.moveToRelative = function (x, y) {
          if (x !== undefined && x !== null) {
            this.x += x;
          }
          if (y !== undefined && y !== null) {
            this.y += y;
          }
        };

        DocumentContext.prototype.beginDetachedBlock = function () {
          this.snapshots.push({
            x: this.x,
            y: this.y,
            availableHeight: this.availableHeight,
            availableWidth: this.availableWidth,
            page: this.page,
            endingCell: this.endingCell,
            lastColumnWidth: this.lastColumnWidth,
          });
        };

        DocumentContext.prototype.endDetachedBlock = function () {
          const saved = this.snapshots.pop();

          this.x = saved.x;
          this.y = saved.y;
          this.availableWidth = saved.availableWidth;
          this.availableHeight = saved.availableHeight;
          this.page = saved.page;
          this.endingCell = saved.endingCell;
          this.lastColumnWidth = saved.lastColumnWidth;
        };

        function pageOrientation(pageOrientationString, currentPageOrientation) {
          if (pageOrientationString === undefined) {
            return currentPageOrientation;
          } if (isString(pageOrientationString) && (pageOrientationString.toLowerCase() === 'landscape')) {
            return 'landscape';
          }
          return 'portrait';
        }

        const getPageSize = function (currentPage, newPageOrientation) {
          newPageOrientation = pageOrientation(newPageOrientation, currentPage.pageSize.orientation);

          if (newPageOrientation !== currentPage.pageSize.orientation) {
            return {
              orientation: newPageOrientation,
              width: currentPage.pageSize.height,
              height: currentPage.pageSize.width,
            };
          }
          return {
            orientation: currentPage.pageSize.orientation,
            width: currentPage.pageSize.width,
            height: currentPage.pageSize.height,
          };
        };

        DocumentContext.prototype.moveToNextPage = function (pageOrientation) {
          const nextPageIndex = this.page + 1;

          const prevPage = this.page;
          const prevY = this.y;

          const createNewPage = nextPageIndex >= this.pages.length;
          if (createNewPage) {
            const currentAvailableWidth = this.availableWidth;
            const currentPageOrientation = this.getCurrentPage().pageSize.orientation;

            const pageSize = getPageSize(this.getCurrentPage(), pageOrientation);
            this.addPage(pageSize);

            if (currentPageOrientation === pageSize.orientation) {
              this.availableWidth = currentAvailableWidth;
            }
          } else {
            this.page = nextPageIndex;
            this.initializePage();
          }

          return {
            newPageCreated: createNewPage,
            prevPage,
            prevY,
            y: this.y,
          };
        };

        DocumentContext.prototype.addPage = function (pageSize) {
          const page = { items: [], pageSize };
          this.pages.push(page);
          this.backgroundLength.push(0);
          this.page = this.pages.length - 1;
          this.initializePage();

          this.tracker.emit('pageAdded');

          return page;
        };

        DocumentContext.prototype.getCurrentPage = function () {
          if (this.page < 0 || this.page >= this.pages.length) {
            return null;
          }

          return this.pages[this.page];
        };

        DocumentContext.prototype.getCurrentPosition = function () {
          const { pageSize } = this.getCurrentPage();
          const innerHeight = pageSize.height - this.pageMargins.top - this.pageMargins.bottom;
          const innerWidth = pageSize.width - this.pageMargins.left - this.pageMargins.right;

          return {
            pageNumber: this.page + 1,
            pageOrientation: pageSize.orientation,
            pageInnerHeight: innerHeight,
            pageInnerWidth: innerWidth,
            left: this.x,
            top: this.y,
            verticalRatio: ((this.y - this.pageMargins.top) / innerHeight),
            horizontalRatio: ((this.x - this.pageMargins.left) / innerWidth),
          };
        };

        function bottomMostContext(c1, c2) {
          let r;

          if (c1.page > c2.page) {
            r = c1;
          } else if (c2.page > c1.page) {
            r = c2;
          } else {
            r = (c1.y > c2.y) ? c1 : c2;
          }

          return {
            page: r.page,
            x: r.x,
            y: r.y,
            availableHeight: r.availableHeight,
            availableWidth: r.availableWidth,
          };
        }

        module.exports = DocumentContext;
        /***/ }),

      /***/ 1196:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const Line = __webpack_require__(4775);
        const { isNumber } = __webpack_require__(6225);
        const { pack } = __webpack_require__(6225);
        const { offsetVector } = __webpack_require__(6225);
        const DocumentContext = __webpack_require__(3858);

        /**
 * Creates an instance of ElementWriter - a line/vector writer, which adds
 * elements to current page and sets their positions based on the context
 */
        function ElementWriter(context, tracker) {
          this.context = context;
          this.contextStack = [];
          this.tracker = tracker;
        }

        function addPageItem(page, item, index) {
          if (index === null || index === undefined || index < 0 || index > page.items.length) {
            page.items.push(item);
          } else {
            page.items.splice(index, 0, item);
          }
        }

        ElementWriter.prototype.addLine = function (line, dontUpdateContextPosition, index) {
          const height = line.getHeight();
          const { context } = this;
          const page = context.getCurrentPage();
          const position = this.getCurrentPositionOnPage();

          if (context.availableHeight < height || !page) {
            return false;
          }

          line.x = context.x + (line.x || 0);
          line.y = context.y + (line.y || 0);

          this.alignLine(line);

          addPageItem(page, {
            type: 'line',
            item: line,
          }, index);
          this.tracker.emit('lineAdded', line);

          if (!dontUpdateContextPosition) {
            context.moveDown(height);
          }

          return position;
        };

        ElementWriter.prototype.alignLine = function (line) {
          const width = this.context.availableWidth;
          const lineWidth = line.getWidth();

          const alignment = line.inlines && line.inlines.length > 0 && line.inlines[0].alignment;

          let offset = 0;
          switch (alignment) {
            case 'right':
              offset = width - lineWidth;
              break;
            case 'center':
              offset = (width - lineWidth) / 2;
              break;
          }

          if (offset) {
            line.x = (line.x || 0) + offset;
          }

          if (alignment === 'justify'
		&& !line.newLineForced
		&& !line.lastLineInParagraph
		&& line.inlines.length > 1) {
            const additionalSpacing = (width - lineWidth) / (line.inlines.length - 1);

            for (let i = 1, l = line.inlines.length; i < l; i++) {
              offset = i * additionalSpacing;

              line.inlines[i].x += offset;
              line.inlines[i].justifyShift = additionalSpacing;
            }
          }
        };

        ElementWriter.prototype.addImage = function (image, index, type) {
          const { context } = this;
          const page = context.getCurrentPage();
          const position = this.getCurrentPositionOnPage();

          if (!page || (image.absolutePosition === undefined && context.availableHeight < image._height && page.items.length > 0)) {
            return false;
          }

          if (image._x === undefined) {
            image._x = image.x || 0;
          }

          image.x = context.x + image._x;
          image.y = context.y;

          this.alignImage(image);

          addPageItem(page, {
            type: type || 'image',
            item: image,
          }, index);

          context.moveDown(image._height);

          return position;
        };

        ElementWriter.prototype.addSVG = function (image, index) {
          return this.addImage(image, index, 'svg');
        };

        ElementWriter.prototype.addQr = function (qr, index) {
          const { context } = this;
          const page = context.getCurrentPage();
          const position = this.getCurrentPositionOnPage();

          if (!page || (qr.absolutePosition === undefined && context.availableHeight < qr._height)) {
            return false;
          }

          if (qr._x === undefined) {
            qr._x = qr.x || 0;
          }

          qr.x = context.x + qr._x;
          qr.y = context.y;

          this.alignImage(qr);

          for (let i = 0, l = qr._canvas.length; i < l; i++) {
            const vector = qr._canvas[i];
            vector.x += qr.x;
            vector.y += qr.y;
            this.addVector(vector, true, true, index);
          }

          context.moveDown(qr._height);

          return position;
        };

        ElementWriter.prototype.alignImage = function (image) {
          const width = this.context.availableWidth;
          const imageWidth = image._minWidth;
          let offset = 0;
          switch (image._alignment) {
            case 'right':
              offset = width - imageWidth;
              break;
            case 'center':
              offset = (width - imageWidth) / 2;
              break;
          }

          if (offset) {
            image.x = (image.x || 0) + offset;
          }
        };

        ElementWriter.prototype.alignCanvas = function (node) {
          const width = this.context.availableWidth;
          const canvasWidth = node._minWidth;
          let offset = 0;
          switch (node._alignment) {
            case 'right':
              offset = width - canvasWidth;
              break;
            case 'center':
              offset = (width - canvasWidth) / 2;
              break;
          }
          if (offset) {
            node.canvas.forEach((vector) => {
              offsetVector(vector, offset, 0);
            });
          }
        };

        ElementWriter.prototype.addVector = function (vector, ignoreContextX, ignoreContextY, index) {
          const { context } = this;
          const page = context.getCurrentPage();
          const position = this.getCurrentPositionOnPage();

          if (page) {
            offsetVector(vector, ignoreContextX ? 0 : context.x, ignoreContextY ? 0 : context.y);
            addPageItem(page, {
              type: 'vector',
              item: vector,
            }, index);
            return position;
          }
        };

        ElementWriter.prototype.beginClip = function (width, height) {
          const ctx = this.context;
          const page = ctx.getCurrentPage();
          page.items.push({
            type: 'beginClip',
            item: {
              x: ctx.x, y: ctx.y, width, height,
            },
          });
          return true;
        };

        ElementWriter.prototype.endClip = function () {
          const ctx = this.context;
          const page = ctx.getCurrentPage();
          page.items.push({
            type: 'endClip',
          });
          return true;
        };

        function cloneLine(line) {
          const result = new Line(line.maxWidth);

          for (const key in line) {
            if (line.hasOwnProperty(key)) {
              result[key] = line[key];
            }
          }

          return result;
        }

        ElementWriter.prototype.addFragment = function (block, useBlockXOffset, useBlockYOffset, dontUpdateContextPosition) {
          const ctx = this.context;
          const page = ctx.getCurrentPage();

          if (!useBlockXOffset && block.height > ctx.availableHeight) {
            return false;
          }

          block.items.forEach((item) => {
            switch (item.type) {
              case 'line':
                var l = cloneLine(item.item);

                if (l._node) {
                  l._node.positions[0].pageNumber = ctx.page + 1;
                }
                l.x = (l.x || 0) + (useBlockXOffset ? (block.xOffset || 0) : ctx.x);
                l.y = (l.y || 0) + (useBlockYOffset ? (block.yOffset || 0) : ctx.y);

                page.items.push({
                  type: 'line',
                  item: l,
                });
                break;

              case 'vector':
                var v = pack(item.item);

                offsetVector(v, useBlockXOffset ? (block.xOffset || 0) : ctx.x, useBlockYOffset ? (block.yOffset || 0) : ctx.y);
                page.items.push({
                  type: 'vector',
                  item: v,
                });
                break;

              case 'image':
              case 'svg':
                var img = pack(item.item);

                img.x = (img.x || 0) + (useBlockXOffset ? (block.xOffset || 0) : ctx.x);
                img.y = (img.y || 0) + (useBlockYOffset ? (block.yOffset || 0) : ctx.y);

                page.items.push({
                  type: item.type,
                  item: img,
                });
                break;
            }
          });

          if (!dontUpdateContextPosition) {
            ctx.moveDown(block.height);
          }

          return true;
        };

        /**
 * Pushes the provided context onto the stack or creates a new one
 *
 * pushContext(context) - pushes the provided context and makes it current
 * pushContext(width, height) - creates and pushes a new context with the specified width and height
 * pushContext() - creates a new context for unbreakable blocks (with current availableWidth and full-page-height)
 */
        ElementWriter.prototype.pushContext = function (contextOrWidth, height) {
          if (contextOrWidth === undefined) {
            height = this.context.getCurrentPage().height - this.context.pageMargins.top - this.context.pageMargins.bottom;
            contextOrWidth = this.context.availableWidth;
          }

          if (isNumber(contextOrWidth)) {
            contextOrWidth = new DocumentContext({ width: contextOrWidth, height }, {
              left: 0, right: 0, top: 0, bottom: 0,
            });
          }

          this.contextStack.push(this.context);
          this.context = contextOrWidth;
        };

        ElementWriter.prototype.popContext = function () {
          this.context = this.contextStack.pop();
        };

        ElementWriter.prototype.getCurrentPositionOnPage = function () {
          return (this.contextStack[0] || this.context).getCurrentPosition();
        };

        module.exports = ElementWriter;
        /***/ }),

      /***/ 2249:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const { isArray } = __webpack_require__(6225);

        function typeName(bold, italics) {
          let type = 'normal';
          if (bold && italics) {
            type = 'bolditalics';
          } else if (bold) {
            type = 'bold';
          } else if (italics) {
            type = 'italics';
          }
          return type;
        }

        function FontProvider(fontDescriptors, pdfKitDoc) {
          this.fonts = {};
          this.pdfKitDoc = pdfKitDoc;
          this.fontCache = {};

          for (const font in fontDescriptors) {
            if (fontDescriptors.hasOwnProperty(font)) {
              const fontDef = fontDescriptors[font];

              this.fonts[font] = {
                normal: fontDef.normal,
                bold: fontDef.bold,
                italics: fontDef.italics,
                bolditalics: fontDef.bolditalics,
              };
            }
          }
        }

        FontProvider.prototype.getFontType = function (bold, italics) {
          return typeName(bold, italics);
        };

        FontProvider.prototype.getFontFile = function (familyName, bold, italics) {
          const type = this.getFontType(bold, italics);
          if (!this.fonts[familyName] || !this.fonts[familyName][type]) {
            return null;
          }

          return this.fonts[familyName][type];
        };

        FontProvider.prototype.provideFont = function (familyName, bold, italics) {
          const type = this.getFontType(bold, italics);
          if (this.getFontFile(familyName, bold, italics) === null) {
            throw new Error(`Font '${familyName}' in style '${type}' is not defined in the font section of the document definition.`);
          }

          this.fontCache[familyName] = this.fontCache[familyName] || {};

          if (!this.fontCache[familyName][type]) {
            let def = this.fonts[familyName][type];
            if (!isArray(def)) {
              def = [def];
            }
            this.fontCache[familyName][type] = this.pdfKitDoc.font.apply(this.pdfKitDoc, def)._font;
          }

          return this.fontCache[familyName][type];
        };

        module.exports = FontProvider;
        /***/ }),

      /***/ 6225:
      /***/ (function (module) {
        function isString(variable) {
          return typeof variable === 'string' || variable instanceof String;
        }

        function isNumber(variable) {
          return typeof variable === 'number' || variable instanceof Number;
        }

        function isBoolean(variable) {
          return typeof variable === 'boolean';
        }

        function isArray(variable) {
          return Array.isArray(variable);
        }

        function isFunction(variable) {
          return typeof variable === 'function';
        }

        function isObject(variable) {
          return variable !== null && typeof variable === 'object';
        }

        function isNull(variable) {
          return variable === null;
        }

        function isUndefined(variable) {
          return variable === undefined;
        }

        function pack() {
          const result = {};

          for (let i = 0, l = arguments.length; i < l; i++) {
            const obj = arguments[i];

            if (obj) {
              for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                  result[key] = obj[key];
                }
              }
            }
          }

          return result;
        }

        function offsetVector(vector, x, y) {
          switch (vector.type) {
            case 'ellipse':
            case 'rect':
              vector.x += x;
              vector.y += y;
              break;
            case 'line':
              vector.x1 += x;
              vector.x2 += x;
              vector.y1 += y;
              vector.y2 += y;
              break;
            case 'polyline':
              for (let i = 0, l = vector.points.length; i < l; i++) {
                vector.points[i].x += x;
                vector.points[i].y += y;
              }
              break;
          }
        }

        function fontStringify(key, val) {
          if (key === 'font') {
            return 'font';
          }
          return val;
        }

        function getNodeId(node) {
          if (node.id) {
            return node.id;
          }

          if (isArray(node.text)) {
            for (let i = 0, l = node.text.length; i < l; i++) {
              const n = node.text[i];
              const nodeId = getNodeId(n);
              if (nodeId) {
                return nodeId;
              }
            }
          }

          return null;
        }

        function isPattern(color) {
          return isArray(color) && color.length === 2;
        }

        // converts from a [<pattern name>, <color>] as used by pdfmake
        // into [<pattern object>, <color>] as used by pdfkit
        // (the pattern has to be registered in the doc definition of course)
        function getPattern(color, patterns) {
          return [patterns[color[0]], color[1]];
        }

        module.exports = {
          isString,
          isNumber,
          isBoolean,
          isArray,
          isFunction,
          isObject,
          isNull,
          isUndefined,
          pack,
          fontStringify,
          offsetVector,
          getNodeId,
          isPattern,
          getPattern,
        };
        /***/ }),

      /***/ 3090:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* provided dependency */ const { Buffer } = __webpack_require__(8823);

        const fs = __webpack_require__(3857);

        function ImageMeasure(pdfKitDoc, imageDictionary) {
          this.pdfKitDoc = pdfKitDoc;
          this.imageDictionary = imageDictionary || {};
        }

        ImageMeasure.prototype.measureImage = function (src) {
          let image;
          const that = this;

          if (!this.pdfKitDoc._imageRegistry[src]) {
            try {
              image = this.pdfKitDoc.openImage(realImageSrc(src));
              if (!image) {
                throw 'No image';
              }
            } catch (error) {
              throw `Invalid image: ${error.toString()}\nImages dictionary should contain dataURL entries (or local file paths in node.js)`;
            }
            image.embed(this.pdfKitDoc);
            this.pdfKitDoc._imageRegistry[src] = image;
          } else {
            image = this.pdfKitDoc._imageRegistry[src];
          }

          return { width: image.width, height: image.height };

          function realImageSrc(src) {
            const img = that.imageDictionary[src];

            if (!img) {
              return src;
            }

            if (fs.existsSync(img)) {
              return fs.readFileSync(img);
            }

            const index = img.indexOf('base64,');
            if (index < 0) {
              return that.imageDictionary[src];
            }

            return Buffer.from(img.substring(index + 7), 'base64');
          }
        };

        module.exports = ImageMeasure;
        /***/ }),

      /***/ 2678:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const TraversalTracker = __webpack_require__(8537);
        const DocPreprocessor = __webpack_require__(4889);
        const DocMeasure = __webpack_require__(1728);
        const DocumentContext = __webpack_require__(3858);
        const PageElementWriter = __webpack_require__(2912);
        const ColumnCalculator = __webpack_require__(4498);
        const TableProcessor = __webpack_require__(9342);
        const Line = __webpack_require__(4775);
        const { isString } = __webpack_require__(6225);
        const { isArray } = __webpack_require__(6225);
        const { isUndefined } = __webpack_require__(6225);
        const { isNull } = __webpack_require__(6225);
        const { pack } = __webpack_require__(6225);
        const { offsetVector } = __webpack_require__(6225);
        const { fontStringify } = __webpack_require__(6225);
        const { getNodeId } = __webpack_require__(6225);
        const { isFunction } = __webpack_require__(6225);
        const TextTools = __webpack_require__(1350);
        const StyleContextStack = __webpack_require__(7597);
        const { isNumber } = __webpack_require__(6225);

        function addAll(target, otherArray) {
          otherArray.forEach((item) => {
            target.push(item);
          });
        }

        /**
 * Creates an instance of LayoutBuilder - layout engine which turns document-definition-object
 * into a set of pages, lines, inlines and vectors ready to be rendered into a PDF
 *
 * @param {Object} pageSize - an object defining page width and height
 * @param {Object} pageMargins - an object defining top, left, right and bottom margins
 */
        function LayoutBuilder(pageSize, pageMargins, imageMeasure, svgMeasure) {
          this.pageSize = pageSize;
          this.pageMargins = pageMargins;
          this.tracker = new TraversalTracker();
          this.imageMeasure = imageMeasure;
          this.svgMeasure = svgMeasure;
          this.tableLayouts = {};
        }

        LayoutBuilder.prototype.registerTableLayouts = function (tableLayouts) {
          this.tableLayouts = pack(this.tableLayouts, tableLayouts);
        };

        /**
 * Executes layout engine on document-definition-object and creates an array of pages
 * containing positioned Blocks, Lines and inlines
 *
 * @param {Object} docStructure document-definition-object
 * @param {Object} fontProvider font provider
 * @param {Object} styleDictionary dictionary with style definitions
 * @param {Object} defaultStyle default style definition
 * @return {Array} an array of pages
 */
        LayoutBuilder.prototype.layoutDocument = function (docStructure, fontProvider, styleDictionary, defaultStyle, background, header, footer, images, watermark, pageBreakBeforeFct) {
          function addPageBreaksIfNecessary(linearNodeList, pages) {
            if (!isFunction(pageBreakBeforeFct)) {
              return false;
            }

            linearNodeList = linearNodeList.filter((node) => node.positions.length > 0);

            linearNodeList.forEach((node) => {
              const nodeInfo = {};
              [
                'id', 'text', 'ul', 'ol', 'table', 'image', 'qr', 'canvas', 'svg', 'columns',
                'headlineLevel', 'style', 'pageBreak', 'pageOrientation',
                'width', 'height',
              ].forEach((key) => {
                if (node[key] !== undefined) {
                  nodeInfo[key] = node[key];
                }
              });
              nodeInfo.startPosition = node.positions[0];
              nodeInfo.pageNumbers = Array.from(new Set(node.positions.map((node) => node.pageNumber)));
              nodeInfo.pages = pages.length;
              nodeInfo.stack = isArray(node.stack);

              node.nodeInfo = nodeInfo;
            });

            for (let index = 0; index < linearNodeList.length; index++) {
              const node = linearNodeList[index];
              if (node.pageBreak !== 'before' && !node.pageBreakCalculated) {
                node.pageBreakCalculated = true;
                const pageNumber = node.nodeInfo.pageNumbers[0];
                const followingNodesOnPage = [];
                const nodesOnNextPage = [];
                const previousNodesOnPage = [];
                if (pageBreakBeforeFct.length > 1) {
                  for (var ii = index + 1, l = linearNodeList.length; ii < l; ii++) {
                    if (linearNodeList[ii].nodeInfo.pageNumbers.indexOf(pageNumber) > -1) {
                      followingNodesOnPage.push(linearNodeList[ii].nodeInfo);
                    }
                    if (pageBreakBeforeFct.length > 2 && linearNodeList[ii].nodeInfo.pageNumbers.indexOf(pageNumber + 1) > -1) {
                      nodesOnNextPage.push(linearNodeList[ii].nodeInfo);
                    }
                  }
                }
                if (pageBreakBeforeFct.length > 3) {
                  for (var ii = 0; ii < index; ii++) {
                    if (linearNodeList[ii].nodeInfo.pageNumbers.indexOf(pageNumber) > -1) {
                      previousNodesOnPage.push(linearNodeList[ii].nodeInfo);
                    }
                  }
                }
                if (pageBreakBeforeFct(node.nodeInfo, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage)) {
                  node.pageBreak = 'before';
                  return true;
                }
              }
            }

            return false;
          }

          this.docPreprocessor = new DocPreprocessor();
          this.docMeasure = new DocMeasure(fontProvider, styleDictionary, defaultStyle, this.imageMeasure, this.svgMeasure, this.tableLayouts, images);

          function resetXYs(result) {
            result.linearNodeList.forEach((node) => {
              node.resetXY();
            });
          }

          let result = this.tryLayoutDocument(docStructure, fontProvider, styleDictionary, defaultStyle, background, header, footer, images, watermark);
          while (addPageBreaksIfNecessary(result.linearNodeList, result.pages)) {
            resetXYs(result);
            result = this.tryLayoutDocument(docStructure, fontProvider, styleDictionary, defaultStyle, background, header, footer, images, watermark);
          }

          return result.pages;
        };

        LayoutBuilder.prototype.tryLayoutDocument = function (docStructure, fontProvider, styleDictionary, defaultStyle, background, header, footer, images, watermark, pageBreakBeforeFct) {
          this.linearNodeList = [];
          docStructure = this.docPreprocessor.preprocessDocument(docStructure);
          docStructure = this.docMeasure.measureDocument(docStructure);

          this.writer = new PageElementWriter(
            new DocumentContext(this.pageSize, this.pageMargins), this.tracker,
          );

          const _this = this;
          this.writer.context().tracker.startTracking('pageAdded', () => {
            _this.addBackground(background);
          });

          this.addBackground(background);
          this.processNode(docStructure);
          this.addHeadersAndFooters(header, footer);
          if (watermark != null) {
            this.addWatermark(watermark, fontProvider, defaultStyle);
          }

          return { pages: this.writer.context().pages, linearNodeList: this.linearNodeList };
        };

        LayoutBuilder.prototype.addBackground = function (background) {
          const backgroundGetter = isFunction(background) ? background : function () {
            return background;
          };

          const context = this.writer.context();
          const { pageSize } = context.getCurrentPage();

          let pageBackground = backgroundGetter(context.page + 1, pageSize);

          if (pageBackground) {
            this.writer.beginUnbreakableBlock(pageSize.width, pageSize.height);
            pageBackground = this.docPreprocessor.preprocessDocument(pageBackground);
            this.processNode(this.docMeasure.measureDocument(pageBackground));
            this.writer.commitUnbreakableBlock(0, 0);
            context.backgroundLength[context.page] += pageBackground.positions.length;
          }
        };

        LayoutBuilder.prototype.addStaticRepeatable = function (headerOrFooter, sizeFunction) {
          this.addDynamicRepeatable(() => JSON.parse(JSON.stringify(headerOrFooter)), // copy to new object
	 sizeFunction);
        };

        LayoutBuilder.prototype.addDynamicRepeatable = function (nodeGetter, sizeFunction) {
          const { pages } = this.writer.context();

          for (let pageIndex = 0, l = pages.length; pageIndex < l; pageIndex++) {
            this.writer.context().page = pageIndex;

            let node = nodeGetter(pageIndex + 1, l, this.writer.context().pages[pageIndex].pageSize);

            if (node) {
              const sizes = sizeFunction(this.writer.context().getCurrentPage().pageSize, this.pageMargins);
              this.writer.beginUnbreakableBlock(sizes.width, sizes.height);
              node = this.docPreprocessor.preprocessDocument(node);
              this.processNode(this.docMeasure.measureDocument(node));
              this.writer.commitUnbreakableBlock(sizes.x, sizes.y);
            }
          }
        };

        LayoutBuilder.prototype.addHeadersAndFooters = function (header, footer) {
          const headerSizeFct = function (pageSize, pageMargins) {
            return {
              x: 0,
              y: 0,
              width: pageSize.width,
              height: pageMargins.top,
            };
          };

          const footerSizeFct = function (pageSize, pageMargins) {
            return {
              x: 0,
              y: pageSize.height - pageMargins.bottom,
              width: pageSize.width,
              height: pageMargins.bottom,
            };
          };

          if (isFunction(header)) {
            this.addDynamicRepeatable(header, headerSizeFct);
          } else if (header) {
            this.addStaticRepeatable(header, headerSizeFct);
          }

          if (isFunction(footer)) {
            this.addDynamicRepeatable(footer, footerSizeFct);
          } else if (footer) {
            this.addStaticRepeatable(footer, footerSizeFct);
          }
        };

        LayoutBuilder.prototype.addWatermark = function (watermark, fontProvider, defaultStyle) {
          if (isString(watermark)) {
            watermark = { text: watermark };
          }

          if (!watermark.text) { // empty watermark text
            return;
          }

          watermark.font = watermark.font || defaultStyle.font || 'Roboto';
          watermark.fontSize = watermark.fontSize || 'auto';
          watermark.color = watermark.color || 'black';
          watermark.opacity = isNumber(watermark.opacity) ? watermark.opacity : 0.6;
          watermark.bold = watermark.bold || false;
          watermark.italics = watermark.italics || false;
          watermark.angle = !isUndefined(watermark.angle) && !isNull(watermark.angle) ? watermark.angle : null;

          if (watermark.angle === null) {
            watermark.angle = Math.atan2(this.pageSize.height, this.pageSize.width) * -180 / Math.PI;
          }

          if (watermark.fontSize === 'auto') {
            watermark.fontSize = getWatermarkFontSize(this.pageSize, watermark, fontProvider);
          }

          const watermarkObject = {
            text: watermark.text,
            font: fontProvider.provideFont(watermark.font, watermark.bold, watermark.italics),
            fontSize: watermark.fontSize,
            color: watermark.color,
            opacity: watermark.opacity,
            angle: watermark.angle,
          };

          watermarkObject._size = getWatermarkSize(watermark, fontProvider);

          const { pages } = this.writer.context();
          for (let i = 0, l = pages.length; i < l; i++) {
            pages[i].watermark = watermarkObject;
          }

          function getWatermarkSize(watermark, fontProvider) {
            const textTools = new TextTools(fontProvider);
            const styleContextStack = new StyleContextStack(null, { font: watermark.font, bold: watermark.bold, italics: watermark.italics });

            styleContextStack.push({
              fontSize: watermark.fontSize,
            });

            const size = textTools.sizeOfString(watermark.text, styleContextStack);
            const rotatedSize = textTools.sizeOfRotatedText(watermark.text, watermark.angle, styleContextStack);

            return { size, rotatedSize };
          }

          function getWatermarkFontSize(pageSize, watermark, fontProvider) {
            const textTools = new TextTools(fontProvider);
            const styleContextStack = new StyleContextStack(null, { font: watermark.font, bold: watermark.bold, italics: watermark.italics });
            let rotatedSize;

            /**
		 * Binary search the best font size.
		 * Initial bounds [0, 1000]
		 * Break when range < 1
		 */
            let a = 0;
            let b = 1000;
            let c = (a + b) / 2;
            while (Math.abs(a - b) > 1) {
              styleContextStack.push({
                fontSize: c,
              });
              rotatedSize = textTools.sizeOfRotatedText(watermark.text, watermark.angle, styleContextStack);
              if (rotatedSize.width > pageSize.width) {
                b = c;
                c = (a + b) / 2;
              } else if (rotatedSize.width < pageSize.width) {
                if (rotatedSize.height > pageSize.height) {
                  b = c;
                  c = (a + b) / 2;
                } else {
                  a = c;
                  c = (a + b) / 2;
                }
              }
              styleContextStack.pop();
            }
            /*
		 End binary search
		 */
            return c;
          }
        };

        function decorateNode(node) {
          const { x } = node;
          const { y } = node;
          node.positions = [];

          if (isArray(node.canvas)) {
            node.canvas.forEach((vector) => {
              const { x } = vector;
              const { y } = vector;
              const { x1 } = vector;
              const { y1 } = vector;
              const { x2 } = vector;
              const { y2 } = vector;
              vector.resetXY = function () {
                vector.x = x;
                vector.y = y;
                vector.x1 = x1;
                vector.y1 = y1;
                vector.x2 = x2;
                vector.y2 = y2;
              };
            });
          }

          node.resetXY = function () {
            node.x = x;
            node.y = y;
            if (isArray(node.canvas)) {
              node.canvas.forEach((vector) => {
                vector.resetXY();
              });
            }
          };
        }

        LayoutBuilder.prototype.processNode = function (node) {
          const self = this;

          this.linearNodeList.push(node);
          decorateNode(node);

          applyMargins(() => {
            const { unbreakable } = node;
            if (unbreakable) {
              self.writer.beginUnbreakableBlock();
            }

            const absPosition = node.absolutePosition;
            if (absPosition) {
              self.writer.context().beginDetachedBlock();
              self.writer.context().moveTo(absPosition.x || 0, absPosition.y || 0);
            }

            const relPosition = node.relativePosition;
            if (relPosition) {
              self.writer.context().beginDetachedBlock();
              self.writer.context().moveToRelative(relPosition.x || 0, relPosition.y || 0);
            }

            if (node.stack) {
              self.processVerticalContainer(node);
            } else if (node.columns) {
              self.processColumns(node);
            } else if (node.ul) {
              self.processList(false, node);
            } else if (node.ol) {
              self.processList(true, node);
            } else if (node.table) {
              self.processTable(node);
            } else if (node.text !== undefined) {
              self.processLeaf(node);
            } else if (node.toc) {
              self.processToc(node);
            } else if (node.image) {
              self.processImage(node);
            } else if (node.svg) {
              self.processSVG(node);
            } else if (node.canvas) {
              self.processCanvas(node);
            } else if (node.qr) {
              self.processQr(node);
            } else if (!node._span) {
              throw `Unrecognized document structure: ${JSON.stringify(node, fontStringify)}`;
            }

            if (absPosition || relPosition) {
              self.writer.context().endDetachedBlock();
            }

            if (unbreakable) {
              self.writer.commitUnbreakableBlock();
            }
          });

          function applyMargins(callback) {
            const margin = node._margin;

            if (node.pageBreak === 'before') {
              self.writer.moveToNextPage(node.pageOrientation);
            } else if (node.pageBreak === 'beforeOdd') {
              self.writer.moveToNextPage(node.pageOrientation);
              if ((self.writer.context().page + 1) % 2 === 1) {
                self.writer.moveToNextPage(node.pageOrientation);
              }
            } else if (node.pageBreak === 'beforeEven') {
              self.writer.moveToNextPage(node.pageOrientation);
              if ((self.writer.context().page + 1) % 2 === 0) {
                self.writer.moveToNextPage(node.pageOrientation);
              }
            }

            if (margin) {
              self.writer.context().moveDown(margin[1]);
              self.writer.context().addMargin(margin[0], margin[2]);
            }

            callback();

            if (margin) {
              self.writer.context().addMargin(-margin[0], -margin[2]);
              self.writer.context().moveDown(margin[3]);
            }

            if (node.pageBreak === 'after') {
              self.writer.moveToNextPage(node.pageOrientation);
            } else if (node.pageBreak === 'afterOdd') {
              self.writer.moveToNextPage(node.pageOrientation);
              if ((self.writer.context().page + 1) % 2 === 1) {
                self.writer.moveToNextPage(node.pageOrientation);
              }
            } else if (node.pageBreak === 'afterEven') {
              self.writer.moveToNextPage(node.pageOrientation);
              if ((self.writer.context().page + 1) % 2 === 0) {
                self.writer.moveToNextPage(node.pageOrientation);
              }
            }
          }
        };

        // vertical container
        LayoutBuilder.prototype.processVerticalContainer = function (node) {
          const self = this;
          node.stack.forEach((item) => {
            self.processNode(item);
            addAll(node.positions, item.positions);

            // TODO: paragraph gap
          });
        };

        // columns
        LayoutBuilder.prototype.processColumns = function (columnNode) {
          const { columns } = columnNode;
          let { availableWidth } = this.writer.context();
          const gaps = gapArray(columnNode._gap);

          if (gaps) {
            availableWidth -= (gaps.length - 1) * columnNode._gap;
          }

          ColumnCalculator.buildColumnWidths(columns, availableWidth);
          const result = this.processRow(columns, columns, gaps);
          addAll(columnNode.positions, result.positions);

          function gapArray(gap) {
            if (!gap) {
              return null;
            }

            const gaps = [];
            gaps.push(0);

            for (let i = columns.length - 1; i > 0; i--) {
              gaps.push(gap);
            }

            return gaps;
          }
        };

        LayoutBuilder.prototype.processRow = function (columns, widths, gaps, tableBody, tableRow, height) {
          const self = this;
          const pageBreaks = []; const
            positions = [];

          this.tracker.auto('pageChanged', storePageBreakData, () => {
            widths = widths || columns;

            self.writer.context().beginColumnGroup();

            for (let i = 0, l = columns.length; i < l; i++) {
              const column = columns[i];
              let width = widths[i]._calcWidth;
              const leftOffset = colLeftOffset(i);

              if (column.colSpan && column.colSpan > 1) {
                for (let j = 1; j < column.colSpan; j++) {
                  width += widths[++i]._calcWidth + gaps[i];
                }
              }

              self.writer.context().beginColumn(width, leftOffset, getEndingCell(column, i));
              if (!column._span) {
                self.processNode(column);
                addAll(positions, column.positions);
              } else if (column._columnEndingContext) {
                // row-span ending
                self.writer.context().markEnding(column);
              }
            }

            self.writer.context().completeColumnGroup(height);
          });

          return { pageBreaks, positions };

          function storePageBreakData(data) {
            let pageDesc;

            for (let i = 0, l = pageBreaks.length; i < l; i++) {
              const desc = pageBreaks[i];
              if (desc.prevPage === data.prevPage) {
                pageDesc = desc;
                break;
              }
            }

            if (!pageDesc) {
              pageDesc = data;
              pageBreaks.push(pageDesc);
            }
            pageDesc.prevY = Math.max(pageDesc.prevY, data.prevY);
            pageDesc.y = Math.min(pageDesc.y, data.y);
          }

          function colLeftOffset(i) {
            if (gaps && gaps.length > i) {
              return gaps[i];
            }
            return 0;
          }

          function getEndingCell(column, columnIndex) {
            if (column.rowSpan && column.rowSpan > 1) {
              const endingRow = tableRow + column.rowSpan - 1;
              if (endingRow >= tableBody.length) {
                throw `Row span for column ${columnIndex} (with indexes starting from 0) exceeded row count`;
              }
              return tableBody[endingRow][columnIndex];
            }

            return null;
          }
        };

        // lists
        LayoutBuilder.prototype.processList = function (orderedList, node) {
          const self = this;
          const items = orderedList ? node.ol : node.ul;
          const gapSize = node._gapSize;

          this.writer.context().addMargin(gapSize.width);

          let nextMarker;
          this.tracker.auto('lineAdded', addMarkerToFirstLeaf, () => {
            items.forEach((item) => {
              nextMarker = item.listMarker;
              self.processNode(item);
              addAll(node.positions, item.positions);
            });
          });

          this.writer.context().addMargin(-gapSize.width);

          function addMarkerToFirstLeaf(line) {
            // I'm not very happy with the way list processing is implemented
            // (both code and algorithm should be rethinked)
            if (nextMarker) {
              const marker = nextMarker;
              nextMarker = null;

              if (marker.canvas) {
                const vector = marker.canvas[0];

                offsetVector(vector, -marker._minWidth, 0);
                self.writer.addVector(vector);
              } else if (marker._inlines) {
                const markerLine = new Line(self.pageSize.width);
                markerLine.addInline(marker._inlines[0]);
                markerLine.x = -marker._minWidth;
                markerLine.y = line.getAscenderHeight() - markerLine.getAscenderHeight();
                self.writer.addLine(markerLine, true);
              }
            }
          }
        };

        // tables
        LayoutBuilder.prototype.processTable = function (tableNode) {
          const processor = new TableProcessor(tableNode);

          processor.beginTable(this.writer);

          const rowHeights = tableNode.table.heights;
          for (let i = 0, l = tableNode.table.body.length; i < l; i++) {
            processor.beginRow(i, this.writer);

            var height;
            if (isFunction(rowHeights)) {
              height = rowHeights(i);
            } else if (isArray(rowHeights)) {
              height = rowHeights[i];
            } else {
              height = rowHeights;
            }

            if (height === 'auto') {
              height = undefined;
            }

            const result = this.processRow(tableNode.table.body[i], tableNode.table.widths, tableNode._offsets.offsets, tableNode.table.body, i, height);
            addAll(tableNode.positions, result.positions);

            processor.endRow(i, this.writer, result.pageBreaks);
          }

          processor.endTable(this.writer);
        };

        // leafs (texts)
        LayoutBuilder.prototype.processLeaf = function (node) {
          let line = this.buildNextLine(node);
          if (line && (node.tocItem || node.id)) {
            line._node = node;
          }
          let currentHeight = (line) ? line.getHeight() : 0;
          const maxHeight = node.maxHeight || -1;

          if (line) {
            const nodeId = getNodeId(node);
            if (nodeId) {
              line.id = nodeId;
            }
          }

          if (node._tocItemRef) {
            line._pageNodeRef = node._tocItemRef;
          }

          if (node._pageRef) {
            line._pageNodeRef = node._pageRef._nodeRef;
          }

          if (line && line.inlines && isArray(line.inlines)) {
            for (let i = 0, l = line.inlines.length; i < l; i++) {
              if (line.inlines[i]._tocItemRef) {
                line.inlines[i]._pageNodeRef = line.inlines[i]._tocItemRef;
              }

              if (line.inlines[i]._pageRef) {
                line.inlines[i]._pageNodeRef = line.inlines[i]._pageRef._nodeRef;
              }
            }
          }

          while (line && (maxHeight === -1 || currentHeight < maxHeight)) {
            const positions = this.writer.addLine(line);
            node.positions.push(positions);
            line = this.buildNextLine(node);
            if (line) {
              currentHeight += line.getHeight();
            }
          }
        };

        LayoutBuilder.prototype.processToc = function (node) {
          if (node.toc.title) {
            this.processNode(node.toc.title);
          }
          if (node.toc._table) {
            this.processNode(node.toc._table);
          }
        };

        LayoutBuilder.prototype.buildNextLine = function (textNode) {
          function cloneInline(inline) {
            const newInline = inline.constructor();
            for (const key in inline) {
              newInline[key] = inline[key];
            }
            return newInline;
          }

          if (!textNode._inlines || textNode._inlines.length === 0) {
            return null;
          }

          const line = new Line(this.writer.context().availableWidth);
          const textTools = new TextTools(null);

          let isForceContinue = false;
          while (textNode._inlines && textNode._inlines.length > 0
		&& (line.hasEnoughSpaceForInline(textNode._inlines[0], textNode._inlines.slice(1)) || isForceContinue)) {
            let isHardWrap = false;
            const inline = textNode._inlines.shift();
            isForceContinue = false;

            if (!inline.noWrap && inline.text.length > 1 && inline.width > line.getAvailableWidth()) {
              const widthPerChar = inline.width / inline.text.length;
              let maxChars = Math.floor(line.getAvailableWidth() / widthPerChar);
              if (maxChars < 1) {
                maxChars = 1;
              }
              if (maxChars < inline.text.length) {
                const newInline = cloneInline(inline);

                newInline.text = inline.text.substr(maxChars);
                inline.text = inline.text.substr(0, maxChars);

                newInline.width = textTools.widthOfString(newInline.text, newInline.font, newInline.fontSize, newInline.characterSpacing, newInline.fontFeatures);
                inline.width = textTools.widthOfString(inline.text, inline.font, inline.fontSize, inline.characterSpacing, inline.fontFeatures);

                textNode._inlines.unshift(newInline);
                isHardWrap = true;
              }
            }

            line.addInline(inline);

            isForceContinue = inline.noNewLine && !isHardWrap;
          }

          line.lastLineInParagraph = textNode._inlines.length === 0;

          return line;
        };

        // images
        LayoutBuilder.prototype.processImage = function (node) {
          const position = this.writer.addImage(node);
          node.positions.push(position);
        };

        LayoutBuilder.prototype.processSVG = function (node) {
          const position = this.writer.addSVG(node);
          node.positions.push(position);
        };

        LayoutBuilder.prototype.processCanvas = function (node) {
          const height = node._minHeight;

          if (node.absolutePosition === undefined && this.writer.context().availableHeight < height) {
            // TODO: support for canvas larger than a page
            // TODO: support for other overflow methods

            this.writer.moveToNextPage();
          }

          this.writer.alignCanvas(node);

          node.canvas.forEach(function (vector) {
            const position = this.writer.addVector(vector);
            node.positions.push(position);
          }, this);

          this.writer.context().moveDown(height);
        };

        LayoutBuilder.prototype.processQr = function (node) {
          const position = this.writer.addQr(node);
          node.positions.push(position);
        };

        module.exports = LayoutBuilder;
        /***/ }),

      /***/ 4775:
      /***/ (function (module) {
        /**
 * Creates an instance of Line
 *
 * @constructor
 * @this {Line}
 * @param {Number} Maximum width this line can have
 */
        function Line(maxWidth) {
          this.maxWidth = maxWidth;
          this.leadingCut = 0;
          this.trailingCut = 0;
          this.inlineWidths = 0;
          this.inlines = [];
        }

        Line.prototype.getAscenderHeight = function () {
          let y = 0;

          this.inlines.forEach((inline) => {
            y = Math.max(y, inline.font.ascender / 1000 * inline.fontSize);
          });
          return y;
        };

        Line.prototype.hasEnoughSpaceForInline = function (inline, nextInlines) {
          nextInlines = nextInlines || [];

          if (this.inlines.length === 0) {
            return true;
          }
          if (this.newLineForced) {
            return false;
          }

          let inlineWidth = inline.width;
          let inlineTrailingCut = inline.trailingCut || 0;
          if (inline.noNewLine) {
            for (let i = 0, l = nextInlines.length; i < l; i++) {
              const nextInline = nextInlines[i];
              inlineWidth += nextInline.width;
              inlineTrailingCut += nextInline.trailingCut || 0;
              if (!nextInline.noNewLine) {
                break;
              }
            }
          }

          return (this.inlineWidths + inlineWidth - this.leadingCut - inlineTrailingCut) <= this.maxWidth;
        };

        Line.prototype.addInline = function (inline) {
          if (this.inlines.length === 0) {
            this.leadingCut = inline.leadingCut || 0;
          }
          this.trailingCut = inline.trailingCut || 0;

          inline.x = this.inlineWidths - this.leadingCut;

          this.inlines.push(inline);
          this.inlineWidths += inline.width;

          if (inline.lineEnd) {
            this.newLineForced = true;
          }
        };

        Line.prototype.getWidth = function () {
          return this.inlineWidths - this.leadingCut - this.trailingCut;
        };

        Line.prototype.getAvailableWidth = function () {
          return this.maxWidth - this.getWidth();
        };

        /**
 * Returns line height
 * @return {Number}
 */
        Line.prototype.getHeight = function () {
          let max = 0;

          this.inlines.forEach((item) => {
            max = Math.max(max, item.height || 0);
          });

          return max;
        };

        module.exports = Line;
        /***/ }),

      /***/ 2912:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const { isUndefined } = __webpack_require__(6225);
        const ElementWriter = __webpack_require__(1196);

        /**
 * Creates an instance of PageElementWriter - an extended ElementWriter
 * which can handle:
 * - page-breaks (it adds new pages when there's not enough space left),
 * - repeatable fragments (like table-headers, which are repeated everytime
 *                         a page-break occurs)
 * - transactions (used for unbreakable-blocks when we want to make sure
 *                 whole block will be rendered on the same page)
 */
        function PageElementWriter(context, tracker) {
          this.transactionLevel = 0;
          this.repeatables = [];
          this.tracker = tracker;
          this.writer = new ElementWriter(context, tracker);
        }

        function fitOnPage(self, addFct) {
          let position = addFct(self);
          if (!position) {
            self.moveToNextPage();
            position = addFct(self);
          }
          return position;
        }

        PageElementWriter.prototype.addLine = function (line, dontUpdateContextPosition, index) {
          return fitOnPage(this, (self) => self.writer.addLine(line, dontUpdateContextPosition, index));
        };

        PageElementWriter.prototype.addImage = function (image, index) {
          return fitOnPage(this, (self) => self.writer.addImage(image, index));
        };

        PageElementWriter.prototype.addSVG = function (image, index) {
          return fitOnPage(this, (self) => self.writer.addSVG(image, index));
        };

        PageElementWriter.prototype.addQr = function (qr, index) {
          return fitOnPage(this, (self) => self.writer.addQr(qr, index));
        };

        PageElementWriter.prototype.addVector = function (vector, ignoreContextX, ignoreContextY, index) {
          return this.writer.addVector(vector, ignoreContextX, ignoreContextY, index);
        };

        PageElementWriter.prototype.beginClip = function (width, height) {
          return this.writer.beginClip(width, height);
        };

        PageElementWriter.prototype.endClip = function () {
          return this.writer.endClip();
        };

        PageElementWriter.prototype.alignCanvas = function (node) {
          this.writer.alignCanvas(node);
        };

        PageElementWriter.prototype.addFragment = function (fragment, useBlockXOffset, useBlockYOffset, dontUpdateContextPosition) {
          if (!this.writer.addFragment(fragment, useBlockXOffset, useBlockYOffset, dontUpdateContextPosition)) {
            this.moveToNextPage();
            this.writer.addFragment(fragment, useBlockXOffset, useBlockYOffset, dontUpdateContextPosition);
          }
        };

        PageElementWriter.prototype.moveToNextPage = function (pageOrientation) {
          const nextPage = this.writer.context.moveToNextPage(pageOrientation);

          // moveToNextPage is called multiple times for table, because is called for each column
          // and repeatables are inserted only in the first time. If columns are used, is needed
          // call for table in first column and then for table in the second column (is other repeatables).
          this.repeatables.forEach(function (rep) {
            if (isUndefined(rep.insertedOnPages[this.writer.context.page])) {
              rep.insertedOnPages[this.writer.context.page] = true;
              this.writer.addFragment(rep, true);
            } else {
              this.writer.context.moveDown(rep.height);
            }
          }, this);

          this.writer.tracker.emit('pageChanged', {
            prevPage: nextPage.prevPage,
            prevY: nextPage.prevY,
            y: this.writer.context.y,
          });
        };

        PageElementWriter.prototype.beginUnbreakableBlock = function (width, height) {
          if (this.transactionLevel++ === 0) {
            this.originalX = this.writer.context.x;
            this.writer.pushContext(width, height);
          }
        };

        PageElementWriter.prototype.commitUnbreakableBlock = function (forcedX, forcedY) {
          if (--this.transactionLevel === 0) {
            const unbreakableContext = this.writer.context;
            this.writer.popContext();

            const nbPages = unbreakableContext.pages.length;
            if (nbPages > 0) {
              // no support for multi-page unbreakableBlocks
              const fragment = unbreakableContext.pages[0];
              fragment.xOffset = forcedX;
              fragment.yOffset = forcedY;

              // TODO: vectors can influence height in some situations
              if (nbPages > 1) {
                // on out-of-context blocs (headers, footers, background) height should be the whole DocumentContext height
                if (forcedX !== undefined || forcedY !== undefined) {
                  fragment.height = unbreakableContext.getCurrentPage().pageSize.height - unbreakableContext.pageMargins.top - unbreakableContext.pageMargins.bottom;
                } else {
                  fragment.height = this.writer.context.getCurrentPage().pageSize.height - this.writer.context.pageMargins.top - this.writer.context.pageMargins.bottom;
                  for (let i = 0, l = this.repeatables.length; i < l; i++) {
                    fragment.height -= this.repeatables[i].height;
                  }
                }
              } else {
                fragment.height = unbreakableContext.y;
              }

              if (forcedX !== undefined || forcedY !== undefined) {
                this.writer.addFragment(fragment, true, true, true);
              } else {
                this.addFragment(fragment);
              }
            }
          }
        };

        PageElementWriter.prototype.currentBlockToRepeatable = function () {
          const unbreakableContext = this.writer.context;
          const rep = { items: [] };

          unbreakableContext.pages[0].items.forEach((item) => {
            rep.items.push(item);
          });

          rep.xOffset = this.originalX;

          // TODO: vectors can influence height in some situations
          rep.height = unbreakableContext.y;

          rep.insertedOnPages = [];

          return rep;
        };

        PageElementWriter.prototype.pushToRepeatables = function (rep) {
          this.repeatables.push(rep);
        };

        PageElementWriter.prototype.popFromRepeatables = function () {
          this.repeatables.pop();
        };

        PageElementWriter.prototype.context = function () {
          return this.writer.context;
        };

        module.exports = PageElementWriter;
        /***/ }),

      /***/ 6079:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        function _interopDefault(ex) {
          return (ex && (typeof ex === 'object') && 'default' in ex) ? ex.default : ex;
        }

        const PdfKit = _interopDefault(__webpack_require__(4872));

        function getEngineInstance() {
          return PdfKit;
        }

        function createPdfDocument(options) {
          options = options || {};
          return new PdfKit(options);
        }

        module.exports = {
          getEngineInstance,
          createPdfDocument,
        };
        /***/ }),

      /***/ 8617:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        /* eslint no-unused-vars: ["error", {"args": "none"}] */

        const PdfKitEngine = __webpack_require__(6079);
        const FontProvider = __webpack_require__(2249);
        const LayoutBuilder = __webpack_require__(2678);
        const sizes = __webpack_require__(4762);
        const ImageMeasure = __webpack_require__(3090);
        const SVGMeasure = __webpack_require__(7601);
        const textDecorator = __webpack_require__(3497);
        const TextTools = __webpack_require__(1350);
        const { isFunction } = __webpack_require__(6225);
        const { isString } = __webpack_require__(6225);
        const { isNumber } = __webpack_require__(6225);
        const { isBoolean } = __webpack_require__(6225);
        const { isArray } = __webpack_require__(6225);
        const { isUndefined } = __webpack_require__(6225);
        const { isPattern } = __webpack_require__(6225);
        const { getPattern } = __webpack_require__(6225);
        const SVGtoPDF = __webpack_require__(8071);

        const findFont = function (fonts, requiredFonts, defaultFont) {
          for (let i = 0; i < requiredFonts.length; i++) {
            const requiredFont = requiredFonts[i].toLowerCase();

            for (const font in fonts) {
              if (font.toLowerCase() === requiredFont) {
                return font;
              }
            }
          }

          return defaultFont;
        };

        /// /////////////////////////////////////
        // PdfPrinter

        /**
 * @class Creates an instance of a PdfPrinter which turns document definition into a pdf
 *
 * @param {Object} fontDescriptors font definition dictionary
 *
 * @example
 * var fontDescriptors = {
 *	Roboto: {
 *		normal: 'fonts/Roboto-Regular.ttf',
 *		bold: 'fonts/Roboto-Medium.ttf',
 *		italics: 'fonts/Roboto-Italic.ttf',
 *		bolditalics: 'fonts/Roboto-MediumItalic.ttf'
 *	}
 * };
 *
 * var printer = new PdfPrinter(fontDescriptors);
 */
        function PdfPrinter(fontDescriptors) {
          this.fontDescriptors = fontDescriptors;
        }

        /**
 * Executes layout engine for the specified document and renders it into a pdfkit document
 * ready to be saved.
 *
 * @param {Object} docDefinition document definition
 * @param {Object} docDefinition.content an array describing the pdf structure (for more information take a look at the examples in the /examples folder)
 * @param {Object} [docDefinition.defaultStyle] default (implicit) style definition
 * @param {Object} [docDefinition.styles] dictionary defining all styles which can be used in the document
 * @param {Object} [docDefinition.pageSize] page size (pdfkit units, A4 dimensions by default)
 * @param {Number} docDefinition.pageSize.width width
 * @param {Number} docDefinition.pageSize.height height
 * @param {Object} [docDefinition.pageMargins] page margins (pdfkit units)
 * @param {Number} docDefinition.maxPagesNumber maximum number of pages to render
 *
 * @example
 *
 * var docDefinition = {
 * 	info: {
 *		title: 'awesome Document',
 *		author: 'john doe',
 *		subject: 'subject of document',
 *		keywords: 'keywords for document',
 * 	},
 *	content: [
 *		'First paragraph',
 *		'Second paragraph, this time a little bit longer',
 *		{ text: 'Third paragraph, slightly bigger font size', fontSize: 20 },
 *		{ text: 'Another paragraph using a named style', style: 'header' },
 *		{ text: ['playing with ', 'inlines' ] },
 *		{ text: ['and ', { text: 'restyling ', bold: true }, 'them'] },
 *	],
 *	styles: {
 *		header: { fontSize: 30, bold: true }
 *	},
 *	patterns: {
 *		stripe45d: {
 *			boundingBox: [1, 1, 4, 4],
 *			xStep: 3,
 *			yStep: 3,
 *			pattern: '1 w 0 1 m 4 5 l s 2 0 m 5 3 l s'
 *		}
 *	}
 * };
 *
 * var pdfKitDoc = printer.createPdfKitDocument(docDefinition);
 *
 * pdfKitDoc.pipe(fs.createWriteStream('sample.pdf'));
 * pdfKitDoc.end();
 *
 * @return {Object} a pdfKit document object which can be saved or encode to data-url
 */
        PdfPrinter.prototype.createPdfKitDocument = function (docDefinition, options) {
          options = options || {};

          docDefinition.version = docDefinition.version || '1.3';
          docDefinition.compress = isBoolean(docDefinition.compress) ? docDefinition.compress : true;
          docDefinition.images = docDefinition.images || {};
          docDefinition.pageMargins = ((docDefinition.pageMargins !== undefined) && (docDefinition.pageMargins !== null)) ? docDefinition.pageMargins : 40;

          const pageSize = fixPageSize(docDefinition.pageSize, docDefinition.pageOrientation);

          const pdfOptions = {
            size: [pageSize.width, pageSize.height],
            pdfVersion: docDefinition.version,
            compress: docDefinition.compress,
            userPassword: docDefinition.userPassword,
            ownerPassword: docDefinition.ownerPassword,
            permissions: docDefinition.permissions,
            fontLayoutCache: isBoolean(options.fontLayoutCache) ? options.fontLayoutCache : true,
            bufferPages: options.bufferPages || false,
            autoFirstPage: false,
            info: createMetadata(docDefinition),
            font: null,
          };

          this.pdfKitDoc = PdfKitEngine.createPdfDocument(pdfOptions);

          this.fontProvider = new FontProvider(this.fontDescriptors, this.pdfKitDoc);

          const builder = new LayoutBuilder(pageSize, fixPageMargins(docDefinition.pageMargins), new ImageMeasure(this.pdfKitDoc, docDefinition.images), new SVGMeasure());

          registerDefaultTableLayouts(builder);
          if (options.tableLayouts) {
            builder.registerTableLayouts(options.tableLayouts);
          }

          let pages = builder.layoutDocument(docDefinition.content, this.fontProvider, docDefinition.styles || {}, docDefinition.defaultStyle || {
            fontSize: 12,
            font: 'Roboto',
          }, docDefinition.background, docDefinition.header, docDefinition.footer, docDefinition.images, docDefinition.watermark, docDefinition.pageBreakBefore);
          const maxNumberPages = docDefinition.maxPagesNumber || -1;
          if (isNumber(maxNumberPages) && maxNumberPages > -1) {
            pages = pages.slice(0, maxNumberPages);
          }

          // if pageSize.height is set to Infinity, calculate the actual height of the page that
          // was laid out using the height of each of the items in the page.
          if (pageSize.height === Infinity) {
            const pageHeight = calculatePageHeight(pages, docDefinition.pageMargins);
            this.pdfKitDoc.options.size = [pageSize.width, pageHeight];
          }

          const patterns = createPatterns(docDefinition.patterns || {}, this.pdfKitDoc);

          renderPages(pages, this.fontProvider, this.pdfKitDoc, patterns, options.progressCallback);

          if (options.autoPrint) {
            const printActionRef = this.pdfKitDoc.ref({
              Type: 'Action',
              S: 'Named',
              N: 'Print',
            });
            this.pdfKitDoc._root.data.OpenAction = printActionRef;
            printActionRef.end();
          }
          return this.pdfKitDoc;
        };

        function createMetadata(docDefinition) {
          // PDF standard has these properties reserved: Title, Author, Subject, Keywords,
          // Creator, Producer, CreationDate, ModDate, Trapped.
          // To keep the pdfmake api consistent, the info field are defined lowercase.
          // Custom properties don't contain a space.
          function standardizePropertyKey(key) {
            const standardProperties = ['Title', 'Author', 'Subject', 'Keywords',
              'Creator', 'Producer', 'CreationDate', 'ModDate', 'Trapped'];
            const standardizedKey = key.charAt(0).toUpperCase() + key.slice(1);
            if (standardProperties.indexOf(standardizedKey) !== -1) {
              return standardizedKey;
            }

            return key.replace(/\s+/g, '');
          }

          const info = {
            Producer: 'pdfmake',
            Creator: 'pdfmake',
          };

          if (docDefinition.info) {
            for (let key in docDefinition.info) {
              const value = docDefinition.info[key];
              if (value) {
                key = standardizePropertyKey(key);
                info[key] = value;
              }
            }
          }
          return info;
        }

        function calculatePageHeight(pages, margins) {
          function getItemHeight(item) {
            if (isFunction(item.item.getHeight)) {
              return item.item.getHeight();
            } if (item.item._height) {
              return item.item._height;
            } if (item.type === 'vector') {
              return item.item.y1 > item.item.y2 ? item.item.y1 : item.item.y2;
            }
            // TODO: add support for next item types
            return 0;
          }

          function getBottomPosition(item) {
            const top = item.item.y || 0;
            const height = getItemHeight(item);
            return top + height;
          }

          const fixedMargins = fixPageMargins(margins || 40);
          let height = fixedMargins.top;

          pages.forEach((page) => {
            page.items.forEach((item) => {
              const bottomPosition = getBottomPosition(item);
              if (bottomPosition > height) {
                height = bottomPosition;
              }
            });
          });

          height += fixedMargins.bottom;

          return height;
        }

        function fixPageSize(pageSize, pageOrientation) {
          function isNeedSwapPageSizes(pageOrientation) {
            if (isString(pageOrientation)) {
              pageOrientation = pageOrientation.toLowerCase();
              return ((pageOrientation === 'portrait') && (size.width > size.height))
				|| ((pageOrientation === 'landscape') && (size.width < size.height));
            }
            return false;
          }

          // if pageSize.height is set to auto, set the height to infinity so there are no page breaks.
          if (pageSize && pageSize.height === 'auto') {
            pageSize.height = Infinity;
          }

          var size = pageSize2widthAndHeight(pageSize || 'A4');
          if (isNeedSwapPageSizes(pageOrientation)) { // swap page sizes
            size = { width: size.height, height: size.width };
          }
          size.orientation = size.width > size.height ? 'landscape' : 'portrait';
          return size;
        }

        function fixPageMargins(margin) {
          if (isNumber(margin)) {
            margin = {
              left: margin, right: margin, top: margin, bottom: margin,
            };
          } else if (isArray(margin)) {
            if (margin.length === 2) {
              margin = {
                left: margin[0], top: margin[1], right: margin[0], bottom: margin[1],
              };
            } else if (margin.length === 4) {
              margin = {
                left: margin[0], top: margin[1], right: margin[2], bottom: margin[3],
              };
            } else {
              throw 'Invalid pageMargins definition';
            }
          }

          return margin;
        }

        function registerDefaultTableLayouts(layoutBuilder) {
          layoutBuilder.registerTableLayouts({
            noBorders: {
              hLineWidth(i) {
                return 0;
              },
              vLineWidth(i) {
                return 0;
              },
              paddingLeft(i) {
                return i && 4 || 0;
              },
              paddingRight(i, node) {
                return (i < node.table.widths.length - 1) ? 4 : 0;
              },
            },
            headerLineOnly: {
              hLineWidth(i, node) {
                if (i === 0 || i === node.table.body.length) {
                  return 0;
                }
                return (i === node.table.headerRows) ? 2 : 0;
              },
              vLineWidth(i) {
                return 0;
              },
              paddingLeft(i) {
                return i === 0 ? 0 : 8;
              },
              paddingRight(i, node) {
                return (i === node.table.widths.length - 1) ? 0 : 8;
              },
            },
            lightHorizontalLines: {
              hLineWidth(i, node) {
                if (i === 0 || i === node.table.body.length) {
                  return 0;
                }
                return (i === node.table.headerRows) ? 2 : 1;
              },
              vLineWidth(i) {
                return 0;
              },
              hLineColor(i) {
                return i === 1 ? 'black' : '#aaa';
              },
              paddingLeft(i) {
                return i === 0 ? 0 : 8;
              },
              paddingRight(i, node) {
                return (i === node.table.widths.length - 1) ? 0 : 8;
              },
            },
          });
        }

        function pageSize2widthAndHeight(pageSize) {
          if (isString(pageSize)) {
            const size = sizes[pageSize.toUpperCase()];
            if (!size) {
              throw `Page size ${pageSize} not recognized`;
            }
            return { width: size[0], height: size[1] };
          }

          return pageSize;
        }

        function updatePageOrientationInOptions(currentPage, pdfKitDoc) {
          const previousPageOrientation = pdfKitDoc.options.size[0] > pdfKitDoc.options.size[1] ? 'landscape' : 'portrait';

          if (currentPage.pageSize.orientation !== previousPageOrientation) {
            const width = pdfKitDoc.options.size[0];
            const height = pdfKitDoc.options.size[1];
            pdfKitDoc.options.size = [height, width];
          }
        }

        function renderPages(pages, fontProvider, pdfKitDoc, patterns, progressCallback) {
          pdfKitDoc._pdfMakePages = pages;
          pdfKitDoc.addPage();

          let totalItems = 0;
          if (progressCallback) {
            pages.forEach((page) => {
              totalItems += page.items.length;
            });
          }

          let renderedItems = 0;
          progressCallback = progressCallback || function () {
          };

          for (let i = 0; i < pages.length; i++) {
            if (i > 0) {
              updatePageOrientationInOptions(pages[i], pdfKitDoc);
              pdfKitDoc.addPage(pdfKitDoc.options);
            }

            const page = pages[i];
            for (let ii = 0, il = page.items.length; ii < il; ii++) {
              const item = page.items[ii];
              switch (item.type) {
                case 'vector':
                  renderVector(item.item, patterns, pdfKitDoc);
                  break;
                case 'line':
                  renderLine(item.item, item.item.x, item.item.y, patterns, pdfKitDoc);
                  break;
                case 'image':
                  renderImage(item.item, item.item.x, item.item.y, pdfKitDoc);
                  break;
                case 'svg':
                  renderSVG(item.item, item.item.x, item.item.y, pdfKitDoc, fontProvider);
                  break;
                case 'beginClip':
                  beginClip(item.item, pdfKitDoc);
                  break;
                case 'endClip':
                  endClip(pdfKitDoc);
                  break;
              }
              renderedItems++;
              progressCallback(renderedItems / totalItems);
            }
            if (page.watermark) {
              renderWatermark(page, pdfKitDoc);
            }
          }
        }

        /**
 * Shift the "y" height of the text baseline up or down (superscript or subscript,
 * respectively). The exact shift can / should be changed according to standard
 * conventions.
 *
 * @param {number} y
 * @param {any} inline
 */
        function offsetText(y, inline) {
          let newY = y;
          if (inline.sup) {
            newY -= inline.fontSize * 0.75;
          }
          if (inline.sub) {
            newY += inline.fontSize * 0.35;
          }
          return newY;
        }

        function renderLine(line, x, y, patterns, pdfKitDoc) {
          function preparePageNodeRefLine(_pageNodeRef, inline) {
            let newWidth;
            let diffWidth;
            const textTools = new TextTools(null);

            if (isUndefined(_pageNodeRef.positions)) {
              throw 'Page reference id not found';
            }

            const pageNumber = _pageNodeRef.positions[0].pageNumber.toString();

            inline.text = pageNumber;
            newWidth = textTools.widthOfString(inline.text, inline.font, inline.fontSize, inline.characterSpacing, inline.fontFeatures);
            diffWidth = inline.width - newWidth;
            inline.width = newWidth;

            switch (inline.alignment) {
              case 'right':
                inline.x += diffWidth;
                break;
              case 'center':
                inline.x += diffWidth / 2;
                break;
            }
          }

          if (line._pageNodeRef) {
            preparePageNodeRefLine(line._pageNodeRef, line.inlines[0]);
          }

          x = x || 0;
          y = y || 0;

          const lineHeight = line.getHeight();
          const ascenderHeight = line.getAscenderHeight();
          const descent = lineHeight - ascenderHeight;

          textDecorator.drawBackground(line, x, y, patterns, pdfKitDoc);

          // TODO: line.optimizeInlines();
          for (let i = 0, l = line.inlines.length; i < l; i++) {
            const inline = line.inlines[i];
            const shiftToBaseline = lineHeight - ((inline.font.ascender / 1000) * inline.fontSize) - descent;

            if (inline._pageNodeRef) {
              preparePageNodeRefLine(inline._pageNodeRef, inline);
            }

            const options = {
              lineBreak: false,
              textWidth: inline.width,
              characterSpacing: inline.characterSpacing,
              wordCount: 1,
              link: inline.link,
            };

            if (inline.linkToDestination) {
              options.goTo = inline.linkToDestination;
            }

            if (line.id && i === 0) {
              options.destination = line.id;
            }

            if (inline.fontFeatures) {
              options.features = inline.fontFeatures;
            }

            const opacity = isNumber(inline.opacity) ? inline.opacity : 1;
            pdfKitDoc.opacity(opacity);
            pdfKitDoc.fill(inline.color || 'black');

            pdfKitDoc._font = inline.font;
            pdfKitDoc.fontSize(inline.fontSize);

            const shiftedY = offsetText(y + shiftToBaseline, inline);
            pdfKitDoc.text(inline.text, x + inline.x, shiftedY, options);

            if (inline.linkToPage) {
              const _ref = pdfKitDoc.ref({ Type: 'Action', S: 'GoTo', D: [inline.linkToPage, 0, 0] }).end();
              pdfKitDoc.annotate(x + inline.x, shiftedY, inline.width, inline.height, {
                Subtype: 'Link',
                Dest: [inline.linkToPage - 1, 'XYZ', null, null, null],
              });
            }
          }
          // Decorations won't draw correctly for superscript
          textDecorator.drawDecorations(line, x, y, pdfKitDoc);
        }

        function renderWatermark(page, pdfKitDoc) {
          const { watermark } = page;

          pdfKitDoc.fill(watermark.color);
          pdfKitDoc.opacity(watermark.opacity);

          pdfKitDoc.save();

          pdfKitDoc.rotate(watermark.angle, { origin: [pdfKitDoc.page.width / 2, pdfKitDoc.page.height / 2] });

          const x = pdfKitDoc.page.width / 2 - watermark._size.size.width / 2;
          const y = pdfKitDoc.page.height / 2 - watermark._size.size.height / 2;

          pdfKitDoc._font = watermark.font;
          pdfKitDoc.fontSize(watermark.fontSize);
          pdfKitDoc.text(watermark.text, x, y, { lineBreak: false });

          pdfKitDoc.restore();
        }

        function renderVector(vector, patterns, pdfKitDoc) {
          // TODO: pdf optimization (there's no need to write all properties everytime)
          pdfKitDoc.lineWidth(vector.lineWidth || 1);
          if (vector.dash) {
            pdfKitDoc.dash(vector.dash.length, { space: vector.dash.space || vector.dash.length, phase: vector.dash.phase || 0 });
          } else {
            pdfKitDoc.undash();
          }
          pdfKitDoc.lineJoin(vector.lineJoin || 'miter');
          pdfKitDoc.lineCap(vector.lineCap || 'butt');

          // TODO: clipping

          let gradient = null;

          switch (vector.type) {
            case 'ellipse':
              pdfKitDoc.ellipse(vector.x, vector.y, vector.r1, vector.r2);

              if (vector.linearGradient) {
                gradient = pdfKitDoc.linearGradient(vector.x - vector.r1, vector.y, vector.x + vector.r1, vector.y);
              }
              break;
            case 'rect':
              if (vector.r) {
                pdfKitDoc.roundedRect(vector.x, vector.y, vector.w, vector.h, vector.r);
              } else {
                pdfKitDoc.rect(vector.x, vector.y, vector.w, vector.h);
              }

              if (vector.linearGradient) {
                gradient = pdfKitDoc.linearGradient(vector.x, vector.y, vector.x + vector.w, vector.y);
              }
              break;
            case 'line':
              pdfKitDoc.moveTo(vector.x1, vector.y1);
              pdfKitDoc.lineTo(vector.x2, vector.y2);
              break;
            case 'polyline':
              if (vector.points.length === 0) {
                break;
              }

              pdfKitDoc.moveTo(vector.points[0].x, vector.points[0].y);
              for (var i = 1, l = vector.points.length; i < l; i++) {
                pdfKitDoc.lineTo(vector.points[i].x, vector.points[i].y);
              }

              if (vector.points.length > 1) {
                const p1 = vector.points[0];
                const pn = vector.points[vector.points.length - 1];

                if (vector.closePath || p1.x === pn.x && p1.y === pn.y) {
                  pdfKitDoc.closePath();
                }
              }
              break;
            case 'path':
              pdfKitDoc.path(vector.d);
              break;
          }

          if (vector.linearGradient && gradient) {
            const step = 1 / (vector.linearGradient.length - 1);

            for (var i = 0; i < vector.linearGradient.length; i++) {
              gradient.stop(i * step, vector.linearGradient[i]);
            }

            vector.color = gradient;
          }

          if (isPattern(vector.color)) {
            vector.color = getPattern(vector.color, patterns);
          }

          const fillOpacity = isNumber(vector.fillOpacity) ? vector.fillOpacity : 1;
          const strokeOpacity = isNumber(vector.strokeOpacity) ? vector.strokeOpacity : 1;

          if (vector.color && vector.lineColor) {
            pdfKitDoc.fillColor(vector.color, fillOpacity);
            pdfKitDoc.strokeColor(vector.lineColor, strokeOpacity);
            pdfKitDoc.fillAndStroke();
          } else if (vector.color) {
            pdfKitDoc.fillColor(vector.color, fillOpacity);
            pdfKitDoc.fill();
          } else {
            pdfKitDoc.strokeColor(vector.lineColor || 'black', strokeOpacity);
            pdfKitDoc.stroke();
          }
        }

        function renderImage(image, x, y, pdfKitDoc) {
          const opacity = isNumber(image.opacity) ? image.opacity : 1;
          pdfKitDoc.opacity(opacity);
          if (image.cover) {
            const align = image.cover.align || 'center';
            const valign = image.cover.valign || 'center';
            const width = image.cover.width ? image.cover.width : image.width;
            const height = image.cover.height ? image.cover.height : image.height;
            pdfKitDoc.save();
            pdfKitDoc.rect(image.x, image.y, width, height).clip();
            pdfKitDoc.image(image.image, image.x, image.y, { cover: [width, height], align, valign });
            pdfKitDoc.restore();
          } else {
            pdfKitDoc.image(image.image, image.x, image.y, { width: image._width, height: image._height });
          }
          if (image.link) {
            pdfKitDoc.link(image.x, image.y, image._width, image._height, image.link);
          }
          if (image.linkToPage) {
            pdfKitDoc.ref({ Type: 'Action', S: 'GoTo', D: [image.linkToPage, 0, 0] }).end();
            pdfKitDoc.annotate(image.x, image.y, image._width, image._height, { Subtype: 'Link', Dest: [image.linkToPage - 1, 'XYZ', null, null, null] });
          }
          if (image.linkToDestination) {
            pdfKitDoc.goTo(image.x, image.y, image._width, image._height, image.linkToDestination);
          }
        }

        function renderSVG(svg, x, y, pdfKitDoc, fontProvider) {
          const options = {
            width: svg._width, height: svg._height, assumePt: true, ...svg.options,
          };
          options.fontCallback = function (family, bold, italic) {
            const fontsFamily = family.split(',').map((f) => f.trim().replace(/('|")/g, ''));
            const font = findFont(fontProvider.fonts, fontsFamily, svg.font || 'Roboto');

            const fontFile = fontProvider.getFontFile(font, bold, italic);
            if (fontFile === null) {
              const type = fontProvider.getFontType(bold, italic);
              throw new Error(`Font '${font}' in style '${type}' is not defined in the font section of the document definition.`);
            }

            return fontFile;
          };

          SVGtoPDF(pdfKitDoc, svg.svg, svg.x, svg.y, options);
        }

        function beginClip(rect, pdfKitDoc) {
          pdfKitDoc.save();
          pdfKitDoc.addContent(`${rect.x} ${rect.y} ${rect.width} ${rect.height} re`);
          pdfKitDoc.clip();
        }

        function endClip(pdfKitDoc) {
          pdfKitDoc.restore();
        }

        function createPatterns(patternDefinitions, pdfKitDoc) {
          const patterns = {};
          Object.keys(patternDefinitions).forEach((p) => {
            const pattern = patternDefinitions[p];
            patterns[p] = pdfKitDoc.pattern(pattern.boundingBox, pattern.xStep, pattern.yStep, pattern.pattern, pattern.colored);
          });
          return patterns;
        }

        module.exports = PdfPrinter;
        /***/ }),

      /***/ 145:
      /***/ (function (module) {
        /* eslint no-unused-vars: ["error", {"args": "none"}] */
        /* eslint no-redeclare: "off" */

        /* qr.js -- QR code generator in Javascript (revision 2011-01-19)
 * Written by Kang Seonghoon <public+qrjs@mearie.org>.
 *
 * This source code is in the public domain; if your jurisdiction does not
 * recognize the public domain the terms of Creative Commons CC0 license
 * apply. In the other words, you can always do what you want.
 */

        // per-version information (cf. JIS X 0510:2004 pp. 30--36, 71)
        //
        // [0]: the degree of generator polynomial by ECC levels
        // [1]: # of code blocks by ECC levels
        // [2]: left-top positions of alignment patterns
        //
        // the number in this table (in particular, [0]) does not exactly match with
        // the numbers in the specficiation. see augumenteccs below for the reason.
        const VERSIONS = [
          null,
          [[10, 7, 17, 13], [1, 1, 1, 1], []],
          [[16, 10, 28, 22], [1, 1, 1, 1], [4, 16]],
          [[26, 15, 22, 18], [1, 1, 2, 2], [4, 20]],
          [[18, 20, 16, 26], [2, 1, 4, 2], [4, 24]],
          [[24, 26, 22, 18], [2, 1, 4, 4], [4, 28]],
          [[16, 18, 28, 24], [4, 2, 4, 4], [4, 32]],
          [[18, 20, 26, 18], [4, 2, 5, 6], [4, 20, 36]],
          [[22, 24, 26, 22], [4, 2, 6, 6], [4, 22, 40]],
          [[22, 30, 24, 20], [5, 2, 8, 8], [4, 24, 44]],
          [[26, 18, 28, 24], [5, 4, 8, 8], [4, 26, 48]],
          [[30, 20, 24, 28], [5, 4, 11, 8], [4, 28, 52]],
          [[22, 24, 28, 26], [8, 4, 11, 10], [4, 30, 56]],
          [[22, 26, 22, 24], [9, 4, 16, 12], [4, 32, 60]],
          [[24, 30, 24, 20], [9, 4, 16, 16], [4, 24, 44, 64]],
          [[24, 22, 24, 30], [10, 6, 18, 12], [4, 24, 46, 68]],
          [[28, 24, 30, 24], [10, 6, 16, 17], [4, 24, 48, 72]],
          [[28, 28, 28, 28], [11, 6, 19, 16], [4, 28, 52, 76]],
          [[26, 30, 28, 28], [13, 6, 21, 18], [4, 28, 54, 80]],
          [[26, 28, 26, 26], [14, 7, 25, 21], [4, 28, 56, 84]],
          [[26, 28, 28, 30], [16, 8, 25, 20], [4, 32, 60, 88]],
          [[26, 28, 30, 28], [17, 8, 25, 23], [4, 26, 48, 70, 92]],
          [[28, 28, 24, 30], [17, 9, 34, 23], [4, 24, 48, 72, 96]],
          [[28, 30, 30, 30], [18, 9, 30, 25], [4, 28, 52, 76, 100]],
          [[28, 30, 30, 30], [20, 10, 32, 27], [4, 26, 52, 78, 104]],
          [[28, 26, 30, 30], [21, 12, 35, 29], [4, 30, 56, 82, 108]],
          [[28, 28, 30, 28], [23, 12, 37, 34], [4, 28, 56, 84, 112]],
          [[28, 30, 30, 30], [25, 12, 40, 34], [4, 32, 60, 88, 116]],
          [[28, 30, 30, 30], [26, 13, 42, 35], [4, 24, 48, 72, 96, 120]],
          [[28, 30, 30, 30], [28, 14, 45, 38], [4, 28, 52, 76, 100, 124]],
          [[28, 30, 30, 30], [29, 15, 48, 40], [4, 24, 50, 76, 102, 128]],
          [[28, 30, 30, 30], [31, 16, 51, 43], [4, 28, 54, 80, 106, 132]],
          [[28, 30, 30, 30], [33, 17, 54, 45], [4, 32, 58, 84, 110, 136]],
          [[28, 30, 30, 30], [35, 18, 57, 48], [4, 28, 56, 84, 112, 140]],
          [[28, 30, 30, 30], [37, 19, 60, 51], [4, 32, 60, 88, 116, 144]],
          [[28, 30, 30, 30], [38, 19, 63, 53], [4, 28, 52, 76, 100, 124, 148]],
          [[28, 30, 30, 30], [40, 20, 66, 56], [4, 22, 48, 74, 100, 126, 152]],
          [[28, 30, 30, 30], [43, 21, 70, 59], [4, 26, 52, 78, 104, 130, 156]],
          [[28, 30, 30, 30], [45, 22, 74, 62], [4, 30, 56, 82, 108, 134, 160]],
          [[28, 30, 30, 30], [47, 24, 77, 65], [4, 24, 52, 80, 108, 136, 164]],
          [[28, 30, 30, 30], [49, 25, 81, 68], [4, 28, 56, 84, 112, 140, 168]]];

        // mode constants (cf. Table 2 in JIS X 0510:2004 p. 16)
        const MODE_TERMINATOR = 0;
        const MODE_NUMERIC = 1; const MODE_ALPHANUMERIC = 2; const MODE_OCTET = 4; const
          MODE_KANJI = 8;

        // validation regexps
        const NUMERIC_REGEXP = /^\d*$/;
        const ALPHANUMERIC_REGEXP = /^[A-Za-z0-9 $%*+\-./:]*$/;
        const ALPHANUMERIC_OUT_REGEXP = /^[A-Z0-9 $%*+\-./:]*$/;

        // ECC levels (cf. Table 22 in JIS X 0510:2004 p. 45)
        const ECCLEVEL_L = 1; const ECCLEVEL_M = 0; const ECCLEVEL_Q = 3; const
          ECCLEVEL_H = 2;

        // GF(2^8)-to-integer mapping with a reducing polynomial x^8+x^4+x^3+x^2+1
        // invariant: GF256_MAP[GF256_INVMAP[i]] == i for all i in [1,256)
        const GF256_MAP = []; const
          GF256_INVMAP = [-1];
        for (var i = 0, v = 1; i < 255; ++i) {
          GF256_MAP.push(v);
          GF256_INVMAP[v] = i;
          v = (v * 2) ^ (v >= 128 ? 0x11d : 0);
        }

        // generator polynomials up to degree 30
        // (should match with polynomials in JIS X 0510:2004 Appendix A)
        //
        // generator polynomial of degree K is product of (x-\alpha^0), (x-\alpha^1),
        // ..., (x-\alpha^(K-1)). by convention, we omit the K-th coefficient (always 1)
        // from the result; also other coefficients are written in terms of the exponent
        // to \alpha to avoid the redundant calculation. (see also calculateecc below.)
        const GF256_GENPOLY = [[]];
        for (var i = 0; i < 30; ++i) {
          const prevpoly = GF256_GENPOLY[i]; const
            poly = [];
          for (let j = 0; j <= i; ++j) {
            const a = (j < i ? GF256_MAP[prevpoly[j]] : 0);
            const b = GF256_MAP[(i + (prevpoly[j - 1] || 0)) % 255];
            poly.push(GF256_INVMAP[a ^ b]);
          }
          GF256_GENPOLY.push(poly);
        }

        // alphanumeric character mapping (cf. Table 5 in JIS X 0510:2004 p. 19)
        const ALPHANUMERIC_MAP = {};
        for (var i = 0; i < 45; ++i) {
          ALPHANUMERIC_MAP['0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:'.charAt(i)] = i;
        }

        // mask functions in terms of row # and column #
        // (cf. Table 20 in JIS X 0510:2004 p. 42)
        /* jshint unused: false */
        const MASKFUNCS = [
          function (i, j) {
            return (i + j) % 2 === 0;
          },
          function (i, j) {
            return i % 2 === 0;
          },
          function (i, j) {
            return j % 3 === 0;
          },
          function (i, j) {
            return (i + j) % 3 === 0;
          },
          function (i, j) {
            return (((i / 2) | 0) + ((j / 3) | 0)) % 2 === 0;
          },
          function (i, j) {
            return (i * j) % 2 + (i * j) % 3 === 0;
          },
          function (i, j) {
            return ((i * j) % 2 + (i * j) % 3) % 2 === 0;
          },
          function (i, j) {
            return ((i + j) % 2 + (i * j) % 3) % 2 === 0;
          }];

        // returns true when the version information has to be embeded.
        const needsverinfo = function (ver) {
          return ver > 6;
        };

        // returns the size of entire QR code for given version.
        const getsizebyver = function (ver) {
          return 4 * ver + 17;
        };

        // returns the number of bits available for code words in this version.
        const nfullbits = function (ver) {
          /*
	 * |<--------------- n --------------->|
	 * |        |<----- n-17 ---->|        |
	 * +-------+                ///+-------+ ----
	 * |       |                ///|       |    ^
	 * |  9x9  |       @@@@@    ///|  9x8  |    |
	 * |       | # # # @5x5@ # # # |       |    |
	 * +-------+       @@@@@       +-------+    |
	 *       #                               ---|
	 *                                        ^ |
	 *       #                                |
	 *     @@@@@       @@@@@       @@@@@      | n
	 *     @5x5@       @5x5@       @5x5@   n-17
	 *     @@@@@       @@@@@       @@@@@      | |
	 *       #                                | |
	 * //////                                 v |
	 * //////#                               ---|
	 * +-------+       @@@@@       @@@@@        |
	 * |       |       @5x5@       @5x5@        |
	 * |  8x9  |       @@@@@       @@@@@        |
	 * |       |                                v
	 * +-------+                             ----
	 *
	 * when the entire code has n^2 modules and there are m^2-3 alignment
	 * patterns, we have:
	 * - 225 (= 9x9 + 9x8 + 8x9) modules for finder patterns and
	 *   format information;
	 * - 2n-34 (= 2(n-17)) modules for timing patterns;
	 * - 36 (= 3x6 + 6x3) modules for version information, if any;
	 * - 25m^2-75 (= (m^2-3)(5x5)) modules for alignment patterns
	 *   if any, but 10m-20 (= 2(m-2)x5) of them overlaps with
	 *   timing patterns.
	 */
          const v = VERSIONS[ver];
          let nbits = 16 * ver * ver + 128 * ver + 64; // finder, timing and format info.
          if (needsverinfo(ver)) nbits -= 36; // version information
          if (v[2].length) { // alignment patterns
            nbits -= 25 * v[2].length * v[2].length - 10 * v[2].length - 55;
          }
          return nbits;
        };

        // returns the number of bits available for data portions (i.e. excludes ECC
        // bits but includes mode and length bits) in this version and ECC level.
        const ndatabits = function (ver, ecclevel) {
          let nbits = nfullbits(ver) & ~7; // no sub-octet code words
          const v = VERSIONS[ver];
          nbits -= 8 * v[0][ecclevel] * v[1][ecclevel]; // ecc bits
          return nbits;
        };

        // returns the number of bits required for the length of data.
        // (cf. Table 3 in JIS X 0510:2004 p. 16)
        const ndatalenbits = function (ver, mode) {
          switch (mode) {
            case MODE_NUMERIC:
              return (ver < 10 ? 10 : ver < 27 ? 12 : 14);
            case MODE_ALPHANUMERIC:
              return (ver < 10 ? 9 : ver < 27 ? 11 : 13);
            case MODE_OCTET:
              return (ver < 10 ? 8 : 16);
            case MODE_KANJI:
              return (ver < 10 ? 8 : ver < 27 ? 10 : 12);
          }
        };

        // returns the maximum length of data possible in given configuration.
        const getmaxdatalen = function (ver, mode, ecclevel) {
          const nbits = ndatabits(ver, ecclevel) - 4 - ndatalenbits(ver, mode); // 4 for mode bits
          switch (mode) {
            case MODE_NUMERIC:
              return ((nbits / 10) | 0) * 3 + (nbits % 10 < 4 ? 0 : nbits % 10 < 7 ? 1 : 2);
            case MODE_ALPHANUMERIC:
              return ((nbits / 11) | 0) * 2 + (nbits % 11 < 6 ? 0 : 1);
            case MODE_OCTET:
              return (nbits / 8) | 0;
            case MODE_KANJI:
              return (nbits / 13) | 0;
          }
        };

        // checks if the given data can be encoded in given mode, and returns
        // the converted data for the further processing if possible. otherwise
        // returns null.
        //
        // this function does not check the length of data; it is a duty of
        // encode function below (as it depends on the version and ECC level too).
        const validatedata = function (mode, data) {
          switch (mode) {
            case MODE_NUMERIC:
              if (!data.match(NUMERIC_REGEXP)) return null;
              return data;

            case MODE_ALPHANUMERIC:
              if (!data.match(ALPHANUMERIC_REGEXP)) return null;
              return data.toUpperCase();

            case MODE_OCTET:
              if (typeof data === 'string') { // encode as utf-8 string
                const newdata = [];
                for (let i = 0; i < data.length; ++i) {
                  const ch = data.charCodeAt(i);
                  if (ch < 0x80) {
                    newdata.push(ch);
                  } else if (ch < 0x800) {
                    newdata.push(0xc0 | (ch >> 6),
                      0x80 | (ch & 0x3f));
                  } else if (ch < 0x10000) {
                    newdata.push(0xe0 | (ch >> 12),
                      0x80 | ((ch >> 6) & 0x3f),
                      0x80 | (ch & 0x3f));
                  } else {
                    newdata.push(0xf0 | (ch >> 18),
                      0x80 | ((ch >> 12) & 0x3f),
                      0x80 | ((ch >> 6) & 0x3f),
                      0x80 | (ch & 0x3f));
                  }
                }
                return newdata;
              }
              return data;
          }
        };

        // returns the code words (sans ECC bits) for given data and configurations.
        // requires data to be preprocessed by validatedata. no length check is
        // performed, and everything has to be checked before calling this function.
        const encode = function (ver, mode, data, maxbuflen) {
          const buf = [];
          let bits = 0; let
            remaining = 8;
          const datalen = data.length;

          // this function is intentionally no-op when n=0.
          const pack = function (x, n) {
            if (n >= remaining) {
              buf.push(bits | (x >> (n -= remaining)));
              while (n >= 8) buf.push((x >> (n -= 8)) & 255);
              bits = 0;
              remaining = 8;
            }
            if (n > 0) bits |= (x & ((1 << n) - 1)) << (remaining -= n);
          };

          const nlenbits = ndatalenbits(ver, mode);
          pack(mode, 4);
          pack(datalen, nlenbits);

          switch (mode) {
            case MODE_NUMERIC:
              for (var i = 2; i < datalen; i += 3) {
                pack(parseInt(data.substring(i - 2, i + 1), 10), 10);
              }
              pack(parseInt(data.substring(i - 2), 10), [0, 4, 7][datalen % 3]);
              break;

            case MODE_ALPHANUMERIC:
              for (var i = 1; i < datalen; i += 2) {
                pack(ALPHANUMERIC_MAP[data.charAt(i - 1)] * 45
					+ ALPHANUMERIC_MAP[data.charAt(i)], 11);
              }
              if (datalen % 2 == 1) {
                pack(ALPHANUMERIC_MAP[data.charAt(i - 1)], 6);
              }
              break;

            case MODE_OCTET:
              for (var i = 0; i < datalen; ++i) {
                pack(data[i], 8);
              }
              break;
          }

          // final bits. it is possible that adding terminator causes the buffer
          // to overflow, but then the buffer truncated to the maximum size will
          // be valid as the truncated terminator mode bits and padding is
          // identical in appearance (cf. JIS X 0510:2004 sec 8.4.8).
          pack(MODE_TERMINATOR, 4);
          if (remaining < 8) buf.push(bits);

          // the padding to fill up the remaining space. we should not add any
          // words when the overflow already occurred.
          while (buf.length + 1 < maxbuflen) buf.push(0xec, 0x11);
          if (buf.length < maxbuflen) buf.push(0xec);
          return buf;
        };

        // calculates ECC code words for given code words and generator polynomial.
        //
        // this is quite similar to CRC calculation as both Reed-Solomon and CRC use
        // the certain kind of cyclic codes, which is effectively the division of
        // zero-augumented polynomial by the generator polynomial. the only difference
        // is that Reed-Solomon uses GF(2^8), instead of CRC's GF(2), and Reed-Solomon
        // uses the different generator polynomial than CRC's.
        const calculateecc = function (poly, genpoly) {
          const modulus = poly.slice(0);
          const polylen = poly.length; const
            genpolylen = genpoly.length;
          for (var i = 0; i < genpolylen; ++i) modulus.push(0);
          for (var i = 0; i < polylen;) {
            const quotient = GF256_INVMAP[modulus[i++]];
            if (quotient >= 0) {
              for (let j = 0; j < genpolylen; ++j) {
                modulus[i + j] ^= GF256_MAP[(quotient + genpoly[j]) % 255];
              }
            }
          }
          return modulus.slice(polylen);
        };

        // auguments ECC code words to given code words. the resulting words are
        // ready to be encoded in the matrix.
        //
        // the much of actual augumenting procedure follows JIS X 0510:2004 sec 8.7.
        // the code is simplified using the fact that the size of each code & ECC
        // blocks is almost same; for example, when we have 4 blocks and 46 data words
        // the number of code words in those blocks are 11, 11, 12, 12 respectively.
        const augumenteccs = function (poly, nblocks, genpoly) {
          const subsizes = [];
          const subsize = (poly.length / nblocks) | 0; let
            subsize0 = 0;
          const pivot = nblocks - poly.length % nblocks;
          for (var i = 0; i < pivot; ++i) {
            subsizes.push(subsize0);
            subsize0 += subsize;
          }
          for (var i = pivot; i < nblocks; ++i) {
            subsizes.push(subsize0);
            subsize0 += subsize + 1;
          }
          subsizes.push(subsize0);

          const eccs = [];
          for (var i = 0; i < nblocks; ++i) {
            eccs.push(calculateecc(poly.slice(subsizes[i], subsizes[i + 1]), genpoly));
          }

          const result = [];
          const nitemsperblock = (poly.length / nblocks) | 0;
          for (var i = 0; i < nitemsperblock; ++i) {
            for (var j = 0; j < nblocks; ++j) {
              result.push(poly[subsizes[j] + i]);
            }
          }
          for (var j = pivot; j < nblocks; ++j) {
            result.push(poly[subsizes[j + 1] - 1]);
          }
          for (var i = 0; i < genpoly.length; ++i) {
            for (var j = 0; j < nblocks; ++j) {
              result.push(eccs[j][i]);
            }
          }
          return result;
        };

        // auguments BCH(p+q,q) code to the polynomial over GF(2), given the proper
        // genpoly. the both input and output are in binary numbers, and unlike
        // calculateecc genpoly should include the 1 bit for the highest degree.
        //
        // actual polynomials used for this procedure are as follows:
        // - p=10, q=5, genpoly=x^10+x^8+x^5+x^4+x^2+x+1 (JIS X 0510:2004 Appendix C)
        // - p=18, q=6, genpoly=x^12+x^11+x^10+x^9+x^8+x^5+x^2+1 (ibid. Appendix D)
        const augumentbch = function (poly, p, genpoly, q) {
          let modulus = poly << q;
          for (let i = p - 1; i >= 0; --i) {
            if ((modulus >> (q + i)) & 1) modulus ^= genpoly << i;
          }
          return (poly << q) | modulus;
        };

        // creates the base matrix for given version. it returns two matrices, one of
        // them is the actual one and the another represents the "reserved" portion
        // (e.g. finder and timing patterns) of the matrix.
        //
        // some entries in the matrix may be undefined, rather than 0 or 1. this is
        // intentional (no initialization needed!), and putdata below will fill
        // the remaining ones.
        const makebasematrix = function (ver) {
          const v = VERSIONS[ver]; const
            n = getsizebyver(ver);
          const matrix = []; const
            reserved = [];
          for (var i = 0; i < n; ++i) {
            matrix.push([]);
            reserved.push([]);
          }

          const blit = function (y, x, h, w, bits) {
            for (let i = 0; i < h; ++i) {
              for (let j = 0; j < w; ++j) {
                matrix[y + i][x + j] = (bits[i] >> j) & 1;
                reserved[y + i][x + j] = 1;
              }
            }
          };

          // finder patterns and a part of timing patterns
          // will also mark the format information area (not yet written) as reserved.
          blit(0, 0, 9, 9, [0x7f, 0x41, 0x5d, 0x5d, 0x5d, 0x41, 0x17f, 0x00, 0x40]);
          blit(n - 8, 0, 8, 9, [0x100, 0x7f, 0x41, 0x5d, 0x5d, 0x5d, 0x41, 0x7f]);
          blit(0, n - 8, 9, 8, [0xfe, 0x82, 0xba, 0xba, 0xba, 0x82, 0xfe, 0x00, 0x00]);

          // the rest of timing patterns
          for (var i = 9; i < n - 8; ++i) {
            matrix[6][i] = matrix[i][6] = ~i & 1;
            reserved[6][i] = reserved[i][6] = 1;
          }

          // alignment patterns
          const aligns = v[2]; const
            m = aligns.length;
          for (var i = 0; i < m; ++i) {
            const minj = (i === 0 || i === m - 1 ? 1 : 0); const
              maxj = (i === 0 ? m - 1 : m);
            for (var j = minj; j < maxj; ++j) {
              blit(aligns[i], aligns[j], 5, 5, [0x1f, 0x11, 0x15, 0x11, 0x1f]);
            }
          }

          // version information
          if (needsverinfo(ver)) {
            const code = augumentbch(ver, 6, 0x1f25, 12);
            let k = 0;
            for (var i = 0; i < 6; ++i) {
              for (var j = 0; j < 3; ++j) {
                matrix[i][(n - 11) + j] = matrix[(n - 11) + j][i] = (code >> k++) & 1;
                reserved[i][(n - 11) + j] = reserved[(n - 11) + j][i] = 1;
              }
            }
          }

          return { matrix, reserved };
        };

        // fills the data portion (i.e. unmarked in reserved) of the matrix with given
        // code words. the size of code words should be no more than available bits,
        // and remaining bits are padded to 0 (cf. JIS X 0510:2004 sec 8.7.3).
        const putdata = function (matrix, reserved, buf) {
          const n = matrix.length;
          let k = 0; let
            dir = -1;
          for (let i = n - 1; i >= 0; i -= 2) {
            if (i == 6) --i; // skip the entire timing pattern column
            let jj = (dir < 0 ? n - 1 : 0);
            for (let j = 0; j < n; ++j) {
              for (let ii = i; ii > i - 2; --ii) {
                if (!reserved[jj][ii]) {
                  // may overflow, but (undefined >> x)
                  // is 0 so it will auto-pad to zero.
                  matrix[jj][ii] = (buf[k >> 3] >> (~k & 7)) & 1;
                  ++k;
                }
              }
              jj += dir;
            }
            dir = -dir;
          }
          return matrix;
        };

        // XOR-masks the data portion of the matrix. repeating the call with the same
        // arguments will revert the prior call (convenient in the matrix evaluation).
        const maskdata = function (matrix, reserved, mask) {
          const maskf = MASKFUNCS[mask];
          const n = matrix.length;
          for (let i = 0; i < n; ++i) {
            for (let j = 0; j < n; ++j) {
              if (!reserved[i][j]) matrix[i][j] ^= maskf(i, j);
            }
          }
          return matrix;
        };

        // puts the format information.
        const putformatinfo = function (matrix, reserved, ecclevel, mask) {
          const n = matrix.length;
          const code = augumentbch((ecclevel << 3) | mask, 5, 0x537, 10) ^ 0x5412;
          for (let i = 0; i < 15; ++i) {
            const r = [0, 1, 2, 3, 4, 5, 7, 8, n - 7, n - 6, n - 5, n - 4, n - 3, n - 2, n - 1][i];
            const c = [n - 1, n - 2, n - 3, n - 4, n - 5, n - 6, n - 7, n - 8, 7, 5, 4, 3, 2, 1, 0][i];
            matrix[r][8] = matrix[8][c] = (code >> i) & 1;
            // we don't have to mark those bits reserved; always done
            // in makebasematrix above.
          }
          return matrix;
        };

        // evaluates the resulting matrix and returns the score (lower is better).
        // (cf. JIS X 0510:2004 sec 8.8.2)
        //
        // the evaluation procedure tries to avoid the problematic patterns naturally
        // occuring from the original matrix. for example, it penaltizes the patterns
        // which just look like the finder pattern which will confuse the decoder.
        // we choose the mask which results in the lowest score among 8 possible ones.
        //
        // note: zxing seems to use the same procedure and in many cases its choice
        // agrees to ours, but sometimes it does not. practically it doesn't matter.
        const evaluatematrix = function (matrix) {
          // N1+(k-5) points for each consecutive row of k same-colored modules,
          // where k >= 5. no overlapping row counts.
          const PENALTY_CONSECUTIVE = 3;
          // N2 points for each 2x2 block of same-colored modules.
          // overlapping block does count.
          const PENALTY_TWOBYTWO = 3;
          // N3 points for each pattern with >4W:1B:1W:3B:1W:1B or
          // 1B:1W:3B:1W:1B:>4W, or their multiples (e.g. highly unlikely,
          // but 13W:3B:3W:9B:3W:3B counts).
          const PENALTY_FINDERLIKE = 40;
          // N4*k points for every (5*k)% deviation from 50% black density.
          // i.e. k=1 for 55~60% and 40~45%, k=2 for 60~65% and 35~40%, etc.
          const PENALTY_DENSITY = 10;

          const evaluategroup = function (groups) { // assumes [W,B,W,B,W,...,B,W]
            let score = 0;
            for (var i = 0; i < groups.length; ++i) {
              if (groups[i] >= 5) score += PENALTY_CONSECUTIVE + (groups[i] - 5);
            }
            for (var i = 5; i < groups.length; i += 2) {
              const p = groups[i];
              if (groups[i - 1] == p && groups[i - 2] == 3 * p && groups[i - 3] == p
				&& groups[i - 4] == p && (groups[i - 5] >= 4 * p || groups[i + 1] >= 4 * p)) {
                // this part differs from zxing...
                score += PENALTY_FINDERLIKE;
              }
            }
            return score;
          };

          const n = matrix.length;
          let score = 0; let
            nblacks = 0;
          for (let i = 0; i < n; ++i) {
            const row = matrix[i];
            var groups;

            // evaluate the current row
            groups = [0]; // the first empty group of white
            for (var j = 0; j < n;) {
              var k;
              for (k = 0; j < n && row[j]; ++k) ++j;
              groups.push(k);
              for (k = 0; j < n && !row[j]; ++k) ++j;
              groups.push(k);
            }
            score += evaluategroup(groups);

            // evaluate the current column
            groups = [0];
            for (var j = 0; j < n;) {
              var k;
              for (k = 0; j < n && matrix[j][i]; ++k) ++j;
              groups.push(k);
              for (k = 0; j < n && !matrix[j][i]; ++k) ++j;
              groups.push(k);
            }
            score += evaluategroup(groups);

            // check the 2x2 box and calculate the density
            const nextrow = matrix[i + 1] || [];
            nblacks += row[0];
            for (var j = 1; j < n; ++j) {
              const p = row[j];
              nblacks += p;
              // at least comparison with next row should be strict...
              if (row[j - 1] == p && nextrow[j] === p && nextrow[j - 1] === p) {
                score += PENALTY_TWOBYTWO;
              }
            }
          }

          score += PENALTY_DENSITY * ((Math.abs(nblacks / n / n - 0.5) / 0.05) | 0);
          return score;
        };

        // returns the fully encoded QR code matrix which contains given data.
        // it also chooses the best mask automatically when mask is -1.
        const generate = function (data, ver, mode, ecclevel, mask) {
          const v = VERSIONS[ver];
          let buf = encode(ver, mode, data, ndatabits(ver, ecclevel) >> 3);
          buf = augumenteccs(buf, v[1][ecclevel], GF256_GENPOLY[v[0][ecclevel]]);

          const result = makebasematrix(ver);
          const { matrix } = result;
          const { reserved } = result;
          putdata(matrix, reserved, buf);

          if (mask < 0) {
            // find the best mask
            maskdata(matrix, reserved, 0);
            putformatinfo(matrix, reserved, ecclevel, 0);
            let bestmask = 0; let
              bestscore = evaluatematrix(matrix);
            maskdata(matrix, reserved, 0);
            for (mask = 1; mask < 8; ++mask) {
              maskdata(matrix, reserved, mask);
              putformatinfo(matrix, reserved, ecclevel, mask);
              const score = evaluatematrix(matrix);
              if (bestscore > score) {
                bestscore = score;
                bestmask = mask;
              }
              maskdata(matrix, reserved, mask);
            }
            mask = bestmask;
          }

          maskdata(matrix, reserved, mask);
          putformatinfo(matrix, reserved, ecclevel, mask);
          return matrix;
        };

        // the public interface is trivial; the options available are as follows:
        //
        // - version: an integer in [1,40]. when omitted (or -1) the smallest possible
        //   version is chosen.
        // - mode: one of 'numeric', 'alphanumeric', 'octet'. when omitted the smallest
        //   possible mode is chosen.
        // - eccLevel: one of 'L', 'M', 'Q', 'H'. defaults to 'L'.
        // - mask: an integer in [0,7]. when omitted (or -1) the best mask is chosen.
        //

        function generateFrame(data, options) {
          const MODES = {
            numeric: MODE_NUMERIC,
            alphanumeric: MODE_ALPHANUMERIC,
            octet: MODE_OCTET,
          };
          const ECCLEVELS = {
            L: ECCLEVEL_L,
            M: ECCLEVEL_M,
            Q: ECCLEVEL_Q,
            H: ECCLEVEL_H,
          };

          options = options || {};
          let ver = options.version || -1;
          const ecclevel = ECCLEVELS[(options.eccLevel || 'L').toUpperCase()];
          let mode = options.mode ? MODES[options.mode.toLowerCase()] : -1;
          const mask = 'mask' in options ? options.mask : -1;

          if (mode < 0) {
            if (typeof data === 'string') {
              if (data.match(NUMERIC_REGEXP)) {
                mode = MODE_NUMERIC;
              } else if (data.match(ALPHANUMERIC_OUT_REGEXP)) {
                // while encode supports case-insensitive encoding, we restrict the data to be uppercased when auto-selecting the mode.
                mode = MODE_ALPHANUMERIC;
              } else {
                mode = MODE_OCTET;
              }
            } else {
              mode = MODE_OCTET;
            }
          } else if (!(mode == MODE_NUMERIC || mode == MODE_ALPHANUMERIC
		|| mode == MODE_OCTET)) {
            throw 'invalid or unsupported mode';
          }

          data = validatedata(mode, data);
          if (data === null) throw 'invalid data format';

          if (ecclevel < 0 || ecclevel > 3) throw 'invalid ECC level';

          if (ver < 0) {
            for (ver = 1; ver <= 40; ++ver) {
              if (data.length <= getmaxdatalen(ver, mode, ecclevel)) break;
            }
            if (ver > 40) throw 'too large data for the Qr format';
          } else if (ver < 1 || ver > 40) {
            throw 'invalid Qr version! should be between 1 and 40';
          }

          if (mask != -1 && (mask < 0 || mask > 8)) throw 'invalid mask';
          // console.log('version:', ver, 'mode:', mode, 'ECC:', ecclevel, 'mask:', mask )
          return generate(data, ver, mode, ecclevel, mask);
        }

        // options
        // - modulesize: a number. this is a size of each modules in pixels, and
        //   defaults to 5px.
        // - margin: a number. this is a size of margin in *modules*, and defaults to
        //   4 (white modules). the specficiation mandates the margin no less than 4
        //   modules, so it is better not to alter this value unless you know what
        //   you're doing.
        function buildCanvas(data, options) {
          const canvas = [];
          const background = options.background || '#fff';
          const foreground = options.foreground || '#000';
          // var margin = options.margin || 4;
          const matrix = generateFrame(data, options);
          const n = matrix.length;
          const modSize = Math.floor(options.fit ? options.fit / n : 5);
          const size = n * modSize;

          canvas.push({
            type: 'rect',
            x: 0,
            y: 0,
            w: size,
            h: size,
            lineWidth: 0,
            color: background,
          });

          for (let i = 0; i < n; ++i) {
            for (let j = 0; j < n; ++j) {
              if (matrix[i][j]) {
                canvas.push({
                  type: 'rect',
                  x: modSize * j,
                  y: modSize * i,
                  w: modSize,
                  h: modSize,
                  lineWidth: 0,
                  color: foreground,
                });
              }
            }
          }

          return {
            canvas,
            size,
          };
        }

        function measure(node) {
          const cd = buildCanvas(node.qr, node);
          node._canvas = cd.canvas;
          node._width = node._height = node._minWidth = node._maxWidth = node._minHeight = node._maxHeight = cd.size;
          return node;
        }

        module.exports = {
          measure,
        };
        /***/ }),

      /***/ 4762:
      /***/ (function (module) {
        module.exports = {
          '4A0': [4767.87, 6740.79],
          '2A0': [3370.39, 4767.87],
          A0: [2383.94, 3370.39],
          A1: [1683.78, 2383.94],
          A2: [1190.55, 1683.78],
          A3: [841.89, 1190.55],
          A4: [595.28, 841.89],
          A5: [419.53, 595.28],
          A6: [297.64, 419.53],
          A7: [209.76, 297.64],
          A8: [147.40, 209.76],
          A9: [104.88, 147.40],
          A10: [73.70, 104.88],
          B0: [2834.65, 4008.19],
          B1: [2004.09, 2834.65],
          B2: [1417.32, 2004.09],
          B3: [1000.63, 1417.32],
          B4: [708.66, 1000.63],
          B5: [498.90, 708.66],
          B6: [354.33, 498.90],
          B7: [249.45, 354.33],
          B8: [175.75, 249.45],
          B9: [124.72, 175.75],
          B10: [87.87, 124.72],
          C0: [2599.37, 3676.54],
          C1: [1836.85, 2599.37],
          C2: [1298.27, 1836.85],
          C3: [918.43, 1298.27],
          C4: [649.13, 918.43],
          C5: [459.21, 649.13],
          C6: [323.15, 459.21],
          C7: [229.61, 323.15],
          C8: [161.57, 229.61],
          C9: [113.39, 161.57],
          C10: [79.37, 113.39],
          RA0: [2437.80, 3458.27],
          RA1: [1729.13, 2437.80],
          RA2: [1218.90, 1729.13],
          RA3: [864.57, 1218.90],
          RA4: [609.45, 864.57],
          SRA0: [2551.18, 3628.35],
          SRA1: [1814.17, 2551.18],
          SRA2: [1275.59, 1814.17],
          SRA3: [907.09, 1275.59],
          SRA4: [637.80, 907.09],
          EXECUTIVE: [521.86, 756.00],
          FOLIO: [612.00, 936.00],
          LEGAL: [612.00, 1008.00],
          LETTER: [612.00, 792.00],
          TABLOID: [792.00, 1224.00],
        };
        /***/ }),

      /***/ 7597:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const { isString } = __webpack_require__(6225);
        const { isArray } = __webpack_require__(6225);
        const { isUndefined } = __webpack_require__(6225);
        const { isNull } = __webpack_require__(6225);

        /**
 * Creates an instance of StyleContextStack used for style inheritance and style overrides
 *
 * @constructor
 * @this {StyleContextStack}
 * @param {Object} named styles dictionary
 * @param {Object} optional default style definition
 */
        function StyleContextStack(styleDictionary, defaultStyle) {
          this.defaultStyle = defaultStyle || {};
          this.styleDictionary = styleDictionary;
          this.styleOverrides = [];
        }

        /**
 * Creates cloned version of current stack
 * @return {StyleContextStack} current stack snapshot
 */
        StyleContextStack.prototype.clone = function () {
          const stack = new StyleContextStack(this.styleDictionary, this.defaultStyle);

          this.styleOverrides.forEach((item) => {
            stack.styleOverrides.push(item);
          });

          return stack;
        };

        /**
 * Pushes style-name or style-overrides-object onto the stack for future evaluation
 *
 * @param {String|Object} styleNameOrOverride style-name (referring to styleDictionary) or
 *                                            a new dictionary defining overriding properties
 */
        StyleContextStack.prototype.push = function (styleNameOrOverride) {
          this.styleOverrides.push(styleNameOrOverride);
        };

        /**
 * Removes last style-name or style-overrides-object from the stack
 *
 * @param {Number} howMany - optional number of elements to be popped (if not specified,
 *                           one element will be removed from the stack)
 */
        StyleContextStack.prototype.pop = function (howMany) {
          howMany = howMany || 1;

          while (howMany-- > 0) {
            this.styleOverrides.pop();
          }
        };

        /**
 * Creates a set of named styles or/and a style-overrides-object based on the item,
 * pushes those elements onto the stack for future evaluation and returns the number
 * of elements pushed, so they can be easily poped then.
 *
 * @param {Object} item - an object with optional style property and/or style overrides
 * @return the number of items pushed onto the stack
 */
        StyleContextStack.prototype.autopush = function (item) {
          if (isString(item)) {
            return 0;
          }

          let styleNames = [];

          if (item.style) {
            if (isArray(item.style)) {
              styleNames = item.style;
            } else {
              styleNames = [item.style];
            }
          }

          for (let i = 0, l = styleNames.length; i < l; i++) {
            this.push(styleNames[i]);
          }

          const styleProperties = [
            'font',
            'fontSize',
            'fontFeatures',
            'bold',
            'italics',
            'alignment',
            'color',
            'columnGap',
            'fillColor',
            'fillOpacity',
            'decoration',
            'decorationStyle',
            'decorationColor',
            'background',
            'lineHeight',
            'characterSpacing',
            'noWrap',
            'markerColor',
            'leadingIndent',
            'sup',
            'sub',
            // 'tableCellPadding'
            // 'cellBorder',
            // 'headerCellBorder',
            // 'oddRowCellBorder',
            // 'evenRowCellBorder',
            // 'tableBorder'
          ];
          const styleOverrideObject = {};
          let pushStyleOverrideObject = false;

          styleProperties.forEach((key) => {
            if (!isUndefined(item[key]) && !isNull(item[key])) {
              styleOverrideObject[key] = item[key];
              pushStyleOverrideObject = true;
            }
          });

          if (pushStyleOverrideObject) {
            this.push(styleOverrideObject);
          }

          return styleNames.length + (pushStyleOverrideObject ? 1 : 0);
        };

        /**
 * Automatically pushes elements onto the stack, using autopush based on item,
 * executes callback and then pops elements back. Returns value returned by callback
 *
 * @param  {Object}   item - an object with optional style property and/or style overrides
 * @param  {Function} function to be called between autopush and pop
 * @return {Object} value returned by callback
 */
        StyleContextStack.prototype.auto = function (item, callback) {
          const pushedItems = this.autopush(item);
          const result = callback();

          if (pushedItems > 0) {
            this.pop(pushedItems);
          }

          return result;
        };

        /**
 * Evaluates stack and returns value of a named property
 *
 * @param {String} property - property name
 * @return property value or null if not found
 */
        StyleContextStack.prototype.getProperty = function (property) {
          if (this.styleOverrides) {
            for (let i = this.styleOverrides.length - 1; i >= 0; i--) {
              const item = this.styleOverrides[i];

              if (isString(item)) {
                // named-style-override
                const style = this.styleDictionary[item];
                if (style && !isUndefined(style[property]) && !isNull(style[property])) {
                  return style[property];
                }
              } else if (!isUndefined(item[property]) && !isNull(item[property])) {
                // style-overrides-object
                return item[property];
              }
            }
          }

          return this.defaultStyle && this.defaultStyle[property];
        };

        module.exports = StyleContextStack;
        /***/ }),

      /***/ 7601:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const xmldoc = __webpack_require__(6513);

        /** Strip unit postfix, parse number, but return undefined instead of NaN for bad input */
        function stripUnits(textVal) {
          const n = parseFloat(textVal);
          if (typeof n !== 'number' || isNaN(n)) {
            return undefined;
          }
          return n;
        }

        /** Make sure it's valid XML and the root tage is <svg/>, returns xmldoc DOM */
        function parseSVG(svgString) {
          let doc;

          try {
            doc = new xmldoc.XmlDocument(svgString);
          } catch (err) {
            throw new Error(`SVGMeasure: ${err}`);
          }

          if (doc.name !== 'svg') {
            throw new Error('SVGMeasure: expected <svg> document');
          }

          return doc;
        }

        function SVGMeasure() {
        }

        SVGMeasure.prototype.measureSVG = function (svgString) {
          const doc = parseSVG(svgString);

          let docWidth = stripUnits(doc.attr.width);
          let docHeight = stripUnits(doc.attr.height);

          if ((docWidth == undefined || docHeight == undefined) && typeof doc.attr.viewBox === 'string') {
            const viewBoxParts = doc.attr.viewBox.split(/[,\s]+/);
            if (viewBoxParts.length !== 4) {
              throw new Error(`Unexpected svg viewbox format, should have 4 entries but found: '${doc.attr.viewBox}'`);
            }
            if (docWidth == undefined) {
              docWidth = stripUnits(viewBoxParts[2]);
            }
            if (docHeight == undefined) {
              docHeight = stripUnits(viewBoxParts[3]);
            }
          }

          return {
            width: docWidth,
            height: docHeight,
          };
        };

        SVGMeasure.prototype.writeDimensions = function (svgString, dimensions) {
          const doc = parseSVG(svgString);

          doc.attr.width = `${dimensions.width}`;
          doc.attr.height = `${dimensions.height}`;

          return doc.toString();
        };

        module.exports = SVGMeasure;
        /***/ }),

      /***/ 9342:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const ColumnCalculator = __webpack_require__(4498);
        const { isFunction } = __webpack_require__(6225);
        const { isNumber } = __webpack_require__(6225);

        function TableProcessor(tableNode) {
          this.tableNode = tableNode;
        }

        TableProcessor.prototype.beginTable = function (writer) {
          let tableNode;
          let availableWidth;
          const self = this;

          tableNode = this.tableNode;
          this.offsets = tableNode._offsets;
          this.layout = tableNode._layout;

          availableWidth = writer.context().availableWidth - this.offsets.total;
          ColumnCalculator.buildColumnWidths(tableNode.table.widths, availableWidth);

          this.tableWidth = tableNode._offsets.total + getTableInnerContentWidth();
          this.rowSpanData = prepareRowSpanData();
          this.cleanUpRepeatables = false;

          this.headerRows = tableNode.table.headerRows || 0;
          this.rowsWithoutPageBreak = this.headerRows + (tableNode.table.keepWithHeaderRows || 0);
          this.dontBreakRows = tableNode.table.dontBreakRows || false;

          if (this.rowsWithoutPageBreak) {
            writer.beginUnbreakableBlock();
          }

          // update the border properties of all cells before drawing any lines
          prepareCellBorders(this.tableNode.table.body);

          this.drawHorizontalLine(0, writer);

          function getTableInnerContentWidth() {
            let width = 0;

            tableNode.table.widths.forEach((w) => {
              width += w._calcWidth;
            });

            return width;
          }

          function prepareRowSpanData() {
            const rsd = [];
            let x = 0;
            let lastWidth = 0;

            rsd.push({ left: 0, rowSpan: 0 });

            for (let i = 0, l = self.tableNode.table.body[0].length; i < l; i++) {
              const paddings = self.layout.paddingLeft(i, self.tableNode) + self.layout.paddingRight(i, self.tableNode);
              const lBorder = self.layout.vLineWidth(i, self.tableNode);
              lastWidth = paddings + lBorder + self.tableNode.table.widths[i]._calcWidth;
              rsd[rsd.length - 1].width = lastWidth;
              x += lastWidth;
              rsd.push({ left: x, rowSpan: 0, width: 0 });
            }

            return rsd;
          }

          // Iterate through all cells. If the current cell is the start of a
          // rowSpan/colSpan, update the border property of the cells on its
          // bottom/right accordingly. This is needed since each iteration of the
          // line-drawing loops draws lines for a single cell, not for an entire
          // rowSpan/colSpan.
          function prepareCellBorders(body) {
            for (let rowIndex = 0; rowIndex < body.length; rowIndex++) {
              const row = body[rowIndex];

              for (let colIndex = 0; colIndex < row.length; colIndex++) {
                const cell = row[colIndex];

                if (cell.border) {
                  const rowSpan = cell.rowSpan || 1;
                  const colSpan = cell.colSpan || 1;

                  for (let rowOffset = 0; rowOffset < rowSpan; rowOffset++) {
                    // set left border
                    if (cell.border[0] !== undefined && rowOffset > 0) {
                      setBorder(rowIndex + rowOffset, colIndex, 0, cell.border[0]);
                    }

                    // set right border
                    if (cell.border[2] !== undefined) {
                      setBorder(rowIndex + rowOffset, colIndex + colSpan - 1, 2, cell.border[2]);
                    }
                  }

                  for (let colOffset = 0; colOffset < colSpan; colOffset++) {
                    // set top border
                    if (cell.border[1] !== undefined && colOffset > 0) {
                      setBorder(rowIndex, colIndex + colOffset, 1, cell.border[1]);
                    }

                    // set bottom border
                    if (cell.border[3] !== undefined) {
                      setBorder(rowIndex + rowSpan - 1, colIndex + colOffset, 3, cell.border[3]);
                    }
                  }
                }
              }
            }

            // helper function to set the border for a given cell
            function setBorder(rowIndex, colIndex, borderIndex, borderValue) {
              const cell = body[rowIndex][colIndex];
              cell.border = cell.border || {};
              cell.border[borderIndex] = borderValue;
            }
          }
        };

        TableProcessor.prototype.onRowBreak = function (rowIndex, writer) {
          const self = this;
          return function () {
            const offset = self.rowPaddingTop + (!self.headerRows ? self.topLineWidth : 0);
            writer.context().availableHeight -= self.reservedAtBottom;
            writer.context().moveDown(offset);
          };
        };

        TableProcessor.prototype.beginRow = function (rowIndex, writer) {
          this.topLineWidth = this.layout.hLineWidth(rowIndex, this.tableNode);
          this.rowPaddingTop = this.layout.paddingTop(rowIndex, this.tableNode);
          this.bottomLineWidth = this.layout.hLineWidth(rowIndex + 1, this.tableNode);
          this.rowPaddingBottom = this.layout.paddingBottom(rowIndex, this.tableNode);

          this.rowCallback = this.onRowBreak(rowIndex, writer);
          writer.tracker.startTracking('pageChanged', this.rowCallback);
          if (this.dontBreakRows) {
            writer.beginUnbreakableBlock();
          }
          this.rowTopY = writer.context().y;
          this.reservedAtBottom = this.bottomLineWidth + this.rowPaddingBottom;

          writer.context().availableHeight -= this.reservedAtBottom;

          writer.context().moveDown(this.rowPaddingTop);
        };

        TableProcessor.prototype.drawHorizontalLine = function (lineIndex, writer, overrideY) {
          const lineWidth = this.layout.hLineWidth(lineIndex, this.tableNode);
          if (lineWidth) {
            const style = this.layout.hLineStyle(lineIndex, this.tableNode);
            let dash;
            if (style && style.dash) {
              dash = style.dash;
            }

            const offset = lineWidth / 2;
            let currentLine = null;
            const { body } = this.tableNode.table;
            let cellAbove;
            let currentCell;
            let rowCellAbove;

            for (let i = 0, l = this.rowSpanData.length; i < l; i++) {
              const data = this.rowSpanData[i];
              let shouldDrawLine = !data.rowSpan;
              let borderColor = null;

              // draw only if the current cell requires a top border or the cell in the
              // row above requires a bottom border
              if (shouldDrawLine && i < l - 1) {
                var topBorder = false; var bottomBorder = false; var
                  rowBottomBorder = false;

                // the cell in the row above
                if (lineIndex > 0) {
                  cellAbove = body[lineIndex - 1][i];
                  bottomBorder = cellAbove.border ? cellAbove.border[3] : this.layout.defaultBorder;
                  if (bottomBorder && cellAbove.borderColor) {
                    borderColor = cellAbove.borderColor[3];
                  }
                }

                // the current cell
                if (lineIndex < body.length) {
                  currentCell = body[lineIndex][i];
                  topBorder = currentCell.border ? currentCell.border[1] : this.layout.defaultBorder;
                  if (topBorder && borderColor == null && currentCell.borderColor) {
                    borderColor = currentCell.borderColor[1];
                  }
                }

                shouldDrawLine = topBorder || bottomBorder;
              }

              if (cellAbove && cellAbove._rowSpanCurrentOffset) {
                rowCellAbove = body[lineIndex - 1 - cellAbove._rowSpanCurrentOffset][i];
                rowBottomBorder = rowCellAbove && rowCellAbove.border ? rowCellAbove.border[3] : this.layout.defaultBorder;
                if (rowBottomBorder && rowCellAbove && rowCellAbove.borderColor) {
                  borderColor = rowCellAbove.borderColor[3];
                }
              }

              if (borderColor == null) {
                borderColor = isFunction(this.layout.hLineColor) ? this.layout.hLineColor(lineIndex, this.tableNode, i) : this.layout.hLineColor;
              }

              if (!currentLine && shouldDrawLine) {
                currentLine = { left: data.left, width: 0 };
              }

              if (shouldDrawLine) {
                let colSpanIndex = 0;
                if (rowCellAbove && rowCellAbove.colSpan && rowBottomBorder) {
                  while (rowCellAbove.colSpan > colSpanIndex) {
                    currentLine.width += (this.rowSpanData[i + colSpanIndex++].width || 0);
                  }
                  i += colSpanIndex - 1;
                } else if (cellAbove && cellAbove.colSpan && bottomBorder) {
                  while (cellAbove.colSpan > colSpanIndex) {
                    currentLine.width += (this.rowSpanData[i + colSpanIndex++].width || 0);
                  }
                  i += colSpanIndex - 1;
                } else if (currentCell && currentCell.colSpan && topBorder) {
                  while (currentCell.colSpan > colSpanIndex) {
                    currentLine.width += (this.rowSpanData[i + colSpanIndex++].width || 0);
                  }
                  i += colSpanIndex - 1;
                } else {
                  currentLine.width += (this.rowSpanData[i].width || 0);
                }
              }

              const y = (overrideY || 0) + offset;

              if (shouldDrawLine) {
                if (currentLine && currentLine.width) {
                  writer.addVector({
                    type: 'line',
                    x1: currentLine.left,
                    x2: currentLine.left + currentLine.width,
                    y1: y,
                    y2: y,
                    lineWidth,
                    dash,
                    lineColor: borderColor,
                  }, false, overrideY);
                  currentLine = null;
                  borderColor = null;
                  cellAbove = null;
                  currentCell = null;
                  rowCellAbove = null;
                }
              }
            }

            writer.context().moveDown(lineWidth);
          }
        };

        TableProcessor.prototype.drawVerticalLine = function (x, y0, y1, vLineColIndex, writer, vLineRowIndex, beforeVLineColIndex) {
          const width = this.layout.vLineWidth(vLineColIndex, this.tableNode);
          if (width === 0) {
            return;
          }
          const style = this.layout.vLineStyle(vLineColIndex, this.tableNode);
          let dash;
          if (style && style.dash) {
            dash = style.dash;
          }

          const { body } = this.tableNode.table;
          let cellBefore;
          let currentCell;
          let borderColor;

          // the cell in the col before
          if (vLineColIndex > 0) {
            cellBefore = body[vLineRowIndex][beforeVLineColIndex];
            if (cellBefore && cellBefore.borderColor) {
              if (cellBefore.border ? cellBefore.border[2] : this.layout.defaultBorder) {
                borderColor = cellBefore.borderColor[2];
              }
            }
          }

          // the current cell
          if (borderColor == null && vLineColIndex < body.length) {
            currentCell = body[vLineRowIndex][vLineColIndex];
            if (currentCell && currentCell.borderColor) {
              if (currentCell.border ? currentCell.border[0] : this.layout.defaultBorder) {
                borderColor = currentCell.borderColor[0];
              }
            }
          }

          if (borderColor == null && cellBefore && cellBefore._rowSpanCurrentOffset) {
            const rowCellBeforeAbove = body[vLineRowIndex - cellBefore._rowSpanCurrentOffset][beforeVLineColIndex];
            if (rowCellBeforeAbove.borderColor) {
              if (rowCellBeforeAbove.border ? rowCellBeforeAbove.border[2] : this.layout.defaultBorder) {
                borderColor = rowCellBeforeAbove.borderColor[2];
              }
            }
          }

          if (borderColor == null && currentCell && currentCell._rowSpanCurrentOffset) {
            const rowCurrentCellAbove = body[vLineRowIndex - currentCell._rowSpanCurrentOffset][vLineColIndex];
            if (rowCurrentCellAbove.borderColor) {
              if (rowCurrentCellAbove.border ? rowCurrentCellAbove.border[2] : this.layout.defaultBorder) {
                borderColor = rowCurrentCellAbove.borderColor[2];
              }
            }
          }

          if (borderColor == null) {
            borderColor = isFunction(this.layout.vLineColor) ? this.layout.vLineColor(vLineColIndex, this.tableNode, vLineRowIndex) : this.layout.vLineColor;
          }
          writer.addVector({
            type: 'line',
            x1: x + width / 2,
            x2: x + width / 2,
            y1: y0,
            y2: y1,
            lineWidth: width,
            dash,
            lineColor: borderColor,
          }, false, true);
          cellBefore = null;
          currentCell = null;
          borderColor = null;
        };

        TableProcessor.prototype.endTable = function (writer) {
          if (this.cleanUpRepeatables) {
            writer.popFromRepeatables();
          }
        };

        TableProcessor.prototype.endRow = function (rowIndex, writer, pageBreaks) {
          let l; let
            i;
          const self = this;
          writer.tracker.stopTracking('pageChanged', this.rowCallback);
          writer.context().moveDown(this.layout.paddingBottom(rowIndex, this.tableNode));
          writer.context().availableHeight += this.reservedAtBottom;

          const endingPage = writer.context().page;
          const endingY = writer.context().y;

          const xs = getLineXs();

          const ys = [];

          const hasBreaks = pageBreaks && pageBreaks.length > 0;
          const { body } = this.tableNode.table;

          ys.push({
            y0: this.rowTopY,
            page: hasBreaks ? pageBreaks[0].prevPage : endingPage,
          });

          if (hasBreaks) {
            for (i = 0, l = pageBreaks.length; i < l; i++) {
              const pageBreak = pageBreaks[i];
              ys[ys.length - 1].y1 = pageBreak.prevY;

              ys.push({ y0: pageBreak.y, page: pageBreak.prevPage + 1 });
            }
          }

          ys[ys.length - 1].y1 = endingY;

          const skipOrphanePadding = (ys[0].y1 - ys[0].y0 === this.rowPaddingTop);
          for (let yi = (skipOrphanePadding ? 1 : 0), yl = ys.length; yi < yl; yi++) {
            const willBreak = yi < ys.length - 1;
            const rowBreakWithoutHeader = (yi > 0 && !this.headerRows);
            const hzLineOffset = rowBreakWithoutHeader ? 0 : this.topLineWidth;
            const y1 = ys[yi].y0;
            let y2 = ys[yi].y1;

            if (willBreak) {
              y2 += this.rowPaddingBottom;
            }

            if (writer.context().page != ys[yi].page) {
              writer.context().page = ys[yi].page;

              // TODO: buggy, availableHeight should be updated on every pageChanged event
              // TableProcessor should be pageChanged listener, instead of processRow
              this.reservedAtBottom = 0;
            }

            for (i = 0, l = xs.length; i < l; i++) {
              let leftCellBorder = false;
              let rightCellBorder = false;
              const colIndex = xs[i].index;

              // current cell
              if (colIndex < body[rowIndex].length) {
                var cell = body[rowIndex][colIndex];
                leftCellBorder = cell.border ? cell.border[0] : this.layout.defaultBorder;
                rightCellBorder = cell.border ? cell.border[2] : this.layout.defaultBorder;
              }

              // before cell
              if (colIndex > 0 && !leftCellBorder) {
                var cell = body[rowIndex][colIndex - 1];
                leftCellBorder = cell.border ? cell.border[2] : this.layout.defaultBorder;
              }

              // after cell
              if (colIndex + 1 < body[rowIndex].length && !rightCellBorder) {
                var cell = body[rowIndex][colIndex + 1];
                rightCellBorder = cell.border ? cell.border[0] : this.layout.defaultBorder;
              }

              if (leftCellBorder) {
                this.drawVerticalLine(xs[i].x, y1 - hzLineOffset, y2 + this.bottomLineWidth, xs[i].index, writer, rowIndex, xs[i - 1] ? xs[i - 1].index : null);
              }

              if (i < l - 1) {
                let { fillColor } = body[rowIndex][colIndex];
                let { fillOpacity } = body[rowIndex][colIndex];
                if (!fillColor) {
                  fillColor = isFunction(this.layout.fillColor) ? this.layout.fillColor(rowIndex, this.tableNode, colIndex) : this.layout.fillColor;
                }
                if (!isNumber(fillOpacity)) {
                  fillOpacity = isFunction(this.layout.fillOpacity) ? this.layout.fillOpacity(rowIndex, this.tableNode, colIndex) : this.layout.fillOpacity;
                }
                const { overlayPattern } = body[rowIndex][colIndex];
                const { overlayOpacity } = body[rowIndex][colIndex];
                if (fillColor || overlayPattern) {
                  const widthLeftBorder = leftCellBorder ? this.layout.vLineWidth(colIndex, this.tableNode) : 0;
                  var widthRightBorder;
                  if ((colIndex === 0 || colIndex + 1 == body[rowIndex].length) && !rightCellBorder) {
                    widthRightBorder = this.layout.vLineWidth(colIndex + 1, this.tableNode);
                  } else if (rightCellBorder) {
                    widthRightBorder = this.layout.vLineWidth(colIndex + 1, this.tableNode) / 2;
                  } else {
                    widthRightBorder = 0;
                  }

                  const x1f = this.dontBreakRows ? xs[i].x + widthLeftBorder : xs[i].x + (widthLeftBorder / 2);
                  const y1f = this.dontBreakRows ? y1 : y1 - (hzLineOffset / 2);
                  const x2f = xs[i + 1].x + widthRightBorder;
                  const y2f = this.dontBreakRows ? y2 + this.bottomLineWidth : y2 + (this.bottomLineWidth / 2);
                  const bgWidth = x2f - x1f;
                  const bgHeight = y2f - y1f;
                  if (fillColor) {
                    writer.addVector({
                      type: 'rect',
                      x: x1f,
                      y: y1f,
                      w: bgWidth,
                      h: bgHeight,
                      lineWidth: 0,
                      color: fillColor,
                      fillOpacity,
                    }, false, true, writer.context().backgroundLength[writer.context().page]);
                  }

                  if (overlayPattern) {
                    writer.addVector({
                      type: 'rect',
                      x: x1f,
                      y: y1f,
                      w: bgWidth,
                      h: bgHeight,
                      lineWidth: 0,
                      color: overlayPattern,
                      fillOpacity: overlayOpacity,
                    }, false, true);
                  }
                }
              }
            }

            if (willBreak && this.layout.hLineWhenBroken !== false) {
              this.drawHorizontalLine(rowIndex + 1, writer, y2);
            }
            if (rowBreakWithoutHeader && this.layout.hLineWhenBroken !== false) {
              this.drawHorizontalLine(rowIndex, writer, y1);
            }
          }

          writer.context().page = endingPage;
          writer.context().y = endingY;

          const row = this.tableNode.table.body[rowIndex];
          for (i = 0, l = row.length; i < l; i++) {
            if (row[i].rowSpan) {
              this.rowSpanData[i].rowSpan = row[i].rowSpan;

              // fix colSpans
              if (row[i].colSpan && row[i].colSpan > 1) {
                for (var j = 1; j < row[i].rowSpan; j++) {
                  this.tableNode.table.body[rowIndex + j][i]._colSpan = row[i].colSpan;
                }
              }
              // fix rowSpans
              if (row[i].rowSpan && row[i].rowSpan > 1) {
                for (var j = 1; j < row[i].rowSpan; j++) {
                  this.tableNode.table.body[rowIndex + j][i]._rowSpanCurrentOffset = j;
                }
              }
            }

            if (this.rowSpanData[i].rowSpan > 0) {
              this.rowSpanData[i].rowSpan--;
            }
          }

          this.drawHorizontalLine(rowIndex + 1, writer);

          if (this.headerRows && rowIndex === this.headerRows - 1) {
            this.headerRepeatable = writer.currentBlockToRepeatable();
          }

          if (this.dontBreakRows) {
            writer.tracker.auto('pageChanged',
              () => {
                if (!self.headerRows && self.layout.hLineWhenBroken !== false) {
                  self.drawHorizontalLine(rowIndex, writer);
                }
              },
              () => {
                writer.commitUnbreakableBlock();
              });
          }

          if (this.headerRepeatable && (rowIndex === (this.rowsWithoutPageBreak - 1) || rowIndex === this.tableNode.table.body.length - 1)) {
            writer.commitUnbreakableBlock();
            writer.pushToRepeatables(this.headerRepeatable);
            this.cleanUpRepeatables = true;
            this.headerRepeatable = null;
          }

          function getLineXs() {
            const result = [];
            let cols = 0;

            for (let i = 0, l = self.tableNode.table.body[rowIndex].length; i < l; i++) {
              if (!cols) {
                result.push({ x: self.rowSpanData[i].left, index: i });

                const item = self.tableNode.table.body[rowIndex][i];
                cols = (item._colSpan || item.colSpan || 0);
              }
              if (cols > 0) {
                cols--;
              }
            }

            result.push({ x: self.rowSpanData[self.rowSpanData.length - 1].left, index: self.rowSpanData.length - 1 });

            return result;
          }
        };

        module.exports = TableProcessor;
        /***/ }),

      /***/ 3497:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const { isArray } = __webpack_require__(6225);
        const { isPattern } = __webpack_require__(6225);
        const { getPattern } = __webpack_require__(6225);

        function groupDecorations(line) {
          const groups = []; let
            currentGroup = null;
          for (let i = 0, l = line.inlines.length; i < l; i++) {
            const inline = line.inlines[i];
            let { decoration } = inline;
            if (!decoration) {
              currentGroup = null;
              continue;
            }
            if (!isArray(decoration)) {
              decoration = [decoration];
            }
            const color = inline.decorationColor || inline.color || 'black';
            const style = inline.decorationStyle || 'solid';
            for (let ii = 0, ll = decoration.length; ii < ll; ii++) {
              const decorationItem = decoration[ii];
              if (!currentGroup || decorationItem !== currentGroup.decoration
				|| style !== currentGroup.decorationStyle || color !== currentGroup.decorationColor) {
                currentGroup = {
                  line,
                  decoration: decorationItem,
                  decorationColor: color,
                  decorationStyle: style,
                  inlines: [inline],
                };
                groups.push(currentGroup);
              } else {
                currentGroup.inlines.push(inline);
              }
            }
          }

          return groups;
        }

        function drawDecoration(group, x, y, pdfKitDoc) {
          function maxInline() {
            let max = 0;
            for (let i = 0, l = group.inlines.length; i < l; i++) {
              const inline = group.inlines[i];
              max = inline.fontSize > max ? i : max;
            }
            return group.inlines[max];
          }
          function width() {
            let sum = 0;
            for (let i = 0, l = group.inlines.length; i < l; i++) {
              const justifyShift = (group.inlines[i].justifyShift || 0);
              sum += group.inlines[i].width + justifyShift;
            }
            return sum;
          }
          const firstInline = group.inlines[0];
          const biggerInline = maxInline();
          const totalWidth = width();
          const lineAscent = group.line.getAscenderHeight();
          const ascent = biggerInline.font.ascender / 1000 * biggerInline.fontSize;
          const { height } = biggerInline;
          const descent = height - ascent;

          const lw = 0.5 + Math.floor(Math.max(biggerInline.fontSize - 8, 0) / 2) * 0.12;

          switch (group.decoration) {
            case 'underline':
              y += lineAscent + descent * 0.45;
              break;
            case 'overline':
              y += lineAscent - (ascent * 0.85);
              break;
            case 'lineThrough':
              y += lineAscent - (ascent * 0.25);
              break;
            default:
              throw `Unkown decoration : ${group.decoration}`;
          }
          pdfKitDoc.save();

          if (group.decorationStyle === 'double') {
            const gap = Math.max(0.5, lw * 2);
            pdfKitDoc.fillColor(group.decorationColor)
              .rect(x + firstInline.x, y - lw / 2, totalWidth, lw / 2).fill()
              .rect(x + firstInline.x, y + gap - lw / 2, totalWidth, lw / 2)
              .fill();
          } else if (group.decorationStyle === 'dashed') {
            const nbDashes = Math.ceil(totalWidth / (3.96 + 2.84));
            let rdx = x + firstInline.x;
            pdfKitDoc.rect(rdx, y, totalWidth, lw).clip();
            pdfKitDoc.fillColor(group.decorationColor);
            for (let i = 0; i < nbDashes; i++) {
              pdfKitDoc.rect(rdx, y - lw / 2, 3.96, lw).fill();
              rdx += 3.96 + 2.84;
            }
          } else if (group.decorationStyle === 'dotted') {
            const nbDots = Math.ceil(totalWidth / (lw * 3));
            let rx = x + firstInline.x;
            pdfKitDoc.rect(rx, y, totalWidth, lw).clip();
            pdfKitDoc.fillColor(group.decorationColor);
            for (let ii = 0; ii < nbDots; ii++) {
              pdfKitDoc.rect(rx, y - lw / 2, lw, lw).fill();
              rx += (lw * 3);
            }
          } else if (group.decorationStyle === 'wavy') {
            const sh = 0.7; const
              sv = 1;
            const nbWaves = Math.ceil(totalWidth / (sh * 2)) + 1;
            let rwx = x + firstInline.x - 1;
            pdfKitDoc.rect(x + firstInline.x, y - sv, totalWidth, y + sv).clip();
            pdfKitDoc.lineWidth(0.24);
            pdfKitDoc.moveTo(rwx, y);
            for (let iii = 0; iii < nbWaves; iii++) {
              pdfKitDoc.bezierCurveTo(rwx + sh, y - sv, rwx + sh * 2, y - sv, rwx + sh * 3, y)
                .bezierCurveTo(rwx + sh * 4, y + sv, rwx + sh * 5, y + sv, rwx + sh * 6, y);
              rwx += sh * 6;
            }
            pdfKitDoc.stroke(group.decorationColor);
          } else {
            pdfKitDoc.fillColor(group.decorationColor)
              .rect(x + firstInline.x, y - lw / 2, totalWidth, lw)
              .fill();
          }
          pdfKitDoc.restore();
        }

        function drawDecorations(line, x, y, pdfKitDoc) {
          const groups = groupDecorations(line);
          for (let i = 0, l = groups.length; i < l; i++) {
            drawDecoration(groups[i], x, y, pdfKitDoc);
          }
        }

        function drawBackground(line, x, y, patterns, pdfKitDoc) {
          const height = line.getHeight();
          for (let i = 0, l = line.inlines.length; i < l; i++) {
            const inline = line.inlines[i];
            if (!inline.background) {
              continue;
            }
            let color = inline.background;
            if (isPattern(inline.background)) {
              color = getPattern(inline.background, patterns);
            }
            const justifyShift = (inline.justifyShift || 0);
            pdfKitDoc.fillColor(color)
              .rect(x + inline.x - justifyShift, y, inline.width + justifyShift, height)
              .fill();
          }
        }

        module.exports = {
          drawBackground,
          drawDecorations,
        };
        /***/ }),

      /***/ 1350:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const { isString } = __webpack_require__(6225);
        const { isNumber } = __webpack_require__(6225);
        const { isObject } = __webpack_require__(6225);
        const { isArray } = __webpack_require__(6225);
        const { isUndefined } = __webpack_require__(6225);
        const LineBreaker = __webpack_require__(7337);

        const LEADING = /^(\s)+/g;
        const TRAILING = /(\s)+$/g;

        /**
 * Creates an instance of TextTools - text measurement utility
 *
 * @constructor
 * @param {FontProvider} fontProvider
 */
        function TextTools(fontProvider) {
          this.fontProvider = fontProvider;
        }

        /**
 * Converts an array of strings (or inline-definition-objects) into a collection
 * of inlines and calculated minWidth/maxWidth.
 * and their min/max widths
 * @param  {Object} textArray - an array of inline-definition-objects (or strings)
 * @param  {Object} styleContextStack current style stack
 * @return {Object}                   collection of inlines, minWidth, maxWidth
 */
        TextTools.prototype.buildInlines = function (textArray, styleContextStack) {
          const measured = measure(this.fontProvider, textArray, styleContextStack);

          let minWidth = 0;
          let maxWidth = 0;
          let currentLineWidth;

          measured.forEach((inline) => {
            minWidth = Math.max(minWidth, inline.width - inline.leadingCut - inline.trailingCut);

            if (!currentLineWidth) {
              currentLineWidth = { width: 0, leadingCut: inline.leadingCut, trailingCut: 0 };
            }

            currentLineWidth.width += inline.width;
            currentLineWidth.trailingCut = inline.trailingCut;

            maxWidth = Math.max(maxWidth, getTrimmedWidth(currentLineWidth));

            if (inline.lineEnd) {
              currentLineWidth = null;
            }
          });

          if (getStyleProperty({}, styleContextStack, 'noWrap', false)) {
            minWidth = maxWidth;
          }

          return {
            items: measured,
            minWidth,
            maxWidth,
          };

          function getTrimmedWidth(item) {
            return Math.max(0, item.width - item.leadingCut - item.trailingCut);
          }
        };

        /**
 * Returns size of the specified string (without breaking it) using the current style
 * @param  {String} text              text to be measured
 * @param  {Object} styleContextStack current style stack
 * @return {Object}                   size of the specified string
 */
        TextTools.prototype.sizeOfString = function (text, styleContextStack) {
          text = text ? text.toString().replace(/\t/g, '    ') : '';

          // TODO: refactor - extract from measure
          const fontName = getStyleProperty({}, styleContextStack, 'font', 'Roboto');
          const fontSize = getStyleProperty({}, styleContextStack, 'fontSize', 12);
          const fontFeatures = getStyleProperty({}, styleContextStack, 'fontFeatures', null);
          const bold = getStyleProperty({}, styleContextStack, 'bold', false);
          const italics = getStyleProperty({}, styleContextStack, 'italics', false);
          const lineHeight = getStyleProperty({}, styleContextStack, 'lineHeight', 1);
          const characterSpacing = getStyleProperty({}, styleContextStack, 'characterSpacing', 0);

          const font = this.fontProvider.provideFont(fontName, bold, italics);

          return {
            width: widthOfString(text, font, fontSize, characterSpacing, fontFeatures),
            height: font.lineHeight(fontSize) * lineHeight,
            fontSize,
            lineHeight,
            ascender: font.ascender / 1000 * fontSize,
            descender: font.descender / 1000 * fontSize,
          };
        };

        /**
 * Returns size of the specified rotated string (without breaking it) using the current style
 *
 * @param  {string} text text to be measured
 * @param  {number} angle
 * @param  {object} styleContextStack current style stack
 * @returns {object} size of the specified string
 */
        TextTools.prototype.sizeOfRotatedText = function (text, angle, styleContextStack) {
          const angleRad = angle * Math.PI / -180;
          const size = this.sizeOfString(text, styleContextStack);
          return {
            width: Math.abs(size.height * Math.sin(angleRad)) + Math.abs(size.width * Math.cos(angleRad)),
            height: Math.abs(size.width * Math.sin(angleRad)) + Math.abs(size.height * Math.cos(angleRad)),
          };
        };

        TextTools.prototype.widthOfString = function (text, font, fontSize, characterSpacing, fontFeatures) {
          return widthOfString(text, font, fontSize, characterSpacing, fontFeatures);
        };

        function splitWords(text, noWrap) {
          const results = [];
          text = text.replace(/\t/g, '    ');

          if (noWrap) {
            results.push({ text });
            return results;
          }

          const breaker = new LineBreaker(text);
          let last = 0;
          let bk;

          while (bk = breaker.nextBreak()) {
            let word = text.slice(last, bk.position);

            if (bk.required || word.match(/\r?\n$|\r$/)) { // new line
              word = word.replace(/\r?\n$|\r$/, '');
              results.push({ text: word, lineEnd: true });
            } else {
              results.push({ text: word });
            }

            last = bk.position;
          }

          return results;
        }

        function copyStyle(source, destination) {
          destination = destination || {};
          source = source || {}; // TODO: default style

          for (const key in source) {
            if (key != 'text' && source.hasOwnProperty(key)) {
              destination[key] = source[key];
            }
          }

          return destination;
        }

        function normalizeTextArray(array, styleContextStack) {
          function flatten(array) {
            return array.reduce((prev, cur) => {
              const current = isArray(cur.text) ? flatten(cur.text) : cur;
              const more = [].concat(current).some(Array.isArray);
              return prev.concat(more ? flatten(current) : current);
            }, []);
          }

          function getOneWord(index, words, noWrap) {
            if (isUndefined(words[index])) {
              return null;
            }

            if (words[index].lineEnd) {
              return null;
            }

            let word = words[index].text;

            if (noWrap) {
              const tmpWords = splitWords(normalizeString(word), false);
              if (isUndefined(tmpWords[tmpWords.length - 1])) {
                return null;
              }
              word = tmpWords[tmpWords.length - 1].text;
            }

            return word;
          }

          const results = [];

          if (!isArray(array)) {
            array = [array];
          }

          array = flatten(array);

          let lastWord = null;
          for (let i = 0, l = array.length; i < l; i++) {
            const item = array[i];
            let style = null;
            var words;

            const noWrap = getStyleProperty(item || {}, styleContextStack, 'noWrap', false);
            if (isObject(item)) {
              if (item._textRef && item._textRef._textNodeRef.text) {
                item.text = item._textRef._textNodeRef.text;
              }
              words = splitWords(normalizeString(item.text), noWrap);
              style = copyStyle(item);
            } else {
              words = splitWords(normalizeString(item), noWrap);
            }

            if (lastWord && words.length) {
              const firstWord = getOneWord(0, words, noWrap);

              const wrapWords = splitWords(normalizeString(lastWord + firstWord), false);
              if (wrapWords.length === 1) {
                results[results.length - 1].noNewLine = true;
              }
            }

            for (let i2 = 0, l2 = words.length; i2 < l2; i2++) {
              const result = {
                text: words[i2].text,
              };

              if (words[i2].lineEnd) {
                result.lineEnd = true;
              }

              copyStyle(style, result);

              results.push(result);
            }

            lastWord = null;
            if (i + 1 < l) {
              lastWord = getOneWord(words.length - 1, words, noWrap);
            }
          }

          return results;
        }

        function normalizeString(value) {
          if (value === undefined || value === null) {
            return '';
          } if (isNumber(value)) {
            return value.toString();
          } if (isString(value)) {
            return value;
          }
          return value.toString();
        }

        function getStyleProperty(item, styleContextStack, property, defaultValue) {
          let value;

          if (item[property] !== undefined && item[property] !== null) {
            // item defines this property
            return item[property];
          }

          if (!styleContextStack) {
            return defaultValue;
          }

          styleContextStack.auto(item, () => {
            value = styleContextStack.getProperty(property);
          });

          if (value !== null && value !== undefined) {
            return value;
          }
          return defaultValue;
        }

        function measure(fontProvider, textArray, styleContextStack) {
          const normalized = normalizeTextArray(textArray, styleContextStack);

          if (normalized.length) {
            const leadingIndent = getStyleProperty(normalized[0], styleContextStack, 'leadingIndent', 0);

            if (leadingIndent) {
              normalized[0].leadingCut = -leadingIndent;
              normalized[0].leadingIndent = leadingIndent;
            }
          }

          normalized.forEach((item) => {
            const fontName = getStyleProperty(item, styleContextStack, 'font', 'Roboto');
            let fontSize = getStyleProperty(item, styleContextStack, 'fontSize', 12);
            const fontFeatures = getStyleProperty(item, styleContextStack, 'fontFeatures', null);
            const bold = getStyleProperty(item, styleContextStack, 'bold', false);
            const italics = getStyleProperty(item, styleContextStack, 'italics', false);
            const color = getStyleProperty(item, styleContextStack, 'color', 'black');
            const decoration = getStyleProperty(item, styleContextStack, 'decoration', null);
            const decorationColor = getStyleProperty(item, styleContextStack, 'decorationColor', null);
            const decorationStyle = getStyleProperty(item, styleContextStack, 'decorationStyle', null);
            const background = getStyleProperty(item, styleContextStack, 'background', null);
            const lineHeight = getStyleProperty(item, styleContextStack, 'lineHeight', 1);
            const characterSpacing = getStyleProperty(item, styleContextStack, 'characterSpacing', 0);
            const link = getStyleProperty(item, styleContextStack, 'link', null);
            const linkToPage = getStyleProperty(item, styleContextStack, 'linkToPage', null);
            const linkToDestination = getStyleProperty(item, styleContextStack, 'linkToDestination', null);
            const noWrap = getStyleProperty(item, styleContextStack, 'noWrap', null);
            const preserveLeadingSpaces = getStyleProperty(item, styleContextStack, 'preserveLeadingSpaces', false);
            const preserveTrailingSpaces = getStyleProperty(item, styleContextStack, 'preserveTrailingSpaces', false);
            const opacity = getStyleProperty(item, styleContextStack, 'opacity', 1);
            const sup = getStyleProperty(item, styleContextStack, 'sup', false);
            const sub = getStyleProperty(item, styleContextStack, 'sub', false);

            if ((sup || sub) && item.fontSize === undefined) {
              // font size reduction taken from here: https://en.wikipedia.org/wiki/Subscript_and_superscript#Desktop_publishing
              fontSize *= 0.58;
            }

            const font = fontProvider.provideFont(fontName, bold, italics);

            item.width = widthOfString(item.text, font, fontSize, characterSpacing, fontFeatures);
            item.height = font.lineHeight(fontSize) * lineHeight;

            if (!item.leadingCut) {
              item.leadingCut = 0;
            }

            let leadingSpaces;
            if (!preserveLeadingSpaces && (leadingSpaces = item.text.match(LEADING))) {
              item.leadingCut += widthOfString(leadingSpaces[0], font, fontSize, characterSpacing, fontFeatures);
            }

            let trailingSpaces;
            if (!preserveTrailingSpaces && (trailingSpaces = item.text.match(TRAILING))) {
              item.trailingCut = widthOfString(trailingSpaces[0], font, fontSize, characterSpacing, fontFeatures);
            } else {
              item.trailingCut = 0;
            }

            item.alignment = getStyleProperty(item, styleContextStack, 'alignment', 'left');
            item.font = font;
            item.fontSize = fontSize;
            item.fontFeatures = fontFeatures;
            item.characterSpacing = characterSpacing;
            item.color = color;
            item.decoration = decoration;
            item.decorationColor = decorationColor;
            item.decorationStyle = decorationStyle;
            item.background = background;
            item.link = link;
            item.linkToPage = linkToPage;
            item.linkToDestination = linkToDestination;
            item.noWrap = noWrap;
            item.opacity = opacity;
            item.sup = sup;
            item.sub = sub;
          });

          return normalized;
        }

        function widthOfString(text, font, fontSize, characterSpacing, fontFeatures) {
          return font.widthOfString(text, fontSize, fontFeatures) + ((characterSpacing || 0) * (text.length - 1));
        }

        module.exports = TextTools;
        /***/ }),

      /***/ 8537:
      /***/ (function (module) {
        function TraversalTracker() {
          this.events = {};
        }

        TraversalTracker.prototype.startTracking = function (event, callback) {
          const callbacks = this.events[event] || (this.events[event] = []);

          if (callbacks.indexOf(callback) < 0) {
            callbacks.push(callback);
          }
        };

        TraversalTracker.prototype.stopTracking = function (event, callback) {
          const callbacks = this.events[event];

          if (!callbacks) {
            return;
          }

          const index = callbacks.indexOf(callback);
          if (index >= 0) {
            callbacks.splice(index, 1);
          }
        };

        TraversalTracker.prototype.emit = function (event) {
          const args = Array.prototype.slice.call(arguments, 1);
          const callbacks = this.events[event];

          if (!callbacks) {
            return;
          }

          callbacks.forEach(function (callback) {
            callback.apply(this, args);
          });
        };

        TraversalTracker.prototype.auto = function (event, callback, innerFunction) {
          this.startTracking(event, callback);
          innerFunction();
          this.stopTracking(event, callback);
        };

        module.exports = TraversalTracker;
        /***/ }),

      /***/ 2480:
      /***/ (function () {

        /* (ignored) */

        /***/ }),

      /***/ 5832:
      /***/ (function () {

        /* (ignored) */

        /***/ }),

      /***/ 9862:
      /***/ (function () {

        /* (ignored) */

        /***/ }),

      /***/ 964:
      /***/ (function () {

        /* (ignored) */

        /***/ }),

      /***/ 3083:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const possibleNames = [
          'BigInt64Array',
          'BigUint64Array',
          'Float32Array',
          'Float64Array',
          'Int16Array',
          'Int32Array',
          'Int8Array',
          'Uint16Array',
          'Uint32Array',
          'Uint8Array',
          'Uint8ClampedArray',
        ];

        const g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;

        module.exports = function availableTypedArrays() {
          const out = [];
          for (let i = 0; i < possibleNames.length; i++) {
            if (typeof g[possibleNames[i]] === 'function') {
              out[out.length] = possibleNames[i];
            }
          }
          return out;
        };
        /***/ }),

      /***/ 882:
      /***/ (function (module, __unused_webpack_exports, __webpack_require__) {
        const GetIntrinsic = __webpack_require__(210);

        let $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
        if ($gOPD) {
          try {
            $gOPD([], 'length');
          } catch (e) {
            // IE 8 has a broken gOPD
            $gOPD = null;
          }
        }

        module.exports = $gOPD;
        /***/ }),

      /***/ 3480:
      /***/ (function (module) {
        module.exports = JSON.parse('[["8740","䏰䰲䘃䖦䕸𧉧䵷䖳𧲱䳢𧳅㮕䜶䝄䱇䱀𤊿𣘗𧍒𦺋𧃒䱗𪍑䝏䗚䲅𧱬䴇䪤䚡𦬣爥𥩔𡩣𣸆𣽡晍囻"],["8767","綕夝𨮹㷴霴𧯯寛𡵞媤㘥𩺰嫑宷峼杮薓𩥅瑡璝㡵𡵓𣚞𦀡㻬"],["87a1","𥣞㫵竼龗𤅡𨤍𣇪𠪊𣉞䌊蒄龖鐯䤰蘓墖靊鈘秐稲晠権袝瑌篅枂稬剏遆㓦珄𥶹瓆鿇垳䤯呌䄱𣚎堘穲𧭥讏䚮𦺈䆁𥶙箮𢒼鿈𢓁𢓉𢓌鿉蔄𣖻䂴鿊䓡𪷿拁灮鿋"],["8840","㇀",4,"𠄌㇅𠃑𠃍㇆㇇𠃋𡿨㇈𠃊㇉㇊㇋㇌𠄎㇍㇎ĀÁǍÀĒÉĚÈŌÓǑÒ࿿Ê̄Ế࿿Ê̌ỀÊāáǎàɑēéěèīíǐìōóǒòūúǔùǖǘǚ"],["88a1","ǜü࿿ê̄ế࿿ê̌ềêɡ⏚⏛"],["8940","𪎩𡅅"],["8943","攊"],["8946","丽滝鵎釟"],["894c","𧜵撑会伨侨兖兴农凤务动医华发变团声处备夲头学实実岚庆总斉柾栄桥济炼电纤纬纺织经统缆缷艺苏药视设询车轧轮"],["89a1","琑糼緍楆竉刧"],["89ab","醌碸酞肼"],["89b0","贋胶𠧧"],["89b5","肟黇䳍鷉鸌䰾𩷶𧀎鸊𪄳㗁"],["89c1","溚舾甙"],["89c5","䤑马骏龙禇𨑬𡷊𠗐𢫦两亁亀亇亿仫伷㑌侽㹈倃傈㑽㒓㒥円夅凛凼刅争剹劐匧㗇厩㕑厰㕓参吣㕭㕲㚁咓咣咴咹哐哯唘唣唨㖘唿㖥㖿嗗㗅"],["8a40","𧶄唥"],["8a43","𠱂𠴕𥄫喐𢳆㧬𠍁蹆𤶸𩓥䁓𨂾睺𢰸㨴䟕𨅝𦧲𤷪擝𠵼𠾴𠳕𡃴撍蹾𠺖𠰋𠽤𢲩𨉖𤓓"],["8a64","𠵆𩩍𨃩䟴𤺧𢳂骲㩧𩗴㿭㔆𥋇𩟔𧣈𢵄鵮頕"],["8a76","䏙𦂥撴哣𢵌𢯊𡁷㧻𡁯"],["8aa1","𦛚𦜖𧦠擪𥁒𠱃蹨𢆡𨭌𠜱"],["8aac","䠋𠆩㿺塳𢶍"],["8ab2","𤗈𠓼𦂗𠽌𠶖啹䂻䎺"],["8abb","䪴𢩦𡂝膪飵𠶜捹㧾𢝵跀嚡摼㹃"],["8ac9","𪘁𠸉𢫏𢳉"],["8ace","𡃈𣧂㦒㨆𨊛㕸𥹉𢃇噒𠼱𢲲𩜠㒼氽𤸻"],["8adf","𧕴𢺋𢈈𪙛𨳍𠹺𠰴𦠜羓𡃏𢠃𢤹㗻𥇣𠺌𠾍𠺪㾓𠼰𠵇𡅏𠹌"],["8af6","𠺫𠮩𠵈𡃀𡄽㿹𢚖搲𠾭"],["8b40","𣏴𧘹𢯎𠵾𠵿𢱑𢱕㨘𠺘𡃇𠼮𪘲𦭐𨳒𨶙𨳊閪哌苄喹"],["8b55","𩻃鰦骶𧝞𢷮煀腭胬尜𦕲脴㞗卟𨂽醶𠻺𠸏𠹷𠻻㗝𤷫㘉𠳖嚯𢞵𡃉𠸐𠹸𡁸𡅈𨈇𡑕𠹹𤹐𢶤婔𡀝𡀞𡃵𡃶垜𠸑"],["8ba1","𧚔𨋍𠾵𠹻𥅾㜃𠾶𡆀𥋘𪊽𤧚𡠺𤅷𨉼墙剨㘚𥜽箲孨䠀䬬鼧䧧鰟鮍𥭴𣄽嗻㗲嚉丨夂𡯁屮靑𠂆乛亻㔾尣彑忄㣺扌攵歺氵氺灬爫丬犭𤣩罒礻糹罓𦉪㓁"],["8bde","𦍋耂肀𦘒𦥑卝衤见𧢲讠贝钅镸长门𨸏韦页风飞饣𩠐鱼鸟黄歯龜丷𠂇阝户钢"],["8c40","倻淾𩱳龦㷉袏𤅎灷峵䬠𥇍㕙𥴰愢𨨲辧釶熑朙玺𣊁𪄇㲋𡦀䬐磤琂冮𨜏䀉橣𪊺䈣蘏𠩯稪𩥇𨫪靕灍匤𢁾鏴盙𨧣龧矝亣俰傼丯众龨吴綋墒壐𡶶庒庙忂𢜒斋"],["8ca1","𣏹椙橃𣱣泿"],["8ca7","爀𤔅玌㻛𤨓嬕璹讃𥲤𥚕窓篬糃繬苸薗龩袐龪躹龫迏蕟駠鈡龬𨶹𡐿䁱䊢娚"],["8cc9","顨杫䉶圽"],["8cce","藖𤥻芿𧄍䲁𦵴嵻𦬕𦾾龭龮宖龯曧繛湗秊㶈䓃𣉖𢞖䎚䔶"],["8ce6","峕𣬚諹屸㴒𣕑嵸龲煗䕘𤃬𡸣䱷㥸㑊𠆤𦱁諌侴𠈹妿腬顖𩣺弻"],["8d40","𠮟"],["8d42","𢇁𨥭䄂䚻𩁹㼇龳𪆵䃸㟖䛷𦱆䅼𨚲𧏿䕭㣔𥒚䕡䔛䶉䱻䵶䗪㿈𤬏㙡䓞䒽䇭崾嵈嵖㷼㠏嶤嶹㠠㠸幂庽弥徃㤈㤔㤿㥍惗愽峥㦉憷憹懏㦸戬抐拥挘㧸嚱"],["8da1","㨃揢揻搇摚㩋擀崕嘡龟㪗斆㪽旿晓㫲暒㬢朖㭂枤栀㭘桊梄㭲㭱㭻椉楃牜楤榟榅㮼槖㯝橥橴橱檂㯬檙㯲檫檵櫔櫶殁毁毪汵沪㳋洂洆洦涁㳯涤涱渕渘温溆𨧀溻滢滚齿滨滩漤漴㵆𣽁澁澾㵪㵵熷岙㶊瀬㶑灐灔灯灿炉𠌥䏁㗱𠻘"],["8e40","𣻗垾𦻓焾𥟠㙎榢𨯩孴穉𥣡𩓙穥穽𥦬窻窰竂竃燑𦒍䇊竚竝竪䇯咲𥰁笋筕笩𥌎𥳾箢筯莜𥮴𦱿篐萡箒箸𥴠㶭𥱥蒒篺簆簵𥳁籄粃𤢂粦晽𤕸糉糇糦籴糳糵糎"],["8ea1","繧䔝𦹄絝𦻖璍綉綫焵綳緒𤁗𦀩緤㴓緵𡟹緥𨍭縝𦄡𦅚繮纒䌫鑬縧罀罁罇礶𦋐駡羗𦍑羣𡙡𠁨䕜𣝦䔃𨌺翺𦒉者耈耝耨耯𪂇𦳃耻耼聡𢜔䦉𦘦𣷣𦛨朥肧𨩈脇脚墰𢛶汿𦒘𤾸擧𡒊舘𡡞橓𤩥𤪕䑺舩𠬍𦩒𣵾俹𡓽蓢荢𦬊𤦧𣔰𡝳𣷸芪椛芳䇛"],["8f40","蕋苐茚𠸖𡞴㛁𣅽𣕚艻苢茘𣺋𦶣𦬅𦮗𣗎㶿茝嗬莅䔋𦶥莬菁菓㑾𦻔橗蕚㒖𦹂𢻯葘𥯤葱㷓䓤檧葊𣲵祘蒨𦮖𦹷𦹃蓞萏莑䒠蒓蓤𥲑䉀𥳀䕃蔴嫲𦺙䔧蕳䔖枿蘖"],["8fa1","𨘥𨘻藁𧂈蘂𡖂𧃍䕫䕪蘨㙈𡢢号𧎚虾蝱𪃸蟮𢰧螱蟚蠏噡虬桖䘏衅衆𧗠𣶹𧗤衞袜䙛袴袵揁装睷𧜏覇覊覦覩覧覼𨨥觧𧤤𧪽誜瞓釾誐𧩙竩𧬺𣾏䜓𧬸煼謌謟𥐰𥕥謿譌譍誩𤩺讐讛誯𡛟䘕衏貛𧵔𧶏貫㜥𧵓賖𧶘𧶽贒贃𡤐賛灜贑𤳉㻐起"],["9040","趩𨀂𡀔𤦊㭼𨆼𧄌竧躭躶軃鋔輙輭𨍥𨐒辥錃𪊟𠩐辳䤪𨧞𨔽𣶻廸𣉢迹𪀔𨚼𨔁𢌥㦀𦻗逷𨔼𧪾遡𨕬𨘋邨𨜓郄𨛦邮都酧㫰醩釄粬𨤳𡺉鈎沟鉁鉢𥖹銹𨫆𣲛𨬌𥗛"],["90a1","𠴱錬鍫𨫡𨯫炏嫃𨫢𨫥䥥鉄𨯬𨰹𨯿鍳鑛躼閅閦鐦閠濶䊹𢙺𨛘𡉼𣸮䧟氜陻隖䅬隣𦻕懚隶磵𨫠隽双䦡𦲸𠉴𦐐𩂯𩃥𤫑𡤕𣌊霱虂霶䨏䔽䖅𤫩灵孁霛靜𩇕靗孊𩇫靟鐥僐𣂷𣂼鞉鞟鞱鞾韀韒韠𥑬韮琜𩐳響韵𩐝𧥺䫑頴頳顋顦㬎𧅵㵑𠘰𤅜"],["9140","𥜆飊颷飈飇䫿𦴧𡛓喰飡飦飬鍸餹𤨩䭲𩡗𩤅駵騌騻騐驘𥜥㛄𩂱𩯕髠髢𩬅髴䰎鬔鬭𨘀倴鬴𦦨㣃𣁽魐魀𩴾婅𡡣鮎𤉋鰂鯿鰌𩹨鷔𩾷𪆒𪆫𪃡𪄣𪇟鵾鶃𪄴鸎梈"],["91a1","鷄𢅛𪆓𪈠𡤻𪈳鴹𪂹𪊴麐麕麞麢䴴麪麯𤍤黁㭠㧥㴝伲㞾𨰫鼂鼈䮖鐤𦶢鼗鼖鼹嚟嚊齅馸𩂋韲葿齢齩竜龎爖䮾𤥵𤦻煷𤧸𤍈𤩑玞𨯚𡣺禟𨥾𨸶鍩鏳𨩄鋬鎁鏋𨥬𤒹爗㻫睲穃烐𤑳𤏸煾𡟯炣𡢾𣖙㻇𡢅𥐯𡟸㜢𡛻𡠹㛡𡝴𡣑𥽋㜣𡛀坛𤨥𡏾𡊨"],["9240","𡏆𡒶蔃𣚦蔃葕𤦔𧅥𣸱𥕜𣻻𧁒䓴𣛮𩦝𦼦柹㜳㰕㷧塬𡤢栐䁗𣜿𤃡𤂋𤄏𦰡哋嚞𦚱嚒𠿟𠮨𠸍鏆𨬓鎜仸儫㠙𤐶亼𠑥𠍿佋侊𥙑婨𠆫𠏋㦙𠌊𠐔㐵伩𠋀𨺳𠉵諚𠈌亘"],["92a1","働儍侢伃𤨎𣺊佂倮偬傁俌俥偘僼兙兛兝兞湶𣖕𣸹𣺿浲𡢄𣺉冨凃𠗠䓝𠒣𠒒𠒑赺𨪜𠜎剙劤𠡳勡鍮䙺熌𤎌𠰠𤦬𡃤槑𠸝瑹㻞璙琔瑖玘䮎𤪼𤂍叐㖄爏𤃉喴𠍅响𠯆圝鉝雴鍦埝垍坿㘾壋媙𨩆𡛺𡝯𡜐娬妸銏婾嫏娒𥥆𡧳𡡡𤊕㛵洅瑃娡𥺃"],["9340","媁𨯗𠐓鏠璌𡌃焅䥲鐈𨧻鎽㞠尞岞幞幈𡦖𡥼𣫮廍孏𡤃𡤄㜁𡢠㛝𡛾㛓脪𨩇𡶺𣑲𨦨弌弎𡤧𡞫婫𡜻孄蘔𧗽衠恾𢡠𢘫忛㺸𢖯𢖾𩂈𦽳懀𠀾𠁆𢘛憙憘恵𢲛𢴇𤛔𩅍"],["93a1","摱𤙥𢭪㨩𢬢𣑐𩣪𢹸挷𪑛撶挱揑𤧣𢵧护𢲡搻敫楲㯴𣂎𣊭𤦉𣊫唍𣋠𡣙𩐿曎𣊉𣆳㫠䆐𥖄𨬢𥖏𡛼𥕛𥐥磮𣄃𡠪𣈴㑤𣈏𣆂𤋉暎𦴤晫䮓昰𧡰𡷫晣𣋒𣋡昞𥡲㣑𣠺𣞼㮙𣞢𣏾瓐㮖枏𤘪梶栞㯄檾㡣𣟕𤒇樳橒櫉欅𡤒攑梘橌㯗橺歗𣿀𣲚鎠鋲𨯪𨫋"],["9440","銉𨀞𨧜鑧涥漋𤧬浧𣽿㶏渄𤀼娽渊塇洤硂焻𤌚𤉶烱牐犇犔𤞏𤜥兹𤪤𠗫瑺𣻸𣙟𤩊𤤗𥿡㼆㺱𤫟𨰣𣼵悧㻳瓌琼鎇琷䒟𦷪䕑疃㽣𤳙𤴆㽘畕癳𪗆㬙瑨𨫌𤦫𤦎㫻"],["94a1","㷍𤩎㻿𤧅𤣳釺圲鍂𨫣𡡤僟𥈡𥇧睸𣈲眎眏睻𤚗𣞁㩞𤣰琸璛㺿𤪺𤫇䃈𤪖𦆮錇𥖁砞碍碈磒珐祙𧝁𥛣䄎禛蒖禥樭𣻺稺秴䅮𡛦䄲鈵秱𠵌𤦌𠊙𣶺𡝮㖗啫㕰㚪𠇔𠰍竢婙𢛵𥪯𥪜娍𠉛磰娪𥯆竾䇹籝籭䈑𥮳𥺼𥺦糍𤧹𡞰粎籼粮檲緜縇緓罎𦉡"],["9540","𦅜𧭈綗𥺂䉪𦭵𠤖柖𠁎𣗏埄𦐒𦏸𤥢翝笧𠠬𥫩𥵃笌𥸎駦虅驣樜𣐿㧢𤧷𦖭騟𦖠蒀𧄧𦳑䓪脷䐂胆脉腂𦞴飃𦩂艢艥𦩑葓𦶧蘐𧈛媆䅿𡡀嬫𡢡嫤𡣘蚠蜨𣶏蠭𧐢娂"],["95a1","衮佅袇袿裦襥襍𥚃襔𧞅𧞄𨯵𨯙𨮜𨧹㺭蒣䛵䛏㟲訽訜𩑈彍鈫𤊄旔焩烄𡡅鵭貟賩𧷜妚矃姰䍮㛔踪躧𤰉輰轊䋴汘澻𢌡䢛潹溋𡟚鯩㚵𤤯邻邗啱䤆醻鐄𨩋䁢𨫼鐧𨰝𨰻蓥訫閙閧閗閖𨴴瑅㻂𤣿𤩂𤏪㻧𣈥随𨻧𨹦𨹥㻌𤧭𤩸𣿮琒瑫㻼靁𩂰"],["9640","桇䨝𩂓𥟟靝鍨𨦉𨰦𨬯𦎾銺嬑譩䤼珹𤈛鞛靱餸𠼦巁𨯅𤪲頟𩓚鋶𩗗釥䓀𨭐𤩧𨭤飜𨩅㼀鈪䤥萔餻饍𧬆㷽馛䭯馪驜𨭥𥣈檏騡嫾騯𩣱䮐𩥈馼䮽䮗鍽塲𡌂堢𤦸"],["96a1","𡓨硄𢜟𣶸棅㵽鑘㤧慐𢞁𢥫愇鱏鱓鱻鰵鰐魿鯏𩸭鮟𪇵𪃾鴡䲮𤄄鸘䲰鴌𪆴𪃭𪃳𩤯鶥蒽𦸒𦿟𦮂藼䔳𦶤𦺄𦷰萠藮𦸀𣟗𦁤秢𣖜𣙀䤭𤧞㵢鏛銾鍈𠊿碹鉷鑍俤㑀遤𥕝砽硔碶硋𡝗𣇉𤥁㚚佲濚濙瀞瀞吔𤆵垻壳垊鴖埗焴㒯𤆬燫𦱀𤾗嬨𡞵𨩉"],["9740","愌嫎娋䊼𤒈㜬䭻𨧼鎻鎸𡣖𠼝葲𦳀𡐓𤋺𢰦𤏁妔𣶷𦝁綨𦅛𦂤𤦹𤦋𨧺鋥珢㻩璴𨭣𡢟㻡𤪳櫘珳珻㻖𤨾𤪔𡟙𤩦𠎧𡐤𤧥瑈𤤖炥𤥶銄珦鍟𠓾錱𨫎𨨖鎆𨯧𥗕䤵𨪂煫"],["97a1","𤥃𠳿嚤𠘚𠯫𠲸唂秄𡟺緾𡛂𤩐𡡒䔮鐁㜊𨫀𤦭妰𡢿𡢃𧒄媡㛢𣵛㚰鉟婹𨪁𡡢鍴㳍𠪴䪖㦊僴㵩㵌𡎜煵䋻𨈘渏𩃤䓫浗𧹏灧沯㳖𣿭𣸭渂漌㵯𠏵畑㚼㓈䚀㻚䡱姄鉮䤾轁𨰜𦯀堒埈㛖𡑒烾𤍢𤩱𢿣𡊰𢎽梹楧𡎘𣓥𧯴𣛟𨪃𣟖𣏺𤲟樚𣚭𦲷萾䓟䓎"],["9840","𦴦𦵑𦲂𦿞漗𧄉茽𡜺菭𦲀𧁓𡟛妉媂𡞳婡婱𡤅𤇼㜭姯𡜼㛇熎鎐暚𤊥婮娫𤊓樫𣻹𧜶𤑛𤋊焝𤉙𨧡侰𦴨峂𤓎𧹍𤎽樌𤉖𡌄炦焳𤏩㶥泟勇𤩏繥姫崯㷳彜𤩝𡟟綤萦"],["98a1","咅𣫺𣌀𠈔坾𠣕𠘙㿥𡾞𪊶瀃𩅛嵰玏糓𨩙𩐠俈翧狍猐𧫴猸猹𥛶獁獈㺩𧬘遬燵𤣲珡臶㻊県㻑沢国琙琞琟㻢㻰㻴㻺瓓㼎㽓畂畭畲疍㽼痈痜㿀癍㿗癴㿜発𤽜熈嘣覀塩䀝睃䀹条䁅㗛瞘䁪䁯属瞾矋売砘点砜䂨砹硇硑硦葈𥔵礳栃礲䄃"],["9940","䄉禑禙辻稆込䅧窑䆲窼艹䇄竏竛䇏両筢筬筻簒簛䉠䉺类粜䊌粸䊔糭输烀𠳏総緔緐緽羮羴犟䎗耠耥笹耮耱联㷌垴炠肷胩䏭脌猪脎脒畠脔䐁㬹腖腙腚"],["99a1","䐓堺腼膄䐥膓䐭膥埯臁臤艔䒏芦艶苊苘苿䒰荗险榊萅烵葤惣蒈䔄蒾蓡蓸蔐蔸蕒䔻蕯蕰藠䕷虲蚒蚲蛯际螋䘆䘗袮裿褤襇覑𧥧訩訸誔誴豑賔賲贜䞘塟跃䟭仮踺嗘坔蹱嗵躰䠷軎転軤軭軲辷迁迊迌逳駄䢭飠鈓䤞鈨鉘鉫銱銮銿"],["9a40","鋣鋫鋳鋴鋽鍃鎄鎭䥅䥑麿鐗匁鐝鐭鐾䥪鑔鑹锭関䦧间阳䧥枠䨤靀䨵鞲韂噔䫤惨颹䬙飱塄餎餙冴餜餷饂饝饢䭰駅䮝騼鬏窃魩鮁鯝鯱鯴䱭鰠㝯𡯂鵉鰺"],["9aa1","黾噐鶓鶽鷀鷼银辶鹻麬麱麽黆铜黢黱黸竈齄𠂔𠊷𠎠椚铃妬𠓗塀铁㞹𠗕𠘕𠙶𡚺块煳𠫂𠫍𠮿呪吆𠯋咞𠯻𠰻𠱓𠱥𠱼惧𠲍噺𠲵𠳝𠳭𠵯𠶲𠷈楕鰯螥𠸄𠸎𠻗𠾐𠼭𠹳尠𠾼帋𡁜𡁏𡁶朞𡁻𡂈𡂖㙇𡂿𡃓𡄯𡄻卤蒭𡋣𡍵𡌶讁𡕷𡘙𡟃𡟇乸炻𡠭𡥪"],["9b40","𡨭𡩅𡰪𡱰𡲬𡻈拃𡻕𡼕熘桕𢁅槩㛈𢉼𢏗𢏺𢜪𢡱𢥏苽𢥧𢦓𢫕覥𢫨辠𢬎鞸𢬿顇骽𢱌"],["9b62","𢲈𢲷𥯨𢴈𢴒𢶷𢶕𢹂𢽴𢿌𣀳𣁦𣌟𣏞徱晈暿𧩹𣕧𣗳爁𤦺矗𣘚𣜖纇𠍆墵朎"],["9ba1","椘𣪧𧙗𥿢𣸑𣺹𧗾𢂚䣐䪸𤄙𨪚𤋮𤌍𤀻𤌴𤎖𤩅𠗊凒𠘑妟𡺨㮾𣳿𤐄𤓖垈𤙴㦛𤜯𨗨𩧉㝢𢇃譞𨭎駖𤠒𤣻𤨕爉𤫀𠱸奥𤺥𤾆𠝹軚𥀬劏圿煱𥊙𥐙𣽊𤪧喼𥑆𥑮𦭒釔㑳𥔿𧘲𥕞䜘𥕢𥕦𥟇𤤿𥡝偦㓻𣏌惞𥤃䝼𨥈𥪮𥮉𥰆𡶐垡煑澶𦄂𧰒遖𦆲𤾚譢𦐂𦑊"],["9c40","嵛𦯷輶𦒄𡤜諪𤧶𦒈𣿯𦔒䯀𦖿𦚵𢜛鑥𥟡憕娧晉侻嚹𤔡𦛼乪𤤴陖涏𦲽㘘襷𦞙𦡮𦐑𦡞營𦣇筂𩃀𠨑𦤦鄄𦤹穅鷰𦧺騦𦨭㙟𦑩𠀡禃𦨴𦭛崬𣔙菏𦮝䛐𦲤画补𦶮墶"],["9ca1","㜜𢖍𧁋𧇍㱔𧊀𧊅銁𢅺𧊋錰𧋦𤧐氹钟𧑐𠻸蠧裵𢤦𨑳𡞱溸𤨪𡠠㦤㚹尐秣䔿暶𩲭𩢤襃𧟌𧡘囖䃟𡘊㦡𣜯𨃨𡏅熭荦𧧝𩆨婧䲷𧂯𨦫𧧽𧨊𧬋𧵦𤅺筃祾𨀉澵𪋟樃𨌘厢𦸇鎿栶靝𨅯𨀣𦦵𡏭𣈯𨁈嶅𨰰𨂃圕頣𨥉嶫𤦈斾槕叒𤪥𣾁㰑朶𨂐𨃴𨄮𡾡𨅏"],["9d40","𨆉𨆯𨈚𨌆𨌯𨎊㗊𨑨𨚪䣺揦𨥖砈鉕𨦸䏲𨧧䏟𨧨𨭆𨯔姸𨰉輋𨿅𩃬筑𩄐𩄼㷷𩅞𤫊运犏嚋𩓧𩗩𩖰𩖸𩜲𩣑𩥉𩥪𩧃𩨨𩬎𩵚𩶛纟𩻸𩼣䲤镇𪊓熢𪋿䶑递𪗋䶜𠲜达嗁"],["9da1","辺𢒰边𤪓䔉繿潖檱仪㓤𨬬𧢝㜺躀𡟵𨀤𨭬𨮙𧨾𦚯㷫𧙕𣲷𥘵𥥖亚𥺁𦉘嚿𠹭踎孭𣺈𤲞揞拐𡟶𡡻攰嘭𥱊吚𥌑㷆𩶘䱽嘢嘞罉𥻘奵𣵀蝰东𠿪𠵉𣚺脗鵞贘瘻鱅癎瞹鍅吲腈苷嘥脲萘肽嗪祢噃吖𠺝㗎嘅嗱曱𨋢㘭甴嗰喺咗啲𠱁𠲖廐𥅈𠹶𢱢"],["9e40","𠺢麫絚嗞𡁵抝靭咔賍燶酶揼掹揾啩𢭃鱲𢺳冚㓟𠶧冧呍唞唓癦踭𦢊疱肶蠄螆裇膶萜𡃁䓬猄𤜆宐茋𦢓噻𢛴𧴯𤆣𧵳𦻐𧊶酰𡇙鈈𣳼𪚩𠺬𠻹牦𡲢䝎𤿂𧿹𠿫䃺"],["9ea1","鱝攟𢶠䣳𤟠𩵼𠿬𠸊恢𧖣𠿭"],["9ead","𦁈𡆇熣纎鵐业丄㕷嬍沲卧㚬㧜卽㚥𤘘墚𤭮舭呋垪𥪕𠥹"],["9ec5","㩒𢑥獴𩺬䴉鯭𣳾𩼰䱛𤾩𩖞𩿞葜𣶶𧊲𦞳𣜠挮紥𣻷𣸬㨪逈勌㹴㙺䗩𠒎癀嫰𠺶硺𧼮墧䂿噼鮋嵴癔𪐴麅䳡痹㟻愙𣃚𤏲"],["9ef5","噝𡊩垧𤥣𩸆刴𧂮㖭汊鵼"],["9f40","籖鬹埞𡝬屓擓𩓐𦌵𧅤蚭𠴨𦴢𤫢𠵱"],["9f4f","凾𡼏嶎霃𡷑麁遌笟鬂峑箣扨挵髿篏鬪籾鬮籂粆鰕篼鬉鼗鰛𤤾齚啳寃俽麘俲剠㸆勑坧偖妷帒韈鶫轜呩鞴饀鞺匬愰"],["9fa1","椬叚鰊鴂䰻陁榀傦畆𡝭駚剳"],["9fae","酙隁酜"],["9fb2","酑𨺗捿𦴣櫊嘑醎畺抅𠏼獏籰𥰡𣳽"],["9fc1","𤤙盖鮝个𠳔莾衂"],["9fc9","届槀僭坺刟巵从氱𠇲伹咜哚劚趂㗾弌㗳"],["9fdb","歒酼龥鮗頮颴骺麨麄煺笔"],["9fe7","毺蠘罸"],["9feb","嘠𪙊蹷齓"],["9ff0","跔蹏鸜踁抂𨍽踨蹵竓𤩷稾磘泪詧瘇"],["a040","𨩚鼦泎蟖痃𪊲硓咢贌狢獱謭猂瓱賫𤪻蘯徺袠䒷"],["a055","𡠻𦸅"],["a058","詾𢔛"],["a05b","惽癧髗鵄鍮鮏蟵"],["a063","蠏賷猬霡鮰㗖犲䰇籑饊𦅙慙䰄麖慽"],["a073","坟慯抦戹拎㩜懢厪𣏵捤栂㗒"],["a0a1","嵗𨯂迚𨸹"],["a0a6","僙𡵆礆匲阸𠼻䁥"],["a0ae","矾"],["a0b0","糂𥼚糚稭聦聣絍甅瓲覔舚朌聢𧒆聛瓰脃眤覉𦟌畓𦻑螩蟎臈螌詉貭譃眫瓸蓚㘵榲趦"],["a0d4","覩瑨涹蟁𤀑瓧㷛煶悤憜㳑煢恷"],["a0e2","罱𨬭牐惩䭾删㰘𣳇𥻗𧙖𥔱𡥄𡋾𩤃𦷜𧂭峁𦆭𨨏𣙷𠃮𦡆𤼎䕢嬟𦍌齐麦𦉫"],["a3c0","␀",31,"␡"],["c6a1","①",9,"⑴",9,"ⅰ",9,"丶丿亅亠冂冖冫勹匸卩厶夊宀巛⼳广廴彐彡攴无疒癶辵隶¨ˆヽヾゝゞ〃仝々〆〇ー［］✽ぁ",23],["c740","す",58,"ァアィイ"],["c7a1","ゥ",81,"А",5,"ЁЖ",4],["c840","Л",26,"ёж",25,"⇧↸↹㇏𠃌乚𠂊刂䒑"],["c8a1","龰冈龱𧘇"],["c8cd","￢￤＇＂㈱№℡゛゜⺀⺄⺆⺇⺈⺊⺌⺍⺕⺜⺝⺥⺧⺪⺬⺮⺶⺼⺾⻆⻊⻌⻍⻏⻖⻗⻞⻣"],["c8f5","ʃɐɛɔɵœøŋʊɪ"],["f9fe","￭"],["fa40","𠕇鋛𠗟𣿅蕌䊵珯况㙉𤥂𨧤鍄𡧛苮𣳈砼杄拟𤤳𨦪𠊠𦮳𡌅侫𢓭倈𦴩𧪄𣘀𤪱𢔓倩𠍾徤𠎀𠍇滛𠐟偽儁㑺儎顬㝃萖𤦤𠒇兠𣎴兪𠯿𢃼𠋥𢔰𠖎𣈳𡦃宂蝽𠖳𣲙冲冸"],["faa1","鴴凉减凑㳜凓𤪦决凢卂凭菍椾𣜭彻刋刦刼劵剗劔効勅簕蕂勠蘍𦬓包𨫞啉滙𣾀𠥔𣿬匳卄𠯢泋𡜦栛珕恊㺪㣌𡛨燝䒢卭却𨚫卾卿𡖖𡘓矦厓𨪛厠厫厮玧𥝲㽙玜叁叅汉义埾叙㪫𠮏叠𣿫𢶣叶𠱷吓灹唫晗浛呭𦭓𠵴啝咏咤䞦𡜍𠻝㶴𠵍"],["fb40","𨦼𢚘啇䳭启琗喆喩嘅𡣗𤀺䕒𤐵暳𡂴嘷曍𣊊暤暭噍噏磱囱鞇叾圀囯园𨭦㘣𡉏坆𤆥汮炋坂㚱𦱾埦𡐖堃𡑔𤍣堦𤯵塜墪㕡壠壜𡈼壻寿坃𪅐𤉸鏓㖡够梦㛃湙"],["fba1","𡘾娤啓𡚒蔅姉𠵎𦲁𦴪𡟜姙𡟻𡞲𦶦浱𡠨𡛕姹𦹅媫婣㛦𤦩婷㜈媖瑥嫓𦾡𢕔㶅𡤑㜲𡚸広勐孶斈孼𧨎䀄䡝𠈄寕慠𡨴𥧌𠖥寳宝䴐尅𡭄尓珎尔𡲥𦬨屉䣝岅峩峯嶋𡷹𡸷崐崘嵆𡺤岺巗苼㠭𤤁𢁉𢅳芇㠶㯂帮檊幵幺𤒼𠳓厦亷廐厨𡝱帉廴𨒂"],["fc40","廹廻㢠廼栾鐛弍𠇁弢㫞䢮𡌺强𦢈𢏐彘𢑱彣鞽𦹮彲鍀𨨶徧嶶㵟𥉐𡽪𧃸𢙨釖𠊞𨨩怱暅𡡷㥣㷇㘹垐𢞴祱㹀悞悤悳𤦂𤦏𧩓璤僡媠慤萤慂慈𦻒憁凴𠙖憇宪𣾷"],["fca1","𢡟懓𨮝𩥝懐㤲𢦀𢣁怣慜攞掋𠄘担𡝰拕𢸍捬𤧟㨗搸揸𡎎𡟼撐澊𢸶頔𤂌𥜝擡擥鑻㩦携㩗敍漖𤨨𤨣斅敭敟𣁾斵𤥀䬷旑䃘𡠩无旣忟𣐀昘𣇷𣇸晄𣆤𣆥晋𠹵晧𥇦晳晴𡸽𣈱𨗴𣇈𥌓矅𢣷馤朂𤎜𤨡㬫槺𣟂杞杧杢𤇍𩃭柗䓩栢湐鈼栁𣏦𦶠桝"],["fd40","𣑯槡樋𨫟楳棃𣗍椁椀㴲㨁𣘼㮀枬楡𨩊䋼椶榘㮡𠏉荣傐槹𣙙𢄪橅𣜃檝㯳枱櫈𩆜㰍欝𠤣惞欵歴𢟍溵𣫛𠎵𡥘㝀吡𣭚毡𣻼毜氷𢒋𤣱𦭑汚舦汹𣶼䓅𣶽𤆤𤤌𤤀"],["fda1","𣳉㛥㳫𠴲鮃𣇹𢒑羏样𦴥𦶡𦷫涖浜湼漄𤥿𤂅𦹲蔳𦽴凇沜渝萮𨬡港𣸯瑓𣾂秌湏媑𣁋濸㜍澝𣸰滺𡒗𤀽䕕鏰潄潜㵎潴𩅰㴻澟𤅄濓𤂑𤅕𤀹𣿰𣾴𤄿凟𤅖𤅗𤅀𦇝灋灾炧炁烌烕烖烟䄄㷨熴熖𤉷焫煅媈煊煮岜𤍥煏鍢𤋁焬𤑚𤨧𤨢熺𨯨炽爎"],["fe40","鑂爕夑鑃爤鍁𥘅爮牀𤥴梽牕牗㹕𣁄栍漽犂猪猫𤠣𨠫䣭𨠄猨献珏玪𠰺𦨮珉瑉𤇢𡛧𤨤昣㛅𤦷𤦍𤧻珷琕椃𤨦琹𠗃㻗瑜𢢭瑠𨺲瑇珤瑶莹瑬㜰瑴鏱樬璂䥓𤪌"],["fea1","𤅟𤩹𨮏孆𨰃𡢞瓈𡦈甎瓩甞𨻙𡩋寗𨺬鎅畍畊畧畮𤾂㼄𤴓疎瑝疞疴瘂瘬癑癏癯癶𦏵皐臯㟸𦤑𦤎皡皥皷盌𦾟葢𥂝𥅽𡸜眞眦着撯𥈠睘𣊬瞯𨥤𨥨𡛁矴砉𡍶𤨒棊碯磇磓隥礮𥗠磗礴碱𧘌辸袄𨬫𦂃𢘜禆褀椂禀𥡗禝𧬹礼禩渪𧄦㺨秆𩄍秔"]]');
        /***/ }),

      /***/ 3336:
      /***/ (function (module) {
        module.exports = JSON.parse('[["0","\\u0000",127,"€"],["8140","丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪",5,"乲乴",9,"乿",6,"亇亊"],["8180","亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂",6,"伋伌伒",4,"伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾",4,"佄佅佇",5,"佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢"],["8240","侤侫侭侰",4,"侶",8,"俀俁係俆俇俈俉俋俌俍俒",4,"俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿",11],["8280","個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯",10,"倻倽倿偀偁偂偄偅偆偉偊偋偍偐",4,"偖偗偘偙偛偝",7,"偦",5,"偭",8,"偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎",20,"傤傦傪傫傭",4,"傳",6,"傼"],["8340","傽",17,"僐",5,"僗僘僙僛",10,"僨僩僪僫僯僰僱僲僴僶",4,"僼",9,"儈"],["8380","儉儊儌",5,"儓",13,"儢",28,"兂兇兊兌兎兏児兒兓兗兘兙兛兝",4,"兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦",4,"冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒",5],["8440","凘凙凚凜凞凟凢凣凥",5,"凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄",5,"剋剎剏剒剓剕剗剘"],["8480","剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳",9,"剾劀劃",4,"劉",6,"劑劒劔",6,"劜劤劥劦劧劮劯劰労",9,"勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務",5,"勠勡勢勣勥",10,"勱",7,"勻勼勽匁匂匃匄匇匉匊匋匌匎"],["8540","匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯",9,"匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏"],["8580","厐",4,"厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯",6,"厷厸厹厺厼厽厾叀參",4,"収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝",4,"呣呥呧呩",7,"呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡"],["8640","咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠",4,"哫哬哯哰哱哴",5,"哻哾唀唂唃唄唅唈唊",4,"唒唓唕",5,"唜唝唞唟唡唥唦"],["8680","唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋",4,"啑啒啓啔啗",4,"啝啞啟啠啢啣啨啩啫啯",5,"啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠",6,"喨",8,"喲喴営喸喺喼喿",4,"嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗",4,"嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸",4,"嗿嘂嘃嘄嘅"],["8740","嘆嘇嘊嘋嘍嘐",7,"嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀",11,"噏",4,"噕噖噚噛噝",4],["8780","噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽",7,"嚇",6,"嚐嚑嚒嚔",14,"嚤",10,"嚰",6,"嚸嚹嚺嚻嚽",12,"囋",8,"囕囖囘囙囜団囥",5,"囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國",6],["8840","園",9,"圝圞圠圡圢圤圥圦圧圫圱圲圴",4,"圼圽圿坁坃坄坅坆坈坉坋坒",4,"坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀"],["8880","垁垇垈垉垊垍",4,"垔",6,"垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹",8,"埄",6,"埌埍埐埑埓埖埗埛埜埞埡埢埣埥",7,"埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥",4,"堫",4,"報堲堳場堶",7],["8940","堾",5,"塅",6,"塎塏塐塒塓塕塖塗塙",4,"塟",5,"塦",4,"塭",16,"塿墂墄墆墇墈墊墋墌"],["8980","墍",4,"墔",4,"墛墜墝墠",7,"墪",17,"墽墾墿壀壂壃壄壆",10,"壒壓壔壖",13,"壥",5,"壭壯壱売壴壵壷壸壺",7,"夃夅夆夈",4,"夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻"],["8a40","夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛",4,"奡奣奤奦",12,"奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦"],["8a80","妧妬妭妰妱妳",5,"妺妼妽妿",6,"姇姈姉姌姍姎姏姕姖姙姛姞",4,"姤姦姧姩姪姫姭",11,"姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪",6,"娳娵娷",4,"娽娾娿婁",4,"婇婈婋",9,"婖婗婘婙婛",5],["8b40","婡婣婤婥婦婨婩婫",8,"婸婹婻婼婽婾媀",17,"媓",6,"媜",13,"媫媬"],["8b80","媭",4,"媴媶媷媹",4,"媿嫀嫃",5,"嫊嫋嫍",4,"嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬",4,"嫲",22,"嬊",11,"嬘",25,"嬳嬵嬶嬸",7,"孁",6],["8c40","孈",7,"孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏"],["8c80","寑寔",8,"寠寢寣實寧審",4,"寯寱",6,"寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧",6,"屰屲",6,"屻屼屽屾岀岃",4,"岉岊岋岎岏岒岓岕岝",4,"岤",4],["8d40","岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅",5,"峌",5,"峓",5,"峚",6,"峢峣峧峩峫峬峮峯峱",9,"峼",4],["8d80","崁崄崅崈",5,"崏",4,"崕崗崘崙崚崜崝崟",4,"崥崨崪崫崬崯",4,"崵",7,"崿",7,"嵈嵉嵍",10,"嵙嵚嵜嵞",10,"嵪嵭嵮嵰嵱嵲嵳嵵",12,"嶃",21,"嶚嶛嶜嶞嶟嶠"],["8e40","嶡",21,"嶸",12,"巆",6,"巎",12,"巜巟巠巣巤巪巬巭"],["8e80","巰巵巶巸",4,"巿帀帄帇帉帊帋帍帎帒帓帗帞",7,"帨",4,"帯帰帲",4,"帹帺帾帿幀幁幃幆",5,"幍",6,"幖",4,"幜幝幟幠幣",14,"幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨",4,"庮",4,"庴庺庻庼庽庿",6],["8f40","廆廇廈廋",5,"廔廕廗廘廙廚廜",11,"廩廫",8,"廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤"],["8f80","弨弫弬弮弰弲",6,"弻弽弾弿彁",14,"彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢",5,"復徫徬徯",5,"徶徸徹徺徻徾",4,"忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇"],["9040","怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰",4,"怶",4,"怽怾恀恄",6,"恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀"],["9080","悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽",7,"惇惈惉惌",4,"惒惓惔惖惗惙惛惞惡",4,"惪惱惲惵惷惸惻",4,"愂愃愄愅愇愊愋愌愐",4,"愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬",18,"慀",6],["9140","慇慉態慍慏慐慒慓慔慖",6,"慞慟慠慡慣慤慥慦慩",6,"慱慲慳慴慶慸",18,"憌憍憏",4,"憕"],["9180","憖",6,"憞",8,"憪憫憭",9,"憸",5,"憿懀懁懃",4,"應懌",4,"懓懕",16,"懧",13,"懶",8,"戀",5,"戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸",4,"扂扄扅扆扊"],["9240","扏扐払扖扗扙扚扜",6,"扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋",5,"抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁"],["9280","拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳",5,"挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖",7,"捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙",6,"採掤掦掫掯掱掲掵掶掹掻掽掿揀"],["9340","揁揂揃揅揇揈揊揋揌揑揓揔揕揗",6,"揟揢揤",4,"揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆",4,"損搎搑搒搕",5,"搝搟搢搣搤"],["9380","搥搧搨搩搫搮",5,"搵",4,"搻搼搾摀摂摃摉摋",6,"摓摕摖摗摙",4,"摟",7,"摨摪摫摬摮",9,"摻",6,"撃撆撈",8,"撓撔撗撘撚撛撜撝撟",4,"撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆",6,"擏擑擓擔擕擖擙據"],["9440","擛擜擝擟擠擡擣擥擧",24,"攁",7,"攊",7,"攓",4,"攙",8],["9480","攢攣攤攦",4,"攬攭攰攱攲攳攷攺攼攽敀",4,"敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數",14,"斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱",7,"斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘",7,"旡旣旤旪旫"],["9540","旲旳旴旵旸旹旻",4,"昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷",4,"昽昿晀時晄",6,"晍晎晐晑晘"],["9580","晙晛晜晝晞晠晢晣晥晧晩",4,"晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘",4,"暞",8,"暩",4,"暯",4,"暵暶暷暸暺暻暼暽暿",25,"曚曞",7,"曧曨曪",5,"曱曵曶書曺曻曽朁朂會"],["9640","朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠",5,"朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗",4,"杝杢杣杤杦杧杫杬杮東杴杶"],["9680","杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹",7,"柂柅",9,"柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵",7,"柾栁栂栃栄栆栍栐栒栔栕栘",4,"栞栟栠栢",6,"栫",6,"栴栵栶栺栻栿桇桋桍桏桒桖",5],["9740","桜桝桞桟桪桬",7,"桵桸",8,"梂梄梇",7,"梐梑梒梔梕梖梘",9,"梣梤梥梩梪梫梬梮梱梲梴梶梷梸"],["9780","梹",6,"棁棃",5,"棊棌棎棏棐棑棓棔棖棗棙棛",4,"棡棢棤",9,"棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆",4,"椌椏椑椓",11,"椡椢椣椥",7,"椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃",16,"楕楖楘楙楛楜楟"],["9840","楡楢楤楥楧楨楩楪楬業楯楰楲",4,"楺楻楽楾楿榁榃榅榊榋榌榎",5,"榖榗榙榚榝",9,"榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽"],["9880","榾榿槀槂",7,"構槍槏槑槒槓槕",5,"槜槝槞槡",11,"槮槯槰槱槳",9,"槾樀",9,"樋",11,"標",5,"樠樢",5,"権樫樬樭樮樰樲樳樴樶",6,"樿",4,"橅橆橈",7,"橑",6,"橚"],["9940","橜",4,"橢橣橤橦",10,"橲",6,"橺橻橽橾橿檁檂檃檅",8,"檏檒",4,"檘",7,"檡",5],["9980","檧檨檪檭",114,"欥欦欨",6],["9a40","欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍",11,"歚",7,"歨歩歫",13,"歺歽歾歿殀殅殈"],["9a80","殌殎殏殐殑殔殕殗殘殙殜",4,"殢",7,"殫",7,"殶殸",6,"毀毃毄毆",4,"毌毎毐毑毘毚毜",4,"毢",7,"毬毭毮毰毱毲毴毶毷毸毺毻毼毾",6,"氈",4,"氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋",4,"汑汒汓汖汘"],["9b40","汙汚汢汣汥汦汧汫",4,"汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘"],["9b80","泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟",5,"洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽",4,"涃涄涆涇涊涋涍涏涐涒涖",4,"涜涢涥涬涭涰涱涳涴涶涷涹",5,"淁淂淃淈淉淊"],["9c40","淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽",7,"渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵"],["9c80","渶渷渹渻",7,"湅",7,"湏湐湑湒湕湗湙湚湜湝湞湠",10,"湬湭湯",14,"満溁溂溄溇溈溊",4,"溑",6,"溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪",5],["9d40","滰滱滲滳滵滶滷滸滺",7,"漃漄漅漇漈漊",4,"漐漑漒漖",9,"漡漢漣漥漦漧漨漬漮漰漲漴漵漷",6,"漿潀潁潂"],["9d80","潃潄潅潈潉潊潌潎",9,"潙潚潛潝潟潠潡潣潤潥潧",5,"潯潰潱潳潵潶潷潹潻潽",6,"澅澆澇澊澋澏",12,"澝澞澟澠澢",4,"澨",10,"澴澵澷澸澺",5,"濁濃",5,"濊",6,"濓",10,"濟濢濣濤濥"],["9e40","濦",7,"濰",32,"瀒",7,"瀜",6,"瀤",6],["9e80","瀫",9,"瀶瀷瀸瀺",17,"灍灎灐",13,"灟",11,"灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞",12,"炰炲炴炵炶為炾炿烄烅烆烇烉烋",12,"烚"],["9f40","烜烝烞烠烡烢烣烥烪烮烰",6,"烸烺烻烼烾",10,"焋",4,"焑焒焔焗焛",10,"焧",7,"焲焳焴"],["9f80","焵焷",13,"煆煇煈煉煋煍煏",12,"煝煟",4,"煥煩",4,"煯煰煱煴煵煶煷煹煻煼煾",5,"熅",4,"熋熌熍熎熐熑熒熓熕熖熗熚",4,"熡",6,"熩熪熫熭",5,"熴熶熷熸熺",8,"燄",9,"燏",4],["a040","燖",9,"燡燢燣燤燦燨",5,"燯",9,"燺",11,"爇",19],["a080","爛爜爞",9,"爩爫爭爮爯爲爳爴爺爼爾牀",6,"牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅",4,"犌犎犐犑犓",11,"犠",11,"犮犱犲犳犵犺",6,"狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛"],["a1a1","　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈",7,"〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓"],["a2a1","ⅰ",9],["a2b1","⒈",19,"⑴",19,"①",9],["a2e5","㈠",9],["a2f1","Ⅰ",11],["a3a1","！＂＃￥％",88,"￣"],["a4a1","ぁ",82],["a5a1","ァ",85],["a6a1","Α",16,"Σ",6],["a6c1","α",16,"σ",6],["a6e0","︵︶︹︺︿﹀︽︾﹁﹂﹃﹄"],["a6ee","︻︼︷︸︱"],["a6f4","︳︴"],["a7a1","А",5,"ЁЖ",25],["a7d1","а",5,"ёж",25],["a840","ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═",35,"▁",6],["a880","█",7,"▓▔▕▼▽◢◣◤◥☉⊕〒〝〞"],["a8a1","āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ"],["a8bd","ńň"],["a8c0","ɡ"],["a8c5","ㄅ",36],["a940","〡",8,"㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤"],["a959","℡㈱"],["a95c","‐"],["a960","ー゛゜ヽヾ〆ゝゞ﹉",9,"﹔﹕﹖﹗﹙",8],["a980","﹢",4,"﹨﹩﹪﹫"],["a996","〇"],["a9a4","─",75],["aa40","狜狝狟狢",5,"狪狫狵狶狹狽狾狿猀猂猄",5,"猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀",8],["aa80","獉獊獋獌獎獏獑獓獔獕獖獘",7,"獡",10,"獮獰獱"],["ab40","獲",11,"獿",4,"玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣",5,"玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃",4],["ab80","珋珌珎珒",6,"珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳",4],["ac40","珸",10,"琄琇琈琋琌琍琎琑",8,"琜",5,"琣琤琧琩琫琭琯琱琲琷",4,"琽琾琿瑀瑂",11],["ac80","瑎",6,"瑖瑘瑝瑠",12,"瑮瑯瑱",4,"瑸瑹瑺"],["ad40","瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑",10,"璝璟",7,"璪",15,"璻",12],["ad80","瓈",9,"瓓",8,"瓝瓟瓡瓥瓧",6,"瓰瓱瓲"],["ae40","瓳瓵瓸",6,"甀甁甂甃甅",7,"甎甐甒甔甕甖甗甛甝甞甠",4,"甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘"],["ae80","畝",7,"畧畨畩畫",6,"畳畵當畷畺",4,"疀疁疂疄疅疇"],["af40","疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦",4,"疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇"],["af80","瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄"],["b040","癅",6,"癎",5,"癕癗",4,"癝癟癠癡癢癤",6,"癬癭癮癰",7,"癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛"],["b080","皜",7,"皥",8,"皯皰皳皵",9,"盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥"],["b140","盄盇盉盋盌盓盕盙盚盜盝盞盠",4,"盦",7,"盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎",10,"眛眜眝眞眡眣眤眥眧眪眫"],["b180","眬眮眰",4,"眹眻眽眾眿睂睄睅睆睈",7,"睒",7,"睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳"],["b240","睝睞睟睠睤睧睩睪睭",11,"睺睻睼瞁瞂瞃瞆",5,"瞏瞐瞓",11,"瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶",4],["b280","瞼瞾矀",12,"矎",8,"矘矙矚矝",4,"矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖"],["b340","矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃",5,"砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚"],["b380","硛硜硞",11,"硯",7,"硸硹硺硻硽",6,"场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚"],["b440","碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨",7,"碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚",9],["b480","磤磥磦磧磩磪磫磭",4,"磳磵磶磸磹磻",5,"礂礃礄礆",6,"础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮"],["b540","礍",5,"礔",9,"礟",4,"礥",14,"礵",4,"礽礿祂祃祄祅祇祊",8,"祔祕祘祙祡祣"],["b580","祤祦祩祪祫祬祮祰",6,"祹祻",4,"禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠"],["b640","禓",6,"禛",11,"禨",10,"禴",4,"禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙",5,"秠秡秢秥秨秪"],["b680","秬秮秱",6,"秹秺秼秾秿稁稄稅稇稈稉稊稌稏",4,"稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二"],["b740","稝稟稡稢稤",14,"稴稵稶稸稺稾穀",5,"穇",9,"穒",4,"穘",16],["b780","穩",6,"穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服"],["b840","窣窤窧窩窪窫窮",4,"窴",10,"竀",10,"竌",9,"竗竘竚竛竜竝竡竢竤竧",5,"竮竰竱竲竳"],["b880","竴",4,"竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹"],["b940","笯笰笲笴笵笶笷笹笻笽笿",5,"筆筈筊筍筎筓筕筗筙筜筞筟筡筣",10,"筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆",6,"箎箏"],["b980","箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹",7,"篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈"],["ba40","篅篈築篊篋篍篎篏篐篒篔",4,"篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲",4,"篸篹篺篻篽篿",7,"簈簉簊簍簎簐",5,"簗簘簙"],["ba80","簚",4,"簠",5,"簨簩簫",12,"簹",5,"籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖"],["bb40","籃",9,"籎",36,"籵",5,"籾",9],["bb80","粈粊",6,"粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴",4,"粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕"],["bc40","粿糀糂糃糄糆糉糋糎",6,"糘糚糛糝糞糡",6,"糩",5,"糰",7,"糹糺糼",13,"紋",5],["bc80","紑",14,"紡紣紤紥紦紨紩紪紬紭紮細",6,"肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件"],["bd40","紷",54,"絯",7],["bd80","絸",32,"健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸"],["be40","継",12,"綧",6,"綯",42],["be80","線",32,"尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻"],["bf40","緻",62],["bf80","縺縼",4,"繂",4,"繈",21,"俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀"],["c040","繞",35,"纃",23,"纜纝纞"],["c080","纮纴纻纼绖绤绬绹缊缐缞缷缹缻",6,"罃罆",9,"罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐"],["c140","罖罙罛罜罝罞罠罣",4,"罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂",7,"羋羍羏",4,"羕",4,"羛羜羠羢羣羥羦羨",6,"羱"],["c180","羳",4,"羺羻羾翀翂翃翄翆翇翈翉翋翍翏",4,"翖翗翙",5,"翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿"],["c240","翤翧翨翪翫翬翭翯翲翴",6,"翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫",5,"耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗"],["c280","聙聛",13,"聫",5,"聲",11,"隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫"],["c340","聾肁肂肅肈肊肍",5,"肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇",4,"胏",6,"胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋"],["c380","脌脕脗脙脛脜脝脟",12,"脭脮脰脳脴脵脷脹",4,"脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸"],["c440","腀",5,"腇腉腍腎腏腒腖腗腘腛",4,"腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃",4,"膉膋膌膍膎膐膒",5,"膙膚膞",4,"膤膥"],["c480","膧膩膫",7,"膴",5,"膼膽膾膿臄臅臇臈臉臋臍",6,"摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁"],["c540","臔",14,"臤臥臦臨臩臫臮",4,"臵",5,"臽臿舃與",4,"舎舏舑舓舕",5,"舝舠舤舥舦舧舩舮舲舺舼舽舿"],["c580","艀艁艂艃艅艆艈艊艌艍艎艐",7,"艙艛艜艝艞艠",7,"艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗"],["c640","艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸"],["c680","苺苼",4,"茊茋茍茐茒茓茖茘茙茝",9,"茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐"],["c740","茾茿荁荂荄荅荈荊",4,"荓荕",4,"荝荢荰",6,"荹荺荾",6,"莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡",6,"莬莭莮"],["c780","莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠"],["c840","菮華菳",4,"菺菻菼菾菿萀萂萅萇萈萉萊萐萒",5,"萙萚萛萞",5,"萩",7,"萲",5,"萹萺萻萾",7,"葇葈葉"],["c880","葊",6,"葒",4,"葘葝葞葟葠葢葤",4,"葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁"],["c940","葽",4,"蒃蒄蒅蒆蒊蒍蒏",7,"蒘蒚蒛蒝蒞蒟蒠蒢",12,"蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗"],["c980","蓘",4,"蓞蓡蓢蓤蓧",4,"蓭蓮蓯蓱",10,"蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳"],["ca40","蔃",8,"蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢",8,"蔭",9,"蔾",4,"蕄蕅蕆蕇蕋",10],["ca80","蕗蕘蕚蕛蕜蕝蕟",4,"蕥蕦蕧蕩",8,"蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱"],["cb40","薂薃薆薈",6,"薐",10,"薝",6,"薥薦薧薩薫薬薭薱",5,"薸薺",6,"藂",6,"藊",4,"藑藒"],["cb80","藔藖",5,"藝",6,"藥藦藧藨藪",14,"恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔"],["cc40","藹藺藼藽藾蘀",4,"蘆",10,"蘒蘓蘔蘕蘗",15,"蘨蘪",13,"蘹蘺蘻蘽蘾蘿虀"],["cc80","虁",11,"虒虓處",4,"虛虜虝號虠虡虣",7,"獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃"],["cd40","虭虯虰虲",6,"蚃",6,"蚎",4,"蚔蚖",5,"蚞",4,"蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻",4,"蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜"],["cd80","蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威"],["ce40","蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀",6,"蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚",5,"蝡蝢蝦",7,"蝯蝱蝲蝳蝵"],["ce80","蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎",4,"螔螕螖螘",6,"螠",4,"巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺"],["cf40","螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁",4,"蟇蟈蟉蟌",4,"蟔",6,"蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯",9],["cf80","蟺蟻蟼蟽蟿蠀蠁蠂蠄",5,"蠋",7,"蠔蠗蠘蠙蠚蠜",4,"蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓"],["d040","蠤",13,"蠳",5,"蠺蠻蠽蠾蠿衁衂衃衆",5,"衎",5,"衕衖衘衚",6,"衦衧衪衭衯衱衳衴衵衶衸衹衺"],["d080","衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗",4,"袝",4,"袣袥",5,"小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄"],["d140","袬袮袯袰袲",4,"袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚",4,"裠裡裦裧裩",6,"裲裵裶裷裺裻製裿褀褁褃",5],["d180","褉褋",4,"褑褔",4,"褜",4,"褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶"],["d240","褸",8,"襂襃襅",24,"襠",5,"襧",19,"襼"],["d280","襽襾覀覂覄覅覇",26,"摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐"],["d340","覢",30,"觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴",6],["d380","觻",4,"訁",5,"計",21,"印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉"],["d440","訞",31,"訿",8,"詉",21],["d480","詟",25,"詺",6,"浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧"],["d540","誁",7,"誋",7,"誔",46],["d580","諃",32,"铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政"],["d640","諤",34,"謈",27],["d680","謤謥謧",30,"帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑"],["d740","譆",31,"譧",4,"譭",25],["d780","讇",24,"讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座"],["d840","谸",8,"豂豃豄豅豈豊豋豍",7,"豖豗豘豙豛",5,"豣",6,"豬",6,"豴豵豶豷豻",6,"貃貄貆貇"],["d880","貈貋貍",6,"貕貖貗貙",20,"亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝"],["d940","貮",62],["d980","賭",32,"佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼"],["da40","贎",14,"贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸",8,"趂趃趆趇趈趉趌",4,"趒趓趕",9,"趠趡"],["da80","趢趤",12,"趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺"],["db40","跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾",6,"踆踇踈踋踍踎踐踑踒踓踕",7,"踠踡踤",4,"踫踭踰踲踳踴踶踷踸踻踼踾"],["db80","踿蹃蹅蹆蹌",4,"蹓",5,"蹚",11,"蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝"],["dc40","蹳蹵蹷",4,"蹽蹾躀躂躃躄躆躈",6,"躑躒躓躕",6,"躝躟",11,"躭躮躰躱躳",6,"躻",7],["dc80","軃",10,"軏",21,"堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥"],["dd40","軥",62],["dd80","輤",32,"荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺"],["de40","轅",32,"轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆"],["de80","迉",4,"迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖"],["df40","這逜連逤逥逧",5,"逰",4,"逷逹逺逽逿遀遃遅遆遈",4,"過達違遖遙遚遜",5,"遤遦遧適遪遫遬遯",4,"遶",6,"遾邁"],["df80","還邅邆邇邉邊邌",4,"邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼"],["e040","郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅",19,"鄚鄛鄜"],["e080","鄝鄟鄠鄡鄤",10,"鄰鄲",6,"鄺",8,"酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼"],["e140","酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀",4,"醆醈醊醎醏醓",6,"醜",5,"醤",5,"醫醬醰醱醲醳醶醷醸醹醻"],["e180","醼",10,"釈釋釐釒",9,"針",8,"帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺"],["e240","釦",62],["e280","鈥",32,"狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧",5,"饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂"],["e340","鉆",45,"鉵",16],["e380","銆",7,"銏",24,"恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾"],["e440","銨",5,"銯",24,"鋉",31],["e480","鋩",32,"洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑"],["e540","錊",51,"錿",10],["e580","鍊",31,"鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣"],["e640","鍬",34,"鎐",27],["e680","鎬",29,"鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩"],["e740","鏎",7,"鏗",54],["e780","鐎",32,"纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡",6,"缪缫缬缭缯",4,"缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬"],["e840","鐯",14,"鐿",43,"鑬鑭鑮鑯"],["e880","鑰",20,"钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹"],["e940","锧锳锽镃镈镋镕镚镠镮镴镵長",7,"門",42],["e980","閫",32,"椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋"],["ea40","闌",27,"闬闿阇阓阘阛阞阠阣",6,"阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗"],["ea80","陘陙陚陜陝陞陠陣陥陦陫陭",4,"陳陸",12,"隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰"],["eb40","隌階隑隒隓隕隖隚際隝",9,"隨",7,"隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖",9,"雡",6,"雫"],["eb80","雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗",4,"霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻"],["ec40","霡",8,"霫霬霮霯霱霳",4,"霺霻霼霽霿",18,"靔靕靗靘靚靜靝靟靣靤靦靧靨靪",7],["ec80","靲靵靷",4,"靽",7,"鞆",4,"鞌鞎鞏鞐鞓鞕鞖鞗鞙",4,"臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐"],["ed40","鞞鞟鞡鞢鞤",6,"鞬鞮鞰鞱鞳鞵",46],["ed80","韤韥韨韮",4,"韴韷",23,"怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨"],["ee40","頏",62],["ee80","顎",32,"睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶",4,"钼钽钿铄铈",6,"铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪"],["ef40","顯",5,"颋颎颒颕颙颣風",37,"飏飐飔飖飗飛飜飝飠",4],["ef80","飥飦飩",30,"铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒",4,"锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤",8,"镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔"],["f040","餈",4,"餎餏餑",28,"餯",26],["f080","饊",9,"饖",12,"饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨",4,"鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦",6,"鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙"],["f140","馌馎馚",10,"馦馧馩",47],["f180","駙",32,"瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃"],["f240","駺",62],["f280","騹",32,"颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒"],["f340","驚",17,"驲骃骉骍骎骔骕骙骦骩",6,"骲骳骴骵骹骻骽骾骿髃髄髆",4,"髍髎髏髐髒體髕髖髗髙髚髛髜"],["f380","髝髞髠髢髣髤髥髧髨髩髪髬髮髰",8,"髺髼",6,"鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋"],["f440","鬇鬉",5,"鬐鬑鬒鬔",10,"鬠鬡鬢鬤",10,"鬰鬱鬳",7,"鬽鬾鬿魀魆魊魋魌魎魐魒魓魕",5],["f480","魛",32,"簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤"],["f540","魼",62],["f580","鮻",32,"酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜"],["f640","鯜",62],["f680","鰛",32,"觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅",5,"龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞",5,"鲥",4,"鲫鲭鲮鲰",7,"鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋"],["f740","鰼",62],["f780","鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾",4,"鳈鳉鳑鳒鳚鳛鳠鳡鳌",4,"鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄"],["f840","鳣",62],["f880","鴢",32],["f940","鵃",62],["f980","鶂",32],["fa40","鶣",62],["fa80","鷢",32],["fb40","鸃",27,"鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴",9,"麀"],["fb80","麁麃麄麅麆麉麊麌",5,"麔",8,"麞麠",5,"麧麨麩麪"],["fc40","麫",8,"麵麶麷麹麺麼麿",4,"黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰",8,"黺黽黿",6],["fc80","鼆",4,"鼌鼏鼑鼒鼔鼕鼖鼘鼚",5,"鼡鼣",8,"鼭鼮鼰鼱"],["fd40","鼲",4,"鼸鼺鼼鼿",4,"齅",10,"齒",38],["fd80","齹",5,"龁龂龍",11,"龜龝龞龡",4,"郎凉秊裏隣"],["fe40","兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩"]]');
        /***/ }),

      /***/ 7348:
      /***/ (function (module) {
        module.exports = JSON.parse('[["0","\\u0000",127],["8141","갂갃갅갆갋",4,"갘갞갟갡갢갣갥",6,"갮갲갳갴"],["8161","갵갶갷갺갻갽갾갿걁",9,"걌걎",5,"걕"],["8181","걖걗걙걚걛걝",18,"걲걳걵걶걹걻",4,"겂겇겈겍겎겏겑겒겓겕",6,"겞겢",5,"겫겭겮겱",6,"겺겾겿곀곂곃곅곆곇곉곊곋곍",7,"곖곘",7,"곢곣곥곦곩곫곭곮곲곴곷",4,"곾곿괁괂괃괅괇",4,"괎괐괒괓"],["8241","괔괕괖괗괙괚괛괝괞괟괡",7,"괪괫괮",5],["8261","괶괷괹괺괻괽",6,"굆굈굊",5,"굑굒굓굕굖굗"],["8281","굙",7,"굢굤",7,"굮굯굱굲굷굸굹굺굾궀궃",4,"궊궋궍궎궏궑",10,"궞",5,"궥",17,"궸",7,"귂귃귅귆귇귉",6,"귒귔",7,"귝귞귟귡귢귣귥",18],["8341","귺귻귽귾긂",5,"긊긌긎",5,"긕",7],["8361","긝",18,"긲긳긵긶긹긻긼"],["8381","긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗",4,"깞깢깣깤깦깧깪깫깭깮깯깱",6,"깺깾",5,"꺆",5,"꺍",46,"꺿껁껂껃껅",6,"껎껒",5,"껚껛껝",8],["8441","껦껧껩껪껬껮",5,"껵껶껷껹껺껻껽",8],["8461","꼆꼉꼊꼋꼌꼎꼏꼑",18],["8481","꼤",7,"꼮꼯꼱꼳꼵",6,"꼾꽀꽄꽅꽆꽇꽊",5,"꽑",10,"꽞",5,"꽦",18,"꽺",5,"꾁꾂꾃꾅꾆꾇꾉",6,"꾒꾓꾔꾖",5,"꾝",26,"꾺꾻꾽꾾"],["8541","꾿꿁",5,"꿊꿌꿏",4,"꿕",6,"꿝",4],["8561","꿢",5,"꿪",5,"꿲꿳꿵꿶꿷꿹",6,"뀂뀃"],["8581","뀅",6,"뀍뀎뀏뀑뀒뀓뀕",6,"뀞",9,"뀩",26,"끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞",29,"끾끿낁낂낃낅",6,"낎낐낒",5,"낛낝낞낣낤"],["8641","낥낦낧낪낰낲낶낷낹낺낻낽",6,"냆냊",5,"냒"],["8661","냓냕냖냗냙",6,"냡냢냣냤냦",10],["8681","냱",22,"넊넍넎넏넑넔넕넖넗넚넞",4,"넦넧넩넪넫넭",6,"넶넺",5,"녂녃녅녆녇녉",6,"녒녓녖녗녙녚녛녝녞녟녡",22,"녺녻녽녾녿놁놃",4,"놊놌놎놏놐놑놕놖놗놙놚놛놝"],["8741","놞",9,"놩",15],["8761","놹",18,"뇍뇎뇏뇑뇒뇓뇕"],["8781","뇖",5,"뇞뇠",7,"뇪뇫뇭뇮뇯뇱",7,"뇺뇼뇾",5,"눆눇눉눊눍",6,"눖눘눚",5,"눡",18,"눵",6,"눽",26,"뉙뉚뉛뉝뉞뉟뉡",6,"뉪",4],["8841","뉯",4,"뉶",5,"뉽",6,"늆늇늈늊",4],["8861","늏늒늓늕늖늗늛",4,"늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷"],["8881","늸",15,"닊닋닍닎닏닑닓",4,"닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉",6,"댒댖",5,"댝",54,"덗덙덚덝덠덡덢덣"],["8941","덦덨덪덬덭덯덲덳덵덶덷덹",6,"뎂뎆",5,"뎍"],["8961","뎎뎏뎑뎒뎓뎕",10,"뎢",5,"뎩뎪뎫뎭"],["8981","뎮",21,"돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩",18,"돽",18,"됑",6,"됙됚됛됝됞됟됡",6,"됪됬",7,"됵",15],["8a41","둅",10,"둒둓둕둖둗둙",6,"둢둤둦"],["8a61","둧",4,"둭",18,"뒁뒂"],["8a81","뒃",4,"뒉",19,"뒞",5,"뒥뒦뒧뒩뒪뒫뒭",7,"뒶뒸뒺",5,"듁듂듃듅듆듇듉",6,"듑듒듓듔듖",5,"듞듟듡듢듥듧",4,"듮듰듲",5,"듹",26,"딖딗딙딚딝"],["8b41","딞",5,"딦딫",4,"딲딳딵딶딷딹",6,"땂땆"],["8b61","땇땈땉땊땎땏땑땒땓땕",6,"땞땢",8],["8b81","땫",52,"떢떣떥떦떧떩떬떭떮떯떲떶",4,"떾떿뗁뗂뗃뗅",6,"뗎뗒",5,"뗙",18,"뗭",18],["8c41","똀",15,"똒똓똕똖똗똙",4],["8c61","똞",6,"똦",5,"똭",6,"똵",5],["8c81","똻",12,"뙉",26,"뙥뙦뙧뙩",50,"뚞뚟뚡뚢뚣뚥",5,"뚭뚮뚯뚰뚲",16],["8d41","뛃",16,"뛕",8],["8d61","뛞",17,"뛱뛲뛳뛵뛶뛷뛹뛺"],["8d81","뛻",4,"뜂뜃뜄뜆",33,"뜪뜫뜭뜮뜱",6,"뜺뜼",7,"띅띆띇띉띊띋띍",6,"띖",9,"띡띢띣띥띦띧띩",6,"띲띴띶",5,"띾띿랁랂랃랅",6,"랎랓랔랕랚랛랝랞"],["8e41","랟랡",6,"랪랮",5,"랶랷랹",8],["8e61","럂",4,"럈럊",19],["8e81","럞",13,"럮럯럱럲럳럵",6,"럾렂",4,"렊렋렍렎렏렑",6,"렚렜렞",5,"렦렧렩렪렫렭",6,"렶렺",5,"롁롂롃롅",11,"롒롔",7,"롞롟롡롢롣롥",6,"롮롰롲",5,"롹롺롻롽",7],["8f41","뢅",7,"뢎",17],["8f61","뢠",7,"뢩",6,"뢱뢲뢳뢵뢶뢷뢹",4],["8f81","뢾뢿룂룄룆",5,"룍룎룏룑룒룓룕",7,"룞룠룢",5,"룪룫룭룮룯룱",6,"룺룼룾",5,"뤅",18,"뤙",6,"뤡",26,"뤾뤿륁륂륃륅",6,"륍륎륐륒",5],["9041","륚륛륝륞륟륡",6,"륪륬륮",5,"륶륷륹륺륻륽"],["9061","륾",5,"릆릈릋릌릏",15],["9081","릟",12,"릮릯릱릲릳릵",6,"릾맀맂",5,"맊맋맍맓",4,"맚맜맟맠맢맦맧맩맪맫맭",6,"맶맻",4,"먂",5,"먉",11,"먖",33,"먺먻먽먾먿멁멃멄멅멆"],["9141","멇멊멌멏멐멑멒멖멗멙멚멛멝",6,"멦멪",5],["9161","멲멳멵멶멷멹",9,"몆몈몉몊몋몍",5],["9181","몓",20,"몪몭몮몯몱몳",4,"몺몼몾",5,"뫅뫆뫇뫉",14,"뫚",33,"뫽뫾뫿묁묂묃묅",7,"묎묐묒",5,"묙묚묛묝묞묟묡",6],["9241","묨묪묬",7,"묷묹묺묿",4,"뭆뭈뭊뭋뭌뭎뭑뭒"],["9261","뭓뭕뭖뭗뭙",7,"뭢뭤",7,"뭭",4],["9281","뭲",21,"뮉뮊뮋뮍뮎뮏뮑",18,"뮥뮦뮧뮩뮪뮫뮭",6,"뮵뮶뮸",7,"믁믂믃믅믆믇믉",6,"믑믒믔",35,"믺믻믽믾밁"],["9341","밃",4,"밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵"],["9361","밶밷밹",6,"뱂뱆뱇뱈뱊뱋뱎뱏뱑",8],["9381","뱚뱛뱜뱞",37,"벆벇벉벊벍벏",4,"벖벘벛",4,"벢벣벥벦벩",6,"벲벶",5,"벾벿볁볂볃볅",7,"볎볒볓볔볖볗볙볚볛볝",22,"볷볹볺볻볽"],["9441","볾",5,"봆봈봊",5,"봑봒봓봕",8],["9461","봞",5,"봥",6,"봭",12],["9481","봺",5,"뵁",6,"뵊뵋뵍뵎뵏뵑",6,"뵚",9,"뵥뵦뵧뵩",22,"붂붃붅붆붋",4,"붒붔붖붗붘붛붝",6,"붥",10,"붱",6,"붹",24],["9541","뷒뷓뷖뷗뷙뷚뷛뷝",11,"뷪",5,"뷱"],["9561","뷲뷳뷵뷶뷷뷹",6,"븁븂븄븆",5,"븎븏븑븒븓"],["9581","븕",6,"븞븠",35,"빆빇빉빊빋빍빏",4,"빖빘빜빝빞빟빢빣빥빦빧빩빫",4,"빲빶",4,"빾빿뺁뺂뺃뺅",6,"뺎뺒",5,"뺚",13,"뺩",14],["9641","뺸",23,"뻒뻓"],["9661","뻕뻖뻙",6,"뻡뻢뻦",5,"뻭",8],["9681","뻶",10,"뼂",5,"뼊",13,"뼚뼞",33,"뽂뽃뽅뽆뽇뽉",6,"뽒뽓뽔뽖",44],["9741","뾃",16,"뾕",8],["9761","뾞",17,"뾱",7],["9781","뾹",11,"뿆",5,"뿎뿏뿑뿒뿓뿕",6,"뿝뿞뿠뿢",89,"쀽쀾쀿"],["9841","쁀",16,"쁒",5,"쁙쁚쁛"],["9861","쁝쁞쁟쁡",6,"쁪",15],["9881","쁺",21,"삒삓삕삖삗삙",6,"삢삤삦",5,"삮삱삲삷",4,"삾샂샃샄샆샇샊샋샍샎샏샑",6,"샚샞",5,"샦샧샩샪샫샭",6,"샶샸샺",5,"섁섂섃섅섆섇섉",6,"섑섒섓섔섖",5,"섡섢섥섨섩섪섫섮"],["9941","섲섳섴섵섷섺섻섽섾섿셁",6,"셊셎",5,"셖셗"],["9961","셙셚셛셝",6,"셦셪",5,"셱셲셳셵셶셷셹셺셻"],["9981","셼",8,"솆",5,"솏솑솒솓솕솗",4,"솞솠솢솣솤솦솧솪솫솭솮솯솱",11,"솾",5,"쇅쇆쇇쇉쇊쇋쇍",6,"쇕쇖쇙",6,"쇡쇢쇣쇥쇦쇧쇩",6,"쇲쇴",7,"쇾쇿숁숂숃숅",6,"숎숐숒",5,"숚숛숝숞숡숢숣"],["9a41","숤숥숦숧숪숬숮숰숳숵",16],["9a61","쉆쉇쉉",6,"쉒쉓쉕쉖쉗쉙",6,"쉡쉢쉣쉤쉦"],["9a81","쉧",4,"쉮쉯쉱쉲쉳쉵",6,"쉾슀슂",5,"슊",5,"슑",6,"슙슚슜슞",5,"슦슧슩슪슫슮",5,"슶슸슺",33,"싞싟싡싢싥",5,"싮싰싲싳싴싵싷싺싽싾싿쌁",6,"쌊쌋쌎쌏"],["9b41","쌐쌑쌒쌖쌗쌙쌚쌛쌝",6,"쌦쌧쌪",8],["9b61","쌳",17,"썆",7],["9b81","썎",25,"썪썫썭썮썯썱썳",4,"썺썻썾",5,"쎅쎆쎇쎉쎊쎋쎍",50,"쏁",22,"쏚"],["9c41","쏛쏝쏞쏡쏣",4,"쏪쏫쏬쏮",5,"쏶쏷쏹",5],["9c61","쏿",8,"쐉",6,"쐑",9],["9c81","쐛",8,"쐥",6,"쐭쐮쐯쐱쐲쐳쐵",6,"쐾",9,"쑉",26,"쑦쑧쑩쑪쑫쑭",6,"쑶쑷쑸쑺",5,"쒁",18,"쒕",6,"쒝",12],["9d41","쒪",13,"쒹쒺쒻쒽",8],["9d61","쓆",25],["9d81","쓠",8,"쓪",5,"쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂",9,"씍씎씏씑씒씓씕",6,"씝",10,"씪씫씭씮씯씱",6,"씺씼씾",5,"앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩",6,"앲앶",5,"앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔"],["9e41","얖얙얚얛얝얞얟얡",7,"얪",9,"얶"],["9e61","얷얺얿",4,"엋엍엏엒엓엕엖엗엙",6,"엢엤엦엧"],["9e81","엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑",6,"옚옝",6,"옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉",6,"왒왖",5,"왞왟왡",10,"왭왮왰왲",5,"왺왻왽왾왿욁",6,"욊욌욎",5,"욖욗욙욚욛욝",6,"욦"],["9f41","욨욪",5,"욲욳욵욶욷욻",4,"웂웄웆",5,"웎"],["9f61","웏웑웒웓웕",6,"웞웟웢",5,"웪웫웭웮웯웱웲"],["9f81","웳",4,"웺웻웼웾",5,"윆윇윉윊윋윍",6,"윖윘윚",5,"윢윣윥윦윧윩",6,"윲윴윶윸윹윺윻윾윿읁읂읃읅",4,"읋읎읐읙읚읛읝읞읟읡",6,"읩읪읬",7,"읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛",4,"잢잧",4,"잮잯잱잲잳잵잶잷"],["a041","잸잹잺잻잾쟂",5,"쟊쟋쟍쟏쟑",6,"쟙쟚쟛쟜"],["a061","쟞",5,"쟥쟦쟧쟩쟪쟫쟭",13],["a081","쟻",4,"젂젃젅젆젇젉젋",4,"젒젔젗",4,"젞젟젡젢젣젥",6,"젮젰젲",5,"젹젺젻젽젾젿졁",6,"졊졋졎",5,"졕",26,"졲졳졵졶졷졹졻",4,"좂좄좈좉좊좎",5,"좕",7,"좞좠좢좣좤"],["a141","좥좦좧좩",18,"좾좿죀죁"],["a161","죂죃죅죆죇죉죊죋죍",6,"죖죘죚",5,"죢죣죥"],["a181","죦",14,"죶",5,"죾죿줁줂줃줇",4,"줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈",9,"±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢"],["a241","줐줒",5,"줙",18],["a261","줭",6,"줵",18],["a281","쥈",7,"쥒쥓쥕쥖쥗쥙",6,"쥢쥤",7,"쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®"],["a341","쥱쥲쥳쥵",6,"쥽",10,"즊즋즍즎즏"],["a361","즑",6,"즚즜즞",16],["a381","즯",16,"짂짃짅짆짉짋",4,"짒짔짗짘짛！",58,"￦］",32,"￣"],["a441","짞짟짡짣짥짦짨짩짪짫짮짲",5,"짺짻짽짾짿쨁쨂쨃쨄"],["a461","쨅쨆쨇쨊쨎",5,"쨕쨖쨗쨙",12],["a481","쨦쨧쨨쨪",28,"ㄱ",93],["a541","쩇",4,"쩎쩏쩑쩒쩓쩕",6,"쩞쩢",5,"쩩쩪"],["a561","쩫",17,"쩾",5,"쪅쪆"],["a581","쪇",16,"쪙",14,"ⅰ",9],["a5b0","Ⅰ",9],["a5c1","Α",16,"Σ",6],["a5e1","α",16,"σ",6],["a641","쪨",19,"쪾쪿쫁쫂쫃쫅"],["a661","쫆",5,"쫎쫐쫒쫔쫕쫖쫗쫚",5,"쫡",6],["a681","쫨쫩쫪쫫쫭",6,"쫵",18,"쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃",7],["a741","쬋",4,"쬑쬒쬓쬕쬖쬗쬙",6,"쬢",7],["a761","쬪",22,"쭂쭃쭄"],["a781","쭅쭆쭇쭊쭋쭍쭎쭏쭑",6,"쭚쭛쭜쭞",5,"쭥",7,"㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙",9,"㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰",9,"㎀",4,"㎺",5,"㎐",4,"Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆"],["a841","쭭",10,"쭺",14],["a861","쮉",18,"쮝",6],["a881","쮤",19,"쮹",11,"ÆÐªĦ"],["a8a6","Ĳ"],["a8a8","ĿŁØŒºÞŦŊ"],["a8b1","㉠",27,"ⓐ",25,"①",14,"½⅓⅔¼¾⅛⅜⅝⅞"],["a941","쯅",14,"쯕",10],["a961","쯠쯡쯢쯣쯥쯦쯨쯪",18],["a981","쯽",14,"찎찏찑찒찓찕",6,"찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀",27,"⒜",25,"⑴",14,"¹²³⁴ⁿ₁₂₃₄"],["aa41","찥찦찪찫찭찯찱",6,"찺찿",4,"챆챇챉챊챋챍챎"],["aa61","챏",4,"챖챚",5,"챡챢챣챥챧챩",6,"챱챲"],["aa81","챳챴챶",29,"ぁ",82],["ab41","첔첕첖첗첚첛첝첞첟첡",6,"첪첮",5,"첶첷첹"],["ab61","첺첻첽",6,"쳆쳈쳊",5,"쳑쳒쳓쳕",5],["ab81","쳛",8,"쳥",6,"쳭쳮쳯쳱",12,"ァ",85],["ac41","쳾쳿촀촂",5,"촊촋촍촎촏촑",6,"촚촜촞촟촠"],["ac61","촡촢촣촥촦촧촩촪촫촭",11,"촺",4],["ac81","촿",28,"쵝쵞쵟А",5,"ЁЖ",25],["acd1","а",5,"ёж",25],["ad41","쵡쵢쵣쵥",6,"쵮쵰쵲",5,"쵹",7],["ad61","춁",6,"춉",10,"춖춗춙춚춛춝춞춟"],["ad81","춠춡춢춣춦춨춪",5,"춱",18,"췅"],["ae41","췆",5,"췍췎췏췑",16],["ae61","췢",5,"췩췪췫췭췮췯췱",6,"췺췼췾",4],["ae81","츃츅츆츇츉츊츋츍",6,"츕츖츗츘츚",5,"츢츣츥츦츧츩츪츫"],["af41","츬츭츮츯츲츴츶",19],["af61","칊",13,"칚칛칝칞칢",5,"칪칬"],["af81","칮",5,"칶칷칹칺칻칽",6,"캆캈캊",5,"캒캓캕캖캗캙"],["b041","캚",5,"캢캦",5,"캮",12],["b061","캻",5,"컂",19],["b081","컖",13,"컦컧컩컪컭",6,"컶컺",5,"가각간갇갈갉갊감",7,"같",4,"갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆"],["b141","켂켃켅켆켇켉",6,"켒켔켖",5,"켝켞켟켡켢켣"],["b161","켥",6,"켮켲",5,"켹",11],["b181","콅",14,"콖콗콙콚콛콝",6,"콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸"],["b241","콭콮콯콲콳콵콶콷콹",6,"쾁쾂쾃쾄쾆",5,"쾍"],["b261","쾎",18,"쾢",5,"쾩"],["b281","쾪",5,"쾱",18,"쿅",6,"깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙"],["b341","쿌",19,"쿢쿣쿥쿦쿧쿩"],["b361","쿪",5,"쿲쿴쿶",5,"쿽쿾쿿퀁퀂퀃퀅",5],["b381","퀋",5,"퀒",5,"퀙",19,"끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫",4,"낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝"],["b441","퀮",5,"퀶퀷퀹퀺퀻퀽",6,"큆큈큊",5],["b461","큑큒큓큕큖큗큙",6,"큡",10,"큮큯"],["b481","큱큲큳큵",6,"큾큿킀킂",18,"뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫",4,"닳담답닷",4,"닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥"],["b541","킕",14,"킦킧킩킪킫킭",5],["b561","킳킶킸킺",5,"탂탃탅탆탇탊",5,"탒탖",4],["b581","탛탞탟탡탢탣탥",6,"탮탲",5,"탹",11,"덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸"],["b641","턅",7,"턎",17],["b661","턠",15,"턲턳턵턶턷턹턻턼턽턾"],["b681","턿텂텆",5,"텎텏텑텒텓텕",6,"텞텠텢",5,"텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗"],["b741","텮",13,"텽",6,"톅톆톇톉톊"],["b761","톋",20,"톢톣톥톦톧"],["b781","톩",6,"톲톴톶톷톸톹톻톽톾톿퇁",14,"래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩"],["b841","퇐",7,"퇙",17],["b861","퇫",8,"퇵퇶퇷퇹",13],["b881","툈툊",5,"툑",24,"륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많",4,"맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼"],["b941","툪툫툮툯툱툲툳툵",6,"툾퉀퉂",5,"퉉퉊퉋퉌"],["b961","퉍",14,"퉝",6,"퉥퉦퉧퉨"],["b981","퉩",22,"튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바",4,"받",4,"밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗"],["ba41","튍튎튏튒튓튔튖",5,"튝튞튟튡튢튣튥",6,"튭"],["ba61","튮튯튰튲",5,"튺튻튽튾틁틃",4,"틊틌",5],["ba81","틒틓틕틖틗틙틚틛틝",6,"틦",9,"틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤"],["bb41","틻",4,"팂팄팆",5,"팏팑팒팓팕팗",4,"팞팢팣"],["bb61","팤팦팧팪팫팭팮팯팱",6,"팺팾",5,"퍆퍇퍈퍉"],["bb81","퍊",31,"빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤"],["bc41","퍪",17,"퍾퍿펁펂펃펅펆펇"],["bc61","펈펉펊펋펎펒",5,"펚펛펝펞펟펡",6,"펪펬펮"],["bc81","펯",4,"펵펶펷펹펺펻펽",6,"폆폇폊",5,"폑",5,"샥샨샬샴샵샷샹섀섄섈섐섕서",4,"섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭"],["bd41","폗폙",7,"폢폤",7,"폮폯폱폲폳폵폶폷"],["bd61","폸폹폺폻폾퐀퐂",5,"퐉",13],["bd81","퐗",5,"퐞",25,"숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰"],["be41","퐸",7,"푁푂푃푅",14],["be61","푔",7,"푝푞푟푡푢푣푥",7,"푮푰푱푲"],["be81","푳",4,"푺푻푽푾풁풃",4,"풊풌풎",5,"풕",8,"쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄",6,"엌엎"],["bf41","풞",10,"풪",14],["bf61","풹",18,"퓍퓎퓏퓑퓒퓓퓕"],["bf81","퓖",5,"퓝퓞퓠",7,"퓩퓪퓫퓭퓮퓯퓱",6,"퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염",5,"옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨"],["c041","퓾",5,"픅픆픇픉픊픋픍",6,"픖픘",5],["c061","픞",25],["c081","픸픹픺픻픾픿핁핂핃핅",6,"핎핐핒",5,"핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응",7,"읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊"],["c141","핤핦핧핪핬핮",5,"핶핷핹핺핻핽",6,"햆햊햋"],["c161","햌햍햎햏햑",19,"햦햧"],["c181","햨",31,"점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓"],["c241","헊헋헍헎헏헑헓",4,"헚헜헞",5,"헦헧헩헪헫헭헮"],["c261","헯",4,"헶헸헺",5,"혂혃혅혆혇혉",6,"혒"],["c281","혖",5,"혝혞혟혡혢혣혥",7,"혮",9,"혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻"],["c341","혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝",4],["c361","홢",4,"홨홪",5,"홲홳홵",11],["c381","횁횂횄횆",5,"횎횏횑횒횓횕",7,"횞횠횢",5,"횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층"],["c441","횫횭횮횯횱",7,"횺횼",7,"훆훇훉훊훋"],["c461","훍훎훏훐훒훓훕훖훘훚",5,"훡훢훣훥훦훧훩",4],["c481","훮훯훱훲훳훴훶",5,"훾훿휁휂휃휅",11,"휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼"],["c541","휕휖휗휚휛휝휞휟휡",6,"휪휬휮",5,"휶휷휹"],["c561","휺휻휽",6,"흅흆흈흊",5,"흒흓흕흚",4],["c581","흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵",6,"흾흿힀힂",5,"힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜"],["c641","힍힎힏힑",6,"힚힜힞",5],["c6a1","퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁"],["c7a1","퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠"],["c8a1","혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝"],["caa1","伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕"],["cba1","匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢"],["cca1","瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械"],["cda1","棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜"],["cea1","科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾"],["cfa1","區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴"],["d0a1","鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣"],["d1a1","朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩",5,"那樂",4,"諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉"],["d2a1","納臘蠟衲囊娘廊",4,"乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧",5,"駑魯",10,"濃籠聾膿農惱牢磊腦賂雷尿壘",7,"嫩訥杻紐勒",5,"能菱陵尼泥匿溺多茶"],["d3a1","丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃"],["d4a1","棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅"],["d5a1","蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣"],["d6a1","煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼"],["d7a1","遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬"],["d8a1","立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅"],["d9a1","蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文"],["daa1","汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑"],["dba1","發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖"],["dca1","碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦"],["dda1","孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥"],["dea1","脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索"],["dfa1","傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署"],["e0a1","胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬"],["e1a1","聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁"],["e2a1","戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧"],["e3a1","嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁"],["e4a1","沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額"],["e5a1","櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬"],["e6a1","旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒"],["e7a1","簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳"],["e8a1","烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療"],["e9a1","窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓"],["eaa1","運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜"],["eba1","濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼"],["eca1","議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄"],["eda1","立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長"],["eea1","障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱"],["efa1","煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖"],["f0a1","靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫"],["f1a1","踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只"],["f2a1","咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯"],["f3a1","鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策"],["f4a1","責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢"],["f5a1","椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃"],["f6a1","贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託"],["f7a1","鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑"],["f8a1","阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃"],["f9a1","品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航"],["faa1","行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型"],["fba1","形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵"],["fca1","禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆"],["fda1","爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰"]]');
        /***/ }),

      /***/ 4284:
      /***/ (function (module) {
        module.exports = JSON.parse('[["0","\\u0000",127],["a140","　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚"],["a1a1","﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢",4,"～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／"],["a240","＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁",7,"▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭"],["a2a1","╮╰╯═╞╪╡◢◣◥◤╱╲╳０",9,"Ⅰ",9,"〡",8,"十卄卅Ａ",25,"ａ",21],["a340","ｗｘｙｚΑ",16,"Σ",6,"α",16,"σ",6,"ㄅ",10],["a3a1","ㄐ",25,"˙ˉˊˇˋ"],["a3e1","€"],["a440","一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才"],["a4a1","丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙"],["a540","世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外"],["a5a1","央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全"],["a640","共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年"],["a6a1","式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣"],["a740","作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍"],["a7a1","均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠"],["a840","杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒"],["a8a1","芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵"],["a940","咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居"],["a9a1","屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊"],["aa40","昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠"],["aaa1","炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附"],["ab40","陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品"],["aba1","哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷"],["ac40","拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗"],["aca1","活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄"],["ad40","耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥"],["ada1","迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪"],["ae40","哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙"],["aea1","恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓"],["af40","浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷"],["afa1","砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃"],["b040","虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡"],["b0a1","陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀"],["b140","娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽"],["b1a1","情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺"],["b240","毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶"],["b2a1","瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼"],["b340","莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途"],["b3a1","部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠"],["b440","婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍"],["b4a1","插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋"],["b540","溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘"],["b5a1","窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁"],["b640","詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑"],["b6a1","間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼"],["b740","媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業"],["b7a1","楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督"],["b840","睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫"],["b8a1","腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊"],["b940","辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴"],["b9a1","飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇"],["ba40","愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢"],["baa1","滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬"],["bb40","罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤"],["bba1","說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜"],["bc40","劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂"],["bca1","慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃"],["bd40","瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯"],["bda1","翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞"],["be40","輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉"],["bea1","鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡"],["bf40","濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊"],["bfa1","縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚"],["c040","錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇"],["c0a1","嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬"],["c140","瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪"],["c1a1","薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁"],["c240","駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘"],["c2a1","癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦"],["c340","鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸"],["c3a1","獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類"],["c440","願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼"],["c4a1","纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴"],["c540","護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬"],["c5a1","禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒"],["c640","讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲"],["c940","乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕"],["c9a1","氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋"],["ca40","汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘"],["caa1","吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇"],["cb40","杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓"],["cba1","芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢"],["cc40","坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋"],["cca1","怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲"],["cd40","泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺"],["cda1","矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏"],["ce40","哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛"],["cea1","峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺"],["cf40","柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂"],["cfa1","洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀"],["d040","穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪"],["d0a1","苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱"],["d140","唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧"],["d1a1","恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤"],["d240","毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸"],["d2a1","牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐"],["d340","笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢"],["d3a1","荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐"],["d440","酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅"],["d4a1","唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏"],["d540","崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟"],["d5a1","捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉"],["d640","淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏"],["d6a1","痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟"],["d740","耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷"],["d7a1","蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪"],["d840","釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷"],["d8a1","堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔"],["d940","惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒"],["d9a1","晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞"],["da40","湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖"],["daa1","琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥"],["db40","罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳"],["dba1","菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺"],["dc40","軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈"],["dca1","隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆"],["dd40","媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤"],["dda1","搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼"],["de40","毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓"],["dea1","煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓"],["df40","稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯"],["dfa1","腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤"],["e040","觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿"],["e0a1","遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠"],["e140","凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠"],["e1a1","寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉"],["e240","榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊"],["e2a1","漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓"],["e340","禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞"],["e3a1","耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻"],["e440","裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍"],["e4a1","銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘"],["e540","噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉"],["e5a1","憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒"],["e640","澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙"],["e6a1","獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟"],["e740","膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢"],["e7a1","蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧"],["e840","踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓"],["e8a1","銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮"],["e940","噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺"],["e9a1","憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸"],["ea40","澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙"],["eaa1","瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘"],["eb40","蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠"],["eba1","諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌"],["ec40","錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕"],["eca1","魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎"],["ed40","檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶"],["eda1","瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞"],["ee40","蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞"],["eea1","謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜"],["ef40","鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰"],["efa1","鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶"],["f040","璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒"],["f0a1","臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧"],["f140","蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪"],["f1a1","鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰"],["f240","徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛"],["f2a1","礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕"],["f340","譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦"],["f3a1","鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲"],["f440","嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩"],["f4a1","禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿"],["f540","鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛"],["f5a1","鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥"],["f640","蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺"],["f6a1","騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚"],["f740","糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊"],["f7a1","驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾"],["f840","讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏"],["f8a1","齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚"],["f940","纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊"],["f9a1","龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓"]]');
        /***/ }),

      /***/ 5633:
      /***/ (function (module) {
        module.exports = JSON.parse('[["0","\\u0000",127],["8ea1","｡",62],["a1a1","　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈",9,"＋－±×÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇"],["a2a1","◆□■△▲▽▼※〒→←↑↓〓"],["a2ba","∈∋⊆⊇⊂⊃∪∩"],["a2ca","∧∨￢⇒⇔∀∃"],["a2dc","∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬"],["a2f2","Å‰♯♭♪†‡¶"],["a2fe","◯"],["a3b0","０",9],["a3c1","Ａ",25],["a3e1","ａ",25],["a4a1","ぁ",82],["a5a1","ァ",85],["a6a1","Α",16,"Σ",6],["a6c1","α",16,"σ",6],["a7a1","А",5,"ЁЖ",25],["a7d1","а",5,"ёж",25],["a8a1","─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂"],["ada1","①",19,"Ⅰ",9],["adc0","㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡"],["addf","㍻〝〟№㏍℡㊤",4,"㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪"],["b0a1","亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭"],["b1a1","院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応"],["b2a1","押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改"],["b3a1","魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱"],["b4a1","粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄"],["b5a1","機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京"],["b6a1","供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈"],["b7a1","掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲"],["b8a1","検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向"],["b9a1","后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込"],["baa1","此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷"],["bba1","察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時"],["bca1","次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周"],["bda1","宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償"],["bea1","勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾"],["bfa1","拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾"],["c0a1","澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線"],["c1a1","繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎"],["c2a1","臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只"],["c3a1","叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵"],["c4a1","帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓"],["c5a1","邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到"],["c6a1","董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入"],["c7a1","如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦"],["c8a1","函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美"],["c9a1","鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服"],["caa1","福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋"],["cba1","法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満"],["cca1","漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒"],["cda1","諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃"],["cea1","痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯"],["cfa1","蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕"],["d0a1","弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲"],["d1a1","僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨"],["d2a1","辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨"],["d3a1","咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉"],["d4a1","圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩"],["d5a1","奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓"],["d6a1","屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏"],["d7a1","廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚"],["d8a1","悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛"],["d9a1","戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼"],["daa1","據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼"],["dba1","曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍"],["dca1","棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣"],["dda1","檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾"],["dea1","沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌"],["dfa1","漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼"],["e0a1","燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱"],["e1a1","瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰"],["e2a1","癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬"],["e3a1","磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐"],["e4a1","筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆"],["e5a1","紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺"],["e6a1","罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋"],["e7a1","隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙"],["e8a1","茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈"],["e9a1","蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙"],["eaa1","蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞"],["eba1","襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫"],["eca1","譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊"],["eda1","蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸"],["eea1","遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮"],["efa1","錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞"],["f0a1","陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰"],["f1a1","顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷"],["f2a1","髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈"],["f3a1","鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠"],["f4a1","堯槇遙瑤凜熙"],["f9a1","纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德"],["faa1","忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱"],["fba1","犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚"],["fca1","釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"],["fcf1","ⅰ",9,"￢￤＇＂"],["8fa2af","˘ˇ¸˙˝¯˛˚～΄΅"],["8fa2c2","¡¦¿"],["8fa2eb","ºª©®™¤№"],["8fa6e1","ΆΈΉΊΪ"],["8fa6e7","Ό"],["8fa6e9","ΎΫ"],["8fa6ec","Ώ"],["8fa6f1","άέήίϊΐόςύϋΰώ"],["8fa7c2","Ђ",10,"ЎЏ"],["8fa7f2","ђ",10,"ўџ"],["8fa9a1","ÆĐ"],["8fa9a4","Ħ"],["8fa9a6","Ĳ"],["8fa9a8","ŁĿ"],["8fa9ab","ŊØŒ"],["8fa9af","ŦÞ"],["8fa9c1","æđðħıĳĸłŀŉŋøœßŧþ"],["8faaa1","ÁÀÄÂĂǍĀĄÅÃĆĈČÇĊĎÉÈËÊĚĖĒĘ"],["8faaba","ĜĞĢĠĤÍÌÏÎǏİĪĮĨĴĶĹĽĻŃŇŅÑÓÒÖÔǑŐŌÕŔŘŖŚŜŠŞŤŢÚÙÜÛŬǓŰŪŲŮŨǗǛǙǕŴÝŸŶŹŽŻ"],["8faba1","áàäâăǎāąåãćĉčçċďéèëêěėēęǵĝğ"],["8fabbd","ġĥíìïîǐ"],["8fabc5","īįĩĵķĺľļńňņñóòöôǒőōõŕřŗśŝšşťţúùüûŭǔűūųůũǘǜǚǖŵýÿŷźžż"],["8fb0a1","丂丄丅丌丒丟丣两丨丫丮丯丰丵乀乁乄乇乑乚乜乣乨乩乴乵乹乿亍亖亗亝亯亹仃仐仚仛仠仡仢仨仯仱仳仵份仾仿伀伂伃伈伋伌伒伕伖众伙伮伱你伳伵伷伹伻伾佀佂佈佉佋佌佒佔佖佘佟佣佪佬佮佱佷佸佹佺佽佾侁侂侄"],["8fb1a1","侅侉侊侌侎侐侒侓侔侗侙侚侞侟侲侷侹侻侼侽侾俀俁俅俆俈俉俋俌俍俏俒俜俠俢俰俲俼俽俿倀倁倄倇倊倌倎倐倓倗倘倛倜倝倞倢倧倮倰倲倳倵偀偁偂偅偆偊偌偎偑偒偓偗偙偟偠偢偣偦偧偪偭偰偱倻傁傃傄傆傊傎傏傐"],["8fb2a1","傒傓傔傖傛傜傞",4,"傪傯傰傹傺傽僀僃僄僇僌僎僐僓僔僘僜僝僟僢僤僦僨僩僯僱僶僺僾儃儆儇儈儋儌儍儎僲儐儗儙儛儜儝儞儣儧儨儬儭儯儱儳儴儵儸儹兂兊兏兓兕兗兘兟兤兦兾冃冄冋冎冘冝冡冣冭冸冺冼冾冿凂"],["8fb3a1","凈减凑凒凓凕凘凞凢凥凮凲凳凴凷刁刂刅划刓刕刖刘刢刨刱刲刵刼剅剉剕剗剘剚剜剟剠剡剦剮剷剸剹劀劂劅劊劌劓劕劖劗劘劚劜劤劥劦劧劯劰劶劷劸劺劻劽勀勄勆勈勌勏勑勔勖勛勜勡勥勨勩勪勬勰勱勴勶勷匀匃匊匋"],["8fb4a1","匌匑匓匘匛匜匞匟匥匧匨匩匫匬匭匰匲匵匼匽匾卂卌卋卙卛卡卣卥卬卭卲卹卾厃厇厈厎厓厔厙厝厡厤厪厫厯厲厴厵厷厸厺厽叀叅叏叒叓叕叚叝叞叠另叧叵吂吓吚吡吧吨吪启吱吴吵呃呄呇呍呏呞呢呤呦呧呩呫呭呮呴呿"],["8fb5a1","咁咃咅咈咉咍咑咕咖咜咟咡咦咧咩咪咭咮咱咷咹咺咻咿哆哊响哎哠哪哬哯哶哼哾哿唀唁唅唈唉唌唍唎唕唪唫唲唵唶唻唼唽啁啇啉啊啍啐啑啘啚啛啞啠啡啤啦啿喁喂喆喈喎喏喑喒喓喔喗喣喤喭喲喿嗁嗃嗆嗉嗋嗌嗎嗑嗒"],["8fb6a1","嗓嗗嗘嗛嗞嗢嗩嗶嗿嘅嘈嘊嘍",5,"嘙嘬嘰嘳嘵嘷嘹嘻嘼嘽嘿噀噁噃噄噆噉噋噍噏噔噞噠噡噢噣噦噩噭噯噱噲噵嚄嚅嚈嚋嚌嚕嚙嚚嚝嚞嚟嚦嚧嚨嚩嚫嚬嚭嚱嚳嚷嚾囅囉囊囋囏囐囌囍囙囜囝囟囡囤",4,"囱囫园"],["8fb7a1","囶囷圁圂圇圊圌圑圕圚圛圝圠圢圣圤圥圩圪圬圮圯圳圴圽圾圿坅坆坌坍坒坢坥坧坨坫坭",4,"坳坴坵坷坹坺坻坼坾垁垃垌垔垗垙垚垜垝垞垟垡垕垧垨垩垬垸垽埇埈埌埏埕埝埞埤埦埧埩埭埰埵埶埸埽埾埿堃堄堈堉埡"],["8fb8a1","堌堍堛堞堟堠堦堧堭堲堹堿塉塌塍塏塐塕塟塡塤塧塨塸塼塿墀墁墇墈墉墊墌墍墏墐墔墖墝墠墡墢墦墩墱墲壄墼壂壈壍壎壐壒壔壖壚壝壡壢壩壳夅夆夋夌夒夓夔虁夝夡夣夤夨夯夰夳夵夶夿奃奆奒奓奙奛奝奞奟奡奣奫奭"],["8fb9a1","奯奲奵奶她奻奼妋妌妎妒妕妗妟妤妧妭妮妯妰妳妷妺妼姁姃姄姈姊姍姒姝姞姟姣姤姧姮姯姱姲姴姷娀娄娌娍娎娒娓娞娣娤娧娨娪娭娰婄婅婇婈婌婐婕婞婣婥婧婭婷婺婻婾媋媐媓媖媙媜媞媟媠媢媧媬媱媲媳媵媸媺媻媿"],["8fbaa1","嫄嫆嫈嫏嫚嫜嫠嫥嫪嫮嫵嫶嫽嬀嬁嬈嬗嬴嬙嬛嬝嬡嬥嬭嬸孁孋孌孒孖孞孨孮孯孼孽孾孿宁宄宆宊宎宐宑宓宔宖宨宩宬宭宯宱宲宷宺宼寀寁寍寏寖",4,"寠寯寱寴寽尌尗尞尟尣尦尩尫尬尮尰尲尵尶屙屚屜屢屣屧屨屩"],["8fbba1","屭屰屴屵屺屻屼屽岇岈岊岏岒岝岟岠岢岣岦岪岲岴岵岺峉峋峒峝峗峮峱峲峴崁崆崍崒崫崣崤崦崧崱崴崹崽崿嵂嵃嵆嵈嵕嵑嵙嵊嵟嵠嵡嵢嵤嵪嵭嵰嵹嵺嵾嵿嶁嶃嶈嶊嶒嶓嶔嶕嶙嶛嶟嶠嶧嶫嶰嶴嶸嶹巃巇巋巐巎巘巙巠巤"],["8fbca1","巩巸巹帀帇帍帒帔帕帘帟帠帮帨帲帵帾幋幐幉幑幖幘幛幜幞幨幪",4,"幰庀庋庎庢庤庥庨庪庬庱庳庽庾庿廆廌廋廎廑廒廔廕廜廞廥廫异弆弇弈弎弙弜弝弡弢弣弤弨弫弬弮弰弴弶弻弽弿彀彄彅彇彍彐彔彘彛彠彣彤彧"],["8fbda1","彯彲彴彵彸彺彽彾徉徍徏徖徜徝徢徧徫徤徬徯徰徱徸忄忇忈忉忋忐",4,"忞忡忢忨忩忪忬忭忮忯忲忳忶忺忼怇怊怍怓怔怗怘怚怟怤怭怳怵恀恇恈恉恌恑恔恖恗恝恡恧恱恾恿悂悆悈悊悎悑悓悕悘悝悞悢悤悥您悰悱悷"],["8fbea1","悻悾惂惄惈惉惊惋惎惏惔惕惙惛惝惞惢惥惲惵惸惼惽愂愇愊愌愐",4,"愖愗愙愜愞愢愪愫愰愱愵愶愷愹慁慅慆慉慞慠慬慲慸慻慼慿憀憁憃憄憋憍憒憓憗憘憜憝憟憠憥憨憪憭憸憹憼懀懁懂懎懏懕懜懝懞懟懡懢懧懩懥"],["8fbfa1","懬懭懯戁戃戄戇戓戕戜戠戢戣戧戩戫戹戽扂扃扄扆扌扐扑扒扔扖扚扜扤扭扯扳扺扽抍抎抏抐抦抨抳抶抷抺抾抿拄拎拕拖拚拪拲拴拼拽挃挄挊挋挍挐挓挖挘挩挪挭挵挶挹挼捁捂捃捄捆捊捋捎捒捓捔捘捛捥捦捬捭捱捴捵"],["8fc0a1","捸捼捽捿掂掄掇掊掐掔掕掙掚掞掤掦掭掮掯掽揁揅揈揎揑揓揔揕揜揠揥揪揬揲揳揵揸揹搉搊搐搒搔搘搞搠搢搤搥搩搪搯搰搵搽搿摋摏摑摒摓摔摚摛摜摝摟摠摡摣摭摳摴摻摽撅撇撏撐撑撘撙撛撝撟撡撣撦撨撬撳撽撾撿"],["8fc1a1","擄擉擊擋擌擎擐擑擕擗擤擥擩擪擭擰擵擷擻擿攁攄攈攉攊攏攓攔攖攙攛攞攟攢攦攩攮攱攺攼攽敃敇敉敐敒敔敟敠敧敫敺敽斁斅斊斒斕斘斝斠斣斦斮斲斳斴斿旂旈旉旎旐旔旖旘旟旰旲旴旵旹旾旿昀昄昈昉昍昑昒昕昖昝"],["8fc2a1","昞昡昢昣昤昦昩昪昫昬昮昰昱昳昹昷晀晅晆晊晌晑晎晗晘晙晛晜晠晡曻晪晫晬晾晳晵晿晷晸晹晻暀晼暋暌暍暐暒暙暚暛暜暟暠暤暭暱暲暵暻暿曀曂曃曈曌曎曏曔曛曟曨曫曬曮曺朅朇朎朓朙朜朠朢朳朾杅杇杈杌杔杕杝"],["8fc3a1","杦杬杮杴杶杻极构枎枏枑枓枖枘枙枛枰枱枲枵枻枼枽柹柀柂柃柅柈柉柒柗柙柜柡柦柰柲柶柷桒栔栙栝栟栨栧栬栭栯栰栱栳栻栿桄桅桊桌桕桗桘桛桫桮",4,"桵桹桺桻桼梂梄梆梈梖梘梚梜梡梣梥梩梪梮梲梻棅棈棌棏"],["8fc4a1","棐棑棓棖棙棜棝棥棨棪棫棬棭棰棱棵棶棻棼棽椆椉椊椐椑椓椖椗椱椳椵椸椻楂楅楉楎楗楛楣楤楥楦楨楩楬楰楱楲楺楻楿榀榍榒榖榘榡榥榦榨榫榭榯榷榸榺榼槅槈槑槖槗槢槥槮槯槱槳槵槾樀樁樃樏樑樕樚樝樠樤樨樰樲"],["8fc5a1","樴樷樻樾樿橅橆橉橊橎橐橑橒橕橖橛橤橧橪橱橳橾檁檃檆檇檉檋檑檛檝檞檟檥檫檯檰檱檴檽檾檿櫆櫉櫈櫌櫐櫔櫕櫖櫜櫝櫤櫧櫬櫰櫱櫲櫼櫽欂欃欆欇欉欏欐欑欗欛欞欤欨欫欬欯欵欶欻欿歆歊歍歒歖歘歝歠歧歫歮歰歵歽"],["8fc6a1","歾殂殅殗殛殟殠殢殣殨殩殬殭殮殰殸殹殽殾毃毄毉毌毖毚毡毣毦毧毮毱毷毹毿氂氄氅氉氍氎氐氒氙氟氦氧氨氬氮氳氵氶氺氻氿汊汋汍汏汒汔汙汛汜汫汭汯汴汶汸汹汻沅沆沇沉沔沕沗沘沜沟沰沲沴泂泆泍泏泐泑泒泔泖"],["8fc7a1","泚泜泠泧泩泫泬泮泲泴洄洇洊洎洏洑洓洚洦洧洨汧洮洯洱洹洼洿浗浞浟浡浥浧浯浰浼涂涇涑涒涔涖涗涘涪涬涴涷涹涽涿淄淈淊淎淏淖淛淝淟淠淢淥淩淯淰淴淶淼渀渄渞渢渧渲渶渹渻渼湄湅湈湉湋湏湑湒湓湔湗湜湝湞"],["8fc8a1","湢湣湨湳湻湽溍溓溙溠溧溭溮溱溳溻溿滀滁滃滇滈滊滍滎滏滫滭滮滹滻滽漄漈漊漌漍漖漘漚漛漦漩漪漯漰漳漶漻漼漭潏潑潒潓潗潙潚潝潞潡潢潨潬潽潾澃澇澈澋澌澍澐澒澓澔澖澚澟澠澥澦澧澨澮澯澰澵澶澼濅濇濈濊"],["8fc9a1","濚濞濨濩濰濵濹濼濽瀀瀅瀆瀇瀍瀗瀠瀣瀯瀴瀷瀹瀼灃灄灈灉灊灋灔灕灝灞灎灤灥灬灮灵灶灾炁炅炆炔",4,"炛炤炫炰炱炴炷烊烑烓烔烕烖烘烜烤烺焃",4,"焋焌焏焞焠焫焭焯焰焱焸煁煅煆煇煊煋煐煒煗煚煜煞煠"],["8fcaa1","煨煹熀熅熇熌熒熚熛熠熢熯熰熲熳熺熿燀燁燄燋燌燓燖燙燚燜燸燾爀爇爈爉爓爗爚爝爟爤爫爯爴爸爹牁牂牃牅牎牏牐牓牕牖牚牜牞牠牣牨牫牮牯牱牷牸牻牼牿犄犉犍犎犓犛犨犭犮犱犴犾狁狇狉狌狕狖狘狟狥狳狴狺狻"],["8fcba1","狾猂猄猅猇猋猍猒猓猘猙猞猢猤猧猨猬猱猲猵猺猻猽獃獍獐獒獖獘獝獞獟獠獦獧獩獫獬獮獯獱獷獹獼玀玁玃玅玆玎玐玓玕玗玘玜玞玟玠玢玥玦玪玫玭玵玷玹玼玽玿珅珆珉珋珌珏珒珓珖珙珝珡珣珦珧珩珴珵珷珹珺珻珽"],["8fcca1","珿琀琁琄琇琊琑琚琛琤琦琨",9,"琹瑀瑃瑄瑆瑇瑋瑍瑑瑒瑗瑝瑢瑦瑧瑨瑫瑭瑮瑱瑲璀璁璅璆璇璉璏璐璑璒璘璙璚璜璟璠璡璣璦璨璩璪璫璮璯璱璲璵璹璻璿瓈瓉瓌瓐瓓瓘瓚瓛瓞瓟瓤瓨瓪瓫瓯瓴瓺瓻瓼瓿甆"],["8fcda1","甒甖甗甠甡甤甧甩甪甯甶甹甽甾甿畀畃畇畈畎畐畒畗畞畟畡畯畱畹",5,"疁疅疐疒疓疕疙疜疢疤疴疺疿痀痁痄痆痌痎痏痗痜痟痠痡痤痧痬痮痯痱痹瘀瘂瘃瘄瘇瘈瘊瘌瘏瘒瘓瘕瘖瘙瘛瘜瘝瘞瘣瘥瘦瘩瘭瘲瘳瘵瘸瘹"],["8fcea1","瘺瘼癊癀癁癃癄癅癉癋癕癙癟癤癥癭癮癯癱癴皁皅皌皍皕皛皜皝皟皠皢",6,"皪皭皽盁盅盉盋盌盎盔盙盠盦盨盬盰盱盶盹盼眀眆眊眎眒眔眕眗眙眚眜眢眨眭眮眯眴眵眶眹眽眾睂睅睆睊睍睎睏睒睖睗睜睞睟睠睢"],["8fcfa1","睤睧睪睬睰睲睳睴睺睽瞀瞄瞌瞍瞔瞕瞖瞚瞟瞢瞧瞪瞮瞯瞱瞵瞾矃矉矑矒矕矙矞矟矠矤矦矪矬矰矱矴矸矻砅砆砉砍砎砑砝砡砢砣砭砮砰砵砷硃硄硇硈硌硎硒硜硞硠硡硣硤硨硪确硺硾碊碏碔碘碡碝碞碟碤碨碬碭碰碱碲碳"],["8fd0a1","碻碽碿磇磈磉磌磎磒磓磕磖磤磛磟磠磡磦磪磲磳礀磶磷磺磻磿礆礌礐礚礜礞礟礠礥礧礩礭礱礴礵礻礽礿祄祅祆祊祋祏祑祔祘祛祜祧祩祫祲祹祻祼祾禋禌禑禓禔禕禖禘禛禜禡禨禩禫禯禱禴禸离秂秄秇秈秊秏秔秖秚秝秞"],["8fd1a1","秠秢秥秪秫秭秱秸秼稂稃稇稉稊稌稑稕稛稞稡稧稫稭稯稰稴稵稸稹稺穄穅穇穈穌穕穖穙穜穝穟穠穥穧穪穭穵穸穾窀窂窅窆窊窋窐窑窔窞窠窣窬窳窵窹窻窼竆竉竌竎竑竛竨竩竫竬竱竴竻竽竾笇笔笟笣笧笩笪笫笭笮笯笰"],["8fd2a1","笱笴笽笿筀筁筇筎筕筠筤筦筩筪筭筯筲筳筷箄箉箎箐箑箖箛箞箠箥箬箯箰箲箵箶箺箻箼箽篂篅篈篊篔篖篗篙篚篛篨篪篲篴篵篸篹篺篼篾簁簂簃簄簆簉簋簌簎簏簙簛簠簥簦簨簬簱簳簴簶簹簺籆籊籕籑籒籓籙",5],["8fd3a1","籡籣籧籩籭籮籰籲籹籼籽粆粇粏粔粞粠粦粰粶粷粺粻粼粿糄糇糈糉糍糏糓糔糕糗糙糚糝糦糩糫糵紃紇紈紉紏紑紒紓紖紝紞紣紦紪紭紱紼紽紾絀絁絇絈絍絑絓絗絙絚絜絝絥絧絪絰絸絺絻絿綁綂綃綅綆綈綋綌綍綑綖綗綝"],["8fd4a1","綞綦綧綪綳綶綷綹緂",4,"緌緍緎緗緙縀緢緥緦緪緫緭緱緵緶緹緺縈縐縑縕縗縜縝縠縧縨縬縭縯縳縶縿繄繅繇繎繐繒繘繟繡繢繥繫繮繯繳繸繾纁纆纇纊纍纑纕纘纚纝纞缼缻缽缾缿罃罄罇罏罒罓罛罜罝罡罣罤罥罦罭"],["8fd5a1","罱罽罾罿羀羋羍羏羐羑羖羗羜羡羢羦羪羭羴羼羿翀翃翈翎翏翛翟翣翥翨翬翮翯翲翺翽翾翿耇耈耊耍耎耏耑耓耔耖耝耞耟耠耤耦耬耮耰耴耵耷耹耺耼耾聀聄聠聤聦聭聱聵肁肈肎肜肞肦肧肫肸肹胈胍胏胒胔胕胗胘胠胭胮"],["8fd6a1","胰胲胳胶胹胺胾脃脋脖脗脘脜脞脠脤脧脬脰脵脺脼腅腇腊腌腒腗腠腡腧腨腩腭腯腷膁膐膄膅膆膋膎膖膘膛膞膢膮膲膴膻臋臃臅臊臎臏臕臗臛臝臞臡臤臫臬臰臱臲臵臶臸臹臽臿舀舃舏舓舔舙舚舝舡舢舨舲舴舺艃艄艅艆"],["8fd7a1","艋艎艏艑艖艜艠艣艧艭艴艻艽艿芀芁芃芄芇芉芊芎芑芔芖芘芚芛芠芡芣芤芧芨芩芪芮芰芲芴芷芺芼芾芿苆苐苕苚苠苢苤苨苪苭苯苶苷苽苾茀茁茇茈茊茋荔茛茝茞茟茡茢茬茭茮茰茳茷茺茼茽荂荃荄荇荍荎荑荕荖荗荰荸"],["8fd8a1","荽荿莀莂莄莆莍莒莔莕莘莙莛莜莝莦莧莩莬莾莿菀菇菉菏菐菑菔菝荓菨菪菶菸菹菼萁萆萊萏萑萕萙莭萯萹葅葇葈葊葍葏葑葒葖葘葙葚葜葠葤葥葧葪葰葳葴葶葸葼葽蒁蒅蒒蒓蒕蒞蒦蒨蒩蒪蒯蒱蒴蒺蒽蒾蓀蓂蓇蓈蓌蓏蓓"],["8fd9a1","蓜蓧蓪蓯蓰蓱蓲蓷蔲蓺蓻蓽蔂蔃蔇蔌蔎蔐蔜蔞蔢蔣蔤蔥蔧蔪蔫蔯蔳蔴蔶蔿蕆蕏",4,"蕖蕙蕜",6,"蕤蕫蕯蕹蕺蕻蕽蕿薁薅薆薉薋薌薏薓薘薝薟薠薢薥薧薴薶薷薸薼薽薾薿藂藇藊藋藎薭藘藚藟藠藦藨藭藳藶藼"],["8fdaa1","藿蘀蘄蘅蘍蘎蘐蘑蘒蘘蘙蘛蘞蘡蘧蘩蘶蘸蘺蘼蘽虀虂虆虒虓虖虗虘虙虝虠",4,"虩虬虯虵虶虷虺蚍蚑蚖蚘蚚蚜蚡蚦蚧蚨蚭蚱蚳蚴蚵蚷蚸蚹蚿蛀蛁蛃蛅蛑蛒蛕蛗蛚蛜蛠蛣蛥蛧蚈蛺蛼蛽蜄蜅蜇蜋蜎蜏蜐蜓蜔蜙蜞蜟蜡蜣"],["8fdba1","蜨蜮蜯蜱蜲蜹蜺蜼蜽蜾蝀蝃蝅蝍蝘蝝蝡蝤蝥蝯蝱蝲蝻螃",6,"螋螌螐螓螕螗螘螙螞螠螣螧螬螭螮螱螵螾螿蟁蟈蟉蟊蟎蟕蟖蟙蟚蟜蟟蟢蟣蟤蟪蟫蟭蟱蟳蟸蟺蟿蠁蠃蠆蠉蠊蠋蠐蠙蠒蠓蠔蠘蠚蠛蠜蠞蠟蠨蠭蠮蠰蠲蠵"],["8fdca1","蠺蠼衁衃衅衈衉衊衋衎衑衕衖衘衚衜衟衠衤衩衱衹衻袀袘袚袛袜袟袠袨袪袺袽袾裀裊",4,"裑裒裓裛裞裧裯裰裱裵裷褁褆褍褎褏褕褖褘褙褚褜褠褦褧褨褰褱褲褵褹褺褾襀襂襅襆襉襏襒襗襚襛襜襡襢襣襫襮襰襳襵襺"],["8fdda1","襻襼襽覉覍覐覔覕覛覜覟覠覥覰覴覵覶覷覼觔",4,"觥觩觫觭觱觳觶觹觽觿訄訅訇訏訑訒訔訕訞訠訢訤訦訫訬訯訵訷訽訾詀詃詅詇詉詍詎詓詖詗詘詜詝詡詥詧詵詶詷詹詺詻詾詿誀誃誆誋誏誐誒誖誗誙誟誧誩誮誯誳"],["8fdea1","誶誷誻誾諃諆諈諉諊諑諓諔諕諗諝諟諬諰諴諵諶諼諿謅謆謋謑謜謞謟謊謭謰謷謼譂",4,"譈譒譓譔譙譍譞譣譭譶譸譹譼譾讁讄讅讋讍讏讔讕讜讞讟谸谹谽谾豅豇豉豋豏豑豓豔豗豘豛豝豙豣豤豦豨豩豭豳豵豶豻豾貆"],["8fdfa1","貇貋貐貒貓貙貛貜貤貹貺賅賆賉賋賏賖賕賙賝賡賨賬賯賰賲賵賷賸賾賿贁贃贉贒贗贛赥赩赬赮赿趂趄趈趍趐趑趕趞趟趠趦趫趬趯趲趵趷趹趻跀跅跆跇跈跊跎跑跔跕跗跙跤跥跧跬跰趼跱跲跴跽踁踄踅踆踋踑踔踖踠踡踢"],["8fe0a1","踣踦踧踱踳踶踷踸踹踽蹀蹁蹋蹍蹎蹏蹔蹛蹜蹝蹞蹡蹢蹩蹬蹭蹯蹰蹱蹹蹺蹻躂躃躉躐躒躕躚躛躝躞躢躧躩躭躮躳躵躺躻軀軁軃軄軇軏軑軔軜軨軮軰軱軷軹軺軭輀輂輇輈輏輐輖輗輘輞輠輡輣輥輧輨輬輭輮輴輵輶輷輺轀轁"],["8fe1a1","轃轇轏轑",4,"轘轝轞轥辝辠辡辤辥辦辵辶辸达迀迁迆迊迋迍运迒迓迕迠迣迤迨迮迱迵迶迻迾适逄逈逌逘逛逨逩逯逪逬逭逳逴逷逿遃遄遌遛遝遢遦遧遬遰遴遹邅邈邋邌邎邐邕邗邘邙邛邠邡邢邥邰邲邳邴邶邽郌邾郃"],["8fe2a1","郄郅郇郈郕郗郘郙郜郝郟郥郒郶郫郯郰郴郾郿鄀鄄鄅鄆鄈鄍鄐鄔鄖鄗鄘鄚鄜鄞鄠鄥鄢鄣鄧鄩鄮鄯鄱鄴鄶鄷鄹鄺鄼鄽酃酇酈酏酓酗酙酚酛酡酤酧酭酴酹酺酻醁醃醅醆醊醎醑醓醔醕醘醞醡醦醨醬醭醮醰醱醲醳醶醻醼醽醿"],["8fe3a1","釂釃釅釓釔釗釙釚釞釤釥釩釪釬",5,"釷釹釻釽鈀鈁鈄鈅鈆鈇鈉鈊鈌鈐鈒鈓鈖鈘鈜鈝鈣鈤鈥鈦鈨鈮鈯鈰鈳鈵鈶鈸鈹鈺鈼鈾鉀鉂鉃鉆鉇鉊鉍鉎鉏鉑鉘鉙鉜鉝鉠鉡鉥鉧鉨鉩鉮鉯鉰鉵",4,"鉻鉼鉽鉿銈銉銊銍銎銒銗"],["8fe4a1","銙銟銠銤銥銧銨銫銯銲銶銸銺銻銼銽銿",4,"鋅鋆鋇鋈鋋鋌鋍鋎鋐鋓鋕鋗鋘鋙鋜鋝鋟鋠鋡鋣鋥鋧鋨鋬鋮鋰鋹鋻鋿錀錂錈錍錑錔錕錜錝錞錟錡錤錥錧錩錪錳錴錶錷鍇鍈鍉鍐鍑鍒鍕鍗鍘鍚鍞鍤鍥鍧鍩鍪鍭鍯鍰鍱鍳鍴鍶"],["8fe5a1","鍺鍽鍿鎀鎁鎂鎈鎊鎋鎍鎏鎒鎕鎘鎛鎞鎡鎣鎤鎦鎨鎫鎴鎵鎶鎺鎩鏁鏄鏅鏆鏇鏉",4,"鏓鏙鏜鏞鏟鏢鏦鏧鏹鏷鏸鏺鏻鏽鐁鐂鐄鐈鐉鐍鐎鐏鐕鐖鐗鐟鐮鐯鐱鐲鐳鐴鐻鐿鐽鑃鑅鑈鑊鑌鑕鑙鑜鑟鑡鑣鑨鑫鑭鑮鑯鑱鑲钄钃镸镹"],["8fe6a1","镾閄閈閌閍閎閝閞閟閡閦閩閫閬閴閶閺閽閿闆闈闉闋闐闑闒闓闙闚闝闞闟闠闤闦阝阞阢阤阥阦阬阱阳阷阸阹阺阼阽陁陒陔陖陗陘陡陮陴陻陼陾陿隁隂隃隄隉隑隖隚隝隟隤隥隦隩隮隯隳隺雊雒嶲雘雚雝雞雟雩雯雱雺霂"],["8fe7a1","霃霅霉霚霛霝霡霢霣霨霱霳靁靃靊靎靏靕靗靘靚靛靣靧靪靮靳靶靷靸靻靽靿鞀鞉鞕鞖鞗鞙鞚鞞鞟鞢鞬鞮鞱鞲鞵鞶鞸鞹鞺鞼鞾鞿韁韄韅韇韉韊韌韍韎韐韑韔韗韘韙韝韞韠韛韡韤韯韱韴韷韸韺頇頊頙頍頎頔頖頜頞頠頣頦"],["8fe8a1","頫頮頯頰頲頳頵頥頾顄顇顊顑顒顓顖顗顙顚顢顣顥顦顪顬颫颭颮颰颴颷颸颺颻颿飂飅飈飌飡飣飥飦飧飪飳飶餂餇餈餑餕餖餗餚餛餜餟餢餦餧餫餱",4,"餹餺餻餼饀饁饆饇饈饍饎饔饘饙饛饜饞饟饠馛馝馟馦馰馱馲馵"],["8fe9a1","馹馺馽馿駃駉駓駔駙駚駜駞駧駪駫駬駰駴駵駹駽駾騂騃騄騋騌騐騑騖騞騠騢騣騤騧騭騮騳騵騶騸驇驁驄驊驋驌驎驑驔驖驝骪骬骮骯骲骴骵骶骹骻骾骿髁髃髆髈髎髐髒髕髖髗髛髜髠髤髥髧髩髬髲髳髵髹髺髽髿",4],["8feaa1","鬄鬅鬈鬉鬋鬌鬍鬎鬐鬒鬖鬙鬛鬜鬠鬦鬫鬭鬳鬴鬵鬷鬹鬺鬽魈魋魌魕魖魗魛魞魡魣魥魦魨魪",4,"魳魵魷魸魹魿鮀鮄鮅鮆鮇鮉鮊鮋鮍鮏鮐鮔鮚鮝鮞鮦鮧鮩鮬鮰鮱鮲鮷鮸鮻鮼鮾鮿鯁鯇鯈鯎鯐鯗鯘鯝鯟鯥鯧鯪鯫鯯鯳鯷鯸"],["8feba1","鯹鯺鯽鯿鰀鰂鰋鰏鰑鰖鰘鰙鰚鰜鰞鰢鰣鰦",4,"鰱鰵鰶鰷鰽鱁鱃鱄鱅鱉鱊鱎鱏鱐鱓鱔鱖鱘鱛鱝鱞鱟鱣鱩鱪鱜鱫鱨鱮鱰鱲鱵鱷鱻鳦鳲鳷鳹鴋鴂鴑鴗鴘鴜鴝鴞鴯鴰鴲鴳鴴鴺鴼鵅鴽鵂鵃鵇鵊鵓鵔鵟鵣鵢鵥鵩鵪鵫鵰鵶鵷鵻"],["8feca1","鵼鵾鶃鶄鶆鶊鶍鶎鶒鶓鶕鶖鶗鶘鶡鶪鶬鶮鶱鶵鶹鶼鶿鷃鷇鷉鷊鷔鷕鷖鷗鷚鷞鷟鷠鷥鷧鷩鷫鷮鷰鷳鷴鷾鸊鸂鸇鸎鸐鸑鸒鸕鸖鸙鸜鸝鹺鹻鹼麀麂麃麄麅麇麎麏麖麘麛麞麤麨麬麮麯麰麳麴麵黆黈黋黕黟黤黧黬黭黮黰黱黲黵"],["8feda1","黸黿鼂鼃鼉鼏鼐鼑鼒鼔鼖鼗鼙鼚鼛鼟鼢鼦鼪鼫鼯鼱鼲鼴鼷鼹鼺鼼鼽鼿齁齃",4,"齓齕齖齗齘齚齝齞齨齩齭",4,"齳齵齺齽龏龐龑龒龔龖龗龞龡龢龣龥"]]');
        /***/ }),

      /***/ 6258:
      /***/ (function (module) {
        module.exports = JSON.parse('{"uChars":[128,165,169,178,184,216,226,235,238,244,248,251,253,258,276,284,300,325,329,334,364,463,465,467,469,471,473,475,477,506,594,610,712,716,730,930,938,962,970,1026,1104,1106,8209,8215,8218,8222,8231,8241,8244,8246,8252,8365,8452,8454,8458,8471,8482,8556,8570,8596,8602,8713,8720,8722,8726,8731,8737,8740,8742,8748,8751,8760,8766,8777,8781,8787,8802,8808,8816,8854,8858,8870,8896,8979,9322,9372,9548,9588,9616,9622,9634,9652,9662,9672,9676,9680,9702,9735,9738,9793,9795,11906,11909,11913,11917,11928,11944,11947,11951,11956,11960,11964,11979,12284,12292,12312,12319,12330,12351,12436,12447,12535,12543,12586,12842,12850,12964,13200,13215,13218,13253,13263,13267,13270,13384,13428,13727,13839,13851,14617,14703,14801,14816,14964,15183,15471,15585,16471,16736,17208,17325,17330,17374,17623,17997,18018,18212,18218,18301,18318,18760,18811,18814,18820,18823,18844,18848,18872,19576,19620,19738,19887,40870,59244,59336,59367,59413,59417,59423,59431,59437,59443,59452,59460,59478,59493,63789,63866,63894,63976,63986,64016,64018,64021,64025,64034,64037,64042,65074,65093,65107,65112,65127,65132,65375,65510,65536],"gbChars":[0,36,38,45,50,81,89,95,96,100,103,104,105,109,126,133,148,172,175,179,208,306,307,308,309,310,311,312,313,341,428,443,544,545,558,741,742,749,750,805,819,820,7922,7924,7925,7927,7934,7943,7944,7945,7950,8062,8148,8149,8152,8164,8174,8236,8240,8262,8264,8374,8380,8381,8384,8388,8390,8392,8393,8394,8396,8401,8406,8416,8419,8424,8437,8439,8445,8482,8485,8496,8521,8603,8936,8946,9046,9050,9063,9066,9076,9092,9100,9108,9111,9113,9131,9162,9164,9218,9219,11329,11331,11334,11336,11346,11361,11363,11366,11370,11372,11375,11389,11682,11686,11687,11692,11694,11714,11716,11723,11725,11730,11736,11982,11989,12102,12336,12348,12350,12384,12393,12395,12397,12510,12553,12851,12962,12973,13738,13823,13919,13933,14080,14298,14585,14698,15583,15847,16318,16434,16438,16481,16729,17102,17122,17315,17320,17402,17418,17859,17909,17911,17915,17916,17936,17939,17961,18664,18703,18814,18962,19043,33469,33470,33471,33484,33485,33490,33497,33501,33505,33513,33520,33536,33550,37845,37921,37948,38029,38038,38064,38065,38066,38069,38075,38076,38078,39108,39109,39113,39114,39115,39116,39265,39394,189000]}');
        /***/ }),

      /***/ 4346:
      /***/ (function (module) {
        module.exports = JSON.parse('[["a140","",62],["a180","",32],["a240","",62],["a280","",32],["a2ab","",5],["a2e3","€"],["a2ef",""],["a2fd",""],["a340","",62],["a380","",31,"　"],["a440","",62],["a480","",32],["a4f4","",10],["a540","",62],["a580","",32],["a5f7","",7],["a640","",62],["a680","",32],["a6b9","",7],["a6d9","",6],["a6ec",""],["a6f3",""],["a6f6","",8],["a740","",62],["a780","",32],["a7c2","",14],["a7f2","",12],["a896","",10],["a8bc","ḿ"],["a8bf","ǹ"],["a8c1",""],["a8ea","",20],["a958",""],["a95b",""],["a95d",""],["a989","〾⿰",11],["a997","",12],["a9f0","",14],["aaa1","",93],["aba1","",93],["aca1","",93],["ada1","",93],["aea1","",93],["afa1","",93],["d7fa","",4],["f8a1","",93],["f9a1","",93],["faa1","",93],["fba1","",93],["fca1","",93],["fda1","",93],["fe50","⺁⺄㑳㑇⺈⺋㖞㘚㘎⺌⺗㥮㤘㧏㧟㩳㧐㭎㱮㳠⺧⺪䁖䅟⺮䌷⺳⺶⺷䎱䎬⺻䏝䓖䙡䙌"],["fe80","䜣䜩䝼䞍⻊䥇䥺䥽䦂䦃䦅䦆䦟䦛䦷䦶䲣䲟䲠䲡䱷䲢䴓",6,"䶮",93],["8135f437",""]]');
        /***/ }),

      /***/ 7014:
      /***/ (function (module) {
        module.exports = JSON.parse('[["0","\\u0000",128],["a1","｡",62],["8140","　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈",9,"＋－±×"],["8180","÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓"],["81b8","∈∋⊆⊇⊂⊃∪∩"],["81c8","∧∨￢⇒⇔∀∃"],["81da","∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬"],["81f0","Å‰♯♭♪†‡¶"],["81fc","◯"],["824f","０",9],["8260","Ａ",25],["8281","ａ",25],["829f","ぁ",82],["8340","ァ",62],["8380","ム",22],["839f","Α",16,"Σ",6],["83bf","α",16,"σ",6],["8440","А",5,"ЁЖ",25],["8470","а",5,"ёж",7],["8480","о",17],["849f","─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂"],["8740","①",19,"Ⅰ",9],["875f","㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡"],["877e","㍻"],["8780","〝〟№㏍℡㊤",4,"㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪"],["889f","亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭"],["8940","院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円"],["8980","園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改"],["8a40","魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫"],["8a80","橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄"],["8b40","機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救"],["8b80","朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈"],["8c40","掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨"],["8c80","劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向"],["8d40","后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降"],["8d80","項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷"],["8e40","察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止"],["8e80","死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周"],["8f40","宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳"],["8f80","準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾"],["9040","拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨"],["9080","逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線"],["9140","繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻"],["9180","操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只"],["9240","叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄"],["9280","逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓"],["9340","邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬"],["9380","凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入"],["9440","如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅"],["9480","楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美"],["9540","鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷"],["9580","斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋"],["9640","法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆"],["9680","摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒"],["9740","諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲"],["9780","沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯"],["9840","蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕"],["989f","弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲"],["9940","僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭"],["9980","凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨"],["9a40","咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸"],["9a80","噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩"],["9b40","奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀"],["9b80","它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏"],["9c40","廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠"],["9c80","怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛"],["9d40","戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫"],["9d80","捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼"],["9e40","曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎"],["9e80","梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣"],["9f40","檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯"],["9f80","麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌"],["e040","漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝"],["e080","烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱"],["e140","瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿"],["e180","痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬"],["e240","磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰"],["e280","窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆"],["e340","紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷"],["e380","縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋"],["e440","隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤"],["e480","艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈"],["e540","蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬"],["e580","蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞"],["e640","襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧"],["e680","諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊"],["e740","蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜"],["e780","轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮"],["e840","錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙"],["e880","閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰"],["e940","顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃"],["e980","騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈"],["ea40","鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯"],["ea80","黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙"],["ed40","纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏"],["ed80","塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱"],["ee40","犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙"],["ee80","蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"],["eeef","ⅰ",9,"￢￤＇＂"],["f040","",62],["f080","",124],["f140","",62],["f180","",124],["f240","",62],["f280","",124],["f340","",62],["f380","",124],["f440","",62],["f480","",124],["f540","",62],["f580","",124],["f640","",62],["f680","",124],["f740","",62],["f780","",124],["f840","",62],["f880","",124],["f940",""],["fa40","ⅰ",9,"Ⅰ",9,"￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊"],["fa80","兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯"],["fb40","涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神"],["fb80","祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙"],["fc40","髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"]]');
        /***/ }),

      /** *** */ 	});
    /** ********************************************************************* */
    /** *** */ 	// The module cache
    /** *** */ 	const __webpack_module_cache__ = {};
    /** *** */
    /** *** */ 	// The require function
    /** *** */ 	function __webpack_require__(moduleId) {
      /** *** */ 		// Check if module is in cache
      /** *** */ 		const cachedModule = __webpack_module_cache__[moduleId];
      /** *** */ 		if (cachedModule !== undefined) {
        /** *** */ 			return cachedModule.exports;
        /** *** */ 		}
      /** *** */ 		// Create a new module (and put it into the cache)
      /** *** */ 		const module = __webpack_module_cache__[moduleId] = {
        /** *** */ 			id: moduleId,
        /** *** */ 			loaded: false,
        /** *** */ 			exports: {},
        /** *** */ 		};
      /** *** */
      /** *** */ 		// Execute the module function
      /** *** */ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
      /** *** */
      /** *** */ 		// Flag the module as loaded
      /** *** */ 		module.loaded = true;
      /** *** */
      /** *** */ 		// Return the exports of the module
      /** *** */ 		return module.exports;
      /** *** */ 	}
    /** *** */
    /** ********************************************************************* */
    /** *** */ 	/* webpack/runtime/global */
    /** *** */ 	!(function () {
      /** *** */ 		__webpack_require__.g = (function () {
        /** *** */ 			if (typeof globalThis === 'object') return globalThis;
        /** *** */ 			try {
          /** *** */ 				return this || new Function('return this')();
          /** *** */ 			} catch (e) {
          /** *** */ 				if (typeof window === 'object') return window;
          /** *** */ 			}
        /** *** */ 		}());
      /** *** */ 	}());
    /** *** */
    /** *** */ 	/* webpack/runtime/node module decorator */
    /** *** */ 	!(function () {
      /** *** */ 		__webpack_require__.nmd = function (module) {
        /** *** */ 			module.paths = [];
        /** *** */ 			if (!module.children) module.children = [];
        /** *** */ 			return module;
        /** *** */ 		};
      /** *** */ 	}());
    /** *** */
    /** ********************************************************************* */
    /** *** */
    /** *** */ 	// startup
    /** *** */ 	// Load entry module and return exports
    /** *** */ 	// This entry module is referenced by other modules so it can't be inlined
    /** *** */ 	const __webpack_exports__ = __webpack_require__(2536);
    /** *** */
    /** *** */ 	return __webpack_exports__;
    /** *** */ })();
});
// # sourceMappingURL=pdfmake.js.map
